//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import moment from 'moment';
import ServiceProxyBase from './serviceProxyBase';
import axios from './axios'

export class AccountServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    isTenantAvailable(body?: IsTenantAvailableInput | undefined, cancelToken?: CancelToken): Promise<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsTenantAvailable(_response);
        });
    }

    protected processIsTenantAvailable(response: AxiosResponse): Promise<IsTenantAvailableOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return Promise.resolve<IsTenantAvailableOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IsTenantAvailableOutput>(null as any);
    }

    /**
     * 注册
     * @param body (optional) 
     * @return OK
     */
    register(body?: RegisterInput | undefined, cancelToken?: CancelToken): Promise<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<RegisterOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterOutput.fromJS(resultData200);
            return Promise.resolve<RegisterOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterOutput>(null as any);
    }

    /**
     * @param c (optional) 
     * @return OK
     */
    resolveTenantId(c?: string | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Account/ResolveTenantId?";
        if (c === null)
            throw new globalThis.Error("The parameter 'c' cannot be null.");
        else if (c !== undefined)
            url_ += "c=" + encodeURIComponent("" + c) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResolveTenantId(_response);
        });
    }

    protected processResolveTenantId(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @return OK
     */
    sendPasswordResetCode(emailAddress?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Account/SendPasswordResetCode?";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendPasswordResetCode(_response);
        });
    }

    protected processSendPasswordResetCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 重置密码
     * @param body (optional) 
     * @return OK
     */
    resetPassword(body?: ResetPasswordInput | undefined, cancelToken?: CancelToken): Promise<ResetPasswordOutput> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<ResetPasswordOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetPasswordOutput.fromJS(resultData200);
            return Promise.resolve<ResetPasswordOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetPasswordOutput>(null as any);
    }

    /**
     * 重置用户全名
     * @param body (optional) 
     * @return OK
     */
    resetFullName(body?: ResetFullNameInput | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Account/ResetFullName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetFullName(_response);
        });
    }

    protected processResetFullName(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @return OK
     */
    sendEmailActivationLink(emailAddress?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Account/SendEmailActivationLink?";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendEmailActivationLink(_response);
        });
    }

    protected processSendEmailActivationLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    activateEmail(body?: ActivateEmailInput | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivateEmail(_response);
        });
    }

    protected processActivateEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param password (optional) 
     * @param body (optional) 
     * @return OK
     */
    passwordVerification(password?: string | undefined, body?: User | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Account/PasswordVerification?";
        if (password === null)
            throw new globalThis.Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPasswordVerification(_response);
        });
    }

    protected processPasswordVerification(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 密码验证
     * @param userId (optional) 
     * @param password (optional) 
     * @return OK
     */
    passwordVerificationByUserId(userId?: number | undefined, password?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Account/PasswordVerificationByUserId?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (password === null)
            throw new globalThis.Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPasswordVerificationByUserId(_response);
        });
    }

    protected processPasswordVerificationByUserId(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class AnnouncementServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 添加系统公告
     * @param body (optional) 
     * @return OK
     */
    addAnnouncement(body?: AddAnnouncementDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Announcement/AddAnnouncement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddAnnouncement(_response);
        });
    }

    protected processAddAnnouncement(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 发送邮件
     * @param id (optional) 
     * @param visibleType (optional) 
     * @return OK
     */
    sendMail(id?: string | undefined, visibleType?: number | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Announcement/SendMail?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (visibleType === null)
            throw new globalThis.Error("The parameter 'visibleType' cannot be null.");
        else if (visibleType !== undefined)
            url_ += "VisibleType=" + encodeURIComponent("" + visibleType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendMail(_response);
        });
    }

    protected processSendMail(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 更新系统公告
     * @param body (optional) 
     * @return OK
     */
    modifyAnnouncement(body?: ModifyAnnouncementDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Announcement/ModifyAnnouncement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModifyAnnouncement(_response);
        });
    }

    protected processModifyAnnouncement(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 删除系统公告（软）
     * @param announcementId (optional) 
     * @return OK
     */
    deleteAnnouncement(announcementId?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Announcement/DeleteAnnouncement?";
        if (announcementId === null)
            throw new globalThis.Error("The parameter 'announcementId' cannot be null.");
        else if (announcementId !== undefined)
            url_ += "AnnouncementId=" + encodeURIComponent("" + announcementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAnnouncement(_response);
        });
    }

    protected processDeleteAnnouncement(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取单个公告信息
     * @param guid (optional) 
     * @return OK
     */
    getAnnouncement(guid?: string | undefined, cancelToken?: CancelToken): Promise<GetAnnouncementDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Announcement/GetAnnouncement?";
        if (guid === null)
            throw new globalThis.Error("The parameter 'guid' cannot be null.");
        else if (guid !== undefined)
            url_ += "guid=" + encodeURIComponent("" + guid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAnnouncement(_response);
        });
    }

    protected processGetAnnouncement(response: AxiosResponse): Promise<GetAnnouncementDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAnnouncementDto.fromJS(resultData200);
            return Promise.resolve<GetAnnouncementDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAnnouncementDto>(null as any);
    }

    /**
     * 查询最新一条需要做系统横幅展示的公告信息
     * @return OK
     */
    getLatestAlertAnnouncement( cancelToken?: CancelToken): Promise<GetAnnouncementDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Announcement/GetLatestAlertAnnouncement";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestAlertAnnouncement(_response);
        });
    }

    protected processGetLatestAlertAnnouncement(response: AxiosResponse): Promise<GetAnnouncementDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAnnouncementDto.fromJS(resultData200);
            return Promise.resolve<GetAnnouncementDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAnnouncementDto>(null as any);
    }

    /**
     * 获取所有系统公告
     * @param body (optional) 
     * @return OK
     */
    getAnnouncementAll(body?: PageAnnouncementAllDto | undefined, cancelToken?: CancelToken): Promise<GetAnnouncementAllTotalCountDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Announcement/GetAnnouncementAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAnnouncementAll(_response);
        });
    }

    protected processGetAnnouncementAll(response: AxiosResponse): Promise<GetAnnouncementAllTotalCountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAnnouncementAllTotalCountDto.fromJS(resultData200);
            return Promise.resolve<GetAnnouncementAllTotalCountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAnnouncementAllTotalCountDto>(null as any);
    }

    /**
     * 文件上传
     * @param excelFile (optional) 
     * @return OK
     */
    fileUpload(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Announcement/FileUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileUpload(_response);
        });
    }

    protected processFileUpload(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 根据文件名称获取文件下载URL
     * @param fileName (optional) 
     * @return OK
     */
    getFileUrl(fileName?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Announcement/GetFileUrl?";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileUrl(_response);
        });
    }

    protected processGetFileUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取所有公告标签
     * @param parentId (optional) 
     * @return OK
     */
    getAnnouncementLabelTypeAll(parentId?: string | undefined, cancelToken?: CancelToken): Promise<AnnouncementLabelTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Announcement/GetAnnouncementLabelTypeAll?";
        if (parentId === null)
            throw new globalThis.Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAnnouncementLabelTypeAll(_response);
        });
    }

    protected processGetAnnouncementLabelTypeAll(response: AxiosResponse): Promise<AnnouncementLabelTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnnouncementLabelTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AnnouncementLabelTypeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnnouncementLabelTypeDto[]>(null as any);
    }

    /**
     * 批量导入认证证书
     * @return OK
     */
    importAuthenticationCertificateFile( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Announcement/ImportAuthenticationCertificateFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportAuthenticationCertificateFile(_response);
        });
    }

    protected processImportAuthenticationCertificateFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id?: string | undefined, cancelToken?: CancelToken): Promise<AnnouncementDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Announcement/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<AnnouncementDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AnnouncementDto.fromJS(resultData200);
            return Promise.resolve<AnnouncementDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnnouncementDto>(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<AnnouncementDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Announcement/GetAll?";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<AnnouncementDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AnnouncementDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<AnnouncementDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnnouncementDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body?: AnnouncementDto | undefined, cancelToken?: CancelToken): Promise<AnnouncementDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Announcement/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<AnnouncementDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AnnouncementDto.fromJS(resultData200);
            return Promise.resolve<AnnouncementDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnnouncementDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body?: AnnouncementDto | undefined, cancelToken?: CancelToken): Promise<AnnouncementDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Announcement/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<AnnouncementDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AnnouncementDto.fromJS(resultData200);
            return Promise.resolve<AnnouncementDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnnouncementDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Announcement/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AssociationCustomersServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取当前登录用户关联的客户(包含客户关联所有商务)
     * @param body (optional) 
     * @return OK
     */
    getAssociationCustomers(body?: PageAssociationCustomersSearchDto | undefined, cancelToken?: CancelToken): Promise<PageTotalAssociationCustomersDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/AssociationCustomers/GetAssociationCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssociationCustomers(_response);
        });
    }

    protected processGetAssociationCustomers(response: AxiosResponse): Promise<PageTotalAssociationCustomersDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageTotalAssociationCustomersDto.fromJS(resultData200);
            return Promise.resolve<PageTotalAssociationCustomersDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageTotalAssociationCustomersDto>(null as any);
    }

    /**
     * 获取当前登录用户关联的客户（仅客户）
     * @param body (optional) 
     * @return OK
     */
    getCustomers(body?: PageAssociationCustomersSearchDto | undefined, cancelToken?: CancelToken): Promise<PageTotalAssociationCustomersDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/AssociationCustomers/GetCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomers(_response);
        });
    }

    protected processGetCustomers(response: AxiosResponse): Promise<PageTotalAssociationCustomersDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageTotalAssociationCustomersDto.fromJS(resultData200);
            return Promise.resolve<PageTotalAssociationCustomersDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageTotalAssociationCustomersDto>(null as any);
    }

    /**
     * 获取当前登录用户关联的客户编号
     * @return OK
     */
    getAssociationCustomersIds( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/AssociationCustomers/GetAssociationCustomersIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssociationCustomersIds(_response);
        });
    }

    protected processGetAssociationCustomersIds(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 导入客户关联信息
     * @param excelFile (optional) 
     * @return OK
     */
    importAssociationCustomers(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/AssociationCustomers/ImportAssociationCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportAssociationCustomers(_response);
        });
    }

    protected processImportAssociationCustomers(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导出客户关联信息
     * @param body (optional) 导出数据筛选条件
     * @return OK
     */
    execlAssociationCustomers(body?: PageAssociationCustomersSearchDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/AssociationCustomers/ExeclAssociationCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExeclAssociationCustomers(_response);
        });
    }

    protected processExeclAssociationCustomers(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导出客户关联信息上传模板
     * @return OK
     */
    excelAssociationCustomersTemplate( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/AssociationCustomers/ExcelAssociationCustomersTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExcelAssociationCustomersTemplate(_response);
        });
    }

    protected processExcelAssociationCustomersTemplate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 根据客户编号获取商务信息
     * @param customerCodes (optional) 
     * @return OK
     */
    getAssociationByCustomer(customerCodes?: string[] | undefined, cancelToken?: CancelToken): Promise<AssociationCustomersOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/AssociationCustomers/GetAssociationByCustomer?";
        if (customerCodes === null)
            throw new globalThis.Error("The parameter 'customerCodes' cannot be null.");
        else if (customerCodes !== undefined)
            customerCodes && customerCodes.forEach(item => { url_ += "customerCodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssociationByCustomer(_response);
        });
    }

    protected processGetAssociationByCustomer(response: AxiosResponse): Promise<AssociationCustomersOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssociationCustomersOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AssociationCustomersOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssociationCustomersOutputDto[]>(null as any);
    }

    /**
     * 删除关联信息
     * @param body (optional) 
     * @return OK
     */
    delete(body?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/AssociationCustomers/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CalendarServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 分页获取日历数据
     * @param endDate (optional) 
     * @param startDate (optional) 
     * @param pageSize (optional) 
     * @param pageIndex (optional) 
     * @return OK
     */
    getAllbyPage(endDate?: string | undefined, startDate?: string | undefined, pageSize?: number | undefined, pageIndex?: number | undefined, cancelToken?: CancelToken): Promise<CalendarDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Calendar/GetAllbyPage?";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllbyPage(_response);
        });
    }

    protected processGetAllbyPage(response: AxiosResponse): Promise<CalendarDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CalendarDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalendarDto[]>(null as any);
    }

    /**
     * 按月份获取日历数据
     * @param year (optional) 
     * @param month (optional) 
     * @return OK
     */
    getAllByMonth(year?: number | undefined, month?: number | undefined, cancelToken?: CancelToken): Promise<CalendarDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Calendar/GetAllByMonth?";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new globalThis.Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllByMonth(_response);
        });
    }

    protected processGetAllByMonth(response: AxiosResponse): Promise<CalendarDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CalendarDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalendarDto[]>(null as any);
    }

    /**
     * 按月份获取日历数据
     * @param year (optional) 
     * @return OK
     */
    getAllDaysByYear(year?: number | undefined, cancelToken?: CancelToken): Promise<CalendarDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Calendar/GetAllDaysByYear?";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDaysByYear(_response);
        });
    }

    protected processGetAllDaysByYear(response: AxiosResponse): Promise<CalendarDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CalendarDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalendarDto[]>(null as any);
    }

    /**
     * 获取导出模板数据，导出当年的1号到14号做为模板数据
     * @param year (optional) 
     * @return OK
     */
    getTemplateDaysByYear(year?: number | undefined, cancelToken?: CancelToken): Promise<CalendarDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Calendar/GetTemplateDaysByYear?";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTemplateDaysByYear(_response);
        });
    }

    protected processGetTemplateDaysByYear(response: AxiosResponse): Promise<CalendarDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CalendarDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalendarDto[]>(null as any);
    }

    /**
     * 按年份获取日历数据
     * @param year (optional) 
     * @return OK
     */
    getAllByYear(year?: number | undefined, cancelToken?: CancelToken): Promise<CalendarDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Calendar/GetAllByYear?";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllByYear(_response);
        });
    }

    protected processGetAllByYear(response: AxiosResponse): Promise<CalendarDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CalendarDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalendarDto[]>(null as any);
    }

    /**
     * 获取一个时间段内的所有假期（周末不算）
     * @param endDate (optional) 
     * @param startDate (optional) 
     * @return OK
     */
    getAll(endDate?: string | undefined, startDate?: string | undefined, cancelToken?: CancelToken): Promise<CalendarDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Calendar/GetAll?";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<CalendarDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CalendarDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalendarDto[]>(null as any);
    }

    /**
     * 获取一个时间段内的所有假期
     * @param endDate (optional) 
     * @param startDate (optional) 
     * @return OK
     */
    getAllDays(endDate?: string | undefined, startDate?: string | undefined, cancelToken?: CancelToken): Promise<CalendarDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Calendar/GetAllDays?";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDays(_response);
        });
    }

    protected processGetAllDays(response: AxiosResponse): Promise<CalendarDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CalendarDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalendarDto[]>(null as any);
    }

    /**
     * 获取一个时间段内的所有假期天数
     * @param endDate (optional) 
     * @param startDate (optional) 
     * @param holidayIncludWeekend (optional) 
     * @return OK
     */
    getHolidaysCount(endDate?: string | undefined, startDate?: string | undefined, holidayIncludWeekend?: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Calendar/GetHolidaysCount?";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (holidayIncludWeekend === null)
            throw new globalThis.Error("The parameter 'holidayIncludWeekend' cannot be null.");
        else if (holidayIncludWeekend !== undefined)
            url_ += "holidayIncludWeekend=" + encodeURIComponent("" + holidayIncludWeekend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHolidaysCount(_response);
        });
    }

    protected processGetHolidaysCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * 根据用户选择的交付日期，排除中间的法定假日之后，计算出最终交付日期
     * @param endDate (optional) 
     * @param startDate (optional) 
     * @param holidayIncludWeekend (optional) 
     * @return OK
     */
    calculateFinalDeliveryDate(endDate?: string | undefined, startDate?: string | undefined, holidayIncludWeekend?: number | undefined, cancelToken?: CancelToken): Promise<moment.Moment> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Calendar/CalculateFinalDeliveryDate?";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (holidayIncludWeekend === null)
            throw new globalThis.Error("The parameter 'holidayIncludWeekend' cannot be null.");
        else if (holidayIncludWeekend !== undefined)
            url_ += "holidayIncludWeekend=" + encodeURIComponent("" + holidayIncludWeekend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateFinalDeliveryDate(_response);
        });
    }

    protected processCalculateFinalDeliveryDate(response: AxiosResponse): Promise<moment.Moment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 ? moment(resultData200.toString()) : null as any;
    
            return Promise.resolve<moment.Moment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<moment.Moment>(null as any);
    }

    /**
     * 根据天数计算出最后交期
     * @param days (optional) 
     * @param startDate (optional) 
     * @param holidayIncludWeekend (optional) 
     * @return OK
     */
    calculateFinalDeliveryDayByDays(days?: string | undefined, startDate?: string | undefined, holidayIncludWeekend?: number | undefined, cancelToken?: CancelToken): Promise<moment.Moment> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Calendar/CalculateFinalDeliveryDayByDays?";
        if (days === null)
            throw new globalThis.Error("The parameter 'days' cannot be null.");
        else if (days !== undefined)
            url_ += "days=" + encodeURIComponent("" + days) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (holidayIncludWeekend === null)
            throw new globalThis.Error("The parameter 'holidayIncludWeekend' cannot be null.");
        else if (holidayIncludWeekend !== undefined)
            url_ += "holidayIncludWeekend=" + encodeURIComponent("" + holidayIncludWeekend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateFinalDeliveryDayByDays(_response);
        });
    }

    protected processCalculateFinalDeliveryDayByDays(response: AxiosResponse): Promise<moment.Moment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 ? moment(resultData200.toString()) : null as any;
    
            return Promise.resolve<moment.Moment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<moment.Moment>(null as any);
    }

    /**
     * 更新日期数据
     * @param body (optional) 
     * @return OK
     */
    updateCalendarByDay(body?: Calendar | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Calendar/updateCalendarByDay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCalendarByDay(_response);
        });
    }

    protected processUpdateCalendarByDay(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 上传假期数据
     * @param file (optional) 
     * @return OK
     */
    uploadDateByExcel(file?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Calendar/uploadDateByExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadDateByExcel(_response);
        });
    }

    protected processUploadDateByExcel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出节假日
     * @param year (optional) 
     * @return OK
     */
    exportHoliday(year?: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Calendar/exportHoliday?";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportHoliday(_response);
        });
    }

    protected processExportHoliday(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 下载日历模板
     * @param year (optional) 
     * @return OK
     */
    exportCalendar(year?: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Calendar/exportCalendar?";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCalendar(_response);
        });
    }

    protected processExportCalendar(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ChannelPartnerServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 返回所有CP列表
     * @return OK
     */
    getList( cancelToken?: CancelToken): Promise<GetChannelPartnerListOutput[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/ChannelPartner/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<GetChannelPartnerListOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetChannelPartnerListOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetChannelPartnerListOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetChannelPartnerListOutput[]>(null as any);
    }

    /**
     * 1.CP调用这个接口，返回责任销售的列表,其他角色返回所有销售列表
     * @return OK
     */
    getSalesList( cancelToken?: CancelToken): Promise<GetSalesListOutput[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/ChannelPartner/GetSalesList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalesList(_response);
        });
    }

    protected processGetSalesList(response: AxiosResponse): Promise<GetSalesListOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetSalesListOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetSalesListOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSalesListOutput[]>(null as any);
    }
}

export class ConfigurationServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changeUiTheme(body?: ChangeUiThemeInput | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeUiTheme(_response);
        });
    }

    protected processChangeUiTheme(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateHostEmailSettings(body?: EmailSettingsEditDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Configuration/UpdateHostEmailSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateHostEmailSettings(_response);
        });
    }

    protected processUpdateHostEmailSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTenantsEmailSettings(body?: TenantEmailSettingsEditDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Configuration/UpdateTenantsEmailSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTenantsEmailSettings(_response);
        });
    }

    protected processUpdateTenantsEmailSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ContractClauseServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 根据文件Id获取文件流
     * @param fileId (optional) 
     * @return OK
     */
    getFileStream(fileId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/ContractClause/GetFileStream?";
        if (fileId === null)
            throw new globalThis.Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileStream(_response);
        });
    }

    protected processGetFileStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CurrencyServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取币种
     * @return OK
     */
    all( cancelToken?: CancelToken): Promise<CurrencyDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Currency/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: AxiosResponse): Promise<CurrencyDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CurrencyDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CurrencyDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurrencyDto[]>(null as any);
    }

    /**
     * 获取币种详情
     * @param currencyId (optional) 
     * @return OK
     */
    details(currencyId?: string | undefined, cancelToken?: CancelToken): Promise<CurrencyDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Currency/Details?";
        if (currencyId === null)
            throw new globalThis.Error("The parameter 'currencyId' cannot be null.");
        else if (currencyId !== undefined)
            url_ += "currencyId=" + encodeURIComponent("" + currencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<CurrencyDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CurrencyDto.fromJS(resultData200);
            return Promise.resolve<CurrencyDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurrencyDto>(null as any);
    }
}

export class CustomerInfosServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 1.获取用户可见的客户列表
     * @param cusAdrName (optional) 
     * @return OK
     */
    getCusNoAndCusAdrNameList(cusAdrName?: string | undefined, cancelToken?: CancelToken): Promise<GetCusNoAndCusAdrNameListOutput[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/GetCusNoAndCusAdrNameList?";
        if (cusAdrName === null)
            throw new globalThis.Error("The parameter 'cusAdrName' cannot be null.");
        else if (cusAdrName !== undefined)
            url_ += "cusAdrName=" + encodeURIComponent("" + cusAdrName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCusNoAndCusAdrNameList(_response);
        });
    }

    protected processGetCusNoAndCusAdrNameList(response: AxiosResponse): Promise<GetCusNoAndCusAdrNameListOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCusNoAndCusAdrNameListOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetCusNoAndCusAdrNameListOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCusNoAndCusAdrNameListOutput[]>(null as any);
    }

    /**
     * 2. 通过客户编号（1000990）获取客户详情
     * @param cusNo (optional) 
     * @return OK
     */
    getCusDetail(cusNo?: string | undefined, cancelToken?: CancelToken): Promise<GetCusDetailOutput> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/GetCusDetail?";
        if (cusNo === null)
            throw new globalThis.Error("The parameter 'cusNo' cannot be null.");
        else if (cusNo !== undefined)
            url_ += "CusNo=" + encodeURIComponent("" + cusNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCusDetail(_response);
        });
    }

    protected processGetCusDetail(response: AxiosResponse): Promise<GetCusDetailOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCusDetailOutput.fromJS(resultData200);
            return Promise.resolve<GetCusDetailOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCusDetailOutput>(null as any);
    }

    /**
     * 查询用户折扣值
     * @param cusNoList (optional) 用户编码列表
     * @return OK
     */
    getCustomerMultiper(cusNoList?: string[] | undefined, cancelToken?: CancelToken): Promise<GetCusDetailOutput[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/GetCustomerMultiper?";
        if (cusNoList === null)
            throw new globalThis.Error("The parameter 'cusNoList' cannot be null.");
        else if (cusNoList !== undefined)
            cusNoList && cusNoList.forEach(item => { url_ += "cusNoList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerMultiper(_response);
        });
    }

    protected processGetCustomerMultiper(response: AxiosResponse): Promise<GetCusDetailOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCusDetailOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetCusDetailOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCusDetailOutput[]>(null as any);
    }

    /**
     * 通过客户编号获取客户详情
     * @param cusNos (optional) 
     * @return OK
     */
    getCusDetailByCusNos(cusNos?: string[] | undefined, cancelToken?: CancelToken): Promise<GetCusDetailOutput[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/GetCusDetailByCusNos?";
        if (cusNos === null)
            throw new globalThis.Error("The parameter 'cusNos' cannot be null.");
        else if (cusNos !== undefined)
            cusNos && cusNos.forEach(item => { url_ += "CusNos=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCusDetailByCusNos(_response);
        });
    }

    protected processGetCusDetailByCusNos(response: AxiosResponse): Promise<GetCusDetailOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCusDetailOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetCusDetailOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCusDetailOutput[]>(null as any);
    }

    /**
     * 通过客户编号获取责任销售
     * @param cusNo (optional) 客户编号
     * @return OK
     */
    getCustomerSales(cusNo?: string | undefined, cancelToken?: CancelToken): Promise<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/GetCustomerSales?";
        if (cusNo === null)
            throw new globalThis.Error("The parameter 'cusNo' cannot be null.");
        else if (cusNo !== undefined)
            url_ += "cusNo=" + encodeURIComponent("" + cusNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerSales(_response);
        });
    }

    protected processGetCustomerSales(response: AxiosResponse): Promise<UserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto[]>(null as any);
    }

    /**
     * 通过客户编号获取客户地址
     * @param cusNo (optional) 客户编号
     * @return OK
     */
    getEuAddresses(cusNo?: string | undefined, cancelToken?: CancelToken): Promise<EUDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/GetEuAddresses?";
        if (cusNo === null)
            throw new globalThis.Error("The parameter 'cusNo' cannot be null.");
        else if (cusNo !== undefined)
            url_ += "cusNo=" + encodeURIComponent("" + cusNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEuAddresses(_response);
        });
    }

    protected processGetEuAddresses(response: AxiosResponse): Promise<EUDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EUDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EUDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EUDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAll(body?: GetAllCustomerInfosInput | undefined, cancelToken?: CancelToken): Promise<GetCustomerInfoForViewDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<GetCustomerInfoForViewDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCustomerInfoForViewDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<GetCustomerInfoForViewDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCustomerInfoForViewDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCustomerInfoForEdit(id?: string | undefined, cancelToken?: CancelToken): Promise<GetCustomerInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/GetCustomerInfoForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerInfoForEdit(_response);
        });
    }

    protected processGetCustomerInfoForEdit(response: AxiosResponse): Promise<GetCustomerInfoForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCustomerInfoForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetCustomerInfoForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCustomerInfoForEditOutput>(null as any);
    }

    /**
     * 行业,渠道,应用的选项
     * @return OK
     */
    getChannelApplicationIndustryUsageOptions( cancelToken?: CancelToken): Promise<GetChannelApplicationIndustryUsageOptionsOutput> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/GetChannelApplicationIndustryUsageOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChannelApplicationIndustryUsageOptions(_response);
        });
    }

    protected processGetChannelApplicationIndustryUsageOptions(response: AxiosResponse): Promise<GetChannelApplicationIndustryUsageOptionsOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetChannelApplicationIndustryUsageOptionsOutput.fromJS(resultData200);
            return Promise.resolve<GetChannelApplicationIndustryUsageOptionsOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetChannelApplicationIndustryUsageOptionsOutput>(null as any);
    }

    /**
     * 检查cusNo是否存在
     * @return OK
     */
    checkCusNoExist(cusNo: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/CheckCusNoExist?";
        if (cusNo === undefined || cusNo === null)
            throw new globalThis.Error("The parameter 'cusNo' must be defined and cannot be null.");
        else
            url_ += "cusNo=" + encodeURIComponent("" + cusNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckCusNoExist(_response);
        });
    }

    protected processCheckCusNoExist(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 创建或修改
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body?: CreateOrEditCustomerInfoDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrEdit(_response);
        });
    }

    protected processCreateOrEdit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量删除
     * @param cusNos (optional) 
     * @return OK
     */
    delete(cusNos?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/Delete?";
        if (cusNos === null)
            throw new globalThis.Error("The parameter 'cusNos' cannot be null.");
        else if (cusNos !== undefined)
            cusNos && cusNos.forEach(item => { url_ += "cusNos=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加销售账号（-1）
     * @param body (optional) 
     * @return OK
     */
    createSales(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/CreateSales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSales(_response);
        });
    }

    protected processCreateSales(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    eCustomerDump(body?: ECustomerDumpInput | undefined, cancelToken?: CancelToken): Promise<Envelope> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/eCustomerDump";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processECustomerDump(_response);
        });
    }

    protected processECustomerDump(response: AxiosResponse): Promise<Envelope> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Envelope.fromJS(resultData200);
            return Promise.resolve<Envelope>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Envelope>(null as any);
    }

    /**
     * 创建同步客户信息的任务并执行
     * @return OK
     */
    createSyncCustomerInfoTaskAndStartExecute( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/CreateSyncCustomerInfoTaskAndStartExecute";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSyncCustomerInfoTaskAndStartExecute(_response);
        });
    }

    protected processCreateSyncCustomerInfoTaskAndStartExecute(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 执行同步任务
     * @param cusNo (optional) 
     * @return OK
     */
    executeSyncCustomerInfo(cusNo?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/ExecuteSyncCustomerInfo?";
        if (cusNo === null)
            throw new globalThis.Error("The parameter 'cusNo' cannot be null.");
        else if (cusNo !== undefined)
            url_ += "cusNo=" + encodeURIComponent("" + cusNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExecuteSyncCustomerInfo(_response);
        });
    }

    protected processExecuteSyncCustomerInfo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据名字返回代码信息等 sc再用
     * @param body (optional) 
     * @return OK
     */
    getCPListByName(body?: string[] | undefined, cancelToken?: CancelToken): Promise<GetCusNoAndCusAdrNameListOutput[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/GetCPListByName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCPListByName(_response);
        });
    }

    protected processGetCPListByName(response: AxiosResponse): Promise<GetCusNoAndCusAdrNameListOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCusNoAndCusAdrNameListOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetCusNoAndCusAdrNameListOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCusNoAndCusAdrNameListOutput[]>(null as any);
    }

    /**
     * @return OK
     */
    fiterByUserIdAndRole( cancelToken?: CancelToken): Promise<GetCusNoAndCusAdrNameListOutput[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/FiterByUserIdAndRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFiterByUserIdAndRole(_response);
        });
    }

    protected processFiterByUserIdAndRole(response: AxiosResponse): Promise<GetCusNoAndCusAdrNameListOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCusNoAndCusAdrNameListOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetCusNoAndCusAdrNameListOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCusNoAndCusAdrNameListOutput[]>(null as any);
    }

    /**
     * 根据CusNo获取JINCustomerCode，如果不存在会增加
     * @param cusNo (optional) 
     * @param channelCode (optional) 渠道
     * @param cusAdrName (optional) 
     * @return OK
     */
    getJINCustomerCode(cusNo?: string | undefined, channelCode?: string | undefined, cusAdrName?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/GetJINCustomerCode?";
        if (cusNo === null)
            throw new globalThis.Error("The parameter 'cusNo' cannot be null.");
        else if (cusNo !== undefined)
            url_ += "cusNo=" + encodeURIComponent("" + cusNo) + "&";
        if (channelCode === null)
            throw new globalThis.Error("The parameter 'channelCode' cannot be null.");
        else if (channelCode !== undefined)
            url_ += "channelCode=" + encodeURIComponent("" + channelCode) + "&";
        if (cusAdrName === null)
            throw new globalThis.Error("The parameter 'cusAdrName' cannot be null.");
        else if (cusAdrName !== undefined)
            url_ += "cusAdrName=" + encodeURIComponent("" + cusAdrName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJINCustomerCode(_response);
        });
    }

    protected processGetJINCustomerCode(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 查询JIN编码
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getCustomerJINCodeList(filter?: string | undefined, sorting?: string | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined, cancelToken?: CancelToken): Promise<CustomerJINCodeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/GetCustomerJINCodeList?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerJINCodeList(_response);
        });
    }

    protected processGetCustomerJINCodeList(response: AxiosResponse): Promise<CustomerJINCodeDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerJINCodeDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<CustomerJINCodeDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerJINCodeDtoPagedResultDto>(null as any);
    }

    /**
     * 删除客户JIN编码
     * @param body (optional) 
     * @return OK
     */
    delCustomerJINCode(body?: CustomerJINCodeInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/DelCustomerJINCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelCustomerJINCode(_response);
        });
    }

    protected processDelCustomerJINCode(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 移除缓存
     * @return OK
     */
    removeCache( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/CustomerInfos/RemoveCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveCache(_response);
        });
    }

    protected processRemoveCache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DeliveryNotesSystemServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 根据客户代码获取运费状态
    http://localhost/api/services/DigitalLogisticSystem/DeliveryNotesSystem/GetFreightStatus?CusNo=1000017
     * @param cusNo (optional) 
     * @return OK
     */
    getFreightStatus(cusNo?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/DeliveryNotesSystem/GetFreightStatus?";
        if (cusNo === null)
            throw new globalThis.Error("The parameter 'cusNo' cannot be null.");
        else if (cusNo !== undefined)
            url_ += "CusNo=" + encodeURIComponent("" + cusNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFreightStatus(_response);
        });
    }

    protected processGetFreightStatus(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 下发订单信息至DNS,对应SAP接口 ZSD21R004(ZSDRO_DNS_BACKLOG) 2100
    CP下单给abb,abb还未生产的backlog iso=pmu
     * @param body (optional) 将要保存到DNS中订单数据
     * @return OK
     */
    saveBacklog(body?: SapBacklogInputDto[] | undefined, cancelToken?: CancelToken): Promise<SapOutputDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/SaveBacklog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveBacklog(_response);
        });
    }

    protected processSaveBacklog(response: AxiosResponse): Promise<SapOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SapOutputDto.fromJS(resultData200);
            return Promise.resolve<SapOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SapOutputDto>(null as any);
    }

    /**
     * 下发订单信息至DNS,对应SAP接口 ZSD0762(ZSD_DNS_SUBMIT_SO_TRACKING) 2903
    ---正常情况下对于CP来说只需要2903的数据 cso=lsu  iso=pmu
    成品入库，库存单子
     * @param body (optional) 将要保存到DNS中订单数据
     * @return OK
     */
    saveTracking(body?: SapTrackingInputDto[] | undefined, cancelToken?: CancelToken): Promise<SapOutputDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/SaveTracking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveTracking(_response);
        });
    }

    protected processSaveTracking(response: AxiosResponse): Promise<SapOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SapOutputDto.fromJS(resultData200);
            return Promise.resolve<SapOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SapOutputDto>(null as any);
    }

    /**
     * 删除订单信息
     * @param orderId (optional) 
     * @return OK
     */
    deleteOrder(orderId?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/DeleteOrder?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOrder(_response);
        });
    }

    protected processDeleteOrder(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取订单信息
     * @param body (optional) 订单信息筛选条件
     * @return OK
     */
    getOrderInformations(body?: PageSearchOrderInformationDto | undefined, cancelToken?: CancelToken): Promise<PageTotalOrderInformationDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/GetOrderInformations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderInformations(_response);
        });
    }

    protected processGetOrderInformations(response: AxiosResponse): Promise<PageTotalOrderInformationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageTotalOrderInformationDto.fromJS(resultData200);
            return Promise.resolve<PageTotalOrderInformationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageTotalOrderInformationDto>(null as any);
    }

    /**
     * 导出模板匹配上传模板
     * @return OK
     */
    exportOrderInformation( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/ExportOrderInformation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportOrderInformation(_response);
        });
    }

    protected processExportOrderInformation(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导入模板中的订单
     * @param cusNo (optional) 客户编号
     * @param excelFile (optional) Excel文件
     * @return OK
     */
    importOrderInformation(cusNo?: string | undefined, excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<PageDeliveryNotesOrderItemInputDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/ImportOrderInformation?";
        if (cusNo === null)
            throw new globalThis.Error("The parameter 'cusNo' cannot be null.");
        else if (cusNo !== undefined)
            url_ += "cusNo=" + encodeURIComponent("" + cusNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportOrderInformation(_response);
        });
    }

    protected processImportOrderInformation(response: AxiosResponse): Promise<PageDeliveryNotesOrderItemInputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PageDeliveryNotesOrderItemInputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PageDeliveryNotesOrderItemInputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageDeliveryNotesOrderItemInputDto[]>(null as any);
    }

    /**
     * 导出库存清单-Job导出
     * @param body (optional) 
     * @return OK
     */
    exportOrderInformationList(body?: PageSearchOrderInformationDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/ExportOrderInformationList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportOrderInformationList(_response);
        });
    }

    protected processExportOrderInformationList(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 导出库存清单
     * @param body (optional) 
     * @return OK
     */
    exportOrderInformationListForJob(body?: PageSearchOrderInformationDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/ExportOrderInformationListForJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportOrderInformationListForJob(_response);
        });
    }

    protected processExportOrderInformationListForJob(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取可用物料组信息
     * @return OK
     */
    getMaterialGroup( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/GetMaterialGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMaterialGroup(_response);
        });
    }

    protected processGetMaterialGroup(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 获取CP已维护物料组规则地址
     * @param soldToParty (optional) 
     * @return OK
     */
    getMaterialRulesAddresForAddress(soldToParty?: string | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/GetMaterialRulesAddresForAddress?";
        if (soldToParty === null)
            throw new globalThis.Error("The parameter 'soldToParty' cannot be null.");
        else if (soldToParty !== undefined)
            url_ += "soldToParty=" + encodeURIComponent("" + soldToParty) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMaterialRulesAddresForAddress(_response);
        });
    }

    protected processGetMaterialRulesAddresForAddress(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 添加物料组规则
     * @param body (optional) 
     * @return OK
     */
    addMaterialRulesAddress(body?: PageMaterialRulesAddressInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/AddMaterialRulesAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddMaterialRulesAddress(_response);
        });
    }

    protected processAddMaterialRulesAddress(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新物料组规则
     * @param body (optional) 
     * @return OK
     */
    editMaterialRulesAddress(body?: PageMaterialRulesAddressInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/EditMaterialRulesAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditMaterialRulesAddress(_response);
        });
    }

    protected processEditMaterialRulesAddress(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param materialRulesAddressId (optional) 
     * @param body (optional) 
     * @return OK
     */
    changeMaterialRulesAddressActive(materialRulesAddressId?: string | undefined, body?: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/ChangeMaterialRulesAddressActive?";
        if (materialRulesAddressId === null)
            throw new globalThis.Error("The parameter 'materialRulesAddressId' cannot be null.");
        else if (materialRulesAddressId !== undefined)
            url_ += "materialRulesAddressId=" + encodeURIComponent("" + materialRulesAddressId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeMaterialRulesAddressActive(_response);
        });
    }

    protected processChangeMaterialRulesAddressActive(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除维护的物料组规则
     * @param materialRulesAddressId (optional) 
     * @return OK
     */
    deleteMaterialRulesAddress(materialRulesAddressId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/DeleteMaterialRulesAddress?";
        if (materialRulesAddressId === null)
            throw new globalThis.Error("The parameter 'materialRulesAddressId' cannot be null.");
        else if (materialRulesAddressId !== undefined)
            url_ += "materialRulesAddressId=" + encodeURIComponent("" + materialRulesAddressId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMaterialRulesAddress(_response);
        });
    }

    protected processDeleteMaterialRulesAddress(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取CP已维护地址及相关物料组验证
     * @param soldToParty (optional) 
     * @return OK
     */
    getMaterialRulesAddress(soldToParty?: string | undefined, cancelToken?: CancelToken): Promise<PageMaterialRulesAddressOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/GetMaterialRulesAddress?";
        if (soldToParty === null)
            throw new globalThis.Error("The parameter 'soldToParty' cannot be null.");
        else if (soldToParty !== undefined)
            url_ += "soldToParty=" + encodeURIComponent("" + soldToParty) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMaterialRulesAddress(_response);
        });
    }

    protected processGetMaterialRulesAddress(response: AxiosResponse): Promise<PageMaterialRulesAddressOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PageMaterialRulesAddressOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PageMaterialRulesAddressOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageMaterialRulesAddressOutputDto[]>(null as any);
    }

    /**
     * 校验物料组是否需要校验，且属于多个物料组校验规则
     * @param soldToParty (optional) 
     * @param body (optional) 
     * @return OK
     */
    checkMaterialGroupRulesForOrder(soldToParty?: string | undefined, body?: string[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/CheckMaterialGroupRulesForOrder?";
        if (soldToParty === null)
            throw new globalThis.Error("The parameter 'soldToParty' cannot be null.");
        else if (soldToParty !== undefined)
            url_ += "soldToParty=" + encodeURIComponent("" + soldToParty) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckMaterialGroupRulesForOrder(_response);
        });
    }

    protected processCheckMaterialGroupRulesForOrder(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 创建提货单信息
     * @param body (optional) 提货单详细信息
     * @return OK
     */
    addDeliveryNotes(body?: PageDeliveryNotesInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/AddDeliveryNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddDeliveryNotes(_response);
        });
    }

    protected processAddDeliveryNotes(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 更新提货单信息
     * @param deliveryNotesId (optional) 提货单编号
     * @param body (optional) 提货单订单详细信息
     * @return OK
     */
    editDeliveryNotes(deliveryNotesId?: string | undefined, body?: PageDeliveryNotesInputDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/EditDeliveryNotes?";
        if (deliveryNotesId === null)
            throw new globalThis.Error("The parameter 'deliveryNotesId' cannot be null.");
        else if (deliveryNotesId !== undefined)
            url_ += "deliveryNotesId=" + encodeURIComponent("" + deliveryNotesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditDeliveryNotes(_response);
        });
    }

    protected processEditDeliveryNotes(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 删除待提交的提货单信息
     * @param deliveryNotesId (optional) 提货单详细信息
     * @return OK
     */
    deleteDeliveryNotes(deliveryNotesId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/DeleteDeliveryNotes?";
        if (deliveryNotesId === null)
            throw new globalThis.Error("The parameter 'deliveryNotesId' cannot be null.");
        else if (deliveryNotesId !== undefined)
            url_ += "deliveryNotesId=" + encodeURIComponent("" + deliveryNotesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDeliveryNotes(_response);
        });
    }

    protected processDeleteDeliveryNotes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取提货单信息
     * @param deliveryNotesId (optional) 
     * @param isEdit (optional) 
     * @return OK
     */
    getDeliveryNotes(deliveryNotesId?: string | undefined, isEdit?: boolean | undefined, cancelToken?: CancelToken): Promise<PageDeliveryNotesOutputDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/GetDeliveryNotes?";
        if (deliveryNotesId === null)
            throw new globalThis.Error("The parameter 'deliveryNotesId' cannot be null.");
        else if (deliveryNotesId !== undefined)
            url_ += "deliveryNotesId=" + encodeURIComponent("" + deliveryNotesId) + "&";
        if (isEdit === null)
            throw new globalThis.Error("The parameter 'isEdit' cannot be null.");
        else if (isEdit !== undefined)
            url_ += "isEdit=" + encodeURIComponent("" + isEdit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeliveryNotes(_response);
        });
    }

    protected processGetDeliveryNotes(response: AxiosResponse): Promise<PageDeliveryNotesOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageDeliveryNotesOutputDto.fromJS(resultData200);
            return Promise.resolve<PageDeliveryNotesOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageDeliveryNotesOutputDto>(null as any);
    }

    /**
     * 获取订单信息
     * @param body (optional) 订单信息筛选条件
     * @return OK
     */
    getDeliveryNotesList(body?: PageSearchDeliveryNotesDto | undefined, cancelToken?: CancelToken): Promise<PageTotalDeliveryNotesDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/GetDeliveryNotesList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeliveryNotesList(_response);
        });
    }

    protected processGetDeliveryNotesList(response: AxiosResponse): Promise<PageTotalDeliveryNotesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageTotalDeliveryNotesDto.fromJS(resultData200);
            return Promise.resolve<PageTotalDeliveryNotesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageTotalDeliveryNotesDto>(null as any);
    }

    /**
     * 检查dn状态
     * @param isSendEmail (optional) 
     * @param body (optional) 
     * @return OK
     */
    checkedDeliveryNotesOrderItemsDNStatus(isSendEmail?: boolean | undefined, body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/CheckedDeliveryNotesOrderItemsDNStatus?";
        if (isSendEmail === null)
            throw new globalThis.Error("The parameter 'isSendEmail' cannot be null.");
        else if (isSendEmail !== undefined)
            url_ += "isSendEmail=" + encodeURIComponent("" + isSendEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckedDeliveryNotesOrderItemsDNStatus(_response);
        });
    }

    protected processCheckedDeliveryNotesOrderItemsDNStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 检查客户的信用额度
     * @param cca (optional) 销售区域
     * @param soldToParty (optional) 客户编号
     * @return OK
     */
    checkCredit(cca?: string | undefined, soldToParty?: string | undefined, cancelToken?: CancelToken): Promise<CheckDnsCreditOutput> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/CheckCredit?";
        if (cca === null)
            throw new globalThis.Error("The parameter 'cca' cannot be null.");
        else if (cca !== undefined)
            url_ += "cca=" + encodeURIComponent("" + cca) + "&";
        if (soldToParty === null)
            throw new globalThis.Error("The parameter 'soldToParty' cannot be null.");
        else if (soldToParty !== undefined)
            url_ += "soldToParty=" + encodeURIComponent("" + soldToParty) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckCredit(_response);
        });
    }

    protected processCheckCredit(response: AxiosResponse): Promise<CheckDnsCreditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckDnsCreditOutput.fromJS(resultData200);
            return Promise.resolve<CheckDnsCreditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckDnsCreditOutput>(null as any);
    }

    /**
     * 检查客户的信用额度
     * @param soldToParty (optional) 客户编号
     * @return OK
     */
    checkCreditSoap(soldToParty?: string | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/CheckCreditSoap?";
        if (soldToParty === null)
            throw new globalThis.Error("The parameter 'soldToParty' cannot be null.");
        else if (soldToParty !== undefined)
            url_ += "soldToParty=" + encodeURIComponent("" + soldToParty) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckCreditSoap(_response);
        });
    }

    protected processCheckCreditSoap(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * 导出所有客户的信用额度
     * @return OK
     */
    exportCreditSoap( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/ExportCreditSoap";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCreditSoap(_response);
        });
    }

    protected processExportCreditSoap(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * SAP回调数据，更新提货单对象，包括DN号，返回的错误信息
     * @param body (optional) 
     * @return OK
     */
    saveDeliveryNotes(body?: SapCreateDnsItemInputDto[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/SaveDeliveryNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveDeliveryNotes(_response);
        });
    }

    protected processSaveDeliveryNotes(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 导出提货单列表-Job导出
     * @param body (optional) 
     * @return OK
     */
    exportDeliveryNotesList(body?: PageSearchDeliveryNotesDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/ExportDeliveryNotesList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportDeliveryNotesList(_response);
        });
    }

    protected processExportDeliveryNotesList(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 导出提货单列表
     * @param body (optional) 筛选条件
     * @return OK
     */
    exportDeliveryNotesListForJob(body?: PageSearchDeliveryNotesDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/ExportDeliveryNotesListForJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportDeliveryNotesListForJob(_response);
        });
    }

    protected processExportDeliveryNotesListForJob(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 重试推送DNS提货单
     * @param deliveryNotesId (optional) 
     * @return OK
     */
    retryPush(deliveryNotesId?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/RetryPush?";
        if (deliveryNotesId === null)
            throw new globalThis.Error("The parameter 'deliveryNotesId' cannot be null.");
        else if (deliveryNotesId !== undefined)
            url_ += "deliveryNotesId=" + encodeURIComponent("" + deliveryNotesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRetryPush(_response);
        });
    }

    protected processRetryPush(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 测试触发自动发货
     * @return OK
     */
    testSendAutomaticShipping( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/TestSendAutomaticShipping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestSendAutomaticShipping(_response);
        });
    }

    protected processTestSendAutomaticShipping(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 补发自动发货
     * @param day (optional) 
     * @return OK
     */
    reissueAutomaticShipping(day?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/ReissueAutomaticShipping?";
        if (day === null)
            throw new globalThis.Error("The parameter 'day' cannot be null.");
        else if (day !== undefined)
            url_ += "day=" + encodeURIComponent("" + day) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReissueAutomaticShipping(_response);
        });
    }

    protected processReissueAutomaticShipping(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 测试预占订单
     * @return OK
     */
    testSendMtsCheckedCreditLimitJob( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/TestSendMtsCheckedCreditLimitJob";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestSendMtsCheckedCreditLimitJob(_response);
        });
    }

    protected processTestSendMtsCheckedCreditLimitJob(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * test 分配库存
     * @param body (optional) 
     * @return OK
     */
    test(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/Test";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTest(_response);
        });
    }

    protected processTest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 测试DNS邮件提醒客户临期非现货订单发货，到期-3D/-1D各提醒一次
     * @return OK
     */
    testSendDnsAutoDeliveryJob( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/TestSendDnsAutoDeliveryJob";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestSendDnsAutoDeliveryJob(_response);
        });
    }

    protected processTestSendDnsAutoDeliveryJob(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 同步mst预占标识到orderinfomation
     * @return OK
     */
    synchronizationMtsIdentifier( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/SynchronizationMtsIdentifier";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSynchronizationMtsIdentifier(_response);
        });
    }

    protected processSynchronizationMtsIdentifier(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取DNS拆单发货订单信息
     * @param body (optional) 订单信息筛选条件
     * @return OK
     */
    getDNSplitOrderList(body?: PageSearchDNSplitOrderDto | undefined, cancelToken?: CancelToken): Promise<PageTotalDeliveryNotesDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/GetDNSplitOrderList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDNSplitOrderList(_response);
        });
    }

    protected processGetDNSplitOrderList(response: AxiosResponse): Promise<PageTotalDeliveryNotesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageTotalDeliveryNotesDto.fromJS(resultData200);
            return Promise.resolve<PageTotalDeliveryNotesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageTotalDeliveryNotesDto>(null as any);
    }

    /**
     * 获取低压可视化库存订单信息
     * @param body (optional) 订单信息筛选条件
     * @return OK
     */
    getOrderVisualization(body?: PageSearchOrderVisualizationDto | undefined, cancelToken?: CancelToken): Promise<PageOrderVisualizationDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/GetOrderVisualization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderVisualization(_response);
        });
    }

    protected processGetOrderVisualization(response: AxiosResponse): Promise<PageOrderVisualizationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageOrderVisualizationDto.fromJS(resultData200);
            return Promise.resolve<PageOrderVisualizationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageOrderVisualizationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSAPOrderVisualizationList(body?: PageSearchOrderVisualizationDto | undefined, cancelToken?: CancelToken): Promise<PageOrderVisualizationDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/GetSAPOrderVisualizationList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSAPOrderVisualizationList(_response);
        });
    }

    protected processGetSAPOrderVisualizationList(response: AxiosResponse): Promise<PageOrderVisualizationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageOrderVisualizationDto.fromJS(resultData200);
            return Promise.resolve<PageOrderVisualizationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageOrderVisualizationDto>(null as any);
    }

    /**
     * 导出低压可视化清单
     * @param body (optional) 
     * @return OK
     */
    exportOrderVisualizationItemList(body?: PageSearchOrderVisualizationDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/ExportOrderVisualizationItemList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportOrderVisualizationItemList(_response);
        });
    }

    protected processExportOrderVisualizationItemList(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导出计划入库日
     * @param body (optional) 
     * @return OK
     */
    exportMaintenancePlans(body?: PageSearchOrderVisualizationDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/ExportMaintenancePlans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportMaintenancePlans(_response);
        });
    }

    protected processExportMaintenancePlans(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param excelFile (optional) 
     * @return OK
     */
    updateSAPOrderVisualizationByExcel(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<PageOrderVisualizationDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/UpdateSAPOrderVisualizationByExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSAPOrderVisualizationByExcel(_response);
        });
    }

    protected processUpdateSAPOrderVisualizationByExcel(response: AxiosResponse): Promise<PageOrderVisualizationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageOrderVisualizationDto.fromJS(resultData200);
            return Promise.resolve<PageOrderVisualizationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageOrderVisualizationDto>(null as any);
    }

    /**
     * 导出低压可视化清单-所有OBL的绿灯数据
     * @param body (optional) 
     * @return OK
     */
    exportAllFirstStockDateList(body?: PageSearchOrderVisualizationDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/ExportAllFirstStockDateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportAllFirstStockDateList(_response);
        });
    }

    protected processExportAllFirstStockDateList(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 有特殊附件时，发运送货要求必填
     * @param body (optional) 
     * @return OK
     */
    markAttachmentDownload(body?: MarkAttachmentDownloadInput | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryNotesSystem/MarkAttachmentDownload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkAttachmentDownload(_response);
        });
    }

    protected processMarkAttachmentDownload(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DnsExternalLoginServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 校验链接中的 key，用内置账号向 IDP 换取 token。
     * @param body (optional) 
     * @return OK
     */
    exchange(body?: DnsExternalLoginExchangeInput | undefined, cancelToken?: CancelToken): Promise<DnsExternalLoginResultDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/DnsExternalLogin/Exchange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExchange(_response);
        });
    }

    protected processExchange(response: AxiosResponse): Promise<DnsExternalLoginResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DnsExternalLoginResultDto.fromJS(resultData200);
            return Promise.resolve<DnsExternalLoginResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DnsExternalLoginResultDto>(null as any);
    }

    /**
     * 为已在 MSP 授权的内置账号生成外部登录 key。key 只返回这一次。
     * @param body (optional) 
     * @return OK
     */
    createKey(body?: DnsExternalLoginCreateInput | undefined, cancelToken?: CancelToken): Promise<DnsExternalLoginKeyResultDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/DnsExternalLogin/CreateKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateKey(_response);
        });
    }

    protected processCreateKey(response: AxiosResponse): Promise<DnsExternalLoginKeyResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DnsExternalLoginKeyResultDto.fromJS(resultData200);
            return Promise.resolve<DnsExternalLoginKeyResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DnsExternalLoginKeyResultDto>(null as any);
    }

    /**
     * 外部系统用 appId 和加密包换取附件页登录。
     * @param body (optional) 
     * @return OK
     */
    entry(body?: DnsExternalLoginEntryInput | undefined, cancelToken?: CancelToken): Promise<DnsExternalLoginResultDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/DnsExternalLogin/Entry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEntry(_response);
        });
    }

    protected processEntry(response: AxiosResponse): Promise<DnsExternalLoginResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DnsExternalLoginResultDto.fromJS(resultData200);
            return Promise.resolve<DnsExternalLoginResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DnsExternalLoginResultDto>(null as any);
    }
}

export class EUsServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAll(body?: GetAllEUsInput | undefined, cancelToken?: CancelToken): Promise<GetEUForViewDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/EUs/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<GetEUForViewDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEUForViewDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<GetEUForViewDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEUForViewDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getEUForEdit(id?: string | undefined, cancelToken?: CancelToken): Promise<GetEUForEditOutput> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/EUs/GetEUForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEUForEdit(_response);
        });
    }

    protected processGetEUForEdit(response: AxiosResponse): Promise<GetEUForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEUForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetEUForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEUForEditOutput>(null as any);
    }

    /**
     * 检查CustomerNumber是否存在
     * @return OK
     */
    checkCustomerNumberExist(cusNo: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/EUs/CheckCustomerNumberExist?";
        if (cusNo === undefined || cusNo === null)
            throw new globalThis.Error("The parameter 'cusNo' must be defined and cannot be null.");
        else
            url_ += "cusNo=" + encodeURIComponent("" + cusNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckCustomerNumberExist(_response);
        });
    }

    protected processCheckCustomerNumberExist(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body?: CreateOrEditEUDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/EUs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrEdit(_response);
        });
    }

    protected processCreateOrEdit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量删除
     * @param customerNumbers (optional) 
     * @return OK
     */
    delete(customerNumbers?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/EUs/Delete?";
        if (customerNumbers === null)
            throw new globalThis.Error("The parameter 'customerNumbers' cannot be null.");
        else if (customerNumbers !== undefined)
            customerNumbers && customerNumbers.forEach(item => { url_ += "customerNumbers=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取客户地址
     * @param clientCode (optional) 客户编号
     * @return OK
     */
    getAllCustomerInfoForTableDropdown(clientCode?: string | undefined, cancelToken?: CancelToken): Promise<EUCustomerInfoLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/EUs/GetAllCustomerInfoForTableDropdown?";
        if (clientCode === null)
            throw new globalThis.Error("The parameter 'clientCode' cannot be null.");
        else if (clientCode !== undefined)
            url_ += "clientCode=" + encodeURIComponent("" + clientCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCustomerInfoForTableDropdown(_response);
        });
    }

    protected processGetAllCustomerInfoForTableDropdown(response: AxiosResponse): Promise<EUCustomerInfoLookupTableDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EUCustomerInfoLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EUCustomerInfoLookupTableDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EUCustomerInfoLookupTableDto[]>(null as any);
    }

    /**
     * 根据客户名称，获取客户信息
     * @param customerNumber (optional) 
     * @param nameCN (optional) 
     * @param telephone (optional) 
     * @param street (optional) 
     * @param contactName (optional) 
     * @param contactEmail (optional) 
     * @param customerInfoCusNo (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getCusInfoByCustomerName(customerNumber?: string | undefined, nameCN?: string | undefined, telephone?: string | undefined, street?: string | undefined, contactName?: string | undefined, contactEmail?: string | undefined, customerInfoCusNo?: string | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<GetEUForEditOutput[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/EUs/GetCusInfoByCustomerName?";
        if (customerNumber === null)
            throw new globalThis.Error("The parameter 'customerNumber' cannot be null.");
        else if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&";
        if (nameCN === null)
            throw new globalThis.Error("The parameter 'nameCN' cannot be null.");
        else if (nameCN !== undefined)
            url_ += "NameCN=" + encodeURIComponent("" + nameCN) + "&";
        if (telephone === null)
            throw new globalThis.Error("The parameter 'telephone' cannot be null.");
        else if (telephone !== undefined)
            url_ += "Telephone=" + encodeURIComponent("" + telephone) + "&";
        if (street === null)
            throw new globalThis.Error("The parameter 'street' cannot be null.");
        else if (street !== undefined)
            url_ += "Street=" + encodeURIComponent("" + street) + "&";
        if (contactName === null)
            throw new globalThis.Error("The parameter 'contactName' cannot be null.");
        else if (contactName !== undefined)
            url_ += "ContactName=" + encodeURIComponent("" + contactName) + "&";
        if (contactEmail === null)
            throw new globalThis.Error("The parameter 'contactEmail' cannot be null.");
        else if (contactEmail !== undefined)
            url_ += "ContactEmail=" + encodeURIComponent("" + contactEmail) + "&";
        if (customerInfoCusNo === null)
            throw new globalThis.Error("The parameter 'customerInfoCusNo' cannot be null.");
        else if (customerInfoCusNo !== undefined)
            url_ += "CustomerInfoCusNo=" + encodeURIComponent("" + customerInfoCusNo) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCusInfoByCustomerName(_response);
        });
    }

    protected processGetCusInfoByCustomerName(response: AxiosResponse): Promise<GetEUForEditOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEUForEditOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetEUForEditOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEUForEditOutput[]>(null as any);
    }

    /**
     * 根据客户编码list查询返回所有的客户信息
     * @param cusNoList (optional) 
     * @return OK
     */
    getListByCusNoList(cusNoList?: string[] | undefined, cancelToken?: CancelToken): Promise<EUDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/EUs/GetListByCusNoList?";
        if (cusNoList === null)
            throw new globalThis.Error("The parameter 'cusNoList' cannot be null.");
        else if (cusNoList !== undefined)
            cusNoList && cusNoList.forEach(item => { url_ += "CusNoList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListByCusNoList(_response);
        });
    }

    protected processGetListByCusNoList(response: AxiosResponse): Promise<EUDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EUDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EUDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EUDto[]>(null as any);
    }

    /**
     * 移除缓存
     * @return OK
     */
    removeCache( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/EUs/RemoveCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveCache(_response);
        });
    }

    protected processRemoveCache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ExportFileServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 文件下载
     * @param fileName (optional) 
     * @return OK
     */
    downloadFileStream(fileName?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/ExportFile/DownloadFileStream?";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadFileStream(_response);
        });
    }

    protected processDownloadFileStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class HolidayServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 启动服务
     * @param body (optional) 
     * @return OK
     */
    start(body?: HolidayJobArgs | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Holiday/Start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStart(_response);
        });
    }

    protected processStart(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 停止任务
     * @return OK
     */
    stop( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Holiday/Stop";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStop(_response);
        });
    }

    protected processStop(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量获取假期信息
     * @param year (optional) 
     * @return OK
     */
    getAll(year?: number | undefined, cancelToken?: CancelToken): Promise<HolidayDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Holiday/GetAll?";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<HolidayDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HolidayDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<HolidayDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HolidayDto[]>(null as any);
    }

    /**
     * 计算最终交付日期
     * @param initialDeliveryDate (optional) 
     * @return OK
     */
    calculateFinalDeliveryDate(initialDeliveryDate?: string | undefined, cancelToken?: CancelToken): Promise<moment.Moment> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Holiday/CalculateFinalDeliveryDate?";
        if (initialDeliveryDate === null)
            throw new globalThis.Error("The parameter 'initialDeliveryDate' cannot be null.");
        else if (initialDeliveryDate !== undefined)
            url_ += "initialDeliveryDate=" + encodeURIComponent("" + initialDeliveryDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateFinalDeliveryDate(_response);
        });
    }

    protected processCalculateFinalDeliveryDate(response: AxiosResponse): Promise<moment.Moment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 ? moment(resultData200.toString()) : null as any;
    
            return Promise.resolve<moment.Moment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<moment.Moment>(null as any);
    }

    /**
     * 获取当前日期至结束日期中包含的法定节假日天数
     * @param endDate (optional) 结束日期
     * @return OK
     */
    containsHoliday(endDate?: string | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Holiday/ContainsHoliday?";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContainsHoliday(_response);
        });
    }

    protected processContainsHoliday(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class HrClientServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 授权接口
     * @return OK
     */
    authorize( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/HrClient/Authorize";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthorize(_response);
        });
    }

    protected processAuthorize(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取员工调动信息
     * @param date (optional) 日期字符(yyyy-MM-dd),默认当天
     * @return OK
     */
    getTransferEmployeeByDate(date?: string | undefined, cancelToken?: CancelToken): Promise<EmployeeDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/HrClient/GetTransferEmployeeByDate?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTransferEmployeeByDate(_response);
        });
    }

    protected processGetTransferEmployeeByDate(response: AxiosResponse): Promise<EmployeeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EmployeeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeDto[]>(null as any);
    }

    /**
     * 通过邮箱获取雇员信息
     * @param email (optional) 
     * @return OK
     */
    getEmployeeByEmail(email?: string | undefined, cancelToken?: CancelToken): Promise<EmployeeDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/HrClient/GetEmployeeByEmail?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeeByEmail(_response);
        });
    }

    protected processGetEmployeeByEmail(response: AxiosResponse): Promise<EmployeeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmployeeDto.fromJS(resultData200);
            return Promise.resolve<EmployeeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeDto>(null as any);
    }
}

export class LockoutVerificationServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 启动服务
     * @param body (optional) 
     * @return OK
     */
    start(body?: LockoutVerificationArgs | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/LockoutVerification/Start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStart(_response);
        });
    }

    protected processStart(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 停止任务
     * @return OK
     */
    stop( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/LockoutVerification/Stop";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStop(_response);
        });
    }

    protected processStop(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MultiplierServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param filter (optional) 
     * @param preCalNoFilter (optional) 
     * @param customerInfoCusNoFk (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter?: string | undefined, preCalNoFilter?: string | undefined, customerInfoCusNoFk?: string | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<GetMultiplierForViewDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Multiplier/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (preCalNoFilter === null)
            throw new globalThis.Error("The parameter 'preCalNoFilter' cannot be null.");
        else if (preCalNoFilter !== undefined)
            url_ += "PreCalNoFilter=" + encodeURIComponent("" + preCalNoFilter) + "&";
        if (customerInfoCusNoFk === null)
            throw new globalThis.Error("The parameter 'customerInfoCusNoFk' cannot be null.");
        else if (customerInfoCusNoFk !== undefined)
            url_ += "CustomerInfoCusNoFk=" + encodeURIComponent("" + customerInfoCusNoFk) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<GetMultiplierForViewDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMultiplierForViewDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<GetMultiplierForViewDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMultiplierForViewDtoPagedResultDto>(null as any);
    }

    /**
     * 根据客户编码获取，客户折扣
     * @param customerNo (optional) 
     * @return OK
     */
    getMultiplierByCustomerNo(customerNo?: string | undefined, cancelToken?: CancelToken): Promise<GetMultiplierForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Multiplier/GetMultiplierByCustomerNo?";
        if (customerNo === null)
            throw new globalThis.Error("The parameter 'customerNo' cannot be null.");
        else if (customerNo !== undefined)
            url_ += "CustomerNo=" + encodeURIComponent("" + customerNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMultiplierByCustomerNo(_response);
        });
    }

    protected processGetMultiplierByCustomerNo(response: AxiosResponse): Promise<GetMultiplierForViewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetMultiplierForViewDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetMultiplierForViewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMultiplierForViewDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMultiplierForView(id?: number | undefined, cancelToken?: CancelToken): Promise<GetMultiplierForViewDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Multiplier/GetMultiplierForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMultiplierForView(_response);
        });
    }

    protected processGetMultiplierForView(response: AxiosResponse): Promise<GetMultiplierForViewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMultiplierForViewDto.fromJS(resultData200);
            return Promise.resolve<GetMultiplierForViewDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMultiplierForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMultiplierForEdit(id?: number | undefined, cancelToken?: CancelToken): Promise<GetMultiplierForEditOutput> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Multiplier/GetMultiplierForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMultiplierForEdit(_response);
        });
    }

    protected processGetMultiplierForEdit(response: AxiosResponse): Promise<GetMultiplierForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMultiplierForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetMultiplierForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMultiplierForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body?: CreateOrEditMultiplierDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Multiplier/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrEdit(_response);
        });
    }

    protected processCreateOrEdit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Multiplier/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PasswordVerificationServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 启动服务
     * @param body (optional) 
     * @return OK
     */
    start(body?: PasswordVerificationArgs | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/PasswordVerification/Start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStart(_response);
        });
    }

    protected processStart(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 停止任务
     * @return OK
     */
    stop( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/PasswordVerification/Stop";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStop(_response);
        });
    }

    protected processStop(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PermissionServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return OK
     */
    getAllPermissions( cancelToken?: CancelToken): Promise<FlatPermissionWithLevelDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPermissions(_response);
        });
    }

    protected processGetAllPermissions(response: AxiosResponse): Promise<FlatPermissionWithLevelDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FlatPermissionWithLevelDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<FlatPermissionWithLevelDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FlatPermissionWithLevelDtoListResultDto>(null as any);
    }
}

export class PermissionTestServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return OK
     */
    getAllowAnonymousGet( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/PermissionTest/GetAllowAnonymous";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllowAnonymousGet(_response);
        });
    }

    protected processGetAllowAnonymousGet(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getAbpAuthorizeGet( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/PermissionTest/GetAbpAuthorize";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAbpAuthorizeGet(_response);
        });
    }

    protected processGetAbpAuthorizeGet(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getIsGrantedGet( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/PermissionTest/GetIsGranted";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsGrantedGet(_response);
        });
    }

    protected processGetIsGrantedGet(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 测试方法：直接调用 HandleCustomerUpdateAsync 进行断点调试
    使用示例：
    var messageBody = @"{
        ""data"": {
            ""MDMCode"": ""M10300099"",
            ""SAPCode"": """",
            ...
        }
    }";
     * @param messageBody (optional) MDM消息JSON字符串
     * @return OK
     */
    testMDMToMSPCustomer(messageBody?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/PermissionTest/TestMDMToMSPCustomer?";
        if (messageBody === null)
            throw new globalThis.Error("The parameter 'messageBody' cannot be null.");
        else if (messageBody !== undefined)
            url_ += "messageBody=" + encodeURIComponent("" + messageBody) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestMDMToMSPCustomer(_response);
        });
    }

    protected processTestMDMToMSPCustomer(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 测试方法：直接调用 HandleCustomerCreateAsync 进行断点调试
     * @param messageBody (optional) MDM消息JSON字符串
     * @return OK
     */
    testMDMToMSPCustomerCreate(messageBody?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/PermissionTest/TestMDMToMSPCustomerCreate?";
        if (messageBody === null)
            throw new globalThis.Error("The parameter 'messageBody' cannot be null.");
        else if (messageBody !== undefined)
            url_ += "messageBody=" + encodeURIComponent("" + messageBody) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestMDMToMSPCustomerCreate(_response);
        });
    }

    protected processTestMDMToMSPCustomerCreate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getAbpSessionCheckGet( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/PermissionTest/GetAbpSessionCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAbpSessionCheckGet(_response);
        });
    }

    protected processGetAbpSessionCheckGet(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getAllowAnonymousGet( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/PermissionTest/GetAllowAnonymous";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllowAnonymousGet(_response);
        });
    }

    protected processGetAllowAnonymousGet(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getAbpAuthorizeGet( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/PermissionTest/GetAbpAuthorize";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAbpAuthorizeGet(_response);
        });
    }

    protected processGetAbpAuthorizeGet(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getIsGrantedGet( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/PermissionTest/GetIsGranted";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsGrantedGet(_response);
        });
    }

    protected processGetIsGrantedGet(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getAbpSessionCheckGet( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/PermissionTest/GetAbpSessionCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAbpSessionCheckGet(_response);
        });
    }

    protected processGetAbpSessionCheckGet(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class RegionsServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取区域信息
    包含三级省市县逻辑
    http://localhost:8080/api/services/DigitalLogisticSystem/Regions/GetAll
    http://localhost:8080/api/services/DigitalLogisticSystem/Regions/GetAll?ParentId=1
     * @param parentId (optional) 
     * @return OK
     */
    getAll(parentId?: number | undefined, cancelToken?: CancelToken): Promise<RegionsDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Regions/GetAll?";
        if (parentId === null)
            throw new globalThis.Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "ParentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<RegionsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegionsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RegionsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegionsDto[]>(null as any);
    }

    /**
     * @param spell (optional) SAP 对应sap的city集合
     * @return OK
     */
    getAllCity(spell?: string | undefined, cancelToken?: CancelToken): Promise<RegionsDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Regions/GetAllCity?";
        if (spell === null)
            throw new globalThis.Error("The parameter 'spell' cannot be null.");
        else if (spell !== undefined)
            url_ += "spell=" + encodeURIComponent("" + spell) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCity(_response);
        });
    }

    protected processGetAllCity(response: AxiosResponse): Promise<RegionsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegionsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RegionsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegionsDto[]>(null as any);
    }
}

export class ResignEmployeeServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 启动服务
     * @param body (optional) 
     * @return OK
     */
    start(body?: ResignEmployeeArgs | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/ResignEmployee/Start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStart(_response);
        });
    }

    protected processStart(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 停止任务
     * @return OK
     */
    stop( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/ResignEmployee/Stop";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStop(_response);
        });
    }

    protected processStop(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class RoleServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body?: CreateRoleDto | undefined, cancelToken?: CancelToken): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDto.fromJS(resultData200);
            return Promise.resolve<RoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto>(null as any);
    }

    /**
     * @param permission (optional) 
     * @return OK
     */
    getRoles(permission?: string | undefined, cancelToken?: CancelToken): Promise<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Role/GetRoles?";
        if (permission === null)
            throw new globalThis.Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<RoleListDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<RoleListDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleListDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body?: RoleDto | undefined, cancelToken?: CancelToken): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDto.fromJS(resultData200);
            return Promise.resolve<RoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Role/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getAllPermissions( cancelToken?: CancelToken): Promise<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPermissions(_response);
        });
    }

    protected processGetAllPermissions(response: AxiosResponse): Promise<PermissionDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<PermissionDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PermissionDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getRoleForEdit(id?: number | undefined, cancelToken?: CancelToken): Promise<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Role/GetRoleForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoleForEdit(_response);
        });
    }

    protected processGetRoleForEdit(response: AxiosResponse): Promise<GetRoleForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetRoleForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRoleForEditOutput>(null as any);
    }

    /**
     * 获取静态角色名称
     * @return OK
     */
    getStaticRoleName( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Role/GetStaticRoleName";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStaticRoleName(_response);
        });
    }

    protected processGetStaticRoleName(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 角色权限变更日志
     * @param body (optional) 
     * @return OK
     */
    getRolePermissionsChangeLogs(body?: PageSearchRolePermissionsChangeLogsDto | undefined, cancelToken?: CancelToken): Promise<RolePermissionsChangeLogsInputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Role/GetRolePermissionsChangeLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRolePermissionsChangeLogs(_response);
        });
    }

    protected processGetRolePermissionsChangeLogs(response: AxiosResponse): Promise<RolePermissionsChangeLogsInputDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RolePermissionsChangeLogsInputDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<RolePermissionsChangeLogsInputDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RolePermissionsChangeLogsInputDtoPagedResultDto>(null as any);
    }

    /**
     * 获取用户角色变更日志
     * @param userFullName (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getUserRoleChangeLog(userFullName?: string | undefined, startDate?: moment.Moment | undefined, endDate?: moment.Moment | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<UserRoleChangeLogInputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Role/GetUserRoleChangeLog?";
        if (userFullName === null)
            throw new globalThis.Error("The parameter 'userFullName' cannot be null.");
        else if (userFullName !== undefined)
            url_ += "UserFullName=" + encodeURIComponent("" + userFullName) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserRoleChangeLog(_response);
        });
    }

    protected processGetUserRoleChangeLog(response: AxiosResponse): Promise<UserRoleChangeLogInputDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserRoleChangeLogInputDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<UserRoleChangeLogInputDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserRoleChangeLogInputDtoPagedResultDto>(null as any);
    }

    /**
     * 导出Excel-角色权限变更日志
     * @param body (optional) 
     * @return OK
     */
    getRolePermissionsChangeLogsToExcel(body?: PageSearchRolePermissionsChangeLogsDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Role/GetRolePermissionsChangeLogsToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRolePermissionsChangeLogsToExcel(_response);
        });
    }

    protected processGetRolePermissionsChangeLogsToExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导出Excel-用户权限变更日志
     * @param userFullName (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getUserRoleChangeLogsToExcel(userFullName?: string | undefined, startDate?: moment.Moment | undefined, endDate?: moment.Moment | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Role/GetUserRoleChangeLogsToExcel?";
        if (userFullName === null)
            throw new globalThis.Error("The parameter 'userFullName' cannot be null.");
        else if (userFullName !== undefined)
            url_ += "UserFullName=" + encodeURIComponent("" + userFullName) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserRoleChangeLogsToExcel(_response);
        });
    }

    protected processGetUserRoleChangeLogsToExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id?: number | undefined, cancelToken?: CancelToken): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Role/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDto.fromJS(resultData200);
            return Promise.resolve<RoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(keyword?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Role/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<RoleDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<RoleDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDtoPagedResultDto>(null as any);
    }
}

export class SessionServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return OK
     */
    getCurrentLoginInformations( cancelToken?: CancelToken): Promise<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentLoginInformations(_response);
        });
    }

    protected processGetCurrentLoginInformations(response: AxiosResponse): Promise<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return Promise.resolve<GetCurrentLoginInformationsOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCurrentLoginInformationsOutput>(null as any);
    }

    /**
     * @return OK
     */
    updateUserSignInToken( cancelToken?: CancelToken): Promise<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserSignInToken(_response);
        });
    }

    protected processUpdateUserSignInToken(response: AxiosResponse): Promise<UpdateUserSignInTokenOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateUserSignInTokenOutput.fromJS(resultData200);
            return Promise.resolve<UpdateUserSignInTokenOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateUserSignInTokenOutput>(null as any);
    }
}

export class ShippingAddressServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id?: number | undefined, cancelToken?: CancelToken): Promise<ShippingAddressDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/ShippingAddress/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ShippingAddressDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ShippingAddressDto.fromJS(resultData200);
            return Promise.resolve<ShippingAddressDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShippingAddressDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body?: ShippingAddressDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/ShippingAddress/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrEdit(_response);
        });
    }

    protected processCreateOrEdit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量删除
     * @param idListStr (optional) 
     * @return OK
     */
    delete(idListStr?: number[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/ShippingAddress/Delete?";
        if (idListStr === null)
            throw new globalThis.Error("The parameter 'idListStr' cannot be null.");
        else if (idListStr !== undefined)
            idListStr && idListStr.forEach(item => { url_ += "idListStr=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据客户获取默认收货地址
    http://localhost/api/services/DigitalLogisticSystem/ShippingAddress/GetDefault?CusNo=1000017
     * @param cusNo (optional) 
     * @return OK
     */
    getDefault(cusNo?: string | undefined, cancelToken?: CancelToken): Promise<ShippingAddressDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/ShippingAddress/GetDefault?";
        if (cusNo === null)
            throw new globalThis.Error("The parameter 'cusNo' cannot be null.");
        else if (cusNo !== undefined)
            url_ += "CusNo=" + encodeURIComponent("" + cusNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDefault(_response);
        });
    }

    protected processGetDefault(response: AxiosResponse): Promise<ShippingAddressDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ShippingAddressDto.fromJS(resultData200);
            return Promise.resolve<ShippingAddressDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShippingAddressDto>(null as any);
    }

    /**
     * 获取列表信息
    http://localhost:8080/api/services/DigitalLogisticSystem/ShippingAddress/GetList
     * @param body (optional) 
     * @return OK
     */
    getPageList(body?: GetShippingAddressInput | undefined, cancelToken?: CancelToken): Promise<PageTotalShippingAddressDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/ShippingAddress/GetPageList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageList(_response);
        });
    }

    protected processGetPageList(response: AxiosResponse): Promise<PageTotalShippingAddressDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageTotalShippingAddressDto.fromJS(resultData200);
            return Promise.resolve<PageTotalShippingAddressDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageTotalShippingAddressDto>(null as any);
    }

    /**
     * 根据条件获取所有的地址信息 CusNo ShipType必须传递一个值
     * @param cusNo (optional) 客户号
     * @param shipType (optional) 收货地址类型
     * @return OK
     */
    getAll(cusNo?: string | undefined, shipType?: number | undefined, cancelToken?: CancelToken): Promise<ShippingAddressDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/ShippingAddress/GetAll?";
        if (cusNo === null)
            throw new globalThis.Error("The parameter 'cusNo' cannot be null.");
        else if (cusNo !== undefined)
            url_ += "CusNo=" + encodeURIComponent("" + cusNo) + "&";
        if (shipType === null)
            throw new globalThis.Error("The parameter 'shipType' cannot be null.");
        else if (shipType !== undefined)
            url_ += "ShipType=" + encodeURIComponent("" + shipType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ShippingAddressDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShippingAddressDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ShippingAddressDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShippingAddressDto[]>(null as any);
    }
}

export class TokenAuthServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 用户名密码认证
     * @param body (optional) 
     * @return OK
     */
    authenticate(body?: AuthenticateModel | undefined, cancelToken?: CancelToken): Promise<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: AxiosResponse): Promise<AuthenticateResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return Promise.resolve<AuthenticateResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResultModel>(null as any);
    }

    /**
     * ccs/pms service account认证
     * @param body (optional) 
     * @return OK
     */
    authenticateByServiceAccount(body?: AuthenticateByServiceAccountModel | undefined, cancelToken?: CancelToken): Promise<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/AuthenticateByServiceAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticateByServiceAccount(_response);
        });
    }

    protected processAuthenticateByServiceAccount(response: AxiosResponse): Promise<AuthenticateResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return Promise.resolve<AuthenticateResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResultModel>(null as any);
    }

    /**
     * 获取外部认证提供商
     * @return OK
     */
    getExternalAuthenticationProviders( cancelToken?: CancelToken): Promise<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExternalAuthenticationProviders(_response);
        });
    }

    protected processGetExternalAuthenticationProviders(response: AxiosResponse): Promise<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ExternalLoginProviderInfoModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExternalLoginProviderInfoModel[]>(null as any);
    }

    /**
     * 外部认证
     * @param body (optional) 
     * @return OK
     */
    externalAuthenticate(body?: ExternalAuthenticateModel | undefined, cancelToken?: CancelToken): Promise<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalAuthenticate(_response);
        });
    }

    protected processExternalAuthenticate(response: AxiosResponse): Promise<AuthenticateResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return Promise.resolve<AuthenticateResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResultModel>(null as any);
    }
}

export class TransferEmployeeServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 筛选人员变动信息
     * @param body (optional) 
     * @return OK
     */
    query(body?: QueryInputDto | undefined, cancelToken?: CancelToken): Promise<QueryOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/TransferEmployee/Query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryOutputDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryOutputDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<QueryOutputDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryOutputDtoPagedResultDto>(null as any);
    }

    /**
     * 删除人员变动信息
     * @return OK
     */
    transferEmployeeDelete(transferEmployeeId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/TransferEmployee/{transferEmployeeId}";
        if (transferEmployeeId === undefined || transferEmployeeId === null)
            throw new globalThis.Error("The parameter 'transferEmployeeId' must be defined.");
        url_ = url_.replace("{transferEmployeeId}", encodeURIComponent("" + transferEmployeeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransferEmployeeDelete(_response);
        });
    }

    protected processTransferEmployeeDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 启动服务
     * @param body (optional) 
     * @return OK
     */
    start(body?: TransferEmployeeArgs | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/TransferEmployee/Start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStart(_response);
        });
    }

    protected processStart(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 停止任务
     * @return OK
     */
    stop( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/TransferEmployee/Stop";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStop(_response);
        });
    }

    protected processStop(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 文件上传
     * @param excelFile (optional) 
     * @return OK
     */
    transferEmployeePost(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/TransferEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransferEmployeePost(_response);
        });
    }

    protected processTransferEmployeePost(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class UserServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 创建
     * @param body (optional) 
     * @return OK
     */
    create(body?: CreateUserDto | undefined, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * 修改
     * @param body (optional) 
     * @return OK
     */
    update(body?: UserDto | undefined, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * 删除(禁用用户)
     * @param id (optional) 
     * @return OK
     */
    delete(id?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 解锁用户
     * @param body (optional) 
     * @return OK
     */
    unlockUserPost(body?: Int64EntityDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlockUserPost(_response);
        });
    }

    protected processUnlockUserPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 恢复用户
     * @param userId (optional) 用户编号
     * @return OK
     */
    unlockUserPut(userId?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/UnlockUser?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlockUserPut(_response);
        });
    }

    protected processUnlockUserPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 用户启用
     * @param body (optional) 
     * @return OK
     */
    unDisabledUser(body?: Int64EntityDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/UnDisabledUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnDisabledUser(_response);
        });
    }

    protected processUnDisabledUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param isAll (optional) 
     * @return OK
     */
    getRoles(isAll?: boolean | undefined, cancelToken?: CancelToken): Promise<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/GetRoles?";
        if (isAll === null)
            throw new globalThis.Error("The parameter 'isAll' cannot be null.");
        else if (isAll !== undefined)
            url_ += "IsAll=" + encodeURIComponent("" + isAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<RoleDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<RoleDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDtoListResultDto>(null as any);
    }

    /**
     * 根据userid ，获取角色id，角色name，，userid为空，就取 当前登录人
     * @param userid (optional) 
     * @return OK
     */
    getUserRoleByUserId(userid?: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/GetUserRoleByUserId?";
        if (userid === null)
            throw new globalThis.Error("The parameter 'userid' cannot be null.");
        else if (userid !== undefined)
            url_ += "userid=" + encodeURIComponent("" + userid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserRoleByUserId(_response);
        });
    }

    protected processGetUserRoleByUserId(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 切换语言
     * @param body (optional) 
     * @return OK
     */
    changeLanguage(body?: ChangeUserLanguageDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeLanguage(_response);
        });
    }

    protected processChangeLanguage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param roleId (optional) 
     * @param state (optional) 0 = All (全部)

    1 = Available (在用)

    2 = Pause (未激活)

    3 = Deleted (禁用)
     * @param userRoleType (optional) 0 = All (全部)

    1 = User (普通用户)

    2 = SuperUser (超级用户)
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(keyword?: string | undefined, isActive?: boolean | undefined, roleId?: number | undefined, state?: UserStateEnum | undefined, userRoleType?: UserRoleTypeEnum | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new globalThis.Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (roleId === null)
            throw new globalThis.Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (state === null)
            throw new globalThis.Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (userRoleType === null)
            throw new globalThis.Error("The parameter 'userRoleType' cannot be null.");
        else if (userRoleType !== undefined)
            url_ += "UserRoleType=" + encodeURIComponent("" + userRoleType) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<UserDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<UserDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDtoPagedResultDto>(null as any);
    }

    /**
     * 有效用户
     * @return OK
     */
    validUsers( cancelToken?: CancelToken): Promise<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/ValidUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidUsers(_response);
        });
    }

    protected processValidUsers(response: AxiosResponse): Promise<UserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto[]>(null as any);
    }

    /**
     * 创建用户登录时间
     * @return OK
     */
    createLastLoginTime( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/CreateLastLoginTime";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLastLoginTime(_response);
        });
    }

    protected processCreateLastLoginTime(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changePassword(body?: ChangePasswordDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 重置密码
     * @param body (optional) 
     * @return OK
     */
    resetPassword(body?: ResetPasswordDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 根据角色名称获取用户Id和Name
     * @return OK
     */
    getUserIdAndNameByRoleName(roleName: string, cancelToken?: CancelToken): Promise<GetUserIdAndNameByRoleNameOutput[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/GetUserIdAndNameByRoleName?";
        if (roleName === undefined || roleName === null)
            throw new globalThis.Error("The parameter 'roleName' must be defined and cannot be null.");
        else
            url_ += "roleName=" + encodeURIComponent("" + roleName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserIdAndNameByRoleName(_response);
        });
    }

    protected processGetUserIdAndNameByRoleName(response: AxiosResponse): Promise<GetUserIdAndNameByRoleNameOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserIdAndNameByRoleNameOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetUserIdAndNameByRoleNameOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserIdAndNameByRoleNameOutput[]>(null as any);
    }

    /**
     * 获取GSC角色下的用户Id和UserName
     * @return OK
     */
    getUserIdAndNameByGSC( cancelToken?: CancelToken): Promise<GcsMaintainUserDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/GetUserIdAndNameByGSC";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserIdAndNameByGSC(_response);
        });
    }

    protected processGetUserIdAndNameByGSC(response: AxiosResponse): Promise<GcsMaintainUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GcsMaintainUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GcsMaintainUserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GcsMaintainUserDto[]>(null as any);
    }

    /**
     * 判断当前用户是否在GCS中
     * @param userId 用户Id
     * @return OK
     */
    judgeUserIsGCSRole(userId: number, cancelToken?: CancelToken): Promise<GcsMaintainUserDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/JudgeUserIsGCSRole?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processJudgeUserIsGCSRole(_response);
        });
    }

    protected processJudgeUserIsGCSRole(response: AxiosResponse): Promise<GcsMaintainUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GcsMaintainUserDto.fromJS(resultData200);
            return Promise.resolve<GcsMaintainUserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GcsMaintainUserDto>(null as any);
    }

    /**
     * 根据username获取用户Id和Name
     * @param body (optional) 
     * @return OK
     */
    getUserIdAndNamesByUserNames(body?: string[] | undefined, cancelToken?: CancelToken): Promise<GetUserIdAndNameByRoleNameOutput[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/GetUserIdAndNamesByUserNames";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserIdAndNamesByUserNames(_response);
        });
    }

    protected processGetUserIdAndNamesByUserNames(response: AxiosResponse): Promise<GetUserIdAndNameByRoleNameOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserIdAndNameByRoleNameOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetUserIdAndNameByRoleNameOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserIdAndNameByRoleNameOutput[]>(null as any);
    }

    /**
     * 根据userid获取用户Id和UserName
     * @param body (optional) 
     * @return OK
     */
    getUserIdAndUserNamesByUserIds(body?: number[] | undefined, cancelToken?: CancelToken): Promise<GetUserIdAndNameByRoleNameOutput[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/GetUserIdAndUserNamesByUserIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserIdAndUserNamesByUserIds(_response);
        });
    }

    protected processGetUserIdAndUserNamesByUserIds(response: AxiosResponse): Promise<GetUserIdAndNameByRoleNameOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserIdAndNameByRoleNameOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetUserIdAndNameByRoleNameOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserIdAndNameByRoleNameOutput[]>(null as any);
    }

    /**
     * 根据userid获取用户Id和Name
     * @param body (optional) 
     * @return OK
     */
    getUserIdAndNamesByUserIds(body?: number[] | undefined, cancelToken?: CancelToken): Promise<GetUserIdAndNameByRoleNameOutput[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/GetUserIdAndNamesByUserIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserIdAndNamesByUserIds(_response);
        });
    }

    protected processGetUserIdAndNamesByUserIds(response: AxiosResponse): Promise<GetUserIdAndNameByRoleNameOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserIdAndNameByRoleNameOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetUserIdAndNameByRoleNameOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserIdAndNameByRoleNameOutput[]>(null as any);
    }

    /**
     * 根据email获取用户Id和Name
     * @param body (optional) 
     * @return OK
     */
    getUserIdAndNamesByEmails(body?: string[] | undefined, cancelToken?: CancelToken): Promise<GetUserIdAndNameByRoleNameOutput[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/GetUserIdAndNamesByEmails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserIdAndNamesByEmails(_response);
        });
    }

    protected processGetUserIdAndNamesByEmails(response: AxiosResponse): Promise<GetUserIdAndNameByRoleNameOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserIdAndNameByRoleNameOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetUserIdAndNameByRoleNameOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserIdAndNameByRoleNameOutput[]>(null as any);
    }

    /**
     * 模糊查询userid根据用户全名或公司名
     * @param roleNames (optional) 多个角色名(可选)
     * @param body (optional) 用户全名或公司名
     * @return OK
     */
    getUserIdAndNamesByLikeName(roleNames?: string[] | undefined, body?: string | undefined, cancelToken?: CancelToken): Promise<GetUserIdAndNameByRoleNameOutput[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/GetUserIdAndNamesByLikeName?";
        if (roleNames === null)
            throw new globalThis.Error("The parameter 'roleNames' cannot be null.");
        else if (roleNames !== undefined)
            roleNames && roleNames.forEach(item => { url_ += "roleNames=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserIdAndNamesByLikeName(_response);
        });
    }

    protected processGetUserIdAndNamesByLikeName(response: AxiosResponse): Promise<GetUserIdAndNameByRoleNameOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserIdAndNameByRoleNameOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetUserIdAndNameByRoleNameOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserIdAndNameByRoleNameOutput[]>(null as any);
    }

    /**
     * 发送邮件(BCC)
     * @param body (optional) 
     * @return OK
     */
    sendMail(body?: SendMailDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/SendMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendMail(_response);
        });
    }

    protected processSendMail(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 发送邮件（TO OR CC）
     * @param body (optional) 
     * @return OK
     */
    sendMailCC(body?: SendMailCCDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/SendMailCC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendMailCC(_response);
        });
    }

    protected processSendMailCC(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 通过用户邮箱获取用户信息
     * @param email (optional) 
     * @return OK
     */
    getUserByEmail(email?: string | undefined, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/GetUserByEmail?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserByEmail(_response);
        });
    }

    protected processGetUserByEmail(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * @param password (optional) 
     * @param body (optional) 
     * @return OK
     */
    passwordVerification(password?: string | undefined, body?: User | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/PasswordVerification?";
        if (password === null)
            throw new globalThis.Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPasswordVerification(_response);
        });
    }

    protected processPasswordVerification(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 密码验证
     * @param userId (optional) 
     * @param password (optional) 
     * @return OK
     */
    passwordVerificationByUserId(userId?: number | undefined, password?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/PasswordVerificationByUserId?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (password === null)
            throw new globalThis.Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPasswordVerificationByUserId(_response);
        });
    }

    protected processPasswordVerificationByUserId(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    passwordGenerate(body?: User | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/PasswordGenerate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPasswordGenerate(_response);
        });
    }

    protected processPasswordGenerate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 密码生成
    密码至少8位。
     新密码不能同前24次更改的密码一致。
     系统管理员密码长度不能小于15位。
    密码至少包含以下4项中的3项
    --密码包含数字
    --密码包含大写的英文字母
    --密码包含小写的英文字母
    --密码包含如%、@、&等特殊字符
     * @param userId (optional) 
     * @return OK
     */
    passwordGenerateByUserId(userId?: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/PasswordGenerateByUserId?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPasswordGenerateByUserId(_response);
        });
    }

    protected processPasswordGenerateByUserId(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * UserAccessRightReview查询
     * @return OK
     */
    getCNIABCscotPartscotInterfaceNormalUserAccessRightReview( cancelToken?: CancelToken): Promise<CNIABCscotPartscotInterfaceNormalUserAccessRightReviewlInputDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/GetCNIABCscotPartscotInterfaceNormalUserAccessRightReview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCNIABCscotPartscotInterfaceNormalUserAccessRightReview(_response);
        });
    }

    protected processGetCNIABCscotPartscotInterfaceNormalUserAccessRightReview(response: AxiosResponse): Promise<CNIABCscotPartscotInterfaceNormalUserAccessRightReviewlInputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CNIABCscotPartscotInterfaceNormalUserAccessRightReviewlInputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CNIABCscotPartscotInterfaceNormalUserAccessRightReviewlInputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CNIABCscotPartscotInterfaceNormalUserAccessRightReviewlInputDto[]>(null as any);
    }

    /**
     * UserAccessRightReview导出报表
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param roleId (optional) 
     * @param state (optional) 0 = All (全部)

    1 = Available (在用)

    2 = Pause (未激活)

    3 = Deleted (禁用)
     * @param userRoleType (optional) 0 = All (全部)

    1 = User (普通用户)

    2 = SuperUser (超级用户)
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getCNIABCscotPartscotInterfaceNormalUserAccessRightReviewToExcel(keyword?: string | undefined, isActive?: boolean | undefined, roleId?: number | undefined, state?: UserStateEnum | undefined, userRoleType?: UserRoleTypeEnum | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/GetCNIABCscotPartscotInterfaceNormalUserAccessRightReviewToExcel?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new globalThis.Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (roleId === null)
            throw new globalThis.Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (state === null)
            throw new globalThis.Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (userRoleType === null)
            throw new globalThis.Error("The parameter 'userRoleType' cannot be null.");
        else if (userRoleType !== undefined)
            url_ += "UserRoleType=" + encodeURIComponent("" + userRoleType) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCNIABCscotPartscotInterfaceNormalUserAccessRightReviewToExcel(_response);
        });
    }

    protected processGetCNIABCscotPartscotInterfaceNormalUserAccessRightReviewToExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * UserAccessRightReview发送邮件
     * @return OK
     */
    cNIABCscotPartscotInterfaceNormalUserAccessRightReviewToEmail( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/CNIABCscotPartscotInterfaceNormalUserAccessRightReviewToEmail";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCNIABCscotPartscotInterfaceNormalUserAccessRightReviewToEmail(_response);
        });
    }

    protected processCNIABCscotPartscotInterfaceNormalUserAccessRightReviewToEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param url (optional) 
     * @param body (optional) 
     * @return OK
     */
    sendCNIABCscotPartscotInterfaceNormalUserAccessRightReviewEmail(url?: string | undefined, body?: Role[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/SendCNIABCscotPartscotInterfaceNormalUserAccessRightReviewEmail?";
        if (url === null)
            throw new globalThis.Error("The parameter 'url' cannot be null.");
        else if (url !== undefined)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendCNIABCscotPartscotInterfaceNormalUserAccessRightReviewEmail(_response);
        });
    }

    protected processSendCNIABCscotPartscotInterfaceNormalUserAccessRightReviewEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出用户信息
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param roleId (optional) 
     * @param state (optional) 0 = All (全部)

    1 = Available (在用)

    2 = Pause (未激活)

    3 = Deleted (禁用)
     * @param userRoleType (optional) 0 = All (全部)

    1 = User (普通用户)

    2 = SuperUser (超级用户)
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    excelUser(keyword?: string | undefined, isActive?: boolean | undefined, roleId?: number | undefined, state?: UserStateEnum | undefined, userRoleType?: UserRoleTypeEnum | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/ExcelUser?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new globalThis.Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (roleId === null)
            throw new globalThis.Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (state === null)
            throw new globalThis.Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (userRoleType === null)
            throw new globalThis.Error("The parameter 'userRoleType' cannot be null.");
        else if (userRoleType !== undefined)
            url_ += "UserRoleType=" + encodeURIComponent("" + userRoleType) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExcelUser(_response);
        });
    }

    protected processExcelUser(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 通过相关字段获取用户信息，获取不到则新增未启用用户【仅供网关使用】
    token org_type 有值时：org_id → SAPCode, org_name → CompanyName
     * @param email (optional) 
     * @param identiFierId (optional) 
     * @param accountName (optional) 
     * @param adAccount (optional) 
     * @param englishName (optional) 
     * @param chineseName (optional) 
     * @param orgId (optional) token claim org_id
     * @param orgName (optional) token claim org_name
     * @param orgType (optional) token claim org_type，有值时才同步 org_id/org_name 到用户表
     * @return OK
     */
    getUserInfo(email?: string | undefined, identiFierId?: string | undefined, accountName?: string | undefined, adAccount?: string | undefined, englishName?: string | undefined, chineseName?: string | undefined, orgId?: string | undefined, orgName?: string | undefined, orgType?: string | undefined, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/GetUserInfo?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (identiFierId === null)
            throw new globalThis.Error("The parameter 'identiFierId' cannot be null.");
        else if (identiFierId !== undefined)
            url_ += "identiFierId=" + encodeURIComponent("" + identiFierId) + "&";
        if (accountName === null)
            throw new globalThis.Error("The parameter 'accountName' cannot be null.");
        else if (accountName !== undefined)
            url_ += "accountName=" + encodeURIComponent("" + accountName) + "&";
        if (adAccount === null)
            throw new globalThis.Error("The parameter 'adAccount' cannot be null.");
        else if (adAccount !== undefined)
            url_ += "adAccount=" + encodeURIComponent("" + adAccount) + "&";
        if (englishName === null)
            throw new globalThis.Error("The parameter 'englishName' cannot be null.");
        else if (englishName !== undefined)
            url_ += "englishName=" + encodeURIComponent("" + englishName) + "&";
        if (chineseName === null)
            throw new globalThis.Error("The parameter 'chineseName' cannot be null.");
        else if (chineseName !== undefined)
            url_ += "chineseName=" + encodeURIComponent("" + chineseName) + "&";
        if (orgId === null)
            throw new globalThis.Error("The parameter 'orgId' cannot be null.");
        else if (orgId !== undefined)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        if (orgName === null)
            throw new globalThis.Error("The parameter 'orgName' cannot be null.");
        else if (orgName !== undefined)
            url_ += "orgName=" + encodeURIComponent("" + orgName) + "&";
        if (orgType === null)
            throw new globalThis.Error("The parameter 'orgType' cannot be null.");
        else if (orgType !== undefined)
            url_ += "orgType=" + encodeURIComponent("" + orgType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserInfo(_response);
        });
    }

    protected processGetUserInfo(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * 清除 UserCache / UserRoleCache（UA 使用进程内缓存，非 Redis；仅供网关/运维调用）
     * @param identiFierId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    clearUserCache(identiFierId?: string | undefined, userId?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/ClearUserCache?";
        if (identiFierId === null)
            throw new globalThis.Error("The parameter 'identiFierId' cannot be null.");
        else if (identiFierId !== undefined)
            url_ += "identiFierId=" + encodeURIComponent("" + identiFierId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearUserCache(_response);
        });
    }

    protected processClearUserCache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据邮箱/账号查询匹配待绑定用户列表
     * @return OK
     */
    getBindingUserInfos( cancelToken?: CancelToken): Promise<BindingUserInfoDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/GetBindingUserInfos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBindingUserInfos(_response);
        });
    }

    protected processGetBindingUserInfos(response: AxiosResponse): Promise<BindingUserInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BindingUserInfoDto.fromJS(resultData200);
            return Promise.resolve<BindingUserInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BindingUserInfoDto>(null as any);
    }

    /**
     * 账号绑定
     * @param body (optional) 
     * @return OK
     */
    bindingAuthenticate(body?: BindingAuthenticateDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/BindingAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBindingAuthenticate(_response);
        });
    }

    protected processBindingAuthenticate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据权限名称获取所有角色 sc交期发邮件使用
     * @param body (optional) 
     * @return OK
     */
    getRolesByPermission(body?: string[] | undefined, cancelToken?: CancelToken): Promise<{ [key: string]: string[]; }> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/GetRolesByPermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRolesByPermission(_response);
        });
    }

    protected processGetRolesByPermission(response: AxiosResponse): Promise<{ [key: string]: string[]; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : [];
                }
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<{ [key: string]: string[]; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string[]; }>(null as any);
    }

    /**
     * 通过权限项获取用户列表
     * @param permissions (optional) 
     * @return OK
     */
    getUserByPermission(permissions?: string[] | undefined, cancelToken?: CancelToken): Promise<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/GetUserByPermission?";
        if (permissions === null)
            throw new globalThis.Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "permissions=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserByPermission(_response);
        });
    }

    protected processGetUserByPermission(response: AxiosResponse): Promise<UserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto[]>(null as any);
    }

    /**
     * 获取维护信息
     * @return OK
     */
    getMaintainInfo( cancelToken?: CancelToken): Promise<MaintainInfoDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/GetMaintainInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMaintainInfo(_response);
        });
    }

    protected processGetMaintainInfo(response: AxiosResponse): Promise<MaintainInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MaintainInfoDto.fromJS(resultData200);
            return Promise.resolve<MaintainInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaintainInfoDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id?: number | undefined, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/services/DigitalLogisticSystem/User/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }
}

export class CountrySalesRelationServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取CountryKey列表
     * @return OK
     */
    getCountryKeyAll( cancelToken?: CancelToken): Promise<CountryKeyDto[]> {
        let url_ = this.baseUrl + "/api/services/IWorld/CountrySalesRelation/GetCountryKeyAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCountryKeyAll(_response);
        });
    }

    protected processGetCountryKeyAll(response: AxiosResponse): Promise<CountryKeyDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryKeyDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CountryKeyDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountryKeyDto[]>(null as any);
    }

    /**
     * 查询国家销售支持
     * @param body (optional) 
     * @return OK
     */
    getAll(body?: PageCountrySalesRelationInputDto | undefined, cancelToken?: CancelToken): Promise<CountrySalesRelationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/IWorld/CountrySalesRelation/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<CountrySalesRelationDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CountrySalesRelationDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<CountrySalesRelationDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountrySalesRelationDtoPagedResultDto>(null as any);
    }

    /**
     * 根据Id查询数据
     * @param id (optional) 
     * @return OK
     */
    getById(id?: string | undefined, cancelToken?: CancelToken): Promise<CountrySalesRelationDto[]> {
        let url_ = this.baseUrl + "/api/services/IWorld/CountrySalesRelation/GetById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<CountrySalesRelationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountrySalesRelationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CountrySalesRelationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountrySalesRelationDto[]>(null as any);
    }

    /**
     * 删除
     * @param body (optional) 
     * @return OK
     */
    delete(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/IWorld/CountrySalesRelation/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新增/编辑
     * @param body (optional) 
     * @return OK
     */
    addOrUpdate(body?: CountrySalesRelationDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/IWorld/CountrySalesRelation/AddOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrUpdate(_response);
        });
    }

    protected processAddOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入
     * @param excelFile (optional) 
     * @return OK
     */
    uploadData(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/IWorld/CountrySalesRelation/UploadData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadData(_response);
        });
    }

    protected processUploadData(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导出国家销售支持
     * @param body (optional) 
     * @return OK
     */
    exportExcel(body?: PageCountrySalesRelationInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/IWorld/CountrySalesRelation/ExportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportExcel(_response);
        });
    }

    protected processExportExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导出国家销售支持
     * @param body (optional) 
     * @return OK
     */
    exportImportTemplate(body?: PageCountrySalesRelationInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/IWorld/CountrySalesRelation/ExportImportTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportImportTemplate(_response);
        });
    }

    protected processExportImportTemplate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class EmailSendLogServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 查询邮件发送日志
     * @param body (optional) 
     * @return OK
     */
    getAll(body?: PageEmailSendLogInputDto | undefined, cancelToken?: CancelToken): Promise<EmailSendLogDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/IWorld/EmailSendLog/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<EmailSendLogDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailSendLogDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<EmailSendLogDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailSendLogDtoPagedResultDto>(null as any);
    }

    /**
     * 重新发送
     * @param body (optional) 
     * @return OK
     */
    reSendEmail(body?: EmailSendLogDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/IWorld/EmailSendLog/ReSendEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReSendEmail(_response);
        });
    }

    protected processReSendEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OperationLogServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @return OK
     */
    getInitData( cancelToken?: CancelToken): Promise<{ [key: string]: any; }> {
        let url_ = this.baseUrl + "/api/services/IWorld/OperationLog/getInitData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInitData(_response);
        });
    }

    protected processGetInitData(response: AxiosResponse): Promise<{ [key: string]: any; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<{ [key: string]: any; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: any; }>(null as any);
    }

    /**
     * 查询邮件发送日志
     * @param body (optional) 
     * @return OK
     */
    getAll(body?: PageOperationLogInputDto | undefined, cancelToken?: CancelToken): Promise<OperationLogDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/IWorld/OperationLog/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<OperationLogDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OperationLogDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<OperationLogDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationLogDtoPagedResultDto>(null as any);
    }

    /**
     * 导出操作信息
     * @param body (optional) 
     * @return OK
     */
    exportExcel(body?: PageOperationLogInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/IWorld/OperationLog/ExportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportExcel(_response);
        });
    }

    protected processExportExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class OrderDetailServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 查询订单信息
     * @param body (optional) 
     * @return OK
     */
    getOrderDetail(body?: PageOrderDetailInputDto | undefined, cancelToken?: CancelToken): Promise<OrderDetailDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/IWorld/OrderDetail/GetOrderDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderDetail(_response);
        });
    }

    protected processGetOrderDetail(response: AxiosResponse): Promise<OrderDetailDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderDetailDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<OrderDetailDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDetailDtoPagedResultDto>(null as any);
    }

    /**
     * 导出订单信息
     * @param body (optional) 
     * @return OK
     */
    exportOrderDetailExcel(body?: PageOrderDetailInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/IWorld/OrderDetail/ExportOrderDetailExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportOrderDetailExcel(_response);
        });
    }

    protected processExportOrderDetailExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 根据Id查询数据
     * @param ids (optional) 
     * @param modificationType (optional) 
     * @return OK
     */
    getById(ids?: string[] | undefined, modificationType?: string | undefined, cancelToken?: CancelToken): Promise<OrderDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/IWorld/OrderDetail/GetById?";
        if (ids === null)
            throw new globalThis.Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (modificationType === null)
            throw new globalThis.Error("The parameter 'modificationType' cannot be null.");
        else if (modificationType !== undefined)
            url_ += "ModificationType=" + encodeURIComponent("" + modificationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<OrderDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderDetailDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderDetailDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDetailDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    manualSyncOrderDetail(body?: OrderDetailSynchronizeInputDto | undefined, cancelToken?: CancelToken): Promise<CommonOutput> {
        let url_ = this.baseUrl + "/api/services/IWorld/OrderDetail/ManualSyncOrderDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManualSyncOrderDetail(_response);
        });
    }

    protected processManualSyncOrderDetail(response: AxiosResponse): Promise<CommonOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommonOutput.fromJS(resultData200);
            return Promise.resolve<CommonOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommonOutput>(null as any);
    }

    /**
     * @param flag (optional) 
     * @param body (optional) 
     * @return OK
     */
    syncOrderDetail(flag?: string | undefined, body?: OrderDetailSynchronizeInputDto | undefined, cancelToken?: CancelToken): Promise<CommonOutput> {
        let url_ = this.baseUrl + "/api/services/IWorld/OrderDetail/SyncOrderDetail?";
        if (flag === null)
            throw new globalThis.Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncOrderDetail(_response);
        });
    }

    protected processSyncOrderDetail(response: AxiosResponse): Promise<CommonOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommonOutput.fromJS(resultData200);
            return Promise.resolve<CommonOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommonOutput>(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @param emailTitle (optional) 
     * @param message (optional) 
     * @return OK
     */
    sendSyncOrderDetailEmail(emailAddress?: string | undefined, emailTitle?: string | undefined, message?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/IWorld/OrderDetail/SendSyncOrderDetailEmail?";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (emailTitle === null)
            throw new globalThis.Error("The parameter 'emailTitle' cannot be null.");
        else if (emailTitle !== undefined)
            url_ += "EmailTitle=" + encodeURIComponent("" + emailTitle) + "&";
        if (message === null)
            throw new globalThis.Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendSyncOrderDetailEmail(_response);
        });
    }

    protected processSendSyncOrderDetailEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    operationHistoryFlag( cancelToken?: CancelToken): Promise<CommonOutput> {
        let url_ = this.baseUrl + "/api/services/IWorld/OrderDetail/OperationHistoryFlag";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperationHistoryFlag(_response);
        });
    }

    protected processOperationHistoryFlag(response: AxiosResponse): Promise<CommonOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommonOutput.fromJS(resultData200);
            return Promise.resolve<CommonOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommonOutput>(null as any);
    }

    /**
     * 根据Id查询Shipment数据
     * @param id (optional) 
     * @return OK
     */
    getShipmentById(id?: string | undefined, cancelToken?: CancelToken): Promise<OrderDetailShipmentDto[]> {
        let url_ = this.baseUrl + "/api/services/IWorld/OrderDetail/GetShipmentById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShipmentById(_response);
        });
    }

    protected processGetShipmentById(response: AxiosResponse): Promise<OrderDetailShipmentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderDetailShipmentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderDetailShipmentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDetailShipmentDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    syncCMSShipment(body?: OrderDetailShipmentInputDto[] | undefined, cancelToken?: CancelToken): Promise<CommonOutput> {
        let url_ = this.baseUrl + "/api/services/IWorld/OrderDetail/SyncCMSShipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncCMSShipment(_response);
        });
    }

    protected processSyncCMSShipment(response: AxiosResponse): Promise<CommonOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommonOutput.fromJS(resultData200);
            return Promise.resolve<CommonOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommonOutput>(null as any);
    }

    /**
     * 修改订单信息
     * @param body (optional) 
     * @return OK
     */
    updateOrderDetail(body?: OrderDetailDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/IWorld/OrderDetail/UpdateOrderDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrderDetail(_response);
        });
    }

    protected processUpdateOrderDetail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param emailTitle (optional) 
     * @param message (optional) 
     * @return OK
     */
    sendReminderEmail(emailTitle?: string | undefined, message?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/IWorld/OrderDetail/SendReminderEmail?";
        if (emailTitle === null)
            throw new globalThis.Error("The parameter 'emailTitle' cannot be null.");
        else if (emailTitle !== undefined)
            url_ += "EmailTitle=" + encodeURIComponent("" + emailTitle) + "&";
        if (message === null)
            throw new globalThis.Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendReminderEmail(_response);
        });
    }

    protected processSendReminderEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 查询订单审批信息
     * @param body (optional) 
     * @return OK
     */
    getOrderDetailAudit(body?: PageOrderDetailAuditInputDto | undefined, cancelToken?: CancelToken): Promise<OrderDetailAuditDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/IWorld/OrderDetail/GetOrderDetailAudit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderDetailAudit(_response);
        });
    }

    protected processGetOrderDetailAudit(response: AxiosResponse): Promise<OrderDetailAuditDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderDetailAuditDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<OrderDetailAuditDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDetailAuditDtoPagedResultDto>(null as any);
    }

    /**
     * 根据Id列表获取审批数据
     * @param ids (optional) 
     * @return OK
     */
    getOrderDetailAuditByIds(ids?: string[] | undefined, cancelToken?: CancelToken): Promise<OrderDetailAuditDto[]> {
        let url_ = this.baseUrl + "/api/services/IWorld/OrderDetail/GetOrderDetailAuditByIds?";
        if (ids === null)
            throw new globalThis.Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderDetailAuditByIds(_response);
        });
    }

    protected processGetOrderDetailAuditByIds(response: AxiosResponse): Promise<OrderDetailAuditDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderDetailAuditDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderDetailAuditDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDetailAuditDto[]>(null as any);
    }

    /**
     * 根据订单号和MergeId 获取同一次提交的相同订单的审批信息
     * @param body (optional) 
     * @return OK
     */
    getOrderDetailAuditByOrderNumberAndMergeId(body?: PageOrderDetailAuditInputDto | undefined, cancelToken?: CancelToken): Promise<OrderDetailAuditDto[]> {
        let url_ = this.baseUrl + "/api/services/IWorld/OrderDetail/GetOrderDetailAuditByOrderNumberAndMergeId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderDetailAuditByOrderNumberAndMergeId(_response);
        });
    }

    protected processGetOrderDetailAuditByOrderNumberAndMergeId(response: AxiosResponse): Promise<OrderDetailAuditDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderDetailAuditDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderDetailAuditDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDetailAuditDto[]>(null as any);
    }

    /**
     * 导出订单审批信息
     * @param body (optional) 
     * @return OK
     */
    exportOrderDetailAuditExcel(body?: PageOrderDetailAuditInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/IWorld/OrderDetail/ExportOrderDetailAuditExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportOrderDetailAuditExcel(_response);
        });
    }

    protected processExportOrderDetailAuditExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 修改订单审核信息
     * @param body (optional) 
     * @return OK
     */
    updateOrderDetailAudit(body?: OrderDetailAuditDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/IWorld/OrderDetail/UpdateOrderDetailAudit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrderDetailAudit(_response);
        });
    }

    protected processUpdateOrderDetailAudit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    approvalScheduledJob( cancelToken?: CancelToken): Promise<CommonOutput> {
        let url_ = this.baseUrl + "/api/services/IWorld/OrderDetail/ApprovalScheduledJob";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApprovalScheduledJob(_response);
        });
    }

    protected processApprovalScheduledJob(response: AxiosResponse): Promise<CommonOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommonOutput.fromJS(resultData200);
            return Promise.resolve<CommonOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommonOutput>(null as any);
    }

    /**
     * @return OK
     */
    testServerBusPublish( cancelToken?: CancelToken): Promise<CommonOutput> {
        let url_ = this.baseUrl + "/api/services/IWorld/OrderDetail/TestServerBusPublish";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestServerBusPublish(_response);
        });
    }

    protected processTestServerBusPublish(response: AxiosResponse): Promise<CommonOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommonOutput.fromJS(resultData200);
            return Promise.resolve<CommonOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommonOutput>(null as any);
    }

    /**
     * 查询订单修改信息
     * @param body (optional) 
     * @return OK
     */
    getOrderDetailModificationLog(body?: PageOrderDetailModificationLogInputDto | undefined, cancelToken?: CancelToken): Promise<OrderDetailModificationLogDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/IWorld/OrderDetail/GetOrderDetailModificationLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderDetailModificationLog(_response);
        });
    }

    protected processGetOrderDetailModificationLog(response: AxiosResponse): Promise<OrderDetailModificationLogDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderDetailModificationLogDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<OrderDetailModificationLogDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDetailModificationLogDtoPagedResultDto>(null as any);
    }

    /**
     * 导出订单修改信息
     * @param body (optional) 
     * @return OK
     */
    exportOrderDetailModificationLogExcel(body?: PageOrderDetailModificationLogInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/IWorld/OrderDetail/ExportOrderDetailModificationLogExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportOrderDetailModificationLogExcel(_response);
        });
    }

    protected processExportOrderDetailModificationLogExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class UserCustomerRelationshipServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAll(body?: PageUserCustomerRelationshipInputDto | undefined, cancelToken?: CancelToken): Promise<UserCustomerRelationshipListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/IWorld/UserCustomerRelationship/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<UserCustomerRelationshipListDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserCustomerRelationshipListDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<UserCustomerRelationshipListDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserCustomerRelationshipListDtoPagedResultDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getByUserId(userId?: number | undefined, cancelToken?: CancelToken): Promise<UserCustomerRelationshipDto> {
        let url_ = this.baseUrl + "/api/services/IWorld/UserCustomerRelationship/GetByUserId?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByUserId(_response);
        });
    }

    protected processGetByUserId(response: AxiosResponse): Promise<UserCustomerRelationshipDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserCustomerRelationshipDto.fromJS(resultData200);
            return Promise.resolve<UserCustomerRelationshipDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserCustomerRelationshipDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addOrUpdate(body?: UserCustomerRelationshipDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/IWorld/UserCustomerRelationship/AddOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrUpdate(_response);
        });
    }

    protected processAddOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    delete(body?: number[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/IWorld/UserCustomerRelationship/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param excelFile (optional) 
     * @return OK
     */
    importExcel(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/IWorld/UserCustomerRelationship/ImportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportExcel(_response);
        });
    }

    protected processImportExcel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    exportImportTemplate(body?: PageUserCustomerRelationshipInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/IWorld/UserCustomerRelationship/ExportImportTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportImportTemplate(_response);
        });
    }

    protected processExportImportTemplate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    exportExcel(body?: PageUserCustomerRelationshipInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/IWorld/UserCustomerRelationship/ExportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportExcel(_response);
        });
    }

    protected processExportExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class VarConfigServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 查询环境变量
     * @param body (optional) 
     * @return OK
     */
    getAll(body?: PageVarConfigSearchInputDto | undefined, cancelToken?: CancelToken): Promise<VarConfigDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/IWorld/VarConfig/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<VarConfigDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VarConfigDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<VarConfigDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VarConfigDtoPagedResultDto>(null as any);
    }

    /**
     * 根据环境变量名称查询
     * @param configName (optional) 
     * @return OK
     */
    getByConfigName(configName?: string | undefined, cancelToken?: CancelToken): Promise<VarConfigDto[]> {
        let url_ = this.baseUrl + "/api/services/IWorld/VarConfig/GetByConfigName?";
        if (configName === null)
            throw new globalThis.Error("The parameter 'configName' cannot be null.");
        else if (configName !== undefined)
            url_ += "ConfigName=" + encodeURIComponent("" + configName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByConfigName(_response);
        });
    }

    protected processGetByConfigName(response: AxiosResponse): Promise<VarConfigDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VarConfigDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<VarConfigDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VarConfigDto[]>(null as any);
    }

    /**
     * 删除
     * @param body (optional) 
     * @return OK
     */
    delete(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/IWorld/VarConfig/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新增/编辑
     * @param body (optional) 
     * @return OK
     */
    addOrUpdate(body?: VarConfigDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/IWorld/VarConfig/AddOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrUpdate(_response);
        });
    }

    protected processAddOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CustomerCodeServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body?: CustomerCodeDto | undefined, cancelToken?: CancelToken): Promise<CustomerCodeDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/CustomerCode/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CustomerCodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerCodeDto.fromJS(resultData200);
            return Promise.resolve<CustomerCodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerCodeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body?: CustomerCodeDto | undefined, cancelToken?: CancelToken): Promise<CustomerCodeDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/CustomerCode/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<CustomerCodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerCodeDto.fromJS(resultData200);
            return Promise.resolve<CustomerCodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerCodeDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id?: string | undefined, cancelToken?: CancelToken): Promise<CustomerCodeDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/CustomerCode/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<CustomerCodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerCodeDto.fromJS(resultData200);
            return Promise.resolve<CustomerCodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerCodeDto>(null as any);
    }

    /**
     * @param platformId (optional) 平台ID
     * @param seriesName (optional) 系列
     * @param creatorId (optional) 
     * @param customerCode (optional) 
     * @param scenarioType (optional) 1 = Industry

    2 = Customer

    3 = ProductExtension

    4 = Project
     * @param listPriceType (optional) 0 = Default (标准面价)

    1 = Custom (自定义面价)

    2 = CustomerCode (客户化代码)

    3 = JIN (境界面价)
     * @param includeHidden (optional) 是否包含隐藏数据
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(platformId?: string | undefined, seriesName?: string | undefined, creatorId?: number | undefined, customerCode?: string | undefined, scenarioType?: ScenarioType | undefined, listPriceType?: ListPriceType | undefined, includeHidden?: boolean | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<CustomerCodeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/CustomerCode/GetAll?";
        if (platformId === null)
            throw new globalThis.Error("The parameter 'platformId' cannot be null.");
        else if (platformId !== undefined)
            url_ += "PlatformId=" + encodeURIComponent("" + platformId) + "&";
        if (seriesName === null)
            throw new globalThis.Error("The parameter 'seriesName' cannot be null.");
        else if (seriesName !== undefined)
            url_ += "SeriesName=" + encodeURIComponent("" + seriesName) + "&";
        if (creatorId === null)
            throw new globalThis.Error("The parameter 'creatorId' cannot be null.");
        else if (creatorId !== undefined)
            url_ += "CreatorId=" + encodeURIComponent("" + creatorId) + "&";
        if (customerCode === null)
            throw new globalThis.Error("The parameter 'customerCode' cannot be null.");
        else if (customerCode !== undefined)
            url_ += "CustomerCode=" + encodeURIComponent("" + customerCode) + "&";
        if (scenarioType === null)
            throw new globalThis.Error("The parameter 'scenarioType' cannot be null.");
        else if (scenarioType !== undefined)
            url_ += "ScenarioType=" + encodeURIComponent("" + scenarioType) + "&";
        if (listPriceType === null)
            throw new globalThis.Error("The parameter 'listPriceType' cannot be null.");
        else if (listPriceType !== undefined)
            url_ += "ListPriceType=" + encodeURIComponent("" + listPriceType) + "&";
        if (includeHidden === null)
            throw new globalThis.Error("The parameter 'includeHidden' cannot be null.");
        else if (includeHidden !== undefined)
            url_ += "IncludeHidden=" + encodeURIComponent("" + includeHidden) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<CustomerCodeDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerCodeDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<CustomerCodeDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerCodeDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/ListPrice/CustomerCode/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ListPriceApprovalServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 发起审批
     * @param body (optional) 
     * @return OK
     */
    submit(body?: SubmitListPriceApprovalDto | undefined, cancelToken?: CancelToken): Promise<ListPriceApprovalInstanceDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApproval/Submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<ListPriceApprovalInstanceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceApprovalInstanceDto.fromJS(resultData200);
            return Promise.resolve<ListPriceApprovalInstanceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceApprovalInstanceDto>(null as any);
    }

    /**
     * 批量提交审批
     * @param submitRemark (optional) 
     * @param operatorUserId (optional) 
     * @param body (optional) 
     * @return OK
     */
    batchSubmitApproval(submitRemark?: string | undefined, operatorUserId?: number | undefined, body?: string[] | undefined, cancelToken?: CancelToken): Promise<ListPriceApprovalInstance[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApproval/BatchSubmitApproval?";
        if (submitRemark === null)
            throw new globalThis.Error("The parameter 'submitRemark' cannot be null.");
        else if (submitRemark !== undefined)
            url_ += "submitRemark=" + encodeURIComponent("" + submitRemark) + "&";
        if (operatorUserId === null)
            throw new globalThis.Error("The parameter 'operatorUserId' cannot be null.");
        else if (operatorUserId !== undefined)
            url_ += "operatorUserId=" + encodeURIComponent("" + operatorUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchSubmitApproval(_response);
        });
    }

    protected processBatchSubmitApproval(response: AxiosResponse): Promise<ListPriceApprovalInstance[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListPriceApprovalInstance.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ListPriceApprovalInstance[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceApprovalInstance[]>(null as any);
    }

    /**
     * 撤回审批
     * @param listPriceSeriesId (optional) 面价表Id
     * @return OK
     */
    recall(listPriceSeriesId?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApproval/Recall?";
        if (listPriceSeriesId === null)
            throw new globalThis.Error("The parameter 'listPriceSeriesId' cannot be null.");
        else if (listPriceSeriesId !== undefined)
            url_ += "listPriceSeriesId=" + encodeURIComponent("" + listPriceSeriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecall(_response);
        });
    }

    protected processRecall(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 同意审批
     * @param body (optional) 
     * @return OK
     */
    approve(body?: ListPriceApprovalActionDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApproval/Approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApprove(_response);
        });
    }

    protected processApprove(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 批量同意审批
     * @param body (optional) 
     * @return OK
     */
    batchApprove(body?: BatchListPriceApprovalActionDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApproval/BatchApprove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchApprove(_response);
        });
    }

    protected processBatchApprove(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 拒绝审批
     * @param body (optional) 
     * @return OK
     */
    reject(body?: ListPriceApprovalActionDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApproval/Reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReject(_response);
        });
    }

    protected processReject(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 批量拒绝审批
     * @param body (optional) 
     * @return OK
     */
    batchReject(body?: BatchListPriceApprovalActionDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApproval/BatchReject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchReject(_response);
        });
    }

    protected processBatchReject(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 审批实例详情
     * @param id (optional) 
     * @return OK
     */
    getInstance(id?: string | undefined, cancelToken?: CancelToken): Promise<ListPriceApprovalInstanceDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApproval/GetInstance?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInstance(_response);
        });
    }

    protected processGetInstance(response: AxiosResponse): Promise<ListPriceApprovalInstanceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceApprovalInstanceDto.fromJS(resultData200);
            return Promise.resolve<ListPriceApprovalInstanceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceApprovalInstanceDto>(null as any);
    }

    /**
     * 查询审批流程是否已通过
     * @param body (optional) 审批实例ID
     * @return OK
     */
    checkApprovalStatus(body?: GuidEntityDto | undefined, cancelToken?: CancelToken): Promise<CheckApprovalStatusOutDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApproval/CheckApprovalStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckApprovalStatus(_response);
        });
    }

    protected processCheckApprovalStatus(response: AxiosResponse): Promise<CheckApprovalStatusOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckApprovalStatusOutDto.fromJS(resultData200);
            return Promise.resolve<CheckApprovalStatusOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckApprovalStatusOutDto>(null as any);
    }

    /**
     * 判断面价表是否处于审批中
     * @param listPriceSeriesId (optional) 面价表Id
     * @return OK
     */
    isUnderApproval(listPriceSeriesId?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApproval/IsUnderApproval?";
        if (listPriceSeriesId === null)
            throw new globalThis.Error("The parameter 'listPriceSeriesId' cannot be null.");
        else if (listPriceSeriesId !== undefined)
            url_ += "listPriceSeriesId=" + encodeURIComponent("" + listPriceSeriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsUnderApproval(_response);
        });
    }

    protected processIsUnderApproval(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 判断当前登录人是否有审批权限
     * @param body (optional) 
     * @return OK
     */
    hasApprovePermission(body?: CheckListPriceApprovalPermissionDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApproval/HasApprovePermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasApprovePermission(_response);
        });
    }

    protected processHasApprovePermission(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取全部审批编号
     * @return OK
     */
    getAllApprovalNos( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApproval/GetAllApprovalNos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllApprovalNos(_response);
        });
    }

    protected processGetAllApprovalNos(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 根据审批编号查询面价系列列表
     * @param body (optional) 审批编号
     * @return OK
     */
    getApprovalSeriesByNo(body?: GetApprovalSeriesByNoInputDto | undefined, cancelToken?: CancelToken): Promise<GetApprovalSeriesByNoResultDto[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApproval/GetApprovalSeriesByNo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApprovalSeriesByNo(_response);
        });
    }

    protected processGetApprovalSeriesByNo(response: AxiosResponse): Promise<GetApprovalSeriesByNoResultDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetApprovalSeriesByNoResultDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetApprovalSeriesByNoResultDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetApprovalSeriesByNoResultDto[]>(null as any);
    }

    /**
     * 查询审批列表
     * @param body (optional) 
     * @return OK
     */
    getApprovalList(body?: PagedListPriceApprovalListInputDto | undefined, cancelToken?: CancelToken): Promise<ListPriceApprovalListItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApproval/GetApprovalList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApprovalList(_response);
        });
    }

    protected processGetApprovalList(response: AxiosResponse): Promise<ListPriceApprovalListItemDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceApprovalListItemDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ListPriceApprovalListItemDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceApprovalListItemDtoPagedResultDto>(null as any);
    }

    /**
     * 导出审批列表到Excel
     * @param body (optional) 查询条件
     * @return OK
     */
    exportApprovalListExcel(body?: PagedListPriceApprovalListInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApproval/ExportApprovalListExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportApprovalListExcel(_response);
        });
    }

    protected processExportApprovalListExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 查询审批历史记录
     * @param body (optional) 
     * @return OK
     */
    getApprovalHistoryList(body?: PagedListPriceApprovalListInputDto | undefined, cancelToken?: CancelToken): Promise<ListPriceApprovalHistoryListItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApproval/GetApprovalHistoryList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApprovalHistoryList(_response);
        });
    }

    protected processGetApprovalHistoryList(response: AxiosResponse): Promise<ListPriceApprovalHistoryListItemDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceApprovalHistoryListItemDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ListPriceApprovalHistoryListItemDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceApprovalHistoryListItemDtoPagedResultDto>(null as any);
    }

    /**
     * 导出审批历史记录到Excel
     * @param body (optional) 查询条件
     * @return OK
     */
    exportApprovalHistoryListExcel(body?: PagedListPriceApprovalListInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApproval/ExportApprovalHistoryListExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportApprovalHistoryListExcel(_response);
        });
    }

    protected processExportApprovalHistoryListExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 审批节点列表
     * @param body (optional) 
     * @return OK
     */
    getApprovalRecordList(body?: GuidEntityDto | undefined, cancelToken?: CancelToken): Promise<ListPriceApprovalNodeRecordDto[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApproval/GetApprovalRecordList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApprovalRecordList(_response);
        });
    }

    protected processGetApprovalRecordList(response: AxiosResponse): Promise<ListPriceApprovalNodeRecordDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListPriceApprovalNodeRecordDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ListPriceApprovalNodeRecordDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceApprovalNodeRecordDto[]>(null as any);
    }
}

export class ListPriceApprovalFlowServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 新增审批流程
     * @param body (optional) 
     * @return OK
     */
    create(body?: ListPriceApprovalFlowDto | undefined, cancelToken?: CancelToken): Promise<ListPriceApprovalFlowDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApprovalFlow/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ListPriceApprovalFlowDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceApprovalFlowDto.fromJS(resultData200);
            return Promise.resolve<ListPriceApprovalFlowDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceApprovalFlowDto>(null as any);
    }

    /**
     * 修改审批流程
     * @param body (optional) 
     * @return OK
     */
    update(body?: ListPriceApprovalFlowDto | undefined, cancelToken?: CancelToken): Promise<ListPriceApprovalFlowDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApprovalFlow/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ListPriceApprovalFlowDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceApprovalFlowDto.fromJS(resultData200);
            return Promise.resolve<ListPriceApprovalFlowDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceApprovalFlowDto>(null as any);
    }

    /**
     * 审批流程详情
     * @param id (optional) 
     * @return OK
     */
    get(id?: string | undefined, cancelToken?: CancelToken): Promise<ListPriceApprovalFlowDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApprovalFlow/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ListPriceApprovalFlowDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceApprovalFlowDto.fromJS(resultData200);
            return Promise.resolve<ListPriceApprovalFlowDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceApprovalFlowDto>(null as any);
    }

    /**
     * 审批流程列表
     * @param body (optional) 
     * @return OK
     */
    getAll(body?: ListPriceApprovalFlowQueryDto | undefined, cancelToken?: CancelToken): Promise<ListPriceApprovalFlowDto[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApprovalFlow/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ListPriceApprovalFlowDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListPriceApprovalFlowDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ListPriceApprovalFlowDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceApprovalFlowDto[]>(null as any);
    }

    /**
     * 删除审批流程
     * @param body (optional) 
     * @return OK
     */
    delete(body?: GuidEntityDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApprovalFlow/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 启用/禁用审批流程
     * @param body (optional) 
     * @return OK
     */
    setEnabled(body?: SetListPriceApprovalFlowEnabledDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceApprovalFlow/SetEnabled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetEnabled(_response);
        });
    }

    protected processSetEnabled(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class ListPriceCommonPriceServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 新增公共价格表维护
     * @param body (optional) 
     * @return OK
     */
    create(body?: ListPriceCommonPriceDto | undefined, cancelToken?: CancelToken): Promise<ListPriceCommonPriceDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceCommonPrice/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ListPriceCommonPriceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceCommonPriceDto.fromJS(resultData200);
            return Promise.resolve<ListPriceCommonPriceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceCommonPriceDto>(null as any);
    }

    /**
     * 新增关联价格表
     * @param body (optional) 
     * @return OK
     */
    addCommonPriceSeries(body?: AddCommonPriceSeriesDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceCommonPrice/AddCommonPriceSeries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddCommonPriceSeries(_response);
        });
    }

    protected processAddCommonPriceSeries(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 删除公共价格表维护
     * @param id (optional) 
     * @return OK
     */
    delete(id?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceCommonPrice/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除关联价格表（批量删除）
     * @param body (optional) 
     * @return OK
     */
    deleteRelatedSeries(body?: DeleteCommonPriceSeriesDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceCommonPrice/DeleteRelatedSeries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRelatedSeries(_response);
        });
    }

    protected processDeleteRelatedSeries(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 查询列表
     * @param sheetName (optional) sheet名称
     * @param seriesName (optional) 系列名称
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(sheetName?: string | undefined, seriesName?: string | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<ListPriceCommonPriceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceCommonPrice/GetAll?";
        if (sheetName === null)
            throw new globalThis.Error("The parameter 'sheetName' cannot be null.");
        else if (sheetName !== undefined)
            url_ += "SheetName=" + encodeURIComponent("" + sheetName) + "&";
        if (seriesName === null)
            throw new globalThis.Error("The parameter 'seriesName' cannot be null.");
        else if (seriesName !== undefined)
            url_ += "SeriesName=" + encodeURIComponent("" + seriesName) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ListPriceCommonPriceDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceCommonPriceDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ListPriceCommonPriceDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceCommonPriceDtoPagedResultDto>(null as any);
    }

    /**
     * 获取所有系列名称用于下拉选择（仅返回与公共价格表有关联关系的系列名称，去重）
     * @return OK
     */
    getAllSeriesForDropdown( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceCommonPrice/GetAllSeriesForDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSeriesForDropdown(_response);
        });
    }

    protected processGetAllSeriesForDropdown(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 导出公共价格表列表到Excel
     * @param body (optional) 查询条件（SheetName、SeriesName）
     * @return OK
     */
    exportExcel(body?: PagedListPriceCommonPriceDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceCommonPrice/ExportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportExcel(_response);
        });
    }

    protected processExportExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 查询详情
     * @param id (optional) 
     * @return OK
     */
    get(id?: string | undefined, cancelToken?: CancelToken): Promise<ListPriceCommonPriceDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceCommonPrice/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ListPriceCommonPriceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceCommonPriceDto.fromJS(resultData200);
            return Promise.resolve<ListPriceCommonPriceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceCommonPriceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body?: ListPriceCommonPriceDto | undefined, cancelToken?: CancelToken): Promise<ListPriceCommonPriceDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceCommonPrice/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ListPriceCommonPriceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceCommonPriceDto.fromJS(resultData200);
            return Promise.resolve<ListPriceCommonPriceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceCommonPriceDto>(null as any);
    }
}

export class ListPriceJINSeriesServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body?: JINSeriesDto | undefined, cancelToken?: CancelToken): Promise<JINSeriesDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<JINSeriesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JINSeriesDto.fromJS(resultData200);
            return Promise.resolve<JINSeriesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JINSeriesDto>(null as any);
    }

    /**
     * 对外创建项目型境界面价表
     * @param body (optional) 
     * @return OK
     */
    createExternalProject(body?: CreateExternalProjectJINSeriesDto | undefined, cancelToken?: CancelToken): Promise<CreateExternalProjectJINSeriesResultDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/CreateExternalProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateExternalProject(_response);
        });
    }

    protected processCreateExternalProject(response: AxiosResponse): Promise<CreateExternalProjectJINSeriesResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateExternalProjectJINSeriesResultDto.fromJS(resultData200);
            return Promise.resolve<CreateExternalProjectJINSeriesResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateExternalProjectJINSeriesResultDto>(null as any);
    }

    /**
     * 补充面价数据（面价选型完成后填充面价表数据）
     * @param body (optional) 
     * @return OK
     */
    updateMotorPriceData(body?: SupplementMotorPriceDataDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/UpdateMotorPriceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMotorPriceData(_response);
        });
    }

    protected processUpdateMotorPriceData(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body?: JINSeriesDto | undefined, cancelToken?: CancelToken): Promise<JINSeriesDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<JINSeriesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JINSeriesDto.fromJS(resultData200);
            return Promise.resolve<JINSeriesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JINSeriesDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param platformId (optional) 平台ID
     * @param seriesName (optional) 系列
     * @param creatorId (optional) 
     * @param customerCode (optional) 
     * @param scenarioType (optional) 1 = Industry

    2 = Customer

    3 = ProductExtension

    4 = Project
     * @param listPriceType (optional) 0 = Default (标准面价)

    1 = Custom (自定义面价)

    2 = CustomerCode (客户化代码)

    3 = JIN (境界面价)
     * @param includeHidden (optional) 是否包含隐藏数据
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(platformId?: string | undefined, seriesName?: string | undefined, creatorId?: number | undefined, customerCode?: string | undefined, scenarioType?: ScenarioType | undefined, listPriceType?: ListPriceType | undefined, includeHidden?: boolean | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<JINSeriesDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/GetAll?";
        if (platformId === null)
            throw new globalThis.Error("The parameter 'platformId' cannot be null.");
        else if (platformId !== undefined)
            url_ += "PlatformId=" + encodeURIComponent("" + platformId) + "&";
        if (seriesName === null)
            throw new globalThis.Error("The parameter 'seriesName' cannot be null.");
        else if (seriesName !== undefined)
            url_ += "SeriesName=" + encodeURIComponent("" + seriesName) + "&";
        if (creatorId === null)
            throw new globalThis.Error("The parameter 'creatorId' cannot be null.");
        else if (creatorId !== undefined)
            url_ += "CreatorId=" + encodeURIComponent("" + creatorId) + "&";
        if (customerCode === null)
            throw new globalThis.Error("The parameter 'customerCode' cannot be null.");
        else if (customerCode !== undefined)
            url_ += "CustomerCode=" + encodeURIComponent("" + customerCode) + "&";
        if (scenarioType === null)
            throw new globalThis.Error("The parameter 'scenarioType' cannot be null.");
        else if (scenarioType !== undefined)
            url_ += "ScenarioType=" + encodeURIComponent("" + scenarioType) + "&";
        if (listPriceType === null)
            throw new globalThis.Error("The parameter 'listPriceType' cannot be null.");
        else if (listPriceType !== undefined)
            url_ += "ListPriceType=" + encodeURIComponent("" + listPriceType) + "&";
        if (includeHidden === null)
            throw new globalThis.Error("The parameter 'includeHidden' cannot be null.");
        else if (includeHidden !== undefined)
            url_ += "IncludeHidden=" + encodeURIComponent("" + includeHidden) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<JINSeriesDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JINSeriesDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<JINSeriesDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JINSeriesDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id?: string | undefined, cancelToken?: CancelToken): Promise<JINSeriesDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<JINSeriesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JINSeriesDto.fromJS(resultData200);
            return Promise.resolve<JINSeriesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JINSeriesDto>(null as any);
    }

    /**
     * 保存证书管理员邮箱
     * @param body (optional) 
     * @return OK
     */
    saveCertAdminEmail(body?: SaveCertAdminEmailInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/SaveCertAdminEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveCertAdminEmail(_response);
        });
    }

    protected processSaveCertAdminEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取JIN系列
     * @param seriesId (optional) 
     * @return OK
     */
    getVersions(seriesId?: string | undefined, cancelToken?: CancelToken): Promise<JINSeriesDto[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/GetVersions?";
        if (seriesId === null)
            throw new globalThis.Error("The parameter 'seriesId' cannot be null.");
        else if (seriesId !== undefined)
            url_ += "seriesId=" + encodeURIComponent("" + seriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVersions(_response);
        });
    }

    protected processGetVersions(response: AxiosResponse): Promise<JINSeriesDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JINSeriesDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JINSeriesDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JINSeriesDto[]>(null as any);
    }

    /**
     * 根据ID和条件更新境界代码
     * @param body (optional) 
     * @return OK
     */
    updateJINCode(body?: JINSeriesDto | undefined, cancelToken?: CancelToken): Promise<ListPriceBasicMotorPriceDto[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/UpdateJINCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateJINCode(_response);
        });
    }

    protected processUpdateJINCode(response: AxiosResponse): Promise<ListPriceBasicMotorPriceDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListPriceBasicMotorPriceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ListPriceBasicMotorPriceDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceBasicMotorPriceDto[]>(null as any);
    }

    /**
     * 根据ID和条件更新境界产品型号
     * @param body (optional) 
     * @return OK
     */
    updateJINModel(body?: JINSeriesDto | undefined, cancelToken?: CancelToken): Promise<ListPriceBasicMotorPriceDto[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/UpdateJINModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateJINModel(_response);
        });
    }

    protected processUpdateJINModel(response: AxiosResponse): Promise<ListPriceBasicMotorPriceDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListPriceBasicMotorPriceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ListPriceBasicMotorPriceDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceBasicMotorPriceDto[]>(null as any);
    }

    /**
     * 批量更新境界代码 - 不更新数据
     * @param listPriceJINSeriesId (optional) 境界面价表ID
     * @param body (optional) 
     * @return OK
     */
    generateJINCode(listPriceJINSeriesId?: string | undefined, body?: ListPriceBasicMotorPriceDto[] | undefined, cancelToken?: CancelToken): Promise<ListPriceBasicMotorPriceDto[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/GenerateJINCode?";
        if (listPriceJINSeriesId === null)
            throw new globalThis.Error("The parameter 'listPriceJINSeriesId' cannot be null.");
        else if (listPriceJINSeriesId !== undefined)
            url_ += "listPriceJINSeriesId=" + encodeURIComponent("" + listPriceJINSeriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateJINCode(_response);
        });
    }

    protected processGenerateJINCode(response: AxiosResponse): Promise<ListPriceBasicMotorPriceDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListPriceBasicMotorPriceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ListPriceBasicMotorPriceDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceBasicMotorPriceDto[]>(null as any);
    }

    /**
     * 批量更新境界产品型号 - 不更新数据
     * @param listPriceJINSeriesId (optional) 
     * @param body (optional) 
     * @return OK
     */
    generateJINModel(listPriceJINSeriesId?: string | undefined, body?: ListPriceBasicMotorPriceDto[] | undefined, cancelToken?: CancelToken): Promise<ListPriceBasicMotorPriceDto[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/GenerateJINModel?";
        if (listPriceJINSeriesId === null)
            throw new globalThis.Error("The parameter 'listPriceJINSeriesId' cannot be null.");
        else if (listPriceJINSeriesId !== undefined)
            url_ += "listPriceJINSeriesId=" + encodeURIComponent("" + listPriceJINSeriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateJINModel(_response);
        });
    }

    protected processGenerateJINModel(response: AxiosResponse): Promise<ListPriceBasicMotorPriceDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListPriceBasicMotorPriceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ListPriceBasicMotorPriceDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceBasicMotorPriceDto[]>(null as any);
    }

    /**
     * 导入
     * @param listPriceSeriesId (optional) 
     * @param file (optional) 
     * @return OK
     */
    importByExcel(listPriceSeriesId?: string | undefined, file?: FileParameter | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/ImportByExcel?";
        if (listPriceSeriesId === null)
            throw new globalThis.Error("The parameter 'listPriceSeriesId' cannot be null.");
        else if (listPriceSeriesId !== undefined)
            url_ += "listPriceSeriesId=" + encodeURIComponent("" + listPriceSeriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportByExcel(_response);
        });
    }

    protected processImportByExcel(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 导出Excel，PM使用，与上传格式一致
     * @param listPriceSeriesId (optional) 
     * @param includePrice (optional) 
     * @return OK
     */
    exportExcel(listPriceSeriesId?: string | undefined, includePrice?: boolean | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/ExportExcel?";
        if (listPriceSeriesId === null)
            throw new globalThis.Error("The parameter 'listPriceSeriesId' cannot be null.");
        else if (listPriceSeriesId !== undefined)
            url_ += "listPriceSeriesId=" + encodeURIComponent("" + listPriceSeriesId) + "&";
        if (includePrice === null)
            throw new globalThis.Error("The parameter 'includePrice' cannot be null.");
        else if (includePrice !== undefined)
            url_ += "includePrice=" + encodeURIComponent("" + includePrice) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportExcel(_response);
        });
    }

    protected processExportExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 行业子编码数据
     * @param code (optional) 
     * @return OK
     */
    getIndustrySubcodes(code?: string | undefined, cancelToken?: CancelToken): Promise<IndustrySubcodeDto[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/GetIndustrySubcodes?";
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIndustrySubcodes(_response);
        });
    }

    protected processGetIndustrySubcodes(response: AxiosResponse): Promise<IndustrySubcodeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IndustrySubcodeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<IndustrySubcodeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IndustrySubcodeDto[]>(null as any);
    }

    /**
     * 创建行业子编码
     * @param body (optional) 
     * @return OK
     */
    createIndustrySubcode(body?: IndustrySubcodeDto | undefined, cancelToken?: CancelToken): Promise<IndustrySubcodeDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/CreateIndustrySubcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateIndustrySubcode(_response);
        });
    }

    protected processCreateIndustrySubcode(response: AxiosResponse): Promise<IndustrySubcodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IndustrySubcodeDto.fromJS(resultData200);
            return Promise.resolve<IndustrySubcodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IndustrySubcodeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submit(body?: JINSeriesDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/Submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    recall(body?: JINSeriesDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/Recall";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecall(_response);
        });
    }

    protected processRecall(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 查找行业代码使用次数
     * @param code (optional) 
     * @return OK
     */
    getIndustryCodeUseCount(code?: string | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/GetIndustryCodeUseCount?";
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIndustryCodeUseCount(_response);
        });
    }

    protected processGetIndustryCodeUseCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * 修改主机参数
     * @param body (optional) 
     * @return OK
     */
    updateBasicMotorRowWithParams(body?: UpdateBasicMotorPriceParamsDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/UpdateBasicMotorRowWithParams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBasicMotorRowWithParams(_response);
        });
    }

    protected processUpdateBasicMotorRowWithParams(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 批量同步主机参数（供第三方调用）
     * @param body (optional) 批量数据
     * @return OK
     */
    batchUpdateBasicMotorParams(body?: BatchSyncBasicMotorParamsDto | undefined, cancelToken?: CancelToken): Promise<BatchSyncResultDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/BatchUpdateBasicMotorParams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchUpdateBasicMotorParams(_response);
        });
    }

    protected processBatchUpdateBasicMotorParams(response: AxiosResponse): Promise<BatchSyncResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatchSyncResultDto.fromJS(resultData200);
            return Promise.resolve<BatchSyncResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatchSyncResultDto>(null as any);
    }

    /**
     * 删除一行主机参数
     * @param body (optional) 
     * @return OK
     */
    deleteBasicMotorParams(body?: GuidEntityDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/DeleteBasicMotorParams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBasicMotorParams(_response);
        });
    }

    protected processDeleteBasicMotorParams(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 主机绑定内含VC
     * @param body (optional) 
     * @return OK
     */
    bindJINCodeVC(body?: BindJINCodeVCInputDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/BindJINCodeVC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBindJINCodeVC(_response);
        });
    }

    protected processBindJINCodeVC(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 拷贝标准面价的主机和VC到当前面价中
     * @param body (optional) 
     * @return OK
     */
    importMotorsAndVCFromBasedSeries(body?: ImportMotorsAndVCInputDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/ImportMotorsAndVCFromBasedSeries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportMotorsAndVCFromBasedSeries(_response);
        });
    }

    protected processImportMotorsAndVCFromBasedSeries(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 一口价境界系列
     * @return OK
     */
    getSalePriceSeries( cancelToken?: CancelToken): Promise<JINSeriesDto[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceJINSeries/GetSalePriceSeries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalePriceSeries(_response);
        });
    }

    protected processGetSalePriceSeries(response: AxiosResponse): Promise<JINSeriesDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JINSeriesDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JINSeriesDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JINSeriesDto[]>(null as any);
    }
}

export class ListPricePlatFormServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 创建面价平台
     * @param body (optional) 
     * @return OK
     */
    create(body?: ListPricePlatFormDto | undefined, cancelToken?: CancelToken): Promise<ListPricePlatFormDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPricePlatForm/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ListPricePlatFormDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPricePlatFormDto.fromJS(resultData200);
            return Promise.resolve<ListPricePlatFormDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPricePlatFormDto>(null as any);
    }

    /**
     * 删除面价平台
     * @param id (optional) 
     * @return OK
     */
    delete(id?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPricePlatForm/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 分页方法
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAll(filter?: string | undefined, sorting?: string | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined, cancelToken?: CancelToken): Promise<ListPricePlatFormDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPricePlatForm/GetAll?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ListPricePlatFormDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPricePlatFormDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ListPricePlatFormDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPricePlatFormDtoPagedResultDto>(null as any);
    }

    /**
     * 手动触发任意后台 Job
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    executeJob(body?: TriggerJobDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPricePlatForm/ExecuteJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExecuteJob(_response);
        });
    }

    protected processExecuteJob(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id?: string | undefined, cancelToken?: CancelToken): Promise<ListPricePlatFormDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPricePlatForm/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ListPricePlatFormDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPricePlatFormDto.fromJS(resultData200);
            return Promise.resolve<ListPricePlatFormDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPricePlatFormDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body?: ListPricePlatFormDto | undefined, cancelToken?: CancelToken): Promise<ListPricePlatFormDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPricePlatForm/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ListPricePlatFormDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPricePlatFormDto.fromJS(resultData200);
            return Promise.resolve<ListPricePlatFormDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPricePlatFormDto>(null as any);
    }
}

export class ListPriceRemarkServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取备注列表
     * @param listPriceSeriesId (optional) 面价表Id（为空获取默认备注）
     * @param remarkType (optional) 备注类型（0:主机备注 1:VC备注，为空获取全部）
     * @return OK
     */
    getList(listPriceSeriesId?: string | undefined, remarkType?: number | undefined, cancelToken?: CancelToken): Promise<ListPriceRemarkDto[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceRemark/GetList?";
        if (listPriceSeriesId === null)
            throw new globalThis.Error("The parameter 'listPriceSeriesId' cannot be null.");
        else if (listPriceSeriesId !== undefined)
            url_ += "ListPriceSeriesId=" + encodeURIComponent("" + listPriceSeriesId) + "&";
        if (remarkType === null)
            throw new globalThis.Error("The parameter 'remarkType' cannot be null.");
        else if (remarkType !== undefined)
            url_ += "RemarkType=" + encodeURIComponent("" + remarkType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<ListPriceRemarkDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListPriceRemarkDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ListPriceRemarkDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceRemarkDto[]>(null as any);
    }

    /**
     * 获取指定面价表的备注
     * @param listPriceSeriesId (optional) 
     * @return OK
     */
    getRemarkWithFallback(listPriceSeriesId?: string | undefined, cancelToken?: CancelToken): Promise<BatchSaveListPriceRemarkDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceRemark/GetRemarkWithFallback?";
        if (listPriceSeriesId === null)
            throw new globalThis.Error("The parameter 'listPriceSeriesId' cannot be null.");
        else if (listPriceSeriesId !== undefined)
            url_ += "listPriceSeriesId=" + encodeURIComponent("" + listPriceSeriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRemarkWithFallback(_response);
        });
    }

    protected processGetRemarkWithFallback(response: AxiosResponse): Promise<BatchSaveListPriceRemarkDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatchSaveListPriceRemarkDto.fromJS(resultData200);
            return Promise.resolve<BatchSaveListPriceRemarkDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatchSaveListPriceRemarkDto>(null as any);
    }

    /**
     * 保存备注
     * @param body (optional) 
     * @return OK
     */
    batchSave(body?: BatchSaveListPriceRemarkDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceRemark/BatchSave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchSave(_response);
        });
    }

    protected processBatchSave(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ListPriceSeriesServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 创建
     * @param body (optional) 
     * @return OK
     */
    create(body?: ListPriceSeriesDto | undefined, cancelToken?: CancelToken): Promise<ListPriceSeriesDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ListPriceSeriesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceSeriesDto.fromJS(resultData200);
            return Promise.resolve<ListPriceSeriesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceSeriesDto>(null as any);
    }

    /**
     * 更新
     * @param body (optional) 
     * @return OK
     */
    update(body?: ListPriceSeriesDto | undefined, cancelToken?: CancelToken): Promise<ListPriceSeriesDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ListPriceSeriesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceSeriesDto.fromJS(resultData200);
            return Promise.resolve<ListPriceSeriesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceSeriesDto>(null as any);
    }

    /**
     * 获取所有
     * @param platformId (optional) 平台ID
     * @param seriesName (optional) 系列
     * @param creatorId (optional) 
     * @param customerCode (optional) 
     * @param scenarioType (optional) 1 = Industry

    2 = Customer

    3 = ProductExtension

    4 = Project
     * @param listPriceType (optional) 0 = Default (标准面价)

    1 = Custom (自定义面价)

    2 = CustomerCode (客户化代码)

    3 = JIN (境界面价)
     * @param includeHidden (optional) 是否包含隐藏数据
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(platformId?: string | undefined, seriesName?: string | undefined, creatorId?: number | undefined, customerCode?: string | undefined, scenarioType?: ScenarioType | undefined, listPriceType?: ListPriceType | undefined, includeHidden?: boolean | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<ListPriceSeriesDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/GetAll?";
        if (platformId === null)
            throw new globalThis.Error("The parameter 'platformId' cannot be null.");
        else if (platformId !== undefined)
            url_ += "PlatformId=" + encodeURIComponent("" + platformId) + "&";
        if (seriesName === null)
            throw new globalThis.Error("The parameter 'seriesName' cannot be null.");
        else if (seriesName !== undefined)
            url_ += "SeriesName=" + encodeURIComponent("" + seriesName) + "&";
        if (creatorId === null)
            throw new globalThis.Error("The parameter 'creatorId' cannot be null.");
        else if (creatorId !== undefined)
            url_ += "CreatorId=" + encodeURIComponent("" + creatorId) + "&";
        if (customerCode === null)
            throw new globalThis.Error("The parameter 'customerCode' cannot be null.");
        else if (customerCode !== undefined)
            url_ += "CustomerCode=" + encodeURIComponent("" + customerCode) + "&";
        if (scenarioType === null)
            throw new globalThis.Error("The parameter 'scenarioType' cannot be null.");
        else if (scenarioType !== undefined)
            url_ += "ScenarioType=" + encodeURIComponent("" + scenarioType) + "&";
        if (listPriceType === null)
            throw new globalThis.Error("The parameter 'listPriceType' cannot be null.");
        else if (listPriceType !== undefined)
            url_ += "ListPriceType=" + encodeURIComponent("" + listPriceType) + "&";
        if (includeHidden === null)
            throw new globalThis.Error("The parameter 'includeHidden' cannot be null.");
        else if (includeHidden !== undefined)
            url_ += "IncludeHidden=" + encodeURIComponent("" + includeHidden) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ListPriceSeriesDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceSeriesDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ListPriceSeriesDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceSeriesDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id?: string | undefined, cancelToken?: CancelToken): Promise<ListPriceSeriesDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ListPriceSeriesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceSeriesDto.fromJS(resultData200);
            return Promise.resolve<ListPriceSeriesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceSeriesDto>(null as any);
    }

    /**
     * 根据面价Id返回面价客户信息
     * @param listPriceSeriesId (optional) 面价Id
     * @return OK
     */
    getCustomersById(listPriceSeriesId?: string | undefined, cancelToken?: CancelToken): Promise<ListPriceSeriesCustomerDto[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/GetCustomersById?";
        if (listPriceSeriesId === null)
            throw new globalThis.Error("The parameter 'listPriceSeriesId' cannot be null.");
        else if (listPriceSeriesId !== undefined)
            url_ += "listPriceSeriesId=" + encodeURIComponent("" + listPriceSeriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomersById(_response);
        });
    }

    protected processGetCustomersById(response: AxiosResponse): Promise<ListPriceSeriesCustomerDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListPriceSeriesCustomerDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ListPriceSeriesCustomerDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceSeriesCustomerDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 电机面价
     * @param listPriceSeriesId (optional) 
     * @param frameNumber (optional) 
     * @param pole (optional) 
     * @param power (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getListPriceBasicMotorPrices(listPriceSeriesId?: string | undefined, frameNumber?: string | undefined, pole?: string | undefined, power?: string | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<ListPriceBasicMotorPriceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/GetListPriceBasicMotorPrices?";
        if (listPriceSeriesId === null)
            throw new globalThis.Error("The parameter 'listPriceSeriesId' cannot be null.");
        else if (listPriceSeriesId !== undefined)
            url_ += "listPriceSeriesId=" + encodeURIComponent("" + listPriceSeriesId) + "&";
        if (frameNumber === null)
            throw new globalThis.Error("The parameter 'frameNumber' cannot be null.");
        else if (frameNumber !== undefined)
            url_ += "FrameNumber=" + encodeURIComponent("" + frameNumber) + "&";
        if (pole === null)
            throw new globalThis.Error("The parameter 'pole' cannot be null.");
        else if (pole !== undefined)
            url_ += "Pole=" + encodeURIComponent("" + pole) + "&";
        if (power === null)
            throw new globalThis.Error("The parameter 'power' cannot be null.");
        else if (power !== undefined)
            url_ += "Power=" + encodeURIComponent("" + power) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListPriceBasicMotorPrices(_response);
        });
    }

    protected processGetListPriceBasicMotorPrices(response: AxiosResponse): Promise<ListPriceBasicMotorPriceDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceBasicMotorPriceDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ListPriceBasicMotorPriceDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceBasicMotorPriceDtoPagedResultDto>(null as any);
    }

    /**
     * VC面价
     * @param listPriceSeriesId (optional) 
     * @param vCCode (optional) 
     * @param discountType (optional) 
     * @param frameNumber (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getListPriceVCPrices(listPriceSeriesId?: string | undefined, vCCode?: string | undefined, discountType?: string | undefined, frameNumber?: string | undefined, sorting?: string | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined, cancelToken?: CancelToken): Promise<ListPriceVCPriceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/GetListPriceVCPrices?";
        if (listPriceSeriesId === null)
            throw new globalThis.Error("The parameter 'listPriceSeriesId' cannot be null.");
        else if (listPriceSeriesId !== undefined)
            url_ += "listPriceSeriesId=" + encodeURIComponent("" + listPriceSeriesId) + "&";
        if (vCCode === null)
            throw new globalThis.Error("The parameter 'vCCode' cannot be null.");
        else if (vCCode !== undefined)
            url_ += "VCCode=" + encodeURIComponent("" + vCCode) + "&";
        if (discountType === null)
            throw new globalThis.Error("The parameter 'discountType' cannot be null.");
        else if (discountType !== undefined)
            url_ += "DiscountType=" + encodeURIComponent("" + discountType) + "&";
        if (frameNumber === null)
            throw new globalThis.Error("The parameter 'frameNumber' cannot be null.");
        else if (frameNumber !== undefined)
            url_ += "FrameNumber=" + encodeURIComponent("" + frameNumber) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListPriceVCPrices(_response);
        });
    }

    protected processGetListPriceVCPrices(response: AxiosResponse): Promise<ListPriceVCPriceDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceVCPriceDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ListPriceVCPriceDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceVCPriceDtoPagedResultDto>(null as any);
    }

    /**
     * 版本列表
     * @param seriesId (optional) 
     * @return OK
     */
    getVersions(seriesId?: string | undefined, cancelToken?: CancelToken): Promise<ListPriceSeriesDto[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/GetVersions?";
        if (seriesId === null)
            throw new globalThis.Error("The parameter 'seriesId' cannot be null.");
        else if (seriesId !== undefined)
            url_ += "seriesId=" + encodeURIComponent("" + seriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVersions(_response);
        });
    }

    protected processGetVersions(response: AxiosResponse): Promise<ListPriceSeriesDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListPriceSeriesDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ListPriceSeriesDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceSeriesDto[]>(null as any);
    }

    /**
     * Excel导入面价
    导入策略：
    1、复制面价表
    2、老版本归档，新版本设置生效时间，老版本设置失效时间
    3、验证成功数据先导入，验证失败提示行错误和原因，返回给用户
     * @param listPriceSeriesId (optional) 
     * @param file (optional) 
     * @return OK
     */
    importByExcel(listPriceSeriesId?: string | undefined, file?: FileParameter | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/ImportByExcel?";
        if (listPriceSeriesId === null)
            throw new globalThis.Error("The parameter 'listPriceSeriesId' cannot be null.");
        else if (listPriceSeriesId !== undefined)
            url_ += "listPriceSeriesId=" + encodeURIComponent("" + listPriceSeriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportByExcel(_response);
        });
    }

    protected processImportByExcel(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 导出Excel，PM使用，与上传格式一致
     * @param listPriceSeriesId (optional) 
     * @return OK
     */
    exportExcel(listPriceSeriesId?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/ExportExcel?";
        if (listPriceSeriesId === null)
            throw new globalThis.Error("The parameter 'listPriceSeriesId' cannot be null.");
        else if (listPriceSeriesId !== undefined)
            url_ += "listPriceSeriesId=" + encodeURIComponent("" + listPriceSeriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportExcel(_response);
        });
    }

    protected processExportExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导出全系列OEM上传模板,不指定面价表ID导出全部数据
     * @param listPriceSeriesId (optional) 
     * @return OK
     */
    exportOmsExcel(listPriceSeriesId?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/ExportOmsExcel?";
        if (listPriceSeriesId === null)
            throw new globalThis.Error("The parameter 'listPriceSeriesId' cannot be null.");
        else if (listPriceSeriesId !== undefined)
            url_ += "listPriceSeriesId=" + encodeURIComponent("" + listPriceSeriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportOmsExcel(_response);
        });
    }

    protected processExportOmsExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 提交
    只处理生效时间
     * @param body (optional) 
     * @return OK
     */
    submit(body?: ListPriceSeriesDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/Submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 撤回
     * @param body (optional) 
     * @return OK
     */
    recall(body?: ListPriceSeriesDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/Recall";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecall(_response);
        });
    }

    protected processRecall(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 查询面价
     * @param body (optional) 
     * @return OK
     */
    getListPrice(body?: ListPriceBasicPriceDto | undefined, cancelToken?: CancelToken): Promise<ListPriceBasicPriceDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/GetListPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListPrice(_response);
        });
    }

    protected processGetListPrice(response: AxiosResponse): Promise<ListPriceBasicPriceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceBasicPriceDto.fromJS(resultData200);
            return Promise.resolve<ListPriceBasicPriceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceBasicPriceDto>(null as any);
    }

    /**
     * 根据系列与基座号查询支持的vc集合
     * @param body (optional) 
     * @return OK
     */
    getVcCode(body?: ListPriceVcCodeInputDto | undefined, cancelToken?: CancelToken): Promise<ListPriceVcCodeOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/GetVcCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVcCode(_response);
        });
    }

    protected processGetVcCode(response: AxiosResponse): Promise<ListPriceVcCodeOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListPriceVcCodeOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ListPriceVcCodeOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceVcCodeOutputDto[]>(null as any);
    }

    /**
     * 获取主机共有的vc
     * @param body (optional) 
     * @return OK
     */
    getVcCodes(body?: ListPriceVcCodeInputDto[] | undefined, cancelToken?: CancelToken): Promise<ListPriceVcCodeOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/GetVcCodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVcCodes(_response);
        });
    }

    protected processGetVcCodes(response: AxiosResponse): Promise<ListPriceVcCodeOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListPriceVcCodeOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ListPriceVcCodeOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceVcCodeOutputDto[]>(null as any);
    }

    /**
     * 获取系列与基座号的短代码
     * @param body (optional) 
     * @return OK
     */
    getSerieShortCode(body?: ListPriceSeriesShortCodeDto[] | undefined, cancelToken?: CancelToken): Promise<ListPriceSeriesShortCodeDto[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/GetSerieShortCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSerieShortCode(_response);
        });
    }

    protected processGetSerieShortCode(response: AxiosResponse): Promise<ListPriceSeriesShortCodeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListPriceSeriesShortCodeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ListPriceSeriesShortCodeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceSeriesShortCodeDto[]>(null as any);
    }

    /**
     * 更新主机参数，by MotorCode
    电压
    频率
    接线方式
    能效等级
     * @param body (optional) 
     * @return OK
     */
    updateBasicMotor(body?: ListPriceBasicMotorPriceDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/UpdateBasicMotor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBasicMotor(_response);
        });
    }

    protected processUpdateBasicMotor(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 更新主机参数，by MotorCode
     * @param body (optional) 
     * @return OK
     */
    updateBasicMotors(body?: ListPriceBasicMotorPriceDto[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/UpdateBasicMotors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBasicMotors(_response);
        });
    }

    protected processUpdateBasicMotors(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param listPriceSeriesId (optional) 
     * @return OK
     */
    executeProductDataScheduler(listPriceSeriesId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/ExecuteProductDataScheduler?";
        if (listPriceSeriesId === null)
            throw new globalThis.Error("The parameter 'listPriceSeriesId' cannot be null.");
        else if (listPriceSeriesId !== undefined)
            url_ += "listPriceSeriesId=" + encodeURIComponent("" + listPriceSeriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExecuteProductDataScheduler(_response);
        });
    }

    protected processExecuteProductDataScheduler(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 电机（主机）单行编辑
     * @param body (optional) 
     * @return OK
     */
    updateBasicMotorRow(body?: UpdateListPriceBasicMotorRowInputDto | undefined, cancelToken?: CancelToken): Promise<ListPriceBasicMotorPriceDtoRowEditResultDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/UpdateBasicMotorRow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBasicMotorRow(_response);
        });
    }

    protected processUpdateBasicMotorRow(response: AxiosResponse): Promise<ListPriceBasicMotorPriceDtoRowEditResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceBasicMotorPriceDtoRowEditResultDto.fromJS(resultData200);
            return Promise.resolve<ListPriceBasicMotorPriceDtoRowEditResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceBasicMotorPriceDtoRowEditResultDto>(null as any);
    }

    /**
     * VC 单行编辑
     * @param body (optional) 
     * @return OK
     */
    updateVCRow(body?: UpdateListPriceVCRowInputDto | undefined, cancelToken?: CancelToken): Promise<ListPriceVCPriceDtoRowEditResultDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/UpdateVCRow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateVCRow(_response);
        });
    }

    protected processUpdateVCRow(response: AxiosResponse): Promise<ListPriceVCPriceDtoRowEditResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceVCPriceDtoRowEditResultDto.fromJS(resultData200);
            return Promise.resolve<ListPriceVCPriceDtoRowEditResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceVCPriceDtoRowEditResultDto>(null as any);
    }

    /**
     * 电机（主机）单行删除
     * @param body (optional) 
     * @return OK
     */
    deleteBasicMotor(body?: DeleteListPriceDetailInputDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/DeleteBasicMotor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBasicMotor(_response);
        });
    }

    protected processDeleteBasicMotor(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * VC 单行删除
     * @param body (optional) 
     * @return OK
     */
    deleteVC(body?: DeleteListPriceDetailInputDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/DeleteVC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteVC(_response);
        });
    }

    protected processDeleteVC(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 创建主机（单行新增）
     * @param body (optional) 主机信息
     * @return OK
     */
    createMotor(body?: CreateMotorInputDto | undefined, cancelToken?: CancelToken): Promise<ListPriceBasicMotorPriceDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/CreateMotor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMotor(_response);
        });
    }

    protected processCreateMotor(response: AxiosResponse): Promise<ListPriceBasicMotorPriceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceBasicMotorPriceDto.fromJS(resultData200);
            return Promise.resolve<ListPriceBasicMotorPriceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceBasicMotorPriceDto>(null as any);
    }

    /**
     * 创建VC
     * @param body (optional) 
     * @return OK
     */
    createVC(body?: CreateVCInputDto | undefined, cancelToken?: CancelToken): Promise<ListPriceVCPriceDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/CreateVC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateVC(_response);
        });
    }

    protected processCreateVC(response: AxiosResponse): Promise<ListPriceVCPriceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPriceVCPriceDto.fromJS(resultData200);
            return Promise.resolve<ListPriceVCPriceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceVCPriceDto>(null as any);
    }

    /**
     * 更新VC 启用/禁用
     * @param body (optional) 
     * @return OK
     */
    updateVcEnabled(body?: UpdateVcEnabledInputDto | undefined, cancelToken?: CancelToken): Promise<UpdateVcEnabledResultDto> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/UpdateVcEnabled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateVcEnabled(_response);
        });
    }

    protected processUpdateVcEnabled(response: AxiosResponse): Promise<UpdateVcEnabledResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateVcEnabledResultDto.fromJS(resultData200);
            return Promise.resolve<UpdateVcEnabledResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateVcEnabledResultDto>(null as any);
    }

    /**
     * 批量修改价格
     * @param body (optional) 
     * @return OK
     */
    batchModifyPrice(body?: BatchModifyPriceInputDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/BatchModifyPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchModifyPrice(_response);
        });
    }

    protected processBatchModifyPrice(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 多面价表批量修改价格（后台任务执行）
     * @param body (optional) 
     * @return OK
     */
    multiSeriesBatchModifyPrice(body?: MultiSeriesBatchModifyPriceInputDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/MultiSeriesBatchModifyPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMultiSeriesBatchModifyPrice(_response);
        });
    }

    protected processMultiSeriesBatchModifyPrice(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 批量修改主机参数（价格除外）
     * @param body (optional) 
     * @return OK
     */
    batchModifyMotor(body?: BatchModifyMotorInputDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/BatchModifyMotor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchModifyMotor(_response);
        });
    }

    protected processBatchModifyMotor(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 变更记录
     * @param id (optional) 
     * @return OK
     */
    getChangeHistory(id?: string | undefined, cancelToken?: CancelToken): Promise<ListPriceChangeHistoryItemDto[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/GetChangeHistory?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChangeHistory(_response);
        });
    }

    protected processGetChangeHistory(response: AxiosResponse): Promise<ListPriceChangeHistoryItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListPriceChangeHistoryItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ListPriceChangeHistoryItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceChangeHistoryItemDto[]>(null as any);
    }

    /**
     * 更新面价表生效时间
    限制：
    1. 新时间不能小于当前时间
    2. 新时间距离现在至少需要1天
     * @param body (optional) 更新生效时间输入DTO
     * @return OK
     */
    updateTakeEffectTime(body?: UpdateTakeEffectTimeInputDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/UpdateTakeEffectTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTakeEffectTime(_response);
        });
    }

    protected processUpdateTakeEffectTime(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 更新公告发布时间
     * @param body (optional) 
     * @return OK
     */
    updateAnnouncementPublishTime(body?: UpdateAnnouncementPublishTimeInputDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/UpdateAnnouncementPublishTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAnnouncementPublishTime(_response);
        });
    }

    protected processUpdateAnnouncementPublishTime(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 更新是否替换选型
     * @param body (optional) 更新输入DTO
     * @return OK
     */
    updateReplaceSelection(body?: UpdateReplaceSelectionInputDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/UpdateReplaceSelection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateReplaceSelection(_response);
        });
    }

    protected processUpdateReplaceSelection(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 启用或禁用面价表
     * @param body (optional) 
     * @return OK
     */
    setSeriesEnabled(body?: SetSeriesEnabledInputDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/SetSeriesEnabled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetSeriesEnabled(_response);
        });
    }

    protected processSetSeriesEnabled(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 手动触发面价表定时启用/禁用任务
    调试用：立即入队定时Job
     * @param listPriceSeriesId (optional) 面价表Id（可选，不传则处理所有符合条件的）
     * @return OK
     */
    executeListPriceSeriesEnableJob(listPriceSeriesId?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/ExecuteListPriceSeriesEnableJob?";
        if (listPriceSeriesId === null)
            throw new globalThis.Error("The parameter 'listPriceSeriesId' cannot be null.");
        else if (listPriceSeriesId !== undefined)
            url_ += "listPriceSeriesId=" + encodeURIComponent("" + listPriceSeriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExecuteListPriceSeriesEnableJob(_response);
        });
    }

    protected processExecuteListPriceSeriesEnableJob(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 导出面价Excel文件
     * @param listPriceSeriesId (optional) 
     * @return OK
     */
    exportBasicMotorPriceExcel(listPriceSeriesId?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/ExportBasicMotorPriceExcel?";
        if (listPriceSeriesId === null)
            throw new globalThis.Error("The parameter 'listPriceSeriesId' cannot be null.");
        else if (listPriceSeriesId !== undefined)
            url_ += "listPriceSeriesId=" + encodeURIComponent("" + listPriceSeriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportBasicMotorPriceExcel(_response);
        });
    }

    protected processExportBasicMotorPriceExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 合并导出面价Excel文件（多个面价表合并到一个Excel）
     * @param body (optional) 包含多个面价表ID的输入DTO
     * @return OK
     */
    exportMergedBasicMotorPriceExcel(body?: MergedExportInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/ExportMergedBasicMotorPriceExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportMergedBasicMotorPriceExcel(_response);
        });
    }

    protected processExportMergedBasicMotorPriceExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 临时调试：创建面价表发布公告
     * @param body (optional) 
     * @return OK
     */
    debugCreateListPricePublishAnnouncement(body?: PublishListPriceAnnouncementInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/DebugCreateListPricePublishAnnouncement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDebugCreateListPricePublishAnnouncement(_response);
        });
    }

    protected processDebugCreateListPricePublishAnnouncement(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 手动触发面价表发布公告任务
    调试用：按指定面价表Id立即入队公告Job
     * @param listPriceSeriesId (optional) 面价表Id
     * @return OK
     */
    executeListPricePublishAnnouncementJob(listPriceSeriesId?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/ExecuteListPricePublishAnnouncementJob?";
        if (listPriceSeriesId === null)
            throw new globalThis.Error("The parameter 'listPriceSeriesId' cannot be null.");
        else if (listPriceSeriesId !== undefined)
            url_ += "listPriceSeriesId=" + encodeURIComponent("" + listPriceSeriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExecuteListPricePublishAnnouncementJob(_response);
        });
    }

    protected processExecuteListPricePublishAnnouncementJob(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取面价表下拉数据
     * @return OK
     */
    getListPriceSeriesOptions( cancelToken?: CancelToken): Promise<ListPriceSeriesOptionDto[]> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/GetListPriceSeriesOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListPriceSeriesOptions(_response);
        });
    }

    protected processGetListPriceSeriesOptions(response: AxiosResponse): Promise<ListPriceSeriesOptionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListPriceSeriesOptionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ListPriceSeriesOptionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPriceSeriesOptionDto[]>(null as any);
    }

    /**
     * 维护封面文件
     * @param body (optional) 
     * @return OK
     */
    updateCoverFileUrl(body?: UpdateListPriceSeriesCoverFileDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/UpdateCoverFileUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCoverFileUrl(_response);
        });
    }

    protected processUpdateCoverFileUrl(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 维护价格补充附件（单个 Excel）。导出面价时会将该 Excel 的全部 sheet 合并到导出文件公共价格表之后。
     * @param body (optional) 
     * @return OK
     */
    updatePriceSupplementFileUrl(body?: UpdateListPriceSeriesPriceSupplementFileDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/UpdatePriceSupplementFileUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePriceSupplementFileUrl(_response);
        });
    }

    protected processUpdatePriceSupplementFileUrl(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 上传文件
     * @param file (optional) 
     * @return OK
     */
    uploadFile(file?: FileParameter | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/UploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取文件可访问地址
     * @param fileName (optional) 
     * @return OK
     */
    getFileAccessUrl(fileName?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/ListPrice/ListPriceSeries/GetFileAccessUrl?";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileAccessUrl(_response);
        });
    }

    protected processGetFileAccessUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class AutoApproveOrderServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 自动审单主方法
     * @param body (optional) 
     * @return OK
     */
    approveOrderMain(body?: AutoApproveOrderJobArgs | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/AutoApproveOrder/ApproveOrderMain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveOrderMain(_response);
        });
    }

    protected processApproveOrderMain(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 更新订单的AutoApproveTaskStatus
     * @param orderId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateOrderAutoApproveTaskStatus(orderId?: string | undefined, body?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/AutoApproveOrder/UpdateOrderAutoApproveTaskStatus?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrderAutoApproveTaskStatus(_response);
        });
    }

    protected processUpdateOrderAutoApproveTaskStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 生成检查结果精简版
     * @param taskid (optional) 
     * @param body (optional) 
     * @return OK
     */
    setCheckResultSimplify(taskid?: string | undefined, body?: OrderForm | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/AutoApproveOrder/SetCheckResultSimplify?";
        if (taskid === null)
            throw new globalThis.Error("The parameter 'taskid' cannot be null.");
        else if (taskid !== undefined)
            url_ += "taskid=" + encodeURIComponent("" + taskid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetCheckResultSimplify(_response);
        });
    }

    protected processSetCheckResultSimplify(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 检查客户是否有信用额度
     * @param cusNo (optional) 
     * @return OK
     */
    checkCredit(cusNo?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/AutoApproveOrder/CheckCredit?";
        if (cusNo === null)
            throw new globalThis.Error("The parameter 'cusNo' cannot be null.");
        else if (cusNo !== undefined)
            url_ += "CusNo=" + encodeURIComponent("" + cusNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckCredit(_response);
        });
    }

    protected processCheckCredit(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 移除缓存
     * @return OK
     */
    cacheCheckItemListRemve( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/AutoApproveOrder/CacheCheckItemListRemve";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCacheCheckItemListRemve(_response);
        });
    }

    protected processCacheCheckItemListRemve(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CountryRiskServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 查询国家列表
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getCountryListByPage(keyword?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<CountryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/CountryRisk/GetCountryListByPage?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCountryListByPage(_response);
        });
    }

    protected processGetCountryListByPage(response: AxiosResponse): Promise<CountryDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CountryDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<CountryDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountryDtoPagedResultDto>(null as any);
    }

    /**
     * 根据国家简称查询风险等级
     * @param shortName (optional) 
     * @return OK
     */
    getRating(shortName?: string | undefined, cancelToken?: CancelToken): Promise<CountryRiskEnum> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/CountryRisk/GetRating?";
        if (shortName === null)
            throw new globalThis.Error("The parameter 'shortName' cannot be null.");
        else if (shortName !== undefined)
            url_ += "shortName=" + encodeURIComponent("" + shortName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRating(_response);
        });
    }

    protected processGetRating(response: AxiosResponse): Promise<CountryRiskEnum> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<CountryRiskEnum>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountryRiskEnum>(null as any);
    }

    /**
     * 导入风险国家信息
     * @param excelFile (optional) 
     * @return OK
     */
    importCountryInfos(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/CountryRisk/ImportCountryInfos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportCountryInfos(_response);
        });
    }

    protected processImportCountryInfos(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导出风险国家上传导入模板
     * @return OK
     */
    excelCountryRiskTemplate( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/CountryRisk/ExcelCountryRiskTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExcelCountryRiskTemplate(_response);
        });
    }

    protected processExcelCountryRiskTemplate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导出风险国家数据
     * @return OK
     */
    excelCountryRisk( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/CountryRisk/ExcelCountryRisk";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExcelCountryRisk(_response);
        });
    }

    protected processExcelCountryRisk(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class DeliveryTimeServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取所有客户信息（限时发货）
     * @param body (optional) 
     * @return OK
     */
    getCustomInfosByDeliveryTime(body?: PageCustomInfosByDeliveryTimeInputDto | undefined, cancelToken?: CancelToken): Promise<GetCustomInfosByDeliveryTimeOutDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryTime/GetCustomInfosByDeliveryTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomInfosByDeliveryTime(_response);
        });
    }

    protected processGetCustomInfosByDeliveryTime(response: AxiosResponse): Promise<GetCustomInfosByDeliveryTimeOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCustomInfosByDeliveryTimeOutDto.fromJS(resultData200);
            return Promise.resolve<GetCustomInfosByDeliveryTimeOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCustomInfosByDeliveryTimeOutDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getDeliveryTimeForSoldToParty(body?: PageDeliveryTimeForSoldToPartyInputDto | undefined, cancelToken?: CancelToken): Promise<GetDeliveryTimeForSoldToPartyOutDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryTime/GetDeliveryTimeForSoldToParty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeliveryTimeForSoldToParty(_response);
        });
    }

    protected processGetDeliveryTimeForSoldToParty(response: AxiosResponse): Promise<GetDeliveryTimeForSoldToPartyOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDeliveryTimeForSoldToPartyOutDto.fromJS(resultData200);
            return Promise.resolve<GetDeliveryTimeForSoldToPartyOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDeliveryTimeForSoldToPartyOutDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    batchModifyDeliveryTimeInfoForSoldToPartys(body?: BatchModifyDeliveryTimeInfoInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryTime/BatchModifyDeliveryTimeInfoForSoldToPartys";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchModifyDeliveryTimeInfoForSoldToPartys(_response);
        });
    }

    protected processBatchModifyDeliveryTimeInfoForSoldToPartys(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    batchModifyDeliveryTimeActiveForSoldToPartys(body?: BatchModifyDeliveryTimeInfoInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DeliveryTime/BatchModifyDeliveryTimeActiveForSoldToPartys";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchModifyDeliveryTimeActiveForSoldToPartys(_response);
        });
    }

    protected processBatchModifyDeliveryTimeActiveForSoldToPartys(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DictionaryServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 根据字典类型获取字典列表
     * @return OK
     */
    getDicType(dicType: string, cancelToken?: CancelToken): Promise<DictionaryGetListOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/Dictionary/GetDicType";
        if (dicType === undefined || dicType === null)
            throw new globalThis.Error("The parameter 'dicType' must be defined.");
        url_ = url_.replace("{dicType}", encodeURIComponent("" + dicType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDicType(_response);
        });
    }

    protected processGetDicType(response: AxiosResponse): Promise<DictionaryGetListOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryGetListOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DictionaryGetListOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DictionaryGetListOutputDto[]>(null as any);
    }
}

export class DomesticNonSalesOrderServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 导入内销非销售订单
     * @param excelFile (optional) 
     * @return OK
     */
    import(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DomesticNonSalesOrder/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 查询内销非销售订单
     * @param body (optional) 
     * @return OK
     */
    paged(body?: PagedDomesticNonSalesOrderRequestDto | undefined, cancelToken?: CancelToken): Promise<DomesticNonSalesOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DomesticNonSalesOrder/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaged(_response);
        });
    }

    protected processPaged(response: AxiosResponse): Promise<DomesticNonSalesOrderDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DomesticNonSalesOrderDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<DomesticNonSalesOrderDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DomesticNonSalesOrderDtoPagedResultDto>(null as any);
    }

    /**
     * 内销非销售订单详情
     * @param orderId (optional) 
     * @return OK
     */
    details(orderId?: string | undefined, cancelToken?: CancelToken): Promise<DomesticNonSalesOrderDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DomesticNonSalesOrder/Details?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<DomesticNonSalesOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DomesticNonSalesOrderDto.fromJS(resultData200);
            return Promise.resolve<DomesticNonSalesOrderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DomesticNonSalesOrderDto>(null as any);
    }

    /**
     * 订单导出
     * @param body (optional) 
     * @return OK
     */
    exportExcelStream(body?: PagedDomesticNonSalesOrderRequestDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DomesticNonSalesOrder/ExportExcelStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportExcelStream(_response);
        });
    }

    protected processExportExcelStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取订单产品备注信息
     * @param productId (optional) 
     * @return OK
     */
    getProductRemark(productId?: string | undefined, cancelToken?: CancelToken): Promise<any[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/DomesticNonSalesOrder/GetProductRemark?";
        if (productId === null)
            throw new globalThis.Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/xml"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductRemark(_response);
        });
    }

    protected processGetProductRemark(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }
}

export class ExcelInputServiceServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 字典维护
     * @param body (optional) 
     * @return OK
     */
    addExportOrderDictionary(body?: OISExportOrderDictionaryDto | undefined, cancelToken?: CancelToken): Promise<OISExportOrderDictionary> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/AddExportOrderDictionary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddExportOrderDictionary(_response);
        });
    }

    protected processAddExportOrderDictionary(response: AxiosResponse): Promise<OISExportOrderDictionary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OISExportOrderDictionary.fromJS(resultData200);
            return Promise.resolve<OISExportOrderDictionary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OISExportOrderDictionary>(null as any);
    }

    /**
     * 添加VC
     * @param body (optional) 
     * @return OK
     */
    addExportOrderProductVCConfirmation(body?: AddExportOrderProductVCConfirmationDto[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/AddExportOrderProductVCConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddExportOrderProductVCConfirmation(_response);
        });
    }

    protected processAddExportOrderProductVCConfirmation(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 删除VC
     * @param id (optional) 
     * @return OK
     */
    deleteExportOrderProductVCConfirmation(id?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/DeleteExportOrderProductVCConfirmation?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteExportOrderProductVCConfirmation(_response);
        });
    }

    protected processDeleteExportOrderProductVCConfirmation(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 导出外销模板
     * @return OK
     */
    excelExportOrderTemplate( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/ExcelExportOrderTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExcelExportOrderTemplate(_response);
        });
    }

    protected processExcelExportOrderTemplate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 根据版本号获取主订单Guid
     * @param cscot (optional) 
     * @param batch (optional) 
     * @param version (optional) 
     * @return OK
     */
    getOrderGuidByVesion(cscot?: string | undefined, batch?: number | undefined, version?: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetOrderGuidByVesion?";
        if (cscot === null)
            throw new globalThis.Error("The parameter 'cscot' cannot be null.");
        else if (cscot !== undefined)
            url_ += "cscot=" + encodeURIComponent("" + cscot) + "&";
        if (batch === null)
            throw new globalThis.Error("The parameter 'batch' cannot be null.");
        else if (batch !== undefined)
            url_ += "batch=" + encodeURIComponent("" + batch) + "&";
        if (version === null)
            throw new globalThis.Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderGuidByVesion(_response);
        });
    }

    protected processGetOrderGuidByVesion(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 多订单导出excel
     * @param body (optional) 
     * @return OK
     */
    exportExcelStream(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/ExportExcelStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportExcelStream(_response);
        });
    }

    protected processExportExcelStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 外销订单列表导出（按行号导出，一个产品行一行）
     * @param body (optional) 
     * @return OK
     */
    exportExportOrderListStream(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/ExportExportOrderListStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportExportOrderListStream(_response);
        });
    }

    protected processExportExportOrderListStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 多订单导出excel
     * @param body (optional) 
     * @return OK
     */
    exportExcelStreamByOrderchange(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/ExportExcelStreamByOrderchange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportExcelStreamByOrderchange(_response);
        });
    }

    protected processExportExcelStreamByOrderchange(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 1.biztailk外销订单导入
    2.提取订单信息,生成订单等级
    3.提取产品信息
    4.提取产品VC信息
    5.生成vc确认信息
    6.存储至数据库
     * @param body (optional) 
     * @return OK
     */
    exportOrderByBizTalk(body?: ExportOrderBizTalkDto | undefined, cancelToken?: CancelToken): Promise<BiztalkExportOrderResult> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/ExportOrderByBizTalk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportOrderByBizTalk(_response);
        });
    }

    protected processExportOrderByBizTalk(response: AxiosResponse): Promise<BiztalkExportOrderResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BiztalkExportOrderResult.fromJS(resultData200);
            return Promise.resolve<BiztalkExportOrderResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BiztalkExportOrderResult>(null as any);
    }

    /**
     * 测试biztalk并发场景
     * @param cscot (optional) 
     * @return OK
     */
    textExportOrderByBizTalk(cscot?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/TextExportOrderByBizTalk?";
        if (cscot === null)
            throw new globalThis.Error("The parameter 'cscot' cannot be null.");
        else if (cscot !== undefined)
            url_ += "cscot=" + encodeURIComponent("" + cscot) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTextExportOrderByBizTalk(_response);
        });
    }

    protected processTextExportOrderByBizTalk(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 解析 bztalkxml
     * @param productId (optional) 
     * @return OK
     */
    getBiztalkXml(productId?: string | undefined, cancelToken?: CancelToken): Promise<any[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetBiztalkXml?";
        if (productId === null)
            throw new globalThis.Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/xml"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBiztalkXml(_response);
        });
    }

    protected processGetBiztalkXml(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }

    /**
     * 查询外销订单
     * @param body (optional) 
     * @return OK
     */
    getExportOrder(body?: ExportQueryDto | undefined, cancelToken?: CancelToken): Promise<ExportSalasOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetExportOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExportOrder(_response);
        });
    }

    protected processGetExportOrder(response: AxiosResponse): Promise<ExportSalasOrderDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportSalasOrderDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ExportSalasOrderDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportSalasOrderDtoPagedResultDto>(null as any);
    }

    /**
     * 根据类别查询字典数据
     * @param orderDictionaryCategory (optional) 1 = Country

    2 = Status

    3 = VCConfirmationStatus

    4 = ReviewStatus
     * @return OK
     */
    getExportOrderDictionary(orderDictionaryCategory?: EnumOISExportOrderDictionaryCategory | undefined, cancelToken?: CancelToken): Promise<OISExportOrderDictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetExportOrderDictionary?";
        if (orderDictionaryCategory === null)
            throw new globalThis.Error("The parameter 'orderDictionaryCategory' cannot be null.");
        else if (orderDictionaryCategory !== undefined)
            url_ += "orderDictionaryCategory=" + encodeURIComponent("" + orderDictionaryCategory) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExportOrderDictionary(_response);
        });
    }

    protected processGetExportOrderDictionary(response: AxiosResponse): Promise<OISExportOrderDictionaryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OISExportOrderDictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OISExportOrderDictionaryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OISExportOrderDictionaryDto[]>(null as any);
    }

    /**
     * 获取vc确认记录
     * @param exportOrderProductsID (optional) 
     * @return OK
     */
    getExportOrderProductVCConfirmation(exportOrderProductsID?: string | undefined, cancelToken?: CancelToken): Promise<ExportOrderProductVCConfirmationDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetExportOrderProductVCConfirmation?";
        if (exportOrderProductsID === null)
            throw new globalThis.Error("The parameter 'exportOrderProductsID' cannot be null.");
        else if (exportOrderProductsID !== undefined)
            url_ += "exportOrderProductsID=" + encodeURIComponent("" + exportOrderProductsID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExportOrderProductVCConfirmation(_response);
        });
    }

    protected processGetExportOrderProductVCConfirmation(response: AxiosResponse): Promise<ExportOrderProductVCConfirmationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExportOrderProductVCConfirmationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ExportOrderProductVCConfirmationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportOrderProductVCConfirmationDto[]>(null as any);
    }

    /**
     * 外销订单详情
     * @param orderId (optional) 
     * @param versionId (optional) 
     * @return OK
     */
    getExportSalasOrderInfo(orderId?: string | undefined, versionId?: string | undefined, cancelToken?: CancelToken): Promise<ExportSalasOrderDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetExportSalasOrderInfo?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (versionId === null)
            throw new globalThis.Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExportSalasOrderInfo(_response);
        });
    }

    protected processGetExportSalasOrderInfo(response: AxiosResponse): Promise<ExportSalasOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportSalasOrderDto.fromJS(resultData200);
            return Promise.resolve<ExportSalasOrderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportSalasOrderDto>(null as any);
    }

    /**
     * 从SmartConfigurator获取此行的所有的vc,返回是否为openvc。
     * @param basicMotorCode (optional) 
     * @return OK
     */
    getExportSalasOrderTechnologyQuotationProductVCsByMotor(basicMotorCode?: string | undefined, cancelToken?: CancelToken): Promise<ExportOrderVcsDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetExportSalasOrderTechnologyQuotationProductVCsByMotor?";
        if (basicMotorCode === null)
            throw new globalThis.Error("The parameter 'basicMotorCode' cannot be null.");
        else if (basicMotorCode !== undefined)
            url_ += "basicMotorCode=" + encodeURIComponent("" + basicMotorCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExportSalasOrderTechnologyQuotationProductVCsByMotor(_response);
        });
    }

    protected processGetExportSalasOrderTechnologyQuotationProductVCsByMotor(response: AxiosResponse): Promise<ExportOrderVcsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExportOrderVcsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ExportOrderVcsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportOrderVcsDto[]>(null as any);
    }

    /**
     * 获取产品主机信息
     * @param exportSalasId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getOISExportOrderProductsInfo(exportSalasId?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<OISExportOrderProductsDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetOISExportOrderProductsInfo?";
        if (exportSalasId === null)
            throw new globalThis.Error("The parameter 'exportSalasId' cannot be null.");
        else if (exportSalasId !== undefined)
            url_ += "exportSalasId=" + encodeURIComponent("" + exportSalasId) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOISExportOrderProductsInfo(_response);
        });
    }

    protected processGetOISExportOrderProductsInfo(response: AxiosResponse): Promise<OISExportOrderProductsDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OISExportOrderProductsDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<OISExportOrderProductsDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OISExportOrderProductsDtoPagedResultDto>(null as any);
    }

    /**
     * 获取SC-自定义VC
     * @return OK
     */
    getRangeByVcCode( cancelToken?: CancelToken): Promise<CustomVcDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetRangeByVcCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRangeByVcCode(_response);
        });
    }

    protected processGetRangeByVcCode(response: AxiosResponse): Promise<CustomVcDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomVcDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CustomVcDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomVcDto[]>(null as any);
    }

    /**
     * 重构  外销导入excel
    1. 上传文件
    2. 判断excel中有几个订单
    3. 将vc列中的字符串全部解析成vc
    4. 判断是否为open vcId
    5. 判断对应的 open vcId 是否符合拼接规则
    6. 判断现有的open vcId 拼接是否跟系统预设的规则一致，如果不一致。则
    6. 拼接vc规则到行备注列
    7. 保存数据
     * @param orderId (optional) 
     * @param excelFile (optional) 
     * @return OK
     */
    input(orderId?: string | undefined, excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<BiztalkExportOrderResult> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/Input?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInput(_response);
        });
    }

    protected processInput(response: AxiosResponse): Promise<BiztalkExportOrderResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BiztalkExportOrderResult.fromJS(resultData200);
            return Promise.resolve<BiztalkExportOrderResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BiztalkExportOrderResult>(null as any);
    }

    /**
     * 外销订单变更导入excel
    1. 上传文件
    2. 判断excel中有几个订单
    3. 将vc列中的字符串全部解析成vc
    4. 判断是否为open vcId
    5. 判断对应的 open vcId 是否符合拼接规则
    6. 判断现有的open vcId 拼接是否跟系统预设的规则一致，如果不一致。则
    6. 拼接vc规则到行备注列
    7. 保存数据
     * @param orderId (optional) 
     * @param excelFile (optional) 
     * @return OK
     */
    inputByOrderChange(orderId?: string | undefined, excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<BiztalkExportOrderResult> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/InputByOrderChange?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInputByOrderChange(_response);
        });
    }

    protected processInputByOrderChange(response: AxiosResponse): Promise<BiztalkExportOrderResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BiztalkExportOrderResult.fromJS(resultData200);
            return Promise.resolve<BiztalkExportOrderResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BiztalkExportOrderResult>(null as any);
    }

    /**
     * vc撤销
     * @param body (optional) 
     * @return OK
     */
    revokeVCConfirmation(body?: RevokeVCConfirmationDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/RevokeVCConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRevokeVCConfirmation(_response);
        });
    }

    protected processRevokeVCConfirmation(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 修改VC
     * @param body (optional) 
     * @return OK
     */
    updateExportOrderProductVCConfirmation(body?: ExportOrderProductVCConfirmationDto[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/UpdateExportOrderProductVCConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateExportOrderProductVCConfirmation(_response);
        });
    }

    protected processUpdateExportOrderProductVCConfirmation(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateOISExportOrder(body?: OISExportOrderDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/UpdateOISExportOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOISExportOrder(_response);
        });
    }

    protected processUpdateOISExportOrder(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 编辑产品信息
     * @param body (optional) 
     * @return OK
     */
    updateOISExportOrderProducts(body?: OISExportOrderProductsDto[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/UpdateOISExportOrderProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOISExportOrderProducts(_response);
        });
    }

    protected processUpdateOISExportOrderProducts(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 订单确认状态
     * @param id (optional) 
     * @param status (optional) 
     * @return OK
     */
    updateOrderConfirMation(id?: string | undefined, status?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/UpdateOrderConfirMation?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrderConfirMation(_response);
        });
    }

    protected processUpdateOrderConfirMation(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 发起订单变更
     * @param exportOrderId (optional) 
     * @return OK
     */
    exportOrderChange(exportOrderId?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/ExportOrderChange?";
        if (exportOrderId === null)
            throw new globalThis.Error("The parameter 'exportOrderId' cannot be null.");
        else if (exportOrderId !== undefined)
            url_ += "exportOrderId=" + encodeURIComponent("" + exportOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportOrderChange(_response);
        });
    }

    protected processExportOrderChange(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取订单变更版本
     * @param orderId (optional) 
     * @return OK
     */
    exportOrderChangeVersions(orderId?: string | undefined, cancelToken?: CancelToken): Promise<ExportSalasOrderDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/ExportOrderChangeVersions?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportOrderChangeVersions(_response);
        });
    }

    protected processExportOrderChangeVersions(response: AxiosResponse): Promise<ExportSalasOrderDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExportSalasOrderDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ExportSalasOrderDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportSalasOrderDto[]>(null as any);
    }

    /**
     * 订单变更确认
     * @param body (optional) 
     * @return OK
     */
    exportOrderChangeConfirm(body?: AddConfirmChangeOrderFromDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/ExportOrderChangeConfirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportOrderChangeConfirm(_response);
        });
    }

    protected processExportOrderChangeConfirm(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 调用接口获取SAP数据
     * @param body (optional) 
     * @return OK
     */
    getSAP(body?: QueryZppMotMpsLifeDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetSAP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSAP(_response);
        });
    }

    protected processGetSAP(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * TODO:需要结合产线进行计算
    产线来源SAP接口
     * @param pmuSoitemCategory (optional) 例子:ZB48
     * @param orderType (optional) 
     * @param productionLine (optional) 
     * @return OK
     */
    getSAPOrderType(pmuSoitemCategory?: string | undefined, orderType?: string | undefined, productionLine?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetSAPOrderType?";
        if (pmuSoitemCategory === null)
            throw new globalThis.Error("The parameter 'pmuSoitemCategory' cannot be null.");
        else if (pmuSoitemCategory !== undefined)
            url_ += "pmuSoitemCategory=" + encodeURIComponent("" + pmuSoitemCategory) + "&";
        if (orderType === null)
            throw new globalThis.Error("The parameter 'orderType' cannot be null.");
        else if (orderType !== undefined)
            url_ += "orderType=" + encodeURIComponent("" + orderType) + "&";
        if (productionLine === null)
            throw new globalThis.Error("The parameter 'productionLine' cannot be null.");
        else if (productionLine !== undefined)
            url_ += "productionLine=" + encodeURIComponent("" + productionLine) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSAPOrderType(_response);
        });
    }

    protected processGetSAPOrderType(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 检查失效VC
     * @param exportOrderId (optional) 
     * @return OK
     */
    checkInvalidVC(exportOrderId?: string | undefined, cancelToken?: CancelToken): Promise<CheckInvalidVCOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/CheckInvalidVC?";
        if (exportOrderId === null)
            throw new globalThis.Error("The parameter 'exportOrderId' cannot be null.");
        else if (exportOrderId !== undefined)
            url_ += "exportOrderId=" + encodeURIComponent("" + exportOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckInvalidVC(_response);
        });
    }

    protected processCheckInvalidVC(response: AxiosResponse): Promise<CheckInvalidVCOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckInvalidVCOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckInvalidVCOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckInvalidVCOutputDto[]>(null as any);
    }

    /**
     * 检查未填备注的OpenVC
     * @param exportOrderId (optional) 
     * @return OK
     */
    checkOpenOrCloseVC(exportOrderId?: string | undefined, cancelToken?: CancelToken): Promise<CheckInvalidVCOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/CheckOpenOrCloseVC?";
        if (exportOrderId === null)
            throw new globalThis.Error("The parameter 'exportOrderId' cannot be null.");
        else if (exportOrderId !== undefined)
            url_ += "exportOrderId=" + encodeURIComponent("" + exportOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckOpenOrCloseVC(_response);
        });
    }

    protected processCheckOpenOrCloseVC(response: AxiosResponse): Promise<CheckInvalidVCOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckInvalidVCOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckInvalidVCOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckInvalidVCOutputDto[]>(null as any);
    }

    /**
     * 订单锁定
     * @param orderId (optional) 
     * @return OK
     */
    lockOrder(orderId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/LockOrder?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLockOrder(_response);
        });
    }

    protected processLockOrder(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出订单用户最后上传附件
     * @param orderId (optional) 
     * @param fileId (optional) 
     * @return OK
     */
    lastConfirmAttachmentsStream(orderId?: string | undefined, fileId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/LastConfirmAttachmentsStream?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (fileId === null)
            throw new globalThis.Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLastConfirmAttachmentsStream(_response);
        });
    }

    protected processLastConfirmAttachmentsStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 审批
     * @param approveId (optional) 
     * @param exportOrderId (optional) 
     * @param approveStatus (optional) 
     * @param comments (optional) 
     * @return OK
     */
    approveExportOrder(approveId?: string | undefined, exportOrderId?: string | undefined, approveStatus?: number | undefined, comments?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/ApproveExportOrder?";
        if (approveId === null)
            throw new globalThis.Error("The parameter 'approveId' cannot be null.");
        else if (approveId !== undefined)
            url_ += "approveId=" + encodeURIComponent("" + approveId) + "&";
        if (exportOrderId === null)
            throw new globalThis.Error("The parameter 'exportOrderId' cannot be null.");
        else if (exportOrderId !== undefined)
            url_ += "exportOrderId=" + encodeURIComponent("" + exportOrderId) + "&";
        if (approveStatus === null)
            throw new globalThis.Error("The parameter 'approveStatus' cannot be null.");
        else if (approveStatus !== undefined)
            url_ += "approveStatus=" + encodeURIComponent("" + approveStatus) + "&";
        if (comments === null)
            throw new globalThis.Error("The parameter 'comments' cannot be null.");
        else if (comments !== undefined)
            url_ += "comments=" + encodeURIComponent("" + comments) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveExportOrder(_response);
        });
    }

    protected processApproveExportOrder(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 查询审核
     * @param orderId (optional) 
     * @return OK
     */
    getExportOrderApproval(orderId?: string | undefined, cancelToken?: CancelToken): Promise<OISExportOrderReviewDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetExportOrderApproval?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExportOrderApproval(_response);
        });
    }

    protected processGetExportOrderApproval(response: AxiosResponse): Promise<OISExportOrderReviewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OISExportOrderReviewDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OISExportOrderReviewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OISExportOrderReviewDto[]>(null as any);
    }

    /**
     * @param exportOrderId (optional) 
     * @return OK
     */
    getUserApprovalByUser(exportOrderId?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetUserApprovalByUser?";
        if (exportOrderId === null)
            throw new globalThis.Error("The parameter 'exportOrderId' cannot be null.");
        else if (exportOrderId !== undefined)
            url_ += "exportOrderId=" + encodeURIComponent("" + exportOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserApprovalByUser(_response);
        });
    }

    protected processGetUserApprovalByUser(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 提交审批
     * @param exportOrderId (optional) 
     * @param message (optional) 
     * @return OK
     */
    submitForApproval(exportOrderId?: string | undefined, message?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/SubmitForApproval?";
        if (exportOrderId === null)
            throw new globalThis.Error("The parameter 'exportOrderId' cannot be null.");
        else if (exportOrderId !== undefined)
            url_ += "exportOrderId=" + encodeURIComponent("" + exportOrderId) + "&";
        if (message === null)
            throw new globalThis.Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitForApproval(_response);
        });
    }

    protected processSubmitForApproval(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 添加
     * @param body (optional) 
     * @return OK
     */
    addOISExportOrderDataPermissions(body?: AddOISExportOrderDataPermissions | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/AddOISExportOrderDataPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOISExportOrderDataPermissions(_response);
        });
    }

    protected processAddOISExportOrderDataPermissions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @param id (optional) 
     * @return OK
     */
    deleteOISExportOrderDataPermissions(id?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/DeleteOISExportOrderDataPermissions?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOISExportOrderDataPermissions(_response);
        });
    }

    protected processDeleteOISExportOrderDataPermissions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 查询
     * @param country (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getOISExportOrderDataPermissions(country?: string | undefined, userId?: string | undefined, cancelToken?: CancelToken): Promise<OISExportOrderDataPermissionsDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetOISExportOrderDataPermissions?";
        if (country === null)
            throw new globalThis.Error("The parameter 'country' cannot be null.");
        else if (country !== undefined)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOISExportOrderDataPermissions(_response);
        });
    }

    protected processGetOISExportOrderDataPermissions(response: AxiosResponse): Promise<OISExportOrderDataPermissionsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OISExportOrderDataPermissionsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OISExportOrderDataPermissionsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OISExportOrderDataPermissionsDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getUsersByExportOrder( cancelToken?: CancelToken): Promise<GetUserIdAndNameByRoleNameOutput[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetUsersByExportOrder";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersByExportOrder(_response);
        });
    }

    protected processGetUsersByExportOrder(response: AxiosResponse): Promise<GetUserIdAndNameByRoleNameOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserIdAndNameByRoleNameOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetUserIdAndNameByRoleNameOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserIdAndNameByRoleNameOutput[]>(null as any);
    }

    /**
     * 获取变更
     * @param versionId (optional) 
     * @return OK
     */
    getOrderChangeProductBasicMotorChanges(versionId?: string | undefined, cancelToken?: CancelToken): Promise<ExportOrderChangeOrderFormProductDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetOrderChangeProductBasicMotorChanges?";
        if (versionId === null)
            throw new globalThis.Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderChangeProductBasicMotorChanges(_response);
        });
    }

    protected processGetOrderChangeProductBasicMotorChanges(response: AxiosResponse): Promise<ExportOrderChangeOrderFormProductDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExportOrderChangeOrderFormProductDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ExportOrderChangeOrderFormProductDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportOrderChangeOrderFormProductDto[]>(null as any);
    }

    /**
     * 根据taskServiceRequest变更订单状态
     * @param body (optional) 
     * @return OK
     */
    updateOrderStatusByTaskRequest(body?: TaskServiceChangeOrderFormDto | undefined, cancelToken?: CancelToken): Promise<ExportOrderChangeOrderFormVersionsDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/UpdateOrderStatusByTaskRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrderStatusByTaskRequest(_response);
        });
    }

    protected processUpdateOrderStatusByTaskRequest(response: AxiosResponse): Promise<ExportOrderChangeOrderFormVersionsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportOrderChangeOrderFormVersionsDto.fromJS(resultData200);
            return Promise.resolve<ExportOrderChangeOrderFormVersionsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportOrderChangeOrderFormVersionsDto>(null as any);
    }

    /**
     * 处理锁定产品
     * @param requestId (optional) 
     * @param body (optional) 
     * @return OK
     */
    executionUpdateChangeOrderMain(requestId?: string | undefined, body?: EnumOrderChangeOrderFormVersionsStatus | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/ExecutionUpdateChangeOrderMain?";
        if (requestId === null)
            throw new globalThis.Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExecutionUpdateChangeOrderMain(_response);
        });
    }

    protected processExecutionUpdateChangeOrderMain(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据任务ID获取外销订单
     * @param taskServiceRequestId (optional) 任务服务请求ID
     * @return OK
     */
    getExportOrderChangeOrderFormByTaskServiceRequestId(taskServiceRequestId?: string | undefined, cancelToken?: CancelToken): Promise<ExportSalasOrderDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetExportOrderChangeOrderFormByTaskServiceRequestId?";
        if (taskServiceRequestId === null)
            throw new globalThis.Error("The parameter 'taskServiceRequestId' cannot be null.");
        else if (taskServiceRequestId !== undefined)
            url_ += "taskServiceRequestId=" + encodeURIComponent("" + taskServiceRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExportOrderChangeOrderFormByTaskServiceRequestId(_response);
        });
    }

    protected processGetExportOrderChangeOrderFormByTaskServiceRequestId(response: AxiosResponse): Promise<ExportSalasOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportSalasOrderDto.fromJS(resultData200);
            return Promise.resolve<ExportSalasOrderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportSalasOrderDto>(null as any);
    }

    /**
     * 根据版本ID获取BOM产品数据
     * @param body (optional) 查询参数
     * @return OK
     */
    getBomProducts(body?: QueryBOMProductDto | undefined, cancelToken?: CancelToken): Promise<BomStatusOfProductDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetBomProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBomProducts(_response);
        });
    }

    protected processGetBomProducts(response: AxiosResponse): Promise<BomStatusOfProductDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BomStatusOfProductDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BomStatusOfProductDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BomStatusOfProductDto[]>(null as any);
    }

    /**
     * @param guids (optional) 
     * @return OK
     */
    getBomProductsById(guids?: string[] | undefined, cancelToken?: CancelToken): Promise<BomStatusOfProductDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetBomProductsById?";
        if (guids === null)
            throw new globalThis.Error("The parameter 'guids' cannot be null.");
        else if (guids !== undefined)
            guids && guids.forEach(item => { url_ += "guids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBomProductsById(_response);
        });
    }

    protected processGetBomProductsById(response: AxiosResponse): Promise<BomStatusOfProductDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BomStatusOfProductDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BomStatusOfProductDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BomStatusOfProductDto[]>(null as any);
    }

    /**
     * 获取子任务信息
     * @param taskId (optional) 
     * @return OK
     */
    getOrderChangeOrderFormTaskLetByMainTaskId(taskId?: string | undefined, cancelToken?: CancelToken): Promise<OrderChangeOrderFormTaskLetDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetOrderChangeOrderFormTaskLetByMainTaskId?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderChangeOrderFormTaskLetByMainTaskId(_response);
        });
    }

    protected processGetOrderChangeOrderFormTaskLetByMainTaskId(response: AxiosResponse): Promise<OrderChangeOrderFormTaskLetDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderChangeOrderFormTaskLetDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderChangeOrderFormTaskLetDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeOrderFormTaskLetDto[]>(null as any);
    }

    /**
     * 添加订单
     * @param body (optional) 
     * @return OK
     */
    addExportOrder(body?: ExportOrderBizTalkDto | undefined, cancelToken?: CancelToken): Promise<BiztalkExportOrderResult> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/AddExportOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddExportOrder(_response);
        });
    }

    protected processAddExportOrder(response: AxiosResponse): Promise<BiztalkExportOrderResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BiztalkExportOrderResult.fromJS(resultData200);
            return Promise.resolve<BiztalkExportOrderResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BiztalkExportOrderResult>(null as any);
    }

    /**
     * 外销，获取订单变更汇总信息
     * @param versionId (optional) 
     * @return OK
     */
    getNewOrderChangeSummaryExport(versionId?: string | undefined, cancelToken?: CancelToken): Promise<ExportNewOrderChangeSummaryOutDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetNewOrderChangeSummaryExport?";
        if (versionId === null)
            throw new globalThis.Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewOrderChangeSummaryExport(_response);
        });
    }

    protected processGetNewOrderChangeSummaryExport(response: AxiosResponse): Promise<ExportNewOrderChangeSummaryOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExportNewOrderChangeSummaryOutDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ExportNewOrderChangeSummaryOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportNewOrderChangeSummaryOutDto[]>(null as any);
    }

    /**
     * 外销订单变更汇总下载
     * @param versionId (optional) 
     * @return OK
     */
    getNewOrderChangeSummaryExportToExcelStream(versionId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetNewOrderChangeSummaryExportToExcelStream?";
        if (versionId === null)
            throw new globalThis.Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewOrderChangeSummaryExportToExcelStream(_response);
        });
    }

    protected processGetNewOrderChangeSummaryExportToExcelStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 订单变更，获取改产品的所有版本
     * @param basicMotorCode (optional) 
     * @param serialNumber (optional) 
     * @param oISExportOrderId (optional) 
     * @return OK
     */
    getOrderChangeOrderFormBasicMotorCodeAllVersionExport(basicMotorCode?: string | undefined, serialNumber?: string | undefined, oISExportOrderId?: string | undefined, cancelToken?: CancelToken): Promise<ExportOrderChangeProductBasicMotorVersionAllDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetOrderChangeOrderFormBasicMotorCodeAllVersionExport?";
        if (basicMotorCode === null)
            throw new globalThis.Error("The parameter 'basicMotorCode' cannot be null.");
        else if (basicMotorCode !== undefined)
            url_ += "basicMotorCode=" + encodeURIComponent("" + basicMotorCode) + "&";
        if (serialNumber === null)
            throw new globalThis.Error("The parameter 'serialNumber' cannot be null.");
        else if (serialNumber !== undefined)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (oISExportOrderId === null)
            throw new globalThis.Error("The parameter 'oISExportOrderId' cannot be null.");
        else if (oISExportOrderId !== undefined)
            url_ += "oISExportOrderId=" + encodeURIComponent("" + oISExportOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderChangeOrderFormBasicMotorCodeAllVersionExport(_response);
        });
    }

    protected processGetOrderChangeOrderFormBasicMotorCodeAllVersionExport(response: AxiosResponse): Promise<ExportOrderChangeProductBasicMotorVersionAllDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExportOrderChangeProductBasicMotorVersionAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ExportOrderChangeProductBasicMotorVersionAllDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportOrderChangeProductBasicMotorVersionAllDto[]>(null as any);
    }

    /**
     * @param versionId (optional) 版本id
     * @param versionsList (optional) 版本列表
     * @param motorChangesList (optional) 
     * @param productsByOrderId (optional) 
     * @param serialNumber (optional) 行号
     * @return OK
     */
    getNewOrderChangeSummaryOutList(versionId?: string | undefined, versionsList?: OISExportOrderChangeOrderFormVersions[] | undefined, motorChangesList?: OISExportOrderChangeProductBasicMotorChange[] | undefined, productsByOrderId?: { [key: string]: OISExportOrderProducts[]; } | undefined, serialNumber?: string | undefined, cancelToken?: CancelToken): Promise<NewOrderChangeSummaryOutDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/GetNewOrderChangeSummaryOutList?";
        if (versionId === null)
            throw new globalThis.Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        if (versionsList === null)
            throw new globalThis.Error("The parameter 'versionsList' cannot be null.");
        else if (versionsList !== undefined)
            versionsList && versionsList.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "versionsList[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (motorChangesList === null)
            throw new globalThis.Error("The parameter 'motorChangesList' cannot be null.");
        else if (motorChangesList !== undefined)
            motorChangesList && motorChangesList.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "motorChangesList[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (productsByOrderId === null)
            throw new globalThis.Error("The parameter 'productsByOrderId' cannot be null.");
        else if (productsByOrderId !== undefined)
            url_ += "productsByOrderId=" + encodeURIComponent("" + productsByOrderId) + "&";
        if (serialNumber === null)
            throw new globalThis.Error("The parameter 'serialNumber' cannot be null.");
        else if (serialNumber !== undefined)
            url_ += "SerialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewOrderChangeSummaryOutList(_response);
        });
    }

    protected processGetNewOrderChangeSummaryOutList(response: AxiosResponse): Promise<NewOrderChangeSummaryOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NewOrderChangeSummaryOutDto.fromJS(resultData200);
            return Promise.resolve<NewOrderChangeSummaryOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewOrderChangeSummaryOutDto>(null as any);
    }

    /**
     * 删除外销订单变更表单
     * @param body (optional) 
     * @return OK
     */
    deleteExportOrderChange(body?: OISExportOrderDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/DeleteExportOrderChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteExportOrderChange(_response);
        });
    }

    protected processDeleteExportOrderChange(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 撤销外销订单变更表单
     * @param body (optional) 
     * @return OK
     */
    revokeExportOrderChange(body?: OISExportOrderDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExcelInputService/RevokeExportOrderChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRevokeExportOrderChange(_response);
        });
    }

    protected processRevokeExportOrderChange(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class ExportOrderApprovalServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取当前用户的审批记录
     * @param body (optional) 
     * @return OK
     */
    getApprovalAll(body?: PageExportOrderApprovalAllSearchDto | undefined, cancelToken?: CancelToken): Promise<ExportSalasOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExportOrderApproval/GetApprovalAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApprovalAll(_response);
        });
    }

    protected processGetApprovalAll(response: AxiosResponse): Promise<ExportSalasOrderDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportSalasOrderDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ExportSalasOrderDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportSalasOrderDtoPagedResultDto>(null as any);
    }

    /**
     * 提交审批
     * @param body (optional) 
     * @return OK
     */
    submitApproval(body?: ExportOrderReviewApprovalDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExportOrderApproval/SubmitApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitApproval(_response);
        });
    }

    protected processSubmitApproval(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 下单审批通过/不通过
     * @param body (optional) 
     * @return OK
     */
    editApproval(body?: ExportOrderReviewApprovalDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExportOrderApproval/EditApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditApproval(_response);
        });
    }

    protected processEditApproval(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    testSalesOrderNoUpdate( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExportOrderApproval/TestSalesOrderNoUpdate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestSalesOrderNoUpdate(_response);
        });
    }

    protected processTestSalesOrderNoUpdate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 调用接口获取SAP数据
     * @param body (optional) 
     * @return OK
     */
    getSAP(body?: QueryZppMotMpsLifeDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExportOrderApproval/GetSAP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSAP(_response);
        });
    }

    protected processGetSAP(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ExportOrderApprovalProcessNodeConfigurationServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 查询所有外销订单审批流程节点配置维护信息
     * @param body (optional) 
     * @return OK
     */
    getAll(body?: PageExportOrderApprovalProcessNodeConfigurationSearchInputDto | undefined, cancelToken?: CancelToken): Promise<ExportOrderApprovalProcessNodeConfigurationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExportOrderApprovalProcessNodeConfiguration/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ExportOrderApprovalProcessNodeConfigurationDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportOrderApprovalProcessNodeConfigurationDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ExportOrderApprovalProcessNodeConfigurationDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportOrderApprovalProcessNodeConfigurationDtoPagedResultDto>(null as any);
    }

    /**
     * 删除
     * @param body (optional) 
     * @return OK
     */
    delete(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExportOrderApprovalProcessNodeConfiguration/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入外销订单审批流程节点配置维护信息
     * @param excelFile (optional) 导入文件
     * @return OK
     */
    import(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExportOrderApprovalProcessNodeConfiguration/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出外销订单审批流程节点配置维护信息
     * @param body (optional) 
     * @return OK
     */
    exportStream(body?: PageExportOrderApprovalProcessNodeConfigurationSearchInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExportOrderApprovalProcessNodeConfiguration/ExportStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportStream(_response);
        });
    }

    protected processExportStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ExportOrderOpenVcServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取外销订单OpenVC
     * @return OK
     */
    all( cancelToken?: CancelToken): Promise<ExportOrderOpenVcDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExportOrderOpenVc/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: AxiosResponse): Promise<ExportOrderOpenVcDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExportOrderOpenVcDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ExportOrderOpenVcDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportOrderOpenVcDto[]>(null as any);
    }

    /**
     * 分页获取外销订单OpenVC
     * @param body (optional) 
     * @return OK
     */
    paged(body?: PagedExportOrderOpenVcRequestDto | undefined, cancelToken?: CancelToken): Promise<ExportOrderOpenVcDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExportOrderOpenVc/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaged(_response);
        });
    }

    protected processPaged(response: AxiosResponse): Promise<ExportOrderOpenVcDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportOrderOpenVcDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ExportOrderOpenVcDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportOrderOpenVcDtoPagedResultDto>(null as any);
    }

    /**
     * 创建外销订单OpenVC
     * @param body (optional) 
     * @return OK
     */
    insert(body?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExportOrderOpenVc/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新外销订单OpenVC
     * @param vcId (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(vcId?: string | undefined, body?: ExportOrderOpenVcDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExportOrderOpenVc/Update?";
        if (vcId === null)
            throw new globalThis.Error("The parameter 'vcId' cannot be null.");
        else if (vcId !== undefined)
            url_ += "vcId=" + encodeURIComponent("" + vcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除外销订单OpenVC
     * @param catehoryId (optional) 
     * @return OK
     */
    delete(catehoryId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ExportOrderOpenVc/Delete?";
        if (catehoryId === null)
            throw new globalThis.Error("The parameter 'catehoryId' cannot be null.");
        else if (catehoryId !== undefined)
            url_ += "catehoryId=" + encodeURIComponent("" + catehoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class FeeOrderServiceServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param cartId (optional) 
     * @return OK
     */
    createOrderFromFeeCart(cartId?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/FeeOrderService/CreateOrderFromFeeCart?";
        if (cartId === null)
            throw new globalThis.Error("The parameter 'cartId' cannot be null.");
        else if (cartId !== undefined)
            url_ += "cartId=" + encodeURIComponent("" + cartId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrderFromFeeCart(_response);
        });
    }

    protected processCreateOrderFromFeeCart(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    enrichCartItemPricing(body?: MotorCertFeeCartItem | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/FeeOrderService/EnrichCartItemPricing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnrichCartItemPricing(_response);
        });
    }

    protected processEnrichCartItemPricing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class FinalCustomerServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 根据客户编码，查询最终客户下拉列表
     * @return OK
     */
    getCustomerByCusNoList( cancelToken?: CancelToken): Promise<OrderFormFinalCustomerListBoxDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/FinalCustomer/GetCustomerByCusNoList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerByCusNoList(_response);
        });
    }

    protected processGetCustomerByCusNoList(response: AxiosResponse): Promise<OrderFormFinalCustomerListBoxDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderFormFinalCustomerListBoxDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderFormFinalCustomerListBoxDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderFormFinalCustomerListBoxDto[]>(null as any);
    }

    /**
     * 查询最终客户列表
     * @return OK
     */
    getCustomerList( cancelToken?: CancelToken): Promise<OrderFormFinalCustomerListBoxDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/FinalCustomer/GetCustomerList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerList(_response);
        });
    }

    protected processGetCustomerList(response: AxiosResponse): Promise<OrderFormFinalCustomerListBoxDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderFormFinalCustomerListBoxDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderFormFinalCustomerListBoxDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderFormFinalCustomerListBoxDto[]>(null as any);
    }

    /**
     * 查询最终客户列表
     * @param keyword (optional) 
     * @param exportType (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getCustomerListByPage(keyword?: string | undefined, exportType?: number | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<OrderFormFinalCustomerDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/FinalCustomer/GetCustomerListByPage?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (exportType === null)
            throw new globalThis.Error("The parameter 'exportType' cannot be null.");
        else if (exportType !== undefined)
            url_ += "ExportType=" + encodeURIComponent("" + exportType) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerListByPage(_response);
        });
    }

    protected processGetCustomerListByPage(response: AxiosResponse): Promise<OrderFormFinalCustomerDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderFormFinalCustomerDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<OrderFormFinalCustomerDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderFormFinalCustomerDtoPagedResultDto>(null as any);
    }

    /**
     * 查询数据
     * @param id (optional) 
     * @return OK
     */
    get(id?: string | undefined, cancelToken?: CancelToken): Promise<OrderFormFinalCustomerDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/FinalCustomer/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<OrderFormFinalCustomerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderFormFinalCustomerDto.fromJS(resultData200);
            return Promise.resolve<OrderFormFinalCustomerDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderFormFinalCustomerDto>(null as any);
    }

    /**
     * 删除
     * @param body (optional) 
     * @return OK
     */
    delete(body?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/FinalCustomer/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新增/编辑
     * @param body (optional) 
     * @return OK
     */
    addOrUpdate(body?: OrderFormFinalCustomerDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/FinalCustomer/AddOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrUpdate(_response);
        });
    }

    protected processAddOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * MDM消息队列,创建或修改客户
     * @param strMdmInput (optional) 
     * @return OK
     */
    addOrUpdateAsyncByMDM(strMdmInput?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/FinalCustomer/AddOrUpdateAsyncByMDM?";
        if (strMdmInput === null)
            throw new globalThis.Error("The parameter 'strMdmInput' cannot be null.");
        else if (strMdmInput !== undefined)
            url_ += "strMdmInput=" + encodeURIComponent("" + strMdmInput) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrUpdateAsyncByMDM(_response);
        });
    }

    protected processAddOrUpdateAsyncByMDM(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入二级客户信息
     * @param excelFile (optional) 
     * @return OK
     */
    importFinalCustomers(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/FinalCustomer/ImportFinalCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportFinalCustomers(_response);
        });
    }

    protected processImportFinalCustomers(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导出二级客户上传导入模板
     * @return OK
     */
    excelFinalCustomerTemplate( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/FinalCustomer/ExcelFinalCustomerTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExcelFinalCustomerTemplate(_response);
        });
    }

    protected processExcelFinalCustomerTemplate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 验证销售与直接客户是否关联
     * @param finalCUstomerCode (optional) 
     * @param saleId (optional) 
     * @return OK
     */
    verifyAssociationsBySale(finalCUstomerCode?: string | undefined, saleId?: number | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/FinalCustomer/VerifyAssociationsBySale?";
        if (finalCUstomerCode === null)
            throw new globalThis.Error("The parameter 'finalCUstomerCode' cannot be null.");
        else if (finalCUstomerCode !== undefined)
            url_ += "finalCUstomerCode=" + encodeURIComponent("" + finalCUstomerCode) + "&";
        if (saleId === null)
            throw new globalThis.Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyAssociationsBySale(_response);
        });
    }

    protected processVerifyAssociationsBySale(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 导出二级客户信息-Job导出
     * @param body (optional) 
     * @return OK
     */
    excelFinalCustomer(body?: PagedCustomerResultRequestDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/FinalCustomer/ExcelFinalCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExcelFinalCustomer(_response);
        });
    }

    protected processExcelFinalCustomer(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 导出二级客户信息-导出
     * @param body (optional) 
     * @return OK
     */
    excelFinalCustomerForJob(body?: PagedCustomerResultRequestDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/FinalCustomer/ExcelFinalCustomerForJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExcelFinalCustomerForJob(_response);
        });
    }

    protected processExcelFinalCustomerForJob(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 刷新客户信息/销售信息
     * @return OK
     */
    updateCustomerOrSale( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/FinalCustomer/UpdateCustomerOrSale";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCustomerOrSale(_response);
        });
    }

    protected processUpdateCustomerOrSale(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取所有的直接客户
     * @param saleId (optional) 销售Id(针对CP选择销售后限定直接客户范围)
     * @return OK
     */
    getAllOrderFormFinalCustomer(saleId?: number | undefined, cancelToken?: CancelToken): Promise<GetAllFinalCustomerListOutput[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/FinalCustomer/GetAllOrderFormFinalCustomer?";
        if (saleId === null)
            throw new globalThis.Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllOrderFormFinalCustomer(_response);
        });
    }

    protected processGetAllOrderFormFinalCustomer(response: AxiosResponse): Promise<GetAllFinalCustomerListOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllFinalCustomerListOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetAllFinalCustomerListOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllFinalCustomerListOutput[]>(null as any);
    }

    /**
     * 获取及联 销售信息
     * @param finalCustomerId (optional) 直接客户Id(针对CP选择直接客户后限定销售可选范围)
     * @param saleAreaCode (optional) 销售区域(针对CP选择销售区域后限定销售可选范围)
     * @return OK
     */
    getSaleInfosForLinkage(finalCustomerId?: string | undefined, saleAreaCode?: string | undefined, cancelToken?: CancelToken): Promise<GetSalesListOutput[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/FinalCustomer/GetSaleInfosForLinkage?";
        if (finalCustomerId === null)
            throw new globalThis.Error("The parameter 'finalCustomerId' cannot be null.");
        else if (finalCustomerId !== undefined)
            url_ += "finalCustomerId=" + encodeURIComponent("" + finalCustomerId) + "&";
        if (saleAreaCode === null)
            throw new globalThis.Error("The parameter 'saleAreaCode' cannot be null.");
        else if (saleAreaCode !== undefined)
            url_ += "saleAreaCode=" + encodeURIComponent("" + saleAreaCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSaleInfosForLinkage(_response);
        });
    }

    protected processGetSaleInfosForLinkage(response: AxiosResponse): Promise<GetSalesListOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetSalesListOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetSalesListOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSalesListOutput[]>(null as any);
    }

    /**
     * 获取及联 行业信息
     * @param finalCustomerCode (optional) 直接客户编码
     * @return OK
     */
    getIndustryInfosForFinalCustomer(finalCustomerCode?: string | undefined, cancelToken?: CancelToken): Promise<GetIndustryInfosForFinalCustomer[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/FinalCustomer/GetIndustryInfosForFinalCustomer?";
        if (finalCustomerCode === null)
            throw new globalThis.Error("The parameter 'finalCustomerCode' cannot be null.");
        else if (finalCustomerCode !== undefined)
            url_ += "finalCustomerCode=" + encodeURIComponent("" + finalCustomerCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIndustryInfosForFinalCustomer(_response);
        });
    }

    protected processGetIndustryInfosForFinalCustomer(response: AxiosResponse): Promise<GetIndustryInfosForFinalCustomer[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetIndustryInfosForFinalCustomer.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetIndustryInfosForFinalCustomer[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIndustryInfosForFinalCustomer[]>(null as any);
    }
}

export class GradeBasicMotorServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 查询所有分类产品
     * @param body (optional) 
     * @return OK
     */
    getAll(body?: PageGradeBasicMotorSearchInputDto | undefined, cancelToken?: CancelToken): Promise<PageGradeBasicMotorSearchOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/GradeBasicMotor/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<PageGradeBasicMotorSearchOutputDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageGradeBasicMotorSearchOutputDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<PageGradeBasicMotorSearchOutputDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageGradeBasicMotorSearchOutputDtoPagedResultDto>(null as any);
    }

    /**
     * 删除
     * @param body (optional) 
     * @return OK
     */
    delete(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/GradeBasicMotor/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @return OK
     */
    deleteAll( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/GradeBasicMotor/DeleteAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入分类产品
     * @param excelFile (optional) 导入文件
     * @return OK
     */
    import(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/GradeBasicMotor/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出分类产品
     * @param body (optional) 
     * @return OK
     */
    export(body?: PageGradeBasicMotorSearchInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/GradeBasicMotor/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class GradeCustomerServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 查询所有分类产品
     * @param body (optional) 
     * @return OK
     */
    getAll(body?: PageGradeCustomerSearchInputDto | undefined, cancelToken?: CancelToken): Promise<PageGradeCustomerSearchOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/GradeCustomer/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<PageGradeCustomerSearchOutputDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageGradeCustomerSearchOutputDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<PageGradeCustomerSearchOutputDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageGradeCustomerSearchOutputDtoPagedResultDto>(null as any);
    }

    /**
     * 删除
     * @param body (optional) 
     * @return OK
     */
    delete(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/GradeCustomer/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入分类产品
     * @param excelFile (optional) 导入文件
     * @return OK
     */
    import(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/GradeCustomer/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出分类产品
     * @param body (optional) 
     * @return OK
     */
    export(body?: PageGradeCustomerSearchInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/GradeCustomer/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class GradeLevelVcServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 查询所有分类产品
     * @param body (optional) 
     * @return OK
     */
    getAll(body?: PageGradeLevelVcSearchInputDto | undefined, cancelToken?: CancelToken): Promise<PageGradeLevelVcSearchOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/GradeLevelVc/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<PageGradeLevelVcSearchOutputDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageGradeLevelVcSearchOutputDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<PageGradeLevelVcSearchOutputDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageGradeLevelVcSearchOutputDtoPagedResultDto>(null as any);
    }

    /**
     * 删除
     * @param body (optional) 
     * @return OK
     */
    delete(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/GradeLevelVc/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @return OK
     */
    deleteAll( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/GradeLevelVc/DeleteAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入分类产品
     * @param excelFile (optional) 导入文件
     * @return OK
     */
    import(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/GradeLevelVc/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出分类产品
     * @param body (optional) 
     * @return OK
     */
    export(body?: PageGradeLevelVcSearchInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/GradeLevelVc/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class GradeVcServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 查询所有分类产品
     * @param body (optional) 
     * @return OK
     */
    getAll(body?: PageGradeVcSearchInputDto | undefined, cancelToken?: CancelToken): Promise<PageGradeVcSearchOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/GradeVc/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<PageGradeVcSearchOutputDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageGradeVcSearchOutputDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<PageGradeVcSearchOutputDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageGradeVcSearchOutputDtoPagedResultDto>(null as any);
    }

    /**
     * 删除
     * @param body (optional) 
     * @return OK
     */
    delete(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/GradeVc/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @return OK
     */
    deleteAll( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/GradeVc/DeleteAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入分类产品Vc
     * @param excelFile (optional) 导入文件
     * @return OK
     */
    import(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/GradeVc/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出分类产品
     * @param body (optional) 
     * @return OK
     */
    export(body?: PageGradeVcSearchInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/GradeVc/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class IndustryMaintenanceServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 查询所有行业及简称
     * @param body (optional) 
     * @return OK
     */
    getAll(body?: PageIndustrySearchRequestDto | undefined, cancelToken?: CancelToken): Promise<PageIndustrySearchResultDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/IndustryMaintenance/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<PageIndustrySearchResultDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageIndustrySearchResultDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<PageIndustrySearchResultDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageIndustrySearchResultDtoPagedResultDto>(null as any);
    }

    /**
     * 编辑行业简称
     * @param id (optional) 主键
     * @param jINIndustryCode (optional) 境界行业简称
     * @return OK
     */
    update(id?: string | undefined, jINIndustryCode?: string | undefined, cancelToken?: CancelToken): Promise<PageIndustrySearchResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/IndustryMaintenance/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (jINIndustryCode === null || jINIndustryCode === undefined)
            throw new globalThis.Error("The parameter 'jINIndustryCode' cannot be null.");
        else
            content_.append("JINIndustryCode", jINIndustryCode.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<PageIndustrySearchResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageIndustrySearchResultDto.fromJS(resultData200);
            return Promise.resolve<PageIndustrySearchResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageIndustrySearchResultDto>(null as any);
    }
}

export class InitOrderFormServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 重置订单中产品系列为空的系列信息
     * @return OK
     */
    resetOrderProductSries( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/InitOrderForm/ResetOrderProductSries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetOrderProductSries(_response);
        });
    }

    protected processResetOrderProductSries(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class JINCodeServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * A/B代码关系查询
     * @param poNumber (optional) 合同号
     * @param modelSelectionId (optional) 选型号
     * @return OK
     */
    getJINOrderForm(poNumber?: string | undefined, modelSelectionId?: string | undefined, cancelToken?: CancelToken): Promise<JINOrderFormOutDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/JINCode/GetJINOrderForm?";
        if (poNumber === null)
            throw new globalThis.Error("The parameter 'poNumber' cannot be null.");
        else if (poNumber !== undefined)
            url_ += "PoNumber=" + encodeURIComponent("" + poNumber) + "&";
        if (modelSelectionId === null)
            throw new globalThis.Error("The parameter 'modelSelectionId' cannot be null.");
        else if (modelSelectionId !== undefined)
            url_ += "ModelSelectionId=" + encodeURIComponent("" + modelSelectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJINOrderForm(_response);
        });
    }

    protected processGetJINOrderForm(response: AxiosResponse): Promise<JINOrderFormOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JINOrderFormOutDto.fromJS(resultData200);
            return Promise.resolve<JINOrderFormOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JINOrderFormOutDto>(null as any);
    }

    /**
     * 获取JINCode完整信息
    包含VC和交期数据
     * @param code (optional) 
     * @param version (optional) 
     * @param clientId (optional) 
     * @return OK
     */
    getVersion(code?: string | undefined, version?: string | undefined, clientId?: string | undefined, cancelToken?: CancelToken): Promise<JINCodeDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/JINCode/GetVersion?";
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (version === null)
            throw new globalThis.Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVersion(_response);
        });
    }

    protected processGetVersion(response: AxiosResponse): Promise<JINCodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JINCodeDto.fromJS(resultData200);
            return Promise.resolve<JINCodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JINCodeDto>(null as any);
    }

    /**
     * 批量获取JINCode完整信息
    包含VC和交期数据
     * @param clientId (optional) 
     * @param body (optional) 
     * @return OK
     */
    getCodes(clientId?: string | undefined, body?: PageListJINCodeDto[] | undefined, cancelToken?: CancelToken): Promise<JINCodeDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/JINCode/GetCodes?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCodes(_response);
        });
    }

    protected processGetCodes(response: AxiosResponse): Promise<JINCodeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JINCodeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JINCodeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JINCodeDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCodesForCycle(body?: PageListJINCodeDto[] | undefined, cancelToken?: CancelToken): Promise<JINCodeForCycleDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/JINCode/GetCodesForCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCodesForCycle(_response);
        });
    }

    protected processGetCodesForCycle(response: AxiosResponse): Promise<JINCodeForCycleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JINCodeForCycleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JINCodeForCycleDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JINCodeForCycleDto[]>(null as any);
    }

    /**
     * 判断当前用户是否有当前境界代码的授权
     * @param body (optional) 境界代码
     * @return OK
     */
    isHasUserAuthorizedMotorCodeRight(body?: string[] | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/JINCode/IsHasUserAuthorizedMotorCodeRight";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsHasUserAuthorizedMotorCodeRight(_response);
        });
    }

    protected processIsHasUserAuthorizedMotorCodeRight(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 获取A代码所有版本
     * @param code (optional) 
     * @return OK
     */
    getCodeVersions(code?: string | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/JINCode/GetCodeVersions?";
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCodeVersions(_response);
        });
    }

    protected processGetCodeVersions(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param codes (optional) 
     * @return OK
     */
    getCodesVersions(codes?: string[] | undefined, cancelToken?: CancelToken): Promise<{ [key: string]: string[]; }> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/JINCode/GetCodesVersions?";
        if (codes === null)
            throw new globalThis.Error("The parameter 'codes' cannot be null.");
        else if (codes !== undefined)
            codes && codes.forEach(item => { url_ += "codes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCodesVersions(_response);
        });
    }

    protected processGetCodesVersions(response: AxiosResponse): Promise<{ [key: string]: string[]; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : [];
                }
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<{ [key: string]: string[]; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string[]; }>(null as any);
    }

    /**
     * 获取境界版本及对应的内含VC版本
     * @param body (optional) 
     * @return OK
     */
    getCodesVersionAndVcs(body?: GetCodesVersionAndVcsInputDto[] | undefined, cancelToken?: CancelToken): Promise<GetCodesVersionAndVcsOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/JINCode/GetCodesVersionAndVcs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCodesVersionAndVcs(_response);
        });
    }

    protected processGetCodesVersionAndVcs(response: AxiosResponse): Promise<GetCodesVersionAndVcsOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCodesVersionAndVcsOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetCodesVersionAndVcsOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCodesVersionAndVcsOutputDto[]>(null as any);
    }

    /**
     * 获取相同映射B代码的项目型境界主机
     * @param jINMotorCode (optional) 境界代码
     * @param jINVersion (optional) 境界版本号
     * @param jINCategoryCode (optional) 境界标识符
     * @param clienter (optional) 一级客户代码
     * @param finalCustomerCode (optional) 二级客户代码
     * @return OK
     */
    getSameBasicCodeJINCodes(jINMotorCode?: string | undefined, jINVersion?: string | undefined, jINCategoryCode?: string | undefined, clienter?: string | undefined, finalCustomerCode?: string | undefined, cancelToken?: CancelToken): Promise<GetSameBasicCodeJINCodesOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/JINCode/GetSameBasicCodeJINCodes?";
        if (jINMotorCode === null)
            throw new globalThis.Error("The parameter 'jINMotorCode' cannot be null.");
        else if (jINMotorCode !== undefined)
            url_ += "JINMotorCode=" + encodeURIComponent("" + jINMotorCode) + "&";
        if (jINVersion === null)
            throw new globalThis.Error("The parameter 'jINVersion' cannot be null.");
        else if (jINVersion !== undefined)
            url_ += "JINVersion=" + encodeURIComponent("" + jINVersion) + "&";
        if (jINCategoryCode === null)
            throw new globalThis.Error("The parameter 'jINCategoryCode' cannot be null.");
        else if (jINCategoryCode !== undefined)
            url_ += "JINCategoryCode=" + encodeURIComponent("" + jINCategoryCode) + "&";
        if (clienter === null)
            throw new globalThis.Error("The parameter 'clienter' cannot be null.");
        else if (clienter !== undefined)
            url_ += "Clienter=" + encodeURIComponent("" + clienter) + "&";
        if (finalCustomerCode === null)
            throw new globalThis.Error("The parameter 'finalCustomerCode' cannot be null.");
        else if (finalCustomerCode !== undefined)
            url_ += "FinalCustomerCode=" + encodeURIComponent("" + finalCustomerCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSameBasicCodeJINCodes(_response);
        });
    }

    protected processGetSameBasicCodeJINCodes(response: AxiosResponse): Promise<GetSameBasicCodeJINCodesOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetSameBasicCodeJINCodesOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetSameBasicCodeJINCodesOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSameBasicCodeJINCodesOutputDto[]>(null as any);
    }

    /**
     * @param request (optional) 
     * @return OK
     */
    getMapBasicMotorCode(request?: PageListJINCodeDto[] | undefined, cancelToken?: CancelToken): Promise<JINMapBasicMotorCodeDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/JINCode/GetMapBasicMotorCode?";
        if (request === null)
            throw new globalThis.Error("The parameter 'request' cannot be null.");
        else if (request !== undefined)
            request && request.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "request[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMapBasicMotorCode(_response);
        });
    }

    protected processGetMapBasicMotorCode(response: AxiosResponse): Promise<JINMapBasicMotorCodeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JINMapBasicMotorCodeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JINMapBasicMotorCodeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JINMapBasicMotorCodeDto[]>(null as any);
    }
}

export class JINMotorInsideVcRemarkServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateJINInsideVcRemark(body?: UpdateJINInsideVcRemarkInputDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/JINMotorInsideVcRemark/UpdateJINInsideVcRemark";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateJINInsideVcRemark(_response);
        });
    }

    protected processUpdateJINInsideVcRemark(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    batchUpdateJINInsideVcRemark(body?: UpdateJINInsideVcRemarkInputDto[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/JINMotorInsideVcRemark/BatchUpdateJINInsideVcRemark";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchUpdateJINInsideVcRemark(_response);
        });
    }

    protected processBatchUpdateJINInsideVcRemark(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 通过订单及其关联的类型
     * @param orderId (optional) 
     * @param insideVcRelType (optional) 0 = Default

    1 = Order

    2 = Change

    3 = Export

    4 = ChangeMain
     * @return OK
     */
    getJINInsideVcRemarkByOrderId(orderId?: string | undefined, insideVcRelType?: InsideVcRelType | undefined, cancelToken?: CancelToken): Promise<JINInsideVcRemarkDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/JINMotorInsideVcRemark/GetJINInsideVcRemarkByOrderId?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "OrderId=" + encodeURIComponent("" + orderId) + "&";
        if (insideVcRelType === null)
            throw new globalThis.Error("The parameter 'insideVcRelType' cannot be null.");
        else if (insideVcRelType !== undefined)
            url_ += "InsideVcRelType=" + encodeURIComponent("" + insideVcRelType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJINInsideVcRemarkByOrderId(_response);
        });
    }

    protected processGetJINInsideVcRemarkByOrderId(response: AxiosResponse): Promise<JINInsideVcRemarkDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JINInsideVcRemarkDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JINInsideVcRemarkDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JINInsideVcRemarkDto[]>(null as any);
    }

    /**
     * 通过订单中产品及其关联的类型(废弃)
     * @param productMotorId (optional) 
     * @param insideVcRelType (optional) 0 = Default

    1 = Order

    2 = Change

    3 = Export

    4 = ChangeMain
     * @return OK
     */
    getJINInsideVcRemarkByProductMotorId(productMotorId?: string | undefined, insideVcRelType?: InsideVcRelType | undefined, cancelToken?: CancelToken): Promise<JINInsideVcRemarkDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/JINMotorInsideVcRemark/GetJINInsideVcRemarkByProductMotorId?";
        if (productMotorId === null)
            throw new globalThis.Error("The parameter 'productMotorId' cannot be null.");
        else if (productMotorId !== undefined)
            url_ += "ProductMotorId=" + encodeURIComponent("" + productMotorId) + "&";
        if (insideVcRelType === null)
            throw new globalThis.Error("The parameter 'insideVcRelType' cannot be null.");
        else if (insideVcRelType !== undefined)
            url_ += "InsideVcRelType=" + encodeURIComponent("" + insideVcRelType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJINInsideVcRemarkByProductMotorId(_response);
        });
    }

    protected processGetJINInsideVcRemarkByProductMotorId(response: AxiosResponse): Promise<JINInsideVcRemarkDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JINInsideVcRemarkDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JINInsideVcRemarkDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JINInsideVcRemarkDto[]>(null as any);
    }

    /**
     * 通过订单中产品及其关联的类型
     * @param serialNumber (optional) 序号
     * @param orderId (optional) 
     * @param jINMotorCode (optional) 
     * @param insideVcRelType (optional) 0 = Default

    1 = Order

    2 = Change

    3 = Export

    4 = ChangeMain
     * @return OK
     */
    getJINInsideVcRemarkBySerialNumberMotorId(serialNumber?: number | undefined, orderId?: string | undefined, jINMotorCode?: string | undefined, insideVcRelType?: InsideVcRelType | undefined, cancelToken?: CancelToken): Promise<JINInsideVcRemarkDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/JINMotorInsideVcRemark/GetJINInsideVcRemarkBySerialNumberMotorId?";
        if (serialNumber === null)
            throw new globalThis.Error("The parameter 'serialNumber' cannot be null.");
        else if (serialNumber !== undefined)
            url_ += "SerialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "OrderId=" + encodeURIComponent("" + orderId) + "&";
        if (jINMotorCode === null)
            throw new globalThis.Error("The parameter 'jINMotorCode' cannot be null.");
        else if (jINMotorCode !== undefined)
            url_ += "JINMotorCode=" + encodeURIComponent("" + jINMotorCode) + "&";
        if (insideVcRelType === null)
            throw new globalThis.Error("The parameter 'insideVcRelType' cannot be null.");
        else if (insideVcRelType !== undefined)
            url_ += "InsideVcRelType=" + encodeURIComponent("" + insideVcRelType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJINInsideVcRemarkBySerialNumberMotorId(_response);
        });
    }

    protected processGetJINInsideVcRemarkBySerialNumberMotorId(response: AxiosResponse): Promise<JINInsideVcRemarkDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JINInsideVcRemarkDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JINInsideVcRemarkDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JINInsideVcRemarkDto[]>(null as any);
    }
}

export class JobHistoryServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 后台任务记录查询
     * @param body (optional) 
     * @return OK
     */
    pageSearchJobHistories(body?: PageSearchJobHistoriesInputDto | undefined, cancelToken?: CancelToken): Promise<PageSearchJobHistoriesOutputDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/JobHistory/PageSearchJobHistories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPageSearchJobHistories(_response);
        });
    }

    protected processPageSearchJobHistories(response: AxiosResponse): Promise<PageSearchJobHistoriesOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageSearchJobHistoriesOutputDto.fromJS(resultData200);
            return Promise.resolve<PageSearchJobHistoriesOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageSearchJobHistoriesOutputDto>(null as any);
    }

    /**
     * 任务记录创建
     * @param body (optional) 
     * @return OK
     */
    createJob(body?: CreateJobInputDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/JobHistory/CreateJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateJob(_response);
        });
    }

    protected processCreateJob(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 任务重试
     * @param id (optional) 任务Id
     * @return OK
     */
    taskRetry(id?: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/JobHistory/TaskRetry?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTaskRetry(_response);
        });
    }

    protected processTaskRetry(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class MotorCertServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 一级列表：已填条件全部 AND（SN→SO→合同收窄后求交，再 AND 交期）。
    仅交期限 31 天；叠加 SN/SO/合同时交期不限 31 天。
     * @param body (optional) 
     * @return OK
     */
    query(body?: MotorCertQueryInputDto | undefined, cancelToken?: CancelToken): Promise<MotorCertQueryResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCert/Query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<MotorCertQueryResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MotorCertQueryResultDto.fromJS(resultData200);
            return Promise.resolve<MotorCertQueryResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MotorCertQueryResultDto>(null as any);
    }

    /**
     * 展开订单：OI 行 + 证书统计；不预拉 SN（点「选择」走 GetSnList）。
    台数分母=LsuOrderQty；已同步 SN=SapSnCreate；证书分子=Mapping 可下载数。
     * @param orderFormId (optional) 
     * @param querySalesOrder (optional) 无 OrderForm（OI 无 LsuContractNumber）时按此 SO（ISO/CSO）拉二级行。
     * @param serialNumbers (optional) 已废弃：L2 不再按 SN 收窄；保留字段兼容旧前端入参。
     * @return OK
     */
    getOrderLines(orderFormId?: string | undefined, querySalesOrder?: string | undefined, serialNumbers?: string | undefined, cancelToken?: CancelToken): Promise<MotorCertOrderRowDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCert/GetOrderLines?";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "OrderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        if (querySalesOrder === null)
            throw new globalThis.Error("The parameter 'querySalesOrder' cannot be null.");
        else if (querySalesOrder !== undefined)
            url_ += "QuerySalesOrder=" + encodeURIComponent("" + querySalesOrder) + "&";
        if (serialNumbers === null)
            throw new globalThis.Error("The parameter 'serialNumbers' cannot be null.");
        else if (serialNumbers !== undefined)
            url_ += "SerialNumbers=" + encodeURIComponent("" + serialNumbers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderLines(_response);
        });
    }

    protected processGetOrderLines(response: AxiosResponse): Promise<MotorCertOrderRowDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MotorCertOrderRowDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MotorCertOrderRowDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MotorCertOrderRowDto[]>(null as any);
    }

    /**
     * @param saleNumber (optional) 
     * @param saleRowNo (optional) 
     * @param pmuSalesOrder (optional) 可选：ISO（Pmu），优先用于 SapSnCreate 匹配，避免仅靠 CSO 反查失败。
     * @param pmuSalesOrderItem (optional) 可选：ISO Item，与 PmuSalesOrder 成对传入。
     * @param scanBlob (optional) 已废弃：选择不再即时扫 Blob，一律只读 Mapping；Blob 由后台 Job 维护。
     * @return OK
     */
    getSnList(saleNumber?: string | undefined, saleRowNo?: string | undefined, pmuSalesOrder?: string | undefined, pmuSalesOrderItem?: string | undefined, scanBlob?: boolean | undefined, cancelToken?: CancelToken): Promise<MotorCertSnItemDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCert/GetSnList?";
        if (saleNumber === null)
            throw new globalThis.Error("The parameter 'saleNumber' cannot be null.");
        else if (saleNumber !== undefined)
            url_ += "SaleNumber=" + encodeURIComponent("" + saleNumber) + "&";
        if (saleRowNo === null)
            throw new globalThis.Error("The parameter 'saleRowNo' cannot be null.");
        else if (saleRowNo !== undefined)
            url_ += "SaleRowNo=" + encodeURIComponent("" + saleRowNo) + "&";
        if (pmuSalesOrder === null)
            throw new globalThis.Error("The parameter 'pmuSalesOrder' cannot be null.");
        else if (pmuSalesOrder !== undefined)
            url_ += "PmuSalesOrder=" + encodeURIComponent("" + pmuSalesOrder) + "&";
        if (pmuSalesOrderItem === null)
            throw new globalThis.Error("The parameter 'pmuSalesOrderItem' cannot be null.");
        else if (pmuSalesOrderItem !== undefined)
            url_ += "PmuSalesOrderItem=" + encodeURIComponent("" + pmuSalesOrderItem) + "&";
        if (scanBlob === null)
            throw new globalThis.Error("The parameter 'scanBlob' cannot be null.");
        else if (scanBlob !== undefined)
            url_ += "ScanBlob=" + encodeURIComponent("" + scanBlob) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSnList(_response);
        });
    }

    protected processGetSnList(response: AxiosResponse): Promise<MotorCertSnItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MotorCertSnItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MotorCertSnItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MotorCertSnItemDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    batchDownload(body?: MotorCertBatchDownloadInputDto | undefined, cancelToken?: CancelToken): Promise<MotorCertBatchDownloadResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCert/BatchDownload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDownload(_response);
        });
    }

    protected processBatchDownload(response: AxiosResponse): Promise<MotorCertBatchDownloadResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MotorCertBatchDownloadResultDto.fromJS(resultData200);
            return Promise.resolve<MotorCertBatchDownloadResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MotorCertBatchDownloadResultDto>(null as any);
    }

    /**
     * 批量下载（异步）：写入导出列表，完成后可在右上角「导出列表」下载 ZIP。
     * @param body (optional) 
     * @return OK
     */
    enqueueBatchDownload(body?: MotorCertBatchDownloadInputDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCert/EnqueueBatchDownload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnqueueBatchDownload(_response);
        });
    }

    protected processEnqueueBatchDownload(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 手动触发 Blob 可用性扫描 Job：① 重扫 Mapping 未齐；② 同步 SapSnCreate（默认 CreationTime ∈ [昨天0点, 现在]）并扫 Blob。
    可选覆盖时间窗口，用于 Excel 历史灌库补扫。
     * @param body (optional) 
     * @return OK
     */
    triggerBlobAvailabilityScan(body?: MotorCertTriggerBlobScanInputDto | undefined, cancelToken?: CancelToken): Promise<MotorCertTriggerBlobScanResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCert/TriggerBlobAvailabilityScan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTriggerBlobAvailabilityScan(_response);
        });
    }

    protected processTriggerBlobAvailabilityScan(response: AxiosResponse): Promise<MotorCertTriggerBlobScanResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MotorCertTriggerBlobScanResultDto.fromJS(resultData200);
            return Promise.resolve<MotorCertTriggerBlobScanResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MotorCertTriggerBlobScanResultDto>(null as any);
    }

    /**
     * 手动触发 Blob 全量遍历导入 Job：列举 ecsinspectreport，按 ISO/ISOitem/SN upsert Mapping。
     * @param body (optional) 
     * @return OK
     */
    triggerBlobImportFromBlob(body?: MotorCertTriggerBlobImportInputDto | undefined, cancelToken?: CancelToken): Promise<MotorCertTriggerBlobImportResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCert/TriggerBlobImportFromBlob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTriggerBlobImportFromBlob(_response);
        });
    }

    protected processTriggerBlobImportFromBlob(response: AxiosResponse): Promise<MotorCertTriggerBlobImportResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MotorCertTriggerBlobImportResultDto.fromJS(resultData200);
            return Promise.resolve<MotorCertTriggerBlobImportResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MotorCertTriggerBlobImportResultDto>(null as any);
    }

    /**
     * 同步执行增量扫描 Job（当前 HTTP 请求内直接跑逻辑，便于本地断点；不入 Hangfire）。
     * @param body (optional) 
     * @return OK
     */
    executeBlobAvailabilityScanSync(body?: MotorCertTriggerBlobScanInputDto | undefined, cancelToken?: CancelToken): Promise<MotorCertExecuteJobSyncResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCert/ExecuteBlobAvailabilityScanSync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExecuteBlobAvailabilityScanSync(_response);
        });
    }

    protected processExecuteBlobAvailabilityScanSync(response: AxiosResponse): Promise<MotorCertExecuteJobSyncResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MotorCertExecuteJobSyncResultDto.fromJS(resultData200);
            return Promise.resolve<MotorCertExecuteJobSyncResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MotorCertExecuteJobSyncResultDto>(null as any);
    }

    /**
     * 同步执行全量 List 导入 Job（当前 HTTP 请求内直接跑逻辑，便于本地断点；不入 Hangfire）。
     * @param body (optional) 
     * @return OK
     */
    executeBlobImportFromBlobSync(body?: MotorCertTriggerBlobImportInputDto | undefined, cancelToken?: CancelToken): Promise<MotorCertExecuteJobSyncResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCert/ExecuteBlobImportFromBlobSync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExecuteBlobImportFromBlobSync(_response);
        });
    }

    protected processExecuteBlobImportFromBlobSync(response: AxiosResponse): Promise<MotorCertExecuteJobSyncResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MotorCertExecuteJobSyncResultDto.fromJS(resultData200);
            return Promise.resolve<MotorCertExecuteJobSyncResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MotorCertExecuteJobSyncResultDto>(null as any);
    }

    /**
     * 后台 Job：打包 ZIP，JobResult 返回可下载 URL。
     * @param body (optional) 
     * @return OK
     */
    batchDownloadForJob(body?: MotorCertBatchDownloadInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCert/BatchDownloadForJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDownloadForJob(_response);
        });
    }

    protected processBatchDownloadForJob(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 联系责任人：发邮件 + 在「上传证书」写入待办（合格证/报告分开，幂等不重复建 Pending）。
     * @param body (optional) 
     * @return OK
     */
    contactHandler(body?: MotorCertContactHandlerInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCert/ContactHandler";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContactHandler(_response);
        });
    }

    protected processContactHandler(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MotorCertFeeCartServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 按订单行获取可加入费用车的 SN（缺报告、未占用）
     * @param saleNumber (optional) 
     * @param saleRowNo (optional) 
     * @param orderFormId (optional) 
     * @param productBasicMotorId (optional) 
     * @return OK
     */
    getAvailableSns(saleNumber?: string | undefined, saleRowNo?: string | undefined, orderFormId?: string | undefined, productBasicMotorId?: string | undefined, cancelToken?: CancelToken): Promise<AvailableFeeCartSnDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCertFeeCart/GetAvailableSns?";
        if (saleNumber === null)
            throw new globalThis.Error("The parameter 'saleNumber' cannot be null.");
        else if (saleNumber !== undefined)
            url_ += "saleNumber=" + encodeURIComponent("" + saleNumber) + "&";
        if (saleRowNo === null)
            throw new globalThis.Error("The parameter 'saleRowNo' cannot be null.");
        else if (saleRowNo !== undefined)
            url_ += "saleRowNo=" + encodeURIComponent("" + saleRowNo) + "&";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "orderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        if (productBasicMotorId === null)
            throw new globalThis.Error("The parameter 'productBasicMotorId' cannot be null.");
        else if (productBasicMotorId !== undefined)
            url_ += "productBasicMotorId=" + encodeURIComponent("" + productBasicMotorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableSns(_response);
        });
    }

    protected processGetAvailableSns(response: AxiosResponse): Promise<AvailableFeeCartSnDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailableFeeCartSnDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AvailableFeeCartSnDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailableFeeCartSnDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addSnToFeeCart(body?: AddSnToFeeCartDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCertFeeCart/AddSnToFeeCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddSnToFeeCart(_response);
        });
    }

    protected processAddSnToFeeCart(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param customerCode (optional) 
     * @return OK
     */
    getFeeCart(customerCode?: string | undefined, cancelToken?: CancelToken): Promise<FeeCartDetailDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCertFeeCart/GetFeeCart?";
        if (customerCode === null)
            throw new globalThis.Error("The parameter 'customerCode' cannot be null.");
        else if (customerCode !== undefined)
            url_ += "customerCode=" + encodeURIComponent("" + customerCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFeeCart(_response);
        });
    }

    protected processGetFeeCart(response: AxiosResponse): Promise<FeeCartDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeeCartDetailDto.fromJS(resultData200);
            return Promise.resolve<FeeCartDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeeCartDetailDto>(null as any);
    }

    /**
     * @param cartId (optional) 
     * @return OK
     */
    getFeeCartById(cartId?: string | undefined, cancelToken?: CancelToken): Promise<FeeCartDetailDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCertFeeCart/GetFeeCartById?";
        if (cartId === null)
            throw new globalThis.Error("The parameter 'cartId' cannot be null.");
        else if (cartId !== undefined)
            url_ += "cartId=" + encodeURIComponent("" + cartId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFeeCartById(_response);
        });
    }

    protected processGetFeeCartById(response: AxiosResponse): Promise<FeeCartDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeeCartDetailDto.fromJS(resultData200);
            return Promise.resolve<FeeCartDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeeCartDetailDto>(null as any);
    }

    /**
     * @param cartId (optional) 
     * @return OK
     */
    getFeeCartForOrderCenter(cartId?: string | undefined, cancelToken?: CancelToken): Promise<FeeCartDetailDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCertFeeCart/GetFeeCartForOrderCenter?";
        if (cartId === null)
            throw new globalThis.Error("The parameter 'cartId' cannot be null.");
        else if (cartId !== undefined)
            url_ += "cartId=" + encodeURIComponent("" + cartId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFeeCartForOrderCenter(_response);
        });
    }

    protected processGetFeeCartForOrderCenter(response: AxiosResponse): Promise<FeeCartDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeeCartDetailDto.fromJS(resultData200);
            return Promise.resolve<FeeCartDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeeCartDetailDto>(null as any);
    }

    /**
     * @param snId (optional) 
     * @return OK
     */
    removeSn(snId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCertFeeCart/RemoveSn?";
        if (snId === null)
            throw new globalThis.Error("The parameter 'snId' cannot be null.");
        else if (snId !== undefined)
            url_ += "snId=" + encodeURIComponent("" + snId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveSn(_response);
        });
    }

    protected processRemoveSn(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param itemId (optional) 
     * @return OK
     */
    removeItem(itemId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCertFeeCart/RemoveItem?";
        if (itemId === null)
            throw new globalThis.Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveItem(_response);
        });
    }

    protected processRemoveItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param cartId (optional) 
     * @return OK
     */
    submitFeeCart(cartId?: string | undefined, cancelToken?: CancelToken): Promise<SubmitFeeCartResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCertFeeCart/SubmitFeeCart?";
        if (cartId === null)
            throw new globalThis.Error("The parameter 'cartId' cannot be null.");
        else if (cartId !== undefined)
            url_ += "cartId=" + encodeURIComponent("" + cartId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitFeeCart(_response);
        });
    }

    protected processSubmitFeeCart(response: AxiosResponse): Promise<SubmitFeeCartResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubmitFeeCartResultDto.fromJS(resultData200);
            return Promise.resolve<SubmitFeeCartResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubmitFeeCartResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    writeBackOrderInfo(body?: WriteBackOrderInfoDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCertFeeCart/WriteBackOrderInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWriteBackOrderInfo(_response);
        });
    }

    protected processWriteBackOrderInfo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    writeBackFeeCartResult(body?: WriteBackFeeCartResultDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCertFeeCart/WriteBackFeeCartResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWriteBackFeeCartResult(_response);
        });
    }

    protected processWriteBackFeeCartResult(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据订单ID获取可补充的SN列表
    供前端「补出厂试验报告」按钮调用
     * @param orderIdentifier (optional) 
     * @return OK
     */
    getAvailableSnsByOrder(orderIdentifier?: string | undefined, cancelToken?: CancelToken): Promise<AvailableSnDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCertFeeCart/GetAvailableSnsByOrder?";
        if (orderIdentifier === null)
            throw new globalThis.Error("The parameter 'orderIdentifier' cannot be null.");
        else if (orderIdentifier !== undefined)
            url_ += "orderIdentifier=" + encodeURIComponent("" + orderIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableSnsByOrder(_response);
        });
    }

    protected processGetAvailableSnsByOrder(response: AxiosResponse): Promise<AvailableSnDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailableSnDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AvailableSnDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailableSnDto[]>(null as any);
    }

    /**
     * 根据CSO号获取订单信息（用于补充购物车头信息）
     * @param csoNumber (optional) 
     * @return OK
     */
    getOrderInfoByCso(csoNumber?: string | undefined, cancelToken?: CancelToken): Promise<OrderInfoForFeeCartDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCertFeeCart/GetOrderInfoByCso?";
        if (csoNumber === null)
            throw new globalThis.Error("The parameter 'csoNumber' cannot be null.");
        else if (csoNumber !== undefined)
            url_ += "csoNumber=" + encodeURIComponent("" + csoNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderInfoByCso(_response);
        });
    }

    protected processGetOrderInfoByCso(response: AxiosResponse): Promise<OrderInfoForFeeCartDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderInfoForFeeCartDto.fromJS(resultData200);
            return Promise.resolve<OrderInfoForFeeCartDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderInfoForFeeCartDto>(null as any);
    }
}

export class MotorCertManualUploadServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 联系责任人产生的待办列表（默认 Pending）。
    CertificateManager：全部；CertificateSupport：按当前登录人 Email = HandlerEmail。
     * @param body (optional) 
     * @return OK
     */
    queryPendingTasks(body?: MotorCertHandlerUploadTaskQueryInputDto | undefined, cancelToken?: CancelToken): Promise<MotorCertHandlerUploadTaskQueryResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCertManualUpload/QueryPendingTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryPendingTasks(_response);
        });
    }

    protected processQueryPendingTasks(response: AxiosResponse): Promise<MotorCertHandlerUploadTaskQueryResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MotorCertHandlerUploadTaskQueryResultDto.fromJS(resultData200);
            return Promise.resolve<MotorCertHandlerUploadTaskQueryResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MotorCertHandlerUploadTaskQueryResultDto>(null as any);
    }

    /**
     * 查询缺失合格证/试验报告的 SN（须带 SN 或 SO，避免全表扫）
     * @param body (optional) 
     * @return OK
     */
    query(body?: MotorCertManualUploadQueryInputDto | undefined, cancelToken?: CancelToken): Promise<MotorCertManualUploadQueryResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCertManualUpload/Query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<MotorCertManualUploadQueryResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MotorCertManualUploadQueryResultDto.fromJS(resultData200);
            return Promise.resolve<MotorCertManualUploadQueryResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MotorCertManualUploadQueryResultDto>(null as any);
    }

    /**
     * 人工上传合格证或试验报告 PDF
     * @param serialNumber (optional) 
     * @param saleNumber (optional) 
     * @param saleRowNo (optional) 
     * @param fileType (optional) 
     * @param file (optional) 
     * @return OK
     */
    uploadFile(serialNumber?: string | undefined, saleNumber?: string | undefined, saleRowNo?: string | undefined, fileType?: MotorCertFileType | undefined, file?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCertManualUpload/UploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (serialNumber === null || serialNumber === undefined)
            throw new globalThis.Error("The parameter 'serialNumber' cannot be null.");
        else
            content_.append("serialNumber", serialNumber.toString());
        if (saleNumber === null || saleNumber === undefined)
            throw new globalThis.Error("The parameter 'saleNumber' cannot be null.");
        else
            content_.append("saleNumber", saleNumber.toString());
        if (saleRowNo === null || saleRowNo === undefined)
            throw new globalThis.Error("The parameter 'saleRowNo' cannot be null.");
        else
            content_.append("saleRowNo", saleRowNo.toString());
        if (fileType === null || fileType === undefined)
            throw new globalThis.Error("The parameter 'fileType' cannot be null.");
        else
            content_.append("fileType", fileType.toString());
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 人工确认待办已处理（上传齐套或无需继续跟时手动关闭）。
     * @param taskId (optional) 
     * @return OK
     */
    markHandlerUploadTaskDone(taskId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/MotorCertManualUpload/MarkHandlerUploadTaskDone?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkHandlerUploadTaskDone(_response);
        });
    }

    protected processMarkHandlerUploadTaskDone(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OISOrderFormAutomateCheckItemServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 列表加载
     * @param body (optional) 
     * @return OK
     */
    checkItemByPage(body?: OISOrderFormAutomateCheckItemPageInput | undefined, cancelToken?: CancelToken): Promise<OISOrderFormAutomateCheckItemPagePagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItem/CheckItemByPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckItemByPage(_response);
        });
    }

    protected processCheckItemByPage(response: AxiosResponse): Promise<OISOrderFormAutomateCheckItemPagePagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OISOrderFormAutomateCheckItemPagePagedResultDto.fromJS(resultData200);
            return Promise.resolve<OISOrderFormAutomateCheckItemPagePagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OISOrderFormAutomateCheckItemPagePagedResultDto>(null as any);
    }

    /**
     * 根据条件获取 检查项目（未被删除的，启用的项目）
     * @param body (optional) 
     * @return OK
     */
    getCheckItem(body?: OISOrderFormAutomateCheckItemPageInput | undefined, cancelToken?: CancelToken): Promise<OISOrderFormAutomateCheckItemPage[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItem/GetCheckItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCheckItem(_response);
        });
    }

    protected processGetCheckItem(response: AxiosResponse): Promise<OISOrderFormAutomateCheckItemPage[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OISOrderFormAutomateCheckItemPage.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OISOrderFormAutomateCheckItemPage[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OISOrderFormAutomateCheckItemPage[]>(null as any);
    }

    /**
     * 新增
     * @param body (optional) 
     * @return OK
     */
    checkItemAdd(body?: OISOrderFormAutomateCheckItemAddDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItem/CheckItemAdd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckItemAdd(_response);
        });
    }

    protected processCheckItemAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 自动审单检查项修改
     * @param body (optional) 
     * @return OK
     */
    checkItemEdit(body?: OISOrderFormAutomateCheckItemEditDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItem/CheckItemEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckItemEdit(_response);
        });
    }

    protected processCheckItemEdit(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 自动审单检查项删除
     * @param body (optional) 
     * @return OK
     */
    checkItemDel(body?: string[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItem/CheckItemDel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckItemDel(_response);
        });
    }

    protected processCheckItemDel(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 设置启用/禁用
     * @param body (optional) 
     * @return OK
     */
    checkItemSetEnable(body?: OISOrderFormAutomateCheckItemSetEnable | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItem/CheckItemSetEnable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckItemSetEnable(_response);
        });
    }

    protected processCheckItemSetEnable(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class OISOrderFormAutomateCheckItemResultServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 列表加载
     * @param body (optional) 
     * @return OK
     */
    checkItemResultPage(body?: OISOrderFormAutomateCheckItemResultPageInputDto | undefined, cancelToken?: CancelToken): Promise<OISOrderFormAutomateCheckItemResultPageDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItemResult/CheckItemResultPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckItemResultPage(_response);
        });
    }

    protected processCheckItemResultPage(response: AxiosResponse): Promise<OISOrderFormAutomateCheckItemResultPageDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OISOrderFormAutomateCheckItemResultPageDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<OISOrderFormAutomateCheckItemResultPageDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OISOrderFormAutomateCheckItemResultPageDtoPagedResultDto>(null as any);
    }

    /**
     * 按查询条件导出excel
     * @param body (optional) 
     * @return OK
     */
    checkItemResultExcel(body?: OISOrderFormAutomateCheckItemResultPageInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItemResult/CheckItemResultExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckItemResultExcel(_response);
        });
    }

    protected processCheckItemResultExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 根据id获取详情
     * @param id (optional) 
     * @return OK
     */
    getDetailInfoById(id?: string | undefined, cancelToken?: CancelToken): Promise<OISOrderFormAutomateCheckItemResultPageDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItemResult/GetDetailInfoById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetailInfoById(_response);
        });
    }

    protected processGetDetailInfoById(response: AxiosResponse): Promise<OISOrderFormAutomateCheckItemResultPageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OISOrderFormAutomateCheckItemResultPageDto.fromJS(resultData200);
            return Promise.resolve<OISOrderFormAutomateCheckItemResultPageDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OISOrderFormAutomateCheckItemResultPageDto>(null as any);
    }

    /**
     * 根据TaskId获取审单结果List
     * @param taskId (optional) 
     * @return OK
     */
    getResultListByTaskId(taskId?: string | undefined, cancelToken?: CancelToken): Promise<OISOrderFormAutomateCheckItemResultPageDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItemResult/GetResultListByTaskId?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResultListByTaskId(_response);
        });
    }

    protected processGetResultListByTaskId(response: AxiosResponse): Promise<OISOrderFormAutomateCheckItemResultPageDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OISOrderFormAutomateCheckItemResultPageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OISOrderFormAutomateCheckItemResultPageDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OISOrderFormAutomateCheckItemResultPageDto[]>(null as any);
    }

    /**
     * 新增
     * @param body (optional) 
     * @return OK
     */
    checkItemResultAdd(body?: OISOrderFormAutomateCheckItemResultAddDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItemResult/CheckItemResultAdd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckItemResultAdd(_response);
        });
    }

    protected processCheckItemResultAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 批量新增
     * @param body (optional) 
     * @return OK
     */
    checkItemResultAddList(body?: OISOrderFormAutomateCheckItemResultAddDto[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItemResult/CheckItemResultAddList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckItemResultAddList(_response);
        });
    }

    protected processCheckItemResultAddList(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 批量新增
     * @param body (optional) 
     * @return OK
     */
    checkItemResultAddListOld(body?: OISOrderFormAutomateCheckItemResultAddDto[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItemResult/CheckItemResultAddListOld";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckItemResultAddListOld(_response);
        });
    }

    protected processCheckItemResultAddListOld(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 删除
     * @param body (optional) 
     * @return OK
     */
    checkItemResultDelList(body?: string[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItemResult/CheckItemResultDelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckItemResultDelList(_response);
        });
    }

    protected processCheckItemResultDelList(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 根据表单ID，删除检查结果
     * @param orderFormId (optional) 表单ID
     * @return OK
     */
    checkItemResultDeleteByOrderFormId(orderFormId?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItemResult/CheckItemResultDeleteByOrderFormId?";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "orderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckItemResultDeleteByOrderFormId(_response);
        });
    }

    protected processCheckItemResultDeleteByOrderFormId(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class OISOrderFormAutomateCheckItemResultSimplifyServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 列表加载
     * @param body (optional) 
     * @return OK
     */
    checkItemResultSimplifyPage(body?: OISOrderFormAutomateCheckItemResultSimplifyPageInputDto | undefined, cancelToken?: CancelToken): Promise<OISOrderFormAutomateCheckItemResultSimplifyPageDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItemResultSimplify/CheckItemResultSimplifyPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckItemResultSimplifyPage(_response);
        });
    }

    protected processCheckItemResultSimplifyPage(response: AxiosResponse): Promise<OISOrderFormAutomateCheckItemResultSimplifyPageDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OISOrderFormAutomateCheckItemResultSimplifyPageDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<OISOrderFormAutomateCheckItemResultSimplifyPageDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OISOrderFormAutomateCheckItemResultSimplifyPageDtoPagedResultDto>(null as any);
    }

    /**
     * 列表加载，只加载错误数据， 待办事项>审批中心，详情，底部列表
     * @param body (optional) 
     * @return OK
     */
    checkItemResultErrorPage(body?: OISOrderFormAutomateCheckItemResultSimplifyPageInputDto | undefined, cancelToken?: CancelToken): Promise<OISOrderFormAutomateCheckItemResultSimplifyPageDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItemResultSimplify/CheckItemResultErrorPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckItemResultErrorPage(_response);
        });
    }

    protected processCheckItemResultErrorPage(response: AxiosResponse): Promise<OISOrderFormAutomateCheckItemResultSimplifyPageDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OISOrderFormAutomateCheckItemResultSimplifyPageDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<OISOrderFormAutomateCheckItemResultSimplifyPageDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OISOrderFormAutomateCheckItemResultSimplifyPageDtoPagedResultDto>(null as any);
    }

    /**
     * 按查询条件导出excel
     * @param body (optional) 
     * @return OK
     */
    checkItemResultSimplifyExcel(body?: OISOrderFormAutomateCheckItemResultSimplifyPageInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItemResultSimplify/CheckItemResultSimplifyExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckItemResultSimplifyExcel(_response);
        });
    }

    protected processCheckItemResultSimplifyExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 新增
     * @param body (optional) 
     * @return OK
     */
    checkItemResultSimplifyAdd(body?: OISOrderFormAutomateCheckItemResultSimplifyAddDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItemResultSimplify/CheckItemResultSimplifyAdd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckItemResultSimplifyAdd(_response);
        });
    }

    protected processCheckItemResultSimplifyAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 检查结果精简版，批量新增
     * @param body (optional) 
     * @return OK
     */
    checkItemResultSimplifyAddList(body?: OISOrderFormAutomateCheckItemResultSimplifyAddDto[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItemResultSimplify/CheckItemResultSimplifyAddList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckItemResultSimplifyAddList(_response);
        });
    }

    protected processCheckItemResultSimplifyAddList(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 检查结果精简版，批量新增/修改
     * @param body (optional) 
     * @return OK
     */
    checkItemResultSimplifyAddOrEditList(body?: OISOrderFormAutomateCheckItemResultSimplifyAddDto[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItemResultSimplify/CheckItemResultSimplifyAddOrEditList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckItemResultSimplifyAddOrEditList(_response);
        });
    }

    protected processCheckItemResultSimplifyAddOrEditList(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 删除
     * @param body (optional) 
     * @return OK
     */
    checkItemResultSimplifyDelList(body?: string[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItemResultSimplify/CheckItemResultSimplifyDelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckItemResultSimplifyDelList(_response);
        });
    }

    protected processCheckItemResultSimplifyDelList(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 根据表单ID删除简化版检查结果（软删除）
     * @param orderFormId (optional) 表单ID
     * @return OK
     */
    checkItemResultSimplifyDeleteByOrderFormId(orderFormId?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateCheckItemResultSimplify/CheckItemResultSimplifyDeleteByOrderFormId?";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "orderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckItemResultSimplifyDeleteByOrderFormId(_response);
        });
    }

    protected processCheckItemResultSimplifyDeleteByOrderFormId(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class OISOrderFormAutomateGreenChannelProjectServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 绿通项目评审记录列表加载
     * @param body (optional) 
     * @return OK
     */
    oISOrderFormAutomateGreenChannelProjectByPage(body?: OISOrderFormAutomateGreenChannelProjectPageInputDto | undefined, cancelToken?: CancelToken): Promise<OISOrderFormAutomateGreenChannelProjectPageDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateGreenChannelProject/OISOrderFormAutomateGreenChannelProjectByPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOISOrderFormAutomateGreenChannelProjectByPage(_response);
        });
    }

    protected processOISOrderFormAutomateGreenChannelProjectByPage(response: AxiosResponse): Promise<OISOrderFormAutomateGreenChannelProjectPageDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OISOrderFormAutomateGreenChannelProjectPageDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<OISOrderFormAutomateGreenChannelProjectPageDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OISOrderFormAutomateGreenChannelProjectPageDtoPagedResultDto>(null as any);
    }

    /**
     * 绿通项目评审记录新增
     * @param body (optional) 
     * @return OK
     */
    oISOrderFormAutomateGreenChannelProjectAdd(body?: OISOrderFormAutomateGreenChannelProjectAddDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateGreenChannelProject/OISOrderFormAutomateGreenChannelProjectAdd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOISOrderFormAutomateGreenChannelProjectAdd(_response);
        });
    }

    protected processOISOrderFormAutomateGreenChannelProjectAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 绿通项目评审记录批量新增类型
     * @param body (optional) 
     * @return OK
     */
    oISOrderFormAutomateGreenChannelProjectAddList(body?: OISOrderFormAutomateGreenChannelProjectAddDto[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateGreenChannelProject/OISOrderFormAutomateGreenChannelProjectAddList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOISOrderFormAutomateGreenChannelProjectAddList(_response);
        });
    }

    protected processOISOrderFormAutomateGreenChannelProjectAddList(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 绿通导入客户选择类型
     * @param types (optional) 
     * @return OK
     */
    greenChannelProjectCoverImport(types?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateGreenChannelProject/GreenChannelProjectCoverImport?";
        if (types === null)
            throw new globalThis.Error("The parameter 'types' cannot be null.");
        else if (types !== undefined)
            url_ += "types=" + encodeURIComponent("" + types) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGreenChannelProjectCoverImport(_response);
        });
    }

    protected processGreenChannelProjectCoverImport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 绿通项目评审记录修改
     * @param body (optional) 
     * @return OK
     */
    oISOrderFormAutomateGreenChannelProjectEdit(body?: OISOrderFormAutomateGreenChannelProjectEditDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateGreenChannelProject/OISOrderFormAutomateGreenChannelProjectEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOISOrderFormAutomateGreenChannelProjectEdit(_response);
        });
    }

    protected processOISOrderFormAutomateGreenChannelProjectEdit(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 导入绿通项目评审数据,并且缓存起来
     * @param excelFile (optional) 
     * @return OK
     */
    importGreenChannelProjectData(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateGreenChannelProject/ImportGreenChannelProjectData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportGreenChannelProjectData(_response);
        });
    }

    protected processImportGreenChannelProjectData(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 按导入数据查询，绿通号是否 已经在表里面
     * @param body (optional) 
     * @return OK
     */
    oISOrderFormAutomateGreenChannelProjectExists(body?: OISOrderFormAutomateGreenChannelProjectAddDto[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateGreenChannelProject/OISOrderFormAutomateGreenChannelProjectExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOISOrderFormAutomateGreenChannelProjectExists(_response);
        });
    }

    protected processOISOrderFormAutomateGreenChannelProjectExists(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 导出，找不到客户的数据
     * @param body (optional) 
     * @return OK
     */
    exportErrorExcel(body?: OISOrderFormAutomateGreenChannelProjectAddDto[] | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateGreenChannelProject/ExportErrorExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportErrorExcel(_response);
        });
    }

    protected processExportErrorExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 一键清空整个绿通项目评审表数据
     * @return OK
     */
    channelProjectClearAllData( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateGreenChannelProject/ChannelProjectClearAllData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChannelProjectClearAllData(_response);
        });
    }

    protected processChannelProjectClearAllData(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 绿通年项目审记录删除
     * @param id (optional) 记录ID
     * @return OK
     */
    channelProjectDelete(id?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateGreenChannelProject/ChannelProjectDelete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChannelProjectDelete(_response);
        });
    }

    protected processChannelProjectDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class OISOrderFormAutomateGreenChannelYearServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 绿通年度评审记录列表加载
     * @param body (optional) 
     * @return OK
     */
    oISOrderFormAutomateGreenChannelYearByPage(body?: OISOrderFormAutomateGreenChannelYearPageInputDto | undefined, cancelToken?: CancelToken): Promise<OISOrderFormAutomateGreenChannelYearPageDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateGreenChannelYear/OISOrderFormAutomateGreenChannelYearByPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOISOrderFormAutomateGreenChannelYearByPage(_response);
        });
    }

    protected processOISOrderFormAutomateGreenChannelYearByPage(response: AxiosResponse): Promise<OISOrderFormAutomateGreenChannelYearPageDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OISOrderFormAutomateGreenChannelYearPageDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<OISOrderFormAutomateGreenChannelYearPageDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OISOrderFormAutomateGreenChannelYearPageDtoPagedResultDto>(null as any);
    }

    /**
     * 绿通年度评审记录新增
     * @param body (optional) 
     * @return OK
     */
    oISOrderFormAutomateGreenChannelYearAdd(body?: OISOrderFormAutomateGreenChannelYearAddDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateGreenChannelYear/OISOrderFormAutomateGreenChannelYearAdd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOISOrderFormAutomateGreenChannelYearAdd(_response);
        });
    }

    protected processOISOrderFormAutomateGreenChannelYearAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 绿通年度评审记录修改
     * @param body (optional) 
     * @return OK
     */
    oISOrderFormAutomateGreenChannelYearEdit(body?: OISOrderFormAutomateGreenChannelYearEditDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateGreenChannelYear/OISOrderFormAutomateGreenChannelYearEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOISOrderFormAutomateGreenChannelYearEdit(_response);
        });
    }

    protected processOISOrderFormAutomateGreenChannelYearEdit(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 绿通导入客户选择类型
     * @param types (optional) 
     * @return OK
     */
    greenChannelYearCoverImport(types?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateGreenChannelYear/GreenChannelYearCoverImport?";
        if (types === null)
            throw new globalThis.Error("The parameter 'types' cannot be null.");
        else if (types !== undefined)
            url_ += "types=" + encodeURIComponent("" + types) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGreenChannelYearCoverImport(_response);
        });
    }

    protected processGreenChannelYearCoverImport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导入绿通年度评审数据
     * @param excelFile (optional) 
     * @return OK
     */
    importGreenChannelYearData(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateGreenChannelYear/ImportGreenChannelYearData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportGreenChannelYearData(_response);
        });
    }

    protected processImportGreenChannelYearData(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 按导入数据查询，绿通号是否 已经在表里面
     * @param body (optional) 
     * @return OK
     */
    oISOrderFormAutomateGreenChannelYearExists(body?: OISOrderFormAutomateGreenChannelYearAddDto[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateGreenChannelYear/OISOrderFormAutomateGreenChannelYearExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOISOrderFormAutomateGreenChannelYearExists(_response);
        });
    }

    protected processOISOrderFormAutomateGreenChannelYearExists(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 一键清空整个绿通年度评审表数据
     * @return OK
     */
    channelYearClearAllData( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateGreenChannelYear/ChannelYearClearAllData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChannelYearClearAllData(_response);
        });
    }

    protected processChannelYearClearAllData(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 绿通年度评审记录删除
     * @param id (optional) 记录ID
     * @return OK
     */
    channelYearDelete(id?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateGreenChannelYear/ChannelYearDelete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChannelYearDelete(_response);
        });
    }

    protected processChannelYearDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class OISOrderFormAutomateOCRLogServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 自动审单OCR调用记录列表加载
     * @param body (optional) 
     * @return OK
     */
    oCRLogByPage(body?: OISOrderFormAutomateOCRLogPageInputDto | undefined, cancelToken?: CancelToken): Promise<OISOrderFormAutomateOCRLogPageDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateOCRLog/OCRLogByPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOCRLogByPage(_response);
        });
    }

    protected processOCRLogByPage(response: AxiosResponse): Promise<OISOrderFormAutomateOCRLogPageDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OISOrderFormAutomateOCRLogPageDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<OISOrderFormAutomateOCRLogPageDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OISOrderFormAutomateOCRLogPageDtoPagedResultDto>(null as any);
    }

    /**
     * OCR调用记录，按查询条件导出excel
     * @param body (optional) 
     * @return OK
     */
    oCRLogExcel(body?: OISOrderFormAutomateOCRLogPageInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateOCRLog/OCRLogExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOCRLogExcel(_response);
        });
    }

    protected processOCRLogExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 自动审单OCR调用记录新增
     * @param body (optional) 
     * @return OK
     */
    oCRLogAdd(body?: OISOrderFormAutomateOCRLogAddDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateOCRLog/OCRLogAdd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOCRLogAdd(_response);
        });
    }

    protected processOCRLogAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * OCR调用记录删除
     * @param body (optional) 
     * @return OK
     */
    oCRLogDelList(body?: string[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateOCRLog/OCRLogDelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOCRLogDelList(_response);
        });
    }

    protected processOCRLogDelList(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取OCR详情
     * @param id (optional) 
     * @return OK
     */
    getOCRDetailInfoById(id?: string | undefined, cancelToken?: CancelToken): Promise<OISOrderFormAutomateOCRLogPageDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateOCRLog/GetOCRDetailInfoById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOCRDetailInfoById(_response);
        });
    }

    protected processGetOCRDetailInfoById(response: AxiosResponse): Promise<OISOrderFormAutomateOCRLogPageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OISOrderFormAutomateOCRLogPageDto.fromJS(resultData200);
            return Promise.resolve<OISOrderFormAutomateOCRLogPageDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OISOrderFormAutomateOCRLogPageDto>(null as any);
    }

    /**
     * 根据orderFormId，判断fileByte是否存在，存在就返回对象
     * @param fileByte (optional) 
     * @param orderFormId (optional) 
     * @return OK
     */
    existsByFileByte(fileByte?: string | undefined, orderFormId?: string | undefined, cancelToken?: CancelToken): Promise<OISOrderFormAutomateOCRLogPageDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateOCRLog/ExistsByFileByte?";
        if (fileByte === null)
            throw new globalThis.Error("The parameter 'fileByte' cannot be null.");
        else if (fileByte !== undefined)
            url_ += "fileByte=" + encodeURIComponent("" + fileByte) + "&";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "orderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExistsByFileByte(_response);
        });
    }

    protected processExistsByFileByte(response: AxiosResponse): Promise<OISOrderFormAutomateOCRLogPageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OISOrderFormAutomateOCRLogPageDto.fromJS(resultData200);
            return Promise.resolve<OISOrderFormAutomateOCRLogPageDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OISOrderFormAutomateOCRLogPageDto>(null as any);
    }
}

export class OISOrderFormAutomateTaskServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 自动审单任务记录列表加载
     * @param body (optional) 
     * @return OK
     */
    oISOrderFormAutomateTaskByPage(body?: OISOrderFormAutomateTaskPageInputDto | undefined, cancelToken?: CancelToken): Promise<OISOrderFormAutomateTaskPageDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateTask/OISOrderFormAutomateTaskByPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOISOrderFormAutomateTaskByPage(_response);
        });
    }

    protected processOISOrderFormAutomateTaskByPage(response: AxiosResponse): Promise<OISOrderFormAutomateTaskPageDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OISOrderFormAutomateTaskPageDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<OISOrderFormAutomateTaskPageDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OISOrderFormAutomateTaskPageDtoPagedResultDto>(null as any);
    }

    /**
     * 自动审单任务记录新增
     * @param body (optional) 
     * @return OK
     */
    oISOrderFormAutomateTaskAdd(body?: OISOrderFormAutomateTaskAddDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateTask/OISOrderFormAutomateTaskAdd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOISOrderFormAutomateTaskAdd(_response);
        });
    }

    protected processOISOrderFormAutomateTaskAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 修改结束时间
     * @param body (optional) 
     * @return OK
     */
    oISOrderFormAutomateTaskEditEndTimeTwo(body?: OISOrderFormAutomateTaskAddDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateTask/OISOrderFormAutomateTaskEditEndTimeTwo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOISOrderFormAutomateTaskEditEndTimeTwo(_response);
        });
    }

    protected processOISOrderFormAutomateTaskEditEndTimeTwo(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 修改结束时间
     * @param body (optional) 
     * @return OK
     */
    oISOrderFormAutomateTaskEditEndTime(body?: OISOrderFormAutomateTaskAddDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateTask/OISOrderFormAutomateTaskEditEndTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOISOrderFormAutomateTaskEditEndTime(_response);
        });
    }

    protected processOISOrderFormAutomateTaskEditEndTime(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 自动审单任务记录修改
     * @param body (optional) 
     * @return OK
     */
    oISOrderFormAutomateTaskEdit(body?: OISOrderFormAutomateTaskEditDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateTask/OISOrderFormAutomateTaskEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOISOrderFormAutomateTaskEdit(_response);
        });
    }

    protected processOISOrderFormAutomateTaskEdit(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 重试次数修改
     * @param id (optional) 
     * @return OK
     */
    oISOrderFormAutomateTaskReTry(id?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateTask/OISOrderFormAutomateTaskReTry?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOISOrderFormAutomateTaskReTry(_response);
        });
    }

    protected processOISOrderFormAutomateTaskReTry(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param t (optional) 
     * @return OK
     */
    getStatusDescription(t?: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateTask/GetStatusDescription?";
        if (t === null)
            throw new globalThis.Error("The parameter 't' cannot be null.");
        else if (t !== undefined)
            url_ += "t=" + encodeURIComponent("" + t) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatusDescription(_response);
        });
    }

    protected processGetStatusDescription(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 按查询条件导出excel
     * @param body (optional) 
     * @return OK
     */
    oISOrderFormAutomateTaskExcel(body?: OISOrderFormAutomateTaskPageInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateTask/OISOrderFormAutomateTaskExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOISOrderFormAutomateTaskExcel(_response);
        });
    }

    protected processOISOrderFormAutomateTaskExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class OISOrderFormAutomateTaskStatusServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    taskStatusAdd(body?: OISOrderFormAutomateTaskStatusAddDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateTaskStatus/TaskStatusAdd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTaskStatusAdd(_response);
        });
    }

    protected processTaskStatusAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 自动审单结果修改
     * @param body (optional) 
     * @return OK
     */
    taskStatusEdit(body?: OISOrderFormAutomateTaskStatusEditDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateTaskStatus/TaskStatusEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTaskStatusEdit(_response);
        });
    }

    protected processTaskStatusEdit(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    taskStatusEditTwo(body?: OISOrderFormAutomateTaskStatusAddDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OISOrderFormAutomateTaskStatus/TaskStatusEditTwo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTaskStatusEditTwo(_response);
        });
    }

    protected processTaskStatusEditTwo(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class OrderServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取所有订单信息
     * @param body (optional) 
     * @return OK
     */
    getOrderFormAll(body?: PageOrderFormAllDto | undefined, cancelToken?: CancelToken): Promise<GetOrderFormAllTotalCountDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/Order/GetOrderFormAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderFormAll(_response);
        });
    }

    protected processGetOrderFormAll(response: AxiosResponse): Promise<GetOrderFormAllTotalCountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOrderFormAllTotalCountDto.fromJS(resultData200);
            return Promise.resolve<GetOrderFormAllTotalCountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrderFormAllTotalCountDto>(null as any);
    }

    /**
     * 获取所有订单信息-导出
     * @param exportType (optional) 1:导出简单；2:导出详单
     * @param body (optional) 
     * @return OK
     */
    exportOrderFormAll(exportType?: number | undefined, body?: PageOrderFormAllDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/Order/ExportOrderFormAll?";
        if (exportType === null)
            throw new globalThis.Error("The parameter 'exportType' cannot be null.");
        else if (exportType !== undefined)
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportOrderFormAll(_response);
        });
    }

    protected processExportOrderFormAll(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class OrderApprovalServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取所有订单维度相关审批记录
     * @param body (optional) 
     * @return OK
     */
    getOrderFormApprovalAll(body?: PageOrderFormApprovalAllDto | undefined, cancelToken?: CancelToken): Promise<GetOrderFormApprovalTotalCountDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderApproval/GetOrderFormApprovalAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderFormApprovalAll(_response);
        });
    }

    protected processGetOrderFormApprovalAll(response: AxiosResponse): Promise<GetOrderFormApprovalTotalCountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOrderFormApprovalTotalCountDto.fromJS(resultData200);
            return Promise.resolve<GetOrderFormApprovalTotalCountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrderFormApprovalTotalCountDto>(null as any);
    }

    /**
     * 获取所有订单维度相关记录-Job导出
     * @param body (optional) 
     * @return OK
     */
    exportGetOrderFormApprovalAll(body?: PageOrderFormApprovalAllDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderApproval/ExportGetOrderFormApprovalAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportGetOrderFormApprovalAll(_response);
        });
    }

    protected processExportGetOrderFormApprovalAll(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取所有订单维度相关审批记录-导出
     * @param body (optional) 
     * @return OK
     */
    exportOrderFormFromApprovalForJob(body?: PageOrderFormApprovalAllDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderApproval/ExportOrderFormFromApprovalForJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportOrderFormFromApprovalForJob(_response);
        });
    }

    protected processExportOrderFormFromApprovalForJob(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 更新审单状态(已阅/未阅/已阅有问题)
     * @param body (optional) 
     * @return OK
     */
    modifyOrderApprovalStatus(body?: ModifyOrderApprovalStatusParam | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderApproval/ModifyOrderApprovalStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModifyOrderApprovalStatus(_response);
        });
    }

    protected processModifyOrderApprovalStatus(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class OrderApprovalCallbackServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 订单审批完成回调接口
    供审批流程在审批结束后调用
     * @param body (optional) 审批回调输入
     * @return OK
     */
    onApprovalCompleted(body?: ApprovalCallbackInputDto | undefined, cancelToken?: CancelToken): Promise<ApprovalCallbackResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderApprovalCallback/OnApprovalCompleted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOnApprovalCompleted(_response);
        });
    }

    protected processOnApprovalCompleted(response: AxiosResponse): Promise<ApprovalCallbackResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApprovalCallbackResultDto.fromJS(resultData200);
            return Promise.resolve<ApprovalCallbackResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApprovalCallbackResultDto>(null as any);
    }
}

export class OrderAutomateServiceServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取订单相关操作行为日志
     * @param body (optional) 
     * @return OK
     */
    pageAutomateLogsForOrder(body?: PageAutomateLogsForOrderParam | undefined, cancelToken?: CancelToken): Promise<PageAutomateLogForOrderDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderAutomateService/PageAutomateLogsForOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPageAutomateLogsForOrder(_response);
        });
    }

    protected processPageAutomateLogsForOrder(response: AxiosResponse): Promise<PageAutomateLogForOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageAutomateLogForOrderDto.fromJS(resultData200);
            return Promise.resolve<PageAutomateLogForOrderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageAutomateLogForOrderDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    pageAutomateLogsStatusForOrder(body?: PageAutomateLogsStatusForOrderParam | undefined, cancelToken?: CancelToken): Promise<PageAutomateLogForOrderDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderAutomateService/PageAutomateLogsStatusForOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPageAutomateLogsStatusForOrder(_response);
        });
    }

    protected processPageAutomateLogsStatusForOrder(response: AxiosResponse): Promise<PageAutomateLogForOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageAutomateLogForOrderDto.fromJS(resultData200);
            return Promise.resolve<PageAutomateLogForOrderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageAutomateLogForOrderDto>(null as any);
    }

    /**
     * 写入订单操作日志,
     * @param body (optional) 
     * @return OK
     */
    writeAutomateLogForOrder(body?: WriteAutomateLogForOrderParam | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderAutomateService/WriteAutomateLogForOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWriteAutomateLogForOrder(_response);
        });
    }

    protected processWriteAutomateLogForOrder(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取待录单订单列表(每次返回 100 条订单)
     * @return OK
     */
    getTodoInfosForOrder( cancelToken?: CancelToken): Promise<GetTodoInfosForOrderDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderAutomateService/GetTodoInfosForOrder";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTodoInfosForOrder(_response);
        });
    }

    protected processGetTodoInfosForOrder(response: AxiosResponse): Promise<GetTodoInfosForOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTodoInfosForOrderDto.fromJS(resultData200);
            return Promise.resolve<GetTodoInfosForOrderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTodoInfosForOrderDto>(null as any);
    }

    /**
     * 获取待录单订单详情-导出
    1. 根据ID获取产品，跟选型信息
    2. 根据ID 获取订单信息
     * @param orderFormId (optional) 
     * @return OK
     */
    exportTodoDetailForOrder(orderFormId?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderAutomateService/ExportTodoDetailForOrder?";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "orderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportTodoDetailForOrder(_response);
        });
    }

    protected processExportTodoDetailForOrder(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class OrderChangeServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 新增订单变更
     * @param orderFormId (optional) 
     * @return OK
     */
    getAll(orderFormId?: string | undefined, cancelToken?: CancelToken): Promise<OrderChangeDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChange/GetAll?";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "orderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<OrderChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderChangeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderChangeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeDto[]>(null as any);
    }

    /**
     * 新增订单变更
     * @param body (optional) 
     * @return OK
     */
    insert(body?: InsertOrderChangeDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChange/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新增订单变更
     * @param modelId (optional) 
     * @return OK
     */
    complete(modelId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChange/Complete?";
        if (modelId === null)
            throw new globalThis.Error("The parameter 'modelId' cannot be null.");
        else if (modelId !== undefined)
            url_ += "modelId=" + encodeURIComponent("" + modelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processComplete(_response);
        });
    }

    protected processComplete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OrderChangeOrderFormServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 初始化订单变更单数据 优化后
     * @param orderFormId (optional) 
     * @return OK
     */
    initOrderChangeOrderForm(orderFormId?: string | undefined, cancelToken?: CancelToken): Promise<OrderChangeOrderFormVersions> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/InitOrderChangeOrderForm?";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "orderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitOrderChangeOrderForm(_response);
        });
    }

    protected processInitOrderChangeOrderForm(response: AxiosResponse): Promise<OrderChangeOrderFormVersions> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderChangeOrderFormVersions.fromJS(resultData200);
            return Promise.resolve<OrderChangeOrderFormVersions>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeOrderFormVersions>(null as any);
    }

    /**
     * 跳转指定版本
     * @param orderFormId (optional) 
     * @return OK
     */
    getOrderChangeOrderFormByOrderFormId(orderFormId?: string | undefined, cancelToken?: CancelToken): Promise<OrderChangeOrderForm> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetOrderChangeOrderFormByOrderFormId?";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "orderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderChangeOrderFormByOrderFormId(_response);
        });
    }

    protected processGetOrderChangeOrderFormByOrderFormId(response: AxiosResponse): Promise<OrderChangeOrderForm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderChangeOrderForm.fromJS(resultData200);
            return Promise.resolve<OrderChangeOrderForm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeOrderForm>(null as any);
    }

    /**
     * 根据任务ID获取订单变更单
     * @param taskServiceRequestId (optional) 
     * @return OK
     */
    getOrderChangeOrderFormByTaskServiceRequestId(taskServiceRequestId?: string | undefined, cancelToken?: CancelToken): Promise<OrderChangeOrderFormDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetOrderChangeOrderFormByTaskServiceRequestId?";
        if (taskServiceRequestId === null)
            throw new globalThis.Error("The parameter 'taskServiceRequestId' cannot be null.");
        else if (taskServiceRequestId !== undefined)
            url_ += "taskServiceRequestId=" + encodeURIComponent("" + taskServiceRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderChangeOrderFormByTaskServiceRequestId(_response);
        });
    }

    protected processGetOrderChangeOrderFormByTaskServiceRequestId(response: AxiosResponse): Promise<OrderChangeOrderFormDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderChangeOrderFormDto.fromJS(resultData200);
            return Promise.resolve<OrderChangeOrderFormDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeOrderFormDto>(null as any);
    }

    /**
     * 根据任务ID获取订单变更单CSO--ISO
     * @param body (optional) 
     * @return OK
     */
    getOrderChangeOrderFormCsoIsoByTaskServiceRequestId(body?: OrderChangeOrderFormCsoIsoByTaskServiceRequestInDto[] | undefined, cancelToken?: CancelToken): Promise<OrderChangeOrderFormCsoIsoByTaskServiceRequestOutDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetOrderChangeOrderFormCsoIsoByTaskServiceRequestId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderChangeOrderFormCsoIsoByTaskServiceRequestId(_response);
        });
    }

    protected processGetOrderChangeOrderFormCsoIsoByTaskServiceRequestId(response: AxiosResponse): Promise<OrderChangeOrderFormCsoIsoByTaskServiceRequestOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderChangeOrderFormCsoIsoByTaskServiceRequestOutDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderChangeOrderFormCsoIsoByTaskServiceRequestOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeOrderFormCsoIsoByTaskServiceRequestOutDto[]>(null as any);
    }

    /**
     * 根据taskServiceRequest变更订单状态
     * @param body (optional) 
     * @return OK
     */
    updateOrderStatusByTaskRequest(body?: TaskServiceChangeOrderFormDto | undefined, cancelToken?: CancelToken): Promise<OrderChangeOrderFormVersionsDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/UpdateOrderStatusByTaskRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrderStatusByTaskRequest(_response);
        });
    }

    protected processUpdateOrderStatusByTaskRequest(response: AxiosResponse): Promise<OrderChangeOrderFormVersionsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderChangeOrderFormVersionsDto.fromJS(resultData200);
            return Promise.resolve<OrderChangeOrderFormVersionsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeOrderFormVersionsDto>(null as any);
    }

    /**
     * 获取最大版本数据.
     * @param orderFormId (optional) 
     * @return OK
     */
    getOrderChangeOrderFormVersionsByOrderFormId(orderFormId?: string | undefined, cancelToken?: CancelToken): Promise<OrderChangeOrderFormVersionsDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetOrderChangeOrderFormVersionsByOrderFormId?";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "orderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderChangeOrderFormVersionsByOrderFormId(_response);
        });
    }

    protected processGetOrderChangeOrderFormVersionsByOrderFormId(response: AxiosResponse): Promise<OrderChangeOrderFormVersionsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderChangeOrderFormVersionsDto.fromJS(resultData200);
            return Promise.resolve<OrderChangeOrderFormVersionsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeOrderFormVersionsDto>(null as any);
    }

    /**
     * @param orderFormId (optional) 
     * @param orderChangeOrderFormId (optional) 
     * @return OK
     */
    getOrderChangeOrderForm(orderFormId?: string | undefined, orderChangeOrderFormId?: string | undefined, cancelToken?: CancelToken): Promise<OrderChangeOrderFormDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetOrderChangeOrderForm?";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "orderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        if (orderChangeOrderFormId === null)
            throw new globalThis.Error("The parameter 'orderChangeOrderFormId' cannot be null.");
        else if (orderChangeOrderFormId !== undefined)
            url_ += "orderChangeOrderFormId=" + encodeURIComponent("" + orderChangeOrderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderChangeOrderForm(_response);
        });
    }

    protected processGetOrderChangeOrderForm(response: AxiosResponse): Promise<OrderChangeOrderFormDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderChangeOrderFormDto.fromJS(resultData200);
            return Promise.resolve<OrderChangeOrderFormDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeOrderFormDto>(null as any);
    }

    /**
     * 获取变更汇总信息  弃用
     * @param versionId (optional) 
     * @return OK
     */
    getOrderChangeSummary(versionId?: string | undefined, cancelToken?: CancelToken): Promise<OrderChangeSummaryOutDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetOrderChangeSummary?";
        if (versionId === null)
            throw new globalThis.Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderChangeSummary(_response);
        });
    }

    protected processGetOrderChangeSummary(response: AxiosResponse): Promise<OrderChangeSummaryOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderChangeSummaryOutDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderChangeSummaryOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeSummaryOutDto[]>(null as any);
    }

    /**
     * 获取excel样式的变更汇总信息
     * @param versionId (optional) 
     * @param taskServiceRequestId (optional) 
     * @return OK
     */
    getNewOrderChangeSummary(versionId?: string | undefined, taskServiceRequestId?: string | undefined, cancelToken?: CancelToken): Promise<NewOrderChangeSummaryOutDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetNewOrderChangeSummary?";
        if (versionId === null)
            throw new globalThis.Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        if (taskServiceRequestId === null)
            throw new globalThis.Error("The parameter 'taskServiceRequestId' cannot be null.");
        else if (taskServiceRequestId !== undefined)
            url_ += "taskServiceRequestId=" + encodeURIComponent("" + taskServiceRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewOrderChangeSummary(_response);
        });
    }

    protected processGetNewOrderChangeSummary(response: AxiosResponse): Promise<NewOrderChangeSummaryOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NewOrderChangeSummaryOutDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<NewOrderChangeSummaryOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewOrderChangeSummaryOutDto[]>(null as any);
    }

    /**
     * 内销订单汇总下载
     * @param versionId (optional) 
     * @param taskServiceRequestId (optional) 
     * @return OK
     */
    getNewOrderChangeSummaryToExcelStream(versionId?: string | undefined, taskServiceRequestId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetNewOrderChangeSummaryToExcelStream?";
        if (versionId === null)
            throw new globalThis.Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        if (taskServiceRequestId === null)
            throw new globalThis.Error("The parameter 'taskServiceRequestId' cannot be null.");
        else if (taskServiceRequestId !== undefined)
            url_ += "taskServiceRequestId=" + encodeURIComponent("" + taskServiceRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewOrderChangeSummaryToExcelStream(_response);
        });
    }

    protected processGetNewOrderChangeSummaryToExcelStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取变更
     * @param versionId (optional) 
     * @param taskServiceRequestId (optional) 
     * @return OK
     */
    getOrderChangeProductBasicMotorChanges(versionId?: string | undefined, taskServiceRequestId?: string | undefined, cancelToken?: CancelToken): Promise<OrderChangeOrderFormVCDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetOrderChangeProductBasicMotorChanges?";
        if (versionId === null)
            throw new globalThis.Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        if (taskServiceRequestId === null)
            throw new globalThis.Error("The parameter 'taskServiceRequestId' cannot be null.");
        else if (taskServiceRequestId !== undefined)
            url_ += "taskServiceRequestId=" + encodeURIComponent("" + taskServiceRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderChangeProductBasicMotorChanges(_response);
        });
    }

    protected processGetOrderChangeProductBasicMotorChanges(response: AxiosResponse): Promise<OrderChangeOrderFormVCDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderChangeOrderFormVCDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderChangeOrderFormVCDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeOrderFormVCDto[]>(null as any);
    }

    /**
     * 暂存  优化后
     * @param body (optional) 
     * @return OK
     */
    saveChange(body?: AddConfirmChangeOrderFromDto | undefined, cancelToken?: CancelToken): Promise<OrderChangeOrderFormDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/SaveChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveChange(_response);
        });
    }

    protected processSaveChange(response: AxiosResponse): Promise<OrderChangeOrderFormDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderChangeOrderFormDto.fromJS(resultData200);
            return Promise.resolve<OrderChangeOrderFormDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeOrderFormDto>(null as any);
    }

    /**
     * 发起确认
     * @param body (optional) 
     * @return OK
     */
    confirmChange(body?: AddConfirmChangeOrderFromDto | undefined, cancelToken?: CancelToken): Promise<CreateOrderChangeMajorDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/ConfirmChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmChange(_response);
        });
    }

    protected processConfirmChange(response: AxiosResponse): Promise<CreateOrderChangeMajorDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrderChangeMajorDto.fromJS(resultData200);
            return Promise.resolve<CreateOrderChangeMajorDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrderChangeMajorDto>(null as any);
    }

    /**
     * 变更审核
     * @param orderChangeOrderFormId (optional) 
     * @param approvalRemark (optional) 
     * @param approvalStatus (optional) 
     * @return OK
     */
    approvalChange(orderChangeOrderFormId?: string | undefined, approvalRemark?: string | undefined, approvalStatus?: number | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/ApprovalChange?";
        if (orderChangeOrderFormId === null)
            throw new globalThis.Error("The parameter 'orderChangeOrderFormId' cannot be null.");
        else if (orderChangeOrderFormId !== undefined)
            url_ += "OrderChangeOrderFormId=" + encodeURIComponent("" + orderChangeOrderFormId) + "&";
        if (approvalRemark === null)
            throw new globalThis.Error("The parameter 'approvalRemark' cannot be null.");
        else if (approvalRemark !== undefined)
            url_ += "approvalRemark=" + encodeURIComponent("" + approvalRemark) + "&";
        if (approvalStatus === null)
            throw new globalThis.Error("The parameter 'approvalStatus' cannot be null.");
        else if (approvalStatus !== undefined)
            url_ += "approvalStatus=" + encodeURIComponent("" + approvalStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApprovalChange(_response);
        });
    }

    protected processApprovalChange(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 发起变更选型
    发起变更选型,注意,需要先调用暂存..  优化后
     * @param body (optional) 
     * @return OK
     */
    changeSC(body?: OrderChangeOrderFormDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/ChangeSC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeSC(_response);
        });
    }

    protected processChangeSC(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 创建新版本  优化后代码
     * @param body (optional) 
     * @return OK
     */
    createNewOrderChangeVersion(body?: OrderChangeOrderFormDto | undefined, cancelToken?: CancelToken): Promise<OrderChangeOrderFormDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/CreateNewOrderChangeVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateNewOrderChangeVersion(_response);
        });
    }

    protected processCreateNewOrderChangeVersion(response: AxiosResponse): Promise<OrderChangeOrderFormDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderChangeOrderFormDto.fromJS(resultData200);
            return Promise.resolve<OrderChangeOrderFormDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeOrderFormDto>(null as any);
    }

    /**
     * 根据当前退回版本创建新版本
     * @param body (optional) 
     * @return OK
     */
    createNewOrderChangeVersionByReject(body?: OrderChangeOrderFormDto | undefined, cancelToken?: CancelToken): Promise<OrderChangeOrderFormDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/CreateNewOrderChangeVersionByReject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateNewOrderChangeVersionByReject(_response);
        });
    }

    protected processCreateNewOrderChangeVersionByReject(response: AxiosResponse): Promise<OrderChangeOrderFormDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderChangeOrderFormDto.fromJS(resultData200);
            return Promise.resolve<OrderChangeOrderFormDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeOrderFormDto>(null as any);
    }

    /**
     * @param orderChangeOrderFormId (optional) 
     * @return OK
     */
    isLockOrderChange(orderChangeOrderFormId?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/IsLockOrderChange?";
        if (orderChangeOrderFormId === null)
            throw new globalThis.Error("The parameter 'orderChangeOrderFormId' cannot be null.");
        else if (orderChangeOrderFormId !== undefined)
            url_ += "orderChangeOrderFormId=" + encodeURIComponent("" + orderChangeOrderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsLockOrderChange(_response);
        });
    }

    protected processIsLockOrderChange(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 确认SC变更  优化后
     * @param body (optional) 
     * @return OK
     */
    confirmOrderChange(body?: ConfirmChangeOrderFormDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/ConfirmOrderChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmOrderChange(_response);
        });
    }

    protected processConfirmOrderChange(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 根据版本ID获取BOM产品数据
     * @param body (optional) 查询参数
     * @return OK
     */
    getBomProducts(body?: QueryBOMProductDto | undefined, cancelToken?: CancelToken): Promise<BomStatusOfProductDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetBomProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBomProducts(_response);
        });
    }

    protected processGetBomProducts(response: AxiosResponse): Promise<BomStatusOfProductDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BomStatusOfProductDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BomStatusOfProductDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BomStatusOfProductDto[]>(null as any);
    }

    /**
     * 导出BOM产品数据
     * @param body (optional) 
     * @return OK
     */
    exportBomProducts(body?: QueryBOMProductDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/ExportBomProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportBomProducts(_response);
        });
    }

    protected processExportBomProducts(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 根据产品ID获取BomStatusOfProduct
     * @param body (optional) 
     * @return OK
     */
    getBomProductsById(body?: string[] | undefined, cancelToken?: CancelToken): Promise<BomStatusOfProductDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetBomProductsById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBomProductsById(_response);
        });
    }

    protected processGetBomProductsById(response: AxiosResponse): Promise<BomStatusOfProductDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BomStatusOfProductDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BomStatusOfProductDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BomStatusOfProductDto[]>(null as any);
    }

    /**
     * 实时修改版本数据.
     * @param body (optional) 
     * @return OK
     */
    updateBomStatusOfProduct(body?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/UpdateBomStatusOfProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBomStatusOfProduct(_response);
        });
    }

    protected processUpdateBomStatusOfProduct(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 测试总交期影响计算逻辑
     * @param id (optional) 
     * @param compnow (optional) 
     * @return OK
     */
    testDelayDay(id?: string | undefined, compnow?: moment.Moment | undefined, cancelToken?: CancelToken): Promise<OrderChangeProductBasicProcessEntity[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/testDelayDay?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (compnow === null)
            throw new globalThis.Error("The parameter 'compnow' cannot be null.");
        else if (compnow !== undefined)
            url_ += "compnow=" + encodeURIComponent(compnow ? "" + compnow.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestDelayDay(_response);
        });
    }

    protected processTestDelayDay(response: AxiosResponse): Promise<OrderChangeProductBasicProcessEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderChangeProductBasicProcessEntity.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderChangeProductBasicProcessEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeProductBasicProcessEntity[]>(null as any);
    }

    /**
     * 获取所有订单信息
     * @param body (optional) 
     * @return OK
     */
    getOrderChangeOrderFormAll(body?: PageOrderFormAllDto | undefined, cancelToken?: CancelToken): Promise<GetOrderChangeOrderFormAllTotalCountDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetOrderChangeOrderFormAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderChangeOrderFormAll(_response);
        });
    }

    protected processGetOrderChangeOrderFormAll(response: AxiosResponse): Promise<GetOrderChangeOrderFormAllTotalCountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOrderChangeOrderFormAllTotalCountDto.fromJS(resultData200);
            return Promise.resolve<GetOrderChangeOrderFormAllTotalCountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrderChangeOrderFormAllTotalCountDto>(null as any);
    }

    /**
     * 获取订单产品备注信息
     * @param productId (optional) 
     * @return OK
     */
    getProductRemark(productId?: string | undefined, cancelToken?: CancelToken): Promise<any[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetProductRemark?";
        if (productId === null)
            throw new globalThis.Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/xml"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductRemark(_response);
        });
    }

    protected processGetProductRemark(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }

    /**
     * 更新主表锁
     * @param requestId (optional) 
     * @param body (optional) 
     * @return OK
     */
    executionUpdateChangeOrderMain(requestId?: string | undefined, body?: EnumOrderChangeOrderFormVersionsStatus | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/ExecutionUpdateChangeOrderMain?";
        if (requestId === null)
            throw new globalThis.Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExecutionUpdateChangeOrderMain(_response);
        });
    }

    protected processExecutionUpdateChangeOrderMain(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取子任务信息
     * @param taskId (optional) 
     * @return OK
     */
    getOrderChangeOrderFormTaskLetByMainTaskId(taskId?: string | undefined, cancelToken?: CancelToken): Promise<OrderChangeOrderFormTaskLetDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetOrderChangeOrderFormTaskLetByMainTaskId?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderChangeOrderFormTaskLetByMainTaskId(_response);
        });
    }

    protected processGetOrderChangeOrderFormTaskLetByMainTaskId(response: AxiosResponse): Promise<OrderChangeOrderFormTaskLetDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderChangeOrderFormTaskLetDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderChangeOrderFormTaskLetDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeOrderFormTaskLetDto[]>(null as any);
    }

    /**
     * 计算版本整单总报价和总可接受价格
     * @param body (optional) 版本Id与行信息
     * @return OK
     */
    calculateProductForAll(body?: QueryBOMProductDto | undefined, cancelToken?: CancelToken): Promise<CalculateProductForAllDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/CalculateProductForAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateProductForAll(_response);
        });
    }

    protected processCalculateProductForAll(response: AxiosResponse): Promise<CalculateProductForAllDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CalculateProductForAllDto.fromJS(resultData200);
            return Promise.resolve<CalculateProductForAllDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalculateProductForAllDto>(null as any);
    }

    /**
     * 商务填写折扣系数，计算人工报价(单行)
    商务填写报价，计算折扣系数(单行)
     * @param orderChangeFormVersionId (optional) 版本Id
     * @param inputSerialNumber (optional) 待计算行序号
     * @param inputMultiplier (optional) 商务折扣系数
     * @param inputPrice (optional) 行报价
     * @param exchangeRateAndTariff (optional) 汇率*关税
     * @return OK
     */
    calculateProductQuote(orderChangeFormVersionId?: string | undefined, inputSerialNumber?: number | undefined, inputMultiplier?: number | undefined, inputPrice?: number | undefined, exchangeRateAndTariff?: number | undefined, cancelToken?: CancelToken): Promise<CalculateProductQuoteDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/CalculateProductQuote?";
        if (orderChangeFormVersionId === null)
            throw new globalThis.Error("The parameter 'orderChangeFormVersionId' cannot be null.");
        else if (orderChangeFormVersionId !== undefined)
            url_ += "orderChangeFormVersionId=" + encodeURIComponent("" + orderChangeFormVersionId) + "&";
        if (inputSerialNumber === null)
            throw new globalThis.Error("The parameter 'inputSerialNumber' cannot be null.");
        else if (inputSerialNumber !== undefined)
            url_ += "inputSerialNumber=" + encodeURIComponent("" + inputSerialNumber) + "&";
        if (inputMultiplier === null)
            throw new globalThis.Error("The parameter 'inputMultiplier' cannot be null.");
        else if (inputMultiplier !== undefined)
            url_ += "inputMultiplier=" + encodeURIComponent("" + inputMultiplier) + "&";
        if (inputPrice === null)
            throw new globalThis.Error("The parameter 'inputPrice' cannot be null.");
        else if (inputPrice !== undefined)
            url_ += "inputPrice=" + encodeURIComponent("" + inputPrice) + "&";
        if (exchangeRateAndTariff === null)
            throw new globalThis.Error("The parameter 'exchangeRateAndTariff' cannot be null.");
        else if (exchangeRateAndTariff !== undefined)
            url_ += "exchangeRateAndTariff=" + encodeURIComponent("" + exchangeRateAndTariff) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateProductQuote(_response);
        });
    }

    protected processCalculateProductQuote(response: AxiosResponse): Promise<CalculateProductQuoteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CalculateProductQuoteDto.fromJS(resultData200);
            return Promise.resolve<CalculateProductQuoteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalculateProductQuoteDto>(null as any);
    }

    /**
     * 优化增加批量拉取 商务填写折扣系数，计算人工报价（和上面单行一样这个只是做优化）
     * @param body (optional) 
     * @return OK
     */
    calculateProductQuoteForAllList(body?: QueryBOMProductForAllDto | undefined, cancelToken?: CancelToken): Promise<CalculateProductQuoteDtoForALL[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/CalculateProductQuoteForAllList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateProductQuoteForAllList(_response);
        });
    }

    protected processCalculateProductQuoteForAllList(response: AxiosResponse): Promise<CalculateProductQuoteDtoForALL[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalculateProductQuoteDtoForALL.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CalculateProductQuoteDtoForALL[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalculateProductQuoteDtoForALL[]>(null as any);
    }

    /**
     * @param key (optional) 
     * @return OK
     */
    getCacheValue(key?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetCacheValue?";
        if (key === null)
            throw new globalThis.Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCacheValue(_response);
        });
    }

    protected processGetCacheValue(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param key (optional) 
     * @return OK
     */
    getCacheByCalculateProductQuoteDto(key?: string | undefined, cancelToken?: CancelToken): Promise<CalculateProductQuoteDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetCacheByCalculateProductQuoteDto?";
        if (key === null)
            throw new globalThis.Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCacheByCalculateProductQuoteDto(_response);
        });
    }

    protected processGetCacheByCalculateProductQuoteDto(response: AxiosResponse): Promise<CalculateProductQuoteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CalculateProductQuoteDto.fromJS(resultData200);
            return Promise.resolve<CalculateProductQuoteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalculateProductQuoteDto>(null as any);
    }

    /**
     * 根据任务ID判断是否为内销订单
     * @param taskId (optional) 任务ID
     * @return OK
     */
    isDomesticOrder(taskId?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/IsDomesticOrder?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsDomesticOrder(_response);
        });
    }

    protected processIsDomesticOrder(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 添加审核日志
     * @param body (optional) 
     * @return OK
     */
    addOrderChangeAuditLogs(body?: OrderChangeTaskAuditLogsDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/AddOrderChangeAuditLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrderChangeAuditLogs(_response);
        });
    }

    protected processAddOrderChangeAuditLogs(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * TODO:需要结合产线进行计算
    产线来源SAP接口
     * @param pmuSoitemCategory (optional) 例子:ZB48
     * @param orderType (optional) 
     * @param productionLine (optional) 
     * @return OK
     */
    getSAPOrderType(pmuSoitemCategory?: string | undefined, orderType?: string | undefined, productionLine?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetSAPOrderType?";
        if (pmuSoitemCategory === null)
            throw new globalThis.Error("The parameter 'pmuSoitemCategory' cannot be null.");
        else if (pmuSoitemCategory !== undefined)
            url_ += "pmuSoitemCategory=" + encodeURIComponent("" + pmuSoitemCategory) + "&";
        if (orderType === null)
            throw new globalThis.Error("The parameter 'orderType' cannot be null.");
        else if (orderType !== undefined)
            url_ += "orderType=" + encodeURIComponent("" + orderType) + "&";
        if (productionLine === null)
            throw new globalThis.Error("The parameter 'productionLine' cannot be null.");
        else if (productionLine !== undefined)
            url_ += "productionLine=" + encodeURIComponent("" + productionLine) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSAPOrderType(_response);
        });
    }

    protected processGetSAPOrderType(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 调用接口获取SAP数据
     * @param body (optional) 
     * @return OK
     */
    getSAP(body?: QueryZppMotMpsLifeDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetSAP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSAP(_response);
        });
    }

    protected processGetSAP(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取订单变更版本的基本电机信息
     * @param basicMotorCode (optional) 
     * @param serialNumber (optional) 
     * @param orderChangeOrderFormId (optional) 
     * @param taskServiceRequestId (optional) 
     * @return OK
     */
    getOrderChangeOrderFormBasicMotorCodeAllVersion(basicMotorCode?: string | undefined, serialNumber?: number | undefined, orderChangeOrderFormId?: string | undefined, taskServiceRequestId?: string | undefined, cancelToken?: CancelToken): Promise<OrderChangeProductBasicMotorVersionAllDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetOrderChangeOrderFormBasicMotorCodeAllVersion?";
        if (basicMotorCode === null)
            throw new globalThis.Error("The parameter 'basicMotorCode' cannot be null.");
        else if (basicMotorCode !== undefined)
            url_ += "basicMotorCode=" + encodeURIComponent("" + basicMotorCode) + "&";
        if (serialNumber === null)
            throw new globalThis.Error("The parameter 'serialNumber' cannot be null.");
        else if (serialNumber !== undefined)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (orderChangeOrderFormId === null)
            throw new globalThis.Error("The parameter 'orderChangeOrderFormId' cannot be null.");
        else if (orderChangeOrderFormId !== undefined)
            url_ += "orderChangeOrderFormId=" + encodeURIComponent("" + orderChangeOrderFormId) + "&";
        if (taskServiceRequestId === null)
            throw new globalThis.Error("The parameter 'taskServiceRequestId' cannot be null.");
        else if (taskServiceRequestId !== undefined)
            url_ += "taskServiceRequestId=" + encodeURIComponent("" + taskServiceRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderChangeOrderFormBasicMotorCodeAllVersion(_response);
        });
    }

    protected processGetOrderChangeOrderFormBasicMotorCodeAllVersion(response: AxiosResponse): Promise<OrderChangeProductBasicMotorVersionAllDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderChangeProductBasicMotorVersionAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderChangeProductBasicMotorVersionAllDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeProductBasicMotorVersionAllDto[]>(null as any);
    }

    /**
     * @param changes (optional) 
     * @return OK
     */
    getChangeStrAfter(changes?: OrderChangeProductBasicMotorChange[] | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetChangeStrAfter?";
        if (changes === null)
            throw new globalThis.Error("The parameter 'changes' cannot be null.");
        else if (changes !== undefined)
            changes && changes.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "changes[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChangeStrAfter(_response);
        });
    }

    protected processGetChangeStrAfter(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param changes (optional) 
     * @return OK
     */
    getChangeStrBefore(changes?: OrderChangeProductBasicMotorChange[] | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetChangeStrBefore?";
        if (changes === null)
            throw new globalThis.Error("The parameter 'changes' cannot be null.");
        else if (changes !== undefined)
            changes && changes.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "changes[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChangeStrBefore(_response);
        });
    }

    protected processGetChangeStrBefore(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取备注信息
     * @param versionId (optional) 
     * @param versionsList (optional) 
     * @param motorChangesList (optional) 
     * @param serialNumber (optional) 
     * @param isMainProcess (optional) 
     * @return OK
     */
    getNewOrderChangeSummaryOutList(versionId?: string | undefined, versionsList?: OrderChangeOrderFormVersions[] | undefined, motorChangesList?: OrderChangeProductBasicMotorChange[] | undefined, serialNumber?: number | undefined, isMainProcess?: boolean | undefined, cancelToken?: CancelToken): Promise<NewOrderChangeSummaryOutDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetNewOrderChangeSummaryOutList?";
        if (versionId === null)
            throw new globalThis.Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        if (versionsList === null)
            throw new globalThis.Error("The parameter 'versionsList' cannot be null.");
        else if (versionsList !== undefined)
            versionsList && versionsList.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "VersionsList[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (motorChangesList === null)
            throw new globalThis.Error("The parameter 'motorChangesList' cannot be null.");
        else if (motorChangesList !== undefined)
            motorChangesList && motorChangesList.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "MotorChangesList[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (serialNumber === null)
            throw new globalThis.Error("The parameter 'serialNumber' cannot be null.");
        else if (serialNumber !== undefined)
            url_ += "SerialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (isMainProcess === null)
            throw new globalThis.Error("The parameter 'isMainProcess' cannot be null.");
        else if (isMainProcess !== undefined)
            url_ += "isMainProcess=" + encodeURIComponent("" + isMainProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewOrderChangeSummaryOutList(_response);
        });
    }

    protected processGetNewOrderChangeSummaryOutList(response: AxiosResponse): Promise<NewOrderChangeSummaryOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NewOrderChangeSummaryOutDto.fromJS(resultData200);
            return Promise.resolve<NewOrderChangeSummaryOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewOrderChangeSummaryOutDto>(null as any);
    }

    /**
     * 是否修改/新增，VC163/209，不包含类型：999163
     * @param orderChangeOrderFormId (optional) 
     * @return OK
     */
    isChangeOrAddVC163209(orderChangeOrderFormId?: string | undefined, cancelToken?: CancelToken): Promise<OrderChangeProductBasicMotorChange[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/IsChangeOrAddVC163209?";
        if (orderChangeOrderFormId === null)
            throw new globalThis.Error("The parameter 'orderChangeOrderFormId' cannot be null.");
        else if (orderChangeOrderFormId !== undefined)
            url_ += "OrderChangeOrderFormId=" + encodeURIComponent("" + orderChangeOrderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsChangeOrAddVC163209(_response);
        });
    }

    protected processIsChangeOrAddVC163209(response: AxiosResponse): Promise<OrderChangeProductBasicMotorChange[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderChangeProductBasicMotorChange.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderChangeProductBasicMotorChange[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeProductBasicMotorChange[]>(null as any);
    }

    /**
     * 查询变更的VC ,只返回 vc 163、209
     * @param orderChangeOrderFormId (optional) 
     * @return OK
     */
    getOrderChangeProductBasicMotorVC163209(orderChangeOrderFormId?: string | undefined, cancelToken?: CancelToken): Promise<OrderChangeProductVCOut[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetOrderChangeProductBasicMotorVC163209?";
        if (orderChangeOrderFormId === null)
            throw new globalThis.Error("The parameter 'orderChangeOrderFormId' cannot be null.");
        else if (orderChangeOrderFormId !== undefined)
            url_ += "orderChangeOrderFormId=" + encodeURIComponent("" + orderChangeOrderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderChangeProductBasicMotorVC163209(_response);
        });
    }

    protected processGetOrderChangeProductBasicMotorVC163209(response: AxiosResponse): Promise<OrderChangeProductVCOut[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderChangeProductVCOut.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderChangeProductVCOut[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeProductVCOut[]>(null as any);
    }

    /**
     * 163、209 按选型号，查询是否 该订单已经下单（订单变更）
     * @param modelSelectionId (optional) 
     * @return OK
     */
    getOrderFormByModelSelectionId(modelSelectionId?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetOrderFormByModelSelectionId?";
        if (modelSelectionId === null)
            throw new globalThis.Error("The parameter 'modelSelectionId' cannot be null.");
        else if (modelSelectionId !== undefined)
            url_ += "ModelSelectionId=" + encodeURIComponent("" + modelSelectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderFormByModelSelectionId(_response);
        });
    }

    protected processGetOrderFormByModelSelectionId(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 查询 订单 产品变更版本
     * @param poNumer (optional) 
     * @param serialNumber (optional) 
     * @param basicMotorCode (optional) 
     * @param body (optional) 
     * @return OK
     */
    checkOrderChangeVersionMotor(poNumer?: string | undefined, serialNumber?: number | undefined, basicMotorCode?: string | undefined, body?: { [key: string]: ServiceRequestListOutput; } | undefined, cancelToken?: CancelToken): Promise<CheckOrderChangeVersionMotorDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/CheckOrderChangeVersionMotor?";
        if (poNumer === null)
            throw new globalThis.Error("The parameter 'poNumer' cannot be null.");
        else if (poNumer !== undefined)
            url_ += "PoNumer=" + encodeURIComponent("" + poNumer) + "&";
        if (serialNumber === null)
            throw new globalThis.Error("The parameter 'serialNumber' cannot be null.");
        else if (serialNumber !== undefined)
            url_ += "SerialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (basicMotorCode === null)
            throw new globalThis.Error("The parameter 'basicMotorCode' cannot be null.");
        else if (basicMotorCode !== undefined)
            url_ += "BasicMotorCode=" + encodeURIComponent("" + basicMotorCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckOrderChangeVersionMotor(_response);
        });
    }

    protected processCheckOrderChangeVersionMotor(response: AxiosResponse): Promise<CheckOrderChangeVersionMotorDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckOrderChangeVersionMotorDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckOrderChangeVersionMotorDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckOrderChangeVersionMotorDto[]>(null as any);
    }

    /**
     * 执行列表查询
     * @param body (optional) 
     * @return OK
     */
    getExecutionListAll(body?: OrderChangeExecutionListQueryDto | undefined, cancelToken?: CancelToken): Promise<GetOrderChangeExecutionListTotalCountDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetExecutionListAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExecutionListAll(_response);
        });
    }

    protected processGetExecutionListAll(response: AxiosResponse): Promise<GetOrderChangeExecutionListTotalCountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOrderChangeExecutionListTotalCountDto.fromJS(resultData200);
            return Promise.resolve<GetOrderChangeExecutionListTotalCountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrderChangeExecutionListTotalCountDto>(null as any);
    }

    /**
     * 根据 RequestId 查出执行列表数据；判断当前登录人是否是执行人
     * @param requestId (optional) 主流程或子流程的 requestId
     * @param userId (optional) 当前登录人Id
     * @return OK
     */
    getExecutionListByRequestId(requestId?: string | undefined, userId?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetExecutionListByRequestId?";
        if (requestId === null)
            throw new globalThis.Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExecutionListByRequestId(_response);
        });
    }

    protected processGetExecutionListByRequestId(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 订单变更确认已执行
     * @param requestId (optional) 
     * @return OK
     */
    confirmExecution(requestId?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/ConfirmExecution?";
        if (requestId === null)
            throw new globalThis.Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "RequestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmExecution(_response);
        });
    }

    protected processConfirmExecution(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 删除订单变更表单
     * @param body (optional) 
     * @return OK
     */
    deleteOrderChange(body?: DeleteOrderChangeDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/DeleteOrderChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOrderChange(_response);
        });
    }

    protected processDeleteOrderChange(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 撤销订单变更表单
     * @param body (optional) 
     * @return OK
     */
    revokeOrderChange(body?: RevokeOrderChangeDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/RevokeOrderChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRevokeOrderChange(_response);
        });
    }

    protected processRevokeOrderChange(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取撤销审批数据
     * @param body (optional) 
     * @return OK
     */
    getOrderChangeOrderFormRevokeApproveServiceRequestId(body?: OrderChangeOrderFormRevokeDto[] | undefined, cancelToken?: CancelToken): Promise<OrderChangeOrderFormRevokeDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/GetOrderChangeOrderFormRevokeApproveServiceRequestId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderChangeOrderFormRevokeApproveServiceRequestId(_response);
        });
    }

    protected processGetOrderChangeOrderFormRevokeApproveServiceRequestId(response: AxiosResponse): Promise<OrderChangeOrderFormRevokeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderChangeOrderFormRevokeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderChangeOrderFormRevokeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeOrderFormRevokeDto[]>(null as any);
    }

    /**
     * 审批撤销订单变更表单
     * @param body (optional) 
     * @return OK
     */
    approveOrderChangeOrderFormRevoke(body?: OrderChangeOrderFormRevokeApproveDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/ApproveOrderChangeOrderFormRevoke";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveOrderChangeOrderFormRevoke(_response);
        });
    }

    protected processApproveOrderChangeOrderFormRevoke(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 是CP或者销售
     * @return OK
     */
    isCPorSale( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderChangeOrderForm/IsCPorSale";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsCPorSale(_response);
        });
    }

    protected processIsCPorSale(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class OrderDashboardServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取所有订单维度相关记录
     * @param body (optional) 
     * @return OK
     */
    getOrderDashboard(body?: PageOrderDashboardDto | undefined, cancelToken?: CancelToken): Promise<GetOrderDashbordPageDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderDashboard/GetOrderDashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderDashboard(_response);
        });
    }

    protected processGetOrderDashboard(response: AxiosResponse): Promise<GetOrderDashbordPageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOrderDashbordPageDto.fromJS(resultData200);
            return Promise.resolve<GetOrderDashbordPageDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrderDashbordPageDto>(null as any);
    }

    /**
     * 获取所有订单维度相关记录
     * @param body (optional) 
     * @return OK
     */
    getOrderDashboardStatistics(body?: PageOrderDashboardDto | undefined, cancelToken?: CancelToken): Promise<GetOrderDashbordStatisticsDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderDashboard/GetOrderDashboardStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderDashboardStatistics(_response);
        });
    }

    protected processGetOrderDashboardStatistics(response: AxiosResponse): Promise<GetOrderDashbordStatisticsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOrderDashbordStatisticsDto.fromJS(resultData200);
            return Promise.resolve<GetOrderDashbordStatisticsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrderDashbordStatisticsDto>(null as any);
    }

    /**
     * 获取所有订单维度相关记录-Job导出
     * @param body (optional) 
     * @return OK
     */
    exportGetOrderFormApprovalAll(body?: PageOrderDashboardDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderDashboard/ExportGetOrderFormApprovalAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportGetOrderFormApprovalAll(_response);
        });
    }

    protected processExportGetOrderFormApprovalAll(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取所有订单维度相关记录-导出
     * @param body (optional) 
     * @return OK
     */
    exportGetOrderFormApprovalAllForJob(body?: PageOrderDashboardDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderDashboard/ExportGetOrderFormApprovalAllForJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportGetOrderFormApprovalAllForJob(_response);
        });
    }

    protected processExportGetOrderFormApprovalAllForJob(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class OrderDictionaryServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 创建字典类型
     * @param body (optional) 
     * @return OK
     */
    createDictionaryType(body?: CreateDictionaryTypeDto | undefined, cancelToken?: CancelToken): Promise<DictionaryTypeDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderDictionary/CreateDictionaryType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDictionaryType(_response);
        });
    }

    protected processCreateDictionaryType(response: AxiosResponse): Promise<DictionaryTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DictionaryTypeDto.fromJS(resultData200);
            return Promise.resolve<DictionaryTypeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DictionaryTypeDto>(null as any);
    }

    /**
     * @return OK
     */
    getDictionaryTypes( cancelToken?: CancelToken): Promise<DictionaryTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderDictionary/GetDictionaryTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDictionaryTypes(_response);
        });
    }

    protected processGetDictionaryTypes(response: AxiosResponse): Promise<DictionaryTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DictionaryTypeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DictionaryTypeDto[]>(null as any);
    }

    /**
     * 获取字典
     * @param dictType (optional) 
     * @return OK
     */
    getByDictType(dictType?: string | undefined, cancelToken?: CancelToken): Promise<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderDictionary/GetByDictType?";
        if (dictType === null)
            throw new globalThis.Error("The parameter 'dictType' cannot be null.");
        else if (dictType !== undefined)
            url_ += "dictType=" + encodeURIComponent("" + dictType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByDictType(_response);
        });
    }

    protected processGetByDictType(response: AxiosResponse): Promise<DictionaryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DictionaryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DictionaryDto[]>(null as any);
    }

    /**
     * 新增字典
     * @param body (optional) 
     * @return OK
     */
    createDictionary(body?: CreateDictionaryDto | undefined, cancelToken?: CancelToken): Promise<DictionaryDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderDictionary/CreateDictionary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDictionary(_response);
        });
    }

    protected processCreateDictionary(response: AxiosResponse): Promise<DictionaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DictionaryDto.fromJS(resultData200);
            return Promise.resolve<DictionaryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DictionaryDto>(null as any);
    }

    /**
     * 新增字典
     * @param body (optional) 
     * @return OK
     */
    createDictionaryAsyncs(body?: CreateDictionaryDto[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderDictionary/CreateDictionaryAsyncs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDictionaryAsyncs(_response);
        });
    }

    protected processCreateDictionaryAsyncs(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 商务客户关联
     * @param customerCode (optional) 
     * @return OK
     */
    getBusinessCustomerRelationDto(customerCode?: string | undefined, cancelToken?: CancelToken): Promise<BusinessCustomerRelationDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderDictionary/GetBusinessCustomerRelationDto?";
        if (customerCode === null)
            throw new globalThis.Error("The parameter 'customerCode' cannot be null.");
        else if (customerCode !== undefined)
            url_ += "customerCode=" + encodeURIComponent("" + customerCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBusinessCustomerRelationDto(_response);
        });
    }

    protected processGetBusinessCustomerRelationDto(response: AxiosResponse): Promise<BusinessCustomerRelationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BusinessCustomerRelationDto.fromJS(resultData200);
            return Promise.resolve<BusinessCustomerRelationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BusinessCustomerRelationDto>(null as any);
    }

    /**
     * 获取商业负责人和商业候选人
     优先找有区域没商务的客户
    其次找有区域有客户的商务
    最后找只有客户的.
    如果都找不到,则提示.商务找不到
     * @param region (optional) 
     * @param customerCode (optional) 
     * @return OK
     */
    getBusinessCustomerRelationDtos(region?: string | undefined, customerCode?: string | undefined, cancelToken?: CancelToken): Promise<BusinessCustomerRelationDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderDictionary/GetBusinessCustomerRelationDtos?";
        if (region === null)
            throw new globalThis.Error("The parameter 'region' cannot be null.");
        else if (region !== undefined)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        if (customerCode === null)
            throw new globalThis.Error("The parameter 'customerCode' cannot be null.");
        else if (customerCode !== undefined)
            url_ += "customerCode=" + encodeURIComponent("" + customerCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBusinessCustomerRelationDtos(_response);
        });
    }

    protected processGetBusinessCustomerRelationDtos(response: AxiosResponse): Promise<BusinessCustomerRelationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BusinessCustomerRelationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BusinessCustomerRelationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BusinessCustomerRelationDto[]>(null as any);
    }

    /**
     * 获取OH负责人和OH候选人
     优先找有区域没商务的客户
    其次找有区域有客户的商务
    最后找只有客户的.
    如果都找不到,则提示.商务找不到
     * @param region (optional) 
     * @param customerCode (optional) 
     * @return OK
     */
    getOrderHandlingRelationDtos(region?: string | undefined, customerCode?: string | undefined, cancelToken?: CancelToken): Promise<OrderHandlingRelationDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderDictionary/GetOrderHandlingRelationDtos?";
        if (region === null)
            throw new globalThis.Error("The parameter 'region' cannot be null.");
        else if (region !== undefined)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        if (customerCode === null)
            throw new globalThis.Error("The parameter 'customerCode' cannot be null.");
        else if (customerCode !== undefined)
            url_ += "customerCode=" + encodeURIComponent("" + customerCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderHandlingRelationDtos(_response);
        });
    }

    protected processGetOrderHandlingRelationDtos(response: AxiosResponse): Promise<OrderHandlingRelationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderHandlingRelationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderHandlingRelationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderHandlingRelationDto[]>(null as any);
    }

    /**
     * 获取OH审核负责人和OH审核候选人
     优先找有区域没商务的客户
    其次找有区域有客户的商务
    最后找只有客户的.
    如果都找不到,则提示.商务找不到
     * @param region (optional) 
     * @param customerCode (optional) 
     * @return OK
     */
    getOrderApproveRelationDtos(region?: string | undefined, customerCode?: string | undefined, cancelToken?: CancelToken): Promise<OrderHandlingRelationDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderDictionary/GetOrderApproveRelationDtos?";
        if (region === null)
            throw new globalThis.Error("The parameter 'region' cannot be null.");
        else if (region !== undefined)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        if (customerCode === null)
            throw new globalThis.Error("The parameter 'customerCode' cannot be null.");
        else if (customerCode !== undefined)
            url_ += "customerCode=" + encodeURIComponent("" + customerCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderApproveRelationDtos(_response);
        });
    }

    protected processGetOrderApproveRelationDtos(response: AxiosResponse): Promise<OrderHandlingRelationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderHandlingRelationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderHandlingRelationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderHandlingRelationDto[]>(null as any);
    }

    /**
     * 获取商务负责人和商业候选人
     * @return OK
     */
    getCommerces( cancelToken?: CancelToken): Promise<GetUserIdAndNameByRoleNameOutput[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderDictionary/GetCommerces";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCommerces(_response);
        });
    }

    protected processGetCommerces(response: AxiosResponse): Promise<GetUserIdAndNameByRoleNameOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserIdAndNameByRoleNameOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetUserIdAndNameByRoleNameOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserIdAndNameByRoleNameOutput[]>(null as any);
    }

    /**
     * 获取订单处理人
     * @return OK
     */
    getOrderHandling( cancelToken?: CancelToken): Promise<GetUserIdAndNameByRoleNameOutput[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderDictionary/GetOrderHandling";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderHandling(_response);
        });
    }

    protected processGetOrderHandling(response: AxiosResponse): Promise<GetUserIdAndNameByRoleNameOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserIdAndNameByRoleNameOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetUserIdAndNameByRoleNameOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserIdAndNameByRoleNameOutput[]>(null as any);
    }

    /**
     * 获取变更原因
     * @param proposerKey (optional) 
     * @param sceneKey (optional) 
     * @return OK
     */
    getChangeReasons(proposerKey?: string | undefined, sceneKey?: string | undefined, cancelToken?: CancelToken): Promise<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderDictionary/GetChangeReasons?";
        if (proposerKey === null)
            throw new globalThis.Error("The parameter 'proposerKey' cannot be null.");
        else if (proposerKey !== undefined)
            url_ += "proposerKey=" + encodeURIComponent("" + proposerKey) + "&";
        if (sceneKey === null)
            throw new globalThis.Error("The parameter 'sceneKey' cannot be null.");
        else if (sceneKey !== undefined)
            url_ += "sceneKey=" + encodeURIComponent("" + sceneKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChangeReasons(_response);
        });
    }

    protected processGetChangeReasons(response: AxiosResponse): Promise<DictionaryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DictionaryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DictionaryDto[]>(null as any);
    }

    /**
     * @param productType (optional) 
     * @return OK
     */
    getOrderProductTypeByProductType(productType?: string | undefined, cancelToken?: CancelToken): Promise<OrderProductTypeEntity[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderDictionary/GetOrderProductTypeByProductType?";
        if (productType === null)
            throw new globalThis.Error("The parameter 'productType' cannot be null.");
        else if (productType !== undefined)
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderProductTypeByProductType(_response);
        });
    }

    protected processGetOrderProductTypeByProductType(response: AxiosResponse): Promise<OrderProductTypeEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderProductTypeEntity.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderProductTypeEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderProductTypeEntity[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrderTypeProductionLine(body?: CreateOrderTypeProductionLineDto[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderDictionary/CreateOrderTypeProductionLine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrderTypeProductionLine(_response);
        });
    }

    protected processCreateOrderTypeProductionLine(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 修改加急配置
     * @param body (optional) 
     * @return OK
     */
    upateUrgentConfiguration(body?: UpateUrgentConfigurationDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderDictionary/UpateUrgentConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpateUrgentConfiguration(_response);
        });
    }

    protected processUpateUrgentConfiguration(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取加急配置
     * @return OK
     */
    getUrgentConfiguration( cancelToken?: CancelToken): Promise<UrgentConfiguration[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderDictionary/GetUrgentConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUrgentConfiguration(_response);
        });
    }

    protected processGetUrgentConfiguration(response: AxiosResponse): Promise<UrgentConfiguration[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UrgentConfiguration.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UrgentConfiguration[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UrgentConfiguration[]>(null as any);
    }
}

export class OrderFormServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取库存接口
     * @param body (optional) 
     * @return OK
     */
    getMtsStk(body?: SapMtsStkInputDto | undefined, cancelToken?: CancelToken): Promise<SapMtsStkOutputDtoListSapOutputDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetMtsStk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMtsStk(_response);
        });
    }

    protected processGetMtsStk(response: AxiosResponse): Promise<SapMtsStkOutputDtoListSapOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SapMtsStkOutputDtoListSapOutputDto.fromJS(resultData200);
            return Promise.resolve<SapMtsStkOutputDtoListSapOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SapMtsStkOutputDtoListSapOutputDto>(null as any);
    }

    /**
     * 库存预占接口
     * @param body (optional) 
     * @return OK
     */
    setOisOrd(body?: SapOisOrdInputDto[] | undefined, cancelToken?: CancelToken): Promise<SapOisOrdOutputDtoListSapOutputDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/SetOisOrd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetOisOrd(_response);
        });
    }

    protected processSetOisOrd(response: AxiosResponse): Promise<SapOisOrdOutputDtoListSapOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SapOisOrdOutputDtoListSapOutputDto.fromJS(resultData200);
            return Promise.resolve<SapOisOrdOutputDtoListSapOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SapOisOrdOutputDtoListSapOutputDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getReplenishInventoryRemindListByPage(body?: ReplenishInventoryRemindSearchInDto | undefined, cancelToken?: CancelToken): Promise<PageReplenishInventoryRemindOutDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetReplenishInventoryRemindListByPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReplenishInventoryRemindListByPage(_response);
        });
    }

    protected processGetReplenishInventoryRemindListByPage(response: AxiosResponse): Promise<PageReplenishInventoryRemindOutDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageReplenishInventoryRemindOutDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<PageReplenishInventoryRemindOutDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageReplenishInventoryRemindOutDtoPagedResultDto>(null as any);
    }

    /**
     * 补库提醒，查询条件导出excel
     * @param body (optional) 
     * @return OK
     */
    excelExportReplenishInventoryRemindList(body?: ReplenishInventoryRemindExportInDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/ExcelExportReplenishInventoryRemindList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExcelExportReplenishInventoryRemindList(_response);
        });
    }

    protected processExcelExportReplenishInventoryRemindList(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 补库提醒新增
     * @param body (optional) 
     * @return OK
     */
    addReplenishInventoryRemind(body?: ReplenishInventoryRemindInDto | undefined, cancelToken?: CancelToken): Promise<OutputDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/AddReplenishInventoryRemind";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddReplenishInventoryRemind(_response);
        });
    }

    protected processAddReplenishInventoryRemind(response: AxiosResponse): Promise<OutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OutputDto.fromJS(resultData200);
            return Promise.resolve<OutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OutputDto>(null as any);
    }

    /**
     * 补库提醒删除(预留)
     * @param body (optional) 
     * @return OK
     */
    delReplenishInventoryRemind(body?: string[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/DelReplenishInventoryRemind";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelReplenishInventoryRemind(_response);
        });
    }

    protected processDelReplenishInventoryRemind(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 补库提醒邮件发送
     * @param body (optional) 
     * @return OK
     */
    sendMailReplenishInventoryRemind(body?: ReplenishInventoryRemind | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/SendMailReplenishInventoryRemind";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendMailReplenishInventoryRemind(_response);
        });
    }

    protected processSendMailReplenishInventoryRemind(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 补库提醒导出excel
     * @param keyid (optional) 
     * @return OK
     */
    excelExportReplenishInventoryRemind(keyid?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/ExcelExportReplenishInventoryRemind?";
        if (keyid === null)
            throw new globalThis.Error("The parameter 'keyid' cannot be null.");
        else if (keyid !== undefined)
            url_ += "keyid=" + encodeURIComponent("" + keyid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExcelExportReplenishInventoryRemind(_response);
        });
    }

    protected processExcelExportReplenishInventoryRemind(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 根据SmartConfigurator中内容生成订单
     * @param body (optional) 
     * @return OK
     */
    addOrderFormSmartConfigurator(body?: AddOrderFormSmartConfiguratorDto | undefined, cancelToken?: CancelToken): Promise<AddOrderFormSmartConfiguratorDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/AddOrderFormSmartConfigurator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrderFormSmartConfigurator(_response);
        });
    }

    protected processAddOrderFormSmartConfigurator(response: AxiosResponse): Promise<AddOrderFormSmartConfiguratorDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddOrderFormSmartConfiguratorDto.fromJS(resultData200);
            return Promise.resolve<AddOrderFormSmartConfiguratorDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddOrderFormSmartConfiguratorDto>(null as any);
    }

    /**
     * 添加重复的订单
     * @param orderFormId (optional) 
     * @return OK
     */
    addDoubleBooking(orderFormId?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/AddDoubleBooking?";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "orderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddDoubleBooking(_response);
        });
    }

    protected processAddDoubleBooking(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 添加订单中的产品组合
     * @param id (optional) 
     * @return OK
     */
    addOrderFormProductBasicMotorItem(id?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/AddOrderFormProductBasicMotorItem?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrderFormProductBasicMotorItem(_response);
        });
    }

    protected processAddOrderFormProductBasicMotorItem(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 发起下单审批
     * @param orderFormId (optional) 
     * @return OK
     */
    addApproval(orderFormId?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/AddApproval?";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "orderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddApproval(_response);
        });
    }

    protected processAddApproval(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 下单审批通过/不通过
     * @param body (optional) 
     * @return OK
     */
    editApproval(body?: EditApprovalDto | undefined, cancelToken?: CancelToken): Promise<EditApprovalParam> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/EditApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditApproval(_response);
        });
    }

    protected processEditApproval(response: AxiosResponse): Promise<EditApprovalParam> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditApprovalParam.fromJS(resultData200);
            return Promise.resolve<EditApprovalParam>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditApprovalParam>(null as any);
    }

    /**
     * 批量下单审批
     * @param body (optional) 
     * @return OK
     */
    editApprovalBatch(body?: EditApprovalDto | undefined, cancelToken?: CancelToken): Promise<EditApprovalParam> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/EditApprovalBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditApprovalBatch(_response);
        });
    }

    protected processEditApprovalBatch(response: AxiosResponse): Promise<EditApprovalParam> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditApprovalParam.fromJS(resultData200);
            return Promise.resolve<EditApprovalParam>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditApprovalParam>(null as any);
    }

    /**
     * 更新订单的OMS订单号
     * @param orderId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateOmsOrderNumber(orderId?: string | undefined, body?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/UpdateOmsOrderNumber?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOmsOrderNumber(_response);
        });
    }

    protected processUpdateOmsOrderNumber(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 文件上传
     * @param excelFile (optional) 
     * @return OK
     */
    fileUpload(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/FileUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileUpload(_response);
        });
    }

    protected processFileUpload(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 根据文件名称获取文件下载URL(长期)
     * @param body (optional) 
     * @return OK
     */
    getFileUrl(body?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetFileUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileUrl(_response);
        });
    }

    protected processGetFileUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 根据文件名称获取文件下载URL（临时）
     * @param body (optional) 
     * @return OK
     */
    getTemporaryFileUrl(body?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetTemporaryFileUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTemporaryFileUrl(_response);
        });
    }

    protected processGetTemporaryFileUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 生成带附件下载头的临时地址，浏览器直接下载而不是打开文件内容。
     * @param body (optional) 
     * @return OK
     */
    getDownloadFileUrl(body?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetDownloadFileUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDownloadFileUrl(_response);
        });
    }

    protected processGetDownloadFileUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 在服务端读取附件并打成压缩包，避免浏览器跨域无法把文件放进同一个包。
     * @param body (optional) 
     * @return OK
     */
    getBatchDownloadFileUrl(body?: BatchDownloadFileInput[] | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetBatchDownloadFileUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBatchDownloadFileUrl(_response);
        });
    }

    protected processGetBatchDownloadFileUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 回写业务数据
     * @param body (optional) 
     * @return OK
     */
    writeBackBusinessData(body?: WriteBackBusinessDataDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/WriteBackBusinessData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWriteBackBusinessData(_response);
        });
    }

    protected processWriteBackBusinessData(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 判断客户订单号是否重复
     * @param orderId (optional) 
     * @param orderNumber (optional) 
     * @return OK
     */
    verifyOrderNumber(orderId?: string | undefined, orderNumber?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/VerifyOrderNumber?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (orderNumber === null)
            throw new globalThis.Error("The parameter 'orderNumber' cannot be null.");
        else if (orderNumber !== undefined)
            url_ += "orderNumber=" + encodeURIComponent("" + orderNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyOrderNumber(_response);
        });
    }

    protected processVerifyOrderNumber(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 修改订单
     * @param body (optional) 
     * @return OK
     */
    editOrderForm(body?: EditOrderFormDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/EditOrderForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditOrderForm(_response);
        });
    }

    protected processEditOrderForm(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 非SCP订单按规则匹配绿通号
     * @param customerCode (optional) 
     * @param orderTime (optional) 
     * @param body (optional) 
     * @return OK
     */
    matchReviewNo(customerCode?: string | undefined, orderTime?: moment.Moment | undefined, body?: GetProductBasicMotorDto[] | undefined, cancelToken?: CancelToken): Promise<GetProductBasicMotorDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/MatchReviewNo?";
        if (customerCode === null)
            throw new globalThis.Error("The parameter 'customerCode' cannot be null.");
        else if (customerCode !== undefined)
            url_ += "customerCode=" + encodeURIComponent("" + customerCode) + "&";
        if (orderTime === null)
            throw new globalThis.Error("The parameter 'orderTime' cannot be null.");
        else if (orderTime !== undefined)
            url_ += "orderTime=" + encodeURIComponent(orderTime ? "" + orderTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMatchReviewNo(_response);
        });
    }

    protected processMatchReviewNo(response: AxiosResponse): Promise<GetProductBasicMotorDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetProductBasicMotorDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetProductBasicMotorDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProductBasicMotorDto[]>(null as any);
    }

    /**
     * 修改订单状态
    0.未开始，1.进行中，2.通过，3.未通过，4.已取消
     * @param id (optional) 
     * @param orderStatus (optional) 
     * @return OK
     */
    editOrderFormStatus(id?: string | undefined, orderStatus?: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/EditOrderFormStatus?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (orderStatus === null)
            throw new globalThis.Error("The parameter 'orderStatus' cannot be null.");
        else if (orderStatus !== undefined)
            url_ += "orderStatus=" + encodeURIComponent("" + orderStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditOrderFormStatus(_response);
        });
    }

    protected processEditOrderFormStatus(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 取消订单时，释放库存
     * @param pONumber (optional) 合同号
     * @param body (optional) 库存产品
     * @return OK
     */
    unreserveInventory(pONumber?: string | undefined, body?: ProductBasicMotor[] | undefined, cancelToken?: CancelToken): Promise<OutPutMsg> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/UnreserveInventory?";
        if (pONumber === null)
            throw new globalThis.Error("The parameter 'pONumber' cannot be null.");
        else if (pONumber !== undefined)
            url_ += "PONumber=" + encodeURIComponent("" + pONumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnreserveInventory(_response);
        });
    }

    protected processUnreserveInventory(response: AxiosResponse): Promise<OutPutMsg> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OutPutMsg.fromJS(resultData200);
            return Promise.resolve<OutPutMsg>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OutPutMsg>(null as any);
    }

    /**
     * 删除订单下的产品组合
     * @param orderFormId (optional) 
     * @param productBasicMotorId (optional) 
     * @return OK
     */
    deleteOrderFormProductBasicMotor(orderFormId?: string | undefined, productBasicMotorId?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/DeleteOrderFormProductBasicMotor?";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "orderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        if (productBasicMotorId === null)
            throw new globalThis.Error("The parameter 'productBasicMotorId' cannot be null.");
        else if (productBasicMotorId !== undefined)
            url_ += "productBasicMotorId=" + encodeURIComponent("" + productBasicMotorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOrderFormProductBasicMotor(_response);
        });
    }

    protected processDeleteOrderFormProductBasicMotor(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 查询单个订单的审批记录数据
     * @param orderFormId (optional) 
     * @return OK
     */
    getOrderFormApprovals(orderFormId?: string | undefined, cancelToken?: CancelToken): Promise<GetOrderFormApprovalDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetOrderFormApprovals?";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "orderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderFormApprovals(_response);
        });
    }

    protected processGetOrderFormApprovals(response: AxiosResponse): Promise<GetOrderFormApprovalDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetOrderFormApprovalDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetOrderFormApprovalDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrderFormApprovalDto[]>(null as any);
    }

    /**
     * 查询单个订单的审批记录数据(包含已取消相同合同号的订单审批记录)
     * @param orderFormId (optional) 订单ID
     * @return OK
     */
    getHisOrderFormApprovals(orderFormId?: string | undefined, cancelToken?: CancelToken): Promise<GetOrderFormApprovalDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetHisOrderFormApprovals?";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "orderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHisOrderFormApprovals(_response);
        });
    }

    protected processGetHisOrderFormApprovals(response: AxiosResponse): Promise<GetOrderFormApprovalDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetOrderFormApprovalDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetOrderFormApprovalDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrderFormApprovalDto[]>(null as any);
    }

    /**
     * 查询单个订单，当前的审批记录
     * @param approvalId (optional) 审批编号
     * @return OK
     */
    getOrderFormApproval(approvalId?: string | undefined, cancelToken?: CancelToken): Promise<GetOrderFormApprovalDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetOrderFormApproval?";
        if (approvalId === null)
            throw new globalThis.Error("The parameter 'approvalId' cannot be null.");
        else if (approvalId !== undefined)
            url_ += "approvalId=" + encodeURIComponent("" + approvalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderFormApproval(_response);
        });
    }

    protected processGetOrderFormApproval(response: AxiosResponse): Promise<GetOrderFormApprovalDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOrderFormApprovalDto.fromJS(resultData200);
            return Promise.resolve<GetOrderFormApprovalDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrderFormApprovalDto>(null as any);
    }

    /**
     * 查询单个订单
     * @param id (optional) 
     * @return OK
     */
    getOrderForm(id?: string | undefined, cancelToken?: CancelToken): Promise<GetOrderFormDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetOrderForm?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderForm(_response);
        });
    }

    protected processGetOrderForm(response: AxiosResponse): Promise<GetOrderFormDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOrderFormDto.fromJS(resultData200);
            return Promise.resolve<GetOrderFormDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrderFormDto>(null as any);
    }

    /**
     * 获取所有的行业
     * @return OK
     */
    getIndustryAll( cancelToken?: CancelToken): Promise<GetIndustryAllDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetIndustryAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIndustryAll(_response);
        });
    }

    protected processGetIndustryAll(response: AxiosResponse): Promise<GetIndustryAllDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetIndustryAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetIndustryAllDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIndustryAllDto[]>(null as any);
    }

    /**
     * 获取所有的应用
     * @return OK
     */
    getApplicationAll( cancelToken?: CancelToken): Promise<GetApplicationAllDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetApplicationAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplicationAll(_response);
        });
    }

    protected processGetApplicationAll(response: AxiosResponse): Promise<GetApplicationAllDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetApplicationAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetApplicationAllDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetApplicationAllDto[]>(null as any);
    }

    /**
     * 获取所有的渠道
     * @return OK
     */
    getChannelAll( cancelToken?: CancelToken): Promise<GetChannelAllDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetChannelAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChannelAll(_response);
        });
    }

    protected processGetChannelAll(response: AxiosResponse): Promise<GetChannelAllDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetChannelAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetChannelAllDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetChannelAllDto[]>(null as any);
    }

    /**
     * 获取所有的销售区域
     * @return OK
     */
    getSalesAreaAll( cancelToken?: CancelToken): Promise<GetSalesAreaAllDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetSalesAreaAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalesAreaAll(_response);
        });
    }

    protected processGetSalesAreaAll(response: AxiosResponse): Promise<GetSalesAreaAllDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetSalesAreaAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetSalesAreaAllDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSalesAreaAllDto[]>(null as any);
    }

    /**
     * 获取上海区域销售经理和销售员的对应关系
     * @param salesAreaName (optional) 
     * @return OK
     */
    getSalesUserByArea(salesAreaName?: string | undefined, cancelToken?: CancelToken): Promise<GetSalesUserDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetSalesUserByArea?";
        if (salesAreaName === null)
            throw new globalThis.Error("The parameter 'salesAreaName' cannot be null.");
        else if (salesAreaName !== undefined)
            url_ += "SalesAreaName=" + encodeURIComponent("" + salesAreaName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalesUserByArea(_response);
        });
    }

    protected processGetSalesUserByArea(response: AxiosResponse): Promise<GetSalesUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetSalesUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetSalesUserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSalesUserDto[]>(null as any);
    }

    /**
     * 获取所有的数据平台订单类型
     * @return OK
     */
    getDataPlatFormOrderTypeAll( cancelToken?: CancelToken): Promise<GetDataPlatFormOrderTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetDataPlatFormOrderTypeAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDataPlatFormOrderTypeAll(_response);
        });
    }

    protected processGetDataPlatFormOrderTypeAll(response: AxiosResponse): Promise<GetDataPlatFormOrderTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetDataPlatFormOrderTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetDataPlatFormOrderTypeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataPlatFormOrderTypeDto[]>(null as any);
    }

    /**
     * 导出OMS上传模板
     * @param orderFormId (optional) 
     * @return OK
     */
    exportOMS(orderFormId?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/ExportOMS?";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "orderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportOMS(_response);
        });
    }

    protected processExportOMS(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导出订单明细
     * @param orderFormId (optional) 
     * @return OK
     */
    exportOrderDetails(orderFormId?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/ExportOrderDetails?";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "orderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportOrderDetails(_response);
        });
    }

    protected processExportOrderDetails(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取当前状态下，当前时间之前，当前登陆人的合同号
     * @param orderStatus 订单状态

    0 = NotStarted (待提交)

    1 = Underway (处理中)

    2 = adopt (已下单)

    3 = Failed (已退回)

    4 = Cancel (已取消)
     * @param time 时间（天）
     * @return OK
     */
    getOrderStateTimeData(orderStatus: OrderStatus, time: number, cancelToken?: CancelToken): Promise<ReturnOrderStateTimeDataDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetOrderStateTimeData?";
        if (orderStatus === undefined || orderStatus === null)
            throw new globalThis.Error("The parameter 'orderStatus' must be defined and cannot be null.");
        else
            url_ += "OrderStatus=" + encodeURIComponent("" + orderStatus) + "&";
        if (time === undefined || time === null)
            throw new globalThis.Error("The parameter 'time' must be defined and cannot be null.");
        else
            url_ += "Time=" + encodeURIComponent("" + time) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderStateTimeData(_response);
        });
    }

    protected processGetOrderStateTimeData(response: AxiosResponse): Promise<ReturnOrderStateTimeDataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReturnOrderStateTimeDataDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ReturnOrderStateTimeDataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReturnOrderStateTimeDataDto[]>(null as any);
    }

    /**
     * 更新未审批订单的主机分类
     * @return OK
     */
    resetProductClassification( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/ResetProductClassification";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetProductClassification(_response);
        });
    }

    protected processResetProductClassification(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 校验订单中包含的客户化代码产品有效状态
     * @param orderFormId (optional) 
     * @return OK
     */
    checkOrderCustomCodeVaild(orderFormId?: string | undefined, cancelToken?: CancelToken): Promise<VaildCustomCodeSalesPriceDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/CheckOrderCustomCodeVaild?";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "orderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckOrderCustomCodeVaild(_response);
        });
    }

    protected processCheckOrderCustomCodeVaild(response: AxiosResponse): Promise<VaildCustomCodeSalesPriceDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VaildCustomCodeSalesPriceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<VaildCustomCodeSalesPriceDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VaildCustomCodeSalesPriceDto[]>(null as any);
    }

    /**
     * 获取客户化代码数据
     * @param basicMotorCodes (optional) 客户化代码产品代码
     * @return OK
     */
    getCustomCodes(basicMotorCodes?: string[] | undefined, cancelToken?: CancelToken): Promise<GetCTOProductBasicMotorAllDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetCustomCodes?";
        if (basicMotorCodes === null)
            throw new globalThis.Error("The parameter 'basicMotorCodes' cannot be null.");
        else if (basicMotorCodes !== undefined)
            basicMotorCodes && basicMotorCodes.forEach(item => { url_ += "basicMotorCodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomCodes(_response);
        });
    }

    protected processGetCustomCodes(response: AxiosResponse): Promise<GetCTOProductBasicMotorAllDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCTOProductBasicMotorAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetCTOProductBasicMotorAllDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCTOProductBasicMotorAllDto[]>(null as any);
    }

    /**
     * 根据主机代码获取数据
     * @param basicMotorCodes (optional) 
     * @return OK
     */
    getCustomCodesByCode(basicMotorCodes?: string[] | undefined, cancelToken?: CancelToken): Promise<CTOProductBasicMotor[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetCustomCodesByCode?";
        if (basicMotorCodes === null)
            throw new globalThis.Error("The parameter 'basicMotorCodes' cannot be null.");
        else if (basicMotorCodes !== undefined)
            basicMotorCodes && basicMotorCodes.forEach(item => { url_ += "basicMotorCodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomCodesByCode(_response);
        });
    }

    protected processGetCustomCodesByCode(response: AxiosResponse): Promise<CTOProductBasicMotor[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CTOProductBasicMotor.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CTOProductBasicMotor[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CTOProductBasicMotor[]>(null as any);
    }

    /**
     * 获取订单产品备注信息
     * @param productId (optional) 
     * @return OK
     */
    getProductRemark(productId?: string | undefined, cancelToken?: CancelToken): Promise<any[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetProductRemark?";
        if (productId === null)
            throw new globalThis.Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/xml"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductRemark(_response);
        });
    }

    protected processGetProductRemark(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }

    /**
     * 重置Open Vc显示方式
     * @return OK
     */
    resetProductVcShowType( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/ResetProductVcShowType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetProductVcShowType(_response);
        });
    }

    protected processResetProductVcShowType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 保存开口项信息
     * @param body (optional) 
     * @return OK
     */
    saveOpenItemInfo(body?: EditOrderFormOpenItemDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/SaveOpenItemInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveOpenItemInfo(_response);
        });
    }

    protected processSaveOpenItemInfo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    orderItemListTransExport(body?: ProductBasicMotor | undefined, cancelToken?: CancelToken): Promise<ExportOrderItem> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/OrderItemListTransExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrderItemListTransExport(_response);
        });
    }

    protected processOrderItemListTransExport(response: AxiosResponse): Promise<ExportOrderItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportOrderItem.fromJS(resultData200);
            return Promise.resolve<ExportOrderItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportOrderItem>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    orderListTransExport(body?: OrderForm | undefined, cancelToken?: CancelToken): Promise<ExportOrder> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/OrderListTransExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrderListTransExport(_response);
        });
    }

    protected processOrderListTransExport(response: AxiosResponse): Promise<ExportOrder> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportOrder.fromJS(resultData200);
            return Promise.resolve<ExportOrder>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportOrder>(null as any);
    }

    /**
     * 根据CTO购物车中的内容生成订单
     * @return OK
     */
    addOrderFormShoppingCart( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/AddOrderFormShoppingCart";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrderFormShoppingCart(_response);
        });
    }

    protected processAddOrderFormShoppingCart(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 电机质量页「补出厂试验报告」：按当前登录用户和订单ID，获取费用购物车的原订单号，
    找到原订单后参照 AddOrderFormShoppingCart 的方式生成一张新订单（SourceType=motorcert）
     * @param orderFormId (optional) 
     * @return OK
     */
    addOrderFormByMotorCert(orderFormId?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/AddOrderFormByMotorCert?";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "orderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrderFormByMotorCert(_response);
        });
    }

    protected processAddOrderFormByMotorCert(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * CTO添加到购物车
     * @param body (optional) 
     * @return OK
     */
    addShoppingCart(body?: AddShoppingCartDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/AddShoppingCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddShoppingCart(_response);
        });
    }

    protected processAddShoppingCart(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 删除CTO购物车中的产品组合
     * @param id (optional) 
     * @return OK
     */
    deleteShoppingCart(id?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/DeleteShoppingCart?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteShoppingCart(_response);
        });
    }

    protected processDeleteShoppingCart(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 删除CTO产品组合
     * @param ids (optional) 
     * @return OK
     */
    deleteCTO(ids?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/DeleteCTO?";
        if (ids === null)
            throw new globalThis.Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCTO(_response);
        });
    }

    protected processDeleteCTO(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入CTO数据
     * @param excelFile (optional) 
     * @return OK
     */
    importCTO(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/ImportCTO";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportCTO(_response);
        });
    }

    protected processImportCTO(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导出CTO上传模板
     * @param body (optional) 
     * @return OK
     */
    exportCTOTemplateStream(body?: PageCTOProductBasicMotorAllDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/ExportCTOTemplateStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCTOTemplateStream(_response);
        });
    }

    protected processExportCTOTemplateStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据指定文件名和CTO导出对象的信息导出内容
     * @param fileNmae (optional) 
     * @param body (optional) 
     * @return OK
     */
    exportCTODtoStream(fileNmae?: string | undefined, body?: ExportCTOProductBasicMotorDto[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/ExportCTODtoStream?";
        if (fileNmae === null)
            throw new globalThis.Error("The parameter 'fileNmae' cannot be null.");
        else if (fileNmae !== undefined)
            url_ += "fileNmae=" + encodeURIComponent("" + fileNmae) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCTODtoStream(_response);
        });
    }

    protected processExportCTODtoStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取CTO数据
     * @param body (optional) 
     * @return OK
     */
    getCTOProductBasicMotorAll(body?: PageCTOProductBasicMotorAllDto | undefined, cancelToken?: CancelToken): Promise<GetCTOProductBasicMotorAllTotalCountDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetCTOProductBasicMotorAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCTOProductBasicMotorAll(_response);
        });
    }

    protected processGetCTOProductBasicMotorAll(response: AxiosResponse): Promise<GetCTOProductBasicMotorAllTotalCountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCTOProductBasicMotorAllTotalCountDto.fromJS(resultData200);
            return Promise.resolve<GetCTOProductBasicMotorAllTotalCountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCTOProductBasicMotorAllTotalCountDto>(null as any);
    }

    /**
     * 获取单个CTO产品组合的信息
     * @param id (optional) 
     * @return OK
     */
    getCTOProductBasicMotor(id?: string | undefined, cancelToken?: CancelToken): Promise<GetCTOProductBasicMotorDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetCTOProductBasicMotor?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCTOProductBasicMotor(_response);
        });
    }

    protected processGetCTOProductBasicMotor(response: AxiosResponse): Promise<GetCTOProductBasicMotorDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCTOProductBasicMotorDto.fromJS(resultData200);
            return Promise.resolve<GetCTOProductBasicMotorDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCTOProductBasicMotorDto>(null as any);
    }

    /**
     * 获取CTO购物车数据
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getShoppingCartAll(skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<GetShoppingCartAllDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetShoppingCartAll?";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShoppingCartAll(_response);
        });
    }

    protected processGetShoppingCartAll(response: AxiosResponse): Promise<GetShoppingCartAllDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetShoppingCartAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetShoppingCartAllDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetShoppingCartAllDto[]>(null as any);
    }

    /**
     * 删除CTO客户化代码
     * @param body (optional) 
     * @return OK
     */
    deleteCustomCode(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/DeleteCustomCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCustomCode(_response);
        });
    }

    protected processDeleteCustomCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据cpCode和主机进行删除
     * @param body (optional) 
     * @return OK
     */
    deleteCustomCodeByBasicMotorCode(body?: EditCustomCodeDto[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/DeleteCustomCodeByBasicMotorCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCustomCodeByBasicMotorCode(_response);
        });
    }

    protected processDeleteCustomCodeByBasicMotorCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除CTO客户化代码
     * @return OK
     */
    deleteCustomCodeAll( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/DeleteCustomCodeAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCustomCodeAll(_response);
        });
    }

    protected processDeleteCustomCodeAll(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新增CTO客户化代码
     * @param body (optional) 
     * @return OK
     */
    addCustomCode(body?: AddCustomCodeDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/AddCustomCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddCustomCode(_response);
        });
    }

    protected processAddCustomCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量添加客户化代码
     * @param body (optional) 
     * @return OK
     */
    batchAddCustomCode(body?: AddCustomCodeDto[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/BatchAddCustomCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchAddCustomCode(_response);
        });
    }

    protected processBatchAddCustomCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * SC电机导入时删除表格没有的客户化代码
     * @param body (optional) 
     * @return OK
     */
    batchDeleteCustomCode(body?: AddCustomCodeDto[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/BatchDeleteCustomCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDeleteCustomCode(_response);
        });
    }

    protected processBatchDeleteCustomCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * SC批量删除客户话代码
     * @param body (optional) 
     * @return OK
     */
    batchDeleteCustomCodeByCustomCode(body?: AddCustomCodeDto[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/BatchDeleteCustomCodeByCustomCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDeleteCustomCodeByCustomCode(_response);
        });
    }

    protected processBatchDeleteCustomCodeByCustomCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 电机交期客户化代码更新时使用
     * @param body (optional) 
     * @return OK
     */
    batchUpdateCustomCycle(body?: AddCustomCodeDto[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/BatchUpdateCustomCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchUpdateCustomCycle(_response);
        });
    }

    protected processBatchUpdateCustomCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 编辑CTO客户化代码
     * @param body (optional) 
     * @return OK
     */
    editCustomCode(body?: EditCustomCodeDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/EditCustomCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditCustomCode(_response);
        });
    }

    protected processEditCustomCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 确认客户化代码状态
     * @param body (optional) 
     * @return OK
     */
    updateProductBasicMotorConfirmStatus(body?: UpdateProductBasicMotorConfirmStatusInputDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/UpdateProductBasicMotorConfirmStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProductBasicMotorConfirmStatus(_response);
        });
    }

    protected processUpdateProductBasicMotorConfirmStatus(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 导入客户化代码
     * @param excelFile (optional) 
     * @return OK
     */
    importCustomCode(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/ImportCustomCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportCustomCode(_response);
        });
    }

    protected processImportCustomCode(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 刷新订单中客户化代码产品价格
     * @return OK
     */
    resetOrderCustomCodeSalesPrice( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/ResetOrderCustomCodeSalesPrice";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetOrderCustomCodeSalesPrice(_response);
        });
    }

    protected processResetOrderCustomCodeSalesPrice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出CTO客户化代码上传模板
     * @param body (optional) 
     * @return OK
     */
    exportCustomCodeTemplate(body?: PageCTOProductBasicMotorAllDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/ExportCustomCodeTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCustomCodeTemplate(_response);
        });
    }

    protected processExportCustomCodeTemplate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取CTO客户化代码数据
     * @param body (optional) 
     * @return OK
     */
    getCustomCodeAll(body?: PageCTOProductBasicMotorAllDto | undefined, cancelToken?: CancelToken): Promise<GetCTOProductBasicMotorAllTotalCountDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetCustomCodeAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomCodeAll(_response);
        });
    }

    protected processGetCustomCodeAll(response: AxiosResponse): Promise<GetCTOProductBasicMotorAllTotalCountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCTOProductBasicMotorAllTotalCountDto.fromJS(resultData200);
            return Promise.resolve<GetCTOProductBasicMotorAllTotalCountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCTOProductBasicMotorAllTotalCountDto>(null as any);
    }

    /**
     * @param cpCodes (optional) 
     * @return OK
     */
    getCustomCodeByCpCodes(cpCodes?: string[] | undefined, cancelToken?: CancelToken): Promise<GetCTOProductBasicMotorAllDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetCustomCodeByCpCodes?";
        if (cpCodes === null)
            throw new globalThis.Error("The parameter 'cpCodes' cannot be null.");
        else if (cpCodes !== undefined)
            cpCodes && cpCodes.forEach(item => { url_ += "cpCodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomCodeByCpCodes(_response);
        });
    }

    protected processGetCustomCodeByCpCodes(response: AxiosResponse): Promise<GetCTOProductBasicMotorAllDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCTOProductBasicMotorAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetCTOProductBasicMotorAllDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCTOProductBasicMotorAllDto[]>(null as any);
    }

    /**
     * 获取单个CTO客户化代码的信息
     * @param id (optional) 
     * @return OK
     */
    getCustomCode(id?: string | undefined, cancelToken?: CancelToken): Promise<GetCTOProductBasicMotorDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetCustomCode?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomCode(_response);
        });
    }

    protected processGetCustomCode(response: AxiosResponse): Promise<GetCTOProductBasicMotorDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCTOProductBasicMotorDto.fromJS(resultData200);
            return Promise.resolve<GetCTOProductBasicMotorDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCTOProductBasicMotorDto>(null as any);
    }

    /**
     * 根据OEM购物车中的内容生成订单
     * @return OK
     */
    addOrderFormOEMShoppingCart( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/AddOrderFormOEMShoppingCart";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrderFormOEMShoppingCart(_response);
        });
    }

    protected processAddOrderFormOEMShoppingCart(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * OEM添加到购物车
     * @param body (optional) 
     * @return OK
     */
    addOEMShoppingCart(body?: AddOEMShoppingCartDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/AddOEMShoppingCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOEMShoppingCart(_response);
        });
    }

    protected processAddOEMShoppingCart(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导入OEM数据
     * @param excelFile (optional) 
     * @return OK
     */
    importOEM(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/ImportOEM";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportOEM(_response);
        });
    }

    protected processImportOEM(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导出OEM上传模板
     * @param body (optional) 
     * @return OK
     */
    exportOEMTemplateStream(body?: PageOEMProductBasicMotorAllDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/ExportOEMTemplateStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportOEMTemplateStream(_response);
        });
    }

    protected processExportOEMTemplateStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出OEM上传模板
     * @param fileNmae (optional) 
     * @param body (optional) 
     * @return OK
     */
    exportOEMDtoStream(fileNmae?: string | undefined, body?: ExportOEMProductBasicMotorDto[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/ExportOEMDtoStream?";
        if (fileNmae === null)
            throw new globalThis.Error("The parameter 'fileNmae' cannot be null.");
        else if (fileNmae !== undefined)
            url_ += "fileNmae=" + encodeURIComponent("" + fileNmae) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportOEMDtoStream(_response);
        });
    }

    protected processExportOEMDtoStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除OEM产品组合
     * @param body (optional) 
     * @return OK
     */
    deleteOEM(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/DeleteOEM";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOEM(_response);
        });
    }

    protected processDeleteOEM(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除OEM购物车中的产品组合
     * @param id (optional) 
     * @return OK
     */
    deleteOEMShoppingCart(id?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/DeleteOEMShoppingCart?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOEMShoppingCart(_response);
        });
    }

    protected processDeleteOEMShoppingCart(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取OEM数据
     * @param body (optional) 
     * @return OK
     */
    getOEMProductBasicMotorAll(body?: PageOEMProductBasicMotorAllDto | undefined, cancelToken?: CancelToken): Promise<GetOEMProductBasicMotorAllTotalCountDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetOEMProductBasicMotorAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOEMProductBasicMotorAll(_response);
        });
    }

    protected processGetOEMProductBasicMotorAll(response: AxiosResponse): Promise<GetOEMProductBasicMotorAllTotalCountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOEMProductBasicMotorAllTotalCountDto.fromJS(resultData200);
            return Promise.resolve<GetOEMProductBasicMotorAllTotalCountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOEMProductBasicMotorAllTotalCountDto>(null as any);
    }

    /**
     * 获取OEM表中所有的客户列表
     * @return OK
     */
    getSheetOEMList( cancelToken?: CancelToken): Promise<GetSheetOEMListDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetSheetOEMList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSheetOEMList(_response);
        });
    }

    protected processGetSheetOEMList(response: AxiosResponse): Promise<GetSheetOEMListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetSheetOEMListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetSheetOEMListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSheetOEMListDto[]>(null as any);
    }

    /**
     * 获取单个OEM产品组合的信息
     * @param id (optional) 
     * @return OK
     */
    getOEMProductBasicMotor(id?: string | undefined, cancelToken?: CancelToken): Promise<GetOEMProductBasicMotorDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetOEMProductBasicMotor?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOEMProductBasicMotor(_response);
        });
    }

    protected processGetOEMProductBasicMotor(response: AxiosResponse): Promise<GetOEMProductBasicMotorDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOEMProductBasicMotorDto.fromJS(resultData200);
            return Promise.resolve<GetOEMProductBasicMotorDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOEMProductBasicMotorDto>(null as any);
    }

    /**
     * 获取OEM购物车数据
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getOEMShoppingCartAll(skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<GetOEMShoppingCartAllDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetOEMShoppingCartAll?";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOEMShoppingCartAll(_response);
        });
    }

    protected processGetOEMShoppingCartAll(response: AxiosResponse): Promise<GetOEMShoppingCartAllDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetOEMShoppingCartAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetOEMShoppingCartAllDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOEMShoppingCartAllDto[]>(null as any);
    }

    /**
     * 更新税率
     * @param body (optional) 更新对象
     * @return OK
     */
    saveTaxRateDto(body?: SaveTaxRateDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/SaveTaxRateDto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveTaxRateDto(_response);
        });
    }

    protected processSaveTaxRateDto(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取税率
     * @return OK
     */
    getTaxRateDto( cancelToken?: CancelToken): Promise<TaxRate> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetTaxRateDto";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaxRateDto(_response);
        });
    }

    protected processGetTaxRateDto(response: AxiosResponse): Promise<TaxRate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TaxRate.fromJS(resultData200);
            return Promise.resolve<TaxRate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaxRate>(null as any);
    }

    /**
     * 更新
     * @param body (optional) 
     * @return OK
     */
    saveOrderFormFinalCustomer(body?: OrderFormFinalCustomerDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/SaveOrderFormFinalCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveOrderFormFinalCustomer(_response);
        });
    }

    protected processSaveOrderFormFinalCustomer(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 批量删除
     * @param idListStr (optional) 
     * @return OK
     */
    deleteOrderFormFinalCustomer(idListStr?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/DeleteOrderFormFinalCustomer?";
        if (idListStr === null)
            throw new globalThis.Error("The parameter 'idListStr' cannot be null.");
        else if (idListStr !== undefined)
            idListStr && idListStr.forEach(item => { url_ += "idListStr=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOrderFormFinalCustomer(_response);
        });
    }

    protected processDeleteOrderFormFinalCustomer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取
     * @param customerNo (optional) CP编号
     * @param customerName (optional) 最终客户名称
     * @param customerCode (optional) 最终客户代号
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getOrderFormFinalCustomer(customerNo?: string | undefined, customerName?: string | undefined, customerCode?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<OrderFormFinalCustomer[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetOrderFormFinalCustomer?";
        if (customerNo === null)
            throw new globalThis.Error("The parameter 'customerNo' cannot be null.");
        else if (customerNo !== undefined)
            url_ += "CustomerNo=" + encodeURIComponent("" + customerNo) + "&";
        if (customerName === null)
            throw new globalThis.Error("The parameter 'customerName' cannot be null.");
        else if (customerName !== undefined)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&";
        if (customerCode === null)
            throw new globalThis.Error("The parameter 'customerCode' cannot be null.");
        else if (customerCode !== undefined)
            url_ += "CustomerCode=" + encodeURIComponent("" + customerCode) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderFormFinalCustomer(_response);
        });
    }

    protected processGetOrderFormFinalCustomer(response: AxiosResponse): Promise<OrderFormFinalCustomer[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderFormFinalCustomer.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderFormFinalCustomer[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderFormFinalCustomer[]>(null as any);
    }

    /**
     * 检查未提交订单的产品代码版本是否过时
     * @param orderFormId (optional) 
     * @return OK
     */
    checkProductCodeVersion(orderFormId?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/CheckProductCodeVersion?";
        if (orderFormId === null)
            throw new globalThis.Error("The parameter 'orderFormId' cannot be null.");
        else if (orderFormId !== undefined)
            url_ += "orderFormId=" + encodeURIComponent("" + orderFormId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckProductCodeVersion(_response);
        });
    }

    protected processCheckProductCodeVersion(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 判断vc是否相同 相同则返回true
     * @param body (optional) 
     * @return OK
     */
    comparisonJINVc(body?: GetCodesVersionAndVcsOutputDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/ComparisonJINVc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processComparisonJINVc(_response);
        });
    }

    protected processComparisonJINVc(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 检查失效产品
     * @param body (optional) 
     * @return OK
     */
    checkFailedProduct(body?: ProductBasicMotor[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/CheckFailedProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckFailedProduct(_response);
        });
    }

    protected processCheckFailedProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 查询PMS判断特价号是否存在
     * @param specialOffer (optional) 
     * @return OK
     */
    existsSpecialOffer(specialOffer?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/ExistsSpecialOffer?";
        if (specialOffer === null)
            throw new globalThis.Error("The parameter 'specialOffer' cannot be null.");
        else if (specialOffer !== undefined)
            url_ += "SpecialOffer=" + encodeURIComponent("" + specialOffer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExistsSpecialOffer(_response);
        });
    }

    protected processExistsSpecialOffer(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 是CP或者销售
     * @return OK
     */
    isCPorSale( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/IsCPorSale";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsCPorSale(_response);
        });
    }

    protected processIsCPorSale(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id?: string | undefined, cancelToken?: CancelToken): Promise<OrderFormDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<OrderFormDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderFormDto.fromJS(resultData200);
            return Promise.resolve<OrderFormDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderFormDto>(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<OrderFormDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/GetAll?";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<OrderFormDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderFormDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<OrderFormDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderFormDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body?: OrderFormDto | undefined, cancelToken?: CancelToken): Promise<OrderFormDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<OrderFormDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderFormDto.fromJS(resultData200);
            return Promise.resolve<OrderFormDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderFormDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body?: OrderFormDto | undefined, cancelToken?: CancelToken): Promise<OrderFormDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<OrderFormDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderFormDto.fromJS(resultData200);
            return Promise.resolve<OrderFormDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderFormDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderForm/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OrderInformationServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getOrderInformationsToIWorld(body?: OrderDetailSynchronizeInputDto | undefined, cancelToken?: CancelToken): Promise<OrderInformationsToIWorld> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderInformation/GetOrderInformationsToIWorld";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderInformationsToIWorld(_response);
        });
    }

    protected processGetOrderInformationsToIWorld(response: AxiosResponse): Promise<OrderInformationsToIWorld> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderInformationsToIWorld.fromJS(resultData200);
            return Promise.resolve<OrderInformationsToIWorld>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderInformationsToIWorld>(null as any);
    }
}

export class OrderQuantityLimitServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 查询所有订单单行产品系列数量限制
     * @param body (optional) 
     * @return OK
     */
    getAllPost(body?: PageOrderQuantityLimitSearchInputDto | undefined, cancelToken?: CancelToken): Promise<PageOrderQuantityLimitSearchOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderQuantityLimit/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPost(_response);
        });
    }

    protected processGetAllPost(response: AxiosResponse): Promise<PageOrderQuantityLimitSearchOutputDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageOrderQuantityLimitSearchOutputDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<PageOrderQuantityLimitSearchOutputDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageOrderQuantityLimitSearchOutputDtoPagedResultDto>(null as any);
    }

    /**
     * 单行产品系列数量限制
     * @return OK
     */
    getAllGet( cancelToken?: CancelToken): Promise<PageOrderQuantityLimitSearchOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderQuantityLimit/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllGet(_response);
        });
    }

    protected processGetAllGet(response: AxiosResponse): Promise<PageOrderQuantityLimitSearchOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PageOrderQuantityLimitSearchOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PageOrderQuantityLimitSearchOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageOrderQuantityLimitSearchOutputDto[]>(null as any);
    }

    /**
     * 删除
     * @param body (optional) 
     * @return OK
     */
    delete(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderQuantityLimit/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入订单单行产品系列数量限制
     * @param excelFile (optional) 导入文件
     * @return OK
     */
    import(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderQuantityLimit/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出订单单行产品系列数量限制
     * @param body (optional) 
     * @return OK
     */
    export(body?: PageOrderQuantityLimitSearchInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderQuantityLimit/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class OrderRecordServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 运费计算
     * @param clearFlag (optional) 清洗数据使用，后期删除
     * @param body (optional) 
     * @return OK
     */
    calculationForFreight(clearFlag?: boolean | undefined, body?: CalculationForFreightParam | undefined, cancelToken?: CancelToken): Promise<CalculationForFreightDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderRecord/CalculationForFreight?";
        if (clearFlag === null)
            throw new globalThis.Error("The parameter 'clearFlag' cannot be null.");
        else if (clearFlag !== undefined)
            url_ += "clearFlag=" + encodeURIComponent("" + clearFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculationForFreight(_response);
        });
    }

    protected processCalculationForFreight(response: AxiosResponse): Promise<CalculationForFreightDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CalculationForFreightDto.fromJS(resultData200);
            return Promise.resolve<CalculationForFreightDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalculationForFreightDto>(null as any);
    }

    /**
     * 2023年全年运费清洗
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param deliveryNoteIds (optional) 待计算订单Id
     * @param ignoreFreightNumbers (optional) 忽略运费计算DNS订单编号
     * @return OK
     */
    clearOrderFreight(startTime?: moment.Moment | undefined, endTime?: moment.Moment | undefined, deliveryNoteIds?: string[] | undefined, ignoreFreightNumbers?: string[] | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderRecord/ClearOrderFreight?";
        if (startTime === null)
            throw new globalThis.Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new globalThis.Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (deliveryNoteIds === null)
            throw new globalThis.Error("The parameter 'deliveryNoteIds' cannot be null.");
        else if (deliveryNoteIds !== undefined)
            deliveryNoteIds && deliveryNoteIds.forEach(item => { url_ += "deliveryNoteIds=" + encodeURIComponent("" + item) + "&"; });
        if (ignoreFreightNumbers === null)
            throw new globalThis.Error("The parameter 'ignoreFreightNumbers' cannot be null.");
        else if (ignoreFreightNumbers !== undefined)
            ignoreFreightNumbers && ignoreFreightNumbers.forEach(item => { url_ += "ignoreFreightNumbers=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearOrderFreight(_response);
        });
    }

    protected processClearOrderFreight(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class OrderVisualizationServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 低压可视化库存逻辑开发
     * @param materials (optional) 
     * @return OK
     */
    generateOrderVisualization(materials?: string[] | undefined, cancelToken?: CancelToken): Promise<SapOutputDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderVisualization/GenerateOrderVisualization?";
        if (materials === null)
            throw new globalThis.Error("The parameter 'materials' cannot be null.");
        else if (materials !== undefined)
            materials && materials.forEach(item => { url_ += "materials=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateOrderVisualization(_response);
        });
    }

    protected processGenerateOrderVisualization(response: AxiosResponse): Promise<SapOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SapOutputDto.fromJS(resultData200);
            return Promise.resolve<SapOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SapOutputDto>(null as any);
    }

    /**
     * 针对系统中现有订单的库存逻辑生成
     * @param body (optional) 
     * @return OK
     */
    generateVisualization(body?: string[] | undefined, cancelToken?: CancelToken): Promise<BooleanOrderVisualizationListOrderInformationsListValueTuple> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/OrderVisualization/GenerateVisualization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateVisualization(_response);
        });
    }

    protected processGenerateVisualization(response: AxiosResponse): Promise<BooleanOrderVisualizationListOrderInformationsListValueTuple> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BooleanOrderVisualizationListOrderInformationsListValueTuple.fromJS(resultData200);
            return Promise.resolve<BooleanOrderVisualizationListOrderInformationsListValueTuple>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BooleanOrderVisualizationListOrderInformationsListValueTuple>(null as any);
    }
}

export class ProductBasicMotorMtsServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * ois 下单
     * @param body (optional) 
     * @return OK
     */
    saveShippingInfo(body?: ProductBasicMotorMtsInDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ProductBasicMotorMts/SaveShippingInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveShippingInfo(_response);
        });
    }

    protected processSaveShippingInfo(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 批量删除
     * @param body (optional) 主键合集
     * @return OK
     */
    shippingInfoMultiDelete(body?: string[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ProductBasicMotorMts/ShippingInfoMultiDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShippingInfoMultiDelete(_response);
        });
    }

    protected processShippingInfoMultiDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class ResetToZeroServiceServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 列表加载
     * @param body (optional) 
     * @return OK
     */
    loadResetToZero(body?: ResetSearchDto | undefined, cancelToken?: CancelToken): Promise<ResetToZeroListOutDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ResetToZeroService/LoadResetToZero";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoadResetToZero(_response);
        });
    }

    protected processLoadResetToZero(response: AxiosResponse): Promise<ResetToZeroListOutDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetToZeroListOutDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ResetToZeroListOutDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetToZeroListOutDtoPagedResultDto>(null as any);
    }

    /**
     * 一键清零 add
     * @param body (optional) 
     * @return OK
     */
    resetToZeroAdd(body?: ResetToZeroInDto | undefined, cancelToken?: CancelToken): Promise<OutPutMsg> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ResetToZeroService/ResetToZeroAdd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetToZeroAdd(_response);
        });
    }

    protected processResetToZeroAdd(response: AxiosResponse): Promise<OutPutMsg> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OutPutMsg.fromJS(resultData200);
            return Promise.resolve<OutPutMsg>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OutPutMsg>(null as any);
    }

    /**
     * 一键清零开关，加载数据
     * @return OK
     */
    resetClearOut( cancelToken?: CancelToken): Promise<ResetToZeroOutDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ResetToZeroService/ResetClearOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetClearOut(_response);
        });
    }

    protected processResetClearOut(response: AxiosResponse): Promise<ResetToZeroOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetToZeroOutDto.fromJS(resultData200);
            return Promise.resolve<ResetToZeroOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetToZeroOutDto>(null as any);
    }

    /**
     * 一键清零开关
     * @param body (optional) 
     * @return OK
     */
    resetClear(body?: ResetToZeroInDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ResetToZeroService/ResetClear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetClear(_response);
        });
    }

    protected processResetClear(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 一键清除日志列表
     * @param body (optional) 
     * @return OK
     */
    getResetClearLogList(body?: PageResetToZeroLogDto | undefined, cancelToken?: CancelToken): Promise<PageTotalResetToZeroLogDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ResetToZeroService/GetResetClearLogList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResetClearLogList(_response);
        });
    }

    protected processGetResetClearLogList(response: AxiosResponse): Promise<PageTotalResetToZeroLogDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageTotalResetToZeroLogDto.fromJS(resultData200);
            return Promise.resolve<PageTotalResetToZeroLogDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageTotalResetToZeroLogDto>(null as any);
    }

    /**
     * 一键清零edit
     * @param body (optional) 
     * @return OK
     */
    resetToZeroEdit(body?: ResetToZeroInDto | undefined, cancelToken?: CancelToken): Promise<OutPutMsg> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ResetToZeroService/ResetToZeroEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetToZeroEdit(_response);
        });
    }

    protected processResetToZeroEdit(response: AxiosResponse): Promise<OutPutMsg> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OutPutMsg.fromJS(resultData200);
            return Promise.resolve<OutPutMsg>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OutPutMsg>(null as any);
    }

    /**
     * 一键清零 del
     * @param body (optional) 
     * @return OK
     */
    resetToZeroDel(body?: string[] | undefined, cancelToken?: CancelToken): Promise<OutPutMsg> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ResetToZeroService/ResetToZeroDel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetToZeroDel(_response);
        });
    }

    protected processResetToZeroDel(response: AxiosResponse): Promise<OutPutMsg> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OutPutMsg.fromJS(resultData200);
            return Promise.resolve<OutPutMsg>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OutPutMsg>(null as any);
    }
}

export class SalesAreaServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 查询所有分类产品
     * @param body (optional) 
     * @return OK
     */
    getAll(body?: PageSalesAreaSearchInputDto | undefined, cancelToken?: CancelToken): Promise<PageSalesAreaSearchOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SalesArea/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<PageSalesAreaSearchOutputDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageSalesAreaSearchOutputDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<PageSalesAreaSearchOutputDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageSalesAreaSearchOutputDtoPagedResultDto>(null as any);
    }

    /**
     * 销售区域下拉列表
     * @param body (optional) 
     * @return OK
     */
    getAllListBox(body?: PageSalesAreaSearchInputDto | undefined, cancelToken?: CancelToken): Promise<PageSalesAreaSearchOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SalesArea/GetAllListBox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllListBox(_response);
        });
    }

    protected processGetAllListBox(response: AxiosResponse): Promise<PageSalesAreaSearchOutputDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageSalesAreaSearchOutputDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<PageSalesAreaSearchOutputDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageSalesAreaSearchOutputDtoPagedResultDto>(null as any);
    }

    /**
     * 删除
     * @param body (optional) 
     * @return OK
     */
    delete(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SalesArea/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新销售区域启用状态
     * @param salesAreaId (optional) 销售区域编号
     * @param body (optional) 启用状态
     * @return OK
     */
    updateEnable(salesAreaId?: string | undefined, body?: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SalesArea/UpdateEnable?";
        if (salesAreaId === null)
            throw new globalThis.Error("The parameter 'salesAreaId' cannot be null.");
        else if (salesAreaId !== undefined)
            url_ += "salesAreaId=" + encodeURIComponent("" + salesAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEnable(_response);
        });
    }

    protected processUpdateEnable(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入分类产品
     * @param excelFile (optional) 导入文件
     * @return OK
     */
    import(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SalesArea/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出分类产品
     * @param body (optional) 
     * @return OK
     */
    export(body?: PageSalesAreaSearchInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SalesArea/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class SalesAreaUserServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 查询客户绑定信息列表
     * @param keyword (optional) 搜索关键字
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getSaleAreaUserByPage(keyword?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<SaleAreaUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SalesAreaUser/GetSaleAreaUserByPage?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSaleAreaUserByPage(_response);
        });
    }

    protected processGetSaleAreaUserByPage(response: AxiosResponse): Promise<SaleAreaUserDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaleAreaUserDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<SaleAreaUserDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaleAreaUserDtoPagedResultDto>(null as any);
    }

    /**
     * 查询数据
     * @param id (optional) 
     * @return OK
     */
    get(id?: number | undefined, cancelToken?: CancelToken): Promise<SaleAreaUserDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SalesAreaUser/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SaleAreaUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaleAreaUserDto.fromJS(resultData200);
            return Promise.resolve<SaleAreaUserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaleAreaUserDto>(null as any);
    }

    /**
     * 删除
     * @param body (optional) 
     * @return OK
     */
    delete(body?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SalesAreaUser/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 开启/禁用关联关系
     * @param id (optional) 
     * @param enable (optional) 
     * @return OK
     */
    modifyRelatedStatus(id?: number | undefined, enable?: boolean | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SalesAreaUser/ModifyRelatedStatus?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (enable === null)
            throw new globalThis.Error("The parameter 'enable' cannot be null.");
        else if (enable !== undefined)
            url_ += "enable=" + encodeURIComponent("" + enable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModifyRelatedStatus(_response);
        });
    }

    protected processModifyRelatedStatus(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 新增/编辑
     * @param body (optional) 
     * @return OK
     */
    addOrUpdate(body?: SaleAreaUserDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SalesAreaUser/AddOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrUpdate(_response);
        });
    }

    protected processAddOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入销售区域绑定用户信息信息
     * @param excelFile (optional) 
     * @return OK
     */
    importSaleAreaUser(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SalesAreaUser/ImportSaleAreaUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportSaleAreaUser(_response);
        });
    }

    protected processImportSaleAreaUser(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导入销售区域绑定用户信息信息上传导入模板
     * @return OK
     */
    excelSaleAreaUserTemplate( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SalesAreaUser/ExcelSaleAreaUserTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExcelSaleAreaUserTemplate(_response);
        });
    }

    protected processExcelSaleAreaUserTemplate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导出销售区域绑定用户信息信息-Job导出
     * @param body (optional) 
     * @return OK
     */
    excelSaleAreaUser(body?: PagedSaleAreaUserDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SalesAreaUser/ExcelSaleAreaUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExcelSaleAreaUser(_response);
        });
    }

    protected processExcelSaleAreaUser(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 导出销售区域绑定用户信息信息-导出
     * @param body (optional) 
     * @return OK
     */
    excelSaleAreaUserForJob(body?: PagedSaleAreaUserDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SalesAreaUser/ExcelSaleAreaUserForJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExcelSaleAreaUserForJob(_response);
        });
    }

    protected processExcelSaleAreaUserForJob(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取及联销售区域信息
     * @param saleId (optional) 销售Id(针对CP选择销售后限定销售区域可选范围)
     * @return OK
     */
    getSaleAreaInfosForLinkage(saleId?: number | undefined, cancelToken?: CancelToken): Promise<SaleAreaUserDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SalesAreaUser/GetSaleAreaInfosForLinkage?";
        if (saleId === null)
            throw new globalThis.Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSaleAreaInfosForLinkage(_response);
        });
    }

    protected processGetSaleAreaInfosForLinkage(response: AxiosResponse): Promise<SaleAreaUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SaleAreaUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SaleAreaUserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaleAreaUserDto[]>(null as any);
    }
}

export class SeriesApproverServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 查询所有系列指定审批人
     * @param body (optional) 
     * @return OK
     */
    getAll(body?: PageSeriesApproverSearchInputDto | undefined, cancelToken?: CancelToken): Promise<PageSeriesApproverSearchOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SeriesApprover/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<PageSeriesApproverSearchOutputDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageSeriesApproverSearchOutputDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<PageSeriesApproverSearchOutputDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageSeriesApproverSearchOutputDtoPagedResultDto>(null as any);
    }

    /**
     * 删除
     * @param body (optional) 
     * @return OK
     */
    delete(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SeriesApprover/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入系列指定审批人
     * @param excelFile (optional) 导入文件
     * @return OK
     */
    import(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SeriesApprover/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出系列指定审批人
     * @param body (optional) 
     * @return OK
     */
    export(body?: PageSeriesApproverSearchInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SeriesApprover/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ShortUrlServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取短网址对应的完整网址请求
     * @return OK
     */
    shortUrl(shortCode: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ShortUrl/{shortCode}";
        if (shortCode === undefined || shortCode === null)
            throw new globalThis.Error("The parameter 'shortCode' must be defined.");
        url_ = url_.replace("{shortCode}", encodeURIComponent("" + shortCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShortUrl(_response);
        });
    }

    protected processShortUrl(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取对应的完整网址信息
     * @param shortCode (optional) 
     * @return OK
     */
    getCompleteUrl(shortCode?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ShortUrl/GetCompleteUrl?";
        if (shortCode === null)
            throw new globalThis.Error("The parameter 'shortCode' cannot be null.");
        else if (shortCode !== undefined)
            url_ += "shortCode=" + encodeURIComponent("" + shortCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompleteUrl(_response);
        });
    }

    protected processGetCompleteUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 生成一个有效的编码
     * @return OK
     */
    validShortCode( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ShortUrl/ValidShortCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidShortCode(_response);
        });
    }

    protected processValidShortCode(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取或插入短链接
     * @param completeUrl (optional) 
     * @param productId (optional) 
     * @return OK
     */
    getOrInsert(completeUrl?: string | undefined, productId?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/ShortUrl/GetOrInsert?";
        if (completeUrl === null)
            throw new globalThis.Error("The parameter 'completeUrl' cannot be null.");
        else if (completeUrl !== undefined)
            url_ += "completeUrl=" + encodeURIComponent("" + completeUrl) + "&";
        if (productId === null)
            throw new globalThis.Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrInsert(_response);
        });
    }

    protected processGetOrInsert(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class SpecialOfferNoServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取特价号
     * @return OK
     */
    all( cancelToken?: CancelToken): Promise<SpecialOfferNoDto[]> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SpecialOfferNo/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: AxiosResponse): Promise<SpecialOfferNoDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpecialOfferNoDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SpecialOfferNoDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpecialOfferNoDto[]>(null as any);
    }

    /**
     * 分页获取特价号
     * @param body (optional) 
     * @return OK
     */
    paged(body?: PagedSpecialOfferNoRequestDto | undefined, cancelToken?: CancelToken): Promise<SpecialOfferNoDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SpecialOfferNo/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaged(_response);
        });
    }

    protected processPaged(response: AxiosResponse): Promise<SpecialOfferNoDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SpecialOfferNoDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<SpecialOfferNoDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpecialOfferNoDtoPagedResultDto>(null as any);
    }

    /**
     * 获取特价号详情
     * @param customVcId (optional) 
     * @return OK
     */
    details(customVcId?: string | undefined, cancelToken?: CancelToken): Promise<SpecialOfferNoDto> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SpecialOfferNo/Details?";
        if (customVcId === null)
            throw new globalThis.Error("The parameter 'customVcId' cannot be null.");
        else if (customVcId !== undefined)
            url_ += "customVcId=" + encodeURIComponent("" + customVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<SpecialOfferNoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SpecialOfferNoDto.fromJS(resultData200);
            return Promise.resolve<SpecialOfferNoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpecialOfferNoDto>(null as any);
    }

    /**
     * 创建特价号
     * @param body (optional) 
     * @return OK
     */
    insert(body?: CreateSpecialOfferNoDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SpecialOfferNo/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新特价号
     * @param specialOfferNoId (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(specialOfferNoId?: string | undefined, body?: UpdateSpecialOfferNoDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SpecialOfferNo/Update?";
        if (specialOfferNoId === null)
            throw new globalThis.Error("The parameter 'specialOfferNoId' cannot be null.");
        else if (specialOfferNoId !== undefined)
            url_ += "specialOfferNoId=" + encodeURIComponent("" + specialOfferNoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除特价号
     * @param specialOfferNoId (optional) 
     * @return OK
     */
    delete(specialOfferNoId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SpecialOfferNo/Delete?";
        if (specialOfferNoId === null)
            throw new globalThis.Error("The parameter 'specialOfferNoId' cannot be null.");
        else if (specialOfferNoId !== undefined)
            url_ += "specialOfferNoId=" + encodeURIComponent("" + specialOfferNoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 检查特价号有效性
     * @param specialOfferNumber (optional) 
     * @return OK
     */
    checkValid(specialOfferNumber?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SpecialOfferNo/CheckValid?";
        if (specialOfferNumber === null)
            throw new globalThis.Error("The parameter 'specialOfferNumber' cannot be null.");
        else if (specialOfferNumber !== undefined)
            url_ += "specialOfferNumber=" + encodeURIComponent("" + specialOfferNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckValid(_response);
        });
    }

    protected processCheckValid(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入特价号
     * @param excelFile (optional) 
     * @return OK
     */
    import(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SpecialOfferNo/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出特价号
     * @param body (optional) 
     * @return OK
     */
    exportStream(body?: PagedSpecialOfferNoRequestDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SpecialOfferNo/ExportStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportStream(_response);
        });
    }

    protected processExportStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SysMessageLogServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    toJson(body?: any | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SysMessageLog/ToJson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToJson(_response);
        });
    }

    protected processToJson(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * ois 日志记录
     * @param body (optional) 
     * @return OK
     */
    logAdd(body?: SysMessageLogDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SysMessageLog/LogAdd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogAdd(_response);
        });
    }

    protected processLogAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 批量删除
     * @param body (optional) 主键合集
     * @return OK
     */
    logMultiDelete(body?: string[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SysMessageLog/LogMultiDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogMultiDelete(_response);
        });
    }

    protected processLogMultiDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 删除
     * @param id (optional) 主键
     * @return OK
     */
    logDelete(id?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/SysMessageLog/LogDelete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogDelete(_response);
        });
    }

    protected processLogDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class TaskInfraServiceServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 发送邮件 TODO
     * @param body (optional) 
     * @return OK
     */
    taskAppServiceSendMail(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/TaskInfraService/TaskAppServiceSendMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTaskAppServiceSendMail(_response);
        });
    }

    protected processTaskAppServiceSendMail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 发送邮件
     * @param orderChangeOrderFormId (optional) 
     * @param requestId (optional) 
     * @param noTificationName (optional) 
     * @param isApproved (optional) 
     * @return OK
     */
    finalNotificationEmail(orderChangeOrderFormId?: string | undefined, requestId?: string | undefined, noTificationName?: string | undefined, isApproved?: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/TaskInfraService/FinalNotificationEmail?";
        if (orderChangeOrderFormId === null)
            throw new globalThis.Error("The parameter 'orderChangeOrderFormId' cannot be null.");
        else if (orderChangeOrderFormId !== undefined)
            url_ += "orderChangeOrderFormId=" + encodeURIComponent("" + orderChangeOrderFormId) + "&";
        if (requestId === null)
            throw new globalThis.Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (noTificationName === null)
            throw new globalThis.Error("The parameter 'noTificationName' cannot be null.");
        else if (noTificationName !== undefined)
            url_ += "noTificationName=" + encodeURIComponent("" + noTificationName) + "&";
        if (isApproved === null)
            throw new globalThis.Error("The parameter 'isApproved' cannot be null.");
        else if (isApproved !== undefined)
            url_ += "isApproved=" + encodeURIComponent("" + isApproved) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFinalNotificationEmail(_response);
        });
    }

    protected processFinalNotificationEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 发送单封订单变更通知邮件（合并所有审批人）
    从 OrderChangeTaskAuditLogs 表获取所有审批人邮箱，合并后发送一封邮件
     * @param orderChangeOrderFormId (optional) 订单变更ID
     * @param requestId (optional) 任务请求ID
     * @param notificationName (optional) 通知名称
     * @param isApproved (optional) 是否审批通过（用于过滤物料计划角色）
     * @return OK
     */
    sendSingleOrderChangeNotificationEmail(orderChangeOrderFormId?: string | undefined, requestId?: string | undefined, notificationName?: string | undefined, isApproved?: boolean | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/TaskInfraService/SendSingleOrderChangeNotificationEmail?";
        if (orderChangeOrderFormId === null)
            throw new globalThis.Error("The parameter 'orderChangeOrderFormId' cannot be null.");
        else if (orderChangeOrderFormId !== undefined)
            url_ += "orderChangeOrderFormId=" + encodeURIComponent("" + orderChangeOrderFormId) + "&";
        if (requestId === null)
            throw new globalThis.Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (notificationName === null)
            throw new globalThis.Error("The parameter 'notificationName' cannot be null.");
        else if (notificationName !== undefined)
            url_ += "notificationName=" + encodeURIComponent("" + notificationName) + "&";
        if (isApproved === null)
            throw new globalThis.Error("The parameter 'isApproved' cannot be null.");
        else if (isApproved !== undefined)
            url_ += "isApproved=" + encodeURIComponent("" + isApproved) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendSingleOrderChangeNotificationEmail(_response);
        });
    }

    protected processSendSingleOrderChangeNotificationEmail(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param userEmail (optional) 
     * @return OK
     */
    getIsRoleLBAT(userEmail?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/TaskInfraService/GetIsRoleLBAT?";
        if (userEmail === null)
            throw new globalThis.Error("The parameter 'userEmail' cannot be null.");
        else if (userEmail !== undefined)
            url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsRoleLBAT(_response);
        });
    }

    protected processGetIsRoleLBAT(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 外销发送邮件
     * @param exportOrderId (optional) 
     * @param requestId (optional) 
     * @param noTificationName (optional) 
     * @param isApproved (optional) 
     * @return OK
     */
    exportTaskAppServiceSendMail(exportOrderId?: string | undefined, requestId?: string | undefined, noTificationName?: string | undefined, isApproved?: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/TaskInfraService/ExportTaskAppServiceSendMail?";
        if (exportOrderId === null)
            throw new globalThis.Error("The parameter 'exportOrderId' cannot be null.");
        else if (exportOrderId !== undefined)
            url_ += "exportOrderId=" + encodeURIComponent("" + exportOrderId) + "&";
        if (requestId === null)
            throw new globalThis.Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (noTificationName === null)
            throw new globalThis.Error("The parameter 'noTificationName' cannot be null.");
        else if (noTificationName !== undefined)
            url_ += "noTificationName=" + encodeURIComponent("" + noTificationName) + "&";
        if (isApproved === null)
            throw new globalThis.Error("The parameter 'isApproved' cannot be null.");
        else if (isApproved !== undefined)
            url_ += "isApproved=" + encodeURIComponent("" + isApproved) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportTaskAppServiceSendMail(_response);
        });
    }

    protected processExportTaskAppServiceSendMail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 发送邮件 TODO
     * @param exportOrderId (optional) 
     * @param requestId (optional) 
     * @param noTificationName (optional) 
     * @param body (optional) 
     * @return OK
     */
    exportTaskAppServiceSendMailByTodo(exportOrderId?: string | undefined, requestId?: string | undefined, noTificationName?: string | undefined, body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/TaskInfraService/ExportTaskAppServiceSendMailByTodo?";
        if (exportOrderId === null)
            throw new globalThis.Error("The parameter 'exportOrderId' cannot be null.");
        else if (exportOrderId !== undefined)
            url_ += "exportOrderId=" + encodeURIComponent("" + exportOrderId) + "&";
        if (requestId === null)
            throw new globalThis.Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (noTificationName === null)
            throw new globalThis.Error("The parameter 'noTificationName' cannot be null.");
        else if (noTificationName !== undefined)
            url_ += "noTificationName=" + encodeURIComponent("" + noTificationName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportTaskAppServiceSendMailByTodo(_response);
        });
    }

    protected processExportTaskAppServiceSendMailByTodo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TencentOCRServiceServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 调用OCR
     * @param imageBase64 (optional) 
     * @param fileType (optional) 
     * @return OK
     */
    bankSlipOCRSync(imageBase64?: string | undefined, fileType?: string | undefined, cancelToken?: CancelToken): Promise<BooleanStringValueTuple> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/TencentOCRService/BankSlipOCRSync?";
        if (imageBase64 === null)
            throw new globalThis.Error("The parameter 'imageBase64' cannot be null.");
        else if (imageBase64 !== undefined)
            url_ += "ImageBase64=" + encodeURIComponent("" + imageBase64) + "&";
        if (fileType === null)
            throw new globalThis.Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBankSlipOCRSync(_response);
        });
    }

    protected processBankSlipOCRSync(response: AxiosResponse): Promise<BooleanStringValueTuple> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BooleanStringValueTuple.fromJS(resultData200);
            return Promise.resolve<BooleanStringValueTuple>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BooleanStringValueTuple>(null as any);
    }

    /**
     * 根据文件路径，返回文件byte[]
     * @param filePath (optional) 
     * @return OK
     */
    getFileBytes(filePath?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/OrderInputSystem/TencentOCRService/GetFileBytes?";
        if (filePath === null)
            throw new globalThis.Error("The parameter 'filePath' cannot be null.");
        else if (filePath !== undefined)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileBytes(_response);
        });
    }

    protected processGetFileBytes(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class WorkFlowServiceTaskServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    startInternalEvaluation(body?: ExternalTaskInput | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/wfst/startInternalEvaluation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartInternalEvaluation(_response);
        });
    }

    protected processStartInternalEvaluation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    doFavor(body?: ExternalTaskInput | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/wfst/doFavor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDoFavor(_response);
        });
    }

    protected processDoFavor(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    factoryEvaluationBomMaterial(body?: ExternalTaskInput | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/wfst/FactoryEvaluationBomMaterial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFactoryEvaluationBomMaterial(_response);
        });
    }

    protected processFactoryEvaluationBomMaterial(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    factoryEvaluationBomProduction(body?: ExternalTaskInput | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/wfst/FactoryEvaluationBomProduction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFactoryEvaluationBomProduction(_response);
        });
    }

    protected processFactoryEvaluationBomProduction(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    factoryEvaluationBom(body?: ExternalTaskInput | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/wfst/FactoryEvaluationBom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFactoryEvaluationBom(_response);
        });
    }

    protected processFactoryEvaluationBom(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    factoryEvaluationBomSummary(body?: ExternalTaskInput | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/wfst/FactoryEvaluationBomSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFactoryEvaluationBomSummary(_response);
        });
    }

    protected processFactoryEvaluationBomSummary(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param serviceRequestId (optional) 
     * @param notificationType (optional) 100 = Todo_Assignee

    101 = Todo_Candidate

    102 = Todo_Owner

    200 = Todo_WillTimeoutIn2Days

    201 = Todo_Timeout

    202 = Todo_Timeout2Days

    203 = Todo_TimeoutOver5Days

    300 = Comment_External_CustomerCreated

    301 = Comment_External_AbbUserCreated

    302 = Comment_Internal_Created

    330 = Comment_ReadReceiptCreated

    400 = WorkOrder_NotCommitted_OverOneHour

    401 = WorkOrder_Committed

    402 = WorkOrder_Processing

    405 = WorkOrder_Close

    501 = ST_Task_Update
     * @param taskId (optional) 
     * @param assignee (optional) 
     * @return OK
     */
    taskEvent(serviceRequestId?: string | undefined, notificationType?: NotificationTypeEnum | undefined, taskId?: string | undefined, assignee?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/wfst/TaskEvent?";
        if (serviceRequestId === null)
            throw new globalThis.Error("The parameter 'serviceRequestId' cannot be null.");
        else if (serviceRequestId !== undefined)
            url_ += "serviceRequestId=" + encodeURIComponent("" + serviceRequestId) + "&";
        if (notificationType === null)
            throw new globalThis.Error("The parameter 'notificationType' cannot be null.");
        else if (notificationType !== undefined)
            url_ += "notificationType=" + encodeURIComponent("" + notificationType) + "&";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (assignee === null)
            throw new globalThis.Error("The parameter 'assignee' cannot be null.");
        else if (assignee !== undefined)
            url_ += "assignee=" + encodeURIComponent("" + assignee) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTaskEvent(_response);
        });
    }

    protected processTaskEvent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param serviceRequestId (optional) 
     * @param notificationType (optional) 100 = Todo_Assignee

    101 = Todo_Candidate

    102 = Todo_Owner

    200 = Todo_WillTimeoutIn2Days

    201 = Todo_Timeout

    202 = Todo_Timeout2Days

    203 = Todo_TimeoutOver5Days

    300 = Comment_External_CustomerCreated

    301 = Comment_External_AbbUserCreated

    302 = Comment_Internal_Created

    330 = Comment_ReadReceiptCreated

    400 = WorkOrder_NotCommitted_OverOneHour

    401 = WorkOrder_Committed

    402 = WorkOrder_Processing

    405 = WorkOrder_Close

    501 = ST_Task_Update
     * @param taskId (optional) 
     * @param assignee (optional) 
     * @return OK
     */
    taskEventBOM(serviceRequestId?: string | undefined, notificationType?: NotificationTypeEnum | undefined, taskId?: string | undefined, assignee?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/wfst/TaskEventBOM?";
        if (serviceRequestId === null)
            throw new globalThis.Error("The parameter 'serviceRequestId' cannot be null.");
        else if (serviceRequestId !== undefined)
            url_ += "serviceRequestId=" + encodeURIComponent("" + serviceRequestId) + "&";
        if (notificationType === null)
            throw new globalThis.Error("The parameter 'notificationType' cannot be null.");
        else if (notificationType !== undefined)
            url_ += "notificationType=" + encodeURIComponent("" + notificationType) + "&";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (assignee === null)
            throw new globalThis.Error("The parameter 'assignee' cannot be null.");
        else if (assignee !== undefined)
            url_ += "assignee=" + encodeURIComponent("" + assignee) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTaskEventBOM(_response);
        });
    }

    protected processTaskEventBOM(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param serviceRequestId (optional) 
     * @param notificationType (optional) 100 = Todo_Assignee

    101 = Todo_Candidate

    102 = Todo_Owner

    200 = Todo_WillTimeoutIn2Days

    201 = Todo_Timeout

    202 = Todo_Timeout2Days

    203 = Todo_TimeoutOver5Days

    300 = Comment_External_CustomerCreated

    301 = Comment_External_AbbUserCreated

    302 = Comment_Internal_Created

    330 = Comment_ReadReceiptCreated

    400 = WorkOrder_NotCommitted_OverOneHour

    401 = WorkOrder_Committed

    402 = WorkOrder_Processing

    405 = WorkOrder_Close

    501 = ST_Task_Update
     * @param taskId (optional) 
     * @param assignee (optional) 
     * @return OK
     */
    taskEventMaterial(serviceRequestId?: string | undefined, notificationType?: NotificationTypeEnum | undefined, taskId?: string | undefined, assignee?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/wfst/TaskEventMaterial?";
        if (serviceRequestId === null)
            throw new globalThis.Error("The parameter 'serviceRequestId' cannot be null.");
        else if (serviceRequestId !== undefined)
            url_ += "serviceRequestId=" + encodeURIComponent("" + serviceRequestId) + "&";
        if (notificationType === null)
            throw new globalThis.Error("The parameter 'notificationType' cannot be null.");
        else if (notificationType !== undefined)
            url_ += "notificationType=" + encodeURIComponent("" + notificationType) + "&";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (assignee === null)
            throw new globalThis.Error("The parameter 'assignee' cannot be null.");
        else if (assignee !== undefined)
            url_ += "assignee=" + encodeURIComponent("" + assignee) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTaskEventMaterial(_response);
        });
    }

    protected processTaskEventMaterial(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param serviceRequestId (optional) 
     * @param notificationType (optional) 100 = Todo_Assignee

    101 = Todo_Candidate

    102 = Todo_Owner

    200 = Todo_WillTimeoutIn2Days

    201 = Todo_Timeout

    202 = Todo_Timeout2Days

    203 = Todo_TimeoutOver5Days

    300 = Comment_External_CustomerCreated

    301 = Comment_External_AbbUserCreated

    302 = Comment_Internal_Created

    330 = Comment_ReadReceiptCreated

    400 = WorkOrder_NotCommitted_OverOneHour

    401 = WorkOrder_Committed

    402 = WorkOrder_Processing

    405 = WorkOrder_Close

    501 = ST_Task_Update
     * @param taskId (optional) 
     * @param assignee (optional) 
     * @return OK
     */
    taskEventProduction(serviceRequestId?: string | undefined, notificationType?: NotificationTypeEnum | undefined, taskId?: string | undefined, assignee?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/wfst/TaskEventProduction?";
        if (serviceRequestId === null)
            throw new globalThis.Error("The parameter 'serviceRequestId' cannot be null.");
        else if (serviceRequestId !== undefined)
            url_ += "serviceRequestId=" + encodeURIComponent("" + serviceRequestId) + "&";
        if (notificationType === null)
            throw new globalThis.Error("The parameter 'notificationType' cannot be null.");
        else if (notificationType !== undefined)
            url_ += "notificationType=" + encodeURIComponent("" + notificationType) + "&";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (assignee === null)
            throw new globalThis.Error("The parameter 'assignee' cannot be null.");
        else if (assignee !== undefined)
            url_ += "assignee=" + encodeURIComponent("" + assignee) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTaskEventProduction(_response);
        });
    }

    protected processTaskEventProduction(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AuthorizedUserCustomerServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * GCS授权人分页展示授权客户
     * @param userName (optional) 
     * @param finalCustomerNames (optional) 
     * @param finalCustomerCodes (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getPageAuthorizedUserCustomer(userName?: string | undefined, finalCustomerNames?: string[] | undefined, finalCustomerCodes?: string[] | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined, filter?: string | undefined, cancelToken?: CancelToken): Promise<GetAuthorizedUserCustomerOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/AuthorizedUserCustomer/GetPageAuthorizedUserCustomer?";
        if (userName === null)
            throw new globalThis.Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (finalCustomerNames === null)
            throw new globalThis.Error("The parameter 'finalCustomerNames' cannot be null.");
        else if (finalCustomerNames !== undefined)
            finalCustomerNames && finalCustomerNames.forEach(item => { url_ += "FinalCustomerNames=" + encodeURIComponent("" + item) + "&"; });
        if (finalCustomerCodes === null)
            throw new globalThis.Error("The parameter 'finalCustomerCodes' cannot be null.");
        else if (finalCustomerCodes !== undefined)
            finalCustomerCodes && finalCustomerCodes.forEach(item => { url_ += "FinalCustomerCodes=" + encodeURIComponent("" + item) + "&"; });
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageAuthorizedUserCustomer(_response);
        });
    }

    protected processGetPageAuthorizedUserCustomer(response: AxiosResponse): Promise<GetAuthorizedUserCustomerOutputDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAuthorizedUserCustomerOutputDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<GetAuthorizedUserCustomerOutputDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAuthorizedUserCustomerOutputDtoPagedResultDto>(null as any);
    }

    /**
     * 获取所有GCS授权人信息
     * @param userName (optional) 
     * @param finalCustomerNames (optional) 
     * @param finalCustomerCodes (optional) 
     * @return OK
     */
    getAuthorizedUserCustomer(userName?: string | undefined, finalCustomerNames?: string[] | undefined, finalCustomerCodes?: string[] | undefined, cancelToken?: CancelToken): Promise<GetAuthorizedUserCustomerOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/AuthorizedUserCustomer/GetAuthorizedUserCustomer?";
        if (userName === null)
            throw new globalThis.Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (finalCustomerNames === null)
            throw new globalThis.Error("The parameter 'finalCustomerNames' cannot be null.");
        else if (finalCustomerNames !== undefined)
            finalCustomerNames && finalCustomerNames.forEach(item => { url_ += "FinalCustomerNames=" + encodeURIComponent("" + item) + "&"; });
        if (finalCustomerCodes === null)
            throw new globalThis.Error("The parameter 'finalCustomerCodes' cannot be null.");
        else if (finalCustomerCodes !== undefined)
            finalCustomerCodes && finalCustomerCodes.forEach(item => { url_ += "FinalCustomerCodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthorizedUserCustomer(_response);
        });
    }

    protected processGetAuthorizedUserCustomer(response: AxiosResponse): Promise<GetAuthorizedUserCustomerOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAuthorizedUserCustomerOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetAuthorizedUserCustomerOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAuthorizedUserCustomerOutputDto[]>(null as any);
    }

    /**
     * 根据二级客户获取GCS(需求变更需要一二级同时匹配，该接口已启用20260716)
     * @param body (optional) 
     * @return OK
     */
    getGCSByCustomer(body?: GetGCSByCustomerInputDto | undefined, cancelToken?: CancelToken): Promise<GetGCSByCustomerOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/AuthorizedUserCustomer/GetGCSByCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGCSByCustomer(_response);
        });
    }

    protected processGetGCSByCustomer(response: AxiosResponse): Promise<GetGCSByCustomerOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGCSByCustomerOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetGCSByCustomerOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetGCSByCustomerOutputDto[]>(null as any);
    }

    /**
     * 根据一级二级用户及一次性项目选型Id获取GCS(复制选型默认选中gcs的接口)
     * @param body (optional) 
     * @return OK
     */
    getGCSByCustomerAndLectoTypeId(body?: GetGCSByCustomerAndLectoTypeIdDto | undefined, cancelToken?: CancelToken): Promise<GetGCSByCustomerOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/AuthorizedUserCustomer/GetGCSByCustomerAndLectoTypeId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGCSByCustomerAndLectoTypeId(_response);
        });
    }

    protected processGetGCSByCustomerAndLectoTypeId(response: AxiosResponse): Promise<GetGCSByCustomerOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetGCSByCustomerOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetGCSByCustomerOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetGCSByCustomerOutputDto[]>(null as any);
    }

    /**
     * 新增授权客户（按授权人维度添加授权客户）
     * @param body (optional) 
     * @return OK
     */
    add(body?: AddAuthorizedUserCustomerRequestDto | undefined, cancelToken?: CancelToken): Promise<GetAuthorizedUserCustomerOutputDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/AuthorizedUserCustomer/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<GetAuthorizedUserCustomerOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAuthorizedUserCustomerOutputDto.fromJS(resultData200);
            return Promise.resolve<GetAuthorizedUserCustomerOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAuthorizedUserCustomerOutputDto>(null as any);
    }

    /**
     * 删除当前客户关联的GCS信息
     * @param id (optional) 
     * @return OK
     */
    delete(id?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/AuthorizedUserCustomer/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 按照客户维度获取客户GCS列表
     * @param finalCustomerName (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getPageAuthorizedCustomer(finalCustomerName?: string | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined, filter?: string | undefined, cancelToken?: CancelToken): Promise<GetPageAuthorizedCustomerOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/AuthorizedUserCustomer/GetPageAuthorizedCustomer?";
        if (finalCustomerName === null)
            throw new globalThis.Error("The parameter 'finalCustomerName' cannot be null.");
        else if (finalCustomerName !== undefined)
            url_ += "FinalCustomerName=" + encodeURIComponent("" + finalCustomerName) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageAuthorizedCustomer(_response);
        });
    }

    protected processGetPageAuthorizedCustomer(response: AxiosResponse): Promise<GetPageAuthorizedCustomerOutputDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPageAuthorizedCustomerOutputDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<GetPageAuthorizedCustomerOutputDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPageAuthorizedCustomerOutputDtoPagedResultDto>(null as any);
    }

    /**
     * 新增客户GCS人员（按客户维度新增）
     * @param body (optional) 
     * @return OK
     */
    addCustomer(body?: AddCustomerRequestDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/AuthorizedUserCustomer/AddCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddCustomer(_response);
        });
    }

    protected processAddCustomer(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 批量新增客户GCS人员
     * @param body (optional) 
     * @return OK
     */
    batchAddCustomer(body?: BatchAddCustomerRequestDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/AuthorizedUserCustomer/BatchAddCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchAddCustomer(_response);
        });
    }

    protected processBatchAddCustomer(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 删除当前客户的全部gcs信息（包括GCS人员）
     * @param id (optional) 
     * @return OK
     */
    deleteScope(id?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/AuthorizedUserCustomer/DeleteScope";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteScope(_response);
        });
    }

    protected processDeleteScope(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 导出gcs境界支持
     * @param body (optional) 
     * @return OK
     */
    exportAuthorizedUserCustomer(body?: GetPageAuthorizedCustomerInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/AuthorizedUserCustomer/ExportAuthorizedUserCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportAuthorizedUserCustomer(_response);
        });
    }

    protected processExportAuthorizedUserCustomer(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导入gcs境界支持
     * @param excelFile (optional) 
     * @return OK
     */
    importAuthorizedUserCustomer(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/AuthorizedUserCustomer/ImportAuthorizedUserCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportAuthorizedUserCustomer(_response);
        });
    }

    protected processImportAuthorizedUserCustomer(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class BasicMotorInfoServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 分页查询
     * @param body (optional) 
     * @return OK
     */
    getPageBasicMotorInfos(body?: PageBasicMotorInfosInputDto | undefined, cancelToken?: CancelToken): Promise<PageBasicMotorInfoOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorInfo/GetPageBasicMotorInfos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageBasicMotorInfos(_response);
        });
    }

    protected processGetPageBasicMotorInfos(response: AxiosResponse): Promise<PageBasicMotorInfoOutputDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageBasicMotorInfoOutputDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<PageBasicMotorInfoOutputDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageBasicMotorInfoOutputDtoPagedResultDto>(null as any);
    }

    /**
     * 获取新的主机分页（一维展示）
     * @param body (optional) 
     * @return OK
     */
    getNewPageBasicMotorInfos(body?: PageBasicMotorInfosInputDto | undefined, cancelToken?: CancelToken): Promise<PageBasicMotorInfoOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorInfo/GetNewPageBasicMotorInfos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewPageBasicMotorInfos(_response);
        });
    }

    protected processGetNewPageBasicMotorInfos(response: AxiosResponse): Promise<PageBasicMotorInfoOutputDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageBasicMotorInfoOutputDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<PageBasicMotorInfoOutputDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageBasicMotorInfoOutputDtoPagedResultDto>(null as any);
    }

    /**
     * 更新同步主机确认状态
     * @param body (optional) 
     * @return OK
     */
    updateBasicMotorConfirmStatus(body?: UpdateBasicMotorConfirmStatusInputDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorInfo/UpdateBasicMotorConfirmStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBasicMotorConfirmStatus(_response);
        });
    }

    protected processUpdateBasicMotorConfirmStatus(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 查询产品代码
     * @param basicMotorCode (optional) 
     * @return OK
     */
    getTop10BasicMotorInfos(basicMotorCode?: string | undefined, cancelToken?: CancelToken): Promise<BasicMotorInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorInfo/GetTop10BasicMotorInfos?";
        if (basicMotorCode === null)
            throw new globalThis.Error("The parameter 'basicMotorCode' cannot be null.");
        else if (basicMotorCode !== undefined)
            url_ += "basicMotorCode=" + encodeURIComponent("" + basicMotorCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTop10BasicMotorInfos(_response);
        });
    }

    protected processGetTop10BasicMotorInfos(response: AxiosResponse): Promise<BasicMotorInfoDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BasicMotorInfoDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BasicMotorInfoDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BasicMotorInfoDto[]>(null as any);
    }

    /**
     * 删除主机
     * @param body (optional) 待删除的主机编号
     * @return OK
     */
    deleteBasicMotor(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorInfo/DeleteBasicMotor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBasicMotor(_response);
        });
    }

    protected processDeleteBasicMotor(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据主机代码查询参数（OIS系统使用）
     * @param body (optional) 
     * @return OK
     */
    getBasicMotorInfosByCodeOnOis(body?: string[] | undefined, cancelToken?: CancelToken): Promise<PageBasicMotorInfoOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorInfo/GetBasicMotorInfosByCodeOnOis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasicMotorInfosByCodeOnOis(_response);
        });
    }

    protected processGetBasicMotorInfosByCodeOnOis(response: AxiosResponse): Promise<PageBasicMotorInfoOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PageBasicMotorInfoOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PageBasicMotorInfoOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageBasicMotorInfoOutputDto[]>(null as any);
    }

    /**
     * 获取主机对应的授权客户数据（ois使用）
     * @param codes (optional) 
     * @return OK
     */
    getBasicMotorInfoCustomersByCode(codes?: string[] | undefined, cancelToken?: CancelToken): Promise<BasicMotorInfoCustomersOutPutDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorInfo/GetBasicMotorInfoCustomersByCode?";
        if (codes === null)
            throw new globalThis.Error("The parameter 'codes' cannot be null.");
        else if (codes !== undefined)
            codes && codes.forEach(item => { url_ += "codes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasicMotorInfoCustomersByCode(_response);
        });
    }

    protected processGetBasicMotorInfoCustomersByCode(response: AxiosResponse): Promise<BasicMotorInfoCustomersOutPutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BasicMotorInfoCustomersOutPutDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BasicMotorInfoCustomersOutPutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BasicMotorInfoCustomersOutPutDto[]>(null as any);
    }

    /**
     * 根据主机代码查询参数
     * @param basicMotorCode (optional) 
     * @return OK
     */
    getBasicMotorParameterByCode(basicMotorCode?: string | undefined, cancelToken?: CancelToken): Promise<PageBasicMotorInfoOutputDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorInfo/GetBasicMotorParameterByCode?";
        if (basicMotorCode === null)
            throw new globalThis.Error("The parameter 'basicMotorCode' cannot be null.");
        else if (basicMotorCode !== undefined)
            url_ += "basicMotorCode=" + encodeURIComponent("" + basicMotorCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasicMotorParameterByCode(_response);
        });
    }

    protected processGetBasicMotorParameterByCode(response: AxiosResponse): Promise<PageBasicMotorInfoOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageBasicMotorInfoOutputDto.fromJS(resultData200);
            return Promise.resolve<PageBasicMotorInfoOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageBasicMotorInfoOutputDto>(null as any);
    }

    /**
     * 添加/修改
     * @param body (optional) 
     * @return OK
     */
    createOrUpdate(body?: CreateOrUpdateBasicMotorInfoInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorInfo/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getBasicMotorInfoDetail(id?: string | undefined, cancelToken?: CancelToken): Promise<CreateOrUpdateBasicMotorInfoInputDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorInfo/GetBasicMotorInfoDetail?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasicMotorInfoDetail(_response);
        });
    }

    protected processGetBasicMotorInfoDetail(response: AxiosResponse): Promise<CreateOrUpdateBasicMotorInfoInputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrUpdateBasicMotorInfoInputDto.fromJS(resultData200);
            return Promise.resolve<CreateOrUpdateBasicMotorInfoInputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrUpdateBasicMotorInfoInputDto>(null as any);
    }

    /**
     * 批量删除
     * @param input (optional) 
     * @return OK
     */
    deletes(input?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorInfo/Deletes?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            input && input.forEach(item => { url_ += "input=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletes(_response);
        });
    }

    protected processDeletes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据主机代码获取主机信息
     * @param code (optional) 
     * @return OK
     */
    getBasicMotorInfoByCode(code?: string | undefined, cancelToken?: CancelToken): Promise<BasicMotorInfo> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorInfo/GetBasicMotorInfoByCode?";
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasicMotorInfoByCode(_response);
        });
    }

    protected processGetBasicMotorInfoByCode(response: AxiosResponse): Promise<BasicMotorInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BasicMotorInfo.fromJS(resultData200);
            return Promise.resolve<BasicMotorInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BasicMotorInfo>(null as any);
    }

    /**
     * 通过产品代码搜索可适用VC
    当产品带VC时识别VC属于Close or Open Vc
    当产品不带VC时，默认查询产品代码可用的VC M2BAX 系列存在内外销2套产品代码和2套VC,区别是内销的的产品代码以“CN”结尾，其余产品系列，内外销一致
    对于产品在系统中不存在的产品代码默认返回所有的标准VC、特殊VC
     * @param body (optional) 
     * @return OK
     */
    applicableVcs(body?: BasicMotorApplicableVcInputDto[] | undefined, cancelToken?: CancelToken): Promise<BasicMotorApplicableVcOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorInfo/ApplicableVcs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApplicableVcs(_response);
        });
    }

    protected processApplicableVcs(response: AxiosResponse): Promise<BasicMotorApplicableVcOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BasicMotorApplicableVcOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BasicMotorApplicableVcOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BasicMotorApplicableVcOutputDto[]>(null as any);
    }

    /**
     * 主机查询可适用VC
     * @param body (optional) 
     * @return OK
     */
    queryApplicableVcs(body?: BasicMotorQueryApplicableVcInputDto | undefined, cancelToken?: CancelToken): Promise<BasicMotorApplicableVcOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorInfo/QueryApplicableVcs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryApplicableVcs(_response);
        });
    }

    protected processQueryApplicableVcs(response: AxiosResponse): Promise<BasicMotorApplicableVcOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BasicMotorApplicableVcOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BasicMotorApplicableVcOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BasicMotorApplicableVcOutputDto[]>(null as any);
    }

    /**
     * 导入裸机数据
     * @param excelFile (optional) 导入文件
     * @return OK
     */
    dataImport(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorInfo/DataImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDataImport(_response);
        });
    }

    protected processDataImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    syncBasicMotorCompatibleVC(body?: BasicMotorCompatibleInfoDTO | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorInfo/SyncBasicMotorCompatibleVC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncBasicMotorCompatibleVC(_response);
        });
    }

    protected processSyncBasicMotorCompatibleVC(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导出主机
     * @param body (optional) 条件筛选对象
     * @return OK
     */
    exportBasicMotorInfoStream(body?: PageBasicMotorInfosInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorInfo/ExportBasicMotorInfoStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportBasicMotorInfoStream(_response);
        });
    }

    protected processExportBasicMotorInfoStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除主机
     * @param body (optional) 条件筛选对象
     * @return OK
     */
    deleteBasicMotorInfo(body?: PageBasicMotorInfosInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorInfo/DeleteBasicMotorInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBasicMotorInfo(_response);
        });
    }

    protected processDeleteBasicMotorInfo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除所有主机
     * @return OK
     */
    deleteBasicMotorInfoAll( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorInfo/DeleteBasicMotorInfoAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBasicMotorInfoAll(_response);
        });
    }

    protected processDeleteBasicMotorInfoAll(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class BasicMotorSriesServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取所有主机系列
     * @param isFilterJIN (optional) 
     * @return OK
     */
    getBasicMotorSriesGet(isFilterJIN?: boolean | undefined, cancelToken?: CancelToken): Promise<PageBasicMotorSriesOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorSries/GetBasicMotorSries?";
        if (isFilterJIN === null)
            throw new globalThis.Error("The parameter 'isFilterJIN' cannot be null.");
        else if (isFilterJIN !== undefined)
            url_ += "isFilterJIN=" + encodeURIComponent("" + isFilterJIN) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasicMotorSriesGet(_response);
        });
    }

    protected processGetBasicMotorSriesGet(response: AxiosResponse): Promise<PageBasicMotorSriesOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PageBasicMotorSriesOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PageBasicMotorSriesOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageBasicMotorSriesOutputDto[]>(null as any);
    }

    /**
     * 获取所有主机系列
     * @param body (optional) 
     * @return OK
     */
    getBasicMotorSriesPost(body?: PageBasicMotorSriesSearchDto | undefined, cancelToken?: CancelToken): Promise<PageTotalBasicMotorSriesDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorSries/GetBasicMotorSries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasicMotorSriesPost(_response);
        });
    }

    protected processGetBasicMotorSriesPost(response: AxiosResponse): Promise<PageTotalBasicMotorSriesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageTotalBasicMotorSriesDto.fromJS(resultData200);
            return Promise.resolve<PageTotalBasicMotorSriesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageTotalBasicMotorSriesDto>(null as any);
    }

    /**
     * 获取所有主机系列
     * @param level (optional) 系列等级
     * @return OK
     */
    getBasicMotorseress(level?: number | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorSries/GetBasicMotorseress?";
        if (level === null)
            throw new globalThis.Error("The parameter 'level' cannot be null.");
        else if (level !== undefined)
            url_ += "level=" + encodeURIComponent("" + level) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasicMotorseress(_response);
        });
    }

    protected processGetBasicMotorseress(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 获取主机系列详情
     * @param sriesId (optional) 
     * @return OK
     */
    getBasicMotorSriesDetails(sriesId?: number | undefined, cancelToken?: CancelToken): Promise<PageBasicMotorSriesDetailsOutputDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorSries/GetBasicMotorSriesDetails?";
        if (sriesId === null)
            throw new globalThis.Error("The parameter 'sriesId' cannot be null.");
        else if (sriesId !== undefined)
            url_ += "sriesId=" + encodeURIComponent("" + sriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasicMotorSriesDetails(_response);
        });
    }

    protected processGetBasicMotorSriesDetails(response: AxiosResponse): Promise<PageBasicMotorSriesDetailsOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageBasicMotorSriesDetailsOutputDto.fromJS(resultData200);
            return Promise.resolve<PageBasicMotorSriesDetailsOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageBasicMotorSriesDetailsOutputDto>(null as any);
    }

    /**
     * 返回树形产品系列
     * @return OK
     */
    getBasicMotorSriesTreeData( cancelToken?: CancelToken): Promise<BasicMotorSriesTreeDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorSries/GetBasicMotorSriesTreeData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasicMotorSriesTreeData(_response);
        });
    }

    protected processGetBasicMotorSriesTreeData(response: AxiosResponse): Promise<BasicMotorSriesTreeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BasicMotorSriesTreeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BasicMotorSriesTreeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BasicMotorSriesTreeDto[]>(null as any);
    }

    /**
     * 移动产品系列
     * @param id (optional) 被移动的节点位置
     * @param toId (optional) 移动到的节点
     * @param moveType (optional) 移动类型  子节点 Child  同级节点之前 Pre  同级节点之后 Next
     * @return OK
     */
    moveBaseMotorSries(id?: number | undefined, toId?: number | undefined, moveType?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorSries/MoveBaseMotorSries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (toId === null || toId === undefined)
            throw new globalThis.Error("The parameter 'toId' cannot be null.");
        else
            content_.append("ToId", toId.toString());
        if (moveType === null || moveType === undefined)
            throw new globalThis.Error("The parameter 'moveType' cannot be null.");
        else
            content_.append("MoveType", moveType.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveBaseMotorSries(_response);
        });
    }

    protected processMoveBaseMotorSries(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 修改产品系列隐藏状态
     * @param id (optional) 系列主键
     * @param hide (optional) 是否隐藏
     * @return OK
     */
    updateBaseMotorSriesHide(id?: number | undefined, hide?: boolean | undefined, cancelToken?: CancelToken): Promise<BasicMotorSriesInfoDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorSries/UpdateBaseMotorSriesHide";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (hide === null || hide === undefined)
            throw new globalThis.Error("The parameter 'hide' cannot be null.");
        else
            content_.append("Hide", hide.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBaseMotorSriesHide(_response);
        });
    }

    protected processUpdateBaseMotorSriesHide(response: AxiosResponse): Promise<BasicMotorSriesInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BasicMotorSriesInfoDto.fromJS(resultData200);
            return Promise.resolve<BasicMotorSriesInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BasicMotorSriesInfoDto>(null as any);
    }

    /**
     * 更新产品系列信息
     * @param id (optional) 
     * @param name (optional) 
     * @param hide (optional) 是否隐藏
     * @return OK
     */
    updateBaseMotorSriesInfo(id?: number | undefined, name?: string | undefined, hide?: boolean | undefined, cancelToken?: CancelToken): Promise<BasicMotorSriesInfoDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/BasicMotorSries/UpdateBaseMotorSriesInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (name === null || name === undefined)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (hide === null || hide === undefined)
            throw new globalThis.Error("The parameter 'hide' cannot be null.");
        else
            content_.append("Hide", hide.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBaseMotorSriesInfo(_response);
        });
    }

    protected processUpdateBaseMotorSriesInfo(response: AxiosResponse): Promise<BasicMotorSriesInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BasicMotorSriesInfoDto.fromJS(resultData200);
            return Promise.resolve<BasicMotorSriesInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BasicMotorSriesInfoDto>(null as any);
    }
}

export class CategoryServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取品类
     * @return OK
     */
    all( cancelToken?: CancelToken): Promise<CategoryDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Category/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: AxiosResponse): Promise<CategoryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CategoryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDto[]>(null as any);
    }

    /**
     * 分页获取品类
     * @param body (optional) 
     * @return OK
     */
    paged(body?: PagedCategoryRequestDto | undefined, cancelToken?: CancelToken): Promise<CategoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Category/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaged(_response);
        });
    }

    protected processPaged(response: AxiosResponse): Promise<CategoryDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<CategoryDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDtoPagedResultDto>(null as any);
    }

    /**
     * 获取品类详情
     * @param customVcId (optional) 
     * @return OK
     */
    details(customVcId?: string | undefined, cancelToken?: CancelToken): Promise<CategoryDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Category/Details?";
        if (customVcId === null)
            throw new globalThis.Error("The parameter 'customVcId' cannot be null.");
        else if (customVcId !== undefined)
            url_ += "customVcId=" + encodeURIComponent("" + customVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<CategoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryDto.fromJS(resultData200);
            return Promise.resolve<CategoryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDto>(null as any);
    }

    /**
     * 获取下一个品类代码
     * @return OK
     */
    getNextCode( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Category/GetNextCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNextCode(_response);
        });
    }

    protected processGetNextCode(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * 创建品类
     * @param body (optional) 
     * @return OK
     */
    insert(body?: CreateCategoryDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Category/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新品类
     * @param catehoryId (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(catehoryId?: string | undefined, body?: UpdateCategoryDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Category/Update?";
        if (catehoryId === null)
            throw new globalThis.Error("The parameter 'catehoryId' cannot be null.");
        else if (catehoryId !== undefined)
            url_ += "catehoryId=" + encodeURIComponent("" + catehoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除品类
     * @param catehoryId (optional) 
     * @return OK
     */
    delete(catehoryId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Category/Delete?";
        if (catehoryId === null)
            throw new globalThis.Error("The parameter 'catehoryId' cannot be null.");
        else if (catehoryId !== undefined)
            url_ += "catehoryId=" + encodeURIComponent("" + catehoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入品类
     * @param excelFile (optional) 
     * @return OK
     */
    import(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Category/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出品类
     * @param body (optional) 
     * @return OK
     */
    exportStream(body?: PagedCategoryRequestDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Category/ExportStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportStream(_response);
        });
    }

    protected processExportStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CategoryCodeServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 分页获取品类
     * @param body (optional) 
     * @return OK
     */
    paged(body?: PagedCategoryCodeRequestDto | undefined, cancelToken?: CancelToken): Promise<CategoryCodeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CategoryCode/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaged(_response);
        });
    }

    protected processPaged(response: AxiosResponse): Promise<CategoryCodeDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryCodeDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<CategoryCodeDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryCodeDtoPagedResultDto>(null as any);
    }

    /**
     * 获取VC编号详情
     * @param body (optional) 
     * @return OK
     */
    details(body?: string | undefined, cancelToken?: CancelToken): Promise<CategoryCodeDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CategoryCode/Details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<CategoryCodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryCodeDto.fromJS(resultData200);
            return Promise.resolve<CategoryCodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryCodeDto>(null as any);
    }

    /**
     * 获取品类下未启用未锁定的品类编号
     * @param categoryId (optional) 
     * @return OK
     * @deprecated
     */
    oldNextNotEnabled(categoryId?: string | undefined, cancelToken?: CancelToken): Promise<CategoryCodeDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CategoryCode/OldNextNotEnabled?";
        if (categoryId === null)
            throw new globalThis.Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOldNextNotEnabled(_response);
        });
    }

    protected processOldNextNotEnabled(response: AxiosResponse): Promise<CategoryCodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryCodeDto.fromJS(resultData200);
            return Promise.resolve<CategoryCodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryCodeDto>(null as any);
    }

    /**
     * 获取品类下未启用未锁定的品类编号
     * @param categoryId (optional) 
     * @return OK
     */
    nextNotEnabled(categoryId?: string | undefined, cancelToken?: CancelToken): Promise<CategoryCodeDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CategoryCode/NextNotEnabled?";
        if (categoryId === null)
            throw new globalThis.Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNextNotEnabled(_response);
        });
    }

    protected processNextNotEnabled(response: AxiosResponse): Promise<CategoryCodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryCodeDto.fromJS(resultData200);
            return Promise.resolve<CategoryCodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryCodeDto>(null as any);
    }

    /**
     * 获取品类下指定数量的未启用未锁定的品类编号代码集合
     * @param categoryId (optional) 
     * @param number (optional) 
     * @return OK
     */
    notEnabledByNumber(categoryId?: string | undefined, number?: number | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CategoryCode/NotEnabledByNumber?";
        if (categoryId === null)
            throw new globalThis.Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (number === null)
            throw new globalThis.Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotEnabledByNumber(_response);
        });
    }

    protected processNotEnabledByNumber(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 品类编号启用(长期启用)
     * @param categoryCodeId (optional) 
     * @return OK
     */
    enabled(categoryCodeId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CategoryCode/Enabled?";
        if (categoryCodeId === null)
            throw new globalThis.Error("The parameter 'categoryCodeId' cannot be null.");
        else if (categoryCodeId !== undefined)
            url_ += "categoryCodeId=" + encodeURIComponent("" + categoryCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnabled(_response);
        });
    }

    protected processEnabled(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 品类编号启用(长期启用)
     * @param body (optional) 
     * @return OK
     */
    enabledByCodes(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CategoryCode/EnabledByCodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnabledByCodes(_response);
        });
    }

    protected processEnabledByCodes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 品类编号锁定(临时启用)
     * @param categoryCodeId (optional) 
     * @return OK
     */
    lock(categoryCodeId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CategoryCode/Lock?";
        if (categoryCodeId === null)
            throw new globalThis.Error("The parameter 'categoryCodeId' cannot be null.");
        else if (categoryCodeId !== undefined)
            url_ += "categoryCodeId=" + encodeURIComponent("" + categoryCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLock(_response);
        });
    }

    protected processLock(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 品类编号解锁
     * @param categoryCodeId (optional) 
     * @return OK
     */
    unLock(categoryCodeId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CategoryCode/UnLock?";
        if (categoryCodeId === null)
            throw new globalThis.Error("The parameter 'categoryCodeId' cannot be null.");
        else if (categoryCodeId !== undefined)
            url_ += "categoryCodeId=" + encodeURIComponent("" + categoryCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnLock(_response);
        });
    }

    protected processUnLock(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 品类编号解锁
     * @param code (optional) 
     * @return OK
     */
    unLockByCode(code?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CategoryCode/UnLockByCode?";
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnLockByCode(_response);
        });
    }

    protected processUnLockByCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 品类编号解锁
     * @param isCheck (optional) 
     * @param body (optional) 
     * @return OK
     */
    unLockByCodes(isCheck?: boolean | undefined, body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CategoryCode/UnLockByCodes?";
        if (isCheck === null)
            throw new globalThis.Error("The parameter 'isCheck' cannot be null.");
        else if (isCheck !== undefined)
            url_ += "isCheck=" + encodeURIComponent("" + isCheck) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnLockByCodes(_response);
        });
    }

    protected processUnLockByCodes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 检查VC是否启用
     * @param body (optional) 
     * @return OK
     */
    vaildVcCode(body?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CategoryCode/VaildVcCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVaildVcCode(_response);
        });
    }

    protected processVaildVcCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量生成品类下的编码
     * @param body (optional) 
     * @return OK
     */
    buildRange(body?: Category[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CategoryCode/BuildRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuildRange(_response);
        });
    }

    protected processBuildRange(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CustomServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取电压
     * @return OK
     */
    getAllVoltage( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Custom/GetAllVoltage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllVoltage(_response);
        });
    }

    protected processGetAllVoltage(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 获取主机系列
     * @param isFilterJIN (optional) 
     * @return OK
     */
    getAllBasicMotorSries(isFilterJIN?: boolean | undefined, cancelToken?: CancelToken): Promise<GetParamsATreeOutPutDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Custom/GetAllBasicMotorSries?";
        if (isFilterJIN === null)
            throw new globalThis.Error("The parameter 'isFilterJIN' cannot be null.");
        else if (isFilterJIN !== undefined)
            url_ += "isFilterJIN=" + encodeURIComponent("" + isFilterJIN) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBasicMotorSries(_response);
        });
    }

    protected processGetAllBasicMotorSries(response: AxiosResponse): Promise<GetParamsATreeOutPutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetParamsATreeOutPutDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetParamsATreeOutPutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetParamsATreeOutPutDto[]>(null as any);
    }

    /**
     * 获取所有第三层级的产品系列
     * @param isFilterJIN (optional) 
     * @return OK
     */
    getAllThreeBasicMotorSries(isFilterJIN?: boolean | undefined, cancelToken?: CancelToken): Promise<GetAllThreeBasicMotorSriesOutPutDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Custom/GetAllThreeBasicMotorSries?";
        if (isFilterJIN === null)
            throw new globalThis.Error("The parameter 'isFilterJIN' cannot be null.");
        else if (isFilterJIN !== undefined)
            url_ += "isFilterJIN=" + encodeURIComponent("" + isFilterJIN) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllThreeBasicMotorSries(_response);
        });
    }

    protected processGetAllThreeBasicMotorSries(response: AxiosResponse): Promise<GetAllThreeBasicMotorSriesOutPutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllThreeBasicMotorSriesOutPutDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetAllThreeBasicMotorSriesOutPutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllThreeBasicMotorSriesOutPutDto[]>(null as any);
    }

    /**
     * 获取频率
     * @return OK
     */
    getAllFrequency( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Custom/GetAllFrequency";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllFrequency(_response);
        });
    }

    protected processGetAllFrequency(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 获取功率
     * @return OK
     */
    getAllPower( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Custom/GetAllPower";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPower(_response);
        });
    }

    protected processGetAllPower(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 获取极数
     * @return OK
     */
    getAllPoleNo( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Custom/GetAllPoleNo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPoleNo(_response);
        });
    }

    protected processGetAllPoleNo(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 获取能效
     * @return OK
     */
    getAllEneEff( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Custom/GetAllEneEff";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllEneEff(_response);
        });
    }

    protected processGetAllEneEff(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 获取编码器
     * @return OK
     */
    getAllEncoder( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Custom/GetAllEncoder";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllEncoder(_response);
        });
    }

    protected processGetAllEncoder(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 获取制动器
     * @return OK
     */
    getAllBrake( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Custom/GetAllBrake";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBrake(_response);
        });
    }

    protected processGetAllBrake(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 获取机座号
     * @return OK
     */
    getAllFrameNo( cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Custom/GetAllFrameNo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllFrameNo(_response);
        });
    }

    protected processGetAllFrameNo(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * 获取安装方式
     * @return OK
     */
    getAllBasicMotorMounting( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Custom/GetAllBasicMotorMounting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBasicMotorMounting(_response);
        });
    }

    protected processGetAllBasicMotorMounting(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 整合获取全部的基础参数
     * @return OK
     */
    getAllBasicData( cancelToken?: CancelToken): Promise<GetAllBasicDataOutPutDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Custom/GetAllBasicData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBasicData(_response);
        });
    }

    protected processGetAllBasicData(response: AxiosResponse): Promise<GetAllBasicDataOutPutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllBasicDataOutPutDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetAllBasicDataOutPutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllBasicDataOutPutDto[]>(null as any);
    }

    /**
     * 上传文件返回string
     * @param file (optional) 
     * @return OK
     */
    updalodFile(file?: FileParameter | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Custom/UpdalodFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdalodFile(_response);
        });
    }

    protected processUpdalodFile(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 根据文件名称获取文件下载URL
     * @param fileName (optional) 
     * @return OK
     */
    getFileUrl(fileName?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Custom/GetFileUrl?";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileUrl(_response);
        });
    }

    protected processGetFileUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取所有报价原则详情
     * @return OK
     */
    getQuotationPrincipleRow( cancelToken?: CancelToken): Promise<QuotationPrincipleRow[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Custom/GetQuotationPrincipleRow";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuotationPrincipleRow(_response);
        });
    }

    protected processGetQuotationPrincipleRow(response: AxiosResponse): Promise<QuotationPrincipleRow[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuotationPrincipleRow.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<QuotationPrincipleRow[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotationPrincipleRow[]>(null as any);
    }
}

export class CustomMotorInfoServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取全部已完成自定义电机
     * @return OK
     */
    getAllCustomMotorInfo( cancelToken?: CancelToken): Promise<GetCustomMotorInfoDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/GetAllCustomMotorInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCustomMotorInfo(_response);
        });
    }

    protected processGetAllCustomMotorInfo(response: AxiosResponse): Promise<GetCustomMotorInfoDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCustomMotorInfoDetailDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetCustomMotorInfoDetailDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCustomMotorInfoDetailDto[]>(null as any);
    }

    /**
     * 自定义电机查询
     * @param body (optional) 
     * @return OK
     */
    getPageCustomMotorMotorInfos(body?: PageSearchCustomMotorInfoInputDto | undefined, cancelToken?: CancelToken): Promise<PageCustomMotorInfoOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/GetPageCustomMotorMotorInfos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageCustomMotorMotorInfos(_response);
        });
    }

    protected processGetPageCustomMotorMotorInfos(response: AxiosResponse): Promise<PageCustomMotorInfoOutputDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageCustomMotorInfoOutputDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<PageCustomMotorInfoOutputDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageCustomMotorInfoOutputDtoPagedResultDto>(null as any);
    }

    /**
     * 新增或更新数据
     * @param body (optional) 
     * @return OK
     */
    createOrUpdate(body?: CreateOrUpdateCustomMotorInfoInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCustomMotorInfoDetail(id?: string | undefined, cancelToken?: CancelToken): Promise<GetCustomMotorInfoDetailDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/GetCustomMotorInfoDetail?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomMotorInfoDetail(_response);
        });
    }

    protected processGetCustomMotorInfoDetail(response: AxiosResponse): Promise<GetCustomMotorInfoDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCustomMotorInfoDetailDto.fromJS(resultData200);
            return Promise.resolve<GetCustomMotorInfoDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCustomMotorInfoDetailDto>(null as any);
    }

    /**
     * 查询参数下拉
     * @return OK
     */
    getComboxSelect( cancelToken?: CancelToken): Promise<GetCustomerComboxSelectDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/GetComboxSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetComboxSelect(_response);
        });
    }

    protected processGetComboxSelect(response: AxiosResponse): Promise<GetCustomerComboxSelectDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCustomerComboxSelectDto.fromJS(resultData200);
            return Promise.resolve<GetCustomerComboxSelectDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCustomerComboxSelectDto>(null as any);
    }

    /**
     * 复制
     * @param body (optional) 
     * @return OK
     */
    copyCustomerMotorInfo(body?: CreateOrUpdateCustomMotorInfoInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/CopyCustomerMotorInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyCustomerMotorInfo(_response);
        });
    }

    protected processCopyCustomerMotorInfo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @param id (optional) 
     * @return OK
     */
    deletCustomerMotorInfo(id?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/DeletCustomerMotorInfo?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletCustomerMotorInfo(_response);
        });
    }

    protected processDeletCustomerMotorInfo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 禁用自定义电机
     * @param id (optional) 
     * @return OK
     */
    disableCustomerMotorInfo(id?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/DisableCustomerMotorInfo?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisableCustomerMotorInfo(_response);
        });
    }

    protected processDisableCustomerMotorInfo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 自定义电机升级
     * @param body (optional) 
     * @return OK
     */
    upgradeCustomerMotorInfo(body?: CreateOrUpdateCustomMotorInfoInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/UpgradeCustomerMotorInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpgradeCustomerMotorInfo(_response);
        });
    }

    protected processUpgradeCustomerMotorInfo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 自定义电机信息导出
     * @param body (optional) 
     * @return OK
     */
    exportCustomMotors(body?: PageSearchCustomMotorInfoInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/ExportCustomMotors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCustomMotors(_response);
        });
    }

    protected processExportCustomMotors(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 审批编辑
     * @param body (optional) 
     * @return OK
     */
    editApproval(body?: CustomMotorEditApprovalDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/EditApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditApproval(_response);
        });
    }

    protected processEditApproval(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取标准的交期时间
     * @param body (optional) 
     * @return OK
     */
    getBasicCycle(body?: CreateOrUpdateCustomMotorInfoInputDto | undefined, cancelToken?: CancelToken): Promise<GetCustomMotorInfoDetailDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/GetBasicCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasicCycle(_response);
        });
    }

    protected processGetBasicCycle(response: AxiosResponse): Promise<GetCustomMotorInfoDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCustomMotorInfoDetailDto.fromJS(resultData200);
            return Promise.resolve<GetCustomMotorInfoDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCustomMotorInfoDetailDto>(null as any);
    }

    /**
     * 获取标准的交期时间(判断是否客户化代码)
     * @param body (optional) 
     * @return OK
     */
    getBasicCycleByType(body?: CreateOrUpdateCustomMotorInfoInputDto | undefined, cancelToken?: CancelToken): Promise<GetCustomMotorInfoDetailDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/GetBasicCycleByType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasicCycleByType(_response);
        });
    }

    protected processGetBasicCycleByType(response: AxiosResponse): Promise<GetCustomMotorInfoDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCustomMotorInfoDetailDto.fromJS(resultData200);
            return Promise.resolve<GetCustomMotorInfoDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCustomMotorInfoDetailDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPageCustomMotorInfoCycle(body?: PageSearchMotorCycleInputDto | undefined, cancelToken?: CancelToken): Promise<PageMotorcycleOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/GetPageCustomMotorInfoCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageCustomMotorInfoCycle(_response);
        });
    }

    protected processGetPageCustomMotorInfoCycle(response: AxiosResponse): Promise<PageMotorcycleOutputDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageMotorcycleOutputDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<PageMotorcycleOutputDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageMotorcycleOutputDtoPagedResultDto>(null as any);
    }

    /**
     * 交期详情获取
     * @param id (optional) 
     * @param motorType (optional) 
     * @return OK
     */
    getCycleDetail(id?: string | undefined, motorType?: string | undefined, cancelToken?: CancelToken): Promise<GetCycleDetailDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/GetCycleDetail?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (motorType === null)
            throw new globalThis.Error("The parameter 'motorType' cannot be null.");
        else if (motorType !== undefined)
            url_ += "motorType=" + encodeURIComponent("" + motorType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCycleDetail(_response);
        });
    }

    protected processGetCycleDetail(response: AxiosResponse): Promise<GetCycleDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCycleDetailDto.fromJS(resultData200);
            return Promise.resolve<GetCycleDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCycleDetailDto>(null as any);
    }

    /**
     * 修改交期
     * @param body (optional) 
     * @return OK
     */
    updayeCycle(body?: MotorCycleEditDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/UpdayeCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdayeCycle(_response);
        });
    }

    protected processUpdayeCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    batchUpdayeCycle(body?: MotorCycleEditDto[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/BatchUpdayeCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchUpdayeCycle(_response);
        });
    }

    protected processBatchUpdayeCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 确认交期
     * @param body (optional) 
     * @return OK
     */
    confirmCycle(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/ConfirmCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmCycle(_response);
        });
    }

    protected processConfirmCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 交期导出
     * @param body (optional) 
     * @return OK
     */
    exportCycle(body?: PageSearchMotorCycleInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/ExportCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCycle(_response);
        });
    }

    protected processExportCycle(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 交期上传
     * @param excelFile (optional) 
     * @return OK
     */
    importCycle(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/ImportCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportCycle(_response);
        });
    }

    protected processImportCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 预览交期
     * @param body (optional) 
     * @return OK
     */
    getPreviewCycle(body?: MotorCycleEditDto | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomMotorInfo/GetPreviewCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPreviewCycle(_response);
        });
    }

    protected processGetPreviewCycle(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class CustomRuleCheckServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 自定义规则检查（61条）
     * @param body (optional) 
     * @return OK
     */
    check(body?: GetInventoryOutPutDto | undefined, cancelToken?: CancelToken): Promise<CheckResultOutput[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomRuleCheck/Check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheck(_response);
        });
    }

    protected processCheck(response: AxiosResponse): Promise<CheckResultOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckResultOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckResultOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckResultOutput[]>(null as any);
    }

    /**
     * 产品自定义规则检查
     * @param body (optional) 
     * @return OK
     */
    checkProducts(body?: CustomRuleCheckProductDto[] | undefined, cancelToken?: CancelToken): Promise<CheckResultOutput[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomRuleCheck/CheckProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckProducts(_response);
        });
    }

    protected processCheckProducts(response: AxiosResponse): Promise<CheckResultOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckResultOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckResultOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckResultOutput[]>(null as any);
    }

    /**
     * @return OK
     */
    initAllRules( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomRuleCheck/InitAllRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitAllRules(_response);
        });
    }

    protected processInitAllRules(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 检查选型产品的VC,返回 包含VC163/209 的VC数据
     * @param lectoTypeId (optional) 
     * @return OK
     */
    getLectoTypeProductVC163209(lectoTypeId?: string | undefined, cancelToken?: CancelToken): Promise<LectoTypeProductVC[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomRuleCheck/GetLectoTypeProductVC163209?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLectoTypeProductVC163209(_response);
        });
    }

    protected processGetLectoTypeProductVC163209(response: AxiosResponse): Promise<LectoTypeProductVC[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LectoTypeProductVC.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LectoTypeProductVC[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LectoTypeProductVC[]>(null as any);
    }
}

export class CustomVcServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 分页获取自定义VC
     * @param body (optional) 
     * @return OK
     */
    paged(body?: PagedCustomVcRequestDto | undefined, cancelToken?: CancelToken): Promise<CustomVcDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaged(_response);
        });
    }

    protected processPaged(response: AxiosResponse): Promise<CustomVcDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomVcDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<CustomVcDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomVcDtoPagedResultDto>(null as any);
    }

    /**
     * 获取自定义VC详情
     * @param vcCodes (optional) 
     * @return OK
     */
    rangeByVcCode(vcCodes?: string[] | undefined, cancelToken?: CancelToken): Promise<CustomVcDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/RangeByVcCode?";
        if (vcCodes === null)
            throw new globalThis.Error("The parameter 'vcCodes' cannot be null.");
        else if (vcCodes !== undefined)
            vcCodes && vcCodes.forEach(item => { url_ += "vcCodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRangeByVcCode(_response);
        });
    }

    protected processRangeByVcCode(response: AxiosResponse): Promise<CustomVcDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomVcDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CustomVcDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomVcDto[]>(null as any);
    }

    /**
     * 获取openvc
     * @param vcCodes (optional) 
     * @return OK
     */
    queryCheckVcs(vcCodes?: string[] | undefined, cancelToken?: CancelToken): Promise<CheckVcRuleDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/QueryCheckVcs?";
        if (vcCodes === null)
            throw new globalThis.Error("The parameter 'vcCodes' cannot be null.");
        else if (vcCodes !== undefined)
            vcCodes && vcCodes.forEach(item => { url_ += "vcCodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryCheckVcs(_response);
        });
    }

    protected processQueryCheckVcs(response: AxiosResponse): Promise<CheckVcRuleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckVcRuleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckVcRuleDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckVcRuleDto[]>(null as any);
    }

    /**
     * 获取自定义VC详情
     * @param customVcId (optional) 
     * @return OK
     */
    details(customVcId?: string | undefined, cancelToken?: CancelToken): Promise<CustomVcDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/Details?";
        if (customVcId === null)
            throw new globalThis.Error("The parameter 'customVcId' cannot be null.");
        else if (customVcId !== undefined)
            url_ += "customVcId=" + encodeURIComponent("" + customVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<CustomVcDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomVcDto.fromJS(resultData200);
            return Promise.resolve<CustomVcDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomVcDto>(null as any);
    }

    /**
     * 创建自定义VC
     * @param body (optional) 
     * @return OK
     */
    insert(body?: CreateCustomVcDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 更新自定义VC
     * @param customVcId (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(customVcId?: string | undefined, body?: UpdateCustomVcDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/Update?";
        if (customVcId === null)
            throw new globalThis.Error("The parameter 'customVcId' cannot be null.");
        else if (customVcId !== undefined)
            url_ += "customVcId=" + encodeURIComponent("" + customVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新状态
     * @param customVcId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateStatus(customVcId?: string | undefined, body?: IndustryVCStatus | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/UpdateStatus?";
        if (customVcId === null)
            throw new globalThis.Error("The parameter 'customVcId' cannot be null.");
        else if (customVcId !== undefined)
            url_ += "customVcId=" + encodeURIComponent("" + customVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStatus(_response);
        });
    }

    protected processUpdateStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 复制
     * @param copyCustomVcId (optional) 
     * @param body (optional) 
     * @return OK
     */
    copy(copyCustomVcId?: string | undefined, body?: CreateCustomVcDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/Copy?";
        if (copyCustomVcId === null)
            throw new globalThis.Error("The parameter 'copyCustomVcId' cannot be null.");
        else if (copyCustomVcId !== undefined)
            url_ += "copyCustomVcId=" + encodeURIComponent("" + copyCustomVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopy(_response);
        });
    }

    protected processCopy(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 升级自定义VC
     * @param customVcId (optional) 
     * @return OK
     */
    upgrade(customVcId?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/Upgrade?";
        if (customVcId === null)
            throw new globalThis.Error("The parameter 'customVcId' cannot be null.");
        else if (customVcId !== undefined)
            url_ += "customVcId=" + encodeURIComponent("" + customVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpgrade(_response);
        });
    }

    protected processUpgrade(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 转行业VC
     * @param customVcId (optional) 
     * @param body (optional) 
     * @return OK
     */
    transferToIndustryVc(customVcId?: string | undefined, body?: TransferToIndustryVcDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/TransferToIndustryVc?";
        if (customVcId === null)
            throw new globalThis.Error("The parameter 'customVcId' cannot be null.");
        else if (customVcId !== undefined)
            url_ += "customVcId=" + encodeURIComponent("" + customVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransferToIndustryVc(_response);
        });
    }

    protected processTransferToIndustryVc(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 删除自定义VC
     * @param customVcId (optional) 
     * @return OK
     */
    delete(customVcId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/Delete?";
        if (customVcId === null)
            throw new globalThis.Error("The parameter 'customVcId' cannot be null.");
        else if (customVcId !== undefined)
            url_ += "customVcId=" + encodeURIComponent("" + customVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 合并自定义VC
     * @param customVcId (optional) 
     * @param body (optional) 
     * @return OK
     */
    merge(customVcId?: string | undefined, body?: string[] | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/Merge?";
        if (customVcId === null)
            throw new globalThis.Error("The parameter 'customVcId' cannot be null.");
        else if (customVcId !== undefined)
            url_ += "customVcId=" + encodeURIComponent("" + customVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMerge(_response);
        });
    }

    protected processMerge(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 检查自定义VC面价与交期信息
     * @param customVcId (optional) 
     * @return OK
     */
    checkCustomVcPrices(customVcId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/CheckCustomVcPrices?";
        if (customVcId === null)
            throw new globalThis.Error("The parameter 'customVcId' cannot be null.");
        else if (customVcId !== undefined)
            url_ += "customVcId=" + encodeURIComponent("" + customVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckCustomVcPrices(_response);
        });
    }

    protected processCheckCustomVcPrices(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入自定义VC
     * @param excelFile (optional) 
     * @return OK
     */
    import(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入自定义VC
     * @param excelFile (optional) 
     * @return OK
     */
    fixedNumberImportInit(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/FixedNumberImportInit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFixedNumberImportInit(_response);
        });
    }

    protected processFixedNumberImportInit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入自定义VC交期信息
     * @param excelFile (optional) 
     * @return OK
     */
    fixedNumberImportCycle(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/FixedNumberImportCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFixedNumberImportCycle(_response);
        });
    }

    protected processFixedNumberImportCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入自定义VC面价信息
     * @param excelFile (optional) 
     * @return OK
     */
    fixedNumberImportListPrice(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/FixedNumberImportListPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFixedNumberImportListPrice(_response);
        });
    }

    protected processFixedNumberImportListPrice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入自定义VC迁移日志
     * @param excelFile (optional) 
     * @return OK
     */
    fixedNumberMigrationlog(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/FixedNumberMigrationlog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFixedNumberMigrationlog(_response);
        });
    }

    protected processFixedNumberMigrationlog(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 初始化导入
     * @param excelFile (optional) 
     * @return OK
     */
    importInit(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/ImportInit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportInit(_response);
        });
    }

    protected processImportInit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 启动服务
     * @return OK
     */
    startCustomVcInitJob( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/StartCustomVcInitJob";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartCustomVcInitJob(_response);
        });
    }

    protected processStartCustomVcInitJob(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出自定义VC初始化导入模板
     * @return OK
     */
    exporInitTemplateStream( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/ExporInitTemplateStream";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExporInitTemplateStream(_response);
        });
    }

    protected processExporInitTemplateStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出自定义VC
     * @param body (optional) 
     * @return OK
     */
    exportBaseStream(body?: PagedCustomVcRequestDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/ExportBaseStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportBaseStream(_response);
        });
    }

    protected processExportBaseStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出自定义VC
     * @param body (optional) 
     * @return OK
     */
    exportLogStream(body?: PagedCustomVcRequestDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVc/ExportLogStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportLogStream(_response);
        });
    }

    protected processExportLogStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CustomVcApprovalServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取自定义VC相关的审批记录
     * @param customVcId (optional) 
     * @return OK
     */
    byCustomVcId(customVcId?: string | undefined, cancelToken?: CancelToken): Promise<CustomVcApprovalDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVcApproval/ByCustomVcId?";
        if (customVcId === null)
            throw new globalThis.Error("The parameter 'customVcId' cannot be null.");
        else if (customVcId !== undefined)
            url_ += "customVcId=" + encodeURIComponent("" + customVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processByCustomVcId(_response);
        });
    }

    protected processByCustomVcId(response: AxiosResponse): Promise<CustomVcApprovalDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomVcApprovalDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CustomVcApprovalDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomVcApprovalDto[]>(null as any);
    }

    /**
     * 创建审批记录
     * @param body (optional) 
     * @return OK
     */
    insert(body?: CreateCustomVcApprovalDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVcApproval/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CustomVcPriceServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 分页获取自定义VC
     * @param body (optional) 
     * @return OK
     */
    paged(body?: PagedCustomVcCycleRequestDto | undefined, cancelToken?: CancelToken): Promise<CustomVcPriceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVcPrice/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaged(_response);
        });
    }

    protected processPaged(response: AxiosResponse): Promise<CustomVcPriceDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomVcPriceDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<CustomVcPriceDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomVcPriceDtoPagedResultDto>(null as any);
    }

    /**
     * 获取自定义VC面价及交期
     * @param customVcId (optional) 
     * @return OK
     */
    byCustomVcId(customVcId?: string | undefined, cancelToken?: CancelToken): Promise<CustomVcPriceDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVcPrice/ByCustomVcId?";
        if (customVcId === null)
            throw new globalThis.Error("The parameter 'customVcId' cannot be null.");
        else if (customVcId !== undefined)
            url_ += "customVcId=" + encodeURIComponent("" + customVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processByCustomVcId(_response);
        });
    }

    protected processByCustomVcId(response: AxiosResponse): Promise<CustomVcPriceDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomVcPriceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CustomVcPriceDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomVcPriceDto[]>(null as any);
    }

    /**
     * 获取自定义VC详情
     * @param customVcPriceId (optional) 
     * @return OK
     */
    details(customVcPriceId?: string | undefined, cancelToken?: CancelToken): Promise<CustomVcPriceDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVcPrice/Details?";
        if (customVcPriceId === null)
            throw new globalThis.Error("The parameter 'customVcPriceId' cannot be null.");
        else if (customVcPriceId !== undefined)
            url_ += "customVcPriceId=" + encodeURIComponent("" + customVcPriceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<CustomVcPriceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomVcPriceDto.fromJS(resultData200);
            return Promise.resolve<CustomVcPriceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomVcPriceDto>(null as any);
    }

    /**
     * 检查同系列同机座号的产品配置
     * @param body (optional) 
     * @return OK
     */
    repetitive(body?: RepetitiveSriesFrameNoSearchDto | undefined, cancelToken?: CancelToken): Promise<RepetitiveOutputDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVcPrice/Repetitive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRepetitive(_response);
        });
    }

    protected processRepetitive(response: AxiosResponse): Promise<RepetitiveOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RepetitiveOutputDto.fromJS(resultData200);
            return Promise.resolve<RepetitiveOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RepetitiveOutputDto>(null as any);
    }

    /**
     * 检查产品下VC的价格来源情况
     * @param body (optional) 
     * @return OK
     */
    repetitivePrice(body?: RepetitivePriceProductDto[] | undefined, cancelToken?: CancelToken): Promise<RepetitivePriceProductDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVcPrice/RepetitivePrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRepetitivePrice(_response);
        });
    }

    protected processRepetitivePrice(response: AxiosResponse): Promise<RepetitivePriceProductDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RepetitivePriceProductDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RepetitivePriceProductDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RepetitivePriceProductDto[]>(null as any);
    }

    /**
     * 创建自定义VC面价及交期
     * @param body (optional) 
     * @return OK
     */
    insert(body?: CreateCustomVcPriceDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVcPrice/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新自定义VC面价及交期
     * @param customVcPriceId (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(customVcPriceId?: string | undefined, body?: UpdateCustomVcPriceDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVcPrice/Update?";
        if (customVcPriceId === null)
            throw new globalThis.Error("The parameter 'customVcPriceId' cannot be null.");
        else if (customVcPriceId !== undefined)
            url_ += "customVcPriceId=" + encodeURIComponent("" + customVcPriceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除自定义VC面价及交期
     * @param customVcPriceId (optional) 
     * @return OK
     */
    delete(customVcPriceId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVcPrice/Delete?";
        if (customVcPriceId === null)
            throw new globalThis.Error("The parameter 'customVcPriceId' cannot be null.");
        else if (customVcPriceId !== undefined)
            url_ += "customVcPriceId=" + encodeURIComponent("" + customVcPriceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 清空所有自定义VC面价及交期
     * @param customVcId (optional) 
     * @return OK
     */
    deleteRange(customVcId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVcPrice/DeleteRange?";
        if (customVcId === null)
            throw new globalThis.Error("The parameter 'customVcId' cannot be null.");
        else if (customVcId !== undefined)
            url_ += "customVcId=" + encodeURIComponent("" + customVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRange(_response);
        });
    }

    protected processDeleteRange(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 将自定义VC配置添加至选型中
     * @param body (optional) 
     * @return OK
     */
    addLectoTypeProductVc(body?: AddLectoTypeProductVc | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVcPrice/AddLectoTypeProductVc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddLectoTypeProductVc(_response);
        });
    }

    protected processAddLectoTypeProductVc(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导入自定义VC交期信息
     * @param excelFile (optional) 
     * @return OK
     */
    importCycle(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVcPrice/ImportCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportCycle(_response);
        });
    }

    protected processImportCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入自定义VC面价信息
     * @param excelFile (optional) 
     * @return OK
     */
    importListPrice(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVcPrice/ImportListPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportListPrice(_response);
        });
    }

    protected processImportListPrice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出自定义VC交期信息
     * @param body (optional) 
     * @return OK
     */
    exportCycleStream(body?: PagedCustomVcRequestDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVcPrice/ExportCycleStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCycleStream(_response);
        });
    }

    protected processExportCycleStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出自定义VC面价信息
     * @param body (optional) 
     * @return OK
     */
    exportListPriceStream(body?: PagedCustomVcRequestDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVcPrice/ExportListPriceStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportListPriceStream(_response);
        });
    }

    protected processExportListPriceStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出自定义VC面价及交期导入模板
     * @return OK
     */
    exportBaseTemplateStream( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVcPrice/ExportBaseTemplateStream";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportBaseTemplateStream(_response);
        });
    }

    protected processExportBaseTemplateStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新VC下单次数
     * @param body (optional) 
     * @return OK
     */
    updatePlaceOrderCount(body?: UpdatePlaceOrderCountDto[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVcPrice/UpdatePlaceOrderCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePlaceOrderCount(_response);
        });
    }

    protected processUpdatePlaceOrderCount(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 检查已完成状态的自定义VC最新面价
     * @param body (optional) 
     * @return OK
     */
    checkCustomVcListUnitPrice(body?: CheckCustomVcListUnitPriceInputDto | undefined, cancelToken?: CancelToken): Promise<CheckCustomVcListUnitPriceOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/CustomVcPrice/CheckCustomVcListUnitPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckCustomVcListUnitPrice(_response);
        });
    }

    protected processCheckCustomVcListUnitPrice(response: AxiosResponse): Promise<CheckCustomVcListUnitPriceOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckCustomVcListUnitPriceOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckCustomVcListUnitPriceOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckCustomVcListUnitPriceOutputDto[]>(null as any);
    }
}

export class DoubleVCCheckRulesServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAll(body?: GetAllDoubleVCCheckRulesInput | undefined, cancelToken?: CancelToken): Promise<DoubleVCCheckRulesDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/DoubleVCCheckRules/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<DoubleVCCheckRulesDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DoubleVCCheckRulesDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<DoubleVCCheckRulesDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DoubleVCCheckRulesDtoPagedResultDto>(null as any);
    }

    /**
     * @param ids (optional) 
     * @param productType (optional) 
     * @param seatNoMax (optional) 
     * @param seatNoMin (optional) 
     * @param vCId1 (optional) 
     * @param vCId2 (optional) 
     * @param rule (optional) 
     * @param compulsoryType (optional) 
     * @param promptContent (optional) 
     * @param creationStartTime (optional) 
     * @param creationEndTime (optional) 
     * @param lastModificationStartTime (optional) 
     * @param lastModificationEndTime (optional) 
     * @param isDeleted (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllOld(ids?: string[] | undefined, productType?: string | undefined, seatNoMax?: number | undefined, seatNoMin?: number | undefined, vCId1?: string | undefined, vCId2?: string | undefined, rule?: string | undefined, compulsoryType?: number | undefined, promptContent?: string | undefined, creationStartTime?: moment.Moment | undefined, creationEndTime?: moment.Moment | undefined, lastModificationStartTime?: moment.Moment | undefined, lastModificationEndTime?: moment.Moment | undefined, isDeleted?: boolean | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<DoubleVCCheckRulesDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/DoubleVCCheckRules/GetAllOld?";
        if (ids === null)
            throw new globalThis.Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (productType === null)
            throw new globalThis.Error("The parameter 'productType' cannot be null.");
        else if (productType !== undefined)
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (seatNoMax === null)
            throw new globalThis.Error("The parameter 'seatNoMax' cannot be null.");
        else if (seatNoMax !== undefined)
            url_ += "seatNoMax=" + encodeURIComponent("" + seatNoMax) + "&";
        if (seatNoMin === null)
            throw new globalThis.Error("The parameter 'seatNoMin' cannot be null.");
        else if (seatNoMin !== undefined)
            url_ += "seatNoMin=" + encodeURIComponent("" + seatNoMin) + "&";
        if (vCId1 === null)
            throw new globalThis.Error("The parameter 'vCId1' cannot be null.");
        else if (vCId1 !== undefined)
            url_ += "vCId1=" + encodeURIComponent("" + vCId1) + "&";
        if (vCId2 === null)
            throw new globalThis.Error("The parameter 'vCId2' cannot be null.");
        else if (vCId2 !== undefined)
            url_ += "vCId2=" + encodeURIComponent("" + vCId2) + "&";
        if (rule === null)
            throw new globalThis.Error("The parameter 'rule' cannot be null.");
        else if (rule !== undefined)
            url_ += "rule=" + encodeURIComponent("" + rule) + "&";
        if (compulsoryType === null)
            throw new globalThis.Error("The parameter 'compulsoryType' cannot be null.");
        else if (compulsoryType !== undefined)
            url_ += "compulsoryType=" + encodeURIComponent("" + compulsoryType) + "&";
        if (promptContent === null)
            throw new globalThis.Error("The parameter 'promptContent' cannot be null.");
        else if (promptContent !== undefined)
            url_ += "promptContent=" + encodeURIComponent("" + promptContent) + "&";
        if (creationStartTime === null)
            throw new globalThis.Error("The parameter 'creationStartTime' cannot be null.");
        else if (creationStartTime !== undefined)
            url_ += "CreationStartTime=" + encodeURIComponent(creationStartTime ? "" + creationStartTime.toISOString() : "") + "&";
        if (creationEndTime === null)
            throw new globalThis.Error("The parameter 'creationEndTime' cannot be null.");
        else if (creationEndTime !== undefined)
            url_ += "CreationEndTime=" + encodeURIComponent(creationEndTime ? "" + creationEndTime.toISOString() : "") + "&";
        if (lastModificationStartTime === null)
            throw new globalThis.Error("The parameter 'lastModificationStartTime' cannot be null.");
        else if (lastModificationStartTime !== undefined)
            url_ += "LastModificationStartTime=" + encodeURIComponent(lastModificationStartTime ? "" + lastModificationStartTime.toISOString() : "") + "&";
        if (lastModificationEndTime === null)
            throw new globalThis.Error("The parameter 'lastModificationEndTime' cannot be null.");
        else if (lastModificationEndTime !== undefined)
            url_ += "LastModificationEndTime=" + encodeURIComponent(lastModificationEndTime ? "" + lastModificationEndTime.toISOString() : "") + "&";
        if (isDeleted === null)
            throw new globalThis.Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllOld(_response);
        });
    }

    protected processGetAllOld(response: AxiosResponse): Promise<DoubleVCCheckRulesDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DoubleVCCheckRulesDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<DoubleVCCheckRulesDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DoubleVCCheckRulesDtoPagedResultDto>(null as any);
    }

    /**
     * 获取所有产品类型
     * @return OK
     */
    getAllProductType( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/DoubleVCCheckRules/GetAllProductType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllProductType(_response);
        });
    }

    protected processGetAllProductType(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getDoubleVCCheckRulesForView(id?: string | undefined, cancelToken?: CancelToken): Promise<DoubleVCCheckRulesDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/DoubleVCCheckRules/GetDoubleVCCheckRulesForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDoubleVCCheckRulesForView(_response);
        });
    }

    protected processGetDoubleVCCheckRulesForView(response: AxiosResponse): Promise<DoubleVCCheckRulesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DoubleVCCheckRulesDto.fromJS(resultData200);
            return Promise.resolve<DoubleVCCheckRulesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DoubleVCCheckRulesDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getDoubleVCCheckRulesForEdit(id?: string | undefined, cancelToken?: CancelToken): Promise<GetDoubleVCCheckRulesForEditOutput> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/DoubleVCCheckRules/GetDoubleVCCheckRulesForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDoubleVCCheckRulesForEdit(_response);
        });
    }

    protected processGetDoubleVCCheckRulesForEdit(response: AxiosResponse): Promise<GetDoubleVCCheckRulesForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDoubleVCCheckRulesForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetDoubleVCCheckRulesForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDoubleVCCheckRulesForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body?: CreateOrEditDoubleVCCheckRulesDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/DoubleVCCheckRules/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrEdit(_response);
        });
    }

    protected processCreateOrEdit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 软删除
     * @param input (optional) 
     * @return OK
     */
    delete(input?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/DoubleVCCheckRules/Delete?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            input && input.forEach(item => { url_ += "input=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 恢复
     * @param body (optional) 
     * @return OK
     */
    recover(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/DoubleVCCheckRules/Recover";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecover(_response);
        });
    }

    protected processRecover(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 彻底删除
     * @param body (optional) 
     * @return OK
     */
    hardDelete(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/DoubleVCCheckRules/HardDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHardDelete(_response);
        });
    }

    protected processHardDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入
     * @param formFiles (optional) 
     * @return OK
     */
    import(formFiles?: FileParameter[] | undefined, cancelToken?: CancelToken): Promise<ImportOutput> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/DoubleVCCheckRules/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFiles === null || formFiles === undefined)
            throw new globalThis.Error("The parameter 'formFiles' cannot be null.");
        else
            formFiles.forEach(item_ => content_.append("formFiles", item_.data, item_.fileName ? item_.fileName : "formFiles") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<ImportOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportOutput.fromJS(resultData200);
            return Promise.resolve<ImportOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportOutput>(null as any);
    }

    /**
     * 导出
     * @param body (optional) 
     * @return OK
     */
    export(body?: GetAllDoubleVCCheckRulesInput | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/DoubleVCCheckRules/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    initAllRules( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/DoubleVCCheckRules/InitAllRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitAllRules(_response);
        });
    }

    protected processInitAllRules(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 双VC检查规则检查
     * @param body (optional) 
     * @return OK
     */
    check(body?: GetInventoryOutPutDto | undefined, cancelToken?: CancelToken): Promise<CheckResultOutput[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/DoubleVCCheckRules/Check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheck(_response);
        });
    }

    protected processCheck(response: AxiosResponse): Promise<CheckResultOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckResultOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckResultOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckResultOutput[]>(null as any);
    }

    /**
     * 移除缓存,并在5秒后更新缓存
     * @return OK
     */
    removeCache( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/DoubleVCCheckRules/RemoveCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveCache(_response);
        });
    }

    protected processRemoveCache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class GreenChannelReviewNoServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取信息
     * @param id (optional) 主键
     * @return OK
     */
    getInfo(id?: string | undefined, cancelToken?: CancelToken): Promise<GreenChannelReviewNoDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/GreenChannelReviewNo/GetInfo?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInfo(_response);
        });
    }

    protected processGetInfo(response: AxiosResponse): Promise<GreenChannelReviewNoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GreenChannelReviewNoDto.fromJS(resultData200);
            return Promise.resolve<GreenChannelReviewNoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GreenChannelReviewNoDto>(null as any);
    }

    /**
     * 获取绿通信息
     * @param productId (optional) 
     * @param vcCodes (optional) 
     * @param customerNo (optional) 
     * @return OK
     */
    getInfoByRule(productId?: string | undefined, vcCodes?: string[] | undefined, customerNo?: string | undefined, cancelToken?: CancelToken): Promise<GreenChannelReviewNoDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/GreenChannelReviewNo/GetInfoByRule?";
        if (productId === null)
            throw new globalThis.Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (vcCodes === null)
            throw new globalThis.Error("The parameter 'vcCodes' cannot be null.");
        else if (vcCodes !== undefined)
            vcCodes && vcCodes.forEach(item => { url_ += "vcCodes=" + encodeURIComponent("" + item) + "&"; });
        if (customerNo === null)
            throw new globalThis.Error("The parameter 'customerNo' cannot be null.");
        else if (customerNo !== undefined)
            url_ += "customerNo=" + encodeURIComponent("" + customerNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInfoByRule(_response);
        });
    }

    protected processGetInfoByRule(response: AxiosResponse): Promise<GreenChannelReviewNoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GreenChannelReviewNoDto.fromJS(resultData200);
            return Promise.resolve<GreenChannelReviewNoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GreenChannelReviewNoDto>(null as any);
    }

    /**
     * 获取分页列表
     * @param customerName (optional) 客户名称
     * @param productNo (optional) 产品编码
     * @param vcCode (optional) vc编码
     * @param reviewNo (optional) 绿通号
     * @param beginTime (optional) 有效期开始时间
     * @param endTime (optional) 有效期结束时间
     * @param isEnable (optional) 是否启用
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getPagedList(customerName?: string | undefined, productNo?: string | undefined, vcCode?: string | undefined, reviewNo?: string | undefined, beginTime?: moment.Moment | undefined, endTime?: moment.Moment | undefined, isEnable?: boolean | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<GreenChannelReviewNoListOutDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/GreenChannelReviewNo/GetPagedList?";
        if (customerName === null)
            throw new globalThis.Error("The parameter 'customerName' cannot be null.");
        else if (customerName !== undefined)
            url_ += "customerName=" + encodeURIComponent("" + customerName) + "&";
        if (productNo === null)
            throw new globalThis.Error("The parameter 'productNo' cannot be null.");
        else if (productNo !== undefined)
            url_ += "productNo=" + encodeURIComponent("" + productNo) + "&";
        if (vcCode === null)
            throw new globalThis.Error("The parameter 'vcCode' cannot be null.");
        else if (vcCode !== undefined)
            url_ += "vcCode=" + encodeURIComponent("" + vcCode) + "&";
        if (reviewNo === null)
            throw new globalThis.Error("The parameter 'reviewNo' cannot be null.");
        else if (reviewNo !== undefined)
            url_ += "reviewNo=" + encodeURIComponent("" + reviewNo) + "&";
        if (beginTime === null)
            throw new globalThis.Error("The parameter 'beginTime' cannot be null.");
        else if (beginTime !== undefined)
            url_ += "beginTime=" + encodeURIComponent(beginTime ? "" + beginTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new globalThis.Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (isEnable === null)
            throw new globalThis.Error("The parameter 'isEnable' cannot be null.");
        else if (isEnable !== undefined)
            url_ += "IsEnable=" + encodeURIComponent("" + isEnable) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedList(_response);
        });
    }

    protected processGetPagedList(response: AxiosResponse): Promise<GreenChannelReviewNoListOutDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GreenChannelReviewNoListOutDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<GreenChannelReviewNoListOutDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GreenChannelReviewNoListOutDtoPagedResultDto>(null as any);
    }

    /**
     * 获取分页列表
     * @param customerName (optional) 客户名称
     * @param productNo (optional) 产品编码
     * @param vcCode (optional) vc编码
     * @param reviewNo (optional) 绿通号
     * @param beginTime (optional) 有效期开始时间
     * @param endTime (optional) 有效期结束时间
     * @param isEnable (optional) 是否启用
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getPagedEndCustomerList(customerName?: string | undefined, productNo?: string | undefined, vcCode?: string | undefined, reviewNo?: string | undefined, beginTime?: moment.Moment | undefined, endTime?: moment.Moment | undefined, isEnable?: boolean | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<GreenChannelReviewNoListOutDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/GreenChannelReviewNo/GetPagedEndCustomerList?";
        if (customerName === null)
            throw new globalThis.Error("The parameter 'customerName' cannot be null.");
        else if (customerName !== undefined)
            url_ += "customerName=" + encodeURIComponent("" + customerName) + "&";
        if (productNo === null)
            throw new globalThis.Error("The parameter 'productNo' cannot be null.");
        else if (productNo !== undefined)
            url_ += "productNo=" + encodeURIComponent("" + productNo) + "&";
        if (vcCode === null)
            throw new globalThis.Error("The parameter 'vcCode' cannot be null.");
        else if (vcCode !== undefined)
            url_ += "vcCode=" + encodeURIComponent("" + vcCode) + "&";
        if (reviewNo === null)
            throw new globalThis.Error("The parameter 'reviewNo' cannot be null.");
        else if (reviewNo !== undefined)
            url_ += "reviewNo=" + encodeURIComponent("" + reviewNo) + "&";
        if (beginTime === null)
            throw new globalThis.Error("The parameter 'beginTime' cannot be null.");
        else if (beginTime !== undefined)
            url_ += "beginTime=" + encodeURIComponent(beginTime ? "" + beginTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new globalThis.Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (isEnable === null)
            throw new globalThis.Error("The parameter 'isEnable' cannot be null.");
        else if (isEnable !== undefined)
            url_ += "IsEnable=" + encodeURIComponent("" + isEnable) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedEndCustomerList(_response);
        });
    }

    protected processGetPagedEndCustomerList(response: AxiosResponse): Promise<GreenChannelReviewNoListOutDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GreenChannelReviewNoListOutDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<GreenChannelReviewNoListOutDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GreenChannelReviewNoListOutDtoPagedResultDto>(null as any);
    }

    /**
     * 批量删除
     * @param body (optional) 主键合集
     * @return OK
     */
    multiDelete(body?: string[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/GreenChannelReviewNo/MultiDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMultiDelete(_response);
        });
    }

    protected processMultiDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 根据id集合批量设置启用状态
     * @param body (optional) 
     * @return OK
     */
    greenChannelSetEnable(body?: GreenChannelSetEnableDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/GreenChannelReviewNo/GreenChannelSetEnable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGreenChannelSetEnable(_response);
        });
    }

    protected processGreenChannelSetEnable(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 生成绿通评审号
     * @param body (optional) 
     * @return OK
     */
    generateReviewNo(body?: GenerateReviewNoDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/GreenChannelReviewNo/GenerateReviewNo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateReviewNo(_response);
        });
    }

    protected processGenerateReviewNo(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 创建或更新
     * @param body (optional) 实体合集
     * @return OK
     */
    createOrUpdate(body?: GreenChannelReviewNoDto[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/GreenChannelReviewNo/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 导入绿通评审号管理
     * @param excelFile (optional) 
     * @return OK
     */
    import(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/GreenChannelReviewNo/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出绿通评审号管理
     * @param body (optional) 
     * @return OK
     */
    exportGreenChannelReviewNoStream(body?: GreenChannelReviewNoListInDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/GreenChannelReviewNo/ExportGreenChannelReviewNoStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportGreenChannelReviewNoStream(_response);
        });
    }

    protected processExportGreenChannelReviewNoStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class IndustryVCServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 分页获取行业VC999(不包括详细信息)
     * @param body (optional) 
     * @return OK
     */
    getPageIndustryVC(body?: GetPageIndustryVCInPutDto | undefined, cancelToken?: CancelToken): Promise<GetPageIndustryVCOutPutDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/GetPageIndustryVC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageIndustryVC(_response);
        });
    }

    protected processGetPageIndustryVC(response: AxiosResponse): Promise<GetPageIndustryVCOutPutDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPageIndustryVCOutPutDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<GetPageIndustryVCOutPutDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPageIndustryVCOutPutDtoPagedResultDto>(null as any);
    }

    /**
     * 获取一个行业VC的详细信息
     * @param id (optional) 
     * @return OK
     */
    getIndustryVCPriceDetails(id?: string | undefined, cancelToken?: CancelToken): Promise<GetIndustryVCDetailsOutPutDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/GetIndustryVCPriceDetails?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIndustryVCPriceDetails(_response);
        });
    }

    protected processGetIndustryVCPriceDetails(response: AxiosResponse): Promise<GetIndustryVCDetailsOutPutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetIndustryVCDetailsOutPutDto.fromJS(resultData200);
            return Promise.resolve<GetIndustryVCDetailsOutPutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIndustryVCDetailsOutPutDto>(null as any);
    }

    /**
     * 创建新的行业VC
    新创建的默认为草稿状态
     * @param body (optional) 
     * @return OK
     */
    createIndustryVC(body?: AddIndustryVCInPutDto | undefined, cancelToken?: CancelToken): Promise<ReturnMessage> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/CreateIndustryVC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateIndustryVC(_response);
        });
    }

    protected processCreateIndustryVC(response: AxiosResponse): Promise<ReturnMessage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReturnMessage.fromJS(resultData200);
            return Promise.resolve<ReturnMessage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReturnMessage>(null as any);
    }

    /**
     * 创建新的行业VC逻辑
     * @param body (optional) 
     * @return OK
     */
    createIndustryVCPrice(body?: AddIndustryVCPriceInPutDto | undefined, cancelToken?: CancelToken): Promise<ReturnMessage> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/CreateIndustryVCPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateIndustryVCPrice(_response);
        });
    }

    protected processCreateIndustryVCPrice(response: AxiosResponse): Promise<ReturnMessage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReturnMessage.fromJS(resultData200);
            return Promise.resolve<ReturnMessage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReturnMessage>(null as any);
    }

    /**
     * 更新行业VC逻辑
     * @param body (optional) 
     * @return OK
     */
    updateIndustryVCPrice(body?: AddIndustryVCPriceInPutDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/UpdateIndustryVCPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateIndustryVCPrice(_response);
        });
    }

    protected processUpdateIndustryVCPrice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除行业VC逻辑
     * @param id (optional) 
     * @return OK
     */
    deleteIndustryVCPrice(id?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/DeleteIndustryVCPrice?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteIndustryVCPrice(_response);
        });
    }

    protected processDeleteIndustryVCPrice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 清空所有行业VC逻辑
     * @param id (optional) 
     * @return OK
     */
    deleteAllIndustryVCPrice(id?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/DeleteAllIndustryVCPrice?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAllIndustryVCPrice(_response);
        });
    }

    protected processDeleteAllIndustryVCPrice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取行业VC详情
     * @param industryVcId (optional) 
     * @return OK
     */
    details(industryVcId?: string | undefined, cancelToken?: CancelToken): Promise<GetPageIndustryVCOutPutDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/Details?";
        if (industryVcId === null)
            throw new globalThis.Error("The parameter 'industryVcId' cannot be null.");
        else if (industryVcId !== undefined)
            url_ += "IndustryVcId=" + encodeURIComponent("" + industryVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<GetPageIndustryVCOutPutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPageIndustryVCOutPutDto.fromJS(resultData200);
            return Promise.resolve<GetPageIndustryVCOutPutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPageIndustryVCOutPutDto>(null as any);
    }

    /**
     * 根据id获取行业VC逻辑
     * @param id (optional) 
     * @return OK
     */
    getIndustryVCPriceById(id?: string | undefined, cancelToken?: CancelToken): Promise<AddIndustryVCPriceInPutDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/GetIndustryVCPriceById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIndustryVCPriceById(_response);
        });
    }

    protected processGetIndustryVCPriceById(response: AxiosResponse): Promise<AddIndustryVCPriceInPutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddIndustryVCPriceInPutDto.fromJS(resultData200);
            return Promise.resolve<AddIndustryVCPriceInPutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddIndustryVCPriceInPutDto>(null as any);
    }

    /**
     * 获取行业VC数据
     * @return OK
     */
    getIndustryVCDetailsSelect( cancelToken?: CancelToken): Promise<GetIndustryVCDetailsOutPutDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/GetIndustryVCDetailsSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIndustryVCDetailsSelect(_response);
        });
    }

    protected processGetIndustryVCDetailsSelect(response: AxiosResponse): Promise<GetIndustryVCDetailsOutPutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetIndustryVCDetailsOutPutDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetIndustryVCDetailsOutPutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIndustryVCDetailsOutPutDto[]>(null as any);
    }

    /**
     * 更新附件列表
     * @param id (optional) 
     * @param attachs (optional) 
     * @return OK
     */
    updateAttachById(id?: string | undefined, attachs?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/UpdateAttachById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (attachs === null)
            throw new globalThis.Error("The parameter 'attachs' cannot be null.");
        else if (attachs !== undefined)
            url_ += "attachs=" + encodeURIComponent("" + attachs) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAttachById(_response);
        });
    }

    protected processUpdateAttachById(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 提交审批
     * @param id (optional) 
     * @return OK
     */
    approvalSubmit(id?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/ApprovalSubmit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApprovalSubmit(_response);
        });
    }

    protected processApprovalSubmit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新行业VC基础信息
     * @param body (optional) 
     * @return OK
     */
    updateIndustryVCBasicData(body?: AddIndustryVCInPutDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/UpdateIndustryVCBasicData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateIndustryVCBasicData(_response);
        });
    }

    protected processUpdateIndustryVCBasicData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 复制行业VC
     * @param industryVCId (optional) 
     * @param body (optional) 
     * @return OK
     */
    copyIndustryVC(industryVCId?: string | undefined, body?: AddIndustryVCInPutDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/CopyIndustryVC?";
        if (industryVCId === null)
            throw new globalThis.Error("The parameter 'industryVCId' cannot be null.");
        else if (industryVCId !== undefined)
            url_ += "industryVCId=" + encodeURIComponent("" + industryVCId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyIndustryVC(_response);
        });
    }

    protected processCopyIndustryVC(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 升级行业VC
     * @param id (optional) 
     * @return OK
     */
    upgradeIndustryVC(id?: string | undefined, cancelToken?: CancelToken): Promise<ReturnMessage> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/UpgradeIndustryVC?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpgradeIndustryVC(_response);
        });
    }

    protected processUpgradeIndustryVC(response: AxiosResponse): Promise<ReturnMessage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReturnMessage.fromJS(resultData200);
            return Promise.resolve<ReturnMessage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReturnMessage>(null as any);
    }

    /**
     * 插入一条审批记录
     * @param body (optional) 
     * @return OK
     */
    approvalIndustryVC(body?: ApprovalIndustryVCInPutDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/ApprovalIndustryVC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApprovalIndustryVC(_response);
        });
    }

    protected processApprovalIndustryVC(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除行业VC
     * @param id (optional) 
     * @return OK
     */
    deleteIndustryVC(id?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/DeleteIndustryVC?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteIndustryVC(_response);
        });
    }

    protected processDeleteIndustryVC(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据产品系列和机座号获取对应的行业VC
     * @param body (optional) 
     * @return OK
     */
    getPageIndustryVCByParam(body?: GetPageIndustryVCByParamInPutDto | undefined, cancelToken?: CancelToken): Promise<GetPageIndustryVCByParamOutPutDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/GetPageIndustryVCByParam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageIndustryVCByParam(_response);
        });
    }

    protected processGetPageIndustryVCByParam(response: AxiosResponse): Promise<GetPageIndustryVCByParamOutPutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPageIndustryVCByParamOutPutDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetPageIndustryVCByParamOutPutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPageIndustryVCByParamOutPutDto[]>(null as any);
    }

    /**
     * 添加行业VC到选型清单
     * @param id (optional) 
     * @param lectoTypeProductId (optional) 
     * @return OK
     */
    addIndustryVC(id?: string | undefined, lectoTypeProductId?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/AddIndustryVC?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (lectoTypeProductId === null)
            throw new globalThis.Error("The parameter 'lectoTypeProductId' cannot be null.");
        else if (lectoTypeProductId !== undefined)
            url_ += "lectoTypeProductId=" + encodeURIComponent("" + lectoTypeProductId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddIndustryVC(_response);
        });
    }

    protected processAddIndustryVC(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 禁用行业VC
     * @param id (optional) 
     * @return OK
     */
    disableIndustryVC(id?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/DisableIndustryVC?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisableIndustryVC(_response);
        });
    }

    protected processDisableIndustryVC(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取行业VC最新编号
    自动编号
     * @return OK
     */
    getIndustryVCNumber( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/GetIndustryVCNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIndustryVCNumber(_response);
        });
    }

    protected processGetIndustryVCNumber(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 刷新所有行业VC交期
     * @return OK
     */
    resetIndustryVCCycle( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/ResetIndustryVCCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetIndustryVCCycle(_response);
        });
    }

    protected processResetIndustryVCCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 撤回行业VC审批
     * @param industryVcId (optional) 
     * @param body (optional) 
     * @return OK
     */
    withdraw(industryVcId?: string | undefined, body?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/Withdraw?";
        if (industryVcId === null)
            throw new globalThis.Error("The parameter 'industryVcId' cannot be null.");
        else if (industryVcId !== undefined)
            url_ += "industryVcId=" + encodeURIComponent("" + industryVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWithdraw(_response);
        });
    }

    protected processWithdraw(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 历史数据初始化导入
     * @param excelFile (optional) 
     * @return OK
     */
    historyInitImport(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/HistoryInitImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHistoryInitImport(_response);
        });
    }

    protected processHistoryInitImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 启动服务
     * @return OK
     */
    startIndustryVCInitJob( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/StartIndustryVCInitJob";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartIndustryVCInitJob(_response);
        });
    }

    protected processStartIndustryVCInitJob(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入行业VC交期信息
     * @param excelFile (optional) 
     * @return OK
     */
    importCycle(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/ImportCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportCycle(_response);
        });
    }

    protected processImportCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入行业VC面价信息
     * @param excelFile (optional) 
     * @return OK
     */
    importListPrice(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/ImportListPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportListPrice(_response);
        });
    }

    protected processImportListPrice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出行业VC交期信息
     * @param body (optional) 
     * @return OK
     */
    exportCycleStream(body?: GetPageIndustryVCInPutDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/ExportCycleStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCycleStream(_response);
        });
    }

    protected processExportCycleStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出行业VC面价信息
     * @param body (optional) 
     * @return OK
     */
    exportListPriceStream(body?: GetPageIndustryVCInPutDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/ExportListPriceStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportListPriceStream(_response);
        });
    }

    protected processExportListPriceStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入行业VC
     * @param excelFile (optional) 
     * @return OK
     */
    import(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入行业VC
     * @param excelFile (optional) 
     * @return OK
     */
    fixedNumberImport(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/FixedNumberImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFixedNumberImport(_response);
        });
    }

    protected processFixedNumberImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入行业VC交期信息
     * @param excelFile (optional) 
     * @return OK
     */
    fixedNumberImportCycle(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/FixedNumberImportCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFixedNumberImportCycle(_response);
        });
    }

    protected processFixedNumberImportCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入行业VC面价信息
     * @param excelFile (optional) 
     * @return OK
     */
    fixedNumberImportListPrice(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/FixedNumberImportListPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFixedNumberImportListPrice(_response);
        });
    }

    protected processFixedNumberImportListPrice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入行业VCVC迁移日志
     * @param excelFile (optional) 
     * @return OK
     */
    fixedNumberMigrationlog(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/FixedNumberMigrationlog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFixedNumberMigrationlog(_response);
        });
    }

    protected processFixedNumberMigrationlog(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出行业VC
     * @param body (optional) 
     * @return OK
     */
    exportBaseStream(body?: GetPageIndustryVCInPutDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/ExportBaseStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportBaseStream(_response);
        });
    }

    protected processExportBaseStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出行业VC数据初始化前后差异对照
     * @return OK
     */
    exportInitDataVariation( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/ExportInitDataVariation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportInitDataVariation(_response);
        });
    }

    protected processExportInitDataVariation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新VC下单次数
     * @param body (optional) 
     * @return OK
     */
    updatePlaceOrderCount(body?: UpdatePlaceOrderCountDto[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/UpdatePlaceOrderCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePlaceOrderCount(_response);
        });
    }

    protected processUpdatePlaceOrderCount(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 检查已完成状态的自定义VC最新面价
     * @param body (optional) 
     * @return OK
     */
    checkIndustryVcListUnitPrice(body?: CheckIndustryVcListUnitPriceInputDto | undefined, cancelToken?: CancelToken): Promise<CheckIndustryVcListUnitPriceOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/IndustryVC/CheckIndustryVcListUnitPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckIndustryVcListUnitPrice(_response);
        });
    }

    protected processCheckIndustryVcListUnitPrice(response: AxiosResponse): Promise<CheckIndustryVcListUnitPriceOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckIndustryVcListUnitPriceOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckIndustryVcListUnitPriceOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckIndustryVcListUnitPriceOutputDto[]>(null as any);
    }
}

export class JINSenarioServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取GCS境界支持列表数据
     * @return OK
     */
    getJINSenarioAuthorizedUser( cancelToken?: CancelToken): Promise<JINSenarioShowDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/JINSenario/GetJINSenarioAuthorizedUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJINSenarioAuthorizedUser(_response);
        });
    }

    protected processGetJINSenarioAuthorizedUser(response: AxiosResponse): Promise<JINSenarioShowDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JINSenarioShowDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JINSenarioShowDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JINSenarioShowDto[]>(null as any);
    }

    /**
     * 新增维护人并删除不存在的
     * @param body (optional) 
     * @return OK
     */
    add(body?: AddAuthorizedUserJINSenarioRequestDto | undefined, cancelToken?: CancelToken): Promise<AuthorizedUserJINSenarioDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/JINSenario/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<AuthorizedUserJINSenarioDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuthorizedUserJINSenarioDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AuthorizedUserJINSenarioDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthorizedUserJINSenarioDto[]>(null as any);
    }

    /**
     * 删除GCS场景维护人
     * @param id (optional) 维护人关联主键
     * @return OK
     */
    delete(id?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/JINSenario/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class JINVCViewInfoSupplementServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 补充境界产品中的VCCode信息并返回权限
     * @param body (optional) 
     * @return OK
     */
    supplementInsideVCCode(body?: GetInventoryOutPutDto | undefined, cancelToken?: CancelToken): Promise<GetInventoryOutPutDtoBooleanStringListValueTuple> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/JINVCViewInfoSupplement/SupplementInsideVCCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSupplementInsideVCCode(_response);
        });
    }

    protected processSupplementInsideVCCode(response: AxiosResponse): Promise<GetInventoryOutPutDtoBooleanStringListValueTuple> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetInventoryOutPutDtoBooleanStringListValueTuple.fromJS(resultData200);
            return Promise.resolve<GetInventoryOutPutDtoBooleanStringListValueTuple>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInventoryOutPutDtoBooleanStringListValueTuple>(null as any);
    }

    /**
     * 返回是否有查看境界的权限
     * @param body (optional) 
     * @return OK
     */
    checkVCCodeRight(body?: GetInventoryOutPutDto | undefined, cancelToken?: CancelToken): Promise<BooleanStringListValueTuple> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/JINVCViewInfoSupplement/CheckVCCodeRight";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckVCCodeRight(_response);
        });
    }

    protected processCheckVCCodeRight(response: AxiosResponse): Promise<BooleanStringListValueTuple> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BooleanStringListValueTuple.fromJS(resultData200);
            return Promise.resolve<BooleanStringListValueTuple>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BooleanStringListValueTuple>(null as any);
    }

    /**
     * 补充境界产品中的VCCode信息并返回权限
     * @param body (optional) 
     * @return OK
     */
    supplementBriefInsideVCCode(body?: OpenVcCheckBriefProductDto[] | undefined, cancelToken?: CancelToken): Promise<OpenVcCheckBriefProductDtoListBooleanStringListValueTuple> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/JINVCViewInfoSupplement/SupplementBriefInsideVCCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSupplementBriefInsideVCCode(_response);
        });
    }

    protected processSupplementBriefInsideVCCode(response: AxiosResponse): Promise<OpenVcCheckBriefProductDtoListBooleanStringListValueTuple> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OpenVcCheckBriefProductDtoListBooleanStringListValueTuple.fromJS(resultData200);
            return Promise.resolve<OpenVcCheckBriefProductDtoListBooleanStringListValueTuple>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OpenVcCheckBriefProductDtoListBooleanStringListValueTuple>(null as any);
    }

    /**
     * 返回是否有查看境界的权限
     * @param body (optional) 
     * @return OK
     */
    checkBriefVCCodeRight(body?: OpenVcCheckBriefProductDto[] | undefined, cancelToken?: CancelToken): Promise<BooleanStringListValueTuple> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/JINVCViewInfoSupplement/CheckBriefVCCodeRight";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckBriefVCCodeRight(_response);
        });
    }

    protected processCheckBriefVCCodeRight(response: AxiosResponse): Promise<BooleanStringListValueTuple> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BooleanStringListValueTuple.fromJS(resultData200);
            return Promise.resolve<BooleanStringListValueTuple>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BooleanStringListValueTuple>(null as any);
    }

    /**
     * 修改DoubleVcCheckRule提醒内容
     * @param originalPrompt (optional) 
     * @param vcId1 (optional) 
     * @param isView (optional) 是否有权限
     * @param body (optional) 
     * @return OK
     */
    generateModifiedPromptContent(originalPrompt?: string | undefined, vcId1?: string | undefined, isView?: boolean | undefined, body?: SMProduct | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/JINVCViewInfoSupplement/GenerateModifiedPromptContent?";
        if (originalPrompt === null)
            throw new globalThis.Error("The parameter 'originalPrompt' cannot be null.");
        else if (originalPrompt !== undefined)
            url_ += "originalPrompt=" + encodeURIComponent("" + originalPrompt) + "&";
        if (vcId1 === null)
            throw new globalThis.Error("The parameter 'vcId1' cannot be null.");
        else if (vcId1 !== undefined)
            url_ += "vcId1=" + encodeURIComponent("" + vcId1) + "&";
        if (isView === null)
            throw new globalThis.Error("The parameter 'isView' cannot be null.");
        else if (isView !== undefined)
            url_ += "isView=" + encodeURIComponent("" + isView) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateModifiedPromptContent(_response);
        });
    }

    protected processGenerateModifiedPromptContent(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 判断是否GCS
     * @return OK
     */
    isGCS( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/JINVCViewInfoSupplement/IsGCS";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsGCS(_response);
        });
    }

    protected processIsGCS(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 判断是否授权当前用户
     * @param clienter (optional) 
     * @param finalCustomerCode (optional) 
     * @return OK
     */
    iSGCSAuthorizedCustomer(clienter?: string | undefined, finalCustomerCode?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/JINVCViewInfoSupplement/ISGCSAuthorizedCustomer?";
        if (clienter === null)
            throw new globalThis.Error("The parameter 'clienter' cannot be null.");
        else if (clienter !== undefined)
            url_ += "clienter=" + encodeURIComponent("" + clienter) + "&";
        if (finalCustomerCode === null)
            throw new globalThis.Error("The parameter 'finalCustomerCode' cannot be null.");
        else if (finalCustomerCode !== undefined)
            url_ += "finalCustomerCode=" + encodeURIComponent("" + finalCustomerCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processISGCSAuthorizedCustomer(_response);
        });
    }

    protected processISGCSAuthorizedCustomer(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class JobServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 定时任务记录
     * @param body (optional) 
     * @return OK
     */
    paged(body?: PagedJobRequestDto | undefined, cancelToken?: CancelToken): Promise<JobPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Job/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaged(_response);
        });
    }

    protected processPaged(response: AxiosResponse): Promise<JobPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobPagedResultDto.fromJS(resultData200);
            return Promise.resolve<JobPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobPagedResultDto>(null as any);
    }

    /**
     * 定时任务执行状态
     * @param jobId (optional) 
     * @return OK
     */
    historyState(jobId?: number | undefined, cancelToken?: CancelToken): Promise<State[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/Job/HistoryState?";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHistoryState(_response);
        });
    }

    protected processHistoryState(response: AxiosResponse): Promise<State[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(State.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<State[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<State[]>(null as any);
    }
}

export class LectoTypeServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 创建选型
     * @param body (optional) 
     * @return OK
     */
    create(body?: CreateLectoTypeInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 创建选型
     * @param body (optional) 
     * @return OK
     */
    ccsCreate(body?: CcsCreateLectoTypeInputDto | undefined, cancelToken?: CancelToken): Promise<SystemCreateLectoTypeResponseDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/CcsCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCcsCreate(_response);
        });
    }

    protected processCcsCreate(response: AxiosResponse): Promise<SystemCreateLectoTypeResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SystemCreateLectoTypeResponseDto.fromJS(resultData200);
            return Promise.resolve<SystemCreateLectoTypeResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemCreateLectoTypeResponseDto>(null as any);
    }

    /**
     * 创建选型供第三方系统使用
     * @param body (optional) 
     * @return OK
     */
    systemCreate(body?: SystemCreateLectoTypeInputDto | undefined, cancelToken?: CancelToken): Promise<SystemCreateLectoTypeResponseDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/SystemCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSystemCreate(_response);
        });
    }

    protected processSystemCreate(response: AxiosResponse): Promise<SystemCreateLectoTypeResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SystemCreateLectoTypeResponseDto.fromJS(resultData200);
            return Promise.resolve<SystemCreateLectoTypeResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemCreateLectoTypeResponseDto>(null as any);
    }

    /**
     * 第三方系统复制选型
     * @param body (optional) 
     * @return OK
     */
    systemCopy(body?: SystemCopyLectoTypeInputDto | undefined, cancelToken?: CancelToken): Promise<SystemCreateLectoTypeResponseDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/SystemCopy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSystemCopy(_response);
        });
    }

    protected processSystemCopy(response: AxiosResponse): Promise<SystemCreateLectoTypeResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SystemCreateLectoTypeResponseDto.fromJS(resultData200);
            return Promise.resolve<SystemCreateLectoTypeResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemCreateLectoTypeResponseDto>(null as any);
    }

    /**
     * 第三方系统替换选型责任销售
     * @param body (optional) 输入对象
     * @return OK
     */
    systemReplaceSales(body?: SystemReplaceSalesInput | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/SystemReplaceSales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSystemReplaceSales(_response);
        });
    }

    protected processSystemReplaceSales(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 第三方系统回写折扣
     * @param body (optional) 
     * @return OK
     */
    systemCallbackPrice(body?: SystemCallbackPrecalInput | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/SystemCallbackPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSystemCallbackPrice(_response);
        });
    }

    protected processSystemCallbackPrice(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 第三方系统设置选型状态
     * @param body (optional) 
     * @return OK
     */
    systemSetstate(body?: SystemSetStatusInput | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/SystemSetstate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSystemSetstate(_response);
        });
    }

    protected processSystemSetstate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 第三方系统判断是否允许申请特价
     * @param body (optional) PMS选型详情
     * @return OK
     */
    systemAllowPrice(body?: GetInventoryOutPutDto | undefined, cancelToken?: CancelToken): Promise<SystemAllowPriceOutput> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/SystemAllowPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSystemAllowPrice(_response);
        });
    }

    protected processSystemAllowPrice(response: AxiosResponse): Promise<SystemAllowPriceOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SystemAllowPriceOutput.fromJS(resultData200);
            return Promise.resolve<SystemAllowPriceOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemAllowPriceOutput>(null as any);
    }

    /**
     * 第三方系统变更客户
     * @param body (optional) 
     * @return OK
     */
    systemChangeClienter(body?: SystemChangeClienterDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/SystemChangeClienter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSystemChangeClienter(_response);
        });
    }

    protected processSystemChangeClienter(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 第三方系统选型转移
     * @param body (optional) 
     * @return OK
     */
    systemChangeCreator(body?: SystemChangeCreatorDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/SystemChangeCreator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSystemChangeCreator(_response);
        });
    }

    protected processSystemChangeCreator(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取整个选型清单
     * @param input (optional) 
     * @return OK
     */
    getInventory(input?: string | undefined, cancelToken?: CancelToken): Promise<GetInventoryOutPutDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/GetInventory?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInventory(_response);
        });
    }

    protected processGetInventory(response: AxiosResponse): Promise<GetInventoryOutPutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetInventoryOutPutDto.fromJS(resultData200);
            return Promise.resolve<GetInventoryOutPutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInventoryOutPutDto>(null as any);
    }

    /**
     * 检查自定义VC是否属于同系列同交期
     * @param body (optional) 
     * @return OK
     */
    checkCustomVcExsitCycle(body?: GetInventoryOutPutDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/CheckCustomVcExsitCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckCustomVcExsitCycle(_response);
        });
    }

    protected processCheckCustomVcExsitCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取选型详情（任何人都可以获取）
     * @param id (optional) 
     * @return OK
     */
    getLectoTypeDetails(id?: string | undefined, cancelToken?: CancelToken): Promise<GetLectoTypeDetailsDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/GetLectoTypeDetails?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLectoTypeDetails(_response);
        });
    }

    protected processGetLectoTypeDetails(response: AxiosResponse): Promise<GetLectoTypeDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLectoTypeDetailsDto.fromJS(resultData200);
            return Promise.resolve<GetLectoTypeDetailsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLectoTypeDetailsDto>(null as any);
    }

    /**
     * 解析 access_token
     * @param token (optional) 
     * @return OK
     */
    parseJwtToken(token?: string | undefined, cancelToken?: CancelToken): Promise<ClaimsIdentity> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/ParseJwtToken?";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processParseJwtToken(_response);
        });
    }

    protected processParseJwtToken(response: AxiosResponse): Promise<ClaimsIdentity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClaimsIdentity.fromJS(resultData200);
            return Promise.resolve<ClaimsIdentity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClaimsIdentity>(null as any);
    }

    /**
     * 更新选型状态为已完成
     * @param lectoTypeId (optional) 
     * @return OK
     */
    updateType(lectoTypeId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/UpdateType?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateType(_response);
        });
    }

    protected processUpdateType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 选型设为已报价
     * @param id (optional) 
     * @return OK
     */
    modelQuote(id?: string | undefined, cancelToken?: CancelToken): Promise<ModelQuoteResult> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/ModelQuote?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModelQuote(_response);
        });
    }

    protected processModelQuote(response: AxiosResponse): Promise<ModelQuoteResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ModelQuoteResult.fromJS(resultData200);
            return Promise.resolve<ModelQuoteResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelQuoteResult>(null as any);
    }

    /**
     * 派生选型直接下单
     1. 计算总价,排除按单收不打折,排除按台收不打折
    2. 跟上一单总价对比
    3. 判断新增的产品是否是不打折的
    4. 判断新增的VC是否为不打折的.
     * @param scId (optional) 
     * @return OK
     */
    pMSOrderDirectly(scId?: string | undefined, cancelToken?: CancelToken): Promise<ModelQuoteResult> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/PMSOrderDirectly?";
        if (scId === null)
            throw new globalThis.Error("The parameter 'scId' cannot be null.");
        else if (scId !== undefined)
            url_ += "scId=" + encodeURIComponent("" + scId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPMSOrderDirectly(_response);
        });
    }

    protected processPMSOrderDirectly(response: AxiosResponse): Promise<ModelQuoteResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ModelQuoteResult.fromJS(resultData200);
            return Promise.resolve<ModelQuoteResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelQuoteResult>(null as any);
    }

    /**
     * 分页获取所有选型
     * @param body (optional) 
     * @return OK
     */
    getHistoryModel(body?: GetHistoryLectoTypeInPutDto | undefined, cancelToken?: CancelToken): Promise<GetHistoryLectoTypeOutPutDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/GetHistoryModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHistoryModel(_response);
        });
    }

    protected processGetHistoryModel(response: AxiosResponse): Promise<GetHistoryLectoTypeOutPutDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetHistoryLectoTypeOutPutDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<GetHistoryLectoTypeOutPutDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetHistoryLectoTypeOutPutDtoPagedResultDto>(null as any);
    }

    /**
     * 删除历史选型
     * @param id (optional) 
     * @return OK
     */
    delHistoryModel(id?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/DelHistoryModel?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelHistoryModel(_response);
        });
    }

    protected processDelHistoryModel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 分页获取我的选型
     * @param body (optional) 
     * @return OK
     */
    getDraftModel(body?: GetDraftsInPutDto | undefined, cancelToken?: CancelToken): Promise<GetDraftsOutPutDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/GetDraftModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDraftModel(_response);
        });
    }

    protected processGetDraftModel(response: AxiosResponse): Promise<GetDraftsOutPutDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDraftsOutPutDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<GetDraftsOutPutDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDraftsOutPutDtoPagedResultDto>(null as any);
    }

    /**
     * 删除我的选型（软删除）
     * @param id (optional) 
     * @return OK
     */
    delDraftModel(id?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/DelDraftModel?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelDraftModel(_response);
        });
    }

    protected processDelDraftModel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 复制选型并返回id
     * @param body (optional) 
     * @return OK
     */
    copyHisModel(body?: CopyHisModelInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/CopyHisModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyHisModel(_response);
        });
    }

    protected processCopyHisModel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 请求帮助
     * @param body (optional) 
     * @return OK
     */
    needHelp(body?: HelpLectoType | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/NeedHelp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNeedHelp(_response);
        });
    }

    protected processNeedHelp(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * CP请求销售帮忙申请折扣
     * @param body (optional) 
     * @return OK
     */
    cPQuotedNeedHelp(body?: CPQuotedNeedHelpInPut | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/CPQuotedNeedHelp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCPQuotedNeedHelp(_response);
        });
    }

    protected processCPQuotedNeedHelp(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 帮助完成
     * @param body (optional) 
     * @return OK
     */
    helpCompleted(body?: HelpLectoType | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/HelpCompleted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHelpCompleted(_response);
        });
    }

    protected processHelpCompleted(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 销售帮助申请折扣完成
     * @param body (optional) 
     * @return OK
     */
    saleHelpDisCountCompleted(body?: SaleHelpDisCountCompletedInPut | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/SaleHelpDisCountCompleted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaleHelpDisCountCompleted(_response);
        });
    }

    protected processSaleHelpDisCountCompleted(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取帮助选型
     * @param body (optional) 
     * @return OK
     */
    getHelpModel(body?: GetHistoryLectoTypeInPutDto | undefined, cancelToken?: CancelToken): Promise<GetHelpLectoTypeOutPutDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/GetHelpModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHelpModel(_response);
        });
    }

    protected processGetHelpModel(response: AxiosResponse): Promise<GetHelpLectoTypeOutPutDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetHelpLectoTypeOutPutDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<GetHelpLectoTypeOutPutDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetHelpLectoTypeOutPutDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addProductsByTes(body?: AddProductCombinationInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/AddProductsByTes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddProductsByTes(_response);
        });
    }

    protected processAddProductsByTes(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addProductsByDqs(body?: AddProductCombinationInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/AddProductsByDqs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddProductsByDqs(_response);
        });
    }

    protected processAddProductsByDqs(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addProductsByHistorys(body?: AddProductCombinationInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/AddProductsByHistorys";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddProductsByHistorys(_response);
        });
    }

    protected processAddProductsByHistorys(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param lectoTypeId (optional) 
     * @param file (optional) 
     * @return OK
     */
    addProductsByExcel(lectoTypeId?: string | undefined, file?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/AddProductsByExcel?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddProductsByExcel(_response);
        });
    }

    protected processAddProductsByExcel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 选型数据下载
     * @param lectyId (optional) 
     * @return OK
     */
    downLoadProductsByExcel(lectyId?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/DownLoadProductsByExcel?";
        if (lectyId === null)
            throw new globalThis.Error("The parameter 'lectyId' cannot be null.");
        else if (lectyId !== undefined)
            url_ += "lectyId=" + encodeURIComponent("" + lectyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownLoadProductsByExcel(_response);
        });
    }

    protected processDownLoadProductsByExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 面价匹配
     * @param body (optional) 
     * @return OK
     */
    facePriceMatching(body?: FacePriceMatchingInPutDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/FacePriceMatching";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFacePriceMatching(_response);
        });
    }

    protected processFacePriceMatching(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 写入pre-cal号
     * @param body (optional) 
     * @return OK
     */
    setPReCalNumber(body?: SetPReCalNumberInPutDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/SetPReCalNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetPReCalNumber(_response);
        });
    }

    protected processSetPReCalNumber(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出预算性报价单
     * @param body (optional) 
     * @return OK
     */
    quotationOnBudgeExport(body?: QuotationOnBudgeExportInPutDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/QuotationOnBudgeExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuotationOnBudgeExport(_response);
        });
    }

    protected processQuotationOnBudgeExport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导出供货清单
     * @param simpleMode (optional) 
     * @param body (optional) 
     * @return OK
     */
    listOfSuppliesExport(simpleMode?: boolean | undefined, body?: QuotationOnBudgeExportInPutDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/ListOfSuppliesExport?";
        if (simpleMode === null)
            throw new globalThis.Error("The parameter 'simpleMode' cannot be null.");
        else if (simpleMode !== undefined)
            url_ += "simpleMode=" + encodeURIComponent("" + simpleMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListOfSuppliesExport(_response);
        });
    }

    protected processListOfSuppliesExport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 外销合同模板
     * @param lectoTypeId (optional) 
     * @return OK
     */
    exportProductContractTemplateStream(lectoTypeId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/ExportProductContractTemplateStream?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportProductContractTemplateStream(_response);
        });
    }

    protected processExportProductContractTemplateStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据选型编号查询进口电机参数配置(OIS系统使用)
     * @param userFriendlyID (optional) 
     * @return OK
     */
    getImportBasicMotorInfosByCodeOnOis(userFriendlyID?: string | undefined, cancelToken?: CancelToken): Promise<PageBasicMotorInfoOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/GetImportBasicMotorInfosByCodeOnOis?";
        if (userFriendlyID === null)
            throw new globalThis.Error("The parameter 'userFriendlyID' cannot be null.");
        else if (userFriendlyID !== undefined)
            url_ += "userFriendlyID=" + encodeURIComponent("" + userFriendlyID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImportBasicMotorInfosByCodeOnOis(_response);
        });
    }

    protected processGetImportBasicMotorInfosByCodeOnOis(response: AxiosResponse): Promise<PageBasicMotorInfoOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PageBasicMotorInfoOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PageBasicMotorInfoOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageBasicMotorInfoOutputDto[]>(null as any);
    }

    /**
     * 导出precal 成本表格
     * @param id (optional) 
     * @return OK
     */
    preCalExport(id?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/preCalExport?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreCalExport(_response);
        });
    }

    protected processPreCalExport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * CCS系统选型导出
     * @param lectoTypeId (optional) 
     * @param email (optional) 
     * @return OK
     */
    ccsLectoTypeExport(lectoTypeId?: string | undefined, email?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/CcsLectoTypeExport?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCcsLectoTypeExport(_response);
        });
    }

    protected processCcsLectoTypeExport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * gcs转交选型
     * @param id (optional) 
     * @return OK
     */
    coLectoType(id?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/CoLectoType?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCoLectoType(_response);
        });
    }

    protected processCoLectoType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取选型的主机交期,以周为单位
     * @param userFriendlyId (optional) 
     * @return OK
     */
    getBasicProductCycle(userFriendlyId?: string | undefined, cancelToken?: CancelToken): Promise<BasicProductCycleOutput[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/GetBasicProductCycle?";
        if (userFriendlyId === null)
            throw new globalThis.Error("The parameter 'userFriendlyId' cannot be null.");
        else if (userFriendlyId !== undefined)
            url_ += "userFriendlyId=" + encodeURIComponent("" + userFriendlyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasicProductCycle(_response);
        });
    }

    protected processGetBasicProductCycle(response: AxiosResponse): Promise<BasicProductCycleOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BasicProductCycleOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BasicProductCycleOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BasicProductCycleOutput[]>(null as any);
    }

    /**
     * 客户化代码交期刷新
     * @param body (optional) 
     * @return OK
     */
    getCustomCodeProductCycle(body?: CustomCodeProductCycleInput | undefined, cancelToken?: CancelToken): Promise<CustomCodeProductCycleOutput> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/GetCustomCodeProductCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomCodeProductCycle(_response);
        });
    }

    protected processGetCustomCodeProductCycle(response: AxiosResponse): Promise<CustomCodeProductCycleOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomCodeProductCycleOutput.fromJS(resultData200);
            return Promise.resolve<CustomCodeProductCycleOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomCodeProductCycleOutput>(null as any);
    }

    /**
     * 获取自制电机的交期天数
     * @param basicMotorCode (optional) 
     * @param vcCodes (optional) 
     * @return OK
     */
    getImportProductCycle(basicMotorCode?: string | undefined, vcCodes?: string[] | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/GetImportProductCycle?";
        if (basicMotorCode === null)
            throw new globalThis.Error("The parameter 'basicMotorCode' cannot be null.");
        else if (basicMotorCode !== undefined)
            url_ += "basicMotorCode=" + encodeURIComponent("" + basicMotorCode) + "&";
        if (vcCodes === null)
            throw new globalThis.Error("The parameter 'vcCodes' cannot be null.");
        else if (vcCodes !== undefined)
            vcCodes && vcCodes.forEach(item => { url_ += "vcCodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImportProductCycle(_response);
        });
    }

    protected processGetImportProductCycle(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * 刷新选型中主机的交期日期
     * @param lectoTypeId (optional) 
     * @return OK
     */
    resetProductsCycle(lectoTypeId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/ResetProductsCycle?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetProductsCycle(_response);
        });
    }

    protected processResetProductsCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取选型中包含主机的最新预计发货天数
     * @param userFriendlyId (optional) 
     * @return OK
     */
    getLectoTypeDate(userFriendlyId?: string | undefined, cancelToken?: CancelToken): Promise<LectoTypeDateOutput> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/GetLectoTypeDate?";
        if (userFriendlyId === null)
            throw new globalThis.Error("The parameter 'userFriendlyId' cannot be null.");
        else if (userFriendlyId !== undefined)
            url_ += "userFriendlyId=" + encodeURIComponent("" + userFriendlyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLectoTypeDate(_response);
        });
    }

    protected processGetLectoTypeDate(response: AxiosResponse): Promise<LectoTypeDateOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LectoTypeDateOutput.fromJS(resultData200);
            return Promise.resolve<LectoTypeDateOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LectoTypeDateOutput>(null as any);
    }

    /**
     * 刷新选型中自定义电机交期
     * @return OK
     */
    resetCustomProductsCycle( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/ResetCustomProductsCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetCustomProductsCycle(_response);
        });
    }

    protected processResetCustomProductsCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 刷新选型中自定义VC交期
     * @return OK
     */
    resetCustomVcCycle( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/ResetCustomVcCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetCustomVcCycle(_response);
        });
    }

    protected processResetCustomVcCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取最新选型
     * @param lectoTypeId (optional) 
     * @return OK
     */
    getNewLectoTypeDetails(lectoTypeId?: string | undefined, cancelToken?: CancelToken): Promise<NewGetInventoryOutPutDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/GetNewLectoTypeDetails?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewLectoTypeDetails(_response);
        });
    }

    protected processGetNewLectoTypeDetails(response: AxiosResponse): Promise<NewGetInventoryOutPutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NewGetInventoryOutPutDto.fromJS(resultData200);
            return Promise.resolve<NewGetInventoryOutPutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewGetInventoryOutPutDto>(null as any);
    }

    /**
     * 创建新版本
    1. 检查SC是否允许创建新版本
    2. 调用PMS 检查是否允许创建新版本（切换版本）
    3. 复制原有选型
    4. 保存原选型状态
    5. 变更原有选型状态
    6. PMS 回发选型信息
     * @param input (optional) 
     * @return OK
     */
    newVersionLectoType(input?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/NewVersionLectoType?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewVersionLectoType(_response);
        });
    }

    protected processNewVersionLectoType(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 切换选型
     * @param oldId (optional) 
     * @param newId (optional) 
     * @return OK
     */
    lectoTypeChanger(oldId?: string | undefined, newId?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/LectoTypeChanger?";
        if (oldId === null)
            throw new globalThis.Error("The parameter 'oldId' cannot be null.");
        else if (oldId !== undefined)
            url_ += "oldId=" + encodeURIComponent("" + oldId) + "&";
        if (newId === null)
            throw new globalThis.Error("The parameter 'newId' cannot be null.");
        else if (newId !== undefined)
            url_ += "newId=" + encodeURIComponent("" + newId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLectoTypeChanger(_response);
        });
    }

    protected processLectoTypeChanger(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 根据项目号获取历史选型版本
     * @param pmsProjectCode (optional) 
     * @param mainId (optional) 
     * @return OK
     */
    getLectoTypeVersions(pmsProjectCode?: string | undefined, mainId?: string | undefined, cancelToken?: CancelToken): Promise<LectoTypeVersionsByList[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/GetLectoTypeVersions?";
        if (pmsProjectCode === null)
            throw new globalThis.Error("The parameter 'pmsProjectCode' cannot be null.");
        else if (pmsProjectCode !== undefined)
            url_ += "pmsProjectCode=" + encodeURIComponent("" + pmsProjectCode) + "&";
        if (mainId === null)
            throw new globalThis.Error("The parameter 'mainId' cannot be null.");
        else if (mainId !== undefined)
            url_ += "mainId=" + encodeURIComponent("" + mainId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLectoTypeVersions(_response);
        });
    }

    protected processGetLectoTypeVersions(response: AxiosResponse): Promise<LectoTypeVersionsByList[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LectoTypeVersionsByList.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LectoTypeVersionsByList[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LectoTypeVersionsByList[]>(null as any);
    }

    /**
     * @return OK
     */
    postPrecal( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/PostPrecal";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostPrecal(_response);
        });
    }

    protected processPostPrecal(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取openvc
     * @param vcCodes (optional) 
     * @return OK
     */
    queryCheckVcs(vcCodes?: string[] | undefined, cancelToken?: CancelToken): Promise<CheckVcRuleDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/QueryCheckVcs?";
        if (vcCodes === null)
            throw new globalThis.Error("The parameter 'vcCodes' cannot be null.");
        else if (vcCodes !== undefined)
            vcCodes && vcCodes.forEach(item => { url_ += "vcCodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryCheckVcs(_response);
        });
    }

    protected processQueryCheckVcs(response: AxiosResponse): Promise<CheckVcRuleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckVcRuleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckVcRuleDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckVcRuleDto[]>(null as any);
    }

    /**
     * 批量回写未完成PMS选型最新数据
     * @return OK
     */
    writeBackPms( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/WriteBackPms";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWriteBackPms(_response);
        });
    }

    protected processWriteBackPms(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 第三方补PMS项目号接口
     * @param body (optional) 
     * @return OK
     */
    updateLectoTypePmsProjectCode(body?: UpdatePMSProjectCodeDTO | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/UpdateLectoTypePmsProjectCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLectoTypePmsProjectCode(_response);
        });
    }

    protected processUpdateLectoTypePmsProjectCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取选型中的国产报价号
     * @param userFriendlyID (optional) 
     * @return OK
     */
    getQuotationNumber(userFriendlyID?: string | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/GetQuotationNumber?";
        if (userFriendlyID === null)
            throw new globalThis.Error("The parameter 'userFriendlyID' cannot be null.");
        else if (userFriendlyID !== undefined)
            url_ += "userFriendlyID=" + encodeURIComponent("" + userFriendlyID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuotationNumber(_response);
        });
    }

    protected processGetQuotationNumber(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 订单变更选型
     * @param body (optional) 
     * @return OK
     */
    orderChangeLectoType(body?: OrderChangLectoTypeDto | undefined, cancelToken?: CancelToken): Promise<OrderChangeLectoTypeOutputDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/OrderChangeLectoType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrderChangeLectoType(_response);
        });
    }

    protected processOrderChangeLectoType(response: AxiosResponse): Promise<OrderChangeLectoTypeOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderChangeLectoTypeOutputDto.fromJS(resultData200);
            return Promise.resolve<OrderChangeLectoTypeOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderChangeLectoTypeOutputDto>(null as any);
    }

    /**
     * 获取选型对应技术协议中VC的备注信息
     * @param userFriendlyId (optional) 
     * @return OK
     */
    getLectoTypeTeVCRemark(userFriendlyId?: string | undefined, cancelToken?: CancelToken): Promise<LectoTypeTeVCRemarkDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/GetLectoTypeTeVCRemark?";
        if (userFriendlyId === null)
            throw new globalThis.Error("The parameter 'userFriendlyId' cannot be null.");
        else if (userFriendlyId !== undefined)
            url_ += "userFriendlyId=" + encodeURIComponent("" + userFriendlyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLectoTypeTeVCRemark(_response);
        });
    }

    protected processGetLectoTypeTeVCRemark(response: AxiosResponse): Promise<LectoTypeTeVCRemarkDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LectoTypeTeVCRemarkDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LectoTypeTeVCRemarkDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LectoTypeTeVCRemarkDto[]>(null as any);
    }

    /**
     * 创建一个流式处理的函数 深度拷贝产品对象
     * @param body (optional) 
     * @return OK
     */
    cloneProduct(body?: LectoTypeProduct | undefined, cancelToken?: CancelToken): Promise<LectoTypeProduct> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/CloneProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloneProduct(_response);
        });
    }

    protected processCloneProduct(response: AxiosResponse): Promise<LectoTypeProduct> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LectoTypeProduct.fromJS(resultData200);
            return Promise.resolve<LectoTypeProduct>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LectoTypeProduct>(null as any);
    }

    /**
     * 回写进行中状态的PMS选型
     * @return OK
     */
    sendPmsNewPrice( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/SendPmsNewPrice";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendPmsNewPrice(_response);
        });
    }

    protected processSendPmsNewPrice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取排除产品的产品型号
     * @return OK
     */
    getNotProductModel( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/GetNotProductModel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotProductModel(_response);
        });
    }

    protected processGetNotProductModel(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 检查是否失效产品
     * @param body (optional) 
     * @return OK
     */
    checkQamtProduct(body?: LectoTypeProduct[] | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/CheckQamtProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckQamtProduct(_response);
        });
    }

    protected processCheckQamtProduct(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param pageSize (optional) 
     * @param pageIndex (optional) 
     * @return OK
     */
    basicMotorParameterSynchronizer(pageSize?: number | undefined, pageIndex?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/BasicMotorParameterSynchronizer?";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBasicMotorParameterSynchronizer(_response);
        });
    }

    protected processBasicMotorParameterSynchronizer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 检查和更新A代码版本
     * @param id (optional) 
     * @return OK
     */
    checkLectoTypeCodeVersion(id?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/CheckLectoTypeCodeVersion?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckLectoTypeCodeVersion(_response);
        });
    }

    protected processCheckLectoTypeCodeVersion(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * GCS角色，查询是否包含vc209，如果不包含vc209，跳过，包含vc209，且技术确认号===技术确认号待定， 需要把技术确认号改为空
     * @param modelId (optional) 选型ID
     * @return OK
     */
    clearTechnicalConfirmation(modelId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/ClearTechnicalConfirmation?";
        if (modelId === null)
            throw new globalThis.Error("The parameter 'modelId' cannot be null.");
        else if (modelId !== undefined)
            url_ += "ModelId=" + encodeURIComponent("" + modelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearTechnicalConfirmation(_response);
        });
    }

    protected processClearTechnicalConfirmation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 境界面价选型选型
     * @param body (optional) 
     * @return OK
     */
    jINCodeLectoType(body?: JINLectoTypeInputDto | undefined, cancelToken?: CancelToken): Promise<JINLectoTypeOutDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/JINCodeLectoType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processJINCodeLectoType(_response);
        });
    }

    protected processJINCodeLectoType(response: AxiosResponse): Promise<JINLectoTypeOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JINLectoTypeOutDto.fromJS(resultData200);
            return Promise.resolve<JINLectoTypeOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JINLectoTypeOutDto>(null as any);
    }

    /**
     * 获取面价选型
     * @param body (optional) 
     * @return OK
     */
    getJINCodeLectoTypePage(body?: GetJINCodeLectoTypePageInputDto | undefined, cancelToken?: CancelToken): Promise<JINCodeLectoTypePageOutPutDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/GetJINCodeLectoTypePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJINCodeLectoTypePage(_response);
        });
    }

    protected processGetJINCodeLectoTypePage(response: AxiosResponse): Promise<JINCodeLectoTypePageOutPutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JINCodeLectoTypePageOutPutDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JINCodeLectoTypePageOutPutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JINCodeLectoTypePageOutPutDto[]>(null as any);
    }

    /**
     * 返回当前面价表关联选型还未完成的代码
     * @param clienter (optional) 客户编码
     * @param clientName (optional) 客户名称
     * @param finalCustomerCode (optional) 二级客户编码
     * @param finalCustomerName (optional) 二级客户名称
     * @param listPriceSeriesId (optional) 境界系列ID
     * @param listPriceJINSeriesId (optional) 境界面价系列ID
     * @return OK
     */
    getJINCodeLectoTypeProcessingCodes(clienter?: string | undefined, clientName?: string | undefined, finalCustomerCode?: string | undefined, finalCustomerName?: string | undefined, listPriceSeriesId?: string | undefined, listPriceJINSeriesId?: string | undefined, cancelToken?: CancelToken): Promise<JINCodeLectoTypeProcessingCodesOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/GetJINCodeLectoTypeProcessingCodes?";
        if (clienter === null)
            throw new globalThis.Error("The parameter 'clienter' cannot be null.");
        else if (clienter !== undefined)
            url_ += "Clienter=" + encodeURIComponent("" + clienter) + "&";
        if (clientName === null)
            throw new globalThis.Error("The parameter 'clientName' cannot be null.");
        else if (clientName !== undefined)
            url_ += "ClientName=" + encodeURIComponent("" + clientName) + "&";
        if (finalCustomerCode === null)
            throw new globalThis.Error("The parameter 'finalCustomerCode' cannot be null.");
        else if (finalCustomerCode !== undefined)
            url_ += "FinalCustomerCode=" + encodeURIComponent("" + finalCustomerCode) + "&";
        if (finalCustomerName === null)
            throw new globalThis.Error("The parameter 'finalCustomerName' cannot be null.");
        else if (finalCustomerName !== undefined)
            url_ += "FinalCustomerName=" + encodeURIComponent("" + finalCustomerName) + "&";
        if (listPriceSeriesId === null)
            throw new globalThis.Error("The parameter 'listPriceSeriesId' cannot be null.");
        else if (listPriceSeriesId !== undefined)
            url_ += "ListPriceSeriesId=" + encodeURIComponent("" + listPriceSeriesId) + "&";
        if (listPriceJINSeriesId === null)
            throw new globalThis.Error("The parameter 'listPriceJINSeriesId' cannot be null.");
        else if (listPriceJINSeriesId !== undefined)
            url_ += "ListPriceJINSeriesId=" + encodeURIComponent("" + listPriceJINSeriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJINCodeLectoTypeProcessingCodes(_response);
        });
    }

    protected processGetJINCodeLectoTypeProcessingCodes(response: AxiosResponse): Promise<JINCodeLectoTypeProcessingCodesOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JINCodeLectoTypeProcessingCodesOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JINCodeLectoTypeProcessingCodesOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JINCodeLectoTypeProcessingCodesOutputDto[]>(null as any);
    }

    /**
     * 境界选型完成
     * @param body (optional) 
     * @return OK
     */
    jINLectoTypeCompleted(body?: JINLectoTypeCompletedDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/JINLectoTypeCompleted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processJINLectoTypeCompleted(_response);
        });
    }

    protected processJINLectoTypeCompleted(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出境界选型（需要控制境界代码）
     * @param body (optional) 
     * @return OK
     */
    exportJINLectoType(body?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/ExportJINLectoType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportJINLectoType(_response);
        });
    }

    protected processExportJINLectoType(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导入境界选型
     * @param lectoTypeId (optional) 
     * @param excelFile (optional) 
     * @return OK
     */
    importJINLectoType(lectoTypeId?: string | undefined, excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/ImportJINLectoType?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportJINLectoType(_response);
        });
    }

    protected processImportJINLectoType(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 面价审批后更新一次性项目
     * @param body (optional) 
     * @return OK
     */
    updateLectoTypeInfoFromLP(body?: UpdateLectoTypeInfoFromLPInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/UpdateLectoTypeInfoFromLP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLectoTypeInfoFromLP(_response);
        });
    }

    protected processUpdateLectoTypeInfoFromLP(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 文件上传
     * @param excelFile (optional) 
     * @return OK
     */
    fileUpload(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<AttachmentFileInfo> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/FileUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileUpload(_response);
        });
    }

    protected processFileUpload(response: AxiosResponse): Promise<AttachmentFileInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AttachmentFileInfo.fromJS(resultData200);
            return Promise.resolve<AttachmentFileInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttachmentFileInfo>(null as any);
    }

    /**
     * 更新选型二级客户
     * @param body (optional) 
     * @return OK
     */
    updateLectoTypeFinalCustomerInfo(body?: UpdateLectoTypeFinalCustomerInfoDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/UpdateLectoTypeFinalCustomerInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLectoTypeFinalCustomerInfo(_response);
        });
    }

    protected processUpdateLectoTypeFinalCustomerInfo(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param lectoTypeId (optional) 
     * @param remark (optional) 
     * @param dqId (optional) 
     * @param teId (optional) 
     * @param body (optional) 
     * @return OK
     */
    saveHelpCompleteRecord(lectoTypeId?: string | undefined, remark?: string | undefined, dqId?: string | undefined, teId?: string | undefined, body?: AttachmentFileInfo[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/SaveHelpCompleteRecord?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        if (remark === null)
            throw new globalThis.Error("The parameter 'remark' cannot be null.");
        else if (remark !== undefined)
            url_ += "Remark=" + encodeURIComponent("" + remark) + "&";
        if (dqId === null)
            throw new globalThis.Error("The parameter 'dqId' cannot be null.");
        else if (dqId !== undefined)
            url_ += "DqId=" + encodeURIComponent("" + dqId) + "&";
        if (teId === null)
            throw new globalThis.Error("The parameter 'teId' cannot be null.");
        else if (teId !== undefined)
            url_ += "teId=" + encodeURIComponent("" + teId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveHelpCompleteRecord(_response);
        });
    }

    protected processSaveHelpCompleteRecord(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 计算生成完整的
     * @param lectoTypeId (optional) 
     * @param isCalPrice (optional) 是否重新拉取价格
     * @return OK
     */
    resetGetLectoTypeInfo(lectoTypeId?: string | undefined, isCalPrice?: boolean | undefined, cancelToken?: CancelToken): Promise<LectoTypeGetInventoryOutPutDtoValueTuple> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/ResetGetLectoTypeInfo?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        if (isCalPrice === null)
            throw new globalThis.Error("The parameter 'isCalPrice' cannot be null.");
        else if (isCalPrice !== undefined)
            url_ += "isCalPrice=" + encodeURIComponent("" + isCalPrice) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetGetLectoTypeInfo(_response);
        });
    }

    protected processResetGetLectoTypeInfo(response: AxiosResponse): Promise<LectoTypeGetInventoryOutPutDtoValueTuple> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LectoTypeGetInventoryOutPutDtoValueTuple.fromJS(resultData200);
            return Promise.resolve<LectoTypeGetInventoryOutPutDtoValueTuple>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LectoTypeGetInventoryOutPutDtoValueTuple>(null as any);
    }

    /**
     * 获取请求协助数据
     * @param lectoTypeId (optional) 
     * @param isBackNoRight (optional) 是否强制返回没有权限的文件
     * @return OK
     */
    getHelpCompleteRecord(lectoTypeId?: string | undefined, isBackNoRight?: boolean | undefined, cancelToken?: CancelToken): Promise<GetHelpCompleteRecordOutPutDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoType/GetHelpCompleteRecord?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "LectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        if (isBackNoRight === null)
            throw new globalThis.Error("The parameter 'isBackNoRight' cannot be null.");
        else if (isBackNoRight !== undefined)
            url_ += "IsBackNoRight=" + encodeURIComponent("" + isBackNoRight) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHelpCompleteRecord(_response);
        });
    }

    protected processGetHelpCompleteRecord(response: AxiosResponse): Promise<GetHelpCompleteRecordOutPutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetHelpCompleteRecordOutPutDto.fromJS(resultData200);
            return Promise.resolve<GetHelpCompleteRecordOutPutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetHelpCompleteRecordOutPutDto>(null as any);
    }
}

export class LectoTypeHelpInfoServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param excelFile (optional) 
     * @return OK
     */
    add(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeHelpInfo/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 更新指定选型信息
     * @param body (optional) 
     * @return OK
     */
    updateGCS(body?: UpdateGCSInputDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeHelpInfo/UpdateGCS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGCS(_response);
        });
    }

    protected processUpdateGCS(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取选型当前请求协助的信息
     * @param lectoTypeId (optional) 
     * @return OK
     */
    getLectoTypeHelpInfo(lectoTypeId?: string | undefined, cancelToken?: CancelToken): Promise<GetLectoTypeHelpInfoDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeHelpInfo/GetLectoTypeHelpInfo?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "LectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLectoTypeHelpInfo(_response);
        });
    }

    protected processGetLectoTypeHelpInfo(response: AxiosResponse): Promise<GetLectoTypeHelpInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLectoTypeHelpInfoDto.fromJS(resultData200);
            return Promise.resolve<GetLectoTypeHelpInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLectoTypeHelpInfoDto>(null as any);
    }
}

export class LectoTypeProductServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 添加
     * @param body (optional) 
     * @return OK
     */
    add(body?: AddLectoTypeProductDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 验证当前境界是否和已添加的境界产品有相同的授权角色
     * @param lectoTypeId (optional) 选型Id
     * @param jinCategoryCode (optional) 新添加的境界代码
     * @return OK
     */
    verifyJINMotorHasSameAuthorizedUser(lectoTypeId?: string | undefined, jinCategoryCode?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/VerifyJINMotorHasSameAuthorizedUser?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        if (jinCategoryCode === null)
            throw new globalThis.Error("The parameter 'jinCategoryCode' cannot be null.");
        else if (jinCategoryCode !== undefined)
            url_ += "jinCategoryCode=" + encodeURIComponent("" + jinCategoryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyJINMotorHasSameAuthorizedUser(_response);
        });
    }

    protected processVerifyJINMotorHasSameAuthorizedUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量删除
     * @param lectoTypeId (optional) 
     * @param body (optional) 
     * @return OK
     */
    delete(lectoTypeId?: string | undefined, body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/Delete?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 复制产品
     * @param copyLectoTypeProductId (optional) 
     * @return OK
     */
    copy(copyLectoTypeProductId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/copy?";
        if (copyLectoTypeProductId === null)
            throw new globalThis.Error("The parameter 'copyLectoTypeProductId' cannot be null.");
        else if (copyLectoTypeProductId !== undefined)
            url_ += "copyLectoTypeProductId=" + encodeURIComponent("" + copyLectoTypeProductId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopy(_response);
        });
    }

    protected processCopy(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 修改产品数量
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateProductNumber(id?: string | undefined, body?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/UpdateProductNumber?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProductNumber(_response);
        });
    }

    protected processUpdateProductNumber(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 修改技术确认号
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateProductTechnicalConfirmation(id?: string | undefined, body?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/UpdateProductTechnicalConfirmation?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProductTechnicalConfirmation(_response);
        });
    }

    protected processUpdateProductTechnicalConfirmation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 修改主机交期评审号
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateProductAppraisalNumber(id?: string | undefined, body?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/UpdateProductAppraisalNumber?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProductAppraisalNumber(_response);
        });
    }

    protected processUpdateProductAppraisalNumber(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 修改主机协议号
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateProductTechnicalSpecifications(id?: string | undefined, body?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/UpdateProductTechnicalSpecifications?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProductTechnicalSpecifications(_response);
        });
    }

    protected processUpdateProductTechnicalSpecifications(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * copy vc功能
     * @param body (optional) 
     * @return OK
     */
    copyProductVcs(body?: CopyProductVcsInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/CopyProductVcs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyProductVcs(_response);
        });
    }

    protected processCopyProductVcs(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加自定义主机
     * @param body (optional) 
     * @return OK
     */
    addCustomProduct(body?: AddCustomProductInPutDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/AddCustomProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddCustomProduct(_response);
        });
    }

    protected processAddCustomProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新自定义电机
     * @param body (optional) 
     * @return OK
     */
    updateCustomProduct(body?: AddCustomProductInPutDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/UpdateCustomProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCustomProduct(_response);
        });
    }

    protected processUpdateCustomProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 外销电机导入
     * @param lectoTypeId (optional) 
     * @param excelFile (optional) 
     * @return OK
     */
    exportProductImport(lectoTypeId?: string | undefined, excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/ExportProductImport?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportProductImport(_response);
        });
    }

    protected processExportProductImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 外销电机导入模板
     * @param lectoTypeId (optional) 
     * @return OK
     */
    excelProductImportTemplateStream(lectoTypeId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/ExcelProductImportTemplateStream?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExcelProductImportTemplateStream(_response);
        });
    }

    protected processExcelProductImportTemplateStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 进口电机导入模板
     * @param lectoTypeId (optional) 
     * @return OK
     */
    exportImportProductTemplateStream(lectoTypeId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/ExportImportProductTemplateStream?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportImportProductTemplateStream(_response);
        });
    }

    protected processExportImportProductTemplateStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 进口电机/零部件导入
     * @param lectoTypeId (optional) 
     * @param excelFile (optional) 
     * @return OK
     */
    importedMotorPartsProductImport(lectoTypeId?: string | undefined, excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/ImportedMotorPartsProductImport?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportedMotorPartsProductImport(_response);
        });
    }

    protected processImportedMotorPartsProductImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加进口电机及零部件
     * @param body (optional) 电机及零部件信息
     * @return OK
     */
    addImportProduct(body?: AddImportProductInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/AddImportProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddImportProduct(_response);
        });
    }

    protected processAddImportProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新进口电机及零部件
     * @param productId (optional) 进口电机选型编号
     * @param body (optional) 进口电机更新内容
     * @return OK
     */
    updateImportProduct(productId?: string | undefined, body?: UpdateImportProductInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/UpdateImportProduct?";
        if (productId === null)
            throw new globalThis.Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateImportProduct(_response);
        });
    }

    protected processUpdateImportProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 修改自定义产品价格
     * @param body (optional) 
     * @return OK
     */
    updateCustomProductUnitPrice(body?: UpdateCustomProductUnitPriceInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/UpdateCustomProductUnitPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCustomProductUnitPrice(_response);
        });
    }

    protected processUpdateCustomProductUnitPrice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 修改产品提交状态
     * @param body (optional) 
     * @return OK
     */
    updateProductSubmit(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/UpdateProductSubmit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProductSubmit(_response);
        });
    }

    protected processUpdateProductSubmit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 重置更新后的交期
     * @return OK
     */
    resetProductCycle( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/ResetProductCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetProductCycle(_response);
        });
    }

    protected processResetProductCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 重置所有状态更新后的交期
     * @return OK
     */
    resetAllProductCycle( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/ResetAllProductCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetAllProductCycle(_response);
        });
    }

    protected processResetAllProductCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新产品期望折扣
     * @param lectoTypeId (optional) 选型编号
     * @param body (optional) 选型产品期望折扣信息
     * @return OK
     */
    updateProductMultiplier(lectoTypeId?: string | undefined, body?: UpdateProductMultiplierDto[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/UpdateProductMultiplier?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProductMultiplier(_response);
        });
    }

    protected processUpdateProductMultiplier(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出PMS选型产品对应的国产报价行号
     * @return OK
     */
    exportPmsLectoTypeLineNumber( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/ExportPmsLectoTypeLineNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportPmsLectoTypeLineNumber(_response);
        });
    }

    protected processExportPmsLectoTypeLineNumber(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 初始化产品序号
     * @return OK
     */
    initProductSerialNo( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/InitProductSerialNo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitProductSerialNo(_response);
        });
    }

    protected processInitProductSerialNo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据产品编号顺序设置序号属性
     * @param body (optional) 
     * @return OK
     */
    setProductSerialNo(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/SetProductSerialNo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetProductSerialNo(_response);
        });
    }

    protected processSetProductSerialNo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取用于冲突检测的产品数据和VC数据
     * @param body (optional) 
     * @return OK
     */
    getMockInventory(body?: GetInventoryOutPutDto | undefined, cancelToken?: CancelToken): Promise<GetInventoryOutPutDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/GetMockInventory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMockInventory(_response);
        });
    }

    protected processGetMockInventory(response: AxiosResponse): Promise<GetInventoryOutPutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetInventoryOutPutDto.fromJS(resultData200);
            return Promise.resolve<GetInventoryOutPutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInventoryOutPutDto>(null as any);
    }

    /**
     * 更新境界代码能效等级，电压、频、安全防护等级、绝缘等级
     * @param pageSize (optional) 
     * @param pageIndex (optional) 
     * @return OK
     */
    updateJINCodeParameter(pageSize?: number | undefined, pageIndex?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/UpdateJINCodeParameter?";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateJINCodeParameter(_response);
        });
    }

    protected processUpdateJINCodeParameter(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 复制VC时，如果复制的vc包含209，给产品的技术确认号设置默认值：技术确认号待定
     * @param body (optional) 
     * @return OK
     */
    copyProductVcsSetTechnicalConfirmation(body?: LectoTypeProductVC[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/CopyProductVcsSetTechnicalConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyProductVcsSetTechnicalConfirmation(_response);
        });
    }

    protected processCopyProductVcsSetTechnicalConfirmation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 是CP或者销售
     * @return OK
     */
    isCPorSale( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/IsCPorSale";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsCPorSale(_response);
        });
    }

    protected processIsCPorSale(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 更换境界代码
     * @param body (optional) 
     * @return OK
     */
    changeJINCode(body?: ChangeJINCodeInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/ChangeJINCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeJINCode(_response);
        });
    }

    protected processChangeJINCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 检查选型下产品VC是否包含163/209，且是否通过GCS帮助；未通过帮助的产品给出提示
     * @param userFriendlyId (optional) 选型编号（UserFriendlyID）
     * @return OK
     */
    checkLectoTypeProductVc163209NoGcsHelp(userFriendlyId?: string | undefined, cancelToken?: CancelToken): Promise<LectoTypeProductVc163209NoGcsHelpDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProduct/CheckLectoTypeProductVc163209NoGcsHelp?";
        if (userFriendlyId === null)
            throw new globalThis.Error("The parameter 'userFriendlyId' cannot be null.");
        else if (userFriendlyId !== undefined)
            url_ += "userFriendlyId=" + encodeURIComponent("" + userFriendlyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckLectoTypeProductVc163209NoGcsHelp(_response);
        });
    }

    protected processCheckLectoTypeProductVc163209NoGcsHelp(response: AxiosResponse): Promise<LectoTypeProductVc163209NoGcsHelpDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LectoTypeProductVc163209NoGcsHelpDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LectoTypeProductVc163209NoGcsHelpDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LectoTypeProductVc163209NoGcsHelpDto[]>(null as any);
    }
}

export class LectoTypeProductOrVcRecordsServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 批量添加选型产品记录
     * @param body (optional) 
     * @return OK
     */
    batchInsertProducts(body?: LectoTypeProductsRecords[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductOrVcRecords/BatchInsertProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchInsertProducts(_response);
        });
    }

    protected processBatchInsertProducts(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 批量添加选型产品VC记录
     * @param body (optional) 选型产品VC记录列表
     * @return OK
     */
    batchInsertProductVCs(body?: LectoTypeProductVCsRecords[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductOrVcRecords/BatchInsertProductVCs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchInsertProductVCs(_response);
        });
    }

    protected processBatchInsertProductVCs(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * GCS帮助后,产品的GcsHelpProductId,反写到 选型产品里面
     * @param lectoTypeId (optional) 
     * @return OK
     */
    updateLectoTypeProjectGCSHelpId(lectoTypeId?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductOrVcRecords/UpdateLectoTypeProjectGCSHelpId?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLectoTypeProjectGCSHelpId(_response);
        });
    }

    protected processUpdateLectoTypeProjectGCSHelpId(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 批量插入选型数据（产品和VC记录）
     * @param body (optional) 选型对象
     * @return OK
     */
    batchInsertData(body?: LectoType | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductOrVcRecords/BatchInsertData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchInsertData(_response);
        });
    }

    protected processBatchInsertData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取GCS 帮助后的产品和VC
     * @param lectoTypeId (optional) 
     * @return OK
     */
    getLectoTypeProductsAndVCRecords(lectoTypeId?: string | undefined, cancelToken?: CancelToken): Promise<LectoTypeProductsRecords[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductOrVcRecords/GetLectoTypeProductsAndVCRecords?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLectoTypeProductsAndVCRecords(_response);
        });
    }

    protected processGetLectoTypeProductsAndVCRecords(response: AxiosResponse): Promise<LectoTypeProductsRecords[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LectoTypeProductsRecords.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LectoTypeProductsRecords[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LectoTypeProductsRecords[]>(null as any);
    }

    /**
     * @param gcsHelpProductId (optional) 
     * @return OK
     */
    getLectoTypeProductsAndVCRecordsByGcsId(gcsHelpProductId?: string | undefined, cancelToken?: CancelToken): Promise<LectoTypeProductsRecords[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductOrVcRecords/GetLectoTypeProductsAndVCRecordsByGcsId?";
        if (gcsHelpProductId === null)
            throw new globalThis.Error("The parameter 'gcsHelpProductId' cannot be null.");
        else if (gcsHelpProductId !== undefined)
            url_ += "GcsHelpProductId=" + encodeURIComponent("" + gcsHelpProductId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLectoTypeProductsAndVCRecordsByGcsId(_response);
        });
    }

    protected processGetLectoTypeProductsAndVCRecordsByGcsId(response: AxiosResponse): Promise<LectoTypeProductsRecords[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LectoTypeProductsRecords.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LectoTypeProductsRecords[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LectoTypeProductsRecords[]>(null as any);
    }
}

export class LectoTypeProductVcServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 添加选型清单产品VC
     * @param body (optional) 
     * @return OK
     */
    add(body?: AddLectoTypeProductVcInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductVc/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 分页获取自定义VC
     * @param body (optional) 
     * @return OK
     */
    pagedCustomVc(body?: PagedCustomVcRequestDto | undefined, cancelToken?: CancelToken): Promise<CustomVcDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductVc/PagedCustomVc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPagedCustomVc(_response);
        });
    }

    protected processPagedCustomVc(response: AxiosResponse): Promise<CustomVcDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomVcDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<CustomVcDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomVcDtoPagedResultDto>(null as any);
    }

    /**
     * 添加自定义产品VC
     * @param lectoTypeProductIds (optional) 
     * @param body (optional) 
     * @return OK
     */
    addCustomVc(lectoTypeProductIds?: string[] | undefined, body?: AddCustomVcInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductVc/AddCustomVc?";
        if (lectoTypeProductIds === null)
            throw new globalThis.Error("The parameter 'lectoTypeProductIds' cannot be null.");
        else if (lectoTypeProductIds !== undefined)
            lectoTypeProductIds && lectoTypeProductIds.forEach(item => { url_ += "lectoTypeProductIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddCustomVc(_response);
        });
    }

    protected processAddCustomVc(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新自定义产品VC
     * @param lectoTypeProductVcId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateCustomVc(lectoTypeProductVcId?: string | undefined, body?: AddCustomVcInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductVc/UpdateCustomVc?";
        if (lectoTypeProductVcId === null)
            throw new globalThis.Error("The parameter 'lectoTypeProductVcId' cannot be null.");
        else if (lectoTypeProductVcId !== undefined)
            url_ += "lectoTypeProductVcId=" + encodeURIComponent("" + lectoTypeProductVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCustomVc(_response);
        });
    }

    protected processUpdateCustomVc(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 修改自定义VC的价格
     * @param body (optional) 
     * @return OK
     */
    updateCustomVcUnitPrice(body?: UpdateCustomVcUnitPriceInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductVc/UpdateCustomVcUnitPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCustomVcUnitPrice(_response);
        });
    }

    protected processUpdateCustomVcUnitPrice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * copy vc
     * @param lectoTypeProductVcId (optional) 
     * @param lectoTypeProductIdEnds (optional) 
     * @return OK
     */
    copyVc(lectoTypeProductVcId?: string | undefined, lectoTypeProductIdEnds?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductVc/CopyVc?";
        if (lectoTypeProductVcId === null)
            throw new globalThis.Error("The parameter 'lectoTypeProductVcId' cannot be null.");
        else if (lectoTypeProductVcId !== undefined)
            url_ += "lectoTypeProductVcId=" + encodeURIComponent("" + lectoTypeProductVcId) + "&";
        if (lectoTypeProductIdEnds === null)
            throw new globalThis.Error("The parameter 'lectoTypeProductIdEnds' cannot be null.");
        else if (lectoTypeProductIdEnds !== undefined)
            lectoTypeProductIdEnds && lectoTypeProductIdEnds.forEach(item => { url_ += "lectoTypeProductIdEnds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyVc(_response);
        });
    }

    protected processCopyVc(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @param id (optional) 
     * @return OK
     */
    delete(id?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductVc/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量删除Id
     * @param body (optional) 
     * @return OK
     */
    batchDelete(body?: BatchDeleteInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductVc/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitVCRemart(body?: GetInventoryOutPutDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductVc/SubmitVCRemart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitVCRemart(_response);
        });
    }

    protected processSubmitVCRemart(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 重置标准VC更新后的交期
     * @return OK
     */
    resetStandardVcCycle( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductVc/ResetStandardVcCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetStandardVcCycle(_response);
        });
    }

    protected processResetStandardVcCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 重置自定义CX更新后的交期
     * @return OK
     */
    resetCustomVcCycle( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductVc/ResetCustomVcCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetCustomVcCycle(_response);
        });
    }

    protected processResetCustomVcCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 重置行业VC更新后的交期
     * @return OK
     */
    resetIndustryVcCycle( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductVc/ResetIndustryVcCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetIndustryVcCycle(_response);
        });
    }

    protected processResetIndustryVcCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 重置标准VC所有所有状态更新后的交期
     * @return OK
     */
    resetStandardAllVcCycle( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductVc/ResetStandardAllVcCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetStandardAllVcCycle(_response);
        });
    }

    protected processResetStandardAllVcCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 重置Open Vc显示方式
     * @return OK
     */
    resetVcShowType( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductVc/ResetVcShowType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetVcShowType(_response);
        });
    }

    protected processResetVcShowType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加VC时，如果添加的VC包含209，给产品的技术确认号设置默认值"技术确认号待定"
     * @param body (optional) 
     * @return OK
     */
    setProductTechnicalConfirmation(body?: LectoTypeProductVC[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductVc/SetProductTechnicalConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetProductTechnicalConfirmation(_response);
        });
    }

    protected processSetProductTechnicalConfirmation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除VC后，判断产品是否还包含VC209，如果不包含VC209,技术确认号==="技术确认号待定",则改为空
     * @param body (optional) 
     * @return OK
     */
    clearProductTechnicalConfirmation(body?: LectoTypeProductVC | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductVc/ClearProductTechnicalConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearProductTechnicalConfirmation(_response);
        });
    }

    protected processClearProductTechnicalConfirmation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 是CP或者销售
     * @return OK
     */
    isCPorSale( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductVc/IsCPorSale";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsCPorSale(_response);
        });
    }

    protected processIsCPorSale(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class LectoTypeProductVcLimitServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param basicMotorSries (optional) 
     * @param lectoTypeId (optional) 
     * @param body (optional) 
     * @return OK
     */
    productOrVCLimit(basicMotorSries?: string | undefined, lectoTypeId?: string | undefined, body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeProductVcLimit/ProductOrVCLimit?";
        if (basicMotorSries === null)
            throw new globalThis.Error("The parameter 'basicMotorSries' cannot be null.");
        else if (basicMotorSries !== undefined)
            url_ += "basicMotorSries=" + encodeURIComponent("" + basicMotorSries) + "&";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProductOrVCLimit(_response);
        });
    }

    protected processProductOrVCLimit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LectoTypeRecordServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 启动服务
     * @param body (optional) 
     * @return OK
     */
    start(body?: LectoTypeRecordJobArgs | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeRecord/Start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStart(_response);
        });
    }

    protected processStart(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 停止任务
     * @return OK
     */
    stop( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/LectoTypeRecord/Stop";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStop(_response);
        });
    }

    protected processStop(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MassQuotationNumberServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 处理ServiceBus消息
     * @param msg (optional) 
     * @return OK
     */
    execServiceBusMessage(msg?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/MassQuotationNumber/ExecServiceBusMessage?";
        if (msg === null)
            throw new globalThis.Error("The parameter 'msg' cannot be null.");
        else if (msg !== undefined)
            url_ += "msg=" + encodeURIComponent("" + msg) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExecServiceBusMessage(_response);
        });
    }

    protected processExecServiceBusMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取特价号列表
     * @param body (optional) 
     * @return OK
     */
    getMassQuotationNumber(body?: GetMassQuotationNumberInput | undefined, cancelToken?: CancelToken): Promise<MassQuotationNumberBaseInfoOutputPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/MassQuotationNumber/GetMassQuotationNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMassQuotationNumber(_response);
        });
    }

    protected processGetMassQuotationNumber(response: AxiosResponse): Promise<MassQuotationNumberBaseInfoOutputPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MassQuotationNumberBaseInfoOutputPagedResultDto.fromJS(resultData200);
            return Promise.resolve<MassQuotationNumberBaseInfoOutputPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MassQuotationNumberBaseInfoOutputPagedResultDto>(null as any);
    }

    /**
     * 选型匹配特价号
     * @param body (optional) 
     * @return OK
     */
    macthQuotationNumberFromLectoType(body?: MacthQuotationNumberFromLectoTypeInput | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/MassQuotationNumber/MacthQuotationNumberFromLectoType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMacthQuotationNumberFromLectoType(_response);
        });
    }

    protected processMacthQuotationNumberFromLectoType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    macthQuotationNumberFromLectoTypeTwo(body?: MacthQuotationNumberFromLectoTypeInput | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/MassQuotationNumber/MacthQuotationNumberFromLectoTypeTwo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMacthQuotationNumberFromLectoTypeTwo(_response);
        });
    }

    protected processMacthQuotationNumberFromLectoTypeTwo(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class MotorAndVcValidityCheckServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 核对是否主机和vc是否有效
     * @param body (optional) 
     * @return OK
     */
    check(body?: GetInventoryOutPutDto | undefined, cancelToken?: CancelToken): Promise<CheckResultOutput[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/MotorAndVcValidityCheck/Check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheck(_response);
        });
    }

    protected processCheck(response: AxiosResponse): Promise<CheckResultOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckResultOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckResultOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckResultOutput[]>(null as any);
    }

    /**
     * @return OK
     */
    initAllRules( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/MotorAndVcValidityCheck/InitAllRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitAllRules(_response);
        });
    }

    protected processInitAllRules(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MotorizerRulesServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * Motorizer std vc规则检查 调用本地从Motorizer拿到的缓存数据
     * @param body (optional) 
     * @return OK
     */
    check(body?: GetInventoryOutPutDto | undefined, cancelToken?: CancelToken): Promise<CheckResultOutput[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/MotorizerRules/Check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheck(_response);
        });
    }

    protected processCheck(response: AxiosResponse): Promise<CheckResultOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckResultOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckResultOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckResultOutput[]>(null as any);
    }

    /**
     * Motorizer openvc规则检查，nswag 占位，s2s vpn打通后替换
     * @param body (optional) 
     * @return OK
     */
    checkOpenVC(body?: GetInventoryOutPutDto | undefined, cancelToken?: CancelToken): Promise<CheckResultOutput[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/MotorizerRules/CheckOpenVC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckOpenVC(_response);
        });
    }

    protected processCheckOpenVC(response: AxiosResponse): Promise<CheckResultOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckResultOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckResultOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckResultOutput[]>(null as any);
    }

    /**
     * @return OK
     */
    initAllRules( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/MotorizerRules/InitAllRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitAllRules(_response);
        });
    }

    protected processInitAllRules(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 启动服务
     * @param body (optional) 
     * @return OK
     */
    start(body?: MotorizerRuleJobArgs | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/MotorizerRules/Start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStart(_response);
        });
    }

    protected processStart(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 停止任务
     * @return OK
     */
    stop( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/MotorizerRules/Stop";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStop(_response);
        });
    }

    protected processStop(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MotorNotCustomerServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 核对主机是否属于当前客户
     * @param body (optional) 
     * @return OK
     */
    check(body?: GetInventoryOutPutDto | undefined, cancelToken?: CancelToken): Promise<CheckResultOutput[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/MotorNotCustomer/Check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheck(_response);
        });
    }

    protected processCheck(response: AxiosResponse): Promise<CheckResultOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckResultOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckResultOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckResultOutput[]>(null as any);
    }

    /**
     * @return OK
     */
    initAllRules( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/MotorNotCustomer/InitAllRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitAllRules(_response);
        });
    }

    protected processInitAllRules(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MotorNotSupportVCSelectionServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * some of the motor can not select VC
     * @param body (optional) 
     * @return OK
     */
    check(body?: GetInventoryOutPutDto | undefined, cancelToken?: CancelToken): Promise<CheckResultOutput[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/MotorNotSupportVCSelection/Check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheck(_response);
        });
    }

    protected processCheck(response: AxiosResponse): Promise<CheckResultOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckResultOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckResultOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckResultOutput[]>(null as any);
    }

    /**
     * @return OK
     */
    initAllRules( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/MotorNotSupportVCSelection/InitAllRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitAllRules(_response);
        });
    }

    protected processInitAllRules(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class NumberWiresCheckRulesServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAll(body?: GetAllNumberWiresCheckRulesInput | undefined, cancelToken?: CancelToken): Promise<NumberWiresCheckRulesDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/NumberWiresCheckRules/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<NumberWiresCheckRulesDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NumberWiresCheckRulesDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<NumberWiresCheckRulesDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NumberWiresCheckRulesDtoPagedResultDto>(null as any);
    }

    /**
     * 获取所有产品类型
     * @return OK
     */
    getAllProductType( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/NumberWiresCheckRules/GetAllProductType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllProductType(_response);
        });
    }

    protected processGetAllProductType(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getNumberWiresCheckRulesForView(id?: string | undefined, cancelToken?: CancelToken): Promise<NumberWiresCheckRulesDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/NumberWiresCheckRules/GetNumberWiresCheckRulesForView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNumberWiresCheckRulesForView(_response);
        });
    }

    protected processGetNumberWiresCheckRulesForView(response: AxiosResponse): Promise<NumberWiresCheckRulesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NumberWiresCheckRulesDto.fromJS(resultData200);
            return Promise.resolve<NumberWiresCheckRulesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NumberWiresCheckRulesDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getNumberWiresCheckRulesForEdit(id?: string | undefined, cancelToken?: CancelToken): Promise<GetNumberWiresCheckRulesForEditOutput> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/NumberWiresCheckRules/GetNumberWiresCheckRulesForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNumberWiresCheckRulesForEdit(_response);
        });
    }

    protected processGetNumberWiresCheckRulesForEdit(response: AxiosResponse): Promise<GetNumberWiresCheckRulesForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetNumberWiresCheckRulesForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetNumberWiresCheckRulesForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetNumberWiresCheckRulesForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body?: CreateOrEditNumberWiresCheckRulesDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/NumberWiresCheckRules/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrEdit(_response);
        });
    }

    protected processCreateOrEdit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 软删除
     * @param input (optional) 
     * @return OK
     */
    delete(input?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/NumberWiresCheckRules/Delete?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            input && input.forEach(item => { url_ += "input=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 恢复
     * @param body (optional) 
     * @return OK
     */
    recover(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/NumberWiresCheckRules/Recover";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecover(_response);
        });
    }

    protected processRecover(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 彻底删除
     * @param body (optional) 
     * @return OK
     */
    hardDelete(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/NumberWiresCheckRules/HardDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHardDelete(_response);
        });
    }

    protected processHardDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入
     * @param formFiles (optional) 
     * @return OK
     */
    import(formFiles?: FileParameter[] | undefined, cancelToken?: CancelToken): Promise<ImportOutput> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/NumberWiresCheckRules/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFiles === null || formFiles === undefined)
            throw new globalThis.Error("The parameter 'formFiles' cannot be null.");
        else
            formFiles.forEach(item_ => content_.append("formFiles", item_.data, item_.fileName ? item_.fileName : "formFiles") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<ImportOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportOutput.fromJS(resultData200);
            return Promise.resolve<ImportOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportOutput>(null as any);
    }

    /**
     * 导出
     * @param body (optional) 
     * @return OK
     */
    export(body?: GetAllNumberWiresCheckRulesInput | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/NumberWiresCheckRules/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * VC头数检查规则检查
     * @param body (optional) 
     * @return OK
     */
    check(body?: GetInventoryOutPutDto | undefined, cancelToken?: CancelToken): Promise<CheckResultOutput[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/NumberWiresCheckRules/Check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheck(_response);
        });
    }

    protected processCheck(response: AxiosResponse): Promise<CheckResultOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckResultOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckResultOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckResultOutput[]>(null as any);
    }

    /**
     * @return OK
     */
    initAllRules( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/NumberWiresCheckRules/InitAllRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitAllRules(_response);
        });
    }

    protected processInitAllRules(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 移除缓存,并在5秒后更新缓存
     * @return OK
     */
    removeCache( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/NumberWiresCheckRules/RemoveCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveCache(_response);
        });
    }

    protected processRemoveCache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OCTOpenVCRulesServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * oct open vc rule check
     * @param body (optional) 
     * @return OK
     */
    check(body?: GetInventoryOutPutDto | undefined, cancelToken?: CancelToken): Promise<CheckResultOutput[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/OCTOpenVCRules/Check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheck(_response);
        });
    }

    protected processCheck(response: AxiosResponse): Promise<CheckResultOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckResultOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckResultOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckResultOutput[]>(null as any);
    }

    /**
     * OpenVc备注简易检查
     * @param body (optional) 
     * @return OK
     */
    checkBrief(body?: OpenVcCheckBriefProductDto[] | undefined, cancelToken?: CancelToken): Promise<OpenVcCheckBriefProductDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/OCTOpenVCRules/CheckBrief";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckBrief(_response);
        });
    }

    protected processCheckBrief(response: AxiosResponse): Promise<OpenVcCheckBriefProductDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OpenVcCheckBriefProductDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OpenVcCheckBriefProductDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OpenVcCheckBriefProductDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getCheckRules( cancelToken?: CancelToken): Promise<OCTOpenVCRuleDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/OCTOpenVCRules/GetCheckRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCheckRules(_response);
        });
    }

    protected processGetCheckRules(response: AxiosResponse): Promise<OCTOpenVCRuleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OCTOpenVCRuleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OCTOpenVCRuleDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OCTOpenVCRuleDto[]>(null as any);
    }

    /**
     * @return OK
     */
    initAllRules( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/OCTOpenVCRules/InitAllRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitAllRules(_response);
        });
    }

    protected processInitAllRules(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 移除缓存,并在5秒后更新缓存
     * @return OK
     */
    removeCache( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/OCTOpenVCRules/RemoveCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveCache(_response);
        });
    }

    protected processRemoveCache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PmsDerivationValidatorServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 产品校验
     * @param body (optional) 
     * @return OK
     */
    productValidate(body?: LectoTypeProduct | undefined, cancelToken?: CancelToken): Promise<LectoTypeProduct> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/PmsDerivationValidator/ProductValidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProductValidate(_response);
        });
    }

    protected processProductValidate(response: AxiosResponse): Promise<LectoTypeProduct> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LectoTypeProduct.fromJS(resultData200);
            return Promise.resolve<LectoTypeProduct>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LectoTypeProduct>(null as any);
    }

    /**
     * 产品校验
     * @param lectoTypeId (optional) 
     * @param body (optional) 
     * @return OK
     */
    productsValidate(lectoTypeId?: string | undefined, body?: LectoTypeProduct[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/PmsDerivationValidator/ProductsValidate?";
        if (lectoTypeId === null)
            throw new globalThis.Error("The parameter 'lectoTypeId' cannot be null.");
        else if (lectoTypeId !== undefined)
            url_ += "lectoTypeId=" + encodeURIComponent("" + lectoTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProductsValidate(_response);
        });
    }

    protected processProductsValidate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * VC校验
     * @param body (optional) 
     * @return OK
     */
    productVCValidate(body?: LectoTypeProductVC | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/PmsDerivationValidator/ProductVCValidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProductVCValidate(_response);
        });
    }

    protected processProductVCValidate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    productVCsValidate(body?: LectoTypeProductVC[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/PmsDerivationValidator/ProductVCsValidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProductVCsValidate(_response);
        });
    }

    protected processProductVCsValidate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PreCalServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 申请preCal
     * @param body (optional) 
     * @return OK
     */
    applyPreCal(body?: ApplyPreCalInput | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/PreCal/ApplyPreCal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApplyPreCal(_response);
        });
    }

    protected processApplyPreCal(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 直接http调用PreCal
     * @param body (optional) 
     * @return OK
     */
    postPreCal(body?: PostInput | undefined, cancelToken?: CancelToken): Promise<PostOutput> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/PreCal/PostPreCal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostPreCal(_response);
        });
    }

    protected processPostPreCal(response: AxiosResponse): Promise<PostOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PostOutput.fromJS(resultData200);
            return Promise.resolve<PostOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostOutput>(null as any);
    }

    /**
     * preCal系统回调
     * @param body (optional) 
     * @return OK
     */
    callBack(body?: CallBackInput | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/PreCal/CallBack";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCallBack(_response);
        });
    }

    protected processCallBack(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 特殊VC
     * @param body (optional) 
     * @return OK
     */
    specialVCode(body?: SpecialVCodeInput | undefined, cancelToken?: CancelToken): Promise<PostOutput> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/PreCal/SpecialVCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSpecialVCode(_response);
        });
    }

    protected processSpecialVCode(response: AxiosResponse): Promise<PostOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PostOutput.fromJS(resultData200);
            return Promise.resolve<PostOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostOutput>(null as any);
    }

    /**
     * 合同评审号
     * @param body (optional) 
     * @return OK
     */
    contractReviewCost(body?: ContractReviewCostInput | undefined, cancelToken?: CancelToken): Promise<PostOutput> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/PreCal/ContractReviewCost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContractReviewCost(_response);
        });
    }

    protected processContractReviewCost(response: AxiosResponse): Promise<PostOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PostOutput.fromJS(resultData200);
            return Promise.resolve<PostOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostOutput>(null as any);
    }
}

export class SerialNoServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取流水号
     * @param sequenceType (optional) 流水号类型：默认：OrderNumber
     * @return OK
     */
    getSerialNo(sequenceType?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SerialNo/GetSerialNo?";
        if (sequenceType === null)
            throw new globalThis.Error("The parameter 'sequenceType' cannot be null.");
        else if (sequenceType !== undefined)
            url_ += "sequenceType=" + encodeURIComponent("" + sequenceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSerialNo(_response);
        });
    }

    protected processGetSerialNo(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 重置流水号
     * @param sequenceType (optional) 流水号类型：默认：OrderNumber
     * @return OK
     */
    resetSerialNo(sequenceType?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SerialNo/ResetSerialNo?";
        if (sequenceType === null)
            throw new globalThis.Error("The parameter 'sequenceType' cannot be null.");
        else if (sequenceType !== undefined)
            url_ += "sequenceType=" + encodeURIComponent("" + sequenceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetSerialNo(_response);
        });
    }

    protected processResetSerialNo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SingleVCNotificationRulesServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAll(body?: GetAllSingleVCNotificationRulesInput | undefined, cancelToken?: CancelToken): Promise<SingleVCNotificationRulesDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SingleVCNotificationRules/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<SingleVCNotificationRulesDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleVCNotificationRulesDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<SingleVCNotificationRulesDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleVCNotificationRulesDtoPagedResultDto>(null as any);
    }

    /**
     * 获取所有产品类型
     * @return OK
     */
    getAllProductType( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SingleVCNotificationRules/GetAllProductType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllProductType(_response);
        });
    }

    protected processGetAllProductType(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSingleVCNotificationRulesForEdit(id?: string | undefined, cancelToken?: CancelToken): Promise<GetSingleVCNotificationRulesForEditOutput> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SingleVCNotificationRules/GetSingleVCNotificationRulesForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSingleVCNotificationRulesForEdit(_response);
        });
    }

    protected processGetSingleVCNotificationRulesForEdit(response: AxiosResponse): Promise<GetSingleVCNotificationRulesForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSingleVCNotificationRulesForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetSingleVCNotificationRulesForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSingleVCNotificationRulesForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body?: CreateOrEditSingleVCNotificationRulesDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SingleVCNotificationRules/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrEdit(_response);
        });
    }

    protected processCreateOrEdit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 软删除
     * @param input (optional) 
     * @return OK
     */
    delete(input?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SingleVCNotificationRules/Delete?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            input && input.forEach(item => { url_ += "input=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 恢复
     * @param body (optional) 
     * @return OK
     */
    recover(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SingleVCNotificationRules/Recover";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecover(_response);
        });
    }

    protected processRecover(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 彻底删除
     * @param body (optional) 
     * @return OK
     */
    hardDelete(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SingleVCNotificationRules/HardDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHardDelete(_response);
        });
    }

    protected processHardDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入
     * @param formFiles (optional) 
     * @return OK
     */
    import(formFiles?: FileParameter[] | undefined, cancelToken?: CancelToken): Promise<ImportOutput> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SingleVCNotificationRules/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFiles === null || formFiles === undefined)
            throw new globalThis.Error("The parameter 'formFiles' cannot be null.");
        else
            formFiles.forEach(item_ => content_.append("formFiles", item_.data, item_.fileName ? item_.fileName : "formFiles") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<ImportOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportOutput.fromJS(resultData200);
            return Promise.resolve<ImportOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportOutput>(null as any);
    }

    /**
     * 导出
     * @param body (optional) 
     * @return OK
     */
    export(body?: GetAllSingleVCNotificationRulesInput | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SingleVCNotificationRules/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 单VC告知信息检查
     * @param body (optional) 
     * @return OK
     */
    check(body?: GetInventoryOutPutDto | undefined, cancelToken?: CancelToken): Promise<CheckResultOutput[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SingleVCNotificationRules/Check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheck(_response);
        });
    }

    protected processCheck(response: AxiosResponse): Promise<CheckResultOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckResultOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckResultOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckResultOutput[]>(null as any);
    }

    /**
     * @return OK
     */
    initAllRules( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SingleVCNotificationRules/InitAllRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitAllRules(_response);
        });
    }

    protected processInitAllRules(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 移除缓存,并在5秒后更新缓存
     * @return OK
     */
    removeCache( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SingleVCNotificationRules/RemoveCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveCache(_response);
        });
    }

    protected processRemoveCache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SpeciaVcServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取全部特殊VC
     * @param body (optional) 
     * @return OK
     */
    all(body?: string[] | undefined, cancelToken?: CancelToken): Promise<SpeciaVcDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SpeciaVc/All";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: AxiosResponse): Promise<SpeciaVcDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpeciaVcDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SpeciaVcDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpeciaVcDto[]>(null as any);
    }

    /**
     * 分页获取特殊VC
     * @param body (optional) 
     * @return OK
     */
    paged(body?: PagedSpeciaVcRequestDto | undefined, cancelToken?: CancelToken): Promise<SpeciaVcDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SpeciaVc/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaged(_response);
        });
    }

    protected processPaged(response: AxiosResponse): Promise<SpeciaVcDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SpeciaVcDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<SpeciaVcDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpeciaVcDtoPagedResultDto>(null as any);
    }

    /**
     * 获取特殊VC详情
     * @param speciaVcId (optional) 
     * @return OK
     */
    details(speciaVcId?: string | undefined, cancelToken?: CancelToken): Promise<SpeciaVcDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SpeciaVc/Details?";
        if (speciaVcId === null)
            throw new globalThis.Error("The parameter 'speciaVcId' cannot be null.");
        else if (speciaVcId !== undefined)
            url_ += "speciaVcId=" + encodeURIComponent("" + speciaVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<SpeciaVcDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SpeciaVcDto.fromJS(resultData200);
            return Promise.resolve<SpeciaVcDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpeciaVcDto>(null as any);
    }

    /**
     * 创建特殊VC
     * @param body (optional) 
     * @return OK
     */
    insert(body?: CreateSpeciaVcDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SpeciaVc/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新特殊VC
     * @param speciaVcId (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(speciaVcId?: string | undefined, body?: UpdateSpeciaVcDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SpeciaVc/Update?";
        if (speciaVcId === null)
            throw new globalThis.Error("The parameter 'speciaVcId' cannot be null.");
        else if (speciaVcId !== undefined)
            url_ += "speciaVcId=" + encodeURIComponent("" + speciaVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除特殊VC
     * @param speciaVcId (optional) 
     * @return OK
     */
    delete(speciaVcId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SpeciaVc/Delete?";
        if (speciaVcId === null)
            throw new globalThis.Error("The parameter 'speciaVcId' cannot be null.");
        else if (speciaVcId !== undefined)
            url_ += "speciaVcId=" + encodeURIComponent("" + speciaVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除特殊VC
     * @param body (optional) 
     * @return OK
     */
    deleteRange(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SpeciaVc/DeleteRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRange(_response);
        });
    }

    protected processDeleteRange(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新特殊VC下单次数
     * @param body (optional) 
     * @return OK
     */
    updatePlaceOrderCount(body?: UpdatePlaceOrderCountDto[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SpeciaVc/UpdatePlaceOrderCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePlaceOrderCount(_response);
        });
    }

    protected processUpdatePlaceOrderCount(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入特殊VC
     * @param excelFile (optional) 
     * @return OK
     */
    import(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SpeciaVc/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 固定编号-导入特殊VC
     * @param excelFile (optional) 
     * @return OK
     */
    fixedNumberImport(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SpeciaVc/FixedNumberImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFixedNumberImport(_response);
        });
    }

    protected processFixedNumberImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出特殊VC
     * @param body (optional) 
     * @return OK
     */
    exportStream(body?: PagedSpeciaVcRequestDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SpeciaVc/ExportStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportStream(_response);
        });
    }

    protected processExportStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SynchronizeSapBaseServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 分页获取基础信息
     * @param body (optional) 
     * @return OK
     */
    paged(body?: PagedSynchronizeSapBaseRequestDto | undefined, cancelToken?: CancelToken): Promise<SynchronizeSapBaseDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SynchronizeSapBase/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaged(_response);
        });
    }

    protected processPaged(response: AxiosResponse): Promise<SynchronizeSapBaseDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SynchronizeSapBaseDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<SynchronizeSapBaseDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SynchronizeSapBaseDtoPagedResultDto>(null as any);
    }

    /**
     * 获取同步记录
     * @param baseId (optional) 
     * @return OK
     */
    records(baseId?: string | undefined, cancelToken?: CancelToken): Promise<SynchronizeSapRecordDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SynchronizeSapBase/Records?";
        if (baseId === null)
            throw new globalThis.Error("The parameter 'baseId' cannot be null.");
        else if (baseId !== undefined)
            url_ += "baseId=" + encodeURIComponent("" + baseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecords(_response);
        });
    }

    protected processRecords(response: AxiosResponse): Promise<SynchronizeSapRecordDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SynchronizeSapRecordDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SynchronizeSapRecordDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SynchronizeSapRecordDto[]>(null as any);
    }
}

export class SynchronizeSapCycleServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 分页获取交期信息
     * @param body (optional) 
     * @return OK
     */
    paged(body?: PagedSynchronizeSapCycleRequestDto | undefined, cancelToken?: CancelToken): Promise<SynchronizeSapCycleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SynchronizeSapCycle/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaged(_response);
        });
    }

    protected processPaged(response: AxiosResponse): Promise<SynchronizeSapCycleDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SynchronizeSapCycleDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<SynchronizeSapCycleDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SynchronizeSapCycleDtoPagedResultDto>(null as any);
    }

    /**
     * 获取同步记录
     * @param cycleId (optional) 
     * @return OK
     */
    records(cycleId?: string | undefined, cancelToken?: CancelToken): Promise<SynchronizeSapRecordDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SynchronizeSapCycle/Records?";
        if (cycleId === null)
            throw new globalThis.Error("The parameter 'cycleId' cannot be null.");
        else if (cycleId !== undefined)
            url_ += "cycleId=" + encodeURIComponent("" + cycleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecords(_response);
        });
    }

    protected processRecords(response: AxiosResponse): Promise<SynchronizeSapRecordDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SynchronizeSapRecordDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SynchronizeSapRecordDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SynchronizeSapRecordDto[]>(null as any);
    }
}

export class SynchronizeSapRecordServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 推送基础信息至SAP
     * @return OK
     */
    synchronousVcBase( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SynchronizeSapRecord/SynchronousVcBase";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSynchronousVcBase(_response);
        });
    }

    protected processSynchronousVcBase(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 推送交期信息至SAP
     * @return OK
     */
    synchronousVcCycle( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SynchronizeSapRecord/SynchronousVcCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSynchronousVcCycle(_response);
        });
    }

    protected processSynchronousVcCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 启动VC基础信息对比服务，将新增、更新后的基础信息推送至SAP
     * @param body (optional) 
     * @return OK
     */
    synchronizeSapBaseChangeJob(body?: SynchronizeSapRecordDataType[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SynchronizeSapRecord/SynchronizeSapBaseChangeJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSynchronizeSapBaseChangeJob(_response);
        });
    }

    protected processSynchronizeSapBaseChangeJob(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 启动VC交期信息对比服务，将新增、更新后的基础信息推送至SAP
     * @param body (optional) 
     * @return OK
     */
    synchronizeSapCycleChangeJob(body?: SynchronizeSapRecordDataType[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/SynchronizeSapRecord/SynchronizeSapCycleChangeJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSynchronizeSapCycleChangeJob(_response);
        });
    }

    protected processSynchronizeSapCycleChangeJob(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TechinalCatalogueServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取技术协议目录
     * @return OK
     */
    all( cancelToken?: CancelToken): Promise<TechinalCatalogueDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechinalCatalogue/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: AxiosResponse): Promise<TechinalCatalogueDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TechinalCatalogueDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TechinalCatalogueDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TechinalCatalogueDto[]>(null as any);
    }

    /**
     * 分页获取技术协议目录
     * @param body (optional) 
     * @return OK
     */
    paged(body?: PagedTechinalCatalogueRequestDto | undefined, cancelToken?: CancelToken): Promise<TechinalCatalogueDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechinalCatalogue/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaged(_response);
        });
    }

    protected processPaged(response: AxiosResponse): Promise<TechinalCatalogueDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TechinalCatalogueDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<TechinalCatalogueDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TechinalCatalogueDtoPagedResultDto>(null as any);
    }

    /**
     * 获取技术协议目录详情
     * @param customVcId (optional) 
     * @return OK
     */
    details(customVcId?: string | undefined, cancelToken?: CancelToken): Promise<TechinalCatalogueDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechinalCatalogue/Details?";
        if (customVcId === null)
            throw new globalThis.Error("The parameter 'customVcId' cannot be null.");
        else if (customVcId !== undefined)
            url_ += "customVcId=" + encodeURIComponent("" + customVcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<TechinalCatalogueDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TechinalCatalogueDto.fromJS(resultData200);
            return Promise.resolve<TechinalCatalogueDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TechinalCatalogueDto>(null as any);
    }

    /**
     * 创建技术协议目录
     * @param body (optional) 
     * @return OK
     */
    insert(body?: CreateTechinalCatalogueDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechinalCatalogue/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 更新技术协议目录
     * @param catehoryId (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(catehoryId?: string | undefined, body?: UpdateTechinalCatalogueDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechinalCatalogue/Update?";
        if (catehoryId === null)
            throw new globalThis.Error("The parameter 'catehoryId' cannot be null.");
        else if (catehoryId !== undefined)
            url_ += "catehoryId=" + encodeURIComponent("" + catehoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除技术协议目录
     * @param catehoryId (optional) 
     * @return OK
     */
    delete(catehoryId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechinalCatalogue/Delete?";
        if (catehoryId === null)
            throw new globalThis.Error("The parameter 'catehoryId' cannot be null.");
        else if (catehoryId !== undefined)
            url_ += "catehoryId=" + encodeURIComponent("" + catehoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TechnicalAgreementServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 获取技术协议书
     * @return OK
     */
    all( cancelToken?: CancelToken): Promise<TechnicalAgreementDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnicalAgreement/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: AxiosResponse): Promise<TechnicalAgreementDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TechnicalAgreementDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TechnicalAgreementDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TechnicalAgreementDto[]>(null as any);
    }

    /**
     * 分页获取技术协议书
     * @param body (optional) 
     * @return OK
     */
    paged(body?: PagedTechnicalAgreementRequestDto | undefined, cancelToken?: CancelToken): Promise<TechnicalAgreementDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnicalAgreement/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaged(_response);
        });
    }

    protected processPaged(response: AxiosResponse): Promise<TechnicalAgreementDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TechnicalAgreementDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<TechnicalAgreementDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TechnicalAgreementDtoPagedResultDto>(null as any);
    }

    /**
     * 获取技术协议目录详情
     * @param technicalAgreementId (optional) 
     * @return OK
     */
    details(technicalAgreementId?: string | undefined, cancelToken?: CancelToken): Promise<TechnicalAgreementDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnicalAgreement/Details?";
        if (technicalAgreementId === null)
            throw new globalThis.Error("The parameter 'technicalAgreementId' cannot be null.");
        else if (technicalAgreementId !== undefined)
            url_ += "technicalAgreementId=" + encodeURIComponent("" + technicalAgreementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<TechnicalAgreementDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TechnicalAgreementDto.fromJS(resultData200);
            return Promise.resolve<TechnicalAgreementDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TechnicalAgreementDto>(null as any);
    }

    /**
     * 创建技术协议书
     * @param body (optional) 
     * @return OK
     */
    insert(body?: CreateTechnicalAgreementDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnicalAgreement/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新技术协议书
     * @param technicalAgreementId (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(technicalAgreementId?: string | undefined, body?: UpdateTechnicalAgreementDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnicalAgreement/Update?";
        if (technicalAgreementId === null)
            throw new globalThis.Error("The parameter 'technicalAgreementId' cannot be null.");
        else if (technicalAgreementId !== undefined)
            url_ += "technicalAgreementId=" + encodeURIComponent("" + technicalAgreementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除技术协议
     * @param technicalAgreementId (optional) 
     * @return OK
     */
    delete(technicalAgreementId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnicalAgreement/Delete?";
        if (technicalAgreementId === null)
            throw new globalThis.Error("The parameter 'technicalAgreementId' cannot be null.");
        else if (technicalAgreementId !== undefined)
            url_ += "technicalAgreementId=" + encodeURIComponent("" + technicalAgreementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量上传技术协议文件
     * @param formFile (optional) 
     * @return OK
     */
    initRange(formFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnicalAgreement/InitRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFile === null || formFile === undefined)
            throw new globalThis.Error("The parameter 'formFile' cannot be null.");
        else
            content_.append("formFile", formFile.data, formFile.fileName ? formFile.fileName : "formFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitRange(_response);
        });
    }

    protected processInitRange(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TechnologyQuotationServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 生成技术协议
     * @param body (optional) 
     * @return OK
     */
    createTe(body?: CreateTeDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/CreateTe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTe(_response);
        });
    }

    protected processCreateTe(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 更新技术协议
     * @param body (optional) 
     * @return OK
     */
    updateTe(body?: UpdateTeDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/UpdateTe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTe(_response);
        });
    }

    protected processUpdateTe(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 生成国产报价
     * @param body (optional) 
     * @return OK
     */
    createDq(body?: CreateDqDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/CreateDq";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDq(_response);
        });
    }

    protected processCreateDq(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 更新国产报价
     * @param body (optional) 
     * @return OK
     */
    updateDq(body?: UpdateDqDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/UpdateDq";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDq(_response);
        });
    }

    protected processUpdateDq(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 分页获取技术协议
     * @param body (optional) 
     * @return OK
     */
    getPageTechnology(body?: GetPageTechnologyAgreementInPutDto | undefined, cancelToken?: CancelToken): Promise<GetPageTechnologyAgreementOutPutDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/GetPageTechnology";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageTechnology(_response);
        });
    }

    protected processGetPageTechnology(response: AxiosResponse): Promise<GetPageTechnologyAgreementOutPutDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPageTechnologyAgreementOutPutDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<GetPageTechnologyAgreementOutPutDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPageTechnologyAgreementOutPutDtoPagedResultDto>(null as any);
    }

    /**
     * 分页获取国产报价
     * @param body (optional) 
     * @return OK
     */
    getPageQuotation(body?: GetPageDomesticQuotationInPutDto | undefined, cancelToken?: CancelToken): Promise<GetPageDomesticQuotationOutPutDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/GetPageQuotation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageQuotation(_response);
        });
    }

    protected processGetPageQuotation(response: AxiosResponse): Promise<GetPageDomesticQuotationOutPutDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPageDomesticQuotationOutPutDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<GetPageDomesticQuotationOutPutDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPageDomesticQuotationOutPutDtoPagedResultDto>(null as any);
    }

    /**
     * 获取技术协议详情
     * @param id (optional) 
     * @return OK
     */
    getTechnologyDetails(id?: string | undefined, cancelToken?: CancelToken): Promise<GetTechnologyAgreementDetailsOutPutDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/GetTechnologyDetails?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTechnologyDetails(_response);
        });
    }

    protected processGetTechnologyDetails(response: AxiosResponse): Promise<GetTechnologyAgreementDetailsOutPutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTechnologyAgreementDetailsOutPutDto.fromJS(resultData200);
            return Promise.resolve<GetTechnologyAgreementDetailsOutPutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTechnologyAgreementDetailsOutPutDto>(null as any);
    }

    /**
     * 获取国产报价详情
     * @param id (optional) 
     * @return OK
     */
    getDomesticQuotationDetails(id?: string | undefined, cancelToken?: CancelToken): Promise<GetDomesticQuotationDetailsOutPutDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/GetDomesticQuotationDetails?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDomesticQuotationDetails(_response);
        });
    }

    protected processGetDomesticQuotationDetails(response: AxiosResponse): Promise<GetDomesticQuotationDetailsOutPutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDomesticQuotationDetailsOutPutDto.fromJS(resultData200);
            return Promise.resolve<GetDomesticQuotationDetailsOutPutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDomesticQuotationDetailsOutPutDto>(null as any);
    }

    /**
     * 插入技术协议审批信息记录
     * @param body (optional) 
     * @return OK
     */
    createApproval(body?: CreateTechnologyQuotationApprovalInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/CreateApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateApproval(_response);
        });
    }

    protected processCreateApproval(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 插入国产报价审批信息记录
     * @param body (optional) 
     * @return OK
     */
    createDqApproval(body?: CreateTechnologyQuotationApprovalInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/CreateDqApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDqApproval(_response);
        });
    }

    protected processCreateDqApproval(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新pms
     * @param domesticQuotationNumber (optional) 
     * @return OK
     */
    updateCustomVCToPMS(domesticQuotationNumber?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/UpdateCustomVCToPMS?";
        if (domesticQuotationNumber === null)
            throw new globalThis.Error("The parameter 'domesticQuotationNumber' cannot be null.");
        else if (domesticQuotationNumber !== undefined)
            url_ += "domesticQuotationNumber=" + encodeURIComponent("" + domesticQuotationNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCustomVCToPMS(_response);
        });
    }

    protected processUpdateCustomVCToPMS(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param number (optional) 
     * @param type (optional) 
     * @return OK
     */
    disableTq(number?: string | undefined, type?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/DisableTq?";
        if (number === null)
            throw new globalThis.Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisableTq(_response);
        });
    }

    protected processDisableTq(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 撤回报价审核申请
     * @param quotationId (optional) 
     * @param body (optional) 
     * @return OK
     */
    withdrawDq(quotationId?: string | undefined, body?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/WithdrawDq?";
        if (quotationId === null)
            throw new globalThis.Error("The parameter 'quotationId' cannot be null.");
        else if (quotationId !== undefined)
            url_ += "quotationId=" + encodeURIComponent("" + quotationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWithdrawDq(_response);
        });
    }

    protected processWithdrawDq(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出国产报价
     * @param id (optional) 
     * @param motorOutputType (optional) 需要导出的类型 A,B,AB
     * @return OK
     */
    dqExport(id?: string | undefined, motorOutputType?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/DqExport?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (motorOutputType === null)
            throw new globalThis.Error("The parameter 'motorOutputType' cannot be null.");
        else if (motorOutputType !== undefined)
            url_ += "motorOutputType=" + encodeURIComponent("" + motorOutputType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDqExport(_response);
        });
    }

    protected processDqExport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导出技术协议
     * @param id (optional) 
     * @param motorOutputType (optional) 
     * @return OK
     */
    teExport(id?: string | undefined, motorOutputType?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/TeExport?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (motorOutputType === null)
            throw new globalThis.Error("The parameter 'motorOutputType' cannot be null.");
        else if (motorOutputType !== undefined)
            url_ += "motorOutputType=" + encodeURIComponent("" + motorOutputType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTeExport(_response);
        });
    }

    protected processTeExport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 1.从OCT中将以前的技术协议（已签订和已作废的）导入到新系统SC中
     * @param file (optional) 
     * @return OK
     */
    importTeByOCT(file?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/ImportTeByOCT";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportTeByOCT(_response);
        });
    }

    protected processImportTeByOCT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 2.从OCT中将以前的技术协议审批记录导入到新系统SC中
     * @param file (optional) 
     * @return OK
     */
    importTeApprovalByOCT(file?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/ImportTeApprovalByOCT";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportTeApprovalByOCT(_response);
        });
    }

    protected processImportTeApprovalByOCT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据excel将OCT以前的技术协议附件导入到SC中
     * @return OK
     */
    imPortTeAttach( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/ImPortTeAttach";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImPortTeAttach(_response);
        });
    }

    protected processImPortTeAttach(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param fileTxt (optional) 
     * @return OK
     */
    getFilesByTxt(fileTxt?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/GetFilesByTxt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileTxt === null || fileTxt === undefined)
            throw new globalThis.Error("The parameter 'fileTxt' cannot be null.");
        else
            content_.append("fileTxt", fileTxt.data, fileTxt.fileName ? fileTxt.fileName : "fileTxt");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilesByTxt(_response);
        });
    }

    protected processGetFilesByTxt(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    uploadAttch( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/UploadAttch";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadAttch(_response);
        });
    }

    protected processUploadAttch(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param fileTxt (optional) 
     * @return OK
     */
    setAttch(fileTxt?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/SetAttch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileTxt === null || fileTxt === undefined)
            throw new globalThis.Error("The parameter 'fileTxt' cannot be null.");
        else
            content_.append("fileTxt", fileTxt.data, fileTxt.fileName ? fileTxt.fileName : "fileTxt");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetAttch(_response);
        });
    }

    protected processSetAttch(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 重置标准VC更新后的交期
     * @return OK
     */
    resetStandardVcCycle( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/ResetStandardVcCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetStandardVcCycle(_response);
        });
    }

    protected processResetStandardVcCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 重置行业VC更新后的交期
     * @return OK
     */
    resetIndustryVcCycle( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/ResetIndustryVcCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetIndustryVcCycle(_response);
        });
    }

    protected processResetIndustryVcCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 重置国产报价非已完成状态的标准产品更新后的交期
     * @return OK
     */
    resetProductCycle( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/ResetProductCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetProductCycle(_response);
        });
    }

    protected processResetProductCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 重置国产报价标准产品所有状态更新后的交期
     * @return OK
     */
    resetAllProductCycle( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/ResetAllProductCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetAllProductCycle(_response);
        });
    }

    protected processResetAllProductCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 重置更新后的报价总计交期
     * @return OK
     */
    resetTeCycle( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/ResetTeCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetTeCycle(_response);
        });
    }

    protected processResetTeCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 重置所有状态更新后的报价总计交期
     * @return OK
     */
    resetAllTeCycle( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/ResetAllTeCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetAllTeCycle(_response);
        });
    }

    protected processResetAllTeCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 刷新报价中自定义电机交期
     * @return OK
     */
    resetCustomProductsCycle( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/ResetCustomProductsCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetCustomProductsCycle(_response);
        });
    }

    protected processResetCustomProductsCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 刷新报价中自定义VC交期
     * @return OK
     */
    resetCustomVcCycle( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/ResetCustomVcCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetCustomVcCycle(_response);
        });
    }

    protected processResetCustomVcCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出自定义VC数据初始化前后差异对照
     * @return OK
     */
    exportInitDataVariation( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/ExportInitDataVariation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportInitDataVariation(_response);
        });
    }

    protected processExportInitDataVariation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 重置Open Vc显示方式
     * @return OK
     */
    resetVcShowType( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/ResetVcShowType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetVcShowType(_response);
        });
    }

    protected processResetVcShowType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 检查GSS报价号有效性
     * @param domesticQuotationNumber (optional) 
     * @return OK
     */
    checkValid(domesticQuotationNumber?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/CheckValid?";
        if (domesticQuotationNumber === null)
            throw new globalThis.Error("The parameter 'domesticQuotationNumber' cannot be null.");
        else if (domesticQuotationNumber !== undefined)
            url_ += "domesticQuotationNumber=" + encodeURIComponent("" + domesticQuotationNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckValid(_response);
        });
    }

    protected processCheckValid(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 变更协议产品中的VC备注信息
     * @param body (optional) 
     * @return OK
     */
    changeTeVcReamrk(body?: ChangeTeVcReamrkProductDto | undefined, cancelToken?: CancelToken): Promise<ChangeTeVcReamrkProductDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/ChangeTeVcReamrk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeTeVcReamrk(_response);
        });
    }

    protected processChangeTeVcReamrk(response: AxiosResponse): Promise<ChangeTeVcReamrkProductDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangeTeVcReamrkProductDto.fromJS(resultData200);
            return Promise.resolve<ChangeTeVcReamrkProductDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeTeVcReamrkProductDto>(null as any);
    }

    /**
     * 更新国产报价产品(面价选型过来的)
     * @param body (optional) 
     * @return OK
     */
    updateProductInfoFromLP(body?: UpdateProductFromLPInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/TechnologyQuotation/UpdateProductInfoFromLP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProductInfoFromLP(_response);
        });
    }

    protected processUpdateProductInfoFromLP(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class VCCheckAllRulesServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 检查清单,检查不通过时中断检查
     * @param body (optional) 
     * @return OK
     */
    checkBreakIfError(body?: GetInventoryOutPutDto | undefined, cancelToken?: CancelToken): Promise<CheckResultOutput> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VCCheckAllRules/CheckBreakIfError";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckBreakIfError(_response);
        });
    }

    protected processCheckBreakIfError(response: AxiosResponse): Promise<CheckResultOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckResultOutput.fromJS(resultData200);
            return Promise.resolve<CheckResultOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckResultOutput>(null as any);
    }

    /**
     * 检查清单,得到所有的规则检查
     * @param body (optional) 
     * @return OK
     */
    check(body?: GetInventoryOutPutDto | undefined, cancelToken?: CancelToken): Promise<CheckResultOutput[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VCCheckAllRules/Check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheck(_response);
        });
    }

    protected processCheck(response: AxiosResponse): Promise<CheckResultOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckResultOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckResultOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckResultOutput[]>(null as any);
    }

    /**
     * @return OK
     */
    initAllRules( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VCCheckAllRules/InitAllRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitAllRules(_response);
        });
    }

    protected processInitAllRules(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class VCGroupRulesServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAll(body?: GetAllVCGroupRulesInput | undefined, cancelToken?: CancelToken): Promise<VCGroupRulesDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VCGroupRules/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<VCGroupRulesDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VCGroupRulesDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<VCGroupRulesDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VCGroupRulesDtoPagedResultDto>(null as any);
    }

    /**
     * 获取所有产品类型
     * @return OK
     */
    getAllProductType( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VCGroupRules/GetAllProductType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllProductType(_response);
        });
    }

    protected processGetAllProductType(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getVCGroupRulesForEdit(id?: string | undefined, cancelToken?: CancelToken): Promise<VCGroupRulesDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VCGroupRules/GetVCGroupRulesForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVCGroupRulesForEdit(_response);
        });
    }

    protected processGetVCGroupRulesForEdit(response: AxiosResponse): Promise<VCGroupRulesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VCGroupRulesDto.fromJS(resultData200);
            return Promise.resolve<VCGroupRulesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VCGroupRulesDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body?: CreateOrEditVCGroupRulesDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VCGroupRules/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrEdit(_response);
        });
    }

    protected processCreateOrEdit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 软删除
     * @param input (optional) 
     * @return OK
     */
    delete(input?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VCGroupRules/Delete?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            input && input.forEach(item => { url_ += "input=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 恢复
     * @param body (optional) 
     * @return OK
     */
    recover(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VCGroupRules/Recover";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecover(_response);
        });
    }

    protected processRecover(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 彻底删除
     * @param body (optional) 
     * @return OK
     */
    hardDelete(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VCGroupRules/HardDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHardDelete(_response);
        });
    }

    protected processHardDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入
     * @param formFiles (optional) 
     * @return OK
     */
    import(formFiles?: FileParameter[] | undefined, cancelToken?: CancelToken): Promise<ImportOutput> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VCGroupRules/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFiles === null || formFiles === undefined)
            throw new globalThis.Error("The parameter 'formFiles' cannot be null.");
        else
            formFiles.forEach(item_ => content_.append("formFiles", item_.data, item_.fileName ? item_.fileName : "formFiles") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<ImportOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportOutput.fromJS(resultData200);
            return Promise.resolve<ImportOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportOutput>(null as any);
    }

    /**
     * 导出
     * @param body (optional) 
     * @return OK
     */
    export(body?: GetAllVCGroupRulesInput | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VCGroupRules/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * VC规则组检查,没有vc也要检查
     * @param body (optional) 
     * @return OK
     */
    check(body?: GetInventoryOutPutDto | undefined, cancelToken?: CancelToken): Promise<CheckResultOutput[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VCGroupRules/Check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheck(_response);
        });
    }

    protected processCheck(response: AxiosResponse): Promise<CheckResultOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckResultOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckResultOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckResultOutput[]>(null as any);
    }

    /**
     * @return OK
     */
    initAllRules( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VCGroupRules/InitAllRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitAllRules(_response);
        });
    }

    protected processInitAllRules(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 移除缓存,并在5秒后更新缓存
     * @return OK
     */
    removeCache( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VCGroupRules/RemoveCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveCache(_response);
        });
    }

    protected processRemoveCache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class VCIDExistValidatorServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * VCID已存在验证
     * @param vcID (optional) 
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    vCIDEsxistCheck(vcID?: string | undefined, id?: string | undefined, body?: VcType | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VCIDExistValidator/VCIDEsxistCheck?";
        if (vcID === null)
            throw new globalThis.Error("The parameter 'vcID' cannot be null.");
        else if (vcID !== undefined)
            url_ += "VcID=" + encodeURIComponent("" + vcID) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVCIDEsxistCheck(_response);
        });
    }

    protected processVCIDEsxistCheck(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class VcInfoServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPageVsInfos(body?: PageVsInfoInputDto | undefined, cancelToken?: CancelToken): Promise<VcInfoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/GetPageVsInfos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageVsInfos(_response);
        });
    }

    protected processGetPageVsInfos(response: AxiosResponse): Promise<VcInfoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VcInfoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<VcInfoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VcInfoPagedResultDto>(null as any);
    }

    /**
     * 分页查询
     * @param body (optional) 
     * @return OK
     */
    getNewPageVsInfos(body?: PageCheckRuleInputDto | undefined, cancelToken?: CancelToken): Promise<PageVcInfoOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/GetNewPageVsInfos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewPageVsInfos(_response);
        });
    }

    protected processGetNewPageVsInfos(response: AxiosResponse): Promise<PageVcInfoOutputDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageVcInfoOutputDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<PageVcInfoOutputDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageVcInfoOutputDtoPagedResultDto>(null as any);
    }

    /**
     * 分页查询VC校验规则
     * @param body (optional) 
     * @return OK
     */
    getPageVcCheckRules(body?: PageCheckRuleInputDto | undefined, cancelToken?: CancelToken): Promise<PageCheckVcRulesOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/GetPageVcCheckRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageVcCheckRules(_response);
        });
    }

    protected processGetPageVcCheckRules(response: AxiosResponse): Promise<PageCheckVcRulesOutputDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageCheckVcRulesOutputDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<PageCheckVcRulesOutputDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageCheckVcRulesOutputDtoPagedResultDto>(null as any);
    }

    /**
     * 更新同步VC确认状态
     * @param body (optional) 
     * @return OK
     */
    updateVCCheckRuleConfirmStatus(body?: UpdateVCCheckRuleConfirmStatusInputDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/UpdateVCCheckRuleConfirmStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateVCCheckRuleConfirmStatus(_response);
        });
    }

    protected processUpdateVCCheckRuleConfirmStatus(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 添加/修改
     * @param body (optional) 
     * @return OK
     */
    createOrUpdate(body?: AddVcInfoDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @param body (optional) 
     * @return OK
     */
    delete(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除Vc基础属性
     * @param body (optional) 
     * @return OK
     */
    deleteAll(body?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/DeleteAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取vc详情
     * @param id (optional) 
     * @return OK
     */
    getVcInfoDetail(id?: string | undefined, cancelToken?: CancelToken): Promise<GetVCInfoDetailDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/GetVcInfoDetail?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVcInfoDetail(_response);
        });
    }

    protected processGetVcInfoDetail(response: AxiosResponse): Promise<GetVCInfoDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetVCInfoDetailDto.fromJS(resultData200);
            return Promise.resolve<GetVCInfoDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetVCInfoDetailDto>(null as any);
    }

    /**
     * 导入VC基础信息
     * @param excelFile (optional) 
     * @return OK
     */
    dataImport(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/DataImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDataImport(_response);
        });
    }

    protected processDataImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加/修改
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateCheckRules(body?: CheckRuleDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/CreateOrUpdateCheckRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateCheckRules(_response);
        });
    }

    protected processCreateOrUpdateCheckRules(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取规则详情
     * @param id (optional) 
     * @return OK
     */
    getCheckRuleDetail(id?: string | undefined, cancelToken?: CancelToken): Promise<GetCheckRuleDetailDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/GetCheckRuleDetail?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCheckRuleDetail(_response);
        });
    }

    protected processGetCheckRuleDetail(response: AxiosResponse): Promise<GetCheckRuleDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCheckRuleDetailDto.fromJS(resultData200);
            return Promise.resolve<GetCheckRuleDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCheckRuleDetailDto>(null as any);
    }

    /**
     * 更新CheckVCRule表
     * @param file (optional) 导入文件
     * @return OK
     */
    updateCheckVCRule(file?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/UpdateCheckVCRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCheckVCRule(_response);
        });
    }

    protected processUpdateCheckVCRule(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除VC属性
     * @param body (optional) Vc编号
     * @return OK
     */
    deleteCheckRule(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/DeleteCheckRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCheckRule(_response);
        });
    }

    protected processDeleteCheckRule(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除VC属性
     * @param body (optional) 
     * @return OK
     */
    deleteCheckRuleAll(body?: PageCheckRuleInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/DeleteCheckRuleAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCheckRuleAll(_response);
        });
    }

    protected processDeleteCheckRuleAll(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出系列下的VC交期信息
     * @param body (optional) 
     * @return OK
     */
    exportCheckVcRulesStream(body?: PageCheckRuleInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/ExportCheckVcRulesStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCheckVcRulesStream(_response);
        });
    }

    protected processExportCheckVcRulesStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出系列下的VC
     * @param body (optional) 
     * @return OK
     */
    exportVcInfoStream(body?: PageCheckRuleInputDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/ExportVcInfoStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportVcInfoStream(_response);
        });
    }

    protected processExportVcInfoStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @param body (optional) 
     * @return OK
     */
    deleteCheckRules(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/DeleteCheckRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCheckRules(_response);
        });
    }

    protected processDeleteCheckRules(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除Vc基础属性
     * @param body (optional) 
     * @return OK
     */
    deleteAllCheckRules(body?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/DeleteAllCheckRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAllCheckRules(_response);
        });
    }

    protected processDeleteAllCheckRules(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取VC下拉框
     * @return OK
     */
    getVCSelect( cancelToken?: CancelToken): Promise<GetVCIDSelectDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/GetVCSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVCSelect(_response);
        });
    }

    protected processGetVCSelect(response: AxiosResponse): Promise<GetVCIDSelectDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetVCIDSelectDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetVCIDSelectDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetVCIDSelectDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPageVCCyele(body?: PageVCCycleOutputDtoInputDto | undefined, cancelToken?: CancelToken): Promise<GetPageVCCycleOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/GetPageVCCyele";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageVCCyele(_response);
        });
    }

    protected processGetPageVCCyele(response: AxiosResponse): Promise<GetPageVCCycleOutputDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPageVCCycleOutputDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<GetPageVCCycleOutputDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPageVCCycleOutputDtoPagedResultDto>(null as any);
    }

    /**
     * 交期详情获取
     * @param id (optional) 
     * @param vcType (optional) 0 = Standard (标准)

    1 = Custom (自定义)

    2 = Industry (行业VC)

    4 = Import (进口电机配置VC)

    5 = ExportOrder (特殊Vc)

    -1 = None (编号缺失)
     * @return OK
     */
    getVCCycleDetail(id?: string | undefined, vcType?: VcType | undefined, cancelToken?: CancelToken): Promise<GetVCCycleDetailDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/GetVCCycleDetail?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (vcType === null)
            throw new globalThis.Error("The parameter 'vcType' cannot be null.");
        else if (vcType !== undefined)
            url_ += "vcType=" + encodeURIComponent("" + vcType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVCCycleDetail(_response);
        });
    }

    protected processGetVCCycleDetail(response: AxiosResponse): Promise<GetVCCycleDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetVCCycleDetailDto.fromJS(resultData200);
            return Promise.resolve<GetVCCycleDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetVCCycleDetailDto>(null as any);
    }

    /**
     * 更新交期信息
     * @param body (optional) 
     * @return OK
     */
    updateCycle(body?: VCCycleEditDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/UpdateCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCycle(_response);
        });
    }

    protected processUpdateCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量更新
     * @param body (optional) 
     * @return OK
     */
    batchUpdateCycle(body?: VCCycleEditDto[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/BatchUpdateCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchUpdateCycle(_response);
        });
    }

    protected processBatchUpdateCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 交期确认
     * @param body (optional) 
     * @return OK
     */
    confirmCycle(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/ConfirmCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmCycle(_response);
        });
    }

    protected processConfirmCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 交期导出
     * @param body (optional) 
     * @return OK
     */
    exportVCCycle(body?: PageVCCycleOutputDtoInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/ExportVCCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportVCCycle(_response);
        });
    }

    protected processExportVCCycle(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 导入VC基础信息
     * @param excelFile (optional) 
     * @return OK
     */
    vcCycleImport(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/VcCycleImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVcCycleImport(_response);
        });
    }

    protected processVcCycleImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取VCID和根据VCId对应的系列和机座号
     * @return OK
     */
    getVCIDBasicMotorSriesFrameNo( cancelToken?: CancelToken): Promise<GetVCIDSelectDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/GetVCIDBasicMotorSriesFrameNo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVCIDBasicMotorSriesFrameNo(_response);
        });
    }

    protected processGetVCIDBasicMotorSriesFrameNo(response: AxiosResponse): Promise<GetVCIDSelectDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetVCIDSelectDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetVCIDSelectDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetVCIDSelectDto[]>(null as any);
    }

    /**
     * 根据vcID、机座号、系列获取标准VC的交期数据
     * @param vcID (optional) 
     * @param frameNo (optional) 
     * @param basicMotorSries (optional) 
     * @return OK
     */
    getStandardCycle(vcID?: string | undefined, frameNo?: number | undefined, basicMotorSries?: string | undefined, cancelToken?: CancelToken): Promise<GetVCCycleDetailDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/GetStandardCycle?";
        if (vcID === null)
            throw new globalThis.Error("The parameter 'vcID' cannot be null.");
        else if (vcID !== undefined)
            url_ += "vcID=" + encodeURIComponent("" + vcID) + "&";
        if (frameNo === null)
            throw new globalThis.Error("The parameter 'frameNo' cannot be null.");
        else if (frameNo !== undefined)
            url_ += "frameNo=" + encodeURIComponent("" + frameNo) + "&";
        if (basicMotorSries === null)
            throw new globalThis.Error("The parameter 'basicMotorSries' cannot be null.");
        else if (basicMotorSries !== undefined)
            url_ += "basicMotorSries=" + encodeURIComponent("" + basicMotorSries) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStandardCycle(_response);
        });
    }

    protected processGetStandardCycle(response: AxiosResponse): Promise<GetVCCycleDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetVCCycleDetailDto.fromJS(resultData200);
            return Promise.resolve<GetVCCycleDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetVCCycleDetailDto>(null as any);
    }

    /**
     * 根据品类含义获取VC编号
     * @param body (optional) 
     * @return OK
     */
    getVcCodeByMeaning(body?: string[] | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/GetVcCodeByMeaning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVcCodeByMeaning(_response);
        });
    }

    protected processGetVcCodeByMeaning(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 通过vcCode获取各种VC基本信息
     * @param vcCodes (optional) 要查询的vcCoode
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getAllKindVCInfo(vcCodes?: string[] | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined, filter?: string | undefined, cancelToken?: CancelToken): Promise<PageAllKindVCInfoOutDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/GetAllKindVCInfo?";
        if (vcCodes === null)
            throw new globalThis.Error("The parameter 'vcCodes' cannot be null.");
        else if (vcCodes !== undefined)
            vcCodes && vcCodes.forEach(item => { url_ += "VcCodes=" + encodeURIComponent("" + item) + "&"; });
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllKindVCInfo(_response);
        });
    }

    protected processGetAllKindVCInfo(response: AxiosResponse): Promise<PageAllKindVCInfoOutDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageAllKindVCInfoOutDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<PageAllKindVCInfoOutDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageAllKindVCInfoOutDtoPagedResultDto>(null as any);
    }

    /**
     * 获取vc完整信息（特殊vc、行业vc、自定义vc、标准vc）
     * @param vcCodes (optional) vcCode
     * @param motorCodes (optional) 涉及主机号
     * @param basicMotorSries (optional) 涉及产品系列
     * @param frameNos (optional) 涉及机座号
     * @return OK
     */
    getAllKindVCCompleteInfo(vcCodes?: string[] | undefined, motorCodes?: string[] | undefined, basicMotorSries?: string[] | undefined, frameNos?: number[] | undefined, cancelToken?: CancelToken): Promise<AllKindVCCompleteInfoOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcInfo/GetAllKindVCCompleteInfo?";
        if (vcCodes === null)
            throw new globalThis.Error("The parameter 'vcCodes' cannot be null.");
        else if (vcCodes !== undefined)
            vcCodes && vcCodes.forEach(item => { url_ += "VcCodes=" + encodeURIComponent("" + item) + "&"; });
        if (motorCodes === null)
            throw new globalThis.Error("The parameter 'motorCodes' cannot be null.");
        else if (motorCodes !== undefined)
            motorCodes && motorCodes.forEach(item => { url_ += "MotorCodes=" + encodeURIComponent("" + item) + "&"; });
        if (basicMotorSries === null)
            throw new globalThis.Error("The parameter 'basicMotorSries' cannot be null.");
        else if (basicMotorSries !== undefined)
            basicMotorSries && basicMotorSries.forEach(item => { url_ += "BasicMotorSries=" + encodeURIComponent("" + item) + "&"; });
        if (frameNos === null)
            throw new globalThis.Error("The parameter 'frameNos' cannot be null.");
        else if (frameNos !== undefined)
            frameNos && frameNos.forEach(item => { url_ += "FrameNos=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllKindVCCompleteInfo(_response);
        });
    }

    protected processGetAllKindVCCompleteInfo(response: AxiosResponse): Promise<AllKindVCCompleteInfoOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AllKindVCCompleteInfoOutputDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AllKindVCCompleteInfoOutputDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AllKindVCCompleteInfoOutputDto[]>(null as any);
    }
}

export class VcLongShortCodeMappingServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 分页获取Vc长短代码映射
     * @param body (optional) 
     * @return OK
     */
    paged(body?: PagedVcLongShortCodeMappingRequestDto | undefined, cancelToken?: CancelToken): Promise<VcLongShortCodeMappingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcLongShortCodeMapping/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaged(_response);
        });
    }

    protected processPaged(response: AxiosResponse): Promise<VcLongShortCodeMappingDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VcLongShortCodeMappingDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<VcLongShortCodeMappingDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VcLongShortCodeMappingDtoPagedResultDto>(null as any);
    }

    /**
     * 分页获取Vc长短代码映射
     * @param body (optional) 
     * @return OK
     */
    query(body?: string[] | undefined, cancelToken?: CancelToken): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcLongShortCodeMapping/Query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<{ [key: string]: string; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * 根据ID获取Vc长短代码映射详情
     * @param id (optional) 
     * @return OK
     */
    getById(id?: string | undefined, cancelToken?: CancelToken): Promise<VcLongShortCodeMappingDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcLongShortCodeMapping/GetById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<VcLongShortCodeMappingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VcLongShortCodeMappingDto.fromJS(resultData200);
            return Promise.resolve<VcLongShortCodeMappingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VcLongShortCodeMappingDto>(null as any);
    }

    /**
     * 获取VC列表（用于下拉选择）- 只返回7位短代码
     * @param keyword (optional) 
     * @return OK
     */
    getVcOptions(keyword?: string | undefined, cancelToken?: CancelToken): Promise<VcOptionDto[]> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcLongShortCodeMapping/GetVcOptions?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVcOptions(_response);
        });
    }

    protected processGetVcOptions(response: AxiosResponse): Promise<VcOptionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VcOptionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<VcOptionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VcOptionDto[]>(null as any);
    }

    /**
     * 添加或更新Vc长短代码映射
     * @param body (optional) 
     * @return OK
     */
    createOrUpdate(body?: CreateOrUpdateVcLongShortCodeMappingDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcLongShortCodeMapping/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除Vc长短代码映射
     * @param mappingId (optional) 
     * @return OK
     */
    delete(mappingId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcLongShortCodeMapping/Delete?";
        if (mappingId === null)
            throw new globalThis.Error("The parameter 'mappingId' cannot be null.");
        else if (mappingId !== undefined)
            url_ += "mappingId=" + encodeURIComponent("" + mappingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除Vc长短代码映射
     * @return OK
     */
    deleteAll( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcLongShortCodeMapping/DeleteAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入Vc长短代码映射
     * @param excelFile (optional) 
     * @return OK
     */
    import(excelFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcLongShortCodeMapping/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出Vc长短代码映射
     * @param body (optional) 
     * @return OK
     */
    exportStream(body?: PagedVcLongShortCodeMappingRequestDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcLongShortCodeMapping/ExportStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportStream(_response);
        });
    }

    protected processExportStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class VcReportServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 主计划排查表
     * @param body (optional) 
     * @return OK
     */
    getPageMainPlanReport(body?: GetPageMainPlanReportInputDto | undefined, cancelToken?: CancelToken): Promise<GetPageMainPlanReportDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcReport/GetPageMainPlanReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageMainPlanReport(_response);
        });
    }

    protected processGetPageMainPlanReport(response: AxiosResponse): Promise<GetPageMainPlanReportDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPageMainPlanReportDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<GetPageMainPlanReportDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPageMainPlanReportDtoPagedResultDto>(null as any);
    }

    /**
     * 导出主计划排查表
     * @param body (optional) 
     * @return OK
     */
    exportPageMainPlanReport(body?: GetPageMainPlanReportInputDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcReport/ExportPageMainPlanReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportPageMainPlanReport(_response);
        });
    }

    protected processExportPageMainPlanReport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    excuteDailyChangeNotification( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcReport/ExcuteDailyChangeNotification";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExcuteDailyChangeNotification(_response);
        });
    }

    protected processExcuteDailyChangeNotification(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取叠加改取值表
     * @param body (optional) 
     * @return OK
     */
    getPagSuperimposedChangeValueReports(body?: GetPageSuperimposedChangeValueInput | undefined, cancelToken?: CancelToken): Promise<GetPageSuperimposedChangeValueDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcReport/GetPagSuperimposedChangeValueReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagSuperimposedChangeValueReports(_response);
        });
    }

    protected processGetPagSuperimposedChangeValueReports(response: AxiosResponse): Promise<GetPageSuperimposedChangeValueDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPageSuperimposedChangeValueDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<GetPageSuperimposedChangeValueDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPageSuperimposedChangeValueDtoPagedResultDto>(null as any);
    }

    /**
     * 批量删除叠加改取值表内容
     * @param body (optional) 
     * @return OK
     */
    batchDelete(body?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcReport/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出叠加改取值表
     * @param body (optional) 
     * @return OK
     */
    exportPagSuperimposedChangeValueReport(body?: GetPageSuperimposedChangeValueInput | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcReport/ExportPagSuperimposedChangeValueReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportPagSuperimposedChangeValueReport(_response);
        });
    }

    protected processExportPagSuperimposedChangeValueReport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 创建或更新数据
     * @param body (optional) 
     * @return OK
     */
    createOrUpdatePagSuperimposedChangeValueReport(body?: CreateOrUpdateSuperimposedChangeValueReportsDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/SmartConfigurator/VcReport/CreateOrUpdatePagSuperimposedChangeValueReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdatePagSuperimposedChangeValueReport(_response);
        });
    }

    protected processCreateOrUpdatePagSuperimposedChangeValueReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ApplicationServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * Submit or Save a Service Request
    TODO move to ProcessInstanceAppService->Post(bool draft)
    this method create a process instance and start it
     * @param submit (optional) True - Submit the service request. False - Save the service request only
     * @param body (optional) 
     * @return OK
     */
    create(submit?: boolean | undefined, body?: CreateServiceRequestInput | undefined, cancelToken?: CancelToken): Promise<CreateServiceRequestOutput> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Application/Create?";
        if (submit === null)
            throw new globalThis.Error("The parameter 'submit' cannot be null.");
        else if (submit !== undefined)
            url_ += "submit=" + encodeURIComponent("" + submit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreateServiceRequestOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateServiceRequestOutput.fromJS(resultData200);
            return Promise.resolve<CreateServiceRequestOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateServiceRequestOutput>(null as any);
    }

    /**
     * 获取服务申请的详情
    TODO move to ProcessInstanceAppService->Get(string processInstanceId)
     * @param serviceRequestId 服务申请单详情
     * @param filterData (optional) 是否过滤数据。过滤有_select扩展的数据
     * @return OK
     */
    detailInfo(serviceRequestId: string, filterData?: boolean | undefined, cancelToken?: CancelToken): Promise<ServiceRequestDetailOutput> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Application/DetailInfo?";
        if (serviceRequestId === undefined || serviceRequestId === null)
            throw new globalThis.Error("The parameter 'serviceRequestId' must be defined and cannot be null.");
        else
            url_ += "serviceRequestId=" + encodeURIComponent("" + serviceRequestId) + "&";
        if (filterData === null)
            throw new globalThis.Error("The parameter 'filterData' cannot be null.");
        else if (filterData !== undefined)
            url_ += "filterData=" + encodeURIComponent("" + filterData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailInfo(_response);
        });
    }

    protected processDetailInfo(response: AxiosResponse): Promise<ServiceRequestDetailOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestDetailOutput.fromJS(resultData200);
            return Promise.resolve<ServiceRequestDetailOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestDetailOutput>(null as any);
    }

    /**
     * 获取工单的处理结果字段
    TODO merge into ProcessInstanceAppService->Get(string processInstanceId)
     * @param processInstanceId (optional) 
     * @return OK
     */
    getProcessResult(processInstanceId?: string | undefined, cancelToken?: CancelToken): Promise<any[]> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Application/GetProcessResult?";
        if (processInstanceId === null)
            throw new globalThis.Error("The parameter 'processInstanceId' cannot be null.");
        else if (processInstanceId !== undefined)
            url_ += "processInstanceId=" + encodeURIComponent("" + processInstanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProcessResult(_response);
        });
    }

    protected processGetProcessResult(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }

    /**
     * 绑定返回结果字段的Schema
    TODO merge into ProcessInstanceAppService->Get(string processInstanceId) as this method works together with method above
     * @param body (optional) 
     * @return OK
     */
    bindResultPropertySchema(body?: any[] | undefined, cancelToken?: CancelToken): Promise<any[]> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Application/BindResultPropertySchema";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBindResultPropertySchema(_response);
        });
    }

    protected processBindResultPropertySchema(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }

    /**
     * 取消未提交的服务申请
    TODO move to ProcessInstanceAppService->Delete(string processInstanceId)
    check the status before delete
     * @return OK
     */
    cancel(serviceRequestId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Application/Cancel?";
        if (serviceRequestId === undefined || serviceRequestId === null)
            throw new globalThis.Error("The parameter 'serviceRequestId' must be defined and cannot be null.");
        else
            url_ += "serviceRequestId=" + encodeURIComponent("" + serviceRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancel(_response);
        });
    }

    protected processCancel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 查询个人的服务申请列表(分页).  状态含义(Status): 0 - 未提交, 1 - 已提交, 2 - 处理中, 3 - 已解决(待评价), 4 - 已关闭(已评价)
    TODO move to ProcessInstanceAppService->Get()
     * @param keyword (optional) 模糊搜索
     * @param pageIndex (optional) 当前页
     * @param pageSize (optional) 分页大小
     * @param serviceTypeId (optional) 服务单类型id。(如：other_service)
     * @param status (optional) 工单状态，仅在非关闭工单状态才可以用
     * @param closed (optional) 显示关闭和非关闭的服务申请
     * @param onlyToDo (optional) 只显示待办数据/全部服务申请
     * @return OK
     */
    myRequests(keyword?: string | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, serviceTypeId?: string | undefined, status?: ServiceRequestStatusEnum | undefined, closed?: boolean | undefined, onlyToDo?: boolean | undefined, cancelToken?: CancelToken): Promise<ServiceRequestListPageOutput> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Application/MyRequests?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (serviceTypeId === null)
            throw new globalThis.Error("The parameter 'serviceTypeId' cannot be null.");
        else if (serviceTypeId !== undefined)
            url_ += "serviceTypeId=" + encodeURIComponent("" + serviceTypeId) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (closed === null)
            throw new globalThis.Error("The parameter 'closed' cannot be null.");
        else if (closed !== undefined)
            url_ += "closed=" + encodeURIComponent("" + closed) + "&";
        if (onlyToDo === null)
            throw new globalThis.Error("The parameter 'onlyToDo' cannot be null.");
        else if (onlyToDo !== undefined)
            url_ += "onlyToDo=" + encodeURIComponent("" + onlyToDo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMyRequests(_response);
        });
    }

    protected processMyRequests(response: AxiosResponse): Promise<ServiceRequestListPageOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestListPageOutput.fromJS(resultData200);
            return Promise.resolve<ServiceRequestListPageOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestListPageOutput>(null as any);
    }

    /**
     * 获取流程中的激活的Activity ，并返回BPMN
    TODO merge into ProcessInstanceAppService->Get(string id)
     * @param processInstanceId (optional) 
     * @return OK
     */
    getActivityInstanceWithBPMN(processInstanceId?: string | undefined, cancelToken?: CancelToken): Promise<ActivityInstanceWithBPMN> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Application/GetActivityInstanceWithBPMN?";
        if (processInstanceId === null)
            throw new globalThis.Error("The parameter 'processInstanceId' cannot be null.");
        else if (processInstanceId !== undefined)
            url_ += "processInstanceId=" + encodeURIComponent("" + processInstanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityInstanceWithBPMN(_response);
        });
    }

    protected processGetActivityInstanceWithBPMN(response: AxiosResponse): Promise<ActivityInstanceWithBPMN> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActivityInstanceWithBPMN.fromJS(resultData200);
            return Promise.resolve<ActivityInstanceWithBPMN>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityInstanceWithBPMN>(null as any);
    }

    /**
     * TODO merge into ProcessInstanceAppService->Get(Id)
     * @param serviceRequestId (optional) 
     * @return OK
     */
    getProcessHistories(serviceRequestId?: string | undefined, cancelToken?: CancelToken): Promise<GetProcessHistoryOutput[]> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Application/GetProcessHistories?";
        if (serviceRequestId === null)
            throw new globalThis.Error("The parameter 'serviceRequestId' cannot be null.");
        else if (serviceRequestId !== undefined)
            url_ += "serviceRequestId=" + encodeURIComponent("" + serviceRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProcessHistories(_response);
        });
    }

    protected processGetProcessHistories(response: AxiosResponse): Promise<GetProcessHistoryOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetProcessHistoryOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetProcessHistoryOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProcessHistoryOutput[]>(null as any);
    }

    /**
     * TODO merge into ProcessInstanceAppService->Get(Id)
     * @param sequenceNumber (optional) 
     * @param operation (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getProcessHistoriesbyPage(sequenceNumber?: string | undefined, operation?: number | undefined, startDate?: moment.Moment | undefined, endDate?: moment.Moment | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, cancelToken?: CancelToken): Promise<GetProcessHistoryOutput2PagedResultDto> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Application/GetProcessHistoriesbyPage?";
        if (sequenceNumber === null)
            throw new globalThis.Error("The parameter 'sequenceNumber' cannot be null.");
        else if (sequenceNumber !== undefined)
            url_ += "SequenceNumber=" + encodeURIComponent("" + sequenceNumber) + "&";
        if (operation === null)
            throw new globalThis.Error("The parameter 'operation' cannot be null.");
        else if (operation !== undefined)
            url_ += "operation=" + encodeURIComponent("" + operation) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProcessHistoriesbyPage(_response);
        });
    }

    protected processGetProcessHistoriesbyPage(response: AxiosResponse): Promise<GetProcessHistoryOutput2PagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProcessHistoryOutput2PagedResultDto.fromJS(resultData200);
            return Promise.resolve<GetProcessHistoryOutput2PagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProcessHistoryOutput2PagedResultDto>(null as any);
    }
}

export class ApplicationTypeDefinitionServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * TODO not sure where this method is used
    The publish script seems directly operate on database
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    addNewServiceTypeDefinition(body?: PostServiceTypeDefinitionDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/TaskApp/ApplicationTypeDefinition/AddNewServiceTypeDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddNewServiceTypeDefinition(_response);
        });
    }

    protected processAddNewServiceTypeDefinition(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取我请求的工单的服务单类型(不包括已关闭的)
    TODO my request list?
    The data returns seems very limited
     * @param inClosedServiceRequest (optional) 从关闭订单中查询服务单类型
     * @return OK
     * @deprecated
     */
    getServiceTypeDefinitionsOfMyRequests(inClosedServiceRequest?: boolean | undefined, cancelToken?: CancelToken): Promise<ServiceTypeDefinitionsOutput[]> {
        let url_ = this.baseUrl + "/api/services/TaskApp/ApplicationTypeDefinition/GetServiceTypeDefinitionsOfMyRequests?";
        if (inClosedServiceRequest === null)
            throw new globalThis.Error("The parameter 'inClosedServiceRequest' cannot be null.");
        else if (inClosedServiceRequest !== undefined)
            url_ += "inClosedServiceRequest=" + encodeURIComponent("" + inClosedServiceRequest) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceTypeDefinitionsOfMyRequests(_response);
        });
    }

    protected processGetServiceTypeDefinitionsOfMyRequests(response: AxiosResponse): Promise<ServiceTypeDefinitionsOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceTypeDefinitionsOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ServiceTypeDefinitionsOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceTypeDefinitionsOutput[]>(null as any);
    }

    /**
     * 返回起始表单的定义
    TODO move the logic to ProcessDefinitionAppService->Get(string serviceRequestType) where serviceRequestType is the id in modeler and ServiceTypeId in ServiceTypeDefinition
    Only one have the permission to submit particular service request type can get the form schema
     * @param serviceRequestTypeId (optional) 服务请求类型Id
     * @return OK
     */
    getStartForm(serviceRequestTypeId?: string | undefined, cancelToken?: CancelToken): Promise<FormSchemaOutput> {
        let url_ = this.baseUrl + "/api/services/TaskApp/ApplicationTypeDefinition/GetStartForm?";
        if (serviceRequestTypeId === null)
            throw new globalThis.Error("The parameter 'serviceRequestTypeId' cannot be null.");
        else if (serviceRequestTypeId !== undefined)
            url_ += "serviceRequestTypeId=" + encodeURIComponent("" + serviceRequestTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStartForm(_response);
        });
    }

    protected processGetStartForm(response: AxiosResponse): Promise<FormSchemaOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FormSchemaOutput.fromJS(resultData200);
            return Promise.resolve<FormSchemaOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormSchemaOutput>(null as any);
    }

    /**
     * 添加服务类型的职责人
    TODO move to ProcessDefinitionAppService->Put()
    responsibility is the relation between process definition and user, sounds really like a aggregation root
     * @param body (optional) 
     * @return OK
     */
    addResponsibility(body?: CreateResponsibilityInput | undefined, cancelToken?: CancelToken): Promise<CreateResponsibilityOutput> {
        let url_ = this.baseUrl + "/api/services/TaskApp/ApplicationTypeDefinition/AddResponsibility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddResponsibility(_response);
        });
    }

    protected processAddResponsibility(response: AxiosResponse): Promise<CreateResponsibilityOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateResponsibilityOutput.fromJS(resultData200);
            return Promise.resolve<CreateResponsibilityOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateResponsibilityOutput>(null as any);
    }
}

export class AttachmentServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body?: CreateAttachmentDto[] | undefined, cancelToken?: CancelToken): Promise<CreatedAttachmentResultDto[]> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Attachment/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedAttachmentResultDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreatedAttachmentResultDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CreatedAttachmentResultDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedAttachmentResultDto[]>(null as any);
    }

    /**
     * @param fileFullName (optional) 
     * @return OK
     */
    getFileSasUri(fileFullName?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Attachment/GetFileSasUri?";
        if (fileFullName === null)
            throw new globalThis.Error("The parameter 'fileFullName' cannot be null.");
        else if (fileFullName !== undefined)
            url_ += "fileFullName=" + encodeURIComponent("" + fileFullName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileSasUri(_response);
        });
    }

    protected processGetFileSasUri(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param fileFullName (optional) 
     * @return OK
     */
    getFileContent(fileFullName?: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Attachment/GetFileContent?";
        if (fileFullName === null)
            throw new globalThis.Error("The parameter 'fileFullName' cannot be null.");
        else if (fileFullName !== undefined)
            url_ += "fileFullName=" + encodeURIComponent("" + fileFullName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileContent(_response);
        });
    }

    protected processGetFileContent(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * 获取多个附件的SasUri
     * @param ids (optional) 附件的id数组
     * @return OK
     */
    getFileSasUriByAttachmentIds(ids?: string[] | undefined, cancelToken?: CancelToken): Promise<GetAttachmentSasUriOutput> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Attachment/GetFileSasUriByAttachmentIds?";
        if (ids === null)
            throw new globalThis.Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileSasUriByAttachmentIds(_response);
        });
    }

    protected processGetFileSasUriByAttachmentIds(response: AxiosResponse): Promise<GetAttachmentSasUriOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAttachmentSasUriOutput.fromJS(resultData200);
            return Promise.resolve<GetAttachmentSasUriOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAttachmentSasUriOutput>(null as any);
    }

    /**
     * 删除附件
     * @param ids (optional) id
     * @return OK
     */
    deleteFiles(ids?: string[] | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Attachment/DeleteFiles?";
        if (ids === null)
            throw new globalThis.Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFiles(_response);
        });
    }

    protected processDeleteFiles(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class CommentServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param commentId (optional) 
     * @param body (optional) 
     * @return OK
     */
    readReceiptComment(commentId?: string | undefined, body?: ReceiptResultType | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Comment/ReadReceiptComment?";
        if (commentId === null)
            throw new globalThis.Error("The parameter 'commentId' cannot be null.");
        else if (commentId !== undefined)
            url_ += "commentId=" + encodeURIComponent("" + commentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadReceiptComment(_response);
        });
    }

    protected processReadReceiptComment(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createExComment(body?: CreateCommentDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Comment/CreateExComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateExComment(_response);
        });
    }

    protected processCreateExComment(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createInComment(body?: CreateCommentDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Comment/CreateInComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateInComment(_response);
        });
    }

    protected processCreateInComment(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param serviceRequestId (optional) 
     * @return OK
     */
    getExternalComments(serviceRequestId?: string | undefined, cancelToken?: CancelToken): Promise<GetCommentsDto[]> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Comment/GetExternalComments?";
        if (serviceRequestId === null)
            throw new globalThis.Error("The parameter 'serviceRequestId' cannot be null.");
        else if (serviceRequestId !== undefined)
            url_ += "serviceRequestId=" + encodeURIComponent("" + serviceRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExternalComments(_response);
        });
    }

    protected processGetExternalComments(response: AxiosResponse): Promise<GetCommentsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCommentsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetCommentsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCommentsDto[]>(null as any);
    }

    /**
     * @param serviceRequestId (optional) 
     * @return OK
     */
    getEInternalComments(serviceRequestId?: string | undefined, cancelToken?: CancelToken): Promise<GetCommentsDto[]> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Comment/GetEInternalComments?";
        if (serviceRequestId === null)
            throw new globalThis.Error("The parameter 'serviceRequestId' cannot be null.");
        else if (serviceRequestId !== undefined)
            url_ += "serviceRequestId=" + encodeURIComponent("" + serviceRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEInternalComments(_response);
        });
    }

    protected processGetEInternalComments(response: AxiosResponse): Promise<GetCommentsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCommentsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetCommentsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCommentsDto[]>(null as any);
    }

    /**
     * @param serviceRequestId (optional) 
     * @return OK
     */
    getInternalComments(serviceRequestId?: string | undefined, cancelToken?: CancelToken): Promise<GetCommentsDto[]> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Comment/GetInternalComments?";
        if (serviceRequestId === null)
            throw new globalThis.Error("The parameter 'serviceRequestId' cannot be null.");
        else if (serviceRequestId !== undefined)
            url_ += "serviceRequestId=" + encodeURIComponent("" + serviceRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInternalComments(_response);
        });
    }

    protected processGetInternalComments(response: AxiosResponse): Promise<GetCommentsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCommentsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetCommentsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCommentsDto[]>(null as any);
    }
}

export class ExternalTaskInterfaceServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    save(body?: ExternalTaskInterfaceInput | undefined, cancelToken?: CancelToken): Promise<ExternalTaskInterfaceOutput> {
        let url_ = this.baseUrl + "/api/services/TaskApp/ExternalTaskInterface/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<ExternalTaskInterfaceOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExternalTaskInterfaceOutput.fromJS(resultData200);
            return Promise.resolve<ExternalTaskInterfaceOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExternalTaskInterfaceOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submit(body?: ExternalTaskInterfaceInput | undefined, cancelToken?: CancelToken): Promise<ExternalTaskInterfaceOutput> {
        let url_ = this.baseUrl + "/api/services/TaskApp/ExternalTaskInterface/Submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<ExternalTaskInterfaceOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExternalTaskInterfaceOutput.fromJS(resultData200);
            return Promise.resolve<ExternalTaskInterfaceOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExternalTaskInterfaceOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitToComment(body?: ExternalTaskInterfaceInput | undefined, cancelToken?: CancelToken): Promise<ExternalTaskInterfaceOutput> {
        let url_ = this.baseUrl + "/api/services/TaskApp/ExternalTaskInterface/SubmitToComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitToComment(_response);
        });
    }

    protected processSubmitToComment(response: AxiosResponse): Promise<ExternalTaskInterfaceOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExternalTaskInterfaceOutput.fromJS(resultData200);
            return Promise.resolve<ExternalTaskInterfaceOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExternalTaskInterfaceOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    synchronized(body?: ExternalTaskInterfaceInput | undefined, cancelToken?: CancelToken): Promise<ExternalTaskInterfaceOutput> {
        let url_ = this.baseUrl + "/api/services/TaskApp/ExternalTaskInterface/Synchronized";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSynchronized(_response);
        });
    }

    protected processSynchronized(response: AxiosResponse): Promise<ExternalTaskInterfaceOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExternalTaskInterfaceOutput.fromJS(resultData200);
            return Promise.resolve<ExternalTaskInterfaceOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExternalTaskInterfaceOutput>(null as any);
    }

    /**
     * @param taskInterfaceId (optional) 
     * @return OK
     */
    getActionItems(taskInterfaceId?: string | undefined, cancelToken?: CancelToken): Promise<TaskInterfaceActionItem> {
        let url_ = this.baseUrl + "/api/services/TaskApp/ExternalTaskInterface/getActionItems?";
        if (taskInterfaceId === null)
            throw new globalThis.Error("The parameter 'taskInterfaceId' cannot be null.");
        else if (taskInterfaceId !== undefined)
            url_ += "TaskInterfaceId=" + encodeURIComponent("" + taskInterfaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActionItems(_response);
        });
    }

    protected processGetActionItems(response: AxiosResponse): Promise<TaskInterfaceActionItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<TaskInterfaceActionItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskInterfaceActionItem>(null as any);
    }

    /**
     * @param taskInterfaceId (optional) 
     * @return OK
     */
    getExternalTaskInterfaceDetail(taskInterfaceId?: string | undefined, cancelToken?: CancelToken): Promise<ExternalTaskInterfaceDetail> {
        let url_ = this.baseUrl + "/api/services/TaskApp/ExternalTaskInterface/GetExternalTaskInterfaceDetail?";
        if (taskInterfaceId === null)
            throw new globalThis.Error("The parameter 'taskInterfaceId' cannot be null.");
        else if (taskInterfaceId !== undefined)
            url_ += "TaskInterfaceId=" + encodeURIComponent("" + taskInterfaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExternalTaskInterfaceDetail(_response);
        });
    }

    protected processGetExternalTaskInterfaceDetail(response: AxiosResponse): Promise<ExternalTaskInterfaceDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExternalTaskInterfaceDetail.fromJS(resultData200);
            return Promise.resolve<ExternalTaskInterfaceDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExternalTaskInterfaceDetail>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return OK
     */
    getExternalTaskInterfaceDetailList(taskId?: string | undefined, cancelToken?: CancelToken): Promise<ExternalTaskInterfaceDetail[]> {
        let url_ = this.baseUrl + "/api/services/TaskApp/ExternalTaskInterface/GetExternalTaskInterfaceDetailList?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExternalTaskInterfaceDetailList(_response);
        });
    }

    protected processGetExternalTaskInterfaceDetailList(response: AxiosResponse): Promise<ExternalTaskInterfaceDetail[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalTaskInterfaceDetail.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ExternalTaskInterfaceDetail[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExternalTaskInterfaceDetail[]>(null as any);
    }
}

export class TaskServiceProxy extends ServiceProxyBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    /**
     * 删除camunda流程仅删除camunda 不会对数据库进行操作
     * @param processInstanceIds (optional) 多个采用,分开
     * @return OK
     */
    deleteCamundaTask(processInstanceIds?: string | undefined, cancelToken?: CancelToken): Promise<ReturnResult> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/DeleteCamundaTask?";
        if (processInstanceIds === null)
            throw new globalThis.Error("The parameter 'processInstanceIds' cannot be null.");
        else if (processInstanceIds !== undefined)
            url_ += "processInstanceIds=" + encodeURIComponent("" + processInstanceIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCamundaTask(_response);
        });
    }

    protected processDeleteCamundaTask(response: AxiosResponse): Promise<ReturnResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReturnResult.fromJS(resultData200);
            return Promise.resolve<ReturnResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReturnResult>(null as any);
    }

    /**
     * 删除无效的定时任务
     * @param inDtos (optional) 
     * @return OK
     */
    deleteRecurringJob(inDtos?: string[] | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/DeleteRecurringJob?";
        if (inDtos === null)
            throw new globalThis.Error("The parameter 'inDtos' cannot be null.");
        else if (inDtos !== undefined)
            inDtos && inDtos.forEach(item => { url_ += "inDtos=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRecurringJob(_response);
        });
    }

    protected processDeleteRecurringJob(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取任务详情信息API
    TODO WTF?
     * @return OK
     * @deprecated
     */
    getTaskDetail(taskId: string, cancelToken?: CancelToken): Promise<WorkOrderTaskDetailOutput> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/GetTaskDetail?";
        if (taskId === undefined || taskId === null)
            throw new globalThis.Error("The parameter 'taskId' must be defined and cannot be null.");
        else
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaskDetail(_response);
        });
    }

    protected processGetTaskDetail(response: AxiosResponse): Promise<WorkOrderTaskDetailOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WorkOrderTaskDetailOutput.fromJS(resultData200);
            return Promise.resolve<WorkOrderTaskDetailOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkOrderTaskDetailOutput>(null as any);
    }

    /**
     * 我的代办工单列表
    TODO move to TaskAppService->Get(Type t), the default method for getting task list by logged in user. Aka. my todo list
    Where Type should be Todo or Concern or History
    Todo: is the task assigned to particular user and in active status, or task has no active assignee but particular user is the candidate
    Concern: is the active task which is followed by particular user(the preset follower permission of process definition, or the user has worked on the process instance before)
    History: Similar to Concern, but the task(or PI???) is in completed state
     * @return OK
     */
    toDo( cancelToken?: CancelToken): Promise<WorkOrders> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/ToDo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToDo(_response);
        });
    }

    protected processToDo(response: AxiosResponse): Promise<WorkOrders> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WorkOrders.fromJS(resultData200);
            return Promise.resolve<WorkOrders>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkOrders>(null as any);
    }

    /**
     * 获取所有代办工单列表
    TODO move to TaskAppService->Get(string Email). Get the todo list by user email
    Consider the permission control for this method, Who and when want to get other's todo list
     * @return OK
     */
    getAllToDo( cancelToken?: CancelToken): Promise<WorkOrders> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/GetAllToDo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllToDo(_response);
        });
    }

    protected processGetAllToDo(response: AxiosResponse): Promise<WorkOrders> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WorkOrders.fromJS(resultData200);
            return Promise.resolve<WorkOrders>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkOrders>(null as any);
    }

    /**
     * 获取指定人代办工单列表
    TODO move to TaskAppService->Get(string Email). Get the todo list by user email
    Consider the permission control for this method, Who and when want to get other's todo list
     * @param userEmail (optional) 
     * @return OK
     */
    getToDo(userEmail?: string | undefined, cancelToken?: CancelToken): Promise<WorkOrders> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/GetToDo?";
        if (userEmail === null)
            throw new globalThis.Error("The parameter 'userEmail' cannot be null.");
        else if (userEmail !== undefined)
            url_ += "UserEmail=" + encodeURIComponent("" + userEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToDo(_response);
        });
    }

    protected processGetToDo(response: AxiosResponse): Promise<WorkOrders> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WorkOrders.fromJS(resultData200);
            return Promise.resolve<WorkOrders>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkOrders>(null as any);
    }

    /**
     * 我的关注工单
    TODO merge into Get method, see description above
     * @return OK
     */
    myConcerns( cancelToken?: CancelToken): Promise<WorkOrders> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/MyConcerns";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMyConcerns(_response);
        });
    }

    protected processMyConcerns(response: AxiosResponse): Promise<WorkOrders> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WorkOrders.fromJS(resultData200);
            return Promise.resolve<WorkOrders>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkOrders>(null as any);
    }

    /**
     * 历史工单 (已关闭的)
    TODO merge into Get method, see description above
     * @return OK
     */
    historyWO( cancelToken?: CancelToken): Promise<WorkOrders> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/HistoryWO";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHistoryWO(_response);
        });
    }

    protected processHistoryWO(response: AxiosResponse): Promise<WorkOrders> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WorkOrders.fromJS(resultData200);
            return Promise.resolve<WorkOrders>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkOrders>(null as any);
    }

    /**
     * 获取所有工单列表
     * @return OK
     */
    getOcAll( cancelToken?: CancelToken): Promise<WorkOrders> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/GetOcAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOcAll(_response);
        });
    }

    protected processGetOcAll(response: AxiosResponse): Promise<WorkOrders> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WorkOrders.fromJS(resultData200);
            return Promise.resolve<WorkOrders>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkOrders>(null as any);
    }

    /**
     * the reassign scope is limited to the candidate users
     * @param taskId (optional) 
     * @return OK
     */
    getCandidateUsersByTaskId(taskId?: string | undefined, cancelToken?: CancelToken): Promise<GetCandidateUserDto[]> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/GetCandidateUsersByTaskId?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCandidateUsersByTaskId(_response);
        });
    }

    protected processGetCandidateUsersByTaskId(response: AxiosResponse): Promise<GetCandidateUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCandidateUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetCandidateUserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCandidateUserDto[]>(null as any);
    }

    /**
     * 获取可指派用户列表。
    鉴权对齐 UA UserAppService：[AbpAuthorize] 要求已认证；
    认证由 MspAuthenticationHandler 完成（ocelot.abpsession 或 X-Gateway-Secret 任一即可）。
     * @return OK
     */
    getAllUser( cancelToken?: CancelToken): Promise<GetCandidateUserDto[]> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/GetAllUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUser(_response);
        });
    }

    protected processGetAllUser(response: AxiosResponse): Promise<GetCandidateUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCandidateUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetCandidateUserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCandidateUserDto[]>(null as any);
    }

    /**
     * 接单接口
    TODO move to TaskAppService->Take
     * @param serviceRequestId (optional) 工单的Id
     * @param taskId (optional) 任务ID
     * @return OK
     */
    claim(serviceRequestId?: string | undefined, taskId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/Claim?";
        if (serviceRequestId === null)
            throw new globalThis.Error("The parameter 'serviceRequestId' cannot be null.");
        else if (serviceRequestId !== undefined)
            url_ += "serviceRequestId=" + encodeURIComponent("" + serviceRequestId) + "&";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClaim(_response);
        });
    }

    protected processClaim(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取指定工单当前激活的所有任务(不包括已完成任务)
    TODO not clear where this method is used
     * @param serviceRequestId (optional) 
     * @return OK
     */
    getTasksByServiceRequestId(serviceRequestId?: string | undefined, cancelToken?: CancelToken): Promise<TaskInfo[]> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/GetTasksByServiceRequestId?";
        if (serviceRequestId === null)
            throw new globalThis.Error("The parameter 'serviceRequestId' cannot be null.");
        else if (serviceRequestId !== undefined)
            url_ += "serviceRequestId=" + encodeURIComponent("" + serviceRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTasksByServiceRequestId(_response);
        });
    }

    protected processGetTasksByServiceRequestId(response: AxiosResponse): Promise<TaskInfo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TaskInfo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskInfo[]>(null as any);
    }

    /**
     * 通过工单id获取工单的所有任务(包括已完成任务)
     * @param serviceRequestId (optional) 工单id，其值等于服务申请单的id
     * @return OK
     */
    getAllTasksByServiceWorkOrderId(serviceRequestId?: string | undefined, cancelToken?: CancelToken): Promise<TaskInfo[]> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/GetAllTasksByServiceWorkOrderId?";
        if (serviceRequestId === null)
            throw new globalThis.Error("The parameter 'serviceRequestId' cannot be null.");
        else if (serviceRequestId !== undefined)
            url_ += "serviceRequestId=" + encodeURIComponent("" + serviceRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTasksByServiceWorkOrderId(_response);
        });
    }

    protected processGetAllTasksByServiceWorkOrderId(response: AxiosResponse): Promise<TaskInfo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TaskInfo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskInfo[]>(null as any);
    }

    /**
     * 工单申请详情
    TODO The PI basic info on the top-left corner of the task page?
     * @param workOrderId 工单id
     * @return OK
     */
    serviceRequestDetailInfo(workOrderId: string, cancelToken?: CancelToken): Promise<ServiceRequestDetailOutput> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/ServiceRequestDetailInfo?";
        if (workOrderId === undefined || workOrderId === null)
            throw new globalThis.Error("The parameter 'workOrderId' must be defined and cannot be null.");
        else
            url_ += "workOrderId=" + encodeURIComponent("" + workOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processServiceRequestDetailInfo(_response);
        });
    }

    protected processServiceRequestDetailInfo(response: AxiosResponse): Promise<ServiceRequestDetailOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestDetailOutput.fromJS(resultData200);
            return Promise.resolve<ServiceRequestDetailOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestDetailOutput>(null as any);
    }

    /**
     * 暂存工单,暂存不会更改任务的状态
    TODO move to TaskAppService->Put(xx) save task info.
     * @param body (optional) 输入数据
     * @return OK
     */
    saveWorkOrderTask(body?: SaveWorkOrderTaskInput | undefined, cancelToken?: CancelToken): Promise<SaveWorkOrderTaskOutput> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/SaveWorkOrderTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveWorkOrderTask(_response);
        });
    }

    protected processSaveWorkOrderTask(response: AxiosResponse): Promise<SaveWorkOrderTaskOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveWorkOrderTaskOutput.fromJS(resultData200);
            return Promise.resolve<SaveWorkOrderTaskOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveWorkOrderTaskOutput>(null as any);
    }

    /**
     * 提交工单,会完成当前任务，并进入下一个任务
    TODO move to TaskAppService->Put(xx) complete task, Aka update task status
     * @param body (optional) 输入数据
     * @return OK
     */
    completeWorkOrderTask(body?: SaveWorkOrderTaskInput | undefined, cancelToken?: CancelToken): Promise<SaveWorkOrderTaskOutput> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/CompleteWorkOrderTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompleteWorkOrderTask(_response);
        });
    }

    protected processCompleteWorkOrderTask(response: AxiosResponse): Promise<SaveWorkOrderTaskOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveWorkOrderTaskOutput.fromJS(resultData200);
            return Promise.resolve<SaveWorkOrderTaskOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveWorkOrderTaskOutput>(null as any);
    }

    /**
     * 重新指派
    TODO move to TaskAppService->Put(xx) reassign task, Aka update the current assignee
     * @param body (optional) 
     * @return OK
     */
    reassign(body?: WorkOrderReassignInput | undefined, cancelToken?: CancelToken): Promise<WorkOrderReassignOutput> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/Reassign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReassign(_response);
        });
    }

    protected processReassign(response: AxiosResponse): Promise<WorkOrderReassignOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WorkOrderReassignOutput.fromJS(resultData200);
            return Promise.resolve<WorkOrderReassignOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkOrderReassignOutput>(null as any);
    }

    /**
     * @param opUserId (optional) 
     * @param body (optional) 
     * @return OK
     */
    newReassign(opUserId?: string | undefined, body?: WorkOrderReassignInput | undefined, cancelToken?: CancelToken): Promise<WorkOrderReassignOutput> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/NewReassign?";
        if (opUserId === null)
            throw new globalThis.Error("The parameter 'opUserId' cannot be null.");
        else if (opUserId !== undefined)
            url_ += "opUserId=" + encodeURIComponent("" + opUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewReassign(_response);
        });
    }

    protected processNewReassign(response: AxiosResponse): Promise<WorkOrderReassignOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WorkOrderReassignOutput.fromJS(resultData200);
            return Promise.resolve<WorkOrderReassignOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkOrderReassignOutput>(null as any);
    }

    /**
     * 获取待办和关注工单的数量
    TODO remove since this method is used for CCS dashboard
     * @return OK
     * @deprecated
     */
    getWorkOrderCount( cancelToken?: CancelToken): Promise<TodoAndConcernCountOutput> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/GetWorkOrderCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWorkOrderCount(_response);
        });
    }

    protected processGetWorkOrderCount(response: AxiosResponse): Promise<TodoAndConcernCountOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TodoAndConcernCountOutput.fromJS(resultData200);
            return Promise.resolve<TodoAndConcernCountOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TodoAndConcernCountOutput>(null as any);
    }

    /**
     * 根据 processInstanceId 获取当前流程实例下所有任务 (包括已完成)
     * @param processInstanceId (optional) 
     * @return OK
     */
    getTaskDtos(processInstanceId?: string | undefined, cancelToken?: CancelToken): Promise<TaskInfo[]> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/GetTaskDtos?";
        if (processInstanceId === null)
            throw new globalThis.Error("The parameter 'processInstanceId' cannot be null.");
        else if (processInstanceId !== undefined)
            url_ += "processInstanceId=" + encodeURIComponent("" + processInstanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaskDtos(_response);
        });
    }

    protected processGetTaskDtos(response: AxiosResponse): Promise<TaskInfo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TaskInfo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskInfo[]>(null as any);
    }

    /**
     * 根据服务名称(ponumber)，获取所有的变更工单
     * @return OK
     */
    serviceRequestListByServiceName(serviceName: string, cancelToken?: CancelToken): Promise<ServiceRequestListOutput[]> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/ServiceRequestListByServiceName?";
        if (serviceName === undefined || serviceName === null)
            throw new globalThis.Error("The parameter 'serviceName' must be defined and cannot be null.");
        else
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processServiceRequestListByServiceName(_response);
        });
    }

    protected processServiceRequestListByServiceName(response: AxiosResponse): Promise<ServiceRequestListOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestListOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ServiceRequestListOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestListOutput[]>(null as any);
    }

    /**
     * 手动关闭整个工单：删除 Camunda 流程实例 + 关单落库（置 Closed、触发通知与操作历史）
    说明：删除流程实例不会触发 Camunda 的 end 历史事件，不会自动走
    ProcessEventHandler -> CloseServiceOrder 链路，因此此处需显式调用 CloseServiceOrder。
     * @param processInstanceId 流程实例ID
     * @param closeReason (optional) 关闭原因（记录到操作历史）
     * @param operatorId (optional) 
     * @return OK
     */
    closeWorkOrder(processInstanceId: string, closeReason?: string | undefined, operatorId?: string | undefined, cancelToken?: CancelToken): Promise<ReturnResult> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/CloseWorkOrder?";
        if (processInstanceId === undefined || processInstanceId === null)
            throw new globalThis.Error("The parameter 'processInstanceId' must be defined and cannot be null.");
        else
            url_ += "processInstanceId=" + encodeURIComponent("" + processInstanceId) + "&";
        if (closeReason === null)
            throw new globalThis.Error("The parameter 'closeReason' cannot be null.");
        else if (closeReason !== undefined)
            url_ += "closeReason=" + encodeURIComponent("" + closeReason) + "&";
        if (operatorId === null)
            throw new globalThis.Error("The parameter 'operatorId' cannot be null.");
        else if (operatorId !== undefined)
            url_ += "operatorId=" + encodeURIComponent("" + operatorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloseWorkOrder(_response);
        });
    }

    protected processCloseWorkOrder(response: AxiosResponse): Promise<ReturnResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReturnResult.fromJS(resultData200);
            return Promise.resolve<ReturnResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReturnResult>(null as any);
    }

    /**
     * 追加订单变更撤销处理历史（发起撤销/审批拒绝等非关单场景，服务间调用）
     * @param processInstanceId 流程实例ID
     * @param description (optional) 记录描述（如：发起撤销：xxx / 审批拒绝撤销：xxx）
     * @param operatorId (optional) 操作人ID（服务间调用显式传入，为空时回退当前会话）
     * @return OK
     */
    addRevokeHistory(processInstanceId: string, description?: string | undefined, operatorId?: string | undefined, cancelToken?: CancelToken): Promise<ReturnResult> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/AddRevokeHistory?";
        if (processInstanceId === undefined || processInstanceId === null)
            throw new globalThis.Error("The parameter 'processInstanceId' must be defined and cannot be null.");
        else
            url_ += "processInstanceId=" + encodeURIComponent("" + processInstanceId) + "&";
        if (description === null)
            throw new globalThis.Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (operatorId === null)
            throw new globalThis.Error("The parameter 'operatorId' cannot be null.");
        else if (operatorId !== undefined)
            url_ += "operatorId=" + encodeURIComponent("" + operatorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddRevokeHistory(_response);
        });
    }

    protected processAddRevokeHistory(response: AxiosResponse): Promise<ReturnResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReturnResult.fromJS(resultData200);
            return Promise.resolve<ReturnResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReturnResult>(null as any);
    }

    /**
     * 按服务申请ID获取该工单的任务表单数据（服务间调用，供再次发起内部评估带出上一单填写内容）
     * @param serviceRequestId 服务申请ID
     * @return OK
     */
    getTaskFormDataByServiceRequestId(serviceRequestId: string, cancelToken?: CancelToken): Promise<TaskFormDataRecordOutput[]> {
        let url_ = this.baseUrl + "/api/services/TaskApp/Task/GetTaskFormDataByServiceRequestId?";
        if (serviceRequestId === undefined || serviceRequestId === null)
            throw new globalThis.Error("The parameter 'serviceRequestId' must be defined and cannot be null.");
        else
            url_ += "serviceRequestId=" + encodeURIComponent("" + serviceRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaskFormDataByServiceRequestId(_response);
        });
    }

    protected processGetTaskFormDataByServiceRequestId(response: AxiosResponse): Promise<TaskFormDataRecordOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskFormDataRecordOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TaskFormDataRecordOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskFormDataRecordOutput[]>(null as any);
    }
}

export class ActivateEmailInput {
    userId!: number;
    confirmationCode!: string | null;
    c!: string | null;

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.confirmationCode = _data["confirmationCode"] !== undefined ? _data["confirmationCode"] : null as any;
            this.c = _data["c"] !== undefined ? _data["c"] : null as any;
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["confirmationCode"] = this.confirmationCode !== undefined ? this.confirmationCode : null as any;
        data["c"] = this.c !== undefined ? this.c : null as any;
        return data;
    }
}

/** 添加视图 */
export class AddAnnouncementDto {
    /** 标题 */
    title!: string | null;
    /** 附件URL */
    attachmentUrl!: string | null;
    /** 类型 */
    certificateType!: string | null;
    /** 是否立即发送邮件 */
    sendMail!: boolean;
    /** 系统横幅展示开始时间 */
    showTimeForStart!: moment.Moment | null;
    /** 系统横幅展示结束时间 */
    showTimeForEnd!: moment.Moment | null;
    /** 可见类型（1：全员可见，2：指定角色） */
    visibleType!: number | null;
    /** 角色Id */
    roleID!: number[] | null;
    announcementLabelTypeDtos!: AnnouncementLabelTypeDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.attachmentUrl = _data["attachmentUrl"] !== undefined ? _data["attachmentUrl"] : null as any;
            this.certificateType = _data["certificateType"] !== undefined ? _data["certificateType"] : null as any;
            this.sendMail = _data["sendMail"] !== undefined ? _data["sendMail"] : null as any;
            this.showTimeForStart = _data["showTimeForStart"] ? moment(_data["showTimeForStart"].toString()) : null as any;
            this.showTimeForEnd = _data["showTimeForEnd"] ? moment(_data["showTimeForEnd"].toString()) : null as any;
            this.visibleType = _data["visibleType"] !== undefined ? _data["visibleType"] : null as any;
            if (Array.isArray(_data["roleID"])) {
                this.roleID = [] as any;
                for (let item of _data["roleID"])
                    this.roleID!.push(item);
            }
            else {
                this.roleID = null as any;
            }
            if (Array.isArray(_data["announcementLabelTypeDtos"])) {
                this.announcementLabelTypeDtos = [] as any;
                for (let item of _data["announcementLabelTypeDtos"])
                    this.announcementLabelTypeDtos!.push(AnnouncementLabelTypeDto.fromJS(item));
            }
            else {
                this.announcementLabelTypeDtos = null as any;
            }
        }
    }

    static fromJS(data: any): AddAnnouncementDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddAnnouncementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["attachmentUrl"] = this.attachmentUrl !== undefined ? this.attachmentUrl : null as any;
        data["certificateType"] = this.certificateType !== undefined ? this.certificateType : null as any;
        data["sendMail"] = this.sendMail !== undefined ? this.sendMail : null as any;
        data["showTimeForStart"] = this.showTimeForStart ? this.showTimeForStart.toISOString() : null as any;
        data["showTimeForEnd"] = this.showTimeForEnd ? this.showTimeForEnd.toISOString() : null as any;
        data["visibleType"] = this.visibleType !== undefined ? this.visibleType : null as any;
        if (Array.isArray(this.roleID)) {
            data["roleID"] = [];
            for (let item of this.roleID)
                data["roleID"].push(item);
        }
        if (Array.isArray(this.announcementLabelTypeDtos)) {
            data["announcementLabelTypeDtos"] = [];
            for (let item of this.announcementLabelTypeDtos)
                data["announcementLabelTypeDtos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 系统公告Dto */
export class AnnouncementDto {
    id!: string;
    /** 标题 */
    title!: string | null;
    /** 附件URL */
    attachmentUrl!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.attachmentUrl = _data["attachmentUrl"] !== undefined ? _data["attachmentUrl"] : null as any;
        }
    }

    static fromJS(data: any): AnnouncementDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnouncementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["attachmentUrl"] = this.attachmentUrl !== undefined ? this.attachmentUrl : null as any;
        return data;
    }
}

export class AnnouncementDtoPagedResultDto {
    items!: AnnouncementDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AnnouncementDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): AnnouncementDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnouncementDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class AnnouncementLabelTypeDto {
    /** 标签类型Id */
    labelTypeId!: string;
    /** 标签类型Id */
    labelTypeName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.labelTypeId = _data["labelTypeId"] !== undefined ? _data["labelTypeId"] : null as any;
            this.labelTypeName = _data["labelTypeName"] !== undefined ? _data["labelTypeName"] : null as any;
        }
    }

    static fromJS(data: any): AnnouncementLabelTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnouncementLabelTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labelTypeId"] = this.labelTypeId !== undefined ? this.labelTypeId : null as any;
        data["labelTypeName"] = this.labelTypeName !== undefined ? this.labelTypeName : null as any;
        return data;
    }
}

export class ApplicationInfoDto {
    version!: string | null;
    releaseDate!: moment.Moment;
    features!: { [key: string]: boolean; } | null;

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : null as any;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (this.features as any)![key] = _data["features"][key] !== undefined ? _data["features"][key] : null as any;
                }
            }
            else {
                this.features = null as any;
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : null as any;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (data["features"] as any)[key] = this.features[key] !== undefined ? this.features[key] : null as any;
            }
        }
        return data;
    }
}

/** 关联客户输出对象 */
export class AssociationCustomersOutputDto {
    /** 编号 */
    id!: string;
    /** 客户编号 */
    customerId!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 关联编号 */
    associationId!: number;
    /** 关联人 */
    associationName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.associationId = _data["associationId"] !== undefined ? _data["associationId"] : null as any;
            this.associationName = _data["associationName"] !== undefined ? _data["associationName"] : null as any;
        }
    }

    static fromJS(data: any): AssociationCustomersOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssociationCustomersOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["associationId"] = this.associationId !== undefined ? this.associationId : null as any;
        data["associationName"] = this.associationName !== undefined ? this.associationName : null as any;
        return data;
    }
}

export class Attachment {
    readonly contentStream!: string | null;
    contentId!: string | null;
    contentType!: ContentType;
    transferEncoding!: TransferEncoding;
    name!: string | null;
    nameEncoding!: Encoding;
    contentDisposition!: ContentDisposition;

    init(_data?: any) {
        if (_data) {
            (this as any).contentStream = _data["contentStream"] !== undefined ? _data["contentStream"] : null as any;
            this.contentId = _data["contentId"] !== undefined ? _data["contentId"] : null as any;
            this.contentType = _data["contentType"] ? ContentType.fromJS(_data["contentType"]) : null as any;
            this.transferEncoding = _data["transferEncoding"] !== undefined ? _data["transferEncoding"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.nameEncoding = _data["nameEncoding"] ? Encoding.fromJS(_data["nameEncoding"]) : null as any;
            this.contentDisposition = _data["contentDisposition"] ? ContentDisposition.fromJS(_data["contentDisposition"]) : null as any;
        }
    }

    static fromJS(data: any): Attachment {
        data = typeof data === 'object' ? data : {};
        let result = new Attachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentStream"] = this.contentStream !== undefined ? this.contentStream : null as any;
        data["contentId"] = this.contentId !== undefined ? this.contentId : null as any;
        data["contentType"] = this.contentType ? this.contentType.toJSON() : null as any;
        data["transferEncoding"] = this.transferEncoding !== undefined ? this.transferEncoding : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["nameEncoding"] = this.nameEncoding ? this.nameEncoding.toJSON() : null as any;
        data["contentDisposition"] = this.contentDisposition ? this.contentDisposition.toJSON() : null as any;
        return data;
    }
}

export class AuthenticateByServiceAccountModel {
    userNameOrEmailAddress!: string | null;
    password!: string | null;
    clientId!: string | null;
    clientSecret!: string | null;
    abpTenantId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"] !== undefined ? _data["userNameOrEmailAddress"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.clientSecret = _data["clientSecret"] !== undefined ? _data["clientSecret"] : null as any;
            this.abpTenantId = _data["abpTenantId"] !== undefined ? _data["abpTenantId"] : null as any;
        }
    }

    static fromJS(data: any): AuthenticateByServiceAccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateByServiceAccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress !== undefined ? this.userNameOrEmailAddress : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["clientSecret"] = this.clientSecret !== undefined ? this.clientSecret : null as any;
        data["abpTenantId"] = this.abpTenantId !== undefined ? this.abpTenantId : null as any;
        return data;
    }
}

export class AuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    rememberClient!: boolean;
    singleSignIn!: boolean | null;
    returnUrl!: string | null;
    abpTenantId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"] !== undefined ? _data["userNameOrEmailAddress"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
            this.rememberClient = _data["rememberClient"] !== undefined ? _data["rememberClient"] : null as any;
            this.singleSignIn = _data["singleSignIn"] !== undefined ? _data["singleSignIn"] : null as any;
            this.returnUrl = _data["returnUrl"] !== undefined ? _data["returnUrl"] : null as any;
            this.abpTenantId = _data["abpTenantId"] !== undefined ? _data["abpTenantId"] : null as any;
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress !== undefined ? this.userNameOrEmailAddress : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        data["rememberClient"] = this.rememberClient !== undefined ? this.rememberClient : null as any;
        data["singleSignIn"] = this.singleSignIn !== undefined ? this.singleSignIn : null as any;
        data["returnUrl"] = this.returnUrl !== undefined ? this.returnUrl : null as any;
        data["abpTenantId"] = this.abpTenantId !== undefined ? this.abpTenantId : null as any;
        return data;
    }
}

export class AuthenticateResultModel {
    accessToken!: string | null;
    encryptedAccessToken!: string | null;
    expireInSeconds!: number;
    userId!: number;
    waitingForActivation!: boolean;
    shouldResetPassword!: boolean;
    passwordResetCode!: string | null;
    returnUrl!: string | null;

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"] !== undefined ? _data["accessToken"] : null as any;
            this.encryptedAccessToken = _data["encryptedAccessToken"] !== undefined ? _data["encryptedAccessToken"] : null as any;
            this.expireInSeconds = _data["expireInSeconds"] !== undefined ? _data["expireInSeconds"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.waitingForActivation = _data["waitingForActivation"] !== undefined ? _data["waitingForActivation"] : null as any;
            this.shouldResetPassword = _data["shouldResetPassword"] !== undefined ? _data["shouldResetPassword"] : null as any;
            this.passwordResetCode = _data["passwordResetCode"] !== undefined ? _data["passwordResetCode"] : null as any;
            this.returnUrl = _data["returnUrl"] !== undefined ? _data["returnUrl"] : null as any;
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken !== undefined ? this.accessToken : null as any;
        data["encryptedAccessToken"] = this.encryptedAccessToken !== undefined ? this.encryptedAccessToken : null as any;
        data["expireInSeconds"] = this.expireInSeconds !== undefined ? this.expireInSeconds : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["waitingForActivation"] = this.waitingForActivation !== undefined ? this.waitingForActivation : null as any;
        data["shouldResetPassword"] = this.shouldResetPassword !== undefined ? this.shouldResetPassword : null as any;
        data["passwordResetCode"] = this.passwordResetCode !== undefined ? this.passwordResetCode : null as any;
        data["returnUrl"] = this.returnUrl !== undefined ? this.returnUrl : null as any;
        return data;
    }
}

/** 账号初始化认证绑定 */
export class BindingAuthenticateDto {
    userId!: number;

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
        }
    }

    static fromJS(data: any): BindingAuthenticateDto {
        data = typeof data === 'object' ? data : {};
        let result = new BindingAuthenticateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        return data;
    }
}

export class BindingUserInfoDto {
    hasIDP!: boolean;
    result!: UserDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.hasIDP = _data["hasIDP"] !== undefined ? _data["hasIDP"] : null as any;
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(UserDto.fromJS(item));
            }
            else {
                this.result = null as any;
            }
        }
    }

    static fromJS(data: any): BindingUserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BindingUserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasIDP"] = this.hasIDP !== undefined ? this.hasIDP : null as any;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class ByteReadOnlySpan {
    readonly length!: number;
    readonly isEmpty!: boolean;

    init(_data?: any) {
        if (_data) {
            (this as any).length = _data["length"] !== undefined ? _data["length"] : null as any;
            (this as any).isEmpty = _data["isEmpty"] !== undefined ? _data["isEmpty"] : null as any;
        }
    }

    static fromJS(data: any): ByteReadOnlySpan {
        data = typeof data === 'object' ? data : {};
        let result = new ByteReadOnlySpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["length"] = this.length !== undefined ? this.length : null as any;
        data["isEmpty"] = this.isEmpty !== undefined ? this.isEmpty : null as any;
        return data;
    }
}

export class CNIABCscotPartscotInterfaceNormalUserAccessRightReviewlInputDto {
    id!: number;
    no!: number;
    emailAddress!: string | null;
    name!: string | null;
    userName!: string | null;
    surname!: string | null;
    roleName!: string | null;
    roleId!: number;
    fullName!: string | null;
    isActive!: boolean;
    isDisabled!: boolean;
    readonly status!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.no = _data["no"] !== undefined ? _data["no"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : null as any;
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : null as any;
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            this.isDisabled = _data["isDisabled"] !== undefined ? _data["isDisabled"] : null as any;
            (this as any).status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static fromJS(data: any): CNIABCscotPartscotInterfaceNormalUserAccessRightReviewlInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CNIABCscotPartscotInterfaceNormalUserAccessRightReviewlInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["no"] = this.no !== undefined ? this.no : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["surname"] = this.surname !== undefined ? this.surname : null as any;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null as any;
        data["roleId"] = this.roleId !== undefined ? this.roleId : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        data["isDisabled"] = this.isDisabled !== undefined ? this.isDisabled : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        return data;
    }
}

export class Calendar {
    id!: string;
    date!: moment.Moment;
    lunarDate!: string | null;
    week!: number;
    holidayName!: string | null;
    holidayDays!: number;
    remark!: string | null;
    weekend!: boolean;
    holiday!: boolean;
    workDay!: boolean;
    creatorUserId!: number | null;
    creationTime!: moment.Moment;
    lastModifierUserId!: number | null;
    lastModificationTime!: moment.Moment;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.date = _data["date"] ? moment(_data["date"].toString()) : null as any;
            this.lunarDate = _data["lunarDate"] !== undefined ? _data["lunarDate"] : null as any;
            this.week = _data["week"] !== undefined ? _data["week"] : null as any;
            this.holidayName = _data["holidayName"] !== undefined ? _data["holidayName"] : null as any;
            this.holidayDays = _data["holidayDays"] !== undefined ? _data["holidayDays"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.weekend = _data["weekend"] !== undefined ? _data["weekend"] : null as any;
            this.holiday = _data["holiday"] !== undefined ? _data["holiday"] : null as any;
            this.workDay = _data["workDay"] !== undefined ? _data["workDay"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): Calendar {
        data = typeof data === 'object' ? data : {};
        let result = new Calendar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["date"] = this.date ? this.date.toISOString() : null as any;
        data["lunarDate"] = this.lunarDate !== undefined ? this.lunarDate : null as any;
        data["week"] = this.week !== undefined ? this.week : null as any;
        data["holidayName"] = this.holidayName !== undefined ? this.holidayName : null as any;
        data["holidayDays"] = this.holidayDays !== undefined ? this.holidayDays : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["weekend"] = this.weekend !== undefined ? this.weekend : null as any;
        data["holiday"] = this.holiday !== undefined ? this.holiday : null as any;
        data["workDay"] = this.workDay !== undefined ? this.workDay : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        return data;
    }
}

export class CalendarDto {
    id!: string;
    /** 日期 */
    date!: moment.Moment;
    holidayName!: string | null;
    holidayDays!: number;
    /** 是否国家法定不上班的节假日 */
    holiday!: boolean;
    /** 是否周末 */
    weekend!: boolean;
    /** 是否工作日 */
    workDay!: boolean;
    week!: number;
    /** 阴历日期 */
    lunarDate!: string | null;
    remark!: string | null;
    /** 创建人 */
    creatorUserId!: number | null;
    /** 创建时间 */
    creationTime!: moment.Moment;
    /** 修改人 */
    lastModifierUserId!: number | null;
    /** 修改时间 */
    lastModificationTime!: moment.Moment | null;
    /** 日期 */
    readonly dateString!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.date = _data["date"] ? moment(_data["date"].toString()) : null as any;
            this.holidayName = _data["holidayName"] !== undefined ? _data["holidayName"] : null as any;
            this.holidayDays = _data["holidayDays"] !== undefined ? _data["holidayDays"] : null as any;
            this.holiday = _data["holiday"] !== undefined ? _data["holiday"] : null as any;
            this.weekend = _data["weekend"] !== undefined ? _data["weekend"] : null as any;
            this.workDay = _data["workDay"] !== undefined ? _data["workDay"] : null as any;
            this.week = _data["week"] !== undefined ? _data["week"] : null as any;
            this.lunarDate = _data["lunarDate"] !== undefined ? _data["lunarDate"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            (this as any).dateString = _data["dateString"] !== undefined ? _data["dateString"] : null as any;
        }
    }

    static fromJS(data: any): CalendarDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["date"] = this.date ? this.date.toISOString() : null as any;
        data["holidayName"] = this.holidayName !== undefined ? this.holidayName : null as any;
        data["holidayDays"] = this.holidayDays !== undefined ? this.holidayDays : null as any;
        data["holiday"] = this.holiday !== undefined ? this.holiday : null as any;
        data["weekend"] = this.weekend !== undefined ? this.weekend : null as any;
        data["workDay"] = this.workDay !== undefined ? this.workDay : null as any;
        data["week"] = this.week !== undefined ? this.week : null as any;
        data["lunarDate"] = this.lunarDate !== undefined ? this.lunarDate : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["dateString"] = this.dateString !== undefined ? this.dateString : null as any;
        return data;
    }
}

export class ChangePasswordDto {
    currentPassword!: string;
    newPassword!: string;

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"] !== undefined ? _data["currentPassword"] : null as any;
            this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : null as any;
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword !== undefined ? this.currentPassword : null as any;
        data["newPassword"] = this.newPassword !== undefined ? this.newPassword : null as any;
        return data;
    }
}

export class ChangeUiThemeInput {
    theme!: string;

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"] !== undefined ? _data["theme"] : null as any;
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme !== undefined ? this.theme : null as any;
        return data;
    }
}

export class ChangeUserLanguageDto {
    languageName!: string;

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"] !== undefined ? _data["languageName"] : null as any;
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName !== undefined ? this.languageName : null as any;
        return data;
    }
}

export class ContentDisposition {
    dispositionType!: string | null;
    readonly parameters!: any[] | null;
    fileName!: string | null;
    creationDate!: moment.Moment;
    modificationDate!: moment.Moment;
    inline!: boolean;
    readDate!: moment.Moment;
    size!: number;

    init(_data?: any) {
        if (_data) {
            this.dispositionType = _data["dispositionType"] !== undefined ? _data["dispositionType"] : null as any;
            if (Array.isArray(_data["parameters"])) {
                (this as any).parameters = [] as any;
                for (let item of _data["parameters"])
                    (this as any).parameters!.push(item);
            }
            else {
                (this as any).parameters = null as any;
            }
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : null as any;
            this.modificationDate = _data["modificationDate"] ? moment(_data["modificationDate"].toString()) : null as any;
            this.inline = _data["inline"] !== undefined ? _data["inline"] : null as any;
            this.readDate = _data["readDate"] ? moment(_data["readDate"].toString()) : null as any;
            this.size = _data["size"] !== undefined ? _data["size"] : null as any;
        }
    }

    static fromJS(data: any): ContentDisposition {
        data = typeof data === 'object' ? data : {};
        let result = new ContentDisposition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dispositionType"] = this.dispositionType !== undefined ? this.dispositionType : null as any;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item);
        }
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null as any;
        data["modificationDate"] = this.modificationDate ? this.modificationDate.toISOString() : null as any;
        data["inline"] = this.inline !== undefined ? this.inline : null as any;
        data["readDate"] = this.readDate ? this.readDate.toISOString() : null as any;
        data["size"] = this.size !== undefined ? this.size : null as any;
        return data;
    }
}

export class ContentType {
    boundary!: string | null;
    charSet!: string | null;
    mediaType!: string | null;
    name!: string | null;
    readonly parameters!: any[] | null;

    init(_data?: any) {
        if (_data) {
            this.boundary = _data["boundary"] !== undefined ? _data["boundary"] : null as any;
            this.charSet = _data["charSet"] !== undefined ? _data["charSet"] : null as any;
            this.mediaType = _data["mediaType"] !== undefined ? _data["mediaType"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["parameters"])) {
                (this as any).parameters = [] as any;
                for (let item of _data["parameters"])
                    (this as any).parameters!.push(item);
            }
            else {
                (this as any).parameters = null as any;
            }
        }
    }

    static fromJS(data: any): ContentType {
        data = typeof data === 'object' ? data : {};
        let result = new ContentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boundary"] = this.boundary !== undefined ? this.boundary : null as any;
        data["charSet"] = this.charSet !== undefined ? this.charSet : null as any;
        data["mediaType"] = this.mediaType !== undefined ? this.mediaType : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item);
        }
        return data;
    }
}

export class CreateOrEditCustomerInfoDto {
    id!: string | null;
    cusNo!: string;
    application!: string | null;
    channel!: string | null;
    industryUsage!: string | null;
    cusAdrName!: string | null;
    cusAdrRoad!: string | null;
    invAdrName!: string | null;
    delAdrName!: string | null;
    delAdrRoad!: string | null;
    mdmCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.cusNo = _data["cusNo"] !== undefined ? _data["cusNo"] : null as any;
            this.application = _data["application"] !== undefined ? _data["application"] : null as any;
            this.channel = _data["channel"] !== undefined ? _data["channel"] : null as any;
            this.industryUsage = _data["industryUsage"] !== undefined ? _data["industryUsage"] : null as any;
            this.cusAdrName = _data["cusAdrName"] !== undefined ? _data["cusAdrName"] : null as any;
            this.cusAdrRoad = _data["cusAdrRoad"] !== undefined ? _data["cusAdrRoad"] : null as any;
            this.invAdrName = _data["invAdrName"] !== undefined ? _data["invAdrName"] : null as any;
            this.delAdrName = _data["delAdrName"] !== undefined ? _data["delAdrName"] : null as any;
            this.delAdrRoad = _data["delAdrRoad"] !== undefined ? _data["delAdrRoad"] : null as any;
            this.mdmCode = _data["mdmCode"] !== undefined ? _data["mdmCode"] : null as any;
        }
    }

    static fromJS(data: any): CreateOrEditCustomerInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCustomerInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["cusNo"] = this.cusNo !== undefined ? this.cusNo : null as any;
        data["application"] = this.application !== undefined ? this.application : null as any;
        data["channel"] = this.channel !== undefined ? this.channel : null as any;
        data["industryUsage"] = this.industryUsage !== undefined ? this.industryUsage : null as any;
        data["cusAdrName"] = this.cusAdrName !== undefined ? this.cusAdrName : null as any;
        data["cusAdrRoad"] = this.cusAdrRoad !== undefined ? this.cusAdrRoad : null as any;
        data["invAdrName"] = this.invAdrName !== undefined ? this.invAdrName : null as any;
        data["delAdrName"] = this.delAdrName !== undefined ? this.delAdrName : null as any;
        data["delAdrRoad"] = this.delAdrRoad !== undefined ? this.delAdrRoad : null as any;
        data["mdmCode"] = this.mdmCode !== undefined ? this.mdmCode : null as any;
        return data;
    }
}

export class CreateOrEditEUDto {
    id!: string | null;
    customerNumber!: string;
    country!: string | null;
    nameCN!: string | null;
    nameEN!: string | null;
    city!: string | null;
    district!: string | null;
    street!: string | null;
    telephone!: string | null;
    fax!: string | null;
    contactName!: string | null;
    contactEmail!: string | null;
    customerInfoCusNo!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.customerNumber = _data["customerNumber"] !== undefined ? _data["customerNumber"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.nameCN = _data["nameCN"] !== undefined ? _data["nameCN"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.district = _data["district"] !== undefined ? _data["district"] : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.telephone = _data["telephone"] !== undefined ? _data["telephone"] : null as any;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : null as any;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : null as any;
            this.contactEmail = _data["contactEmail"] !== undefined ? _data["contactEmail"] : null as any;
            this.customerInfoCusNo = _data["customerInfoCusNo"] !== undefined ? _data["customerInfoCusNo"] : null as any;
        }
    }

    static fromJS(data: any): CreateOrEditEUDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEUDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["customerNumber"] = this.customerNumber !== undefined ? this.customerNumber : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["nameCN"] = this.nameCN !== undefined ? this.nameCN : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["district"] = this.district !== undefined ? this.district : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["telephone"] = this.telephone !== undefined ? this.telephone : null as any;
        data["fax"] = this.fax !== undefined ? this.fax : null as any;
        data["contactName"] = this.contactName !== undefined ? this.contactName : null as any;
        data["contactEmail"] = this.contactEmail !== undefined ? this.contactEmail : null as any;
        data["customerInfoCusNo"] = this.customerInfoCusNo !== undefined ? this.customerInfoCusNo : null as any;
        return data;
    }
}

export class CreateOrEditMultiplierDto {
    id!: number | null;
    preCalNo!: string;
    defaultMultiplier!: number;
    seriesMultiplier!: { [key: string]: number; } | null;
    expiredTime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.preCalNo = _data["preCalNo"] !== undefined ? _data["preCalNo"] : null as any;
            this.defaultMultiplier = _data["defaultMultiplier"] !== undefined ? _data["defaultMultiplier"] : null as any;
            if (_data["seriesMultiplier"]) {
                this.seriesMultiplier = {} as any;
                for (let key in _data["seriesMultiplier"]) {
                    if (_data["seriesMultiplier"].hasOwnProperty(key))
                        (this.seriesMultiplier as any)![key] = _data["seriesMultiplier"][key] !== undefined ? _data["seriesMultiplier"][key] : null as any;
                }
            }
            else {
                this.seriesMultiplier = null as any;
            }
            this.expiredTime = _data["expiredTime"] ? moment(_data["expiredTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): CreateOrEditMultiplierDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMultiplierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["preCalNo"] = this.preCalNo !== undefined ? this.preCalNo : null as any;
        data["defaultMultiplier"] = this.defaultMultiplier !== undefined ? this.defaultMultiplier : null as any;
        if (this.seriesMultiplier) {
            data["seriesMultiplier"] = {};
            for (let key in this.seriesMultiplier) {
                if (this.seriesMultiplier.hasOwnProperty(key))
                    (data["seriesMultiplier"] as any)[key] = this.seriesMultiplier[key] !== undefined ? this.seriesMultiplier[key] : null as any;
            }
        }
        data["expiredTime"] = this.expiredTime ? this.expiredTime.toISOString() : null as any;
        return data;
    }
}

export class CreateRoleDto {
    name!: string;
    displayName!: string;
    normalizedName!: string | null;
    description!: string | null;
    level!: number;
    grantedPermissions!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null as any;
            this.normalizedName = _data["normalizedName"] !== undefined ? _data["normalizedName"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.level = _data["level"] !== undefined ? _data["level"] : null as any;
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
            else {
                this.grantedPermissions = null as any;
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        data["normalizedName"] = this.normalizedName !== undefined ? this.normalizedName : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["level"] = this.level !== undefined ? this.level : null as any;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }
}

export class CreateUserDto {
    id!: number;
    companyName!: string | null;
    userName!: string;
    name!: string;
    surname!: string;
    emailAddress!: string;
    isActive!: boolean;
    fullName!: string | null;
    lastLoginTime!: moment.Moment | null;
    readonly lastLoginTimeString!: string | null;
    creationTime!: moment.Moment;
    roleNames!: string[] | null;
    roleDisplayName!: string[] | null;
    customerInfoCusNo!: string | null;
    salesCusNos!: string[] | null;
    isDisabled!: boolean;
    isLock!: boolean;
    identiFierId!: string | null;
    password!: string | null;
    readonly shouldChangePasswordOnNextLogin!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : null as any;
            (this as any).lastLoginTimeString = _data["lastLoginTimeString"] !== undefined ? _data["lastLoginTimeString"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            else {
                this.roleNames = null as any;
            }
            if (Array.isArray(_data["roleDisplayName"])) {
                this.roleDisplayName = [] as any;
                for (let item of _data["roleDisplayName"])
                    this.roleDisplayName!.push(item);
            }
            else {
                this.roleDisplayName = null as any;
            }
            this.customerInfoCusNo = _data["customerInfoCusNo"] !== undefined ? _data["customerInfoCusNo"] : null as any;
            if (Array.isArray(_data["salesCusNos"])) {
                this.salesCusNos = [] as any;
                for (let item of _data["salesCusNos"])
                    this.salesCusNos!.push(item);
            }
            else {
                this.salesCusNos = null as any;
            }
            this.isDisabled = _data["isDisabled"] !== undefined ? _data["isDisabled"] : null as any;
            this.isLock = _data["isLock"] !== undefined ? _data["isLock"] : null as any;
            this.identiFierId = _data["identiFierId"] !== undefined ? _data["identiFierId"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
            (this as any).shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"] !== undefined ? _data["shouldChangePasswordOnNextLogin"] : null as any;
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["surname"] = this.surname !== undefined ? this.surname : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : null as any;
        data["lastLoginTimeString"] = this.lastLoginTimeString !== undefined ? this.lastLoginTimeString : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        if (Array.isArray(this.roleDisplayName)) {
            data["roleDisplayName"] = [];
            for (let item of this.roleDisplayName)
                data["roleDisplayName"].push(item);
        }
        data["customerInfoCusNo"] = this.customerInfoCusNo !== undefined ? this.customerInfoCusNo : null as any;
        if (Array.isArray(this.salesCusNos)) {
            data["salesCusNos"] = [];
            for (let item of this.salesCusNos)
                data["salesCusNos"].push(item);
        }
        data["isDisabled"] = this.isDisabled !== undefined ? this.isDisabled : null as any;
        data["isLock"] = this.isLock !== undefined ? this.isLock : null as any;
        data["identiFierId"] = this.identiFierId !== undefined ? this.identiFierId : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin !== undefined ? this.shouldChangePasswordOnNextLogin : null as any;
        return data;
    }
}

/** 币种 */
export class CurrencyDto {
    id!: string;
    /** 遵循ISO 4217标准的三位字母货币代码，确保每种货币有一个唯一的缩写。 */
    code!: string | null;
    /** 货币符号 */
    symbol!: string | null;
    /** 货币的英文名称。 */
    name_EN!: string | null;
    /** 货币的中文名称。 */
    name_ZH!: string | null;
    /** 流通 */
    inCirculation!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.symbol = _data["symbol"] !== undefined ? _data["symbol"] : null as any;
            this.name_EN = _data["name_EN"] !== undefined ? _data["name_EN"] : null as any;
            this.name_ZH = _data["name_ZH"] !== undefined ? _data["name_ZH"] : null as any;
            this.inCirculation = _data["inCirculation"] !== undefined ? _data["inCirculation"] : null as any;
        }
    }

    static fromJS(data: any): CurrencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["symbol"] = this.symbol !== undefined ? this.symbol : null as any;
        data["name_EN"] = this.name_EN !== undefined ? this.name_EN : null as any;
        data["name_ZH"] = this.name_ZH !== undefined ? this.name_ZH : null as any;
        data["inCirculation"] = this.inCirculation !== undefined ? this.inCirculation : null as any;
        return data;
    }
}

export class CustomeCpDto {
    id!: number;
    name!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): CustomeCpDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomeCpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export class CustomerInfo {
    id!: string | null;
    shortName!: string | null;
    language!: string | null;
    country!: string | null;
    currency!: string | null;
    partDelAccept!: number | null;
    termsOfDel!: string | null;
    termsOfPayment!: string | null;
    meansOfTrp!: string | null;
    mainResponsibleSRU!: string | null;
    su!: string | null;
    application!: string | null;
    channel!: string | null;
    industryUsage!: string | null;
    cusAdrName!: string | null;
    cusAdrRoad!: string | null;
    cusAdrPostCode!: string | null;
    cusAdrTown!: string | null;
    cusAdrCountry!: string | null;
    cusAdrPhone!: string | null;
    invAdrName!: string | null;
    invAdrRoad!: string | null;
    invAdrPostCode!: string | null;
    invAdrTown!: string | null;
    invAdrCountry!: string | null;
    invAdrPhone!: string | null;
    delAdrName!: string | null;
    delAdrRoad!: string | null;
    delAdrPostCode!: string | null;
    delAdrTown!: string | null;
    delAdrCountry!: string | null;
    delAdrPhone!: string | null;
    delAdrContactPerson!: string | null;
    customerMultiplier!: CustomerMultiplier;
    euAddresses!: EU[] | null;
    customerSales!: CustomerSales[] | null;
    customerCps!: User[] | null;
    mdmCode!: string | null;
    sapCode!: string | null;
    dataType!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
            this.partDelAccept = _data["partDelAccept"] !== undefined ? _data["partDelAccept"] : null as any;
            this.termsOfDel = _data["termsOfDel"] !== undefined ? _data["termsOfDel"] : null as any;
            this.termsOfPayment = _data["termsOfPayment"] !== undefined ? _data["termsOfPayment"] : null as any;
            this.meansOfTrp = _data["meansOfTrp"] !== undefined ? _data["meansOfTrp"] : null as any;
            this.mainResponsibleSRU = _data["mainResponsibleSRU"] !== undefined ? _data["mainResponsibleSRU"] : null as any;
            this.su = _data["su"] !== undefined ? _data["su"] : null as any;
            this.application = _data["application"] !== undefined ? _data["application"] : null as any;
            this.channel = _data["channel"] !== undefined ? _data["channel"] : null as any;
            this.industryUsage = _data["industryUsage"] !== undefined ? _data["industryUsage"] : null as any;
            this.cusAdrName = _data["cusAdrName"] !== undefined ? _data["cusAdrName"] : null as any;
            this.cusAdrRoad = _data["cusAdrRoad"] !== undefined ? _data["cusAdrRoad"] : null as any;
            this.cusAdrPostCode = _data["cusAdrPostCode"] !== undefined ? _data["cusAdrPostCode"] : null as any;
            this.cusAdrTown = _data["cusAdrTown"] !== undefined ? _data["cusAdrTown"] : null as any;
            this.cusAdrCountry = _data["cusAdrCountry"] !== undefined ? _data["cusAdrCountry"] : null as any;
            this.cusAdrPhone = _data["cusAdrPhone"] !== undefined ? _data["cusAdrPhone"] : null as any;
            this.invAdrName = _data["invAdrName"] !== undefined ? _data["invAdrName"] : null as any;
            this.invAdrRoad = _data["invAdrRoad"] !== undefined ? _data["invAdrRoad"] : null as any;
            this.invAdrPostCode = _data["invAdrPostCode"] !== undefined ? _data["invAdrPostCode"] : null as any;
            this.invAdrTown = _data["invAdrTown"] !== undefined ? _data["invAdrTown"] : null as any;
            this.invAdrCountry = _data["invAdrCountry"] !== undefined ? _data["invAdrCountry"] : null as any;
            this.invAdrPhone = _data["invAdrPhone"] !== undefined ? _data["invAdrPhone"] : null as any;
            this.delAdrName = _data["delAdrName"] !== undefined ? _data["delAdrName"] : null as any;
            this.delAdrRoad = _data["delAdrRoad"] !== undefined ? _data["delAdrRoad"] : null as any;
            this.delAdrPostCode = _data["delAdrPostCode"] !== undefined ? _data["delAdrPostCode"] : null as any;
            this.delAdrTown = _data["delAdrTown"] !== undefined ? _data["delAdrTown"] : null as any;
            this.delAdrCountry = _data["delAdrCountry"] !== undefined ? _data["delAdrCountry"] : null as any;
            this.delAdrPhone = _data["delAdrPhone"] !== undefined ? _data["delAdrPhone"] : null as any;
            this.delAdrContactPerson = _data["delAdrContactPerson"] !== undefined ? _data["delAdrContactPerson"] : null as any;
            this.customerMultiplier = _data["customerMultiplier"] ? CustomerMultiplier.fromJS(_data["customerMultiplier"]) : null as any;
            if (Array.isArray(_data["euAddresses"])) {
                this.euAddresses = [] as any;
                for (let item of _data["euAddresses"])
                    this.euAddresses!.push(EU.fromJS(item));
            }
            else {
                this.euAddresses = null as any;
            }
            if (Array.isArray(_data["customerSales"])) {
                this.customerSales = [] as any;
                for (let item of _data["customerSales"])
                    this.customerSales!.push(CustomerSales.fromJS(item));
            }
            else {
                this.customerSales = null as any;
            }
            if (Array.isArray(_data["customerCps"])) {
                this.customerCps = [] as any;
                for (let item of _data["customerCps"])
                    this.customerCps!.push(User.fromJS(item));
            }
            else {
                this.customerCps = null as any;
            }
            this.mdmCode = _data["mdmCode"] !== undefined ? _data["mdmCode"] : null as any;
            this.sapCode = _data["sapCode"] !== undefined ? _data["sapCode"] : null as any;
            this.dataType = _data["dataType"] !== undefined ? _data["dataType"] : null as any;
        }
    }

    static fromJS(data: any): CustomerInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["shortName"] = this.shortName !== undefined ? this.shortName : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        data["partDelAccept"] = this.partDelAccept !== undefined ? this.partDelAccept : null as any;
        data["termsOfDel"] = this.termsOfDel !== undefined ? this.termsOfDel : null as any;
        data["termsOfPayment"] = this.termsOfPayment !== undefined ? this.termsOfPayment : null as any;
        data["meansOfTrp"] = this.meansOfTrp !== undefined ? this.meansOfTrp : null as any;
        data["mainResponsibleSRU"] = this.mainResponsibleSRU !== undefined ? this.mainResponsibleSRU : null as any;
        data["su"] = this.su !== undefined ? this.su : null as any;
        data["application"] = this.application !== undefined ? this.application : null as any;
        data["channel"] = this.channel !== undefined ? this.channel : null as any;
        data["industryUsage"] = this.industryUsage !== undefined ? this.industryUsage : null as any;
        data["cusAdrName"] = this.cusAdrName !== undefined ? this.cusAdrName : null as any;
        data["cusAdrRoad"] = this.cusAdrRoad !== undefined ? this.cusAdrRoad : null as any;
        data["cusAdrPostCode"] = this.cusAdrPostCode !== undefined ? this.cusAdrPostCode : null as any;
        data["cusAdrTown"] = this.cusAdrTown !== undefined ? this.cusAdrTown : null as any;
        data["cusAdrCountry"] = this.cusAdrCountry !== undefined ? this.cusAdrCountry : null as any;
        data["cusAdrPhone"] = this.cusAdrPhone !== undefined ? this.cusAdrPhone : null as any;
        data["invAdrName"] = this.invAdrName !== undefined ? this.invAdrName : null as any;
        data["invAdrRoad"] = this.invAdrRoad !== undefined ? this.invAdrRoad : null as any;
        data["invAdrPostCode"] = this.invAdrPostCode !== undefined ? this.invAdrPostCode : null as any;
        data["invAdrTown"] = this.invAdrTown !== undefined ? this.invAdrTown : null as any;
        data["invAdrCountry"] = this.invAdrCountry !== undefined ? this.invAdrCountry : null as any;
        data["invAdrPhone"] = this.invAdrPhone !== undefined ? this.invAdrPhone : null as any;
        data["delAdrName"] = this.delAdrName !== undefined ? this.delAdrName : null as any;
        data["delAdrRoad"] = this.delAdrRoad !== undefined ? this.delAdrRoad : null as any;
        data["delAdrPostCode"] = this.delAdrPostCode !== undefined ? this.delAdrPostCode : null as any;
        data["delAdrTown"] = this.delAdrTown !== undefined ? this.delAdrTown : null as any;
        data["delAdrCountry"] = this.delAdrCountry !== undefined ? this.delAdrCountry : null as any;
        data["delAdrPhone"] = this.delAdrPhone !== undefined ? this.delAdrPhone : null as any;
        data["delAdrContactPerson"] = this.delAdrContactPerson !== undefined ? this.delAdrContactPerson : null as any;
        data["customerMultiplier"] = this.customerMultiplier ? this.customerMultiplier.toJSON() : null as any;
        if (Array.isArray(this.euAddresses)) {
            data["euAddresses"] = [];
            for (let item of this.euAddresses)
                data["euAddresses"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.customerSales)) {
            data["customerSales"] = [];
            for (let item of this.customerSales)
                data["customerSales"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.customerCps)) {
            data["customerCps"] = [];
            for (let item of this.customerCps)
                data["customerCps"].push(item ? item.toJSON() : null as any);
        }
        data["mdmCode"] = this.mdmCode !== undefined ? this.mdmCode : null as any;
        data["sapCode"] = this.sapCode !== undefined ? this.sapCode : null as any;
        data["dataType"] = this.dataType !== undefined ? this.dataType : null as any;
        return data;
    }
}

export class CustomerInfoDto {
    id!: string | null;
    cusNo!: string | null;
    application!: string | null;
    channel!: string | null;
    industryUsage!: string | null;
    cusAdrName!: string | null;
    cusAdrRoad!: string | null;
    invAdrName!: string | null;
    delAdrName!: string | null;
    delAdrRoad!: string | null;
    preCalNo!: string | null;
    customerMultiplierDefaultMultiplier!: number;
    customerMultiplierSeriesMultiplier!: { [key: string]: number; } | null;
    customerMultiplierExpiredTime!: moment.Moment | null;
    customerMultiplierIsActive!: boolean;
    mdmCode!: string | null;
    sapCode!: string | null;
    dataType!: string | null;
    customerSales!: CustomerSaleDto[] | null;
    customerCps!: CustomeCpDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.cusNo = _data["cusNo"] !== undefined ? _data["cusNo"] : null as any;
            this.application = _data["application"] !== undefined ? _data["application"] : null as any;
            this.channel = _data["channel"] !== undefined ? _data["channel"] : null as any;
            this.industryUsage = _data["industryUsage"] !== undefined ? _data["industryUsage"] : null as any;
            this.cusAdrName = _data["cusAdrName"] !== undefined ? _data["cusAdrName"] : null as any;
            this.cusAdrRoad = _data["cusAdrRoad"] !== undefined ? _data["cusAdrRoad"] : null as any;
            this.invAdrName = _data["invAdrName"] !== undefined ? _data["invAdrName"] : null as any;
            this.delAdrName = _data["delAdrName"] !== undefined ? _data["delAdrName"] : null as any;
            this.delAdrRoad = _data["delAdrRoad"] !== undefined ? _data["delAdrRoad"] : null as any;
            this.preCalNo = _data["preCalNo"] !== undefined ? _data["preCalNo"] : null as any;
            this.customerMultiplierDefaultMultiplier = _data["customerMultiplierDefaultMultiplier"] !== undefined ? _data["customerMultiplierDefaultMultiplier"] : null as any;
            if (_data["customerMultiplierSeriesMultiplier"]) {
                this.customerMultiplierSeriesMultiplier = {} as any;
                for (let key in _data["customerMultiplierSeriesMultiplier"]) {
                    if (_data["customerMultiplierSeriesMultiplier"].hasOwnProperty(key))
                        (this.customerMultiplierSeriesMultiplier as any)![key] = _data["customerMultiplierSeriesMultiplier"][key] !== undefined ? _data["customerMultiplierSeriesMultiplier"][key] : null as any;
                }
            }
            else {
                this.customerMultiplierSeriesMultiplier = null as any;
            }
            this.customerMultiplierExpiredTime = _data["customerMultiplierExpiredTime"] ? moment(_data["customerMultiplierExpiredTime"].toString()) : null as any;
            this.customerMultiplierIsActive = _data["customerMultiplierIsActive"] !== undefined ? _data["customerMultiplierIsActive"] : null as any;
            this.mdmCode = _data["mdmCode"] !== undefined ? _data["mdmCode"] : null as any;
            this.sapCode = _data["sapCode"] !== undefined ? _data["sapCode"] : null as any;
            this.dataType = _data["dataType"] !== undefined ? _data["dataType"] : null as any;
            if (Array.isArray(_data["customerSales"])) {
                this.customerSales = [] as any;
                for (let item of _data["customerSales"])
                    this.customerSales!.push(CustomerSaleDto.fromJS(item));
            }
            else {
                this.customerSales = null as any;
            }
            if (Array.isArray(_data["customerCps"])) {
                this.customerCps = [] as any;
                for (let item of _data["customerCps"])
                    this.customerCps!.push(CustomeCpDto.fromJS(item));
            }
            else {
                this.customerCps = null as any;
            }
        }
    }

    static fromJS(data: any): CustomerInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["cusNo"] = this.cusNo !== undefined ? this.cusNo : null as any;
        data["application"] = this.application !== undefined ? this.application : null as any;
        data["channel"] = this.channel !== undefined ? this.channel : null as any;
        data["industryUsage"] = this.industryUsage !== undefined ? this.industryUsage : null as any;
        data["cusAdrName"] = this.cusAdrName !== undefined ? this.cusAdrName : null as any;
        data["cusAdrRoad"] = this.cusAdrRoad !== undefined ? this.cusAdrRoad : null as any;
        data["invAdrName"] = this.invAdrName !== undefined ? this.invAdrName : null as any;
        data["delAdrName"] = this.delAdrName !== undefined ? this.delAdrName : null as any;
        data["delAdrRoad"] = this.delAdrRoad !== undefined ? this.delAdrRoad : null as any;
        data["preCalNo"] = this.preCalNo !== undefined ? this.preCalNo : null as any;
        data["customerMultiplierDefaultMultiplier"] = this.customerMultiplierDefaultMultiplier !== undefined ? this.customerMultiplierDefaultMultiplier : null as any;
        if (this.customerMultiplierSeriesMultiplier) {
            data["customerMultiplierSeriesMultiplier"] = {};
            for (let key in this.customerMultiplierSeriesMultiplier) {
                if (this.customerMultiplierSeriesMultiplier.hasOwnProperty(key))
                    (data["customerMultiplierSeriesMultiplier"] as any)[key] = this.customerMultiplierSeriesMultiplier[key] !== undefined ? this.customerMultiplierSeriesMultiplier[key] : null as any;
            }
        }
        data["customerMultiplierExpiredTime"] = this.customerMultiplierExpiredTime ? this.customerMultiplierExpiredTime.toISOString() : null as any;
        data["customerMultiplierIsActive"] = this.customerMultiplierIsActive !== undefined ? this.customerMultiplierIsActive : null as any;
        data["mdmCode"] = this.mdmCode !== undefined ? this.mdmCode : null as any;
        data["sapCode"] = this.sapCode !== undefined ? this.sapCode : null as any;
        data["dataType"] = this.dataType !== undefined ? this.dataType : null as any;
        if (Array.isArray(this.customerSales)) {
            data["customerSales"] = [];
            for (let item of this.customerSales)
                data["customerSales"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.customerCps)) {
            data["customerCps"] = [];
            for (let item of this.customerCps)
                data["customerCps"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class CustomerJINCodeDto {
    customerCode!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 客户渠道编码 */
    customerChannelCode!: string | null;
    /** 客户渠道名称 */
    customerChannelName!: string | null;
    /** JIN编码 */
    jinCustomerCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.customerChannelCode = _data["customerChannelCode"] !== undefined ? _data["customerChannelCode"] : null as any;
            this.customerChannelName = _data["customerChannelName"] !== undefined ? _data["customerChannelName"] : null as any;
            this.jinCustomerCode = _data["jinCustomerCode"] !== undefined ? _data["jinCustomerCode"] : null as any;
        }
    }

    static fromJS(data: any): CustomerJINCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerJINCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["customerChannelCode"] = this.customerChannelCode !== undefined ? this.customerChannelCode : null as any;
        data["customerChannelName"] = this.customerChannelName !== undefined ? this.customerChannelName : null as any;
        data["jinCustomerCode"] = this.jinCustomerCode !== undefined ? this.jinCustomerCode : null as any;
        return data;
    }
}

export class CustomerJINCodeDtoPagedResultDto {
    items!: CustomerJINCodeDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustomerJINCodeDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): CustomerJINCodeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerJINCodeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class CustomerJINCodeInfo {
    /** 二级客户代码 */
    customerCode!: string | null;
    /** 渠道客户代码 */
    channelCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.channelCode = _data["channelCode"] !== undefined ? _data["channelCode"] : null as any;
        }
    }

    static fromJS(data: any): CustomerJINCodeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerJINCodeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["channelCode"] = this.channelCode !== undefined ? this.channelCode : null as any;
        return data;
    }
}

export class CustomerJINCodeInputDto {
    customerJINCodeInfos!: CustomerJINCodeInfo[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customerJINCodeInfos"])) {
                this.customerJINCodeInfos = [] as any;
                for (let item of _data["customerJINCodeInfos"])
                    this.customerJINCodeInfos!.push(CustomerJINCodeInfo.fromJS(item));
            }
            else {
                this.customerJINCodeInfos = null as any;
            }
        }
    }

    static fromJS(data: any): CustomerJINCodeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerJINCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customerJINCodeInfos)) {
            data["customerJINCodeInfos"] = [];
            for (let item of this.customerJINCodeInfos)
                data["customerJINCodeInfos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class CustomerMultiplier {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    preCalNo!: string;
    defaultMultiplier!: number;
    seriesMultiplier!: { [key: string]: number; } | null;
    expiredTime!: moment.Moment | null;
    isActive!: boolean;
    customerInfoCusNoFk!: string | null;
    customerInfo!: CustomerInfo;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.preCalNo = _data["preCalNo"] !== undefined ? _data["preCalNo"] : null as any;
            this.defaultMultiplier = _data["defaultMultiplier"] !== undefined ? _data["defaultMultiplier"] : null as any;
            if (_data["seriesMultiplier"]) {
                this.seriesMultiplier = {} as any;
                for (let key in _data["seriesMultiplier"]) {
                    if (_data["seriesMultiplier"].hasOwnProperty(key))
                        (this.seriesMultiplier as any)![key] = _data["seriesMultiplier"][key] !== undefined ? _data["seriesMultiplier"][key] : null as any;
                }
            }
            else {
                this.seriesMultiplier = null as any;
            }
            this.expiredTime = _data["expiredTime"] ? moment(_data["expiredTime"].toString()) : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            this.customerInfoCusNoFk = _data["customerInfoCusNoFk"] !== undefined ? _data["customerInfoCusNoFk"] : null as any;
            this.customerInfo = _data["customerInfo"] ? CustomerInfo.fromJS(_data["customerInfo"]) : null as any;
        }
    }

    static fromJS(data: any): CustomerMultiplier {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerMultiplier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["preCalNo"] = this.preCalNo !== undefined ? this.preCalNo : null as any;
        data["defaultMultiplier"] = this.defaultMultiplier !== undefined ? this.defaultMultiplier : null as any;
        if (this.seriesMultiplier) {
            data["seriesMultiplier"] = {};
            for (let key in this.seriesMultiplier) {
                if (this.seriesMultiplier.hasOwnProperty(key))
                    (data["seriesMultiplier"] as any)[key] = this.seriesMultiplier[key] !== undefined ? this.seriesMultiplier[key] : null as any;
            }
        }
        data["expiredTime"] = this.expiredTime ? this.expiredTime.toISOString() : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        data["customerInfoCusNoFk"] = this.customerInfoCusNoFk !== undefined ? this.customerInfoCusNoFk : null as any;
        data["customerInfo"] = this.customerInfo ? this.customerInfo.toJSON() : null as any;
        return data;
    }
}

export class CustomerSaleDto {
    id!: number;
    name!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): CustomerSaleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSaleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export class CustomerSales {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    cusNo!: string | null;
    customer!: CustomerInfo;
    saleId!: number;
    sale!: User;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.cusNo = _data["cusNo"] !== undefined ? _data["cusNo"] : null as any;
            this.customer = _data["customer"] ? CustomerInfo.fromJS(_data["customer"]) : null as any;
            this.saleId = _data["saleId"] !== undefined ? _data["saleId"] : null as any;
            this.sale = _data["sale"] ? User.fromJS(_data["sale"]) : null as any;
        }
    }

    static fromJS(data: any): CustomerSales {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSales();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["cusNo"] = this.cusNo !== undefined ? this.cusNo : null as any;
        data["customer"] = this.customer ? this.customer.toJSON() : null as any;
        data["saleId"] = this.saleId !== undefined ? this.saleId : null as any;
        data["sale"] = this.sale ? this.sale.toJSON() : null as any;
        return data;
    }
}

export class DecoderFallback {
    readonly maxCharCount!: number;

    init(_data?: any) {
        if (_data) {
            (this as any).maxCharCount = _data["maxCharCount"] !== undefined ? _data["maxCharCount"] : null as any;
        }
    }

    static fromJS(data: any): DecoderFallback {
        data = typeof data === 'object' ? data : {};
        let result = new DecoderFallback();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxCharCount"] = this.maxCharCount !== undefined ? this.maxCharCount : null as any;
        return data;
    }
}

export class DnsExternalLoginCreateInput {
    userName!: string;
    password!: string;

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
        }
    }

    static fromJS(data: any): DnsExternalLoginCreateInput {
        data = typeof data === 'object' ? data : {};
        let result = new DnsExternalLoginCreateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        return data;
    }
}

export class DnsExternalLoginEntryInput {
    appId!: string;
    /** 明文为 unix秒|随机串。AES-256-CBC，密钥是 secret 的 SHA256，16 字节 IV 放在密文前，整体 Base64。 */
    payload!: string;

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"] !== undefined ? _data["appId"] : null as any;
            this.payload = _data["payload"] !== undefined ? _data["payload"] : null as any;
        }
    }

    static fromJS(data: any): DnsExternalLoginEntryInput {
        data = typeof data === 'object' ? data : {};
        let result = new DnsExternalLoginEntryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId !== undefined ? this.appId : null as any;
        data["payload"] = this.payload !== undefined ? this.payload : null as any;
        return data;
    }
}

export class DnsExternalLoginExchangeInput {
    key!: string;

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
        }
    }

    static fromJS(data: any): DnsExternalLoginExchangeInput {
        data = typeof data === 'object' ? data : {};
        let result = new DnsExternalLoginExchangeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        return data;
    }
}

export class DnsExternalLoginKeyResultDto {
    key!: string | null;

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
        }
    }

    static fromJS(data: any): DnsExternalLoginKeyResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DnsExternalLoginKeyResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        return data;
    }
}

export class DnsExternalLoginResultDto {
    accessToken!: string | null;
    expiresIn!: number;
    redirectPath!: string | null;

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"] !== undefined ? _data["accessToken"] : null as any;
            this.expiresIn = _data["expiresIn"] !== undefined ? _data["expiresIn"] : null as any;
            this.redirectPath = _data["redirectPath"] !== undefined ? _data["redirectPath"] : null as any;
        }
    }

    static fromJS(data: any): DnsExternalLoginResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DnsExternalLoginResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken !== undefined ? this.accessToken : null as any;
        data["expiresIn"] = this.expiresIn !== undefined ? this.expiresIn : null as any;
        data["redirectPath"] = this.redirectPath !== undefined ? this.redirectPath : null as any;
        return data;
    }
}

export class EU {
    id!: string | null;
    country!: string | null;
    nameCN!: string | null;
    nameEN!: string | null;
    city!: string | null;
    district!: string | null;
    street!: string | null;
    telephone!: string | null;
    fax!: string | null;
    contactName!: string | null;
    contactEmail!: string | null;
    customerInfoCusNo!: string | null;
    customerInfoFk!: CustomerInfo;
    euMultiplier!: EUMultiplier;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.nameCN = _data["nameCN"] !== undefined ? _data["nameCN"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.district = _data["district"] !== undefined ? _data["district"] : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.telephone = _data["telephone"] !== undefined ? _data["telephone"] : null as any;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : null as any;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : null as any;
            this.contactEmail = _data["contactEmail"] !== undefined ? _data["contactEmail"] : null as any;
            this.customerInfoCusNo = _data["customerInfoCusNo"] !== undefined ? _data["customerInfoCusNo"] : null as any;
            this.customerInfoFk = _data["customerInfoFk"] ? CustomerInfo.fromJS(_data["customerInfoFk"]) : null as any;
            this.euMultiplier = _data["euMultiplier"] ? EUMultiplier.fromJS(_data["euMultiplier"]) : null as any;
        }
    }

    static fromJS(data: any): EU {
        data = typeof data === 'object' ? data : {};
        let result = new EU();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["nameCN"] = this.nameCN !== undefined ? this.nameCN : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["district"] = this.district !== undefined ? this.district : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["telephone"] = this.telephone !== undefined ? this.telephone : null as any;
        data["fax"] = this.fax !== undefined ? this.fax : null as any;
        data["contactName"] = this.contactName !== undefined ? this.contactName : null as any;
        data["contactEmail"] = this.contactEmail !== undefined ? this.contactEmail : null as any;
        data["customerInfoCusNo"] = this.customerInfoCusNo !== undefined ? this.customerInfoCusNo : null as any;
        data["customerInfoFk"] = this.customerInfoFk ? this.customerInfoFk.toJSON() : null as any;
        data["euMultiplier"] = this.euMultiplier ? this.euMultiplier.toJSON() : null as any;
        return data;
    }
}

export class EUCustomerInfoLookupTableDto {
    id!: string | null;
    displayName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null as any;
        }
    }

    static fromJS(data: any): EUCustomerInfoLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new EUCustomerInfoLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        return data;
    }
}

export class EUDto {
    customerNumber!: string | null;
    country!: string | null;
    nameCN!: string | null;
    nameEN!: string | null;
    city!: string | null;
    district!: string | null;
    street!: string | null;
    telephone!: string | null;
    fax!: string | null;
    contactName!: string | null;
    contactEmail!: string | null;
    customerInfoCusNo!: string | null;
    preCalNo!: string | null;
    euMultiplierDefaultMultiplier!: number;
    euMultiplierSeriesMultiplier!: { [key: string]: number; } | null;
    euMultiplierExpiredTime!: moment.Moment | null;
    euMultiplierIsActive!: boolean;

    init(_data?: any) {
        if (_data) {
            this.customerNumber = _data["customerNumber"] !== undefined ? _data["customerNumber"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.nameCN = _data["nameCN"] !== undefined ? _data["nameCN"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.district = _data["district"] !== undefined ? _data["district"] : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.telephone = _data["telephone"] !== undefined ? _data["telephone"] : null as any;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : null as any;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : null as any;
            this.contactEmail = _data["contactEmail"] !== undefined ? _data["contactEmail"] : null as any;
            this.customerInfoCusNo = _data["customerInfoCusNo"] !== undefined ? _data["customerInfoCusNo"] : null as any;
            this.preCalNo = _data["preCalNo"] !== undefined ? _data["preCalNo"] : null as any;
            this.euMultiplierDefaultMultiplier = _data["euMultiplierDefaultMultiplier"] !== undefined ? _data["euMultiplierDefaultMultiplier"] : null as any;
            if (_data["euMultiplierSeriesMultiplier"]) {
                this.euMultiplierSeriesMultiplier = {} as any;
                for (let key in _data["euMultiplierSeriesMultiplier"]) {
                    if (_data["euMultiplierSeriesMultiplier"].hasOwnProperty(key))
                        (this.euMultiplierSeriesMultiplier as any)![key] = _data["euMultiplierSeriesMultiplier"][key] !== undefined ? _data["euMultiplierSeriesMultiplier"][key] : null as any;
                }
            }
            else {
                this.euMultiplierSeriesMultiplier = null as any;
            }
            this.euMultiplierExpiredTime = _data["euMultiplierExpiredTime"] ? moment(_data["euMultiplierExpiredTime"].toString()) : null as any;
            this.euMultiplierIsActive = _data["euMultiplierIsActive"] !== undefined ? _data["euMultiplierIsActive"] : null as any;
        }
    }

    static fromJS(data: any): EUDto {
        data = typeof data === 'object' ? data : {};
        let result = new EUDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerNumber"] = this.customerNumber !== undefined ? this.customerNumber : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["nameCN"] = this.nameCN !== undefined ? this.nameCN : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["district"] = this.district !== undefined ? this.district : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["telephone"] = this.telephone !== undefined ? this.telephone : null as any;
        data["fax"] = this.fax !== undefined ? this.fax : null as any;
        data["contactName"] = this.contactName !== undefined ? this.contactName : null as any;
        data["contactEmail"] = this.contactEmail !== undefined ? this.contactEmail : null as any;
        data["customerInfoCusNo"] = this.customerInfoCusNo !== undefined ? this.customerInfoCusNo : null as any;
        data["preCalNo"] = this.preCalNo !== undefined ? this.preCalNo : null as any;
        data["euMultiplierDefaultMultiplier"] = this.euMultiplierDefaultMultiplier !== undefined ? this.euMultiplierDefaultMultiplier : null as any;
        if (this.euMultiplierSeriesMultiplier) {
            data["euMultiplierSeriesMultiplier"] = {};
            for (let key in this.euMultiplierSeriesMultiplier) {
                if (this.euMultiplierSeriesMultiplier.hasOwnProperty(key))
                    (data["euMultiplierSeriesMultiplier"] as any)[key] = this.euMultiplierSeriesMultiplier[key] !== undefined ? this.euMultiplierSeriesMultiplier[key] : null as any;
            }
        }
        data["euMultiplierExpiredTime"] = this.euMultiplierExpiredTime ? this.euMultiplierExpiredTime.toISOString() : null as any;
        data["euMultiplierIsActive"] = this.euMultiplierIsActive !== undefined ? this.euMultiplierIsActive : null as any;
        return data;
    }
}

export class EUMultiplier {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    preCalNo!: string;
    defaultMultiplier!: number;
    seriesMultiplier!: { [key: string]: number; } | null;
    expiredTime!: moment.Moment | null;
    isActive!: boolean;
    customerInfoCusNoFk!: string | null;
    euCustomerNumberFk!: string | null;
    eu!: EU;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.preCalNo = _data["preCalNo"] !== undefined ? _data["preCalNo"] : null as any;
            this.defaultMultiplier = _data["defaultMultiplier"] !== undefined ? _data["defaultMultiplier"] : null as any;
            if (_data["seriesMultiplier"]) {
                this.seriesMultiplier = {} as any;
                for (let key in _data["seriesMultiplier"]) {
                    if (_data["seriesMultiplier"].hasOwnProperty(key))
                        (this.seriesMultiplier as any)![key] = _data["seriesMultiplier"][key] !== undefined ? _data["seriesMultiplier"][key] : null as any;
                }
            }
            else {
                this.seriesMultiplier = null as any;
            }
            this.expiredTime = _data["expiredTime"] ? moment(_data["expiredTime"].toString()) : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            this.customerInfoCusNoFk = _data["customerInfoCusNoFk"] !== undefined ? _data["customerInfoCusNoFk"] : null as any;
            this.euCustomerNumberFk = _data["euCustomerNumberFk"] !== undefined ? _data["euCustomerNumberFk"] : null as any;
            this.eu = _data["eu"] ? EU.fromJS(_data["eu"]) : null as any;
        }
    }

    static fromJS(data: any): EUMultiplier {
        data = typeof data === 'object' ? data : {};
        let result = new EUMultiplier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["preCalNo"] = this.preCalNo !== undefined ? this.preCalNo : null as any;
        data["defaultMultiplier"] = this.defaultMultiplier !== undefined ? this.defaultMultiplier : null as any;
        if (this.seriesMultiplier) {
            data["seriesMultiplier"] = {};
            for (let key in this.seriesMultiplier) {
                if (this.seriesMultiplier.hasOwnProperty(key))
                    (data["seriesMultiplier"] as any)[key] = this.seriesMultiplier[key] !== undefined ? this.seriesMultiplier[key] : null as any;
            }
        }
        data["expiredTime"] = this.expiredTime ? this.expiredTime.toISOString() : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        data["customerInfoCusNoFk"] = this.customerInfoCusNoFk !== undefined ? this.customerInfoCusNoFk : null as any;
        data["euCustomerNumberFk"] = this.euCustomerNumberFk !== undefined ? this.euCustomerNumberFk : null as any;
        data["eu"] = this.eu ? this.eu.toJSON() : null as any;
        return data;
    }
}

export class EmailSettingsEditDto {
    defaultFromAddress!: string | null;
    defaultFromDisplayName!: string | null;
    smtpHost!: string | null;
    smtpPort!: number;
    smtpUserName!: string | null;
    smtpPassword!: string | null;
    smtpDomain!: string | null;
    smtpEnableSsl!: boolean;
    smtpUseDefaultCredentials!: boolean;

    init(_data?: any) {
        if (_data) {
            this.defaultFromAddress = _data["defaultFromAddress"] !== undefined ? _data["defaultFromAddress"] : null as any;
            this.defaultFromDisplayName = _data["defaultFromDisplayName"] !== undefined ? _data["defaultFromDisplayName"] : null as any;
            this.smtpHost = _data["smtpHost"] !== undefined ? _data["smtpHost"] : null as any;
            this.smtpPort = _data["smtpPort"] !== undefined ? _data["smtpPort"] : null as any;
            this.smtpUserName = _data["smtpUserName"] !== undefined ? _data["smtpUserName"] : null as any;
            this.smtpPassword = _data["smtpPassword"] !== undefined ? _data["smtpPassword"] : null as any;
            this.smtpDomain = _data["smtpDomain"] !== undefined ? _data["smtpDomain"] : null as any;
            this.smtpEnableSsl = _data["smtpEnableSsl"] !== undefined ? _data["smtpEnableSsl"] : null as any;
            this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"] !== undefined ? _data["smtpUseDefaultCredentials"] : null as any;
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress !== undefined ? this.defaultFromAddress : null as any;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName !== undefined ? this.defaultFromDisplayName : null as any;
        data["smtpHost"] = this.smtpHost !== undefined ? this.smtpHost : null as any;
        data["smtpPort"] = this.smtpPort !== undefined ? this.smtpPort : null as any;
        data["smtpUserName"] = this.smtpUserName !== undefined ? this.smtpUserName : null as any;
        data["smtpPassword"] = this.smtpPassword !== undefined ? this.smtpPassword : null as any;
        data["smtpDomain"] = this.smtpDomain !== undefined ? this.smtpDomain : null as any;
        data["smtpEnableSsl"] = this.smtpEnableSsl !== undefined ? this.smtpEnableSsl : null as any;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials !== undefined ? this.smtpUseDefaultCredentials : null as any;
        return data;
    }
}

/** HR系统人员信息 */
export class EmployeeDto {
    geid!: string | null;
    employeeNumber!: string | null;
    adAccount!: string | null;
    email!: string | null;
    fullName!: string | null;
    company!: string | null;
    organizationUnitCode!: string | null;
    organizationUnitName!: string | null;
    jobCode!: string | null;
    jobName!: string | null;
    lbuCode!: string | null;
    lbuName!: string | null;
    lineManagerEmployeeNumber!: string | null;
    lineManagerFullName!: string | null;
    employeeGroupCode!: string | null;
    employeeGroupName!: string | null;
    employeeSubGroupCode!: string | null;
    employeeSubGroupName!: string | null;
    transferDate!: string | null;
    previousCompany!: string | null;
    previousOrganizationUnitCode!: string | null;
    previousOrganizationUnitName!: string | null;
    previousJobCode!: string | null;
    previousJobName!: string | null;
    previousLBUCode!: string | null;
    previousLBUName!: string | null;
    previousLineManagerEmployeeNumber!: string | null;
    previousLineManagerFullName!: string | null;
    previousEmployeeGroupCode!: string | null;
    previousEmployeeGroupName!: string | null;
    previousEmployeeSubGroupCode!: string | null;
    previousEmployeeSubGroupName!: string | null;
    dataSourceType!: string | null;
    employeeID!: string | null;
    /** 中文名 */
    chineseName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.geid = _data["geid"] !== undefined ? _data["geid"] : null as any;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.adAccount = _data["adAccount"] !== undefined ? _data["adAccount"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.company = _data["company"] !== undefined ? _data["company"] : null as any;
            this.organizationUnitCode = _data["organizationUnitCode"] !== undefined ? _data["organizationUnitCode"] : null as any;
            this.organizationUnitName = _data["organizationUnitName"] !== undefined ? _data["organizationUnitName"] : null as any;
            this.jobCode = _data["jobCode"] !== undefined ? _data["jobCode"] : null as any;
            this.jobName = _data["jobName"] !== undefined ? _data["jobName"] : null as any;
            this.lbuCode = _data["lbuCode"] !== undefined ? _data["lbuCode"] : null as any;
            this.lbuName = _data["lbuName"] !== undefined ? _data["lbuName"] : null as any;
            this.lineManagerEmployeeNumber = _data["lineManagerEmployeeNumber"] !== undefined ? _data["lineManagerEmployeeNumber"] : null as any;
            this.lineManagerFullName = _data["lineManagerFullName"] !== undefined ? _data["lineManagerFullName"] : null as any;
            this.employeeGroupCode = _data["employeeGroupCode"] !== undefined ? _data["employeeGroupCode"] : null as any;
            this.employeeGroupName = _data["employeeGroupName"] !== undefined ? _data["employeeGroupName"] : null as any;
            this.employeeSubGroupCode = _data["employeeSubGroupCode"] !== undefined ? _data["employeeSubGroupCode"] : null as any;
            this.employeeSubGroupName = _data["employeeSubGroupName"] !== undefined ? _data["employeeSubGroupName"] : null as any;
            this.transferDate = _data["transferDate"] !== undefined ? _data["transferDate"] : null as any;
            this.previousCompany = _data["previousCompany"] !== undefined ? _data["previousCompany"] : null as any;
            this.previousOrganizationUnitCode = _data["previousOrganizationUnitCode"] !== undefined ? _data["previousOrganizationUnitCode"] : null as any;
            this.previousOrganizationUnitName = _data["previousOrganizationUnitName"] !== undefined ? _data["previousOrganizationUnitName"] : null as any;
            this.previousJobCode = _data["previousJobCode"] !== undefined ? _data["previousJobCode"] : null as any;
            this.previousJobName = _data["previousJobName"] !== undefined ? _data["previousJobName"] : null as any;
            this.previousLBUCode = _data["previousLBUCode"] !== undefined ? _data["previousLBUCode"] : null as any;
            this.previousLBUName = _data["previousLBUName"] !== undefined ? _data["previousLBUName"] : null as any;
            this.previousLineManagerEmployeeNumber = _data["previousLineManagerEmployeeNumber"] !== undefined ? _data["previousLineManagerEmployeeNumber"] : null as any;
            this.previousLineManagerFullName = _data["previousLineManagerFullName"] !== undefined ? _data["previousLineManagerFullName"] : null as any;
            this.previousEmployeeGroupCode = _data["previousEmployeeGroupCode"] !== undefined ? _data["previousEmployeeGroupCode"] : null as any;
            this.previousEmployeeGroupName = _data["previousEmployeeGroupName"] !== undefined ? _data["previousEmployeeGroupName"] : null as any;
            this.previousEmployeeSubGroupCode = _data["previousEmployeeSubGroupCode"] !== undefined ? _data["previousEmployeeSubGroupCode"] : null as any;
            this.previousEmployeeSubGroupName = _data["previousEmployeeSubGroupName"] !== undefined ? _data["previousEmployeeSubGroupName"] : null as any;
            this.dataSourceType = _data["dataSourceType"] !== undefined ? _data["dataSourceType"] : null as any;
            this.employeeID = _data["employeeID"] !== undefined ? _data["employeeID"] : null as any;
            this.chineseName = _data["chineseName"] !== undefined ? _data["chineseName"] : null as any;
        }
    }

    static fromJS(data: any): EmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geid"] = this.geid !== undefined ? this.geid : null as any;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["adAccount"] = this.adAccount !== undefined ? this.adAccount : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["company"] = this.company !== undefined ? this.company : null as any;
        data["organizationUnitCode"] = this.organizationUnitCode !== undefined ? this.organizationUnitCode : null as any;
        data["organizationUnitName"] = this.organizationUnitName !== undefined ? this.organizationUnitName : null as any;
        data["jobCode"] = this.jobCode !== undefined ? this.jobCode : null as any;
        data["jobName"] = this.jobName !== undefined ? this.jobName : null as any;
        data["lbuCode"] = this.lbuCode !== undefined ? this.lbuCode : null as any;
        data["lbuName"] = this.lbuName !== undefined ? this.lbuName : null as any;
        data["lineManagerEmployeeNumber"] = this.lineManagerEmployeeNumber !== undefined ? this.lineManagerEmployeeNumber : null as any;
        data["lineManagerFullName"] = this.lineManagerFullName !== undefined ? this.lineManagerFullName : null as any;
        data["employeeGroupCode"] = this.employeeGroupCode !== undefined ? this.employeeGroupCode : null as any;
        data["employeeGroupName"] = this.employeeGroupName !== undefined ? this.employeeGroupName : null as any;
        data["employeeSubGroupCode"] = this.employeeSubGroupCode !== undefined ? this.employeeSubGroupCode : null as any;
        data["employeeSubGroupName"] = this.employeeSubGroupName !== undefined ? this.employeeSubGroupName : null as any;
        data["transferDate"] = this.transferDate !== undefined ? this.transferDate : null as any;
        data["previousCompany"] = this.previousCompany !== undefined ? this.previousCompany : null as any;
        data["previousOrganizationUnitCode"] = this.previousOrganizationUnitCode !== undefined ? this.previousOrganizationUnitCode : null as any;
        data["previousOrganizationUnitName"] = this.previousOrganizationUnitName !== undefined ? this.previousOrganizationUnitName : null as any;
        data["previousJobCode"] = this.previousJobCode !== undefined ? this.previousJobCode : null as any;
        data["previousJobName"] = this.previousJobName !== undefined ? this.previousJobName : null as any;
        data["previousLBUCode"] = this.previousLBUCode !== undefined ? this.previousLBUCode : null as any;
        data["previousLBUName"] = this.previousLBUName !== undefined ? this.previousLBUName : null as any;
        data["previousLineManagerEmployeeNumber"] = this.previousLineManagerEmployeeNumber !== undefined ? this.previousLineManagerEmployeeNumber : null as any;
        data["previousLineManagerFullName"] = this.previousLineManagerFullName !== undefined ? this.previousLineManagerFullName : null as any;
        data["previousEmployeeGroupCode"] = this.previousEmployeeGroupCode !== undefined ? this.previousEmployeeGroupCode : null as any;
        data["previousEmployeeGroupName"] = this.previousEmployeeGroupName !== undefined ? this.previousEmployeeGroupName : null as any;
        data["previousEmployeeSubGroupCode"] = this.previousEmployeeSubGroupCode !== undefined ? this.previousEmployeeSubGroupCode : null as any;
        data["previousEmployeeSubGroupName"] = this.previousEmployeeSubGroupName !== undefined ? this.previousEmployeeSubGroupName : null as any;
        data["dataSourceType"] = this.dataSourceType !== undefined ? this.dataSourceType : null as any;
        data["employeeID"] = this.employeeID !== undefined ? this.employeeID : null as any;
        data["chineseName"] = this.chineseName !== undefined ? this.chineseName : null as any;
        return data;
    }
}

export class EncoderFallback {
    readonly maxCharCount!: number;

    init(_data?: any) {
        if (_data) {
            (this as any).maxCharCount = _data["maxCharCount"] !== undefined ? _data["maxCharCount"] : null as any;
        }
    }

    static fromJS(data: any): EncoderFallback {
        data = typeof data === 'object' ? data : {};
        let result = new EncoderFallback();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxCharCount"] = this.maxCharCount !== undefined ? this.maxCharCount : null as any;
        return data;
    }
}

export class Encoding {
    preamble!: ByteReadOnlySpan;
    readonly bodyName!: string | null;
    readonly encodingName!: string | null;
    readonly headerName!: string | null;
    readonly webName!: string | null;
    readonly windowsCodePage!: number;
    readonly isBrowserDisplay!: boolean;
    readonly isBrowserSave!: boolean;
    readonly isMailNewsDisplay!: boolean;
    readonly isMailNewsSave!: boolean;
    readonly isSingleByte!: boolean;
    encoderFallback!: EncoderFallback;
    decoderFallback!: DecoderFallback;
    readonly isReadOnly!: boolean;
    readonly codePage!: number;

    init(_data?: any) {
        if (_data) {
            this.preamble = _data["preamble"] ? ByteReadOnlySpan.fromJS(_data["preamble"]) : null as any;
            (this as any).bodyName = _data["bodyName"] !== undefined ? _data["bodyName"] : null as any;
            (this as any).encodingName = _data["encodingName"] !== undefined ? _data["encodingName"] : null as any;
            (this as any).headerName = _data["headerName"] !== undefined ? _data["headerName"] : null as any;
            (this as any).webName = _data["webName"] !== undefined ? _data["webName"] : null as any;
            (this as any).windowsCodePage = _data["windowsCodePage"] !== undefined ? _data["windowsCodePage"] : null as any;
            (this as any).isBrowserDisplay = _data["isBrowserDisplay"] !== undefined ? _data["isBrowserDisplay"] : null as any;
            (this as any).isBrowserSave = _data["isBrowserSave"] !== undefined ? _data["isBrowserSave"] : null as any;
            (this as any).isMailNewsDisplay = _data["isMailNewsDisplay"] !== undefined ? _data["isMailNewsDisplay"] : null as any;
            (this as any).isMailNewsSave = _data["isMailNewsSave"] !== undefined ? _data["isMailNewsSave"] : null as any;
            (this as any).isSingleByte = _data["isSingleByte"] !== undefined ? _data["isSingleByte"] : null as any;
            this.encoderFallback = _data["encoderFallback"] ? EncoderFallback.fromJS(_data["encoderFallback"]) : null as any;
            this.decoderFallback = _data["decoderFallback"] ? DecoderFallback.fromJS(_data["decoderFallback"]) : null as any;
            (this as any).isReadOnly = _data["isReadOnly"] !== undefined ? _data["isReadOnly"] : null as any;
            (this as any).codePage = _data["codePage"] !== undefined ? _data["codePage"] : null as any;
        }
    }

    static fromJS(data: any): Encoding {
        data = typeof data === 'object' ? data : {};
        let result = new Encoding();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preamble"] = this.preamble ? this.preamble.toJSON() : null as any;
        data["bodyName"] = this.bodyName !== undefined ? this.bodyName : null as any;
        data["encodingName"] = this.encodingName !== undefined ? this.encodingName : null as any;
        data["headerName"] = this.headerName !== undefined ? this.headerName : null as any;
        data["webName"] = this.webName !== undefined ? this.webName : null as any;
        data["windowsCodePage"] = this.windowsCodePage !== undefined ? this.windowsCodePage : null as any;
        data["isBrowserDisplay"] = this.isBrowserDisplay !== undefined ? this.isBrowserDisplay : null as any;
        data["isBrowserSave"] = this.isBrowserSave !== undefined ? this.isBrowserSave : null as any;
        data["isMailNewsDisplay"] = this.isMailNewsDisplay !== undefined ? this.isMailNewsDisplay : null as any;
        data["isMailNewsSave"] = this.isMailNewsSave !== undefined ? this.isMailNewsSave : null as any;
        data["isSingleByte"] = this.isSingleByte !== undefined ? this.isSingleByte : null as any;
        data["encoderFallback"] = this.encoderFallback ? this.encoderFallback.toJSON() : null as any;
        data["decoderFallback"] = this.decoderFallback ? this.decoderFallback.toJSON() : null as any;
        data["isReadOnly"] = this.isReadOnly !== undefined ? this.isReadOnly : null as any;
        data["codePage"] = this.codePage !== undefined ? this.codePage : null as any;
        return data;
    }
}

export class Envelope {
    body!: EnvelopeBody;

    init(_data?: any) {
        if (_data) {
            this.body = _data["body"] ? EnvelopeBody.fromJS(_data["body"]) : null as any;
        }
    }

    static fromJS(data: any): Envelope {
        data = typeof data === 'object' ? data : {};
        let result = new Envelope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["body"] = this.body ? this.body.toJSON() : null as any;
        return data;
    }
}

export class EnvelopeBody {
    eCustomerDumpResponse!: ECustomerDumpResponse;

    init(_data?: any) {
        if (_data) {
            this.eCustomerDumpResponse = _data["eCustomerDumpResponse"] ? ECustomerDumpResponse.fromJS(_data["eCustomerDumpResponse"]) : null as any;
        }
    }

    static fromJS(data: any): EnvelopeBody {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eCustomerDumpResponse"] = this.eCustomerDumpResponse ? this.eCustomerDumpResponse.toJSON() : null as any;
        return data;
    }
}

export class ExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string;
    providerAccessCode!: string;

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"] !== undefined ? _data["authProvider"] : null as any;
            this.providerKey = _data["providerKey"] !== undefined ? _data["providerKey"] : null as any;
            this.providerAccessCode = _data["providerAccessCode"] !== undefined ? _data["providerAccessCode"] : null as any;
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider !== undefined ? this.authProvider : null as any;
        data["providerKey"] = this.providerKey !== undefined ? this.providerKey : null as any;
        data["providerAccessCode"] = this.providerAccessCode !== undefined ? this.providerAccessCode : null as any;
        return data;
    }
}

export class ExternalLoginProviderInfoModel {
    name!: string | null;
    clientId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        return data;
    }
}

export class FlatPermissionDto {
    parentName!: string | null;
    name!: string | null;
    displayName!: string | null;
    description!: string | null;
    isGrantedByDefault!: boolean;

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"] !== undefined ? _data["parentName"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.isGrantedByDefault = _data["isGrantedByDefault"] !== undefined ? _data["isGrantedByDefault"] : null as any;
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName !== undefined ? this.parentName : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["isGrantedByDefault"] = this.isGrantedByDefault !== undefined ? this.isGrantedByDefault : null as any;
        return data;
    }
}

export class FlatPermissionWithLevelDto {
    parentName!: string | null;
    name!: string | null;
    displayName!: string | null;
    description!: string | null;
    isGrantedByDefault!: boolean;
    level!: number;

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"] !== undefined ? _data["parentName"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.isGrantedByDefault = _data["isGrantedByDefault"] !== undefined ? _data["isGrantedByDefault"] : null as any;
            this.level = _data["level"] !== undefined ? _data["level"] : null as any;
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName !== undefined ? this.parentName : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["isGrantedByDefault"] = this.isGrantedByDefault !== undefined ? this.isGrantedByDefault : null as any;
        data["level"] = this.level !== undefined ? this.level : null as any;
        return data;
    }
}

export class FlatPermissionWithLevelDtoListResultDto {
    items!: FlatPermissionWithLevelDto[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FlatPermissionWithLevelDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionWithLevelDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GcsMaintainUserDto {
    /** 用户编码 */
    userId!: number;
    /** 用户名称 */
    userName!: string | null;
    /** 用户名称 */
    fullName!: string | null;
    /** 用户类型 */
    userType!: number;

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.userType = _data["userType"] !== undefined ? _data["userType"] : null as any;
        }
    }

    static fromJS(data: any): GcsMaintainUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new GcsMaintainUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["userType"] = this.userType !== undefined ? this.userType : null as any;
        return data;
    }
}

export class GetAllCustomerInfosInput {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | null;
    cusNo!: string | null;
    cusAdrName!: string | null;
    readonly keyword!: string[] | null;
    cusAdrRoad!: string | null;
    invAdrName!: string | null;
    delAdrName!: string | null;
    delAdrRoad!: string | null;
    application!: string | null;
    channel!: string | null;
    industryUsage!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.sorting = _data["sorting"] !== undefined ? _data["sorting"] : null as any;
            this.cusNo = _data["cusNo"] !== undefined ? _data["cusNo"] : null as any;
            this.cusAdrName = _data["cusAdrName"] !== undefined ? _data["cusAdrName"] : null as any;
            if (Array.isArray(_data["keyword"])) {
                (this as any).keyword = [] as any;
                for (let item of _data["keyword"])
                    (this as any).keyword!.push(item);
            }
            else {
                (this as any).keyword = null as any;
            }
            this.cusAdrRoad = _data["cusAdrRoad"] !== undefined ? _data["cusAdrRoad"] : null as any;
            this.invAdrName = _data["invAdrName"] !== undefined ? _data["invAdrName"] : null as any;
            this.delAdrName = _data["delAdrName"] !== undefined ? _data["delAdrName"] : null as any;
            this.delAdrRoad = _data["delAdrRoad"] !== undefined ? _data["delAdrRoad"] : null as any;
            this.application = _data["application"] !== undefined ? _data["application"] : null as any;
            this.channel = _data["channel"] !== undefined ? _data["channel"] : null as any;
            this.industryUsage = _data["industryUsage"] !== undefined ? _data["industryUsage"] : null as any;
        }
    }

    static fromJS(data: any): GetAllCustomerInfosInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCustomerInfosInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["sorting"] = this.sorting !== undefined ? this.sorting : null as any;
        data["cusNo"] = this.cusNo !== undefined ? this.cusNo : null as any;
        data["cusAdrName"] = this.cusAdrName !== undefined ? this.cusAdrName : null as any;
        if (Array.isArray(this.keyword)) {
            data["keyword"] = [];
            for (let item of this.keyword)
                data["keyword"].push(item);
        }
        data["cusAdrRoad"] = this.cusAdrRoad !== undefined ? this.cusAdrRoad : null as any;
        data["invAdrName"] = this.invAdrName !== undefined ? this.invAdrName : null as any;
        data["delAdrName"] = this.delAdrName !== undefined ? this.delAdrName : null as any;
        data["delAdrRoad"] = this.delAdrRoad !== undefined ? this.delAdrRoad : null as any;
        data["application"] = this.application !== undefined ? this.application : null as any;
        data["channel"] = this.channel !== undefined ? this.channel : null as any;
        data["industryUsage"] = this.industryUsage !== undefined ? this.industryUsage : null as any;
        return data;
    }
}

export class GetAllEUsInput {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | null;
    customerNumber!: string | null;
    nameCN!: string | null;
    telephone!: string | null;
    street!: string | null;
    contactName!: string | null;
    contactEmail!: string | null;
    customerInfoCusNo!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.sorting = _data["sorting"] !== undefined ? _data["sorting"] : null as any;
            this.customerNumber = _data["customerNumber"] !== undefined ? _data["customerNumber"] : null as any;
            this.nameCN = _data["nameCN"] !== undefined ? _data["nameCN"] : null as any;
            this.telephone = _data["telephone"] !== undefined ? _data["telephone"] : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : null as any;
            this.contactEmail = _data["contactEmail"] !== undefined ? _data["contactEmail"] : null as any;
            this.customerInfoCusNo = _data["customerInfoCusNo"] !== undefined ? _data["customerInfoCusNo"] : null as any;
        }
    }

    static fromJS(data: any): GetAllEUsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllEUsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["sorting"] = this.sorting !== undefined ? this.sorting : null as any;
        data["customerNumber"] = this.customerNumber !== undefined ? this.customerNumber : null as any;
        data["nameCN"] = this.nameCN !== undefined ? this.nameCN : null as any;
        data["telephone"] = this.telephone !== undefined ? this.telephone : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["contactName"] = this.contactName !== undefined ? this.contactName : null as any;
        data["contactEmail"] = this.contactEmail !== undefined ? this.contactEmail : null as any;
        data["customerInfoCusNo"] = this.customerInfoCusNo !== undefined ? this.customerInfoCusNo : null as any;
        return data;
    }
}

export class GetAnnouncementAllDto {
    /** 主键id */
    id!: string | null;
    /** 标题 */
    title!: string | null;
    /** 附件URL */
    attachmentUrl!: string | null;
    /** 创建时间 */
    creationTime!: moment.Moment;
    /** 标签 */
    labelTypeName!: string | null;
    /** 类型 */
    certificateType!: string | null;
    /** 系统横幅展示开始时间 */
    showTimeForStart!: moment.Moment | null;
    /** 系统横幅展示结束时间 */
    showTimeForEnd!: moment.Moment | null;
    announcementLabelTypeDtos!: AnnouncementLabelTypeDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.attachmentUrl = _data["attachmentUrl"] !== undefined ? _data["attachmentUrl"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.labelTypeName = _data["labelTypeName"] !== undefined ? _data["labelTypeName"] : null as any;
            this.certificateType = _data["certificateType"] !== undefined ? _data["certificateType"] : null as any;
            this.showTimeForStart = _data["showTimeForStart"] ? moment(_data["showTimeForStart"].toString()) : null as any;
            this.showTimeForEnd = _data["showTimeForEnd"] ? moment(_data["showTimeForEnd"].toString()) : null as any;
            if (Array.isArray(_data["announcementLabelTypeDtos"])) {
                this.announcementLabelTypeDtos = [] as any;
                for (let item of _data["announcementLabelTypeDtos"])
                    this.announcementLabelTypeDtos!.push(AnnouncementLabelTypeDto.fromJS(item));
            }
            else {
                this.announcementLabelTypeDtos = null as any;
            }
        }
    }

    static fromJS(data: any): GetAnnouncementAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAnnouncementAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["attachmentUrl"] = this.attachmentUrl !== undefined ? this.attachmentUrl : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["labelTypeName"] = this.labelTypeName !== undefined ? this.labelTypeName : null as any;
        data["certificateType"] = this.certificateType !== undefined ? this.certificateType : null as any;
        data["showTimeForStart"] = this.showTimeForStart ? this.showTimeForStart.toISOString() : null as any;
        data["showTimeForEnd"] = this.showTimeForEnd ? this.showTimeForEnd.toISOString() : null as any;
        if (Array.isArray(this.announcementLabelTypeDtos)) {
            data["announcementLabelTypeDtos"] = [];
            for (let item of this.announcementLabelTypeDtos)
                data["announcementLabelTypeDtos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetAnnouncementAllTotalCountDto {
    /** 总数 */
    totalCount!: number;
    getAnnouncementAllDtos!: GetAnnouncementAllDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["getAnnouncementAllDtos"])) {
                this.getAnnouncementAllDtos = [] as any;
                for (let item of _data["getAnnouncementAllDtos"])
                    this.getAnnouncementAllDtos!.push(GetAnnouncementAllDto.fromJS(item));
            }
            else {
                this.getAnnouncementAllDtos = null as any;
            }
        }
    }

    static fromJS(data: any): GetAnnouncementAllTotalCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAnnouncementAllTotalCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.getAnnouncementAllDtos)) {
            data["getAnnouncementAllDtos"] = [];
            for (let item of this.getAnnouncementAllDtos)
                data["getAnnouncementAllDtos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetAnnouncementDto {
    /** 主键id */
    id!: string | null;
    /** 标题 */
    title!: string | null;
    /** 附件URL */
    attachmentUrl!: string | null;
    /** 创建时间 */
    creationTime!: moment.Moment;
    /** 类型 */
    certificateType!: string | null;
    /** 系统横幅展示开始时间 */
    showTimeForStart!: moment.Moment | null;
    /** 系统横幅展示结束时间 */
    showTimeForEnd!: moment.Moment | null;
    /** 可见类型（1：全员可见，2：指定角色） */
    visibleType!: number | null;
    /** 角色Id */
    roleID!: number[] | null;
    announcementLabelTypeDtos!: AnnouncementLabelTypeDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.attachmentUrl = _data["attachmentUrl"] !== undefined ? _data["attachmentUrl"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.certificateType = _data["certificateType"] !== undefined ? _data["certificateType"] : null as any;
            this.showTimeForStart = _data["showTimeForStart"] ? moment(_data["showTimeForStart"].toString()) : null as any;
            this.showTimeForEnd = _data["showTimeForEnd"] ? moment(_data["showTimeForEnd"].toString()) : null as any;
            this.visibleType = _data["visibleType"] !== undefined ? _data["visibleType"] : null as any;
            if (Array.isArray(_data["roleID"])) {
                this.roleID = [] as any;
                for (let item of _data["roleID"])
                    this.roleID!.push(item);
            }
            else {
                this.roleID = null as any;
            }
            if (Array.isArray(_data["announcementLabelTypeDtos"])) {
                this.announcementLabelTypeDtos = [] as any;
                for (let item of _data["announcementLabelTypeDtos"])
                    this.announcementLabelTypeDtos!.push(AnnouncementLabelTypeDto.fromJS(item));
            }
            else {
                this.announcementLabelTypeDtos = null as any;
            }
        }
    }

    static fromJS(data: any): GetAnnouncementDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAnnouncementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["attachmentUrl"] = this.attachmentUrl !== undefined ? this.attachmentUrl : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["certificateType"] = this.certificateType !== undefined ? this.certificateType : null as any;
        data["showTimeForStart"] = this.showTimeForStart ? this.showTimeForStart.toISOString() : null as any;
        data["showTimeForEnd"] = this.showTimeForEnd ? this.showTimeForEnd.toISOString() : null as any;
        data["visibleType"] = this.visibleType !== undefined ? this.visibleType : null as any;
        if (Array.isArray(this.roleID)) {
            data["roleID"] = [];
            for (let item of this.roleID)
                data["roleID"].push(item);
        }
        if (Array.isArray(this.announcementLabelTypeDtos)) {
            data["announcementLabelTypeDtos"] = [];
            for (let item of this.announcementLabelTypeDtos)
                data["announcementLabelTypeDtos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetChannelApplicationIndustryUsageOptionsOutput {
    channels!: string[] | null;
    applications!: string[] | null;
    industryUsages!: string[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["channels"])) {
                this.channels = [] as any;
                for (let item of _data["channels"])
                    this.channels!.push(item);
            }
            else {
                this.channels = null as any;
            }
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(item);
            }
            else {
                this.applications = null as any;
            }
            if (Array.isArray(_data["industryUsages"])) {
                this.industryUsages = [] as any;
                for (let item of _data["industryUsages"])
                    this.industryUsages!.push(item);
            }
            else {
                this.industryUsages = null as any;
            }
        }
    }

    static fromJS(data: any): GetChannelApplicationIndustryUsageOptionsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetChannelApplicationIndustryUsageOptionsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.channels)) {
            data["channels"] = [];
            for (let item of this.channels)
                data["channels"].push(item);
        }
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item);
        }
        if (Array.isArray(this.industryUsages)) {
            data["industryUsages"] = [];
            for (let item of this.industryUsages)
                data["industryUsages"].push(item);
        }
        return data;
    }
}

export class GetChannelPartnerListOutput {
    id!: number;
    name!: string | null;
    companyName!: string | null;
    emailAddress!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
        }
    }

    static fromJS(data: any): GetChannelPartnerListOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetChannelPartnerListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        return data;
    }
}

export class GetCurrentLoginInformationsOutput {
    application!: ApplicationInfoDto;
    user!: UserLoginInfoDto;
    tenant!: TenantLoginInfoDto;

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : null as any;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : null as any;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : null as any;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["user"] = this.user ? this.user.toJSON() : null as any;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : null as any;
        return data;
    }
}

export class GetCusDetailOutput {
    id!: string | null;
    cusNo!: string | null;
    application!: string | null;
    channel!: string | null;
    industryUsage!: string | null;
    cusAdrName!: string | null;
    cusAdrRoad!: string | null;
    invAdrName!: string | null;
    delAdrName!: string | null;
    delAdrRoad!: string | null;
    preCalNo!: string | null;
    customerMultiplierDefaultMultiplier!: number;
    customerMultiplierSeriesMultiplier!: { [key: string]: number; } | null;
    customerMultiplierExpiredTime!: moment.Moment | null;
    customerMultiplierIsActive!: boolean;
    mdmCode!: string | null;
    sapCode!: string | null;
    dataType!: string | null;
    customerSales!: CustomerSaleDto[] | null;
    customerCps!: CustomeCpDto[] | null;
    euDtos!: EUDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.cusNo = _data["cusNo"] !== undefined ? _data["cusNo"] : null as any;
            this.application = _data["application"] !== undefined ? _data["application"] : null as any;
            this.channel = _data["channel"] !== undefined ? _data["channel"] : null as any;
            this.industryUsage = _data["industryUsage"] !== undefined ? _data["industryUsage"] : null as any;
            this.cusAdrName = _data["cusAdrName"] !== undefined ? _data["cusAdrName"] : null as any;
            this.cusAdrRoad = _data["cusAdrRoad"] !== undefined ? _data["cusAdrRoad"] : null as any;
            this.invAdrName = _data["invAdrName"] !== undefined ? _data["invAdrName"] : null as any;
            this.delAdrName = _data["delAdrName"] !== undefined ? _data["delAdrName"] : null as any;
            this.delAdrRoad = _data["delAdrRoad"] !== undefined ? _data["delAdrRoad"] : null as any;
            this.preCalNo = _data["preCalNo"] !== undefined ? _data["preCalNo"] : null as any;
            this.customerMultiplierDefaultMultiplier = _data["customerMultiplierDefaultMultiplier"] !== undefined ? _data["customerMultiplierDefaultMultiplier"] : null as any;
            if (_data["customerMultiplierSeriesMultiplier"]) {
                this.customerMultiplierSeriesMultiplier = {} as any;
                for (let key in _data["customerMultiplierSeriesMultiplier"]) {
                    if (_data["customerMultiplierSeriesMultiplier"].hasOwnProperty(key))
                        (this.customerMultiplierSeriesMultiplier as any)![key] = _data["customerMultiplierSeriesMultiplier"][key] !== undefined ? _data["customerMultiplierSeriesMultiplier"][key] : null as any;
                }
            }
            else {
                this.customerMultiplierSeriesMultiplier = null as any;
            }
            this.customerMultiplierExpiredTime = _data["customerMultiplierExpiredTime"] ? moment(_data["customerMultiplierExpiredTime"].toString()) : null as any;
            this.customerMultiplierIsActive = _data["customerMultiplierIsActive"] !== undefined ? _data["customerMultiplierIsActive"] : null as any;
            this.mdmCode = _data["mdmCode"] !== undefined ? _data["mdmCode"] : null as any;
            this.sapCode = _data["sapCode"] !== undefined ? _data["sapCode"] : null as any;
            this.dataType = _data["dataType"] !== undefined ? _data["dataType"] : null as any;
            if (Array.isArray(_data["customerSales"])) {
                this.customerSales = [] as any;
                for (let item of _data["customerSales"])
                    this.customerSales!.push(CustomerSaleDto.fromJS(item));
            }
            else {
                this.customerSales = null as any;
            }
            if (Array.isArray(_data["customerCps"])) {
                this.customerCps = [] as any;
                for (let item of _data["customerCps"])
                    this.customerCps!.push(CustomeCpDto.fromJS(item));
            }
            else {
                this.customerCps = null as any;
            }
            if (Array.isArray(_data["euDtos"])) {
                this.euDtos = [] as any;
                for (let item of _data["euDtos"])
                    this.euDtos!.push(EUDto.fromJS(item));
            }
            else {
                this.euDtos = null as any;
            }
        }
    }

    static fromJS(data: any): GetCusDetailOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCusDetailOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["cusNo"] = this.cusNo !== undefined ? this.cusNo : null as any;
        data["application"] = this.application !== undefined ? this.application : null as any;
        data["channel"] = this.channel !== undefined ? this.channel : null as any;
        data["industryUsage"] = this.industryUsage !== undefined ? this.industryUsage : null as any;
        data["cusAdrName"] = this.cusAdrName !== undefined ? this.cusAdrName : null as any;
        data["cusAdrRoad"] = this.cusAdrRoad !== undefined ? this.cusAdrRoad : null as any;
        data["invAdrName"] = this.invAdrName !== undefined ? this.invAdrName : null as any;
        data["delAdrName"] = this.delAdrName !== undefined ? this.delAdrName : null as any;
        data["delAdrRoad"] = this.delAdrRoad !== undefined ? this.delAdrRoad : null as any;
        data["preCalNo"] = this.preCalNo !== undefined ? this.preCalNo : null as any;
        data["customerMultiplierDefaultMultiplier"] = this.customerMultiplierDefaultMultiplier !== undefined ? this.customerMultiplierDefaultMultiplier : null as any;
        if (this.customerMultiplierSeriesMultiplier) {
            data["customerMultiplierSeriesMultiplier"] = {};
            for (let key in this.customerMultiplierSeriesMultiplier) {
                if (this.customerMultiplierSeriesMultiplier.hasOwnProperty(key))
                    (data["customerMultiplierSeriesMultiplier"] as any)[key] = this.customerMultiplierSeriesMultiplier[key] !== undefined ? this.customerMultiplierSeriesMultiplier[key] : null as any;
            }
        }
        data["customerMultiplierExpiredTime"] = this.customerMultiplierExpiredTime ? this.customerMultiplierExpiredTime.toISOString() : null as any;
        data["customerMultiplierIsActive"] = this.customerMultiplierIsActive !== undefined ? this.customerMultiplierIsActive : null as any;
        data["mdmCode"] = this.mdmCode !== undefined ? this.mdmCode : null as any;
        data["sapCode"] = this.sapCode !== undefined ? this.sapCode : null as any;
        data["dataType"] = this.dataType !== undefined ? this.dataType : null as any;
        if (Array.isArray(this.customerSales)) {
            data["customerSales"] = [];
            for (let item of this.customerSales)
                data["customerSales"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.customerCps)) {
            data["customerCps"] = [];
            for (let item of this.customerCps)
                data["customerCps"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.euDtos)) {
            data["euDtos"] = [];
            for (let item of this.euDtos)
                data["euDtos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetCusNoAndCusAdrNameListOutput {
    cusNo!: string | null;
    cusAdrName!: string | null;
    channel!: string | null;
    industryCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.cusNo = _data["cusNo"] !== undefined ? _data["cusNo"] : null as any;
            this.cusAdrName = _data["cusAdrName"] !== undefined ? _data["cusAdrName"] : null as any;
            this.channel = _data["channel"] !== undefined ? _data["channel"] : null as any;
            this.industryCode = _data["industryCode"] !== undefined ? _data["industryCode"] : null as any;
        }
    }

    static fromJS(data: any): GetCusNoAndCusAdrNameListOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCusNoAndCusAdrNameListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cusNo"] = this.cusNo !== undefined ? this.cusNo : null as any;
        data["cusAdrName"] = this.cusAdrName !== undefined ? this.cusAdrName : null as any;
        data["channel"] = this.channel !== undefined ? this.channel : null as any;
        data["industryCode"] = this.industryCode !== undefined ? this.industryCode : null as any;
        return data;
    }
}

export class GetCustomerInfoForEditOutput {
    customerInfo!: CreateOrEditCustomerInfoDto;

    init(_data?: any) {
        if (_data) {
            this.customerInfo = _data["customerInfo"] ? CreateOrEditCustomerInfoDto.fromJS(_data["customerInfo"]) : null as any;
        }
    }

    static fromJS(data: any): GetCustomerInfoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerInfoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerInfo"] = this.customerInfo ? this.customerInfo.toJSON() : null as any;
        return data;
    }
}

export class GetCustomerInfoForViewDto {
    customerInfo!: CustomerInfoDto;

    init(_data?: any) {
        if (_data) {
            this.customerInfo = _data["customerInfo"] ? CustomerInfoDto.fromJS(_data["customerInfo"]) : null as any;
        }
    }

    static fromJS(data: any): GetCustomerInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerInfo"] = this.customerInfo ? this.customerInfo.toJSON() : null as any;
        return data;
    }
}

export class GetCustomerInfoForViewDtoPagedResultDto {
    items!: GetCustomerInfoForViewDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCustomerInfoForViewDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): GetCustomerInfoForViewDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerInfoForViewDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class GetEUForEditOutput {
    eu!: CreateOrEditEUDto;

    init(_data?: any) {
        if (_data) {
            this.eu = _data["eu"] ? CreateOrEditEUDto.fromJS(_data["eu"]) : null as any;
        }
    }

    static fromJS(data: any): GetEUForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEUForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eu"] = this.eu ? this.eu.toJSON() : null as any;
        return data;
    }
}

export class GetEUForViewDto {
    eu!: EUDto;
    customerInfoCusNo!: string | null;

    init(_data?: any) {
        if (_data) {
            this.eu = _data["eu"] ? EUDto.fromJS(_data["eu"]) : null as any;
            this.customerInfoCusNo = _data["customerInfoCusNo"] !== undefined ? _data["customerInfoCusNo"] : null as any;
        }
    }

    static fromJS(data: any): GetEUForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEUForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eu"] = this.eu ? this.eu.toJSON() : null as any;
        data["customerInfoCusNo"] = this.customerInfoCusNo !== undefined ? this.customerInfoCusNo : null as any;
        return data;
    }
}

export class GetEUForViewDtoPagedResultDto {
    items!: GetEUForViewDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetEUForViewDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): GetEUForViewDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEUForViewDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class GetMultiplierForEditOutput {
    multiplier!: CreateOrEditMultiplierDto;

    init(_data?: any) {
        if (_data) {
            this.multiplier = _data["multiplier"] ? CreateOrEditMultiplierDto.fromJS(_data["multiplier"]) : null as any;
        }
    }

    static fromJS(data: any): GetMultiplierForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMultiplierForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["multiplier"] = this.multiplier ? this.multiplier.toJSON() : null as any;
        return data;
    }
}

export class GetMultiplierForViewDto {
    multiplier!: MultiplierDto;

    init(_data?: any) {
        if (_data) {
            this.multiplier = _data["multiplier"] ? MultiplierDto.fromJS(_data["multiplier"]) : null as any;
        }
    }

    static fromJS(data: any): GetMultiplierForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMultiplierForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["multiplier"] = this.multiplier ? this.multiplier.toJSON() : null as any;
        return data;
    }
}

export class GetMultiplierForViewDtoPagedResultDto {
    items!: GetMultiplierForViewDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMultiplierForViewDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): GetMultiplierForViewDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMultiplierForViewDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class GetRoleForEditOutput {
    role!: RoleEditDto;
    permissions!: FlatPermissionDto[] | null;
    grantedPermissionNames!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : null as any;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            else {
                this.permissions = null as any;
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
            else {
                this.grantedPermissionNames = null as any;
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : null as any;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export class GetSalesListOutput {
    saleId!: number;
    name!: string | null;

    init(_data?: any) {
        if (_data) {
            this.saleId = _data["saleId"] !== undefined ? _data["saleId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): GetSalesListOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleId"] = this.saleId !== undefined ? this.saleId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

/** 查询收货地址列表 查询条件 */
export class GetShippingAddressInput {
    maxResultCount!: number;
    skipCount!: number;
    customerInfoCusNo!: string | null;
    /** 客户名称 */
    shipName!: string | null;
    /** 详细地址 */
    address!: string | null;
    /** 联系人 */
    contactName!: string | null;
    /** 联系电话 */
    telPhone!: string | null;
    /** 邮箱地址 */
    emailAddress!: string | null;
    /** 收货城市 */
    regionIdList!: number[] | null;
    /** 收货地址类型
仓库 站点 等 */
    shipType!: number | null;
    /** 排序方式，默认正序 */
    sortOrder!: boolean;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.customerInfoCusNo = _data["customerInfoCusNo"] !== undefined ? _data["customerInfoCusNo"] : null as any;
            this.shipName = _data["shipName"] !== undefined ? _data["shipName"] : null as any;
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : null as any;
            this.telPhone = _data["telPhone"] !== undefined ? _data["telPhone"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            if (Array.isArray(_data["regionIdList"])) {
                this.regionIdList = [] as any;
                for (let item of _data["regionIdList"])
                    this.regionIdList!.push(item);
            }
            else {
                this.regionIdList = null as any;
            }
            this.shipType = _data["shipType"] !== undefined ? _data["shipType"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
        }
    }

    static fromJS(data: any): GetShippingAddressInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetShippingAddressInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["customerInfoCusNo"] = this.customerInfoCusNo !== undefined ? this.customerInfoCusNo : null as any;
        data["shipName"] = this.shipName !== undefined ? this.shipName : null as any;
        data["address"] = this.address !== undefined ? this.address : null as any;
        data["contactName"] = this.contactName !== undefined ? this.contactName : null as any;
        data["telPhone"] = this.telPhone !== undefined ? this.telPhone : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        if (Array.isArray(this.regionIdList)) {
            data["regionIdList"] = [];
            for (let item of this.regionIdList)
                data["regionIdList"].push(item);
        }
        data["shipType"] = this.shipType !== undefined ? this.shipType : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        return data;
    }
}

export class GetUserIdAndNameByRoleNameOutput {
    userId!: number;
    name!: string | null;
    emailAddress!: string | null;
    customerInfoCusNo!: string | null;
    englishName!: string | null;
    chineseName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.customerInfoCusNo = _data["customerInfoCusNo"] !== undefined ? _data["customerInfoCusNo"] : null as any;
            this.englishName = _data["englishName"] !== undefined ? _data["englishName"] : null as any;
            this.chineseName = _data["chineseName"] !== undefined ? _data["chineseName"] : null as any;
        }
    }

    static fromJS(data: any): GetUserIdAndNameByRoleNameOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserIdAndNameByRoleNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["customerInfoCusNo"] = this.customerInfoCusNo !== undefined ? this.customerInfoCusNo : null as any;
        data["englishName"] = this.englishName !== undefined ? this.englishName : null as any;
        data["chineseName"] = this.chineseName !== undefined ? this.chineseName : null as any;
        return data;
    }
}

export class HolidayDto {
    id!: string;
    /** 假期名称 */
    name!: string | null;
    /** 年份 */
    year!: number;
    /** 日期 */
    date!: moment.Moment;
    /** 日期 */
    readonly dateString!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.year = _data["year"] !== undefined ? _data["year"] : null as any;
            this.date = _data["date"] ? moment(_data["date"].toString()) : null as any;
            (this as any).dateString = _data["dateString"] !== undefined ? _data["dateString"] : null as any;
        }
    }

    static fromJS(data: any): HolidayDto {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["year"] = this.year !== undefined ? this.year : null as any;
        data["date"] = this.date ? this.date.toISOString() : null as any;
        data["dateString"] = this.dateString !== undefined ? this.dateString : null as any;
        return data;
    }
}

/** 假期参数 */
export class HolidayJobArgs {
    /** 任务名称 */
    jobName!: string | null;
    /** 年份 */
    year!: number;

    init(_data?: any) {
        if (_data) {
            this.jobName = _data["jobName"] !== undefined ? _data["jobName"] : null as any;
            this.year = _data["year"] !== undefined ? _data["year"] : null as any;
        }
    }

    static fromJS(data: any): HolidayJobArgs {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayJobArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobName"] = this.jobName !== undefined ? this.jobName : null as any;
        data["year"] = this.year !== undefined ? this.year : null as any;
        return data;
    }
}

export class Int64EntityDto {
    id!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export class IsTenantAvailableInput {
    tenancyName!: string;

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"] !== undefined ? _data["tenancyName"] : null as any;
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName !== undefined ? this.tenancyName : null as any;
        return data;
    }
}

export class IsTenantAvailableOutput {
    state!: TenantAvailabilityState;
    tenantId!: number | null;
    serverRootAddress!: string | null;

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : null as any;
            this.serverRootAddress = _data["serverRootAddress"] !== undefined ? _data["serverRootAddress"] : null as any;
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null as any;
        data["serverRootAddress"] = this.serverRootAddress !== undefined ? this.serverRootAddress : null as any;
        return data;
    }
}

export class LockoutVerificationArgs {
    /** 任务名称 */
    jobName!: string | null;
    userId!: number;

    init(_data?: any) {
        if (_data) {
            this.jobName = _data["jobName"] !== undefined ? _data["jobName"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
        }
    }

    static fromJS(data: any): LockoutVerificationArgs {
        data = typeof data === 'object' ? data : {};
        let result = new LockoutVerificationArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobName"] = this.jobName !== undefined ? this.jobName : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        return data;
    }
}

/** 邮件中表格 */
export class MailTable {
    heads!: string[] | null;
    bodys!: MailTableBody[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["heads"])) {
                this.heads = [] as any;
                for (let item of _data["heads"])
                    this.heads!.push(item);
            }
            else {
                this.heads = null as any;
            }
            if (Array.isArray(_data["bodys"])) {
                this.bodys = [] as any;
                for (let item of _data["bodys"])
                    this.bodys!.push(MailTableBody.fromJS(item));
            }
            else {
                this.bodys = null as any;
            }
        }
    }

    static fromJS(data: any): MailTable {
        data = typeof data === 'object' ? data : {};
        let result = new MailTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.heads)) {
            data["heads"] = [];
            for (let item of this.heads)
                data["heads"].push(item);
        }
        if (Array.isArray(this.bodys)) {
            data["bodys"] = [];
            for (let item of this.bodys)
                data["bodys"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 邮件中表格的内容 */
export class MailTableBody {
    /** 内容 */
    bodys!: string[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bodys"])) {
                this.bodys = [] as any;
                for (let item of _data["bodys"])
                    this.bodys!.push(item);
            }
            else {
                this.bodys = null as any;
            }
        }
    }

    static fromJS(data: any): MailTableBody {
        data = typeof data === 'object' ? data : {};
        let result = new MailTableBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bodys)) {
            data["bodys"] = [];
            for (let item of this.bodys)
                data["bodys"].push(item);
        }
        return data;
    }
}

/** 邮件中携带的按钮链接 */
export class MailTableButton {
    /** 按钮跳转链接 */
    url!: string | null;
    /** 按钮名称 */
    name!: string | null;

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): MailTableButton {
        data = typeof data === 'object' ? data : {};
        let result = new MailTableButton();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export class MaintainInfoDto {
    /** 是否维护中 */
    enabled!: boolean;
    /** 维护开始时间 */
    start!: moment.Moment | null;
    /** 维护结束时间 */
    end!: moment.Moment | null;
    /** 维护提示信息 */
    message!: string | null;

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
            this.start = _data["start"] ? moment(_data["start"].toString()) : null as any;
            this.end = _data["end"] ? moment(_data["end"].toString()) : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): MaintainInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaintainInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        data["start"] = this.start ? this.start.toISOString() : null as any;
        data["end"] = this.end ? this.end.toISOString() : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }
}

/** 更新公告信息 */
export class ModifyAnnouncementDto {
    /** Id */
    id!: string;
    /** 标题 */
    title!: string | null;
    /** 附件URL */
    attachmentUrl!: string | null;
    /** 类型 */
    certificateType!: string | null;
    /** 系统横幅展示开始时间 */
    showTimeForStart!: moment.Moment | null;
    /** 系统横幅展示结束时间 */
    showTimeForEnd!: moment.Moment | null;
    /** 可见类型（1：全员可见，2：指定角色） */
    visibleType!: number | null;
    /** 角色Id */
    roleID!: number[] | null;
    announcementLabelTypeDtos!: AnnouncementLabelTypeDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.attachmentUrl = _data["attachmentUrl"] !== undefined ? _data["attachmentUrl"] : null as any;
            this.certificateType = _data["certificateType"] !== undefined ? _data["certificateType"] : null as any;
            this.showTimeForStart = _data["showTimeForStart"] ? moment(_data["showTimeForStart"].toString()) : null as any;
            this.showTimeForEnd = _data["showTimeForEnd"] ? moment(_data["showTimeForEnd"].toString()) : null as any;
            this.visibleType = _data["visibleType"] !== undefined ? _data["visibleType"] : null as any;
            if (Array.isArray(_data["roleID"])) {
                this.roleID = [] as any;
                for (let item of _data["roleID"])
                    this.roleID!.push(item);
            }
            else {
                this.roleID = null as any;
            }
            if (Array.isArray(_data["announcementLabelTypeDtos"])) {
                this.announcementLabelTypeDtos = [] as any;
                for (let item of _data["announcementLabelTypeDtos"])
                    this.announcementLabelTypeDtos!.push(AnnouncementLabelTypeDto.fromJS(item));
            }
            else {
                this.announcementLabelTypeDtos = null as any;
            }
        }
    }

    static fromJS(data: any): ModifyAnnouncementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyAnnouncementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["attachmentUrl"] = this.attachmentUrl !== undefined ? this.attachmentUrl : null as any;
        data["certificateType"] = this.certificateType !== undefined ? this.certificateType : null as any;
        data["showTimeForStart"] = this.showTimeForStart ? this.showTimeForStart.toISOString() : null as any;
        data["showTimeForEnd"] = this.showTimeForEnd ? this.showTimeForEnd.toISOString() : null as any;
        data["visibleType"] = this.visibleType !== undefined ? this.visibleType : null as any;
        if (Array.isArray(this.roleID)) {
            data["roleID"] = [];
            for (let item of this.roleID)
                data["roleID"].push(item);
        }
        if (Array.isArray(this.announcementLabelTypeDtos)) {
            data["announcementLabelTypeDtos"] = [];
            for (let item of this.announcementLabelTypeDtos)
                data["announcementLabelTypeDtos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class MultiplierDto {
    id!: number;
    preCalNo!: string | null;
    defaultMultiplier!: number;
    seriesMultiplier!: { [key: string]: number; } | null;
    expiredTime!: moment.Moment | null;
    isActive!: boolean;
    customerInfoCusNoFk!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.preCalNo = _data["preCalNo"] !== undefined ? _data["preCalNo"] : null as any;
            this.defaultMultiplier = _data["defaultMultiplier"] !== undefined ? _data["defaultMultiplier"] : null as any;
            if (_data["seriesMultiplier"]) {
                this.seriesMultiplier = {} as any;
                for (let key in _data["seriesMultiplier"]) {
                    if (_data["seriesMultiplier"].hasOwnProperty(key))
                        (this.seriesMultiplier as any)![key] = _data["seriesMultiplier"][key] !== undefined ? _data["seriesMultiplier"][key] : null as any;
                }
            }
            else {
                this.seriesMultiplier = null as any;
            }
            this.expiredTime = _data["expiredTime"] ? moment(_data["expiredTime"].toString()) : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            this.customerInfoCusNoFk = _data["customerInfoCusNoFk"] !== undefined ? _data["customerInfoCusNoFk"] : null as any;
        }
    }

    static fromJS(data: any): MultiplierDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiplierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["preCalNo"] = this.preCalNo !== undefined ? this.preCalNo : null as any;
        data["defaultMultiplier"] = this.defaultMultiplier !== undefined ? this.defaultMultiplier : null as any;
        if (this.seriesMultiplier) {
            data["seriesMultiplier"] = {};
            for (let key in this.seriesMultiplier) {
                if (this.seriesMultiplier.hasOwnProperty(key))
                    (data["seriesMultiplier"] as any)[key] = this.seriesMultiplier[key] !== undefined ? this.seriesMultiplier[key] : null as any;
            }
        }
        data["expiredTime"] = this.expiredTime ? this.expiredTime.toISOString() : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        data["customerInfoCusNoFk"] = this.customerInfoCusNoFk !== undefined ? this.customerInfoCusNoFk : null as any;
        return data;
    }
}

export class PageAnnouncementAllDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 搜索关键字 */
    keyword!: string | null;
    /** 公告标签类型Id */
    announcementLabelTypeId!: string | null;
    /** 认证模块名称 */
    certificateType!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.keyword = _data["keyword"] !== undefined ? _data["keyword"] : null as any;
            this.announcementLabelTypeId = _data["announcementLabelTypeId"] !== undefined ? _data["announcementLabelTypeId"] : null as any;
            this.certificateType = _data["certificateType"] !== undefined ? _data["certificateType"] : null as any;
        }
    }

    static fromJS(data: any): PageAnnouncementAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageAnnouncementAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["keyword"] = this.keyword !== undefined ? this.keyword : null as any;
        data["announcementLabelTypeId"] = this.announcementLabelTypeId !== undefined ? this.announcementLabelTypeId : null as any;
        data["certificateType"] = this.certificateType !== undefined ? this.certificateType : null as any;
        return data;
    }
}

export class PageAssociationCustomersSearchDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 关联人名称 */
    associationName!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 排序方式，默认正序 */
    sortOrder!: boolean;
    /** 搜索关键字 */
    readonly keyword!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.associationName = _data["associationName"] !== undefined ? _data["associationName"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            if (Array.isArray(_data["keyword"])) {
                (this as any).keyword = [] as any;
                for (let item of _data["keyword"])
                    (this as any).keyword!.push(item);
            }
            else {
                (this as any).keyword = null as any;
            }
        }
    }

    static fromJS(data: any): PageAssociationCustomersSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageAssociationCustomersSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["associationName"] = this.associationName !== undefined ? this.associationName : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        if (Array.isArray(this.keyword)) {
            data["keyword"] = [];
            for (let item of this.keyword)
                data["keyword"].push(item);
        }
        return data;
    }
}

export class PageSearchRolePermissionsChangeLogsDto {
    maxResultCount!: number;
    skipCount!: number;
    roleName!: string | null;
    startDate!: moment.Moment | null;
    endDate!: moment.Moment | null;
    permissionsSimpleDTOs!: PermissionsSimpleDTO[] | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : null as any;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
            if (Array.isArray(_data["permissionsSimpleDTOs"])) {
                this.permissionsSimpleDTOs = [] as any;
                for (let item of _data["permissionsSimpleDTOs"])
                    this.permissionsSimpleDTOs!.push(PermissionsSimpleDTO.fromJS(item));
            }
            else {
                this.permissionsSimpleDTOs = null as any;
            }
        }
    }

    static fromJS(data: any): PageSearchRolePermissionsChangeLogsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageSearchRolePermissionsChangeLogsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        if (Array.isArray(this.permissionsSimpleDTOs)) {
            data["permissionsSimpleDTOs"] = [];
            for (let item of this.permissionsSimpleDTOs)
                data["permissionsSimpleDTOs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class PageTotalAssociationCustomersDto {
    /** 总数 */
    totalCount!: number;
    /** 数据集合 */
    items!: AssociationCustomersOutputDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AssociationCustomersOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): PageTotalAssociationCustomersDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageTotalAssociationCustomersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class PageTotalShippingAddressDto {
    /** 总数 */
    totalCount!: number;
    items!: ShippingAddressDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ShippingAddressDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): PageTotalShippingAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageTotalShippingAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 启动参数 */
export class PasswordVerificationArgs {
    /** 任务名称 */
    jobName!: string | null;
    /** 邮箱过滤字符 */
    emailContains!: string | null;

    init(_data?: any) {
        if (_data) {
            this.jobName = _data["jobName"] !== undefined ? _data["jobName"] : null as any;
            this.emailContains = _data["emailContains"] !== undefined ? _data["emailContains"] : null as any;
        }
    }

    static fromJS(data: any): PasswordVerificationArgs {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordVerificationArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobName"] = this.jobName !== undefined ? this.jobName : null as any;
        data["emailContains"] = this.emailContains !== undefined ? this.emailContains : null as any;
        return data;
    }
}

export class PermissionDto {
    id!: number;
    name!: string | null;
    displayName!: string | null;
    description!: string | null;
    parentName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.parentName = _data["parentName"] !== undefined ? _data["parentName"] : null as any;
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["parentName"] = this.parentName !== undefined ? this.parentName : null as any;
        return data;
    }
}

export class PermissionDtoListResultDto {
    items!: PermissionDto[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PermissionDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class PermissionsSimpleDTO {
    id!: number;
    name!: string | null;
    displayName!: string | null;
    description!: string | null;
    parentName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.parentName = _data["parentName"] !== undefined ? _data["parentName"] : null as any;
        }
    }

    static fromJS(data: any): PermissionsSimpleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionsSimpleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["parentName"] = this.parentName !== undefined ? this.parentName : null as any;
        return data;
    }
}

/** 查看条件 */
export class QueryInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 工号 */
    employeeNumber!: string | null;
    /** 用户 */
    fullName!: string | null;
    /** 直接经理 */
    lineManagerFullName!: string | null;
    /** 公司 */
    company!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.lineManagerFullName = _data["lineManagerFullName"] !== undefined ? _data["lineManagerFullName"] : null as any;
            this.company = _data["company"] !== undefined ? _data["company"] : null as any;
        }
    }

    static fromJS(data: any): QueryInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["lineManagerFullName"] = this.lineManagerFullName !== undefined ? this.lineManagerFullName : null as any;
        data["company"] = this.company !== undefined ? this.company : null as any;
        return data;
    }
}

export class QueryOutputDto {
    id!: string;
    isDeleted!: boolean;
    geid!: string | null;
    employeeNumber!: string | null;
    adAccount!: string | null;
    email!: string | null;
    fullName!: string | null;
    company!: string | null;
    organizationUnitCode!: string | null;
    organizationUnitName!: string | null;
    jobCode!: string | null;
    jobName!: string | null;
    lbuCode!: string | null;
    lbuName!: string | null;
    lineManagerEmployeeNumber!: string | null;
    lineManagerFullName!: string | null;
    employeeGroupCode!: string | null;
    employeeGroupName!: string | null;
    employeeSubGroupCode!: string | null;
    employeeSubGroupName!: string | null;
    transferDate!: string | null;
    previousCompany!: string | null;
    previousOrganizationUnitCode!: string | null;
    previousOrganizationUnitName!: string | null;
    previousJobCode!: string | null;
    previousJobName!: string | null;
    previousLBUCode!: string | null;
    previousLBUName!: string | null;
    previousLineManagerEmployeeNumber!: string | null;
    previousLineManagerFullName!: string | null;
    previousEmployeeGroupCode!: string | null;
    previousEmployeeGroupName!: string | null;
    previousEmployeeSubGroupCode!: string | null;
    previousEmployeeSubGroupName!: string | null;
    dataSourceType!: string | null;
    employeeId!: string | null;
    /** 中文名 */
    chineseName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.geid = _data["geid"] !== undefined ? _data["geid"] : null as any;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.adAccount = _data["adAccount"] !== undefined ? _data["adAccount"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.company = _data["company"] !== undefined ? _data["company"] : null as any;
            this.organizationUnitCode = _data["organizationUnitCode"] !== undefined ? _data["organizationUnitCode"] : null as any;
            this.organizationUnitName = _data["organizationUnitName"] !== undefined ? _data["organizationUnitName"] : null as any;
            this.jobCode = _data["jobCode"] !== undefined ? _data["jobCode"] : null as any;
            this.jobName = _data["jobName"] !== undefined ? _data["jobName"] : null as any;
            this.lbuCode = _data["lbuCode"] !== undefined ? _data["lbuCode"] : null as any;
            this.lbuName = _data["lbuName"] !== undefined ? _data["lbuName"] : null as any;
            this.lineManagerEmployeeNumber = _data["lineManagerEmployeeNumber"] !== undefined ? _data["lineManagerEmployeeNumber"] : null as any;
            this.lineManagerFullName = _data["lineManagerFullName"] !== undefined ? _data["lineManagerFullName"] : null as any;
            this.employeeGroupCode = _data["employeeGroupCode"] !== undefined ? _data["employeeGroupCode"] : null as any;
            this.employeeGroupName = _data["employeeGroupName"] !== undefined ? _data["employeeGroupName"] : null as any;
            this.employeeSubGroupCode = _data["employeeSubGroupCode"] !== undefined ? _data["employeeSubGroupCode"] : null as any;
            this.employeeSubGroupName = _data["employeeSubGroupName"] !== undefined ? _data["employeeSubGroupName"] : null as any;
            this.transferDate = _data["transferDate"] !== undefined ? _data["transferDate"] : null as any;
            this.previousCompany = _data["previousCompany"] !== undefined ? _data["previousCompany"] : null as any;
            this.previousOrganizationUnitCode = _data["previousOrganizationUnitCode"] !== undefined ? _data["previousOrganizationUnitCode"] : null as any;
            this.previousOrganizationUnitName = _data["previousOrganizationUnitName"] !== undefined ? _data["previousOrganizationUnitName"] : null as any;
            this.previousJobCode = _data["previousJobCode"] !== undefined ? _data["previousJobCode"] : null as any;
            this.previousJobName = _data["previousJobName"] !== undefined ? _data["previousJobName"] : null as any;
            this.previousLBUCode = _data["previousLBUCode"] !== undefined ? _data["previousLBUCode"] : null as any;
            this.previousLBUName = _data["previousLBUName"] !== undefined ? _data["previousLBUName"] : null as any;
            this.previousLineManagerEmployeeNumber = _data["previousLineManagerEmployeeNumber"] !== undefined ? _data["previousLineManagerEmployeeNumber"] : null as any;
            this.previousLineManagerFullName = _data["previousLineManagerFullName"] !== undefined ? _data["previousLineManagerFullName"] : null as any;
            this.previousEmployeeGroupCode = _data["previousEmployeeGroupCode"] !== undefined ? _data["previousEmployeeGroupCode"] : null as any;
            this.previousEmployeeGroupName = _data["previousEmployeeGroupName"] !== undefined ? _data["previousEmployeeGroupName"] : null as any;
            this.previousEmployeeSubGroupCode = _data["previousEmployeeSubGroupCode"] !== undefined ? _data["previousEmployeeSubGroupCode"] : null as any;
            this.previousEmployeeSubGroupName = _data["previousEmployeeSubGroupName"] !== undefined ? _data["previousEmployeeSubGroupName"] : null as any;
            this.dataSourceType = _data["dataSourceType"] !== undefined ? _data["dataSourceType"] : null as any;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : null as any;
            this.chineseName = _data["chineseName"] !== undefined ? _data["chineseName"] : null as any;
        }
    }

    static fromJS(data: any): QueryOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["geid"] = this.geid !== undefined ? this.geid : null as any;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["adAccount"] = this.adAccount !== undefined ? this.adAccount : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["company"] = this.company !== undefined ? this.company : null as any;
        data["organizationUnitCode"] = this.organizationUnitCode !== undefined ? this.organizationUnitCode : null as any;
        data["organizationUnitName"] = this.organizationUnitName !== undefined ? this.organizationUnitName : null as any;
        data["jobCode"] = this.jobCode !== undefined ? this.jobCode : null as any;
        data["jobName"] = this.jobName !== undefined ? this.jobName : null as any;
        data["lbuCode"] = this.lbuCode !== undefined ? this.lbuCode : null as any;
        data["lbuName"] = this.lbuName !== undefined ? this.lbuName : null as any;
        data["lineManagerEmployeeNumber"] = this.lineManagerEmployeeNumber !== undefined ? this.lineManagerEmployeeNumber : null as any;
        data["lineManagerFullName"] = this.lineManagerFullName !== undefined ? this.lineManagerFullName : null as any;
        data["employeeGroupCode"] = this.employeeGroupCode !== undefined ? this.employeeGroupCode : null as any;
        data["employeeGroupName"] = this.employeeGroupName !== undefined ? this.employeeGroupName : null as any;
        data["employeeSubGroupCode"] = this.employeeSubGroupCode !== undefined ? this.employeeSubGroupCode : null as any;
        data["employeeSubGroupName"] = this.employeeSubGroupName !== undefined ? this.employeeSubGroupName : null as any;
        data["transferDate"] = this.transferDate !== undefined ? this.transferDate : null as any;
        data["previousCompany"] = this.previousCompany !== undefined ? this.previousCompany : null as any;
        data["previousOrganizationUnitCode"] = this.previousOrganizationUnitCode !== undefined ? this.previousOrganizationUnitCode : null as any;
        data["previousOrganizationUnitName"] = this.previousOrganizationUnitName !== undefined ? this.previousOrganizationUnitName : null as any;
        data["previousJobCode"] = this.previousJobCode !== undefined ? this.previousJobCode : null as any;
        data["previousJobName"] = this.previousJobName !== undefined ? this.previousJobName : null as any;
        data["previousLBUCode"] = this.previousLBUCode !== undefined ? this.previousLBUCode : null as any;
        data["previousLBUName"] = this.previousLBUName !== undefined ? this.previousLBUName : null as any;
        data["previousLineManagerEmployeeNumber"] = this.previousLineManagerEmployeeNumber !== undefined ? this.previousLineManagerEmployeeNumber : null as any;
        data["previousLineManagerFullName"] = this.previousLineManagerFullName !== undefined ? this.previousLineManagerFullName : null as any;
        data["previousEmployeeGroupCode"] = this.previousEmployeeGroupCode !== undefined ? this.previousEmployeeGroupCode : null as any;
        data["previousEmployeeGroupName"] = this.previousEmployeeGroupName !== undefined ? this.previousEmployeeGroupName : null as any;
        data["previousEmployeeSubGroupCode"] = this.previousEmployeeSubGroupCode !== undefined ? this.previousEmployeeSubGroupCode : null as any;
        data["previousEmployeeSubGroupName"] = this.previousEmployeeSubGroupName !== undefined ? this.previousEmployeeSubGroupName : null as any;
        data["dataSourceType"] = this.dataSourceType !== undefined ? this.dataSourceType : null as any;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : null as any;
        data["chineseName"] = this.chineseName !== undefined ? this.chineseName : null as any;
        return data;
    }
}

export class QueryOutputDtoPagedResultDto {
    items!: QueryOutputDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QueryOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): QueryOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class RegionsDto {
    id!: number;
    /** CusNo */
    areaId!: number | null;
    parentId!: number | null;
    regionName!: string | null;
    spell!: string | null;
    spellShort!: string | null;
    displaySequence!: number;
    path!: string | null;
    depth!: number;
    fullRegionName!: string | null;
    details!: RegionsDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.areaId = _data["areaId"] !== undefined ? _data["areaId"] : null as any;
            this.parentId = _data["parentId"] !== undefined ? _data["parentId"] : null as any;
            this.regionName = _data["regionName"] !== undefined ? _data["regionName"] : null as any;
            this.spell = _data["spell"] !== undefined ? _data["spell"] : null as any;
            this.spellShort = _data["spellShort"] !== undefined ? _data["spellShort"] : null as any;
            this.displaySequence = _data["displaySequence"] !== undefined ? _data["displaySequence"] : null as any;
            this.path = _data["path"] !== undefined ? _data["path"] : null as any;
            this.depth = _data["depth"] !== undefined ? _data["depth"] : null as any;
            this.fullRegionName = _data["fullRegionName"] !== undefined ? _data["fullRegionName"] : null as any;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(RegionsDto.fromJS(item));
            }
            else {
                this.details = null as any;
            }
        }
    }

    static fromJS(data: any): RegionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["areaId"] = this.areaId !== undefined ? this.areaId : null as any;
        data["parentId"] = this.parentId !== undefined ? this.parentId : null as any;
        data["regionName"] = this.regionName !== undefined ? this.regionName : null as any;
        data["spell"] = this.spell !== undefined ? this.spell : null as any;
        data["spellShort"] = this.spellShort !== undefined ? this.spellShort : null as any;
        data["displaySequence"] = this.displaySequence !== undefined ? this.displaySequence : null as any;
        data["path"] = this.path !== undefined ? this.path : null as any;
        data["depth"] = this.depth !== undefined ? this.depth : null as any;
        data["fullRegionName"] = this.fullRegionName !== undefined ? this.fullRegionName : null as any;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class RegisterInput {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse!: string | null;

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
            this.captchaResponse = _data["captchaResponse"] !== undefined ? _data["captchaResponse"] : null as any;
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["surname"] = this.surname !== undefined ? this.surname : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        data["captchaResponse"] = this.captchaResponse !== undefined ? this.captchaResponse : null as any;
        return data;
    }
}

export class RegisterOutput {
    canLogin!: boolean;

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"] !== undefined ? _data["canLogin"] : null as any;
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin !== undefined ? this.canLogin : null as any;
        return data;
    }
}

export class ResetFullNameInput {
    userId!: number;
    fullName!: string | null;
    c!: string | null;

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.c = _data["c"] !== undefined ? _data["c"] : null as any;
        }
    }

    static fromJS(data: any): ResetFullNameInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetFullNameInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["c"] = this.c !== undefined ? this.c : null as any;
        return data;
    }
}

export class ResetPasswordDto {
    adminPassword!: string;
    userId!: number;
    newPassword!: string;

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"] !== undefined ? _data["adminPassword"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : null as any;
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword !== undefined ? this.adminPassword : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["newPassword"] = this.newPassword !== undefined ? this.newPassword : null as any;
        return data;
    }
}

export class ResetPasswordInput {
    userIdStr!: string | null;
    userId!: number;
    resetCode!: string | null;
    password!: string | null;
    returnUrl!: string | null;
    singleSignIn!: string | null;
    c!: string | null;

    init(_data?: any) {
        if (_data) {
            this.userIdStr = _data["userIdStr"] !== undefined ? _data["userIdStr"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.resetCode = _data["resetCode"] !== undefined ? _data["resetCode"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
            this.returnUrl = _data["returnUrl"] !== undefined ? _data["returnUrl"] : null as any;
            this.singleSignIn = _data["singleSignIn"] !== undefined ? _data["singleSignIn"] : null as any;
            this.c = _data["c"] !== undefined ? _data["c"] : null as any;
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userIdStr"] = this.userIdStr !== undefined ? this.userIdStr : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["resetCode"] = this.resetCode !== undefined ? this.resetCode : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        data["returnUrl"] = this.returnUrl !== undefined ? this.returnUrl : null as any;
        data["singleSignIn"] = this.singleSignIn !== undefined ? this.singleSignIn : null as any;
        data["c"] = this.c !== undefined ? this.c : null as any;
        return data;
    }
}

export class ResetPasswordOutput {
    canLogin!: boolean;
    userName!: string | null;
    errorMsg!: string | null;

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"] !== undefined ? _data["canLogin"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.errorMsg = _data["errorMsg"] !== undefined ? _data["errorMsg"] : null as any;
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin !== undefined ? this.canLogin : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["errorMsg"] = this.errorMsg !== undefined ? this.errorMsg : null as any;
        return data;
    }
}

/** 离职人员参数 */
export class ResignEmployeeArgs {
    /** 任务名称 */
    jobName!: string | null;
    /** 邮箱过滤字符 */
    emailContains!: string | null;
    /** 测试邮件地址(小写) */
    emails!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.jobName = _data["jobName"] !== undefined ? _data["jobName"] : null as any;
            this.emailContains = _data["emailContains"] !== undefined ? _data["emailContains"] : null as any;
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            else {
                this.emails = null as any;
            }
        }
    }

    static fromJS(data: any): ResignEmployeeArgs {
        data = typeof data === 'object' ? data : {};
        let result = new ResignEmployeeArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobName"] = this.jobName !== undefined ? this.jobName : null as any;
        data["emailContains"] = this.emailContains !== undefined ? this.emailContains : null as any;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        return data;
    }
}

export class Role {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    tenantId!: number | null;
    name!: string;
    displayName!: string;
    isStatic!: boolean;
    isDefault!: boolean;
    permissions!: RolePermissionSetting[] | null;
    normalizedName!: string;
    claims!: RoleClaim[] | null;
    concurrencyStamp!: string | null;
    deleterUser!: User;
    creatorUser!: User;
    lastModifierUser!: User;
    level!: number;
    description!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null as any;
            this.isStatic = _data["isStatic"] !== undefined ? _data["isStatic"] : null as any;
            this.isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : null as any;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(RolePermissionSetting.fromJS(item));
            }
            else {
                this.permissions = null as any;
            }
            this.normalizedName = _data["normalizedName"] !== undefined ? _data["normalizedName"] : null as any;
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(RoleClaim.fromJS(item));
            }
            else {
                this.claims = null as any;
            }
            this.concurrencyStamp = _data["concurrencyStamp"] !== undefined ? _data["concurrencyStamp"] : null as any;
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : null as any;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : null as any;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : null as any;
            this.level = _data["level"] !== undefined ? _data["level"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        data["isStatic"] = this.isStatic !== undefined ? this.isStatic : null as any;
        data["isDefault"] = this.isDefault !== undefined ? this.isDefault : null as any;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : null as any);
        }
        data["normalizedName"] = this.normalizedName !== undefined ? this.normalizedName : null as any;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item ? item.toJSON() : null as any);
        }
        data["concurrencyStamp"] = this.concurrencyStamp !== undefined ? this.concurrencyStamp : null as any;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : null as any;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : null as any;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : null as any;
        data["level"] = this.level !== undefined ? this.level : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }
}

export class RoleClaim {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    tenantId!: number | null;
    roleId!: number;
    claimType!: string | null;
    claimValue!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : null as any;
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : null as any;
            this.claimType = _data["claimType"] !== undefined ? _data["claimType"] : null as any;
            this.claimValue = _data["claimValue"] !== undefined ? _data["claimValue"] : null as any;
        }
    }

    static fromJS(data: any): RoleClaim {
        data = typeof data === 'object' ? data : {};
        let result = new RoleClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null as any;
        data["roleId"] = this.roleId !== undefined ? this.roleId : null as any;
        data["claimType"] = this.claimType !== undefined ? this.claimType : null as any;
        data["claimValue"] = this.claimValue !== undefined ? this.claimValue : null as any;
        return data;
    }
}

export class RoleDto {
    id!: number;
    name!: string;
    displayName!: string;
    normalizedName!: string | null;
    description!: string | null;
    grantedPermissions!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null as any;
            this.normalizedName = _data["normalizedName"] !== undefined ? _data["normalizedName"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
            else {
                this.grantedPermissions = null as any;
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        data["normalizedName"] = this.normalizedName !== undefined ? this.normalizedName : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }
}

export class RoleDtoListResultDto {
    items!: RoleDto[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class RoleDtoPagedResultDto {
    items!: RoleDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class RoleEditDto {
    id!: number;
    name!: string;
    displayName!: string;
    description!: string | null;
    isStatic!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.isStatic = _data["isStatic"] !== undefined ? _data["isStatic"] : null as any;
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["isStatic"] = this.isStatic !== undefined ? this.isStatic : null as any;
        return data;
    }
}

export class RoleListDto {
    id!: number;
    name!: string | null;
    displayName!: string | null;
    isStatic!: boolean;
    isDefault!: boolean;
    creationTime!: moment.Moment;
    level!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null as any;
            this.isStatic = _data["isStatic"] !== undefined ? _data["isStatic"] : null as any;
            this.isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.level = _data["level"] !== undefined ? _data["level"] : null as any;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        data["isStatic"] = this.isStatic !== undefined ? this.isStatic : null as any;
        data["isDefault"] = this.isDefault !== undefined ? this.isDefault : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["level"] = this.level !== undefined ? this.level : null as any;
        return data;
    }
}

export class RoleListDtoListResultDto {
    items!: RoleListDto[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class RolePermissionSetting {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    tenantId!: number | null;
    name!: string;
    isGranted!: boolean;
    roleId!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.isGranted = _data["isGranted"] !== undefined ? _data["isGranted"] : null as any;
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : null as any;
        }
    }

    static fromJS(data: any): RolePermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["isGranted"] = this.isGranted !== undefined ? this.isGranted : null as any;
        data["roleId"] = this.roleId !== undefined ? this.roleId : null as any;
        return data;
    }
}

export class RolePermissionsChangeLogsInputDto {
    /** 角色名称 */
    roleName!: string | null;
    /** 操作人 */
    permissionsName!: string | null;
    excelPermissionsName!: string | null;
    /** 操作类型1：删除、2：新增、3：修改 */
    operationType!: number;
    readonly operationName!: string | null;
    /** 操作人 */
    operationUserFullName!: string | null;
    /** 创建时间 */
    createTime!: moment.Moment;
    /** 租户Id */
    tenantId!: number;

    init(_data?: any) {
        if (_data) {
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : null as any;
            this.permissionsName = _data["permissionsName"] !== undefined ? _data["permissionsName"] : null as any;
            this.excelPermissionsName = _data["excelPermissionsName"] !== undefined ? _data["excelPermissionsName"] : null as any;
            this.operationType = _data["operationType"] !== undefined ? _data["operationType"] : null as any;
            (this as any).operationName = _data["operationName"] !== undefined ? _data["operationName"] : null as any;
            this.operationUserFullName = _data["operationUserFullName"] !== undefined ? _data["operationUserFullName"] : null as any;
            this.createTime = _data["createTime"] ? moment(_data["createTime"].toString()) : null as any;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : null as any;
        }
    }

    static fromJS(data: any): RolePermissionsChangeLogsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermissionsChangeLogsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleName"] = this.roleName !== undefined ? this.roleName : null as any;
        data["permissionsName"] = this.permissionsName !== undefined ? this.permissionsName : null as any;
        data["excelPermissionsName"] = this.excelPermissionsName !== undefined ? this.excelPermissionsName : null as any;
        data["operationType"] = this.operationType !== undefined ? this.operationType : null as any;
        data["operationName"] = this.operationName !== undefined ? this.operationName : null as any;
        data["operationUserFullName"] = this.operationUserFullName !== undefined ? this.operationUserFullName : null as any;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : null as any;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null as any;
        return data;
    }
}

export class RolePermissionsChangeLogsInputDtoPagedResultDto {
    items!: RolePermissionsChangeLogsInputDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RolePermissionsChangeLogsInputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): RolePermissionsChangeLogsInputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermissionsChangeLogsInputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 发送邮件 */
export class SendMailCCDto {
    /** 1：用户：只用传用户id即可
2：角色：只用传角色名称即可
3：邮箱：只用穿邮箱地址即可 */
    sendMailType!: number;
    /** 标题 */
    subject!: string;
    /** 系统业务简略说明，在收件箱中显示 */
    description!: string | null;
    /** 字幕 */
    subTitle!: string | null;
    /** 邮件介绍 */
    graph!: string | null;
    /** 内容 */
    body!: string;
    /** 收件人集合 */
    sendMailUserDtos!: SendMailUserDto[] | null;
    /** 抄送人集合 */
    sendMailCCUserDtos!: SendMailUserDto[] | null;
    mailTableButton!: MailTableButton;
    mailTable!: MailTable;

    init(_data?: any) {
        if (_data) {
            this.sendMailType = _data["sendMailType"] !== undefined ? _data["sendMailType"] : null as any;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.subTitle = _data["subTitle"] !== undefined ? _data["subTitle"] : null as any;
            this.graph = _data["graph"] !== undefined ? _data["graph"] : null as any;
            this.body = _data["body"] !== undefined ? _data["body"] : null as any;
            if (Array.isArray(_data["sendMailUserDtos"])) {
                this.sendMailUserDtos = [] as any;
                for (let item of _data["sendMailUserDtos"])
                    this.sendMailUserDtos!.push(SendMailUserDto.fromJS(item));
            }
            else {
                this.sendMailUserDtos = null as any;
            }
            if (Array.isArray(_data["sendMailCCUserDtos"])) {
                this.sendMailCCUserDtos = [] as any;
                for (let item of _data["sendMailCCUserDtos"])
                    this.sendMailCCUserDtos!.push(SendMailUserDto.fromJS(item));
            }
            else {
                this.sendMailCCUserDtos = null as any;
            }
            this.mailTableButton = _data["mailTableButton"] ? MailTableButton.fromJS(_data["mailTableButton"]) : null as any;
            this.mailTable = _data["mailTable"] ? MailTable.fromJS(_data["mailTable"]) : null as any;
        }
    }

    static fromJS(data: any): SendMailCCDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendMailCCDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sendMailType"] = this.sendMailType !== undefined ? this.sendMailType : null as any;
        data["subject"] = this.subject !== undefined ? this.subject : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["subTitle"] = this.subTitle !== undefined ? this.subTitle : null as any;
        data["graph"] = this.graph !== undefined ? this.graph : null as any;
        data["body"] = this.body !== undefined ? this.body : null as any;
        if (Array.isArray(this.sendMailUserDtos)) {
            data["sendMailUserDtos"] = [];
            for (let item of this.sendMailUserDtos)
                data["sendMailUserDtos"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.sendMailCCUserDtos)) {
            data["sendMailCCUserDtos"] = [];
            for (let item of this.sendMailCCUserDtos)
                data["sendMailCCUserDtos"].push(item ? item.toJSON() : null as any);
        }
        data["mailTableButton"] = this.mailTableButton ? this.mailTableButton.toJSON() : null as any;
        data["mailTable"] = this.mailTable ? this.mailTable.toJSON() : null as any;
        return data;
    }
}

/** 发送邮件 */
export class SendMailDto {
    /** 1：用户：只用传用户id即可
2：角色：只用传角色名称即可
3：邮箱：只用穿邮箱地址即可 */
    sendMailType!: number;
    /** 标题 */
    subject!: string | null;
    /** 系统业务简略说明，在收件箱中显示 */
    description!: string | null;
    /** 字幕 */
    subTitle!: string | null;
    /** 邮件介绍 */
    graph!: string | null;
    /** 内容 */
    body!: string | null;
    /** 收件人集合 */
    sendMailUserDtos!: SendMailUserDto[] | null;
    mailTableButton!: MailTableButton;
    mailTable!: MailTable;
    attachments!: Attachment[] | null;
    /** 1.blob文件地址传递 2.stream传递 */
    attachmentType!: number;

    init(_data?: any) {
        if (_data) {
            this.sendMailType = _data["sendMailType"] !== undefined ? _data["sendMailType"] : null as any;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.subTitle = _data["subTitle"] !== undefined ? _data["subTitle"] : null as any;
            this.graph = _data["graph"] !== undefined ? _data["graph"] : null as any;
            this.body = _data["body"] !== undefined ? _data["body"] : null as any;
            if (Array.isArray(_data["sendMailUserDtos"])) {
                this.sendMailUserDtos = [] as any;
                for (let item of _data["sendMailUserDtos"])
                    this.sendMailUserDtos!.push(SendMailUserDto.fromJS(item));
            }
            else {
                this.sendMailUserDtos = null as any;
            }
            this.mailTableButton = _data["mailTableButton"] ? MailTableButton.fromJS(_data["mailTableButton"]) : null as any;
            this.mailTable = _data["mailTable"] ? MailTable.fromJS(_data["mailTable"]) : null as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(Attachment.fromJS(item));
            }
            else {
                this.attachments = null as any;
            }
            this.attachmentType = _data["attachmentType"] !== undefined ? _data["attachmentType"] : null as any;
        }
    }

    static fromJS(data: any): SendMailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendMailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sendMailType"] = this.sendMailType !== undefined ? this.sendMailType : null as any;
        data["subject"] = this.subject !== undefined ? this.subject : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["subTitle"] = this.subTitle !== undefined ? this.subTitle : null as any;
        data["graph"] = this.graph !== undefined ? this.graph : null as any;
        data["body"] = this.body !== undefined ? this.body : null as any;
        if (Array.isArray(this.sendMailUserDtos)) {
            data["sendMailUserDtos"] = [];
            for (let item of this.sendMailUserDtos)
                data["sendMailUserDtos"].push(item ? item.toJSON() : null as any);
        }
        data["mailTableButton"] = this.mailTableButton ? this.mailTableButton.toJSON() : null as any;
        data["mailTable"] = this.mailTable ? this.mailTable.toJSON() : null as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : null as any);
        }
        data["attachmentType"] = this.attachmentType !== undefined ? this.attachmentType : null as any;
        return data;
    }
}

/** 人员/角色 */
export class SendMailUserDto {
    /** 人员id */
    userId!: number;
    /** 角色名称 */
    roleName!: string | null;
    /** 邮箱地址 */
    email!: string | null;

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): SendMailUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendMailUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export class Setting {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    tenantId!: number | null;
    userId!: number | null;
    name!: string;
    value!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }
}

/** 收货地址dto */
export class ShippingAddressDto {
    id!: number;
    code!: string | null;
    seq!: number | null;
    customerInfoCusNo!: string | null;
    /** 收货地址类型
仓库 站点 等 */
    shipType!: number;
    /** 收货标签 */
    tag!: string | null;
    /** 国家 */
    country!: string | null;
    /** 城市 */
    city!: string | null;
    /** 联系人 */
    contactName!: string | null;
    /** Fax */
    fax!: string | null;
    /** 收货地址代号 */
    shipNumber!: string | null;
    regionId!: number | null;
    /** 收货地址名称 */
    shipName!: string | null;
    address!: string | null;
    /** 邮编 */
    zipcode!: string | null;
    emailAddress!: string | null;
    telPhone!: string | null;
    celPhone!: string | null;
    isDefault!: boolean | null;
    aliases!: string | null;
    latitude!: number | null;
    longitude!: number | null;
    remark!: string | null;
    /** 预留字段 后期可以作为用户的收货地址 */
    userId!: number | null;
    /** 是否勾选特殊附件 */
    hasSpecialAttachment!: boolean;
    /** 特殊附件文件名 */
    specialAttachmentName!: string | null;
    /** 是否勾选发运送货要求 */
    hasDeliveryRequirement!: boolean;
    /** 发运送货要求附件文件名 */
    deliveryRequirementAttachmentName!: string | null;
    regionIdList!: number[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.seq = _data["seq"] !== undefined ? _data["seq"] : null as any;
            this.customerInfoCusNo = _data["customerInfoCusNo"] !== undefined ? _data["customerInfoCusNo"] : null as any;
            this.shipType = _data["shipType"] !== undefined ? _data["shipType"] : null as any;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : null as any;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : null as any;
            this.shipNumber = _data["shipNumber"] !== undefined ? _data["shipNumber"] : null as any;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : null as any;
            this.shipName = _data["shipName"] !== undefined ? _data["shipName"] : null as any;
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
            this.zipcode = _data["zipcode"] !== undefined ? _data["zipcode"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.telPhone = _data["telPhone"] !== undefined ? _data["telPhone"] : null as any;
            this.celPhone = _data["celPhone"] !== undefined ? _data["celPhone"] : null as any;
            this.isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : null as any;
            this.aliases = _data["aliases"] !== undefined ? _data["aliases"] : null as any;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null as any;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.hasSpecialAttachment = _data["hasSpecialAttachment"] !== undefined ? _data["hasSpecialAttachment"] : null as any;
            this.specialAttachmentName = _data["specialAttachmentName"] !== undefined ? _data["specialAttachmentName"] : null as any;
            this.hasDeliveryRequirement = _data["hasDeliveryRequirement"] !== undefined ? _data["hasDeliveryRequirement"] : null as any;
            this.deliveryRequirementAttachmentName = _data["deliveryRequirementAttachmentName"] !== undefined ? _data["deliveryRequirementAttachmentName"] : null as any;
            if (Array.isArray(_data["regionIdList"])) {
                this.regionIdList = [] as any;
                for (let item of _data["regionIdList"])
                    this.regionIdList!.push(item);
            }
            else {
                this.regionIdList = null as any;
            }
        }
    }

    static fromJS(data: any): ShippingAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["seq"] = this.seq !== undefined ? this.seq : null as any;
        data["customerInfoCusNo"] = this.customerInfoCusNo !== undefined ? this.customerInfoCusNo : null as any;
        data["shipType"] = this.shipType !== undefined ? this.shipType : null as any;
        data["tag"] = this.tag !== undefined ? this.tag : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["contactName"] = this.contactName !== undefined ? this.contactName : null as any;
        data["fax"] = this.fax !== undefined ? this.fax : null as any;
        data["shipNumber"] = this.shipNumber !== undefined ? this.shipNumber : null as any;
        data["regionId"] = this.regionId !== undefined ? this.regionId : null as any;
        data["shipName"] = this.shipName !== undefined ? this.shipName : null as any;
        data["address"] = this.address !== undefined ? this.address : null as any;
        data["zipcode"] = this.zipcode !== undefined ? this.zipcode : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["telPhone"] = this.telPhone !== undefined ? this.telPhone : null as any;
        data["celPhone"] = this.celPhone !== undefined ? this.celPhone : null as any;
        data["isDefault"] = this.isDefault !== undefined ? this.isDefault : null as any;
        data["aliases"] = this.aliases !== undefined ? this.aliases : null as any;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null as any;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["hasSpecialAttachment"] = this.hasSpecialAttachment !== undefined ? this.hasSpecialAttachment : null as any;
        data["specialAttachmentName"] = this.specialAttachmentName !== undefined ? this.specialAttachmentName : null as any;
        data["hasDeliveryRequirement"] = this.hasDeliveryRequirement !== undefined ? this.hasDeliveryRequirement : null as any;
        data["deliveryRequirementAttachmentName"] = this.deliveryRequirementAttachmentName !== undefined ? this.deliveryRequirementAttachmentName : null as any;
        if (Array.isArray(this.regionIdList)) {
            data["regionIdList"] = [];
            for (let item of this.regionIdList)
                data["regionIdList"].push(item);
        }
        return data;
    }
}

/** 1 = Available 2 = InActive 3 = NotFound */
export enum TenantAvailabilityState {
    Available = 1,
    InActive = 2,
    NotFound = 3,
}

export class TenantEmailSettingsEditDto {
    defaultFromAddress!: string | null;
    defaultFromDisplayName!: string | null;
    smtpHost!: string | null;
    smtpPort!: number;
    smtpUserName!: string | null;
    smtpPassword!: string | null;
    smtpDomain!: string | null;
    smtpEnableSsl!: boolean;
    smtpUseDefaultCredentials!: boolean;
    useHostDefaultEmailSettings!: boolean;

    init(_data?: any) {
        if (_data) {
            this.defaultFromAddress = _data["defaultFromAddress"] !== undefined ? _data["defaultFromAddress"] : null as any;
            this.defaultFromDisplayName = _data["defaultFromDisplayName"] !== undefined ? _data["defaultFromDisplayName"] : null as any;
            this.smtpHost = _data["smtpHost"] !== undefined ? _data["smtpHost"] : null as any;
            this.smtpPort = _data["smtpPort"] !== undefined ? _data["smtpPort"] : null as any;
            this.smtpUserName = _data["smtpUserName"] !== undefined ? _data["smtpUserName"] : null as any;
            this.smtpPassword = _data["smtpPassword"] !== undefined ? _data["smtpPassword"] : null as any;
            this.smtpDomain = _data["smtpDomain"] !== undefined ? _data["smtpDomain"] : null as any;
            this.smtpEnableSsl = _data["smtpEnableSsl"] !== undefined ? _data["smtpEnableSsl"] : null as any;
            this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"] !== undefined ? _data["smtpUseDefaultCredentials"] : null as any;
            this.useHostDefaultEmailSettings = _data["useHostDefaultEmailSettings"] !== undefined ? _data["useHostDefaultEmailSettings"] : null as any;
        }
    }

    static fromJS(data: any): TenantEmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress !== undefined ? this.defaultFromAddress : null as any;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName !== undefined ? this.defaultFromDisplayName : null as any;
        data["smtpHost"] = this.smtpHost !== undefined ? this.smtpHost : null as any;
        data["smtpPort"] = this.smtpPort !== undefined ? this.smtpPort : null as any;
        data["smtpUserName"] = this.smtpUserName !== undefined ? this.smtpUserName : null as any;
        data["smtpPassword"] = this.smtpPassword !== undefined ? this.smtpPassword : null as any;
        data["smtpDomain"] = this.smtpDomain !== undefined ? this.smtpDomain : null as any;
        data["smtpEnableSsl"] = this.smtpEnableSsl !== undefined ? this.smtpEnableSsl : null as any;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials !== undefined ? this.smtpUseDefaultCredentials : null as any;
        data["useHostDefaultEmailSettings"] = this.useHostDefaultEmailSettings !== undefined ? this.useHostDefaultEmailSettings : null as any;
        return data;
    }
}

export class TenantLoginInfoDto {
    id!: number;
    tenancyName!: string | null;
    name!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tenancyName = _data["tenancyName"] !== undefined ? _data["tenancyName"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tenancyName"] = this.tenancyName !== undefined ? this.tenancyName : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

/** 启动参数 */
export class TransferEmployeeArgs {
    /** 任务名称 */
    jobName!: string | null;
    /** 邮箱过滤字符 */
    emailContains!: string | null;
    /** 调动日期 */
    date!: string | null;
    /** 测试邮件地址(大写) */
    emails!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.jobName = _data["jobName"] !== undefined ? _data["jobName"] : null as any;
            this.emailContains = _data["emailContains"] !== undefined ? _data["emailContains"] : null as any;
            this.date = _data["date"] !== undefined ? _data["date"] : null as any;
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            else {
                this.emails = null as any;
            }
        }
    }

    static fromJS(data: any): TransferEmployeeArgs {
        data = typeof data === 'object' ? data : {};
        let result = new TransferEmployeeArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobName"] = this.jobName !== undefined ? this.jobName : null as any;
        data["emailContains"] = this.emailContains !== undefined ? this.emailContains : null as any;
        data["date"] = this.date !== undefined ? this.date : null as any;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        return data;
    }
}

/** 0 = QuotedPrintable 1 = Base64 2 = SevenBit 3 = EightBit -1 = Unknown */
export enum TransferEncoding {
    QuotedPrintable = 0,
    Base64 = 1,
    SevenBit = 2,
    EightBit = 3,
    Unknown = -1,
}

export class UpdateUserSignInTokenOutput {
    signInToken!: string | null;
    encodedUserId!: string | null;
    encodedTenantId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.signInToken = _data["signInToken"] !== undefined ? _data["signInToken"] : null as any;
            this.encodedUserId = _data["encodedUserId"] !== undefined ? _data["encodedUserId"] : null as any;
            this.encodedTenantId = _data["encodedTenantId"] !== undefined ? _data["encodedTenantId"] : null as any;
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken !== undefined ? this.signInToken : null as any;
        data["encodedUserId"] = this.encodedUserId !== undefined ? this.encodedUserId : null as any;
        data["encodedTenantId"] = this.encodedTenantId !== undefined ? this.encodedTenantId : null as any;
        return data;
    }
}

export class User {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    authenticationSource!: string | null;
    userName!: string;
    tenantId!: number | null;
    name!: string;
    surname!: string;
    password!: string;
    emailConfirmationCode!: string | null;
    passwordResetCode!: string | null;
    lockoutEndDateUtc!: moment.Moment | null;
    accessFailedCount!: number;
    isLockoutEnabled!: boolean;
    phoneNumber!: string | null;
    isPhoneNumberConfirmed!: boolean;
    securityStamp!: string | null;
    isTwoFactorEnabled!: boolean;
    logins!: UserLogin[] | null;
    roles!: UserRole[] | null;
    claims!: UserClaim[] | null;
    permissions!: UserPermissionSetting[] | null;
    settings!: Setting[] | null;
    isEmailConfirmed!: boolean;
    isActive!: boolean;
    normalizedUserName!: string;
    normalizedEmailAddress!: string;
    concurrencyStamp!: string | null;
    tokens!: UserToken[] | null;
    deleterUser!: User;
    creatorUser!: User;
    lastModifierUser!: User;
    identiFierId!: string | null;
    realPassword!: string | null;
    signInToken!: string | null;
    signInTokenExpireTimeUtc!: moment.Moment | null;
    companyName!: string | null;
    sapCode!: string | null;
    shouldChangePasswordOnNextLogin!: boolean;
    isDisabled!: boolean;
    englishName!: string | null;
    adAccount!: string | null;
    chineseName!: string | null;
    fullName!: string | null;
    emailAddress!: string | null;
    roleName!: string | null;
    customerInfoCusNo!: string | null;
    channelPartnerCustomerInfo!: CustomerInfo;
    customerSales!: CustomerSales[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.authenticationSource = _data["authenticationSource"] !== undefined ? _data["authenticationSource"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
            this.emailConfirmationCode = _data["emailConfirmationCode"] !== undefined ? _data["emailConfirmationCode"] : null as any;
            this.passwordResetCode = _data["passwordResetCode"] !== undefined ? _data["passwordResetCode"] : null as any;
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : null as any;
            this.accessFailedCount = _data["accessFailedCount"] !== undefined ? _data["accessFailedCount"] : null as any;
            this.isLockoutEnabled = _data["isLockoutEnabled"] !== undefined ? _data["isLockoutEnabled"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"] !== undefined ? _data["isPhoneNumberConfirmed"] : null as any;
            this.securityStamp = _data["securityStamp"] !== undefined ? _data["securityStamp"] : null as any;
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"] !== undefined ? _data["isTwoFactorEnabled"] : null as any;
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins!.push(UserLogin.fromJS(item));
            }
            else {
                this.logins = null as any;
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRole.fromJS(item));
            }
            else {
                this.roles = null as any;
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(UserClaim.fromJS(item));
            }
            else {
                this.claims = null as any;
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(UserPermissionSetting.fromJS(item));
            }
            else {
                this.permissions = null as any;
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings!.push(Setting.fromJS(item));
            }
            else {
                this.settings = null as any;
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"] !== undefined ? _data["isEmailConfirmed"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            this.normalizedUserName = _data["normalizedUserName"] !== undefined ? _data["normalizedUserName"] : null as any;
            this.normalizedEmailAddress = _data["normalizedEmailAddress"] !== undefined ? _data["normalizedEmailAddress"] : null as any;
            this.concurrencyStamp = _data["concurrencyStamp"] !== undefined ? _data["concurrencyStamp"] : null as any;
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens!.push(UserToken.fromJS(item));
            }
            else {
                this.tokens = null as any;
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : null as any;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : null as any;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : null as any;
            this.identiFierId = _data["identiFierId"] !== undefined ? _data["identiFierId"] : null as any;
            this.realPassword = _data["realPassword"] !== undefined ? _data["realPassword"] : null as any;
            this.signInToken = _data["signInToken"] !== undefined ? _data["signInToken"] : null as any;
            this.signInTokenExpireTimeUtc = _data["signInTokenExpireTimeUtc"] ? moment(_data["signInTokenExpireTimeUtc"].toString()) : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.sapCode = _data["sapCode"] !== undefined ? _data["sapCode"] : null as any;
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"] !== undefined ? _data["shouldChangePasswordOnNextLogin"] : null as any;
            this.isDisabled = _data["isDisabled"] !== undefined ? _data["isDisabled"] : null as any;
            this.englishName = _data["englishName"] !== undefined ? _data["englishName"] : null as any;
            this.adAccount = _data["adAccount"] !== undefined ? _data["adAccount"] : null as any;
            this.chineseName = _data["chineseName"] !== undefined ? _data["chineseName"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : null as any;
            this.customerInfoCusNo = _data["customerInfoCusNo"] !== undefined ? _data["customerInfoCusNo"] : null as any;
            this.channelPartnerCustomerInfo = _data["channelPartnerCustomerInfo"] ? CustomerInfo.fromJS(_data["channelPartnerCustomerInfo"]) : null as any;
            if (Array.isArray(_data["customerSales"])) {
                this.customerSales = [] as any;
                for (let item of _data["customerSales"])
                    this.customerSales!.push(CustomerSales.fromJS(item));
            }
            else {
                this.customerSales = null as any;
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["authenticationSource"] = this.authenticationSource !== undefined ? this.authenticationSource : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["surname"] = this.surname !== undefined ? this.surname : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        data["emailConfirmationCode"] = this.emailConfirmationCode !== undefined ? this.emailConfirmationCode : null as any;
        data["passwordResetCode"] = this.passwordResetCode !== undefined ? this.passwordResetCode : null as any;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : null as any;
        data["accessFailedCount"] = this.accessFailedCount !== undefined ? this.accessFailedCount : null as any;
        data["isLockoutEnabled"] = this.isLockoutEnabled !== undefined ? this.isLockoutEnabled : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed !== undefined ? this.isPhoneNumberConfirmed : null as any;
        data["securityStamp"] = this.securityStamp !== undefined ? this.securityStamp : null as any;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled !== undefined ? this.isTwoFactorEnabled : null as any;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item ? item.toJSON() : null as any);
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed !== undefined ? this.isEmailConfirmed : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        data["normalizedUserName"] = this.normalizedUserName !== undefined ? this.normalizedUserName : null as any;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress !== undefined ? this.normalizedEmailAddress : null as any;
        data["concurrencyStamp"] = this.concurrencyStamp !== undefined ? this.concurrencyStamp : null as any;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item ? item.toJSON() : null as any);
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : null as any;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : null as any;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : null as any;
        data["identiFierId"] = this.identiFierId !== undefined ? this.identiFierId : null as any;
        data["realPassword"] = this.realPassword !== undefined ? this.realPassword : null as any;
        data["signInToken"] = this.signInToken !== undefined ? this.signInToken : null as any;
        data["signInTokenExpireTimeUtc"] = this.signInTokenExpireTimeUtc ? this.signInTokenExpireTimeUtc.toISOString() : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["sapCode"] = this.sapCode !== undefined ? this.sapCode : null as any;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin !== undefined ? this.shouldChangePasswordOnNextLogin : null as any;
        data["isDisabled"] = this.isDisabled !== undefined ? this.isDisabled : null as any;
        data["englishName"] = this.englishName !== undefined ? this.englishName : null as any;
        data["adAccount"] = this.adAccount !== undefined ? this.adAccount : null as any;
        data["chineseName"] = this.chineseName !== undefined ? this.chineseName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null as any;
        data["customerInfoCusNo"] = this.customerInfoCusNo !== undefined ? this.customerInfoCusNo : null as any;
        data["channelPartnerCustomerInfo"] = this.channelPartnerCustomerInfo ? this.channelPartnerCustomerInfo.toJSON() : null as any;
        if (Array.isArray(this.customerSales)) {
            data["customerSales"] = [];
            for (let item of this.customerSales)
                data["customerSales"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class UserClaim {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    tenantId!: number | null;
    userId!: number;
    claimType!: string | null;
    claimValue!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.claimType = _data["claimType"] !== undefined ? _data["claimType"] : null as any;
            this.claimValue = _data["claimValue"] !== undefined ? _data["claimValue"] : null as any;
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["claimType"] = this.claimType !== undefined ? this.claimType : null as any;
        data["claimValue"] = this.claimValue !== undefined ? this.claimValue : null as any;
        return data;
    }
}

export class UserDto {
    id!: number;
    companyName!: string | null;
    userName!: string;
    name!: string;
    surname!: string;
    emailAddress!: string;
    isActive!: boolean;
    fullName!: string | null;
    lastLoginTime!: moment.Moment | null;
    readonly lastLoginTimeString!: string | null;
    creationTime!: moment.Moment;
    roleNames!: string[] | null;
    roleDisplayName!: string[] | null;
    customerInfoCusNo!: string | null;
    salesCusNos!: string[] | null;
    isDisabled!: boolean;
    isLock!: boolean;
    identiFierId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : null as any;
            (this as any).lastLoginTimeString = _data["lastLoginTimeString"] !== undefined ? _data["lastLoginTimeString"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            else {
                this.roleNames = null as any;
            }
            if (Array.isArray(_data["roleDisplayName"])) {
                this.roleDisplayName = [] as any;
                for (let item of _data["roleDisplayName"])
                    this.roleDisplayName!.push(item);
            }
            else {
                this.roleDisplayName = null as any;
            }
            this.customerInfoCusNo = _data["customerInfoCusNo"] !== undefined ? _data["customerInfoCusNo"] : null as any;
            if (Array.isArray(_data["salesCusNos"])) {
                this.salesCusNos = [] as any;
                for (let item of _data["salesCusNos"])
                    this.salesCusNos!.push(item);
            }
            else {
                this.salesCusNos = null as any;
            }
            this.isDisabled = _data["isDisabled"] !== undefined ? _data["isDisabled"] : null as any;
            this.isLock = _data["isLock"] !== undefined ? _data["isLock"] : null as any;
            this.identiFierId = _data["identiFierId"] !== undefined ? _data["identiFierId"] : null as any;
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["surname"] = this.surname !== undefined ? this.surname : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : null as any;
        data["lastLoginTimeString"] = this.lastLoginTimeString !== undefined ? this.lastLoginTimeString : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        if (Array.isArray(this.roleDisplayName)) {
            data["roleDisplayName"] = [];
            for (let item of this.roleDisplayName)
                data["roleDisplayName"].push(item);
        }
        data["customerInfoCusNo"] = this.customerInfoCusNo !== undefined ? this.customerInfoCusNo : null as any;
        if (Array.isArray(this.salesCusNos)) {
            data["salesCusNos"] = [];
            for (let item of this.salesCusNos)
                data["salesCusNos"].push(item);
        }
        data["isDisabled"] = this.isDisabled !== undefined ? this.isDisabled : null as any;
        data["isLock"] = this.isLock !== undefined ? this.isLock : null as any;
        data["identiFierId"] = this.identiFierId !== undefined ? this.identiFierId : null as any;
        return data;
    }
}

export class UserDtoPagedResultDto {
    items!: UserDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class UserLogin {
    id!: number;
    tenantId!: number | null;
    userId!: number;
    loginProvider!: string;
    providerKey!: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.loginProvider = _data["loginProvider"] !== undefined ? _data["loginProvider"] : null as any;
            this.providerKey = _data["providerKey"] !== undefined ? _data["providerKey"] : null as any;
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["loginProvider"] = this.loginProvider !== undefined ? this.loginProvider : null as any;
        data["providerKey"] = this.providerKey !== undefined ? this.providerKey : null as any;
        return data;
    }
}

export class UserLoginInfoDto {
    id!: number;
    name!: string | null;
    surname!: string | null;
    userName!: string | null;
    emailAddress!: string | null;
    fullName!: string | null;
    customerInfoCusNo!: string | null;
    roleName!: string | null;
    sapCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.customerInfoCusNo = _data["customerInfoCusNo"] !== undefined ? _data["customerInfoCusNo"] : null as any;
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : null as any;
            this.sapCode = _data["sapCode"] !== undefined ? _data["sapCode"] : null as any;
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["surname"] = this.surname !== undefined ? this.surname : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["customerInfoCusNo"] = this.customerInfoCusNo !== undefined ? this.customerInfoCusNo : null as any;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null as any;
        data["sapCode"] = this.sapCode !== undefined ? this.sapCode : null as any;
        return data;
    }
}

export class UserPermissionSetting {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    tenantId!: number | null;
    name!: string;
    isGranted!: boolean;
    userId!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.isGranted = _data["isGranted"] !== undefined ? _data["isGranted"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["isGranted"] = this.isGranted !== undefined ? this.isGranted : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        return data;
    }
}

export class UserRole {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    tenantId!: number | null;
    userId!: number;
    roleId!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : null as any;
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["roleId"] = this.roleId !== undefined ? this.roleId : null as any;
        return data;
    }
}

export class UserRoleChangeLogInputDto {
    userId!: number;
    userFullName!: string | null;
    emailAddress!: string | null;
    fullName!: string | null;
    operationUserFullName!: string | null;
    readonly operationUserName!: string | null;
    historyRoleName!: string | null;
    persentRoleName!: string | null;
    createTime!: moment.Moment;
    tenantId!: number;
    /** 状态1：新增，2：修改，3：删除，4：激活，5：冻结，6：启用，7：禁用 */
    logType!: number | null;
    readonly logTypeName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.userFullName = _data["userFullName"] !== undefined ? _data["userFullName"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.operationUserFullName = _data["operationUserFullName"] !== undefined ? _data["operationUserFullName"] : null as any;
            (this as any).operationUserName = _data["operationUserName"] !== undefined ? _data["operationUserName"] : null as any;
            this.historyRoleName = _data["historyRoleName"] !== undefined ? _data["historyRoleName"] : null as any;
            this.persentRoleName = _data["persentRoleName"] !== undefined ? _data["persentRoleName"] : null as any;
            this.createTime = _data["createTime"] ? moment(_data["createTime"].toString()) : null as any;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : null as any;
            this.logType = _data["logType"] !== undefined ? _data["logType"] : null as any;
            (this as any).logTypeName = _data["logTypeName"] !== undefined ? _data["logTypeName"] : null as any;
        }
    }

    static fromJS(data: any): UserRoleChangeLogInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleChangeLogInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userFullName"] = this.userFullName !== undefined ? this.userFullName : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["operationUserFullName"] = this.operationUserFullName !== undefined ? this.operationUserFullName : null as any;
        data["operationUserName"] = this.operationUserName !== undefined ? this.operationUserName : null as any;
        data["historyRoleName"] = this.historyRoleName !== undefined ? this.historyRoleName : null as any;
        data["persentRoleName"] = this.persentRoleName !== undefined ? this.persentRoleName : null as any;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : null as any;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null as any;
        data["logType"] = this.logType !== undefined ? this.logType : null as any;
        data["logTypeName"] = this.logTypeName !== undefined ? this.logTypeName : null as any;
        return data;
    }
}

export class UserRoleChangeLogInputDtoPagedResultDto {
    items!: UserRoleChangeLogInputDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserRoleChangeLogInputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): UserRoleChangeLogInputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleChangeLogInputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 0 = All (全部) 1 = User (普通用户) 2 = SuperUser (超级用户) */
export enum UserRoleTypeEnum {
    All = 0,
    User = 1,
    SuperUser = 2,
}

/** 0 = All (全部) 1 = Available (在用) 2 = Pause (未激活) 3 = Deleted (禁用) */
export enum UserStateEnum {
    All = 0,
    Available = 1,
    Pause = 2,
    Deleted = 3,
}

export class UserToken {
    id!: number;
    tenantId!: number | null;
    userId!: number;
    loginProvider!: string | null;
    name!: string | null;
    value!: string | null;
    expireDate!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.loginProvider = _data["loginProvider"] !== undefined ? _data["loginProvider"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["loginProvider"] = this.loginProvider !== undefined ? this.loginProvider : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : null as any;
        return data;
    }
}

export class ECustomerDumpInput {
    cusNo!: string;
    salesResponsibleUnit!: string;

    init(_data?: any) {
        if (_data) {
            this.cusNo = _data["cusNo"] !== undefined ? _data["cusNo"] : null as any;
            this.salesResponsibleUnit = _data["salesResponsibleUnit"] !== undefined ? _data["salesResponsibleUnit"] : null as any;
        }
    }

    static fromJS(data: any): ECustomerDumpInput {
        data = typeof data === 'object' ? data : {};
        let result = new ECustomerDumpInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cusNo"] = this.cusNo !== undefined ? this.cusNo : null as any;
        data["salesResponsibleUnit"] = this.salesResponsibleUnit !== undefined ? this.salesResponsibleUnit : null as any;
        return data;
    }
}

export class ECustomerDumpResponse {
    messages!: ECustomerDumpResponseMessages;

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ECustomerDumpResponseMessages.fromJS(_data["messages"]) : null as any;
        }
    }

    static fromJS(data: any): ECustomerDumpResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ECustomerDumpResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : null as any;
        return data;
    }
}

export class ECustomerDumpResponseMessages {
    eCustomerDumpResp!: ECustomerDumpResponseMessagesECustomerDumpResp;

    init(_data?: any) {
        if (_data) {
            this.eCustomerDumpResp = _data["eCustomerDumpResp"] ? ECustomerDumpResponseMessagesECustomerDumpResp.fromJS(_data["eCustomerDumpResp"]) : null as any;
        }
    }

    static fromJS(data: any): ECustomerDumpResponseMessages {
        data = typeof data === 'object' ? data : {};
        let result = new ECustomerDumpResponseMessages();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eCustomerDumpResp"] = this.eCustomerDumpResp ? this.eCustomerDumpResp.toJSON() : null as any;
        return data;
    }
}

export class ECustomerDumpResponseMessagesECustomerDumpResp {
    msgHead!: ECustomerDumpResponseMessagesECustomerDumpRespMsgHead;
    customers!: ECustomerDumpResponseMessagesECustomerDumpRespCustomers;
    connectToSUList!: ECustomerDumpResponseMessagesECustomerDumpRespConnectToSUList;

    init(_data?: any) {
        if (_data) {
            this.msgHead = _data["msgHead"] ? ECustomerDumpResponseMessagesECustomerDumpRespMsgHead.fromJS(_data["msgHead"]) : null as any;
            this.customers = _data["customers"] ? ECustomerDumpResponseMessagesECustomerDumpRespCustomers.fromJS(_data["customers"]) : null as any;
            this.connectToSUList = _data["connectToSUList"] ? ECustomerDumpResponseMessagesECustomerDumpRespConnectToSUList.fromJS(_data["connectToSUList"]) : null as any;
        }
    }

    static fromJS(data: any): ECustomerDumpResponseMessagesECustomerDumpResp {
        data = typeof data === 'object' ? data : {};
        let result = new ECustomerDumpResponseMessagesECustomerDumpResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["msgHead"] = this.msgHead ? this.msgHead.toJSON() : null as any;
        data["customers"] = this.customers ? this.customers.toJSON() : null as any;
        data["connectToSUList"] = this.connectToSUList ? this.connectToSUList.toJSON() : null as any;
        return data;
    }
}

export class ECustomerDumpResponseMessagesECustomerDumpRespConnectToSUList {
    connectToSU!: ECustomerDumpResponseMessagesECustomerDumpRespConnectToSUListConnectToSU;

    init(_data?: any) {
        if (_data) {
            this.connectToSU = _data["connectToSU"] ? ECustomerDumpResponseMessagesECustomerDumpRespConnectToSUListConnectToSU.fromJS(_data["connectToSU"]) : null as any;
        }
    }

    static fromJS(data: any): ECustomerDumpResponseMessagesECustomerDumpRespConnectToSUList {
        data = typeof data === 'object' ? data : {};
        let result = new ECustomerDumpResponseMessagesECustomerDumpRespConnectToSUList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectToSU"] = this.connectToSU ? this.connectToSU.toJSON() : null as any;
        return data;
    }
}

export class ECustomerDumpResponseMessagesECustomerDumpRespConnectToSUListConnectToSU {
    orderRoutingBU!: string | null;
    sellingUnit!: string | null;
    sellingUnitDomain!: string | null;
    minDeliveryLeadTime!: number;

    init(_data?: any) {
        if (_data) {
            this.orderRoutingBU = _data["orderRoutingBU"] !== undefined ? _data["orderRoutingBU"] : null as any;
            this.sellingUnit = _data["sellingUnit"] !== undefined ? _data["sellingUnit"] : null as any;
            this.sellingUnitDomain = _data["sellingUnitDomain"] !== undefined ? _data["sellingUnitDomain"] : null as any;
            this.minDeliveryLeadTime = _data["minDeliveryLeadTime"] !== undefined ? _data["minDeliveryLeadTime"] : null as any;
        }
    }

    static fromJS(data: any): ECustomerDumpResponseMessagesECustomerDumpRespConnectToSUListConnectToSU {
        data = typeof data === 'object' ? data : {};
        let result = new ECustomerDumpResponseMessagesECustomerDumpRespConnectToSUListConnectToSU();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderRoutingBU"] = this.orderRoutingBU !== undefined ? this.orderRoutingBU : null as any;
        data["sellingUnit"] = this.sellingUnit !== undefined ? this.sellingUnit : null as any;
        data["sellingUnitDomain"] = this.sellingUnitDomain !== undefined ? this.sellingUnitDomain : null as any;
        data["minDeliveryLeadTime"] = this.minDeliveryLeadTime !== undefined ? this.minDeliveryLeadTime : null as any;
        return data;
    }
}

export class ECustomerDumpResponseMessagesECustomerDumpRespCustomers {
    responseStartRecord!: any | null;
    responseRecordCount!: any | null;
    data!: ECustomerDumpResponseMessagesECustomerDumpRespCustomersData;

    init(_data?: any) {
        if (_data) {
            this.responseStartRecord = _data["responseStartRecord"] !== undefined ? _data["responseStartRecord"] : null as any;
            this.responseRecordCount = _data["responseRecordCount"] !== undefined ? _data["responseRecordCount"] : null as any;
            this.data = _data["data"] ? ECustomerDumpResponseMessagesECustomerDumpRespCustomersData.fromJS(_data["data"]) : null as any;
        }
    }

    static fromJS(data: any): ECustomerDumpResponseMessagesECustomerDumpRespCustomers {
        data = typeof data === 'object' ? data : {};
        let result = new ECustomerDumpResponseMessagesECustomerDumpRespCustomers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseStartRecord"] = this.responseStartRecord !== undefined ? this.responseStartRecord : null as any;
        data["responseRecordCount"] = this.responseRecordCount !== undefined ? this.responseRecordCount : null as any;
        data["data"] = this.data ? this.data.toJSON() : null as any;
        return data;
    }
}

export class ECustomerDumpResponseMessagesECustomerDumpRespCustomersData {
    cusNo!: number;
    shortName!: number;
    language!: string | null;
    country!: string | null;
    currency!: string | null;
    salesPersonName!: string | null;
    partDelAccept!: number;
    termsOfDel!: string | null;
    termsOfPayment!: string | null;
    meansOfTrp!: string | null;
    mainResponsibleSRU!: string | null;
    su!: string | null;
    cusAdr!: ECustomerDumpResponseMessagesECustomerDumpRespCustomersDataCusAdr;
    invAdr!: ECustomerDumpResponseMessagesECustomerDumpRespCustomersDataInvAdr;
    delAdr!: ECustomerDumpResponseMessagesECustomerDumpRespCustomersDataDelAdr;

    init(_data?: any) {
        if (_data) {
            this.cusNo = _data["cusNo"] !== undefined ? _data["cusNo"] : null as any;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
            this.salesPersonName = _data["salesPersonName"] !== undefined ? _data["salesPersonName"] : null as any;
            this.partDelAccept = _data["partDelAccept"] !== undefined ? _data["partDelAccept"] : null as any;
            this.termsOfDel = _data["termsOfDel"] !== undefined ? _data["termsOfDel"] : null as any;
            this.termsOfPayment = _data["termsOfPayment"] !== undefined ? _data["termsOfPayment"] : null as any;
            this.meansOfTrp = _data["meansOfTrp"] !== undefined ? _data["meansOfTrp"] : null as any;
            this.mainResponsibleSRU = _data["mainResponsibleSRU"] !== undefined ? _data["mainResponsibleSRU"] : null as any;
            this.su = _data["su"] !== undefined ? _data["su"] : null as any;
            this.cusAdr = _data["cusAdr"] ? ECustomerDumpResponseMessagesECustomerDumpRespCustomersDataCusAdr.fromJS(_data["cusAdr"]) : null as any;
            this.invAdr = _data["invAdr"] ? ECustomerDumpResponseMessagesECustomerDumpRespCustomersDataInvAdr.fromJS(_data["invAdr"]) : null as any;
            this.delAdr = _data["delAdr"] ? ECustomerDumpResponseMessagesECustomerDumpRespCustomersDataDelAdr.fromJS(_data["delAdr"]) : null as any;
        }
    }

    static fromJS(data: any): ECustomerDumpResponseMessagesECustomerDumpRespCustomersData {
        data = typeof data === 'object' ? data : {};
        let result = new ECustomerDumpResponseMessagesECustomerDumpRespCustomersData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cusNo"] = this.cusNo !== undefined ? this.cusNo : null as any;
        data["shortName"] = this.shortName !== undefined ? this.shortName : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        data["salesPersonName"] = this.salesPersonName !== undefined ? this.salesPersonName : null as any;
        data["partDelAccept"] = this.partDelAccept !== undefined ? this.partDelAccept : null as any;
        data["termsOfDel"] = this.termsOfDel !== undefined ? this.termsOfDel : null as any;
        data["termsOfPayment"] = this.termsOfPayment !== undefined ? this.termsOfPayment : null as any;
        data["meansOfTrp"] = this.meansOfTrp !== undefined ? this.meansOfTrp : null as any;
        data["mainResponsibleSRU"] = this.mainResponsibleSRU !== undefined ? this.mainResponsibleSRU : null as any;
        data["su"] = this.su !== undefined ? this.su : null as any;
        data["cusAdr"] = this.cusAdr ? this.cusAdr.toJSON() : null as any;
        data["invAdr"] = this.invAdr ? this.invAdr.toJSON() : null as any;
        data["delAdr"] = this.delAdr ? this.delAdr.toJSON() : null as any;
        return data;
    }
}

export class ECustomerDumpResponseMessagesECustomerDumpRespCustomersDataCusAdr {
    name1!: string | null;
    name2!: string | null;
    name3!: string | null;
    readonly name!: string | null;
    road1!: string | null;
    road2!: string | null;
    road3!: string | null;
    readonly road!: string | null;
    postCode!: number;
    town!: string | null;
    country!: string | null;
    phone!: string | null;
    fax!: string | null;

    init(_data?: any) {
        if (_data) {
            this.name1 = _data["name1"] !== undefined ? _data["name1"] : null as any;
            this.name2 = _data["name2"] !== undefined ? _data["name2"] : null as any;
            this.name3 = _data["name3"] !== undefined ? _data["name3"] : null as any;
            (this as any).name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.road1 = _data["road1"] !== undefined ? _data["road1"] : null as any;
            this.road2 = _data["road2"] !== undefined ? _data["road2"] : null as any;
            this.road3 = _data["road3"] !== undefined ? _data["road3"] : null as any;
            (this as any).road = _data["road"] !== undefined ? _data["road"] : null as any;
            this.postCode = _data["postCode"] !== undefined ? _data["postCode"] : null as any;
            this.town = _data["town"] !== undefined ? _data["town"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : null as any;
        }
    }

    static fromJS(data: any): ECustomerDumpResponseMessagesECustomerDumpRespCustomersDataCusAdr {
        data = typeof data === 'object' ? data : {};
        let result = new ECustomerDumpResponseMessagesECustomerDumpRespCustomersDataCusAdr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name1"] = this.name1 !== undefined ? this.name1 : null as any;
        data["name2"] = this.name2 !== undefined ? this.name2 : null as any;
        data["name3"] = this.name3 !== undefined ? this.name3 : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["road1"] = this.road1 !== undefined ? this.road1 : null as any;
        data["road2"] = this.road2 !== undefined ? this.road2 : null as any;
        data["road3"] = this.road3 !== undefined ? this.road3 : null as any;
        data["road"] = this.road !== undefined ? this.road : null as any;
        data["postCode"] = this.postCode !== undefined ? this.postCode : null as any;
        data["town"] = this.town !== undefined ? this.town : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["fax"] = this.fax !== undefined ? this.fax : null as any;
        return data;
    }
}

export class ECustomerDumpResponseMessagesECustomerDumpRespCustomersDataDelAdr {
    name1!: string | null;
    name2!: string | null;
    name3!: string | null;
    readonly name!: string | null;
    road1!: string | null;
    road2!: string | null;
    road3!: string | null;
    readonly road!: string | null;
    postCode!: number;
    town!: string | null;
    country!: string | null;
    phone!: string | null;
    contactPerson!: string | null;

    init(_data?: any) {
        if (_data) {
            this.name1 = _data["name1"] !== undefined ? _data["name1"] : null as any;
            this.name2 = _data["name2"] !== undefined ? _data["name2"] : null as any;
            this.name3 = _data["name3"] !== undefined ? _data["name3"] : null as any;
            (this as any).name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.road1 = _data["road1"] !== undefined ? _data["road1"] : null as any;
            this.road2 = _data["road2"] !== undefined ? _data["road2"] : null as any;
            this.road3 = _data["road3"] !== undefined ? _data["road3"] : null as any;
            (this as any).road = _data["road"] !== undefined ? _data["road"] : null as any;
            this.postCode = _data["postCode"] !== undefined ? _data["postCode"] : null as any;
            this.town = _data["town"] !== undefined ? _data["town"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.contactPerson = _data["contactPerson"] !== undefined ? _data["contactPerson"] : null as any;
        }
    }

    static fromJS(data: any): ECustomerDumpResponseMessagesECustomerDumpRespCustomersDataDelAdr {
        data = typeof data === 'object' ? data : {};
        let result = new ECustomerDumpResponseMessagesECustomerDumpRespCustomersDataDelAdr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name1"] = this.name1 !== undefined ? this.name1 : null as any;
        data["name2"] = this.name2 !== undefined ? this.name2 : null as any;
        data["name3"] = this.name3 !== undefined ? this.name3 : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["road1"] = this.road1 !== undefined ? this.road1 : null as any;
        data["road2"] = this.road2 !== undefined ? this.road2 : null as any;
        data["road3"] = this.road3 !== undefined ? this.road3 : null as any;
        data["road"] = this.road !== undefined ? this.road : null as any;
        data["postCode"] = this.postCode !== undefined ? this.postCode : null as any;
        data["town"] = this.town !== undefined ? this.town : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["contactPerson"] = this.contactPerson !== undefined ? this.contactPerson : null as any;
        return data;
    }
}

export class ECustomerDumpResponseMessagesECustomerDumpRespCustomersDataInvAdr {
    name1!: string | null;
    name2!: string | null;
    name3!: string | null;
    readonly name!: string | null;
    road1!: string | null;
    road2!: string | null;
    road3!: string | null;
    readonly road!: string | null;
    postCode!: number;
    town!: string | null;
    country!: string | null;
    phone!: string | null;
    fax!: string | null;

    init(_data?: any) {
        if (_data) {
            this.name1 = _data["name1"] !== undefined ? _data["name1"] : null as any;
            this.name2 = _data["name2"] !== undefined ? _data["name2"] : null as any;
            this.name3 = _data["name3"] !== undefined ? _data["name3"] : null as any;
            (this as any).name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.road1 = _data["road1"] !== undefined ? _data["road1"] : null as any;
            this.road2 = _data["road2"] !== undefined ? _data["road2"] : null as any;
            this.road3 = _data["road3"] !== undefined ? _data["road3"] : null as any;
            (this as any).road = _data["road"] !== undefined ? _data["road"] : null as any;
            this.postCode = _data["postCode"] !== undefined ? _data["postCode"] : null as any;
            this.town = _data["town"] !== undefined ? _data["town"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : null as any;
        }
    }

    static fromJS(data: any): ECustomerDumpResponseMessagesECustomerDumpRespCustomersDataInvAdr {
        data = typeof data === 'object' ? data : {};
        let result = new ECustomerDumpResponseMessagesECustomerDumpRespCustomersDataInvAdr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name1"] = this.name1 !== undefined ? this.name1 : null as any;
        data["name2"] = this.name2 !== undefined ? this.name2 : null as any;
        data["name3"] = this.name3 !== undefined ? this.name3 : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["road1"] = this.road1 !== undefined ? this.road1 : null as any;
        data["road2"] = this.road2 !== undefined ? this.road2 : null as any;
        data["road3"] = this.road3 !== undefined ? this.road3 : null as any;
        data["road"] = this.road !== undefined ? this.road : null as any;
        data["postCode"] = this.postCode !== undefined ? this.postCode : null as any;
        data["town"] = this.town !== undefined ? this.town : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["fax"] = this.fax !== undefined ? this.fax : null as any;
        return data;
    }
}

export class ECustomerDumpResponseMessagesECustomerDumpRespMsgHead {
    ois!: string | null;
    language!: string | null;
    epixUser!: string | null;
    epixPasswd!: string | null;
    epixEndUserSessionId!: number;
    okToUseReplyCacheSince!: number;

    init(_data?: any) {
        if (_data) {
            this.ois = _data["ois"] !== undefined ? _data["ois"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            this.epixUser = _data["epixUser"] !== undefined ? _data["epixUser"] : null as any;
            this.epixPasswd = _data["epixPasswd"] !== undefined ? _data["epixPasswd"] : null as any;
            this.epixEndUserSessionId = _data["epixEndUserSessionId"] !== undefined ? _data["epixEndUserSessionId"] : null as any;
            this.okToUseReplyCacheSince = _data["okToUseReplyCacheSince"] !== undefined ? _data["okToUseReplyCacheSince"] : null as any;
        }
    }

    static fromJS(data: any): ECustomerDumpResponseMessagesECustomerDumpRespMsgHead {
        data = typeof data === 'object' ? data : {};
        let result = new ECustomerDumpResponseMessagesECustomerDumpRespMsgHead();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ois"] = this.ois !== undefined ? this.ois : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["epixUser"] = this.epixUser !== undefined ? this.epixUser : null as any;
        data["epixPasswd"] = this.epixPasswd !== undefined ? this.epixPasswd : null as any;
        data["epixEndUserSessionId"] = this.epixEndUserSessionId !== undefined ? this.epixEndUserSessionId : null as any;
        data["okToUseReplyCacheSince"] = this.okToUseReplyCacheSince !== undefined ? this.okToUseReplyCacheSince : null as any;
        return data;
    }
}

export class CommonOutput {
    isSuccess!: boolean;
    code!: number;
    message!: string | null;
    data!: any | null;
    errors!: any | null;
    timestamp!: number;

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.errors = _data["errors"] !== undefined ? _data["errors"] : null as any;
            this.timestamp = _data["timestamp"] !== undefined ? _data["timestamp"] : null as any;
        }
    }

    static fromJS(data: any): CommonOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CommonOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["errors"] = this.errors !== undefined ? this.errors : null as any;
        data["timestamp"] = this.timestamp !== undefined ? this.timestamp : null as any;
        return data;
    }
}

export class CountryKeyDto {
    /** 主键Id */
    id!: string;
    /** 国家简写 */
    countryKeyCode!: string | null;
    /** 国家名称 */
    countryKeyName!: string | null;
    /** 创建人Id */
    creatorUserId!: number | null;
    /** 创建人 */
    creatorUserName!: string | null;
    /** 创建时间 */
    creationTime!: moment.Moment | null;
    /** 修改人Id */
    lastModifierUserId!: number | null;
    /** 修改人 */
    lastModifierUserName!: string | null;
    /** 修改时间 */
    lastModificationTime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.countryKeyCode = _data["countryKeyCode"] !== undefined ? _data["countryKeyCode"] : null as any;
            this.countryKeyName = _data["countryKeyName"] !== undefined ? _data["countryKeyName"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.creatorUserName = _data["creatorUserName"] !== undefined ? _data["creatorUserName"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.lastModifierUserName = _data["lastModifierUserName"] !== undefined ? _data["lastModifierUserName"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): CountryKeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryKeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["countryKeyCode"] = this.countryKeyCode !== undefined ? this.countryKeyCode : null as any;
        data["countryKeyName"] = this.countryKeyName !== undefined ? this.countryKeyName : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["creatorUserName"] = this.creatorUserName !== undefined ? this.creatorUserName : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["lastModifierUserName"] = this.lastModifierUserName !== undefined ? this.lastModifierUserName : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        return data;
    }
}

export class CountrySalesRelationDto {
    /** 主键Id */
    id!: string;
    /** 变量名称 */
    customerCode!: string | null;
    /** 变量值 */
    customerName!: string | null;
    /** 国家 */
    countryKey!: string | null;
    /** 销售代理 */
    salesAgentName!: string | null;
    /** 订单类型 */
    orderType!: string | null;
    /** 创建人Id */
    creatorUserId!: number | null;
    /** 创建人 */
    creatorUserName!: string | null;
    /** 创建时间 */
    creationTime!: moment.Moment | null;
    readonly creationTimeStr!: string | null;
    /** 修改人Id */
    lastModifierUserId!: number | null;
    /** 修改人 */
    lastModifierUserName!: string | null;
    /** 修改时间 */
    lastModificationTime!: moment.Moment | null;
    readonly lastModificationTimeStr!: string | null;
    isInsert!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.countryKey = _data["countryKey"] !== undefined ? _data["countryKey"] : null as any;
            this.salesAgentName = _data["salesAgentName"] !== undefined ? _data["salesAgentName"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.creatorUserName = _data["creatorUserName"] !== undefined ? _data["creatorUserName"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            (this as any).creationTimeStr = _data["creationTimeStr"] !== undefined ? _data["creationTimeStr"] : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.lastModifierUserName = _data["lastModifierUserName"] !== undefined ? _data["lastModifierUserName"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            (this as any).lastModificationTimeStr = _data["lastModificationTimeStr"] !== undefined ? _data["lastModificationTimeStr"] : null as any;
            this.isInsert = _data["isInsert"] !== undefined ? _data["isInsert"] : null as any;
        }
    }

    static fromJS(data: any): CountrySalesRelationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountrySalesRelationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["countryKey"] = this.countryKey !== undefined ? this.countryKey : null as any;
        data["salesAgentName"] = this.salesAgentName !== undefined ? this.salesAgentName : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["creatorUserName"] = this.creatorUserName !== undefined ? this.creatorUserName : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creationTimeStr"] = this.creationTimeStr !== undefined ? this.creationTimeStr : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["lastModifierUserName"] = this.lastModifierUserName !== undefined ? this.lastModifierUserName : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModificationTimeStr"] = this.lastModificationTimeStr !== undefined ? this.lastModificationTimeStr : null as any;
        data["isInsert"] = this.isInsert !== undefined ? this.isInsert : null as any;
        return data;
    }
}

export class CountrySalesRelationDtoPagedResultDto {
    items!: CountrySalesRelationDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CountrySalesRelationDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): CountrySalesRelationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountrySalesRelationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class EmailSendLogDto {
    /** 主键Id */
    id!: string;
    /** 订单号 */
    orderNumber!: string | null;
    /** 订单行号 */
    orderRowNo!: string | null;
    /** 邮件标题 */
    title!: string | null;
    /** 收件人邮箱 */
    recipient!: string | null;
    /** 邮件内容 */
    content!: string | null;
    /** 发送状态 */
    status!: boolean;
    /** 发送次数 */
    count!: number;
    /** 错误描述 */
    errorMessage!: string | null;
    /** 发送时间 */
    sendTime!: moment.Moment | null;
    readonly sendTimeStr!: string | null;
    /** 创建人Id */
    creatorUserId!: number | null;
    /** 创建人 */
    creatorUserName!: string | null;
    /** 创建时间 */
    creationTime!: moment.Moment | null;
    readonly creationTimeStr!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : null as any;
            this.orderRowNo = _data["orderRowNo"] !== undefined ? _data["orderRowNo"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.recipient = _data["recipient"] !== undefined ? _data["recipient"] : null as any;
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : null as any;
            this.sendTime = _data["sendTime"] ? moment(_data["sendTime"].toString()) : null as any;
            (this as any).sendTimeStr = _data["sendTimeStr"] !== undefined ? _data["sendTimeStr"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.creatorUserName = _data["creatorUserName"] !== undefined ? _data["creatorUserName"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            (this as any).creationTimeStr = _data["creationTimeStr"] !== undefined ? _data["creationTimeStr"] : null as any;
        }
    }

    static fromJS(data: any): EmailSendLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSendLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : null as any;
        data["orderRowNo"] = this.orderRowNo !== undefined ? this.orderRowNo : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["recipient"] = this.recipient !== undefined ? this.recipient : null as any;
        data["content"] = this.content !== undefined ? this.content : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null as any;
        data["sendTime"] = this.sendTime ? this.sendTime.toISOString() : null as any;
        data["sendTimeStr"] = this.sendTimeStr !== undefined ? this.sendTimeStr : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["creatorUserName"] = this.creatorUserName !== undefined ? this.creatorUserName : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creationTimeStr"] = this.creationTimeStr !== undefined ? this.creationTimeStr : null as any;
        return data;
    }
}

export class EmailSendLogDtoPagedResultDto {
    items!: EmailSendLogDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EmailSendLogDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): EmailSendLogDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSendLogDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class IEventData {
    eventTime!: moment.Moment;
    eventSource!: any | null;

    init(_data?: any) {
        if (_data) {
            this.eventTime = _data["eventTime"] ? moment(_data["eventTime"].toString()) : null as any;
            this.eventSource = _data["eventSource"] !== undefined ? _data["eventSource"] : null as any;
        }
    }

    static fromJS(data: any): IEventData {
        data = typeof data === 'object' ? data : {};
        let result = new IEventData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : null as any;
        data["eventSource"] = this.eventSource !== undefined ? this.eventSource : null as any;
        return data;
    }
}

export class OperationLogDto {
    /** 表名 */
    tableName!: string | null;
    /** 操作编号 */
    operationCode!: string | null;
    /** 操作模块 */
    moduleName!: string | null;
    /** 操作内容 */
    content!: string | null;
    /** 操作人Id */
    creatorUserId!: number | null;
    /** 操作人 */
    creatorUserName!: string | null;
    /** 操作时间 */
    creationTime!: moment.Moment | null;
    readonly creationTimeStr!: string | null;

    init(_data?: any) {
        if (_data) {
            this.tableName = _data["tableName"] !== undefined ? _data["tableName"] : null as any;
            this.operationCode = _data["operationCode"] !== undefined ? _data["operationCode"] : null as any;
            this.moduleName = _data["moduleName"] !== undefined ? _data["moduleName"] : null as any;
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.creatorUserName = _data["creatorUserName"] !== undefined ? _data["creatorUserName"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            (this as any).creationTimeStr = _data["creationTimeStr"] !== undefined ? _data["creationTimeStr"] : null as any;
        }
    }

    static fromJS(data: any): OperationLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName !== undefined ? this.tableName : null as any;
        data["operationCode"] = this.operationCode !== undefined ? this.operationCode : null as any;
        data["moduleName"] = this.moduleName !== undefined ? this.moduleName : null as any;
        data["content"] = this.content !== undefined ? this.content : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["creatorUserName"] = this.creatorUserName !== undefined ? this.creatorUserName : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creationTimeStr"] = this.creationTimeStr !== undefined ? this.creationTimeStr : null as any;
        return data;
    }
}

export class OperationLogDtoPagedResultDto {
    items!: OperationLogDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OperationLogDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): OperationLogDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationLogDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class OrderDetail {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    orderNumber!: string | null;
    orderRowNo!: string | null;
    orderCreateUser!: string | null;
    orderCreateDate!: moment.Moment | null;
    orderSubmitDate!: moment.Moment | null;
    saleNumber!: string | null;
    saleRowNo!: string | null;
    customerPo!: string | null;
    customerCode!: string | null;
    customerName!: string | null;
    scheduledAssemblyDate!: moment.Moment | null;
    actualAssemblyDate!: moment.Moment | null;
    actualStorageDate!: moment.Moment | null;
    bomFinishDate!: moment.Moment | null;
    actualStartDate!: moment.Moment | null;
    customerRequestedDate!: moment.Moment | null;
    expectedDeliveryDate!: moment.Moment | null;
    actualDeliveryDate!: moment.Moment | null;
    lastReceiptDate!: moment.Moment | null;
    deliveryDate!: moment.Moment | null;
    freezeDate!: moment.Moment | null;
    freezeStatus!: boolean;
    orderStatus!: string | null;
    manualContractNumber!: string | null;
    serialNumber!: string | null;
    productCode!: string | null;
    productName!: string | null;
    productNameEn!: string | null;
    orderQty!: number;
    unitPrice!: number;
    amount!: number;
    commitQty!: number;
    deliveryQty!: number;
    inspectionQty!: number;
    technicalParameterModificationCount!: number | null;
    technicalParameterModificationDescription!: string | null;
    technicalParameterModificationUserId!: number | null;
    technicalParameterModificationTime!: moment.Moment | null;
    priceModificationCount!: number | null;
    priceModificationDescription!: string | null;
    priceModificationUserId!: number | null;
    priceModificationTime!: moment.Moment | null;
    deliveryDateModificationCount!: number | null;
    deliveryDateModificationDescription!: string | null;
    deliveryDateModificationUserId!: number | null;
    deliveryDateModificationTime!: moment.Moment | null;
    isOrderCancel!: number | null;
    orderCancelDescription!: string | null;
    orderCancelUserId!: number | null;
    orderCancelTime!: moment.Moment | null;
    orderType!: string | null;
    historyFlag!: string | null;
    orderDetailSerialNumbers!: OrderDetailSerialNumber[] | null;
    orderDetailShipments!: OrderDetailShipment[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : null as any;
            this.orderRowNo = _data["orderRowNo"] !== undefined ? _data["orderRowNo"] : null as any;
            this.orderCreateUser = _data["orderCreateUser"] !== undefined ? _data["orderCreateUser"] : null as any;
            this.orderCreateDate = _data["orderCreateDate"] ? moment(_data["orderCreateDate"].toString()) : null as any;
            this.orderSubmitDate = _data["orderSubmitDate"] ? moment(_data["orderSubmitDate"].toString()) : null as any;
            this.saleNumber = _data["saleNumber"] !== undefined ? _data["saleNumber"] : null as any;
            this.saleRowNo = _data["saleRowNo"] !== undefined ? _data["saleRowNo"] : null as any;
            this.customerPo = _data["customerPo"] !== undefined ? _data["customerPo"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.scheduledAssemblyDate = _data["scheduledAssemblyDate"] ? moment(_data["scheduledAssemblyDate"].toString()) : null as any;
            this.actualAssemblyDate = _data["actualAssemblyDate"] ? moment(_data["actualAssemblyDate"].toString()) : null as any;
            this.actualStorageDate = _data["actualStorageDate"] ? moment(_data["actualStorageDate"].toString()) : null as any;
            this.bomFinishDate = _data["bomFinishDate"] ? moment(_data["bomFinishDate"].toString()) : null as any;
            this.actualStartDate = _data["actualStartDate"] ? moment(_data["actualStartDate"].toString()) : null as any;
            this.customerRequestedDate = _data["customerRequestedDate"] ? moment(_data["customerRequestedDate"].toString()) : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] ? moment(_data["expectedDeliveryDate"].toString()) : null as any;
            this.actualDeliveryDate = _data["actualDeliveryDate"] ? moment(_data["actualDeliveryDate"].toString()) : null as any;
            this.lastReceiptDate = _data["lastReceiptDate"] ? moment(_data["lastReceiptDate"].toString()) : null as any;
            this.deliveryDate = _data["deliveryDate"] ? moment(_data["deliveryDate"].toString()) : null as any;
            this.freezeDate = _data["freezeDate"] ? moment(_data["freezeDate"].toString()) : null as any;
            this.freezeStatus = _data["freezeStatus"] !== undefined ? _data["freezeStatus"] : null as any;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : null as any;
            this.manualContractNumber = _data["manualContractNumber"] !== undefined ? _data["manualContractNumber"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.productCode = _data["productCode"] !== undefined ? _data["productCode"] : null as any;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : null as any;
            this.productNameEn = _data["productNameEn"] !== undefined ? _data["productNameEn"] : null as any;
            this.orderQty = _data["orderQty"] !== undefined ? _data["orderQty"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.commitQty = _data["commitQty"] !== undefined ? _data["commitQty"] : null as any;
            this.deliveryQty = _data["deliveryQty"] !== undefined ? _data["deliveryQty"] : null as any;
            this.inspectionQty = _data["inspectionQty"] !== undefined ? _data["inspectionQty"] : null as any;
            this.technicalParameterModificationCount = _data["technicalParameterModificationCount"] !== undefined ? _data["technicalParameterModificationCount"] : null as any;
            this.technicalParameterModificationDescription = _data["technicalParameterModificationDescription"] !== undefined ? _data["technicalParameterModificationDescription"] : null as any;
            this.technicalParameterModificationUserId = _data["technicalParameterModificationUserId"] !== undefined ? _data["technicalParameterModificationUserId"] : null as any;
            this.technicalParameterModificationTime = _data["technicalParameterModificationTime"] ? moment(_data["technicalParameterModificationTime"].toString()) : null as any;
            this.priceModificationCount = _data["priceModificationCount"] !== undefined ? _data["priceModificationCount"] : null as any;
            this.priceModificationDescription = _data["priceModificationDescription"] !== undefined ? _data["priceModificationDescription"] : null as any;
            this.priceModificationUserId = _data["priceModificationUserId"] !== undefined ? _data["priceModificationUserId"] : null as any;
            this.priceModificationTime = _data["priceModificationTime"] ? moment(_data["priceModificationTime"].toString()) : null as any;
            this.deliveryDateModificationCount = _data["deliveryDateModificationCount"] !== undefined ? _data["deliveryDateModificationCount"] : null as any;
            this.deliveryDateModificationDescription = _data["deliveryDateModificationDescription"] !== undefined ? _data["deliveryDateModificationDescription"] : null as any;
            this.deliveryDateModificationUserId = _data["deliveryDateModificationUserId"] !== undefined ? _data["deliveryDateModificationUserId"] : null as any;
            this.deliveryDateModificationTime = _data["deliveryDateModificationTime"] ? moment(_data["deliveryDateModificationTime"].toString()) : null as any;
            this.isOrderCancel = _data["isOrderCancel"] !== undefined ? _data["isOrderCancel"] : null as any;
            this.orderCancelDescription = _data["orderCancelDescription"] !== undefined ? _data["orderCancelDescription"] : null as any;
            this.orderCancelUserId = _data["orderCancelUserId"] !== undefined ? _data["orderCancelUserId"] : null as any;
            this.orderCancelTime = _data["orderCancelTime"] ? moment(_data["orderCancelTime"].toString()) : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.historyFlag = _data["historyFlag"] !== undefined ? _data["historyFlag"] : null as any;
            if (Array.isArray(_data["orderDetailSerialNumbers"])) {
                this.orderDetailSerialNumbers = [] as any;
                for (let item of _data["orderDetailSerialNumbers"])
                    this.orderDetailSerialNumbers!.push(OrderDetailSerialNumber.fromJS(item));
            }
            else {
                this.orderDetailSerialNumbers = null as any;
            }
            if (Array.isArray(_data["orderDetailShipments"])) {
                this.orderDetailShipments = [] as any;
                for (let item of _data["orderDetailShipments"])
                    this.orderDetailShipments!.push(OrderDetailShipment.fromJS(item));
            }
            else {
                this.orderDetailShipments = null as any;
            }
        }
    }

    static fromJS(data: any): OrderDetail {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : null as any;
        data["orderRowNo"] = this.orderRowNo !== undefined ? this.orderRowNo : null as any;
        data["orderCreateUser"] = this.orderCreateUser !== undefined ? this.orderCreateUser : null as any;
        data["orderCreateDate"] = this.orderCreateDate ? this.orderCreateDate.toISOString() : null as any;
        data["orderSubmitDate"] = this.orderSubmitDate ? this.orderSubmitDate.toISOString() : null as any;
        data["saleNumber"] = this.saleNumber !== undefined ? this.saleNumber : null as any;
        data["saleRowNo"] = this.saleRowNo !== undefined ? this.saleRowNo : null as any;
        data["customerPo"] = this.customerPo !== undefined ? this.customerPo : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["scheduledAssemblyDate"] = this.scheduledAssemblyDate ? this.scheduledAssemblyDate.toISOString() : null as any;
        data["actualAssemblyDate"] = this.actualAssemblyDate ? this.actualAssemblyDate.toISOString() : null as any;
        data["actualStorageDate"] = this.actualStorageDate ? this.actualStorageDate.toISOString() : null as any;
        data["bomFinishDate"] = this.bomFinishDate ? this.bomFinishDate.toISOString() : null as any;
        data["actualStartDate"] = this.actualStartDate ? this.actualStartDate.toISOString() : null as any;
        data["customerRequestedDate"] = this.customerRequestedDate ? this.customerRequestedDate.toISOString() : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate ? this.expectedDeliveryDate.toISOString() : null as any;
        data["actualDeliveryDate"] = this.actualDeliveryDate ? this.actualDeliveryDate.toISOString() : null as any;
        data["lastReceiptDate"] = this.lastReceiptDate ? this.lastReceiptDate.toISOString() : null as any;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : null as any;
        data["freezeDate"] = this.freezeDate ? this.freezeDate.toISOString() : null as any;
        data["freezeStatus"] = this.freezeStatus !== undefined ? this.freezeStatus : null as any;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : null as any;
        data["manualContractNumber"] = this.manualContractNumber !== undefined ? this.manualContractNumber : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["productCode"] = this.productCode !== undefined ? this.productCode : null as any;
        data["productName"] = this.productName !== undefined ? this.productName : null as any;
        data["productNameEn"] = this.productNameEn !== undefined ? this.productNameEn : null as any;
        data["orderQty"] = this.orderQty !== undefined ? this.orderQty : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["commitQty"] = this.commitQty !== undefined ? this.commitQty : null as any;
        data["deliveryQty"] = this.deliveryQty !== undefined ? this.deliveryQty : null as any;
        data["inspectionQty"] = this.inspectionQty !== undefined ? this.inspectionQty : null as any;
        data["technicalParameterModificationCount"] = this.technicalParameterModificationCount !== undefined ? this.technicalParameterModificationCount : null as any;
        data["technicalParameterModificationDescription"] = this.technicalParameterModificationDescription !== undefined ? this.technicalParameterModificationDescription : null as any;
        data["technicalParameterModificationUserId"] = this.technicalParameterModificationUserId !== undefined ? this.technicalParameterModificationUserId : null as any;
        data["technicalParameterModificationTime"] = this.technicalParameterModificationTime ? this.technicalParameterModificationTime.toISOString() : null as any;
        data["priceModificationCount"] = this.priceModificationCount !== undefined ? this.priceModificationCount : null as any;
        data["priceModificationDescription"] = this.priceModificationDescription !== undefined ? this.priceModificationDescription : null as any;
        data["priceModificationUserId"] = this.priceModificationUserId !== undefined ? this.priceModificationUserId : null as any;
        data["priceModificationTime"] = this.priceModificationTime ? this.priceModificationTime.toISOString() : null as any;
        data["deliveryDateModificationCount"] = this.deliveryDateModificationCount !== undefined ? this.deliveryDateModificationCount : null as any;
        data["deliveryDateModificationDescription"] = this.deliveryDateModificationDescription !== undefined ? this.deliveryDateModificationDescription : null as any;
        data["deliveryDateModificationUserId"] = this.deliveryDateModificationUserId !== undefined ? this.deliveryDateModificationUserId : null as any;
        data["deliveryDateModificationTime"] = this.deliveryDateModificationTime ? this.deliveryDateModificationTime.toISOString() : null as any;
        data["isOrderCancel"] = this.isOrderCancel !== undefined ? this.isOrderCancel : null as any;
        data["orderCancelDescription"] = this.orderCancelDescription !== undefined ? this.orderCancelDescription : null as any;
        data["orderCancelUserId"] = this.orderCancelUserId !== undefined ? this.orderCancelUserId : null as any;
        data["orderCancelTime"] = this.orderCancelTime ? this.orderCancelTime.toISOString() : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["historyFlag"] = this.historyFlag !== undefined ? this.historyFlag : null as any;
        if (Array.isArray(this.orderDetailSerialNumbers)) {
            data["orderDetailSerialNumbers"] = [];
            for (let item of this.orderDetailSerialNumbers)
                data["orderDetailSerialNumbers"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.orderDetailShipments)) {
            data["orderDetailShipments"] = [];
            for (let item of this.orderDetailShipments)
                data["orderDetailShipments"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class OrderDetailAuditDto {
    /** 主键Id */
    id!: string;
    /** 订单号 */
    orderNumber!: string | null;
    /** 订单行号 */
    orderRowNo!: string | null;
    orderDetailId!: string;
    /** 客户编号 */
    customerCode!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** SO */
    saleNumber!: string | null;
    /** SO Line */
    saleRowNo!: string | null;
    /** 手工合同号 */
    manualContractNumber!: string | null;
    /** SerialNumber */
    serialNumber!: string | null;
    /** 产品编号 */
    productCode!: string | null;
    /** 产品名称 */
    productName!: string | null;
    /** 修改类型 */
    modificationType!: string | null;
    modificationTypeName!: string | null;
    /** 修改内容 */
    content!: string | null;
    /** 审核状态（0 未审核  4 拒绝  8 通过） */
    auditStatus!: string | null;
    /** 审核状态描述 */
    auditStatusName!: string | null;
    /** 备注 */
    auditRemark!: string | null;
    /** 审核人Id */
    auditUserId!: number | null;
    /** 审核人名称 */
    auditUserName!: string | null;
    /** 默认审核人Id */
    defaultAuditUserId!: number | null;
    /** 默认审核人名称 */
    defaultAuditUserName!: string | null;
    /** 审核日期 */
    auditDate!: moment.Moment | null;
    readonly auditDateTimeStr!: string | null;
    /** 客户邮箱 */
    emailAddress!: string | null;
    /** 创建人Id */
    creatorUserId!: number | null;
    /** 创建人 */
    creatorUserName!: string | null;
    /** 创建时间 */
    creationTime!: moment.Moment | null;
    readonly creationTimeStr!: string | null;
    /** 修改人Id */
    lastModifierUserId!: number | null;
    /** 修改人 */
    lastModifierUserName!: string | null;
    /** 修改时间 */
    lastModificationTime!: moment.Moment | null;
    readonly lastModificationTimeStr!: string | null;
    /** Id 列表 */
    idList!: string[] | null;
    /** 修改备注 */
    remark!: string | null;
    /** 时间间隔（当前时间与创建时间的时间间隔，单位：小时） */
    timeInterval!: number;
    rowClassName!: string | null;
    mergeId!: string;
    /** 同一次提交的Code一致 */
    mergeCode!: string | null;
    /** 冻结日期 */
    freezeDate!: moment.Moment | null;
    readonly freezeDateStr!: string | null;
    /** 订单状态 */
    orderStatus!: string | null;
    orderStatusName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : null as any;
            this.orderRowNo = _data["orderRowNo"] !== undefined ? _data["orderRowNo"] : null as any;
            this.orderDetailId = _data["orderDetailId"] !== undefined ? _data["orderDetailId"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.saleNumber = _data["saleNumber"] !== undefined ? _data["saleNumber"] : null as any;
            this.saleRowNo = _data["saleRowNo"] !== undefined ? _data["saleRowNo"] : null as any;
            this.manualContractNumber = _data["manualContractNumber"] !== undefined ? _data["manualContractNumber"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.productCode = _data["productCode"] !== undefined ? _data["productCode"] : null as any;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : null as any;
            this.modificationType = _data["modificationType"] !== undefined ? _data["modificationType"] : null as any;
            this.modificationTypeName = _data["modificationTypeName"] !== undefined ? _data["modificationTypeName"] : null as any;
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
            this.auditStatus = _data["auditStatus"] !== undefined ? _data["auditStatus"] : null as any;
            this.auditStatusName = _data["auditStatusName"] !== undefined ? _data["auditStatusName"] : null as any;
            this.auditRemark = _data["auditRemark"] !== undefined ? _data["auditRemark"] : null as any;
            this.auditUserId = _data["auditUserId"] !== undefined ? _data["auditUserId"] : null as any;
            this.auditUserName = _data["auditUserName"] !== undefined ? _data["auditUserName"] : null as any;
            this.defaultAuditUserId = _data["defaultAuditUserId"] !== undefined ? _data["defaultAuditUserId"] : null as any;
            this.defaultAuditUserName = _data["defaultAuditUserName"] !== undefined ? _data["defaultAuditUserName"] : null as any;
            this.auditDate = _data["auditDate"] ? moment(_data["auditDate"].toString()) : null as any;
            (this as any).auditDateTimeStr = _data["auditDateTimeStr"] !== undefined ? _data["auditDateTimeStr"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.creatorUserName = _data["creatorUserName"] !== undefined ? _data["creatorUserName"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            (this as any).creationTimeStr = _data["creationTimeStr"] !== undefined ? _data["creationTimeStr"] : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.lastModifierUserName = _data["lastModifierUserName"] !== undefined ? _data["lastModifierUserName"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            (this as any).lastModificationTimeStr = _data["lastModificationTimeStr"] !== undefined ? _data["lastModificationTimeStr"] : null as any;
            if (Array.isArray(_data["idList"])) {
                this.idList = [] as any;
                for (let item of _data["idList"])
                    this.idList!.push(item);
            }
            else {
                this.idList = null as any;
            }
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.timeInterval = _data["timeInterval"] !== undefined ? _data["timeInterval"] : null as any;
            this.rowClassName = _data["rowClassName"] !== undefined ? _data["rowClassName"] : null as any;
            this.mergeId = _data["mergeId"] !== undefined ? _data["mergeId"] : null as any;
            this.mergeCode = _data["mergeCode"] !== undefined ? _data["mergeCode"] : null as any;
            this.freezeDate = _data["freezeDate"] ? moment(_data["freezeDate"].toString()) : null as any;
            (this as any).freezeDateStr = _data["freezeDateStr"] !== undefined ? _data["freezeDateStr"] : null as any;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : null as any;
            this.orderStatusName = _data["orderStatusName"] !== undefined ? _data["orderStatusName"] : null as any;
        }
    }

    static fromJS(data: any): OrderDetailAuditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailAuditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : null as any;
        data["orderRowNo"] = this.orderRowNo !== undefined ? this.orderRowNo : null as any;
        data["orderDetailId"] = this.orderDetailId !== undefined ? this.orderDetailId : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["saleNumber"] = this.saleNumber !== undefined ? this.saleNumber : null as any;
        data["saleRowNo"] = this.saleRowNo !== undefined ? this.saleRowNo : null as any;
        data["manualContractNumber"] = this.manualContractNumber !== undefined ? this.manualContractNumber : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["productCode"] = this.productCode !== undefined ? this.productCode : null as any;
        data["productName"] = this.productName !== undefined ? this.productName : null as any;
        data["modificationType"] = this.modificationType !== undefined ? this.modificationType : null as any;
        data["modificationTypeName"] = this.modificationTypeName !== undefined ? this.modificationTypeName : null as any;
        data["content"] = this.content !== undefined ? this.content : null as any;
        data["auditStatus"] = this.auditStatus !== undefined ? this.auditStatus : null as any;
        data["auditStatusName"] = this.auditStatusName !== undefined ? this.auditStatusName : null as any;
        data["auditRemark"] = this.auditRemark !== undefined ? this.auditRemark : null as any;
        data["auditUserId"] = this.auditUserId !== undefined ? this.auditUserId : null as any;
        data["auditUserName"] = this.auditUserName !== undefined ? this.auditUserName : null as any;
        data["defaultAuditUserId"] = this.defaultAuditUserId !== undefined ? this.defaultAuditUserId : null as any;
        data["defaultAuditUserName"] = this.defaultAuditUserName !== undefined ? this.defaultAuditUserName : null as any;
        data["auditDate"] = this.auditDate ? this.auditDate.toISOString() : null as any;
        data["auditDateTimeStr"] = this.auditDateTimeStr !== undefined ? this.auditDateTimeStr : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["creatorUserName"] = this.creatorUserName !== undefined ? this.creatorUserName : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creationTimeStr"] = this.creationTimeStr !== undefined ? this.creationTimeStr : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["lastModifierUserName"] = this.lastModifierUserName !== undefined ? this.lastModifierUserName : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModificationTimeStr"] = this.lastModificationTimeStr !== undefined ? this.lastModificationTimeStr : null as any;
        if (Array.isArray(this.idList)) {
            data["idList"] = [];
            for (let item of this.idList)
                data["idList"].push(item);
        }
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["timeInterval"] = this.timeInterval !== undefined ? this.timeInterval : null as any;
        data["rowClassName"] = this.rowClassName !== undefined ? this.rowClassName : null as any;
        data["mergeId"] = this.mergeId !== undefined ? this.mergeId : null as any;
        data["mergeCode"] = this.mergeCode !== undefined ? this.mergeCode : null as any;
        data["freezeDate"] = this.freezeDate ? this.freezeDate.toISOString() : null as any;
        data["freezeDateStr"] = this.freezeDateStr !== undefined ? this.freezeDateStr : null as any;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : null as any;
        data["orderStatusName"] = this.orderStatusName !== undefined ? this.orderStatusName : null as any;
        return data;
    }
}

export class OrderDetailAuditDtoPagedResultDto {
    items!: OrderDetailAuditDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderDetailAuditDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): OrderDetailAuditDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailAuditDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class OrderDetailDto {
    /** 主键Id */
    id!: string;
    /** 订单号 */
    orderNumber!: string | null;
    /** 订单行号 */
    orderRowNo!: string | null;
    orderCreateUser!: string | null;
    /** 订单创建日期 */
    orderCreateDate!: moment.Moment | null;
    readonly orderCreateDateStr!: string | null;
    /** 订单提交日期 */
    orderSubmitDate!: moment.Moment;
    /** SO */
    saleNumber!: string | null;
    /** SO Line */
    saleRowNo!: string | null;
    /** 客户采购订单号 */
    customerPo!: string | null;
    /** 客户编号 */
    customerCode!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 计划装配日期 */
    scheduledAssemblyDate!: moment.Moment | null;
    readonly scheduledAssemblyDateStr!: string | null;
    /** 实际装配日期 */
    actualAssemblyDate!: moment.Moment;
    /** 实际入库日期 */
    actualStorageDate!: moment.Moment;
    /** 计划BOM完成日期 */
    bomFinishDate!: moment.Moment;
    /** 实际开工日 */
    actualStartDate!: moment.Moment;
    /** 客户要求日期 */
    customerRequestedDate!: moment.Moment;
    /** 预计出货日期 */
    expectedDeliveryDate!: moment.Moment | null;
    readonly expectedDeliveryDateStr!: string | null;
    /** 实际出货日期 */
    actualDeliveryDate!: moment.Moment;
    /** 最后一次收货日期 */
    lastReceiptDate!: moment.Moment;
    /** 出货日期 */
    deliveryDate!: moment.Moment;
    /** 冻结日期 */
    freezeDate!: moment.Moment | null;
    readonly freezeDateStr!: string | null;
    /** 冻结状态 */
    freezeStatus!: boolean;
    /** 订单状态 */
    orderStatus!: string | null;
    orderStatusName!: string | null;
    /** 手工合同号 */
    manualContractNumber!: string | null;
    /** SerialNumber */
    serialNumber!: string | null;
    /** 产品编号 */
    productCode!: string | null;
    /** 产品名称 */
    productName!: string | null;
    /** 产品名称(英文) */
    productNameEn!: string | null;
    /** 订单数量 */
    orderQty!: number;
    /** 单价 */
    unitPrice!: number;
    /** 金额（含税） */
    amount!: number;
    /** 提交数量（库存数量） */
    commitQty!: number;
    /** 出库数量（交付数量） */
    deliveryQty!: number;
    /** In Quality Insp（无用字段） */
    inspectionQty!: number;
    /** 技术参数修改次数 */
    technicalParameterModificationCount!: number;
    /** 技术参数修改描述 */
    technicalParameterModificationDescription!: string | null;
    /** 技术参数修改人Id */
    technicalParameterModificationUserId!: number;
    /** 技术参数修改时间 */
    technicalParameterModificationTime!: moment.Moment;
    /** 价格修改次数 */
    priceModificationCount!: number;
    /** 价格修改描述 */
    priceModificationDescription!: string | null;
    /** 价格修改人Id */
    priceModificationUserId!: number;
    /** 价格修改时间 */
    priceModificationTime!: moment.Moment;
    /** 交期修改次数 */
    deliveryDateModificationCount!: number;
    /** 交期修改描述 */
    deliveryDateModificationDescription!: string | null;
    /** 交期修改人Id */
    deliveryDateModificationUserId!: number;
    /** 交期修改时间 */
    deliveryDateModificationTime!: moment.Moment;
    /** 订单是否取消 */
    isOrderCancel!: number;
    /** 订单取消描述 */
    orderCancelDescription!: string | null;
    /** 订单取消人Id */
    orderCancelUserId!: number;
    /** 订单取消时间 */
    orderCancelTime!: moment.Moment;
    /** 修改类型 */
    modificationType!: string | null;
    /** Id 列表 */
    idList!: string[] | null;
    /** 修改备注 */
    editRemark!: string | null;
    /** 订单类型 */
    orderType!: string | null;
    /** 调整后单价 */
    changePrice!: number;
    /** 调整后金额 */
    changeAmount!: number;
    /** 1.增加 0.降低 */
    changeRequest!: string | null;
    editDetailJson!: string | null;
    /** 是否历史订单标志（0：非历史订单  1：历史订单） */
    historyFlag!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : null as any;
            this.orderRowNo = _data["orderRowNo"] !== undefined ? _data["orderRowNo"] : null as any;
            this.orderCreateUser = _data["orderCreateUser"] !== undefined ? _data["orderCreateUser"] : null as any;
            this.orderCreateDate = _data["orderCreateDate"] ? moment(_data["orderCreateDate"].toString()) : null as any;
            (this as any).orderCreateDateStr = _data["orderCreateDateStr"] !== undefined ? _data["orderCreateDateStr"] : null as any;
            this.orderSubmitDate = _data["orderSubmitDate"] ? moment(_data["orderSubmitDate"].toString()) : null as any;
            this.saleNumber = _data["saleNumber"] !== undefined ? _data["saleNumber"] : null as any;
            this.saleRowNo = _data["saleRowNo"] !== undefined ? _data["saleRowNo"] : null as any;
            this.customerPo = _data["customerPo"] !== undefined ? _data["customerPo"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.scheduledAssemblyDate = _data["scheduledAssemblyDate"] ? moment(_data["scheduledAssemblyDate"].toString()) : null as any;
            (this as any).scheduledAssemblyDateStr = _data["scheduledAssemblyDateStr"] !== undefined ? _data["scheduledAssemblyDateStr"] : null as any;
            this.actualAssemblyDate = _data["actualAssemblyDate"] ? moment(_data["actualAssemblyDate"].toString()) : null as any;
            this.actualStorageDate = _data["actualStorageDate"] ? moment(_data["actualStorageDate"].toString()) : null as any;
            this.bomFinishDate = _data["bomFinishDate"] ? moment(_data["bomFinishDate"].toString()) : null as any;
            this.actualStartDate = _data["actualStartDate"] ? moment(_data["actualStartDate"].toString()) : null as any;
            this.customerRequestedDate = _data["customerRequestedDate"] ? moment(_data["customerRequestedDate"].toString()) : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] ? moment(_data["expectedDeliveryDate"].toString()) : null as any;
            (this as any).expectedDeliveryDateStr = _data["expectedDeliveryDateStr"] !== undefined ? _data["expectedDeliveryDateStr"] : null as any;
            this.actualDeliveryDate = _data["actualDeliveryDate"] ? moment(_data["actualDeliveryDate"].toString()) : null as any;
            this.lastReceiptDate = _data["lastReceiptDate"] ? moment(_data["lastReceiptDate"].toString()) : null as any;
            this.deliveryDate = _data["deliveryDate"] ? moment(_data["deliveryDate"].toString()) : null as any;
            this.freezeDate = _data["freezeDate"] ? moment(_data["freezeDate"].toString()) : null as any;
            (this as any).freezeDateStr = _data["freezeDateStr"] !== undefined ? _data["freezeDateStr"] : null as any;
            this.freezeStatus = _data["freezeStatus"] !== undefined ? _data["freezeStatus"] : null as any;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : null as any;
            this.orderStatusName = _data["orderStatusName"] !== undefined ? _data["orderStatusName"] : null as any;
            this.manualContractNumber = _data["manualContractNumber"] !== undefined ? _data["manualContractNumber"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.productCode = _data["productCode"] !== undefined ? _data["productCode"] : null as any;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : null as any;
            this.productNameEn = _data["productNameEn"] !== undefined ? _data["productNameEn"] : null as any;
            this.orderQty = _data["orderQty"] !== undefined ? _data["orderQty"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.commitQty = _data["commitQty"] !== undefined ? _data["commitQty"] : null as any;
            this.deliveryQty = _data["deliveryQty"] !== undefined ? _data["deliveryQty"] : null as any;
            this.inspectionQty = _data["inspectionQty"] !== undefined ? _data["inspectionQty"] : null as any;
            this.technicalParameterModificationCount = _data["technicalParameterModificationCount"] !== undefined ? _data["technicalParameterModificationCount"] : null as any;
            this.technicalParameterModificationDescription = _data["technicalParameterModificationDescription"] !== undefined ? _data["technicalParameterModificationDescription"] : null as any;
            this.technicalParameterModificationUserId = _data["technicalParameterModificationUserId"] !== undefined ? _data["technicalParameterModificationUserId"] : null as any;
            this.technicalParameterModificationTime = _data["technicalParameterModificationTime"] ? moment(_data["technicalParameterModificationTime"].toString()) : null as any;
            this.priceModificationCount = _data["priceModificationCount"] !== undefined ? _data["priceModificationCount"] : null as any;
            this.priceModificationDescription = _data["priceModificationDescription"] !== undefined ? _data["priceModificationDescription"] : null as any;
            this.priceModificationUserId = _data["priceModificationUserId"] !== undefined ? _data["priceModificationUserId"] : null as any;
            this.priceModificationTime = _data["priceModificationTime"] ? moment(_data["priceModificationTime"].toString()) : null as any;
            this.deliveryDateModificationCount = _data["deliveryDateModificationCount"] !== undefined ? _data["deliveryDateModificationCount"] : null as any;
            this.deliveryDateModificationDescription = _data["deliveryDateModificationDescription"] !== undefined ? _data["deliveryDateModificationDescription"] : null as any;
            this.deliveryDateModificationUserId = _data["deliveryDateModificationUserId"] !== undefined ? _data["deliveryDateModificationUserId"] : null as any;
            this.deliveryDateModificationTime = _data["deliveryDateModificationTime"] ? moment(_data["deliveryDateModificationTime"].toString()) : null as any;
            this.isOrderCancel = _data["isOrderCancel"] !== undefined ? _data["isOrderCancel"] : null as any;
            this.orderCancelDescription = _data["orderCancelDescription"] !== undefined ? _data["orderCancelDescription"] : null as any;
            this.orderCancelUserId = _data["orderCancelUserId"] !== undefined ? _data["orderCancelUserId"] : null as any;
            this.orderCancelTime = _data["orderCancelTime"] ? moment(_data["orderCancelTime"].toString()) : null as any;
            this.modificationType = _data["modificationType"] !== undefined ? _data["modificationType"] : null as any;
            if (Array.isArray(_data["idList"])) {
                this.idList = [] as any;
                for (let item of _data["idList"])
                    this.idList!.push(item);
            }
            else {
                this.idList = null as any;
            }
            this.editRemark = _data["editRemark"] !== undefined ? _data["editRemark"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.changePrice = _data["changePrice"] !== undefined ? _data["changePrice"] : null as any;
            this.changeAmount = _data["changeAmount"] !== undefined ? _data["changeAmount"] : null as any;
            this.changeRequest = _data["changeRequest"] !== undefined ? _data["changeRequest"] : null as any;
            this.editDetailJson = _data["editDetailJson"] !== undefined ? _data["editDetailJson"] : null as any;
            this.historyFlag = _data["historyFlag"] !== undefined ? _data["historyFlag"] : null as any;
        }
    }

    static fromJS(data: any): OrderDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : null as any;
        data["orderRowNo"] = this.orderRowNo !== undefined ? this.orderRowNo : null as any;
        data["orderCreateUser"] = this.orderCreateUser !== undefined ? this.orderCreateUser : null as any;
        data["orderCreateDate"] = this.orderCreateDate ? this.orderCreateDate.toISOString() : null as any;
        data["orderCreateDateStr"] = this.orderCreateDateStr !== undefined ? this.orderCreateDateStr : null as any;
        data["orderSubmitDate"] = this.orderSubmitDate ? this.orderSubmitDate.toISOString() : null as any;
        data["saleNumber"] = this.saleNumber !== undefined ? this.saleNumber : null as any;
        data["saleRowNo"] = this.saleRowNo !== undefined ? this.saleRowNo : null as any;
        data["customerPo"] = this.customerPo !== undefined ? this.customerPo : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["scheduledAssemblyDate"] = this.scheduledAssemblyDate ? this.scheduledAssemblyDate.toISOString() : null as any;
        data["scheduledAssemblyDateStr"] = this.scheduledAssemblyDateStr !== undefined ? this.scheduledAssemblyDateStr : null as any;
        data["actualAssemblyDate"] = this.actualAssemblyDate ? this.actualAssemblyDate.toISOString() : null as any;
        data["actualStorageDate"] = this.actualStorageDate ? this.actualStorageDate.toISOString() : null as any;
        data["bomFinishDate"] = this.bomFinishDate ? this.bomFinishDate.toISOString() : null as any;
        data["actualStartDate"] = this.actualStartDate ? this.actualStartDate.toISOString() : null as any;
        data["customerRequestedDate"] = this.customerRequestedDate ? this.customerRequestedDate.toISOString() : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate ? this.expectedDeliveryDate.toISOString() : null as any;
        data["expectedDeliveryDateStr"] = this.expectedDeliveryDateStr !== undefined ? this.expectedDeliveryDateStr : null as any;
        data["actualDeliveryDate"] = this.actualDeliveryDate ? this.actualDeliveryDate.toISOString() : null as any;
        data["lastReceiptDate"] = this.lastReceiptDate ? this.lastReceiptDate.toISOString() : null as any;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : null as any;
        data["freezeDate"] = this.freezeDate ? this.freezeDate.toISOString() : null as any;
        data["freezeDateStr"] = this.freezeDateStr !== undefined ? this.freezeDateStr : null as any;
        data["freezeStatus"] = this.freezeStatus !== undefined ? this.freezeStatus : null as any;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : null as any;
        data["orderStatusName"] = this.orderStatusName !== undefined ? this.orderStatusName : null as any;
        data["manualContractNumber"] = this.manualContractNumber !== undefined ? this.manualContractNumber : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["productCode"] = this.productCode !== undefined ? this.productCode : null as any;
        data["productName"] = this.productName !== undefined ? this.productName : null as any;
        data["productNameEn"] = this.productNameEn !== undefined ? this.productNameEn : null as any;
        data["orderQty"] = this.orderQty !== undefined ? this.orderQty : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["commitQty"] = this.commitQty !== undefined ? this.commitQty : null as any;
        data["deliveryQty"] = this.deliveryQty !== undefined ? this.deliveryQty : null as any;
        data["inspectionQty"] = this.inspectionQty !== undefined ? this.inspectionQty : null as any;
        data["technicalParameterModificationCount"] = this.technicalParameterModificationCount !== undefined ? this.technicalParameterModificationCount : null as any;
        data["technicalParameterModificationDescription"] = this.technicalParameterModificationDescription !== undefined ? this.technicalParameterModificationDescription : null as any;
        data["technicalParameterModificationUserId"] = this.technicalParameterModificationUserId !== undefined ? this.technicalParameterModificationUserId : null as any;
        data["technicalParameterModificationTime"] = this.technicalParameterModificationTime ? this.technicalParameterModificationTime.toISOString() : null as any;
        data["priceModificationCount"] = this.priceModificationCount !== undefined ? this.priceModificationCount : null as any;
        data["priceModificationDescription"] = this.priceModificationDescription !== undefined ? this.priceModificationDescription : null as any;
        data["priceModificationUserId"] = this.priceModificationUserId !== undefined ? this.priceModificationUserId : null as any;
        data["priceModificationTime"] = this.priceModificationTime ? this.priceModificationTime.toISOString() : null as any;
        data["deliveryDateModificationCount"] = this.deliveryDateModificationCount !== undefined ? this.deliveryDateModificationCount : null as any;
        data["deliveryDateModificationDescription"] = this.deliveryDateModificationDescription !== undefined ? this.deliveryDateModificationDescription : null as any;
        data["deliveryDateModificationUserId"] = this.deliveryDateModificationUserId !== undefined ? this.deliveryDateModificationUserId : null as any;
        data["deliveryDateModificationTime"] = this.deliveryDateModificationTime ? this.deliveryDateModificationTime.toISOString() : null as any;
        data["isOrderCancel"] = this.isOrderCancel !== undefined ? this.isOrderCancel : null as any;
        data["orderCancelDescription"] = this.orderCancelDescription !== undefined ? this.orderCancelDescription : null as any;
        data["orderCancelUserId"] = this.orderCancelUserId !== undefined ? this.orderCancelUserId : null as any;
        data["orderCancelTime"] = this.orderCancelTime ? this.orderCancelTime.toISOString() : null as any;
        data["modificationType"] = this.modificationType !== undefined ? this.modificationType : null as any;
        if (Array.isArray(this.idList)) {
            data["idList"] = [];
            for (let item of this.idList)
                data["idList"].push(item);
        }
        data["editRemark"] = this.editRemark !== undefined ? this.editRemark : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["changePrice"] = this.changePrice !== undefined ? this.changePrice : null as any;
        data["changeAmount"] = this.changeAmount !== undefined ? this.changeAmount : null as any;
        data["changeRequest"] = this.changeRequest !== undefined ? this.changeRequest : null as any;
        data["editDetailJson"] = this.editDetailJson !== undefined ? this.editDetailJson : null as any;
        data["historyFlag"] = this.historyFlag !== undefined ? this.historyFlag : null as any;
        return data;
    }
}

export class OrderDetailDtoPagedResultDto {
    items!: OrderDetailDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderDetailDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): OrderDetailDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class OrderDetailModificationLogDto {
    /** 主键Id */
    id!: string;
    /** 订单号 */
    orderNumber!: string | null;
    /** 订单行号 */
    orderRowNo!: string | null;
    /** 订单数量 */
    orderQty!: number;
    /** 冻结状态 */
    freezeStatus!: boolean;
    /** 计划装配日期 */
    scheduledAssemblyDate!: moment.Moment | null;
    /** 客户编号 */
    customerCode!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** SO */
    saleNumber!: string | null;
    /** SO Line */
    saleRowNo!: string | null;
    /** 手工合同号 */
    manualContractNumber!: string | null;
    /** 修改类型 */
    modificationType!: string | null;
    /** Product Code */
    productCode!: string | null;
    /** Product Name */
    productName!: string | null;
    serialNumber!: string | null;
    /** 审核状态（0 未审核  4 拒绝  8 通过） */
    auditStatus!: string | null;
    /** 审核状态描述 */
    auditStatusName!: string | null;
    /** 备注 */
    auditRemark!: string | null;
    /** 审核人Id */
    auditUserId!: number | null;
    /** 审核人名称 */
    auditUserName!: string | null;
    /** 变更提交时间 */
    auditCreationTime!: moment.Moment;
    /** 审核日期 */
    auditDate!: moment.Moment | null;
    readonly auditDateTimeStr!: string | null;
    /** 修改内容 */
    content!: string | null;
    /** 备注 */
    remark!: string | null;
    /** 审核表对应Id */
    orderDetailAuditId!: string;
    /** 创建人Id */
    creatorUserId!: number | null;
    /** 创建人 */
    creatorUserName!: string | null;
    /** 创建时间 */
    creationTime!: moment.Moment | null;
    readonly creationTimeStr!: string | null;
    /** 修改人Id */
    lastModifierUserId!: number | null;
    /** 修改人 */
    lastModifierUserName!: string | null;
    /** 修改时间 */
    lastModificationTime!: moment.Moment | null;
    readonly lastModificationTimeStr!: string | null;
    orderDetail!: OrderDetail;
    /** 修改次数 */
    modificationCount!: number | null;
    /** 数量 */
    commitQty!: number | null;
    /** 调整前单价 */
    unitPrice!: number | null;
    /** 调整前金额 */
    amount!: number | null;
    /** 调整后单价 */
    changePrice!: number | null;
    /** 调整后金额 */
    changeAmount!: number | null;
    /** Increase: 增加 Reduce: 减少 */
    changeRequest!: string | null;
    /** 区域 */
    region!: string | null;
    mergeCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : null as any;
            this.orderRowNo = _data["orderRowNo"] !== undefined ? _data["orderRowNo"] : null as any;
            this.orderQty = _data["orderQty"] !== undefined ? _data["orderQty"] : null as any;
            this.freezeStatus = _data["freezeStatus"] !== undefined ? _data["freezeStatus"] : null as any;
            this.scheduledAssemblyDate = _data["scheduledAssemblyDate"] ? moment(_data["scheduledAssemblyDate"].toString()) : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.saleNumber = _data["saleNumber"] !== undefined ? _data["saleNumber"] : null as any;
            this.saleRowNo = _data["saleRowNo"] !== undefined ? _data["saleRowNo"] : null as any;
            this.manualContractNumber = _data["manualContractNumber"] !== undefined ? _data["manualContractNumber"] : null as any;
            this.modificationType = _data["modificationType"] !== undefined ? _data["modificationType"] : null as any;
            this.productCode = _data["productCode"] !== undefined ? _data["productCode"] : null as any;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.auditStatus = _data["auditStatus"] !== undefined ? _data["auditStatus"] : null as any;
            this.auditStatusName = _data["auditStatusName"] !== undefined ? _data["auditStatusName"] : null as any;
            this.auditRemark = _data["auditRemark"] !== undefined ? _data["auditRemark"] : null as any;
            this.auditUserId = _data["auditUserId"] !== undefined ? _data["auditUserId"] : null as any;
            this.auditUserName = _data["auditUserName"] !== undefined ? _data["auditUserName"] : null as any;
            this.auditCreationTime = _data["auditCreationTime"] ? moment(_data["auditCreationTime"].toString()) : null as any;
            this.auditDate = _data["auditDate"] ? moment(_data["auditDate"].toString()) : null as any;
            (this as any).auditDateTimeStr = _data["auditDateTimeStr"] !== undefined ? _data["auditDateTimeStr"] : null as any;
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.orderDetailAuditId = _data["orderDetailAuditId"] !== undefined ? _data["orderDetailAuditId"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.creatorUserName = _data["creatorUserName"] !== undefined ? _data["creatorUserName"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            (this as any).creationTimeStr = _data["creationTimeStr"] !== undefined ? _data["creationTimeStr"] : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.lastModifierUserName = _data["lastModifierUserName"] !== undefined ? _data["lastModifierUserName"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            (this as any).lastModificationTimeStr = _data["lastModificationTimeStr"] !== undefined ? _data["lastModificationTimeStr"] : null as any;
            this.orderDetail = _data["orderDetail"] ? OrderDetail.fromJS(_data["orderDetail"]) : null as any;
            this.modificationCount = _data["modificationCount"] !== undefined ? _data["modificationCount"] : null as any;
            this.commitQty = _data["commitQty"] !== undefined ? _data["commitQty"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.changePrice = _data["changePrice"] !== undefined ? _data["changePrice"] : null as any;
            this.changeAmount = _data["changeAmount"] !== undefined ? _data["changeAmount"] : null as any;
            this.changeRequest = _data["changeRequest"] !== undefined ? _data["changeRequest"] : null as any;
            this.region = _data["region"] !== undefined ? _data["region"] : null as any;
            this.mergeCode = _data["mergeCode"] !== undefined ? _data["mergeCode"] : null as any;
        }
    }

    static fromJS(data: any): OrderDetailModificationLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailModificationLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : null as any;
        data["orderRowNo"] = this.orderRowNo !== undefined ? this.orderRowNo : null as any;
        data["orderQty"] = this.orderQty !== undefined ? this.orderQty : null as any;
        data["freezeStatus"] = this.freezeStatus !== undefined ? this.freezeStatus : null as any;
        data["scheduledAssemblyDate"] = this.scheduledAssemblyDate ? this.scheduledAssemblyDate.toISOString() : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["saleNumber"] = this.saleNumber !== undefined ? this.saleNumber : null as any;
        data["saleRowNo"] = this.saleRowNo !== undefined ? this.saleRowNo : null as any;
        data["manualContractNumber"] = this.manualContractNumber !== undefined ? this.manualContractNumber : null as any;
        data["modificationType"] = this.modificationType !== undefined ? this.modificationType : null as any;
        data["productCode"] = this.productCode !== undefined ? this.productCode : null as any;
        data["productName"] = this.productName !== undefined ? this.productName : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["auditStatus"] = this.auditStatus !== undefined ? this.auditStatus : null as any;
        data["auditStatusName"] = this.auditStatusName !== undefined ? this.auditStatusName : null as any;
        data["auditRemark"] = this.auditRemark !== undefined ? this.auditRemark : null as any;
        data["auditUserId"] = this.auditUserId !== undefined ? this.auditUserId : null as any;
        data["auditUserName"] = this.auditUserName !== undefined ? this.auditUserName : null as any;
        data["auditCreationTime"] = this.auditCreationTime ? this.auditCreationTime.toISOString() : null as any;
        data["auditDate"] = this.auditDate ? this.auditDate.toISOString() : null as any;
        data["auditDateTimeStr"] = this.auditDateTimeStr !== undefined ? this.auditDateTimeStr : null as any;
        data["content"] = this.content !== undefined ? this.content : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["orderDetailAuditId"] = this.orderDetailAuditId !== undefined ? this.orderDetailAuditId : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["creatorUserName"] = this.creatorUserName !== undefined ? this.creatorUserName : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creationTimeStr"] = this.creationTimeStr !== undefined ? this.creationTimeStr : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["lastModifierUserName"] = this.lastModifierUserName !== undefined ? this.lastModifierUserName : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModificationTimeStr"] = this.lastModificationTimeStr !== undefined ? this.lastModificationTimeStr : null as any;
        data["orderDetail"] = this.orderDetail ? this.orderDetail.toJSON() : null as any;
        data["modificationCount"] = this.modificationCount !== undefined ? this.modificationCount : null as any;
        data["commitQty"] = this.commitQty !== undefined ? this.commitQty : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["changePrice"] = this.changePrice !== undefined ? this.changePrice : null as any;
        data["changeAmount"] = this.changeAmount !== undefined ? this.changeAmount : null as any;
        data["changeRequest"] = this.changeRequest !== undefined ? this.changeRequest : null as any;
        data["region"] = this.region !== undefined ? this.region : null as any;
        data["mergeCode"] = this.mergeCode !== undefined ? this.mergeCode : null as any;
        return data;
    }
}

export class OrderDetailModificationLogDtoPagedResultDto {
    items!: OrderDetailModificationLogDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderDetailModificationLogDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): OrderDetailModificationLogDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailModificationLogDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class OrderDetailSerialNumber {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    orderDetailId!: string;
    orderNumber!: string | null;
    orderRowNo!: string | null;
    serialNumber!: string | null;
    orderDetail!: OrderDetail;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.orderDetailId = _data["orderDetailId"] !== undefined ? _data["orderDetailId"] : null as any;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : null as any;
            this.orderRowNo = _data["orderRowNo"] !== undefined ? _data["orderRowNo"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.orderDetail = _data["orderDetail"] ? OrderDetail.fromJS(_data["orderDetail"]) : null as any;
        }
    }

    static fromJS(data: any): OrderDetailSerialNumber {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailSerialNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["orderDetailId"] = this.orderDetailId !== undefined ? this.orderDetailId : null as any;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : null as any;
        data["orderRowNo"] = this.orderRowNo !== undefined ? this.orderRowNo : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["orderDetail"] = this.orderDetail ? this.orderDetail.toJSON() : null as any;
        return data;
    }
}

export class OrderDetailShipment {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    orderDetailId!: string;
    orderNumber!: string | null;
    orderRowNo!: string | null;
    saleNumber!: string | null;
    saleRowNo!: string | null;
    shipmentCode!: string | null;
    referenceCode!: string | null;
    etdDate!: moment.Moment | null;
    etaDate!: moment.Moment | null;
    atdDate!: moment.Moment | null;
    ataDate!: moment.Moment | null;
    orderDetail!: OrderDetail;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.orderDetailId = _data["orderDetailId"] !== undefined ? _data["orderDetailId"] : null as any;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : null as any;
            this.orderRowNo = _data["orderRowNo"] !== undefined ? _data["orderRowNo"] : null as any;
            this.saleNumber = _data["saleNumber"] !== undefined ? _data["saleNumber"] : null as any;
            this.saleRowNo = _data["saleRowNo"] !== undefined ? _data["saleRowNo"] : null as any;
            this.shipmentCode = _data["shipmentCode"] !== undefined ? _data["shipmentCode"] : null as any;
            this.referenceCode = _data["referenceCode"] !== undefined ? _data["referenceCode"] : null as any;
            this.etdDate = _data["etdDate"] ? moment(_data["etdDate"].toString()) : null as any;
            this.etaDate = _data["etaDate"] ? moment(_data["etaDate"].toString()) : null as any;
            this.atdDate = _data["atdDate"] ? moment(_data["atdDate"].toString()) : null as any;
            this.ataDate = _data["ataDate"] ? moment(_data["ataDate"].toString()) : null as any;
            this.orderDetail = _data["orderDetail"] ? OrderDetail.fromJS(_data["orderDetail"]) : null as any;
        }
    }

    static fromJS(data: any): OrderDetailShipment {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailShipment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["orderDetailId"] = this.orderDetailId !== undefined ? this.orderDetailId : null as any;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : null as any;
        data["orderRowNo"] = this.orderRowNo !== undefined ? this.orderRowNo : null as any;
        data["saleNumber"] = this.saleNumber !== undefined ? this.saleNumber : null as any;
        data["saleRowNo"] = this.saleRowNo !== undefined ? this.saleRowNo : null as any;
        data["shipmentCode"] = this.shipmentCode !== undefined ? this.shipmentCode : null as any;
        data["referenceCode"] = this.referenceCode !== undefined ? this.referenceCode : null as any;
        data["etdDate"] = this.etdDate ? this.etdDate.toISOString() : null as any;
        data["etaDate"] = this.etaDate ? this.etaDate.toISOString() : null as any;
        data["atdDate"] = this.atdDate ? this.atdDate.toISOString() : null as any;
        data["ataDate"] = this.ataDate ? this.ataDate.toISOString() : null as any;
        data["orderDetail"] = this.orderDetail ? this.orderDetail.toJSON() : null as any;
        return data;
    }
}

export class OrderDetailShipmentDto {
    /** 主键Id */
    id!: string;
    /** OrderDetail Id */
    orderDetailId!: string;
    /** 订单号 */
    orderNumber!: string | null;
    /** 订单行号 */
    orderRowNo!: string | null;
    /** SO */
    saleNumber!: string | null;
    /** SO Line */
    saleRowNo!: string | null;
    /** Shipment */
    shipmentCode!: string | null;
    /** ReferenceCode */
    referenceCode!: string | null;
    /** ETDDate */
    etdDate!: moment.Moment | null;
    readonly etdDateStr!: string | null;
    /** ETADate */
    etaDate!: moment.Moment | null;
    readonly etaDateStr!: string | null;
    /** ATDDate */
    atdDate!: moment.Moment | null;
    readonly atdDateStr!: string | null;
    /** ATADate */
    ataDate!: moment.Moment | null;
    readonly ataDateStr!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.orderDetailId = _data["orderDetailId"] !== undefined ? _data["orderDetailId"] : null as any;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : null as any;
            this.orderRowNo = _data["orderRowNo"] !== undefined ? _data["orderRowNo"] : null as any;
            this.saleNumber = _data["saleNumber"] !== undefined ? _data["saleNumber"] : null as any;
            this.saleRowNo = _data["saleRowNo"] !== undefined ? _data["saleRowNo"] : null as any;
            this.shipmentCode = _data["shipmentCode"] !== undefined ? _data["shipmentCode"] : null as any;
            this.referenceCode = _data["referenceCode"] !== undefined ? _data["referenceCode"] : null as any;
            this.etdDate = _data["etdDate"] ? moment(_data["etdDate"].toString()) : null as any;
            (this as any).etdDateStr = _data["etdDateStr"] !== undefined ? _data["etdDateStr"] : null as any;
            this.etaDate = _data["etaDate"] ? moment(_data["etaDate"].toString()) : null as any;
            (this as any).etaDateStr = _data["etaDateStr"] !== undefined ? _data["etaDateStr"] : null as any;
            this.atdDate = _data["atdDate"] ? moment(_data["atdDate"].toString()) : null as any;
            (this as any).atdDateStr = _data["atdDateStr"] !== undefined ? _data["atdDateStr"] : null as any;
            this.ataDate = _data["ataDate"] ? moment(_data["ataDate"].toString()) : null as any;
            (this as any).ataDateStr = _data["ataDateStr"] !== undefined ? _data["ataDateStr"] : null as any;
        }
    }

    static fromJS(data: any): OrderDetailShipmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailShipmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["orderDetailId"] = this.orderDetailId !== undefined ? this.orderDetailId : null as any;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : null as any;
        data["orderRowNo"] = this.orderRowNo !== undefined ? this.orderRowNo : null as any;
        data["saleNumber"] = this.saleNumber !== undefined ? this.saleNumber : null as any;
        data["saleRowNo"] = this.saleRowNo !== undefined ? this.saleRowNo : null as any;
        data["shipmentCode"] = this.shipmentCode !== undefined ? this.shipmentCode : null as any;
        data["referenceCode"] = this.referenceCode !== undefined ? this.referenceCode : null as any;
        data["etdDate"] = this.etdDate ? this.etdDate.toISOString() : null as any;
        data["etdDateStr"] = this.etdDateStr !== undefined ? this.etdDateStr : null as any;
        data["etaDate"] = this.etaDate ? this.etaDate.toISOString() : null as any;
        data["etaDateStr"] = this.etaDateStr !== undefined ? this.etaDateStr : null as any;
        data["atdDate"] = this.atdDate ? this.atdDate.toISOString() : null as any;
        data["atdDateStr"] = this.atdDateStr !== undefined ? this.atdDateStr : null as any;
        data["ataDate"] = this.ataDate ? this.ataDate.toISOString() : null as any;
        data["ataDateStr"] = this.ataDateStr !== undefined ? this.ataDateStr : null as any;
        return data;
    }
}

export class OrderDetailShipmentInputDto {
    orderNumber!: string | null;
    /** 订单行号 */
    orderRowNo!: string | null;
    /** SO */
    saleNumber!: string | null;
    /** SO Line */
    saleRowNo!: string | null;
    /** Shipment */
    shipmentCode!: string | null;
    /** ReferenceCode */
    referenceCode!: string | null;
    /** ETDDate */
    etdDate!: moment.Moment | null;
    /** ETADate */
    etaDate!: moment.Moment | null;
    /** ATDDate */
    atdDate!: moment.Moment | null;
    /** ATADate */
    ataDate!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : null as any;
            this.orderRowNo = _data["orderRowNo"] !== undefined ? _data["orderRowNo"] : null as any;
            this.saleNumber = _data["saleNumber"] !== undefined ? _data["saleNumber"] : null as any;
            this.saleRowNo = _data["saleRowNo"] !== undefined ? _data["saleRowNo"] : null as any;
            this.shipmentCode = _data["shipmentCode"] !== undefined ? _data["shipmentCode"] : null as any;
            this.referenceCode = _data["referenceCode"] !== undefined ? _data["referenceCode"] : null as any;
            this.etdDate = _data["etdDate"] ? moment(_data["etdDate"].toString()) : null as any;
            this.etaDate = _data["etaDate"] ? moment(_data["etaDate"].toString()) : null as any;
            this.atdDate = _data["atdDate"] ? moment(_data["atdDate"].toString()) : null as any;
            this.ataDate = _data["ataDate"] ? moment(_data["ataDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): OrderDetailShipmentInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailShipmentInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : null as any;
        data["orderRowNo"] = this.orderRowNo !== undefined ? this.orderRowNo : null as any;
        data["saleNumber"] = this.saleNumber !== undefined ? this.saleNumber : null as any;
        data["saleRowNo"] = this.saleRowNo !== undefined ? this.saleRowNo : null as any;
        data["shipmentCode"] = this.shipmentCode !== undefined ? this.shipmentCode : null as any;
        data["referenceCode"] = this.referenceCode !== undefined ? this.referenceCode : null as any;
        data["etdDate"] = this.etdDate ? this.etdDate.toISOString() : null as any;
        data["etaDate"] = this.etaDate ? this.etaDate.toISOString() : null as any;
        data["atdDate"] = this.atdDate ? this.atdDate.toISOString() : null as any;
        data["ataDate"] = this.ataDate ? this.ataDate.toISOString() : null as any;
        return data;
    }
}

export class OrderDetailSynchronizeInputDto {
    /** 下单 */
    dateRange!: moment.Moment[] | null;
    readonly startDateTime!: string | null;
    readonly endDateTime!: string | null;
    customerCodeList!: string[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dateRange"])) {
                this.dateRange = [] as any;
                for (let item of _data["dateRange"])
                    this.dateRange!.push(moment(item));
            }
            else {
                this.dateRange = null as any;
            }
            (this as any).startDateTime = _data["startDateTime"] !== undefined ? _data["startDateTime"] : null as any;
            (this as any).endDateTime = _data["endDateTime"] !== undefined ? _data["endDateTime"] : null as any;
            if (Array.isArray(_data["customerCodeList"])) {
                this.customerCodeList = [] as any;
                for (let item of _data["customerCodeList"])
                    this.customerCodeList!.push(item);
            }
            else {
                this.customerCodeList = null as any;
            }
        }
    }

    static fromJS(data: any): OrderDetailSynchronizeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailSynchronizeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dateRange)) {
            data["dateRange"] = [];
            for (let item of this.dateRange)
                data["dateRange"].push(item.toISOString());
        }
        data["startDateTime"] = this.startDateTime !== undefined ? this.startDateTime : null as any;
        data["endDateTime"] = this.endDateTime !== undefined ? this.endDateTime : null as any;
        if (Array.isArray(this.customerCodeList)) {
            data["customerCodeList"] = [];
            for (let item of this.customerCodeList)
                data["customerCodeList"].push(item);
        }
        return data;
    }
}

export class PageCountrySalesRelationInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 客户编码 */
    customerCode!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 国家 */
    countryKey!: string | null;
    /** 销售代理 */
    salesAgentName!: string | null;
    /** 订单类型 */
    orderType!: string | null;
    /** 开始日期 */
    readonly startDateTime!: moment.Moment | null;
    /** 结束日期(结束日期包含在当日创建的数据，因此天数+1,判断时使用小于比较符) */
    readonly endDateTime!: moment.Moment | null;
    date!: moment.Moment[] | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.countryKey = _data["countryKey"] !== undefined ? _data["countryKey"] : null as any;
            this.salesAgentName = _data["salesAgentName"] !== undefined ? _data["salesAgentName"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            (this as any).startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : null as any;
            (this as any).endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : null as any;
            if (Array.isArray(_data["date"])) {
                this.date = [] as any;
                for (let item of _data["date"])
                    this.date!.push(moment(item));
            }
            else {
                this.date = null as any;
            }
        }
    }

    static fromJS(data: any): PageCountrySalesRelationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageCountrySalesRelationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["countryKey"] = this.countryKey !== undefined ? this.countryKey : null as any;
        data["salesAgentName"] = this.salesAgentName !== undefined ? this.salesAgentName : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : null as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : null as any;
        if (Array.isArray(this.date)) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item.toISOString());
        }
        return data;
    }
}

export class PageEmailSendLogInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 订单号 */
    orderNumber!: string | null;
    /** 订单行号 */
    orderRowNo!: string | null;
    /** 邮件标题 */
    title!: string | null;
    /** 收件人邮箱 */
    recipient!: string | null;
    /** 发送状态 */
    status!: string | null;
    /** 发送时间 */
    readonly sendDateStartDateTime!: moment.Moment | null;
    /** 发送时间 */
    readonly sendDateEndDateTime!: moment.Moment | null;
    /** 发送时间 */
    sendDate!: moment.Moment[] | null;
    /** 开始日期 */
    readonly startDateTime!: moment.Moment | null;
    /** 结束日期(结束日期包含在当日创建的数据，因此天数+1,判断时使用小于比较符) */
    readonly endDateTime!: moment.Moment | null;
    date!: moment.Moment[] | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : null as any;
            this.orderRowNo = _data["orderRowNo"] !== undefined ? _data["orderRowNo"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.recipient = _data["recipient"] !== undefined ? _data["recipient"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            (this as any).sendDateStartDateTime = _data["sendDateStartDateTime"] ? moment(_data["sendDateStartDateTime"].toString()) : null as any;
            (this as any).sendDateEndDateTime = _data["sendDateEndDateTime"] ? moment(_data["sendDateEndDateTime"].toString()) : null as any;
            if (Array.isArray(_data["sendDate"])) {
                this.sendDate = [] as any;
                for (let item of _data["sendDate"])
                    this.sendDate!.push(moment(item));
            }
            else {
                this.sendDate = null as any;
            }
            (this as any).startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : null as any;
            (this as any).endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : null as any;
            if (Array.isArray(_data["date"])) {
                this.date = [] as any;
                for (let item of _data["date"])
                    this.date!.push(moment(item));
            }
            else {
                this.date = null as any;
            }
        }
    }

    static fromJS(data: any): PageEmailSendLogInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageEmailSendLogInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : null as any;
        data["orderRowNo"] = this.orderRowNo !== undefined ? this.orderRowNo : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["recipient"] = this.recipient !== undefined ? this.recipient : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["sendDateStartDateTime"] = this.sendDateStartDateTime ? this.sendDateStartDateTime.toISOString() : null as any;
        data["sendDateEndDateTime"] = this.sendDateEndDateTime ? this.sendDateEndDateTime.toISOString() : null as any;
        if (Array.isArray(this.sendDate)) {
            data["sendDate"] = [];
            for (let item of this.sendDate)
                data["sendDate"].push(item.toISOString());
        }
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : null as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : null as any;
        if (Array.isArray(this.date)) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item.toISOString());
        }
        return data;
    }
}

export class PageOperationLogInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 表名 */
    tableName!: string | null;
    /** 操作编号 */
    operationCode!: string | null;
    /** 操作模块 */
    moduleName!: string | null;
    /** 创建者Id */
    createUserId!: string | null;
    /** 开始日期 */
    readonly startDateTime!: moment.Moment | null;
    /** 结束日期(结束日期包含在当日创建的数据，因此天数+1,判断时使用小于比较符) */
    readonly endDateTime!: moment.Moment | null;
    date!: moment.Moment[] | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.tableName = _data["tableName"] !== undefined ? _data["tableName"] : null as any;
            this.operationCode = _data["operationCode"] !== undefined ? _data["operationCode"] : null as any;
            this.moduleName = _data["moduleName"] !== undefined ? _data["moduleName"] : null as any;
            this.createUserId = _data["createUserId"] !== undefined ? _data["createUserId"] : null as any;
            (this as any).startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : null as any;
            (this as any).endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : null as any;
            if (Array.isArray(_data["date"])) {
                this.date = [] as any;
                for (let item of _data["date"])
                    this.date!.push(moment(item));
            }
            else {
                this.date = null as any;
            }
        }
    }

    static fromJS(data: any): PageOperationLogInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageOperationLogInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["tableName"] = this.tableName !== undefined ? this.tableName : null as any;
        data["operationCode"] = this.operationCode !== undefined ? this.operationCode : null as any;
        data["moduleName"] = this.moduleName !== undefined ? this.moduleName : null as any;
        data["createUserId"] = this.createUserId !== undefined ? this.createUserId : null as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : null as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : null as any;
        if (Array.isArray(this.date)) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item.toISOString());
        }
        return data;
    }
}

export class PageOrderDetailAuditInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 订单号 */
    orderNumber!: string | null;
    /** 订单行号 */
    orderRowNo!: string | null;
    /** SO */
    saleNumber!: string | null;
    /** SO */
    productCode!: string | null;
    /** 手工合同号 */
    manualContractNumber!: string | null;
    /** 序列号 */
    serialNumber!: string | null;
    /** 修改类型 */
    modificationType!: string | null;
    /** 审核状态（0 未审核  4 拒绝  8 通过） */
    auditStatus!: string | null;
    /** 审核开始日期 */
    readonly auditStartDateTime!: moment.Moment | null;
    /** 审核结束日期(结束日期包含在当日创建的数据，因此天数+1,判断时使用小于比较符) */
    readonly auditEndDateTime!: moment.Moment | null;
    /** 审核日期 */
    auditDate!: moment.Moment[] | null;
    /** 开始日期 */
    readonly startDateTime!: moment.Moment | null;
    /** 结束日期(结束日期包含在当日创建的数据，因此天数+1,判断时使用小于比较符) */
    readonly endDateTime!: moment.Moment | null;
    date!: moment.Moment[] | null;
    mergeCode!: string | null;
    orderNumberAndMergeId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : null as any;
            this.orderRowNo = _data["orderRowNo"] !== undefined ? _data["orderRowNo"] : null as any;
            this.saleNumber = _data["saleNumber"] !== undefined ? _data["saleNumber"] : null as any;
            this.productCode = _data["productCode"] !== undefined ? _data["productCode"] : null as any;
            this.manualContractNumber = _data["manualContractNumber"] !== undefined ? _data["manualContractNumber"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.modificationType = _data["modificationType"] !== undefined ? _data["modificationType"] : null as any;
            this.auditStatus = _data["auditStatus"] !== undefined ? _data["auditStatus"] : null as any;
            (this as any).auditStartDateTime = _data["auditStartDateTime"] ? moment(_data["auditStartDateTime"].toString()) : null as any;
            (this as any).auditEndDateTime = _data["auditEndDateTime"] ? moment(_data["auditEndDateTime"].toString()) : null as any;
            if (Array.isArray(_data["auditDate"])) {
                this.auditDate = [] as any;
                for (let item of _data["auditDate"])
                    this.auditDate!.push(moment(item));
            }
            else {
                this.auditDate = null as any;
            }
            (this as any).startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : null as any;
            (this as any).endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : null as any;
            if (Array.isArray(_data["date"])) {
                this.date = [] as any;
                for (let item of _data["date"])
                    this.date!.push(moment(item));
            }
            else {
                this.date = null as any;
            }
            this.mergeCode = _data["mergeCode"] !== undefined ? _data["mergeCode"] : null as any;
            this.orderNumberAndMergeId = _data["orderNumberAndMergeId"] !== undefined ? _data["orderNumberAndMergeId"] : null as any;
        }
    }

    static fromJS(data: any): PageOrderDetailAuditInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageOrderDetailAuditInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : null as any;
        data["orderRowNo"] = this.orderRowNo !== undefined ? this.orderRowNo : null as any;
        data["saleNumber"] = this.saleNumber !== undefined ? this.saleNumber : null as any;
        data["productCode"] = this.productCode !== undefined ? this.productCode : null as any;
        data["manualContractNumber"] = this.manualContractNumber !== undefined ? this.manualContractNumber : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["modificationType"] = this.modificationType !== undefined ? this.modificationType : null as any;
        data["auditStatus"] = this.auditStatus !== undefined ? this.auditStatus : null as any;
        data["auditStartDateTime"] = this.auditStartDateTime ? this.auditStartDateTime.toISOString() : null as any;
        data["auditEndDateTime"] = this.auditEndDateTime ? this.auditEndDateTime.toISOString() : null as any;
        if (Array.isArray(this.auditDate)) {
            data["auditDate"] = [];
            for (let item of this.auditDate)
                data["auditDate"].push(item.toISOString());
        }
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : null as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : null as any;
        if (Array.isArray(this.date)) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item.toISOString());
        }
        data["mergeCode"] = this.mergeCode !== undefined ? this.mergeCode : null as any;
        data["orderNumberAndMergeId"] = this.orderNumberAndMergeId !== undefined ? this.orderNumberAndMergeId : null as any;
        return data;
    }
}

export class PageOrderDetailInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** OMS NO */
    orderNumber!: string | null;
    /** Line No */
    orderRowNo!: string | null;
    /** 下单开始日期 */
    readonly orderSubmitStartDateTime!: moment.Moment | null;
    /** 下单结束日期(结束日期包含在当日创建的数据，因此天数+1,判断时使用小于比较符) */
    readonly orderSubmitEndDateTime!: moment.Moment | null;
    /** 下单 */
    orderSubmitDate!: moment.Moment[] | null;
    /** 当前计划出库开始日期（EXW Date） */
    readonly expectedDeliveryStartDateTime!: moment.Moment | null;
    /** 当前计划出库结束日期 （EXW Date） */
    readonly expectedDeliveryEndDateTime!: moment.Moment | null;
    /** 当前计划出库（EXW Date） */
    expectedDeliveryDate!: moment.Moment[] | null;
    /** 订单状态 */
    orderStatus!: string | null;
    /** 冻结状态 */
    freezeStatus!: string | null;
    /** 产品编号 */
    productCode!: string | null;
    /** 产品名称 */
    productName!: string | null;
    /** 手工合同号 */
    manualContractNumber!: string | null;
    /** 客户采购订单号（Puchcase Order） */
    customerPo!: string | null;
    /** SerialNumber */
    serialNumber!: string | null;
    /** SO */
    saleNumber!: string | null;
    /** SO Line */
    saleRowNo!: string | null;
    /** 客户编号 */
    customerCode!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 历史查询 */
    historySearch!: string | null;
    homePage!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : null as any;
            this.orderRowNo = _data["orderRowNo"] !== undefined ? _data["orderRowNo"] : null as any;
            (this as any).orderSubmitStartDateTime = _data["orderSubmitStartDateTime"] ? moment(_data["orderSubmitStartDateTime"].toString()) : null as any;
            (this as any).orderSubmitEndDateTime = _data["orderSubmitEndDateTime"] ? moment(_data["orderSubmitEndDateTime"].toString()) : null as any;
            if (Array.isArray(_data["orderSubmitDate"])) {
                this.orderSubmitDate = [] as any;
                for (let item of _data["orderSubmitDate"])
                    this.orderSubmitDate!.push(moment(item));
            }
            else {
                this.orderSubmitDate = null as any;
            }
            (this as any).expectedDeliveryStartDateTime = _data["expectedDeliveryStartDateTime"] ? moment(_data["expectedDeliveryStartDateTime"].toString()) : null as any;
            (this as any).expectedDeliveryEndDateTime = _data["expectedDeliveryEndDateTime"] ? moment(_data["expectedDeliveryEndDateTime"].toString()) : null as any;
            if (Array.isArray(_data["expectedDeliveryDate"])) {
                this.expectedDeliveryDate = [] as any;
                for (let item of _data["expectedDeliveryDate"])
                    this.expectedDeliveryDate!.push(moment(item));
            }
            else {
                this.expectedDeliveryDate = null as any;
            }
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : null as any;
            this.freezeStatus = _data["freezeStatus"] !== undefined ? _data["freezeStatus"] : null as any;
            this.productCode = _data["productCode"] !== undefined ? _data["productCode"] : null as any;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : null as any;
            this.manualContractNumber = _data["manualContractNumber"] !== undefined ? _data["manualContractNumber"] : null as any;
            this.customerPo = _data["customerPo"] !== undefined ? _data["customerPo"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.saleNumber = _data["saleNumber"] !== undefined ? _data["saleNumber"] : null as any;
            this.saleRowNo = _data["saleRowNo"] !== undefined ? _data["saleRowNo"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.historySearch = _data["historySearch"] !== undefined ? _data["historySearch"] : null as any;
            this.homePage = _data["homePage"] !== undefined ? _data["homePage"] : null as any;
        }
    }

    static fromJS(data: any): PageOrderDetailInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageOrderDetailInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : null as any;
        data["orderRowNo"] = this.orderRowNo !== undefined ? this.orderRowNo : null as any;
        data["orderSubmitStartDateTime"] = this.orderSubmitStartDateTime ? this.orderSubmitStartDateTime.toISOString() : null as any;
        data["orderSubmitEndDateTime"] = this.orderSubmitEndDateTime ? this.orderSubmitEndDateTime.toISOString() : null as any;
        if (Array.isArray(this.orderSubmitDate)) {
            data["orderSubmitDate"] = [];
            for (let item of this.orderSubmitDate)
                data["orderSubmitDate"].push(item.toISOString());
        }
        data["expectedDeliveryStartDateTime"] = this.expectedDeliveryStartDateTime ? this.expectedDeliveryStartDateTime.toISOString() : null as any;
        data["expectedDeliveryEndDateTime"] = this.expectedDeliveryEndDateTime ? this.expectedDeliveryEndDateTime.toISOString() : null as any;
        if (Array.isArray(this.expectedDeliveryDate)) {
            data["expectedDeliveryDate"] = [];
            for (let item of this.expectedDeliveryDate)
                data["expectedDeliveryDate"].push(item.toISOString());
        }
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : null as any;
        data["freezeStatus"] = this.freezeStatus !== undefined ? this.freezeStatus : null as any;
        data["productCode"] = this.productCode !== undefined ? this.productCode : null as any;
        data["productName"] = this.productName !== undefined ? this.productName : null as any;
        data["manualContractNumber"] = this.manualContractNumber !== undefined ? this.manualContractNumber : null as any;
        data["customerPo"] = this.customerPo !== undefined ? this.customerPo : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["saleNumber"] = this.saleNumber !== undefined ? this.saleNumber : null as any;
        data["saleRowNo"] = this.saleRowNo !== undefined ? this.saleRowNo : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["historySearch"] = this.historySearch !== undefined ? this.historySearch : null as any;
        data["homePage"] = this.homePage !== undefined ? this.homePage : null as any;
        return data;
    }
}

export class PageOrderDetailModificationLogInputDto {
    maxResultCount!: number;
    skipCount!: number;
    orderNumber!: string | null;
    /** 订单行号 */
    orderRowNo!: string | null;
    /** 修改类型 */
    modificationType!: string | null;
    /** SO */
    saleNumber!: string | null;
    /** SO Line */
    saleRowNo!: string | null;
    productCode!: string | null;
    productName!: string | null;
    serialNumber!: string | null;
    /** 审核状态（0 未审核  4 拒绝  8 通过） */
    auditStatus!: string | null;
    /** 开始日期 */
    readonly startDateTime!: moment.Moment | null;
    /** 结束日期(结束日期包含在当日创建的数据，因此天数+1,判断时使用小于比较符) */
    readonly endDateTime!: moment.Moment | null;
    date!: moment.Moment[] | null;
    /** 开始日期 */
    readonly auditDateStartDateTime!: moment.Moment | null;
    /** 结束日期(结束日期包含在当日创建的数据，因此天数+1,判断时使用小于比较符) */
    readonly auditDateEndDateTime!: moment.Moment | null;
    auditDate!: moment.Moment[] | null;
    mergeCode!: string | null;
    homePage!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : null as any;
            this.orderRowNo = _data["orderRowNo"] !== undefined ? _data["orderRowNo"] : null as any;
            this.modificationType = _data["modificationType"] !== undefined ? _data["modificationType"] : null as any;
            this.saleNumber = _data["saleNumber"] !== undefined ? _data["saleNumber"] : null as any;
            this.saleRowNo = _data["saleRowNo"] !== undefined ? _data["saleRowNo"] : null as any;
            this.productCode = _data["productCode"] !== undefined ? _data["productCode"] : null as any;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.auditStatus = _data["auditStatus"] !== undefined ? _data["auditStatus"] : null as any;
            (this as any).startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : null as any;
            (this as any).endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : null as any;
            if (Array.isArray(_data["date"])) {
                this.date = [] as any;
                for (let item of _data["date"])
                    this.date!.push(moment(item));
            }
            else {
                this.date = null as any;
            }
            (this as any).auditDateStartDateTime = _data["auditDateStartDateTime"] ? moment(_data["auditDateStartDateTime"].toString()) : null as any;
            (this as any).auditDateEndDateTime = _data["auditDateEndDateTime"] ? moment(_data["auditDateEndDateTime"].toString()) : null as any;
            if (Array.isArray(_data["auditDate"])) {
                this.auditDate = [] as any;
                for (let item of _data["auditDate"])
                    this.auditDate!.push(moment(item));
            }
            else {
                this.auditDate = null as any;
            }
            this.mergeCode = _data["mergeCode"] !== undefined ? _data["mergeCode"] : null as any;
            this.homePage = _data["homePage"] !== undefined ? _data["homePage"] : null as any;
        }
    }

    static fromJS(data: any): PageOrderDetailModificationLogInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageOrderDetailModificationLogInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : null as any;
        data["orderRowNo"] = this.orderRowNo !== undefined ? this.orderRowNo : null as any;
        data["modificationType"] = this.modificationType !== undefined ? this.modificationType : null as any;
        data["saleNumber"] = this.saleNumber !== undefined ? this.saleNumber : null as any;
        data["saleRowNo"] = this.saleRowNo !== undefined ? this.saleRowNo : null as any;
        data["productCode"] = this.productCode !== undefined ? this.productCode : null as any;
        data["productName"] = this.productName !== undefined ? this.productName : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["auditStatus"] = this.auditStatus !== undefined ? this.auditStatus : null as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : null as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : null as any;
        if (Array.isArray(this.date)) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item.toISOString());
        }
        data["auditDateStartDateTime"] = this.auditDateStartDateTime ? this.auditDateStartDateTime.toISOString() : null as any;
        data["auditDateEndDateTime"] = this.auditDateEndDateTime ? this.auditDateEndDateTime.toISOString() : null as any;
        if (Array.isArray(this.auditDate)) {
            data["auditDate"] = [];
            for (let item of this.auditDate)
                data["auditDate"].push(item.toISOString());
        }
        data["mergeCode"] = this.mergeCode !== undefined ? this.mergeCode : null as any;
        data["homePage"] = this.homePage !== undefined ? this.homePage : null as any;
        return data;
    }
}

export class PageUserCustomerRelationshipInputDto {
    maxResultCount!: number;
    skipCount!: number;
    userId!: number | null;
    countrySaleRelationId!: string | null;
    isEnabled!: boolean | null;
    startTime!: moment.Moment | null;
    endTime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.countrySaleRelationId = _data["countrySaleRelationId"] !== undefined ? _data["countrySaleRelationId"] : null as any;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : null as any;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : null as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): PageUserCustomerRelationshipInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageUserCustomerRelationshipInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["countrySaleRelationId"] = this.countrySaleRelationId !== undefined ? this.countrySaleRelationId : null as any;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        return data;
    }
}

export class PageVarConfigSearchInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 变量名称 */
    configName!: string | null;
    /** 描述 */
    description!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.configName = _data["configName"] !== undefined ? _data["configName"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): PageVarConfigSearchInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageVarConfigSearchInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["configName"] = this.configName !== undefined ? this.configName : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }
}

export class UserCustomerRelationshipDto {
    userId!: number | null;
    countrySaleRelationIds!: string[] | null;
    isEnabled!: boolean;

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            if (Array.isArray(_data["countrySaleRelationIds"])) {
                this.countrySaleRelationIds = [] as any;
                for (let item of _data["countrySaleRelationIds"])
                    this.countrySaleRelationIds!.push(item);
            }
            else {
                this.countrySaleRelationIds = null as any;
            }
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : null as any;
        }
    }

    static fromJS(data: any): UserCustomerRelationshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCustomerRelationshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        if (Array.isArray(this.countrySaleRelationIds)) {
            data["countrySaleRelationIds"] = [];
            for (let item of this.countrySaleRelationIds)
                data["countrySaleRelationIds"].push(item);
        }
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        return data;
    }
}

export class UserCustomerRelationshipListDto {
    userName!: string | null;
    userEmail!: string | null;
    customerCode!: string | null;
    customerName!: string | null;
    userId!: number;
    isEnabled!: boolean;
    creator!: string | null;
    creationTime!: moment.Moment;
    modifier!: string | null;
    modificationTime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.userEmail = _data["userEmail"] !== undefined ? _data["userEmail"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : null as any;
            this.creator = _data["creator"] !== undefined ? _data["creator"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.modifier = _data["modifier"] !== undefined ? _data["modifier"] : null as any;
            this.modificationTime = _data["modificationTime"] ? moment(_data["modificationTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): UserCustomerRelationshipListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCustomerRelationshipListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["userEmail"] = this.userEmail !== undefined ? this.userEmail : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        data["creator"] = this.creator !== undefined ? this.creator : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["modifier"] = this.modifier !== undefined ? this.modifier : null as any;
        data["modificationTime"] = this.modificationTime ? this.modificationTime.toISOString() : null as any;
        return data;
    }
}

export class UserCustomerRelationshipListDtoPagedResultDto {
    items!: UserCustomerRelationshipListDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserCustomerRelationshipListDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): UserCustomerRelationshipListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCustomerRelationshipListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class VarConfigDto {
    /** 主键Id */
    id!: string;
    /** 变量名称 */
    configName!: string | null;
    /** 变量值 */
    configValue!: string | null;
    /** 描述 */
    description!: string | null;
    /** 创建人Id */
    creatorUserId!: number | null;
    /** 创建人 */
    creatorUserName!: string | null;
    /** 创建时间 */
    creationTime!: moment.Moment | null;
    readonly creationTimeStr!: string | null;
    /** 修改人Id */
    lastModifierUserId!: number | null;
    /** 修改人 */
    lastModifierUserName!: string | null;
    /** 修改时间 */
    lastModificationTime!: moment.Moment | null;
    readonly lastModificationTimeStr!: string | null;
    isInsert!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.configName = _data["configName"] !== undefined ? _data["configName"] : null as any;
            this.configValue = _data["configValue"] !== undefined ? _data["configValue"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.creatorUserName = _data["creatorUserName"] !== undefined ? _data["creatorUserName"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            (this as any).creationTimeStr = _data["creationTimeStr"] !== undefined ? _data["creationTimeStr"] : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.lastModifierUserName = _data["lastModifierUserName"] !== undefined ? _data["lastModifierUserName"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            (this as any).lastModificationTimeStr = _data["lastModificationTimeStr"] !== undefined ? _data["lastModificationTimeStr"] : null as any;
            this.isInsert = _data["isInsert"] !== undefined ? _data["isInsert"] : null as any;
        }
    }

    static fromJS(data: any): VarConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new VarConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["configName"] = this.configName !== undefined ? this.configName : null as any;
        data["configValue"] = this.configValue !== undefined ? this.configValue : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["creatorUserName"] = this.creatorUserName !== undefined ? this.creatorUserName : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creationTimeStr"] = this.creationTimeStr !== undefined ? this.creationTimeStr : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["lastModifierUserName"] = this.lastModifierUserName !== undefined ? this.lastModifierUserName : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModificationTimeStr"] = this.lastModificationTimeStr !== undefined ? this.lastModificationTimeStr : null as any;
        data["isInsert"] = this.isInsert !== undefined ? this.isInsert : null as any;
        return data;
    }
}

export class VarConfigDtoPagedResultDto {
    items!: VarConfigDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VarConfigDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): VarConfigDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VarConfigDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 新增详情页-新增关联价格表 */
export class AddCommonPriceSeriesDto {
    /** 公共价格表Id */
    commonPriceId!: string;
    /** 需要关联的价格表系列Id集合 */
    listPriceSeriesIds!: string[];

    init(_data?: any) {
        if (_data) {
            this.commonPriceId = _data["commonPriceId"] !== undefined ? _data["commonPriceId"] : null as any;
            if (Array.isArray(_data["listPriceSeriesIds"])) {
                this.listPriceSeriesIds = [] as any;
                for (let item of _data["listPriceSeriesIds"])
                    this.listPriceSeriesIds!.push(item);
            }
            else {
                this.listPriceSeriesIds = null as any;
            }
        }
    }

    static fromJS(data: any): AddCommonPriceSeriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddCommonPriceSeriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commonPriceId"] = this.commonPriceId !== undefined ? this.commonPriceId : null as any;
        if (Array.isArray(this.listPriceSeriesIds)) {
            data["listPriceSeriesIds"] = [];
            for (let item of this.listPriceSeriesIds)
                data["listPriceSeriesIds"].push(item);
        }
        return data;
    }
}

/** 审批状态枚举 1 = Approved (审批通过) 2 = Rejected (审批拒绝) 3 = Cancelled (已取消) */
export enum ApprovalStatus {
    NotApproved = 0,
    UnderApproval = 1,
    ApprovalPassed = 2,
    ApprovalFailed = 3,
    Archived = 4,
    WaitRelease = 5,
}

/** 1 = GCS (GCS) */
export enum AuthorizedUserType {
    GCS = 1,
}

/** 批量审批操作参数 */
export class BatchListPriceApprovalActionDto {
    /** 审批编号 */
    approvalNo!: string | null;
    /** 审批意见 */
    comments!: string | null;
    /** 备注 */
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.approvalNo = _data["approvalNo"] !== undefined ? _data["approvalNo"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): BatchListPriceApprovalActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchListPriceApprovalActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalNo"] = this.approvalNo !== undefined ? this.approvalNo : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

/** 批量修改主机参数 */
export class BatchModifyMotorInputDto {
    /** 面价表（系列版本）Id */
    listPriceSeriesId!: string;
    /** 勾选的明细Id；空=全量 */
    selectedMotorPriceIds!: string[] | null;
    /** 规则列表 */
    rules!: BatchModifyMotorRuleDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            if (Array.isArray(_data["selectedMotorPriceIds"])) {
                this.selectedMotorPriceIds = [] as any;
                for (let item of _data["selectedMotorPriceIds"])
                    this.selectedMotorPriceIds!.push(item);
            }
            else {
                this.selectedMotorPriceIds = null as any;
            }
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(BatchModifyMotorRuleDto.fromJS(item));
            }
            else {
                this.rules = null as any;
            }
        }
    }

    static fromJS(data: any): BatchModifyMotorInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchModifyMotorInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        if (Array.isArray(this.selectedMotorPriceIds)) {
            data["selectedMotorPriceIds"] = [];
            for (let item of this.selectedMotorPriceIds)
                data["selectedMotorPriceIds"].push(item);
        }
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 单条规则：字段 / 当前值 / 修改为 规则说明： - CurrentValue 有值：作为过滤条件 - CurrentValue 为空：不加条件（范围内全改） - CurrentValue = "-"：表示当前值为 NULL - NewValue 为空：忽略该规则（不修改） - basicMotorModel / basicMotorProductCode 额外支持 * 前缀后缀匹配替换：  * *XXX  = 按后缀匹配（找到以 XXX 结尾的），把结尾 XXX 替换为 NewValue  * XXX*  = 按前缀匹配（找到以 XXX 开头的），把开头 XXX 替换为 NewValue  * 无 *  = 精确匹配整体替换（默认，与其他字段一致）  * 多个 * 以第一个 * 为准 */
export class BatchModifyMotorRuleDto {
    field!: MotorBatchField;
    /** 有值=过滤；空=不过滤；"-"=NULL。
basicMotorModel/basicMotorProductCode 支持 *XXX(后缀) / XXX*(前缀) */
    currentValue!: string | null;
    /** 空=不修改该字段 */
    newValue!: string | null;

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"] !== undefined ? _data["field"] : null as any;
            this.currentValue = _data["currentValue"] !== undefined ? _data["currentValue"] : null as any;
            this.newValue = _data["newValue"] !== undefined ? _data["newValue"] : null as any;
        }
    }

    static fromJS(data: any): BatchModifyMotorRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchModifyMotorRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field !== undefined ? this.field : null as any;
        data["currentValue"] = this.currentValue !== undefined ? this.currentValue : null as any;
        data["newValue"] = this.newValue !== undefined ? this.newValue : null as any;
        return data;
    }
}

/** 批量修改价格 */
export class BatchModifyPriceInputDto {
    /** 面价表（系列版本）Id */
    listPriceSeriesId!: string;
    /** 是否修改电机面价（是/否） */
    modifyMotor!: boolean;
    /** 是否修改VC面价（是/否） */
    modifyVC!: boolean;
    /** VC 机座号列表（VCFrameNumber，如 "71"）
- 传了：只改这些机座号
- 不传/空：默认改全部（仍以 VcDetailIds 为范围） */
    vcFrameNumbers!: string[] | null;
    operator!: PriceAdjustOperator;
    /** 参数：乘法为系数；加法为增量（可负） */
    value!: number;
    /** 电机明细Id集合（ListPriceBasicMotorPrice.Id） */
    motorDetailIds!: string[] | null;
    /** VC明细Id集合（ListPriceVCPrice.Id） */
    vcDetailIds!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.modifyMotor = _data["modifyMotor"] !== undefined ? _data["modifyMotor"] : null as any;
            this.modifyVC = _data["modifyVC"] !== undefined ? _data["modifyVC"] : null as any;
            if (Array.isArray(_data["vcFrameNumbers"])) {
                this.vcFrameNumbers = [] as any;
                for (let item of _data["vcFrameNumbers"])
                    this.vcFrameNumbers!.push(item);
            }
            else {
                this.vcFrameNumbers = null as any;
            }
            this.operator = _data["operator"] !== undefined ? _data["operator"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            if (Array.isArray(_data["motorDetailIds"])) {
                this.motorDetailIds = [] as any;
                for (let item of _data["motorDetailIds"])
                    this.motorDetailIds!.push(item);
            }
            else {
                this.motorDetailIds = null as any;
            }
            if (Array.isArray(_data["vcDetailIds"])) {
                this.vcDetailIds = [] as any;
                for (let item of _data["vcDetailIds"])
                    this.vcDetailIds!.push(item);
            }
            else {
                this.vcDetailIds = null as any;
            }
        }
    }

    static fromJS(data: any): BatchModifyPriceInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchModifyPriceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["modifyMotor"] = this.modifyMotor !== undefined ? this.modifyMotor : null as any;
        data["modifyVC"] = this.modifyVC !== undefined ? this.modifyVC : null as any;
        if (Array.isArray(this.vcFrameNumbers)) {
            data["vcFrameNumbers"] = [];
            for (let item of this.vcFrameNumbers)
                data["vcFrameNumbers"].push(item);
        }
        data["operator"] = this.operator !== undefined ? this.operator : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        if (Array.isArray(this.motorDetailIds)) {
            data["motorDetailIds"] = [];
            for (let item of this.motorDetailIds)
                data["motorDetailIds"].push(item);
        }
        if (Array.isArray(this.vcDetailIds)) {
            data["vcDetailIds"] = [];
            for (let item of this.vcDetailIds)
                data["vcDetailIds"].push(item);
        }
        return data;
    }
}

/** 批量保存面价备注Dto */
export class BatchSaveListPriceRemarkDto {
    /** 面价表Id（为空表示默认备注） */
    listPriceSeriesId!: string | null;
    /** 主机备注列表 */
    motorRemarks!: RemarkItemDto[] | null;
    /** VC备注列表 */
    vcRemarks!: RemarkItemDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            if (Array.isArray(_data["motorRemarks"])) {
                this.motorRemarks = [] as any;
                for (let item of _data["motorRemarks"])
                    this.motorRemarks!.push(RemarkItemDto.fromJS(item));
            }
            else {
                this.motorRemarks = null as any;
            }
            if (Array.isArray(_data["vcRemarks"])) {
                this.vcRemarks = [] as any;
                for (let item of _data["vcRemarks"])
                    this.vcRemarks!.push(RemarkItemDto.fromJS(item));
            }
            else {
                this.vcRemarks = null as any;
            }
        }
    }

    static fromJS(data: any): BatchSaveListPriceRemarkDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchSaveListPriceRemarkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        if (Array.isArray(this.motorRemarks)) {
            data["motorRemarks"] = [];
            for (let item of this.motorRemarks)
                data["motorRemarks"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.vcRemarks)) {
            data["vcRemarks"] = [];
            for (let item of this.vcRemarks)
                data["vcRemarks"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 批量同步主机参数Dto */
export class BatchSyncBasicMotorParamDto {
    /** 参数Id（有值则更新，无值则新增） */
    id!: string | null;
    /** 能效 */
    eneEff!: string | null;
    /** 频率 */
    frequency!: string | null;
    /** 极数 */
    poleNo!: string | null;
    /** 功率 */
    power!: string | null;
    /** 电压 */
    voltage!: string | null;
    /** 绝缘等级 */
    insulation!: string | null;
    /** 安全防护等级 */
    safty!: string | null;
    /** 接线方式 */
    wiringMode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.insulation = _data["insulation"] !== undefined ? _data["insulation"] : null as any;
            this.safty = _data["safty"] !== undefined ? _data["safty"] : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
        }
    }

    static fromJS(data: any): BatchSyncBasicMotorParamDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchSyncBasicMotorParamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["insulation"] = this.insulation !== undefined ? this.insulation : null as any;
        data["safty"] = this.safty !== undefined ? this.safty : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        return data;
    }
}

/** 批量同步主机参数项Dto */
export class BatchSyncBasicMotorParamItemDto {
    /** 主机Id */
    listPriceBasicMotorPriceId!: string;
    /** 主机参数列表 */
    basicMotorParams!: BatchSyncBasicMotorParamDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceBasicMotorPriceId = _data["listPriceBasicMotorPriceId"] !== undefined ? _data["listPriceBasicMotorPriceId"] : null as any;
            if (Array.isArray(_data["basicMotorParams"])) {
                this.basicMotorParams = [] as any;
                for (let item of _data["basicMotorParams"])
                    this.basicMotorParams!.push(BatchSyncBasicMotorParamDto.fromJS(item));
            }
            else {
                this.basicMotorParams = null as any;
            }
        }
    }

    static fromJS(data: any): BatchSyncBasicMotorParamItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchSyncBasicMotorParamItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceBasicMotorPriceId"] = this.listPriceBasicMotorPriceId !== undefined ? this.listPriceBasicMotorPriceId : null as any;
        if (Array.isArray(this.basicMotorParams)) {
            data["basicMotorParams"] = [];
            for (let item of this.basicMotorParams)
                data["basicMotorParams"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 批量同步主机参数Dto（供第三方调用） */
export class BatchSyncBasicMotorParamsDto {
    /** 主机参数列表 */
    items!: BatchSyncBasicMotorParamItemDto[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BatchSyncBasicMotorParamItemDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): BatchSyncBasicMotorParamsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchSyncBasicMotorParamsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 批量同步失败项Dto */
export class BatchSyncFailItemDto {
    /** 主机Id */
    listPriceBasicMotorPriceId!: string;
    /** 错误信息 */
    errorMessage!: string | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceBasicMotorPriceId = _data["listPriceBasicMotorPriceId"] !== undefined ? _data["listPriceBasicMotorPriceId"] : null as any;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : null as any;
        }
    }

    static fromJS(data: any): BatchSyncFailItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchSyncFailItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceBasicMotorPriceId"] = this.listPriceBasicMotorPriceId !== undefined ? this.listPriceBasicMotorPriceId : null as any;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null as any;
        return data;
    }
}

/** 批量同步结果Dto */
export class BatchSyncResultDto {
    /** 成功数量 */
    successCount!: number;
    /** 失败数量 */
    failCount!: number;
    /** 失败详情 */
    failItems!: BatchSyncFailItemDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.successCount = _data["successCount"] !== undefined ? _data["successCount"] : null as any;
            this.failCount = _data["failCount"] !== undefined ? _data["failCount"] : null as any;
            if (Array.isArray(_data["failItems"])) {
                this.failItems = [] as any;
                for (let item of _data["failItems"])
                    this.failItems!.push(BatchSyncFailItemDto.fromJS(item));
            }
            else {
                this.failItems = null as any;
            }
        }
    }

    static fromJS(data: any): BatchSyncResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchSyncResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["successCount"] = this.successCount !== undefined ? this.successCount : null as any;
        data["failCount"] = this.failCount !== undefined ? this.failCount : null as any;
        if (Array.isArray(this.failItems)) {
            data["failItems"] = [];
            for (let item of this.failItems)
                data["failItems"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 主机绑定内含VC */
export class BindJINCodeVCInputDto {
    /** 境界Id */
    listPriceJINSeriesId!: string;
    /** 主机集合（每个主机可绑定各自的 VC 集合，一次调用支持多主机） */
    motors!: BindJINCodeVCMotorInputDto[];
    gcs!: BindJINGCSInputDto;

    init(_data?: any) {
        if (_data) {
            this.listPriceJINSeriesId = _data["listPriceJINSeriesId"] !== undefined ? _data["listPriceJINSeriesId"] : null as any;
            if (Array.isArray(_data["motors"])) {
                this.motors = [] as any;
                for (let item of _data["motors"])
                    this.motors!.push(BindJINCodeVCMotorInputDto.fromJS(item));
            }
            else {
                this.motors = null as any;
            }
            this.gcs = _data["gcs"] ? BindJINGCSInputDto.fromJS(_data["gcs"]) : null as any;
        }
    }

    static fromJS(data: any): BindJINCodeVCInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BindJINCodeVCInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceJINSeriesId"] = this.listPriceJINSeriesId !== undefined ? this.listPriceJINSeriesId : null as any;
        if (Array.isArray(this.motors)) {
            data["motors"] = [];
            for (let item of this.motors)
                data["motors"].push(item ? item.toJSON() : null as any);
        }
        data["gcs"] = this.gcs ? this.gcs.toJSON() : null as any;
        return data;
    }
}

/** 主机绑定内含VC子项 */
export class BindJINCodeVCItemInputDto {
    /** 电机代码 */
    motorCode!: string | null;
    /** JIN代码 */
    jinCode!: string | null;
    /** VC代码 */
    vcCode!: string;
    /** 备注 */
    remark!: string | null;
    /** VC类型 */
    vcType!: number;
    /** VC显示类型 */
    vcShowType!: number;

    init(_data?: any) {
        if (_data) {
            this.motorCode = _data["motorCode"] !== undefined ? _data["motorCode"] : null as any;
            this.jinCode = _data["jinCode"] !== undefined ? _data["jinCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
        }
    }

    static fromJS(data: any): BindJINCodeVCItemInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BindJINCodeVCItemInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["motorCode"] = this.motorCode !== undefined ? this.motorCode : null as any;
        data["jinCode"] = this.jinCode !== undefined ? this.jinCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        return data;
    }
}

/** 单台主机绑定内含VC（主机Id + 其 VC 子项集合） */
export class BindJINCodeVCMotorInputDto {
    /** 主机Id */
    listPriceBasicMotorPriceId!: string;
    /** VC子项集合（空集合表示清空该主机所有内含VC） */
    items!: BindJINCodeVCItemInputDto[];

    init(_data?: any) {
        if (_data) {
            this.listPriceBasicMotorPriceId = _data["listPriceBasicMotorPriceId"] !== undefined ? _data["listPriceBasicMotorPriceId"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BindJINCodeVCItemInputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): BindJINCodeVCMotorInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BindJINCodeVCMotorInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceBasicMotorPriceId"] = this.listPriceBasicMotorPriceId !== undefined ? this.listPriceBasicMotorPriceId : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** GCS信息入参 */
export class BindJINGCSInputDto {
    /** 备注 */
    remark!: string | null;
    /** 附件地址集合 */
    attachmentUrls!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            if (Array.isArray(_data["attachmentUrls"])) {
                this.attachmentUrls = [] as any;
                for (let item of _data["attachmentUrls"])
                    this.attachmentUrls!.push(item);
            }
            else {
                this.attachmentUrls = null as any;
            }
        }
    }

    static fromJS(data: any): BindJINGCSInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BindJINGCSInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        if (Array.isArray(this.attachmentUrls)) {
            data["attachmentUrls"] = [];
            for (let item of this.attachmentUrls)
                data["attachmentUrls"].push(item);
        }
        return data;
    }
}

/** 审批产品列表 */
export class CheckApprovalProducts {
    /** lectoType产品Id */
    lectoTypeProductId!: string | null;
    /** 单价 */
    unitPrice!: number;
    /** 基础主机代码 */
    basicMotorCode!: string | null;
    /** 基础主机系列 */
    basicMotorSeries!: string | null;
    /** 基础主机型号 */
    basicMotorModel!: string | null;
    /** 基础主机安装方式 */
    basicMotorMounting!: string | null;
    /** 极数 */
    poleNo!: string | null;
    /** 电压 */
    voltage!: string | null;
    /** 机座号 */
    frameNo!: number | null;
    /** 功率 */
    power!: string | null;
    /** 编码器 */
    encoder!: string | null;
    /** 频率 */
    frequency!: string | null;
    /** JIN分类代码 */
    jinCategoryCode!: string | null;
    /** JIN电机代码 */
    jinMotorCode!: string | null;
    /** JIN电机代码 */
    jinMotorProductCode!: string | null;
    /** JIN版本 */
    jinVersion!: string | null;

    init(_data?: any) {
        if (_data) {
            this.lectoTypeProductId = _data["lectoTypeProductId"] !== undefined ? _data["lectoTypeProductId"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSeries = _data["basicMotorSeries"] !== undefined ? _data["basicMotorSeries"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.encoder = _data["encoder"] !== undefined ? _data["encoder"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinMotorCode = _data["jinMotorCode"] !== undefined ? _data["jinMotorCode"] : null as any;
            this.jinMotorProductCode = _data["jinMotorProductCode"] !== undefined ? _data["jinMotorProductCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
        }
    }

    static fromJS(data: any): CheckApprovalProducts {
        data = typeof data === 'object' ? data : {};
        let result = new CheckApprovalProducts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lectoTypeProductId"] = this.lectoTypeProductId !== undefined ? this.lectoTypeProductId : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSeries"] = this.basicMotorSeries !== undefined ? this.basicMotorSeries : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["encoder"] = this.encoder !== undefined ? this.encoder : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinMotorCode"] = this.jinMotorCode !== undefined ? this.jinMotorCode : null as any;
        data["jinMotorProductCode"] = this.jinMotorProductCode !== undefined ? this.jinMotorProductCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        return data;
    }
}

/** 检查审批是否结束 */
export class CheckApprovalStatusOutDto {
    /** 是否通过 */
    isApproved!: boolean;
    /** 是否批量审批 */
    isBatchApproval!: boolean;
    /** 是否一次性项目 */
    isOneTime!: boolean;
    /** 是否替换选型 */
    isReplaceSelection!: boolean;
    /** 分类代码 */
    categoryCode!: string | null;
    /** 场景代码 */
    scenarioCode!: string | null;
    /** 场景代码 */
    userFriendlyId!: string | null;
    /** 境界表Id */
    listPriceJINSeriesId!: string | null;
    scenarioType!: ScenarioType;
    /** PMS项目编号 */
    pmsProjectCode!: string | null;
    /** 产品 */
    products!: CheckApprovalProducts[] | null;

    init(_data?: any) {
        if (_data) {
            this.isApproved = _data["isApproved"] !== undefined ? _data["isApproved"] : null as any;
            this.isBatchApproval = _data["isBatchApproval"] !== undefined ? _data["isBatchApproval"] : null as any;
            this.isOneTime = _data["isOneTime"] !== undefined ? _data["isOneTime"] : null as any;
            this.isReplaceSelection = _data["isReplaceSelection"] !== undefined ? _data["isReplaceSelection"] : null as any;
            this.categoryCode = _data["categoryCode"] !== undefined ? _data["categoryCode"] : null as any;
            this.scenarioCode = _data["scenarioCode"] !== undefined ? _data["scenarioCode"] : null as any;
            this.userFriendlyId = _data["userFriendlyId"] !== undefined ? _data["userFriendlyId"] : null as any;
            this.listPriceJINSeriesId = _data["listPriceJINSeriesId"] !== undefined ? _data["listPriceJINSeriesId"] : null as any;
            this.scenarioType = _data["scenarioType"] !== undefined ? _data["scenarioType"] : null as any;
            this.pmsProjectCode = _data["pmsProjectCode"] !== undefined ? _data["pmsProjectCode"] : null as any;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(CheckApprovalProducts.fromJS(item));
            }
            else {
                this.products = null as any;
            }
        }
    }

    static fromJS(data: any): CheckApprovalStatusOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckApprovalStatusOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isApproved"] = this.isApproved !== undefined ? this.isApproved : null as any;
        data["isBatchApproval"] = this.isBatchApproval !== undefined ? this.isBatchApproval : null as any;
        data["isOneTime"] = this.isOneTime !== undefined ? this.isOneTime : null as any;
        data["isReplaceSelection"] = this.isReplaceSelection !== undefined ? this.isReplaceSelection : null as any;
        data["categoryCode"] = this.categoryCode !== undefined ? this.categoryCode : null as any;
        data["scenarioCode"] = this.scenarioCode !== undefined ? this.scenarioCode : null as any;
        data["userFriendlyId"] = this.userFriendlyId !== undefined ? this.userFriendlyId : null as any;
        data["listPriceJINSeriesId"] = this.listPriceJINSeriesId !== undefined ? this.listPriceJINSeriesId : null as any;
        data["scenarioType"] = this.scenarioType !== undefined ? this.scenarioType : null as any;
        data["pmsProjectCode"] = this.pmsProjectCode !== undefined ? this.pmsProjectCode : null as any;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 判断当前登录人是否有审批权限 */
export class CheckListPriceApprovalPermissionDto {
    /** 面价表Id */
    listPriceSeriesId!: string | null;
    /** 审批实例Id */
    approvalInstanceId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.approvalInstanceId = _data["approvalInstanceId"] !== undefined ? _data["approvalInstanceId"] : null as any;
        }
    }

    static fromJS(data: any): CheckListPriceApprovalPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckListPriceApprovalPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["approvalInstanceId"] = this.approvalInstanceId !== undefined ? this.approvalInstanceId : null as any;
        return data;
    }
}

/** 0 = Empty 1 = SerialNumber */
export enum CodeCodingRuleType {
    Empty = 0,
    SerialNumber = 1,
}

/** 对外创建项目型境界面价表 - 主机明细 */
export class CreateExternalJINMotorDto {
    /** 主机id */
    lectoTypeProductld!: string | null;
    /** 外部传入的主机序号 */
    serialNo!: string;
    /** 安装方式名称 */
    mountingName!: string;
    /** 安装方式对应编号 */
    mountingCorrespondingNo!: string | null;
    /** 境界主机产品代码 */
    basicMotorProductCode!: string;
    /** 境界主机型号 */
    basicMotorModel!: string;
    /** 基础主机代码 */
    basedMotorCode!: string | null;
    /** 基础主机型号 */
    basedMotorModel!: string | null;
    /** 功率 */
    basicMotorRateOfWork!: string | null;
    /** 极数 */
    basicMotorSeries!: string | null;
    /** 转速 */
    basicMotorSpeed!: string | null;
    /** 主机价格 */
    basicMotorPrice!: string | null;
    /** 主机备注 */
    basicMotorRemark!: string | null;
    /** 主机设计类型 */
    basicMotorDesignType!: string | null;
    /** 主机产品代码展示值 */
    basicMotorProductCodeExhibition!: string | null;
    /** 机座号 */
    frameNumber!: number | null;
    /** 是否启用 */
    isEnabled!: boolean;
    /** 是否对外发布 */
    isReleased!: boolean;
    /** A/B面价系数
默认为 1。 */
    listPriceMultiplier!: number;
    /** 接线方式 */
    wiringMode!: string | null;
    /** 频率 */
    frequency!: string | null;
    /** 能效 */
    eneEff!: string | null;
    /** 电压 */
    voltage!: string | null;
    /** 绝缘等级 */
    insulation!: string | null;
    /** 防护等级 */
    safty!: string | null;
    /** 铭牌 */
    typeDesignation!: string | null;
    /** 国产报价号 */
    domesticQuotationNumber!: string | null;
    /** 国产报价号编号 */
    domesticQuotationNumberCode!: string | null;
    /** 主机内含VC
说明：
1. 这是“主机绑定的内含VC”；
2. 不是可选VC；
3. 若无内含VC，可传空集合。 */
    innerVCs!: CreateExternalJINMotorInnerVcDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.lectoTypeProductld = _data["lectoTypeProductld"] !== undefined ? _data["lectoTypeProductld"] : null as any;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : null as any;
            this.mountingName = _data["mountingName"] !== undefined ? _data["mountingName"] : null as any;
            this.mountingCorrespondingNo = _data["mountingCorrespondingNo"] !== undefined ? _data["mountingCorrespondingNo"] : null as any;
            this.basicMotorProductCode = _data["basicMotorProductCode"] !== undefined ? _data["basicMotorProductCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basedMotorCode = _data["basedMotorCode"] !== undefined ? _data["basedMotorCode"] : null as any;
            this.basedMotorModel = _data["basedMotorModel"] !== undefined ? _data["basedMotorModel"] : null as any;
            this.basicMotorRateOfWork = _data["basicMotorRateOfWork"] !== undefined ? _data["basicMotorRateOfWork"] : null as any;
            this.basicMotorSeries = _data["basicMotorSeries"] !== undefined ? _data["basicMotorSeries"] : null as any;
            this.basicMotorSpeed = _data["basicMotorSpeed"] !== undefined ? _data["basicMotorSpeed"] : null as any;
            this.basicMotorPrice = _data["basicMotorPrice"] !== undefined ? _data["basicMotorPrice"] : null as any;
            this.basicMotorRemark = _data["basicMotorRemark"] !== undefined ? _data["basicMotorRemark"] : null as any;
            this.basicMotorDesignType = _data["basicMotorDesignType"] !== undefined ? _data["basicMotorDesignType"] : null as any;
            this.basicMotorProductCodeExhibition = _data["basicMotorProductCodeExhibition"] !== undefined ? _data["basicMotorProductCodeExhibition"] : null as any;
            this.frameNumber = _data["frameNumber"] !== undefined ? _data["frameNumber"] : null as any;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : null as any;
            this.isReleased = _data["isReleased"] !== undefined ? _data["isReleased"] : null as any;
            this.listPriceMultiplier = _data["listPriceMultiplier"] !== undefined ? _data["listPriceMultiplier"] : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.insulation = _data["insulation"] !== undefined ? _data["insulation"] : null as any;
            this.safty = _data["safty"] !== undefined ? _data["safty"] : null as any;
            this.typeDesignation = _data["typeDesignation"] !== undefined ? _data["typeDesignation"] : null as any;
            this.domesticQuotationNumber = _data["domesticQuotationNumber"] !== undefined ? _data["domesticQuotationNumber"] : null as any;
            this.domesticQuotationNumberCode = _data["domesticQuotationNumberCode"] !== undefined ? _data["domesticQuotationNumberCode"] : null as any;
            if (Array.isArray(_data["innerVCs"])) {
                this.innerVCs = [] as any;
                for (let item of _data["innerVCs"])
                    this.innerVCs!.push(CreateExternalJINMotorInnerVcDto.fromJS(item));
            }
            else {
                this.innerVCs = null as any;
            }
        }
    }

    static fromJS(data: any): CreateExternalJINMotorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExternalJINMotorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lectoTypeProductld"] = this.lectoTypeProductld !== undefined ? this.lectoTypeProductld : null as any;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : null as any;
        data["mountingName"] = this.mountingName !== undefined ? this.mountingName : null as any;
        data["mountingCorrespondingNo"] = this.mountingCorrespondingNo !== undefined ? this.mountingCorrespondingNo : null as any;
        data["basicMotorProductCode"] = this.basicMotorProductCode !== undefined ? this.basicMotorProductCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basedMotorCode"] = this.basedMotorCode !== undefined ? this.basedMotorCode : null as any;
        data["basedMotorModel"] = this.basedMotorModel !== undefined ? this.basedMotorModel : null as any;
        data["basicMotorRateOfWork"] = this.basicMotorRateOfWork !== undefined ? this.basicMotorRateOfWork : null as any;
        data["basicMotorSeries"] = this.basicMotorSeries !== undefined ? this.basicMotorSeries : null as any;
        data["basicMotorSpeed"] = this.basicMotorSpeed !== undefined ? this.basicMotorSpeed : null as any;
        data["basicMotorPrice"] = this.basicMotorPrice !== undefined ? this.basicMotorPrice : null as any;
        data["basicMotorRemark"] = this.basicMotorRemark !== undefined ? this.basicMotorRemark : null as any;
        data["basicMotorDesignType"] = this.basicMotorDesignType !== undefined ? this.basicMotorDesignType : null as any;
        data["basicMotorProductCodeExhibition"] = this.basicMotorProductCodeExhibition !== undefined ? this.basicMotorProductCodeExhibition : null as any;
        data["frameNumber"] = this.frameNumber !== undefined ? this.frameNumber : null as any;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        data["isReleased"] = this.isReleased !== undefined ? this.isReleased : null as any;
        data["listPriceMultiplier"] = this.listPriceMultiplier !== undefined ? this.listPriceMultiplier : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["insulation"] = this.insulation !== undefined ? this.insulation : null as any;
        data["safty"] = this.safty !== undefined ? this.safty : null as any;
        data["typeDesignation"] = this.typeDesignation !== undefined ? this.typeDesignation : null as any;
        data["domesticQuotationNumber"] = this.domesticQuotationNumber !== undefined ? this.domesticQuotationNumber : null as any;
        data["domesticQuotationNumberCode"] = this.domesticQuotationNumberCode !== undefined ? this.domesticQuotationNumberCode : null as any;
        if (Array.isArray(this.innerVCs)) {
            data["innerVCs"] = [];
            for (let item of this.innerVCs)
                data["innerVCs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 对外创建项目型境界面价表 - 主机内含VC */
export class CreateExternalJINMotorInnerVcDto {
    /** 基础主机代码 */
    motorCode!: string | null;
    /** 境界主机代码 */
    jinCode!: string | null;
    /** VC代码 */
    vcCode!: string;
    /** 备注 */
    remark!: string | null;
    /** VC类型 */
    vcType!: number;
    /** VC展示类型 */
    vcShowType!: number;
    /** VC价格 */
    vcPrice!: string | null;

    init(_data?: any) {
        if (_data) {
            this.motorCode = _data["motorCode"] !== undefined ? _data["motorCode"] : null as any;
            this.jinCode = _data["jinCode"] !== undefined ? _data["jinCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.vcPrice = _data["vcPrice"] !== undefined ? _data["vcPrice"] : null as any;
        }
    }

    static fromJS(data: any): CreateExternalJINMotorInnerVcDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExternalJINMotorInnerVcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["motorCode"] = this.motorCode !== undefined ? this.motorCode : null as any;
        data["jinCode"] = this.jinCode !== undefined ? this.jinCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["vcPrice"] = this.vcPrice !== undefined ? this.vcPrice : null as any;
        return data;
    }
}

/** 对外创建项目型境界面价表入参 */
export class CreateExternalProjectJINSeriesDto {
    /** 面价平台Id */
    listPricePlatFormId!: string;
    /** 系列名称 */
    seriesName!: string;
    /** 系列描述 */
    seriesDescribe!: string | null;
    /** 系列版本生效时间 */
    seriesVersionsTakeEffectTime!: moment.Moment;
    /** 系列版本描述 */
    seriesVersionsDescribe!: string | null;
    /** 系列VC长代码类型 */
    seriesVCType!: string | null;
    /** 是否隐藏 */
    isHidden!: boolean;
    /** 是否仅发布 */
    isPublishOnly!: boolean;
    /** 封面文件地址 */
    coverFileUrl!: string | null;
    /** 是否有VC */
    hasVCs!: boolean;
    /** 是否可携带VC */
    canCarryVCs!: boolean;
    /** 报价原则 */
    quotationPrinciple!: string | null;
    discountType!: ListPriceDiscountType;
    /** PMS项目号 */
    pmsProjectCode!: string | null;
    /** 项目型场景代码 */
    scenarioCode!: string | null;
    /** 项目型场景代码 */
    userFriendlyId!: string | null;
    /** Precal号 */
    precalNo!: string | null;
    /** 证书管理 */
    certificateAdmin!: string | null;
    codeCodingRule!: CodeCodingRuleType;
    modelCodingRule!: ModelCodingRuleType;
    /** 客户列表
不传表示未绑定客户。 */
    customers!: ExternalJINSeriesCustomerDto[] | null;
    /** 授权用户
外部若不维护授权用户，可不传。 */
    authorizedUsers!: ExternalJINAuthorizedUserDto[] | null;
    /** 主机明细 */
    motors!: CreateExternalJINMotorDto[];

    init(_data?: any) {
        if (_data) {
            this.listPricePlatFormId = _data["listPricePlatFormId"] !== undefined ? _data["listPricePlatFormId"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
            this.seriesDescribe = _data["seriesDescribe"] !== undefined ? _data["seriesDescribe"] : null as any;
            this.seriesVersionsTakeEffectTime = _data["seriesVersionsTakeEffectTime"] ? moment(_data["seriesVersionsTakeEffectTime"].toString()) : null as any;
            this.seriesVersionsDescribe = _data["seriesVersionsDescribe"] !== undefined ? _data["seriesVersionsDescribe"] : null as any;
            this.seriesVCType = _data["seriesVCType"] !== undefined ? _data["seriesVCType"] : null as any;
            this.isHidden = _data["isHidden"] !== undefined ? _data["isHidden"] : null as any;
            this.isPublishOnly = _data["isPublishOnly"] !== undefined ? _data["isPublishOnly"] : null as any;
            this.coverFileUrl = _data["coverFileUrl"] !== undefined ? _data["coverFileUrl"] : null as any;
            this.hasVCs = _data["hasVCs"] !== undefined ? _data["hasVCs"] : null as any;
            this.canCarryVCs = _data["canCarryVCs"] !== undefined ? _data["canCarryVCs"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : null as any;
            this.pmsProjectCode = _data["pmsProjectCode"] !== undefined ? _data["pmsProjectCode"] : null as any;
            this.scenarioCode = _data["scenarioCode"] !== undefined ? _data["scenarioCode"] : null as any;
            this.userFriendlyId = _data["userFriendlyId"] !== undefined ? _data["userFriendlyId"] : null as any;
            this.precalNo = _data["precalNo"] !== undefined ? _data["precalNo"] : null as any;
            this.certificateAdmin = _data["certificateAdmin"] !== undefined ? _data["certificateAdmin"] : null as any;
            this.codeCodingRule = _data["codeCodingRule"] !== undefined ? _data["codeCodingRule"] : null as any;
            this.modelCodingRule = _data["modelCodingRule"] !== undefined ? _data["modelCodingRule"] : null as any;
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(ExternalJINSeriesCustomerDto.fromJS(item));
            }
            else {
                this.customers = null as any;
            }
            if (Array.isArray(_data["authorizedUsers"])) {
                this.authorizedUsers = [] as any;
                for (let item of _data["authorizedUsers"])
                    this.authorizedUsers!.push(ExternalJINAuthorizedUserDto.fromJS(item));
            }
            else {
                this.authorizedUsers = null as any;
            }
            if (Array.isArray(_data["motors"])) {
                this.motors = [] as any;
                for (let item of _data["motors"])
                    this.motors!.push(CreateExternalJINMotorDto.fromJS(item));
            }
            else {
                this.motors = null as any;
            }
        }
    }

    static fromJS(data: any): CreateExternalProjectJINSeriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExternalProjectJINSeriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPricePlatFormId"] = this.listPricePlatFormId !== undefined ? this.listPricePlatFormId : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        data["seriesDescribe"] = this.seriesDescribe !== undefined ? this.seriesDescribe : null as any;
        data["seriesVersionsTakeEffectTime"] = this.seriesVersionsTakeEffectTime ? this.seriesVersionsTakeEffectTime.toISOString() : null as any;
        data["seriesVersionsDescribe"] = this.seriesVersionsDescribe !== undefined ? this.seriesVersionsDescribe : null as any;
        data["seriesVCType"] = this.seriesVCType !== undefined ? this.seriesVCType : null as any;
        data["isHidden"] = this.isHidden !== undefined ? this.isHidden : null as any;
        data["isPublishOnly"] = this.isPublishOnly !== undefined ? this.isPublishOnly : null as any;
        data["coverFileUrl"] = this.coverFileUrl !== undefined ? this.coverFileUrl : null as any;
        data["hasVCs"] = this.hasVCs !== undefined ? this.hasVCs : null as any;
        data["canCarryVCs"] = this.canCarryVCs !== undefined ? this.canCarryVCs : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["discountType"] = this.discountType !== undefined ? this.discountType : null as any;
        data["pmsProjectCode"] = this.pmsProjectCode !== undefined ? this.pmsProjectCode : null as any;
        data["scenarioCode"] = this.scenarioCode !== undefined ? this.scenarioCode : null as any;
        data["userFriendlyId"] = this.userFriendlyId !== undefined ? this.userFriendlyId : null as any;
        data["precalNo"] = this.precalNo !== undefined ? this.precalNo : null as any;
        data["certificateAdmin"] = this.certificateAdmin !== undefined ? this.certificateAdmin : null as any;
        data["codeCodingRule"] = this.codeCodingRule !== undefined ? this.codeCodingRule : null as any;
        data["modelCodingRule"] = this.modelCodingRule !== undefined ? this.modelCodingRule : null as any;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.authorizedUsers)) {
            data["authorizedUsers"] = [];
            for (let item of this.authorizedUsers)
                data["authorizedUsers"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.motors)) {
            data["motors"] = [];
            for (let item of this.motors)
                data["motors"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 对外创建项目型境界面价表 - 返回结果 */
export class CreateExternalProjectJINSeriesResultDto {
    /** 境界表Id */
    listPriceJINSeriesId!: string;
    /** 标准面价Id */
    listPriceSeriesId!: string;
    /** 主机明细列表 */
    motors!: CreateExternalProjectMotorResultDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceJINSeriesId = _data["listPriceJINSeriesId"] !== undefined ? _data["listPriceJINSeriesId"] : null as any;
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            if (Array.isArray(_data["motors"])) {
                this.motors = [] as any;
                for (let item of _data["motors"])
                    this.motors!.push(CreateExternalProjectMotorResultDto.fromJS(item));
            }
            else {
                this.motors = null as any;
            }
        }
    }

    static fromJS(data: any): CreateExternalProjectJINSeriesResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExternalProjectJINSeriesResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceJINSeriesId"] = this.listPriceJINSeriesId !== undefined ? this.listPriceJINSeriesId : null as any;
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        if (Array.isArray(this.motors)) {
            data["motors"] = [];
            for (let item of this.motors)
                data["motors"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 对外创建项目型境界面价表 - 主机明细返回结果 */
export class CreateExternalProjectMotorResultDto {
    /** 主机明细Id */
    listPriceBasicMotorPriceId!: string;
    /** 主机产品标识 */
    lectoTypeProductId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceBasicMotorPriceId = _data["listPriceBasicMotorPriceId"] !== undefined ? _data["listPriceBasicMotorPriceId"] : null as any;
            this.lectoTypeProductId = _data["lectoTypeProductId"] !== undefined ? _data["lectoTypeProductId"] : null as any;
        }
    }

    static fromJS(data: any): CreateExternalProjectMotorResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExternalProjectMotorResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceBasicMotorPriceId"] = this.listPriceBasicMotorPriceId !== undefined ? this.listPriceBasicMotorPriceId : null as any;
        data["lectoTypeProductId"] = this.lectoTypeProductId !== undefined ? this.lectoTypeProductId : null as any;
        return data;
    }
}

/** 创建主机入参 */
export class CreateMotorInputDto {
    /** 面价表Id */
    listPriceSeriesId!: string;
    /** 主机产品代码 */
    basicMotorProductCode!: string | null;
    /** 主机功率 */
    basicMotorRateOfWork!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 主机极数 */
    basicMotorSeries!: string | null;
    /** 转速 */
    basicMotorSpeed!: string | null;
    /** 主机价格 */
    basicMotorPrice!: string | null;
    /** 主机备注 */
    basicMotorRemark!: string | null;
    /** 主机设计类型 */
    basicMotorDesignType!: string | null;
    /** 安装方式名称 */
    mountingName!: string | null;
    /** 机座号 */
    frameNumber!: number;
    /** 接线方式 */
    wiringMode!: string | null;
    /** 频率 */
    frequency!: string | null;
    /** 能效 */
    eneEff!: string | null;
    /** 电压 */
    voltage!: string | null;
    /** 绝缘等级 */
    insulation!: string | null;
    /** 防护等级 */
    safty!: string | null;
    /** 铭牌 */
    typeDesignation!: string | null;
    /** 是否启用 */
    isEnabled!: boolean;
    /** 是否对外发布 */
    isReleased!: boolean;
    /** 面价系数 */
    listPriceMultiplier!: number;
    /** 基础主机代码（用于自动计算系数） */
    basedMotorCode!: string | null;
    /** 基础主机型号（用于生成 JIN 型号，与 BasedMotorCode 配对） */
    basedMotorModel!: string | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.basicMotorProductCode = _data["basicMotorProductCode"] !== undefined ? _data["basicMotorProductCode"] : null as any;
            this.basicMotorRateOfWork = _data["basicMotorRateOfWork"] !== undefined ? _data["basicMotorRateOfWork"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorSeries = _data["basicMotorSeries"] !== undefined ? _data["basicMotorSeries"] : null as any;
            this.basicMotorSpeed = _data["basicMotorSpeed"] !== undefined ? _data["basicMotorSpeed"] : null as any;
            this.basicMotorPrice = _data["basicMotorPrice"] !== undefined ? _data["basicMotorPrice"] : null as any;
            this.basicMotorRemark = _data["basicMotorRemark"] !== undefined ? _data["basicMotorRemark"] : null as any;
            this.basicMotorDesignType = _data["basicMotorDesignType"] !== undefined ? _data["basicMotorDesignType"] : null as any;
            this.mountingName = _data["mountingName"] !== undefined ? _data["mountingName"] : null as any;
            this.frameNumber = _data["frameNumber"] !== undefined ? _data["frameNumber"] : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.insulation = _data["insulation"] !== undefined ? _data["insulation"] : null as any;
            this.safty = _data["safty"] !== undefined ? _data["safty"] : null as any;
            this.typeDesignation = _data["typeDesignation"] !== undefined ? _data["typeDesignation"] : null as any;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : null as any;
            this.isReleased = _data["isReleased"] !== undefined ? _data["isReleased"] : null as any;
            this.listPriceMultiplier = _data["listPriceMultiplier"] !== undefined ? _data["listPriceMultiplier"] : null as any;
            this.basedMotorCode = _data["basedMotorCode"] !== undefined ? _data["basedMotorCode"] : null as any;
            this.basedMotorModel = _data["basedMotorModel"] !== undefined ? _data["basedMotorModel"] : null as any;
        }
    }

    static fromJS(data: any): CreateMotorInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMotorInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["basicMotorProductCode"] = this.basicMotorProductCode !== undefined ? this.basicMotorProductCode : null as any;
        data["basicMotorRateOfWork"] = this.basicMotorRateOfWork !== undefined ? this.basicMotorRateOfWork : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorSeries"] = this.basicMotorSeries !== undefined ? this.basicMotorSeries : null as any;
        data["basicMotorSpeed"] = this.basicMotorSpeed !== undefined ? this.basicMotorSpeed : null as any;
        data["basicMotorPrice"] = this.basicMotorPrice !== undefined ? this.basicMotorPrice : null as any;
        data["basicMotorRemark"] = this.basicMotorRemark !== undefined ? this.basicMotorRemark : null as any;
        data["basicMotorDesignType"] = this.basicMotorDesignType !== undefined ? this.basicMotorDesignType : null as any;
        data["mountingName"] = this.mountingName !== undefined ? this.mountingName : null as any;
        data["frameNumber"] = this.frameNumber !== undefined ? this.frameNumber : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["insulation"] = this.insulation !== undefined ? this.insulation : null as any;
        data["safty"] = this.safty !== undefined ? this.safty : null as any;
        data["typeDesignation"] = this.typeDesignation !== undefined ? this.typeDesignation : null as any;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        data["isReleased"] = this.isReleased !== undefined ? this.isReleased : null as any;
        data["listPriceMultiplier"] = this.listPriceMultiplier !== undefined ? this.listPriceMultiplier : null as any;
        data["basedMotorCode"] = this.basedMotorCode !== undefined ? this.basedMotorCode : null as any;
        data["basedMotorModel"] = this.basedMotorModel !== undefined ? this.basedMotorModel : null as any;
        return data;
    }
}

/** 创建VC入参 */
export class CreateVCInputDto {
    /** 面价表Id */
    listPriceSeriesId!: string;
    /** VC编码 */
    vcCode!: string;
    /** VC描述 */
    vcDescribe!: string | null;
    /** VC价格 */
    vcPrice!: string | null;
    /** VC备注 */
    vcRemark!: string | null;
    /** VC类型 */
    vcType!: string | null;
    /** 折扣类型 */
    vcDiscountType!: string | null;
    /** 机座号 */
    frameNumber!: string | null;
    /** 是否启用 */
    isEnabled!: boolean;

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.vcDescribe = _data["vcDescribe"] !== undefined ? _data["vcDescribe"] : null as any;
            this.vcPrice = _data["vcPrice"] !== undefined ? _data["vcPrice"] : null as any;
            this.vcRemark = _data["vcRemark"] !== undefined ? _data["vcRemark"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.vcDiscountType = _data["vcDiscountType"] !== undefined ? _data["vcDiscountType"] : null as any;
            this.frameNumber = _data["frameNumber"] !== undefined ? _data["frameNumber"] : null as any;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : null as any;
        }
    }

    static fromJS(data: any): CreateVCInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVCInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["vcDescribe"] = this.vcDescribe !== undefined ? this.vcDescribe : null as any;
        data["vcPrice"] = this.vcPrice !== undefined ? this.vcPrice : null as any;
        data["vcRemark"] = this.vcRemark !== undefined ? this.vcRemark : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcDiscountType"] = this.vcDiscountType !== undefined ? this.vcDiscountType : null as any;
        data["frameNumber"] = this.frameNumber !== undefined ? this.frameNumber : null as any;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        return data;
    }
}

export class CustomerCodeDto {
    id!: string;
    /** 系列所属平台Id */
    listPricePlatFormId!: string;
    /** 系列所属平台name */
    listPricePlatFormName!: string | null;
    /** 平台所属人Id */
    platFormOwnerId!: string | null;
    /** 平台所属人名称 */
    platFormOwnerName!: string | null;
    /** 系列名称
Required为必须 */
    seriesName!: string;
    /** 系列描述
StringLength是string的长度限制 */
    seriesDescribe!: string | null;
    /** 客户列表 */
    customers!: ListPriceSeriesCustomerDto[] | null;
    /** 系列版本编号 */
    seriesVersionsNo!: string | null;
    /** 系列版本生效时间 */
    seriesVersionsTakeEffectTime!: moment.Moment;
    /** 系列版本描述
StringLength是string的长度限制 */
    seriesVersionsDescribe!: string | null;
    /** 失效时间 */
    versionsEffectExpirationTime!: moment.Moment | null;
    /** 创建时间 */
    creationTime!: moment.Moment;
    /** 系列ID，用于确认当前所有系列为一个系列 */
    seriesId!: string;
    listPriceType!: ListPriceType;
    approvalStatus!: ApprovalStatus;
    /** 系列上传VC长代码生成产品类型 */
    seriesVCType!: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.listPricePlatFormId = _data["listPricePlatFormId"] !== undefined ? _data["listPricePlatFormId"] : null as any;
            this.listPricePlatFormName = _data["listPricePlatFormName"] !== undefined ? _data["listPricePlatFormName"] : null as any;
            this.platFormOwnerId = _data["platFormOwnerId"] !== undefined ? _data["platFormOwnerId"] : null as any;
            this.platFormOwnerName = _data["platFormOwnerName"] !== undefined ? _data["platFormOwnerName"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
            this.seriesDescribe = _data["seriesDescribe"] !== undefined ? _data["seriesDescribe"] : null as any;
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(ListPriceSeriesCustomerDto.fromJS(item));
            }
            else {
                this.customers = null as any;
            }
            this.seriesVersionsNo = _data["seriesVersionsNo"] !== undefined ? _data["seriesVersionsNo"] : null as any;
            this.seriesVersionsTakeEffectTime = _data["seriesVersionsTakeEffectTime"] ? moment(_data["seriesVersionsTakeEffectTime"].toString()) : null as any;
            this.seriesVersionsDescribe = _data["seriesVersionsDescribe"] !== undefined ? _data["seriesVersionsDescribe"] : null as any;
            this.versionsEffectExpirationTime = _data["versionsEffectExpirationTime"] ? moment(_data["versionsEffectExpirationTime"].toString()) : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.seriesId = _data["seriesId"] !== undefined ? _data["seriesId"] : null as any;
            this.listPriceType = _data["listPriceType"] !== undefined ? _data["listPriceType"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
            this.seriesVCType = _data["seriesVCType"] !== undefined ? _data["seriesVCType"] : null as any;
        }
    }

    static fromJS(data: any): CustomerCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["listPricePlatFormId"] = this.listPricePlatFormId !== undefined ? this.listPricePlatFormId : null as any;
        data["listPricePlatFormName"] = this.listPricePlatFormName !== undefined ? this.listPricePlatFormName : null as any;
        data["platFormOwnerId"] = this.platFormOwnerId !== undefined ? this.platFormOwnerId : null as any;
        data["platFormOwnerName"] = this.platFormOwnerName !== undefined ? this.platFormOwnerName : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        data["seriesDescribe"] = this.seriesDescribe !== undefined ? this.seriesDescribe : null as any;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item ? item.toJSON() : null as any);
        }
        data["seriesVersionsNo"] = this.seriesVersionsNo !== undefined ? this.seriesVersionsNo : null as any;
        data["seriesVersionsTakeEffectTime"] = this.seriesVersionsTakeEffectTime ? this.seriesVersionsTakeEffectTime.toISOString() : null as any;
        data["seriesVersionsDescribe"] = this.seriesVersionsDescribe !== undefined ? this.seriesVersionsDescribe : null as any;
        data["versionsEffectExpirationTime"] = this.versionsEffectExpirationTime ? this.versionsEffectExpirationTime.toISOString() : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["seriesId"] = this.seriesId !== undefined ? this.seriesId : null as any;
        data["listPriceType"] = this.listPriceType !== undefined ? this.listPriceType : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        data["seriesVCType"] = this.seriesVCType !== undefined ? this.seriesVCType : null as any;
        return data;
    }
}

export class CustomerCodeDtoPagedResultDto {
    items!: CustomerCodeDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustomerCodeDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): CustomerCodeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerCodeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 删除关联Dto（批量删除） */
export class DeleteCommonPriceSeriesDto {
    /** 公共价格表Id */
    commonPriceId!: string;
    /** 面价系列Id集合（支持批量删除） */
    listPriceSeriesIds!: string[];

    init(_data?: any) {
        if (_data) {
            this.commonPriceId = _data["commonPriceId"] !== undefined ? _data["commonPriceId"] : null as any;
            if (Array.isArray(_data["listPriceSeriesIds"])) {
                this.listPriceSeriesIds = [] as any;
                for (let item of _data["listPriceSeriesIds"])
                    this.listPriceSeriesIds!.push(item);
            }
            else {
                this.listPriceSeriesIds = null as any;
            }
        }
    }

    static fromJS(data: any): DeleteCommonPriceSeriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCommonPriceSeriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commonPriceId"] = this.commonPriceId !== undefined ? this.commonPriceId : null as any;
        if (Array.isArray(this.listPriceSeriesIds)) {
            data["listPriceSeriesIds"] = [];
            for (let item of this.listPriceSeriesIds)
                data["listPriceSeriesIds"].push(item);
        }
        return data;
    }
}

/** 删除面价明细入参 */
export class DeleteListPriceDetailInputDto {
    /** 面价表Id */
    listPriceSeriesId!: string;
    /** 明细Id集合 */
    ids!: string[];

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            else {
                this.ids = null as any;
            }
        }
    }

    static fromJS(data: any): DeleteListPriceDetailInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteListPriceDetailInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

/** 对外创建项目型境界面价表 - 授权用户 */
export class ExternalJINAuthorizedUserDto {
    /** 用户Id */
    userId!: number;
    userType!: AuthorizedUserType;

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.userType = _data["userType"] !== undefined ? _data["userType"] : null as any;
        }
    }

    static fromJS(data: any): ExternalJINAuthorizedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalJINAuthorizedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userType"] = this.userType !== undefined ? this.userType : null as any;
        return data;
    }
}

/** 对外创建项目型境界面价表 - 客户信息 */
export class ExternalJINSeriesCustomerDto {
    /** 客户代码 */
    customerCode!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 二级客户代码 */
    subCustomerCode!: string | null;
    /** 二级客户名称 */
    subCustomerName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.subCustomerCode = _data["subCustomerCode"] !== undefined ? _data["subCustomerCode"] : null as any;
            this.subCustomerName = _data["subCustomerName"] !== undefined ? _data["subCustomerName"] : null as any;
        }
    }

    static fromJS(data: any): ExternalJINSeriesCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalJINSeriesCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["subCustomerCode"] = this.subCustomerCode !== undefined ? this.subCustomerCode : null as any;
        data["subCustomerName"] = this.subCustomerName !== undefined ? this.subCustomerName : null as any;
        return data;
    }
}

/** 根据审批编号查询面价系列入参 */
export class GetApprovalSeriesByNoInputDto {
    /** 审批编号 */
    approvalNo!: string;

    init(_data?: any) {
        if (_data) {
            this.approvalNo = _data["approvalNo"] !== undefined ? _data["approvalNo"] : null as any;
        }
    }

    static fromJS(data: any): GetApprovalSeriesByNoInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetApprovalSeriesByNoInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalNo"] = this.approvalNo !== undefined ? this.approvalNo : null as any;
        return data;
    }
}

/** 根据审批编号查询面价系列返回结果 */
export class GetApprovalSeriesByNoResultDto {
    /** 审批实例Id */
    approvalInstanceId!: string;
    /** 面价表Id（标准面价Id） */
    listPriceSeriesId!: string;
    /** 系列名称 */
    seriesName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.approvalInstanceId = _data["approvalInstanceId"] !== undefined ? _data["approvalInstanceId"] : null as any;
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
        }
    }

    static fromJS(data: any): GetApprovalSeriesByNoResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetApprovalSeriesByNoResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalInstanceId"] = this.approvalInstanceId !== undefined ? this.approvalInstanceId : null as any;
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        return data;
    }
}

export class GuidEntityDto {
    id!: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): GuidEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuidEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

/** 导入主机和VC的请求参数 */
export class ImportMotorsAndVCInputDto {
    /** 当前标准面价表Id */
    targetSeriesId!: string;
    /** 来源面价表Id */
    copyFromSeriesId!: string;

    init(_data?: any) {
        if (_data) {
            this.targetSeriesId = _data["targetSeriesId"] !== undefined ? _data["targetSeriesId"] : null as any;
            this.copyFromSeriesId = _data["copyFromSeriesId"] !== undefined ? _data["copyFromSeriesId"] : null as any;
        }
    }

    static fromJS(data: any): ImportMotorsAndVCInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportMotorsAndVCInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetSeriesId"] = this.targetSeriesId !== undefined ? this.targetSeriesId : null as any;
        data["copyFromSeriesId"] = this.copyFromSeriesId !== undefined ? this.copyFromSeriesId : null as any;
        return data;
    }
}

export class IndustrySubcodeDto {
    id!: string;
    /** 行业编号 */
    industryCode!: string;
    /** 行业子编号 */
    subcode!: string;
    /** 行业子编号描述 */
    subcodeDescription!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.industryCode = _data["industryCode"] !== undefined ? _data["industryCode"] : null as any;
            this.subcode = _data["subcode"] !== undefined ? _data["subcode"] : null as any;
            this.subcodeDescription = _data["subcodeDescription"] !== undefined ? _data["subcodeDescription"] : null as any;
        }
    }

    static fromJS(data: any): IndustrySubcodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndustrySubcodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["industryCode"] = this.industryCode !== undefined ? this.industryCode : null as any;
        data["subcode"] = this.subcode !== undefined ? this.subcode : null as any;
        data["subcodeDescription"] = this.subcodeDescription !== undefined ? this.subcodeDescription : null as any;
        return data;
    }
}

export class JINSeriesDto {
    id!: string;
    /** 面价表ID
创建时选择的标准面价表 */
    listPriceSeriesId!: string;
    /** 境界标识符 */
    categoryCode!: string | null;
    modelCodingRule!: ModelCodingRuleType;
    codeCodingRule!: CodeCodingRuleType;
    scenarioType!: ScenarioType;
    /** 业务场景编码
行业型：行业代码,3位
产品型：标准面价表ID
项目型：选型号
客户型：客户代码 */
    scenarioCode!: string | null;
    /** 内含VC */
    hasVCs!: boolean;
    /** 允许携带VC */
    canCarryVCs!: boolean;
    /** 报价原则 */
    quotationPrinciple!: string | null;
    discountType!: ListPriceDiscountType;
    /** PMS项目编号 */
    pmsProjectCode!: string | null;
    /** 特价号 */
    precalNo!: string | null;
    /** 证书管理员，支持多个 */
    certificateAdmin!: string | null;
    /** 证书管理员邮箱（仅 JIN，存 Redis） */
    certAdminEmail!: string | null;
    /** 列表价乘数，A/B代码系数，平均值 */
    listPriceMultiplier!: number | null;
    /** 协助完成，协助人填写的备注 */
    helperRemark!: string | null;
    /** 协助完成，协助人上传的附件 */
    helperAttachments!: string | null;
    /** 创建人 */
    creatorId!: number;
    approvalStatus!: ApprovalStatus;
    listPriceSeries!: ListPriceSeriesDto;
    listPriceSeriesAuthorizedUsers!: ListPriceSeriesAuthorizedUserDto[] | null;
    /** GCS协助信息 */
    gcsAssistInfo!: ListPriceJINGCSAssistDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.categoryCode = _data["categoryCode"] !== undefined ? _data["categoryCode"] : null as any;
            this.modelCodingRule = _data["modelCodingRule"] !== undefined ? _data["modelCodingRule"] : null as any;
            this.codeCodingRule = _data["codeCodingRule"] !== undefined ? _data["codeCodingRule"] : null as any;
            this.scenarioType = _data["scenarioType"] !== undefined ? _data["scenarioType"] : null as any;
            this.scenarioCode = _data["scenarioCode"] !== undefined ? _data["scenarioCode"] : null as any;
            this.hasVCs = _data["hasVCs"] !== undefined ? _data["hasVCs"] : null as any;
            this.canCarryVCs = _data["canCarryVCs"] !== undefined ? _data["canCarryVCs"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : null as any;
            this.pmsProjectCode = _data["pmsProjectCode"] !== undefined ? _data["pmsProjectCode"] : null as any;
            this.precalNo = _data["precalNo"] !== undefined ? _data["precalNo"] : null as any;
            this.certificateAdmin = _data["certificateAdmin"] !== undefined ? _data["certificateAdmin"] : null as any;
            this.certAdminEmail = _data["certAdminEmail"] !== undefined ? _data["certAdminEmail"] : null as any;
            this.listPriceMultiplier = _data["listPriceMultiplier"] !== undefined ? _data["listPriceMultiplier"] : null as any;
            this.helperRemark = _data["helperRemark"] !== undefined ? _data["helperRemark"] : null as any;
            this.helperAttachments = _data["helperAttachments"] !== undefined ? _data["helperAttachments"] : null as any;
            this.creatorId = _data["creatorId"] !== undefined ? _data["creatorId"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
            this.listPriceSeries = _data["listPriceSeries"] ? ListPriceSeriesDto.fromJS(_data["listPriceSeries"]) : null as any;
            if (Array.isArray(_data["listPriceSeriesAuthorizedUsers"])) {
                this.listPriceSeriesAuthorizedUsers = [] as any;
                for (let item of _data["listPriceSeriesAuthorizedUsers"])
                    this.listPriceSeriesAuthorizedUsers!.push(ListPriceSeriesAuthorizedUserDto.fromJS(item));
            }
            else {
                this.listPriceSeriesAuthorizedUsers = null as any;
            }
            if (Array.isArray(_data["gcsAssistInfo"])) {
                this.gcsAssistInfo = [] as any;
                for (let item of _data["gcsAssistInfo"])
                    this.gcsAssistInfo!.push(ListPriceJINGCSAssistDto.fromJS(item));
            }
            else {
                this.gcsAssistInfo = null as any;
            }
        }
    }

    static fromJS(data: any): JINSeriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new JINSeriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["categoryCode"] = this.categoryCode !== undefined ? this.categoryCode : null as any;
        data["modelCodingRule"] = this.modelCodingRule !== undefined ? this.modelCodingRule : null as any;
        data["codeCodingRule"] = this.codeCodingRule !== undefined ? this.codeCodingRule : null as any;
        data["scenarioType"] = this.scenarioType !== undefined ? this.scenarioType : null as any;
        data["scenarioCode"] = this.scenarioCode !== undefined ? this.scenarioCode : null as any;
        data["hasVCs"] = this.hasVCs !== undefined ? this.hasVCs : null as any;
        data["canCarryVCs"] = this.canCarryVCs !== undefined ? this.canCarryVCs : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["discountType"] = this.discountType !== undefined ? this.discountType : null as any;
        data["pmsProjectCode"] = this.pmsProjectCode !== undefined ? this.pmsProjectCode : null as any;
        data["precalNo"] = this.precalNo !== undefined ? this.precalNo : null as any;
        data["certificateAdmin"] = this.certificateAdmin !== undefined ? this.certificateAdmin : null as any;
        data["certAdminEmail"] = this.certAdminEmail !== undefined ? this.certAdminEmail : null as any;
        data["listPriceMultiplier"] = this.listPriceMultiplier !== undefined ? this.listPriceMultiplier : null as any;
        data["helperRemark"] = this.helperRemark !== undefined ? this.helperRemark : null as any;
        data["helperAttachments"] = this.helperAttachments !== undefined ? this.helperAttachments : null as any;
        data["creatorId"] = this.creatorId !== undefined ? this.creatorId : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        data["listPriceSeries"] = this.listPriceSeries ? this.listPriceSeries.toJSON() : null as any;
        if (Array.isArray(this.listPriceSeriesAuthorizedUsers)) {
            data["listPriceSeriesAuthorizedUsers"] = [];
            for (let item of this.listPriceSeriesAuthorizedUsers)
                data["listPriceSeriesAuthorizedUsers"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.gcsAssistInfo)) {
            data["gcsAssistInfo"] = [];
            for (let item of this.gcsAssistInfo)
                data["gcsAssistInfo"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class JINSeriesDtoPagedResultDto {
    items!: JINSeriesDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(JINSeriesDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): JINSeriesDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new JINSeriesDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 审批操作入参（同意/拒绝共用） */
export class ListPriceApprovalActionDto {
    /** 审批实例Id */
    approvalInstanceId!: string;
    /** 审批意见 */
    comments!: string | null;
    /** 审批备注 */
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.approvalInstanceId = _data["approvalInstanceId"] !== undefined ? _data["approvalInstanceId"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceApprovalActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceApprovalActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalInstanceId"] = this.approvalInstanceId !== undefined ? this.approvalInstanceId : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

/** 1 = Create 2 = Update */
export enum ListPriceApprovalChangeType {
    Create = 1,
    Update = 2,
}

export class ListPriceApprovalFlow {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    flowName!: string;
    templateType!: ListPriceApprovalTemplateType;
    isEnabled!: boolean;
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.flowName = _data["flowName"] !== undefined ? _data["flowName"] : null as any;
            this.templateType = _data["templateType"] !== undefined ? _data["templateType"] : null as any;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceApprovalFlow {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceApprovalFlow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["flowName"] = this.flowName !== undefined ? this.flowName : null as any;
        data["templateType"] = this.templateType !== undefined ? this.templateType : null as any;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

/** 流程配置Dto */
export class ListPriceApprovalFlowDto {
    id!: string;
    /** 流程名称 */
    flowName!: string;
    templateType!: ListPriceApprovalTemplateType;
    /** 是否启用 */
    isEnabled!: boolean;
    /** 流程备注 */
    remark!: string | null;
    /** 节点集合 */
    nodes!: ListPriceApprovalFlowNodeDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.flowName = _data["flowName"] !== undefined ? _data["flowName"] : null as any;
            this.templateType = _data["templateType"] !== undefined ? _data["templateType"] : null as any;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            if (Array.isArray(_data["nodes"])) {
                this.nodes = [] as any;
                for (let item of _data["nodes"])
                    this.nodes!.push(ListPriceApprovalFlowNodeDto.fromJS(item));
            }
            else {
                this.nodes = null as any;
            }
        }
    }

    static fromJS(data: any): ListPriceApprovalFlowDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceApprovalFlowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["flowName"] = this.flowName !== undefined ? this.flowName : null as any;
        data["templateType"] = this.templateType !== undefined ? this.templateType : null as any;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        if (Array.isArray(this.nodes)) {
            data["nodes"] = [];
            for (let item of this.nodes)
                data["nodes"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 流程节点配置Dto */
export class ListPriceApprovalFlowNodeDto {
    id!: string;
    /** 节点名称 */
    nodeName!: string;
    /** 节点顺序 */
    sequence!: number;
    /** 审批角色Id */
    roleId!: number;
    /** 是否启用 */
    isEnabled!: boolean;
    /** 节点备注 */
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nodeName = _data["nodeName"] !== undefined ? _data["nodeName"] : null as any;
            this.sequence = _data["sequence"] !== undefined ? _data["sequence"] : null as any;
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : null as any;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceApprovalFlowNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceApprovalFlowNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nodeName"] = this.nodeName !== undefined ? this.nodeName : null as any;
        data["sequence"] = this.sequence !== undefined ? this.sequence : null as any;
        data["roleId"] = this.roleId !== undefined ? this.roleId : null as any;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

/** 流程列表查询入参 */
export class ListPriceApprovalFlowQueryDto {
    /** 流程名称 */
    flowName!: string | null;
    /** 是否启用 */
    isEnabled!: boolean | null;
    /** 排序 */
    sorting!: string | null;

    init(_data?: any) {
        if (_data) {
            this.flowName = _data["flowName"] !== undefined ? _data["flowName"] : null as any;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : null as any;
            this.sorting = _data["sorting"] !== undefined ? _data["sorting"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceApprovalFlowQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceApprovalFlowQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flowName"] = this.flowName !== undefined ? this.flowName : null as any;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        data["sorting"] = this.sorting !== undefined ? this.sorting : null as any;
        return data;
    }
}

/** 审批历史记录列表项 */
export class ListPriceApprovalHistoryListItemDto {
    /** 审批编号（格式：APP-2026-0001） */
    approvalNo!: string | null;
    /** 是否批量审批 */
    isBatchApproval!: boolean;
    /** 审批实例Id */
    approvalInstanceId!: string;
    /** 面价表Id */
    listPriceSeriesId!: string;
    /** 面价表编号
例如：202509A */
    seriesVersion!: string | null;
    /** 面价表名称 */
    seriesName!: string | null;
    listPriceType!: ListPriceType;
    changeType!: ListPriceApprovalChangeType;
    /** 面价表更新类型文本
供前端直接显示：新建 / 更新 */
    changeTypeText!: string | null;
    status!: ListPriceApprovalInstanceStatus;
    /** 审批状态文本
供前端直接显示：审批中 / 通过 / 拒绝
历史记录里一般是：通过 / 拒绝 */
    statusText!: string | null;
    /** 提交时间 */
    submitTime!: moment.Moment;
    /** 提交备注 */
    submitRemark!: string | null;
    /** 审批时间
审批实例完成时间 */
    approvalTime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.approvalNo = _data["approvalNo"] !== undefined ? _data["approvalNo"] : null as any;
            this.isBatchApproval = _data["isBatchApproval"] !== undefined ? _data["isBatchApproval"] : null as any;
            this.approvalInstanceId = _data["approvalInstanceId"] !== undefined ? _data["approvalInstanceId"] : null as any;
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.seriesVersion = _data["seriesVersion"] !== undefined ? _data["seriesVersion"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
            this.listPriceType = _data["listPriceType"] !== undefined ? _data["listPriceType"] : null as any;
            this.changeType = _data["changeType"] !== undefined ? _data["changeType"] : null as any;
            this.changeTypeText = _data["changeTypeText"] !== undefined ? _data["changeTypeText"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.statusText = _data["statusText"] !== undefined ? _data["statusText"] : null as any;
            this.submitTime = _data["submitTime"] ? moment(_data["submitTime"].toString()) : null as any;
            this.submitRemark = _data["submitRemark"] !== undefined ? _data["submitRemark"] : null as any;
            this.approvalTime = _data["approvalTime"] ? moment(_data["approvalTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ListPriceApprovalHistoryListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceApprovalHistoryListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalNo"] = this.approvalNo !== undefined ? this.approvalNo : null as any;
        data["isBatchApproval"] = this.isBatchApproval !== undefined ? this.isBatchApproval : null as any;
        data["approvalInstanceId"] = this.approvalInstanceId !== undefined ? this.approvalInstanceId : null as any;
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["seriesVersion"] = this.seriesVersion !== undefined ? this.seriesVersion : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        data["listPriceType"] = this.listPriceType !== undefined ? this.listPriceType : null as any;
        data["changeType"] = this.changeType !== undefined ? this.changeType : null as any;
        data["changeTypeText"] = this.changeTypeText !== undefined ? this.changeTypeText : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["statusText"] = this.statusText !== undefined ? this.statusText : null as any;
        data["submitTime"] = this.submitTime ? this.submitTime.toISOString() : null as any;
        data["submitRemark"] = this.submitRemark !== undefined ? this.submitRemark : null as any;
        data["approvalTime"] = this.approvalTime ? this.approvalTime.toISOString() : null as any;
        return data;
    }
}

export class ListPriceApprovalHistoryListItemDtoPagedResultDto {
    items!: ListPriceApprovalHistoryListItemDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ListPriceApprovalHistoryListItemDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceApprovalHistoryListItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceApprovalHistoryListItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class ListPriceApprovalInstance {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    listPriceSeriesId!: string;
    flowId!: string;
    listPriceType!: ListPriceType;
    scenarioType!: ScenarioType;
    approvalNo!: string | null;
    isBatchApproval!: boolean;
    seriesVersion!: string;
    seriesName!: string;
    changeType!: ListPriceApprovalChangeType;
    submitRemark!: string | null;
    attachmentJson!: string | null;
    currentInstanceNodeId!: string | null;
    currentSequence!: number | null;
    status!: ListPriceApprovalInstanceStatus;
    isFinished!: boolean;
    finishedTime!: moment.Moment | null;
    listPriceSeries!: ListPriceSeries;
    flow!: ListPriceApprovalFlow;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.flowId = _data["flowId"] !== undefined ? _data["flowId"] : null as any;
            this.listPriceType = _data["listPriceType"] !== undefined ? _data["listPriceType"] : null as any;
            this.scenarioType = _data["scenarioType"] !== undefined ? _data["scenarioType"] : null as any;
            this.approvalNo = _data["approvalNo"] !== undefined ? _data["approvalNo"] : null as any;
            this.isBatchApproval = _data["isBatchApproval"] !== undefined ? _data["isBatchApproval"] : null as any;
            this.seriesVersion = _data["seriesVersion"] !== undefined ? _data["seriesVersion"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
            this.changeType = _data["changeType"] !== undefined ? _data["changeType"] : null as any;
            this.submitRemark = _data["submitRemark"] !== undefined ? _data["submitRemark"] : null as any;
            this.attachmentJson = _data["attachmentJson"] !== undefined ? _data["attachmentJson"] : null as any;
            this.currentInstanceNodeId = _data["currentInstanceNodeId"] !== undefined ? _data["currentInstanceNodeId"] : null as any;
            this.currentSequence = _data["currentSequence"] !== undefined ? _data["currentSequence"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.isFinished = _data["isFinished"] !== undefined ? _data["isFinished"] : null as any;
            this.finishedTime = _data["finishedTime"] ? moment(_data["finishedTime"].toString()) : null as any;
            this.listPriceSeries = _data["listPriceSeries"] ? ListPriceSeries.fromJS(_data["listPriceSeries"]) : null as any;
            this.flow = _data["flow"] ? ListPriceApprovalFlow.fromJS(_data["flow"]) : null as any;
        }
    }

    static fromJS(data: any): ListPriceApprovalInstance {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceApprovalInstance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["flowId"] = this.flowId !== undefined ? this.flowId : null as any;
        data["listPriceType"] = this.listPriceType !== undefined ? this.listPriceType : null as any;
        data["scenarioType"] = this.scenarioType !== undefined ? this.scenarioType : null as any;
        data["approvalNo"] = this.approvalNo !== undefined ? this.approvalNo : null as any;
        data["isBatchApproval"] = this.isBatchApproval !== undefined ? this.isBatchApproval : null as any;
        data["seriesVersion"] = this.seriesVersion !== undefined ? this.seriesVersion : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        data["changeType"] = this.changeType !== undefined ? this.changeType : null as any;
        data["submitRemark"] = this.submitRemark !== undefined ? this.submitRemark : null as any;
        data["attachmentJson"] = this.attachmentJson !== undefined ? this.attachmentJson : null as any;
        data["currentInstanceNodeId"] = this.currentInstanceNodeId !== undefined ? this.currentInstanceNodeId : null as any;
        data["currentSequence"] = this.currentSequence !== undefined ? this.currentSequence : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["isFinished"] = this.isFinished !== undefined ? this.isFinished : null as any;
        data["finishedTime"] = this.finishedTime ? this.finishedTime.toISOString() : null as any;
        data["listPriceSeries"] = this.listPriceSeries ? this.listPriceSeries.toJSON() : null as any;
        data["flow"] = this.flow ? this.flow.toJSON() : null as any;
        return data;
    }
}

/** 审批实例详情Dto */
export class ListPriceApprovalInstanceDto {
    id!: string;
    /** 审批编号（格式：APP-2026-0001） */
    approvalNo!: string | null;
    /** 是否批量审批 */
    isBatchApproval!: boolean;
    /** 面价表Id */
    listPriceSeriesId!: string;
    /** 流程Id */
    flowId!: string;
    listPriceType!: ListPriceType;
    scenarioType!: ScenarioType;
    /** 版本号 */
    seriesVersion!: string | null;
    /** 面价表名称 */
    seriesName!: string | null;
    changeType!: ListPriceApprovalChangeType;
    /** 提交备注 */
    submitRemark!: string | null;
    /** 提交附件URL列表 */
    attachmentUrls!: string[] | null;
    /** 当前审批实例节点Id */
    currentInstanceNodeId!: string | null;
    /** 当前顺序 */
    currentSequence!: number | null;
    status!: ListPriceApprovalInstanceStatus;
    /** 是否已完成 */
    isFinished!: boolean;
    /** 完成时间 */
    finishedTime!: moment.Moment | null;
    /** 境界表Id（根据标准面价Id关联查询，无对应境界表时为空） */
    listPriceJINSeriesId!: string | null;
    /** 节点列表 */
    nodes!: ListPriceApprovalInstanceNodeDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.approvalNo = _data["approvalNo"] !== undefined ? _data["approvalNo"] : null as any;
            this.isBatchApproval = _data["isBatchApproval"] !== undefined ? _data["isBatchApproval"] : null as any;
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.flowId = _data["flowId"] !== undefined ? _data["flowId"] : null as any;
            this.listPriceType = _data["listPriceType"] !== undefined ? _data["listPriceType"] : null as any;
            this.scenarioType = _data["scenarioType"] !== undefined ? _data["scenarioType"] : null as any;
            this.seriesVersion = _data["seriesVersion"] !== undefined ? _data["seriesVersion"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
            this.changeType = _data["changeType"] !== undefined ? _data["changeType"] : null as any;
            this.submitRemark = _data["submitRemark"] !== undefined ? _data["submitRemark"] : null as any;
            if (Array.isArray(_data["attachmentUrls"])) {
                this.attachmentUrls = [] as any;
                for (let item of _data["attachmentUrls"])
                    this.attachmentUrls!.push(item);
            }
            else {
                this.attachmentUrls = null as any;
            }
            this.currentInstanceNodeId = _data["currentInstanceNodeId"] !== undefined ? _data["currentInstanceNodeId"] : null as any;
            this.currentSequence = _data["currentSequence"] !== undefined ? _data["currentSequence"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.isFinished = _data["isFinished"] !== undefined ? _data["isFinished"] : null as any;
            this.finishedTime = _data["finishedTime"] ? moment(_data["finishedTime"].toString()) : null as any;
            this.listPriceJINSeriesId = _data["listPriceJINSeriesId"] !== undefined ? _data["listPriceJINSeriesId"] : null as any;
            if (Array.isArray(_data["nodes"])) {
                this.nodes = [] as any;
                for (let item of _data["nodes"])
                    this.nodes!.push(ListPriceApprovalInstanceNodeDto.fromJS(item));
            }
            else {
                this.nodes = null as any;
            }
        }
    }

    static fromJS(data: any): ListPriceApprovalInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceApprovalInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["approvalNo"] = this.approvalNo !== undefined ? this.approvalNo : null as any;
        data["isBatchApproval"] = this.isBatchApproval !== undefined ? this.isBatchApproval : null as any;
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["flowId"] = this.flowId !== undefined ? this.flowId : null as any;
        data["listPriceType"] = this.listPriceType !== undefined ? this.listPriceType : null as any;
        data["scenarioType"] = this.scenarioType !== undefined ? this.scenarioType : null as any;
        data["seriesVersion"] = this.seriesVersion !== undefined ? this.seriesVersion : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        data["changeType"] = this.changeType !== undefined ? this.changeType : null as any;
        data["submitRemark"] = this.submitRemark !== undefined ? this.submitRemark : null as any;
        if (Array.isArray(this.attachmentUrls)) {
            data["attachmentUrls"] = [];
            for (let item of this.attachmentUrls)
                data["attachmentUrls"].push(item);
        }
        data["currentInstanceNodeId"] = this.currentInstanceNodeId !== undefined ? this.currentInstanceNodeId : null as any;
        data["currentSequence"] = this.currentSequence !== undefined ? this.currentSequence : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["isFinished"] = this.isFinished !== undefined ? this.isFinished : null as any;
        data["finishedTime"] = this.finishedTime ? this.finishedTime.toISOString() : null as any;
        data["listPriceJINSeriesId"] = this.listPriceJINSeriesId !== undefined ? this.listPriceJINSeriesId : null as any;
        if (Array.isArray(this.nodes)) {
            data["nodes"] = [];
            for (let item of this.nodes)
                data["nodes"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 审批实例节点Dto */
export class ListPriceApprovalInstanceNodeDto {
    id!: string;
    /** 节点名称 */
    nodeName!: string | null;
    /** 节点顺序 */
    sequence!: number;
    /** 审批角色Id */
    roleId!: number | null;
    /** 审批用户Id */
    userId!: number | null;
    status!: ListPriceApprovalNodeStatus;
    /** 是否当前节点 */
    isCurrent!: boolean;
    /** 审批人用户Id */
    approverUserId!: number | null;
    /** 审批意见 */
    comments!: string | null;
    /** 审批时间 */
    approvalTime!: moment.Moment | null;
    /** 审批备注 */
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nodeName = _data["nodeName"] !== undefined ? _data["nodeName"] : null as any;
            this.sequence = _data["sequence"] !== undefined ? _data["sequence"] : null as any;
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.isCurrent = _data["isCurrent"] !== undefined ? _data["isCurrent"] : null as any;
            this.approverUserId = _data["approverUserId"] !== undefined ? _data["approverUserId"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.approvalTime = _data["approvalTime"] ? moment(_data["approvalTime"].toString()) : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceApprovalInstanceNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceApprovalInstanceNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nodeName"] = this.nodeName !== undefined ? this.nodeName : null as any;
        data["sequence"] = this.sequence !== undefined ? this.sequence : null as any;
        data["roleId"] = this.roleId !== undefined ? this.roleId : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["isCurrent"] = this.isCurrent !== undefined ? this.isCurrent : null as any;
        data["approverUserId"] = this.approverUserId !== undefined ? this.approverUserId : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["approvalTime"] = this.approvalTime ? this.approvalTime.toISOString() : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

/** 1 = InProgress 2 = Approved 3 = Rejected 4 = Cancelled */
export enum ListPriceApprovalInstanceStatus {
    InProgress = 1,
    Approved = 2,
    Rejected = 3,
    Cancelled = 4,
}

/** 审批列表项 */
export class ListPriceApprovalListItemDto {
    /** 审批编号（格式：APP-2026-0001） */
    approvalNo!: string | null;
    /** 是否批量审批 */
    isBatchApproval!: boolean;
    /** 审批实例Id */
    approvalInstanceId!: string;
    /** 面价表版本Id */
    listPriceSeriesId!: string;
    /** 产品系列 / 面价表名称 */
    seriesName!: string | null;
    /** 面价表编号（如：202509A） */
    seriesVersion!: string | null;
    changeType!: ListPriceApprovalChangeType;
    /** 变更类型文本（给前端直接显示） */
    changeTypeText!: string | null;
    status!: ListPriceApprovalInstanceStatus;
    /** 审批状态文本（给前端直接显示） */
    statusText!: string | null;
    /** 提交时间
审批实例创建时间即提交时间 */
    submitTime!: moment.Moment;
    /** 提交人用户Id */
    submitterUserId!: number | null;
    /** 提交人显示名
目前没有姓名接口时，先返回用户Id字符串 */
    submitterName!: string | null;
    /** 提交备注 */
    submitRemark!: string | null;
    /** 当前审批顺序 */
    currentSequence!: number | null;
    /** 当前审批实例节点Id */
    currentInstanceNodeId!: string | null;
    /** 当前节点名称
审批中时有值；已完成时可能为空 */
    currentNodeName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.approvalNo = _data["approvalNo"] !== undefined ? _data["approvalNo"] : null as any;
            this.isBatchApproval = _data["isBatchApproval"] !== undefined ? _data["isBatchApproval"] : null as any;
            this.approvalInstanceId = _data["approvalInstanceId"] !== undefined ? _data["approvalInstanceId"] : null as any;
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
            this.seriesVersion = _data["seriesVersion"] !== undefined ? _data["seriesVersion"] : null as any;
            this.changeType = _data["changeType"] !== undefined ? _data["changeType"] : null as any;
            this.changeTypeText = _data["changeTypeText"] !== undefined ? _data["changeTypeText"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.statusText = _data["statusText"] !== undefined ? _data["statusText"] : null as any;
            this.submitTime = _data["submitTime"] ? moment(_data["submitTime"].toString()) : null as any;
            this.submitterUserId = _data["submitterUserId"] !== undefined ? _data["submitterUserId"] : null as any;
            this.submitterName = _data["submitterName"] !== undefined ? _data["submitterName"] : null as any;
            this.submitRemark = _data["submitRemark"] !== undefined ? _data["submitRemark"] : null as any;
            this.currentSequence = _data["currentSequence"] !== undefined ? _data["currentSequence"] : null as any;
            this.currentInstanceNodeId = _data["currentInstanceNodeId"] !== undefined ? _data["currentInstanceNodeId"] : null as any;
            this.currentNodeName = _data["currentNodeName"] !== undefined ? _data["currentNodeName"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceApprovalListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceApprovalListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalNo"] = this.approvalNo !== undefined ? this.approvalNo : null as any;
        data["isBatchApproval"] = this.isBatchApproval !== undefined ? this.isBatchApproval : null as any;
        data["approvalInstanceId"] = this.approvalInstanceId !== undefined ? this.approvalInstanceId : null as any;
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        data["seriesVersion"] = this.seriesVersion !== undefined ? this.seriesVersion : null as any;
        data["changeType"] = this.changeType !== undefined ? this.changeType : null as any;
        data["changeTypeText"] = this.changeTypeText !== undefined ? this.changeTypeText : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["statusText"] = this.statusText !== undefined ? this.statusText : null as any;
        data["submitTime"] = this.submitTime ? this.submitTime.toISOString() : null as any;
        data["submitterUserId"] = this.submitterUserId !== undefined ? this.submitterUserId : null as any;
        data["submitterName"] = this.submitterName !== undefined ? this.submitterName : null as any;
        data["submitRemark"] = this.submitRemark !== undefined ? this.submitRemark : null as any;
        data["currentSequence"] = this.currentSequence !== undefined ? this.currentSequence : null as any;
        data["currentInstanceNodeId"] = this.currentInstanceNodeId !== undefined ? this.currentInstanceNodeId : null as any;
        data["currentNodeName"] = this.currentNodeName !== undefined ? this.currentNodeName : null as any;
        return data;
    }
}

export class ListPriceApprovalListItemDtoPagedResultDto {
    items!: ListPriceApprovalListItemDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ListPriceApprovalListItemDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceApprovalListItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceApprovalListItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 审批记录列表项 */
export class ListPriceApprovalNodeRecordDto {
    /** 审批实例Id */
    approvalInstanceId!: string;
    /** 审批实例节点Id */
    approvalInstanceNodeId!: string;
    /** 面价表Id */
    listPriceSeriesId!: string;
    /** 面价表编号
例如：202509A */
    seriesVersion!: string | null;
    /** 面价表名称 */
    seriesName!: string | null;
    changeType!: ListPriceApprovalChangeType;
    /** 面价表更新类型文本
供前端直接显示：新建 / 更新 */
    changeTypeText!: string | null;
    /** 提交时间
审批实例创建时间即提交时间 */
    submitTime!: moment.Moment;
    status!: ListPriceApprovalNodeStatus;
    /** 审批状态文本
供前端直接显示：审批中 / 通过 / 拒绝 */
    statusText!: string | null;
    /** 提交备注 */
    submitRemark!: string | null;
    /** 审核时间
来自审批节点表 */
    approvalTime!: moment.Moment | null;
    /** 审批节点名称
例如：销售经理审批 / PM审批 */
    nodeName!: string | null;
    /** 节点顺序 */
    sequence!: number;
    /** 审批意见 */
    comments!: string | null;
    /** 审批人用户Id */
    approverUserId!: number | null;
    /** 是否批量审批 */
    isBatchApproval!: boolean;

    init(_data?: any) {
        if (_data) {
            this.approvalInstanceId = _data["approvalInstanceId"] !== undefined ? _data["approvalInstanceId"] : null as any;
            this.approvalInstanceNodeId = _data["approvalInstanceNodeId"] !== undefined ? _data["approvalInstanceNodeId"] : null as any;
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.seriesVersion = _data["seriesVersion"] !== undefined ? _data["seriesVersion"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
            this.changeType = _data["changeType"] !== undefined ? _data["changeType"] : null as any;
            this.changeTypeText = _data["changeTypeText"] !== undefined ? _data["changeTypeText"] : null as any;
            this.submitTime = _data["submitTime"] ? moment(_data["submitTime"].toString()) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.statusText = _data["statusText"] !== undefined ? _data["statusText"] : null as any;
            this.submitRemark = _data["submitRemark"] !== undefined ? _data["submitRemark"] : null as any;
            this.approvalTime = _data["approvalTime"] ? moment(_data["approvalTime"].toString()) : null as any;
            this.nodeName = _data["nodeName"] !== undefined ? _data["nodeName"] : null as any;
            this.sequence = _data["sequence"] !== undefined ? _data["sequence"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.approverUserId = _data["approverUserId"] !== undefined ? _data["approverUserId"] : null as any;
            this.isBatchApproval = _data["isBatchApproval"] !== undefined ? _data["isBatchApproval"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceApprovalNodeRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceApprovalNodeRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalInstanceId"] = this.approvalInstanceId !== undefined ? this.approvalInstanceId : null as any;
        data["approvalInstanceNodeId"] = this.approvalInstanceNodeId !== undefined ? this.approvalInstanceNodeId : null as any;
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["seriesVersion"] = this.seriesVersion !== undefined ? this.seriesVersion : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        data["changeType"] = this.changeType !== undefined ? this.changeType : null as any;
        data["changeTypeText"] = this.changeTypeText !== undefined ? this.changeTypeText : null as any;
        data["submitTime"] = this.submitTime ? this.submitTime.toISOString() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["statusText"] = this.statusText !== undefined ? this.statusText : null as any;
        data["submitRemark"] = this.submitRemark !== undefined ? this.submitRemark : null as any;
        data["approvalTime"] = this.approvalTime ? this.approvalTime.toISOString() : null as any;
        data["nodeName"] = this.nodeName !== undefined ? this.nodeName : null as any;
        data["sequence"] = this.sequence !== undefined ? this.sequence : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["approverUserId"] = this.approverUserId !== undefined ? this.approverUserId : null as any;
        data["isBatchApproval"] = this.isBatchApproval !== undefined ? this.isBatchApproval : null as any;
        return data;
    }
}

/** 0 = Pending 1 = Waiting 2 = Approved 3 = Rejected 4 = Cancelled */
export enum ListPriceApprovalNodeStatus {
    Pending = 0,
    Waiting = 1,
    Approved = 2,
    Rejected = 3,
    Cancelled = 4,
}

/** 1 = OneNode 2 = TwoNode 3 = ThreeNode */
export enum ListPriceApprovalTemplateType {
    OneNode = 1,
    TwoNode = 2,
    ThreeNode = 3,
}

export class ListPriceBasicMotorMounting {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    basicMotorMountingName!: string;
    basicMotorMountingCorrespondingNo!: string;
    listPriceBasicMotorPrices!: ListPriceBasicMotorPrice[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.basicMotorMountingName = _data["basicMotorMountingName"] !== undefined ? _data["basicMotorMountingName"] : null as any;
            this.basicMotorMountingCorrespondingNo = _data["basicMotorMountingCorrespondingNo"] !== undefined ? _data["basicMotorMountingCorrespondingNo"] : null as any;
            if (Array.isArray(_data["listPriceBasicMotorPrices"])) {
                this.listPriceBasicMotorPrices = [] as any;
                for (let item of _data["listPriceBasicMotorPrices"])
                    this.listPriceBasicMotorPrices!.push(ListPriceBasicMotorPrice.fromJS(item));
            }
            else {
                this.listPriceBasicMotorPrices = null as any;
            }
        }
    }

    static fromJS(data: any): ListPriceBasicMotorMounting {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceBasicMotorMounting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["basicMotorMountingName"] = this.basicMotorMountingName !== undefined ? this.basicMotorMountingName : null as any;
        data["basicMotorMountingCorrespondingNo"] = this.basicMotorMountingCorrespondingNo !== undefined ? this.basicMotorMountingCorrespondingNo : null as any;
        if (Array.isArray(this.listPriceBasicMotorPrices)) {
            data["listPriceBasicMotorPrices"] = [];
            for (let item of this.listPriceBasicMotorPrices)
                data["listPriceBasicMotorPrices"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class ListPriceBasicMotorMountingDto {
    id!: string;
    /** 安装方式名称{B3,B3左,B3右,B5,B35,B14} */
    basicMotorMountingName!: string | null;
    /** 安装方式对应的编号 */
    basicMotorMountingCorrespondingNo!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorMountingName = _data["basicMotorMountingName"] !== undefined ? _data["basicMotorMountingName"] : null as any;
            this.basicMotorMountingCorrespondingNo = _data["basicMotorMountingCorrespondingNo"] !== undefined ? _data["basicMotorMountingCorrespondingNo"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceBasicMotorMountingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceBasicMotorMountingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorMountingName"] = this.basicMotorMountingName !== undefined ? this.basicMotorMountingName : null as any;
        data["basicMotorMountingCorrespondingNo"] = this.basicMotorMountingCorrespondingNo !== undefined ? this.basicMotorMountingCorrespondingNo : null as any;
        return data;
    }
}

export class ListPriceBasicMotorPrice {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    basicMotorRateOfWork!: string | null;
    basicMotorModel!: string | null;
    basicMotorSeries!: string | null;
    basicMotorProductCode!: string;
    listPriceBasicMotorMountingId!: string;
    listPriceBasicMotorMounting!: ListPriceBasicMotorMounting;
    basicMotorPrice!: string | null;
    basicMotorRemark!: string | null;
    basicMotorDesignType!: string | null;
    basicMotorProductCodeExhibition!: string | null;
    listPriceSeriesId!: string;
    listPriceSeries!: ListPriceSeries;
    listPriceType!: ListPriceType;
    isEnabled!: boolean;
    seriesVersion!: string | null;
    basedMotorPriceId!: string | null;
    basedMotor!: ListPriceBasicMotorPrice;
    basedMotorCode!: string | null;
    basedMotorModel!: string | null;
    listPriceJINCodeVCs!: ListPriceJINCodeVC[] | null;
    /** 转速 */
    basicMotorSpeed!: string | null;
    /** 是否发布 */
    isReleased!: boolean;
    listPriceMultiplier!: number;
    wiringMode!: string | null;
    frequency!: string | null;
    eneEff!: string | null;
    voltage!: string | null;
    insulation!: string | null;
    safty!: string | null;
    typeDesignation!: string | null;
    frameNumber!: number;
    serialNo!: string | null;
    lectoTypeProductld!: string | null;
    domesticQuotationNumber!: string | null;
    domesticQuotationNumberCode!: string | null;
    basicMotorParams!: ListPriceBasicMotorPriceParam[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.basicMotorRateOfWork = _data["basicMotorRateOfWork"] !== undefined ? _data["basicMotorRateOfWork"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorSeries = _data["basicMotorSeries"] !== undefined ? _data["basicMotorSeries"] : null as any;
            this.basicMotorProductCode = _data["basicMotorProductCode"] !== undefined ? _data["basicMotorProductCode"] : null as any;
            this.listPriceBasicMotorMountingId = _data["listPriceBasicMotorMountingId"] !== undefined ? _data["listPriceBasicMotorMountingId"] : null as any;
            this.listPriceBasicMotorMounting = _data["listPriceBasicMotorMounting"] ? ListPriceBasicMotorMounting.fromJS(_data["listPriceBasicMotorMounting"]) : null as any;
            this.basicMotorPrice = _data["basicMotorPrice"] !== undefined ? _data["basicMotorPrice"] : null as any;
            this.basicMotorRemark = _data["basicMotorRemark"] !== undefined ? _data["basicMotorRemark"] : null as any;
            this.basicMotorDesignType = _data["basicMotorDesignType"] !== undefined ? _data["basicMotorDesignType"] : null as any;
            this.basicMotorProductCodeExhibition = _data["basicMotorProductCodeExhibition"] !== undefined ? _data["basicMotorProductCodeExhibition"] : null as any;
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.listPriceSeries = _data["listPriceSeries"] ? ListPriceSeries.fromJS(_data["listPriceSeries"]) : null as any;
            this.listPriceType = _data["listPriceType"] !== undefined ? _data["listPriceType"] : null as any;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : null as any;
            this.seriesVersion = _data["seriesVersion"] !== undefined ? _data["seriesVersion"] : null as any;
            this.basedMotorPriceId = _data["basedMotorPriceId"] !== undefined ? _data["basedMotorPriceId"] : null as any;
            this.basedMotor = _data["basedMotor"] ? ListPriceBasicMotorPrice.fromJS(_data["basedMotor"]) : null as any;
            this.basedMotorCode = _data["basedMotorCode"] !== undefined ? _data["basedMotorCode"] : null as any;
            this.basedMotorModel = _data["basedMotorModel"] !== undefined ? _data["basedMotorModel"] : null as any;
            if (Array.isArray(_data["listPriceJINCodeVCs"])) {
                this.listPriceJINCodeVCs = [] as any;
                for (let item of _data["listPriceJINCodeVCs"])
                    this.listPriceJINCodeVCs!.push(ListPriceJINCodeVC.fromJS(item));
            }
            else {
                this.listPriceJINCodeVCs = null as any;
            }
            this.basicMotorSpeed = _data["basicMotorSpeed"] !== undefined ? _data["basicMotorSpeed"] : null as any;
            this.isReleased = _data["isReleased"] !== undefined ? _data["isReleased"] : null as any;
            this.listPriceMultiplier = _data["listPriceMultiplier"] !== undefined ? _data["listPriceMultiplier"] : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.insulation = _data["insulation"] !== undefined ? _data["insulation"] : null as any;
            this.safty = _data["safty"] !== undefined ? _data["safty"] : null as any;
            this.typeDesignation = _data["typeDesignation"] !== undefined ? _data["typeDesignation"] : null as any;
            this.frameNumber = _data["frameNumber"] !== undefined ? _data["frameNumber"] : null as any;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : null as any;
            this.lectoTypeProductld = _data["lectoTypeProductld"] !== undefined ? _data["lectoTypeProductld"] : null as any;
            this.domesticQuotationNumber = _data["domesticQuotationNumber"] !== undefined ? _data["domesticQuotationNumber"] : null as any;
            this.domesticQuotationNumberCode = _data["domesticQuotationNumberCode"] !== undefined ? _data["domesticQuotationNumberCode"] : null as any;
            if (Array.isArray(_data["basicMotorParams"])) {
                this.basicMotorParams = [] as any;
                for (let item of _data["basicMotorParams"])
                    this.basicMotorParams!.push(ListPriceBasicMotorPriceParam.fromJS(item));
            }
            else {
                this.basicMotorParams = null as any;
            }
        }
    }

    static fromJS(data: any): ListPriceBasicMotorPrice {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceBasicMotorPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["basicMotorRateOfWork"] = this.basicMotorRateOfWork !== undefined ? this.basicMotorRateOfWork : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorSeries"] = this.basicMotorSeries !== undefined ? this.basicMotorSeries : null as any;
        data["basicMotorProductCode"] = this.basicMotorProductCode !== undefined ? this.basicMotorProductCode : null as any;
        data["listPriceBasicMotorMountingId"] = this.listPriceBasicMotorMountingId !== undefined ? this.listPriceBasicMotorMountingId : null as any;
        data["listPriceBasicMotorMounting"] = this.listPriceBasicMotorMounting ? this.listPriceBasicMotorMounting.toJSON() : null as any;
        data["basicMotorPrice"] = this.basicMotorPrice !== undefined ? this.basicMotorPrice : null as any;
        data["basicMotorRemark"] = this.basicMotorRemark !== undefined ? this.basicMotorRemark : null as any;
        data["basicMotorDesignType"] = this.basicMotorDesignType !== undefined ? this.basicMotorDesignType : null as any;
        data["basicMotorProductCodeExhibition"] = this.basicMotorProductCodeExhibition !== undefined ? this.basicMotorProductCodeExhibition : null as any;
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["listPriceSeries"] = this.listPriceSeries ? this.listPriceSeries.toJSON() : null as any;
        data["listPriceType"] = this.listPriceType !== undefined ? this.listPriceType : null as any;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        data["seriesVersion"] = this.seriesVersion !== undefined ? this.seriesVersion : null as any;
        data["basedMotorPriceId"] = this.basedMotorPriceId !== undefined ? this.basedMotorPriceId : null as any;
        data["basedMotor"] = this.basedMotor ? this.basedMotor.toJSON() : null as any;
        data["basedMotorCode"] = this.basedMotorCode !== undefined ? this.basedMotorCode : null as any;
        data["basedMotorModel"] = this.basedMotorModel !== undefined ? this.basedMotorModel : null as any;
        if (Array.isArray(this.listPriceJINCodeVCs)) {
            data["listPriceJINCodeVCs"] = [];
            for (let item of this.listPriceJINCodeVCs)
                data["listPriceJINCodeVCs"].push(item ? item.toJSON() : null as any);
        }
        data["basicMotorSpeed"] = this.basicMotorSpeed !== undefined ? this.basicMotorSpeed : null as any;
        data["isReleased"] = this.isReleased !== undefined ? this.isReleased : null as any;
        data["listPriceMultiplier"] = this.listPriceMultiplier !== undefined ? this.listPriceMultiplier : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["insulation"] = this.insulation !== undefined ? this.insulation : null as any;
        data["safty"] = this.safty !== undefined ? this.safty : null as any;
        data["typeDesignation"] = this.typeDesignation !== undefined ? this.typeDesignation : null as any;
        data["frameNumber"] = this.frameNumber !== undefined ? this.frameNumber : null as any;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : null as any;
        data["lectoTypeProductld"] = this.lectoTypeProductld !== undefined ? this.lectoTypeProductld : null as any;
        data["domesticQuotationNumber"] = this.domesticQuotationNumber !== undefined ? this.domesticQuotationNumber : null as any;
        data["domesticQuotationNumberCode"] = this.domesticQuotationNumberCode !== undefined ? this.domesticQuotationNumberCode : null as any;
        if (Array.isArray(this.basicMotorParams)) {
            data["basicMotorParams"] = [];
            for (let item of this.basicMotorParams)
                data["basicMotorParams"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class ListPriceBasicMotorPriceDto {
    id!: string;
    /** 主机功率 */
    basicMotorRateOfWork!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 主机极数 */
    basicMotorSeries!: string | null;
    /** 主机产品代码 */
    basicMotorProductCode!: string | null;
    listPriceBasicMotorMountingId!: string;
    listPriceBasicMotorMounting!: ListPriceBasicMotorMountingDto;
    /** 主机价格A */
    basicMotorPrice!: string | null;
    /** 主机备注 */
    basicMotorRemark!: string | null;
    /** 主机设计类型 */
    basicMotorDesignType!: string | null;
    /** 转速 */
    basicMotorSpeed!: string | null;
    /** 极数 */
    basicMotorPoles!: string | null;
    basedMotorCode!: string | null;
    basedMotorModel!: string | null;
    /** 是否对外发布 */
    isReleased!: boolean;
    /** 主机产品代码-展示使用 */
    basicMotorProductCodeExhibition!: string | null;
    /** 接线方式 */
    wiringMode!: string | null;
    /** 频率 */
    frequency!: string | null;
    /** 能效 */
    eneEff!: string | null;
    /** 电压 */
    voltage!: string | null;
    /** 绝缘等级 */
    insulation!: string | null;
    /** 防护等级 */
    safty!: string | null;
    /** 铭牌 */
    typeDesignation!: string | null;
    /** 机座号 */
    frameNumber!: number;
    /** 面价系数 */
    listPriceMultiplier!: number;
    /** 国产报价号 */
    domesticQuotationNumber!: string | null;
    /** 国产报价号编号 */
    domesticQuotationNumberCode!: string | null;
    /** 内含VC */
    jinCodeVCs!: ListPriceJINCodeVCDto[] | null;
    /** 主机参数（一个主机价格对应多条参数） */
    basicMotorParams!: ListPriceBasicMotorPriceParamDto[] | null;
    /** 突出显示字段 */
    highlightFields!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorRateOfWork = _data["basicMotorRateOfWork"] !== undefined ? _data["basicMotorRateOfWork"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorSeries = _data["basicMotorSeries"] !== undefined ? _data["basicMotorSeries"] : null as any;
            this.basicMotorProductCode = _data["basicMotorProductCode"] !== undefined ? _data["basicMotorProductCode"] : null as any;
            this.listPriceBasicMotorMountingId = _data["listPriceBasicMotorMountingId"] !== undefined ? _data["listPriceBasicMotorMountingId"] : null as any;
            this.listPriceBasicMotorMounting = _data["listPriceBasicMotorMounting"] ? ListPriceBasicMotorMountingDto.fromJS(_data["listPriceBasicMotorMounting"]) : null as any;
            this.basicMotorPrice = _data["basicMotorPrice"] !== undefined ? _data["basicMotorPrice"] : null as any;
            this.basicMotorRemark = _data["basicMotorRemark"] !== undefined ? _data["basicMotorRemark"] : null as any;
            this.basicMotorDesignType = _data["basicMotorDesignType"] !== undefined ? _data["basicMotorDesignType"] : null as any;
            this.basicMotorSpeed = _data["basicMotorSpeed"] !== undefined ? _data["basicMotorSpeed"] : null as any;
            this.basicMotorPoles = _data["basicMotorPoles"] !== undefined ? _data["basicMotorPoles"] : null as any;
            this.basedMotorCode = _data["basedMotorCode"] !== undefined ? _data["basedMotorCode"] : null as any;
            this.basedMotorModel = _data["basedMotorModel"] !== undefined ? _data["basedMotorModel"] : null as any;
            this.isReleased = _data["isReleased"] !== undefined ? _data["isReleased"] : null as any;
            this.basicMotorProductCodeExhibition = _data["basicMotorProductCodeExhibition"] !== undefined ? _data["basicMotorProductCodeExhibition"] : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.insulation = _data["insulation"] !== undefined ? _data["insulation"] : null as any;
            this.safty = _data["safty"] !== undefined ? _data["safty"] : null as any;
            this.typeDesignation = _data["typeDesignation"] !== undefined ? _data["typeDesignation"] : null as any;
            this.frameNumber = _data["frameNumber"] !== undefined ? _data["frameNumber"] : null as any;
            this.listPriceMultiplier = _data["listPriceMultiplier"] !== undefined ? _data["listPriceMultiplier"] : null as any;
            this.domesticQuotationNumber = _data["domesticQuotationNumber"] !== undefined ? _data["domesticQuotationNumber"] : null as any;
            this.domesticQuotationNumberCode = _data["domesticQuotationNumberCode"] !== undefined ? _data["domesticQuotationNumberCode"] : null as any;
            if (Array.isArray(_data["jinCodeVCs"])) {
                this.jinCodeVCs = [] as any;
                for (let item of _data["jinCodeVCs"])
                    this.jinCodeVCs!.push(ListPriceJINCodeVCDto.fromJS(item));
            }
            else {
                this.jinCodeVCs = null as any;
            }
            if (Array.isArray(_data["basicMotorParams"])) {
                this.basicMotorParams = [] as any;
                for (let item of _data["basicMotorParams"])
                    this.basicMotorParams!.push(ListPriceBasicMotorPriceParamDto.fromJS(item));
            }
            else {
                this.basicMotorParams = null as any;
            }
            if (Array.isArray(_data["highlightFields"])) {
                this.highlightFields = [] as any;
                for (let item of _data["highlightFields"])
                    this.highlightFields!.push(item);
            }
            else {
                this.highlightFields = null as any;
            }
        }
    }

    static fromJS(data: any): ListPriceBasicMotorPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceBasicMotorPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorRateOfWork"] = this.basicMotorRateOfWork !== undefined ? this.basicMotorRateOfWork : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorSeries"] = this.basicMotorSeries !== undefined ? this.basicMotorSeries : null as any;
        data["basicMotorProductCode"] = this.basicMotorProductCode !== undefined ? this.basicMotorProductCode : null as any;
        data["listPriceBasicMotorMountingId"] = this.listPriceBasicMotorMountingId !== undefined ? this.listPriceBasicMotorMountingId : null as any;
        data["listPriceBasicMotorMounting"] = this.listPriceBasicMotorMounting ? this.listPriceBasicMotorMounting.toJSON() : null as any;
        data["basicMotorPrice"] = this.basicMotorPrice !== undefined ? this.basicMotorPrice : null as any;
        data["basicMotorRemark"] = this.basicMotorRemark !== undefined ? this.basicMotorRemark : null as any;
        data["basicMotorDesignType"] = this.basicMotorDesignType !== undefined ? this.basicMotorDesignType : null as any;
        data["basicMotorSpeed"] = this.basicMotorSpeed !== undefined ? this.basicMotorSpeed : null as any;
        data["basicMotorPoles"] = this.basicMotorPoles !== undefined ? this.basicMotorPoles : null as any;
        data["basedMotorCode"] = this.basedMotorCode !== undefined ? this.basedMotorCode : null as any;
        data["basedMotorModel"] = this.basedMotorModel !== undefined ? this.basedMotorModel : null as any;
        data["isReleased"] = this.isReleased !== undefined ? this.isReleased : null as any;
        data["basicMotorProductCodeExhibition"] = this.basicMotorProductCodeExhibition !== undefined ? this.basicMotorProductCodeExhibition : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["insulation"] = this.insulation !== undefined ? this.insulation : null as any;
        data["safty"] = this.safty !== undefined ? this.safty : null as any;
        data["typeDesignation"] = this.typeDesignation !== undefined ? this.typeDesignation : null as any;
        data["frameNumber"] = this.frameNumber !== undefined ? this.frameNumber : null as any;
        data["listPriceMultiplier"] = this.listPriceMultiplier !== undefined ? this.listPriceMultiplier : null as any;
        data["domesticQuotationNumber"] = this.domesticQuotationNumber !== undefined ? this.domesticQuotationNumber : null as any;
        data["domesticQuotationNumberCode"] = this.domesticQuotationNumberCode !== undefined ? this.domesticQuotationNumberCode : null as any;
        if (Array.isArray(this.jinCodeVCs)) {
            data["jinCodeVCs"] = [];
            for (let item of this.jinCodeVCs)
                data["jinCodeVCs"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.basicMotorParams)) {
            data["basicMotorParams"] = [];
            for (let item of this.basicMotorParams)
                data["basicMotorParams"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.highlightFields)) {
            data["highlightFields"] = [];
            for (let item of this.highlightFields)
                data["highlightFields"].push(item);
        }
        return data;
    }
}

export class ListPriceBasicMotorPriceDtoPagedResultDto {
    items!: ListPriceBasicMotorPriceDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ListPriceBasicMotorPriceDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceBasicMotorPriceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceBasicMotorPriceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 单行编辑返回值（用于前端做“字段级”高亮） */
export class ListPriceBasicMotorPriceDtoRowEditResultDto {
    /** 更新后的行数据（合并行对应的全量明细列表） */
    item!: ListPriceBasicMotorPriceDto[] | null;
    /** 本次更新发生变化的字段名（前端可据此对单元格做颜色标识） */
    changedFields!: string[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["item"])) {
                this.item = [] as any;
                for (let item of _data["item"])
                    this.item!.push(ListPriceBasicMotorPriceDto.fromJS(item));
            }
            else {
                this.item = null as any;
            }
            if (Array.isArray(_data["changedFields"])) {
                this.changedFields = [] as any;
                for (let item of _data["changedFields"])
                    this.changedFields!.push(item);
            }
            else {
                this.changedFields = null as any;
            }
        }
    }

    static fromJS(data: any): ListPriceBasicMotorPriceDtoRowEditResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceBasicMotorPriceDtoRowEditResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.item)) {
            data["item"] = [];
            for (let item of this.item)
                data["item"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.changedFields)) {
            data["changedFields"] = [];
            for (let item of this.changedFields)
                data["changedFields"].push(item);
        }
        return data;
    }
}

export class ListPriceBasicMotorPriceParam {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    listPriceBasicMotorPriceId!: string;
    listPriceBasicMotorPrice!: ListPriceBasicMotorPrice;
    eneEff!: string | null;
    frequency!: string | null;
    poleNo!: string | null;
    power!: string | null;
    voltage!: string | null;
    insulation!: string | null;
    safty!: string | null;
    wiringMode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.listPriceBasicMotorPriceId = _data["listPriceBasicMotorPriceId"] !== undefined ? _data["listPriceBasicMotorPriceId"] : null as any;
            this.listPriceBasicMotorPrice = _data["listPriceBasicMotorPrice"] ? ListPriceBasicMotorPrice.fromJS(_data["listPriceBasicMotorPrice"]) : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.insulation = _data["insulation"] !== undefined ? _data["insulation"] : null as any;
            this.safty = _data["safty"] !== undefined ? _data["safty"] : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceBasicMotorPriceParam {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceBasicMotorPriceParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["listPriceBasicMotorPriceId"] = this.listPriceBasicMotorPriceId !== undefined ? this.listPriceBasicMotorPriceId : null as any;
        data["listPriceBasicMotorPrice"] = this.listPriceBasicMotorPrice ? this.listPriceBasicMotorPrice.toJSON() : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["insulation"] = this.insulation !== undefined ? this.insulation : null as any;
        data["safty"] = this.safty !== undefined ? this.safty : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        return data;
    }
}

/** 主机参数Dto */
export class ListPriceBasicMotorPriceParamDto {
    id!: string;
    /** 能效 */
    eneEff!: string | null;
    /** 频率 */
    frequency!: string | null;
    /** 极数 */
    poleNo!: string | null;
    /** 功率 */
    power!: string | null;
    /** 电压 */
    voltage!: string | null;
    /** 绝缘等级 */
    insulation!: string | null;
    /** 安全防护等级 */
    safty!: string | null;
    /** 接线方式 */
    wiringMode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.insulation = _data["insulation"] !== undefined ? _data["insulation"] : null as any;
            this.safty = _data["safty"] !== undefined ? _data["safty"] : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceBasicMotorPriceParamDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceBasicMotorPriceParamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["insulation"] = this.insulation !== undefined ? this.insulation : null as any;
        data["safty"] = this.safty !== undefined ? this.safty : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        return data;
    }
}

export class ListPriceBasicPriceDto {
    /** 主键ID（原样返回） */
    id!: string | null;
    clientID!: string;
    products!: Product[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.clientID = _data["clientID"] !== undefined ? _data["clientID"] : null as any;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(Product.fromJS(item));
            }
            else {
                this.products = null as any;
            }
        }
    }

    static fromJS(data: any): ListPriceBasicPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceBasicPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["clientID"] = this.clientID !== undefined ? this.clientID : null as any;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 变更详情返回Dto */
export class ListPriceChangeHistoryItemDto {
    /** 变更记录Id */
    id!: string;
    /** 日期字符串（yyyy-MM-dd） */
    date!: string | null;
    /** 变更时间 */
    changeTime!: moment.Moment;
    /** 修改人 */
    modifierUserId!: number | null;
    dataItemType!: ListPriceDataItemType;
    changeType!: ListPriceChangeType;
    /** 变更字段名称/列名称 */
    dataItemName!: string | null;
    /** 旧值 */
    oldValue!: string | null;
    /** 新值 */
    newValue!: string | null;
    /** 操作规则（记录本次变更的操作来源/规则，如批量调价规则等） */
    operationRule!: string | null;
    /** 电机编码（Motor / MotorPrice 类型记录） */
    motorCode!: string | null;
    /** VC Code（VCPrice 类型记录） */
    vcCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.date = _data["date"] !== undefined ? _data["date"] : null as any;
            this.changeTime = _data["changeTime"] ? moment(_data["changeTime"].toString()) : null as any;
            this.modifierUserId = _data["modifierUserId"] !== undefined ? _data["modifierUserId"] : null as any;
            this.dataItemType = _data["dataItemType"] !== undefined ? _data["dataItemType"] : null as any;
            this.changeType = _data["changeType"] !== undefined ? _data["changeType"] : null as any;
            this.dataItemName = _data["dataItemName"] !== undefined ? _data["dataItemName"] : null as any;
            this.oldValue = _data["oldValue"] !== undefined ? _data["oldValue"] : null as any;
            this.newValue = _data["newValue"] !== undefined ? _data["newValue"] : null as any;
            this.operationRule = _data["operationRule"] !== undefined ? _data["operationRule"] : null as any;
            this.motorCode = _data["motorCode"] !== undefined ? _data["motorCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceChangeHistoryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceChangeHistoryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["date"] = this.date !== undefined ? this.date : null as any;
        data["changeTime"] = this.changeTime ? this.changeTime.toISOString() : null as any;
        data["modifierUserId"] = this.modifierUserId !== undefined ? this.modifierUserId : null as any;
        data["dataItemType"] = this.dataItemType !== undefined ? this.dataItemType : null as any;
        data["changeType"] = this.changeType !== undefined ? this.changeType : null as any;
        data["dataItemName"] = this.dataItemName !== undefined ? this.dataItemName : null as any;
        data["oldValue"] = this.oldValue !== undefined ? this.oldValue : null as any;
        data["newValue"] = this.newValue !== undefined ? this.newValue : null as any;
        data["operationRule"] = this.operationRule !== undefined ? this.operationRule : null as any;
        data["motorCode"] = this.motorCode !== undefined ? this.motorCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        return data;
    }
}

/** 1 = Add 2 = Update 3 = Batch 4 = Delete 5 = Import 6 = Selection */
export enum ListPriceChangeType {
    Add = 1,
    Update = 2,
    Batch = 3,
    Delete = 4,
    Import = 5,
    Selection = 6,
}

/** 公共价格表维护Dto */
export class ListPriceCommonPriceDto {
    id!: string;
    /** FileUrl */
    fileUrl!: string | null;
    /** SheetName */
    sheetName!: string | null;
    /** 公共价格表维护关联明细 */
    relatedSeries!: ListPriceCommonPriceSeriesItemDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.fileUrl = _data["fileUrl"] !== undefined ? _data["fileUrl"] : null as any;
            this.sheetName = _data["sheetName"] !== undefined ? _data["sheetName"] : null as any;
            if (Array.isArray(_data["relatedSeries"])) {
                this.relatedSeries = [] as any;
                for (let item of _data["relatedSeries"])
                    this.relatedSeries!.push(ListPriceCommonPriceSeriesItemDto.fromJS(item));
            }
            else {
                this.relatedSeries = null as any;
            }
        }
    }

    static fromJS(data: any): ListPriceCommonPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceCommonPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["fileUrl"] = this.fileUrl !== undefined ? this.fileUrl : null as any;
        data["sheetName"] = this.sheetName !== undefined ? this.sheetName : null as any;
        if (Array.isArray(this.relatedSeries)) {
            data["relatedSeries"] = [];
            for (let item of this.relatedSeries)
                data["relatedSeries"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class ListPriceCommonPriceDtoPagedResultDto {
    items!: ListPriceCommonPriceDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ListPriceCommonPriceDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceCommonPriceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceCommonPriceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 公共价格表维护关联明细 */
export class ListPriceCommonPriceSeriesItemDto {
    /** 面价系列Id */
    listPriceSeriesId!: string;
    /** 系列名称 */
    seriesName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceCommonPriceSeriesItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceCommonPriceSeriesItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        return data;
    }
}

/** 1 = ListPrice 2 = Motor 3 = MotorPrice 4 = VCPrice 5 = VCCode */
export enum ListPriceDataItemType {
    ListPrice = 1,
    Motor = 2,
    MotorPrice = 3,
    VCPrice = 4,
    VCCode = 5,
}

/** 0 = ListPrice (面价) 1 = SalePrice (售价) */
export enum ListPriceDiscountType {
    ListPrice = 0,
    SalePrice = 1,
}

export class ListPriceJINCodeVC {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    listPriceBasicMotorPriceId!: string;
    listPriceSeriesId!: string | null;
    motorCode!: string | null;
    jinCode!: string | null;
    vcCode!: string | null;
    remark!: string | null;
    status!: number;
    vcType!: number;
    vcShowType!: number;
    vcPrice!: string | null;
    listPriceBasicMotorPrice!: ListPriceBasicMotorPrice;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.listPriceBasicMotorPriceId = _data["listPriceBasicMotorPriceId"] !== undefined ? _data["listPriceBasicMotorPriceId"] : null as any;
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.motorCode = _data["motorCode"] !== undefined ? _data["motorCode"] : null as any;
            this.jinCode = _data["jinCode"] !== undefined ? _data["jinCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.vcPrice = _data["vcPrice"] !== undefined ? _data["vcPrice"] : null as any;
            this.listPriceBasicMotorPrice = _data["listPriceBasicMotorPrice"] ? ListPriceBasicMotorPrice.fromJS(_data["listPriceBasicMotorPrice"]) : null as any;
        }
    }

    static fromJS(data: any): ListPriceJINCodeVC {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceJINCodeVC();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["listPriceBasicMotorPriceId"] = this.listPriceBasicMotorPriceId !== undefined ? this.listPriceBasicMotorPriceId : null as any;
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["motorCode"] = this.motorCode !== undefined ? this.motorCode : null as any;
        data["jinCode"] = this.jinCode !== undefined ? this.jinCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["vcPrice"] = this.vcPrice !== undefined ? this.vcPrice : null as any;
        data["listPriceBasicMotorPrice"] = this.listPriceBasicMotorPrice ? this.listPriceBasicMotorPrice.toJSON() : null as any;
        return data;
    }
}

export class ListPriceJINCodeVCDto {
    id!: string;
    /** VC代码 */
    vcCode!: string | null;
    /** 备注 - OpenVC */
    remark!: string | null;
    vcType!: number;
    vcShowType!: number;
    /** 品类 */
    category!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceJINCodeVCDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceJINCodeVCDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        return data;
    }
}

/** GCS协助信息Dto */
export class ListPriceJINGCSAssistDto {
    /** 主键 */
    id!: string;
    /** 境界Id */
    listPriceJINSeriesId!: string;
    /** 备注 */
    remark!: string | null;
    /** 附件地址集合 */
    attachmentUrls!: string[] | null;
    /** 创建时间 */
    creationTime!: moment.Moment;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.listPriceJINSeriesId = _data["listPriceJINSeriesId"] !== undefined ? _data["listPriceJINSeriesId"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            if (Array.isArray(_data["attachmentUrls"])) {
                this.attachmentUrls = [] as any;
                for (let item of _data["attachmentUrls"])
                    this.attachmentUrls!.push(item);
            }
            else {
                this.attachmentUrls = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ListPriceJINGCSAssistDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceJINGCSAssistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["listPriceJINSeriesId"] = this.listPriceJINSeriesId !== undefined ? this.listPriceJINSeriesId : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        if (Array.isArray(this.attachmentUrls)) {
            data["attachmentUrls"] = [];
            for (let item of this.attachmentUrls)
                data["attachmentUrls"].push(item);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        return data;
    }
}

export class ListPricePlatForm {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    platFormName!: string;
    platFormOwnerId!: string;
    platFormOwnerName!: string;
    platFormDescribe!: string | null;
    listPriceSeries!: ListPriceSeries[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.platFormName = _data["platFormName"] !== undefined ? _data["platFormName"] : null as any;
            this.platFormOwnerId = _data["platFormOwnerId"] !== undefined ? _data["platFormOwnerId"] : null as any;
            this.platFormOwnerName = _data["platFormOwnerName"] !== undefined ? _data["platFormOwnerName"] : null as any;
            this.platFormDescribe = _data["platFormDescribe"] !== undefined ? _data["platFormDescribe"] : null as any;
            if (Array.isArray(_data["listPriceSeries"])) {
                this.listPriceSeries = [] as any;
                for (let item of _data["listPriceSeries"])
                    this.listPriceSeries!.push(ListPriceSeries.fromJS(item));
            }
            else {
                this.listPriceSeries = null as any;
            }
        }
    }

    static fromJS(data: any): ListPricePlatForm {
        data = typeof data === 'object' ? data : {};
        let result = new ListPricePlatForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["platFormName"] = this.platFormName !== undefined ? this.platFormName : null as any;
        data["platFormOwnerId"] = this.platFormOwnerId !== undefined ? this.platFormOwnerId : null as any;
        data["platFormOwnerName"] = this.platFormOwnerName !== undefined ? this.platFormOwnerName : null as any;
        data["platFormDescribe"] = this.platFormDescribe !== undefined ? this.platFormDescribe : null as any;
        if (Array.isArray(this.listPriceSeries)) {
            data["listPriceSeries"] = [];
            for (let item of this.listPriceSeries)
                data["listPriceSeries"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class ListPricePlatFormDto {
    id!: string;
    /** 平台名称
Required为必须 */
    platFormName!: string;
    /** 平台所属人Id */
    platFormOwnerId!: string;
    /** 平台所属人名称 */
    platFormOwnerName!: string;
    /** 平台描述
StringLength是string的长度限制 */
    platFormDescribe!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.platFormName = _data["platFormName"] !== undefined ? _data["platFormName"] : null as any;
            this.platFormOwnerId = _data["platFormOwnerId"] !== undefined ? _data["platFormOwnerId"] : null as any;
            this.platFormOwnerName = _data["platFormOwnerName"] !== undefined ? _data["platFormOwnerName"] : null as any;
            this.platFormDescribe = _data["platFormDescribe"] !== undefined ? _data["platFormDescribe"] : null as any;
        }
    }

    static fromJS(data: any): ListPricePlatFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPricePlatFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["platFormName"] = this.platFormName !== undefined ? this.platFormName : null as any;
        data["platFormOwnerId"] = this.platFormOwnerId !== undefined ? this.platFormOwnerId : null as any;
        data["platFormOwnerName"] = this.platFormOwnerName !== undefined ? this.platFormOwnerName : null as any;
        data["platFormDescribe"] = this.platFormDescribe !== undefined ? this.platFormDescribe : null as any;
        return data;
    }
}

export class ListPricePlatFormDtoPagedResultDto {
    items!: ListPricePlatFormDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ListPricePlatFormDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): ListPricePlatFormDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPricePlatFormDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 面价备注Dto */
export class ListPriceRemarkDto {
    id!: string;
    /** 备注类型（0:主机备注 1:VC备注） */
    remarkType!: number;
    /** 是否为默认备注 */
    isDefault!: boolean;
    /** 关联面价表Id */
    listPriceSeriesId!: string | null;
    /** 备注内容 */
    content!: string | null;
    /** 排序号 */
    sortOrder!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.remarkType = _data["remarkType"] !== undefined ? _data["remarkType"] : null as any;
            this.isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : null as any;
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceRemarkDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceRemarkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["remarkType"] = this.remarkType !== undefined ? this.remarkType : null as any;
        data["isDefault"] = this.isDefault !== undefined ? this.isDefault : null as any;
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["content"] = this.content !== undefined ? this.content : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        return data;
    }
}

export class ListPriceSeries {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    listPricePlatForm!: ListPricePlatForm;
    listPricePlatFormId!: string | null;
    seriesName!: string;
    seriesDescribe!: string | null;
    seriesApplicationObject!: string | null;
    seriesVersionsNo!: string;
    seriesVersionsTakeEffectTime!: moment.Moment;
    seriesVersionsDescribe!: string | null;
    versionsIsTakeEffect!: boolean;
    versionsApprovalStatus!: ApprovalStatus;
    seriesId!: string;
    seriesVCType!: string | null;
    listPriceBasicMotorPrices!: ListPriceBasicMotorPrice[] | null;
    listPriceVCPrices!: ListPriceVCPrice[] | null;
    listPriceSeriesCustomers!: ListPriceSeriesCustomer[] | null;
    listPriceType!: ListPriceType;
    cusomterCode!: string | null;
    expirationTime!: moment.Moment | null;
    isPublishProductAnnouncement!: boolean;
    isPublishAnnouncement!: boolean;
    announcementPublishTime!: moment.Moment | null;
    /** 是否隐藏 */
    isHidden!: boolean;
    /** 是否仅发布 */
    isPublishOnly!: boolean;
    coverFileUrl!: string | null;
    priceSupplementFileUrl!: string | null;
    scheduledEnableTime!: moment.Moment | null;
    targetEnabledState!: boolean;
    isReplaceSelection!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.listPricePlatForm = _data["listPricePlatForm"] ? ListPricePlatForm.fromJS(_data["listPricePlatForm"]) : null as any;
            this.listPricePlatFormId = _data["listPricePlatFormId"] !== undefined ? _data["listPricePlatFormId"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
            this.seriesDescribe = _data["seriesDescribe"] !== undefined ? _data["seriesDescribe"] : null as any;
            this.seriesApplicationObject = _data["seriesApplicationObject"] !== undefined ? _data["seriesApplicationObject"] : null as any;
            this.seriesVersionsNo = _data["seriesVersionsNo"] !== undefined ? _data["seriesVersionsNo"] : null as any;
            this.seriesVersionsTakeEffectTime = _data["seriesVersionsTakeEffectTime"] ? moment(_data["seriesVersionsTakeEffectTime"].toString()) : null as any;
            this.seriesVersionsDescribe = _data["seriesVersionsDescribe"] !== undefined ? _data["seriesVersionsDescribe"] : null as any;
            this.versionsIsTakeEffect = _data["versionsIsTakeEffect"] !== undefined ? _data["versionsIsTakeEffect"] : null as any;
            this.versionsApprovalStatus = _data["versionsApprovalStatus"] !== undefined ? _data["versionsApprovalStatus"] : null as any;
            this.seriesId = _data["seriesId"] !== undefined ? _data["seriesId"] : null as any;
            this.seriesVCType = _data["seriesVCType"] !== undefined ? _data["seriesVCType"] : null as any;
            if (Array.isArray(_data["listPriceBasicMotorPrices"])) {
                this.listPriceBasicMotorPrices = [] as any;
                for (let item of _data["listPriceBasicMotorPrices"])
                    this.listPriceBasicMotorPrices!.push(ListPriceBasicMotorPrice.fromJS(item));
            }
            else {
                this.listPriceBasicMotorPrices = null as any;
            }
            if (Array.isArray(_data["listPriceVCPrices"])) {
                this.listPriceVCPrices = [] as any;
                for (let item of _data["listPriceVCPrices"])
                    this.listPriceVCPrices!.push(ListPriceVCPrice.fromJS(item));
            }
            else {
                this.listPriceVCPrices = null as any;
            }
            if (Array.isArray(_data["listPriceSeriesCustomers"])) {
                this.listPriceSeriesCustomers = [] as any;
                for (let item of _data["listPriceSeriesCustomers"])
                    this.listPriceSeriesCustomers!.push(ListPriceSeriesCustomer.fromJS(item));
            }
            else {
                this.listPriceSeriesCustomers = null as any;
            }
            this.listPriceType = _data["listPriceType"] !== undefined ? _data["listPriceType"] : null as any;
            this.cusomterCode = _data["cusomterCode"] !== undefined ? _data["cusomterCode"] : null as any;
            this.expirationTime = _data["expirationTime"] ? moment(_data["expirationTime"].toString()) : null as any;
            this.isPublishProductAnnouncement = _data["isPublishProductAnnouncement"] !== undefined ? _data["isPublishProductAnnouncement"] : null as any;
            this.isPublishAnnouncement = _data["isPublishAnnouncement"] !== undefined ? _data["isPublishAnnouncement"] : null as any;
            this.announcementPublishTime = _data["announcementPublishTime"] ? moment(_data["announcementPublishTime"].toString()) : null as any;
            this.isHidden = _data["isHidden"] !== undefined ? _data["isHidden"] : null as any;
            this.isPublishOnly = _data["isPublishOnly"] !== undefined ? _data["isPublishOnly"] : null as any;
            this.coverFileUrl = _data["coverFileUrl"] !== undefined ? _data["coverFileUrl"] : null as any;
            this.priceSupplementFileUrl = _data["priceSupplementFileUrl"] !== undefined ? _data["priceSupplementFileUrl"] : null as any;
            this.scheduledEnableTime = _data["scheduledEnableTime"] ? moment(_data["scheduledEnableTime"].toString()) : null as any;
            this.targetEnabledState = _data["targetEnabledState"] !== undefined ? _data["targetEnabledState"] : null as any;
            this.isReplaceSelection = _data["isReplaceSelection"] !== undefined ? _data["isReplaceSelection"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceSeries {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceSeries();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["listPricePlatForm"] = this.listPricePlatForm ? this.listPricePlatForm.toJSON() : null as any;
        data["listPricePlatFormId"] = this.listPricePlatFormId !== undefined ? this.listPricePlatFormId : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        data["seriesDescribe"] = this.seriesDescribe !== undefined ? this.seriesDescribe : null as any;
        data["seriesApplicationObject"] = this.seriesApplicationObject !== undefined ? this.seriesApplicationObject : null as any;
        data["seriesVersionsNo"] = this.seriesVersionsNo !== undefined ? this.seriesVersionsNo : null as any;
        data["seriesVersionsTakeEffectTime"] = this.seriesVersionsTakeEffectTime ? this.seriesVersionsTakeEffectTime.toISOString() : null as any;
        data["seriesVersionsDescribe"] = this.seriesVersionsDescribe !== undefined ? this.seriesVersionsDescribe : null as any;
        data["versionsIsTakeEffect"] = this.versionsIsTakeEffect !== undefined ? this.versionsIsTakeEffect : null as any;
        data["versionsApprovalStatus"] = this.versionsApprovalStatus !== undefined ? this.versionsApprovalStatus : null as any;
        data["seriesId"] = this.seriesId !== undefined ? this.seriesId : null as any;
        data["seriesVCType"] = this.seriesVCType !== undefined ? this.seriesVCType : null as any;
        if (Array.isArray(this.listPriceBasicMotorPrices)) {
            data["listPriceBasicMotorPrices"] = [];
            for (let item of this.listPriceBasicMotorPrices)
                data["listPriceBasicMotorPrices"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.listPriceVCPrices)) {
            data["listPriceVCPrices"] = [];
            for (let item of this.listPriceVCPrices)
                data["listPriceVCPrices"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.listPriceSeriesCustomers)) {
            data["listPriceSeriesCustomers"] = [];
            for (let item of this.listPriceSeriesCustomers)
                data["listPriceSeriesCustomers"].push(item ? item.toJSON() : null as any);
        }
        data["listPriceType"] = this.listPriceType !== undefined ? this.listPriceType : null as any;
        data["cusomterCode"] = this.cusomterCode !== undefined ? this.cusomterCode : null as any;
        data["expirationTime"] = this.expirationTime ? this.expirationTime.toISOString() : null as any;
        data["isPublishProductAnnouncement"] = this.isPublishProductAnnouncement !== undefined ? this.isPublishProductAnnouncement : null as any;
        data["isPublishAnnouncement"] = this.isPublishAnnouncement !== undefined ? this.isPublishAnnouncement : null as any;
        data["announcementPublishTime"] = this.announcementPublishTime ? this.announcementPublishTime.toISOString() : null as any;
        data["isHidden"] = this.isHidden !== undefined ? this.isHidden : null as any;
        data["isPublishOnly"] = this.isPublishOnly !== undefined ? this.isPublishOnly : null as any;
        data["coverFileUrl"] = this.coverFileUrl !== undefined ? this.coverFileUrl : null as any;
        data["priceSupplementFileUrl"] = this.priceSupplementFileUrl !== undefined ? this.priceSupplementFileUrl : null as any;
        data["scheduledEnableTime"] = this.scheduledEnableTime ? this.scheduledEnableTime.toISOString() : null as any;
        data["targetEnabledState"] = this.targetEnabledState !== undefined ? this.targetEnabledState : null as any;
        data["isReplaceSelection"] = this.isReplaceSelection !== undefined ? this.isReplaceSelection : null as any;
        return data;
    }
}

/** 面价详情页审批信息 */
export class ListPriceSeriesApprovalInfoDto {
    /** 审批实例Id */
    approvalInstanceId!: string;
    status!: ListPriceApprovalInstanceStatus;
    /** 提交时间 */
    submitTime!: moment.Moment;
    /** 提交人用户Id */
    submitterUserId!: number | null;
    /** 提交备注 */
    submitRemark!: string | null;
    /** 当前节点名称 */
    currentNodeName!: string | null;
    /** 完成时间 */
    finishedTime!: moment.Moment | null;
    /** 审批记录 */
    records!: ListPriceSeriesApprovalRecordDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.approvalInstanceId = _data["approvalInstanceId"] !== undefined ? _data["approvalInstanceId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.submitTime = _data["submitTime"] ? moment(_data["submitTime"].toString()) : null as any;
            this.submitterUserId = _data["submitterUserId"] !== undefined ? _data["submitterUserId"] : null as any;
            this.submitRemark = _data["submitRemark"] !== undefined ? _data["submitRemark"] : null as any;
            this.currentNodeName = _data["currentNodeName"] !== undefined ? _data["currentNodeName"] : null as any;
            this.finishedTime = _data["finishedTime"] ? moment(_data["finishedTime"].toString()) : null as any;
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(ListPriceSeriesApprovalRecordDto.fromJS(item));
            }
            else {
                this.records = null as any;
            }
        }
    }

    static fromJS(data: any): ListPriceSeriesApprovalInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceSeriesApprovalInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalInstanceId"] = this.approvalInstanceId !== undefined ? this.approvalInstanceId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["submitTime"] = this.submitTime ? this.submitTime.toISOString() : null as any;
        data["submitterUserId"] = this.submitterUserId !== undefined ? this.submitterUserId : null as any;
        data["submitRemark"] = this.submitRemark !== undefined ? this.submitRemark : null as any;
        data["currentNodeName"] = this.currentNodeName !== undefined ? this.currentNodeName : null as any;
        data["finishedTime"] = this.finishedTime ? this.finishedTime.toISOString() : null as any;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 面价详情页审批记录 */
export class ListPriceSeriesApprovalRecordDto {
    /** 审批节点实例Id */
    approvalInstanceNodeId!: string;
    /** 节点名称 */
    nodeName!: string | null;
    /** 节点顺序 */
    sequence!: number;
    status!: ListPriceApprovalNodeStatus;
    /** 面价表编号 */
    seriesVersion!: string | null;
    /** 面价表名称 */
    seriesName!: string | null;
    /** 审批人用户Id */
    approverUserId!: number | null;
    /** 审批时间 */
    approvalTime!: moment.Moment | null;
    /** 审批意见 */
    comments!: string | null;

    init(_data?: any) {
        if (_data) {
            this.approvalInstanceNodeId = _data["approvalInstanceNodeId"] !== undefined ? _data["approvalInstanceNodeId"] : null as any;
            this.nodeName = _data["nodeName"] !== undefined ? _data["nodeName"] : null as any;
            this.sequence = _data["sequence"] !== undefined ? _data["sequence"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.seriesVersion = _data["seriesVersion"] !== undefined ? _data["seriesVersion"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
            this.approverUserId = _data["approverUserId"] !== undefined ? _data["approverUserId"] : null as any;
            this.approvalTime = _data["approvalTime"] ? moment(_data["approvalTime"].toString()) : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceSeriesApprovalRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceSeriesApprovalRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalInstanceNodeId"] = this.approvalInstanceNodeId !== undefined ? this.approvalInstanceNodeId : null as any;
        data["nodeName"] = this.nodeName !== undefined ? this.nodeName : null as any;
        data["sequence"] = this.sequence !== undefined ? this.sequence : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["seriesVersion"] = this.seriesVersion !== undefined ? this.seriesVersion : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        data["approverUserId"] = this.approverUserId !== undefined ? this.approverUserId : null as any;
        data["approvalTime"] = this.approvalTime ? this.approvalTime.toISOString() : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        return data;
    }
}

export class ListPriceSeriesAuthorizedUserDto {
    id!: string;
    userId!: number;
    userName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceSeriesAuthorizedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceSeriesAuthorizedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        return data;
    }
}

export class ListPriceSeriesChangeDto {
    id!: string;
    listPriceSeriesId!: string;
    /** 系列所属平台name */
    listPricePlatFormName!: string | null;
    dataItemType!: ListPriceDataItemType;
    dataItemName!: string | null;
    changeType!: ListPriceChangeType;
    oldValue!: string | null;
    newValue!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.listPricePlatFormName = _data["listPricePlatFormName"] !== undefined ? _data["listPricePlatFormName"] : null as any;
            this.dataItemType = _data["dataItemType"] !== undefined ? _data["dataItemType"] : null as any;
            this.dataItemName = _data["dataItemName"] !== undefined ? _data["dataItemName"] : null as any;
            this.changeType = _data["changeType"] !== undefined ? _data["changeType"] : null as any;
            this.oldValue = _data["oldValue"] !== undefined ? _data["oldValue"] : null as any;
            this.newValue = _data["newValue"] !== undefined ? _data["newValue"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceSeriesChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceSeriesChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["listPricePlatFormName"] = this.listPricePlatFormName !== undefined ? this.listPricePlatFormName : null as any;
        data["dataItemType"] = this.dataItemType !== undefined ? this.dataItemType : null as any;
        data["dataItemName"] = this.dataItemName !== undefined ? this.dataItemName : null as any;
        data["changeType"] = this.changeType !== undefined ? this.changeType : null as any;
        data["oldValue"] = this.oldValue !== undefined ? this.oldValue : null as any;
        data["newValue"] = this.newValue !== undefined ? this.newValue : null as any;
        return data;
    }
}

export class ListPriceSeriesCustomer {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    customerCode!: string;
    customerName!: string | null;
    subCustomerCode!: string;
    subCustomerName!: string | null;
    listPriceId!: string;
    listPriceSeries!: ListPriceSeries;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.subCustomerCode = _data["subCustomerCode"] !== undefined ? _data["subCustomerCode"] : null as any;
            this.subCustomerName = _data["subCustomerName"] !== undefined ? _data["subCustomerName"] : null as any;
            this.listPriceId = _data["listPriceId"] !== undefined ? _data["listPriceId"] : null as any;
            this.listPriceSeries = _data["listPriceSeries"] ? ListPriceSeries.fromJS(_data["listPriceSeries"]) : null as any;
        }
    }

    static fromJS(data: any): ListPriceSeriesCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceSeriesCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["subCustomerCode"] = this.subCustomerCode !== undefined ? this.subCustomerCode : null as any;
        data["subCustomerName"] = this.subCustomerName !== undefined ? this.subCustomerName : null as any;
        data["listPriceId"] = this.listPriceId !== undefined ? this.listPriceId : null as any;
        data["listPriceSeries"] = this.listPriceSeries ? this.listPriceSeries.toJSON() : null as any;
        return data;
    }
}

export class ListPriceSeriesCustomerDto {
    /** 客户编号 */
    customerCode!: string;
    /** 客户名称 */
    customerName!: string | null;
    /** 二级客户Id */
    subCustomerCode!: string;
    /** 二级客户名称 */
    subCustomerName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.subCustomerCode = _data["subCustomerCode"] !== undefined ? _data["subCustomerCode"] : null as any;
            this.subCustomerName = _data["subCustomerName"] !== undefined ? _data["subCustomerName"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceSeriesCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceSeriesCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["subCustomerCode"] = this.subCustomerCode !== undefined ? this.subCustomerCode : null as any;
        data["subCustomerName"] = this.subCustomerName !== undefined ? this.subCustomerName : null as any;
        return data;
    }
}

export class ListPriceSeriesDto {
    id!: string;
    /** 系列所属平台Id */
    listPricePlatFormId!: string;
    /** 系列所属平台name */
    listPricePlatFormName!: string | null;
    /** 平台所属人Id */
    platFormOwnerId!: string | null;
    /** 平台所属人名称 */
    platFormOwnerName!: string | null;
    /** 系列名称
Required为必须 */
    seriesName!: string;
    /** 系列描述
StringLength是string的长度限制 */
    seriesDescribe!: string | null;
    /** 客户列表 */
    customers!: ListPriceSeriesCustomerDto[] | null;
    /** 系列版本编号 */
    seriesVersionsNo!: string | null;
    /** 客户境界编号 */
    customerCode!: string | null;
    /** 系列版本生效时间 */
    seriesVersionsTakeEffectTime!: moment.Moment;
    /** 系列版本描述
StringLength是string的长度限制 */
    seriesVersionsDescribe!: string | null;
    /** 失效时间 */
    versionsEffectExpirationTime!: moment.Moment | null;
    /** 创建时间 */
    creationTime!: moment.Moment;
    /** 系列ID，用于确认当前所有系列为一个系列 */
    seriesId!: string;
    listPriceType!: ListPriceType;
    approvalStatus!: ApprovalStatus;
    /** 创建人 */
    creatorId!: number;
    /** 主机 - 列表中不提供查询 */
    listPriceBasicMotorPrices!: ListPriceBasicMotorPriceDto[] | null;
    /** VC - 列表中不提供查询 */
    listPriceVCPrices!: ListPriceVCPriceDto[] | null;
    /** 价格变更记录 - 列表中不提供查询 */
    listPriceSeriesChanges!: ListPriceSeriesChangeDto[] | null;
    /** 定义的VC机座号 - 列表中不提供查询 */
    definedVCFrameNumbers!: ListPriceVCFrameNumberDto[] | null;
    /** 定义的主机安装方式 - 列表中不提供查询 */
    definedBasicMotorMountings!: ListPriceBasicMotorMountingDto[] | null;
    /** 机座号 */
    frameNumbers!: string[] | null;
    /** 安装方式 */
    basicMotorMountings!: string[] | null;
    /** 极数 */
    poles!: string[] | null;
    /** 功率 */
    powers!: string[] | null;
    /** 打折类型 */
    discountTypes!: string[] | null;
    /** 系列上传VC长代码生成产品类型 */
    seriesVCType!: string;
    /** 是否隐藏 */
    isHidden!: boolean;
    /** 是否仅发布 */
    isPublishOnly!: boolean;
    /** 公告发布时间（独立于产品生效时间，若未设置则使用 SeriesVersionsTakeEffectTime） */
    announcementPublishTime!: moment.Moment | null;
    /** 是否替换选型（默认 false） */
    isReplaceSelection!: boolean;
    /** 封面文件 */
    coverFileUrl!: string | null;
    /** 价格补充附件(Excel) */
    priceSupplementFileUrl!: string | null;
    approvalInfo!: ListPriceSeriesApprovalInfoDto;
    /** 变更字段高亮显示 */
    highlightFields!: string[] | null;
    /** 是否生效 */
    versionsIsTakeEffect!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.listPricePlatFormId = _data["listPricePlatFormId"] !== undefined ? _data["listPricePlatFormId"] : null as any;
            this.listPricePlatFormName = _data["listPricePlatFormName"] !== undefined ? _data["listPricePlatFormName"] : null as any;
            this.platFormOwnerId = _data["platFormOwnerId"] !== undefined ? _data["platFormOwnerId"] : null as any;
            this.platFormOwnerName = _data["platFormOwnerName"] !== undefined ? _data["platFormOwnerName"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
            this.seriesDescribe = _data["seriesDescribe"] !== undefined ? _data["seriesDescribe"] : null as any;
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(ListPriceSeriesCustomerDto.fromJS(item));
            }
            else {
                this.customers = null as any;
            }
            this.seriesVersionsNo = _data["seriesVersionsNo"] !== undefined ? _data["seriesVersionsNo"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.seriesVersionsTakeEffectTime = _data["seriesVersionsTakeEffectTime"] ? moment(_data["seriesVersionsTakeEffectTime"].toString()) : null as any;
            this.seriesVersionsDescribe = _data["seriesVersionsDescribe"] !== undefined ? _data["seriesVersionsDescribe"] : null as any;
            this.versionsEffectExpirationTime = _data["versionsEffectExpirationTime"] ? moment(_data["versionsEffectExpirationTime"].toString()) : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.seriesId = _data["seriesId"] !== undefined ? _data["seriesId"] : null as any;
            this.listPriceType = _data["listPriceType"] !== undefined ? _data["listPriceType"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
            this.creatorId = _data["creatorId"] !== undefined ? _data["creatorId"] : null as any;
            if (Array.isArray(_data["listPriceBasicMotorPrices"])) {
                this.listPriceBasicMotorPrices = [] as any;
                for (let item of _data["listPriceBasicMotorPrices"])
                    this.listPriceBasicMotorPrices!.push(ListPriceBasicMotorPriceDto.fromJS(item));
            }
            else {
                this.listPriceBasicMotorPrices = null as any;
            }
            if (Array.isArray(_data["listPriceVCPrices"])) {
                this.listPriceVCPrices = [] as any;
                for (let item of _data["listPriceVCPrices"])
                    this.listPriceVCPrices!.push(ListPriceVCPriceDto.fromJS(item));
            }
            else {
                this.listPriceVCPrices = null as any;
            }
            if (Array.isArray(_data["listPriceSeriesChanges"])) {
                this.listPriceSeriesChanges = [] as any;
                for (let item of _data["listPriceSeriesChanges"])
                    this.listPriceSeriesChanges!.push(ListPriceSeriesChangeDto.fromJS(item));
            }
            else {
                this.listPriceSeriesChanges = null as any;
            }
            if (Array.isArray(_data["definedVCFrameNumbers"])) {
                this.definedVCFrameNumbers = [] as any;
                for (let item of _data["definedVCFrameNumbers"])
                    this.definedVCFrameNumbers!.push(ListPriceVCFrameNumberDto.fromJS(item));
            }
            else {
                this.definedVCFrameNumbers = null as any;
            }
            if (Array.isArray(_data["definedBasicMotorMountings"])) {
                this.definedBasicMotorMountings = [] as any;
                for (let item of _data["definedBasicMotorMountings"])
                    this.definedBasicMotorMountings!.push(ListPriceBasicMotorMountingDto.fromJS(item));
            }
            else {
                this.definedBasicMotorMountings = null as any;
            }
            if (Array.isArray(_data["frameNumbers"])) {
                this.frameNumbers = [] as any;
                for (let item of _data["frameNumbers"])
                    this.frameNumbers!.push(item);
            }
            else {
                this.frameNumbers = null as any;
            }
            if (Array.isArray(_data["basicMotorMountings"])) {
                this.basicMotorMountings = [] as any;
                for (let item of _data["basicMotorMountings"])
                    this.basicMotorMountings!.push(item);
            }
            else {
                this.basicMotorMountings = null as any;
            }
            if (Array.isArray(_data["poles"])) {
                this.poles = [] as any;
                for (let item of _data["poles"])
                    this.poles!.push(item);
            }
            else {
                this.poles = null as any;
            }
            if (Array.isArray(_data["powers"])) {
                this.powers = [] as any;
                for (let item of _data["powers"])
                    this.powers!.push(item);
            }
            else {
                this.powers = null as any;
            }
            if (Array.isArray(_data["discountTypes"])) {
                this.discountTypes = [] as any;
                for (let item of _data["discountTypes"])
                    this.discountTypes!.push(item);
            }
            else {
                this.discountTypes = null as any;
            }
            this.seriesVCType = _data["seriesVCType"] !== undefined ? _data["seriesVCType"] : null as any;
            this.isHidden = _data["isHidden"] !== undefined ? _data["isHidden"] : null as any;
            this.isPublishOnly = _data["isPublishOnly"] !== undefined ? _data["isPublishOnly"] : null as any;
            this.announcementPublishTime = _data["announcementPublishTime"] ? moment(_data["announcementPublishTime"].toString()) : null as any;
            this.isReplaceSelection = _data["isReplaceSelection"] !== undefined ? _data["isReplaceSelection"] : null as any;
            this.coverFileUrl = _data["coverFileUrl"] !== undefined ? _data["coverFileUrl"] : null as any;
            this.priceSupplementFileUrl = _data["priceSupplementFileUrl"] !== undefined ? _data["priceSupplementFileUrl"] : null as any;
            this.approvalInfo = _data["approvalInfo"] ? ListPriceSeriesApprovalInfoDto.fromJS(_data["approvalInfo"]) : null as any;
            if (Array.isArray(_data["highlightFields"])) {
                this.highlightFields = [] as any;
                for (let item of _data["highlightFields"])
                    this.highlightFields!.push(item);
            }
            else {
                this.highlightFields = null as any;
            }
            this.versionsIsTakeEffect = _data["versionsIsTakeEffect"] !== undefined ? _data["versionsIsTakeEffect"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceSeriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceSeriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["listPricePlatFormId"] = this.listPricePlatFormId !== undefined ? this.listPricePlatFormId : null as any;
        data["listPricePlatFormName"] = this.listPricePlatFormName !== undefined ? this.listPricePlatFormName : null as any;
        data["platFormOwnerId"] = this.platFormOwnerId !== undefined ? this.platFormOwnerId : null as any;
        data["platFormOwnerName"] = this.platFormOwnerName !== undefined ? this.platFormOwnerName : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        data["seriesDescribe"] = this.seriesDescribe !== undefined ? this.seriesDescribe : null as any;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item ? item.toJSON() : null as any);
        }
        data["seriesVersionsNo"] = this.seriesVersionsNo !== undefined ? this.seriesVersionsNo : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["seriesVersionsTakeEffectTime"] = this.seriesVersionsTakeEffectTime ? this.seriesVersionsTakeEffectTime.toISOString() : null as any;
        data["seriesVersionsDescribe"] = this.seriesVersionsDescribe !== undefined ? this.seriesVersionsDescribe : null as any;
        data["versionsEffectExpirationTime"] = this.versionsEffectExpirationTime ? this.versionsEffectExpirationTime.toISOString() : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["seriesId"] = this.seriesId !== undefined ? this.seriesId : null as any;
        data["listPriceType"] = this.listPriceType !== undefined ? this.listPriceType : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        data["creatorId"] = this.creatorId !== undefined ? this.creatorId : null as any;
        if (Array.isArray(this.listPriceBasicMotorPrices)) {
            data["listPriceBasicMotorPrices"] = [];
            for (let item of this.listPriceBasicMotorPrices)
                data["listPriceBasicMotorPrices"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.listPriceVCPrices)) {
            data["listPriceVCPrices"] = [];
            for (let item of this.listPriceVCPrices)
                data["listPriceVCPrices"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.listPriceSeriesChanges)) {
            data["listPriceSeriesChanges"] = [];
            for (let item of this.listPriceSeriesChanges)
                data["listPriceSeriesChanges"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.definedVCFrameNumbers)) {
            data["definedVCFrameNumbers"] = [];
            for (let item of this.definedVCFrameNumbers)
                data["definedVCFrameNumbers"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.definedBasicMotorMountings)) {
            data["definedBasicMotorMountings"] = [];
            for (let item of this.definedBasicMotorMountings)
                data["definedBasicMotorMountings"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.frameNumbers)) {
            data["frameNumbers"] = [];
            for (let item of this.frameNumbers)
                data["frameNumbers"].push(item);
        }
        if (Array.isArray(this.basicMotorMountings)) {
            data["basicMotorMountings"] = [];
            for (let item of this.basicMotorMountings)
                data["basicMotorMountings"].push(item);
        }
        if (Array.isArray(this.poles)) {
            data["poles"] = [];
            for (let item of this.poles)
                data["poles"].push(item);
        }
        if (Array.isArray(this.powers)) {
            data["powers"] = [];
            for (let item of this.powers)
                data["powers"].push(item);
        }
        if (Array.isArray(this.discountTypes)) {
            data["discountTypes"] = [];
            for (let item of this.discountTypes)
                data["discountTypes"].push(item);
        }
        data["seriesVCType"] = this.seriesVCType !== undefined ? this.seriesVCType : null as any;
        data["isHidden"] = this.isHidden !== undefined ? this.isHidden : null as any;
        data["isPublishOnly"] = this.isPublishOnly !== undefined ? this.isPublishOnly : null as any;
        data["announcementPublishTime"] = this.announcementPublishTime ? this.announcementPublishTime.toISOString() : null as any;
        data["isReplaceSelection"] = this.isReplaceSelection !== undefined ? this.isReplaceSelection : null as any;
        data["coverFileUrl"] = this.coverFileUrl !== undefined ? this.coverFileUrl : null as any;
        data["priceSupplementFileUrl"] = this.priceSupplementFileUrl !== undefined ? this.priceSupplementFileUrl : null as any;
        data["approvalInfo"] = this.approvalInfo ? this.approvalInfo.toJSON() : null as any;
        if (Array.isArray(this.highlightFields)) {
            data["highlightFields"] = [];
            for (let item of this.highlightFields)
                data["highlightFields"].push(item);
        }
        data["versionsIsTakeEffect"] = this.versionsIsTakeEffect !== undefined ? this.versionsIsTakeEffect : null as any;
        return data;
    }
}

export class ListPriceSeriesDtoPagedResultDto {
    items!: ListPriceSeriesDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ListPriceSeriesDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceSeriesDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceSeriesDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 公共价格表关联下拉：面价表选项 */
export class ListPriceSeriesOptionDto {
    /** 面价表版本Id */
    listPriceSeriesId!: string;
    /** 系列名称 */
    seriesName!: string | null;
    listPriceType!: ListPriceType;

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
            this.listPriceType = _data["listPriceType"] !== undefined ? _data["listPriceType"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceSeriesOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceSeriesOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        data["listPriceType"] = this.listPriceType !== undefined ? this.listPriceType : null as any;
        return data;
    }
}

export class ListPriceSeriesShortCodeDto {
    /** 系列名 */
    seriesName!: string | null;
    /** 基座号 */
    frameNumber!: number;
    /** 系列短代码 */
    shortCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
            this.frameNumber = _data["frameNumber"] !== undefined ? _data["frameNumber"] : null as any;
            this.shortCode = _data["shortCode"] !== undefined ? _data["shortCode"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceSeriesShortCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceSeriesShortCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        data["frameNumber"] = this.frameNumber !== undefined ? this.frameNumber : null as any;
        data["shortCode"] = this.shortCode !== undefined ? this.shortCode : null as any;
        return data;
    }
}

/** 0 = Default (标准面价) 1 = Custom (自定义面价) 2 = CustomerCode (客户化代码) 3 = JIN (境界面价) */
export enum ListPriceType {
    Default = 0,
    Custom = 1,
    CustomerCode = 2,
    JIN = 3,
}

export class ListPriceVCFrameNumber {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    vcFrameNumber!: string;
    vcFrameNumberShortCode!: string | null;
    listPriceVCPrice!: ListPriceVCPrice[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.vcFrameNumber = _data["vcFrameNumber"] !== undefined ? _data["vcFrameNumber"] : null as any;
            this.vcFrameNumberShortCode = _data["vcFrameNumberShortCode"] !== undefined ? _data["vcFrameNumberShortCode"] : null as any;
            if (Array.isArray(_data["listPriceVCPrice"])) {
                this.listPriceVCPrice = [] as any;
                for (let item of _data["listPriceVCPrice"])
                    this.listPriceVCPrice!.push(ListPriceVCPrice.fromJS(item));
            }
            else {
                this.listPriceVCPrice = null as any;
            }
        }
    }

    static fromJS(data: any): ListPriceVCFrameNumber {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceVCFrameNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["vcFrameNumber"] = this.vcFrameNumber !== undefined ? this.vcFrameNumber : null as any;
        data["vcFrameNumberShortCode"] = this.vcFrameNumberShortCode !== undefined ? this.vcFrameNumberShortCode : null as any;
        if (Array.isArray(this.listPriceVCPrice)) {
            data["listPriceVCPrice"] = [];
            for (let item of this.listPriceVCPrice)
                data["listPriceVCPrice"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class ListPriceVCFrameNumberDto {
    id!: string;
    /** 变量机座号 */
    vcFrameNumber!: string | null;
    /** 变量机座号短码(按机座号生成长代码时用于替换机座号) */
    vcFrameNumberShortCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcFrameNumber = _data["vcFrameNumber"] !== undefined ? _data["vcFrameNumber"] : null as any;
            this.vcFrameNumberShortCode = _data["vcFrameNumberShortCode"] !== undefined ? _data["vcFrameNumberShortCode"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceVCFrameNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceVCFrameNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcFrameNumber"] = this.vcFrameNumber !== undefined ? this.vcFrameNumber : null as any;
        data["vcFrameNumberShortCode"] = this.vcFrameNumberShortCode !== undefined ? this.vcFrameNumberShortCode : null as any;
        return data;
    }
}

export class ListPriceVCPrice {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    vcProductCode!: string | null;
    vcCode!: string | null;
    vcDescribe!: string | null;
    listPriceVCFrameNumberId!: string;
    listPriceVCFrameNumber!: ListPriceVCFrameNumber;
    vcPrice!: string | null;
    vcRemark!: string | null;
    vcType!: string | null;
    vcDiscountType!: string | null;
    listPriceSeriesId!: string;
    listPriceSeries!: ListPriceSeries;
    listPriceType!: ListPriceType;
    isEnabled!: boolean;
    seriesVersion!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.vcProductCode = _data["vcProductCode"] !== undefined ? _data["vcProductCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.vcDescribe = _data["vcDescribe"] !== undefined ? _data["vcDescribe"] : null as any;
            this.listPriceVCFrameNumberId = _data["listPriceVCFrameNumberId"] !== undefined ? _data["listPriceVCFrameNumberId"] : null as any;
            this.listPriceVCFrameNumber = _data["listPriceVCFrameNumber"] ? ListPriceVCFrameNumber.fromJS(_data["listPriceVCFrameNumber"]) : null as any;
            this.vcPrice = _data["vcPrice"] !== undefined ? _data["vcPrice"] : null as any;
            this.vcRemark = _data["vcRemark"] !== undefined ? _data["vcRemark"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.vcDiscountType = _data["vcDiscountType"] !== undefined ? _data["vcDiscountType"] : null as any;
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.listPriceSeries = _data["listPriceSeries"] ? ListPriceSeries.fromJS(_data["listPriceSeries"]) : null as any;
            this.listPriceType = _data["listPriceType"] !== undefined ? _data["listPriceType"] : null as any;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : null as any;
            this.seriesVersion = _data["seriesVersion"] !== undefined ? _data["seriesVersion"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceVCPrice {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceVCPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["vcProductCode"] = this.vcProductCode !== undefined ? this.vcProductCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["vcDescribe"] = this.vcDescribe !== undefined ? this.vcDescribe : null as any;
        data["listPriceVCFrameNumberId"] = this.listPriceVCFrameNumberId !== undefined ? this.listPriceVCFrameNumberId : null as any;
        data["listPriceVCFrameNumber"] = this.listPriceVCFrameNumber ? this.listPriceVCFrameNumber.toJSON() : null as any;
        data["vcPrice"] = this.vcPrice !== undefined ? this.vcPrice : null as any;
        data["vcRemark"] = this.vcRemark !== undefined ? this.vcRemark : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcDiscountType"] = this.vcDiscountType !== undefined ? this.vcDiscountType : null as any;
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["listPriceSeries"] = this.listPriceSeries ? this.listPriceSeries.toJSON() : null as any;
        data["listPriceType"] = this.listPriceType !== undefined ? this.listPriceType : null as any;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        data["seriesVersion"] = this.seriesVersion !== undefined ? this.seriesVersion : null as any;
        return data;
    }
}

export class ListPriceVCPriceDto {
    id!: string;
    /** 变量产品代码 */
    vcProductCode!: string | null;
    /** 变量编号 */
    vcCode!: string | null;
    /** 变量描述 */
    vcDescribe!: string | null;
    /** 变量价格 */
    vcPrice!: string | null;
    /** 变量备注 */
    vcRemark!: string | null;
    /** 变量类型 */
    vcType!: string | null;
    /** 折扣类型 */
    vcDiscountType!: string | null;
    /** 机座号 */
    frameName!: string | null;
    listPriceVCFrameNumberId!: string;
    /** 是否启用 */
    isEnabled!: boolean;
    /** 突出显示字段 */
    highlightFields!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcProductCode = _data["vcProductCode"] !== undefined ? _data["vcProductCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.vcDescribe = _data["vcDescribe"] !== undefined ? _data["vcDescribe"] : null as any;
            this.vcPrice = _data["vcPrice"] !== undefined ? _data["vcPrice"] : null as any;
            this.vcRemark = _data["vcRemark"] !== undefined ? _data["vcRemark"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.vcDiscountType = _data["vcDiscountType"] !== undefined ? _data["vcDiscountType"] : null as any;
            this.frameName = _data["frameName"] !== undefined ? _data["frameName"] : null as any;
            this.listPriceVCFrameNumberId = _data["listPriceVCFrameNumberId"] !== undefined ? _data["listPriceVCFrameNumberId"] : null as any;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : null as any;
            if (Array.isArray(_data["highlightFields"])) {
                this.highlightFields = [] as any;
                for (let item of _data["highlightFields"])
                    this.highlightFields!.push(item);
            }
            else {
                this.highlightFields = null as any;
            }
        }
    }

    static fromJS(data: any): ListPriceVCPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceVCPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcProductCode"] = this.vcProductCode !== undefined ? this.vcProductCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["vcDescribe"] = this.vcDescribe !== undefined ? this.vcDescribe : null as any;
        data["vcPrice"] = this.vcPrice !== undefined ? this.vcPrice : null as any;
        data["vcRemark"] = this.vcRemark !== undefined ? this.vcRemark : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcDiscountType"] = this.vcDiscountType !== undefined ? this.vcDiscountType : null as any;
        data["frameName"] = this.frameName !== undefined ? this.frameName : null as any;
        data["listPriceVCFrameNumberId"] = this.listPriceVCFrameNumberId !== undefined ? this.listPriceVCFrameNumberId : null as any;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        if (Array.isArray(this.highlightFields)) {
            data["highlightFields"] = [];
            for (let item of this.highlightFields)
                data["highlightFields"].push(item);
        }
        return data;
    }
}

export class ListPriceVCPriceDtoPagedResultDto {
    items!: ListPriceVCPriceDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ListPriceVCPriceDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceVCPriceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceVCPriceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 单行编辑返回值（用于前端做“字段级”高亮） */
export class ListPriceVCPriceDtoRowEditResultDto {
    /** 更新后的行数据（合并行对应的全量明细列表） */
    item!: ListPriceVCPriceDto[] | null;
    /** 本次更新发生变化的字段名（前端可据此对单元格做颜色标识） */
    changedFields!: string[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["item"])) {
                this.item = [] as any;
                for (let item of _data["item"])
                    this.item!.push(ListPriceVCPriceDto.fromJS(item));
            }
            else {
                this.item = null as any;
            }
            if (Array.isArray(_data["changedFields"])) {
                this.changedFields = [] as any;
                for (let item of _data["changedFields"])
                    this.changedFields!.push(item);
            }
            else {
                this.changedFields = null as any;
            }
        }
    }

    static fromJS(data: any): ListPriceVCPriceDtoRowEditResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceVCPriceDtoRowEditResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.item)) {
            data["item"] = [];
            for (let item of this.item)
                data["item"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.changedFields)) {
            data["changedFields"] = [];
            for (let item of this.changedFields)
                data["changedFields"].push(item);
        }
        return data;
    }
}

export class ListPriceVcCodeInputDto {
    /** 系列名 */
    seriesName!: string | null;
    /** 基座号 */
    frameNumber!: number;

    init(_data?: any) {
        if (_data) {
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
            this.frameNumber = _data["frameNumber"] !== undefined ? _data["frameNumber"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceVcCodeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceVcCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        data["frameNumber"] = this.frameNumber !== undefined ? this.frameNumber : null as any;
        return data;
    }
}

export class ListPriceVcCodeOutputDto {
    /** Vc编号 */
    vcCode!: string | null;
    /** Vc长代码 */
    vcProductCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.vcProductCode = _data["vcProductCode"] !== undefined ? _data["vcProductCode"] : null as any;
        }
    }

    static fromJS(data: any): ListPriceVcCodeOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriceVcCodeOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["vcProductCode"] = this.vcProductCode !== undefined ? this.vcProductCode : null as any;
        return data;
    }
}

/** 合并导出输入DTO */
export class MergedExportInputDto {
    /** 面价表ID列表 */
    listPriceSeriesIds!: string[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["listPriceSeriesIds"])) {
                this.listPriceSeriesIds = [] as any;
                for (let item of _data["listPriceSeriesIds"])
                    this.listPriceSeriesIds!.push(item);
            }
            else {
                this.listPriceSeriesIds = null as any;
            }
        }
    }

    static fromJS(data: any): MergedExportInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MergedExportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.listPriceSeriesIds)) {
            data["listPriceSeriesIds"] = [];
            for (let item of this.listPriceSeriesIds)
                data["listPriceSeriesIds"].push(item);
        }
        return data;
    }
}

/** 0 = Unchanged 1 = Prefix 2 = Suffix */
export enum ModelCodingRuleType {
    Unchanged = 0,
    Prefix = 1,
    Suffix = 2,
}

/** 主机字段枚举 1 = isReleased (是否对外发布 -> IsReleased (bool)) 2 = basicMotorRateOfWork (功率(kW) -> BasicMotorRateOfWork (string)) 3 = basicMotorSpeed (转速 -> BasicMotorSpeed) 4 = wiringMode (接线方式 -> WiringMode (string)) 5 = frequency (频率 -> Frequency (string)) 6 = eneEff (能效 -> EneEff (string)) 7 = voltage (电压 -> Voltage (string)) 8 = insulation (绝缘等级 -> Insulation (string)) 9 = safty (防护等级 -> Safty (string)) 10 = basicMotorModel (电机型号 -> BasicMotorModel (string)) 11 = basicMotorSeries (电机极数 -> BasicMotorSeries (string)) 12 = typeDesignation (铭牌 -> TypeDesignation (string)) 13 = basicMotorRemark (电机备注 -> BasicMotorRemark (string)) 14 = basicMotorDesignType (电机设计类型 -> BasicMotorDesignType (string)) 15 = listPriceMultiplier (A/B面价系数 -> ListPriceMultiplier (double)) 16 = basicMotorProductCode (主机产品代码 -> BasicMotorProductCode (string) 仅本字段与 basicMotorModel 支持 * 前缀/后缀匹配替换) */
export enum MotorBatchField {
    IsReleased = 1,
    BasicMotorRateOfWork = 2,
    BasicMotorSpeed = 3,
    WiringMode = 4,
    Frequency = 5,
    EneEff = 6,
    Voltage = 7,
    Insulation = 8,
    Safty = 9,
    BasicMotorModel = 10,
    BasicMotorSeries = 11,
    TypeDesignation = 12,
    BasicMotorRemark = 13,
    BasicMotorDesignType = 14,
    ListPriceMultiplier = 15,
    BasicMotorProductCode = 16,
}

/** 电机拼装列更新单元（例如 B3/B5） */
export class MotorMountingCellUpdateDto {
    /** 安装方式 Id */
    listPriceBasicMotorMountingId!: string;
    /** 该安装方式下的产品代码 */
    productCode!: string | null;
    /** 该安装方式下的价格 */
    price!: string | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceBasicMotorMountingId = _data["listPriceBasicMotorMountingId"] !== undefined ? _data["listPriceBasicMotorMountingId"] : null as any;
            this.productCode = _data["productCode"] !== undefined ? _data["productCode"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
        }
    }

    static fromJS(data: any): MotorMountingCellUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorMountingCellUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceBasicMotorMountingId"] = this.listPriceBasicMotorMountingId !== undefined ? this.listPriceBasicMotorMountingId : null as any;
        data["productCode"] = this.productCode !== undefined ? this.productCode : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        return data;
    }
}

/** 多面价表批量修改价格输入Dto */
export class MultiSeriesBatchModifyPriceInputDto {
    /** 面价表（系列版本）Id集合 */
    listPriceSeriesIds!: string[];
    operator!: PriceAdjustOperator;
    /** 参数：乘法为系数；加法为增量（可负） */
    value!: number;
    /** 是否修改主机价格 */
    isModifyMotorPrice!: boolean;
    /** 是否修改VC价格 */
    isModifyVCPrices!: boolean;
    /** 是否提交审核（true=提交审核，false=仅修改价格不提交） */
    isSubmitApproval!: boolean | null;
    /** 生效时间（仅当 IsSubmitApproval=true 时需要填写） */
    seriesVersionsTakeEffectTime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["listPriceSeriesIds"])) {
                this.listPriceSeriesIds = [] as any;
                for (let item of _data["listPriceSeriesIds"])
                    this.listPriceSeriesIds!.push(item);
            }
            else {
                this.listPriceSeriesIds = null as any;
            }
            this.operator = _data["operator"] !== undefined ? _data["operator"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.isModifyMotorPrice = _data["isModifyMotorPrice"] !== undefined ? _data["isModifyMotorPrice"] : null as any;
            this.isModifyVCPrices = _data["isModifyVCPrices"] !== undefined ? _data["isModifyVCPrices"] : null as any;
            this.isSubmitApproval = _data["isSubmitApproval"] !== undefined ? _data["isSubmitApproval"] : null as any;
            this.seriesVersionsTakeEffectTime = _data["seriesVersionsTakeEffectTime"] ? moment(_data["seriesVersionsTakeEffectTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): MultiSeriesBatchModifyPriceInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiSeriesBatchModifyPriceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.listPriceSeriesIds)) {
            data["listPriceSeriesIds"] = [];
            for (let item of this.listPriceSeriesIds)
                data["listPriceSeriesIds"].push(item);
        }
        data["operator"] = this.operator !== undefined ? this.operator : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["isModifyMotorPrice"] = this.isModifyMotorPrice !== undefined ? this.isModifyMotorPrice : null as any;
        data["isModifyVCPrices"] = this.isModifyVCPrices !== undefined ? this.isModifyVCPrices : null as any;
        data["isSubmitApproval"] = this.isSubmitApproval !== undefined ? this.isSubmitApproval : null as any;
        data["seriesVersionsTakeEffectTime"] = this.seriesVersionsTakeEffectTime ? this.seriesVersionsTakeEffectTime.toISOString() : null as any;
        return data;
    }
}

/** 审批列表查询入参 */
export class PagedListPriceApprovalListInputDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | null;
    /** 审批编号（格式：APP-2026-0001） */
    approvalNo!: string | null;
    status!: ListPriceApprovalInstanceStatus;
    /** 面价表 */
    seriesName!: string | null;
    listPriceType!: ListPriceType;
    /** 主机产品代码（模糊匹配） */
    productCode!: string | null;
    /** 提交开始时间 */
    submitStartTime!: moment.Moment | null;
    /** 提交结束时间 */
    submitEndTime!: moment.Moment | null;
    /** 审核开始时间 */
    approvalStartTime!: moment.Moment | null;
    /** 审核结束时间 */
    approvalEndTime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.sorting = _data["sorting"] !== undefined ? _data["sorting"] : null as any;
            this.approvalNo = _data["approvalNo"] !== undefined ? _data["approvalNo"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
            this.listPriceType = _data["listPriceType"] !== undefined ? _data["listPriceType"] : null as any;
            this.productCode = _data["productCode"] !== undefined ? _data["productCode"] : null as any;
            this.submitStartTime = _data["submitStartTime"] ? moment(_data["submitStartTime"].toString()) : null as any;
            this.submitEndTime = _data["submitEndTime"] ? moment(_data["submitEndTime"].toString()) : null as any;
            this.approvalStartTime = _data["approvalStartTime"] ? moment(_data["approvalStartTime"].toString()) : null as any;
            this.approvalEndTime = _data["approvalEndTime"] ? moment(_data["approvalEndTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): PagedListPriceApprovalListInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListPriceApprovalListInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["sorting"] = this.sorting !== undefined ? this.sorting : null as any;
        data["approvalNo"] = this.approvalNo !== undefined ? this.approvalNo : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        data["listPriceType"] = this.listPriceType !== undefined ? this.listPriceType : null as any;
        data["productCode"] = this.productCode !== undefined ? this.productCode : null as any;
        data["submitStartTime"] = this.submitStartTime ? this.submitStartTime.toISOString() : null as any;
        data["submitEndTime"] = this.submitEndTime ? this.submitEndTime.toISOString() : null as any;
        data["approvalStartTime"] = this.approvalStartTime ? this.approvalStartTime.toISOString() : null as any;
        data["approvalEndTime"] = this.approvalEndTime ? this.approvalEndTime.toISOString() : null as any;
        return data;
    }
}

/** 列表查询入参 */
export class PagedListPriceCommonPriceDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | null;
    /** sheet名称 */
    sheetName!: string | null;
    /** 系列名称 */
    seriesName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.sorting = _data["sorting"] !== undefined ? _data["sorting"] : null as any;
            this.sheetName = _data["sheetName"] !== undefined ? _data["sheetName"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
        }
    }

    static fromJS(data: any): PagedListPriceCommonPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListPriceCommonPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["sorting"] = this.sorting !== undefined ? this.sorting : null as any;
        data["sheetName"] = this.sheetName !== undefined ? this.sheetName : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        return data;
    }
}

/** 运算规则 1 = Multiply (当前价格 × 参数) 2 = Add (当前价格 + 参数（可为负数）) */
export enum PriceAdjustOperator {
    Multiply = 1,
    Add = 2,
}

export class Product {
    /** 选型产品组合的唯一ID */
    id!: string | null;
    /** 产品组合编码（不使用） */
    productMixCode!: string | null;
    /** 电机型号 */
    basicMotorModel!: string | null;
    /** 电机产品代码 */
    basicMotorCode!: string | null;
    /** 机座号 */
    frameSize!: number;
    /** 价格查询结果，可能的值为：
S（裸机自带，不需要返回价格），
R（需要技术部门确认价格），
N/A（不能选），
Y（正确返回价格）,
NULL(面价表没有这条数据)
M （需要用户手动输入） */
    unitPriceResult!: string | null;
    /** 面价 */
    unitPrice!: number;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 系列名称 */
    seriesName!: string | null;
    /** 版本 */
    version!: string | null;
    /** 主机类型 */
    basicMotorType!: number | null;
    vc!: VC[] | null;
    /** SC序号 */
    serialNo!: number;
    /** 客户物料号（客户的号） */
    customerMaterialNumber!: string | null;
    /** 产品数量 */
    numberOfProduct!: number;
    /** 1, 来自面价（OIS需要重新取）， 2， GCS报价， 3， 客户自己填 */
    unitPriceType!: string;
    /** 对于 2 报价具有有效期 */
    unitPriceExpiredTime!: moment.Moment | null;
    /** 折扣类型，系数折扣 1,总价折扣 2 */
    multipilerType!: number;
    /** 系数过期时间 */
    multipilerExpiredTime!: moment.Moment | null;
    /** 系数 */
    multiplier!: number;
    /** 缺省系数 */
    defaultMultiplier!: number | null;
    /** 总价 */
    price!: number;
    /** 单价(售价)，存在按单不打折VC的情况下不一定是平均产品单价。 */
    productPrice!: number;
    /** 备注 （客户化代码备注、工艺文件号） */
    remark!: string | null;
    /** 备注二(约定与主机生产、排序无关，但是与创建订单或者主机下单规则有关的信息存放此字段) */
    remarkTwo!: string | null;
    /** 预计交货日期/天数 */
    expectedDeliveryDate!: string;
    /** 技术确认号 (SFDC的号) */
    technicalConfirmation!: string | null;
    /** 技术协议号 */
    technicalSpecifications!: string | null;
    /** 国产报价号 */
    domesticQuotationNumber!: string | null;
    /** 交期评审号 */
    appraisalNumber!: string | null;
    checkResultOutput!: CheckResultOutputDto;
    /** 可打折面价 */
    discountUnitPrice!: number | null;
    /** 按台收不打折 */
    noDiscountByPlatformUnitPrice!: number | null;
    /** 按单收不打折 */
    noDiscountByListUnitPrice!: number | null;
    /** 币种关联编号 */
    currencyId!: string | null;
    prdTech!: Prdtech;
    prdElecs!: Prdelec[] | null;
    /** 是否为PMS派生选型,新增的主机 */
    isNewPMSProduct!: boolean | null;
    /** pre-cal 行号 */
    precalItemNo!: number | null;
    /** precal号 */
    precalId!: string | null;
    /** PMS原始折扣 */
    pmsMultiplier!: number | null;
    /** 总价模式 原始折扣 */
    originalMultiplier!: number | null;
    /** 是否增减了VC或改动了VC的备注信息导致技术协议发生了变动 */
    agreementChanges!: boolean;
    /** 来源报价产品id */
    technologyQuotationProductId!: string | null;
    /** 来源协议产品id (协议是针对产品行的且对所有客户有效，因此在业务上不需要考虑客户变更的场景) */
    technicalSpecificationProductId!: string | null;
    /** 境界标识符 */
    jinCategoryCode!: string | null;
    /** 境界代码版本号 */
    jinVersion!: string | null;
    /** 物料描述 */
    materialDescription!: string | null;
    /** 内含vc备注 */
    insideVCOpenRemarks!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.productMixCode = _data["productMixCode"] !== undefined ? _data["productMixCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.basicMotorType = _data["basicMotorType"] !== undefined ? _data["basicMotorType"] : null as any;
            if (Array.isArray(_data["vc"])) {
                this.vc = [] as any;
                for (let item of _data["vc"])
                    this.vc!.push(VC.fromJS(item));
            }
            else {
                this.vc = null as any;
            }
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.numberOfProduct = _data["numberOfProduct"] !== undefined ? _data["numberOfProduct"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.unitPriceExpiredTime = _data["unitPriceExpiredTime"] ? moment(_data["unitPriceExpiredTime"].toString()) : null as any;
            this.multipilerType = _data["multipilerType"] !== undefined ? _data["multipilerType"] : null as any;
            this.multipilerExpiredTime = _data["multipilerExpiredTime"] ? moment(_data["multipilerExpiredTime"].toString()) : null as any;
            this.multiplier = _data["multiplier"] !== undefined ? _data["multiplier"] : null as any;
            this.defaultMultiplier = _data["defaultMultiplier"] !== undefined ? _data["defaultMultiplier"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            this.productPrice = _data["productPrice"] !== undefined ? _data["productPrice"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.remarkTwo = _data["remarkTwo"] !== undefined ? _data["remarkTwo"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.technicalConfirmation = _data["technicalConfirmation"] !== undefined ? _data["technicalConfirmation"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.domesticQuotationNumber = _data["domesticQuotationNumber"] !== undefined ? _data["domesticQuotationNumber"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.checkResultOutput = _data["checkResultOutput"] ? CheckResultOutputDto.fromJS(_data["checkResultOutput"]) : null as any;
            this.discountUnitPrice = _data["discountUnitPrice"] !== undefined ? _data["discountUnitPrice"] : null as any;
            this.noDiscountByPlatformUnitPrice = _data["noDiscountByPlatformUnitPrice"] !== undefined ? _data["noDiscountByPlatformUnitPrice"] : null as any;
            this.noDiscountByListUnitPrice = _data["noDiscountByListUnitPrice"] !== undefined ? _data["noDiscountByListUnitPrice"] : null as any;
            this.currencyId = _data["currencyId"] !== undefined ? _data["currencyId"] : null as any;
            this.prdTech = _data["prdTech"] ? Prdtech.fromJS(_data["prdTech"]) : null as any;
            if (Array.isArray(_data["prdElecs"])) {
                this.prdElecs = [] as any;
                for (let item of _data["prdElecs"])
                    this.prdElecs!.push(Prdelec.fromJS(item));
            }
            else {
                this.prdElecs = null as any;
            }
            this.isNewPMSProduct = _data["isNewPMSProduct"] !== undefined ? _data["isNewPMSProduct"] : null as any;
            this.precalItemNo = _data["precalItemNo"] !== undefined ? _data["precalItemNo"] : null as any;
            this.precalId = _data["precalId"] !== undefined ? _data["precalId"] : null as any;
            this.pmsMultiplier = _data["pmsMultiplier"] !== undefined ? _data["pmsMultiplier"] : null as any;
            this.originalMultiplier = _data["originalMultiplier"] !== undefined ? _data["originalMultiplier"] : null as any;
            this.agreementChanges = _data["agreementChanges"] !== undefined ? _data["agreementChanges"] : null as any;
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
            this.technicalSpecificationProductId = _data["technicalSpecificationProductId"] !== undefined ? _data["technicalSpecificationProductId"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.materialDescription = _data["materialDescription"] !== undefined ? _data["materialDescription"] : null as any;
            this.insideVCOpenRemarks = _data["insideVCOpenRemarks"] !== undefined ? _data["insideVCOpenRemarks"] : null as any;
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["productMixCode"] = this.productMixCode !== undefined ? this.productMixCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["basicMotorType"] = this.basicMotorType !== undefined ? this.basicMotorType : null as any;
        if (Array.isArray(this.vc)) {
            data["vc"] = [];
            for (let item of this.vc)
                data["vc"].push(item ? item.toJSON() : null as any);
        }
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["numberOfProduct"] = this.numberOfProduct !== undefined ? this.numberOfProduct : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["unitPriceExpiredTime"] = this.unitPriceExpiredTime ? this.unitPriceExpiredTime.toISOString() : null as any;
        data["multipilerType"] = this.multipilerType !== undefined ? this.multipilerType : null as any;
        data["multipilerExpiredTime"] = this.multipilerExpiredTime ? this.multipilerExpiredTime.toISOString() : null as any;
        data["multiplier"] = this.multiplier !== undefined ? this.multiplier : null as any;
        data["defaultMultiplier"] = this.defaultMultiplier !== undefined ? this.defaultMultiplier : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["productPrice"] = this.productPrice !== undefined ? this.productPrice : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["remarkTwo"] = this.remarkTwo !== undefined ? this.remarkTwo : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["technicalConfirmation"] = this.technicalConfirmation !== undefined ? this.technicalConfirmation : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["domesticQuotationNumber"] = this.domesticQuotationNumber !== undefined ? this.domesticQuotationNumber : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["checkResultOutput"] = this.checkResultOutput ? this.checkResultOutput.toJSON() : null as any;
        data["discountUnitPrice"] = this.discountUnitPrice !== undefined ? this.discountUnitPrice : null as any;
        data["noDiscountByPlatformUnitPrice"] = this.noDiscountByPlatformUnitPrice !== undefined ? this.noDiscountByPlatformUnitPrice : null as any;
        data["noDiscountByListUnitPrice"] = this.noDiscountByListUnitPrice !== undefined ? this.noDiscountByListUnitPrice : null as any;
        data["currencyId"] = this.currencyId !== undefined ? this.currencyId : null as any;
        data["prdTech"] = this.prdTech ? this.prdTech.toJSON() : null as any;
        if (Array.isArray(this.prdElecs)) {
            data["prdElecs"] = [];
            for (let item of this.prdElecs)
                data["prdElecs"].push(item ? item.toJSON() : null as any);
        }
        data["isNewPMSProduct"] = this.isNewPMSProduct !== undefined ? this.isNewPMSProduct : null as any;
        data["precalItemNo"] = this.precalItemNo !== undefined ? this.precalItemNo : null as any;
        data["precalId"] = this.precalId !== undefined ? this.precalId : null as any;
        data["pmsMultiplier"] = this.pmsMultiplier !== undefined ? this.pmsMultiplier : null as any;
        data["originalMultiplier"] = this.originalMultiplier !== undefined ? this.originalMultiplier : null as any;
        data["agreementChanges"] = this.agreementChanges !== undefined ? this.agreementChanges : null as any;
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        data["technicalSpecificationProductId"] = this.technicalSpecificationProductId !== undefined ? this.technicalSpecificationProductId : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["materialDescription"] = this.materialDescription !== undefined ? this.materialDescription : null as any;
        data["insideVCOpenRemarks"] = this.insideVCOpenRemarks !== undefined ? this.insideVCOpenRemarks : null as any;
        return data;
    }
}

/** 创建面价表发布公告输入 */
export class PublishListPriceAnnouncementInputDto {
    /** 面价表Id */
    listPriceSeriesId!: string;
    /** 公告标题，为空时系统自动生成 */
    title!: string | null;
    /** 公告类型 */
    certificateType!: string | null;
    /** 是否立即发送邮件 */
    sendMail!: boolean;
    /** 标签类型Id，用于指定公告标签 */
    labelTypeId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.certificateType = _data["certificateType"] !== undefined ? _data["certificateType"] : null as any;
            this.sendMail = _data["sendMail"] !== undefined ? _data["sendMail"] : null as any;
            this.labelTypeId = _data["labelTypeId"] !== undefined ? _data["labelTypeId"] : null as any;
        }
    }

    static fromJS(data: any): PublishListPriceAnnouncementInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublishListPriceAnnouncementInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["certificateType"] = this.certificateType !== undefined ? this.certificateType : null as any;
        data["sendMail"] = this.sendMail !== undefined ? this.sendMail : null as any;
        data["labelTypeId"] = this.labelTypeId !== undefined ? this.labelTypeId : null as any;
        return data;
    }
}

/** 备注项Dto */
export class RemarkItemDto {
    /** 备注Id（更新时必填） */
    id!: string | null;
    /** 备注内容 */
    content!: string;
    /** 排序号 */
    sortOrder!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
        }
    }

    static fromJS(data: any): RemarkItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemarkItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["content"] = this.content !== undefined ? this.content : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        return data;
    }
}

export class SaveCertAdminEmailInputDto {
    /** 境界面价表 Id（ListPriceJINSeries.Id） */
    jinSeriesId!: string;
    /** 证书管理员邮箱 */
    certAdminEmail!: string | null;

    init(_data?: any) {
        if (_data) {
            this.jinSeriesId = _data["jinSeriesId"] !== undefined ? _data["jinSeriesId"] : null as any;
            this.certAdminEmail = _data["certAdminEmail"] !== undefined ? _data["certAdminEmail"] : null as any;
        }
    }

    static fromJS(data: any): SaveCertAdminEmailInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCertAdminEmailInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jinSeriesId"] = this.jinSeriesId !== undefined ? this.jinSeriesId : null as any;
        data["certAdminEmail"] = this.certAdminEmail !== undefined ? this.certAdminEmail : null as any;
        return data;
    }
}

/** 1 = Industry 2 = Customer 3 = ProductExtension 4 = Project */
export enum ScenarioType {
    Industry = 1,
    Customer = 2,
    ProductExtension = 3,
    Project = 4,
}

/** 启用/禁用流程入参 */
export class SetListPriceApprovalFlowEnabledDto {
    /** 流程Id */
    id!: string;
    /** 是否启用 */
    isEnabled!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : null as any;
        }
    }

    static fromJS(data: any): SetListPriceApprovalFlowEnabledDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetListPriceApprovalFlowEnabledDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        return data;
    }
}

/** 启用/禁用面价表入参 */
export class SetSeriesEnabledInputDto {
    /** 面价表Id */
    listPriceSeriesId!: string;
    /** true=启用，false=禁用 */
    isEnabled!: boolean;
    /** 定时时间（可选），不填则立即执行 */
    scheduledTime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : null as any;
            this.scheduledTime = _data["scheduledTime"] ? moment(_data["scheduledTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): SetSeriesEnabledInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetSeriesEnabledInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        data["scheduledTime"] = this.scheduledTime ? this.scheduledTime.toISOString() : null as any;
        return data;
    }
}

/** 发起审批入参 */
export class SubmitListPriceApprovalDto {
    /** 面价表Id */
    listPriceSeriesId!: string;
    changeType!: ListPriceApprovalChangeType;
    /** 提交备注 */
    submitRemark!: string | null;
    /** 提交附件URL列表 */
    attachmentUrls!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.changeType = _data["changeType"] !== undefined ? _data["changeType"] : null as any;
            this.submitRemark = _data["submitRemark"] !== undefined ? _data["submitRemark"] : null as any;
            if (Array.isArray(_data["attachmentUrls"])) {
                this.attachmentUrls = [] as any;
                for (let item of _data["attachmentUrls"])
                    this.attachmentUrls!.push(item);
            }
            else {
                this.attachmentUrls = null as any;
            }
        }
    }

    static fromJS(data: any): SubmitListPriceApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitListPriceApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["changeType"] = this.changeType !== undefined ? this.changeType : null as any;
        data["submitRemark"] = this.submitRemark !== undefined ? this.submitRemark : null as any;
        if (Array.isArray(this.attachmentUrls)) {
            data["attachmentUrls"] = [];
            for (let item of this.attachmentUrls)
                data["attachmentUrls"].push(item);
        }
        return data;
    }
}

/** 补充主机内含VCDto */
export class SupplementMotorInnerVCDto {
    /** 内含VC Id（有值则更新，无值则新增） */
    id!: string | null;
    /** VC代码 */
    vcCode!: string | null;
    /** VC价格 */
    vcPrice!: string | null;
    /** 电机代码 */
    motorCode!: string | null;
    /** JIN代码 */
    jinCode!: string | null;
    /** 备注 */
    remark!: string | null;
    /** VC类型 */
    vcType!: number;
    /** VC展示类型 */
    vcShowType!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.vcPrice = _data["vcPrice"] !== undefined ? _data["vcPrice"] : null as any;
            this.motorCode = _data["motorCode"] !== undefined ? _data["motorCode"] : null as any;
            this.jinCode = _data["jinCode"] !== undefined ? _data["jinCode"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
        }
    }

    static fromJS(data: any): SupplementMotorInnerVCDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplementMotorInnerVCDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["vcPrice"] = this.vcPrice !== undefined ? this.vcPrice : null as any;
        data["motorCode"] = this.motorCode !== undefined ? this.motorCode : null as any;
        data["jinCode"] = this.jinCode !== undefined ? this.jinCode : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        return data;
    }
}

/** 补充主机参数项Dto */
export class SupplementMotorParamItemDto {
    /** 参数Id（有值则更新，无值则新增） */
    id!: string | null;
    /** 能效 */
    eneEff!: string | null;
    /** 频率 */
    frequency!: string | null;
    /** 极数 */
    poleNo!: string | null;
    /** 功率 */
    power!: string | null;
    /** 电压 */
    voltage!: string | null;
    /** 绝缘等级 */
    insulation!: string | null;
    /** 安全防护等级 */
    safty!: string | null;
    /** 接线方式 */
    wiringMode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.insulation = _data["insulation"] !== undefined ? _data["insulation"] : null as any;
            this.safty = _data["safty"] !== undefined ? _data["safty"] : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
        }
    }

    static fromJS(data: any): SupplementMotorParamItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplementMotorParamItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["insulation"] = this.insulation !== undefined ? this.insulation : null as any;
        data["safty"] = this.safty !== undefined ? this.safty : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        return data;
    }
}

/** 补充面价数据入参Dto */
export class SupplementMotorPriceDataDto {
    /** 境界系列Id */
    jinSeriesId!: string;
    /** GCS协助备注 */
    gcsRemark!: string | null;
    /** GCS附件列表 */
    gcsAttachmentUrls!: string[] | null;
    /** 主机数据列表 */
    motors!: SupplementMotorPriceItemDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.jinSeriesId = _data["jinSeriesId"] !== undefined ? _data["jinSeriesId"] : null as any;
            this.gcsRemark = _data["gcsRemark"] !== undefined ? _data["gcsRemark"] : null as any;
            if (Array.isArray(_data["gcsAttachmentUrls"])) {
                this.gcsAttachmentUrls = [] as any;
                for (let item of _data["gcsAttachmentUrls"])
                    this.gcsAttachmentUrls!.push(item);
            }
            else {
                this.gcsAttachmentUrls = null as any;
            }
            if (Array.isArray(_data["motors"])) {
                this.motors = [] as any;
                for (let item of _data["motors"])
                    this.motors!.push(SupplementMotorPriceItemDto.fromJS(item));
            }
            else {
                this.motors = null as any;
            }
        }
    }

    static fromJS(data: any): SupplementMotorPriceDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplementMotorPriceDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jinSeriesId"] = this.jinSeriesId !== undefined ? this.jinSeriesId : null as any;
        data["gcsRemark"] = this.gcsRemark !== undefined ? this.gcsRemark : null as any;
        if (Array.isArray(this.gcsAttachmentUrls)) {
            data["gcsAttachmentUrls"] = [];
            for (let item of this.gcsAttachmentUrls)
                data["gcsAttachmentUrls"].push(item);
        }
        if (Array.isArray(this.motors)) {
            data["motors"] = [];
            for (let item of this.motors)
                data["motors"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 补充主机数据项Dto */
export class SupplementMotorPriceItemDto {
    /** 主机Id（用于更新，如果有值则更新，无值则根据产品代码+序号匹配） */
    listPriceBasicMotorPriceId!: string | null;
    /** 极数 */
    poleNo!: string | null;
    /** 功率 */
    power!: string | null;
    /** 电机型号 */
    basicMotorModel!: string | null;
    /** 产品代码（用于匹配） */
    basicMotorProductCode!: string | null;
    /** 序号（用于加强匹配） */
    serialNo!: string | null;
    /** 价格（B3/B3左等价格） */
    basicMotorPrice!: string | null;
    /** 国产报价号 */
    domesticQuotationNumber!: string | null;
    /** 国产报价号编号 */
    domesticQuotationNumberCode!: string | null;
    /** 主机参数列表 */
    motorParams!: SupplementMotorParamItemDto[] | null;
    /** 主机内含VC列表 */
    innerVCs!: SupplementMotorInnerVCDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceBasicMotorPriceId = _data["listPriceBasicMotorPriceId"] !== undefined ? _data["listPriceBasicMotorPriceId"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorProductCode = _data["basicMotorProductCode"] !== undefined ? _data["basicMotorProductCode"] : null as any;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : null as any;
            this.basicMotorPrice = _data["basicMotorPrice"] !== undefined ? _data["basicMotorPrice"] : null as any;
            this.domesticQuotationNumber = _data["domesticQuotationNumber"] !== undefined ? _data["domesticQuotationNumber"] : null as any;
            this.domesticQuotationNumberCode = _data["domesticQuotationNumberCode"] !== undefined ? _data["domesticQuotationNumberCode"] : null as any;
            if (Array.isArray(_data["motorParams"])) {
                this.motorParams = [] as any;
                for (let item of _data["motorParams"])
                    this.motorParams!.push(SupplementMotorParamItemDto.fromJS(item));
            }
            else {
                this.motorParams = null as any;
            }
            if (Array.isArray(_data["innerVCs"])) {
                this.innerVCs = [] as any;
                for (let item of _data["innerVCs"])
                    this.innerVCs!.push(SupplementMotorInnerVCDto.fromJS(item));
            }
            else {
                this.innerVCs = null as any;
            }
        }
    }

    static fromJS(data: any): SupplementMotorPriceItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplementMotorPriceItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceBasicMotorPriceId"] = this.listPriceBasicMotorPriceId !== undefined ? this.listPriceBasicMotorPriceId : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorProductCode"] = this.basicMotorProductCode !== undefined ? this.basicMotorProductCode : null as any;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : null as any;
        data["basicMotorPrice"] = this.basicMotorPrice !== undefined ? this.basicMotorPrice : null as any;
        data["domesticQuotationNumber"] = this.domesticQuotationNumber !== undefined ? this.domesticQuotationNumber : null as any;
        data["domesticQuotationNumberCode"] = this.domesticQuotationNumberCode !== undefined ? this.domesticQuotationNumberCode : null as any;
        if (Array.isArray(this.motorParams)) {
            data["motorParams"] = [];
            for (let item of this.motorParams)
                data["motorParams"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.innerVCs)) {
            data["innerVCs"] = [];
            for (let item of this.innerVCs)
                data["innerVCs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class TriggerJobDto {
    /** Job 的完整类名（带命名空间），例如：
MyCompany.MyProject.Jobs.ListPriceSeriesMotorSyncJob */
    jobType!: string;
    /** 可选：传递给 Job 的 JSON 参数（如果你的 Job 需要参数的话） */
    argsJson!: string | null;

    init(_data?: any) {
        if (_data) {
            this.jobType = _data["jobType"] !== undefined ? _data["jobType"] : null as any;
            this.argsJson = _data["argsJson"] !== undefined ? _data["argsJson"] : null as any;
        }
    }

    static fromJS(data: any): TriggerJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobType"] = this.jobType !== undefined ? this.jobType : null as any;
        data["argsJson"] = this.argsJson !== undefined ? this.argsJson : null as any;
        return data;
    }
}

/** 0 = Discount (打折) 1 = NoDiscountByPlatform (按台收不打折) 2 = NoDiscountByList (按单收不打折) 3 = NoDiscount (不打折) -1 = NULL (错误) */
export enum UnitPriceType {
    Discount = 0,
    NoDiscountByPlatform = 1,
    NoDiscountByList = 2,
    NoDiscount = 3,
    NULL = -1,
}

/** 更新公告发布时间输入DTO */
export class UpdateAnnouncementPublishTimeInputDto {
    /** 面价表Id */
    listPriceSeriesId!: string;
    /** 新的公告发布时间 */
    newAnnouncementPublishTime!: moment.Moment;

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.newAnnouncementPublishTime = _data["newAnnouncementPublishTime"] ? moment(_data["newAnnouncementPublishTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): UpdateAnnouncementPublishTimeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAnnouncementPublishTimeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["newAnnouncementPublishTime"] = this.newAnnouncementPublishTime ? this.newAnnouncementPublishTime.toISOString() : null as any;
        return data;
    }
}

/** 修改主机参数Dto */
export class UpdateBasicMotorPriceParamsDto {
    /** 面价表Id */
    listPriceSeriesId!: string;
    /** 目标主机Id集合 */
    listPriceBasicMotorPriceId!: string[];
    /** 主机参数 */
    basicMotorParams!: UpsertBasicMotorPriceParamDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            if (Array.isArray(_data["listPriceBasicMotorPriceId"])) {
                this.listPriceBasicMotorPriceId = [] as any;
                for (let item of _data["listPriceBasicMotorPriceId"])
                    this.listPriceBasicMotorPriceId!.push(item);
            }
            else {
                this.listPriceBasicMotorPriceId = null as any;
            }
            if (Array.isArray(_data["basicMotorParams"])) {
                this.basicMotorParams = [] as any;
                for (let item of _data["basicMotorParams"])
                    this.basicMotorParams!.push(UpsertBasicMotorPriceParamDto.fromJS(item));
            }
            else {
                this.basicMotorParams = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateBasicMotorPriceParamsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBasicMotorPriceParamsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        if (Array.isArray(this.listPriceBasicMotorPriceId)) {
            data["listPriceBasicMotorPriceId"] = [];
            for (let item of this.listPriceBasicMotorPriceId)
                data["listPriceBasicMotorPriceId"].push(item);
        }
        if (Array.isArray(this.basicMotorParams)) {
            data["basicMotorParams"] = [];
            for (let item of this.basicMotorParams)
                data["basicMotorParams"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 电机（主机）单行编辑入参 */
export class UpdateListPriceBasicMotorRowInputDto {
    /** 面价表（系列版本）Id */
    listPriceSeriesId!: string;
    /** 合并行对应的明细 Id 集合 */
    rowIds!: string[];
    /** 主机转速 */
    basicMotorSpeed!: string | null;
    /** 主机功率 */
    basicMotorRateOfWork!: string | null;
    /** 主机极数 */
    basicMotorSeries!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 主机备注 */
    basicMotorRemark!: string | null;
    /** 主机设计类型 */
    basicMotorDesignType!: string | null;
    /** 是否启用 */
    isEnabled!: boolean | null;
    /** 是否发布 */
    isReleased!: boolean | null;
    /** 电压 */
    voltage!: string | null;
    /** 频率 */
    frequency!: string | null;
    /** 接线方式 */
    wiringMode!: string | null;
    /** 能效等级 */
    eneEff!: string | null;
    /** 绝缘等级 */
    insulation!: string | null;
    /** 防护/安全等级 */
    safty!: string | null;
    /** 价格表A/B代码系数 */
    listPriceMultiplier!: number | null;
    /** 铭牌 */
    typeDesignation!: string | null;
    /** B3/B5/... 等拼装列更新 */
    mountingCells!: MotorMountingCellUpdateDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            if (Array.isArray(_data["rowIds"])) {
                this.rowIds = [] as any;
                for (let item of _data["rowIds"])
                    this.rowIds!.push(item);
            }
            else {
                this.rowIds = null as any;
            }
            this.basicMotorSpeed = _data["basicMotorSpeed"] !== undefined ? _data["basicMotorSpeed"] : null as any;
            this.basicMotorRateOfWork = _data["basicMotorRateOfWork"] !== undefined ? _data["basicMotorRateOfWork"] : null as any;
            this.basicMotorSeries = _data["basicMotorSeries"] !== undefined ? _data["basicMotorSeries"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorRemark = _data["basicMotorRemark"] !== undefined ? _data["basicMotorRemark"] : null as any;
            this.basicMotorDesignType = _data["basicMotorDesignType"] !== undefined ? _data["basicMotorDesignType"] : null as any;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : null as any;
            this.isReleased = _data["isReleased"] !== undefined ? _data["isReleased"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.insulation = _data["insulation"] !== undefined ? _data["insulation"] : null as any;
            this.safty = _data["safty"] !== undefined ? _data["safty"] : null as any;
            this.listPriceMultiplier = _data["listPriceMultiplier"] !== undefined ? _data["listPriceMultiplier"] : null as any;
            this.typeDesignation = _data["typeDesignation"] !== undefined ? _data["typeDesignation"] : null as any;
            if (Array.isArray(_data["mountingCells"])) {
                this.mountingCells = [] as any;
                for (let item of _data["mountingCells"])
                    this.mountingCells!.push(MotorMountingCellUpdateDto.fromJS(item));
            }
            else {
                this.mountingCells = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateListPriceBasicMotorRowInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateListPriceBasicMotorRowInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        if (Array.isArray(this.rowIds)) {
            data["rowIds"] = [];
            for (let item of this.rowIds)
                data["rowIds"].push(item);
        }
        data["basicMotorSpeed"] = this.basicMotorSpeed !== undefined ? this.basicMotorSpeed : null as any;
        data["basicMotorRateOfWork"] = this.basicMotorRateOfWork !== undefined ? this.basicMotorRateOfWork : null as any;
        data["basicMotorSeries"] = this.basicMotorSeries !== undefined ? this.basicMotorSeries : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorRemark"] = this.basicMotorRemark !== undefined ? this.basicMotorRemark : null as any;
        data["basicMotorDesignType"] = this.basicMotorDesignType !== undefined ? this.basicMotorDesignType : null as any;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        data["isReleased"] = this.isReleased !== undefined ? this.isReleased : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["insulation"] = this.insulation !== undefined ? this.insulation : null as any;
        data["safty"] = this.safty !== undefined ? this.safty : null as any;
        data["listPriceMultiplier"] = this.listPriceMultiplier !== undefined ? this.listPriceMultiplier : null as any;
        data["typeDesignation"] = this.typeDesignation !== undefined ? this.typeDesignation : null as any;
        if (Array.isArray(this.mountingCells)) {
            data["mountingCells"] = [];
            for (let item of this.mountingCells)
                data["mountingCells"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 维护封面 */
export class UpdateListPriceSeriesCoverFileDto {
    /** 面价Id */
    listPriceSeriesId!: string;
    /** 封面地址 */
    coverFileUrl!: string | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.coverFileUrl = _data["coverFileUrl"] !== undefined ? _data["coverFileUrl"] : null as any;
        }
    }

    static fromJS(data: any): UpdateListPriceSeriesCoverFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateListPriceSeriesCoverFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["coverFileUrl"] = this.coverFileUrl !== undefined ? this.coverFileUrl : null as any;
        return data;
    }
}

/** 维护价格补充附件（单个 Excel） */
export class UpdateListPriceSeriesPriceSupplementFileDto {
    /** 面价Id */
    listPriceSeriesId!: string;
    /** 价格补充附件URL（仅限 .xlsx/.xls；传空字符串表示清除） */
    priceSupplementFileUrl!: string | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.priceSupplementFileUrl = _data["priceSupplementFileUrl"] !== undefined ? _data["priceSupplementFileUrl"] : null as any;
        }
    }

    static fromJS(data: any): UpdateListPriceSeriesPriceSupplementFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateListPriceSeriesPriceSupplementFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["priceSupplementFileUrl"] = this.priceSupplementFileUrl !== undefined ? this.priceSupplementFileUrl : null as any;
        return data;
    }
}

/** VC 单行编辑入参 */
export class UpdateListPriceVCRowInputDto {
    /** 面价表（系列版本）Id */
    listPriceSeriesId!: string;
    /** 合并行对应的明细 Id 集合 */
    rowIds!: string[];
    /** VC 描述 */
    vcDescribe!: string | null;
    /** VC 备注 */
    vcRemark!: string | null;
    /** VC 类型 */
    vcType!: string | null;
    /** 折扣类型 */
    vcDiscountType!: string | null;
    /** 是否启用 */
    isEnabled!: boolean | null;
    /** 71/80/.../355 等拼装列更新 */
    frameCells!: VCFrameCellUpdateDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            if (Array.isArray(_data["rowIds"])) {
                this.rowIds = [] as any;
                for (let item of _data["rowIds"])
                    this.rowIds!.push(item);
            }
            else {
                this.rowIds = null as any;
            }
            this.vcDescribe = _data["vcDescribe"] !== undefined ? _data["vcDescribe"] : null as any;
            this.vcRemark = _data["vcRemark"] !== undefined ? _data["vcRemark"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.vcDiscountType = _data["vcDiscountType"] !== undefined ? _data["vcDiscountType"] : null as any;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : null as any;
            if (Array.isArray(_data["frameCells"])) {
                this.frameCells = [] as any;
                for (let item of _data["frameCells"])
                    this.frameCells!.push(VCFrameCellUpdateDto.fromJS(item));
            }
            else {
                this.frameCells = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateListPriceVCRowInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateListPriceVCRowInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        if (Array.isArray(this.rowIds)) {
            data["rowIds"] = [];
            for (let item of this.rowIds)
                data["rowIds"].push(item);
        }
        data["vcDescribe"] = this.vcDescribe !== undefined ? this.vcDescribe : null as any;
        data["vcRemark"] = this.vcRemark !== undefined ? this.vcRemark : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcDiscountType"] = this.vcDiscountType !== undefined ? this.vcDiscountType : null as any;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        if (Array.isArray(this.frameCells)) {
            data["frameCells"] = [];
            for (let item of this.frameCells)
                data["frameCells"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 更新是否替换选型输入DTO */
export class UpdateReplaceSelectionInputDto {
    /** 面价表Id */
    listPriceSeriesId!: string;
    /** 是否替换选型 */
    isReplaceSelection!: boolean;

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.isReplaceSelection = _data["isReplaceSelection"] !== undefined ? _data["isReplaceSelection"] : null as any;
        }
    }

    static fromJS(data: any): UpdateReplaceSelectionInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReplaceSelectionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["isReplaceSelection"] = this.isReplaceSelection !== undefined ? this.isReplaceSelection : null as any;
        return data;
    }
}

/** 更新生效时间输入DTO */
export class UpdateTakeEffectTimeInputDto {
    /** 面价表Id */
    listPriceSeriesId!: string;
    /** 新的生效时间 */
    newTakeEffectTime!: moment.Moment;

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.newTakeEffectTime = _data["newTakeEffectTime"] ? moment(_data["newTakeEffectTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): UpdateTakeEffectTimeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTakeEffectTimeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["newTakeEffectTime"] = this.newTakeEffectTime ? this.newTakeEffectTime.toISOString() : null as any;
        return data;
    }
}

/** 修改VC价格 启用/禁用 */
export class UpdateVcEnabledInputDto {
    /** 面价版本Id */
    listPriceSeriesId!: string;
    /** VCId */
    id!: string;
    /** true=启用，false=禁用 */
    isEnabled!: boolean;

    init(_data?: any) {
        if (_data) {
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : null as any;
        }
    }

    static fromJS(data: any): UpdateVcEnabledInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVcEnabledInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        return data;
    }
}

/** 修改VC价格返回Dto */
export class UpdateVcEnabledResultDto {
    /** VCId */
    id!: string;
    /** 变量编号 */
    vcCode!: string | null;
    /** 变量机座号 */
    vcFrameNumber!: string | null;
    /** 是否启用 */
    isEnabled!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.vcFrameNumber = _data["vcFrameNumber"] !== undefined ? _data["vcFrameNumber"] : null as any;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : null as any;
        }
    }

    static fromJS(data: any): UpdateVcEnabledResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVcEnabledResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["vcFrameNumber"] = this.vcFrameNumber !== undefined ? this.vcFrameNumber : null as any;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        return data;
    }
}

/** 修改主机参数Dto */
export class UpsertBasicMotorPriceParamDto {
    /** Id */
    id!: string | null;
    /** 能效 */
    eneEff!: string | null;
    /** 频率 */
    frequency!: string | null;
    /** 极数 */
    poleNo!: string | null;
    /** 功率 */
    power!: string | null;
    /** 电压 */
    voltage!: string | null;
    /** 绝缘等级 */
    insulation!: string | null;
    /** 安全防护登记 */
    safty!: string | null;
    /** 接线方式 */
    wiringMode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.insulation = _data["insulation"] !== undefined ? _data["insulation"] : null as any;
            this.safty = _data["safty"] !== undefined ? _data["safty"] : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
        }
    }

    static fromJS(data: any): UpsertBasicMotorPriceParamDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertBasicMotorPriceParamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["insulation"] = this.insulation !== undefined ? this.insulation : null as any;
        data["safty"] = this.safty !== undefined ? this.safty : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        return data;
    }
}

export class VC {
    /** 主键ID（原样返回） */
    id!: string | null;
    /** VC 长代码 */
    vcProductCode!: string | null;
    /** VC 短码， 包括999小代码 */
    vcCode!: string | null;
    /** 价格查询结果，可能的值为：
S（裸机自带，不需要返回价格），
R（需要技术部门确认价格），
N/A（不能选），
Y（正确返回价格）,
NULL(面价表没有这条数据)
M （需要用户手动输入） */
    unitPriceResult!: string | null;
    /** VC的面价 */
    unitPrice!: number;
    /** 折扣类型 */
    discountType!: UnitPriceType;
    /** VC含义 */
    meaning!: string | null;
    /** VC开放式内容(OpenVC 备注) */
    remark!: string | null;
    numberWires!: number;
    vcShowType!: VCShowType;
    /** 1, 来自面价（OIS需要重新取）， 2， GCS报价， 3， 客户自己填 */
    unitPriceType!: string;
    /** 有效期 */
    unitPriceExpiredTime!: moment.Moment | null;
    vcType!: VcType;
    vcFreeText!: Vcfreetext[] | null;
    /** 是否为PMS派生选型-后新增的选型 */
    isNewProductVC!: boolean | null;
    /** 来源报价产品VC id */
    technologyQuotationProductVCId!: string | null;
    /** 来源协议产品VC id */
    technicalSpecificationProductVCId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcProductCode = _data["vcProductCode"] !== undefined ? _data["vcProductCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.unitPriceExpiredTime = _data["unitPriceExpiredTime"] ? moment(_data["unitPriceExpiredTime"].toString()) : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            if (Array.isArray(_data["vcFreeText"])) {
                this.vcFreeText = [] as any;
                for (let item of _data["vcFreeText"])
                    this.vcFreeText!.push(Vcfreetext.fromJS(item));
            }
            else {
                this.vcFreeText = null as any;
            }
            this.isNewProductVC = _data["isNewProductVC"] !== undefined ? _data["isNewProductVC"] : null as any;
            this.technologyQuotationProductVCId = _data["technologyQuotationProductVCId"] !== undefined ? _data["technologyQuotationProductVCId"] : null as any;
            this.technicalSpecificationProductVCId = _data["technicalSpecificationProductVCId"] !== undefined ? _data["technicalSpecificationProductVCId"] : null as any;
        }
    }

    static fromJS(data: any): VC {
        data = typeof data === 'object' ? data : {};
        let result = new VC();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcProductCode"] = this.vcProductCode !== undefined ? this.vcProductCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["discountType"] = this.discountType !== undefined ? this.discountType : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["unitPriceExpiredTime"] = this.unitPriceExpiredTime ? this.unitPriceExpiredTime.toISOString() : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        if (Array.isArray(this.vcFreeText)) {
            data["vcFreeText"] = [];
            for (let item of this.vcFreeText)
                data["vcFreeText"].push(item ? item.toJSON() : null as any);
        }
        data["isNewProductVC"] = this.isNewProductVC !== undefined ? this.isNewProductVC : null as any;
        data["technologyQuotationProductVCId"] = this.technologyQuotationProductVCId !== undefined ? this.technologyQuotationProductVCId : null as any;
        data["technicalSpecificationProductVCId"] = this.technicalSpecificationProductVCId !== undefined ? this.technicalSpecificationProductVCId : null as any;
        return data;
    }
}

/** VC 拼装列更新单元 */
export class VCFrameCellUpdateDto {
    /** 机座号 Id */
    listPriceVCFrameNumberId!: string;
    /** 对应价格 */
    price!: string | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceVCFrameNumberId = _data["listPriceVCFrameNumberId"] !== undefined ? _data["listPriceVCFrameNumberId"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
        }
    }

    static fromJS(data: any): VCFrameCellUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new VCFrameCellUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceVCFrameNumberId"] = this.listPriceVCFrameNumberId !== undefined ? this.listPriceVCFrameNumberId : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        return data;
    }
}

export class AddConfirmChangeOrderFromDto {
    taskFormData!: string | null;
    orderChangeOrderFormDto!: string | null;

    init(_data?: any) {
        if (_data) {
            this.taskFormData = _data["taskFormData"] !== undefined ? _data["taskFormData"] : null as any;
            this.orderChangeOrderFormDto = _data["orderChangeOrderFormDto"] !== undefined ? _data["orderChangeOrderFormDto"] : null as any;
        }
    }

    static fromJS(data: any): AddConfirmChangeOrderFromDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddConfirmChangeOrderFromDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskFormData"] = this.taskFormData !== undefined ? this.taskFormData : null as any;
        data["orderChangeOrderFormDto"] = this.orderChangeOrderFormDto !== undefined ? this.orderChangeOrderFormDto : null as any;
        return data;
    }
}

export class AddCustomCodeDto {
    /** 客户物料号 */
    customerMaterialNumber!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 机座号 */
    frameSize!: number;
    /** 预计交货日期/周 */
    expectedDeliveryDate!: string | null;
    /** 备注 */
    remark!: string | null;
    /** 售价 */
    salesPrice!: number;
    /** cp编号 */
    cpCode!: string | null;
    /** cp名称 */
    cpCoName!: string | null;
    /** 客户化代码 */
    customCode!: boolean;
    /** 二级客户代码 */
    finalCustomerCode!: string | null;
    /** 二级客户名称 */
    finalCustomerName!: string | null;
    /** Vc */
    vcCodes!: string | null;
    /** Vc备注 */
    vcCodeRemark!: string | null;
    technicalSpecifications!: string | null;
    oldCPCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.cpCoName = _data["cpCoName"] !== undefined ? _data["cpCoName"] : null as any;
            this.customCode = _data["customCode"] !== undefined ? _data["customCode"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.vcCodes = _data["vcCodes"] !== undefined ? _data["vcCodes"] : null as any;
            this.vcCodeRemark = _data["vcCodeRemark"] !== undefined ? _data["vcCodeRemark"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.oldCPCode = _data["oldCPCode"] !== undefined ? _data["oldCPCode"] : null as any;
        }
    }

    static fromJS(data: any): AddCustomCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["cpCoName"] = this.cpCoName !== undefined ? this.cpCoName : null as any;
        data["customCode"] = this.customCode !== undefined ? this.customCode : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["vcCodes"] = this.vcCodes !== undefined ? this.vcCodes : null as any;
        data["vcCodeRemark"] = this.vcCodeRemark !== undefined ? this.vcCodeRemark : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["oldCPCode"] = this.oldCPCode !== undefined ? this.oldCPCode : null as any;
        return data;
    }
}

export class AddExportOrderProductVCConfirmationDto {
    exportOrderProductsID!: string | null;
    readonly oisExportOrderProductsId!: string | null;
    vcID!: string | null;
    /** VC描述 */
    meaning!: string | null;
    /** 开放式内容 */
    remark!: string | null;
    vcType!: number;
    vcShowType!: number;
    vcOpenOrClose!: number;

    init(_data?: any) {
        if (_data) {
            this.exportOrderProductsID = _data["exportOrderProductsID"] !== undefined ? _data["exportOrderProductsID"] : null as any;
            (this as any).oisExportOrderProductsId = _data["oisExportOrderProductsId"] !== undefined ? _data["oisExportOrderProductsId"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.vcOpenOrClose = _data["vcOpenOrClose"] !== undefined ? _data["vcOpenOrClose"] : null as any;
        }
    }

    static fromJS(data: any): AddExportOrderProductVCConfirmationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddExportOrderProductVCConfirmationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exportOrderProductsID"] = this.exportOrderProductsID !== undefined ? this.exportOrderProductsID : null as any;
        data["oisExportOrderProductsId"] = this.oisExportOrderProductsId !== undefined ? this.oisExportOrderProductsId : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["vcOpenOrClose"] = this.vcOpenOrClose !== undefined ? this.vcOpenOrClose : null as any;
        return data;
    }
}

export class AddOEMShoppingCartDto {
    /** 产品组合Id */
    id!: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): AddOEMShoppingCartDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddOEMShoppingCartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export class AddOISExportOrderDataPermissions {
    /** 国家 */
    country!: string | null;
    userId!: number | null;
    userName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
        }
    }

    static fromJS(data: any): AddOISExportOrderDataPermissions {
        data = typeof data === 'object' ? data : {};
        let result = new AddOISExportOrderDataPermissions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        return data;
    }
}

export class AddOrderFormSmartConfiguratorDto {
    /** 流水ID */
    id!: string | null;
    /** 选型ID */
    userFriendlyID!: string | null;
    /** 选型名称 */
    name!: string | null;
    /** 来源 SOI/MOI */
    sourceId!: string;
    /** CPid */
    clientID!: string;
    /** CP名称 */
    clientName!: string;
    /** 发货地址编码 */
    shippingAddressCode!: string | null;
    /** 发货地址 */
    shippingAddress!: string | null;
    /** 预计交货日期/天数（生产周期，按天 （整个订单的最大交期）） */
    expectedDeliveryDate!: string;
    /** 责任销售编码 */
    responsibleSalesCode!: string;
    /** 责任销售名称 */
    responsibleSalesName!: string;
    /** 特价申请号 */
    specialOfferApplicationNumber!: string | null;
    /** 特价申请号来源 */
    isManual!: boolean;
    products!: Product[] | null;
    /** 直接客户代码(其他无代码) */
    finalCustomerCode!: string | null;
    /** 直接客户名称 */
    finalCustomerName!: string | null;
    /** PMS项目号 */
    projectNo!: string | null;
    projectName!: string | null;
    pmsProjectCode!: string | null;
    /** 币种编号 */
    currencyId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.userFriendlyID = _data["userFriendlyID"] !== undefined ? _data["userFriendlyID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : null as any;
            this.clientID = _data["clientID"] !== undefined ? _data["clientID"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.shippingAddressCode = _data["shippingAddressCode"] !== undefined ? _data["shippingAddressCode"] : null as any;
            this.shippingAddress = _data["shippingAddress"] !== undefined ? _data["shippingAddress"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.responsibleSalesCode = _data["responsibleSalesCode"] !== undefined ? _data["responsibleSalesCode"] : null as any;
            this.responsibleSalesName = _data["responsibleSalesName"] !== undefined ? _data["responsibleSalesName"] : null as any;
            this.specialOfferApplicationNumber = _data["specialOfferApplicationNumber"] !== undefined ? _data["specialOfferApplicationNumber"] : null as any;
            this.isManual = _data["isManual"] !== undefined ? _data["isManual"] : null as any;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(Product.fromJS(item));
            }
            else {
                this.products = null as any;
            }
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.projectNo = _data["projectNo"] !== undefined ? _data["projectNo"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.pmsProjectCode = _data["pmsProjectCode"] !== undefined ? _data["pmsProjectCode"] : null as any;
            this.currencyId = _data["currencyId"] !== undefined ? _data["currencyId"] : null as any;
        }
    }

    static fromJS(data: any): AddOrderFormSmartConfiguratorDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrderFormSmartConfiguratorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["userFriendlyID"] = this.userFriendlyID !== undefined ? this.userFriendlyID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["sourceId"] = this.sourceId !== undefined ? this.sourceId : null as any;
        data["clientID"] = this.clientID !== undefined ? this.clientID : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["shippingAddressCode"] = this.shippingAddressCode !== undefined ? this.shippingAddressCode : null as any;
        data["shippingAddress"] = this.shippingAddress !== undefined ? this.shippingAddress : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["responsibleSalesCode"] = this.responsibleSalesCode !== undefined ? this.responsibleSalesCode : null as any;
        data["responsibleSalesName"] = this.responsibleSalesName !== undefined ? this.responsibleSalesName : null as any;
        data["specialOfferApplicationNumber"] = this.specialOfferApplicationNumber !== undefined ? this.specialOfferApplicationNumber : null as any;
        data["isManual"] = this.isManual !== undefined ? this.isManual : null as any;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : null as any);
        }
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["projectNo"] = this.projectNo !== undefined ? this.projectNo : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["pmsProjectCode"] = this.pmsProjectCode !== undefined ? this.pmsProjectCode : null as any;
        data["currencyId"] = this.currencyId !== undefined ? this.currencyId : null as any;
        return data;
    }
}

export class AddShoppingCartDto {
    /** 产品组合Id */
    id!: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): AddShoppingCartDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddShoppingCartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

/** 单个SN信息 */
export class AddSnItemDto {
    serialNumber!: string | null;
    mappingId!: string;
    sourceCso!: string | null;
    sourceCsoItem!: string | null;
    sourceIso!: string | null;
    sourceIsoItem!: string | null;
    sourceOrderFormId!: string | null;
    sourceProductBasicMotorId!: string | null;
    basicMotorModel!: string | null;
    basicMotorCode!: string | null;
    motorSeries!: string | null;
    frameSize!: number;

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.mappingId = _data["mappingId"] !== undefined ? _data["mappingId"] : null as any;
            this.sourceCso = _data["sourceCso"] !== undefined ? _data["sourceCso"] : null as any;
            this.sourceCsoItem = _data["sourceCsoItem"] !== undefined ? _data["sourceCsoItem"] : null as any;
            this.sourceIso = _data["sourceIso"] !== undefined ? _data["sourceIso"] : null as any;
            this.sourceIsoItem = _data["sourceIsoItem"] !== undefined ? _data["sourceIsoItem"] : null as any;
            this.sourceOrderFormId = _data["sourceOrderFormId"] !== undefined ? _data["sourceOrderFormId"] : null as any;
            this.sourceProductBasicMotorId = _data["sourceProductBasicMotorId"] !== undefined ? _data["sourceProductBasicMotorId"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.motorSeries = _data["motorSeries"] !== undefined ? _data["motorSeries"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
        }
    }

    static fromJS(data: any): AddSnItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddSnItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["mappingId"] = this.mappingId !== undefined ? this.mappingId : null as any;
        data["sourceCso"] = this.sourceCso !== undefined ? this.sourceCso : null as any;
        data["sourceCsoItem"] = this.sourceCsoItem !== undefined ? this.sourceCsoItem : null as any;
        data["sourceIso"] = this.sourceIso !== undefined ? this.sourceIso : null as any;
        data["sourceIsoItem"] = this.sourceIsoItem !== undefined ? this.sourceIsoItem : null as any;
        data["sourceOrderFormId"] = this.sourceOrderFormId !== undefined ? this.sourceOrderFormId : null as any;
        data["sourceProductBasicMotorId"] = this.sourceProductBasicMotorId !== undefined ? this.sourceProductBasicMotorId : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["motorSeries"] = this.motorSeries !== undefined ? this.motorSeries : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        return data;
    }
}

/** 添加SN到费用购物车输入DTO */
export class AddSnToFeeCartDto {
    /** 客户代码 */
    customerCode!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    cartType!: FeeCartType;
    /** 要添加的SN列表 */
    serialNumbers!: AddSnItemDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.cartType = _data["cartType"] !== undefined ? _data["cartType"] : null as any;
            if (Array.isArray(_data["serialNumbers"])) {
                this.serialNumbers = [] as any;
                for (let item of _data["serialNumbers"])
                    this.serialNumbers!.push(AddSnItemDto.fromJS(item));
            }
            else {
                this.serialNumbers = null as any;
            }
        }
    }

    static fromJS(data: any): AddSnToFeeCartDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddSnToFeeCartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["cartType"] = this.cartType !== undefined ? this.cartType : null as any;
        if (Array.isArray(this.serialNumbers)) {
            data["serialNumbers"] = [];
            for (let item of this.serialNumbers)
                data["serialNumbers"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class Application {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    applicationCode!: string | null;
    applicationName!: string | null;
    orderForms!: OrderForm[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.applicationCode = _data["applicationCode"] !== undefined ? _data["applicationCode"] : null as any;
            this.applicationName = _data["applicationName"] !== undefined ? _data["applicationName"] : null as any;
            if (Array.isArray(_data["orderForms"])) {
                this.orderForms = [] as any;
                for (let item of _data["orderForms"])
                    this.orderForms!.push(OrderForm.fromJS(item));
            }
            else {
                this.orderForms = null as any;
            }
        }
    }

    static fromJS(data: any): Application {
        data = typeof data === 'object' ? data : {};
        let result = new Application();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["applicationCode"] = this.applicationCode !== undefined ? this.applicationCode : null as any;
        data["applicationName"] = this.applicationName !== undefined ? this.applicationName : null as any;
        if (Array.isArray(this.orderForms)) {
            data["orderForms"] = [];
            for (let item of this.orderForms)
                data["orderForms"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 审批回调输入DTO */
export class ApprovalCallbackInputDto {
    /** 订单FormId */
    orderFormId!: string;
    approvalStatus!: ApprovalStatus;
    /** 审批消息（拒绝原因等） */
    approvalMessage!: string | null;
    /** 审批人ID */
    approverUserId!: number | null;
    /** 审批时间 */
    approvalTime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
            this.approvalMessage = _data["approvalMessage"] !== undefined ? _data["approvalMessage"] : null as any;
            this.approverUserId = _data["approverUserId"] !== undefined ? _data["approverUserId"] : null as any;
            this.approvalTime = _data["approvalTime"] ? moment(_data["approvalTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApprovalCallbackInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalCallbackInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        data["approvalMessage"] = this.approvalMessage !== undefined ? this.approvalMessage : null as any;
        data["approverUserId"] = this.approverUserId !== undefined ? this.approverUserId : null as any;
        data["approvalTime"] = this.approvalTime ? this.approvalTime.toISOString() : null as any;
        return data;
    }
}

/** 审批回调结果DTO */
export class ApprovalCallbackResultDto {
    /** 是否成功 */
    success!: boolean;
    /** 消息 */
    message!: string | null;

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): ApprovalCallbackResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalCallbackResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }
}

/** 0 = Unread (未阅) 1 = Reviewed (已阅) 2 = Issues (已阅有问题) */
export enum ApprovalStatusEnum {
    Unread = 0,
    Reviewed = 1,
    Issues = 2,
}

/** 0 = error (错误) 1 = UnderReview (待审核) 2 = Approved (审核通过) 3 = Failed (审核未通过) 4 = NotUnderway (待订单处理审核) 5 = Cancel (取消) */
export enum AuditStatus {
    Error = 0,
    UnderReview = 1,
    Approved = 2,
    Failed = 3,
    NotUnderway = 4,
    Cancel = 5,
}

export class AutoApproveOrderJobArgs {
    /** 任务名称--自动审单任务 */
    jobName!: string | null;
    /** 订单id */
    orderFormId!: string;
    cusDetailOutputObj!: GetCusDetailOutput;
    userId!: number;
    userName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.jobName = _data["jobName"] !== undefined ? _data["jobName"] : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.cusDetailOutputObj = _data["cusDetailOutputObj"] ? GetCusDetailOutput.fromJS(_data["cusDetailOutputObj"]) : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
        }
    }

    static fromJS(data: any): AutoApproveOrderJobArgs {
        data = typeof data === 'object' ? data : {};
        let result = new AutoApproveOrderJobArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobName"] = this.jobName !== undefined ? this.jobName : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["cusDetailOutputObj"] = this.cusDetailOutputObj ? this.cusDetailOutputObj.toJSON() : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        return data;
    }
}

/** 0 = Manual (人工操作) 2 = Pending (待审单) 3 = ToBeOperated (待录单) 4 = Operation (录单中) 10 = Operated (已录单) 11 = RPAOperated (自动录单完成) -3 = OperatedFailed (录单失败) -2 = ApproveFailed (审单失败) -1 = Failed (自动化错误) */
export enum AutomateStatusEnum {
    Manual = 0,
    Pending = 2,
    ToBeOperated = 3,
    Operation = 4,
    Operated = 10,
    RPAOperated = 11,
    OperatedFailed = -3,
    ApproveFailed = -2,
    Failed = -1,
}

/** 质量页可选 SN */
export class AvailableFeeCartSnDto {
    serialNumber!: string | null;
    mappingId!: string;
    sourceCso!: string | null;
    sourceCsoItem!: string | null;
    sourceIso!: string | null;
    sourceIsoItem!: string | null;
    basicMotorModel!: string | null;
    basicMotorCode!: string | null;
    motorSeries!: string | null;
    frameSize!: number;
    sourceOrderFormId!: string | null;
    sourceProductBasicMotorId!: string | null;
    customerCode!: string | null;
    customerName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.mappingId = _data["mappingId"] !== undefined ? _data["mappingId"] : null as any;
            this.sourceCso = _data["sourceCso"] !== undefined ? _data["sourceCso"] : null as any;
            this.sourceCsoItem = _data["sourceCsoItem"] !== undefined ? _data["sourceCsoItem"] : null as any;
            this.sourceIso = _data["sourceIso"] !== undefined ? _data["sourceIso"] : null as any;
            this.sourceIsoItem = _data["sourceIsoItem"] !== undefined ? _data["sourceIsoItem"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.motorSeries = _data["motorSeries"] !== undefined ? _data["motorSeries"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.sourceOrderFormId = _data["sourceOrderFormId"] !== undefined ? _data["sourceOrderFormId"] : null as any;
            this.sourceProductBasicMotorId = _data["sourceProductBasicMotorId"] !== undefined ? _data["sourceProductBasicMotorId"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
        }
    }

    static fromJS(data: any): AvailableFeeCartSnDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableFeeCartSnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["mappingId"] = this.mappingId !== undefined ? this.mappingId : null as any;
        data["sourceCso"] = this.sourceCso !== undefined ? this.sourceCso : null as any;
        data["sourceCsoItem"] = this.sourceCsoItem !== undefined ? this.sourceCsoItem : null as any;
        data["sourceIso"] = this.sourceIso !== undefined ? this.sourceIso : null as any;
        data["sourceIsoItem"] = this.sourceIsoItem !== undefined ? this.sourceIsoItem : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["motorSeries"] = this.motorSeries !== undefined ? this.motorSeries : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["sourceOrderFormId"] = this.sourceOrderFormId !== undefined ? this.sourceOrderFormId : null as any;
        data["sourceProductBasicMotorId"] = this.sourceProductBasicMotorId !== undefined ? this.sourceProductBasicMotorId : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        return data;
    }
}

/** 可选SN DTO */
export class AvailableSnDto {
    /** 序列号 */
    serialNumber!: string | null;
    /** MotorSapSnMapping表ID */
    mappingId!: string;
    /** 原CSO号 */
    sourceCso!: string | null;
    /** 原CSO行号 */
    sourceCsoItem!: string | null;
    /** 电机型号 */
    basicMotorModel!: string | null;
    /** 电机编码 */
    basicMotorCode!: string | null;
    /** 主机系列 */
    motorSeries!: string | null;
    /** 机座号 */
    frameSize!: number;
    /** 客户代码 */
    customerCode!: string | null;
    /** 客户名称 */
    customerName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.mappingId = _data["mappingId"] !== undefined ? _data["mappingId"] : null as any;
            this.sourceCso = _data["sourceCso"] !== undefined ? _data["sourceCso"] : null as any;
            this.sourceCsoItem = _data["sourceCsoItem"] !== undefined ? _data["sourceCsoItem"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.motorSeries = _data["motorSeries"] !== undefined ? _data["motorSeries"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
        }
    }

    static fromJS(data: any): AvailableSnDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableSnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["mappingId"] = this.mappingId !== undefined ? this.mappingId : null as any;
        data["sourceCso"] = this.sourceCso !== undefined ? this.sourceCso : null as any;
        data["sourceCsoItem"] = this.sourceCsoItem !== undefined ? this.sourceCsoItem : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["motorSeries"] = this.motorSeries !== undefined ? this.motorSeries : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        return data;
    }
}

export class BatchDownloadFileInput {
    fileName!: string | null;
    name!: string | null;

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): BatchDownloadFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new BatchDownloadFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export class BatchDto {
    approvalId!: string;
    orderFormId!: string;

    init(_data?: any) {
        if (_data) {
            this.approvalId = _data["approvalId"] !== undefined ? _data["approvalId"] : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
        }
    }

    static fromJS(data: any): BatchDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalId"] = this.approvalId !== undefined ? this.approvalId : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        return data;
    }
}

/** 批量 新增/更新客户已维护限制发货时间段 */
export class BatchModifyDeliveryTimeInfoInputDto {
    /** 客户编号 */
    deliveryTimes!: CustomInfosByDeliveryTimeDto[] | null;
    /** 是否生效 */
    isActive!: boolean | null;
    /** 起始时间 */
    startDate!: moment.Moment | null;
    /** 终止时间 */
    endDate!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deliveryTimes"])) {
                this.deliveryTimes = [] as any;
                for (let item of _data["deliveryTimes"])
                    this.deliveryTimes!.push(CustomInfosByDeliveryTimeDto.fromJS(item));
            }
            else {
                this.deliveryTimes = null as any;
            }
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): BatchModifyDeliveryTimeInfoInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchModifyDeliveryTimeInfoInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deliveryTimes)) {
            data["deliveryTimes"] = [];
            for (let item of this.deliveryTimes)
                data["deliveryTimes"].push(item ? item.toJSON() : null as any);
        }
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        return data;
    }
}

/** 导入返回格式 */
export class BiztalkExportOrderResult {
    /** 外销订单编号 */
    exportOrderId!: string;
    /** 状态码 */
    statusCode!: number;
    /** 消息 */
    message!: string | null;
    /** 每一行的提示信息 */
    itemMessage!: string[] | null;
    /** 是否成功 */
    success!: boolean;

    init(_data?: any) {
        if (_data) {
            this.exportOrderId = _data["exportOrderId"] !== undefined ? _data["exportOrderId"] : null as any;
            this.statusCode = _data["statusCode"] !== undefined ? _data["statusCode"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            if (Array.isArray(_data["itemMessage"])) {
                this.itemMessage = [] as any;
                for (let item of _data["itemMessage"])
                    this.itemMessage!.push(item);
            }
            else {
                this.itemMessage = null as any;
            }
            this.success = _data["success"] !== undefined ? _data["success"] : null as any;
        }
    }

    static fromJS(data: any): BiztalkExportOrderResult {
        data = typeof data === 'object' ? data : {};
        let result = new BiztalkExportOrderResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exportOrderId"] = this.exportOrderId !== undefined ? this.exportOrderId : null as any;
        data["statusCode"] = this.statusCode !== undefined ? this.statusCode : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        if (Array.isArray(this.itemMessage)) {
            data["itemMessage"] = [];
            for (let item of this.itemMessage)
                data["itemMessage"].push(item);
        }
        data["success"] = this.success !== undefined ? this.success : null as any;
        return data;
    }
}

export class BomStatusOfProductDto {
    /** 订单ID */
    orderChangeOrderFormId!: string;
    /** 产品ID */
    productId!: string;
    /** 序号 */
    serialNum!: string | null;
    /** 电机型号 */
    basicMM!: string | null;
    /** 电机系列 */
    basicMS!: string | null;
    /** 订单分类 */
    orderCls!: string | null;
    /** 电机编码 */
    basicMC!: string | null;
    /** 基座号 */
    frameSz!: number;
    /** 数量 */
    numProduct!: number;
    /** 系数 */
    mult!: number | null;
    /** pms折扣系数 */
    pmsMult!: number | null;
    /** 总单价 */
    totUPrice!: number | null;
    /** 提出方, 创建时候填写 */
    presPty!: string | null;
    /** 变更原因,创建时候填写 */
    chgRsn!: string | null;
    /** 变更原因,具体原因 */
    chgMatRmk!: string | null;
    /** 责任方,流程回传 */
    respParty!: string | null;
    /** 选型问题类型,流程回传 */
    selIssueType!: string | null;
    /** 选型问题具体描述,流程回传 */
    selIssueDet!: string | null;
    /** 减免金额, 系统最低可接受报价总和 - 客户确认行总价总和 */
    dedAmt!: number | null;
    /** 减免原因 */
    abRsn!: string | null;
    /** 减免提出方 */
    redReq!: string | null;
    /** 减免具体原因 */
    abatInit!: string | null;
    /** BOM是否变更 */
    isBomChanged!: boolean | null;
    /** 物料影响 */
    materialImpact!: boolean;
    /** BOM变更物料类型 */
    chgMatType!: string[] | null;
    /** BOM变更物料备注 */
    bomChgRemark!: string | null;
    /** 计划BOM更新时间 */
    planBomUpdDur!: number | null;
    /** 装配返工工时(单台)(小时) */
    laborHours!: number | null;
    /** 物料交期影响 */
    matDlvImp!: string | null;
    /** 商务折扣 */
    cMultiplier!: number | null;
    /** 产品大类 */
    orderPT!: string | null;
    /** 变更前行总价 */
    preChgTotPrice!: number | null;
    /** 变更前售价 */
    preSalesPrice!: number | null;
    /** 变更后售价 */
    postSalesPrice!: number | null;
    /** 变更后行总价 */
    postCTP!: number | null;
    /** 客户确认行总价 */
    custCtPrice!: number | null;
    /** 变更前系数 */
    preMultiplier!: number | null;
    /** 变更后系数 */
    postMultiplier!: number | null;
    /** 修改前的TP单价,TODO:初始化时候计算 */
    unitTP!: number | null;
    /** 修改前的TP总价,TODO:初始化时候计算 */
    transferPrice!: number | null;
    /** 修改后的TP单价,TODO:在发起流程时候计算 */
    utpMod!: number | null;
    /** 修改后的TP总价,TODO:在发起流程时候计算 */
    tpMod!: number | null;
    /** 产线（字典表Value） */
    prodLine!: string | null;
    /** 产品组,根据 productType 筛选出产品组 */
    prodGrp!: string | null;
    /** 订单类型 */
    oType!: string | null;
    /** 实际BOM完成日期 */
    actBomCompDate!: moment.Moment | null;
    /** 当前计划装配日期 */
    curSchAsmDt!: moment.Moment | null;
    /** BOMDesignerID */
    bomDesID!: string | null;
    /** Bom状态 */
    bomStatus!: string | null;
    sapOT!: string | null;
    pmuSoiC!: string | null;
    /** 系统最低可接受报价 */
    minAcptQuote!: number | null;
    /** 人工报价=系统计算行总价=商务折扣报价 */
    laborQuote!: number | null;
    /** 是否直通 */
    isDirectPass!: boolean | null;
    /** 是否执行 */
    isFeasible!: boolean | null;
    /** 呆滞物料成本 */
    stagnInvCost!: number | null;
    /** 其他呆滞物料成本 */
    addStagnInvCost!: number | null;
    /** 人工工时总费用 */
    totalLaborCost!: number | null;
    /** 商务确认已审批系数(基本等同于pms系数) */
    commConfirmMult!: number | null;
    /** 物料返工工时(单台)(小时) */
    preAssyManHrs!: number | null;
    /** 系统计算交期影响 */
    calcDelivImpact!: number | null;
    /** 计划确认交期影响 */
    planConfImpDeliv!: number | null;
    /** pmu订单号-ISO号 */
    internalSO!: string | null;
    /** LSU订单号-CSO号 */
    customerSO!: string | null;
    /** LSU 行号 */
    csoItem!: string | null;
    /** Pmu 行号 */
    isoItem!: string | null;
    /** 变更费用币种 */
    currencyType!: string | null;
    /** 变更费用,仅针对进口 */
    changePrice!: number | null;
    /** 工艺,是否建议执行 */
    isExecutionAdvised!: boolean | null;
    /** (单台)其他呆滞物料成本*1.2*1.13 */
    addStagnInvCostVisit!: number | null;
    /** (单台)人工工时总费用*1.13 */
    totalLaborCostVisit!: number | null;
    /** 变更后售价（系统报价+变更后单价（VC增减后）+人工报价*1.2*1.13+工时*1.13） */
    postSalesPriceVisit!: number | null;
    /** 变更后总价 */
    postSalesTotalPriceVisit!: number | null;
    /** 是否人工评估总交期影响  加 */
    isManual!: boolean | null;
    fpDateByE!: moment.Moment | null;
    /** 行当前是否修改状态
为系统自行计算，若行有修改则出现 */
    isStatusModifiableByE!: boolean | null;
    /** 修改费用 */
    updatePriceByE!: number | null;
    /** 修改备注 */
    updateRemarksByExport!: string | null;
    /** 产品VC */
    isSpecific!: boolean | null;
    /** 计划BOM完成日 */
    planBomCompletionDate!: string | null;
    /** 实际BOM完成日 */
    actualBomCompletionDateBySAP!: string | null;
    /** 计划装配日 */
    planAssemblyDateBySAP!: string | null;
    /** MPS排产日 */
    actualScheduledDateBySAP!: string | null;
    /** 实际排产日 */
    actualProductionSchedulingDateSAP!: string | null;
    /** 实际开工日期 */
    actualCommencementDateSAP!: string | null;
    /** 计划入库日 */
    plannedPutawayDateBySAP!: string | null;
    /** 实际入库日 */
    actualPutawayDateBySAP!: string | null;
    /** 实际入库数量 */
    actualPutawayQTYBySAP!: number | null;
    pmuSoitemCategoryBySAP!: string | null;
    /** VC变化天数 */
    vcChangeDays!: number | null;
    /** 期望交期是否有变化 */
    hasChange!: boolean | null;
    /** 主流程客户最终确认天数 */
    customerDays!: number | null;
    /** 总交期影响 */
    totalDelayImpact!: number | null;
    /** 主流程总交期影响 */
    mainTotalDelayImpact!: number | null;
    /** 汇率* 关税 */
    exchangeRateAndTariff!: number | null;

    init(_data?: any) {
        if (_data) {
            this.orderChangeOrderFormId = _data["orderChangeOrderFormId"] !== undefined ? _data["orderChangeOrderFormId"] : null as any;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : null as any;
            this.serialNum = _data["serialNum"] !== undefined ? _data["serialNum"] : null as any;
            this.basicMM = _data["basicMM"] !== undefined ? _data["basicMM"] : null as any;
            this.basicMS = _data["basicMS"] !== undefined ? _data["basicMS"] : null as any;
            this.orderCls = _data["orderCls"] !== undefined ? _data["orderCls"] : null as any;
            this.basicMC = _data["basicMC"] !== undefined ? _data["basicMC"] : null as any;
            this.frameSz = _data["frameSz"] !== undefined ? _data["frameSz"] : null as any;
            this.numProduct = _data["numProduct"] !== undefined ? _data["numProduct"] : null as any;
            this.mult = _data["mult"] !== undefined ? _data["mult"] : null as any;
            this.pmsMult = _data["pmsMult"] !== undefined ? _data["pmsMult"] : null as any;
            this.totUPrice = _data["totUPrice"] !== undefined ? _data["totUPrice"] : null as any;
            this.presPty = _data["presPty"] !== undefined ? _data["presPty"] : null as any;
            this.chgRsn = _data["chgRsn"] !== undefined ? _data["chgRsn"] : null as any;
            this.chgMatRmk = _data["chgMatRmk"] !== undefined ? _data["chgMatRmk"] : null as any;
            this.respParty = _data["respParty"] !== undefined ? _data["respParty"] : null as any;
            this.selIssueType = _data["selIssueType"] !== undefined ? _data["selIssueType"] : null as any;
            this.selIssueDet = _data["selIssueDet"] !== undefined ? _data["selIssueDet"] : null as any;
            this.dedAmt = _data["dedAmt"] !== undefined ? _data["dedAmt"] : null as any;
            this.abRsn = _data["abRsn"] !== undefined ? _data["abRsn"] : null as any;
            this.redReq = _data["redReq"] !== undefined ? _data["redReq"] : null as any;
            this.abatInit = _data["abatInit"] !== undefined ? _data["abatInit"] : null as any;
            this.isBomChanged = _data["isBomChanged"] !== undefined ? _data["isBomChanged"] : null as any;
            this.materialImpact = _data["materialImpact"] !== undefined ? _data["materialImpact"] : null as any;
            if (Array.isArray(_data["chgMatType"])) {
                this.chgMatType = [] as any;
                for (let item of _data["chgMatType"])
                    this.chgMatType!.push(item);
            }
            else {
                this.chgMatType = null as any;
            }
            this.bomChgRemark = _data["bomChgRemark"] !== undefined ? _data["bomChgRemark"] : null as any;
            this.planBomUpdDur = _data["planBomUpdDur"] !== undefined ? _data["planBomUpdDur"] : null as any;
            this.laborHours = _data["laborHours"] !== undefined ? _data["laborHours"] : null as any;
            this.matDlvImp = _data["matDlvImp"] !== undefined ? _data["matDlvImp"] : null as any;
            this.cMultiplier = _data["cMultiplier"] !== undefined ? _data["cMultiplier"] : null as any;
            this.orderPT = _data["orderPT"] !== undefined ? _data["orderPT"] : null as any;
            this.preChgTotPrice = _data["preChgTotPrice"] !== undefined ? _data["preChgTotPrice"] : null as any;
            this.preSalesPrice = _data["preSalesPrice"] !== undefined ? _data["preSalesPrice"] : null as any;
            this.postSalesPrice = _data["postSalesPrice"] !== undefined ? _data["postSalesPrice"] : null as any;
            this.postCTP = _data["postCTP"] !== undefined ? _data["postCTP"] : null as any;
            this.custCtPrice = _data["custCtPrice"] !== undefined ? _data["custCtPrice"] : null as any;
            this.preMultiplier = _data["preMultiplier"] !== undefined ? _data["preMultiplier"] : null as any;
            this.postMultiplier = _data["postMultiplier"] !== undefined ? _data["postMultiplier"] : null as any;
            this.unitTP = _data["unitTP"] !== undefined ? _data["unitTP"] : null as any;
            this.transferPrice = _data["transferPrice"] !== undefined ? _data["transferPrice"] : null as any;
            this.utpMod = _data["utpMod"] !== undefined ? _data["utpMod"] : null as any;
            this.tpMod = _data["tpMod"] !== undefined ? _data["tpMod"] : null as any;
            this.prodLine = _data["prodLine"] !== undefined ? _data["prodLine"] : null as any;
            this.prodGrp = _data["prodGrp"] !== undefined ? _data["prodGrp"] : null as any;
            this.oType = _data["oType"] !== undefined ? _data["oType"] : null as any;
            this.actBomCompDate = _data["actBomCompDate"] ? moment(_data["actBomCompDate"].toString()) : null as any;
            this.curSchAsmDt = _data["curSchAsmDt"] ? moment(_data["curSchAsmDt"].toString()) : null as any;
            this.bomDesID = _data["bomDesID"] !== undefined ? _data["bomDesID"] : null as any;
            this.bomStatus = _data["bomStatus"] !== undefined ? _data["bomStatus"] : null as any;
            this.sapOT = _data["sapOT"] !== undefined ? _data["sapOT"] : null as any;
            this.pmuSoiC = _data["pmuSoiC"] !== undefined ? _data["pmuSoiC"] : null as any;
            this.minAcptQuote = _data["minAcptQuote"] !== undefined ? _data["minAcptQuote"] : null as any;
            this.laborQuote = _data["laborQuote"] !== undefined ? _data["laborQuote"] : null as any;
            this.isDirectPass = _data["isDirectPass"] !== undefined ? _data["isDirectPass"] : null as any;
            this.isFeasible = _data["isFeasible"] !== undefined ? _data["isFeasible"] : null as any;
            this.stagnInvCost = _data["stagnInvCost"] !== undefined ? _data["stagnInvCost"] : null as any;
            this.addStagnInvCost = _data["addStagnInvCost"] !== undefined ? _data["addStagnInvCost"] : null as any;
            this.totalLaborCost = _data["totalLaborCost"] !== undefined ? _data["totalLaborCost"] : null as any;
            this.commConfirmMult = _data["commConfirmMult"] !== undefined ? _data["commConfirmMult"] : null as any;
            this.preAssyManHrs = _data["preAssyManHrs"] !== undefined ? _data["preAssyManHrs"] : null as any;
            this.calcDelivImpact = _data["calcDelivImpact"] !== undefined ? _data["calcDelivImpact"] : null as any;
            this.planConfImpDeliv = _data["planConfImpDeliv"] !== undefined ? _data["planConfImpDeliv"] : null as any;
            this.internalSO = _data["internalSO"] !== undefined ? _data["internalSO"] : null as any;
            this.customerSO = _data["customerSO"] !== undefined ? _data["customerSO"] : null as any;
            this.csoItem = _data["csoItem"] !== undefined ? _data["csoItem"] : null as any;
            this.isoItem = _data["isoItem"] !== undefined ? _data["isoItem"] : null as any;
            this.currencyType = _data["currencyType"] !== undefined ? _data["currencyType"] : null as any;
            this.changePrice = _data["changePrice"] !== undefined ? _data["changePrice"] : null as any;
            this.isExecutionAdvised = _data["isExecutionAdvised"] !== undefined ? _data["isExecutionAdvised"] : null as any;
            this.addStagnInvCostVisit = _data["addStagnInvCostVisit"] !== undefined ? _data["addStagnInvCostVisit"] : null as any;
            this.totalLaborCostVisit = _data["totalLaborCostVisit"] !== undefined ? _data["totalLaborCostVisit"] : null as any;
            this.postSalesPriceVisit = _data["postSalesPriceVisit"] !== undefined ? _data["postSalesPriceVisit"] : null as any;
            this.postSalesTotalPriceVisit = _data["postSalesTotalPriceVisit"] !== undefined ? _data["postSalesTotalPriceVisit"] : null as any;
            this.isManual = _data["isManual"] !== undefined ? _data["isManual"] : null as any;
            this.fpDateByE = _data["fpDateByE"] ? moment(_data["fpDateByE"].toString()) : null as any;
            this.isStatusModifiableByE = _data["isStatusModifiableByE"] !== undefined ? _data["isStatusModifiableByE"] : null as any;
            this.updatePriceByE = _data["updatePriceByE"] !== undefined ? _data["updatePriceByE"] : null as any;
            this.updateRemarksByExport = _data["updateRemarksByExport"] !== undefined ? _data["updateRemarksByExport"] : null as any;
            this.isSpecific = _data["isSpecific"] !== undefined ? _data["isSpecific"] : null as any;
            this.planBomCompletionDate = _data["planBomCompletionDate"] !== undefined ? _data["planBomCompletionDate"] : null as any;
            this.actualBomCompletionDateBySAP = _data["actualBomCompletionDateBySAP"] !== undefined ? _data["actualBomCompletionDateBySAP"] : null as any;
            this.planAssemblyDateBySAP = _data["planAssemblyDateBySAP"] !== undefined ? _data["planAssemblyDateBySAP"] : null as any;
            this.actualScheduledDateBySAP = _data["actualScheduledDateBySAP"] !== undefined ? _data["actualScheduledDateBySAP"] : null as any;
            this.actualProductionSchedulingDateSAP = _data["actualProductionSchedulingDateSAP"] !== undefined ? _data["actualProductionSchedulingDateSAP"] : null as any;
            this.actualCommencementDateSAP = _data["actualCommencementDateSAP"] !== undefined ? _data["actualCommencementDateSAP"] : null as any;
            this.plannedPutawayDateBySAP = _data["plannedPutawayDateBySAP"] !== undefined ? _data["plannedPutawayDateBySAP"] : null as any;
            this.actualPutawayDateBySAP = _data["actualPutawayDateBySAP"] !== undefined ? _data["actualPutawayDateBySAP"] : null as any;
            this.actualPutawayQTYBySAP = _data["actualPutawayQTYBySAP"] !== undefined ? _data["actualPutawayQTYBySAP"] : null as any;
            this.pmuSoitemCategoryBySAP = _data["pmuSoitemCategoryBySAP"] !== undefined ? _data["pmuSoitemCategoryBySAP"] : null as any;
            this.vcChangeDays = _data["vcChangeDays"] !== undefined ? _data["vcChangeDays"] : null as any;
            this.hasChange = _data["hasChange"] !== undefined ? _data["hasChange"] : null as any;
            this.customerDays = _data["customerDays"] !== undefined ? _data["customerDays"] : null as any;
            this.totalDelayImpact = _data["totalDelayImpact"] !== undefined ? _data["totalDelayImpact"] : null as any;
            this.mainTotalDelayImpact = _data["mainTotalDelayImpact"] !== undefined ? _data["mainTotalDelayImpact"] : null as any;
            this.exchangeRateAndTariff = _data["exchangeRateAndTariff"] !== undefined ? _data["exchangeRateAndTariff"] : null as any;
        }
    }

    static fromJS(data: any): BomStatusOfProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new BomStatusOfProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderChangeOrderFormId"] = this.orderChangeOrderFormId !== undefined ? this.orderChangeOrderFormId : null as any;
        data["productId"] = this.productId !== undefined ? this.productId : null as any;
        data["serialNum"] = this.serialNum !== undefined ? this.serialNum : null as any;
        data["basicMM"] = this.basicMM !== undefined ? this.basicMM : null as any;
        data["basicMS"] = this.basicMS !== undefined ? this.basicMS : null as any;
        data["orderCls"] = this.orderCls !== undefined ? this.orderCls : null as any;
        data["basicMC"] = this.basicMC !== undefined ? this.basicMC : null as any;
        data["frameSz"] = this.frameSz !== undefined ? this.frameSz : null as any;
        data["numProduct"] = this.numProduct !== undefined ? this.numProduct : null as any;
        data["mult"] = this.mult !== undefined ? this.mult : null as any;
        data["pmsMult"] = this.pmsMult !== undefined ? this.pmsMult : null as any;
        data["totUPrice"] = this.totUPrice !== undefined ? this.totUPrice : null as any;
        data["presPty"] = this.presPty !== undefined ? this.presPty : null as any;
        data["chgRsn"] = this.chgRsn !== undefined ? this.chgRsn : null as any;
        data["chgMatRmk"] = this.chgMatRmk !== undefined ? this.chgMatRmk : null as any;
        data["respParty"] = this.respParty !== undefined ? this.respParty : null as any;
        data["selIssueType"] = this.selIssueType !== undefined ? this.selIssueType : null as any;
        data["selIssueDet"] = this.selIssueDet !== undefined ? this.selIssueDet : null as any;
        data["dedAmt"] = this.dedAmt !== undefined ? this.dedAmt : null as any;
        data["abRsn"] = this.abRsn !== undefined ? this.abRsn : null as any;
        data["redReq"] = this.redReq !== undefined ? this.redReq : null as any;
        data["abatInit"] = this.abatInit !== undefined ? this.abatInit : null as any;
        data["isBomChanged"] = this.isBomChanged !== undefined ? this.isBomChanged : null as any;
        data["materialImpact"] = this.materialImpact !== undefined ? this.materialImpact : null as any;
        if (Array.isArray(this.chgMatType)) {
            data["chgMatType"] = [];
            for (let item of this.chgMatType)
                data["chgMatType"].push(item);
        }
        data["bomChgRemark"] = this.bomChgRemark !== undefined ? this.bomChgRemark : null as any;
        data["planBomUpdDur"] = this.planBomUpdDur !== undefined ? this.planBomUpdDur : null as any;
        data["laborHours"] = this.laborHours !== undefined ? this.laborHours : null as any;
        data["matDlvImp"] = this.matDlvImp !== undefined ? this.matDlvImp : null as any;
        data["cMultiplier"] = this.cMultiplier !== undefined ? this.cMultiplier : null as any;
        data["orderPT"] = this.orderPT !== undefined ? this.orderPT : null as any;
        data["preChgTotPrice"] = this.preChgTotPrice !== undefined ? this.preChgTotPrice : null as any;
        data["preSalesPrice"] = this.preSalesPrice !== undefined ? this.preSalesPrice : null as any;
        data["postSalesPrice"] = this.postSalesPrice !== undefined ? this.postSalesPrice : null as any;
        data["postCTP"] = this.postCTP !== undefined ? this.postCTP : null as any;
        data["custCtPrice"] = this.custCtPrice !== undefined ? this.custCtPrice : null as any;
        data["preMultiplier"] = this.preMultiplier !== undefined ? this.preMultiplier : null as any;
        data["postMultiplier"] = this.postMultiplier !== undefined ? this.postMultiplier : null as any;
        data["unitTP"] = this.unitTP !== undefined ? this.unitTP : null as any;
        data["transferPrice"] = this.transferPrice !== undefined ? this.transferPrice : null as any;
        data["utpMod"] = this.utpMod !== undefined ? this.utpMod : null as any;
        data["tpMod"] = this.tpMod !== undefined ? this.tpMod : null as any;
        data["prodLine"] = this.prodLine !== undefined ? this.prodLine : null as any;
        data["prodGrp"] = this.prodGrp !== undefined ? this.prodGrp : null as any;
        data["oType"] = this.oType !== undefined ? this.oType : null as any;
        data["actBomCompDate"] = this.actBomCompDate ? this.actBomCompDate.toISOString() : null as any;
        data["curSchAsmDt"] = this.curSchAsmDt ? this.curSchAsmDt.toISOString() : null as any;
        data["bomDesID"] = this.bomDesID !== undefined ? this.bomDesID : null as any;
        data["bomStatus"] = this.bomStatus !== undefined ? this.bomStatus : null as any;
        data["sapOT"] = this.sapOT !== undefined ? this.sapOT : null as any;
        data["pmuSoiC"] = this.pmuSoiC !== undefined ? this.pmuSoiC : null as any;
        data["minAcptQuote"] = this.minAcptQuote !== undefined ? this.minAcptQuote : null as any;
        data["laborQuote"] = this.laborQuote !== undefined ? this.laborQuote : null as any;
        data["isDirectPass"] = this.isDirectPass !== undefined ? this.isDirectPass : null as any;
        data["isFeasible"] = this.isFeasible !== undefined ? this.isFeasible : null as any;
        data["stagnInvCost"] = this.stagnInvCost !== undefined ? this.stagnInvCost : null as any;
        data["addStagnInvCost"] = this.addStagnInvCost !== undefined ? this.addStagnInvCost : null as any;
        data["totalLaborCost"] = this.totalLaborCost !== undefined ? this.totalLaborCost : null as any;
        data["commConfirmMult"] = this.commConfirmMult !== undefined ? this.commConfirmMult : null as any;
        data["preAssyManHrs"] = this.preAssyManHrs !== undefined ? this.preAssyManHrs : null as any;
        data["calcDelivImpact"] = this.calcDelivImpact !== undefined ? this.calcDelivImpact : null as any;
        data["planConfImpDeliv"] = this.planConfImpDeliv !== undefined ? this.planConfImpDeliv : null as any;
        data["internalSO"] = this.internalSO !== undefined ? this.internalSO : null as any;
        data["customerSO"] = this.customerSO !== undefined ? this.customerSO : null as any;
        data["csoItem"] = this.csoItem !== undefined ? this.csoItem : null as any;
        data["isoItem"] = this.isoItem !== undefined ? this.isoItem : null as any;
        data["currencyType"] = this.currencyType !== undefined ? this.currencyType : null as any;
        data["changePrice"] = this.changePrice !== undefined ? this.changePrice : null as any;
        data["isExecutionAdvised"] = this.isExecutionAdvised !== undefined ? this.isExecutionAdvised : null as any;
        data["addStagnInvCostVisit"] = this.addStagnInvCostVisit !== undefined ? this.addStagnInvCostVisit : null as any;
        data["totalLaborCostVisit"] = this.totalLaborCostVisit !== undefined ? this.totalLaborCostVisit : null as any;
        data["postSalesPriceVisit"] = this.postSalesPriceVisit !== undefined ? this.postSalesPriceVisit : null as any;
        data["postSalesTotalPriceVisit"] = this.postSalesTotalPriceVisit !== undefined ? this.postSalesTotalPriceVisit : null as any;
        data["isManual"] = this.isManual !== undefined ? this.isManual : null as any;
        data["fpDateByE"] = this.fpDateByE ? this.fpDateByE.toISOString() : null as any;
        data["isStatusModifiableByE"] = this.isStatusModifiableByE !== undefined ? this.isStatusModifiableByE : null as any;
        data["updatePriceByE"] = this.updatePriceByE !== undefined ? this.updatePriceByE : null as any;
        data["updateRemarksByExport"] = this.updateRemarksByExport !== undefined ? this.updateRemarksByExport : null as any;
        data["isSpecific"] = this.isSpecific !== undefined ? this.isSpecific : null as any;
        data["planBomCompletionDate"] = this.planBomCompletionDate !== undefined ? this.planBomCompletionDate : null as any;
        data["actualBomCompletionDateBySAP"] = this.actualBomCompletionDateBySAP !== undefined ? this.actualBomCompletionDateBySAP : null as any;
        data["planAssemblyDateBySAP"] = this.planAssemblyDateBySAP !== undefined ? this.planAssemblyDateBySAP : null as any;
        data["actualScheduledDateBySAP"] = this.actualScheduledDateBySAP !== undefined ? this.actualScheduledDateBySAP : null as any;
        data["actualProductionSchedulingDateSAP"] = this.actualProductionSchedulingDateSAP !== undefined ? this.actualProductionSchedulingDateSAP : null as any;
        data["actualCommencementDateSAP"] = this.actualCommencementDateSAP !== undefined ? this.actualCommencementDateSAP : null as any;
        data["plannedPutawayDateBySAP"] = this.plannedPutawayDateBySAP !== undefined ? this.plannedPutawayDateBySAP : null as any;
        data["actualPutawayDateBySAP"] = this.actualPutawayDateBySAP !== undefined ? this.actualPutawayDateBySAP : null as any;
        data["actualPutawayQTYBySAP"] = this.actualPutawayQTYBySAP !== undefined ? this.actualPutawayQTYBySAP : null as any;
        data["pmuSoitemCategoryBySAP"] = this.pmuSoitemCategoryBySAP !== undefined ? this.pmuSoitemCategoryBySAP : null as any;
        data["vcChangeDays"] = this.vcChangeDays !== undefined ? this.vcChangeDays : null as any;
        data["hasChange"] = this.hasChange !== undefined ? this.hasChange : null as any;
        data["customerDays"] = this.customerDays !== undefined ? this.customerDays : null as any;
        data["totalDelayImpact"] = this.totalDelayImpact !== undefined ? this.totalDelayImpact : null as any;
        data["mainTotalDelayImpact"] = this.mainTotalDelayImpact !== undefined ? this.mainTotalDelayImpact : null as any;
        data["exchangeRateAndTariff"] = this.exchangeRateAndTariff !== undefined ? this.exchangeRateAndTariff : null as any;
        return data;
    }
}

export class BooleanOrderVisualizationListOrderInformationsListValueTuple {

    init(_data?: any) {
    }

    static fromJS(data: any): BooleanOrderVisualizationListOrderInformationsListValueTuple {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanOrderVisualizationListOrderInformationsListValueTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export class BooleanStringValueTuple {

    init(_data?: any) {
    }

    static fromJS(data: any): BooleanStringValueTuple {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanStringValueTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export class BusinessCustomerRelationBackUpEntity {
    id!: string;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    businessCustomerRelationId!: string;
    businessUserId!: number | null;
    businessUserEmailName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.businessCustomerRelationId = _data["businessCustomerRelationId"] !== undefined ? _data["businessCustomerRelationId"] : null as any;
            this.businessUserId = _data["businessUserId"] !== undefined ? _data["businessUserId"] : null as any;
            this.businessUserEmailName = _data["businessUserEmailName"] !== undefined ? _data["businessUserEmailName"] : null as any;
        }
    }

    static fromJS(data: any): BusinessCustomerRelationBackUpEntity {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessCustomerRelationBackUpEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["businessCustomerRelationId"] = this.businessCustomerRelationId !== undefined ? this.businessCustomerRelationId : null as any;
        data["businessUserId"] = this.businessUserId !== undefined ? this.businessUserId : null as any;
        data["businessUserEmailName"] = this.businessUserEmailName !== undefined ? this.businessUserEmailName : null as any;
        return data;
    }
}

export class BusinessCustomerRelationDto {
    id!: string;
    region!: string | null;
    readonly customerCode!: string | null;
    customerName!: string | null;
    /** 商务用户Id */
    businessUserId!: number | null;
    businessUserEmailName!: string | null;
    businessCustomerRelationBackUps!: BusinessCustomerRelationBackUpEntity[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.region = _data["region"] !== undefined ? _data["region"] : null as any;
            (this as any).customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.businessUserId = _data["businessUserId"] !== undefined ? _data["businessUserId"] : null as any;
            this.businessUserEmailName = _data["businessUserEmailName"] !== undefined ? _data["businessUserEmailName"] : null as any;
            if (Array.isArray(_data["businessCustomerRelationBackUps"])) {
                this.businessCustomerRelationBackUps = [] as any;
                for (let item of _data["businessCustomerRelationBackUps"])
                    this.businessCustomerRelationBackUps!.push(BusinessCustomerRelationBackUpEntity.fromJS(item));
            }
            else {
                this.businessCustomerRelationBackUps = null as any;
            }
        }
    }

    static fromJS(data: any): BusinessCustomerRelationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessCustomerRelationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["region"] = this.region !== undefined ? this.region : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["businessUserId"] = this.businessUserId !== undefined ? this.businessUserId : null as any;
        data["businessUserEmailName"] = this.businessUserEmailName !== undefined ? this.businessUserEmailName : null as any;
        if (Array.isArray(this.businessCustomerRelationBackUps)) {
            data["businessCustomerRelationBackUps"] = [];
            for (let item of this.businessCustomerRelationBackUps)
                data["businessCustomerRelationBackUps"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class CTOProductBasicMotor {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    productMixCode!: string | null;
    customerMaterialNumber!: string | null;
    basicMotorModel!: string | null;
    basicMotorCode!: string | null;
    basicMotorSries!: string | null;
    frameSize!: number;
    expectedDeliveryDate!: string | null;
    remark!: string | null;
    salesPrice!: number;
    receivePrdTechJSON!: string | null;
    receivePrdElecsJSON!: string | null;
    cpCode!: string | null;
    cpCoName!: string | null;
    finalCustomerCode!: string | null;
    finalCustomerName!: string | null;
    multiplier!: number;
    multiplierExpiredDate!: moment.Moment | null;
    gssQuotationNo!: string | null;
    gssTechnicalConfirmationNumber!: string | null;
    technicalSpecifications!: string | null;
    customCode!: boolean;
    specialOfferNumber!: string | null;
    appraisalNumber!: string | null;
    technologyQuotationProductId!: string | null;
    technicalSpecificationProductId!: string | null;
    ctoProductVCs!: CTOProductVC[] | null;
    shoppingCarts!: ShoppingCart[] | null;
    status!: ProductBasicMotorCodeStatus;
    confirmStatus!: ProductSyncConfirmStatus;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.productMixCode = _data["productMixCode"] !== undefined ? _data["productMixCode"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.receivePrdTechJSON = _data["receivePrdTechJSON"] !== undefined ? _data["receivePrdTechJSON"] : null as any;
            this.receivePrdElecsJSON = _data["receivePrdElecsJSON"] !== undefined ? _data["receivePrdElecsJSON"] : null as any;
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.cpCoName = _data["cpCoName"] !== undefined ? _data["cpCoName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.multiplier = _data["multiplier"] !== undefined ? _data["multiplier"] : null as any;
            this.multiplierExpiredDate = _data["multiplierExpiredDate"] ? moment(_data["multiplierExpiredDate"].toString()) : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.customCode = _data["customCode"] !== undefined ? _data["customCode"] : null as any;
            this.specialOfferNumber = _data["specialOfferNumber"] !== undefined ? _data["specialOfferNumber"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
            this.technicalSpecificationProductId = _data["technicalSpecificationProductId"] !== undefined ? _data["technicalSpecificationProductId"] : null as any;
            if (Array.isArray(_data["ctoProductVCs"])) {
                this.ctoProductVCs = [] as any;
                for (let item of _data["ctoProductVCs"])
                    this.ctoProductVCs!.push(CTOProductVC.fromJS(item));
            }
            else {
                this.ctoProductVCs = null as any;
            }
            if (Array.isArray(_data["shoppingCarts"])) {
                this.shoppingCarts = [] as any;
                for (let item of _data["shoppingCarts"])
                    this.shoppingCarts!.push(ShoppingCart.fromJS(item));
            }
            else {
                this.shoppingCarts = null as any;
            }
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.confirmStatus = _data["confirmStatus"] !== undefined ? _data["confirmStatus"] : null as any;
        }
    }

    static fromJS(data: any): CTOProductBasicMotor {
        data = typeof data === 'object' ? data : {};
        let result = new CTOProductBasicMotor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["productMixCode"] = this.productMixCode !== undefined ? this.productMixCode : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["receivePrdTechJSON"] = this.receivePrdTechJSON !== undefined ? this.receivePrdTechJSON : null as any;
        data["receivePrdElecsJSON"] = this.receivePrdElecsJSON !== undefined ? this.receivePrdElecsJSON : null as any;
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["cpCoName"] = this.cpCoName !== undefined ? this.cpCoName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["multiplier"] = this.multiplier !== undefined ? this.multiplier : null as any;
        data["multiplierExpiredDate"] = this.multiplierExpiredDate ? this.multiplierExpiredDate.toISOString() : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["customCode"] = this.customCode !== undefined ? this.customCode : null as any;
        data["specialOfferNumber"] = this.specialOfferNumber !== undefined ? this.specialOfferNumber : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        data["technicalSpecificationProductId"] = this.technicalSpecificationProductId !== undefined ? this.technicalSpecificationProductId : null as any;
        if (Array.isArray(this.ctoProductVCs)) {
            data["ctoProductVCs"] = [];
            for (let item of this.ctoProductVCs)
                data["ctoProductVCs"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.shoppingCarts)) {
            data["shoppingCarts"] = [];
            for (let item of this.shoppingCarts)
                data["shoppingCarts"].push(item ? item.toJSON() : null as any);
        }
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["confirmStatus"] = this.confirmStatus !== undefined ? this.confirmStatus : null as any;
        return data;
    }
}

export class CTOProductVC {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    vcProductCode!: string | null;
    vcCode!: string | null;
    discountType!: string | null;
    meaning!: string | null;
    remark!: string | null;
    receiveVcFreeTextJSON!: string | null;
    listPrice!: number;
    technologyQuotationProductVCId!: string | null;
    technicalSpecificationProductVCId!: string | null;
    ctoProductBasicMotor!: CTOProductBasicMotor;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.vcProductCode = _data["vcProductCode"] !== undefined ? _data["vcProductCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.receiveVcFreeTextJSON = _data["receiveVcFreeTextJSON"] !== undefined ? _data["receiveVcFreeTextJSON"] : null as any;
            this.listPrice = _data["listPrice"] !== undefined ? _data["listPrice"] : null as any;
            this.technologyQuotationProductVCId = _data["technologyQuotationProductVCId"] !== undefined ? _data["technologyQuotationProductVCId"] : null as any;
            this.technicalSpecificationProductVCId = _data["technicalSpecificationProductVCId"] !== undefined ? _data["technicalSpecificationProductVCId"] : null as any;
            this.ctoProductBasicMotor = _data["ctoProductBasicMotor"] ? CTOProductBasicMotor.fromJS(_data["ctoProductBasicMotor"]) : null as any;
        }
    }

    static fromJS(data: any): CTOProductVC {
        data = typeof data === 'object' ? data : {};
        let result = new CTOProductVC();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["vcProductCode"] = this.vcProductCode !== undefined ? this.vcProductCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["discountType"] = this.discountType !== undefined ? this.discountType : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["receiveVcFreeTextJSON"] = this.receiveVcFreeTextJSON !== undefined ? this.receiveVcFreeTextJSON : null as any;
        data["listPrice"] = this.listPrice !== undefined ? this.listPrice : null as any;
        data["technologyQuotationProductVCId"] = this.technologyQuotationProductVCId !== undefined ? this.technologyQuotationProductVCId : null as any;
        data["technicalSpecificationProductVCId"] = this.technicalSpecificationProductVCId !== undefined ? this.technicalSpecificationProductVCId : null as any;
        data["ctoProductBasicMotor"] = this.ctoProductBasicMotor ? this.ctoProductBasicMotor.toJSON() : null as any;
        return data;
    }
}

export class CalculateProductForAllDto {
    minimumAcceptableQuote!: number | null;
    laborQuote!: number | null;

    init(_data?: any) {
        if (_data) {
            this.minimumAcceptableQuote = _data["minimumAcceptableQuote"] !== undefined ? _data["minimumAcceptableQuote"] : null as any;
            this.laborQuote = _data["laborQuote"] !== undefined ? _data["laborQuote"] : null as any;
        }
    }

    static fromJS(data: any): CalculateProductForAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateProductForAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumAcceptableQuote"] = this.minimumAcceptableQuote !== undefined ? this.minimumAcceptableQuote : null as any;
        data["laborQuote"] = this.laborQuote !== undefined ? this.laborQuote : null as any;
        return data;
    }
}

export class CalculateProductQuoteDto {
    minAcptQuote!: number | null;
    laborQuote!: number | null;
    cMultiplier!: number | null;
    miniChangePrice!: number | null;

    init(_data?: any) {
        if (_data) {
            this.minAcptQuote = _data["minAcptQuote"] !== undefined ? _data["minAcptQuote"] : null as any;
            this.laborQuote = _data["laborQuote"] !== undefined ? _data["laborQuote"] : null as any;
            this.cMultiplier = _data["cMultiplier"] !== undefined ? _data["cMultiplier"] : null as any;
            this.miniChangePrice = _data["miniChangePrice"] !== undefined ? _data["miniChangePrice"] : null as any;
        }
    }

    static fromJS(data: any): CalculateProductQuoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateProductQuoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minAcptQuote"] = this.minAcptQuote !== undefined ? this.minAcptQuote : null as any;
        data["laborQuote"] = this.laborQuote !== undefined ? this.laborQuote : null as any;
        data["cMultiplier"] = this.cMultiplier !== undefined ? this.cMultiplier : null as any;
        data["miniChangePrice"] = this.miniChangePrice !== undefined ? this.miniChangePrice : null as any;
        return data;
    }
}

/** 批量读取 */
export class CalculateProductQuoteDtoForALL {
    minAcptQuote!: number | null;
    laborQuote!: number | null;
    cMultiplier!: number | null;
    miniChangePrice!: number | null;
    /** 产品ID */
    productId!: string;
    /** 序号 */
    serialNum!: string | null;

    init(_data?: any) {
        if (_data) {
            this.minAcptQuote = _data["minAcptQuote"] !== undefined ? _data["minAcptQuote"] : null as any;
            this.laborQuote = _data["laborQuote"] !== undefined ? _data["laborQuote"] : null as any;
            this.cMultiplier = _data["cMultiplier"] !== undefined ? _data["cMultiplier"] : null as any;
            this.miniChangePrice = _data["miniChangePrice"] !== undefined ? _data["miniChangePrice"] : null as any;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : null as any;
            this.serialNum = _data["serialNum"] !== undefined ? _data["serialNum"] : null as any;
        }
    }

    static fromJS(data: any): CalculateProductQuoteDtoForALL {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateProductQuoteDtoForALL();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minAcptQuote"] = this.minAcptQuote !== undefined ? this.minAcptQuote : null as any;
        data["laborQuote"] = this.laborQuote !== undefined ? this.laborQuote : null as any;
        data["cMultiplier"] = this.cMultiplier !== undefined ? this.cMultiplier : null as any;
        data["miniChangePrice"] = this.miniChangePrice !== undefined ? this.miniChangePrice : null as any;
        data["productId"] = this.productId !== undefined ? this.productId : null as any;
        data["serialNum"] = this.serialNum !== undefined ? this.serialNum : null as any;
        return data;
    }
}

/** 运费计算返回结构 */
export class CalculationForFreightDto {
    /** 拆单状态 */
    splitOrderStatus!: boolean;
    /** 总运费 */
    totalFreight!: number;
    /** 不含税金额合计 */
    totalAmountForAfterTax!: number;
    /** 含税金额合计 */
    totalAmountForTax!: number;
    /** 发货单以及对应变更库存 */
    deliveryNoteForFreight!: DeliveryNoteForFreight[] | null;

    init(_data?: any) {
        if (_data) {
            this.splitOrderStatus = _data["splitOrderStatus"] !== undefined ? _data["splitOrderStatus"] : null as any;
            this.totalFreight = _data["totalFreight"] !== undefined ? _data["totalFreight"] : null as any;
            this.totalAmountForAfterTax = _data["totalAmountForAfterTax"] !== undefined ? _data["totalAmountForAfterTax"] : null as any;
            this.totalAmountForTax = _data["totalAmountForTax"] !== undefined ? _data["totalAmountForTax"] : null as any;
            if (Array.isArray(_data["deliveryNoteForFreight"])) {
                this.deliveryNoteForFreight = [] as any;
                for (let item of _data["deliveryNoteForFreight"])
                    this.deliveryNoteForFreight!.push(DeliveryNoteForFreight.fromJS(item));
            }
            else {
                this.deliveryNoteForFreight = null as any;
            }
        }
    }

    static fromJS(data: any): CalculationForFreightDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationForFreightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["splitOrderStatus"] = this.splitOrderStatus !== undefined ? this.splitOrderStatus : null as any;
        data["totalFreight"] = this.totalFreight !== undefined ? this.totalFreight : null as any;
        data["totalAmountForAfterTax"] = this.totalAmountForAfterTax !== undefined ? this.totalAmountForAfterTax : null as any;
        data["totalAmountForTax"] = this.totalAmountForTax !== undefined ? this.totalAmountForTax : null as any;
        if (Array.isArray(this.deliveryNoteForFreight)) {
            data["deliveryNoteForFreight"] = [];
            for (let item of this.deliveryNoteForFreight)
                data["deliveryNoteForFreight"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 运费计算参数 */
export class CalculationForFreightParam {
    /** 待计算订单Id */
    deliveryNoteId!: string;
    /** 运输类型 (10-自提、99-顺丰) */
    shippingType!: string | null;
    /** 发货单以及对应变更库存 */
    deliveryNoteItems!: CalculationFreightForItems[] | null;
    /** 忽略运费计算DNS订单编号 */
    ignoreFreightNumbers!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.deliveryNoteId = _data["deliveryNoteId"] !== undefined ? _data["deliveryNoteId"] : null as any;
            this.shippingType = _data["shippingType"] !== undefined ? _data["shippingType"] : null as any;
            if (Array.isArray(_data["deliveryNoteItems"])) {
                this.deliveryNoteItems = [] as any;
                for (let item of _data["deliveryNoteItems"])
                    this.deliveryNoteItems!.push(CalculationFreightForItems.fromJS(item));
            }
            else {
                this.deliveryNoteItems = null as any;
            }
            if (Array.isArray(_data["ignoreFreightNumbers"])) {
                this.ignoreFreightNumbers = [] as any;
                for (let item of _data["ignoreFreightNumbers"])
                    this.ignoreFreightNumbers!.push(item);
            }
            else {
                this.ignoreFreightNumbers = null as any;
            }
        }
    }

    static fromJS(data: any): CalculationForFreightParam {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationForFreightParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryNoteId"] = this.deliveryNoteId !== undefined ? this.deliveryNoteId : null as any;
        data["shippingType"] = this.shippingType !== undefined ? this.shippingType : null as any;
        if (Array.isArray(this.deliveryNoteItems)) {
            data["deliveryNoteItems"] = [];
            for (let item of this.deliveryNoteItems)
                data["deliveryNoteItems"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.ignoreFreightNumbers)) {
            data["ignoreFreightNumbers"] = [];
            for (let item of this.ignoreFreightNumbers)
                data["ignoreFreightNumbers"].push(item);
        }
        return data;
    }
}

export class CalculationFreightForItems {
    /** 订单id */
    itemId!: string;
    /** 发货数量 */
    number!: number;

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
        }
    }

    static fromJS(data: any): CalculationFreightForItems {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationFreightForItems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId !== undefined ? this.itemId : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        return data;
    }
}

export class Channel {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    channelCode!: string | null;
    channelName!: string | null;
    orderForms!: OrderForm[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.channelCode = _data["channelCode"] !== undefined ? _data["channelCode"] : null as any;
            this.channelName = _data["channelName"] !== undefined ? _data["channelName"] : null as any;
            if (Array.isArray(_data["orderForms"])) {
                this.orderForms = [] as any;
                for (let item of _data["orderForms"])
                    this.orderForms!.push(OrderForm.fromJS(item));
            }
            else {
                this.orderForms = null as any;
            }
        }
    }

    static fromJS(data: any): Channel {
        data = typeof data === 'object' ? data : {};
        let result = new Channel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["channelCode"] = this.channelCode !== undefined ? this.channelCode : null as any;
        data["channelName"] = this.channelName !== undefined ? this.channelName : null as any;
        if (Array.isArray(this.orderForms)) {
            data["orderForms"] = [];
            for (let item of this.orderForms)
                data["orderForms"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 检查信用额度输出对象 */
export class CheckDnsCreditOutput {
    /** 剩余信用额度 */
    creditLimitRemain!: number;
    /** 欠款额度 */
    dueAmount!: number;

    init(_data?: any) {
        if (_data) {
            this.creditLimitRemain = _data["creditLimitRemain"] !== undefined ? _data["creditLimitRemain"] : null as any;
            this.dueAmount = _data["dueAmount"] !== undefined ? _data["dueAmount"] : null as any;
        }
    }

    static fromJS(data: any): CheckDnsCreditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDnsCreditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creditLimitRemain"] = this.creditLimitRemain !== undefined ? this.creditLimitRemain : null as any;
        data["dueAmount"] = this.dueAmount !== undefined ? this.dueAmount : null as any;
        return data;
    }
}

export class CheckInvalidVCOutputDto {
    /** 电机 */
    basicMotorCode!: string | null;
    /** 行号 */
    cScotOrderItemId!: string | null;
    /** VC编号 */
    vcs!: string | null;

    init(_data?: any) {
        if (_data) {
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.cScotOrderItemId = _data["cScotOrderItemId"] !== undefined ? _data["cScotOrderItemId"] : null as any;
            this.vcs = _data["vcs"] !== undefined ? _data["vcs"] : null as any;
        }
    }

    static fromJS(data: any): CheckInvalidVCOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckInvalidVCOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["cScotOrderItemId"] = this.cScotOrderItemId !== undefined ? this.cScotOrderItemId : null as any;
        data["vcs"] = this.vcs !== undefined ? this.vcs : null as any;
        return data;
    }
}

export class CheckOrderChangeVersionMotorDto {
    orderFormId!: string;
    poNumber!: string | null;
    versionId!: string;
    orderChangeOrderFormId!: string | null;
    orderChangeProductBasicMotorId!: string;
    version!: number | null;
    sequenceNumber!: string | null;
    basicMotorCode!: string | null;
    serialNumber!: number | null;

    init(_data?: any) {
        if (_data) {
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.versionId = _data["versionId"] !== undefined ? _data["versionId"] : null as any;
            this.orderChangeOrderFormId = _data["orderChangeOrderFormId"] !== undefined ? _data["orderChangeOrderFormId"] : null as any;
            this.orderChangeProductBasicMotorId = _data["orderChangeProductBasicMotorId"] !== undefined ? _data["orderChangeProductBasicMotorId"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.sequenceNumber = _data["sequenceNumber"] !== undefined ? _data["sequenceNumber"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
        }
    }

    static fromJS(data: any): CheckOrderChangeVersionMotorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckOrderChangeVersionMotorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["versionId"] = this.versionId !== undefined ? this.versionId : null as any;
        data["orderChangeOrderFormId"] = this.orderChangeOrderFormId !== undefined ? this.orderChangeOrderFormId : null as any;
        data["orderChangeProductBasicMotorId"] = this.orderChangeProductBasicMotorId !== undefined ? this.orderChangeProductBasicMotorId : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["sequenceNumber"] = this.sequenceNumber !== undefined ? this.sequenceNumber : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        return data;
    }
}

/** SMCONF带过来的规则检查 */
export class CheckResultOutputDto {
    productId!: string;
    ruleSource!: RuleSource;
    /** 若出现错误 1，不需要额外的详情字段 */
    readonly result!: number;
    /** 若出现错误 2，则该字段需要给出对于裸机不可选的和不需要的VC列表 */
    unavaliable!: string[] | null;
    /** 若出现错误 2，则该字段需要给出对于裸机不可选的和不需要的VC列表 */
    redundant!: string[] | null;
    /** 若出现错误 4，则该字段需要给出选择的哪几个vc不兼容 */
    incompatible!: Incompatible[] | null;
    /** 若出现错误 8，则该字段需要给出对于该裸机，哪些vc是必选的 */
    required!: string[] | null;
    /** 若出现错误 16， 则需要给出：由于那个vc导致哪些vc要换成哪些vc */
    resolvable!: Resolvable[] | null;
    /** 若出现错误 32， 则需要给出：哪些vc需要提供什么样的free text */
    freetext!: Freetext[] | null;
    /** 若出现错误 64， 则需要给出：由于哪些vc导致需要用户提供哪些技术参数
若技术参数是列表形式，需要将可选值提供给用户 */
    prodtech!: Prodtech[] | null;
    prodElec!: Prodelec[] | null;
    selectOrInput!: SelectOrInput[] | null;
    /** 256 warn message from 61条 */
    warn!: string[] | null;
    /** 512 warn message from 61条 */
    error!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"] !== undefined ? _data["productId"] : null as any;
            this.ruleSource = _data["ruleSource"] !== undefined ? _data["ruleSource"] : null as any;
            (this as any).result = _data["result"] !== undefined ? _data["result"] : null as any;
            if (Array.isArray(_data["unavaliable"])) {
                this.unavaliable = [] as any;
                for (let item of _data["unavaliable"])
                    this.unavaliable!.push(item);
            }
            else {
                this.unavaliable = null as any;
            }
            if (Array.isArray(_data["redundant"])) {
                this.redundant = [] as any;
                for (let item of _data["redundant"])
                    this.redundant!.push(item);
            }
            else {
                this.redundant = null as any;
            }
            if (Array.isArray(_data["incompatible"])) {
                this.incompatible = [] as any;
                for (let item of _data["incompatible"])
                    this.incompatible!.push(Incompatible.fromJS(item));
            }
            else {
                this.incompatible = null as any;
            }
            if (Array.isArray(_data["required"])) {
                this.required = [] as any;
                for (let item of _data["required"])
                    this.required!.push(item);
            }
            else {
                this.required = null as any;
            }
            if (Array.isArray(_data["resolvable"])) {
                this.resolvable = [] as any;
                for (let item of _data["resolvable"])
                    this.resolvable!.push(Resolvable.fromJS(item));
            }
            else {
                this.resolvable = null as any;
            }
            if (Array.isArray(_data["freetext"])) {
                this.freetext = [] as any;
                for (let item of _data["freetext"])
                    this.freetext!.push(Freetext.fromJS(item));
            }
            else {
                this.freetext = null as any;
            }
            if (Array.isArray(_data["prodtech"])) {
                this.prodtech = [] as any;
                for (let item of _data["prodtech"])
                    this.prodtech!.push(Prodtech.fromJS(item));
            }
            else {
                this.prodtech = null as any;
            }
            if (Array.isArray(_data["prodElec"])) {
                this.prodElec = [] as any;
                for (let item of _data["prodElec"])
                    this.prodElec!.push(Prodelec.fromJS(item));
            }
            else {
                this.prodElec = null as any;
            }
            if (Array.isArray(_data["selectOrInput"])) {
                this.selectOrInput = [] as any;
                for (let item of _data["selectOrInput"])
                    this.selectOrInput!.push(SelectOrInput.fromJS(item));
            }
            else {
                this.selectOrInput = null as any;
            }
            if (Array.isArray(_data["warn"])) {
                this.warn = [] as any;
                for (let item of _data["warn"])
                    this.warn!.push(item);
            }
            else {
                this.warn = null as any;
            }
            if (Array.isArray(_data["error"])) {
                this.error = [] as any;
                for (let item of _data["error"])
                    this.error!.push(item);
            }
            else {
                this.error = null as any;
            }
        }
    }

    static fromJS(data: any): CheckResultOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckResultOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId !== undefined ? this.productId : null as any;
        data["ruleSource"] = this.ruleSource !== undefined ? this.ruleSource : null as any;
        data["result"] = this.result !== undefined ? this.result : null as any;
        if (Array.isArray(this.unavaliable)) {
            data["unavaliable"] = [];
            for (let item of this.unavaliable)
                data["unavaliable"].push(item);
        }
        if (Array.isArray(this.redundant)) {
            data["redundant"] = [];
            for (let item of this.redundant)
                data["redundant"].push(item);
        }
        if (Array.isArray(this.incompatible)) {
            data["incompatible"] = [];
            for (let item of this.incompatible)
                data["incompatible"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.required)) {
            data["required"] = [];
            for (let item of this.required)
                data["required"].push(item);
        }
        if (Array.isArray(this.resolvable)) {
            data["resolvable"] = [];
            for (let item of this.resolvable)
                data["resolvable"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.freetext)) {
            data["freetext"] = [];
            for (let item of this.freetext)
                data["freetext"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.prodtech)) {
            data["prodtech"] = [];
            for (let item of this.prodtech)
                data["prodtech"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.prodElec)) {
            data["prodElec"] = [];
            for (let item of this.prodElec)
                data["prodElec"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectOrInput)) {
            data["selectOrInput"] = [];
            for (let item of this.selectOrInput)
                data["selectOrInput"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.warn)) {
            data["warn"] = [];
            for (let item of this.warn)
                data["warn"].push(item);
        }
        if (Array.isArray(this.error)) {
            data["error"] = [];
            for (let item of this.error)
                data["error"].push(item);
        }
        return data;
    }
}

export class ConfirmChangeOrderFormDto {
    orderChangeOrderFormId!: string;
    orderChangeProductBasicMotor!: OrderChangeProductBasicMotorAddDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.orderChangeOrderFormId = _data["orderChangeOrderFormId"] !== undefined ? _data["orderChangeOrderFormId"] : null as any;
            if (Array.isArray(_data["orderChangeProductBasicMotor"])) {
                this.orderChangeProductBasicMotor = [] as any;
                for (let item of _data["orderChangeProductBasicMotor"])
                    this.orderChangeProductBasicMotor!.push(OrderChangeProductBasicMotorAddDto.fromJS(item));
            }
            else {
                this.orderChangeProductBasicMotor = null as any;
            }
        }
    }

    static fromJS(data: any): ConfirmChangeOrderFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmChangeOrderFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderChangeOrderFormId"] = this.orderChangeOrderFormId !== undefined ? this.orderChangeOrderFormId : null as any;
        if (Array.isArray(this.orderChangeProductBasicMotor)) {
            data["orderChangeProductBasicMotor"] = [];
            for (let item of this.orderChangeProductBasicMotor)
                data["orderChangeProductBasicMotor"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 0 = WithVC (同VC) 1 = HavaVc (已有VC) 2 = CostList (成本列表) 3 = WorkOrder (见工作令) 4 = SeeEnclosure (详见附件) */
export enum CostType {
    WithVC = 0,
    HavaVc = 1,
    CostList = 2,
    WorkOrder = 3,
    SeeEnclosure = 4,
}

export class CountryDto {
    id!: string;
    /** 国家名称简称 */
    shortName!: string | null;
    /** 国家名称 */
    country!: string | null;
    /** 国家名称(中文) */
    countryCN!: string | null;
    riskLevel!: CountryRiskEnum;
    /** 额定值 */
    rating!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.countryCN = _data["countryCN"] !== undefined ? _data["countryCN"] : null as any;
            this.riskLevel = _data["riskLevel"] !== undefined ? _data["riskLevel"] : null as any;
            this.rating = _data["rating"] !== undefined ? _data["rating"] : null as any;
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["shortName"] = this.shortName !== undefined ? this.shortName : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["countryCN"] = this.countryCN !== undefined ? this.countryCN : null as any;
        data["riskLevel"] = this.riskLevel !== undefined ? this.riskLevel : null as any;
        data["rating"] = this.rating !== undefined ? this.rating : null as any;
        return data;
    }
}

export class CountryDtoPagedResultDto {
    items!: CountryDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CountryDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): CountryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 0 = Unknown 1 = N (N) 2 = H (H) 3 = S (S) 4 = D (D) */
export enum CountryRiskEnum {
    Unknown = 0,
    N = 1,
    H = 2,
    S = 3,
    D = 4,
}

export class CreateDictionaryDto {
    /** 字典类型（必填） */
    dictType!: string;
    dictValue!: string;
    /** 字典标签 */
    dictLabel!: string | null;
    isDefault!: boolean;
    listClass!: string | null;
    cssClass!: string | null;
    serialNum!: number;
    state!: boolean;
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.dictType = _data["dictType"] !== undefined ? _data["dictType"] : null as any;
            this.dictValue = _data["dictValue"] !== undefined ? _data["dictValue"] : null as any;
            this.dictLabel = _data["dictLabel"] !== undefined ? _data["dictLabel"] : null as any;
            this.isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : null as any;
            this.listClass = _data["listClass"] !== undefined ? _data["listClass"] : null as any;
            this.cssClass = _data["cssClass"] !== undefined ? _data["cssClass"] : null as any;
            this.serialNum = _data["serialNum"] !== undefined ? _data["serialNum"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): CreateDictionaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDictionaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dictType"] = this.dictType !== undefined ? this.dictType : null as any;
        data["dictValue"] = this.dictValue !== undefined ? this.dictValue : null as any;
        data["dictLabel"] = this.dictLabel !== undefined ? this.dictLabel : null as any;
        data["isDefault"] = this.isDefault !== undefined ? this.isDefault : null as any;
        data["listClass"] = this.listClass !== undefined ? this.listClass : null as any;
        data["cssClass"] = this.cssClass !== undefined ? this.cssClass : null as any;
        data["serialNum"] = this.serialNum !== undefined ? this.serialNum : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

export class CreateDictionaryTypeDto {
    /** 字典名称 (必填，最长20字符) */
    dictName!: string;
    /** 字典类型 (必填，最长20字符) */
    dictType!: string;
    /** 描述信息 (可选) */
    remark!: string | null;
    /** 初始状态 (默认true) */
    state!: boolean;
    /** 排序序号 (非负整数) */
    serialNum!: number;

    init(_data?: any) {
        if (_data) {
            this.dictName = _data["dictName"] !== undefined ? _data["dictName"] : null as any;
            this.dictType = _data["dictType"] !== undefined ? _data["dictType"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.serialNum = _data["serialNum"] !== undefined ? _data["serialNum"] : null as any;
        }
    }

    static fromJS(data: any): CreateDictionaryTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDictionaryTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dictName"] = this.dictName !== undefined ? this.dictName : null as any;
        data["dictType"] = this.dictType !== undefined ? this.dictType : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["serialNum"] = this.serialNum !== undefined ? this.serialNum : null as any;
        return data;
    }
}

/** 创建后台任务记录 */
export class CreateJobInputDto {
    /** 任务名称 */
    jobName!: string | null;
    jobType!: JobEnum;
    /** 任务执行方法(后台任务执行判断使用) */
    jobFunction!: string | null;
    /** 导出参数 */
    jobParam!: string | null;

    init(_data?: any) {
        if (_data) {
            this.jobName = _data["jobName"] !== undefined ? _data["jobName"] : null as any;
            this.jobType = _data["jobType"] !== undefined ? _data["jobType"] : null as any;
            this.jobFunction = _data["jobFunction"] !== undefined ? _data["jobFunction"] : null as any;
            this.jobParam = _data["jobParam"] !== undefined ? _data["jobParam"] : null as any;
        }
    }

    static fromJS(data: any): CreateJobInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJobInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobName"] = this.jobName !== undefined ? this.jobName : null as any;
        data["jobType"] = this.jobType !== undefined ? this.jobType : null as any;
        data["jobFunction"] = this.jobFunction !== undefined ? this.jobFunction : null as any;
        data["jobParam"] = this.jobParam !== undefined ? this.jobParam : null as any;
        return data;
    }
}

/** 发起订单变更流程 */
export class CreateOrderChangeMajorDto {
    /** 提交时的变更原因（表单） */
    orderChangeReason!: string | null;
    /** 提交时的具体原因（表单） */
    specificReason!: string | null;
    /** 提交时的责任方（表单） */
    responsibleParty!: string | null;
    /** 提交时的选型问题类型（表单） */
    scIssueType!: string | null;
    /** 提交时的具体原因（表单） */
    scIssueTypeReason!: string | null;
    /** 提交时的备注（表单） */
    comments!: string | null;
    /** 提交时的附件（表单） */
    startAttachments!: FileModel[] | null;
    /** 提出方(表单) */
    presentingParty!: string | null;
    /** 商务处理人 */
    commercialAssignee!: string | null;
    /** 产品列表（用来在商务节点填写 BOM 状态） */
    products!: string | null;
    /** 商务的候选人列表 */
    commercialCandidate!: string | null;
    /** ordre handling 处理人 */
    ohAssignee!: string | null;
    /** ordre handling 并行处理人 */
    ohAssignees!: string | null;
    /** order handling 转办候选人 */
    ohCandidate!: string | null;
    ocfId!: string;
    /** OH审批 */
    ohApprovalAssignee!: string | null;
    /** 商务处理人直接修改
商务审核人直接修改 */
    directlyModify!: boolean;

    init(_data?: any) {
        if (_data) {
            this.orderChangeReason = _data["orderChangeReason"] !== undefined ? _data["orderChangeReason"] : null as any;
            this.specificReason = _data["specificReason"] !== undefined ? _data["specificReason"] : null as any;
            this.responsibleParty = _data["responsibleParty"] !== undefined ? _data["responsibleParty"] : null as any;
            this.scIssueType = _data["scIssueType"] !== undefined ? _data["scIssueType"] : null as any;
            this.scIssueTypeReason = _data["scIssueTypeReason"] !== undefined ? _data["scIssueTypeReason"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            if (Array.isArray(_data["startAttachments"])) {
                this.startAttachments = [] as any;
                for (let item of _data["startAttachments"])
                    this.startAttachments!.push(FileModel.fromJS(item));
            }
            else {
                this.startAttachments = null as any;
            }
            this.presentingParty = _data["presentingParty"] !== undefined ? _data["presentingParty"] : null as any;
            this.commercialAssignee = _data["commercialAssignee"] !== undefined ? _data["commercialAssignee"] : null as any;
            this.products = _data["products"] !== undefined ? _data["products"] : null as any;
            this.commercialCandidate = _data["commercialCandidate"] !== undefined ? _data["commercialCandidate"] : null as any;
            this.ohAssignee = _data["ohAssignee"] !== undefined ? _data["ohAssignee"] : null as any;
            this.ohAssignees = _data["ohAssignees"] !== undefined ? _data["ohAssignees"] : null as any;
            this.ohCandidate = _data["ohCandidate"] !== undefined ? _data["ohCandidate"] : null as any;
            this.ocfId = _data["ocfId"] !== undefined ? _data["ocfId"] : null as any;
            this.ohApprovalAssignee = _data["ohApprovalAssignee"] !== undefined ? _data["ohApprovalAssignee"] : null as any;
            this.directlyModify = _data["directlyModify"] !== undefined ? _data["directlyModify"] : null as any;
        }
    }

    static fromJS(data: any): CreateOrderChangeMajorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderChangeMajorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderChangeReason"] = this.orderChangeReason !== undefined ? this.orderChangeReason : null as any;
        data["specificReason"] = this.specificReason !== undefined ? this.specificReason : null as any;
        data["responsibleParty"] = this.responsibleParty !== undefined ? this.responsibleParty : null as any;
        data["scIssueType"] = this.scIssueType !== undefined ? this.scIssueType : null as any;
        data["scIssueTypeReason"] = this.scIssueTypeReason !== undefined ? this.scIssueTypeReason : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        if (Array.isArray(this.startAttachments)) {
            data["startAttachments"] = [];
            for (let item of this.startAttachments)
                data["startAttachments"].push(item ? item.toJSON() : null as any);
        }
        data["presentingParty"] = this.presentingParty !== undefined ? this.presentingParty : null as any;
        data["commercialAssignee"] = this.commercialAssignee !== undefined ? this.commercialAssignee : null as any;
        data["products"] = this.products !== undefined ? this.products : null as any;
        data["commercialCandidate"] = this.commercialCandidate !== undefined ? this.commercialCandidate : null as any;
        data["ohAssignee"] = this.ohAssignee !== undefined ? this.ohAssignee : null as any;
        data["ohAssignees"] = this.ohAssignees !== undefined ? this.ohAssignees : null as any;
        data["ohCandidate"] = this.ohCandidate !== undefined ? this.ohCandidate : null as any;
        data["ocfId"] = this.ocfId !== undefined ? this.ocfId : null as any;
        data["ohApprovalAssignee"] = this.ohApprovalAssignee !== undefined ? this.ohApprovalAssignee : null as any;
        data["directlyModify"] = this.directlyModify !== undefined ? this.directlyModify : null as any;
        return data;
    }
}

export class CreateOrderTypeProductionLineDto {
    /** 状态 */
    state!: boolean;
    /** 订单类型（字典表Value） */
    orderType!: string | null;
    /** 产线（字典表Value） */
    productionLine!: string | null;
    /** 关联类型 */
    personType!: string | null;
    /** 关联人员 页面通过选择用户关联 */
    personEmail!: string | null;
    /** 描述 */
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.productionLine = _data["productionLine"] !== undefined ? _data["productionLine"] : null as any;
            this.personType = _data["personType"] !== undefined ? _data["personType"] : null as any;
            this.personEmail = _data["personEmail"] !== undefined ? _data["personEmail"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): CreateOrderTypeProductionLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderTypeProductionLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["productionLine"] = this.productionLine !== undefined ? this.productionLine : null as any;
        data["personType"] = this.personType !== undefined ? this.personType : null as any;
        data["personEmail"] = this.personEmail !== undefined ? this.personEmail : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

export class CreateSpecialOfferNoDto {
    /** 特价号 */
    specialOfferNumber!: string | null;
    /** 有效期 */
    validityPeriod!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.specialOfferNumber = _data["specialOfferNumber"] !== undefined ? _data["specialOfferNumber"] : null as any;
            this.validityPeriod = _data["validityPeriod"] ? moment(_data["validityPeriod"].toString()) : null as any;
        }
    }

    static fromJS(data: any): CreateSpecialOfferNoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSpecialOfferNoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specialOfferNumber"] = this.specialOfferNumber !== undefined ? this.specialOfferNumber : null as any;
        data["validityPeriod"] = this.validityPeriod ? this.validityPeriod.toISOString() : null as any;
        return data;
    }
}

/** 客户信息 */
export class CustomInfosByDeliveryTimeDto {
    /** Id */
    id!: string | null;
    /** 客户编号 */
    soldToParty!: string | null;
    /** 客户名称 */
    customerName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.soldToParty = _data["soldToParty"] !== undefined ? _data["soldToParty"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
        }
    }

    static fromJS(data: any): CustomInfosByDeliveryTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomInfosByDeliveryTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["soldToParty"] = this.soldToParty !== undefined ? this.soldToParty : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        return data;
    }
}

export class CustomVcDto {
    id!: string;
    /** 创建人编号 */
    creatorUserId!: number | null;
    /** 创建人 */
    creatorUser!: string | null;
    /** 创建日期 */
    creationTime!: moment.Moment;
    /** VC ID */
    vcID!: string | null;
    /** 品类编号 */
    categoryId!: string;
    /** 品类 */
    category!: string | null;
    /** VC含义 */
    meaning!: string | null;
    /** 英文含义 */
    englishMeaning!: string | null;
    /** VC备注 */
    vcTypeDescription!: string | null;
    /** VC头数 */
    numberWires!: number;
    status!: IndustryVCStatus;
    /** 状态 */
    readonly statusName!: string | null;
    /** 是否属于升级VC */
    upgrade!: boolean;
    /** 使用次数 */
    placeOrderCount!: number;
    /** 自定义VC产品配置 */
    customVcPriceDtos!: CustomVcPriceDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.creatorUser = _data["creatorUser"] !== undefined ? _data["creatorUser"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            (this as any).statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            this.upgrade = _data["upgrade"] !== undefined ? _data["upgrade"] : null as any;
            this.placeOrderCount = _data["placeOrderCount"] !== undefined ? _data["placeOrderCount"] : null as any;
            if (Array.isArray(_data["customVcPriceDtos"])) {
                this.customVcPriceDtos = [] as any;
                for (let item of _data["customVcPriceDtos"])
                    this.customVcPriceDtos!.push(CustomVcPriceDto.fromJS(item));
            }
            else {
                this.customVcPriceDtos = null as any;
            }
        }
    }

    static fromJS(data: any): CustomVcDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomVcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["creatorUser"] = this.creatorUser !== undefined ? this.creatorUser : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        data["upgrade"] = this.upgrade !== undefined ? this.upgrade : null as any;
        data["placeOrderCount"] = this.placeOrderCount !== undefined ? this.placeOrderCount : null as any;
        if (Array.isArray(this.customVcPriceDtos)) {
            data["customVcPriceDtos"] = [];
            for (let item of this.customVcPriceDtos)
                data["customVcPriceDtos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class CustomVcPriceDto {
    id!: string;
    /** 创建时间 */
    creationTime!: moment.Moment;
    /** 修改时间 */
    lastModificationTime!: moment.Moment | null;
    /** 主机代码 */
    basicMotorCode!: string | null;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 机座号 */
    frameNo!: number | null;
    /** 工程周期（自然日） */
    engineeringCycle!: number | null;
    engineeringCalculationMode!: EngineeringCalculationMode;
    /** 工程计算方式 */
    readonly engineeringCalculationModeName!: string | null;
    /** 采购周期（工作日） */
    purchaseCycle!: number | null;
    purchaseCycleMode!: PurchaseCycleMode;
    /** 采购计算方式 */
    readonly purchaseCycleModeName!: string | null;
    /** 生产周期（自然日） */
    productionCycle!: number | null;
    /** 测试周期（自然日） */
    testCycle!: number | null;
    /** 船检周期（自然日） */
    shipSurveyCycle!: number | null;
    /** GR增量 */
    grCycle!: number | null;
    /** 单价 */
    unitPrice!: number | null;
    /** 面价公式 */
    unitPriceFormula!: string | null;
    unitPriceType!: UnitPriceType;
    /** 打折类型 */
    readonly unitPriceTypeName!: string | null;
    /** 成本 */
    cost!: number | null;
    /** 成本公式 */
    costFormula!: string | null;
    costType!: CostType;
    /** 打折类型 */
    readonly costTypeName!: string | null;
    /** 成本类型详情 */
    costTypeDetail!: string | null;
    /** 报价原则 */
    quotationPrinciple!: string | null;
    /** 报价原则详情 */
    quotationPrincipleDetails!: string | null;
    /** 下单次数 */
    placeOrderCount!: number;
    /** 自定义VC编号 */
    customVcId!: string;
    customVc!: CustomVcDto;
    /** 工程更新/确认时间 */
    engineeringCycleUpdateTime!: moment.Moment | null;
    /** 船检周期更新/确认时间 */
    shipSurveyCycleUpdateTime!: moment.Moment | null;
    /** 生产周期更新/确认时间 */
    productionCycleUpdateTime!: moment.Moment | null;
    /** 采购周期更新/确认时间 */
    purchaseCycleUpdateTime!: moment.Moment | null;
    /** 测试周期更新/确认时间 */
    testCycleUpdateTime!: moment.Moment | null;
    /** GR增量更新时间/确认时间 */
    grCycleUpdateTime!: moment.Moment | null;
    /** SCM周期 */
    scmCycle!: number | null;
    /** SCM计算方式 */
    scmCalculationMode!: string | null;
    /** SCM备注 */
    scmRemark!: string | null;
    /** 额外叠加时间 */
    extraOverlayTime!: boolean | null;
    /** 是否叠加逻辑 */
    isOverlayLogic!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            (this as any).engineeringCalculationModeName = _data["engineeringCalculationModeName"] !== undefined ? _data["engineeringCalculationModeName"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            (this as any).purchaseCycleModeName = _data["purchaseCycleModeName"] !== undefined ? _data["purchaseCycleModeName"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            (this as any).unitPriceTypeName = _data["unitPriceTypeName"] !== undefined ? _data["unitPriceTypeName"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            (this as any).costTypeName = _data["costTypeName"] !== undefined ? _data["costTypeName"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.placeOrderCount = _data["placeOrderCount"] !== undefined ? _data["placeOrderCount"] : null as any;
            this.customVcId = _data["customVcId"] !== undefined ? _data["customVcId"] : null as any;
            this.customVc = _data["customVc"] ? CustomVcDto.fromJS(_data["customVc"]) : null as any;
            this.engineeringCycleUpdateTime = _data["engineeringCycleUpdateTime"] ? moment(_data["engineeringCycleUpdateTime"].toString()) : null as any;
            this.shipSurveyCycleUpdateTime = _data["shipSurveyCycleUpdateTime"] ? moment(_data["shipSurveyCycleUpdateTime"].toString()) : null as any;
            this.productionCycleUpdateTime = _data["productionCycleUpdateTime"] ? moment(_data["productionCycleUpdateTime"].toString()) : null as any;
            this.purchaseCycleUpdateTime = _data["purchaseCycleUpdateTime"] ? moment(_data["purchaseCycleUpdateTime"].toString()) : null as any;
            this.testCycleUpdateTime = _data["testCycleUpdateTime"] ? moment(_data["testCycleUpdateTime"].toString()) : null as any;
            this.grCycleUpdateTime = _data["grCycleUpdateTime"] ? moment(_data["grCycleUpdateTime"].toString()) : null as any;
            this.scmCycle = _data["scmCycle"] !== undefined ? _data["scmCycle"] : null as any;
            this.scmCalculationMode = _data["scmCalculationMode"] !== undefined ? _data["scmCalculationMode"] : null as any;
            this.scmRemark = _data["scmRemark"] !== undefined ? _data["scmRemark"] : null as any;
            this.extraOverlayTime = _data["extraOverlayTime"] !== undefined ? _data["extraOverlayTime"] : null as any;
            this.isOverlayLogic = _data["isOverlayLogic"] !== undefined ? _data["isOverlayLogic"] : null as any;
        }
    }

    static fromJS(data: any): CustomVcPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomVcPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["engineeringCalculationModeName"] = this.engineeringCalculationModeName !== undefined ? this.engineeringCalculationModeName : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["purchaseCycleModeName"] = this.purchaseCycleModeName !== undefined ? this.purchaseCycleModeName : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["unitPriceTypeName"] = this.unitPriceTypeName !== undefined ? this.unitPriceTypeName : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeName"] = this.costTypeName !== undefined ? this.costTypeName : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["placeOrderCount"] = this.placeOrderCount !== undefined ? this.placeOrderCount : null as any;
        data["customVcId"] = this.customVcId !== undefined ? this.customVcId : null as any;
        data["customVc"] = this.customVc ? this.customVc.toJSON() : null as any;
        data["engineeringCycleUpdateTime"] = this.engineeringCycleUpdateTime ? this.engineeringCycleUpdateTime.toISOString() : null as any;
        data["shipSurveyCycleUpdateTime"] = this.shipSurveyCycleUpdateTime ? this.shipSurveyCycleUpdateTime.toISOString() : null as any;
        data["productionCycleUpdateTime"] = this.productionCycleUpdateTime ? this.productionCycleUpdateTime.toISOString() : null as any;
        data["purchaseCycleUpdateTime"] = this.purchaseCycleUpdateTime ? this.purchaseCycleUpdateTime.toISOString() : null as any;
        data["testCycleUpdateTime"] = this.testCycleUpdateTime ? this.testCycleUpdateTime.toISOString() : null as any;
        data["grCycleUpdateTime"] = this.grCycleUpdateTime ? this.grCycleUpdateTime.toISOString() : null as any;
        data["scmCycle"] = this.scmCycle !== undefined ? this.scmCycle : null as any;
        data["scmCalculationMode"] = this.scmCalculationMode !== undefined ? this.scmCalculationMode : null as any;
        data["scmRemark"] = this.scmRemark !== undefined ? this.scmRemark : null as any;
        data["extraOverlayTime"] = this.extraOverlayTime !== undefined ? this.extraOverlayTime : null as any;
        data["isOverlayLogic"] = this.isOverlayLogic !== undefined ? this.isOverlayLogic : null as any;
        return data;
    }
}

export class DataPlatFormOrderChangeTypeDto {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    /** 订单名称 */
    dataPlatFormOrderTypeName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.dataPlatFormOrderTypeName = _data["dataPlatFormOrderTypeName"] !== undefined ? _data["dataPlatFormOrderTypeName"] : null as any;
        }
    }

    static fromJS(data: any): DataPlatFormOrderChangeTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataPlatFormOrderChangeTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["dataPlatFormOrderTypeName"] = this.dataPlatFormOrderTypeName !== undefined ? this.dataPlatFormOrderTypeName : null as any;
        return data;
    }
}

export class DataPlatFormOrderType {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    dataPlatFormOrderTypeName!: string | null;
    orderForms!: OrderForm[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.dataPlatFormOrderTypeName = _data["dataPlatFormOrderTypeName"] !== undefined ? _data["dataPlatFormOrderTypeName"] : null as any;
            if (Array.isArray(_data["orderForms"])) {
                this.orderForms = [] as any;
                for (let item of _data["orderForms"])
                    this.orderForms!.push(OrderForm.fromJS(item));
            }
            else {
                this.orderForms = null as any;
            }
        }
    }

    static fromJS(data: any): DataPlatFormOrderType {
        data = typeof data === 'object' ? data : {};
        let result = new DataPlatFormOrderType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["dataPlatFormOrderTypeName"] = this.dataPlatFormOrderTypeName !== undefined ? this.dataPlatFormOrderTypeName : null as any;
        if (Array.isArray(this.orderForms)) {
            data["orderForms"] = [];
            for (let item of this.orderForms)
                data["orderForms"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class DeleteOrderChangeDto {
    orderFormId!: string;
    orderChangeOrderFormId!: string;

    init(_data?: any) {
        if (_data) {
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.orderChangeOrderFormId = _data["orderChangeOrderFormId"] !== undefined ? _data["orderChangeOrderFormId"] : null as any;
        }
    }

    static fromJS(data: any): DeleteOrderChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteOrderChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["orderChangeOrderFormId"] = this.orderChangeOrderFormId !== undefined ? this.orderChangeOrderFormId : null as any;
        return data;
    }
}

/** 订单运费计算结果 */
export class DeliveryNoteForFreight {
    /** 订单行号 */
    itemId!: string;
    /** 运费 */
    freight!: number;

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : null as any;
            this.freight = _data["freight"] !== undefined ? _data["freight"] : null as any;
        }
    }

    static fromJS(data: any): DeliveryNoteForFreight {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryNoteForFreight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId !== undefined ? this.itemId : null as any;
        data["freight"] = this.freight !== undefined ? this.freight : null as any;
        return data;
    }
}

/** 客户所属发货时间信息 */
export class DeliveryTimeForSoldToPartyDto {
    /** Id */
    id!: string | null;
    /** 客户编号 */
    soldToParty!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 行业 */
    industryUsage!: string | null;
    /** 最新一次状态 */
    isActive!: boolean | null;
    /** 最新一次开始时间 */
    startDate!: moment.Moment | null;
    /** 最新一次结束时间 */
    endDate!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.soldToParty = _data["soldToParty"] !== undefined ? _data["soldToParty"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.industryUsage = _data["industryUsage"] !== undefined ? _data["industryUsage"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): DeliveryTimeForSoldToPartyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryTimeForSoldToPartyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["soldToParty"] = this.soldToParty !== undefined ? this.soldToParty : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["industryUsage"] = this.industryUsage !== undefined ? this.industryUsage : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        return data;
    }
}

export class DictionaryDto {
    id!: string;
    /** 字典标签（显示文本） */
    dictLabel!: string | null;
    /** 字典值（存储值） */
    dictValue!: string | null;
    /** 是否默认选项 */
    isDefault!: boolean;
    /** 样式标签 */
    listClass!: string | null;
    /** CSS类名 */
    cssClass!: string | null;
    /** 排序序号 */
    serialNum!: number;
    dictType!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.dictLabel = _data["dictLabel"] !== undefined ? _data["dictLabel"] : null as any;
            this.dictValue = _data["dictValue"] !== undefined ? _data["dictValue"] : null as any;
            this.isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : null as any;
            this.listClass = _data["listClass"] !== undefined ? _data["listClass"] : null as any;
            this.cssClass = _data["cssClass"] !== undefined ? _data["cssClass"] : null as any;
            this.serialNum = _data["serialNum"] !== undefined ? _data["serialNum"] : null as any;
            this.dictType = _data["dictType"] !== undefined ? _data["dictType"] : null as any;
        }
    }

    static fromJS(data: any): DictionaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DictionaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["dictLabel"] = this.dictLabel !== undefined ? this.dictLabel : null as any;
        data["dictValue"] = this.dictValue !== undefined ? this.dictValue : null as any;
        data["isDefault"] = this.isDefault !== undefined ? this.isDefault : null as any;
        data["listClass"] = this.listClass !== undefined ? this.listClass : null as any;
        data["cssClass"] = this.cssClass !== undefined ? this.cssClass : null as any;
        data["serialNum"] = this.serialNum !== undefined ? this.serialNum : null as any;
        data["dictType"] = this.dictType !== undefined ? this.dictType : null as any;
        return data;
    }
}

export class DictionaryGetListOutputDto {
    id!: string;
    /** 字典标签 */
    dictLabel!: string | null;
    /** 字典值 */
    dictValue!: string | null;
    /** 是否为该类型的默认值 */
    isDefault!: boolean;
    /** 描述 */
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.dictLabel = _data["dictLabel"] !== undefined ? _data["dictLabel"] : null as any;
            this.dictValue = _data["dictValue"] !== undefined ? _data["dictValue"] : null as any;
            this.isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): DictionaryGetListOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DictionaryGetListOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["dictLabel"] = this.dictLabel !== undefined ? this.dictLabel : null as any;
        data["dictValue"] = this.dictValue !== undefined ? this.dictValue : null as any;
        data["isDefault"] = this.isDefault !== undefined ? this.isDefault : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

/** 字典类型数据传输对象 */
export class DictionaryTypeDto {
    /** 字典类型ID */
    id!: string;
    /** 排序序号
<example>1</example> */
    serialNum!: number;
    /** 启用状态
<example>true</example> */
    state!: boolean;
    /** 字典名称
<example>性别类型</example> */
    dictName!: string | null;
    /** 字典类型唯一标识
<example>system_gender</example> */
    dictType!: string | null;
    /** 描述信息
<example>系统通用性别字典</example> */
    remark!: string | null;
    /** 创建时间 */
    creationTime!: moment.Moment;
    /** 最后修改时间 */
    lastModificationTime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.serialNum = _data["serialNum"] !== undefined ? _data["serialNum"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.dictName = _data["dictName"] !== undefined ? _data["dictName"] : null as any;
            this.dictType = _data["dictType"] !== undefined ? _data["dictType"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): DictionaryTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DictionaryTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["serialNum"] = this.serialNum !== undefined ? this.serialNum : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["dictName"] = this.dictName !== undefined ? this.dictName : null as any;
        data["dictType"] = this.dictType !== undefined ? this.dictType : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        return data;
    }
}

/** 差异结果 */
export class DiffResult {
    /** key */
    key!: string | null;
    /** 对比内容 */
    value!: string | null;
    itemRowns!: ItemRown[] | null;

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            if (Array.isArray(_data["itemRowns"])) {
                this.itemRowns = [] as any;
                for (let item of _data["itemRowns"])
                    this.itemRowns!.push(ItemRown.fromJS(item));
            }
            else {
                this.itemRowns = null as any;
            }
        }
    }

    static fromJS(data: any): DiffResult {
        data = typeof data === 'object' ? data : {};
        let result = new DiffResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        if (Array.isArray(this.itemRowns)) {
            data["itemRowns"] = [];
            for (let item of this.itemRowns)
                data["itemRowns"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class Domain {
    _int!: Int;
    list!: List[] | null;

    init(_data?: any) {
        if (_data) {
            this._int = _data["_int"] ? Int.fromJS(_data["_int"]) : null as any;
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"])
                    this.list!.push(List.fromJS(item));
            }
            else {
                this.list = null as any;
            }
        }
    }

    static fromJS(data: any): Domain {
        data = typeof data === 'object' ? data : {};
        let result = new Domain();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_int"] = this._int ? this._int.toJSON() : null as any;
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class Domain1 {
    list!: List1[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"])
                    this.list!.push(List1.fromJS(item));
            }
            else {
                this.list = null as any;
            }
        }
    }

    static fromJS(data: any): Domain1 {
        data = typeof data === 'object' ? data : {};
        let result = new Domain1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 内销非销售订单Dto */
export class DomesticNonSalesOrderDto {
    id!: string;
    /** 客户需求日期 */
    customerRequiredDate!: string | null;
    /** ReceiveTime */
    receiveTime!: string | null;
    /** 国家 */
    country!: string | null;
    /** CscotOrderItemId */
    cscotOrderItemId!: string | null;
    /** CscotOrderTime */
    cscotOrderTime!: string | null;
    cscotSru!: string | null;
    cscotOrderType!: string | null;
    wareHouseID!: string | null;
    orderType!: string | null;
    status!: string | null;
    /** 销售员 */
    salesPerson!: string | null;
    customerCode!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 合同号 */
    contractNumber!: string | null;
    /** 客户订单号 */
    customerOrderNumber!: string | null;
    /** 客户生产单号 */
    prodOrderNum!: string | null;
    precalNo!: string | null;
    /** GSS报价单号 */
    gssQuotationNumber!: string | null;
    /** 产品列表 */
    products!: DomesticNonSalesProductDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.customerRequiredDate = _data["customerRequiredDate"] !== undefined ? _data["customerRequiredDate"] : null as any;
            this.receiveTime = _data["receiveTime"] !== undefined ? _data["receiveTime"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.cscotOrderItemId = _data["cscotOrderItemId"] !== undefined ? _data["cscotOrderItemId"] : null as any;
            this.cscotOrderTime = _data["cscotOrderTime"] !== undefined ? _data["cscotOrderTime"] : null as any;
            this.cscotSru = _data["cscotSru"] !== undefined ? _data["cscotSru"] : null as any;
            this.cscotOrderType = _data["cscotOrderType"] !== undefined ? _data["cscotOrderType"] : null as any;
            this.wareHouseID = _data["wareHouseID"] !== undefined ? _data["wareHouseID"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.salesPerson = _data["salesPerson"] !== undefined ? _data["salesPerson"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.contractNumber = _data["contractNumber"] !== undefined ? _data["contractNumber"] : null as any;
            this.customerOrderNumber = _data["customerOrderNumber"] !== undefined ? _data["customerOrderNumber"] : null as any;
            this.prodOrderNum = _data["prodOrderNum"] !== undefined ? _data["prodOrderNum"] : null as any;
            this.precalNo = _data["precalNo"] !== undefined ? _data["precalNo"] : null as any;
            this.gssQuotationNumber = _data["gssQuotationNumber"] !== undefined ? _data["gssQuotationNumber"] : null as any;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(DomesticNonSalesProductDto.fromJS(item));
            }
            else {
                this.products = null as any;
            }
        }
    }

    static fromJS(data: any): DomesticNonSalesOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new DomesticNonSalesOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["customerRequiredDate"] = this.customerRequiredDate !== undefined ? this.customerRequiredDate : null as any;
        data["receiveTime"] = this.receiveTime !== undefined ? this.receiveTime : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["cscotOrderItemId"] = this.cscotOrderItemId !== undefined ? this.cscotOrderItemId : null as any;
        data["cscotOrderTime"] = this.cscotOrderTime !== undefined ? this.cscotOrderTime : null as any;
        data["cscotSru"] = this.cscotSru !== undefined ? this.cscotSru : null as any;
        data["cscotOrderType"] = this.cscotOrderType !== undefined ? this.cscotOrderType : null as any;
        data["wareHouseID"] = this.wareHouseID !== undefined ? this.wareHouseID : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["salesPerson"] = this.salesPerson !== undefined ? this.salesPerson : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["contractNumber"] = this.contractNumber !== undefined ? this.contractNumber : null as any;
        data["customerOrderNumber"] = this.customerOrderNumber !== undefined ? this.customerOrderNumber : null as any;
        data["prodOrderNum"] = this.prodOrderNum !== undefined ? this.prodOrderNum : null as any;
        data["precalNo"] = this.precalNo !== undefined ? this.precalNo : null as any;
        data["gssQuotationNumber"] = this.gssQuotationNumber !== undefined ? this.gssQuotationNumber : null as any;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class DomesticNonSalesOrderDtoPagedResultDto {
    items!: DomesticNonSalesOrderDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DomesticNonSalesOrderDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): DomesticNonSalesOrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DomesticNonSalesOrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class DomesticNonSalesProductDto {
    id!: string;
    /** 电机 */
    basicMotorCode!: string | null;
    /** 数量 */
    number!: number;
    transferListPrice!: string | null;
    tpDiscount!: string | null;
    /** 单价 */
    unitPrice!: number;
    /** 总价 */
    totalPrice!: number;
    /** 币种 */
    currency!: string | null;
    /** 描述 */
    describe!: string | null;
    prodType!: string | null;
    core!: string | null;
    power!: string | null;
    powerUnit!: string | null;
    pole!: string | null;
    voltage!: string | null;
    frequency!: string | null;
    installType!: string | null;
    insulation!: string | null;
    safty!: string | null;
    support!: string | null;
    intSupport!: string | null;
    /** 内销非销售订单产品Vc */
    vcs!: DomesticNonSalesProductVcDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.transferListPrice = _data["transferListPrice"] !== undefined ? _data["transferListPrice"] : null as any;
            this.tpDiscount = _data["tpDiscount"] !== undefined ? _data["tpDiscount"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.totalPrice = _data["totalPrice"] !== undefined ? _data["totalPrice"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
            this.describe = _data["describe"] !== undefined ? _data["describe"] : null as any;
            this.prodType = _data["prodType"] !== undefined ? _data["prodType"] : null as any;
            this.core = _data["core"] !== undefined ? _data["core"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.powerUnit = _data["powerUnit"] !== undefined ? _data["powerUnit"] : null as any;
            this.pole = _data["pole"] !== undefined ? _data["pole"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.installType = _data["installType"] !== undefined ? _data["installType"] : null as any;
            this.insulation = _data["insulation"] !== undefined ? _data["insulation"] : null as any;
            this.safty = _data["safty"] !== undefined ? _data["safty"] : null as any;
            this.support = _data["support"] !== undefined ? _data["support"] : null as any;
            this.intSupport = _data["intSupport"] !== undefined ? _data["intSupport"] : null as any;
            if (Array.isArray(_data["vcs"])) {
                this.vcs = [] as any;
                for (let item of _data["vcs"])
                    this.vcs!.push(DomesticNonSalesProductVcDto.fromJS(item));
            }
            else {
                this.vcs = null as any;
            }
        }
    }

    static fromJS(data: any): DomesticNonSalesProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new DomesticNonSalesProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["transferListPrice"] = this.transferListPrice !== undefined ? this.transferListPrice : null as any;
        data["tpDiscount"] = this.tpDiscount !== undefined ? this.tpDiscount : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["totalPrice"] = this.totalPrice !== undefined ? this.totalPrice : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        data["describe"] = this.describe !== undefined ? this.describe : null as any;
        data["prodType"] = this.prodType !== undefined ? this.prodType : null as any;
        data["core"] = this.core !== undefined ? this.core : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["powerUnit"] = this.powerUnit !== undefined ? this.powerUnit : null as any;
        data["pole"] = this.pole !== undefined ? this.pole : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["installType"] = this.installType !== undefined ? this.installType : null as any;
        data["insulation"] = this.insulation !== undefined ? this.insulation : null as any;
        data["safty"] = this.safty !== undefined ? this.safty : null as any;
        data["support"] = this.support !== undefined ? this.support : null as any;
        data["intSupport"] = this.intSupport !== undefined ? this.intSupport : null as any;
        if (Array.isArray(this.vcs)) {
            data["vcs"] = [];
            for (let item of this.vcs)
                data["vcs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class DomesticNonSalesProductVcDto {
    id!: string;
    /** VcID */
    vcCode!: string | null;
    /** VC描述 */
    meaning!: string | null;
    /** 开放式内容 */
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): DomesticNonSalesProductVcDto {
        data = typeof data === 'object' ? data : {};
        let result = new DomesticNonSalesProductVcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

export class EditApprovalDto {
    /** 审批ID */
    approvalId!: string;
    auditStatus!: AuditStatus;
    /** 意见 */
    approvalRemarks!: string | null;
    /** 附件合同名称 */
    attachmentName!: string | null;
    /** OMS订单号（暂时因为没有与OMS系统做接口，所以暂时由审批人员导入OMS系统成功之后填写） */
    omsOrderNumber!: string | null;
    /** 审批集合 */
    approvalList!: BatchDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.approvalId = _data["approvalId"] !== undefined ? _data["approvalId"] : null as any;
            this.auditStatus = _data["auditStatus"] !== undefined ? _data["auditStatus"] : null as any;
            this.approvalRemarks = _data["approvalRemarks"] !== undefined ? _data["approvalRemarks"] : null as any;
            this.attachmentName = _data["attachmentName"] !== undefined ? _data["attachmentName"] : null as any;
            this.omsOrderNumber = _data["omsOrderNumber"] !== undefined ? _data["omsOrderNumber"] : null as any;
            if (Array.isArray(_data["approvalList"])) {
                this.approvalList = [] as any;
                for (let item of _data["approvalList"])
                    this.approvalList!.push(BatchDto.fromJS(item));
            }
            else {
                this.approvalList = null as any;
            }
        }
    }

    static fromJS(data: any): EditApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalId"] = this.approvalId !== undefined ? this.approvalId : null as any;
        data["auditStatus"] = this.auditStatus !== undefined ? this.auditStatus : null as any;
        data["approvalRemarks"] = this.approvalRemarks !== undefined ? this.approvalRemarks : null as any;
        data["attachmentName"] = this.attachmentName !== undefined ? this.attachmentName : null as any;
        data["omsOrderNumber"] = this.omsOrderNumber !== undefined ? this.omsOrderNumber : null as any;
        if (Array.isArray(this.approvalList)) {
            data["approvalList"] = [];
            for (let item of this.approvalList)
                data["approvalList"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class EditApprovalParam {
    /** 状态 */
    status!: boolean;
    /** 提示信息 */
    message!: string | null;

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): EditApprovalParam {
        data = typeof data === 'object' ? data : {};
        let result = new EditApprovalParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }
}

export class EditCustomCodeDto {
    id!: string;
    /** 客户物料号 */
    customerMaterialNumber!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 机座号 */
    frameSize!: number;
    /** 预计交货日期/周 */
    expectedDeliveryDate!: string | null;
    /** 备注 */
    remark!: string | null;
    /** 售价 */
    salesPrice!: number;
    /** CP编码 */
    cpCode!: string | null;
    /** 二级客户名称 */
    finalCustomerName!: string | null;
    /** 二级客户编码编码 */
    finalCustomerCode!: string | null;
    /** CP名称 */
    cpCoName!: string | null;
    /** Vc */
    vcCodes!: string | null;
    /** Vc备注 */
    vcCodeRemark!: string | null;
    technicalSpecifications!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.cpCoName = _data["cpCoName"] !== undefined ? _data["cpCoName"] : null as any;
            this.vcCodes = _data["vcCodes"] !== undefined ? _data["vcCodes"] : null as any;
            this.vcCodeRemark = _data["vcCodeRemark"] !== undefined ? _data["vcCodeRemark"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
        }
    }

    static fromJS(data: any): EditCustomCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditCustomCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["cpCoName"] = this.cpCoName !== undefined ? this.cpCoName : null as any;
        data["vcCodes"] = this.vcCodes !== undefined ? this.vcCodes : null as any;
        data["vcCodeRemark"] = this.vcCodeRemark !== undefined ? this.vcCodeRemark : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        return data;
    }
}

export class EditOrderFormDto {
    /** 是否提交 */
    isSubmit!: boolean;
    /** 是否生成合同号 */
    isPONumber!: boolean;
    /** 定制需求
合同号取当前订单的合同号 */
    poNumberOrderFormId!: string | null;
    /** 订单Id */
    orderFormId!: string;
    /** 特价申请号 */
    specialOfferApplicationNumber!: string | null;
    /** 总台数 */
    totalNumber!: string | null;
    /** 总价 */
    totalPrice!: string | null;
    /** 客户订单号 */
    customerOrderNumber!: string | null;
    /** PO号 */
    poNumber!: string | null;
    /** 预计交货日期/天数 */
    expectedDeliveryDate!: string | null;
    /** 预计交货日期 */
    expectedDeliveryDateDisplay!: moment.Moment | null;
    /** 项目名称 */
    projectName!: string | null;
    /** 项目编号 */
    projectNo!: string | null;
    /** 销售区域 */
    salesAreaCode!: string | null;
    /** 行业 */
    industryCode!: string | null;
    /** 应用 */
    applicationCode!: string | null;
    /** 渠道 */
    channelCode!: string | null;
    /** 数据交换平台订单类型id */
    dataPlatFormOrderTypeId!: string;
    /** 责任销售编码 */
    responsibleSalesCode!: string | null;
    /** 责任销售名称 */
    responsibleSalesName!: string | null;
    /** 最终客户编码 */
    endCustomerCode!: string | null;
    /** 最终客户名称 */
    endCustomerName!: string | null;
    /** 发货地址编码 */
    shippingAddressCode!: string | null;
    /** 发货地址 */
    shippingAddress!: string | null;
    /** 当前登录CP的编号 */
    cpNo!: string | null;
    /** 附件合同名称 */
    attachmentName!: string | null;
    /** 交货条款
此字段为20210324添加 */
    deliveryTerms!: string | null;
    /** 主机 */
    productBasicMotors!: EditProductBasicMotorDto[] | null;
    productBasicMotorMtsAdd!: ProductBasicMotorMtsInDto;
    /** 是否为备库订单 */
    forLibOrderFlg!: boolean | null;
    /** 最终客户名称 */
    finalCustomer!: string | null;
    /** 最终客户代号 */
    finalCustomerCode!: string | null;
    /** 当前订单税率 */
    curTaxRate!: number | null;
    /** 不含税总金额 sum（ProductBasicMotors.PriceWithoutTax） */
    totalPriceWithoutTax!: number | null;
    /** 总税金 sum（ProductBasicMotors.UnitTaxPrice） */
    totalTaxPrice!: number | null;
    /** 最终用户所在地 */
    locationCountry!: string | null;
    /** 备案号(仅风险国家填写) */
    recordNumber!: string | null;
    /** 产品售价保留小数 */
    salesPriceDecimal!: boolean;
    /** 自动交货时间 */
    autoDeliveryTime!: moment.Moment | null;
    /** 订单保存时间 */
    saveTime!: moment.Moment | null;
    /** 下单时间 */
    orderTime!: moment.Moment | null;
    /** 水单附件 */
    attachmentBankReceipt!: string | null;

    init(_data?: any) {
        if (_data) {
            this.isSubmit = _data["isSubmit"] !== undefined ? _data["isSubmit"] : null as any;
            this.isPONumber = _data["isPONumber"] !== undefined ? _data["isPONumber"] : null as any;
            this.poNumberOrderFormId = _data["poNumberOrderFormId"] !== undefined ? _data["poNumberOrderFormId"] : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.specialOfferApplicationNumber = _data["specialOfferApplicationNumber"] !== undefined ? _data["specialOfferApplicationNumber"] : null as any;
            this.totalNumber = _data["totalNumber"] !== undefined ? _data["totalNumber"] : null as any;
            this.totalPrice = _data["totalPrice"] !== undefined ? _data["totalPrice"] : null as any;
            this.customerOrderNumber = _data["customerOrderNumber"] !== undefined ? _data["customerOrderNumber"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.expectedDeliveryDateDisplay = _data["expectedDeliveryDateDisplay"] ? moment(_data["expectedDeliveryDateDisplay"].toString()) : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.projectNo = _data["projectNo"] !== undefined ? _data["projectNo"] : null as any;
            this.salesAreaCode = _data["salesAreaCode"] !== undefined ? _data["salesAreaCode"] : null as any;
            this.industryCode = _data["industryCode"] !== undefined ? _data["industryCode"] : null as any;
            this.applicationCode = _data["applicationCode"] !== undefined ? _data["applicationCode"] : null as any;
            this.channelCode = _data["channelCode"] !== undefined ? _data["channelCode"] : null as any;
            this.dataPlatFormOrderTypeId = _data["dataPlatFormOrderTypeId"] !== undefined ? _data["dataPlatFormOrderTypeId"] : null as any;
            this.responsibleSalesCode = _data["responsibleSalesCode"] !== undefined ? _data["responsibleSalesCode"] : null as any;
            this.responsibleSalesName = _data["responsibleSalesName"] !== undefined ? _data["responsibleSalesName"] : null as any;
            this.endCustomerCode = _data["endCustomerCode"] !== undefined ? _data["endCustomerCode"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.shippingAddressCode = _data["shippingAddressCode"] !== undefined ? _data["shippingAddressCode"] : null as any;
            this.shippingAddress = _data["shippingAddress"] !== undefined ? _data["shippingAddress"] : null as any;
            this.cpNo = _data["cpNo"] !== undefined ? _data["cpNo"] : null as any;
            this.attachmentName = _data["attachmentName"] !== undefined ? _data["attachmentName"] : null as any;
            this.deliveryTerms = _data["deliveryTerms"] !== undefined ? _data["deliveryTerms"] : null as any;
            if (Array.isArray(_data["productBasicMotors"])) {
                this.productBasicMotors = [] as any;
                for (let item of _data["productBasicMotors"])
                    this.productBasicMotors!.push(EditProductBasicMotorDto.fromJS(item));
            }
            else {
                this.productBasicMotors = null as any;
            }
            this.productBasicMotorMtsAdd = _data["productBasicMotorMtsAdd"] ? ProductBasicMotorMtsInDto.fromJS(_data["productBasicMotorMtsAdd"]) : null as any;
            this.forLibOrderFlg = _data["forLibOrderFlg"] !== undefined ? _data["forLibOrderFlg"] : null as any;
            this.finalCustomer = _data["finalCustomer"] !== undefined ? _data["finalCustomer"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.curTaxRate = _data["curTaxRate"] !== undefined ? _data["curTaxRate"] : null as any;
            this.totalPriceWithoutTax = _data["totalPriceWithoutTax"] !== undefined ? _data["totalPriceWithoutTax"] : null as any;
            this.totalTaxPrice = _data["totalTaxPrice"] !== undefined ? _data["totalTaxPrice"] : null as any;
            this.locationCountry = _data["locationCountry"] !== undefined ? _data["locationCountry"] : null as any;
            this.recordNumber = _data["recordNumber"] !== undefined ? _data["recordNumber"] : null as any;
            this.salesPriceDecimal = _data["salesPriceDecimal"] !== undefined ? _data["salesPriceDecimal"] : null as any;
            this.autoDeliveryTime = _data["autoDeliveryTime"] ? moment(_data["autoDeliveryTime"].toString()) : null as any;
            this.saveTime = _data["saveTime"] ? moment(_data["saveTime"].toString()) : null as any;
            this.orderTime = _data["orderTime"] ? moment(_data["orderTime"].toString()) : null as any;
            this.attachmentBankReceipt = _data["attachmentBankReceipt"] !== undefined ? _data["attachmentBankReceipt"] : null as any;
        }
    }

    static fromJS(data: any): EditOrderFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditOrderFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSubmit"] = this.isSubmit !== undefined ? this.isSubmit : null as any;
        data["isPONumber"] = this.isPONumber !== undefined ? this.isPONumber : null as any;
        data["poNumberOrderFormId"] = this.poNumberOrderFormId !== undefined ? this.poNumberOrderFormId : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["specialOfferApplicationNumber"] = this.specialOfferApplicationNumber !== undefined ? this.specialOfferApplicationNumber : null as any;
        data["totalNumber"] = this.totalNumber !== undefined ? this.totalNumber : null as any;
        data["totalPrice"] = this.totalPrice !== undefined ? this.totalPrice : null as any;
        data["customerOrderNumber"] = this.customerOrderNumber !== undefined ? this.customerOrderNumber : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["expectedDeliveryDateDisplay"] = this.expectedDeliveryDateDisplay ? this.expectedDeliveryDateDisplay.toISOString() : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["projectNo"] = this.projectNo !== undefined ? this.projectNo : null as any;
        data["salesAreaCode"] = this.salesAreaCode !== undefined ? this.salesAreaCode : null as any;
        data["industryCode"] = this.industryCode !== undefined ? this.industryCode : null as any;
        data["applicationCode"] = this.applicationCode !== undefined ? this.applicationCode : null as any;
        data["channelCode"] = this.channelCode !== undefined ? this.channelCode : null as any;
        data["dataPlatFormOrderTypeId"] = this.dataPlatFormOrderTypeId !== undefined ? this.dataPlatFormOrderTypeId : null as any;
        data["responsibleSalesCode"] = this.responsibleSalesCode !== undefined ? this.responsibleSalesCode : null as any;
        data["responsibleSalesName"] = this.responsibleSalesName !== undefined ? this.responsibleSalesName : null as any;
        data["endCustomerCode"] = this.endCustomerCode !== undefined ? this.endCustomerCode : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["shippingAddressCode"] = this.shippingAddressCode !== undefined ? this.shippingAddressCode : null as any;
        data["shippingAddress"] = this.shippingAddress !== undefined ? this.shippingAddress : null as any;
        data["cpNo"] = this.cpNo !== undefined ? this.cpNo : null as any;
        data["attachmentName"] = this.attachmentName !== undefined ? this.attachmentName : null as any;
        data["deliveryTerms"] = this.deliveryTerms !== undefined ? this.deliveryTerms : null as any;
        if (Array.isArray(this.productBasicMotors)) {
            data["productBasicMotors"] = [];
            for (let item of this.productBasicMotors)
                data["productBasicMotors"].push(item ? item.toJSON() : null as any);
        }
        data["productBasicMotorMtsAdd"] = this.productBasicMotorMtsAdd ? this.productBasicMotorMtsAdd.toJSON() : null as any;
        data["forLibOrderFlg"] = this.forLibOrderFlg !== undefined ? this.forLibOrderFlg : null as any;
        data["finalCustomer"] = this.finalCustomer !== undefined ? this.finalCustomer : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["curTaxRate"] = this.curTaxRate !== undefined ? this.curTaxRate : null as any;
        data["totalPriceWithoutTax"] = this.totalPriceWithoutTax !== undefined ? this.totalPriceWithoutTax : null as any;
        data["totalTaxPrice"] = this.totalTaxPrice !== undefined ? this.totalTaxPrice : null as any;
        data["locationCountry"] = this.locationCountry !== undefined ? this.locationCountry : null as any;
        data["recordNumber"] = this.recordNumber !== undefined ? this.recordNumber : null as any;
        data["salesPriceDecimal"] = this.salesPriceDecimal !== undefined ? this.salesPriceDecimal : null as any;
        data["autoDeliveryTime"] = this.autoDeliveryTime ? this.autoDeliveryTime.toISOString() : null as any;
        data["saveTime"] = this.saveTime ? this.saveTime.toISOString() : null as any;
        data["orderTime"] = this.orderTime ? this.orderTime.toISOString() : null as any;
        data["attachmentBankReceipt"] = this.attachmentBankReceipt !== undefined ? this.attachmentBankReceipt : null as any;
        return data;
    }
}

/** 订单开口向编辑Dto */
export class EditOrderFormOpenItemDto {
    /** 订单id */
    id!: string;
    /** 开口项 */
    openItems!: string[] | null;
    /** 开口项备注 */
    openItemRemark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["openItems"])) {
                this.openItems = [] as any;
                for (let item of _data["openItems"])
                    this.openItems!.push(item);
            }
            else {
                this.openItems = null as any;
            }
            this.openItemRemark = _data["openItemRemark"] !== undefined ? _data["openItemRemark"] : null as any;
        }
    }

    static fromJS(data: any): EditOrderFormOpenItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditOrderFormOpenItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.openItems)) {
            data["openItems"] = [];
            for (let item of this.openItems)
                data["openItems"].push(item);
        }
        data["openItemRemark"] = this.openItemRemark !== undefined ? this.openItemRemark : null as any;
        return data;
    }
}

export class EditProductBasicMotorDto {
    /** 序号 */
    serialNumber!: number;
    /** 主机Id */
    productBasicMotorId!: string | null;
    /** 客户物料号 */
    customerMaterialNumber!: string | null;
    /** 系数 */
    multiplier!: number;
    /** 系数过期时间 */
    multiplierExpiredDate!: moment.Moment | null;
    /** 面价 */
    unitPrice!: number;
    /** 售价 */
    salesPrice!: number;
    /** 产品组合的数量 */
    numberOfProduct!: number;
    /** 备注二 */
    remarkTwo!: string | null;
    /** 预计交货日期/天数 */
    expectedDeliveryDate!: string | null;
    /** 实际交货日期/天数 */
    actualDeliveryDate!: string | null;
    /** 原始实际交货日期/天 */
    originalActualDeliveryDate!: string | null;
    /** 客户期望交货日期/天 */
    customerExpectedDeliveryDate!: moment.Moment | null;
    /** 客户原期望交货期 */
    customerActualDeliveryDate!: moment.Moment | null;
    /** GSS报价号 */
    gssQuotationNo!: string | null;
    /** GSS技术确认号（SFDC） */
    gssTechnicalConfirmationNumber!: string | null;
    /** 技术规范（技术规范号） */
    technicalSpecifications!: string | null;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** 订单类型 */
    orderType!: string | null;
    checkResultOutput!: CheckResultOutputDto;
    /** vc */
    productVCDtos!: EditProductVCDto[] | null;
    /** 1 含税总金额 售价(SalesPrice)*NumberOfProduct
售价(salesPrice)=(面价+VC.unitPrice)*系数(multiplier) */
    priceWithTax!: number | null;
    /** 不含税总金额 PriceWithTax-UnitTaxPrice */
    priceWithoutTax!: number | null;
    /** 2 税金 PriceWithTax*OrderForm.TaxPrice
总价/1.13后四舍五入，保留2位小数，订单行先计算再合计进总价，界面显示只要在header里 */
    unitTaxPrice!: number | null;
    /** 可打折面价 */
    discountUnitPrice!: number | null;
    /** 按台收不打折 */
    noDiscountByPlatformUnitPrice!: number | null;
    /** 按单收不打折 */
    noDiscountByListUnitPrice!: number | null;
    /** 特殊返点标识 */
    specialRebateFlag!: string | null;
    /** 是否为PMS派生选型后,新增的主机 */
    isNewPMSProduct!: boolean | null;
    /** 运营相关备注 */
    operationalRemarks!: string | null;
    /** PMS原始折扣 */
    pmsMultiplier!: number | null;
    /** 特价号 */
    specialOfferNumber!: string | null;
    /** 是否增减了VC或改动了VC的备注信息导致技术协议发生了变动 */
    agreementChanges!: boolean;

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.productBasicMotorId = _data["productBasicMotorId"] !== undefined ? _data["productBasicMotorId"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.multiplier = _data["multiplier"] !== undefined ? _data["multiplier"] : null as any;
            this.multiplierExpiredDate = _data["multiplierExpiredDate"] ? moment(_data["multiplierExpiredDate"].toString()) : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.numberOfProduct = _data["numberOfProduct"] !== undefined ? _data["numberOfProduct"] : null as any;
            this.remarkTwo = _data["remarkTwo"] !== undefined ? _data["remarkTwo"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.actualDeliveryDate = _data["actualDeliveryDate"] !== undefined ? _data["actualDeliveryDate"] : null as any;
            this.originalActualDeliveryDate = _data["originalActualDeliveryDate"] !== undefined ? _data["originalActualDeliveryDate"] : null as any;
            this.customerExpectedDeliveryDate = _data["customerExpectedDeliveryDate"] ? moment(_data["customerExpectedDeliveryDate"].toString()) : null as any;
            this.customerActualDeliveryDate = _data["customerActualDeliveryDate"] ? moment(_data["customerActualDeliveryDate"].toString()) : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.checkResultOutput = _data["checkResultOutput"] ? CheckResultOutputDto.fromJS(_data["checkResultOutput"]) : null as any;
            if (Array.isArray(_data["productVCDtos"])) {
                this.productVCDtos = [] as any;
                for (let item of _data["productVCDtos"])
                    this.productVCDtos!.push(EditProductVCDto.fromJS(item));
            }
            else {
                this.productVCDtos = null as any;
            }
            this.priceWithTax = _data["priceWithTax"] !== undefined ? _data["priceWithTax"] : null as any;
            this.priceWithoutTax = _data["priceWithoutTax"] !== undefined ? _data["priceWithoutTax"] : null as any;
            this.unitTaxPrice = _data["unitTaxPrice"] !== undefined ? _data["unitTaxPrice"] : null as any;
            this.discountUnitPrice = _data["discountUnitPrice"] !== undefined ? _data["discountUnitPrice"] : null as any;
            this.noDiscountByPlatformUnitPrice = _data["noDiscountByPlatformUnitPrice"] !== undefined ? _data["noDiscountByPlatformUnitPrice"] : null as any;
            this.noDiscountByListUnitPrice = _data["noDiscountByListUnitPrice"] !== undefined ? _data["noDiscountByListUnitPrice"] : null as any;
            this.specialRebateFlag = _data["specialRebateFlag"] !== undefined ? _data["specialRebateFlag"] : null as any;
            this.isNewPMSProduct = _data["isNewPMSProduct"] !== undefined ? _data["isNewPMSProduct"] : null as any;
            this.operationalRemarks = _data["operationalRemarks"] !== undefined ? _data["operationalRemarks"] : null as any;
            this.pmsMultiplier = _data["pmsMultiplier"] !== undefined ? _data["pmsMultiplier"] : null as any;
            this.specialOfferNumber = _data["specialOfferNumber"] !== undefined ? _data["specialOfferNumber"] : null as any;
            this.agreementChanges = _data["agreementChanges"] !== undefined ? _data["agreementChanges"] : null as any;
        }
    }

    static fromJS(data: any): EditProductBasicMotorDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditProductBasicMotorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["productBasicMotorId"] = this.productBasicMotorId !== undefined ? this.productBasicMotorId : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["multiplier"] = this.multiplier !== undefined ? this.multiplier : null as any;
        data["multiplierExpiredDate"] = this.multiplierExpiredDate ? this.multiplierExpiredDate.toISOString() : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["numberOfProduct"] = this.numberOfProduct !== undefined ? this.numberOfProduct : null as any;
        data["remarkTwo"] = this.remarkTwo !== undefined ? this.remarkTwo : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["actualDeliveryDate"] = this.actualDeliveryDate !== undefined ? this.actualDeliveryDate : null as any;
        data["originalActualDeliveryDate"] = this.originalActualDeliveryDate !== undefined ? this.originalActualDeliveryDate : null as any;
        data["customerExpectedDeliveryDate"] = this.customerExpectedDeliveryDate ? this.customerExpectedDeliveryDate.toISOString() : null as any;
        data["customerActualDeliveryDate"] = this.customerActualDeliveryDate ? this.customerActualDeliveryDate.toISOString() : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["checkResultOutput"] = this.checkResultOutput ? this.checkResultOutput.toJSON() : null as any;
        if (Array.isArray(this.productVCDtos)) {
            data["productVCDtos"] = [];
            for (let item of this.productVCDtos)
                data["productVCDtos"].push(item ? item.toJSON() : null as any);
        }
        data["priceWithTax"] = this.priceWithTax !== undefined ? this.priceWithTax : null as any;
        data["priceWithoutTax"] = this.priceWithoutTax !== undefined ? this.priceWithoutTax : null as any;
        data["unitTaxPrice"] = this.unitTaxPrice !== undefined ? this.unitTaxPrice : null as any;
        data["discountUnitPrice"] = this.discountUnitPrice !== undefined ? this.discountUnitPrice : null as any;
        data["noDiscountByPlatformUnitPrice"] = this.noDiscountByPlatformUnitPrice !== undefined ? this.noDiscountByPlatformUnitPrice : null as any;
        data["noDiscountByListUnitPrice"] = this.noDiscountByListUnitPrice !== undefined ? this.noDiscountByListUnitPrice : null as any;
        data["specialRebateFlag"] = this.specialRebateFlag !== undefined ? this.specialRebateFlag : null as any;
        data["isNewPMSProduct"] = this.isNewPMSProduct !== undefined ? this.isNewPMSProduct : null as any;
        data["operationalRemarks"] = this.operationalRemarks !== undefined ? this.operationalRemarks : null as any;
        data["pmsMultiplier"] = this.pmsMultiplier !== undefined ? this.pmsMultiplier : null as any;
        data["specialOfferNumber"] = this.specialOfferNumber !== undefined ? this.specialOfferNumber : null as any;
        data["agreementChanges"] = this.agreementChanges !== undefined ? this.agreementChanges : null as any;
        return data;
    }
}

export class EditProductVCDto {
    /** VCId */
    productVCId!: string;
    /** VC编号 */
    vcCode!: string | null;
    vcShowType!: VCShowType;
    /** 备注 */
    remark!: string | null;
    /** 面价 */
    unitPrice!: number;
    /** 售价 */
    salesPrice!: number;
    /** 是否内含vc */
    isInside!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.productVCId = _data["productVCId"] !== undefined ? _data["productVCId"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.isInside = _data["isInside"] !== undefined ? _data["isInside"] : null as any;
        }
    }

    static fromJS(data: any): EditProductVCDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditProductVCDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productVCId"] = this.productVCId !== undefined ? this.productVCId : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["isInside"] = this.isInside !== undefined ? this.isInside : null as any;
        return data;
    }
}

export class Elec {
    /** input box type */
    inType!: string | null;
    /** integer string list read-only imagelist combobox float */
    paraType!: string | null;
    /** 问题点，tech data 不应该有voltage，需要使用实际设备调用Motorizer api 测试。 */
    key!: string | null;
    mask!: string | null;
    /** default value（只是个ID） */
    val!: string | null;
    /** 默认值的意思 */
    valdesc!: string | null;
    domain!: Domain1;
    desc!: string | null;
    help!: string | null;

    init(_data?: any) {
        if (_data) {
            this.inType = _data["inType"] !== undefined ? _data["inType"] : null as any;
            this.paraType = _data["paraType"] !== undefined ? _data["paraType"] : null as any;
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.mask = _data["mask"] !== undefined ? _data["mask"] : null as any;
            this.val = _data["val"] !== undefined ? _data["val"] : null as any;
            this.valdesc = _data["valdesc"] !== undefined ? _data["valdesc"] : null as any;
            this.domain = _data["domain"] ? Domain1.fromJS(_data["domain"]) : null as any;
            this.desc = _data["desc"] !== undefined ? _data["desc"] : null as any;
            this.help = _data["help"] !== undefined ? _data["help"] : null as any;
        }
    }

    static fromJS(data: any): Elec {
        data = typeof data === 'object' ? data : {};
        let result = new Elec();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inType"] = this.inType !== undefined ? this.inType : null as any;
        data["paraType"] = this.paraType !== undefined ? this.paraType : null as any;
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["mask"] = this.mask !== undefined ? this.mask : null as any;
        data["val"] = this.val !== undefined ? this.val : null as any;
        data["valdesc"] = this.valdesc !== undefined ? this.valdesc : null as any;
        data["domain"] = this.domain ? this.domain.toJSON() : null as any;
        data["desc"] = this.desc !== undefined ? this.desc : null as any;
        data["help"] = this.help !== undefined ? this.help : null as any;
        return data;
    }
}

/** 0 = Superposition (叠加) 1 = Value (取值) */
export enum EngineeringCalculationMode {
    Superposition = 0,
    Value = 1,
}

/** 0 = InProgress (执行中) 1 = Completed (成功) 2 = Abnormal (异常) */
export enum EnumAutoApproveTaskStatus {
    InProgress = 0,
    Completed = 1,
    Abnormal = 2,
}

/** 1 = UnitPrice (单价) 2 = SalesPrice (售价变更) 3 = Multiplier (系数变更) 4 = AddVCChange (新增VC) 5 = DeleteVCChange (VC删除) 6 = VCChangeRemark (OpenVC备注变更) 7 = TotalUnitPrice (总面价) 8 = ExportNewUnitPrice (新单价) 9 = VCUnitPrice (VC面价变更) 10 = TransferPrice (TP总价变更) 11 = UnitTransferPrice (TP单价变更) 12 = TechnicalSpecifications (协议号变更) 13 = CustomerExpectedDeliveryDate (交期变更) 14 = ExportCustomerExpectedDeliveryDate (客户期望交货期变更) 15 = ExportOrderConfirMation (产品确认变更) 16 = ExportTechConfirmationNumber (技术确认号变更) 17 = ExportGssQuotationNumber (特价号变更) 18 = ExportTotalPrice (总价变更) 19 = ExportOrderConfirMationComment (产品确认备注变更) 20 = GSSQuotationNo (报价号变更) 21 = GSSTechnicalConfirmationNumber (技术确认号变更) 22 = OperationalRemarks (运营相关备注变更) 23 = CustomerMaterialNumber (客户物料号变更) 24 = ProjectNo (项目编码变更) 25 = ProjectName (项目名称变更) 26 = SpecialOfferApplicationNumber (特价号变更) 27 = PONumber (合同号变更) 28 = OrderType (订单类型变更) 29 = RemarkTwo (商务备注变更) 30 = CustomerOrderNumber (客户订单号变更) 31 = FinalCustomer (直接客户变更) 32 = Industry (行业变更) 33 = JINCodeChange (境界代码变更) */
export enum EnumChangeType {
    UnitPrice = 1,
    SalesPrice = 2,
    Multiplier = 3,
    AddVCChange = 4,
    DeleteVCChange = 5,
    VCChangeRemark = 6,
    TotalUnitPrice = 7,
    ExportNewUnitPrice = 8,
    VCUnitPrice = 9,
    TransferPrice = 10,
    UnitTransferPrice = 11,
    TechnicalSpecifications = 12,
    CustomerExpectedDeliveryDate = 13,
    ExportCustomerExpectedDeliveryDate = 14,
    ExportOrderConfirMation = 15,
    ExportTechConfirmationNumber = 16,
    ExportGssQuotationNumber = 17,
    ExportTotalPrice = 18,
    ExportOrderConfirMationComment = 19,
    GSSQuotationNo = 20,
    GSSTechnicalConfirmationNumber = 21,
    OperationalRemarks = 22,
    CustomerMaterialNumber = 23,
    ProjectNo = 24,
    ProjectName = 25,
    SpecialOfferApplicationNumber = 26,
    PONumber = 27,
    OrderType = 28,
    RemarkTwo = 29,
    CustomerOrderNumber = 30,
    FinalCustomer = 31,
    Industry = 32,
    JINCodeChange = 33,
}

/** 1 = Country 2 = Status 3 = VCConfirmationStatus 4 = ReviewStatus */
export enum EnumOISExportOrderDictionaryCategory {
    Country = 1,
    Status = 2,
    VCConfirmationStatus = 3,
    ReviewStatus = 4,
}

/** 0 = Waiting (待提交) 1 = Pending (待审核) 2 = Approved (审核通过) 3 = Rejected (已拒绝) 4 = EndApproved (最终审核通过) 5 = Submitted (已提交) 6 = OrderChange (订单变更中) 7 = ConfirmChanges (待确认变更) 8 = ExportOrderChangeConfirm (订单变更完成) 9 = ExportOrderChangeRejected (订单变更已退回) */
export enum EnumOISExportOrderReviewStatus {
    Waiting = 0,
    Pending = 1,
    Approved = 2,
    Rejected = 3,
    EndApproved = 4,
    Submitted = 5,
    OrderChange = 6,
    ConfirmChanges = 7,
    ExportOrderChangeConfirm = 8,
    ExportOrderChangeRejected = 9,
}

/** 1 = Close (Close) 2 = Open (Open) -1 = UnKnow (未知VC) */
export enum EnumOISExportOrderVcOpenOrClose {
    Close = 1,
    Open = 2,
    UnKnow = -1,
}

/** 1 = OIS (内销) 2 = Export (外销) */
export enum EnumOrderChangeType {
    OIS = 1,
    Export = 2,
}

/** 0 = Standard (标准) 1 = Custom (自定义) 2 = Industry (行业VC) 4 = Import (进口电机配置VC) 5 = ExportOrder (特殊Vc) 100 = ExportVC (外销VC) -1 = None (编号缺失) */
export enum EnumVcType {
    Standard = 0,
    Custom = 1,
    Industry = 2,
    Import = 4,
    ExportOrder = 5,
    ExportVC = 100,
    None = -1,
}

/** VC确认 */
export class ExcelExportOrderProductVCConfirmation {
    vcID!: string | null;
    /** VC描述 */
    meaning!: string | null;
    /** 开放式内容 */
    remark!: string | null;
    /** 新增/删除/修改 */
    updateStatus!: number;

    init(_data?: any) {
        if (_data) {
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.updateStatus = _data["updateStatus"] !== undefined ? _data["updateStatus"] : null as any;
        }
    }

    static fromJS(data: any): ExcelExportOrderProductVCConfirmation {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelExportOrderProductVCConfirmation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["updateStatus"] = this.updateStatus !== undefined ? this.updateStatus : null as any;
        return data;
    }
}

export class ExportCTOProductBasicMotorDto {
    /** 客户编号 */
    cpCode!: string | null;
    /** 客户名称 */
    cpCoName!: string | null;
    /** 二级客户编号 */
    finalCustomerCode!: string | null;
    /** 二级客户名称 */
    finalCustomerName!: string | null;
    /** 客户物料号 */
    customerMaterialNumber!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 产品代码 */
    basicMotorCode!: string | null;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 机座号 */
    frameSize!: number;
    /** GSS报价号 */
    gssQuotationNo!: string | null;
    /** GSS技术确认号 */
    gssTechnicalConfirmationNumber!: string | null;
    /** 技术协议号 */
    technicalSpecifications!: string | null;
    /** 备注 */
    remark!: string | null;
    /** VC代码 */
    vcCode!: string | null;
    /** VC面价 */
    vcPrice!: string | null;
    /** 售价 */
    salesPrice!: number;
    /** 特价号 */
    specialOfferNumber!: string | null;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** 预计交货日期/天 */
    expectedDeliveryDate!: string | null;
    /** 报价产品标识 */
    technologyQuotationProductId!: string | null;
    /** 协议产品标识 (协议是针对产品行的且对所有客户有效，因此在业务上不需要考虑客户变更的场景) */
    technicalSpecificationProductId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.cpCoName = _data["cpCoName"] !== undefined ? _data["cpCoName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.vcPrice = _data["vcPrice"] !== undefined ? _data["vcPrice"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.specialOfferNumber = _data["specialOfferNumber"] !== undefined ? _data["specialOfferNumber"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
            this.technicalSpecificationProductId = _data["technicalSpecificationProductId"] !== undefined ? _data["technicalSpecificationProductId"] : null as any;
        }
    }

    static fromJS(data: any): ExportCTOProductBasicMotorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportCTOProductBasicMotorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["cpCoName"] = this.cpCoName !== undefined ? this.cpCoName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["vcPrice"] = this.vcPrice !== undefined ? this.vcPrice : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["specialOfferNumber"] = this.specialOfferNumber !== undefined ? this.specialOfferNumber : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        data["technicalSpecificationProductId"] = this.technicalSpecificationProductId !== undefined ? this.technicalSpecificationProductId : null as any;
        return data;
    }
}

/** 外销订单变更汇总输出 */
export class ExportNewOrderChangeSummaryOutDto {
    /** const changeTypes = ['VC', '备注全', '交期变化', '总面价', '售价', '系数', 'TP', 'URL']; */
    changeTypes!: string[] | null;
    isoItem!: string | null;
    csoItem!: string | null;
    /** pmu订单号-ISO号 */
    internalSalesOrder!: string | null;
    /** LSU订单号-CSO号 */
    customerSalesOrder!: string | null;
    /** OMS单号 */
    omsOrderNumber!: string | null;
    /** 序列号-行号 */
    serialNumber!: string | null;
    oldProduct!: NewOrderChangeSummaryProductOutDto;
    newProduct!: NewOrderChangeSummaryProductOutDto;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["changeTypes"])) {
                this.changeTypes = [] as any;
                for (let item of _data["changeTypes"])
                    this.changeTypes!.push(item);
            }
            else {
                this.changeTypes = null as any;
            }
            this.isoItem = _data["isoItem"] !== undefined ? _data["isoItem"] : null as any;
            this.csoItem = _data["csoItem"] !== undefined ? _data["csoItem"] : null as any;
            this.internalSalesOrder = _data["internalSalesOrder"] !== undefined ? _data["internalSalesOrder"] : null as any;
            this.customerSalesOrder = _data["customerSalesOrder"] !== undefined ? _data["customerSalesOrder"] : null as any;
            this.omsOrderNumber = _data["omsOrderNumber"] !== undefined ? _data["omsOrderNumber"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.oldProduct = _data["oldProduct"] ? NewOrderChangeSummaryProductOutDto.fromJS(_data["oldProduct"]) : null as any;
            this.newProduct = _data["newProduct"] ? NewOrderChangeSummaryProductOutDto.fromJS(_data["newProduct"]) : null as any;
        }
    }

    static fromJS(data: any): ExportNewOrderChangeSummaryOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportNewOrderChangeSummaryOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.changeTypes)) {
            data["changeTypes"] = [];
            for (let item of this.changeTypes)
                data["changeTypes"].push(item);
        }
        data["isoItem"] = this.isoItem !== undefined ? this.isoItem : null as any;
        data["csoItem"] = this.csoItem !== undefined ? this.csoItem : null as any;
        data["internalSalesOrder"] = this.internalSalesOrder !== undefined ? this.internalSalesOrder : null as any;
        data["customerSalesOrder"] = this.customerSalesOrder !== undefined ? this.customerSalesOrder : null as any;
        data["omsOrderNumber"] = this.omsOrderNumber !== undefined ? this.omsOrderNumber : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["oldProduct"] = this.oldProduct ? this.oldProduct.toJSON() : null as any;
        data["newProduct"] = this.newProduct ? this.newProduct.toJSON() : null as any;
        return data;
    }
}

export class ExportOEMProductBasicMotorDto {
    /** 客户编号 */
    cpCode!: string | null;
    /** 客户名称 */
    cpCoName!: string | null;
    /** 二级客户编号 */
    finalCustomerCode!: string | null;
    /** 二级客户名称 */
    finalCustomerName!: string | null;
    /** 客户物料号 */
    customerMaterialNumber!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 产品代码 */
    basicMotorCode!: string | null;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 机座号 */
    frameSize!: number;
    /** GSS报价号 */
    gssQuotationNo!: string | null;
    /** GSS技术确认号 */
    gssTechnicalConfirmationNumber!: string | null;
    /** 技术协议号 */
    technicalSpecifications!: string | null;
    /** 备注 */
    remark!: string | null;
    /** VC代码 */
    vcCode!: string | null;
    /** 售价 */
    salesPrice!: number;
    /** 特价号 */
    specialOfferNumber!: string | null;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** 预计交货日期/天 */
    expectedDeliveryDate!: string | null;
    /** 报价产品标识 */
    technologyQuotationProductId!: string | null;
    /** 协议产品标识 (协议是针对产品行的且对所有客户有效，因此在业务上不需要考虑客户变更的场景) */
    technicalSpecificationProductId!: string | null;
    /** 系数 */
    multiplier!: number;

    init(_data?: any) {
        if (_data) {
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.cpCoName = _data["cpCoName"] !== undefined ? _data["cpCoName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.specialOfferNumber = _data["specialOfferNumber"] !== undefined ? _data["specialOfferNumber"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
            this.technicalSpecificationProductId = _data["technicalSpecificationProductId"] !== undefined ? _data["technicalSpecificationProductId"] : null as any;
            this.multiplier = _data["multiplier"] !== undefined ? _data["multiplier"] : null as any;
        }
    }

    static fromJS(data: any): ExportOEMProductBasicMotorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOEMProductBasicMotorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["cpCoName"] = this.cpCoName !== undefined ? this.cpCoName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["specialOfferNumber"] = this.specialOfferNumber !== undefined ? this.specialOfferNumber : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        data["technicalSpecificationProductId"] = this.technicalSpecificationProductId !== undefined ? this.technicalSpecificationProductId : null as any;
        data["multiplier"] = this.multiplier !== undefined ? this.multiplier : null as any;
        return data;
    }
}

export class ExportOrder {
    /** 合同号 */
    poNumber!: string | null;
    /** 客户代码 */
    endCustomerCode!: string | null;
    /** 客户名称 */
    endCustomerName!: string | null;
    /** 渠道 */
    channelName!: string | null;
    /** 行业 */
    industryName!: string | null;
    /** 应用 */
    applicationName!: string | null;
    /** 交货地址、电话 */
    shippingAddress!: string | null;
    /** Pre-cal号 */
    specialOfferApplicationNumber!: string | null;
    /** 特价号接口
特价申请号来源true，则是手动的,false，就代表是自动生成的 */
    isManual!: string | null;
    /** 希望交货期 */
    customerExpectedDeliveryDate!: string | null;
    /** 销售员 */
    responsibleSalesName!: string | null;
    /** 销售区域 */
    salesArea!: string | null;
    /** 客户订单号 */
    customerOrderNumber!: string | null;
    /** 备库订单 */
    forLibOrderStr!: string | null;
    /** 直接客户 */
    finalCustomer!: string | null;
    /** 最终客户代号 */
    finalCustomerCode!: string | null;
    /** 订单类型 */
    orderType!: string | null;
    /** 项目编号 */
    projectNo!: string | null;
    /** 项目名称 */
    projectName!: string | null;
    /** 选型号 */
    modelSelectionId!: string | null;
    /** 选型名称 */
    modelSelectionName!: string | null;
    /** 来源 */
    orderSource!: string | null;
    /** 制单人 */
    creatorUserName!: string | null;
    /** 制单时间 */
    creationTime!: string | null;
    /** 提交时间 */
    orderTime!: string | null;
    /** 审批状态 */
    auditStatus!: string | null;
    /** 审批人 */
    auditCreatorUserId!: string | null;
    /** 审批人 */
    auditCreatorUserName!: string | null;
    /** 审批时间 */
    auditCreationTime!: string | null;
    /** 审批意见 */
    remarks!: string | null;
    /** OMS订单号 */
    omsOrderNumber!: string | null;
    /** 订单优先级 */
    orderGrade!: string | null;
    /** 当前订单税率 */
    curTaxRate!: number | null;
    /** 不含税总金额 sum（ProductBasicMotors.PriceWithoutTax） */
    totalPriceWithoutTax!: number | null;
    /** 总税金 sum（ProductBasicMotors.UnitTaxPrice） */
    totalTaxPrice!: number | null;
    /** 最终用户所在地国家,关联风险国家表(CountryRisk) */
    locationCountry!: string | null;
    /** 最终用户所在地国家风险等级 */
    riskLevel!: string | null;
    /** 备案号(仅风险国家填写) */
    recordNumber!: string | null;

    init(_data?: any) {
        if (_data) {
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.endCustomerCode = _data["endCustomerCode"] !== undefined ? _data["endCustomerCode"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.channelName = _data["channelName"] !== undefined ? _data["channelName"] : null as any;
            this.industryName = _data["industryName"] !== undefined ? _data["industryName"] : null as any;
            this.applicationName = _data["applicationName"] !== undefined ? _data["applicationName"] : null as any;
            this.shippingAddress = _data["shippingAddress"] !== undefined ? _data["shippingAddress"] : null as any;
            this.specialOfferApplicationNumber = _data["specialOfferApplicationNumber"] !== undefined ? _data["specialOfferApplicationNumber"] : null as any;
            this.isManual = _data["isManual"] !== undefined ? _data["isManual"] : null as any;
            this.customerExpectedDeliveryDate = _data["customerExpectedDeliveryDate"] !== undefined ? _data["customerExpectedDeliveryDate"] : null as any;
            this.responsibleSalesName = _data["responsibleSalesName"] !== undefined ? _data["responsibleSalesName"] : null as any;
            this.salesArea = _data["salesArea"] !== undefined ? _data["salesArea"] : null as any;
            this.customerOrderNumber = _data["customerOrderNumber"] !== undefined ? _data["customerOrderNumber"] : null as any;
            this.forLibOrderStr = _data["forLibOrderStr"] !== undefined ? _data["forLibOrderStr"] : null as any;
            this.finalCustomer = _data["finalCustomer"] !== undefined ? _data["finalCustomer"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.projectNo = _data["projectNo"] !== undefined ? _data["projectNo"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.modelSelectionId = _data["modelSelectionId"] !== undefined ? _data["modelSelectionId"] : null as any;
            this.modelSelectionName = _data["modelSelectionName"] !== undefined ? _data["modelSelectionName"] : null as any;
            this.orderSource = _data["orderSource"] !== undefined ? _data["orderSource"] : null as any;
            this.creatorUserName = _data["creatorUserName"] !== undefined ? _data["creatorUserName"] : null as any;
            this.creationTime = _data["creationTime"] !== undefined ? _data["creationTime"] : null as any;
            this.orderTime = _data["orderTime"] !== undefined ? _data["orderTime"] : null as any;
            this.auditStatus = _data["auditStatus"] !== undefined ? _data["auditStatus"] : null as any;
            this.auditCreatorUserId = _data["auditCreatorUserId"] !== undefined ? _data["auditCreatorUserId"] : null as any;
            this.auditCreatorUserName = _data["auditCreatorUserName"] !== undefined ? _data["auditCreatorUserName"] : null as any;
            this.auditCreationTime = _data["auditCreationTime"] !== undefined ? _data["auditCreationTime"] : null as any;
            this.remarks = _data["remarks"] !== undefined ? _data["remarks"] : null as any;
            this.omsOrderNumber = _data["omsOrderNumber"] !== undefined ? _data["omsOrderNumber"] : null as any;
            this.orderGrade = _data["orderGrade"] !== undefined ? _data["orderGrade"] : null as any;
            this.curTaxRate = _data["curTaxRate"] !== undefined ? _data["curTaxRate"] : null as any;
            this.totalPriceWithoutTax = _data["totalPriceWithoutTax"] !== undefined ? _data["totalPriceWithoutTax"] : null as any;
            this.totalTaxPrice = _data["totalTaxPrice"] !== undefined ? _data["totalTaxPrice"] : null as any;
            this.locationCountry = _data["locationCountry"] !== undefined ? _data["locationCountry"] : null as any;
            this.riskLevel = _data["riskLevel"] !== undefined ? _data["riskLevel"] : null as any;
            this.recordNumber = _data["recordNumber"] !== undefined ? _data["recordNumber"] : null as any;
        }
    }

    static fromJS(data: any): ExportOrder {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["endCustomerCode"] = this.endCustomerCode !== undefined ? this.endCustomerCode : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["channelName"] = this.channelName !== undefined ? this.channelName : null as any;
        data["industryName"] = this.industryName !== undefined ? this.industryName : null as any;
        data["applicationName"] = this.applicationName !== undefined ? this.applicationName : null as any;
        data["shippingAddress"] = this.shippingAddress !== undefined ? this.shippingAddress : null as any;
        data["specialOfferApplicationNumber"] = this.specialOfferApplicationNumber !== undefined ? this.specialOfferApplicationNumber : null as any;
        data["isManual"] = this.isManual !== undefined ? this.isManual : null as any;
        data["customerExpectedDeliveryDate"] = this.customerExpectedDeliveryDate !== undefined ? this.customerExpectedDeliveryDate : null as any;
        data["responsibleSalesName"] = this.responsibleSalesName !== undefined ? this.responsibleSalesName : null as any;
        data["salesArea"] = this.salesArea !== undefined ? this.salesArea : null as any;
        data["customerOrderNumber"] = this.customerOrderNumber !== undefined ? this.customerOrderNumber : null as any;
        data["forLibOrderStr"] = this.forLibOrderStr !== undefined ? this.forLibOrderStr : null as any;
        data["finalCustomer"] = this.finalCustomer !== undefined ? this.finalCustomer : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["projectNo"] = this.projectNo !== undefined ? this.projectNo : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["modelSelectionId"] = this.modelSelectionId !== undefined ? this.modelSelectionId : null as any;
        data["modelSelectionName"] = this.modelSelectionName !== undefined ? this.modelSelectionName : null as any;
        data["orderSource"] = this.orderSource !== undefined ? this.orderSource : null as any;
        data["creatorUserName"] = this.creatorUserName !== undefined ? this.creatorUserName : null as any;
        data["creationTime"] = this.creationTime !== undefined ? this.creationTime : null as any;
        data["orderTime"] = this.orderTime !== undefined ? this.orderTime : null as any;
        data["auditStatus"] = this.auditStatus !== undefined ? this.auditStatus : null as any;
        data["auditCreatorUserId"] = this.auditCreatorUserId !== undefined ? this.auditCreatorUserId : null as any;
        data["auditCreatorUserName"] = this.auditCreatorUserName !== undefined ? this.auditCreatorUserName : null as any;
        data["auditCreationTime"] = this.auditCreationTime !== undefined ? this.auditCreationTime : null as any;
        data["remarks"] = this.remarks !== undefined ? this.remarks : null as any;
        data["omsOrderNumber"] = this.omsOrderNumber !== undefined ? this.omsOrderNumber : null as any;
        data["orderGrade"] = this.orderGrade !== undefined ? this.orderGrade : null as any;
        data["curTaxRate"] = this.curTaxRate !== undefined ? this.curTaxRate : null as any;
        data["totalPriceWithoutTax"] = this.totalPriceWithoutTax !== undefined ? this.totalPriceWithoutTax : null as any;
        data["totalTaxPrice"] = this.totalTaxPrice !== undefined ? this.totalTaxPrice : null as any;
        data["locationCountry"] = this.locationCountry !== undefined ? this.locationCountry : null as any;
        data["riskLevel"] = this.riskLevel !== undefined ? this.riskLevel : null as any;
        data["recordNumber"] = this.recordNumber !== undefined ? this.recordNumber : null as any;
        return data;
    }
}

export class ExportOrderApprovalProcessNodeConfigurationDto {
    id!: string;
    /** 提交人 */
    submitter!: number;
    /** 提交人名称 */
    submitterName!: string | null;
    /** 提交人邮箱 */
    submitterEmail!: string | null;
    /** 节点 */
    node!: string | null;
    /** 审核人 */
    reviewedBy!: number;
    /** 审核人 */
    reviewedByName!: string | null;
    /** 审核人邮箱 */
    reviewedByEmail!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.submitter = _data["submitter"] !== undefined ? _data["submitter"] : null as any;
            this.submitterName = _data["submitterName"] !== undefined ? _data["submitterName"] : null as any;
            this.submitterEmail = _data["submitterEmail"] !== undefined ? _data["submitterEmail"] : null as any;
            this.node = _data["node"] !== undefined ? _data["node"] : null as any;
            this.reviewedBy = _data["reviewedBy"] !== undefined ? _data["reviewedBy"] : null as any;
            this.reviewedByName = _data["reviewedByName"] !== undefined ? _data["reviewedByName"] : null as any;
            this.reviewedByEmail = _data["reviewedByEmail"] !== undefined ? _data["reviewedByEmail"] : null as any;
        }
    }

    static fromJS(data: any): ExportOrderApprovalProcessNodeConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOrderApprovalProcessNodeConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["submitter"] = this.submitter !== undefined ? this.submitter : null as any;
        data["submitterName"] = this.submitterName !== undefined ? this.submitterName : null as any;
        data["submitterEmail"] = this.submitterEmail !== undefined ? this.submitterEmail : null as any;
        data["node"] = this.node !== undefined ? this.node : null as any;
        data["reviewedBy"] = this.reviewedBy !== undefined ? this.reviewedBy : null as any;
        data["reviewedByName"] = this.reviewedByName !== undefined ? this.reviewedByName : null as any;
        data["reviewedByEmail"] = this.reviewedByEmail !== undefined ? this.reviewedByEmail : null as any;
        return data;
    }
}

export class ExportOrderApprovalProcessNodeConfigurationDtoPagedResultDto {
    items!: ExportOrderApprovalProcessNodeConfigurationDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExportOrderApprovalProcessNodeConfigurationDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): ExportOrderApprovalProcessNodeConfigurationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOrderApprovalProcessNodeConfigurationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 0 = Confirm (确认版本) 1 = Init (初始版本) 2 = Update (修改版本) */
export enum ExportOrderAttachmentType {
    Confirm = 0,
    Init = 1,
    Update = 2,
}

export class ExportOrderBizTalkDto {
    cscot!: string | null;
    /** 客户需求日期 */
    customerRequiredDate!: string | null;
    receiveTime!: string | null;
    country!: string | null;
    cScotOrderTime!: string | null;
    cScotSRU!: string | null;
    cScotOrderType!: string | null;
    wareHouseID!: string | null;
    orderType!: string | null;
    status!: string | null;
    /** 销售员 */
    salesPerson!: string | null;
    /** 客户代码 */
    customerCode!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 合同号 */
    contractNumber!: string | null;
    /** 客户订单号 */
    customerOrderNumber!: string | null;
    /** 客户生产单号 */
    customerProductionNumber!: string | null;
    /** 整单特价号 */
    precalNo!: string | null;
    /** 创建人 */
    ownerID!: string | null;
    /** 电机信息 */
    exportOrderProducts!: ExportOrderProductDto[] | null;
    /** 订单条款 */
    orderTerms!: string | null;
    /** sap下发 订单条款 */
    incoterm!: string | null;
    /** 目的港 */
    portOfDestination!: string | null;
    /** sap下发 目的港 */
    inPortOfDestinationcoterm!: string | null;

    init(_data?: any) {
        if (_data) {
            this.cscot = _data["cscot"] !== undefined ? _data["cscot"] : null as any;
            this.customerRequiredDate = _data["customerRequiredDate"] !== undefined ? _data["customerRequiredDate"] : null as any;
            this.receiveTime = _data["receiveTime"] !== undefined ? _data["receiveTime"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.cScotOrderTime = _data["cScotOrderTime"] !== undefined ? _data["cScotOrderTime"] : null as any;
            this.cScotSRU = _data["cScotSRU"] !== undefined ? _data["cScotSRU"] : null as any;
            this.cScotOrderType = _data["cScotOrderType"] !== undefined ? _data["cScotOrderType"] : null as any;
            this.wareHouseID = _data["wareHouseID"] !== undefined ? _data["wareHouseID"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.salesPerson = _data["salesPerson"] !== undefined ? _data["salesPerson"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.contractNumber = _data["contractNumber"] !== undefined ? _data["contractNumber"] : null as any;
            this.customerOrderNumber = _data["customerOrderNumber"] !== undefined ? _data["customerOrderNumber"] : null as any;
            this.customerProductionNumber = _data["customerProductionNumber"] !== undefined ? _data["customerProductionNumber"] : null as any;
            this.precalNo = _data["precalNo"] !== undefined ? _data["precalNo"] : null as any;
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            if (Array.isArray(_data["exportOrderProducts"])) {
                this.exportOrderProducts = [] as any;
                for (let item of _data["exportOrderProducts"])
                    this.exportOrderProducts!.push(ExportOrderProductDto.fromJS(item));
            }
            else {
                this.exportOrderProducts = null as any;
            }
            this.orderTerms = _data["orderTerms"] !== undefined ? _data["orderTerms"] : null as any;
            this.incoterm = _data["incoterm"] !== undefined ? _data["incoterm"] : null as any;
            this.portOfDestination = _data["portOfDestination"] !== undefined ? _data["portOfDestination"] : null as any;
            this.inPortOfDestinationcoterm = _data["inPortOfDestinationcoterm"] !== undefined ? _data["inPortOfDestinationcoterm"] : null as any;
        }
    }

    static fromJS(data: any): ExportOrderBizTalkDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOrderBizTalkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cscot"] = this.cscot !== undefined ? this.cscot : null as any;
        data["customerRequiredDate"] = this.customerRequiredDate !== undefined ? this.customerRequiredDate : null as any;
        data["receiveTime"] = this.receiveTime !== undefined ? this.receiveTime : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["cScotOrderTime"] = this.cScotOrderTime !== undefined ? this.cScotOrderTime : null as any;
        data["cScotSRU"] = this.cScotSRU !== undefined ? this.cScotSRU : null as any;
        data["cScotOrderType"] = this.cScotOrderType !== undefined ? this.cScotOrderType : null as any;
        data["wareHouseID"] = this.wareHouseID !== undefined ? this.wareHouseID : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["salesPerson"] = this.salesPerson !== undefined ? this.salesPerson : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["contractNumber"] = this.contractNumber !== undefined ? this.contractNumber : null as any;
        data["customerOrderNumber"] = this.customerOrderNumber !== undefined ? this.customerOrderNumber : null as any;
        data["customerProductionNumber"] = this.customerProductionNumber !== undefined ? this.customerProductionNumber : null as any;
        data["precalNo"] = this.precalNo !== undefined ? this.precalNo : null as any;
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        if (Array.isArray(this.exportOrderProducts)) {
            data["exportOrderProducts"] = [];
            for (let item of this.exportOrderProducts)
                data["exportOrderProducts"].push(item ? item.toJSON() : null as any);
        }
        data["orderTerms"] = this.orderTerms !== undefined ? this.orderTerms : null as any;
        data["incoterm"] = this.incoterm !== undefined ? this.incoterm : null as any;
        data["portOfDestination"] = this.portOfDestination !== undefined ? this.portOfDestination : null as any;
        data["inPortOfDestinationcoterm"] = this.inPortOfDestinationcoterm !== undefined ? this.inPortOfDestinationcoterm : null as any;
        return data;
    }
}

export class ExportOrderChangeOrderFormProductDto {
    productCode!: string | null;
    vcCode!: string | null;
    changeType!: EnumChangeType;
    readonly changeTypeName!: string | null;
    cScotOrderItemId!: string | null;
    oldValue!: string | null;
    newValue!: string | null;
    oldRemark!: string | null;
    newRemark!: string | null;
    oldMeaning!: string | null;
    newMeaning!: string | null;
    oisExportOrderProductsId!: string;
    creationTime!: moment.Moment | null;
    oisExportOrderProducts!: OISExportOrderProductsDto;

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"] !== undefined ? _data["productCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.changeType = _data["changeType"] !== undefined ? _data["changeType"] : null as any;
            (this as any).changeTypeName = _data["changeTypeName"] !== undefined ? _data["changeTypeName"] : null as any;
            this.cScotOrderItemId = _data["cScotOrderItemId"] !== undefined ? _data["cScotOrderItemId"] : null as any;
            this.oldValue = _data["oldValue"] !== undefined ? _data["oldValue"] : null as any;
            this.newValue = _data["newValue"] !== undefined ? _data["newValue"] : null as any;
            this.oldRemark = _data["oldRemark"] !== undefined ? _data["oldRemark"] : null as any;
            this.newRemark = _data["newRemark"] !== undefined ? _data["newRemark"] : null as any;
            this.oldMeaning = _data["oldMeaning"] !== undefined ? _data["oldMeaning"] : null as any;
            this.newMeaning = _data["newMeaning"] !== undefined ? _data["newMeaning"] : null as any;
            this.oisExportOrderProductsId = _data["oisExportOrderProductsId"] !== undefined ? _data["oisExportOrderProductsId"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.oisExportOrderProducts = _data["oisExportOrderProducts"] ? OISExportOrderProductsDto.fromJS(_data["oisExportOrderProducts"]) : null as any;
        }
    }

    static fromJS(data: any): ExportOrderChangeOrderFormProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOrderChangeOrderFormProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode !== undefined ? this.productCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["changeType"] = this.changeType !== undefined ? this.changeType : null as any;
        data["changeTypeName"] = this.changeTypeName !== undefined ? this.changeTypeName : null as any;
        data["cScotOrderItemId"] = this.cScotOrderItemId !== undefined ? this.cScotOrderItemId : null as any;
        data["oldValue"] = this.oldValue !== undefined ? this.oldValue : null as any;
        data["newValue"] = this.newValue !== undefined ? this.newValue : null as any;
        data["oldRemark"] = this.oldRemark !== undefined ? this.oldRemark : null as any;
        data["newRemark"] = this.newRemark !== undefined ? this.newRemark : null as any;
        data["oldMeaning"] = this.oldMeaning !== undefined ? this.oldMeaning : null as any;
        data["newMeaning"] = this.newMeaning !== undefined ? this.newMeaning : null as any;
        data["oisExportOrderProductsId"] = this.oisExportOrderProductsId !== undefined ? this.oisExportOrderProductsId : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["oisExportOrderProducts"] = this.oisExportOrderProducts ? this.oisExportOrderProducts.toJSON() : null as any;
        return data;
    }
}

export class ExportOrderChangeOrderFormVersionsDto {
    id!: string;
    /** 变更ID */
    orderChangeOrderFormId!: string;
    /** 源订单ID */
    sourceOrderFromID!: string;
    /** 版本号 */
    version!: number | null;
    status!: EnumOrderChangeOrderFormVersionsStatus;
    creationTime!: moment.Moment;
    readonly orderChangeOrderFormVersionsStatusName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.orderChangeOrderFormId = _data["orderChangeOrderFormId"] !== undefined ? _data["orderChangeOrderFormId"] : null as any;
            this.sourceOrderFromID = _data["sourceOrderFromID"] !== undefined ? _data["sourceOrderFromID"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            (this as any).orderChangeOrderFormVersionsStatusName = _data["orderChangeOrderFormVersionsStatusName"] !== undefined ? _data["orderChangeOrderFormVersionsStatusName"] : null as any;
        }
    }

    static fromJS(data: any): ExportOrderChangeOrderFormVersionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOrderChangeOrderFormVersionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["orderChangeOrderFormId"] = this.orderChangeOrderFormId !== undefined ? this.orderChangeOrderFormId : null as any;
        data["sourceOrderFromID"] = this.sourceOrderFromID !== undefined ? this.sourceOrderFromID : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["orderChangeOrderFormVersionsStatusName"] = this.orderChangeOrderFormVersionsStatusName !== undefined ? this.orderChangeOrderFormVersionsStatusName : null as any;
        return data;
    }
}

export class ExportOrderChangeProductBasicMotorVersionAllDto {
    /** 版本号 */
    version!: number;
    /** 版本状态，enumOrderChangeOrderFormVersionsStatus */
    versionStatus!: string | null;
    /** 变更服务申请的Id */
    serviceRequestId!: string | null;
    /** 变更时间,orderChangeOrderFormVersionsRepository==LastModificationTime */
    changeTime!: moment.Moment | null;
    /** 版本id */
    orderChangeOrderFormVersionsId!: string | null;
    /** 产品id */
    orderChangeProductBasicMotorId!: string | null;
    /** 序号/行号 */
    serialNumber!: string | null;
    /** 变更服务申请的工单号 */
    sequenceNumber!: string | null;
    /** 变更状态 */
    serviceRequestStatus!: string | null;
    /** 源订单号.外销下单后,以此作为唯一的订单号 */
    cscot!: string | null;
    status!: EnumOrderChangeOrderFormVersionsStatus;
    /** 电机 */
    basicMotorCode!: string | null;
    cScotOrderItemId!: string | null;
    productClassification!: string | null;
    orderClassification!: string | null;
    oisExportOrderId!: string | null;
    powerUnit!: string | null;
    /** 新价格 */
    newUnitPrice!: number | null;
    /** 客户期望交货日期 */
    customerExpectedDeliveryDate!: moment.Moment | null;
    /** 客户需求日期 */
    wishedDate!: string | null;
    /** GSS报价单号 */
    gssQuotationNumber!: string | null;
    mspOutputRemarks!: string | null;
    /** VC */
    productsVCs!: OISExportOrderProductsVC[] | null;
    /** 产品确认 */
    orderConfirMation!: string | null;
    /** Excel 备注长度 */
    excelVcRemarkConfirmedLength!: number | null;
    /** 订单操作备注 */
    orderConfirMationComment!: string | null;
    /** 技术确认号 */
    techConfirmationNumber!: string | null;
    orderType!: string | null;
    /** 客户生产代码 */
    customerProductionNumber!: string | null;
    /** 变更前 */
    changeBefore!: string | null;
    /** 变更后 */
    changeAfter!: string | null;
    newOrderChangeSummaryOutDto!: NewOrderChangeSummaryOutDto;

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.versionStatus = _data["versionStatus"] !== undefined ? _data["versionStatus"] : null as any;
            this.serviceRequestId = _data["serviceRequestId"] !== undefined ? _data["serviceRequestId"] : null as any;
            this.changeTime = _data["changeTime"] ? moment(_data["changeTime"].toString()) : null as any;
            this.orderChangeOrderFormVersionsId = _data["orderChangeOrderFormVersionsId"] !== undefined ? _data["orderChangeOrderFormVersionsId"] : null as any;
            this.orderChangeProductBasicMotorId = _data["orderChangeProductBasicMotorId"] !== undefined ? _data["orderChangeProductBasicMotorId"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.sequenceNumber = _data["sequenceNumber"] !== undefined ? _data["sequenceNumber"] : null as any;
            this.serviceRequestStatus = _data["serviceRequestStatus"] !== undefined ? _data["serviceRequestStatus"] : null as any;
            this.cscot = _data["cscot"] !== undefined ? _data["cscot"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.cScotOrderItemId = _data["cScotOrderItemId"] !== undefined ? _data["cScotOrderItemId"] : null as any;
            this.productClassification = _data["productClassification"] !== undefined ? _data["productClassification"] : null as any;
            this.orderClassification = _data["orderClassification"] !== undefined ? _data["orderClassification"] : null as any;
            this.oisExportOrderId = _data["oisExportOrderId"] !== undefined ? _data["oisExportOrderId"] : null as any;
            this.powerUnit = _data["powerUnit"] !== undefined ? _data["powerUnit"] : null as any;
            this.newUnitPrice = _data["newUnitPrice"] !== undefined ? _data["newUnitPrice"] : null as any;
            this.customerExpectedDeliveryDate = _data["customerExpectedDeliveryDate"] ? moment(_data["customerExpectedDeliveryDate"].toString()) : null as any;
            this.wishedDate = _data["wishedDate"] !== undefined ? _data["wishedDate"] : null as any;
            this.gssQuotationNumber = _data["gssQuotationNumber"] !== undefined ? _data["gssQuotationNumber"] : null as any;
            this.mspOutputRemarks = _data["mspOutputRemarks"] !== undefined ? _data["mspOutputRemarks"] : null as any;
            if (Array.isArray(_data["productsVCs"])) {
                this.productsVCs = [] as any;
                for (let item of _data["productsVCs"])
                    this.productsVCs!.push(OISExportOrderProductsVC.fromJS(item));
            }
            else {
                this.productsVCs = null as any;
            }
            this.orderConfirMation = _data["orderConfirMation"] !== undefined ? _data["orderConfirMation"] : null as any;
            this.excelVcRemarkConfirmedLength = _data["excelVcRemarkConfirmedLength"] !== undefined ? _data["excelVcRemarkConfirmedLength"] : null as any;
            this.orderConfirMationComment = _data["orderConfirMationComment"] !== undefined ? _data["orderConfirMationComment"] : null as any;
            this.techConfirmationNumber = _data["techConfirmationNumber"] !== undefined ? _data["techConfirmationNumber"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.customerProductionNumber = _data["customerProductionNumber"] !== undefined ? _data["customerProductionNumber"] : null as any;
            this.changeBefore = _data["changeBefore"] !== undefined ? _data["changeBefore"] : null as any;
            this.changeAfter = _data["changeAfter"] !== undefined ? _data["changeAfter"] : null as any;
            this.newOrderChangeSummaryOutDto = _data["newOrderChangeSummaryOutDto"] ? NewOrderChangeSummaryOutDto.fromJS(_data["newOrderChangeSummaryOutDto"]) : null as any;
        }
    }

    static fromJS(data: any): ExportOrderChangeProductBasicMotorVersionAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOrderChangeProductBasicMotorVersionAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["versionStatus"] = this.versionStatus !== undefined ? this.versionStatus : null as any;
        data["serviceRequestId"] = this.serviceRequestId !== undefined ? this.serviceRequestId : null as any;
        data["changeTime"] = this.changeTime ? this.changeTime.toISOString() : null as any;
        data["orderChangeOrderFormVersionsId"] = this.orderChangeOrderFormVersionsId !== undefined ? this.orderChangeOrderFormVersionsId : null as any;
        data["orderChangeProductBasicMotorId"] = this.orderChangeProductBasicMotorId !== undefined ? this.orderChangeProductBasicMotorId : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["sequenceNumber"] = this.sequenceNumber !== undefined ? this.sequenceNumber : null as any;
        data["serviceRequestStatus"] = this.serviceRequestStatus !== undefined ? this.serviceRequestStatus : null as any;
        data["cscot"] = this.cscot !== undefined ? this.cscot : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["cScotOrderItemId"] = this.cScotOrderItemId !== undefined ? this.cScotOrderItemId : null as any;
        data["productClassification"] = this.productClassification !== undefined ? this.productClassification : null as any;
        data["orderClassification"] = this.orderClassification !== undefined ? this.orderClassification : null as any;
        data["oisExportOrderId"] = this.oisExportOrderId !== undefined ? this.oisExportOrderId : null as any;
        data["powerUnit"] = this.powerUnit !== undefined ? this.powerUnit : null as any;
        data["newUnitPrice"] = this.newUnitPrice !== undefined ? this.newUnitPrice : null as any;
        data["customerExpectedDeliveryDate"] = this.customerExpectedDeliveryDate ? this.customerExpectedDeliveryDate.toISOString() : null as any;
        data["wishedDate"] = this.wishedDate !== undefined ? this.wishedDate : null as any;
        data["gssQuotationNumber"] = this.gssQuotationNumber !== undefined ? this.gssQuotationNumber : null as any;
        data["mspOutputRemarks"] = this.mspOutputRemarks !== undefined ? this.mspOutputRemarks : null as any;
        if (Array.isArray(this.productsVCs)) {
            data["productsVCs"] = [];
            for (let item of this.productsVCs)
                data["productsVCs"].push(item ? item.toJSON() : null as any);
        }
        data["orderConfirMation"] = this.orderConfirMation !== undefined ? this.orderConfirMation : null as any;
        data["excelVcRemarkConfirmedLength"] = this.excelVcRemarkConfirmedLength !== undefined ? this.excelVcRemarkConfirmedLength : null as any;
        data["orderConfirMationComment"] = this.orderConfirMationComment !== undefined ? this.orderConfirMationComment : null as any;
        data["techConfirmationNumber"] = this.techConfirmationNumber !== undefined ? this.techConfirmationNumber : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["customerProductionNumber"] = this.customerProductionNumber !== undefined ? this.customerProductionNumber : null as any;
        data["changeBefore"] = this.changeBefore !== undefined ? this.changeBefore : null as any;
        data["changeAfter"] = this.changeAfter !== undefined ? this.changeAfter : null as any;
        data["newOrderChangeSummaryOutDto"] = this.newOrderChangeSummaryOutDto ? this.newOrderChangeSummaryOutDto.toJSON() : null as any;
        return data;
    }
}

export class ExportOrderItem {
    /** 合同号 */
    poNumber!: string | null;
    /** 客户代码 */
    endCustomerCode!: string | null;
    /** 客户名称 */
    endCustomerName!: string | null;
    /** 渠道 */
    channelName!: string | null;
    /** 行业 */
    industryName!: string | null;
    /** 应用 */
    applicationName!: string | null;
    /** 交货地址、电话 */
    shippingAddress!: string | null;
    /** Pre-cal号 */
    specialOfferApplicationNumber!: string | null;
    /** 特价号接口
特价申请号来源true，则是手动的,false，就代表是自动生成的 */
    isManual!: string | null;
    /** 希望交货期 */
    customerExpectedDeliveryDate!: string | null;
    /** 销售员 */
    responsibleSalesName!: string | null;
    /** 销售区域 */
    salesArea!: string | null;
    /** 客户订单号 */
    customerOrderNumber!: string | null;
    /** 备库订单 */
    forLibOrderStr!: string | null;
    /** 直接客户 */
    finalCustomer!: string | null;
    /** 最终客户代号 */
    finalCustomerCode!: string | null;
    /** 订单类型 */
    orderType!: string | null;
    /** 项目编号 */
    projectNo!: string | null;
    /** 项目名称 */
    projectName!: string | null;
    /** 选型号 */
    modelSelectionId!: string | null;
    /** 选型名称 */
    modelSelectionName!: string | null;
    /** 来源 */
    orderSource!: string | null;
    /** 制单人 */
    creatorUserName!: string | null;
    /** 制单时间 */
    creationTime!: string | null;
    /** 提交时间 */
    orderTime!: string | null;
    /** 审批状态 */
    auditStatus!: string | null;
    /** 审批人 */
    auditCreatorUserId!: string | null;
    /** 审批人 */
    auditCreatorUserName!: string | null;
    /** 审批时间 */
    auditCreationTime!: string | null;
    /** 审批意见 */
    remarks!: string | null;
    /** OMS订单号 */
    omsOrderNumber!: string | null;
    /** 订单优先级 */
    orderGrade!: string | null;
    /** 当前订单税率 */
    curTaxRate!: number | null;
    /** 不含税总金额 sum（ProductBasicMotors.PriceWithoutTax） */
    totalPriceWithoutTax!: number | null;
    /** 总税金 sum（ProductBasicMotors.UnitTaxPrice） */
    totalTaxPrice!: number | null;
    /** 最终用户所在地国家,关联风险国家表(CountryRisk) */
    locationCountry!: string | null;
    /** 最终用户所在地国家风险等级 */
    riskLevel!: string | null;
    /** 备案号(仅风险国家填写) */
    recordNumber!: string | null;
    /** 序号 */
    serialNumber!: number;
    /** 产品代码 */
    basicMotorCode!: string | null;
    /** 型号 */
    basicMotorModel!: string | null;
    /** 参数 */
    basicMotorParameter!: string | null;
    /** 电机面价 */
    basicMotorUnitPrice!: string | null;
    /** VC代码 */
    vcCode!: string | null;
    /** VC面价 */
    vcUnitPrice!: string | null;
    /** 订单类型 */
    vcOrderType!: string | null;
    /** 折扣 */
    multiplier!: string | null;
    /** 无折扣费用 */
    noMultiplierPrice!: string | null;
    /** GSS报价号 */
    gssQuotationNo!: string | null;
    /** GSS技术确认号 */
    gssTechnicalConfirmationNumber!: string | null;
    /** 技术规范 */
    technicalSpecifications!: string | null;
    /** 备注1 */
    remark!: string | null;
    /** 备注2 */
    remarkTwo!: string | null;
    /** 台数 */
    number!: string | null;
    /** 单价 */
    price!: string | null;
    /** 总价 */
    totalPrice!: string | null;
    /** VC描述 */
    meaning!: string | null;
    /** 预计交货天数 */
    expectedDeliveryDate!: string | null;
    /** 实际交货天数 */
    actualDeliveryDate!: string | null;
    /** 客户期望交货期 */
    vcCustomerExpectedDeliveryDate!: string | null;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** 1 含税总金额 售价(SalesPrice)*NumberOfProduct
售价(salesPrice)=(面价+VC.unitPrice)*系数(multiplier) */
    priceWithTax!: number | null;
    /** 不含税总金额 PriceWithTax-UnitTaxPrice */
    priceWithoutTax!: number | null;
    /** 2 税金 PriceWithTax*OrderForm.TaxPrice
总价/1.13后四舍五入，保留2位小数，订单行先计算再合计进总价，界面显示只要在header里 */
    unitTaxPrice!: number | null;

    init(_data?: any) {
        if (_data) {
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.endCustomerCode = _data["endCustomerCode"] !== undefined ? _data["endCustomerCode"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.channelName = _data["channelName"] !== undefined ? _data["channelName"] : null as any;
            this.industryName = _data["industryName"] !== undefined ? _data["industryName"] : null as any;
            this.applicationName = _data["applicationName"] !== undefined ? _data["applicationName"] : null as any;
            this.shippingAddress = _data["shippingAddress"] !== undefined ? _data["shippingAddress"] : null as any;
            this.specialOfferApplicationNumber = _data["specialOfferApplicationNumber"] !== undefined ? _data["specialOfferApplicationNumber"] : null as any;
            this.isManual = _data["isManual"] !== undefined ? _data["isManual"] : null as any;
            this.customerExpectedDeliveryDate = _data["customerExpectedDeliveryDate"] !== undefined ? _data["customerExpectedDeliveryDate"] : null as any;
            this.responsibleSalesName = _data["responsibleSalesName"] !== undefined ? _data["responsibleSalesName"] : null as any;
            this.salesArea = _data["salesArea"] !== undefined ? _data["salesArea"] : null as any;
            this.customerOrderNumber = _data["customerOrderNumber"] !== undefined ? _data["customerOrderNumber"] : null as any;
            this.forLibOrderStr = _data["forLibOrderStr"] !== undefined ? _data["forLibOrderStr"] : null as any;
            this.finalCustomer = _data["finalCustomer"] !== undefined ? _data["finalCustomer"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.projectNo = _data["projectNo"] !== undefined ? _data["projectNo"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.modelSelectionId = _data["modelSelectionId"] !== undefined ? _data["modelSelectionId"] : null as any;
            this.modelSelectionName = _data["modelSelectionName"] !== undefined ? _data["modelSelectionName"] : null as any;
            this.orderSource = _data["orderSource"] !== undefined ? _data["orderSource"] : null as any;
            this.creatorUserName = _data["creatorUserName"] !== undefined ? _data["creatorUserName"] : null as any;
            this.creationTime = _data["creationTime"] !== undefined ? _data["creationTime"] : null as any;
            this.orderTime = _data["orderTime"] !== undefined ? _data["orderTime"] : null as any;
            this.auditStatus = _data["auditStatus"] !== undefined ? _data["auditStatus"] : null as any;
            this.auditCreatorUserId = _data["auditCreatorUserId"] !== undefined ? _data["auditCreatorUserId"] : null as any;
            this.auditCreatorUserName = _data["auditCreatorUserName"] !== undefined ? _data["auditCreatorUserName"] : null as any;
            this.auditCreationTime = _data["auditCreationTime"] !== undefined ? _data["auditCreationTime"] : null as any;
            this.remarks = _data["remarks"] !== undefined ? _data["remarks"] : null as any;
            this.omsOrderNumber = _data["omsOrderNumber"] !== undefined ? _data["omsOrderNumber"] : null as any;
            this.orderGrade = _data["orderGrade"] !== undefined ? _data["orderGrade"] : null as any;
            this.curTaxRate = _data["curTaxRate"] !== undefined ? _data["curTaxRate"] : null as any;
            this.totalPriceWithoutTax = _data["totalPriceWithoutTax"] !== undefined ? _data["totalPriceWithoutTax"] : null as any;
            this.totalTaxPrice = _data["totalTaxPrice"] !== undefined ? _data["totalTaxPrice"] : null as any;
            this.locationCountry = _data["locationCountry"] !== undefined ? _data["locationCountry"] : null as any;
            this.riskLevel = _data["riskLevel"] !== undefined ? _data["riskLevel"] : null as any;
            this.recordNumber = _data["recordNumber"] !== undefined ? _data["recordNumber"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorParameter = _data["basicMotorParameter"] !== undefined ? _data["basicMotorParameter"] : null as any;
            this.basicMotorUnitPrice = _data["basicMotorUnitPrice"] !== undefined ? _data["basicMotorUnitPrice"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.vcUnitPrice = _data["vcUnitPrice"] !== undefined ? _data["vcUnitPrice"] : null as any;
            this.vcOrderType = _data["vcOrderType"] !== undefined ? _data["vcOrderType"] : null as any;
            this.multiplier = _data["multiplier"] !== undefined ? _data["multiplier"] : null as any;
            this.noMultiplierPrice = _data["noMultiplierPrice"] !== undefined ? _data["noMultiplierPrice"] : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.remarkTwo = _data["remarkTwo"] !== undefined ? _data["remarkTwo"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            this.totalPrice = _data["totalPrice"] !== undefined ? _data["totalPrice"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.actualDeliveryDate = _data["actualDeliveryDate"] !== undefined ? _data["actualDeliveryDate"] : null as any;
            this.vcCustomerExpectedDeliveryDate = _data["vcCustomerExpectedDeliveryDate"] !== undefined ? _data["vcCustomerExpectedDeliveryDate"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.priceWithTax = _data["priceWithTax"] !== undefined ? _data["priceWithTax"] : null as any;
            this.priceWithoutTax = _data["priceWithoutTax"] !== undefined ? _data["priceWithoutTax"] : null as any;
            this.unitTaxPrice = _data["unitTaxPrice"] !== undefined ? _data["unitTaxPrice"] : null as any;
        }
    }

    static fromJS(data: any): ExportOrderItem {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOrderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["endCustomerCode"] = this.endCustomerCode !== undefined ? this.endCustomerCode : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["channelName"] = this.channelName !== undefined ? this.channelName : null as any;
        data["industryName"] = this.industryName !== undefined ? this.industryName : null as any;
        data["applicationName"] = this.applicationName !== undefined ? this.applicationName : null as any;
        data["shippingAddress"] = this.shippingAddress !== undefined ? this.shippingAddress : null as any;
        data["specialOfferApplicationNumber"] = this.specialOfferApplicationNumber !== undefined ? this.specialOfferApplicationNumber : null as any;
        data["isManual"] = this.isManual !== undefined ? this.isManual : null as any;
        data["customerExpectedDeliveryDate"] = this.customerExpectedDeliveryDate !== undefined ? this.customerExpectedDeliveryDate : null as any;
        data["responsibleSalesName"] = this.responsibleSalesName !== undefined ? this.responsibleSalesName : null as any;
        data["salesArea"] = this.salesArea !== undefined ? this.salesArea : null as any;
        data["customerOrderNumber"] = this.customerOrderNumber !== undefined ? this.customerOrderNumber : null as any;
        data["forLibOrderStr"] = this.forLibOrderStr !== undefined ? this.forLibOrderStr : null as any;
        data["finalCustomer"] = this.finalCustomer !== undefined ? this.finalCustomer : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["projectNo"] = this.projectNo !== undefined ? this.projectNo : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["modelSelectionId"] = this.modelSelectionId !== undefined ? this.modelSelectionId : null as any;
        data["modelSelectionName"] = this.modelSelectionName !== undefined ? this.modelSelectionName : null as any;
        data["orderSource"] = this.orderSource !== undefined ? this.orderSource : null as any;
        data["creatorUserName"] = this.creatorUserName !== undefined ? this.creatorUserName : null as any;
        data["creationTime"] = this.creationTime !== undefined ? this.creationTime : null as any;
        data["orderTime"] = this.orderTime !== undefined ? this.orderTime : null as any;
        data["auditStatus"] = this.auditStatus !== undefined ? this.auditStatus : null as any;
        data["auditCreatorUserId"] = this.auditCreatorUserId !== undefined ? this.auditCreatorUserId : null as any;
        data["auditCreatorUserName"] = this.auditCreatorUserName !== undefined ? this.auditCreatorUserName : null as any;
        data["auditCreationTime"] = this.auditCreationTime !== undefined ? this.auditCreationTime : null as any;
        data["remarks"] = this.remarks !== undefined ? this.remarks : null as any;
        data["omsOrderNumber"] = this.omsOrderNumber !== undefined ? this.omsOrderNumber : null as any;
        data["orderGrade"] = this.orderGrade !== undefined ? this.orderGrade : null as any;
        data["curTaxRate"] = this.curTaxRate !== undefined ? this.curTaxRate : null as any;
        data["totalPriceWithoutTax"] = this.totalPriceWithoutTax !== undefined ? this.totalPriceWithoutTax : null as any;
        data["totalTaxPrice"] = this.totalTaxPrice !== undefined ? this.totalTaxPrice : null as any;
        data["locationCountry"] = this.locationCountry !== undefined ? this.locationCountry : null as any;
        data["riskLevel"] = this.riskLevel !== undefined ? this.riskLevel : null as any;
        data["recordNumber"] = this.recordNumber !== undefined ? this.recordNumber : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorParameter"] = this.basicMotorParameter !== undefined ? this.basicMotorParameter : null as any;
        data["basicMotorUnitPrice"] = this.basicMotorUnitPrice !== undefined ? this.basicMotorUnitPrice : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["vcUnitPrice"] = this.vcUnitPrice !== undefined ? this.vcUnitPrice : null as any;
        data["vcOrderType"] = this.vcOrderType !== undefined ? this.vcOrderType : null as any;
        data["multiplier"] = this.multiplier !== undefined ? this.multiplier : null as any;
        data["noMultiplierPrice"] = this.noMultiplierPrice !== undefined ? this.noMultiplierPrice : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["remarkTwo"] = this.remarkTwo !== undefined ? this.remarkTwo : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["totalPrice"] = this.totalPrice !== undefined ? this.totalPrice : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["actualDeliveryDate"] = this.actualDeliveryDate !== undefined ? this.actualDeliveryDate : null as any;
        data["vcCustomerExpectedDeliveryDate"] = this.vcCustomerExpectedDeliveryDate !== undefined ? this.vcCustomerExpectedDeliveryDate : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["priceWithTax"] = this.priceWithTax !== undefined ? this.priceWithTax : null as any;
        data["priceWithoutTax"] = this.priceWithoutTax !== undefined ? this.priceWithoutTax : null as any;
        data["unitTaxPrice"] = this.unitTaxPrice !== undefined ? this.unitTaxPrice : null as any;
        return data;
    }
}

export class ExportOrderOpenVcDto {
    id!: string;
    /** VC编号 */
    vcCode!: string | null;
    /** OpenVc */
    open!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.open = _data["open"] !== undefined ? _data["open"] : null as any;
        }
    }

    static fromJS(data: any): ExportOrderOpenVcDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOrderOpenVcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["open"] = this.open !== undefined ? this.open : null as any;
        return data;
    }
}

export class ExportOrderOpenVcDtoPagedResultDto {
    items!: ExportOrderOpenVcDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExportOrderOpenVcDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): ExportOrderOpenVcDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOrderOpenVcDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 外销主机 */
export class ExportOrderProductDto {
    oisExportOrderProductsId!: string | null;
    /** 电机 */
    basicMotorCode!: string | null;
    /** 数量 */
    number!: number | null;
    transferListPrice!: string | null;
    tpDiscount!: number | null;
    /** 单价 */
    unitPrice!: number | null;
    /** 总价 */
    totalPrice!: number | null;
    /** 币种 */
    currency!: string | null;
    /** 描述 */
    describe!: string | null;
    prodType!: string | null;
    core!: string | null;
    /** 单位 */
    powerUnit!: string | null;
    readonly powerUnitDescription!: string | null;
    power!: string | null;
    pole!: string | null;
    voltage!: string | null;
    frequency!: string | null;
    installType!: string | null;
    insulation!: string | null;
    safty!: string | null;
    support!: string | null;
    intSupport!: string | null;
    variantCode!: string | null;
    /** 备注 */
    remark!: string | null;
    /** 行备注 */
    lineRemark!: string | null;
    /** 产品VC */
    exportOrderProductVCs!: ExportOrderProductVC[] | null;
    /** 行备注-Confirmed */
    excelExportOrderProductVCConfirmations!: ExcelExportOrderProductVCConfirmation[] | null;
    productClassification!: string | null;
    orderClassification!: string | null;
    cScotOrderItemId!: string | null;
    /** 增加/减少的VC */
    vcAmountChange!: string | null;
    /** 新单价 */
    newPrice!: number | null;
    /** header备注 */
    headerRemarkConfirmed!: string | null;
    /** 行备注 */
    lineRemarkConfirmed!: string | null;
    /** 客户期望交货期 */
    customerExpectedDeliveryDate!: moment.Moment | null;
    /** 客户需求日期 */
    wishedDate!: string | null;
    mspOutputRemarks!: string | null;
    readonly excelVcRemarkConfirmedLength!: number | null;
    /** GSS报价单号 */
    gssQuotationNumber!: string | null;
    techConfirmationNumber!: string | null;
    customerSpecificNote!: string | null;
    orderConfirMation!: string | null;
    orderChangeProductBasicProcessEntity!: OrderChangeProductBasicProcessEntity;
    allVC!: string | null;
    updatePriceByExport!: number | null;
    updateRemarksByExport!: string | null;

    init(_data?: any) {
        if (_data) {
            this.oisExportOrderProductsId = _data["oisExportOrderProductsId"] !== undefined ? _data["oisExportOrderProductsId"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.transferListPrice = _data["transferListPrice"] !== undefined ? _data["transferListPrice"] : null as any;
            this.tpDiscount = _data["tpDiscount"] !== undefined ? _data["tpDiscount"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.totalPrice = _data["totalPrice"] !== undefined ? _data["totalPrice"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
            this.describe = _data["describe"] !== undefined ? _data["describe"] : null as any;
            this.prodType = _data["prodType"] !== undefined ? _data["prodType"] : null as any;
            this.core = _data["core"] !== undefined ? _data["core"] : null as any;
            this.powerUnit = _data["powerUnit"] !== undefined ? _data["powerUnit"] : null as any;
            (this as any).powerUnitDescription = _data["powerUnitDescription"] !== undefined ? _data["powerUnitDescription"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.pole = _data["pole"] !== undefined ? _data["pole"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.installType = _data["installType"] !== undefined ? _data["installType"] : null as any;
            this.insulation = _data["insulation"] !== undefined ? _data["insulation"] : null as any;
            this.safty = _data["safty"] !== undefined ? _data["safty"] : null as any;
            this.support = _data["support"] !== undefined ? _data["support"] : null as any;
            this.intSupport = _data["intSupport"] !== undefined ? _data["intSupport"] : null as any;
            this.variantCode = _data["variantCode"] !== undefined ? _data["variantCode"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.lineRemark = _data["lineRemark"] !== undefined ? _data["lineRemark"] : null as any;
            if (Array.isArray(_data["exportOrderProductVCs"])) {
                this.exportOrderProductVCs = [] as any;
                for (let item of _data["exportOrderProductVCs"])
                    this.exportOrderProductVCs!.push(ExportOrderProductVC.fromJS(item));
            }
            else {
                this.exportOrderProductVCs = null as any;
            }
            if (Array.isArray(_data["excelExportOrderProductVCConfirmations"])) {
                this.excelExportOrderProductVCConfirmations = [] as any;
                for (let item of _data["excelExportOrderProductVCConfirmations"])
                    this.excelExportOrderProductVCConfirmations!.push(ExcelExportOrderProductVCConfirmation.fromJS(item));
            }
            else {
                this.excelExportOrderProductVCConfirmations = null as any;
            }
            this.productClassification = _data["productClassification"] !== undefined ? _data["productClassification"] : null as any;
            this.orderClassification = _data["orderClassification"] !== undefined ? _data["orderClassification"] : null as any;
            this.cScotOrderItemId = _data["cScotOrderItemId"] !== undefined ? _data["cScotOrderItemId"] : null as any;
            this.vcAmountChange = _data["vcAmountChange"] !== undefined ? _data["vcAmountChange"] : null as any;
            this.newPrice = _data["newPrice"] !== undefined ? _data["newPrice"] : null as any;
            this.headerRemarkConfirmed = _data["headerRemarkConfirmed"] !== undefined ? _data["headerRemarkConfirmed"] : null as any;
            this.lineRemarkConfirmed = _data["lineRemarkConfirmed"] !== undefined ? _data["lineRemarkConfirmed"] : null as any;
            this.customerExpectedDeliveryDate = _data["customerExpectedDeliveryDate"] ? moment(_data["customerExpectedDeliveryDate"].toString()) : null as any;
            this.wishedDate = _data["wishedDate"] !== undefined ? _data["wishedDate"] : null as any;
            this.mspOutputRemarks = _data["mspOutputRemarks"] !== undefined ? _data["mspOutputRemarks"] : null as any;
            (this as any).excelVcRemarkConfirmedLength = _data["excelVcRemarkConfirmedLength"] !== undefined ? _data["excelVcRemarkConfirmedLength"] : null as any;
            this.gssQuotationNumber = _data["gssQuotationNumber"] !== undefined ? _data["gssQuotationNumber"] : null as any;
            this.techConfirmationNumber = _data["techConfirmationNumber"] !== undefined ? _data["techConfirmationNumber"] : null as any;
            this.customerSpecificNote = _data["customerSpecificNote"] !== undefined ? _data["customerSpecificNote"] : null as any;
            this.orderConfirMation = _data["orderConfirMation"] !== undefined ? _data["orderConfirMation"] : null as any;
            this.orderChangeProductBasicProcessEntity = _data["orderChangeProductBasicProcessEntity"] ? OrderChangeProductBasicProcessEntity.fromJS(_data["orderChangeProductBasicProcessEntity"]) : null as any;
            this.allVC = _data["allVC"] !== undefined ? _data["allVC"] : null as any;
            this.updatePriceByExport = _data["updatePriceByExport"] !== undefined ? _data["updatePriceByExport"] : null as any;
            this.updateRemarksByExport = _data["updateRemarksByExport"] !== undefined ? _data["updateRemarksByExport"] : null as any;
        }
    }

    static fromJS(data: any): ExportOrderProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOrderProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oisExportOrderProductsId"] = this.oisExportOrderProductsId !== undefined ? this.oisExportOrderProductsId : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["transferListPrice"] = this.transferListPrice !== undefined ? this.transferListPrice : null as any;
        data["tpDiscount"] = this.tpDiscount !== undefined ? this.tpDiscount : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["totalPrice"] = this.totalPrice !== undefined ? this.totalPrice : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        data["describe"] = this.describe !== undefined ? this.describe : null as any;
        data["prodType"] = this.prodType !== undefined ? this.prodType : null as any;
        data["core"] = this.core !== undefined ? this.core : null as any;
        data["powerUnit"] = this.powerUnit !== undefined ? this.powerUnit : null as any;
        data["powerUnitDescription"] = this.powerUnitDescription !== undefined ? this.powerUnitDescription : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["pole"] = this.pole !== undefined ? this.pole : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["installType"] = this.installType !== undefined ? this.installType : null as any;
        data["insulation"] = this.insulation !== undefined ? this.insulation : null as any;
        data["safty"] = this.safty !== undefined ? this.safty : null as any;
        data["support"] = this.support !== undefined ? this.support : null as any;
        data["intSupport"] = this.intSupport !== undefined ? this.intSupport : null as any;
        data["variantCode"] = this.variantCode !== undefined ? this.variantCode : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["lineRemark"] = this.lineRemark !== undefined ? this.lineRemark : null as any;
        if (Array.isArray(this.exportOrderProductVCs)) {
            data["exportOrderProductVCs"] = [];
            for (let item of this.exportOrderProductVCs)
                data["exportOrderProductVCs"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.excelExportOrderProductVCConfirmations)) {
            data["excelExportOrderProductVCConfirmations"] = [];
            for (let item of this.excelExportOrderProductVCConfirmations)
                data["excelExportOrderProductVCConfirmations"].push(item ? item.toJSON() : null as any);
        }
        data["productClassification"] = this.productClassification !== undefined ? this.productClassification : null as any;
        data["orderClassification"] = this.orderClassification !== undefined ? this.orderClassification : null as any;
        data["cScotOrderItemId"] = this.cScotOrderItemId !== undefined ? this.cScotOrderItemId : null as any;
        data["vcAmountChange"] = this.vcAmountChange !== undefined ? this.vcAmountChange : null as any;
        data["newPrice"] = this.newPrice !== undefined ? this.newPrice : null as any;
        data["headerRemarkConfirmed"] = this.headerRemarkConfirmed !== undefined ? this.headerRemarkConfirmed : null as any;
        data["lineRemarkConfirmed"] = this.lineRemarkConfirmed !== undefined ? this.lineRemarkConfirmed : null as any;
        data["customerExpectedDeliveryDate"] = this.customerExpectedDeliveryDate ? this.customerExpectedDeliveryDate.toISOString() : null as any;
        data["wishedDate"] = this.wishedDate !== undefined ? this.wishedDate : null as any;
        data["mspOutputRemarks"] = this.mspOutputRemarks !== undefined ? this.mspOutputRemarks : null as any;
        data["excelVcRemarkConfirmedLength"] = this.excelVcRemarkConfirmedLength !== undefined ? this.excelVcRemarkConfirmedLength : null as any;
        data["gssQuotationNumber"] = this.gssQuotationNumber !== undefined ? this.gssQuotationNumber : null as any;
        data["techConfirmationNumber"] = this.techConfirmationNumber !== undefined ? this.techConfirmationNumber : null as any;
        data["customerSpecificNote"] = this.customerSpecificNote !== undefined ? this.customerSpecificNote : null as any;
        data["orderConfirMation"] = this.orderConfirMation !== undefined ? this.orderConfirMation : null as any;
        data["orderChangeProductBasicProcessEntity"] = this.orderChangeProductBasicProcessEntity ? this.orderChangeProductBasicProcessEntity.toJSON() : null as any;
        data["allVC"] = this.allVC !== undefined ? this.allVC : null as any;
        data["updatePriceByExport"] = this.updatePriceByExport !== undefined ? this.updatePriceByExport : null as any;
        data["updateRemarksByExport"] = this.updateRemarksByExport !== undefined ? this.updateRemarksByExport : null as any;
        return data;
    }
}

/** 产品VC */
export class ExportOrderProductVC {
    vcid!: string | null;
    /** VC描述 */
    meaning!: string | null;
    /** 备注 */
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.vcid = _data["vcid"] !== undefined ? _data["vcid"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): ExportOrderProductVC {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOrderProductVC();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcid"] = this.vcid !== undefined ? this.vcid : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

export class ExportOrderProductVCConfirmationDto {
    id!: string;
    oisExportOrderProductsId!: string | null;
    vcID!: string | null;
    /** VC描述 */
    meaning!: string | null;
    /** 开放式内容 */
    remark!: string | null;
    /** 新增/删除/修改 */
    updateStatus!: number;
    statusName!: string | null;
    vcType!: EnumVcType;
    readonly vcTypeName!: string | null;
    vcOpenOrClose!: EnumOISExportOrderVcOpenOrClose;
    readonly vcOpenOrCloseName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.oisExportOrderProductsId = _data["oisExportOrderProductsId"] !== undefined ? _data["oisExportOrderProductsId"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.updateStatus = _data["updateStatus"] !== undefined ? _data["updateStatus"] : null as any;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            (this as any).vcTypeName = _data["vcTypeName"] !== undefined ? _data["vcTypeName"] : null as any;
            this.vcOpenOrClose = _data["vcOpenOrClose"] !== undefined ? _data["vcOpenOrClose"] : null as any;
            (this as any).vcOpenOrCloseName = _data["vcOpenOrCloseName"] !== undefined ? _data["vcOpenOrCloseName"] : null as any;
        }
    }

    static fromJS(data: any): ExportOrderProductVCConfirmationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOrderProductVCConfirmationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["oisExportOrderProductsId"] = this.oisExportOrderProductsId !== undefined ? this.oisExportOrderProductsId : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["updateStatus"] = this.updateStatus !== undefined ? this.updateStatus : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcTypeName"] = this.vcTypeName !== undefined ? this.vcTypeName : null as any;
        data["vcOpenOrClose"] = this.vcOpenOrClose !== undefined ? this.vcOpenOrClose : null as any;
        data["vcOpenOrCloseName"] = this.vcOpenOrCloseName !== undefined ? this.vcOpenOrCloseName : null as any;
        return data;
    }
}

/** 外销订单审批对象 */
export class ExportOrderReviewApprovalDto {
    /** 审批编号 */
    id!: string | null;
    /** 外销订单编号 */
    exportOrderId!: string;
    approvalStatus!: EnumOISExportOrderReviewStatus;
    /** 审批意见 */
    message!: string | null;
    /** 订单条款 */
    orderTerms!: string | null;
    /** 目的港 */
    portOfDestination!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.exportOrderId = _data["exportOrderId"] !== undefined ? _data["exportOrderId"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.orderTerms = _data["orderTerms"] !== undefined ? _data["orderTerms"] : null as any;
            this.portOfDestination = _data["portOfDestination"] !== undefined ? _data["portOfDestination"] : null as any;
        }
    }

    static fromJS(data: any): ExportOrderReviewApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOrderReviewApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["exportOrderId"] = this.exportOrderId !== undefined ? this.exportOrderId : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["orderTerms"] = this.orderTerms !== undefined ? this.orderTerms : null as any;
        data["portOfDestination"] = this.portOfDestination !== undefined ? this.portOfDestination : null as any;
        return data;
    }
}

export class ExportOrderVcsDto {
    basicMotorCode!: string | null;
    vcid!: string | null;
    meaning!: string | null;
    vcType!: EnumVcType;
    readonly vcTypeName!: string | null;
    vcShowType!: VCShowType;
    vcOpenOrClose!: VcOpenOrClose;
    readonly vcOpenOrCloseName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.vcid = _data["vcid"] !== undefined ? _data["vcid"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            (this as any).vcTypeName = _data["vcTypeName"] !== undefined ? _data["vcTypeName"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.vcOpenOrClose = _data["vcOpenOrClose"] !== undefined ? _data["vcOpenOrClose"] : null as any;
            (this as any).vcOpenOrCloseName = _data["vcOpenOrCloseName"] !== undefined ? _data["vcOpenOrCloseName"] : null as any;
        }
    }

    static fromJS(data: any): ExportOrderVcsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOrderVcsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["vcid"] = this.vcid !== undefined ? this.vcid : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcTypeName"] = this.vcTypeName !== undefined ? this.vcTypeName : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["vcOpenOrClose"] = this.vcOpenOrClose !== undefined ? this.vcOpenOrClose : null as any;
        data["vcOpenOrCloseName"] = this.vcOpenOrCloseName !== undefined ? this.vcOpenOrCloseName : null as any;
        return data;
    }
}

export class ExportQueryDto {
    maxResultCount!: number;
    skipCount!: number;
    cscot!: string | null;
    startCreationTime!: moment.Moment | null;
    endCreationTime!: moment.Moment | null;
    reviewStatus!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.cscot = _data["cscot"] !== undefined ? _data["cscot"] : null as any;
            this.startCreationTime = _data["startCreationTime"] ? moment(_data["startCreationTime"].toString()) : null as any;
            this.endCreationTime = _data["endCreationTime"] ? moment(_data["endCreationTime"].toString()) : null as any;
            this.reviewStatus = _data["reviewStatus"] !== undefined ? _data["reviewStatus"] : null as any;
        }
    }

    static fromJS(data: any): ExportQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["cscot"] = this.cscot !== undefined ? this.cscot : null as any;
        data["startCreationTime"] = this.startCreationTime ? this.startCreationTime.toISOString() : null as any;
        data["endCreationTime"] = this.endCreationTime ? this.endCreationTime.toISOString() : null as any;
        data["reviewStatus"] = this.reviewStatus !== undefined ? this.reviewStatus : null as any;
        return data;
    }
}

export class ExportSalasOrderDto {
    id!: string;
    cscot!: string | null;
    /** 客户需求日期 */
    customerRequiredDate!: string | null;
    /** 国家 */
    country!: string | null;
    cScotOrderTime!: string | null;
    cScotSRU!: string | null;
    cScotOrderType!: string | null;
    wareHouseID!: string | null;
    orderType!: string | null;
    status!: string | null;
    /** 销售员 */
    salesPerson!: string | null;
    customerCode!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 合同号 */
    contractNumber!: string | null;
    /** 客户订单号 */
    customerOrderNumber!: string | null;
    precalNo!: string | null;
    /** GSS报价单号 */
    gssQuotationNumber!: string | null;
    version!: string | null;
    /** 批次号 */
    batch!: number;
    reviewStatus!: EnumOISExportOrderReviewStatus;
    readonly reviewStatusString!: string | null;
    totalPrice!: number | null;
    customerProductionNumber!: string | null;
    headerRemarkConfirmed!: string | null;
    maxVersion!: number | null;
    oisExportOrderChangeOrderFormVersions!: OISExportOrderChangeOrderFormVersions;
    /** 最新用户上传的确认附件 */
    confirmAttachments!: OISExportOrderAttachmentDto[] | null;
    initAttachments!: OISExportOrderAttachmentDto;
    /** 审批记录编号 */
    approvalId!: string | null;
    /** 是否锁定 */
    isLocked!: boolean;
    /** 锁定时间 */
    lockDate!: moment.Moment | null;
    /** 锁定时间 */
    readonly lockDateString!: string | null;
    /** 最后下发时间 */
    lastIssueTime!: moment.Moment | null;
    /** 最后下发时间 */
    readonly lastIssueTimeString!: string | null;
    /** Item行数 */
    productCount!: number;
    orderCode!: string | null;
    zoreOrderId!: string | null;
    creationTime!: moment.Moment;
    readonly creationTimeString!: string | null;
    /** 完成时间 */
    completionTime!: moment.Moment | null;
    /** 订单条款 */
    orderTerms!: string | null;
    /** 目的港 */
    portOfDestination!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.cscot = _data["cscot"] !== undefined ? _data["cscot"] : null as any;
            this.customerRequiredDate = _data["customerRequiredDate"] !== undefined ? _data["customerRequiredDate"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.cScotOrderTime = _data["cScotOrderTime"] !== undefined ? _data["cScotOrderTime"] : null as any;
            this.cScotSRU = _data["cScotSRU"] !== undefined ? _data["cScotSRU"] : null as any;
            this.cScotOrderType = _data["cScotOrderType"] !== undefined ? _data["cScotOrderType"] : null as any;
            this.wareHouseID = _data["wareHouseID"] !== undefined ? _data["wareHouseID"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.salesPerson = _data["salesPerson"] !== undefined ? _data["salesPerson"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.contractNumber = _data["contractNumber"] !== undefined ? _data["contractNumber"] : null as any;
            this.customerOrderNumber = _data["customerOrderNumber"] !== undefined ? _data["customerOrderNumber"] : null as any;
            this.precalNo = _data["precalNo"] !== undefined ? _data["precalNo"] : null as any;
            this.gssQuotationNumber = _data["gssQuotationNumber"] !== undefined ? _data["gssQuotationNumber"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.batch = _data["batch"] !== undefined ? _data["batch"] : null as any;
            this.reviewStatus = _data["reviewStatus"] !== undefined ? _data["reviewStatus"] : null as any;
            (this as any).reviewStatusString = _data["reviewStatusString"] !== undefined ? _data["reviewStatusString"] : null as any;
            this.totalPrice = _data["totalPrice"] !== undefined ? _data["totalPrice"] : null as any;
            this.customerProductionNumber = _data["customerProductionNumber"] !== undefined ? _data["customerProductionNumber"] : null as any;
            this.headerRemarkConfirmed = _data["headerRemarkConfirmed"] !== undefined ? _data["headerRemarkConfirmed"] : null as any;
            this.maxVersion = _data["maxVersion"] !== undefined ? _data["maxVersion"] : null as any;
            this.oisExportOrderChangeOrderFormVersions = _data["oisExportOrderChangeOrderFormVersions"] ? OISExportOrderChangeOrderFormVersions.fromJS(_data["oisExportOrderChangeOrderFormVersions"]) : null as any;
            if (Array.isArray(_data["confirmAttachments"])) {
                this.confirmAttachments = [] as any;
                for (let item of _data["confirmAttachments"])
                    this.confirmAttachments!.push(OISExportOrderAttachmentDto.fromJS(item));
            }
            else {
                this.confirmAttachments = null as any;
            }
            this.initAttachments = _data["initAttachments"] ? OISExportOrderAttachmentDto.fromJS(_data["initAttachments"]) : null as any;
            this.approvalId = _data["approvalId"] !== undefined ? _data["approvalId"] : null as any;
            this.isLocked = _data["isLocked"] !== undefined ? _data["isLocked"] : null as any;
            this.lockDate = _data["lockDate"] ? moment(_data["lockDate"].toString()) : null as any;
            (this as any).lockDateString = _data["lockDateString"] !== undefined ? _data["lockDateString"] : null as any;
            this.lastIssueTime = _data["lastIssueTime"] ? moment(_data["lastIssueTime"].toString()) : null as any;
            (this as any).lastIssueTimeString = _data["lastIssueTimeString"] !== undefined ? _data["lastIssueTimeString"] : null as any;
            this.productCount = _data["productCount"] !== undefined ? _data["productCount"] : null as any;
            this.orderCode = _data["orderCode"] !== undefined ? _data["orderCode"] : null as any;
            this.zoreOrderId = _data["zoreOrderId"] !== undefined ? _data["zoreOrderId"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            (this as any).creationTimeString = _data["creationTimeString"] !== undefined ? _data["creationTimeString"] : null as any;
            this.completionTime = _data["completionTime"] ? moment(_data["completionTime"].toString()) : null as any;
            this.orderTerms = _data["orderTerms"] !== undefined ? _data["orderTerms"] : null as any;
            this.portOfDestination = _data["portOfDestination"] !== undefined ? _data["portOfDestination"] : null as any;
        }
    }

    static fromJS(data: any): ExportSalasOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportSalasOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["cscot"] = this.cscot !== undefined ? this.cscot : null as any;
        data["customerRequiredDate"] = this.customerRequiredDate !== undefined ? this.customerRequiredDate : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["cScotOrderTime"] = this.cScotOrderTime !== undefined ? this.cScotOrderTime : null as any;
        data["cScotSRU"] = this.cScotSRU !== undefined ? this.cScotSRU : null as any;
        data["cScotOrderType"] = this.cScotOrderType !== undefined ? this.cScotOrderType : null as any;
        data["wareHouseID"] = this.wareHouseID !== undefined ? this.wareHouseID : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["salesPerson"] = this.salesPerson !== undefined ? this.salesPerson : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["contractNumber"] = this.contractNumber !== undefined ? this.contractNumber : null as any;
        data["customerOrderNumber"] = this.customerOrderNumber !== undefined ? this.customerOrderNumber : null as any;
        data["precalNo"] = this.precalNo !== undefined ? this.precalNo : null as any;
        data["gssQuotationNumber"] = this.gssQuotationNumber !== undefined ? this.gssQuotationNumber : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["batch"] = this.batch !== undefined ? this.batch : null as any;
        data["reviewStatus"] = this.reviewStatus !== undefined ? this.reviewStatus : null as any;
        data["reviewStatusString"] = this.reviewStatusString !== undefined ? this.reviewStatusString : null as any;
        data["totalPrice"] = this.totalPrice !== undefined ? this.totalPrice : null as any;
        data["customerProductionNumber"] = this.customerProductionNumber !== undefined ? this.customerProductionNumber : null as any;
        data["headerRemarkConfirmed"] = this.headerRemarkConfirmed !== undefined ? this.headerRemarkConfirmed : null as any;
        data["maxVersion"] = this.maxVersion !== undefined ? this.maxVersion : null as any;
        data["oisExportOrderChangeOrderFormVersions"] = this.oisExportOrderChangeOrderFormVersions ? this.oisExportOrderChangeOrderFormVersions.toJSON() : null as any;
        if (Array.isArray(this.confirmAttachments)) {
            data["confirmAttachments"] = [];
            for (let item of this.confirmAttachments)
                data["confirmAttachments"].push(item ? item.toJSON() : null as any);
        }
        data["initAttachments"] = this.initAttachments ? this.initAttachments.toJSON() : null as any;
        data["approvalId"] = this.approvalId !== undefined ? this.approvalId : null as any;
        data["isLocked"] = this.isLocked !== undefined ? this.isLocked : null as any;
        data["lockDate"] = this.lockDate ? this.lockDate.toISOString() : null as any;
        data["lockDateString"] = this.lockDateString !== undefined ? this.lockDateString : null as any;
        data["lastIssueTime"] = this.lastIssueTime ? this.lastIssueTime.toISOString() : null as any;
        data["lastIssueTimeString"] = this.lastIssueTimeString !== undefined ? this.lastIssueTimeString : null as any;
        data["productCount"] = this.productCount !== undefined ? this.productCount : null as any;
        data["orderCode"] = this.orderCode !== undefined ? this.orderCode : null as any;
        data["zoreOrderId"] = this.zoreOrderId !== undefined ? this.zoreOrderId : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creationTimeString"] = this.creationTimeString !== undefined ? this.creationTimeString : null as any;
        data["completionTime"] = this.completionTime ? this.completionTime.toISOString() : null as any;
        data["orderTerms"] = this.orderTerms !== undefined ? this.orderTerms : null as any;
        data["portOfDestination"] = this.portOfDestination !== undefined ? this.portOfDestination : null as any;
        return data;
    }
}

export class ExportSalasOrderDtoPagedResultDto {
    items!: ExportSalasOrderDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExportSalasOrderDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): ExportSalasOrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportSalasOrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class ExternalTaskInput {
    id!: string | null;
    processDefinitionKey!: string | null;
    processInstanceId!: string | null;
    variables!: { [key: string]: VariableValue; } | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.processDefinitionKey = _data["processDefinitionKey"] !== undefined ? _data["processDefinitionKey"] : null as any;
            this.processInstanceId = _data["processInstanceId"] !== undefined ? _data["processInstanceId"] : null as any;
            if (_data["variables"]) {
                this.variables = {} as any;
                for (let key in _data["variables"]) {
                    if (_data["variables"].hasOwnProperty(key))
                        (this.variables as any)![key] = _data["variables"][key] ? VariableValue.fromJS(_data["variables"][key]) : new VariableValue();
                }
            }
            else {
                this.variables = null as any;
            }
        }
    }

    static fromJS(data: any): ExternalTaskInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalTaskInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["processDefinitionKey"] = this.processDefinitionKey !== undefined ? this.processDefinitionKey : null as any;
        data["processInstanceId"] = this.processInstanceId !== undefined ? this.processInstanceId : null as any;
        if (this.variables) {
            data["variables"] = {};
            for (let key in this.variables) {
                if (this.variables.hasOwnProperty(key))
                    (data["variables"] as any)[key] = this.variables[key] ? this.variables[key].toJSON() : null as any;
            }
        }
        return data;
    }
}

/** 费用购物车详情DTO */
export class FeeCartDetailDto {
    id!: string;
    /** 归属用户ID */
    ownerUserId!: number;
    /** 客户代码 */
    customerCode!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    cartType!: FeeCartType;
    status!: FeeCartStatus;
    orderNo!: string | null;
    orderFormId!: string | null;
    items!: FeeCartItemDto[] | null;
    totalSnCount!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.ownerUserId = _data["ownerUserId"] !== undefined ? _data["ownerUserId"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.cartType = _data["cartType"] !== undefined ? _data["cartType"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.orderNo = _data["orderNo"] !== undefined ? _data["orderNo"] : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FeeCartItemDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalSnCount = _data["totalSnCount"] !== undefined ? _data["totalSnCount"] : null as any;
        }
    }

    static fromJS(data: any): FeeCartDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeeCartDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["ownerUserId"] = this.ownerUserId !== undefined ? this.ownerUserId : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["cartType"] = this.cartType !== undefined ? this.cartType : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["orderNo"] = this.orderNo !== undefined ? this.orderNo : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalSnCount"] = this.totalSnCount !== undefined ? this.totalSnCount : null as any;
        return data;
    }
}

export class FeeCartItemDto {
    id!: string;
    basicMotorModel!: string | null;
    basicMotorCode!: string | null;
    frameSize!: number;
    motorSeries!: string | null;
    qty!: number;
    sourceCso!: string | null;
    sourceCsoItem!: string | null;
    sourceIso!: string | null;
    sourceIsoItem!: string | null;
    feeMotorCode!: string | null;
    feeSapMaterial!: string | null;
    vcLongCode!: string | null;
    unitPrice!: number | null;
    multiplier!: number | null;
    salesPrice!: number | null;
    operationalRemarks!: string | null;
    remarkTwo!: string | null;
    sns!: FeeCartSnDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.motorSeries = _data["motorSeries"] !== undefined ? _data["motorSeries"] : null as any;
            this.qty = _data["qty"] !== undefined ? _data["qty"] : null as any;
            this.sourceCso = _data["sourceCso"] !== undefined ? _data["sourceCso"] : null as any;
            this.sourceCsoItem = _data["sourceCsoItem"] !== undefined ? _data["sourceCsoItem"] : null as any;
            this.sourceIso = _data["sourceIso"] !== undefined ? _data["sourceIso"] : null as any;
            this.sourceIsoItem = _data["sourceIsoItem"] !== undefined ? _data["sourceIsoItem"] : null as any;
            this.feeMotorCode = _data["feeMotorCode"] !== undefined ? _data["feeMotorCode"] : null as any;
            this.feeSapMaterial = _data["feeSapMaterial"] !== undefined ? _data["feeSapMaterial"] : null as any;
            this.vcLongCode = _data["vcLongCode"] !== undefined ? _data["vcLongCode"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.multiplier = _data["multiplier"] !== undefined ? _data["multiplier"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.operationalRemarks = _data["operationalRemarks"] !== undefined ? _data["operationalRemarks"] : null as any;
            this.remarkTwo = _data["remarkTwo"] !== undefined ? _data["remarkTwo"] : null as any;
            if (Array.isArray(_data["sns"])) {
                this.sns = [] as any;
                for (let item of _data["sns"])
                    this.sns!.push(FeeCartSnDto.fromJS(item));
            }
            else {
                this.sns = null as any;
            }
        }
    }

    static fromJS(data: any): FeeCartItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeeCartItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["motorSeries"] = this.motorSeries !== undefined ? this.motorSeries : null as any;
        data["qty"] = this.qty !== undefined ? this.qty : null as any;
        data["sourceCso"] = this.sourceCso !== undefined ? this.sourceCso : null as any;
        data["sourceCsoItem"] = this.sourceCsoItem !== undefined ? this.sourceCsoItem : null as any;
        data["sourceIso"] = this.sourceIso !== undefined ? this.sourceIso : null as any;
        data["sourceIsoItem"] = this.sourceIsoItem !== undefined ? this.sourceIsoItem : null as any;
        data["feeMotorCode"] = this.feeMotorCode !== undefined ? this.feeMotorCode : null as any;
        data["feeSapMaterial"] = this.feeSapMaterial !== undefined ? this.feeSapMaterial : null as any;
        data["vcLongCode"] = this.vcLongCode !== undefined ? this.vcLongCode : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["multiplier"] = this.multiplier !== undefined ? this.multiplier : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["operationalRemarks"] = this.operationalRemarks !== undefined ? this.operationalRemarks : null as any;
        data["remarkTwo"] = this.remarkTwo !== undefined ? this.remarkTwo : null as any;
        if (Array.isArray(this.sns)) {
            data["sns"] = [];
            for (let item of this.sns)
                data["sns"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 1 = Completed 2 = Rejected 3 = Cancelled */
export enum FeeCartResultStatus {
    Completed = 1,
    Rejected = 2,
    Cancelled = 3,
}

/** 费用购物车SN DTO */
export class FeeCartSnDto {
    id!: string;
    /** 序列号 */
    serialNumber!: string | null;
    /** 原CSO号 */
    sourceCso!: string | null;
    /** 原CSO行号 */
    sourceCsoItem!: string | null;
    occupyStatus!: SnOccupyStatus;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.sourceCso = _data["sourceCso"] !== undefined ? _data["sourceCso"] : null as any;
            this.sourceCsoItem = _data["sourceCsoItem"] !== undefined ? _data["sourceCsoItem"] : null as any;
            this.occupyStatus = _data["occupyStatus"] !== undefined ? _data["occupyStatus"] : null as any;
        }
    }

    static fromJS(data: any): FeeCartSnDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeeCartSnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["sourceCso"] = this.sourceCso !== undefined ? this.sourceCso : null as any;
        data["sourceCsoItem"] = this.sourceCsoItem !== undefined ? this.sourceCsoItem : null as any;
        data["occupyStatus"] = this.occupyStatus !== undefined ? this.occupyStatus : null as any;
        return data;
    }
}

/** 0 = Draft 1 = Submitted 2 = Completed */
export enum FeeCartStatus {
    Draft = 0,
    Submitted = 1,
    Completed = 2,
}

/** 1 = CpCto 2 = SalesOem */
export enum FeeCartType {
    CpCto = 1,
    SalesOem = 2,
}

export class FileModel {
    uid!: string | null;
    lastModified!: number;
    lastModifiedDate!: moment.Moment;
    name!: string | null;
    size!: number;
    type!: string | null;
    percent!: number;
    originFileObj!: OriginFile;
    status!: string | null;
    response!: FileModelResponse;

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"] !== undefined ? _data["uid"] : null as any;
            this.lastModified = _data["lastModified"] !== undefined ? _data["lastModified"] : null as any;
            this.lastModifiedDate = _data["lastModifiedDate"] ? moment(_data["lastModifiedDate"].toString()) : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.size = _data["size"] !== undefined ? _data["size"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.percent = _data["percent"] !== undefined ? _data["percent"] : null as any;
            this.originFileObj = _data["originFileObj"] ? OriginFile.fromJS(_data["originFileObj"]) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.response = _data["response"] ? FileModelResponse.fromJS(_data["response"]) : null as any;
        }
    }

    static fromJS(data: any): FileModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid !== undefined ? this.uid : null as any;
        data["lastModified"] = this.lastModified !== undefined ? this.lastModified : null as any;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["size"] = this.size !== undefined ? this.size : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["percent"] = this.percent !== undefined ? this.percent : null as any;
        data["originFileObj"] = this.originFileObj ? this.originFileObj.toJSON() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["response"] = this.response ? this.response.toJSON() : null as any;
        return data;
    }
}

export class FileModelResponse {
    fileName!: string | null;
    id!: string | null;
    mimeType!: string | null;
    url!: string | null;

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.mimeType = _data["mimeType"] !== undefined ? _data["mimeType"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
        }
    }

    static fromJS(data: any): FileModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["mimeType"] = this.mimeType !== undefined ? this.mimeType : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        return data;
    }
}

export class Freetext {
    vc!: string[] | null;
    required!: Required[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vc"])) {
                this.vc = [] as any;
                for (let item of _data["vc"])
                    this.vc!.push(item);
            }
            else {
                this.vc = null as any;
            }
            if (Array.isArray(_data["required"])) {
                this.required = [] as any;
                for (let item of _data["required"])
                    this.required!.push(Required.fromJS(item));
            }
            else {
                this.required = null as any;
            }
        }
    }

    static fromJS(data: any): Freetext {
        data = typeof data === 'object' ? data : {};
        let result = new Freetext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vc)) {
            data["vc"] = [];
            for (let item of this.vc)
                data["vc"].push(item);
        }
        if (Array.isArray(this.required)) {
            data["required"] = [];
            for (let item of this.required)
                data["required"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetAllFinalCustomerListOutput {
    /** CP编号 */
    customerNo!: string | null;
    /** 最终客户名称 */
    customerName!: string | null;
    /** 最终客户代号 */
    customerCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
        }
    }

    static fromJS(data: any): GetAllFinalCustomerListOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllFinalCustomerListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        return data;
    }
}

export class GetApplicationAllDto {
    /** 应用编码 */
    applicationCode!: string | null;
    /** 应用名称 */
    applicationName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.applicationCode = _data["applicationCode"] !== undefined ? _data["applicationCode"] : null as any;
            this.applicationName = _data["applicationName"] !== undefined ? _data["applicationName"] : null as any;
        }
    }

    static fromJS(data: any): GetApplicationAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicationAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationCode"] = this.applicationCode !== undefined ? this.applicationCode : null as any;
        data["applicationName"] = this.applicationName !== undefined ? this.applicationName : null as any;
        return data;
    }
}

export class GetCTOProductBasicMotorAllDto {
    /** 主键Id */
    id!: string;
    /** 产品组合编码 */
    productMixCode!: string | null;
    /** 客户物料号 */
    customerMaterialNumber!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 机座号 */
    frameSize!: number;
    /** 备注 */
    remark!: string | null;
    /** 售价 */
    salesPrice!: number;
    /** cp编号 */
    cpCode!: string | null;
    /** cp名称 */
    cpName!: string | null;
    /** 二级客户代码 */
    finalCustomerCode!: string | null;
    /** 二级客户名称 */
    finalCustomerName!: string | null;
    /** 系列名称 */
    seriesName!: string | null;
    /** 是否可以勾选 */
    checked!: boolean;
    /** 客户化代码 */
    customCode!: boolean;
    /** Vc */
    vcCodes!: string | null;
    /** Vc备注 */
    vcCodeRemark!: string | null;
    /** 创建时间 */
    creationTime!: moment.Moment;
    /** GSS报价号 */
    gssQuotationNo!: string | null;
    /** GSS技术确认号 */
    gssTechnicalConfirmationNumber!: string | null;
    /** 技术规范 */
    technicalSpecifications!: string | null;
    /** 特价号 */
    specialOfferNumber!: string | null;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** 预计交货日期/天 */
    expectedDeliveryDate!: string | null;
    status!: ProductBasicMotorCodeStatus;
    confirmStatus!: ProductSyncConfirmStatus;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.productMixCode = _data["productMixCode"] !== undefined ? _data["productMixCode"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.cpName = _data["cpName"] !== undefined ? _data["cpName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
            this.checked = _data["checked"] !== undefined ? _data["checked"] : null as any;
            this.customCode = _data["customCode"] !== undefined ? _data["customCode"] : null as any;
            this.vcCodes = _data["vcCodes"] !== undefined ? _data["vcCodes"] : null as any;
            this.vcCodeRemark = _data["vcCodeRemark"] !== undefined ? _data["vcCodeRemark"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.specialOfferNumber = _data["specialOfferNumber"] !== undefined ? _data["specialOfferNumber"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.confirmStatus = _data["confirmStatus"] !== undefined ? _data["confirmStatus"] : null as any;
        }
    }

    static fromJS(data: any): GetCTOProductBasicMotorAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCTOProductBasicMotorAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["productMixCode"] = this.productMixCode !== undefined ? this.productMixCode : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["cpName"] = this.cpName !== undefined ? this.cpName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        data["checked"] = this.checked !== undefined ? this.checked : null as any;
        data["customCode"] = this.customCode !== undefined ? this.customCode : null as any;
        data["vcCodes"] = this.vcCodes !== undefined ? this.vcCodes : null as any;
        data["vcCodeRemark"] = this.vcCodeRemark !== undefined ? this.vcCodeRemark : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["specialOfferNumber"] = this.specialOfferNumber !== undefined ? this.specialOfferNumber : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["confirmStatus"] = this.confirmStatus !== undefined ? this.confirmStatus : null as any;
        return data;
    }
}

export class GetCTOProductBasicMotorAllTotalCountDto {
    /** 总数 */
    totalCount!: number;
    getCTOProductBasicMotorAllDtos!: GetCTOProductBasicMotorAllDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["getCTOProductBasicMotorAllDtos"])) {
                this.getCTOProductBasicMotorAllDtos = [] as any;
                for (let item of _data["getCTOProductBasicMotorAllDtos"])
                    this.getCTOProductBasicMotorAllDtos!.push(GetCTOProductBasicMotorAllDto.fromJS(item));
            }
            else {
                this.getCTOProductBasicMotorAllDtos = null as any;
            }
        }
    }

    static fromJS(data: any): GetCTOProductBasicMotorAllTotalCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCTOProductBasicMotorAllTotalCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.getCTOProductBasicMotorAllDtos)) {
            data["getCTOProductBasicMotorAllDtos"] = [];
            for (let item of this.getCTOProductBasicMotorAllDtos)
                data["getCTOProductBasicMotorAllDtos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetCTOProductBasicMotorDto {
    /** 主键 */
    id!: string;
    /** 产品组合编码 */
    productMixCode!: string | null;
    /** 客户物料号 */
    customerMaterialNumber!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 机座号 */
    frameSize!: number;
    /** 预计交货日期/天 */
    expectedDeliveryDate!: string | null;
    /** 备注 */
    remark!: string | null;
    /** 售价 */
    salesPrice!: number;
    /** 接收PrdTech的JSON */
    receivePrdTechJSON!: string | null;
    /** 接收PrdElecs的JSON */
    receivePrdElecsJSON!: string | null;
    /** CP编码 */
    cpCode!: string | null;
    /** CP名称 */
    cpCoName!: string | null;
    /** 二级客户代码 */
    finalCustomerCode!: string | null;
    /** 二级客户名称 */
    finalCustomerName!: string | null;
    /** Vc */
    vcCodes!: string | null;
    /** Vc备注 */
    vcCodeRemark!: string | null;
    /** 客户化代码 */
    customCode!: boolean;
    /** GSS报价号 */
    gssQuotationNo!: string | null;
    /** GSS技术确认号 */
    gssTechnicalConfirmationNumber!: string | null;
    /** 技术规范 */
    technicalSpecifications!: string | null;
    /** 特价号 */
    specialOfferNumber!: string | null;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** CTO产品VC */
    ctoProductVCs!: GetCTOProductVCDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.productMixCode = _data["productMixCode"] !== undefined ? _data["productMixCode"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.receivePrdTechJSON = _data["receivePrdTechJSON"] !== undefined ? _data["receivePrdTechJSON"] : null as any;
            this.receivePrdElecsJSON = _data["receivePrdElecsJSON"] !== undefined ? _data["receivePrdElecsJSON"] : null as any;
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.cpCoName = _data["cpCoName"] !== undefined ? _data["cpCoName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.vcCodes = _data["vcCodes"] !== undefined ? _data["vcCodes"] : null as any;
            this.vcCodeRemark = _data["vcCodeRemark"] !== undefined ? _data["vcCodeRemark"] : null as any;
            this.customCode = _data["customCode"] !== undefined ? _data["customCode"] : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.specialOfferNumber = _data["specialOfferNumber"] !== undefined ? _data["specialOfferNumber"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            if (Array.isArray(_data["ctoProductVCs"])) {
                this.ctoProductVCs = [] as any;
                for (let item of _data["ctoProductVCs"])
                    this.ctoProductVCs!.push(GetCTOProductVCDto.fromJS(item));
            }
            else {
                this.ctoProductVCs = null as any;
            }
        }
    }

    static fromJS(data: any): GetCTOProductBasicMotorDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCTOProductBasicMotorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["productMixCode"] = this.productMixCode !== undefined ? this.productMixCode : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["receivePrdTechJSON"] = this.receivePrdTechJSON !== undefined ? this.receivePrdTechJSON : null as any;
        data["receivePrdElecsJSON"] = this.receivePrdElecsJSON !== undefined ? this.receivePrdElecsJSON : null as any;
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["cpCoName"] = this.cpCoName !== undefined ? this.cpCoName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["vcCodes"] = this.vcCodes !== undefined ? this.vcCodes : null as any;
        data["vcCodeRemark"] = this.vcCodeRemark !== undefined ? this.vcCodeRemark : null as any;
        data["customCode"] = this.customCode !== undefined ? this.customCode : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["specialOfferNumber"] = this.specialOfferNumber !== undefined ? this.specialOfferNumber : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        if (Array.isArray(this.ctoProductVCs)) {
            data["ctoProductVCs"] = [];
            for (let item of this.ctoProductVCs)
                data["ctoProductVCs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetCTOProductVCDto {
    /** 主键 */
    id!: string;
    /** 变量产品代码 */
    vcProductCode!: string | null;
    /** 变量编号 */
    vcCode!: string | null;
    /** 折扣类型 */
    discountType!: string | null;
    /** 描述 */
    meaning!: string | null;
    /** 备注 */
    remark!: string | null;
    /** 接收VCFreeText的JSON */
    receiveVcFreeTextJSON!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcProductCode = _data["vcProductCode"] !== undefined ? _data["vcProductCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.receiveVcFreeTextJSON = _data["receiveVcFreeTextJSON"] !== undefined ? _data["receiveVcFreeTextJSON"] : null as any;
        }
    }

    static fromJS(data: any): GetCTOProductVCDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCTOProductVCDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcProductCode"] = this.vcProductCode !== undefined ? this.vcProductCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["discountType"] = this.discountType !== undefined ? this.discountType : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["receiveVcFreeTextJSON"] = this.receiveVcFreeTextJSON !== undefined ? this.receiveVcFreeTextJSON : null as any;
        return data;
    }
}

export class GetChannelAllDto {
    /** 渠道编号 */
    channelCode!: string | null;
    /** 渠道名称 */
    channelName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.channelCode = _data["channelCode"] !== undefined ? _data["channelCode"] : null as any;
            this.channelName = _data["channelName"] !== undefined ? _data["channelName"] : null as any;
        }
    }

    static fromJS(data: any): GetChannelAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetChannelAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelCode"] = this.channelCode !== undefined ? this.channelCode : null as any;
        data["channelName"] = this.channelName !== undefined ? this.channelName : null as any;
        return data;
    }
}

export class GetCodesVersionAndVcsOutputDto {
    jinMotorCode!: string | null;
    basicMotorCode!: string | null;
    hasVCs!: boolean;
    canCarryVCs!: boolean;
    version!: string | null;
    status!: number;
    subCustomerCode!: string | null;
    customerCode!: string | null;
    listPriceMultiplier!: number;
    jinIndicator!: string | null;
    technologyQuotationProductId!: string | null;
    vcs!: JInCodesVcsOutputDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.jinMotorCode = _data["jinMotorCode"] !== undefined ? _data["jinMotorCode"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.hasVCs = _data["hasVCs"] !== undefined ? _data["hasVCs"] : null as any;
            this.canCarryVCs = _data["canCarryVCs"] !== undefined ? _data["canCarryVCs"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.subCustomerCode = _data["subCustomerCode"] !== undefined ? _data["subCustomerCode"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.listPriceMultiplier = _data["listPriceMultiplier"] !== undefined ? _data["listPriceMultiplier"] : null as any;
            this.jinIndicator = _data["jinIndicator"] !== undefined ? _data["jinIndicator"] : null as any;
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
            if (Array.isArray(_data["vcs"])) {
                this.vcs = [] as any;
                for (let item of _data["vcs"])
                    this.vcs!.push(JInCodesVcsOutputDto.fromJS(item));
            }
            else {
                this.vcs = null as any;
            }
        }
    }

    static fromJS(data: any): GetCodesVersionAndVcsOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCodesVersionAndVcsOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jinMotorCode"] = this.jinMotorCode !== undefined ? this.jinMotorCode : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["hasVCs"] = this.hasVCs !== undefined ? this.hasVCs : null as any;
        data["canCarryVCs"] = this.canCarryVCs !== undefined ? this.canCarryVCs : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["subCustomerCode"] = this.subCustomerCode !== undefined ? this.subCustomerCode : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["listPriceMultiplier"] = this.listPriceMultiplier !== undefined ? this.listPriceMultiplier : null as any;
        data["jinIndicator"] = this.jinIndicator !== undefined ? this.jinIndicator : null as any;
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        if (Array.isArray(this.vcs)) {
            data["vcs"] = [];
            for (let item of this.vcs)
                data["vcs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 分页获取所有客户信息 */
export class GetCustomInfosByDeliveryTimeOutDto {
    /** 总数 */
    totalCount!: number;
    cusDeliveryTimeInfos!: DeliveryTimeForSoldToPartyDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["cusDeliveryTimeInfos"])) {
                this.cusDeliveryTimeInfos = [] as any;
                for (let item of _data["cusDeliveryTimeInfos"])
                    this.cusDeliveryTimeInfos!.push(DeliveryTimeForSoldToPartyDto.fromJS(item));
            }
            else {
                this.cusDeliveryTimeInfos = null as any;
            }
        }
    }

    static fromJS(data: any): GetCustomInfosByDeliveryTimeOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomInfosByDeliveryTimeOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.cusDeliveryTimeInfos)) {
            data["cusDeliveryTimeInfos"] = [];
            for (let item of this.cusDeliveryTimeInfos)
                data["cusDeliveryTimeInfos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetDataPlatFormOrderTypeDto {
    /** 订单ID */
    dataPlatFormOrderTypeId!: string | null;
    /** 订单名称 */
    dataPlatFormOrderTypeName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.dataPlatFormOrderTypeId = _data["dataPlatFormOrderTypeId"] !== undefined ? _data["dataPlatFormOrderTypeId"] : null as any;
            this.dataPlatFormOrderTypeName = _data["dataPlatFormOrderTypeName"] !== undefined ? _data["dataPlatFormOrderTypeName"] : null as any;
        }
    }

    static fromJS(data: any): GetDataPlatFormOrderTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataPlatFormOrderTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataPlatFormOrderTypeId"] = this.dataPlatFormOrderTypeId !== undefined ? this.dataPlatFormOrderTypeId : null as any;
        data["dataPlatFormOrderTypeName"] = this.dataPlatFormOrderTypeName !== undefined ? this.dataPlatFormOrderTypeName : null as any;
        return data;
    }
}

/** 根据客户编号获取已维护发货时间记录 */
export class GetDeliveryTimeForSoldToPartyOutDto {
    /** 总数 */
    totalCount!: number;
    deliveryTimes!: DeliveryTimeForSoldToPartyDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["deliveryTimes"])) {
                this.deliveryTimes = [] as any;
                for (let item of _data["deliveryTimes"])
                    this.deliveryTimes!.push(DeliveryTimeForSoldToPartyDto.fromJS(item));
            }
            else {
                this.deliveryTimes = null as any;
            }
        }
    }

    static fromJS(data: any): GetDeliveryTimeForSoldToPartyOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeliveryTimeForSoldToPartyOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.deliveryTimes)) {
            data["deliveryTimes"] = [];
            for (let item of this.deliveryTimes)
                data["deliveryTimes"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetIndustryAllDto {
    /** 行业编码 */
    industryCode!: string | null;
    /** 行业名称 */
    industryName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.industryCode = _data["industryCode"] !== undefined ? _data["industryCode"] : null as any;
            this.industryName = _data["industryName"] !== undefined ? _data["industryName"] : null as any;
        }
    }

    static fromJS(data: any): GetIndustryAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIndustryAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["industryCode"] = this.industryCode !== undefined ? this.industryCode : null as any;
        data["industryName"] = this.industryName !== undefined ? this.industryName : null as any;
        return data;
    }
}

/** 获取最终客户行业信息 */
export class GetIndustryInfosForFinalCustomer {
    /** 行业编号 */
    industryCode!: string | null;
    /** 行业名称 */
    industryName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.industryCode = _data["industryCode"] !== undefined ? _data["industryCode"] : null as any;
            this.industryName = _data["industryName"] !== undefined ? _data["industryName"] : null as any;
        }
    }

    static fromJS(data: any): GetIndustryInfosForFinalCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new GetIndustryInfosForFinalCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["industryCode"] = this.industryCode !== undefined ? this.industryCode : null as any;
        data["industryName"] = this.industryName !== undefined ? this.industryName : null as any;
        return data;
    }
}

export class GetOEMProductBasicMotorAllDto {
    /** 主键Id */
    id!: string;
    /** 产品组合编码 */
    productMixCode!: string | null;
    /** 客户物料号 */
    customerMaterialNumber!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 机座号 */
    frameSize!: number;
    /** 备注 */
    remark!: string | null;
    /** OEM客户名称 */
    cpName!: string | null;
    /** OEM二级客户名称 */
    finalCustomerName!: string | null;
    /** 售价 */
    salesPrice!: number;
    /** 客户化代码 */
    customCode!: boolean;
    /** GSS报价号 */
    gssQuotationNo!: string | null;
    /** GSS技术确认号 */
    gssTechnicalConfirmationNumber!: string | null;
    /** 技术规范 */
    technicalSpecifications!: string | null;
    /** 特价号 */
    specialOfferNumber!: string | null;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** 预计交货日期/天 */
    expectedDeliveryDate!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.productMixCode = _data["productMixCode"] !== undefined ? _data["productMixCode"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.cpName = _data["cpName"] !== undefined ? _data["cpName"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.customCode = _data["customCode"] !== undefined ? _data["customCode"] : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.specialOfferNumber = _data["specialOfferNumber"] !== undefined ? _data["specialOfferNumber"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
        }
    }

    static fromJS(data: any): GetOEMProductBasicMotorAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOEMProductBasicMotorAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["productMixCode"] = this.productMixCode !== undefined ? this.productMixCode : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["cpName"] = this.cpName !== undefined ? this.cpName : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["customCode"] = this.customCode !== undefined ? this.customCode : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["specialOfferNumber"] = this.specialOfferNumber !== undefined ? this.specialOfferNumber : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        return data;
    }
}

export class GetOEMProductBasicMotorAllTotalCountDto {
    /** 总数 */
    totalCount!: number;
    getOEMProductBasicMotorAllDtos!: GetOEMProductBasicMotorAllDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["getOEMProductBasicMotorAllDtos"])) {
                this.getOEMProductBasicMotorAllDtos = [] as any;
                for (let item of _data["getOEMProductBasicMotorAllDtos"])
                    this.getOEMProductBasicMotorAllDtos!.push(GetOEMProductBasicMotorAllDto.fromJS(item));
            }
            else {
                this.getOEMProductBasicMotorAllDtos = null as any;
            }
        }
    }

    static fromJS(data: any): GetOEMProductBasicMotorAllTotalCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOEMProductBasicMotorAllTotalCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.getOEMProductBasicMotorAllDtos)) {
            data["getOEMProductBasicMotorAllDtos"] = [];
            for (let item of this.getOEMProductBasicMotorAllDtos)
                data["getOEMProductBasicMotorAllDtos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetOEMProductBasicMotorDto {
    /** 主键 */
    id!: string;
    /** 产品组合编码 */
    productMixCode!: string | null;
    /** 客户物料号 */
    customerMaterialNumber!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 机座号 */
    frameSize!: number;
    /** 预计交货日期/天 */
    expectedDeliveryDate!: string | null;
    /** 售价 */
    salesPrice!: number;
    /** 备注 */
    remark!: string | null;
    /** 接收PrdTech的JSON */
    receivePrdTechJSON!: string | null;
    /** 接收PrdElecs的JSON */
    receivePrdElecsJSON!: string | null;
    /** CP编码 */
    cpCode!: string | null;
    /** CP名称 */
    cpCoName!: string | null;
    /** 二级客户编码 */
    finalCustomerCode!: string | null;
    /** 二级客户名称 */
    finalCustomerName!: string | null;
    /** Vc */
    vcCodes!: string | null;
    /** Vc备注 */
    vcCodeRemark!: string | null;
    /** 客户化代码 */
    customCode!: boolean;
    /** GSS报价号 */
    gssQuotationNo!: string | null;
    /** GSS技术确认号 */
    gssTechnicalConfirmationNumber!: string | null;
    /** 技术规范 */
    technicalSpecifications!: string | null;
    /** 特价号 */
    specialOfferNumber!: string | null;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** CTO产品VC */
    oemProductVCs!: GetOEMProductVCDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.productMixCode = _data["productMixCode"] !== undefined ? _data["productMixCode"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.receivePrdTechJSON = _data["receivePrdTechJSON"] !== undefined ? _data["receivePrdTechJSON"] : null as any;
            this.receivePrdElecsJSON = _data["receivePrdElecsJSON"] !== undefined ? _data["receivePrdElecsJSON"] : null as any;
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.cpCoName = _data["cpCoName"] !== undefined ? _data["cpCoName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.vcCodes = _data["vcCodes"] !== undefined ? _data["vcCodes"] : null as any;
            this.vcCodeRemark = _data["vcCodeRemark"] !== undefined ? _data["vcCodeRemark"] : null as any;
            this.customCode = _data["customCode"] !== undefined ? _data["customCode"] : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.specialOfferNumber = _data["specialOfferNumber"] !== undefined ? _data["specialOfferNumber"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            if (Array.isArray(_data["oemProductVCs"])) {
                this.oemProductVCs = [] as any;
                for (let item of _data["oemProductVCs"])
                    this.oemProductVCs!.push(GetOEMProductVCDto.fromJS(item));
            }
            else {
                this.oemProductVCs = null as any;
            }
        }
    }

    static fromJS(data: any): GetOEMProductBasicMotorDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOEMProductBasicMotorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["productMixCode"] = this.productMixCode !== undefined ? this.productMixCode : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["receivePrdTechJSON"] = this.receivePrdTechJSON !== undefined ? this.receivePrdTechJSON : null as any;
        data["receivePrdElecsJSON"] = this.receivePrdElecsJSON !== undefined ? this.receivePrdElecsJSON : null as any;
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["cpCoName"] = this.cpCoName !== undefined ? this.cpCoName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["vcCodes"] = this.vcCodes !== undefined ? this.vcCodes : null as any;
        data["vcCodeRemark"] = this.vcCodeRemark !== undefined ? this.vcCodeRemark : null as any;
        data["customCode"] = this.customCode !== undefined ? this.customCode : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["specialOfferNumber"] = this.specialOfferNumber !== undefined ? this.specialOfferNumber : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        if (Array.isArray(this.oemProductVCs)) {
            data["oemProductVCs"] = [];
            for (let item of this.oemProductVCs)
                data["oemProductVCs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetOEMProductVCDto {
    /** 主键 */
    id!: string;
    /** 变量产品代码 */
    vcProductCode!: string | null;
    /** 变量编号 */
    vcCode!: string | null;
    /** 折扣类型 */
    discountType!: string | null;
    /** 描述 */
    meaning!: string | null;
    /** 备注 */
    remark!: string | null;
    /** 接收VCFreeText的JSON */
    receiveVcFreeTextJSON!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcProductCode = _data["vcProductCode"] !== undefined ? _data["vcProductCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.receiveVcFreeTextJSON = _data["receiveVcFreeTextJSON"] !== undefined ? _data["receiveVcFreeTextJSON"] : null as any;
        }
    }

    static fromJS(data: any): GetOEMProductVCDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOEMProductVCDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcProductCode"] = this.vcProductCode !== undefined ? this.vcProductCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["discountType"] = this.discountType !== undefined ? this.discountType : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["receiveVcFreeTextJSON"] = this.receiveVcFreeTextJSON !== undefined ? this.receiveVcFreeTextJSON : null as any;
        return data;
    }
}

export class GetOEMShoppingCartAllDto {
    /** 主键Id */
    id!: string;
    /** 产品组合编码 */
    productMixCode!: string | null;
    /** 客户物料号 */
    customerMaterialNumber!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 机座号 */
    frameSize!: number;
    /** 备注 */
    remark!: string | null;
    /** CP编码 */
    cpCode!: string | null;
    /** 二级客户名称 */
    finalCustomerName!: string | null;
    /** 二级客户编码 */
    finalCustomerCode!: string | null;
    /** CP名称 */
    cpCoName!: string | null;
    /** GSS报价号 */
    gssQuotationNo!: string | null;
    /** GSS技术确认号 */
    gssTechnicalConfirmationNumber!: string | null;
    /** 技术规范 */
    technicalSpecifications!: string | null;
    /** 特价号 */
    specialOfferNumber!: string | null;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** 预计交货日期/天 */
    expectedDeliveryDate!: string | null;
    vcs!: GetOEMShoppingCartVCAllDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.productMixCode = _data["productMixCode"] !== undefined ? _data["productMixCode"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.cpCoName = _data["cpCoName"] !== undefined ? _data["cpCoName"] : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.specialOfferNumber = _data["specialOfferNumber"] !== undefined ? _data["specialOfferNumber"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            if (Array.isArray(_data["vcs"])) {
                this.vcs = [] as any;
                for (let item of _data["vcs"])
                    this.vcs!.push(GetOEMShoppingCartVCAllDto.fromJS(item));
            }
            else {
                this.vcs = null as any;
            }
        }
    }

    static fromJS(data: any): GetOEMShoppingCartAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOEMShoppingCartAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["productMixCode"] = this.productMixCode !== undefined ? this.productMixCode : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["cpCoName"] = this.cpCoName !== undefined ? this.cpCoName : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["specialOfferNumber"] = this.specialOfferNumber !== undefined ? this.specialOfferNumber : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        if (Array.isArray(this.vcs)) {
            data["vcs"] = [];
            for (let item of this.vcs)
                data["vcs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetOEMShoppingCartVCAllDto {
    /** 主键 */
    id!: string;
    /** 变量产品代码 */
    vcProductCode!: string | null;
    /** 变量编号 */
    vcCode!: string | null;
    /** 折扣类型 */
    discountType!: string | null;
    /** 描述 */
    meaning!: string | null;
    /** 备注 */
    remark!: string | null;
    /** 接收VCFreeText的JSON */
    receiveVcFreeTextJSON!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcProductCode = _data["vcProductCode"] !== undefined ? _data["vcProductCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.receiveVcFreeTextJSON = _data["receiveVcFreeTextJSON"] !== undefined ? _data["receiveVcFreeTextJSON"] : null as any;
        }
    }

    static fromJS(data: any): GetOEMShoppingCartVCAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOEMShoppingCartVCAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcProductCode"] = this.vcProductCode !== undefined ? this.vcProductCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["discountType"] = this.discountType !== undefined ? this.discountType : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["receiveVcFreeTextJSON"] = this.receiveVcFreeTextJSON !== undefined ? this.receiveVcFreeTextJSON : null as any;
        return data;
    }
}

export class GetOrderChangeExecutionListTotalCountDto {
    /** 总数 */
    totalCount!: number;
    getExecutionListDtos!: OrderChangeExecutionListDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["getExecutionListDtos"])) {
                this.getExecutionListDtos = [] as any;
                for (let item of _data["getExecutionListDtos"])
                    this.getExecutionListDtos!.push(OrderChangeExecutionListDto.fromJS(item));
            }
            else {
                this.getExecutionListDtos = null as any;
            }
        }
    }

    static fromJS(data: any): GetOrderChangeExecutionListTotalCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderChangeExecutionListTotalCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.getExecutionListDtos)) {
            data["getExecutionListDtos"] = [];
            for (let item of this.getExecutionListDtos)
                data["getExecutionListDtos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetOrderChangeOrderFormAllDto {
    /** 主键 */
    id!: string;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** 选型Id */
    modelSelectionId!: string | null;
    /** 选型名称 */
    modelSelectionName!: string | null;
    /** 特价申请号 */
    specialOfferApplicationNumber!: string | null;
    /** 总价 */
    totalPrice!: number | null;
    /** 客户订单号 */
    customerOrderNumber!: string | null;
    /** 最终客户编码 */
    endCustomerCode!: string | null;
    /** 最终客户名称 */
    endCustomerName!: string | null;
    /** 下单时间 */
    orderTime!: moment.Moment | null;
    /** 订单完成时间 */
    orderCompleteTime!: moment.Moment | null;
    /** 预计交货日期/天 */
    expectedDeliveryDate!: string | null;
    /** 客户期望交货日期/天 */
    customerExpectedDeliveryDate!: string | null;
    /** PO号 */
    poNumber!: string | null;
    orderStatus!: EnumOrderChangeOrderFormVersionsStatus;
    readonly orderStatusName!: string | null;
    orderType!: OrderType;
    /** 创建人 */
    creationId!: number | null;
    /** 创建名称 */
    creationName!: string | null;
    /** 创建时间 */
    creationTime!: moment.Moment;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.modelSelectionId = _data["modelSelectionId"] !== undefined ? _data["modelSelectionId"] : null as any;
            this.modelSelectionName = _data["modelSelectionName"] !== undefined ? _data["modelSelectionName"] : null as any;
            this.specialOfferApplicationNumber = _data["specialOfferApplicationNumber"] !== undefined ? _data["specialOfferApplicationNumber"] : null as any;
            this.totalPrice = _data["totalPrice"] !== undefined ? _data["totalPrice"] : null as any;
            this.customerOrderNumber = _data["customerOrderNumber"] !== undefined ? _data["customerOrderNumber"] : null as any;
            this.endCustomerCode = _data["endCustomerCode"] !== undefined ? _data["endCustomerCode"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.orderTime = _data["orderTime"] ? moment(_data["orderTime"].toString()) : null as any;
            this.orderCompleteTime = _data["orderCompleteTime"] ? moment(_data["orderCompleteTime"].toString()) : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.customerExpectedDeliveryDate = _data["customerExpectedDeliveryDate"] !== undefined ? _data["customerExpectedDeliveryDate"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : null as any;
            (this as any).orderStatusName = _data["orderStatusName"] !== undefined ? _data["orderStatusName"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.creationId = _data["creationId"] !== undefined ? _data["creationId"] : null as any;
            this.creationName = _data["creationName"] !== undefined ? _data["creationName"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): GetOrderChangeOrderFormAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderChangeOrderFormAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["modelSelectionId"] = this.modelSelectionId !== undefined ? this.modelSelectionId : null as any;
        data["modelSelectionName"] = this.modelSelectionName !== undefined ? this.modelSelectionName : null as any;
        data["specialOfferApplicationNumber"] = this.specialOfferApplicationNumber !== undefined ? this.specialOfferApplicationNumber : null as any;
        data["totalPrice"] = this.totalPrice !== undefined ? this.totalPrice : null as any;
        data["customerOrderNumber"] = this.customerOrderNumber !== undefined ? this.customerOrderNumber : null as any;
        data["endCustomerCode"] = this.endCustomerCode !== undefined ? this.endCustomerCode : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["orderTime"] = this.orderTime ? this.orderTime.toISOString() : null as any;
        data["orderCompleteTime"] = this.orderCompleteTime ? this.orderCompleteTime.toISOString() : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["customerExpectedDeliveryDate"] = this.customerExpectedDeliveryDate !== undefined ? this.customerExpectedDeliveryDate : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : null as any;
        data["orderStatusName"] = this.orderStatusName !== undefined ? this.orderStatusName : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["creationId"] = this.creationId !== undefined ? this.creationId : null as any;
        data["creationName"] = this.creationName !== undefined ? this.creationName : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        return data;
    }
}

export class GetOrderChangeOrderFormAllTotalCountDto {
    /** 总数 */
    totalCount!: number;
    getOrderFormAllDtos!: GetOrderChangeOrderFormAllDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["getOrderFormAllDtos"])) {
                this.getOrderFormAllDtos = [] as any;
                for (let item of _data["getOrderFormAllDtos"])
                    this.getOrderFormAllDtos!.push(GetOrderChangeOrderFormAllDto.fromJS(item));
            }
            else {
                this.getOrderFormAllDtos = null as any;
            }
        }
    }

    static fromJS(data: any): GetOrderChangeOrderFormAllTotalCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderChangeOrderFormAllTotalCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.getOrderFormAllDtos)) {
            data["getOrderFormAllDtos"] = [];
            for (let item of this.getOrderFormAllDtos)
                data["getOrderFormAllDtos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** Order Dashbord 结果对象 统计“待审核”，“已审核”，“需修改”订单的数据接口 */
export class GetOrderDashboardDto {
    /** 订单Id */
    orderFormId!: string;
    /** 提交时间 */
    orderTime!: moment.Moment | null;
    /** 合同号 */
    poNumber!: string | null;
    /** 产品数量 */
    productCount!: number;
    /** 订单总金额 */
    totalAmount!: number | null;
    /** 客户代码 */
    endCustomerCode!: string | null;
    /** 客户名称 */
    endCustomerName!: string | null;
    /** 销售区域 */
    salesAreaName!: string | null;
    /** 行业 */
    industryName!: string | null;
    /** 应用 */
    applicationName!: string | null;
    /** 交货地址 */
    shippingAddress!: string | null;
    /** Pre-cal号 */
    specialOfferApplicationNumber!: string | null;
    /** 特价号接口 */
    isManual!: string | null;
    /** 希望交货期 */
    customerExpectedDeliveryDate!: moment.Moment | null;
    /** 销售员 */
    responsibleSalesName!: string | null;
    /** 渠道 */
    channelName!: string | null;
    /** 客户订单号 */
    customerOrderNumber!: string | null;
    /** 备库订单 */
    forLibOrderStr!: string | null;
    /** 直接客户编码 */
    finalCustomerCode!: string | null;
    /** 直接客户 */
    finalCustomer!: string | null;
    orderType!: OrderType;
    /** 项目编号 */
    projectNo!: string | null;
    /** 项目名称 */
    projectName!: string | null;
    /** 选型号 */
    modelSelectionId!: string | null;
    /** 选型名称 */
    modelSelectionName!: string | null;
    /** 来源 */
    orderSource!: string | null;
    /** 制单人Id */
    creatorUserId!: number | null;
    /** 制单人 */
    creatorUserName!: string | null;
    /** 制单时间 */
    creationTime!: moment.Moment | null;
    /** 最后一次审批Id */
    approvalId!: string | null;
    auditStatus!: AuditStatus;
    /** 审批状态 */
    readonly auditStatusStr!: string | null;
    /** 审批人Id */
    auditCreatorUserId!: number | null;
    /** 审批人 */
    auditCreatorUserName!: string | null;
    /** 审批时间 */
    auditCreationTime!: moment.Moment | null;
    /** 审批意见 */
    remarks!: string | null;
    /** OMS订单号 */
    omsOrderNumber!: string | null;
    /** 订单优先级 */
    orderGrade!: string | null;
    /** 退单时长
1  对于退回重新提交的订单：从退回时间（审批被驳回时间）-->重新提交的时间
2  对于退回则暂未提交的订单：从退回时间-->统计当前时间 */
    backDuration!: number;
    /** 订单提交时间
最终审批时间的提交时间 */
    submitTime!: moment.Moment | null;
    /** 所在地国家 */
    locationCountry!: string | null;
    /** 所在地国家中文名 */
    locationCountryCN!: string | null;
    /** 开口项 */
    openItem!: string | null;

    init(_data?: any) {
        if (_data) {
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.orderTime = _data["orderTime"] ? moment(_data["orderTime"].toString()) : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.productCount = _data["productCount"] !== undefined ? _data["productCount"] : null as any;
            this.totalAmount = _data["totalAmount"] !== undefined ? _data["totalAmount"] : null as any;
            this.endCustomerCode = _data["endCustomerCode"] !== undefined ? _data["endCustomerCode"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.salesAreaName = _data["salesAreaName"] !== undefined ? _data["salesAreaName"] : null as any;
            this.industryName = _data["industryName"] !== undefined ? _data["industryName"] : null as any;
            this.applicationName = _data["applicationName"] !== undefined ? _data["applicationName"] : null as any;
            this.shippingAddress = _data["shippingAddress"] !== undefined ? _data["shippingAddress"] : null as any;
            this.specialOfferApplicationNumber = _data["specialOfferApplicationNumber"] !== undefined ? _data["specialOfferApplicationNumber"] : null as any;
            this.isManual = _data["isManual"] !== undefined ? _data["isManual"] : null as any;
            this.customerExpectedDeliveryDate = _data["customerExpectedDeliveryDate"] ? moment(_data["customerExpectedDeliveryDate"].toString()) : null as any;
            this.responsibleSalesName = _data["responsibleSalesName"] !== undefined ? _data["responsibleSalesName"] : null as any;
            this.channelName = _data["channelName"] !== undefined ? _data["channelName"] : null as any;
            this.customerOrderNumber = _data["customerOrderNumber"] !== undefined ? _data["customerOrderNumber"] : null as any;
            this.forLibOrderStr = _data["forLibOrderStr"] !== undefined ? _data["forLibOrderStr"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomer = _data["finalCustomer"] !== undefined ? _data["finalCustomer"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.projectNo = _data["projectNo"] !== undefined ? _data["projectNo"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.modelSelectionId = _data["modelSelectionId"] !== undefined ? _data["modelSelectionId"] : null as any;
            this.modelSelectionName = _data["modelSelectionName"] !== undefined ? _data["modelSelectionName"] : null as any;
            this.orderSource = _data["orderSource"] !== undefined ? _data["orderSource"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.creatorUserName = _data["creatorUserName"] !== undefined ? _data["creatorUserName"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.approvalId = _data["approvalId"] !== undefined ? _data["approvalId"] : null as any;
            this.auditStatus = _data["auditStatus"] !== undefined ? _data["auditStatus"] : null as any;
            (this as any).auditStatusStr = _data["auditStatusStr"] !== undefined ? _data["auditStatusStr"] : null as any;
            this.auditCreatorUserId = _data["auditCreatorUserId"] !== undefined ? _data["auditCreatorUserId"] : null as any;
            this.auditCreatorUserName = _data["auditCreatorUserName"] !== undefined ? _data["auditCreatorUserName"] : null as any;
            this.auditCreationTime = _data["auditCreationTime"] ? moment(_data["auditCreationTime"].toString()) : null as any;
            this.remarks = _data["remarks"] !== undefined ? _data["remarks"] : null as any;
            this.omsOrderNumber = _data["omsOrderNumber"] !== undefined ? _data["omsOrderNumber"] : null as any;
            this.orderGrade = _data["orderGrade"] !== undefined ? _data["orderGrade"] : null as any;
            this.backDuration = _data["backDuration"] !== undefined ? _data["backDuration"] : null as any;
            this.submitTime = _data["submitTime"] ? moment(_data["submitTime"].toString()) : null as any;
            this.locationCountry = _data["locationCountry"] !== undefined ? _data["locationCountry"] : null as any;
            this.locationCountryCN = _data["locationCountryCN"] !== undefined ? _data["locationCountryCN"] : null as any;
            this.openItem = _data["openItem"] !== undefined ? _data["openItem"] : null as any;
        }
    }

    static fromJS(data: any): GetOrderDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["orderTime"] = this.orderTime ? this.orderTime.toISOString() : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["productCount"] = this.productCount !== undefined ? this.productCount : null as any;
        data["totalAmount"] = this.totalAmount !== undefined ? this.totalAmount : null as any;
        data["endCustomerCode"] = this.endCustomerCode !== undefined ? this.endCustomerCode : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["salesAreaName"] = this.salesAreaName !== undefined ? this.salesAreaName : null as any;
        data["industryName"] = this.industryName !== undefined ? this.industryName : null as any;
        data["applicationName"] = this.applicationName !== undefined ? this.applicationName : null as any;
        data["shippingAddress"] = this.shippingAddress !== undefined ? this.shippingAddress : null as any;
        data["specialOfferApplicationNumber"] = this.specialOfferApplicationNumber !== undefined ? this.specialOfferApplicationNumber : null as any;
        data["isManual"] = this.isManual !== undefined ? this.isManual : null as any;
        data["customerExpectedDeliveryDate"] = this.customerExpectedDeliveryDate ? this.customerExpectedDeliveryDate.toISOString() : null as any;
        data["responsibleSalesName"] = this.responsibleSalesName !== undefined ? this.responsibleSalesName : null as any;
        data["channelName"] = this.channelName !== undefined ? this.channelName : null as any;
        data["customerOrderNumber"] = this.customerOrderNumber !== undefined ? this.customerOrderNumber : null as any;
        data["forLibOrderStr"] = this.forLibOrderStr !== undefined ? this.forLibOrderStr : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomer"] = this.finalCustomer !== undefined ? this.finalCustomer : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["projectNo"] = this.projectNo !== undefined ? this.projectNo : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["modelSelectionId"] = this.modelSelectionId !== undefined ? this.modelSelectionId : null as any;
        data["modelSelectionName"] = this.modelSelectionName !== undefined ? this.modelSelectionName : null as any;
        data["orderSource"] = this.orderSource !== undefined ? this.orderSource : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["creatorUserName"] = this.creatorUserName !== undefined ? this.creatorUserName : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["approvalId"] = this.approvalId !== undefined ? this.approvalId : null as any;
        data["auditStatus"] = this.auditStatus !== undefined ? this.auditStatus : null as any;
        data["auditStatusStr"] = this.auditStatusStr !== undefined ? this.auditStatusStr : null as any;
        data["auditCreatorUserId"] = this.auditCreatorUserId !== undefined ? this.auditCreatorUserId : null as any;
        data["auditCreatorUserName"] = this.auditCreatorUserName !== undefined ? this.auditCreatorUserName : null as any;
        data["auditCreationTime"] = this.auditCreationTime ? this.auditCreationTime.toISOString() : null as any;
        data["remarks"] = this.remarks !== undefined ? this.remarks : null as any;
        data["omsOrderNumber"] = this.omsOrderNumber !== undefined ? this.omsOrderNumber : null as any;
        data["orderGrade"] = this.orderGrade !== undefined ? this.orderGrade : null as any;
        data["backDuration"] = this.backDuration !== undefined ? this.backDuration : null as any;
        data["submitTime"] = this.submitTime ? this.submitTime.toISOString() : null as any;
        data["locationCountry"] = this.locationCountry !== undefined ? this.locationCountry : null as any;
        data["locationCountryCN"] = this.locationCountryCN !== undefined ? this.locationCountryCN : null as any;
        data["openItem"] = this.openItem !== undefined ? this.openItem : null as any;
        return data;
    }
}

/** Order Dashbord 结果对象 统计“待审核”，“已审核”，“需修改”订单的数据接口 */
export class GetOrderDashbordPageDto {
    /** 总数 */
    totalCount!: number;
    /** 输出数据 */
    details!: GetOrderDashboardDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(GetOrderDashboardDto.fromJS(item));
            }
            else {
                this.details = null as any;
            }
        }
    }

    static fromJS(data: any): GetOrderDashbordPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderDashbordPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** Order Dashbord 统计结果 */
export class GetOrderDashbordStatisticsDto {
    /** 合同数量 */
    poCount!: number;
    /** 订单总金额 */
    totalAmount!: number;
    /** 1天内订单、合同数量 */
    poCount1!: number;
    /** 1天内 订单总金额 */
    totalAmount1!: number;
    /** 2天内订单、合同数量 */
    poCount2!: number;
    /** 2天内订单 订单总金额 */
    totalAmount2!: number;
    /** 3天及以上订单； 数量 */
    poCount3!: number;
    /** 3天及以上 订单总金额 */
    totalAmount3!: number;

    init(_data?: any) {
        if (_data) {
            this.poCount = _data["poCount"] !== undefined ? _data["poCount"] : null as any;
            this.totalAmount = _data["totalAmount"] !== undefined ? _data["totalAmount"] : null as any;
            this.poCount1 = _data["poCount1"] !== undefined ? _data["poCount1"] : null as any;
            this.totalAmount1 = _data["totalAmount1"] !== undefined ? _data["totalAmount1"] : null as any;
            this.poCount2 = _data["poCount2"] !== undefined ? _data["poCount2"] : null as any;
            this.totalAmount2 = _data["totalAmount2"] !== undefined ? _data["totalAmount2"] : null as any;
            this.poCount3 = _data["poCount3"] !== undefined ? _data["poCount3"] : null as any;
            this.totalAmount3 = _data["totalAmount3"] !== undefined ? _data["totalAmount3"] : null as any;
        }
    }

    static fromJS(data: any): GetOrderDashbordStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderDashbordStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poCount"] = this.poCount !== undefined ? this.poCount : null as any;
        data["totalAmount"] = this.totalAmount !== undefined ? this.totalAmount : null as any;
        data["poCount1"] = this.poCount1 !== undefined ? this.poCount1 : null as any;
        data["totalAmount1"] = this.totalAmount1 !== undefined ? this.totalAmount1 : null as any;
        data["poCount2"] = this.poCount2 !== undefined ? this.poCount2 : null as any;
        data["totalAmount2"] = this.totalAmount2 !== undefined ? this.totalAmount2 : null as any;
        data["poCount3"] = this.poCount3 !== undefined ? this.poCount3 : null as any;
        data["totalAmount3"] = this.totalAmount3 !== undefined ? this.totalAmount3 : null as any;
        return data;
    }
}

export class GetOrderFormAllDto {
    /** 主键 */
    id!: string;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** 选型Id */
    modelSelectionId!: string | null;
    /** 选型名称 */
    modelSelectionName!: string | null;
    /** 特价申请号 */
    specialOfferApplicationNumber!: string | null;
    /** 总价 */
    totalPrice!: number | null;
    /** 客户订单号 */
    customerOrderNumber!: string | null;
    /** 最终客户编码 */
    endCustomerCode!: string | null;
    /** 最终客户名称 */
    endCustomerName!: string | null;
    /** 下单时间 */
    orderTime!: moment.Moment | null;
    /** 订单完成时间 */
    orderCompleteTime!: moment.Moment | null;
    /** 预计交货日期/天 */
    expectedDeliveryDate!: string | null;
    /** 客户期望交货日期/天 */
    customerExpectedDeliveryDate!: string | null;
    /** PO号 */
    poNumber!: string | null;
    orderStatus!: OrderStatus;
    orderType!: OrderType;
    /** 创建人 */
    creationId!: number | null;
    /** 创建名称 */
    creationName!: string | null;
    /** 创建时间 */
    creationTime!: moment.Moment;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.modelSelectionId = _data["modelSelectionId"] !== undefined ? _data["modelSelectionId"] : null as any;
            this.modelSelectionName = _data["modelSelectionName"] !== undefined ? _data["modelSelectionName"] : null as any;
            this.specialOfferApplicationNumber = _data["specialOfferApplicationNumber"] !== undefined ? _data["specialOfferApplicationNumber"] : null as any;
            this.totalPrice = _data["totalPrice"] !== undefined ? _data["totalPrice"] : null as any;
            this.customerOrderNumber = _data["customerOrderNumber"] !== undefined ? _data["customerOrderNumber"] : null as any;
            this.endCustomerCode = _data["endCustomerCode"] !== undefined ? _data["endCustomerCode"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.orderTime = _data["orderTime"] ? moment(_data["orderTime"].toString()) : null as any;
            this.orderCompleteTime = _data["orderCompleteTime"] ? moment(_data["orderCompleteTime"].toString()) : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.customerExpectedDeliveryDate = _data["customerExpectedDeliveryDate"] !== undefined ? _data["customerExpectedDeliveryDate"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.creationId = _data["creationId"] !== undefined ? _data["creationId"] : null as any;
            this.creationName = _data["creationName"] !== undefined ? _data["creationName"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): GetOrderFormAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderFormAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["modelSelectionId"] = this.modelSelectionId !== undefined ? this.modelSelectionId : null as any;
        data["modelSelectionName"] = this.modelSelectionName !== undefined ? this.modelSelectionName : null as any;
        data["specialOfferApplicationNumber"] = this.specialOfferApplicationNumber !== undefined ? this.specialOfferApplicationNumber : null as any;
        data["totalPrice"] = this.totalPrice !== undefined ? this.totalPrice : null as any;
        data["customerOrderNumber"] = this.customerOrderNumber !== undefined ? this.customerOrderNumber : null as any;
        data["endCustomerCode"] = this.endCustomerCode !== undefined ? this.endCustomerCode : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["orderTime"] = this.orderTime ? this.orderTime.toISOString() : null as any;
        data["orderCompleteTime"] = this.orderCompleteTime ? this.orderCompleteTime.toISOString() : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["customerExpectedDeliveryDate"] = this.customerExpectedDeliveryDate !== undefined ? this.customerExpectedDeliveryDate : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["creationId"] = this.creationId !== undefined ? this.creationId : null as any;
        data["creationName"] = this.creationName !== undefined ? this.creationName : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        return data;
    }
}

export class GetOrderFormAllTotalCountDto {
    /** 总数 */
    totalCount!: number;
    getOrderFormAllDtos!: GetOrderFormAllDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["getOrderFormAllDtos"])) {
                this.getOrderFormAllDtos = [] as any;
                for (let item of _data["getOrderFormAllDtos"])
                    this.getOrderFormAllDtos!.push(GetOrderFormAllDto.fromJS(item));
            }
            else {
                this.getOrderFormAllDtos = null as any;
            }
        }
    }

    static fromJS(data: any): GetOrderFormAllTotalCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderFormAllTotalCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.getOrderFormAllDtos)) {
            data["getOrderFormAllDtos"] = [];
            for (let item of this.getOrderFormAllDtos)
                data["getOrderFormAllDtos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetOrderFormApprovalAllDto {
    /** 订单Id */
    orderFormId!: string;
    /** 审批Id */
    approvalId!: string;
    /** 总价 */
    totalPrice!: number | null;
    /** 客户订单号 */
    customerOrderNumber!: string | null;
    /** 下单时间 */
    orderTime!: moment.Moment | null;
    /** 订单完成时间 */
    orderCompleteTime!: moment.Moment | null;
    /** 预计交货日期/天 */
    expectedDeliveryDate!: string | null;
    /** 客户期望交货日期/天 */
    customerExpectedDeliveryDate!: string | null;
    /** PO号 */
    poNumber!: string | null;
    auditStatus!: AuditStatus;
    orderStatus!: OrderStatus;
    orderType!: OrderType;
    /** SOI/MOI */
    orderSource!: string | null;
    /** 销售区域 */
    salesAreaName!: string | null;
    /** 创建人 */
    creationId!: number | null;
    /** 创建名称 */
    creationName!: string | null;
    /** 审批通过时间 */
    approvedDateTime!: moment.Moment | null;
    /** 最终客户编码 */
    endCustomerCode!: string | null;
    /** 最终客户名称 */
    endCustomerName!: string | null;
    approvalStatus!: ApprovalStatusEnum;
    automateStatus!: AutomateStatusEnum;
    /** OMS订单号 */
    omsOrderNumber!: string | null;
    /** 自动审单状态 */
    autoApproveTaskStatus!: string | null;
    /** 银行水单 */
    attachmentBankReceipt!: string | null;

    init(_data?: any) {
        if (_data) {
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.approvalId = _data["approvalId"] !== undefined ? _data["approvalId"] : null as any;
            this.totalPrice = _data["totalPrice"] !== undefined ? _data["totalPrice"] : null as any;
            this.customerOrderNumber = _data["customerOrderNumber"] !== undefined ? _data["customerOrderNumber"] : null as any;
            this.orderTime = _data["orderTime"] ? moment(_data["orderTime"].toString()) : null as any;
            this.orderCompleteTime = _data["orderCompleteTime"] ? moment(_data["orderCompleteTime"].toString()) : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.customerExpectedDeliveryDate = _data["customerExpectedDeliveryDate"] !== undefined ? _data["customerExpectedDeliveryDate"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.auditStatus = _data["auditStatus"] !== undefined ? _data["auditStatus"] : null as any;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.orderSource = _data["orderSource"] !== undefined ? _data["orderSource"] : null as any;
            this.salesAreaName = _data["salesAreaName"] !== undefined ? _data["salesAreaName"] : null as any;
            this.creationId = _data["creationId"] !== undefined ? _data["creationId"] : null as any;
            this.creationName = _data["creationName"] !== undefined ? _data["creationName"] : null as any;
            this.approvedDateTime = _data["approvedDateTime"] ? moment(_data["approvedDateTime"].toString()) : null as any;
            this.endCustomerCode = _data["endCustomerCode"] !== undefined ? _data["endCustomerCode"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
            this.automateStatus = _data["automateStatus"] !== undefined ? _data["automateStatus"] : null as any;
            this.omsOrderNumber = _data["omsOrderNumber"] !== undefined ? _data["omsOrderNumber"] : null as any;
            this.autoApproveTaskStatus = _data["autoApproveTaskStatus"] !== undefined ? _data["autoApproveTaskStatus"] : null as any;
            this.attachmentBankReceipt = _data["attachmentBankReceipt"] !== undefined ? _data["attachmentBankReceipt"] : null as any;
        }
    }

    static fromJS(data: any): GetOrderFormApprovalAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderFormApprovalAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["approvalId"] = this.approvalId !== undefined ? this.approvalId : null as any;
        data["totalPrice"] = this.totalPrice !== undefined ? this.totalPrice : null as any;
        data["customerOrderNumber"] = this.customerOrderNumber !== undefined ? this.customerOrderNumber : null as any;
        data["orderTime"] = this.orderTime ? this.orderTime.toISOString() : null as any;
        data["orderCompleteTime"] = this.orderCompleteTime ? this.orderCompleteTime.toISOString() : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["customerExpectedDeliveryDate"] = this.customerExpectedDeliveryDate !== undefined ? this.customerExpectedDeliveryDate : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["auditStatus"] = this.auditStatus !== undefined ? this.auditStatus : null as any;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["orderSource"] = this.orderSource !== undefined ? this.orderSource : null as any;
        data["salesAreaName"] = this.salesAreaName !== undefined ? this.salesAreaName : null as any;
        data["creationId"] = this.creationId !== undefined ? this.creationId : null as any;
        data["creationName"] = this.creationName !== undefined ? this.creationName : null as any;
        data["approvedDateTime"] = this.approvedDateTime ? this.approvedDateTime.toISOString() : null as any;
        data["endCustomerCode"] = this.endCustomerCode !== undefined ? this.endCustomerCode : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        data["automateStatus"] = this.automateStatus !== undefined ? this.automateStatus : null as any;
        data["omsOrderNumber"] = this.omsOrderNumber !== undefined ? this.omsOrderNumber : null as any;
        data["autoApproveTaskStatus"] = this.autoApproveTaskStatus !== undefined ? this.autoApproveTaskStatus : null as any;
        data["attachmentBankReceipt"] = this.attachmentBankReceipt !== undefined ? this.attachmentBankReceipt : null as any;
        return data;
    }
}

export class GetOrderFormApprovalDto {
    /** 审批id */
    approvalId!: string;
    /** 审批备注 */
    approvalRemarks!: string | null;
    auditStatus!: AuditStatus;
    /** 创建人 */
    creatorUserId!: number | null;
    /** 创建人名称 */
    creatorUserName!: string | null;
    /** 创建时间 */
    creationTime!: moment.Moment;
    /** 修改人 */
    lastModifierUserId!: number | null;
    /** 修改人名称 */
    lastModifierUserName!: string | null;
    /** 修改时间 */
    lastModificationTime!: moment.Moment | null;
    /** 附件名称 */
    fileName!: string | null;
    /** OMS订单号 */
    omsOrderNumber!: string | null;
    /** 订单表Id */
    orderFormId!: string;
    /** 审批节点 */
    node!: string | null;
    approvalStatus!: ApprovalStatusEnum;

    init(_data?: any) {
        if (_data) {
            this.approvalId = _data["approvalId"] !== undefined ? _data["approvalId"] : null as any;
            this.approvalRemarks = _data["approvalRemarks"] !== undefined ? _data["approvalRemarks"] : null as any;
            this.auditStatus = _data["auditStatus"] !== undefined ? _data["auditStatus"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.creatorUserName = _data["creatorUserName"] !== undefined ? _data["creatorUserName"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.lastModifierUserName = _data["lastModifierUserName"] !== undefined ? _data["lastModifierUserName"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.omsOrderNumber = _data["omsOrderNumber"] !== undefined ? _data["omsOrderNumber"] : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.node = _data["node"] !== undefined ? _data["node"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
        }
    }

    static fromJS(data: any): GetOrderFormApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderFormApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalId"] = this.approvalId !== undefined ? this.approvalId : null as any;
        data["approvalRemarks"] = this.approvalRemarks !== undefined ? this.approvalRemarks : null as any;
        data["auditStatus"] = this.auditStatus !== undefined ? this.auditStatus : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["creatorUserName"] = this.creatorUserName !== undefined ? this.creatorUserName : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["lastModifierUserName"] = this.lastModifierUserName !== undefined ? this.lastModifierUserName : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["omsOrderNumber"] = this.omsOrderNumber !== undefined ? this.omsOrderNumber : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["node"] = this.node !== undefined ? this.node : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        return data;
    }
}

export class GetOrderFormApprovalTotalCountDto {
    /** 总数 */
    totalCount!: number;
    items!: GetOrderFormApprovalAllDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetOrderFormApprovalAllDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): GetOrderFormApprovalTotalCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderFormApprovalTotalCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetOrderFormDto {
    /** 订单Id */
    orderFormId!: string | null;
    /** 选型Id */
    modelSelectionId!: string | null;
    /** 选型名称 */
    modelSelectionName!: string | null;
    /** 特价申请号 */
    specialOfferApplicationNumber!: string | null;
    /** 特价申请号来源 */
    isManual!: boolean;
    /** 总台数 */
    totalNumber!: string | null;
    /** 总价 */
    totalPrice!: string | null;
    /** 客户订单号 */
    customerOrderNumber!: string | null;
    /** 自动交货时间 */
    autoDeliveryTime!: moment.Moment | null;
    /** 订单保存时间 */
    saveTime!: moment.Moment | null;
    /** 下单时间 */
    orderTime!: moment.Moment | null;
    /** 订单完成时间 */
    orderCompleteTime!: moment.Moment | null;
    /** 订单取消时间 */
    orderCancelTime!: moment.Moment | null;
    /** 预计交货日期 */
    expectedDeliveryDate!: string | null;
    /** 预计交货日期 */
    expectedDeliveryDateDisplay!: moment.Moment | null;
    /** PO号 */
    poNumber!: string | null;
    orderStatus!: OrderStatus;
    orderType!: OrderType;
    /** 订单来源 */
    orderSource!: string | null;
    /** 订单来源类型（SOI/MOI/MotorCert） */
    sourceType!: string | null;
    /** CP编码 */
    cpCode!: string | null;
    /** CP名称 */
    cpCoName!: string | null;
    /** 最终客户编码 */
    endCustomerCode!: string | null;
    /** 最终客户名称 */
    endCustomerName!: string | null;
    /** 发货地址编码 */
    shippingAddressCode!: string | null;
    /** 发货地址 */
    shippingAddress!: string | null;
    /** 项目名称 */
    projectName!: string | null;
    /** 项目编号 */
    projectNo!: string | null;
    /** 责任销售编码 */
    responsibleSalesCode!: string | null;
    /** 责任销售名称 */
    responsibleSalesName!: string | null;
    /** 销售区域 */
    salesArea!: string | null;
    /** 销售区域名称 */
    salesAreaName!: string | null;
    /** 行业 */
    industryCode!: string | null;
    /** 行业名称 */
    industryName!: string | null;
    /** 二级客户行业编号 */
    finalCustomerIndustryCode!: string | null;
    /** 二级客户行业名称 */
    finalCustomerIndustryName!: string | null;
    /** 应用 */
    applicationCode!: string | null;
    /** 应用名称 */
    applicationName!: string | null;
    /** 数据交换平台订单类型id */
    dataPlatFormOrderTypeId!: string | null;
    /** 数据交换平台订单类型名称 */
    dataPlatFormOrderTypeName!: string | null;
    /** 附件合同名称 */
    attachmentName!: string | null;
    /** GSS报价号 */
    gssQuotationNo!: string | null;
    /** GSS技术确认号（SFDC） */
    gssTechnicalConfirmationNumber!: string | null;
    /** 技术规范（技术规范号） */
    technicalSpecifications!: string | null;
    /** 创建人ID */
    creatorUserId!: number | null;
    /** 创建人名称 */
    creatorUserName!: string | null;
    /** 交货条款
此字段为20210324添加 */
    deliveryTerms!: string | null;
    /** 产品裸机 */
    productBasicMotors!: GetProductBasicMotorDto[] | null;
    /** 审批记录 */
    orderFormApprovals!: GetOrderFormApprovalDto[] | null;
    /** 是否为备库订单 */
    forLibOrderFlg!: boolean | null;
    /** 是否禁止修改FinalCustomer */
    forbidModityFinalCustomer!: boolean | null;
    /** 最终客户名称 */
    finalCustomer!: string | null;
    /** 最终客户代号 */
    finalCustomerCode!: string | null;
    /** 当前订单税率 */
    curTaxRate!: number | null;
    /** 不含税总金额 sum（ProductBasicMotors.PriceWithoutTax） */
    totalPriceWithoutTax!: number | null;
    /** 总税金 sum（ProductBasicMotors.UnitTaxPrice） */
    totalTaxPrice!: number | null;
    /** 指定审批人 */
    specifyApproval!: boolean;
    /** 指定审批人是否已审批 */
    specifyApprovalChecked!: boolean;
    countryRiskLevel!: CountryRiskEnum;
    /** 最终用户所在地国家,关联风险国家表(CountryRisk) */
    locationCountry!: string | null;
    /** 最终用户所在地国家名称 */
    locationCountryName!: string | null;
    /** 备案号(仅风险国家填写) */
    recordNumber!: string | null;
    approvalStatus!: ApprovalStatusEnum;
    /** 产品售价保留小数 */
    salesPriceDecimal!: boolean;
    productTotal!: number;
    vcCheck!: string[] | null;
    /** 币种关联编号 */
    currencyId!: string | null;
    /** 外销手工单 */
    exportManualOrder!: boolean;
    /** 开口项 */
    openItem!: string | null;
    /** 开口项其他时输入备注 */
    openItemRemark!: string | null;
    /** 一键清零 */
    oneClickClean!: boolean;
    /** 预占订单地址 */
    mtsOrderAddress!: string | null;
    /** 水单附件 */
    attachmentBankReceipt!: string | null;

    init(_data?: any) {
        if (_data) {
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.modelSelectionId = _data["modelSelectionId"] !== undefined ? _data["modelSelectionId"] : null as any;
            this.modelSelectionName = _data["modelSelectionName"] !== undefined ? _data["modelSelectionName"] : null as any;
            this.specialOfferApplicationNumber = _data["specialOfferApplicationNumber"] !== undefined ? _data["specialOfferApplicationNumber"] : null as any;
            this.isManual = _data["isManual"] !== undefined ? _data["isManual"] : null as any;
            this.totalNumber = _data["totalNumber"] !== undefined ? _data["totalNumber"] : null as any;
            this.totalPrice = _data["totalPrice"] !== undefined ? _data["totalPrice"] : null as any;
            this.customerOrderNumber = _data["customerOrderNumber"] !== undefined ? _data["customerOrderNumber"] : null as any;
            this.autoDeliveryTime = _data["autoDeliveryTime"] ? moment(_data["autoDeliveryTime"].toString()) : null as any;
            this.saveTime = _data["saveTime"] ? moment(_data["saveTime"].toString()) : null as any;
            this.orderTime = _data["orderTime"] ? moment(_data["orderTime"].toString()) : null as any;
            this.orderCompleteTime = _data["orderCompleteTime"] ? moment(_data["orderCompleteTime"].toString()) : null as any;
            this.orderCancelTime = _data["orderCancelTime"] ? moment(_data["orderCancelTime"].toString()) : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.expectedDeliveryDateDisplay = _data["expectedDeliveryDateDisplay"] ? moment(_data["expectedDeliveryDateDisplay"].toString()) : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.orderSource = _data["orderSource"] !== undefined ? _data["orderSource"] : null as any;
            this.sourceType = _data["sourceType"] !== undefined ? _data["sourceType"] : null as any;
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.cpCoName = _data["cpCoName"] !== undefined ? _data["cpCoName"] : null as any;
            this.endCustomerCode = _data["endCustomerCode"] !== undefined ? _data["endCustomerCode"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.shippingAddressCode = _data["shippingAddressCode"] !== undefined ? _data["shippingAddressCode"] : null as any;
            this.shippingAddress = _data["shippingAddress"] !== undefined ? _data["shippingAddress"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.projectNo = _data["projectNo"] !== undefined ? _data["projectNo"] : null as any;
            this.responsibleSalesCode = _data["responsibleSalesCode"] !== undefined ? _data["responsibleSalesCode"] : null as any;
            this.responsibleSalesName = _data["responsibleSalesName"] !== undefined ? _data["responsibleSalesName"] : null as any;
            this.salesArea = _data["salesArea"] !== undefined ? _data["salesArea"] : null as any;
            this.salesAreaName = _data["salesAreaName"] !== undefined ? _data["salesAreaName"] : null as any;
            this.industryCode = _data["industryCode"] !== undefined ? _data["industryCode"] : null as any;
            this.industryName = _data["industryName"] !== undefined ? _data["industryName"] : null as any;
            this.finalCustomerIndustryCode = _data["finalCustomerIndustryCode"] !== undefined ? _data["finalCustomerIndustryCode"] : null as any;
            this.finalCustomerIndustryName = _data["finalCustomerIndustryName"] !== undefined ? _data["finalCustomerIndustryName"] : null as any;
            this.applicationCode = _data["applicationCode"] !== undefined ? _data["applicationCode"] : null as any;
            this.applicationName = _data["applicationName"] !== undefined ? _data["applicationName"] : null as any;
            this.dataPlatFormOrderTypeId = _data["dataPlatFormOrderTypeId"] !== undefined ? _data["dataPlatFormOrderTypeId"] : null as any;
            this.dataPlatFormOrderTypeName = _data["dataPlatFormOrderTypeName"] !== undefined ? _data["dataPlatFormOrderTypeName"] : null as any;
            this.attachmentName = _data["attachmentName"] !== undefined ? _data["attachmentName"] : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.creatorUserName = _data["creatorUserName"] !== undefined ? _data["creatorUserName"] : null as any;
            this.deliveryTerms = _data["deliveryTerms"] !== undefined ? _data["deliveryTerms"] : null as any;
            if (Array.isArray(_data["productBasicMotors"])) {
                this.productBasicMotors = [] as any;
                for (let item of _data["productBasicMotors"])
                    this.productBasicMotors!.push(GetProductBasicMotorDto.fromJS(item));
            }
            else {
                this.productBasicMotors = null as any;
            }
            if (Array.isArray(_data["orderFormApprovals"])) {
                this.orderFormApprovals = [] as any;
                for (let item of _data["orderFormApprovals"])
                    this.orderFormApprovals!.push(GetOrderFormApprovalDto.fromJS(item));
            }
            else {
                this.orderFormApprovals = null as any;
            }
            this.forLibOrderFlg = _data["forLibOrderFlg"] !== undefined ? _data["forLibOrderFlg"] : null as any;
            this.forbidModityFinalCustomer = _data["forbidModityFinalCustomer"] !== undefined ? _data["forbidModityFinalCustomer"] : null as any;
            this.finalCustomer = _data["finalCustomer"] !== undefined ? _data["finalCustomer"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.curTaxRate = _data["curTaxRate"] !== undefined ? _data["curTaxRate"] : null as any;
            this.totalPriceWithoutTax = _data["totalPriceWithoutTax"] !== undefined ? _data["totalPriceWithoutTax"] : null as any;
            this.totalTaxPrice = _data["totalTaxPrice"] !== undefined ? _data["totalTaxPrice"] : null as any;
            this.specifyApproval = _data["specifyApproval"] !== undefined ? _data["specifyApproval"] : null as any;
            this.specifyApprovalChecked = _data["specifyApprovalChecked"] !== undefined ? _data["specifyApprovalChecked"] : null as any;
            this.countryRiskLevel = _data["countryRiskLevel"] !== undefined ? _data["countryRiskLevel"] : null as any;
            this.locationCountry = _data["locationCountry"] !== undefined ? _data["locationCountry"] : null as any;
            this.locationCountryName = _data["locationCountryName"] !== undefined ? _data["locationCountryName"] : null as any;
            this.recordNumber = _data["recordNumber"] !== undefined ? _data["recordNumber"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
            this.salesPriceDecimal = _data["salesPriceDecimal"] !== undefined ? _data["salesPriceDecimal"] : null as any;
            this.productTotal = _data["productTotal"] !== undefined ? _data["productTotal"] : null as any;
            if (Array.isArray(_data["vcCheck"])) {
                this.vcCheck = [] as any;
                for (let item of _data["vcCheck"])
                    this.vcCheck!.push(item);
            }
            else {
                this.vcCheck = null as any;
            }
            this.currencyId = _data["currencyId"] !== undefined ? _data["currencyId"] : null as any;
            this.exportManualOrder = _data["exportManualOrder"] !== undefined ? _data["exportManualOrder"] : null as any;
            this.openItem = _data["openItem"] !== undefined ? _data["openItem"] : null as any;
            this.openItemRemark = _data["openItemRemark"] !== undefined ? _data["openItemRemark"] : null as any;
            this.oneClickClean = _data["oneClickClean"] !== undefined ? _data["oneClickClean"] : null as any;
            this.mtsOrderAddress = _data["mtsOrderAddress"] !== undefined ? _data["mtsOrderAddress"] : null as any;
            this.attachmentBankReceipt = _data["attachmentBankReceipt"] !== undefined ? _data["attachmentBankReceipt"] : null as any;
        }
    }

    static fromJS(data: any): GetOrderFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["modelSelectionId"] = this.modelSelectionId !== undefined ? this.modelSelectionId : null as any;
        data["modelSelectionName"] = this.modelSelectionName !== undefined ? this.modelSelectionName : null as any;
        data["specialOfferApplicationNumber"] = this.specialOfferApplicationNumber !== undefined ? this.specialOfferApplicationNumber : null as any;
        data["isManual"] = this.isManual !== undefined ? this.isManual : null as any;
        data["totalNumber"] = this.totalNumber !== undefined ? this.totalNumber : null as any;
        data["totalPrice"] = this.totalPrice !== undefined ? this.totalPrice : null as any;
        data["customerOrderNumber"] = this.customerOrderNumber !== undefined ? this.customerOrderNumber : null as any;
        data["autoDeliveryTime"] = this.autoDeliveryTime ? this.autoDeliveryTime.toISOString() : null as any;
        data["saveTime"] = this.saveTime ? this.saveTime.toISOString() : null as any;
        data["orderTime"] = this.orderTime ? this.orderTime.toISOString() : null as any;
        data["orderCompleteTime"] = this.orderCompleteTime ? this.orderCompleteTime.toISOString() : null as any;
        data["orderCancelTime"] = this.orderCancelTime ? this.orderCancelTime.toISOString() : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["expectedDeliveryDateDisplay"] = this.expectedDeliveryDateDisplay ? this.expectedDeliveryDateDisplay.toISOString() : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["orderSource"] = this.orderSource !== undefined ? this.orderSource : null as any;
        data["sourceType"] = this.sourceType !== undefined ? this.sourceType : null as any;
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["cpCoName"] = this.cpCoName !== undefined ? this.cpCoName : null as any;
        data["endCustomerCode"] = this.endCustomerCode !== undefined ? this.endCustomerCode : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["shippingAddressCode"] = this.shippingAddressCode !== undefined ? this.shippingAddressCode : null as any;
        data["shippingAddress"] = this.shippingAddress !== undefined ? this.shippingAddress : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["projectNo"] = this.projectNo !== undefined ? this.projectNo : null as any;
        data["responsibleSalesCode"] = this.responsibleSalesCode !== undefined ? this.responsibleSalesCode : null as any;
        data["responsibleSalesName"] = this.responsibleSalesName !== undefined ? this.responsibleSalesName : null as any;
        data["salesArea"] = this.salesArea !== undefined ? this.salesArea : null as any;
        data["salesAreaName"] = this.salesAreaName !== undefined ? this.salesAreaName : null as any;
        data["industryCode"] = this.industryCode !== undefined ? this.industryCode : null as any;
        data["industryName"] = this.industryName !== undefined ? this.industryName : null as any;
        data["finalCustomerIndustryCode"] = this.finalCustomerIndustryCode !== undefined ? this.finalCustomerIndustryCode : null as any;
        data["finalCustomerIndustryName"] = this.finalCustomerIndustryName !== undefined ? this.finalCustomerIndustryName : null as any;
        data["applicationCode"] = this.applicationCode !== undefined ? this.applicationCode : null as any;
        data["applicationName"] = this.applicationName !== undefined ? this.applicationName : null as any;
        data["dataPlatFormOrderTypeId"] = this.dataPlatFormOrderTypeId !== undefined ? this.dataPlatFormOrderTypeId : null as any;
        data["dataPlatFormOrderTypeName"] = this.dataPlatFormOrderTypeName !== undefined ? this.dataPlatFormOrderTypeName : null as any;
        data["attachmentName"] = this.attachmentName !== undefined ? this.attachmentName : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["creatorUserName"] = this.creatorUserName !== undefined ? this.creatorUserName : null as any;
        data["deliveryTerms"] = this.deliveryTerms !== undefined ? this.deliveryTerms : null as any;
        if (Array.isArray(this.productBasicMotors)) {
            data["productBasicMotors"] = [];
            for (let item of this.productBasicMotors)
                data["productBasicMotors"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.orderFormApprovals)) {
            data["orderFormApprovals"] = [];
            for (let item of this.orderFormApprovals)
                data["orderFormApprovals"].push(item ? item.toJSON() : null as any);
        }
        data["forLibOrderFlg"] = this.forLibOrderFlg !== undefined ? this.forLibOrderFlg : null as any;
        data["forbidModityFinalCustomer"] = this.forbidModityFinalCustomer !== undefined ? this.forbidModityFinalCustomer : null as any;
        data["finalCustomer"] = this.finalCustomer !== undefined ? this.finalCustomer : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["curTaxRate"] = this.curTaxRate !== undefined ? this.curTaxRate : null as any;
        data["totalPriceWithoutTax"] = this.totalPriceWithoutTax !== undefined ? this.totalPriceWithoutTax : null as any;
        data["totalTaxPrice"] = this.totalTaxPrice !== undefined ? this.totalTaxPrice : null as any;
        data["specifyApproval"] = this.specifyApproval !== undefined ? this.specifyApproval : null as any;
        data["specifyApprovalChecked"] = this.specifyApprovalChecked !== undefined ? this.specifyApprovalChecked : null as any;
        data["countryRiskLevel"] = this.countryRiskLevel !== undefined ? this.countryRiskLevel : null as any;
        data["locationCountry"] = this.locationCountry !== undefined ? this.locationCountry : null as any;
        data["locationCountryName"] = this.locationCountryName !== undefined ? this.locationCountryName : null as any;
        data["recordNumber"] = this.recordNumber !== undefined ? this.recordNumber : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        data["salesPriceDecimal"] = this.salesPriceDecimal !== undefined ? this.salesPriceDecimal : null as any;
        data["productTotal"] = this.productTotal !== undefined ? this.productTotal : null as any;
        if (Array.isArray(this.vcCheck)) {
            data["vcCheck"] = [];
            for (let item of this.vcCheck)
                data["vcCheck"].push(item);
        }
        data["currencyId"] = this.currencyId !== undefined ? this.currencyId : null as any;
        data["exportManualOrder"] = this.exportManualOrder !== undefined ? this.exportManualOrder : null as any;
        data["openItem"] = this.openItem !== undefined ? this.openItem : null as any;
        data["openItemRemark"] = this.openItemRemark !== undefined ? this.openItemRemark : null as any;
        data["oneClickClean"] = this.oneClickClean !== undefined ? this.oneClickClean : null as any;
        data["mtsOrderAddress"] = this.mtsOrderAddress !== undefined ? this.mtsOrderAddress : null as any;
        data["attachmentBankReceipt"] = this.attachmentBankReceipt !== undefined ? this.attachmentBankReceipt : null as any;
        return data;
    }
}

export class GetProductBasicMotorDto {
    /** 序号 */
    serialNumber!: number;
    /** SC序号 */
    scSerialNumber!: number;
    /** 主机Id */
    productBasicMotorId!: string | null;
    /** 产品组合编码 */
    productMixCode!: string | null;
    /** 客户物料号 */
    customerMaterialNumber!: string | null;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** 订单形式 */
    orderType!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 主机类型 */
    basicMotorType!: number;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 产品组合的数量 */
    numberOfProduct!: number;
    /** 系数 */
    multiplier!: number;
    /** 系数过期时间 */
    multiplierExpiredDate!: moment.Moment | null;
    multipilerType!: number;
    /** 面价类型
1, 来自面价（OIS需要重新取）， 2， GCS报价， 3， 客户自己填 */
    unitPriceType!: string | null;
    /** 面价有效时间 */
    unitPriceExpiredTime!: moment.Moment | null;
    /** 面价 */
    unitPrice!: number;
    /** 总面价 */
    totalUnitPrice!: number;
    /** 售价 */
    salesPrice!: number;
    /** 售价（OEM产品初始售价） */
    oemSalesPrice!: number;
    /** 备注 */
    remark!: string | null;
    /** 备注二 */
    remarkTwo!: string | null;
    /** 预计交货日期/天 */
    expectedDeliveryDate!: string | null;
    /** 实际交货日期/天 */
    actualDeliveryDate!: string | null;
    /** 原始实际交货日期/天 */
    originalActualDeliveryDate!: string | null;
    /** 客户期望交货日期/天 */
    customerExpectedDeliveryDate!: moment.Moment | null;
    /** 客户期望交货日期 */
    readonly customerExpectedDeliveryDateString!: string | null;
    /** 客户原期望交货期 */
    customerActualDeliveryDate!: moment.Moment | null;
    /** 客户原期望交货期 */
    readonly customerActualDeliveryDateString!: string | null;
    /** 是否需要提醒 */
    isEarlyWarning!: boolean;
    /** 接收PrdTech的JSON */
    receivePrdTechJSON!: string | null;
    /** 接收PrdElecs的JSON */
    receivePrdElecsJSON!: string | null;
    /** 机座号 */
    frameSize!: number;
    /** 系列名称 */
    seriesName!: string | null;
    /** GSS报价号 */
    gssQuotationNo!: string | null;
    /** GSS技术确认号（SFDC） */
    gssTechnicalConfirmationNumber!: string | null;
    /** 技术规范（技术规范号） */
    technicalSpecifications!: string | null;
    checkResultOutput!: CheckResultOutputDto;
    productClassification!: string | null;
    /** 订单分类 */
    orderClassification!: string | null;
    productVCs!: GetProductVCDto[] | null;
    /** 境界产品内含VC */
    productJINVCs!: GetProductVCDto[] | null;
    /** 1 含税总金额 售价(SalesPrice)*NumberOfProduct
售价(salesPrice)=(面价+VC.unitPrice)*系数(multiplier) */
    priceWithTax!: number | null;
    /** 不含税总金额 PriceWithTax-UnitTaxPrice */
    priceWithoutTax!: number | null;
    /** 2 税金 PriceWithTax*OrderForm.TaxPrice
总价/1.13后四舍五入，保留2位小数，订单行先计算再合计进总价，界面显示只要在header里 */
    unitTaxPrice!: number | null;
    /** 可打折面价 */
    discountUnitPrice!: number | null;
    /** 按台收不打折 */
    noDiscountByPlatformUnitPrice!: number | null;
    /** 按单收不打折 */
    noDiscountByListUnitPrice!: number | null;
    /** 特殊返点标识 */
    specialRebateFlag!: string | null;
    /** 是否为PMS派生选型后新增的产品 */
    isNewPMSProduct!: boolean | null;
    /** 运营相关备注 */
    operationalRemarks!: string | null;
    orderForm!: GetOrderFormDto;
    /** PMS原始折扣 */
    pmsMultiplier!: number | null;
    /** 特价号 */
    specialOfferNumber!: string | null;
    /** 是否增减了VC或改动了VC的备注信息导致技术协议发生了变动 */
    agreementChanges!: boolean;
    /** 来源报价产品id */
    technologyQuotationProductId!: string | null;
    /** 来源协议产品id (协议是针对产品行的且对所有客户有效，因此在业务上不需要考虑客户变更的场景) */
    technicalSpecificationProductId!: string | null;
    jinCategoryCode!: string | null;
    jinVersion!: string | null;
    /** 境界基础电机系列 */
    jinBasedMotorSries!: string | null;
    /** 境界输出备注 */
    jinRemarkOutDto!: JinRemarkOutDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.scSerialNumber = _data["scSerialNumber"] !== undefined ? _data["scSerialNumber"] : null as any;
            this.productBasicMotorId = _data["productBasicMotorId"] !== undefined ? _data["productBasicMotorId"] : null as any;
            this.productMixCode = _data["productMixCode"] !== undefined ? _data["productMixCode"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorType = _data["basicMotorType"] !== undefined ? _data["basicMotorType"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.numberOfProduct = _data["numberOfProduct"] !== undefined ? _data["numberOfProduct"] : null as any;
            this.multiplier = _data["multiplier"] !== undefined ? _data["multiplier"] : null as any;
            this.multiplierExpiredDate = _data["multiplierExpiredDate"] ? moment(_data["multiplierExpiredDate"].toString()) : null as any;
            this.multipilerType = _data["multipilerType"] !== undefined ? _data["multipilerType"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.unitPriceExpiredTime = _data["unitPriceExpiredTime"] ? moment(_data["unitPriceExpiredTime"].toString()) : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.totalUnitPrice = _data["totalUnitPrice"] !== undefined ? _data["totalUnitPrice"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.oemSalesPrice = _data["oemSalesPrice"] !== undefined ? _data["oemSalesPrice"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.remarkTwo = _data["remarkTwo"] !== undefined ? _data["remarkTwo"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.actualDeliveryDate = _data["actualDeliveryDate"] !== undefined ? _data["actualDeliveryDate"] : null as any;
            this.originalActualDeliveryDate = _data["originalActualDeliveryDate"] !== undefined ? _data["originalActualDeliveryDate"] : null as any;
            this.customerExpectedDeliveryDate = _data["customerExpectedDeliveryDate"] ? moment(_data["customerExpectedDeliveryDate"].toString()) : null as any;
            (this as any).customerExpectedDeliveryDateString = _data["customerExpectedDeliveryDateString"] !== undefined ? _data["customerExpectedDeliveryDateString"] : null as any;
            this.customerActualDeliveryDate = _data["customerActualDeliveryDate"] ? moment(_data["customerActualDeliveryDate"].toString()) : null as any;
            (this as any).customerActualDeliveryDateString = _data["customerActualDeliveryDateString"] !== undefined ? _data["customerActualDeliveryDateString"] : null as any;
            this.isEarlyWarning = _data["isEarlyWarning"] !== undefined ? _data["isEarlyWarning"] : null as any;
            this.receivePrdTechJSON = _data["receivePrdTechJSON"] !== undefined ? _data["receivePrdTechJSON"] : null as any;
            this.receivePrdElecsJSON = _data["receivePrdElecsJSON"] !== undefined ? _data["receivePrdElecsJSON"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.checkResultOutput = _data["checkResultOutput"] ? CheckResultOutputDto.fromJS(_data["checkResultOutput"]) : null as any;
            this.productClassification = _data["productClassification"] !== undefined ? _data["productClassification"] : null as any;
            this.orderClassification = _data["orderClassification"] !== undefined ? _data["orderClassification"] : null as any;
            if (Array.isArray(_data["productVCs"])) {
                this.productVCs = [] as any;
                for (let item of _data["productVCs"])
                    this.productVCs!.push(GetProductVCDto.fromJS(item));
            }
            else {
                this.productVCs = null as any;
            }
            if (Array.isArray(_data["productJINVCs"])) {
                this.productJINVCs = [] as any;
                for (let item of _data["productJINVCs"])
                    this.productJINVCs!.push(GetProductVCDto.fromJS(item));
            }
            else {
                this.productJINVCs = null as any;
            }
            this.priceWithTax = _data["priceWithTax"] !== undefined ? _data["priceWithTax"] : null as any;
            this.priceWithoutTax = _data["priceWithoutTax"] !== undefined ? _data["priceWithoutTax"] : null as any;
            this.unitTaxPrice = _data["unitTaxPrice"] !== undefined ? _data["unitTaxPrice"] : null as any;
            this.discountUnitPrice = _data["discountUnitPrice"] !== undefined ? _data["discountUnitPrice"] : null as any;
            this.noDiscountByPlatformUnitPrice = _data["noDiscountByPlatformUnitPrice"] !== undefined ? _data["noDiscountByPlatformUnitPrice"] : null as any;
            this.noDiscountByListUnitPrice = _data["noDiscountByListUnitPrice"] !== undefined ? _data["noDiscountByListUnitPrice"] : null as any;
            this.specialRebateFlag = _data["specialRebateFlag"] !== undefined ? _data["specialRebateFlag"] : null as any;
            this.isNewPMSProduct = _data["isNewPMSProduct"] !== undefined ? _data["isNewPMSProduct"] : null as any;
            this.operationalRemarks = _data["operationalRemarks"] !== undefined ? _data["operationalRemarks"] : null as any;
            this.orderForm = _data["orderForm"] ? GetOrderFormDto.fromJS(_data["orderForm"]) : null as any;
            this.pmsMultiplier = _data["pmsMultiplier"] !== undefined ? _data["pmsMultiplier"] : null as any;
            this.specialOfferNumber = _data["specialOfferNumber"] !== undefined ? _data["specialOfferNumber"] : null as any;
            this.agreementChanges = _data["agreementChanges"] !== undefined ? _data["agreementChanges"] : null as any;
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
            this.technicalSpecificationProductId = _data["technicalSpecificationProductId"] !== undefined ? _data["technicalSpecificationProductId"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.jinBasedMotorSries = _data["jinBasedMotorSries"] !== undefined ? _data["jinBasedMotorSries"] : null as any;
            if (Array.isArray(_data["jinRemarkOutDto"])) {
                this.jinRemarkOutDto = [] as any;
                for (let item of _data["jinRemarkOutDto"])
                    this.jinRemarkOutDto!.push(JinRemarkOutDto.fromJS(item));
            }
            else {
                this.jinRemarkOutDto = null as any;
            }
        }
    }

    static fromJS(data: any): GetProductBasicMotorDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductBasicMotorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["scSerialNumber"] = this.scSerialNumber !== undefined ? this.scSerialNumber : null as any;
        data["productBasicMotorId"] = this.productBasicMotorId !== undefined ? this.productBasicMotorId : null as any;
        data["productMixCode"] = this.productMixCode !== undefined ? this.productMixCode : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorType"] = this.basicMotorType !== undefined ? this.basicMotorType : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["numberOfProduct"] = this.numberOfProduct !== undefined ? this.numberOfProduct : null as any;
        data["multiplier"] = this.multiplier !== undefined ? this.multiplier : null as any;
        data["multiplierExpiredDate"] = this.multiplierExpiredDate ? this.multiplierExpiredDate.toISOString() : null as any;
        data["multipilerType"] = this.multipilerType !== undefined ? this.multipilerType : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["unitPriceExpiredTime"] = this.unitPriceExpiredTime ? this.unitPriceExpiredTime.toISOString() : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["totalUnitPrice"] = this.totalUnitPrice !== undefined ? this.totalUnitPrice : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["oemSalesPrice"] = this.oemSalesPrice !== undefined ? this.oemSalesPrice : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["remarkTwo"] = this.remarkTwo !== undefined ? this.remarkTwo : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["actualDeliveryDate"] = this.actualDeliveryDate !== undefined ? this.actualDeliveryDate : null as any;
        data["originalActualDeliveryDate"] = this.originalActualDeliveryDate !== undefined ? this.originalActualDeliveryDate : null as any;
        data["customerExpectedDeliveryDate"] = this.customerExpectedDeliveryDate ? this.customerExpectedDeliveryDate.toISOString() : null as any;
        data["customerExpectedDeliveryDateString"] = this.customerExpectedDeliveryDateString !== undefined ? this.customerExpectedDeliveryDateString : null as any;
        data["customerActualDeliveryDate"] = this.customerActualDeliveryDate ? this.customerActualDeliveryDate.toISOString() : null as any;
        data["customerActualDeliveryDateString"] = this.customerActualDeliveryDateString !== undefined ? this.customerActualDeliveryDateString : null as any;
        data["isEarlyWarning"] = this.isEarlyWarning !== undefined ? this.isEarlyWarning : null as any;
        data["receivePrdTechJSON"] = this.receivePrdTechJSON !== undefined ? this.receivePrdTechJSON : null as any;
        data["receivePrdElecsJSON"] = this.receivePrdElecsJSON !== undefined ? this.receivePrdElecsJSON : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["checkResultOutput"] = this.checkResultOutput ? this.checkResultOutput.toJSON() : null as any;
        data["productClassification"] = this.productClassification !== undefined ? this.productClassification : null as any;
        data["orderClassification"] = this.orderClassification !== undefined ? this.orderClassification : null as any;
        if (Array.isArray(this.productVCs)) {
            data["productVCs"] = [];
            for (let item of this.productVCs)
                data["productVCs"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.productJINVCs)) {
            data["productJINVCs"] = [];
            for (let item of this.productJINVCs)
                data["productJINVCs"].push(item ? item.toJSON() : null as any);
        }
        data["priceWithTax"] = this.priceWithTax !== undefined ? this.priceWithTax : null as any;
        data["priceWithoutTax"] = this.priceWithoutTax !== undefined ? this.priceWithoutTax : null as any;
        data["unitTaxPrice"] = this.unitTaxPrice !== undefined ? this.unitTaxPrice : null as any;
        data["discountUnitPrice"] = this.discountUnitPrice !== undefined ? this.discountUnitPrice : null as any;
        data["noDiscountByPlatformUnitPrice"] = this.noDiscountByPlatformUnitPrice !== undefined ? this.noDiscountByPlatformUnitPrice : null as any;
        data["noDiscountByListUnitPrice"] = this.noDiscountByListUnitPrice !== undefined ? this.noDiscountByListUnitPrice : null as any;
        data["specialRebateFlag"] = this.specialRebateFlag !== undefined ? this.specialRebateFlag : null as any;
        data["isNewPMSProduct"] = this.isNewPMSProduct !== undefined ? this.isNewPMSProduct : null as any;
        data["operationalRemarks"] = this.operationalRemarks !== undefined ? this.operationalRemarks : null as any;
        data["orderForm"] = this.orderForm ? this.orderForm.toJSON() : null as any;
        data["pmsMultiplier"] = this.pmsMultiplier !== undefined ? this.pmsMultiplier : null as any;
        data["specialOfferNumber"] = this.specialOfferNumber !== undefined ? this.specialOfferNumber : null as any;
        data["agreementChanges"] = this.agreementChanges !== undefined ? this.agreementChanges : null as any;
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        data["technicalSpecificationProductId"] = this.technicalSpecificationProductId !== undefined ? this.technicalSpecificationProductId : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["jinBasedMotorSries"] = this.jinBasedMotorSries !== undefined ? this.jinBasedMotorSries : null as any;
        if (Array.isArray(this.jinRemarkOutDto)) {
            data["jinRemarkOutDto"] = [];
            for (let item of this.jinRemarkOutDto)
                data["jinRemarkOutDto"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetProductVCDto {
    /** VCId */
    productVCId!: string | null;
    /** 变量产品代码 */
    vcProductCode!: string | null;
    /** 变量编号 */
    vcCode!: string | null;
    vcShowType!: VCShowType;
    /** 折扣类型 */
    discountType!: string | null;
    unitPriceResult!: string | null;
    /** 面价类型
1, 来自面价（OIS需要重新取）， 2， GCS报价， 3， 客户自己填 */
    unitPriceType!: string | null;
    /** 面价有效时间 */
    unitPriceExpiredTime!: moment.Moment | null;
    /** 面价 */
    unitPrice!: number;
    /** 售价 */
    salesPrice!: number;
    /** 描述 */
    meaning!: string | null;
    /** 备注 */
    remark!: string | null;
    /** 接收VCFreeText的JSON */
    receiveVcFreeTextJSON!: string | null;
    /** 是否为PMS派生选型后新增的VC */
    isNewProductVC!: boolean | null;
    vcType!: VcType;
    product!: GetProductBasicMotorDto;
    /** 来源报价产品VC id */
    technologyQuotationProductVCId!: string | null;
    /** 来源协议产品VC id */
    technicalSpecificationProductVCId!: string | null;
    /** 是否境界内含vc */
    isInside!: boolean;

    init(_data?: any) {
        if (_data) {
            this.productVCId = _data["productVCId"] !== undefined ? _data["productVCId"] : null as any;
            this.vcProductCode = _data["vcProductCode"] !== undefined ? _data["vcProductCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.unitPriceExpiredTime = _data["unitPriceExpiredTime"] ? moment(_data["unitPriceExpiredTime"].toString()) : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.receiveVcFreeTextJSON = _data["receiveVcFreeTextJSON"] !== undefined ? _data["receiveVcFreeTextJSON"] : null as any;
            this.isNewProductVC = _data["isNewProductVC"] !== undefined ? _data["isNewProductVC"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.product = _data["product"] ? GetProductBasicMotorDto.fromJS(_data["product"]) : null as any;
            this.technologyQuotationProductVCId = _data["technologyQuotationProductVCId"] !== undefined ? _data["technologyQuotationProductVCId"] : null as any;
            this.technicalSpecificationProductVCId = _data["technicalSpecificationProductVCId"] !== undefined ? _data["technicalSpecificationProductVCId"] : null as any;
            this.isInside = _data["isInside"] !== undefined ? _data["isInside"] : null as any;
        }
    }

    static fromJS(data: any): GetProductVCDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductVCDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productVCId"] = this.productVCId !== undefined ? this.productVCId : null as any;
        data["vcProductCode"] = this.vcProductCode !== undefined ? this.vcProductCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["discountType"] = this.discountType !== undefined ? this.discountType : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["unitPriceExpiredTime"] = this.unitPriceExpiredTime ? this.unitPriceExpiredTime.toISOString() : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["receiveVcFreeTextJSON"] = this.receiveVcFreeTextJSON !== undefined ? this.receiveVcFreeTextJSON : null as any;
        data["isNewProductVC"] = this.isNewProductVC !== undefined ? this.isNewProductVC : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["product"] = this.product ? this.product.toJSON() : null as any;
        data["technologyQuotationProductVCId"] = this.technologyQuotationProductVCId !== undefined ? this.technologyQuotationProductVCId : null as any;
        data["technicalSpecificationProductVCId"] = this.technicalSpecificationProductVCId !== undefined ? this.technicalSpecificationProductVCId : null as any;
        data["isInside"] = this.isInside !== undefined ? this.isInside : null as any;
        return data;
    }
}

export class GetSalesAreaAllDto {
    salesAreaCode!: string | null;
    salesAreaName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.salesAreaCode = _data["salesAreaCode"] !== undefined ? _data["salesAreaCode"] : null as any;
            this.salesAreaName = _data["salesAreaName"] !== undefined ? _data["salesAreaName"] : null as any;
        }
    }

    static fromJS(data: any): GetSalesAreaAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesAreaAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesAreaCode"] = this.salesAreaCode !== undefined ? this.salesAreaCode : null as any;
        data["salesAreaName"] = this.salesAreaName !== undefined ? this.salesAreaName : null as any;
        return data;
    }
}

export class GetSalesUserDto {
    salesAreaName!: string | null;
    areaManager!: string | null;
    userName!: string | null;
    userEmail!: string | null;

    init(_data?: any) {
        if (_data) {
            this.salesAreaName = _data["salesAreaName"] !== undefined ? _data["salesAreaName"] : null as any;
            this.areaManager = _data["areaManager"] !== undefined ? _data["areaManager"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.userEmail = _data["userEmail"] !== undefined ? _data["userEmail"] : null as any;
        }
    }

    static fromJS(data: any): GetSalesUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesAreaName"] = this.salesAreaName !== undefined ? this.salesAreaName : null as any;
        data["areaManager"] = this.areaManager !== undefined ? this.areaManager : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["userEmail"] = this.userEmail !== undefined ? this.userEmail : null as any;
        return data;
    }
}

export class GetSheetOEMListDto {
    /** OEM编号 */
    oemCode!: string | null;
    /** OEM名称 */
    oemName!: string | null;
    /** 二级客户代码 */
    finalCustomerCode!: string | null;
    /** 二级客户名称 */
    finalCustomerName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.oemCode = _data["oemCode"] !== undefined ? _data["oemCode"] : null as any;
            this.oemName = _data["oemName"] !== undefined ? _data["oemName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
        }
    }

    static fromJS(data: any): GetSheetOEMListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSheetOEMListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oemCode"] = this.oemCode !== undefined ? this.oemCode : null as any;
        data["oemName"] = this.oemName !== undefined ? this.oemName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        return data;
    }
}

export class GetShoppingCartAllDto {
    /** 主键Id */
    id!: string;
    /** 产品组合编码 */
    productMixCode!: string | null;
    /** 客户物料号 */
    customerMaterialNumber!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 机座号 */
    frameSize!: number;
    /** 备注 */
    remark!: string | null;
    /** CP编码 */
    cpCode!: string | null;
    /** CP名称 */
    cpCoName!: string | null;
    /** 二级客户编码 */
    finalCustomerCode!: string | null;
    /** 二级客户名称 */
    finalCustomerName!: string | null;
    vcs!: GetShoppingCartVCAllDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.productMixCode = _data["productMixCode"] !== undefined ? _data["productMixCode"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.cpCoName = _data["cpCoName"] !== undefined ? _data["cpCoName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            if (Array.isArray(_data["vcs"])) {
                this.vcs = [] as any;
                for (let item of _data["vcs"])
                    this.vcs!.push(GetShoppingCartVCAllDto.fromJS(item));
            }
            else {
                this.vcs = null as any;
            }
        }
    }

    static fromJS(data: any): GetShoppingCartAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShoppingCartAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["productMixCode"] = this.productMixCode !== undefined ? this.productMixCode : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["cpCoName"] = this.cpCoName !== undefined ? this.cpCoName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        if (Array.isArray(this.vcs)) {
            data["vcs"] = [];
            for (let item of this.vcs)
                data["vcs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetShoppingCartVCAllDto {
    /** 主键 */
    id!: string;
    /** 变量产品代码 */
    vcProductCode!: string | null;
    /** 变量编号 */
    vcCode!: string | null;
    /** 折扣类型 */
    discountType!: string | null;
    /** 描述 */
    meaning!: string | null;
    /** 备注 */
    remark!: string | null;
    /** 接收VCFreeText的JSON */
    receiveVcFreeTextJSON!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcProductCode = _data["vcProductCode"] !== undefined ? _data["vcProductCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.receiveVcFreeTextJSON = _data["receiveVcFreeTextJSON"] !== undefined ? _data["receiveVcFreeTextJSON"] : null as any;
        }
    }

    static fromJS(data: any): GetShoppingCartVCAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShoppingCartVCAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcProductCode"] = this.vcProductCode !== undefined ? this.vcProductCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["discountType"] = this.discountType !== undefined ? this.discountType : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["receiveVcFreeTextJSON"] = this.receiveVcFreeTextJSON !== undefined ? this.receiveVcFreeTextJSON : null as any;
        return data;
    }
}

/** 查询待录单订单列表 */
export class GetTodoInfosForOrderDto {
    /** 总数 */
    totalCount!: number;
    /** 待录订单 id */
    todoIds!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["todoIds"])) {
                this.todoIds = [] as any;
                for (let item of _data["todoIds"])
                    this.todoIds!.push(item);
            }
            else {
                this.todoIds = null as any;
            }
        }
    }

    static fromJS(data: any): GetTodoInfosForOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTodoInfosForOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.todoIds)) {
            data["todoIds"] = [];
            for (let item of this.todoIds)
                data["todoIds"].push(item);
        }
        return data;
    }
}

export class Incompatible {
    confilict!: string | null;
    vc!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.confilict = _data["confilict"] !== undefined ? _data["confilict"] : null as any;
            if (Array.isArray(_data["vc"])) {
                this.vc = [] as any;
                for (let item of _data["vc"])
                    this.vc!.push(item);
            }
            else {
                this.vc = null as any;
            }
        }
    }

    static fromJS(data: any): Incompatible {
        data = typeof data === 'object' ? data : {};
        let result = new Incompatible();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confilict"] = this.confilict !== undefined ? this.confilict : null as any;
        if (Array.isArray(this.vc)) {
            data["vc"] = [];
            for (let item of this.vc)
                data["vc"].push(item);
        }
        return data;
    }
}

export class Industry {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    industryCode!: string | null;
    industryName!: string | null;
    orderForms!: OrderForm[] | null;
    jinIndustryCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.industryCode = _data["industryCode"] !== undefined ? _data["industryCode"] : null as any;
            this.industryName = _data["industryName"] !== undefined ? _data["industryName"] : null as any;
            if (Array.isArray(_data["orderForms"])) {
                this.orderForms = [] as any;
                for (let item of _data["orderForms"])
                    this.orderForms!.push(OrderForm.fromJS(item));
            }
            else {
                this.orderForms = null as any;
            }
            this.jinIndustryCode = _data["jinIndustryCode"] !== undefined ? _data["jinIndustryCode"] : null as any;
        }
    }

    static fromJS(data: any): Industry {
        data = typeof data === 'object' ? data : {};
        let result = new Industry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["industryCode"] = this.industryCode !== undefined ? this.industryCode : null as any;
        data["industryName"] = this.industryName !== undefined ? this.industryName : null as any;
        if (Array.isArray(this.orderForms)) {
            data["orderForms"] = [];
            for (let item of this.orderForms)
                data["orderForms"].push(item ? item.toJSON() : null as any);
        }
        data["jinIndustryCode"] = this.jinIndustryCode !== undefined ? this.jinIndustryCode : null as any;
        return data;
    }
}

/** 0 = WaitToExamine (待审核) 1 = Rejected (已驳回) 2 = Completed (已完成) 3 = Disable (已禁用) 4 = draft (草稿) */
export enum IndustryVCStatus {
    WaitToExamine = 0,
    Rejected = 1,
    Completed = 2,
    Disable = 3,
    Draft = 4,
}

/** 新增订单变更 */
export class InsertOrderChangeDto {
    /** 订单变更 */
    orderFormId!: string;
    /** 待变更的产品编号 */
    changeProductIds!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            if (Array.isArray(_data["changeProductIds"])) {
                this.changeProductIds = [] as any;
                for (let item of _data["changeProductIds"])
                    this.changeProductIds!.push(item);
            }
            else {
                this.changeProductIds = null as any;
            }
        }
    }

    static fromJS(data: any): InsertOrderChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsertOrderChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        if (Array.isArray(this.changeProductIds)) {
            data["changeProductIds"] = [];
            for (let item of this.changeProductIds)
                data["changeProductIds"].push(item);
        }
        return data;
    }
}

/** 0 = Default 1 = Order 2 = Change 3 = Export 4 = ChangeMain */
export enum InsideVcRelType {
    Default = 0,
    Order = 1,
    Change = 2,
    Export = 3,
    ChangeMain = 4,
}

export class Int {
    max!: number;
    min!: number;

    init(_data?: any) {
        if (_data) {
            this.max = _data["max"] !== undefined ? _data["max"] : null as any;
            this.min = _data["min"] !== undefined ? _data["min"] : null as any;
        }
    }

    static fromJS(data: any): Int {
        data = typeof data === 'object' ? data : {};
        let result = new Int();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["max"] = this.max !== undefined ? this.max : null as any;
        data["min"] = this.min !== undefined ? this.min : null as any;
        return data;
    }
}

/** 对比结果 */
export class ItemRown {
    item!: string | null;
    changeType!: number;

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"] !== undefined ? _data["item"] : null as any;
            this.changeType = _data["changeType"] !== undefined ? _data["changeType"] : null as any;
        }
    }

    static fromJS(data: any): ItemRown {
        data = typeof data === 'object' ? data : {};
        let result = new ItemRown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item !== undefined ? this.item : null as any;
        data["changeType"] = this.changeType !== undefined ? this.changeType : null as any;
        return data;
    }
}

/** 境界代码对应的标准产品出参 */
export class JINCodeStandardProductOutDto {
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 备注 */
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): JINCodeStandardProductOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new JINCodeStandardProductOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

export class JINInsideVcRemarkDto {
    /** 境界代码 */
    jinMototCode!: string | null;
    /** 境界版本 */
    jinVersion!: string | null;
    /** vcCode */
    vcCode!: string | null;
    /** 关联产品Id */
    productBasicMotorId!: string;
    /** 关联订单Id */
    orderId!: string;
    insideVcRelType!: InsideVcRelType;
    /** vc类型 */
    vcType!: number;
    /** Vc显示类型 */
    vcShowType!: number;
    /** 折扣类型 */
    discountType!: number;
    /** VC含义 */
    meaning!: string | null;
    englishMeaning!: string | null;
    /** 备注 */
    remark!: string | null;
    /** 原始备注 */
    sourceRemark!: string | null;
    category!: string | null;
    serialNumber!: number;

    init(_data?: any) {
        if (_data) {
            this.jinMototCode = _data["jinMototCode"] !== undefined ? _data["jinMototCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.productBasicMotorId = _data["productBasicMotorId"] !== undefined ? _data["productBasicMotorId"] : null as any;
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : null as any;
            this.insideVcRelType = _data["insideVcRelType"] !== undefined ? _data["insideVcRelType"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.sourceRemark = _data["sourceRemark"] !== undefined ? _data["sourceRemark"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
        }
    }

    static fromJS(data: any): JINInsideVcRemarkDto {
        data = typeof data === 'object' ? data : {};
        let result = new JINInsideVcRemarkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jinMototCode"] = this.jinMototCode !== undefined ? this.jinMototCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["productBasicMotorId"] = this.productBasicMotorId !== undefined ? this.productBasicMotorId : null as any;
        data["orderId"] = this.orderId !== undefined ? this.orderId : null as any;
        data["insideVcRelType"] = this.insideVcRelType !== undefined ? this.insideVcRelType : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["discountType"] = this.discountType !== undefined ? this.discountType : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["sourceRemark"] = this.sourceRemark !== undefined ? this.sourceRemark : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        return data;
    }
}

/** A/B代码关系查询出参 */
export class JINOrderFormOutDto {
    orderFormId!: string;
    /** 项目名称 */
    projectName!: string | null;
    /** 项目编号 */
    projectNo!: string | null;
    /** 选型Id */
    modelSelectionId!: string | null;
    /** 选型名称 */
    modelSelectionName!: string | null;
    /** 特价申请号 */
    specialOfferApplicationNumber!: string | null;
    /** 特价申请号来源true，则是手动的,false，就代表是自动生成的 */
    isManual!: boolean;
    /** 总台数 */
    totalNumber!: string | null;
    /** 总价 */
    totalPrice!: number | null;
    /** 客户订单号 */
    customerOrderNumber!: string | null;
    /** 取消时间 */
    orderCancelTime!: moment.Moment | null;
    /** 下单时间 */
    orderTime!: moment.Moment | null;
    /** 订单完成时间 */
    orderCompleteTime!: moment.Moment | null;
    /** 客户期望交货日期 */
    customerExpectedDeliveryDate!: moment.Moment | null;
    /** PO号 */
    poNumber!: string | null;
    orderStatus!: OrderStatus;
    orderType!: OrderType;
    /** 订单来源 */
    orderSource!: string | null;
    /** CP编码 */
    cpCode!: string | null;
    /** CP名称 */
    cpCoName!: string | null;
    /** 最终客户编码 */
    endCustomerCode!: string | null;
    /** 最终客户名称 */
    endCustomerName!: string | null;
    /** 发货地址编码 */
    shippingAddressCode!: string | null;
    /** 发货地址 */
    shippingAddress!: string | null;
    /** 责任销售编码 */
    responsibleSalesCode!: string | null;
    /** 责任销售名称 */
    responsibleSalesName!: string | null;
    /** 附件合同名称 */
    attachmentName!: string | null;
    /** OMS订单号（暂时因为没有与OMS系统做接口，所以暂时由审批人员导入OMS系统成功之后填写） */
    omsOrderNumber!: string | null;
    dataPlatFormOrderType!: DataPlatFormOrderChangeTypeDto;
    dataPlatFormOrderTypeId!: string;
    industry!: Industry;
    application!: Application;
    channel!: Channel;
    salesArea!: SalesArea;
    /** 交货条款
此字段为20210324添加 */
    deliveryTerms!: string | null;
    /** 是否生成合同号 */
    isPoNumber!: boolean;
    /** 是否为备库订单 */
    forLibOrderFlg!: boolean | null;
    /** 最终客户名称 */
    finalCustomer!: string | null;
    /** 当前订单税率 */
    curTaxRate!: number | null;
    /** 不含税总金额 sum（ProductBasicMotors.PriceWithoutTax） */
    totalPriceWithoutTax!: number | null;
    /** 总税金 sum（ProductBasicMotors.UnitTaxPrice） */
    totalTaxPrice!: number | null;
    /** 最终客户代号 */
    finalCustomerCode!: string | null;
    /** 产品售价保留小数 */
    salesPriceDecimal!: boolean;
    /** SCID */
    lectoTypesId!: string | null;
    /** 币种 */
    currencyId!: string | null;
    /** 币种 */
    currencyType!: string | null;
    /** 产品裸机 */
    productBasicMotor!: JINOrderFormProductBasicMotorOutDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.projectNo = _data["projectNo"] !== undefined ? _data["projectNo"] : null as any;
            this.modelSelectionId = _data["modelSelectionId"] !== undefined ? _data["modelSelectionId"] : null as any;
            this.modelSelectionName = _data["modelSelectionName"] !== undefined ? _data["modelSelectionName"] : null as any;
            this.specialOfferApplicationNumber = _data["specialOfferApplicationNumber"] !== undefined ? _data["specialOfferApplicationNumber"] : null as any;
            this.isManual = _data["isManual"] !== undefined ? _data["isManual"] : null as any;
            this.totalNumber = _data["totalNumber"] !== undefined ? _data["totalNumber"] : null as any;
            this.totalPrice = _data["totalPrice"] !== undefined ? _data["totalPrice"] : null as any;
            this.customerOrderNumber = _data["customerOrderNumber"] !== undefined ? _data["customerOrderNumber"] : null as any;
            this.orderCancelTime = _data["orderCancelTime"] ? moment(_data["orderCancelTime"].toString()) : null as any;
            this.orderTime = _data["orderTime"] ? moment(_data["orderTime"].toString()) : null as any;
            this.orderCompleteTime = _data["orderCompleteTime"] ? moment(_data["orderCompleteTime"].toString()) : null as any;
            this.customerExpectedDeliveryDate = _data["customerExpectedDeliveryDate"] ? moment(_data["customerExpectedDeliveryDate"].toString()) : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.orderSource = _data["orderSource"] !== undefined ? _data["orderSource"] : null as any;
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.cpCoName = _data["cpCoName"] !== undefined ? _data["cpCoName"] : null as any;
            this.endCustomerCode = _data["endCustomerCode"] !== undefined ? _data["endCustomerCode"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.shippingAddressCode = _data["shippingAddressCode"] !== undefined ? _data["shippingAddressCode"] : null as any;
            this.shippingAddress = _data["shippingAddress"] !== undefined ? _data["shippingAddress"] : null as any;
            this.responsibleSalesCode = _data["responsibleSalesCode"] !== undefined ? _data["responsibleSalesCode"] : null as any;
            this.responsibleSalesName = _data["responsibleSalesName"] !== undefined ? _data["responsibleSalesName"] : null as any;
            this.attachmentName = _data["attachmentName"] !== undefined ? _data["attachmentName"] : null as any;
            this.omsOrderNumber = _data["omsOrderNumber"] !== undefined ? _data["omsOrderNumber"] : null as any;
            this.dataPlatFormOrderType = _data["dataPlatFormOrderType"] ? DataPlatFormOrderChangeTypeDto.fromJS(_data["dataPlatFormOrderType"]) : null as any;
            this.dataPlatFormOrderTypeId = _data["dataPlatFormOrderTypeId"] !== undefined ? _data["dataPlatFormOrderTypeId"] : null as any;
            this.industry = _data["industry"] ? Industry.fromJS(_data["industry"]) : null as any;
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : null as any;
            this.channel = _data["channel"] ? Channel.fromJS(_data["channel"]) : null as any;
            this.salesArea = _data["salesArea"] ? SalesArea.fromJS(_data["salesArea"]) : null as any;
            this.deliveryTerms = _data["deliveryTerms"] !== undefined ? _data["deliveryTerms"] : null as any;
            this.isPoNumber = _data["isPoNumber"] !== undefined ? _data["isPoNumber"] : null as any;
            this.forLibOrderFlg = _data["forLibOrderFlg"] !== undefined ? _data["forLibOrderFlg"] : null as any;
            this.finalCustomer = _data["finalCustomer"] !== undefined ? _data["finalCustomer"] : null as any;
            this.curTaxRate = _data["curTaxRate"] !== undefined ? _data["curTaxRate"] : null as any;
            this.totalPriceWithoutTax = _data["totalPriceWithoutTax"] !== undefined ? _data["totalPriceWithoutTax"] : null as any;
            this.totalTaxPrice = _data["totalTaxPrice"] !== undefined ? _data["totalTaxPrice"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.salesPriceDecimal = _data["salesPriceDecimal"] !== undefined ? _data["salesPriceDecimal"] : null as any;
            this.lectoTypesId = _data["lectoTypesId"] !== undefined ? _data["lectoTypesId"] : null as any;
            this.currencyId = _data["currencyId"] !== undefined ? _data["currencyId"] : null as any;
            this.currencyType = _data["currencyType"] !== undefined ? _data["currencyType"] : null as any;
            if (Array.isArray(_data["productBasicMotor"])) {
                this.productBasicMotor = [] as any;
                for (let item of _data["productBasicMotor"])
                    this.productBasicMotor!.push(JINOrderFormProductBasicMotorOutDto.fromJS(item));
            }
            else {
                this.productBasicMotor = null as any;
            }
        }
    }

    static fromJS(data: any): JINOrderFormOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new JINOrderFormOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["projectNo"] = this.projectNo !== undefined ? this.projectNo : null as any;
        data["modelSelectionId"] = this.modelSelectionId !== undefined ? this.modelSelectionId : null as any;
        data["modelSelectionName"] = this.modelSelectionName !== undefined ? this.modelSelectionName : null as any;
        data["specialOfferApplicationNumber"] = this.specialOfferApplicationNumber !== undefined ? this.specialOfferApplicationNumber : null as any;
        data["isManual"] = this.isManual !== undefined ? this.isManual : null as any;
        data["totalNumber"] = this.totalNumber !== undefined ? this.totalNumber : null as any;
        data["totalPrice"] = this.totalPrice !== undefined ? this.totalPrice : null as any;
        data["customerOrderNumber"] = this.customerOrderNumber !== undefined ? this.customerOrderNumber : null as any;
        data["orderCancelTime"] = this.orderCancelTime ? this.orderCancelTime.toISOString() : null as any;
        data["orderTime"] = this.orderTime ? this.orderTime.toISOString() : null as any;
        data["orderCompleteTime"] = this.orderCompleteTime ? this.orderCompleteTime.toISOString() : null as any;
        data["customerExpectedDeliveryDate"] = this.customerExpectedDeliveryDate ? this.customerExpectedDeliveryDate.toISOString() : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["orderSource"] = this.orderSource !== undefined ? this.orderSource : null as any;
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["cpCoName"] = this.cpCoName !== undefined ? this.cpCoName : null as any;
        data["endCustomerCode"] = this.endCustomerCode !== undefined ? this.endCustomerCode : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["shippingAddressCode"] = this.shippingAddressCode !== undefined ? this.shippingAddressCode : null as any;
        data["shippingAddress"] = this.shippingAddress !== undefined ? this.shippingAddress : null as any;
        data["responsibleSalesCode"] = this.responsibleSalesCode !== undefined ? this.responsibleSalesCode : null as any;
        data["responsibleSalesName"] = this.responsibleSalesName !== undefined ? this.responsibleSalesName : null as any;
        data["attachmentName"] = this.attachmentName !== undefined ? this.attachmentName : null as any;
        data["omsOrderNumber"] = this.omsOrderNumber !== undefined ? this.omsOrderNumber : null as any;
        data["dataPlatFormOrderType"] = this.dataPlatFormOrderType ? this.dataPlatFormOrderType.toJSON() : null as any;
        data["dataPlatFormOrderTypeId"] = this.dataPlatFormOrderTypeId !== undefined ? this.dataPlatFormOrderTypeId : null as any;
        data["industry"] = this.industry ? this.industry.toJSON() : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["channel"] = this.channel ? this.channel.toJSON() : null as any;
        data["salesArea"] = this.salesArea ? this.salesArea.toJSON() : null as any;
        data["deliveryTerms"] = this.deliveryTerms !== undefined ? this.deliveryTerms : null as any;
        data["isPoNumber"] = this.isPoNumber !== undefined ? this.isPoNumber : null as any;
        data["forLibOrderFlg"] = this.forLibOrderFlg !== undefined ? this.forLibOrderFlg : null as any;
        data["finalCustomer"] = this.finalCustomer !== undefined ? this.finalCustomer : null as any;
        data["curTaxRate"] = this.curTaxRate !== undefined ? this.curTaxRate : null as any;
        data["totalPriceWithoutTax"] = this.totalPriceWithoutTax !== undefined ? this.totalPriceWithoutTax : null as any;
        data["totalTaxPrice"] = this.totalTaxPrice !== undefined ? this.totalTaxPrice : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["salesPriceDecimal"] = this.salesPriceDecimal !== undefined ? this.salesPriceDecimal : null as any;
        data["lectoTypesId"] = this.lectoTypesId !== undefined ? this.lectoTypesId : null as any;
        data["currencyId"] = this.currencyId !== undefined ? this.currencyId : null as any;
        data["currencyType"] = this.currencyType !== undefined ? this.currencyType : null as any;
        if (Array.isArray(this.productBasicMotor)) {
            data["productBasicMotor"] = [];
            for (let item of this.productBasicMotor)
                data["productBasicMotor"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 境界内订单产品裸机信息出参 */
export class JINOrderFormProductBasicMotorOutDto {
    /** 产品Id */
    id!: string;
    /** 产品组合编码 */
    productMixCode!: string | null;
    /** 客户物料号 */
    customerMaterialNumber!: string | null;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** 订单形式 */
    orderType!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 主机类型 */
    basicMotorType!: number;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 产品组合的数量 */
    numberOfProduct!: number;
    /** 折扣类型，总价折扣 1，系数折扣 2 */
    multipilerType!: number;
    /** 系数 */
    multiplier!: number;
    /** 系数过期时间 */
    multiplierExpiredDate!: moment.Moment | null;
    /** 1, 来自面价（OIS需要重新取）， 2， GCS报价， 3， 客户自己填 */
    unitPriceType!: string | null;
    /** 对于 2 报价具有有效期 */
    unitPriceExpiredTime!: moment.Moment | null;
    /** 面价 */
    unitPrice!: number;
    /** 售价 */
    salesPrice!: number;
    /** 售价（OEM产品初始售价） */
    oemSalesPrice!: number;
    /** 备注(约定与主机生产、排期相关的信息存放此字段) */
    remark!: string | null;
    /** 备注二(约定与主机生产、排序无关，但是与创建订单或者主机下单规则有关的信息存放此字段) */
    remarkTwo!: string | null;
    /** 机座号 */
    frameSize!: number;
    /** 预计交货日期/天 */
    expectedDeliveryDate!: string | null;
    /** 实际交货日期/天 */
    actualDeliveryDate!: string | null;
    /** 客户原实际交货日期 */
    originalActualDeliveryDate!: string | null;
    /** 客户期望交货日期 */
    customerExpectedDeliveryDate!: moment.Moment | null;
    /** 客户原期望交货期 */
    customerActualDeliveryDate!: moment.Moment | null;
    /** GSS报价号 */
    gssQuotationNo!: string | null;
    /** GSS技术确认号（SFDC） */
    gssTechnicalConfirmationNumber!: string | null;
    /** 技术规范（技术规范号） */
    technicalSpecifications!: string | null;
    /** 接收PrdTech的JSON */
    receivePrdTechJSON!: string | null;
    /** 接收PrdElecs的JSON */
    receivePrdElecsJSON!: string | null;
    /** SMCONF带过来的规则检查 */
    checkResultOutput!: string | null;
    /** 主机分类 */
    productClassification!: string | null;
    /** 订单分类 */
    orderClassification!: string | null;
    /** 订单Id */
    orderFormId!: string | null;
    /** 1 含税总金额 售价(SalesPrice)*NumberOfProduct
售价(salesPrice)=(面价+VC.unitPrice)*系数(multiplier) */
    priceWithTax!: number | null;
    /** 2 不含税总金额 PriceWithTax/(1+OrderForm.TaxPrice)
PriceWithTax/1.13后四舍五入，保留2位小数，订单行先计算再合计进总价，界面显示只要在header里 */
    priceWithoutTax!: number | null;
    /** 3 税金 PriceWithTax - PriceWithoutTax */
    unitTaxPrice!: number | null;
    /** 可打折面价 */
    discountUnitPrice!: number | null;
    /** 按台收不打折 */
    noDiscountByPlatformUnitPrice!: number | null;
    /** 按单收不打折 */
    noDiscountByListUnitPrice!: number | null;
    /** 序号 */
    serialNumber!: number | null;
    /** SC序号 */
    scSerialNumber!: number | null;
    /** precal序号 */
    precalItemNo!: number | null;
    /** 特殊返点标识 */
    specialRebateFlag!: string | null;
    /**  PMS
是否为PMS派生选型后,新增的主机 */
    isNewPMSProduct!: boolean | null;
    /** 运营相关备注 */
    operationalRemarks!: string | null;
    /** PMS原始折扣 */
    pmsMultiplier!: number | null;
    /** 特价号 */
    specialOfferNumber!: string | null;
    /** 是否增减了VC或改动了VC的备注信息导致技术协议发生了变动 */
    agreementChanges!: boolean;
    /** 来源报价产品id */
    technologyQuotationProductId!: string | null;
    /** 来源协议产品id (协议是针对产品行的且对所有客户有效，因此在业务上不需要考虑客户变更的场景) */
    technicalSpecificationProductId!: string | null;
    /** 境界标识符 */
    jinCategoryCode!: string | null;
    /** 境界代码版本号 */
    jinVersion!: string | null;
    /** 产品VC */
    productVCs!: JINOrderFormProductVcOutDto[] | null;
    jinStandardProductBasicMotor!: JINStandardProductBasicMotorOutDto;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.productMixCode = _data["productMixCode"] !== undefined ? _data["productMixCode"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorType = _data["basicMotorType"] !== undefined ? _data["basicMotorType"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.numberOfProduct = _data["numberOfProduct"] !== undefined ? _data["numberOfProduct"] : null as any;
            this.multipilerType = _data["multipilerType"] !== undefined ? _data["multipilerType"] : null as any;
            this.multiplier = _data["multiplier"] !== undefined ? _data["multiplier"] : null as any;
            this.multiplierExpiredDate = _data["multiplierExpiredDate"] ? moment(_data["multiplierExpiredDate"].toString()) : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.unitPriceExpiredTime = _data["unitPriceExpiredTime"] ? moment(_data["unitPriceExpiredTime"].toString()) : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.oemSalesPrice = _data["oemSalesPrice"] !== undefined ? _data["oemSalesPrice"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.remarkTwo = _data["remarkTwo"] !== undefined ? _data["remarkTwo"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.actualDeliveryDate = _data["actualDeliveryDate"] !== undefined ? _data["actualDeliveryDate"] : null as any;
            this.originalActualDeliveryDate = _data["originalActualDeliveryDate"] !== undefined ? _data["originalActualDeliveryDate"] : null as any;
            this.customerExpectedDeliveryDate = _data["customerExpectedDeliveryDate"] ? moment(_data["customerExpectedDeliveryDate"].toString()) : null as any;
            this.customerActualDeliveryDate = _data["customerActualDeliveryDate"] ? moment(_data["customerActualDeliveryDate"].toString()) : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.receivePrdTechJSON = _data["receivePrdTechJSON"] !== undefined ? _data["receivePrdTechJSON"] : null as any;
            this.receivePrdElecsJSON = _data["receivePrdElecsJSON"] !== undefined ? _data["receivePrdElecsJSON"] : null as any;
            this.checkResultOutput = _data["checkResultOutput"] !== undefined ? _data["checkResultOutput"] : null as any;
            this.productClassification = _data["productClassification"] !== undefined ? _data["productClassification"] : null as any;
            this.orderClassification = _data["orderClassification"] !== undefined ? _data["orderClassification"] : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.priceWithTax = _data["priceWithTax"] !== undefined ? _data["priceWithTax"] : null as any;
            this.priceWithoutTax = _data["priceWithoutTax"] !== undefined ? _data["priceWithoutTax"] : null as any;
            this.unitTaxPrice = _data["unitTaxPrice"] !== undefined ? _data["unitTaxPrice"] : null as any;
            this.discountUnitPrice = _data["discountUnitPrice"] !== undefined ? _data["discountUnitPrice"] : null as any;
            this.noDiscountByPlatformUnitPrice = _data["noDiscountByPlatformUnitPrice"] !== undefined ? _data["noDiscountByPlatformUnitPrice"] : null as any;
            this.noDiscountByListUnitPrice = _data["noDiscountByListUnitPrice"] !== undefined ? _data["noDiscountByListUnitPrice"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.scSerialNumber = _data["scSerialNumber"] !== undefined ? _data["scSerialNumber"] : null as any;
            this.precalItemNo = _data["precalItemNo"] !== undefined ? _data["precalItemNo"] : null as any;
            this.specialRebateFlag = _data["specialRebateFlag"] !== undefined ? _data["specialRebateFlag"] : null as any;
            this.isNewPMSProduct = _data["isNewPMSProduct"] !== undefined ? _data["isNewPMSProduct"] : null as any;
            this.operationalRemarks = _data["operationalRemarks"] !== undefined ? _data["operationalRemarks"] : null as any;
            this.pmsMultiplier = _data["pmsMultiplier"] !== undefined ? _data["pmsMultiplier"] : null as any;
            this.specialOfferNumber = _data["specialOfferNumber"] !== undefined ? _data["specialOfferNumber"] : null as any;
            this.agreementChanges = _data["agreementChanges"] !== undefined ? _data["agreementChanges"] : null as any;
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
            this.technicalSpecificationProductId = _data["technicalSpecificationProductId"] !== undefined ? _data["technicalSpecificationProductId"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            if (Array.isArray(_data["productVCs"])) {
                this.productVCs = [] as any;
                for (let item of _data["productVCs"])
                    this.productVCs!.push(JINOrderFormProductVcOutDto.fromJS(item));
            }
            else {
                this.productVCs = null as any;
            }
            this.jinStandardProductBasicMotor = _data["jinStandardProductBasicMotor"] ? JINStandardProductBasicMotorOutDto.fromJS(_data["jinStandardProductBasicMotor"]) : null as any;
        }
    }

    static fromJS(data: any): JINOrderFormProductBasicMotorOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new JINOrderFormProductBasicMotorOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["productMixCode"] = this.productMixCode !== undefined ? this.productMixCode : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorType"] = this.basicMotorType !== undefined ? this.basicMotorType : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["numberOfProduct"] = this.numberOfProduct !== undefined ? this.numberOfProduct : null as any;
        data["multipilerType"] = this.multipilerType !== undefined ? this.multipilerType : null as any;
        data["multiplier"] = this.multiplier !== undefined ? this.multiplier : null as any;
        data["multiplierExpiredDate"] = this.multiplierExpiredDate ? this.multiplierExpiredDate.toISOString() : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["unitPriceExpiredTime"] = this.unitPriceExpiredTime ? this.unitPriceExpiredTime.toISOString() : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["oemSalesPrice"] = this.oemSalesPrice !== undefined ? this.oemSalesPrice : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["remarkTwo"] = this.remarkTwo !== undefined ? this.remarkTwo : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["actualDeliveryDate"] = this.actualDeliveryDate !== undefined ? this.actualDeliveryDate : null as any;
        data["originalActualDeliveryDate"] = this.originalActualDeliveryDate !== undefined ? this.originalActualDeliveryDate : null as any;
        data["customerExpectedDeliveryDate"] = this.customerExpectedDeliveryDate ? this.customerExpectedDeliveryDate.toISOString() : null as any;
        data["customerActualDeliveryDate"] = this.customerActualDeliveryDate ? this.customerActualDeliveryDate.toISOString() : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["receivePrdTechJSON"] = this.receivePrdTechJSON !== undefined ? this.receivePrdTechJSON : null as any;
        data["receivePrdElecsJSON"] = this.receivePrdElecsJSON !== undefined ? this.receivePrdElecsJSON : null as any;
        data["checkResultOutput"] = this.checkResultOutput !== undefined ? this.checkResultOutput : null as any;
        data["productClassification"] = this.productClassification !== undefined ? this.productClassification : null as any;
        data["orderClassification"] = this.orderClassification !== undefined ? this.orderClassification : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["priceWithTax"] = this.priceWithTax !== undefined ? this.priceWithTax : null as any;
        data["priceWithoutTax"] = this.priceWithoutTax !== undefined ? this.priceWithoutTax : null as any;
        data["unitTaxPrice"] = this.unitTaxPrice !== undefined ? this.unitTaxPrice : null as any;
        data["discountUnitPrice"] = this.discountUnitPrice !== undefined ? this.discountUnitPrice : null as any;
        data["noDiscountByPlatformUnitPrice"] = this.noDiscountByPlatformUnitPrice !== undefined ? this.noDiscountByPlatformUnitPrice : null as any;
        data["noDiscountByListUnitPrice"] = this.noDiscountByListUnitPrice !== undefined ? this.noDiscountByListUnitPrice : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["scSerialNumber"] = this.scSerialNumber !== undefined ? this.scSerialNumber : null as any;
        data["precalItemNo"] = this.precalItemNo !== undefined ? this.precalItemNo : null as any;
        data["specialRebateFlag"] = this.specialRebateFlag !== undefined ? this.specialRebateFlag : null as any;
        data["isNewPMSProduct"] = this.isNewPMSProduct !== undefined ? this.isNewPMSProduct : null as any;
        data["operationalRemarks"] = this.operationalRemarks !== undefined ? this.operationalRemarks : null as any;
        data["pmsMultiplier"] = this.pmsMultiplier !== undefined ? this.pmsMultiplier : null as any;
        data["specialOfferNumber"] = this.specialOfferNumber !== undefined ? this.specialOfferNumber : null as any;
        data["agreementChanges"] = this.agreementChanges !== undefined ? this.agreementChanges : null as any;
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        data["technicalSpecificationProductId"] = this.technicalSpecificationProductId !== undefined ? this.technicalSpecificationProductId : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        if (Array.isArray(this.productVCs)) {
            data["productVCs"] = [];
            for (let item of this.productVCs)
                data["productVCs"].push(item ? item.toJSON() : null as any);
        }
        data["jinStandardProductBasicMotor"] = this.jinStandardProductBasicMotor ? this.jinStandardProductBasicMotor.toJSON() : null as any;
        return data;
    }
}

/** 境界订单产品VC出参 */
export class JINOrderFormProductVcOutDto {
    /** 变量产品代码 */
    vcProductCode!: string | null;
    /** 变量编号 */
    vcCode!: string | null;
    /** Vc显示类型 */
    vcShowType!: number;
    /** 折扣类型 */
    discountType!: string | null;
    /** 1, 来自面价（OIS需要重新取）， 2， GCS报价， 3， 客户自己填 */
    unitPriceType!: string | null;
    /** 有效期 */
    unitPriceExpiredTime!: moment.Moment | null;
    /** 面价 */
    unitPrice!: number;
    /** 售价 */
    salesPrice!: number;
    /** 描述 */
    meaning!: string | null;
    /** 备注 */
    remark!: string | null;
    /** 接收VCFreeText的JSON */
    receiveVcFreeTextJSON!: string | null;
    /** 是否为PMS派生选型后,新增的VC */
    isNewProductVC!: boolean | null;
    /** VC类型 */
    vcType!: number;
    /** 产品Id */
    productBasicMotorId!: string | null;
    /** 是否境界内含vc */
    isJIN!: boolean;

    init(_data?: any) {
        if (_data) {
            this.vcProductCode = _data["vcProductCode"] !== undefined ? _data["vcProductCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.unitPriceExpiredTime = _data["unitPriceExpiredTime"] ? moment(_data["unitPriceExpiredTime"].toString()) : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.receiveVcFreeTextJSON = _data["receiveVcFreeTextJSON"] !== undefined ? _data["receiveVcFreeTextJSON"] : null as any;
            this.isNewProductVC = _data["isNewProductVC"] !== undefined ? _data["isNewProductVC"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.productBasicMotorId = _data["productBasicMotorId"] !== undefined ? _data["productBasicMotorId"] : null as any;
            this.isJIN = _data["isJIN"] !== undefined ? _data["isJIN"] : null as any;
        }
    }

    static fromJS(data: any): JINOrderFormProductVcOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new JINOrderFormProductVcOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcProductCode"] = this.vcProductCode !== undefined ? this.vcProductCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["discountType"] = this.discountType !== undefined ? this.discountType : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["unitPriceExpiredTime"] = this.unitPriceExpiredTime ? this.unitPriceExpiredTime.toISOString() : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["receiveVcFreeTextJSON"] = this.receiveVcFreeTextJSON !== undefined ? this.receiveVcFreeTextJSON : null as any;
        data["isNewProductVC"] = this.isNewProductVC !== undefined ? this.isNewProductVC : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["productBasicMotorId"] = this.productBasicMotorId !== undefined ? this.productBasicMotorId : null as any;
        data["isJIN"] = this.isJIN !== undefined ? this.isJIN : null as any;
        return data;
    }
}

/** 境界对应 标准的产品代码 */
export class JINStandardProductBasicMotorOutDto {
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 机座号 */
    frameSize!: number | null;
    /** 能效 */
    eneEff!: string | null;
    /** 电压 */
    voltage!: string | null;
    /** 接线方式 */
    wiringMode!: string | null;
    /** 频率 */
    frequency!: string | null;
    /** 功率 */
    power!: string | null;
    /** 极数 */
    poleNo!: string | null;
    /** 安装方式 */
    basicMotorMounting!: string | null;

    init(_data?: any) {
        if (_data) {
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
        }
    }

    static fromJS(data: any): JINStandardProductBasicMotorOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new JINStandardProductBasicMotorOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        return data;
    }
}

export class JInCodesVcsOutputDto {
    jinCodeId!: string;
    jinMotorCode!: string | null;
    vcCode!: string | null;
    status!: number;
    vcType!: number;
    vcShowType!: number;
    vcRemark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.jinCodeId = _data["jinCodeId"] !== undefined ? _data["jinCodeId"] : null as any;
            this.jinMotorCode = _data["jinMotorCode"] !== undefined ? _data["jinMotorCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.vcRemark = _data["vcRemark"] !== undefined ? _data["vcRemark"] : null as any;
        }
    }

    static fromJS(data: any): JInCodesVcsOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new JInCodesVcsOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jinCodeId"] = this.jinCodeId !== undefined ? this.jinCodeId : null as any;
        data["jinMotorCode"] = this.jinMotorCode !== undefined ? this.jinMotorCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["vcRemark"] = this.vcRemark !== undefined ? this.vcRemark : null as any;
        return data;
    }
}

/** 境界备注输出Dto */
export class JinRemarkOutDto {
    /** 含义 */
    meaning!: string | null;
    /** 备注 */
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): JinRemarkOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new JinRemarkOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

/** 0 = UnKnow (未知类型) 1 = Export (导出任务) 2 = Import (导入任务) */
export enum JobEnum {
    UnKnow = 0,
    Export = 1,
    Import = 2,
}

export class List {
    key!: string | null;
    value!: string | null;

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static fromJS(data: any): List {
        data = typeof data === 'object' ? data : {};
        let result = new List();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }
}

export class List1 {
    key!: string | null;
    value!: string | null;

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static fromJS(data: any): List1 {
        data = typeof data === 'object' ? data : {};
        let result = new List1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }
}

/** 记录物流或仓库已下载 DNS 附件。 */
export class MarkAttachmentDownloadInput {
    ids!: string[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            else {
                this.ids = null as any;
            }
        }
    }

    static fromJS(data: any): MarkAttachmentDownloadInput {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAttachmentDownloadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export class ModifyOrderApprovalStatusParam {
    /** 主键 */
    orderId!: string;
    approvalStatus!: ApprovalStatusEnum;

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
        }
    }

    static fromJS(data: any): ModifyOrderApprovalStatusParam {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyOrderApprovalStatusParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId !== undefined ? this.orderId : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        return data;
    }
}

export class MotorCertBatchDownloadInputDto {
    fileType!: MotorCertFileType;
    selections!: MotorCertDownloadSelectionDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.fileType = _data["fileType"] !== undefined ? _data["fileType"] : null as any;
            if (Array.isArray(_data["selections"])) {
                this.selections = [] as any;
                for (let item of _data["selections"])
                    this.selections!.push(MotorCertDownloadSelectionDto.fromJS(item));
            }
            else {
                this.selections = null as any;
            }
        }
    }

    static fromJS(data: any): MotorCertBatchDownloadInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertBatchDownloadInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileType"] = this.fileType !== undefined ? this.fileType : null as any;
        if (Array.isArray(this.selections)) {
            data["selections"] = [];
            for (let item of this.selections)
                data["selections"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class MotorCertBatchDownloadResultDto {
    zipFileName!: string | null;
    downloadUrl!: string | null;
    fileSize!: number;
    successCount!: number;
    failList!: MotorCertDownloadFailItemDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.zipFileName = _data["zipFileName"] !== undefined ? _data["zipFileName"] : null as any;
            this.downloadUrl = _data["downloadUrl"] !== undefined ? _data["downloadUrl"] : null as any;
            this.fileSize = _data["fileSize"] !== undefined ? _data["fileSize"] : null as any;
            this.successCount = _data["successCount"] !== undefined ? _data["successCount"] : null as any;
            if (Array.isArray(_data["failList"])) {
                this.failList = [] as any;
                for (let item of _data["failList"])
                    this.failList!.push(MotorCertDownloadFailItemDto.fromJS(item));
            }
            else {
                this.failList = null as any;
            }
        }
    }

    static fromJS(data: any): MotorCertBatchDownloadResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertBatchDownloadResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zipFileName"] = this.zipFileName !== undefined ? this.zipFileName : null as any;
        data["downloadUrl"] = this.downloadUrl !== undefined ? this.downloadUrl : null as any;
        data["fileSize"] = this.fileSize !== undefined ? this.fileSize : null as any;
        data["successCount"] = this.successCount !== undefined ? this.successCount : null as any;
        if (Array.isArray(this.failList)) {
            data["failList"] = [];
            for (let item of this.failList)
                data["failList"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class MotorCertContactHandlerInputDto {
    saleNumber!: string | null;
    saleRowNo!: string | null;
    lsuSalesOrder!: string | null;
    lsuItem!: string | null;
    pmuSalesOrder!: string | null;
    pmuSalesOrderItem!: string | null;
    basicMotorModel!: string | null;

    init(_data?: any) {
        if (_data) {
            this.saleNumber = _data["saleNumber"] !== undefined ? _data["saleNumber"] : null as any;
            this.saleRowNo = _data["saleRowNo"] !== undefined ? _data["saleRowNo"] : null as any;
            this.lsuSalesOrder = _data["lsuSalesOrder"] !== undefined ? _data["lsuSalesOrder"] : null as any;
            this.lsuItem = _data["lsuItem"] !== undefined ? _data["lsuItem"] : null as any;
            this.pmuSalesOrder = _data["pmuSalesOrder"] !== undefined ? _data["pmuSalesOrder"] : null as any;
            this.pmuSalesOrderItem = _data["pmuSalesOrderItem"] !== undefined ? _data["pmuSalesOrderItem"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
        }
    }

    static fromJS(data: any): MotorCertContactHandlerInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertContactHandlerInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleNumber"] = this.saleNumber !== undefined ? this.saleNumber : null as any;
        data["saleRowNo"] = this.saleRowNo !== undefined ? this.saleRowNo : null as any;
        data["lsuSalesOrder"] = this.lsuSalesOrder !== undefined ? this.lsuSalesOrder : null as any;
        data["lsuItem"] = this.lsuItem !== undefined ? this.lsuItem : null as any;
        data["pmuSalesOrder"] = this.pmuSalesOrder !== undefined ? this.pmuSalesOrder : null as any;
        data["pmuSalesOrderItem"] = this.pmuSalesOrderItem !== undefined ? this.pmuSalesOrderItem : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        return data;
    }
}

export class MotorCertDownloadFailItemDto {
    serialNumber!: string | null;
    reason!: string | null;

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
        }
    }

    static fromJS(data: any): MotorCertDownloadFailItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertDownloadFailItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        return data;
    }
}

export class MotorCertDownloadSelectionDto {
    saleNumber!: string | null;
    saleRowNo!: string | null;
    /** 可选 ISO，用于 SapSnCreate 匹配 */
    pmuSalesOrder!: string | null;
    /** 可选 ISO Item */
    pmuSalesOrderItem!: string | null;
    selectMode!: string | null;
    snList!: string[] | null;
    /** 是否打包合格证；null 时跟随 FileType */
    includeCert!: boolean | null;
    /** 是否打包试验报告；null 时跟随 FileType */
    includeReport!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.saleNumber = _data["saleNumber"] !== undefined ? _data["saleNumber"] : null as any;
            this.saleRowNo = _data["saleRowNo"] !== undefined ? _data["saleRowNo"] : null as any;
            this.pmuSalesOrder = _data["pmuSalesOrder"] !== undefined ? _data["pmuSalesOrder"] : null as any;
            this.pmuSalesOrderItem = _data["pmuSalesOrderItem"] !== undefined ? _data["pmuSalesOrderItem"] : null as any;
            this.selectMode = _data["selectMode"] !== undefined ? _data["selectMode"] : null as any;
            if (Array.isArray(_data["snList"])) {
                this.snList = [] as any;
                for (let item of _data["snList"])
                    this.snList!.push(item);
            }
            else {
                this.snList = null as any;
            }
            this.includeCert = _data["includeCert"] !== undefined ? _data["includeCert"] : null as any;
            this.includeReport = _data["includeReport"] !== undefined ? _data["includeReport"] : null as any;
        }
    }

    static fromJS(data: any): MotorCertDownloadSelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertDownloadSelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleNumber"] = this.saleNumber !== undefined ? this.saleNumber : null as any;
        data["saleRowNo"] = this.saleRowNo !== undefined ? this.saleRowNo : null as any;
        data["pmuSalesOrder"] = this.pmuSalesOrder !== undefined ? this.pmuSalesOrder : null as any;
        data["pmuSalesOrderItem"] = this.pmuSalesOrderItem !== undefined ? this.pmuSalesOrderItem : null as any;
        data["selectMode"] = this.selectMode !== undefined ? this.selectMode : null as any;
        if (Array.isArray(this.snList)) {
            data["snList"] = [];
            for (let item of this.snList)
                data["snList"].push(item);
        }
        data["includeCert"] = this.includeCert !== undefined ? this.includeCert : null as any;
        data["includeReport"] = this.includeReport !== undefined ? this.includeReport : null as any;
        return data;
    }
}

/** 同步执行 Job（当前请求内直接跑 ExecuteAsync，便于断点调试；勿在生产高峰调用）。 */
export class MotorCertExecuteJobSyncResultDto {
    succeeded!: boolean;
    jobName!: string | null;
    startedAt!: moment.Moment;
    finishedAt!: moment.Moment;
    elapsedSeconds!: number;
    message!: string | null;
    error!: string | null;

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"] !== undefined ? _data["succeeded"] : null as any;
            this.jobName = _data["jobName"] !== undefined ? _data["jobName"] : null as any;
            this.startedAt = _data["startedAt"] ? moment(_data["startedAt"].toString()) : null as any;
            this.finishedAt = _data["finishedAt"] ? moment(_data["finishedAt"].toString()) : null as any;
            this.elapsedSeconds = _data["elapsedSeconds"] !== undefined ? _data["elapsedSeconds"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.error = _data["error"] !== undefined ? _data["error"] : null as any;
        }
    }

    static fromJS(data: any): MotorCertExecuteJobSyncResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertExecuteJobSyncResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded !== undefined ? this.succeeded : null as any;
        data["jobName"] = this.jobName !== undefined ? this.jobName : null as any;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : null as any;
        data["finishedAt"] = this.finishedAt ? this.finishedAt.toISOString() : null as any;
        data["elapsedSeconds"] = this.elapsedSeconds !== undefined ? this.elapsedSeconds : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["error"] = this.error !== undefined ? this.error : null as any;
        return data;
    }
}

export class MotorCertFeeCart {
    id!: string;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    ownerUserId!: number;
    customerCode!: string;
    customerName!: string | null;
    cartType!: number | null;
    status!: number | null;
    resultStatus!: number | null;
    resultMessage!: string | null;
    resultTime!: moment.Moment | null;
    orderFormId!: string | null;
    orderNo!: string | null;
    submittedTime!: moment.Moment | null;
    submitFailedMessage!: string | null;
    items!: MotorCertFeeCartItem[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.ownerUserId = _data["ownerUserId"] !== undefined ? _data["ownerUserId"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.cartType = _data["cartType"] !== undefined ? _data["cartType"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.resultStatus = _data["resultStatus"] !== undefined ? _data["resultStatus"] : null as any;
            this.resultMessage = _data["resultMessage"] !== undefined ? _data["resultMessage"] : null as any;
            this.resultTime = _data["resultTime"] ? moment(_data["resultTime"].toString()) : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.orderNo = _data["orderNo"] !== undefined ? _data["orderNo"] : null as any;
            this.submittedTime = _data["submittedTime"] ? moment(_data["submittedTime"].toString()) : null as any;
            this.submitFailedMessage = _data["submitFailedMessage"] !== undefined ? _data["submitFailedMessage"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MotorCertFeeCartItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): MotorCertFeeCart {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertFeeCart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["ownerUserId"] = this.ownerUserId !== undefined ? this.ownerUserId : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["cartType"] = this.cartType !== undefined ? this.cartType : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["resultStatus"] = this.resultStatus !== undefined ? this.resultStatus : null as any;
        data["resultMessage"] = this.resultMessage !== undefined ? this.resultMessage : null as any;
        data["resultTime"] = this.resultTime ? this.resultTime.toISOString() : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["orderNo"] = this.orderNo !== undefined ? this.orderNo : null as any;
        data["submittedTime"] = this.submittedTime ? this.submittedTime.toISOString() : null as any;
        data["submitFailedMessage"] = this.submitFailedMessage !== undefined ? this.submitFailedMessage : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class MotorCertFeeCartItem {
    id!: string;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    cartId!: string;
    sourceOrderFormId!: string | null;
    sourceProductBasicMotorId!: string | null;
    sourceCso!: string | null;
    sourceCsoItem!: string | null;
    sourceIso!: string | null;
    sourceIsoItem!: string | null;
    basicMotorModel!: string | null;
    basicMotorCode!: string | null;
    motorSeries!: string | null;
    frameSize!: number | null;
    feeMotorCode!: string | null;
    feeSapMaterial!: string | null;
    vcLongCode!: string | null;
    unitPrice!: number | null;
    multiplier!: number | null;
    salesPrice!: number | null;
    qty!: number | null;
    operationalRemarks!: string | null;
    remarkTwo!: string | null;
    sortNo!: number | null;
    cart!: MotorCertFeeCart;
    sns!: MotorCertFeeCartSn[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.cartId = _data["cartId"] !== undefined ? _data["cartId"] : null as any;
            this.sourceOrderFormId = _data["sourceOrderFormId"] !== undefined ? _data["sourceOrderFormId"] : null as any;
            this.sourceProductBasicMotorId = _data["sourceProductBasicMotorId"] !== undefined ? _data["sourceProductBasicMotorId"] : null as any;
            this.sourceCso = _data["sourceCso"] !== undefined ? _data["sourceCso"] : null as any;
            this.sourceCsoItem = _data["sourceCsoItem"] !== undefined ? _data["sourceCsoItem"] : null as any;
            this.sourceIso = _data["sourceIso"] !== undefined ? _data["sourceIso"] : null as any;
            this.sourceIsoItem = _data["sourceIsoItem"] !== undefined ? _data["sourceIsoItem"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.motorSeries = _data["motorSeries"] !== undefined ? _data["motorSeries"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.feeMotorCode = _data["feeMotorCode"] !== undefined ? _data["feeMotorCode"] : null as any;
            this.feeSapMaterial = _data["feeSapMaterial"] !== undefined ? _data["feeSapMaterial"] : null as any;
            this.vcLongCode = _data["vcLongCode"] !== undefined ? _data["vcLongCode"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.multiplier = _data["multiplier"] !== undefined ? _data["multiplier"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.qty = _data["qty"] !== undefined ? _data["qty"] : null as any;
            this.operationalRemarks = _data["operationalRemarks"] !== undefined ? _data["operationalRemarks"] : null as any;
            this.remarkTwo = _data["remarkTwo"] !== undefined ? _data["remarkTwo"] : null as any;
            this.sortNo = _data["sortNo"] !== undefined ? _data["sortNo"] : null as any;
            this.cart = _data["cart"] ? MotorCertFeeCart.fromJS(_data["cart"]) : null as any;
            if (Array.isArray(_data["sns"])) {
                this.sns = [] as any;
                for (let item of _data["sns"])
                    this.sns!.push(MotorCertFeeCartSn.fromJS(item));
            }
            else {
                this.sns = null as any;
            }
        }
    }

    static fromJS(data: any): MotorCertFeeCartItem {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertFeeCartItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["cartId"] = this.cartId !== undefined ? this.cartId : null as any;
        data["sourceOrderFormId"] = this.sourceOrderFormId !== undefined ? this.sourceOrderFormId : null as any;
        data["sourceProductBasicMotorId"] = this.sourceProductBasicMotorId !== undefined ? this.sourceProductBasicMotorId : null as any;
        data["sourceCso"] = this.sourceCso !== undefined ? this.sourceCso : null as any;
        data["sourceCsoItem"] = this.sourceCsoItem !== undefined ? this.sourceCsoItem : null as any;
        data["sourceIso"] = this.sourceIso !== undefined ? this.sourceIso : null as any;
        data["sourceIsoItem"] = this.sourceIsoItem !== undefined ? this.sourceIsoItem : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["motorSeries"] = this.motorSeries !== undefined ? this.motorSeries : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["feeMotorCode"] = this.feeMotorCode !== undefined ? this.feeMotorCode : null as any;
        data["feeSapMaterial"] = this.feeSapMaterial !== undefined ? this.feeSapMaterial : null as any;
        data["vcLongCode"] = this.vcLongCode !== undefined ? this.vcLongCode : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["multiplier"] = this.multiplier !== undefined ? this.multiplier : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["qty"] = this.qty !== undefined ? this.qty : null as any;
        data["operationalRemarks"] = this.operationalRemarks !== undefined ? this.operationalRemarks : null as any;
        data["remarkTwo"] = this.remarkTwo !== undefined ? this.remarkTwo : null as any;
        data["sortNo"] = this.sortNo !== undefined ? this.sortNo : null as any;
        data["cart"] = this.cart ? this.cart.toJSON() : null as any;
        if (Array.isArray(this.sns)) {
            data["sns"] = [];
            for (let item of this.sns)
                data["sns"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class MotorCertFeeCartSn {
    id!: string;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    cartItemId!: string;
    cartId!: string;
    serialNumber!: string;
    sourceCso!: string | null;
    sourceCsoItem!: string | null;
    mappingId!: string | null;
    occupyStatus!: number | null;
    cartItem!: MotorCertFeeCartItem;
    cart!: MotorCertFeeCart;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.cartItemId = _data["cartItemId"] !== undefined ? _data["cartItemId"] : null as any;
            this.cartId = _data["cartId"] !== undefined ? _data["cartId"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.sourceCso = _data["sourceCso"] !== undefined ? _data["sourceCso"] : null as any;
            this.sourceCsoItem = _data["sourceCsoItem"] !== undefined ? _data["sourceCsoItem"] : null as any;
            this.mappingId = _data["mappingId"] !== undefined ? _data["mappingId"] : null as any;
            this.occupyStatus = _data["occupyStatus"] !== undefined ? _data["occupyStatus"] : null as any;
            this.cartItem = _data["cartItem"] ? MotorCertFeeCartItem.fromJS(_data["cartItem"]) : null as any;
            this.cart = _data["cart"] ? MotorCertFeeCart.fromJS(_data["cart"]) : null as any;
        }
    }

    static fromJS(data: any): MotorCertFeeCartSn {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertFeeCartSn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["cartItemId"] = this.cartItemId !== undefined ? this.cartItemId : null as any;
        data["cartId"] = this.cartId !== undefined ? this.cartId : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["sourceCso"] = this.sourceCso !== undefined ? this.sourceCso : null as any;
        data["sourceCsoItem"] = this.sourceCsoItem !== undefined ? this.sourceCsoItem : null as any;
        data["mappingId"] = this.mappingId !== undefined ? this.mappingId : null as any;
        data["occupyStatus"] = this.occupyStatus !== undefined ? this.occupyStatus : null as any;
        data["cartItem"] = this.cartItem ? this.cartItem.toJSON() : null as any;
        data["cart"] = this.cart ? this.cart.toJSON() : null as any;
        return data;
    }
}

/** 0 = All 1 = Cert 2 = Report */
export enum MotorCertFileType {
    All = 0,
    Cert = 1,
    Report = 2,
}

export class MotorCertHandlerUploadTaskDto {
    id!: string;
    saleNumber!: string | null;
    saleRowNo!: string | null;
    lsuSalesOrder!: string | null;
    lsuItem!: string | null;
    pmuSalesOrder!: string | null;
    pmuSalesOrderItem!: string | null;
    basicMotorModel!: string | null;
    motorType!: MotorType;
    motorTypeText!: string | null;
    fileType!: MotorCertFileType;
    fileTypeText!: string | null;
    status!: MotorCertHandlerUploadTaskStatus;
    expectedQty!: number;
    creationTime!: moment.Moment;
    requesterUserName!: string | null;
    handlerEmail!: string | null;
    handlerName!: string | null;
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.saleNumber = _data["saleNumber"] !== undefined ? _data["saleNumber"] : null as any;
            this.saleRowNo = _data["saleRowNo"] !== undefined ? _data["saleRowNo"] : null as any;
            this.lsuSalesOrder = _data["lsuSalesOrder"] !== undefined ? _data["lsuSalesOrder"] : null as any;
            this.lsuItem = _data["lsuItem"] !== undefined ? _data["lsuItem"] : null as any;
            this.pmuSalesOrder = _data["pmuSalesOrder"] !== undefined ? _data["pmuSalesOrder"] : null as any;
            this.pmuSalesOrderItem = _data["pmuSalesOrderItem"] !== undefined ? _data["pmuSalesOrderItem"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.motorType = _data["motorType"] !== undefined ? _data["motorType"] : null as any;
            this.motorTypeText = _data["motorTypeText"] !== undefined ? _data["motorTypeText"] : null as any;
            this.fileType = _data["fileType"] !== undefined ? _data["fileType"] : null as any;
            this.fileTypeText = _data["fileTypeText"] !== undefined ? _data["fileTypeText"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.expectedQty = _data["expectedQty"] !== undefined ? _data["expectedQty"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.requesterUserName = _data["requesterUserName"] !== undefined ? _data["requesterUserName"] : null as any;
            this.handlerEmail = _data["handlerEmail"] !== undefined ? _data["handlerEmail"] : null as any;
            this.handlerName = _data["handlerName"] !== undefined ? _data["handlerName"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): MotorCertHandlerUploadTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertHandlerUploadTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["saleNumber"] = this.saleNumber !== undefined ? this.saleNumber : null as any;
        data["saleRowNo"] = this.saleRowNo !== undefined ? this.saleRowNo : null as any;
        data["lsuSalesOrder"] = this.lsuSalesOrder !== undefined ? this.lsuSalesOrder : null as any;
        data["lsuItem"] = this.lsuItem !== undefined ? this.lsuItem : null as any;
        data["pmuSalesOrder"] = this.pmuSalesOrder !== undefined ? this.pmuSalesOrder : null as any;
        data["pmuSalesOrderItem"] = this.pmuSalesOrderItem !== undefined ? this.pmuSalesOrderItem : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["motorType"] = this.motorType !== undefined ? this.motorType : null as any;
        data["motorTypeText"] = this.motorTypeText !== undefined ? this.motorTypeText : null as any;
        data["fileType"] = this.fileType !== undefined ? this.fileType : null as any;
        data["fileTypeText"] = this.fileTypeText !== undefined ? this.fileTypeText : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["expectedQty"] = this.expectedQty !== undefined ? this.expectedQty : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["requesterUserName"] = this.requesterUserName !== undefined ? this.requesterUserName : null as any;
        data["handlerEmail"] = this.handlerEmail !== undefined ? this.handlerEmail : null as any;
        data["handlerName"] = this.handlerName !== undefined ? this.handlerName : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

export class MotorCertHandlerUploadTaskQueryInputDto {
    status!: MotorCertHandlerUploadTaskStatus;
    skipCount!: number;
    maxResultCount!: number;

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
        }
    }

    static fromJS(data: any): MotorCertHandlerUploadTaskQueryInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertHandlerUploadTaskQueryInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        return data;
    }
}

export class MotorCertHandlerUploadTaskQueryResultDto {
    totalCount!: number;
    items!: MotorCertHandlerUploadTaskDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MotorCertHandlerUploadTaskDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): MotorCertHandlerUploadTaskQueryResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertHandlerUploadTaskQueryResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 0 = Pending 1 = Done 2 = Cancelled */
export enum MotorCertHandlerUploadTaskStatus {
    Pending = 0,
    Done = 1,
    Cancelled = 2,
}

export class MotorCertManualUploadItemDto {
    id!: string;
    serialNumber!: string | null;
    saleNumber!: string | null;
    saleRowNo!: string | null;
    lsuSalesOrder!: string | null;
    lsuItem!: string | null;
    pmuSalesOrder!: string | null;
    pmuSalesOrderItem!: string | null;
    basicMotorModel!: string | null;
    motorType!: MotorType;
    motorTypeText!: string | null;
    hasVc148!: boolean;
    hasCert!: boolean;
    hasReport!: boolean;
    missingCert!: boolean;
    missingReport!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.saleNumber = _data["saleNumber"] !== undefined ? _data["saleNumber"] : null as any;
            this.saleRowNo = _data["saleRowNo"] !== undefined ? _data["saleRowNo"] : null as any;
            this.lsuSalesOrder = _data["lsuSalesOrder"] !== undefined ? _data["lsuSalesOrder"] : null as any;
            this.lsuItem = _data["lsuItem"] !== undefined ? _data["lsuItem"] : null as any;
            this.pmuSalesOrder = _data["pmuSalesOrder"] !== undefined ? _data["pmuSalesOrder"] : null as any;
            this.pmuSalesOrderItem = _data["pmuSalesOrderItem"] !== undefined ? _data["pmuSalesOrderItem"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.motorType = _data["motorType"] !== undefined ? _data["motorType"] : null as any;
            this.motorTypeText = _data["motorTypeText"] !== undefined ? _data["motorTypeText"] : null as any;
            this.hasVc148 = _data["hasVc148"] !== undefined ? _data["hasVc148"] : null as any;
            this.hasCert = _data["hasCert"] !== undefined ? _data["hasCert"] : null as any;
            this.hasReport = _data["hasReport"] !== undefined ? _data["hasReport"] : null as any;
            this.missingCert = _data["missingCert"] !== undefined ? _data["missingCert"] : null as any;
            this.missingReport = _data["missingReport"] !== undefined ? _data["missingReport"] : null as any;
        }
    }

    static fromJS(data: any): MotorCertManualUploadItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertManualUploadItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["saleNumber"] = this.saleNumber !== undefined ? this.saleNumber : null as any;
        data["saleRowNo"] = this.saleRowNo !== undefined ? this.saleRowNo : null as any;
        data["lsuSalesOrder"] = this.lsuSalesOrder !== undefined ? this.lsuSalesOrder : null as any;
        data["lsuItem"] = this.lsuItem !== undefined ? this.lsuItem : null as any;
        data["pmuSalesOrder"] = this.pmuSalesOrder !== undefined ? this.pmuSalesOrder : null as any;
        data["pmuSalesOrderItem"] = this.pmuSalesOrderItem !== undefined ? this.pmuSalesOrderItem : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["motorType"] = this.motorType !== undefined ? this.motorType : null as any;
        data["motorTypeText"] = this.motorTypeText !== undefined ? this.motorTypeText : null as any;
        data["hasVc148"] = this.hasVc148 !== undefined ? this.hasVc148 : null as any;
        data["hasCert"] = this.hasCert !== undefined ? this.hasCert : null as any;
        data["hasReport"] = this.hasReport !== undefined ? this.hasReport : null as any;
        data["missingCert"] = this.missingCert !== undefined ? this.missingCert : null as any;
        data["missingReport"] = this.missingReport !== undefined ? this.missingReport : null as any;
        return data;
    }
}

export class MotorCertManualUploadQueryInputDto {
    /** 序列号：单值模糊匹配（Contains），不支持逗号多值 */
    serialNumbers!: string | null;
    /** LSU/PMU（CSO/ISO）：模糊匹配 */
    saleNumber!: string | null;
    saleRowNo!: string | null;
    missingType!: MotorCertMissingFileType;
    skipCount!: number;
    maxResultCount!: number;

    init(_data?: any) {
        if (_data) {
            this.serialNumbers = _data["serialNumbers"] !== undefined ? _data["serialNumbers"] : null as any;
            this.saleNumber = _data["saleNumber"] !== undefined ? _data["saleNumber"] : null as any;
            this.saleRowNo = _data["saleRowNo"] !== undefined ? _data["saleRowNo"] : null as any;
            this.missingType = _data["missingType"] !== undefined ? _data["missingType"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
        }
    }

    static fromJS(data: any): MotorCertManualUploadQueryInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertManualUploadQueryInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumbers"] = this.serialNumbers !== undefined ? this.serialNumbers : null as any;
        data["saleNumber"] = this.saleNumber !== undefined ? this.saleNumber : null as any;
        data["saleRowNo"] = this.saleRowNo !== undefined ? this.saleRowNo : null as any;
        data["missingType"] = this.missingType !== undefined ? this.missingType : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        return data;
    }
}

export class MotorCertManualUploadQueryResultDto {
    totalCount!: number;
    items!: MotorCertManualUploadItemDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MotorCertManualUploadItemDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): MotorCertManualUploadQueryResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertManualUploadQueryResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 0 = All 1 = Cert 2 = Report 3 = Any */
export enum MotorCertMissingFileType {
    All = 0,
    Cert = 1,
    Report = 2,
    Any = 3,
}

/** 一级：订单头（OrderForm / 合同号） */
export class MotorCertOrderHeaderDto {
    orderFormId!: string;
    poNumber!: string | null;
    /** 无 MSP 合同/OrderForm 时，用 ISO（或 CSO）展开二级行；有 OrderForm 时可空。 */
    querySalesOrder!: string | null;
    customerCode!: string | null;
    customerName!: string | null;
    responsibleSalesName!: string | null;
    lineCount!: number;
    /** 一级不汇总（避免 Query 超时）；仅二级行有值 */
    totalSnCount!: number;
    /** 一级不汇总；仅二级行有值 */
    certAvailableCount!: number;
    /** 一级不汇总；仅二级行有值 */
    reportAvailableCount!: number;

    init(_data?: any) {
        if (_data) {
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.querySalesOrder = _data["querySalesOrder"] !== undefined ? _data["querySalesOrder"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.responsibleSalesName = _data["responsibleSalesName"] !== undefined ? _data["responsibleSalesName"] : null as any;
            this.lineCount = _data["lineCount"] !== undefined ? _data["lineCount"] : null as any;
            this.totalSnCount = _data["totalSnCount"] !== undefined ? _data["totalSnCount"] : null as any;
            this.certAvailableCount = _data["certAvailableCount"] !== undefined ? _data["certAvailableCount"] : null as any;
            this.reportAvailableCount = _data["reportAvailableCount"] !== undefined ? _data["reportAvailableCount"] : null as any;
        }
    }

    static fromJS(data: any): MotorCertOrderHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertOrderHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["querySalesOrder"] = this.querySalesOrder !== undefined ? this.querySalesOrder : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["responsibleSalesName"] = this.responsibleSalesName !== undefined ? this.responsibleSalesName : null as any;
        data["lineCount"] = this.lineCount !== undefined ? this.lineCount : null as any;
        data["totalSnCount"] = this.totalSnCount !== undefined ? this.totalSnCount : null as any;
        data["certAvailableCount"] = this.certAvailableCount !== undefined ? this.certAvailableCount : null as any;
        data["reportAvailableCount"] = this.reportAvailableCount !== undefined ? this.reportAvailableCount : null as any;
        return data;
    }
}

export class MotorCertOrderRowDto {
    rowKey!: string | null;
    saleNumber!: string | null;
    saleRowNo!: string | null;
    orderFormId!: string | null;
    productBasicMotorId!: string | null;
    orderInformationId!: string | null;
    lsuSalesOrder!: string | null;
    lsuItem!: string | null;
    pmuSalesOrder!: string | null;
    pmuSalesOrderItem!: string | null;
    basicMotorModel!: string | null;
    /** 订货台数（OI.LsuOrderQty），证书状态分母 */
    totalSnCount!: number;
    /** SapSnCreate 已同步 SN 数 */
    syncedSnCount!: number;
    /** Mapping 中满足合格证下载条件的 SN 数（分子） */
    certAvailableCount!: number;
    /** Mapping 中满足报告下载条件的 SN 数（分子） */
    reportAvailableCount!: number;
    orderStatusText!: string | null;
    motorType!: MotorType;
    hasVc148!: boolean;
    /** 备注等效需补出厂试验报告；费用车终态/人工上传解锁后为 false */
    showSupplementVc148!: boolean;
    /** 该行是否有 SN 已被费用车占用（占用中则不展示补报告按钮） */
    snOccupied!: boolean;
    canDownloadCert!: boolean;
    canDownloadReport!: boolean;
    showContactHandler!: boolean;
    /** 缺失处理列短文案：可点「联系责任人」时说明缺什么；不可点时说明为何不显示。 */
    missingHandlingText!: string | null;
    /** 缺失处理列 Tooltip 详细说明 */
    missingHandlingHint!: string | null;
    /** 电机类型文案（国产自制/国产外购/进口），便于对照为何不显示联系责任人 */
    motorTypeText!: string | null;
    /** L2 是否展示报告进度（仅需出厂试验报告的订单行） */
    showReportStatus!: boolean;
    /** 展开行附带的 SN（不扫 Blob） */
    snItems!: MotorCertSnItemDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.rowKey = _data["rowKey"] !== undefined ? _data["rowKey"] : null as any;
            this.saleNumber = _data["saleNumber"] !== undefined ? _data["saleNumber"] : null as any;
            this.saleRowNo = _data["saleRowNo"] !== undefined ? _data["saleRowNo"] : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.productBasicMotorId = _data["productBasicMotorId"] !== undefined ? _data["productBasicMotorId"] : null as any;
            this.orderInformationId = _data["orderInformationId"] !== undefined ? _data["orderInformationId"] : null as any;
            this.lsuSalesOrder = _data["lsuSalesOrder"] !== undefined ? _data["lsuSalesOrder"] : null as any;
            this.lsuItem = _data["lsuItem"] !== undefined ? _data["lsuItem"] : null as any;
            this.pmuSalesOrder = _data["pmuSalesOrder"] !== undefined ? _data["pmuSalesOrder"] : null as any;
            this.pmuSalesOrderItem = _data["pmuSalesOrderItem"] !== undefined ? _data["pmuSalesOrderItem"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.totalSnCount = _data["totalSnCount"] !== undefined ? _data["totalSnCount"] : null as any;
            this.syncedSnCount = _data["syncedSnCount"] !== undefined ? _data["syncedSnCount"] : null as any;
            this.certAvailableCount = _data["certAvailableCount"] !== undefined ? _data["certAvailableCount"] : null as any;
            this.reportAvailableCount = _data["reportAvailableCount"] !== undefined ? _data["reportAvailableCount"] : null as any;
            this.orderStatusText = _data["orderStatusText"] !== undefined ? _data["orderStatusText"] : null as any;
            this.motorType = _data["motorType"] !== undefined ? _data["motorType"] : null as any;
            this.hasVc148 = _data["hasVc148"] !== undefined ? _data["hasVc148"] : null as any;
            this.showSupplementVc148 = _data["showSupplementVc148"] !== undefined ? _data["showSupplementVc148"] : null as any;
            this.snOccupied = _data["snOccupied"] !== undefined ? _data["snOccupied"] : null as any;
            this.canDownloadCert = _data["canDownloadCert"] !== undefined ? _data["canDownloadCert"] : null as any;
            this.canDownloadReport = _data["canDownloadReport"] !== undefined ? _data["canDownloadReport"] : null as any;
            this.showContactHandler = _data["showContactHandler"] !== undefined ? _data["showContactHandler"] : null as any;
            this.missingHandlingText = _data["missingHandlingText"] !== undefined ? _data["missingHandlingText"] : null as any;
            this.missingHandlingHint = _data["missingHandlingHint"] !== undefined ? _data["missingHandlingHint"] : null as any;
            this.motorTypeText = _data["motorTypeText"] !== undefined ? _data["motorTypeText"] : null as any;
            this.showReportStatus = _data["showReportStatus"] !== undefined ? _data["showReportStatus"] : null as any;
            if (Array.isArray(_data["snItems"])) {
                this.snItems = [] as any;
                for (let item of _data["snItems"])
                    this.snItems!.push(MotorCertSnItemDto.fromJS(item));
            }
            else {
                this.snItems = null as any;
            }
        }
    }

    static fromJS(data: any): MotorCertOrderRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertOrderRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowKey"] = this.rowKey !== undefined ? this.rowKey : null as any;
        data["saleNumber"] = this.saleNumber !== undefined ? this.saleNumber : null as any;
        data["saleRowNo"] = this.saleRowNo !== undefined ? this.saleRowNo : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["productBasicMotorId"] = this.productBasicMotorId !== undefined ? this.productBasicMotorId : null as any;
        data["orderInformationId"] = this.orderInformationId !== undefined ? this.orderInformationId : null as any;
        data["lsuSalesOrder"] = this.lsuSalesOrder !== undefined ? this.lsuSalesOrder : null as any;
        data["lsuItem"] = this.lsuItem !== undefined ? this.lsuItem : null as any;
        data["pmuSalesOrder"] = this.pmuSalesOrder !== undefined ? this.pmuSalesOrder : null as any;
        data["pmuSalesOrderItem"] = this.pmuSalesOrderItem !== undefined ? this.pmuSalesOrderItem : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["totalSnCount"] = this.totalSnCount !== undefined ? this.totalSnCount : null as any;
        data["syncedSnCount"] = this.syncedSnCount !== undefined ? this.syncedSnCount : null as any;
        data["certAvailableCount"] = this.certAvailableCount !== undefined ? this.certAvailableCount : null as any;
        data["reportAvailableCount"] = this.reportAvailableCount !== undefined ? this.reportAvailableCount : null as any;
        data["orderStatusText"] = this.orderStatusText !== undefined ? this.orderStatusText : null as any;
        data["motorType"] = this.motorType !== undefined ? this.motorType : null as any;
        data["hasVc148"] = this.hasVc148 !== undefined ? this.hasVc148 : null as any;
        data["showSupplementVc148"] = this.showSupplementVc148 !== undefined ? this.showSupplementVc148 : null as any;
        data["snOccupied"] = this.snOccupied !== undefined ? this.snOccupied : null as any;
        data["canDownloadCert"] = this.canDownloadCert !== undefined ? this.canDownloadCert : null as any;
        data["canDownloadReport"] = this.canDownloadReport !== undefined ? this.canDownloadReport : null as any;
        data["showContactHandler"] = this.showContactHandler !== undefined ? this.showContactHandler : null as any;
        data["missingHandlingText"] = this.missingHandlingText !== undefined ? this.missingHandlingText : null as any;
        data["missingHandlingHint"] = this.missingHandlingHint !== undefined ? this.missingHandlingHint : null as any;
        data["motorTypeText"] = this.motorTypeText !== undefined ? this.motorTypeText : null as any;
        data["showReportStatus"] = this.showReportStatus !== undefined ? this.showReportStatus : null as any;
        if (Array.isArray(this.snItems)) {
            data["snItems"] = [];
            for (let item of this.snItems)
                data["snItems"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class MotorCertQueryInputDto {
    dnNumbers!: string | null;
    contractNumbers!: string | null;
    serialNumbers!: string | null;
    /** 发货/交货日期起（含）。L1 对应 OrderForm.CustomerExpectedDeliveryDate（客户期望交货日期） */
    deliveryDateStart!: moment.Moment | null;
    /** 发货/交货日期止（含）。L1 对应 OrderForm.CustomerExpectedDeliveryDate */
    deliveryDateEnd!: moment.Moment | null;
    skipCount!: number;
    maxResultCount!: number;

    init(_data?: any) {
        if (_data) {
            this.dnNumbers = _data["dnNumbers"] !== undefined ? _data["dnNumbers"] : null as any;
            this.contractNumbers = _data["contractNumbers"] !== undefined ? _data["contractNumbers"] : null as any;
            this.serialNumbers = _data["serialNumbers"] !== undefined ? _data["serialNumbers"] : null as any;
            this.deliveryDateStart = _data["deliveryDateStart"] ? moment(_data["deliveryDateStart"].toString()) : null as any;
            this.deliveryDateEnd = _data["deliveryDateEnd"] ? moment(_data["deliveryDateEnd"].toString()) : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
        }
    }

    static fromJS(data: any): MotorCertQueryInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertQueryInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dnNumbers"] = this.dnNumbers !== undefined ? this.dnNumbers : null as any;
        data["contractNumbers"] = this.contractNumbers !== undefined ? this.contractNumbers : null as any;
        data["serialNumbers"] = this.serialNumbers !== undefined ? this.serialNumbers : null as any;
        data["deliveryDateStart"] = this.deliveryDateStart ? this.deliveryDateStart.toISOString() : null as any;
        data["deliveryDateEnd"] = this.deliveryDateEnd ? this.deliveryDateEnd.toISOString() : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        return data;
    }
}

export class MotorCertQueryResultDto {
    totalCount!: number;
    /** 订单头列表（一级） */
    items!: MotorCertOrderHeaderDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MotorCertOrderHeaderDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): MotorCertQueryResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertQueryResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class MotorCertSnItemDto {
    serialNumber!: string | null;
    hasCert!: boolean;
    hasReport!: boolean;
    motorType!: MotorType;
    canDownloadCert!: boolean;
    canDownloadReport!: boolean;
    /** 当前订单行是否需要试验报告（正式 VC148 或备注关键字）。
false 时前端「测试报告」列显示「无」，不显示可下载/不可下载。 */
    requiresReport!: boolean;

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.hasCert = _data["hasCert"] !== undefined ? _data["hasCert"] : null as any;
            this.hasReport = _data["hasReport"] !== undefined ? _data["hasReport"] : null as any;
            this.motorType = _data["motorType"] !== undefined ? _data["motorType"] : null as any;
            this.canDownloadCert = _data["canDownloadCert"] !== undefined ? _data["canDownloadCert"] : null as any;
            this.canDownloadReport = _data["canDownloadReport"] !== undefined ? _data["canDownloadReport"] : null as any;
            this.requiresReport = _data["requiresReport"] !== undefined ? _data["requiresReport"] : null as any;
        }
    }

    static fromJS(data: any): MotorCertSnItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertSnItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["hasCert"] = this.hasCert !== undefined ? this.hasCert : null as any;
        data["hasReport"] = this.hasReport !== undefined ? this.hasReport : null as any;
        data["motorType"] = this.motorType !== undefined ? this.motorType : null as any;
        data["canDownloadCert"] = this.canDownloadCert !== undefined ? this.canDownloadCert : null as any;
        data["canDownloadReport"] = this.canDownloadReport !== undefined ? this.canDownloadReport : null as any;
        data["requiresReport"] = this.requiresReport !== undefined ? this.requiresReport : null as any;
        return data;
    }
}

/** 手动触发 MotorCertBlobImportFromBlobJob（按时间增量 List Blob → upsert Mapping） */
export class MotorCertTriggerBlobImportInputDto {
    /** 可选，覆盖默认批大小 */
    batchSize!: number | null;
    /** true：忽略检查点全量重扫 */
    forceFullScan!: boolean;

    init(_data?: any) {
        if (_data) {
            this.batchSize = _data["batchSize"] !== undefined ? _data["batchSize"] : null as any;
            this.forceFullScan = _data["forceFullScan"] !== undefined ? _data["forceFullScan"] : null as any;
        }
    }

    static fromJS(data: any): MotorCertTriggerBlobImportInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertTriggerBlobImportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchSize"] = this.batchSize !== undefined ? this.batchSize : null as any;
        data["forceFullScan"] = this.forceFullScan !== undefined ? this.forceFullScan : null as any;
        return data;
    }
}

export class MotorCertTriggerBlobImportResultDto {
    enqueued!: boolean;
    message!: string | null;

    init(_data?: any) {
        if (_data) {
            this.enqueued = _data["enqueued"] !== undefined ? _data["enqueued"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): MotorCertTriggerBlobImportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertTriggerBlobImportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enqueued"] = this.enqueued !== undefined ? this.enqueued : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }
}

/** 手动触发 MotorCertBlobAvailabilityScanJob */
export class MotorCertTriggerBlobScanInputDto {
    /** 可选，覆盖默认批大小 */
    batchSize!: number | null;
    /** 可选，覆盖窗口起点（含）；默认昨天 0 点 */
    sapSnCreateFrom!: moment.Moment | null;
    /** 可选，覆盖窗口终点（含）；默认当前时刻 */
    sapSnCreateTo!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.batchSize = _data["batchSize"] !== undefined ? _data["batchSize"] : null as any;
            this.sapSnCreateFrom = _data["sapSnCreateFrom"] ? moment(_data["sapSnCreateFrom"].toString()) : null as any;
            this.sapSnCreateTo = _data["sapSnCreateTo"] ? moment(_data["sapSnCreateTo"].toString()) : null as any;
        }
    }

    static fromJS(data: any): MotorCertTriggerBlobScanInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertTriggerBlobScanInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchSize"] = this.batchSize !== undefined ? this.batchSize : null as any;
        data["sapSnCreateFrom"] = this.sapSnCreateFrom ? this.sapSnCreateFrom.toISOString() : null as any;
        data["sapSnCreateTo"] = this.sapSnCreateTo ? this.sapSnCreateTo.toISOString() : null as any;
        return data;
    }
}

export class MotorCertTriggerBlobScanResultDto {
    enqueued!: boolean;
    sapSnCreateFrom!: moment.Moment;
    sapSnCreateTo!: moment.Moment;
    message!: string | null;

    init(_data?: any) {
        if (_data) {
            this.enqueued = _data["enqueued"] !== undefined ? _data["enqueued"] : null as any;
            this.sapSnCreateFrom = _data["sapSnCreateFrom"] ? moment(_data["sapSnCreateFrom"].toString()) : null as any;
            this.sapSnCreateTo = _data["sapSnCreateTo"] ? moment(_data["sapSnCreateTo"].toString()) : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): MotorCertTriggerBlobScanResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCertTriggerBlobScanResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enqueued"] = this.enqueued !== undefined ? this.enqueued : null as any;
        data["sapSnCreateFrom"] = this.sapSnCreateFrom ? this.sapSnCreateFrom.toISOString() : null as any;
        data["sapSnCreateTo"] = this.sapSnCreateTo ? this.sapSnCreateTo.toISOString() : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }
}

/** 1 = DomesticSelfMade 2 = DomesticPurchased 3 = Imported */
export enum MotorType {
    DomesticSelfMade = 1,
    DomesticPurchased = 2,
    Imported = 3,
}

/** 订单变更汇总输出 */
export class NewOrderChangeSummaryOutDto {
    /** const changeTypes = ['VC', '备注全', '交期变化', '总面价', '售价', '系数', 'TP', 'URL']; */
    changeTypes!: string[] | null;
    isoItem!: string | null;
    csoItem!: string | null;
    /** pmu订单号-ISO号 */
    internalSalesOrder!: string | null;
    /** LSU订单号-CSO号 */
    customerSalesOrder!: string | null;
    /** OMS单号 */
    omsOrderNumber!: string | null;
    /** 序列号-行号 */
    serialNumber!: number | null;
    oldProduct!: NewOrderChangeSummaryProductOutDto;
    newProduct!: NewOrderChangeSummaryProductOutDto;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["changeTypes"])) {
                this.changeTypes = [] as any;
                for (let item of _data["changeTypes"])
                    this.changeTypes!.push(item);
            }
            else {
                this.changeTypes = null as any;
            }
            this.isoItem = _data["isoItem"] !== undefined ? _data["isoItem"] : null as any;
            this.csoItem = _data["csoItem"] !== undefined ? _data["csoItem"] : null as any;
            this.internalSalesOrder = _data["internalSalesOrder"] !== undefined ? _data["internalSalesOrder"] : null as any;
            this.customerSalesOrder = _data["customerSalesOrder"] !== undefined ? _data["customerSalesOrder"] : null as any;
            this.omsOrderNumber = _data["omsOrderNumber"] !== undefined ? _data["omsOrderNumber"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.oldProduct = _data["oldProduct"] ? NewOrderChangeSummaryProductOutDto.fromJS(_data["oldProduct"]) : null as any;
            this.newProduct = _data["newProduct"] ? NewOrderChangeSummaryProductOutDto.fromJS(_data["newProduct"]) : null as any;
        }
    }

    static fromJS(data: any): NewOrderChangeSummaryOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewOrderChangeSummaryOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.changeTypes)) {
            data["changeTypes"] = [];
            for (let item of this.changeTypes)
                data["changeTypes"].push(item);
        }
        data["isoItem"] = this.isoItem !== undefined ? this.isoItem : null as any;
        data["csoItem"] = this.csoItem !== undefined ? this.csoItem : null as any;
        data["internalSalesOrder"] = this.internalSalesOrder !== undefined ? this.internalSalesOrder : null as any;
        data["customerSalesOrder"] = this.customerSalesOrder !== undefined ? this.customerSalesOrder : null as any;
        data["omsOrderNumber"] = this.omsOrderNumber !== undefined ? this.omsOrderNumber : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["oldProduct"] = this.oldProduct ? this.oldProduct.toJSON() : null as any;
        data["newProduct"] = this.newProduct ? this.newProduct.toJSON() : null as any;
        return data;
    }
}

/** 变更汇总信息产品行 */
export class NewOrderChangeSummaryProductOutDto {
    /** VC信息 */
    vc!: NewOrderChangeSummaryVcOutDto[] | null;
    /** 备注全 */
    remark!: string | null;
    /** 差异对比结果 */
    remarkDiff!: DiffResult[] | null;
    /** 系数 */
    multiplier!: string | null;
    /** 系数，是否显示 */
    multiplierVisible!: boolean;
    /** 售价 */
    salesPrice!: string | null;
    /** 售价，是否显示 */
    salesPriceVisible!: boolean;
    /** 短链接 */
    shortLink!: string | null;
    /** 短链接，是否显示 */
    shortLinkVisible!: boolean;
    /** TP总价 */
    transferPrice!: string | null;
    /** TP总价，是否显示 */
    transferPriceVisible!: boolean;
    /** TP单价 */
    unitTransferPrice!: string | null;
    /** TP单价，是否显示 */
    unitTransferPriceVisible!: boolean;
    /** 总面价 */
    totalUnitPrice!: string | null;
    /** 总面价，是否显示 */
    totalUnitPriceVisible!: boolean;
    /** 面价 */
    unitPrice!: string | null;
    /** 面价，是否显示 */
    unitPriceVisible!: boolean;
    /** 最终交期结果 */
    newCustomerExpectedDelivery!: string | null;
    /** 最终交期结果，是否显示 */
    newCustomerExpectedDeliveryVisible!: boolean;
    /** 商务最终确认价格 (单价) */
    enterUnitPrice!: number | null;
    /** 商务最终确认价格，是否显示 */
    enterUnitPriceVisible!: boolean;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vc"])) {
                this.vc = [] as any;
                for (let item of _data["vc"])
                    this.vc!.push(NewOrderChangeSummaryVcOutDto.fromJS(item));
            }
            else {
                this.vc = null as any;
            }
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            if (Array.isArray(_data["remarkDiff"])) {
                this.remarkDiff = [] as any;
                for (let item of _data["remarkDiff"])
                    this.remarkDiff!.push(DiffResult.fromJS(item));
            }
            else {
                this.remarkDiff = null as any;
            }
            this.multiplier = _data["multiplier"] !== undefined ? _data["multiplier"] : null as any;
            this.multiplierVisible = _data["multiplierVisible"] !== undefined ? _data["multiplierVisible"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.salesPriceVisible = _data["salesPriceVisible"] !== undefined ? _data["salesPriceVisible"] : null as any;
            this.shortLink = _data["shortLink"] !== undefined ? _data["shortLink"] : null as any;
            this.shortLinkVisible = _data["shortLinkVisible"] !== undefined ? _data["shortLinkVisible"] : null as any;
            this.transferPrice = _data["transferPrice"] !== undefined ? _data["transferPrice"] : null as any;
            this.transferPriceVisible = _data["transferPriceVisible"] !== undefined ? _data["transferPriceVisible"] : null as any;
            this.unitTransferPrice = _data["unitTransferPrice"] !== undefined ? _data["unitTransferPrice"] : null as any;
            this.unitTransferPriceVisible = _data["unitTransferPriceVisible"] !== undefined ? _data["unitTransferPriceVisible"] : null as any;
            this.totalUnitPrice = _data["totalUnitPrice"] !== undefined ? _data["totalUnitPrice"] : null as any;
            this.totalUnitPriceVisible = _data["totalUnitPriceVisible"] !== undefined ? _data["totalUnitPriceVisible"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceVisible = _data["unitPriceVisible"] !== undefined ? _data["unitPriceVisible"] : null as any;
            this.newCustomerExpectedDelivery = _data["newCustomerExpectedDelivery"] !== undefined ? _data["newCustomerExpectedDelivery"] : null as any;
            this.newCustomerExpectedDeliveryVisible = _data["newCustomerExpectedDeliveryVisible"] !== undefined ? _data["newCustomerExpectedDeliveryVisible"] : null as any;
            this.enterUnitPrice = _data["enterUnitPrice"] !== undefined ? _data["enterUnitPrice"] : null as any;
            this.enterUnitPriceVisible = _data["enterUnitPriceVisible"] !== undefined ? _data["enterUnitPriceVisible"] : null as any;
        }
    }

    static fromJS(data: any): NewOrderChangeSummaryProductOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewOrderChangeSummaryProductOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vc)) {
            data["vc"] = [];
            for (let item of this.vc)
                data["vc"].push(item ? item.toJSON() : null as any);
        }
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        if (Array.isArray(this.remarkDiff)) {
            data["remarkDiff"] = [];
            for (let item of this.remarkDiff)
                data["remarkDiff"].push(item ? item.toJSON() : null as any);
        }
        data["multiplier"] = this.multiplier !== undefined ? this.multiplier : null as any;
        data["multiplierVisible"] = this.multiplierVisible !== undefined ? this.multiplierVisible : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["salesPriceVisible"] = this.salesPriceVisible !== undefined ? this.salesPriceVisible : null as any;
        data["shortLink"] = this.shortLink !== undefined ? this.shortLink : null as any;
        data["shortLinkVisible"] = this.shortLinkVisible !== undefined ? this.shortLinkVisible : null as any;
        data["transferPrice"] = this.transferPrice !== undefined ? this.transferPrice : null as any;
        data["transferPriceVisible"] = this.transferPriceVisible !== undefined ? this.transferPriceVisible : null as any;
        data["unitTransferPrice"] = this.unitTransferPrice !== undefined ? this.unitTransferPrice : null as any;
        data["unitTransferPriceVisible"] = this.unitTransferPriceVisible !== undefined ? this.unitTransferPriceVisible : null as any;
        data["totalUnitPrice"] = this.totalUnitPrice !== undefined ? this.totalUnitPrice : null as any;
        data["totalUnitPriceVisible"] = this.totalUnitPriceVisible !== undefined ? this.totalUnitPriceVisible : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceVisible"] = this.unitPriceVisible !== undefined ? this.unitPriceVisible : null as any;
        data["newCustomerExpectedDelivery"] = this.newCustomerExpectedDelivery !== undefined ? this.newCustomerExpectedDelivery : null as any;
        data["newCustomerExpectedDeliveryVisible"] = this.newCustomerExpectedDeliveryVisible !== undefined ? this.newCustomerExpectedDeliveryVisible : null as any;
        data["enterUnitPrice"] = this.enterUnitPrice !== undefined ? this.enterUnitPrice : null as any;
        data["enterUnitPriceVisible"] = this.enterUnitPriceVisible !== undefined ? this.enterUnitPriceVisible : null as any;
        return data;
    }
}

/** vc信息 */
export class NewOrderChangeSummaryVcOutDto {
    /** 0默认,1是标红,2是蓝色,3是红色加红线 */
    styleType!: number;
    /** VCID */
    vcCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.styleType = _data["styleType"] !== undefined ? _data["styleType"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
        }
    }

    static fromJS(data: any): NewOrderChangeSummaryVcOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewOrderChangeSummaryVcOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["styleType"] = this.styleType !== undefined ? this.styleType : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        return data;
    }
}

/** 100 = Todo_Assignee 101 = Todo_Candidate 102 = Todo_Owner 200 = Todo_WillTimeoutIn2Days 201 = Todo_Timeout 202 = Todo_Timeout2Days 203 = Todo_TimeoutOver5Days 300 = Comment_External_CustomerCreated 301 = Comment_External_AbbUserCreated 302 = Comment_Internal_Created 330 = Comment_ReadReceiptCreated 400 = WorkOrder_NotCommitted_OverOneHour 401 = WorkOrder_Committed 402 = WorkOrder_Processing 405 = WorkOrder_Close 501 = ST_Task_Update */
export enum NotificationTypeEnum {
    Todo_Assignee = 100,
    Todo_Candidate = 101,
    Todo_Owner = 102,
    Todo_WillTimeoutIn2Days = 200,
    Todo_Timeout = 201,
    Todo_Timeout2Days = 202,
    Todo_TimeoutOver5Days = 203,
    Comment_External_CustomerCreated = 300,
    Comment_External_AbbUserCreated = 301,
    Comment_Internal_Created = 302,
    Comment_ReadReceiptCreated = 330,
    WorkOrder_NotCommitted_OverOneHour = 400,
    WorkOrder_Committed = 401,
    WorkOrder_Processing = 402,
    WorkOrder_Close = 405,
    ST_Task_Update = 501,
}

export class OISApproval {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    remarks!: string | null;
    auditStatus!: AuditStatus;
    approvedDateTime!: moment.Moment | null;
    orderFormId!: string;
    orderForm!: OrderForm;
    node!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.remarks = _data["remarks"] !== undefined ? _data["remarks"] : null as any;
            this.auditStatus = _data["auditStatus"] !== undefined ? _data["auditStatus"] : null as any;
            this.approvedDateTime = _data["approvedDateTime"] ? moment(_data["approvedDateTime"].toString()) : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.orderForm = _data["orderForm"] ? OrderForm.fromJS(_data["orderForm"]) : null as any;
            this.node = _data["node"] !== undefined ? _data["node"] : null as any;
        }
    }

    static fromJS(data: any): OISApproval {
        data = typeof data === 'object' ? data : {};
        let result = new OISApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["remarks"] = this.remarks !== undefined ? this.remarks : null as any;
        data["auditStatus"] = this.auditStatus !== undefined ? this.auditStatus : null as any;
        data["approvedDateTime"] = this.approvedDateTime ? this.approvedDateTime.toISOString() : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["orderForm"] = this.orderForm ? this.orderForm.toJSON() : null as any;
        data["node"] = this.node !== undefined ? this.node : null as any;
        return data;
    }
}

export class OISExportOrder {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    cscot!: string | null;
    customerRequiredDate!: string | null;
    receiveTime!: moment.Moment | null;
    country!: string | null;
    cScotOrderTime!: string | null;
    cScotSRU!: string | null;
    cScotOrderType!: string | null;
    wareHouseID!: string | null;
    orderType!: string | null;
    status!: string | null;
    salesPerson!: string | null;
    customerName!: string | null;
    contractNumber!: string | null;
    customerOrderNumber!: string | null;
    precalNo!: string | null;
    version!: number | null;
    batch!: number;
    reviewStatus!: EnumOISExportOrderReviewStatus;
    customerCode!: string | null;
    customerProductionNumber!: string | null;
    headerRemarkConfirmed!: string | null;
    isLocked!: boolean;
    lockDate!: moment.Moment | null;
    lastIssueTime!: moment.Moment | null;
    orderCode!: string | null;
    salesOrderNo!: string | null;
    products!: OISExportOrderProducts[] | null;
    oisExportOrderChangeOrderFormVersions!: OISExportOrderChangeOrderFormVersions;
    orderChangeProcessEntity!: OrderChangeProcessEntity;
    orderTerms!: string | null;
    portOfDestination!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.cscot = _data["cscot"] !== undefined ? _data["cscot"] : null as any;
            this.customerRequiredDate = _data["customerRequiredDate"] !== undefined ? _data["customerRequiredDate"] : null as any;
            this.receiveTime = _data["receiveTime"] ? moment(_data["receiveTime"].toString()) : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.cScotOrderTime = _data["cScotOrderTime"] !== undefined ? _data["cScotOrderTime"] : null as any;
            this.cScotSRU = _data["cScotSRU"] !== undefined ? _data["cScotSRU"] : null as any;
            this.cScotOrderType = _data["cScotOrderType"] !== undefined ? _data["cScotOrderType"] : null as any;
            this.wareHouseID = _data["wareHouseID"] !== undefined ? _data["wareHouseID"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.salesPerson = _data["salesPerson"] !== undefined ? _data["salesPerson"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.contractNumber = _data["contractNumber"] !== undefined ? _data["contractNumber"] : null as any;
            this.customerOrderNumber = _data["customerOrderNumber"] !== undefined ? _data["customerOrderNumber"] : null as any;
            this.precalNo = _data["precalNo"] !== undefined ? _data["precalNo"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.batch = _data["batch"] !== undefined ? _data["batch"] : null as any;
            this.reviewStatus = _data["reviewStatus"] !== undefined ? _data["reviewStatus"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerProductionNumber = _data["customerProductionNumber"] !== undefined ? _data["customerProductionNumber"] : null as any;
            this.headerRemarkConfirmed = _data["headerRemarkConfirmed"] !== undefined ? _data["headerRemarkConfirmed"] : null as any;
            this.isLocked = _data["isLocked"] !== undefined ? _data["isLocked"] : null as any;
            this.lockDate = _data["lockDate"] ? moment(_data["lockDate"].toString()) : null as any;
            this.lastIssueTime = _data["lastIssueTime"] ? moment(_data["lastIssueTime"].toString()) : null as any;
            this.orderCode = _data["orderCode"] !== undefined ? _data["orderCode"] : null as any;
            this.salesOrderNo = _data["salesOrderNo"] !== undefined ? _data["salesOrderNo"] : null as any;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(OISExportOrderProducts.fromJS(item));
            }
            else {
                this.products = null as any;
            }
            this.oisExportOrderChangeOrderFormVersions = _data["oisExportOrderChangeOrderFormVersions"] ? OISExportOrderChangeOrderFormVersions.fromJS(_data["oisExportOrderChangeOrderFormVersions"]) : null as any;
            this.orderChangeProcessEntity = _data["orderChangeProcessEntity"] ? OrderChangeProcessEntity.fromJS(_data["orderChangeProcessEntity"]) : null as any;
            this.orderTerms = _data["orderTerms"] !== undefined ? _data["orderTerms"] : null as any;
            this.portOfDestination = _data["portOfDestination"] !== undefined ? _data["portOfDestination"] : null as any;
        }
    }

    static fromJS(data: any): OISExportOrder {
        data = typeof data === 'object' ? data : {};
        let result = new OISExportOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["cscot"] = this.cscot !== undefined ? this.cscot : null as any;
        data["customerRequiredDate"] = this.customerRequiredDate !== undefined ? this.customerRequiredDate : null as any;
        data["receiveTime"] = this.receiveTime ? this.receiveTime.toISOString() : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["cScotOrderTime"] = this.cScotOrderTime !== undefined ? this.cScotOrderTime : null as any;
        data["cScotSRU"] = this.cScotSRU !== undefined ? this.cScotSRU : null as any;
        data["cScotOrderType"] = this.cScotOrderType !== undefined ? this.cScotOrderType : null as any;
        data["wareHouseID"] = this.wareHouseID !== undefined ? this.wareHouseID : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["salesPerson"] = this.salesPerson !== undefined ? this.salesPerson : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["contractNumber"] = this.contractNumber !== undefined ? this.contractNumber : null as any;
        data["customerOrderNumber"] = this.customerOrderNumber !== undefined ? this.customerOrderNumber : null as any;
        data["precalNo"] = this.precalNo !== undefined ? this.precalNo : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["batch"] = this.batch !== undefined ? this.batch : null as any;
        data["reviewStatus"] = this.reviewStatus !== undefined ? this.reviewStatus : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerProductionNumber"] = this.customerProductionNumber !== undefined ? this.customerProductionNumber : null as any;
        data["headerRemarkConfirmed"] = this.headerRemarkConfirmed !== undefined ? this.headerRemarkConfirmed : null as any;
        data["isLocked"] = this.isLocked !== undefined ? this.isLocked : null as any;
        data["lockDate"] = this.lockDate ? this.lockDate.toISOString() : null as any;
        data["lastIssueTime"] = this.lastIssueTime ? this.lastIssueTime.toISOString() : null as any;
        data["orderCode"] = this.orderCode !== undefined ? this.orderCode : null as any;
        data["salesOrderNo"] = this.salesOrderNo !== undefined ? this.salesOrderNo : null as any;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : null as any);
        }
        data["oisExportOrderChangeOrderFormVersions"] = this.oisExportOrderChangeOrderFormVersions ? this.oisExportOrderChangeOrderFormVersions.toJSON() : null as any;
        data["orderChangeProcessEntity"] = this.orderChangeProcessEntity ? this.orderChangeProcessEntity.toJSON() : null as any;
        data["orderTerms"] = this.orderTerms !== undefined ? this.orderTerms : null as any;
        data["portOfDestination"] = this.portOfDestination !== undefined ? this.portOfDestination : null as any;
        return data;
    }
}

export class OISExportOrderAttachmentDto {
    id!: string | null;
    /** 附件名 */
    attachmentName!: string | null;
    /** 附件链接 */
    attachmentUrl!: string | null;
    type!: ExportOrderAttachmentType;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.attachmentName = _data["attachmentName"] !== undefined ? _data["attachmentName"] : null as any;
            this.attachmentUrl = _data["attachmentUrl"] !== undefined ? _data["attachmentUrl"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): OISExportOrderAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISExportOrderAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["attachmentName"] = this.attachmentName !== undefined ? this.attachmentName : null as any;
        data["attachmentUrl"] = this.attachmentUrl !== undefined ? this.attachmentUrl : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }
}

export class OISExportOrderChangeOrderFormVersions {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    oisExportOrderId!: string;
    cscot!: string | null;
    version!: number | null;
    status!: EnumOrderChangeOrderFormVersionsStatus;
    mspjson!: string | null;
    approvalRemark!: string | null;
    taskProcessInstanceId!: string | null;
    taskServiceRequestId!: string | null;
    serviceTypeId!: string | null;
    batch!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.oisExportOrderId = _data["oisExportOrderId"] !== undefined ? _data["oisExportOrderId"] : null as any;
            this.cscot = _data["cscot"] !== undefined ? _data["cscot"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.mspjson = _data["mspjson"] !== undefined ? _data["mspjson"] : null as any;
            this.approvalRemark = _data["approvalRemark"] !== undefined ? _data["approvalRemark"] : null as any;
            this.taskProcessInstanceId = _data["taskProcessInstanceId"] !== undefined ? _data["taskProcessInstanceId"] : null as any;
            this.taskServiceRequestId = _data["taskServiceRequestId"] !== undefined ? _data["taskServiceRequestId"] : null as any;
            this.serviceTypeId = _data["serviceTypeId"] !== undefined ? _data["serviceTypeId"] : null as any;
            this.batch = _data["batch"] !== undefined ? _data["batch"] : null as any;
        }
    }

    static fromJS(data: any): OISExportOrderChangeOrderFormVersions {
        data = typeof data === 'object' ? data : {};
        let result = new OISExportOrderChangeOrderFormVersions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["oisExportOrderId"] = this.oisExportOrderId !== undefined ? this.oisExportOrderId : null as any;
        data["cscot"] = this.cscot !== undefined ? this.cscot : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["mspjson"] = this.mspjson !== undefined ? this.mspjson : null as any;
        data["approvalRemark"] = this.approvalRemark !== undefined ? this.approvalRemark : null as any;
        data["taskProcessInstanceId"] = this.taskProcessInstanceId !== undefined ? this.taskProcessInstanceId : null as any;
        data["taskServiceRequestId"] = this.taskServiceRequestId !== undefined ? this.taskServiceRequestId : null as any;
        data["serviceTypeId"] = this.serviceTypeId !== undefined ? this.serviceTypeId : null as any;
        data["batch"] = this.batch !== undefined ? this.batch : null as any;
        return data;
    }
}

export class OISExportOrderChangeProductBasicMotorChange {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    oisExportOrderChangeOrderFormVersionsId!: string;
    oisExportOrderProductsId!: string;
    changeType!: EnumChangeType;
    oldValue!: string | null;
    newValue!: string | null;
    cScotOrderItemId!: string | null;
    newRemark!: string | null;
    oldRemark!: string | null;
    oldMeaning!: string | null;
    newMeaning!: string | null;
    oisExportOrderProducts!: OISExportOrderProducts;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.oisExportOrderChangeOrderFormVersionsId = _data["oisExportOrderChangeOrderFormVersionsId"] !== undefined ? _data["oisExportOrderChangeOrderFormVersionsId"] : null as any;
            this.oisExportOrderProductsId = _data["oisExportOrderProductsId"] !== undefined ? _data["oisExportOrderProductsId"] : null as any;
            this.changeType = _data["changeType"] !== undefined ? _data["changeType"] : null as any;
            this.oldValue = _data["oldValue"] !== undefined ? _data["oldValue"] : null as any;
            this.newValue = _data["newValue"] !== undefined ? _data["newValue"] : null as any;
            this.cScotOrderItemId = _data["cScotOrderItemId"] !== undefined ? _data["cScotOrderItemId"] : null as any;
            this.newRemark = _data["newRemark"] !== undefined ? _data["newRemark"] : null as any;
            this.oldRemark = _data["oldRemark"] !== undefined ? _data["oldRemark"] : null as any;
            this.oldMeaning = _data["oldMeaning"] !== undefined ? _data["oldMeaning"] : null as any;
            this.newMeaning = _data["newMeaning"] !== undefined ? _data["newMeaning"] : null as any;
            this.oisExportOrderProducts = _data["oisExportOrderProducts"] ? OISExportOrderProducts.fromJS(_data["oisExportOrderProducts"]) : null as any;
        }
    }

    static fromJS(data: any): OISExportOrderChangeProductBasicMotorChange {
        data = typeof data === 'object' ? data : {};
        let result = new OISExportOrderChangeProductBasicMotorChange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["oisExportOrderChangeOrderFormVersionsId"] = this.oisExportOrderChangeOrderFormVersionsId !== undefined ? this.oisExportOrderChangeOrderFormVersionsId : null as any;
        data["oisExportOrderProductsId"] = this.oisExportOrderProductsId !== undefined ? this.oisExportOrderProductsId : null as any;
        data["changeType"] = this.changeType !== undefined ? this.changeType : null as any;
        data["oldValue"] = this.oldValue !== undefined ? this.oldValue : null as any;
        data["newValue"] = this.newValue !== undefined ? this.newValue : null as any;
        data["cScotOrderItemId"] = this.cScotOrderItemId !== undefined ? this.cScotOrderItemId : null as any;
        data["newRemark"] = this.newRemark !== undefined ? this.newRemark : null as any;
        data["oldRemark"] = this.oldRemark !== undefined ? this.oldRemark : null as any;
        data["oldMeaning"] = this.oldMeaning !== undefined ? this.oldMeaning : null as any;
        data["newMeaning"] = this.newMeaning !== undefined ? this.newMeaning : null as any;
        data["oisExportOrderProducts"] = this.oisExportOrderProducts ? this.oisExportOrderProducts.toJSON() : null as any;
        return data;
    }
}

export class OISExportOrderDataPermissionsDto {
    id!: number | null;
    /** 国家 */
    country!: string | null;
    userId!: number | null;
    userName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
        }
    }

    static fromJS(data: any): OISExportOrderDataPermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISExportOrderDataPermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        return data;
    }
}

export class OISExportOrderDictionary {
    id!: number;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    category!: EnumOISExportOrderDictionaryCategory;
    name!: string | null;
    code!: string | null;
    description!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): OISExportOrderDictionary {
        data = typeof data === 'object' ? data : {};
        let result = new OISExportOrderDictionary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }
}

export class OISExportOrderDictionaryDto {
    category!: number;
    name!: string | null;
    code!: string | null;

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
        }
    }

    static fromJS(data: any): OISExportOrderDictionaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISExportOrderDictionaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        return data;
    }
}

export class OISExportOrderDto {
    orderId!: string;
    headerRemarkConfirmed!: string | null;
    precalNo!: string | null;
    orderTerms!: string | null;
    portOfDestination!: string | null;
    revokeRemark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : null as any;
            this.headerRemarkConfirmed = _data["headerRemarkConfirmed"] !== undefined ? _data["headerRemarkConfirmed"] : null as any;
            this.precalNo = _data["precalNo"] !== undefined ? _data["precalNo"] : null as any;
            this.orderTerms = _data["orderTerms"] !== undefined ? _data["orderTerms"] : null as any;
            this.portOfDestination = _data["portOfDestination"] !== undefined ? _data["portOfDestination"] : null as any;
            this.revokeRemark = _data["revokeRemark"] !== undefined ? _data["revokeRemark"] : null as any;
        }
    }

    static fromJS(data: any): OISExportOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISExportOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId !== undefined ? this.orderId : null as any;
        data["headerRemarkConfirmed"] = this.headerRemarkConfirmed !== undefined ? this.headerRemarkConfirmed : null as any;
        data["precalNo"] = this.precalNo !== undefined ? this.precalNo : null as any;
        data["orderTerms"] = this.orderTerms !== undefined ? this.orderTerms : null as any;
        data["portOfDestination"] = this.portOfDestination !== undefined ? this.portOfDestination : null as any;
        data["revokeRemark"] = this.revokeRemark !== undefined ? this.revokeRemark : null as any;
        return data;
    }
}

export class OISExportOrderProductVCConfirmation {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    oisExportOrderProductsId!: string | null;
    vcID!: string | null;
    meaning!: string | null;
    remark!: string | null;
    updateStatus!: number;
    vcType!: number | null;
    vcOpenOrClose!: EnumOISExportOrderVcOpenOrClose;
    cScotOrderItemId!: string | null;
    category!: string | null;
    englishMeaning!: string | null;
    oisExportOrderProducts!: OISExportOrderProducts;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.oisExportOrderProductsId = _data["oisExportOrderProductsId"] !== undefined ? _data["oisExportOrderProductsId"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.updateStatus = _data["updateStatus"] !== undefined ? _data["updateStatus"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.vcOpenOrClose = _data["vcOpenOrClose"] !== undefined ? _data["vcOpenOrClose"] : null as any;
            this.cScotOrderItemId = _data["cScotOrderItemId"] !== undefined ? _data["cScotOrderItemId"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.oisExportOrderProducts = _data["oisExportOrderProducts"] ? OISExportOrderProducts.fromJS(_data["oisExportOrderProducts"]) : null as any;
        }
    }

    static fromJS(data: any): OISExportOrderProductVCConfirmation {
        data = typeof data === 'object' ? data : {};
        let result = new OISExportOrderProductVCConfirmation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["oisExportOrderProductsId"] = this.oisExportOrderProductsId !== undefined ? this.oisExportOrderProductsId : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["updateStatus"] = this.updateStatus !== undefined ? this.updateStatus : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcOpenOrClose"] = this.vcOpenOrClose !== undefined ? this.vcOpenOrClose : null as any;
        data["cScotOrderItemId"] = this.cScotOrderItemId !== undefined ? this.cScotOrderItemId : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["oisExportOrderProducts"] = this.oisExportOrderProducts ? this.oisExportOrderProducts.toJSON() : null as any;
        return data;
    }
}

export class OISExportOrderProducts {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    basicMotorCode!: string | null;
    number!: number | null;
    transferListPrice!: number | null;
    tpDiscount!: number | null;
    unitPrice!: number | null;
    totalPrice!: number | null;
    newTotalPrice!: number | null;
    currency!: string | null;
    describe!: string | null;
    prodType!: string | null;
    core!: string | null;
    power!: string | null;
    pole!: string | null;
    voltage!: string | null;
    frequency!: string | null;
    installType!: string | null;
    insulation!: string | null;
    safty!: string | null;
    support!: string | null;
    intSupport!: string | null;
    variantCode!: string | null;
    remark!: string | null;
    lineRemark!: string | null;
    cScotOrderItemId!: string | null;
    productClassification!: string | null;
    orderClassification!: string | null;
    oisExportOrderId!: string | null;
    powerUnit!: string | null;
    newUnitPrice!: number | null;
    customerExpectedDeliveryDate!: moment.Moment | null;
    wishedDate!: string | null;
    gssQuotationNumber!: string | null;
    mspOutputRemarks!: string | null;
    oisExportOrder!: OISExportOrder;
    productsVCs!: OISExportOrderProductsVC[] | null;
    productVCConfirmations!: OISExportOrderProductVCConfirmation[] | null;
    orderConfirMation!: string | null;
    excelVcRemarkConfirmedLength!: number | null;
    orderConfirMationComment!: string | null;
    techConfirmationNumber!: string | null;
    orderType!: string | null;
    orderChangeProductBasicProcessEntity!: OrderChangeProductBasicProcessEntity;
    customerProductionNumber!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.transferListPrice = _data["transferListPrice"] !== undefined ? _data["transferListPrice"] : null as any;
            this.tpDiscount = _data["tpDiscount"] !== undefined ? _data["tpDiscount"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.totalPrice = _data["totalPrice"] !== undefined ? _data["totalPrice"] : null as any;
            this.newTotalPrice = _data["newTotalPrice"] !== undefined ? _data["newTotalPrice"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
            this.describe = _data["describe"] !== undefined ? _data["describe"] : null as any;
            this.prodType = _data["prodType"] !== undefined ? _data["prodType"] : null as any;
            this.core = _data["core"] !== undefined ? _data["core"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.pole = _data["pole"] !== undefined ? _data["pole"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.installType = _data["installType"] !== undefined ? _data["installType"] : null as any;
            this.insulation = _data["insulation"] !== undefined ? _data["insulation"] : null as any;
            this.safty = _data["safty"] !== undefined ? _data["safty"] : null as any;
            this.support = _data["support"] !== undefined ? _data["support"] : null as any;
            this.intSupport = _data["intSupport"] !== undefined ? _data["intSupport"] : null as any;
            this.variantCode = _data["variantCode"] !== undefined ? _data["variantCode"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.lineRemark = _data["lineRemark"] !== undefined ? _data["lineRemark"] : null as any;
            this.cScotOrderItemId = _data["cScotOrderItemId"] !== undefined ? _data["cScotOrderItemId"] : null as any;
            this.productClassification = _data["productClassification"] !== undefined ? _data["productClassification"] : null as any;
            this.orderClassification = _data["orderClassification"] !== undefined ? _data["orderClassification"] : null as any;
            this.oisExportOrderId = _data["oisExportOrderId"] !== undefined ? _data["oisExportOrderId"] : null as any;
            this.powerUnit = _data["powerUnit"] !== undefined ? _data["powerUnit"] : null as any;
            this.newUnitPrice = _data["newUnitPrice"] !== undefined ? _data["newUnitPrice"] : null as any;
            this.customerExpectedDeliveryDate = _data["customerExpectedDeliveryDate"] ? moment(_data["customerExpectedDeliveryDate"].toString()) : null as any;
            this.wishedDate = _data["wishedDate"] !== undefined ? _data["wishedDate"] : null as any;
            this.gssQuotationNumber = _data["gssQuotationNumber"] !== undefined ? _data["gssQuotationNumber"] : null as any;
            this.mspOutputRemarks = _data["mspOutputRemarks"] !== undefined ? _data["mspOutputRemarks"] : null as any;
            this.oisExportOrder = _data["oisExportOrder"] ? OISExportOrder.fromJS(_data["oisExportOrder"]) : null as any;
            if (Array.isArray(_data["productsVCs"])) {
                this.productsVCs = [] as any;
                for (let item of _data["productsVCs"])
                    this.productsVCs!.push(OISExportOrderProductsVC.fromJS(item));
            }
            else {
                this.productsVCs = null as any;
            }
            if (Array.isArray(_data["productVCConfirmations"])) {
                this.productVCConfirmations = [] as any;
                for (let item of _data["productVCConfirmations"])
                    this.productVCConfirmations!.push(OISExportOrderProductVCConfirmation.fromJS(item));
            }
            else {
                this.productVCConfirmations = null as any;
            }
            this.orderConfirMation = _data["orderConfirMation"] !== undefined ? _data["orderConfirMation"] : null as any;
            this.excelVcRemarkConfirmedLength = _data["excelVcRemarkConfirmedLength"] !== undefined ? _data["excelVcRemarkConfirmedLength"] : null as any;
            this.orderConfirMationComment = _data["orderConfirMationComment"] !== undefined ? _data["orderConfirMationComment"] : null as any;
            this.techConfirmationNumber = _data["techConfirmationNumber"] !== undefined ? _data["techConfirmationNumber"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.orderChangeProductBasicProcessEntity = _data["orderChangeProductBasicProcessEntity"] ? OrderChangeProductBasicProcessEntity.fromJS(_data["orderChangeProductBasicProcessEntity"]) : null as any;
            this.customerProductionNumber = _data["customerProductionNumber"] !== undefined ? _data["customerProductionNumber"] : null as any;
        }
    }

    static fromJS(data: any): OISExportOrderProducts {
        data = typeof data === 'object' ? data : {};
        let result = new OISExportOrderProducts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["transferListPrice"] = this.transferListPrice !== undefined ? this.transferListPrice : null as any;
        data["tpDiscount"] = this.tpDiscount !== undefined ? this.tpDiscount : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["totalPrice"] = this.totalPrice !== undefined ? this.totalPrice : null as any;
        data["newTotalPrice"] = this.newTotalPrice !== undefined ? this.newTotalPrice : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        data["describe"] = this.describe !== undefined ? this.describe : null as any;
        data["prodType"] = this.prodType !== undefined ? this.prodType : null as any;
        data["core"] = this.core !== undefined ? this.core : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["pole"] = this.pole !== undefined ? this.pole : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["installType"] = this.installType !== undefined ? this.installType : null as any;
        data["insulation"] = this.insulation !== undefined ? this.insulation : null as any;
        data["safty"] = this.safty !== undefined ? this.safty : null as any;
        data["support"] = this.support !== undefined ? this.support : null as any;
        data["intSupport"] = this.intSupport !== undefined ? this.intSupport : null as any;
        data["variantCode"] = this.variantCode !== undefined ? this.variantCode : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["lineRemark"] = this.lineRemark !== undefined ? this.lineRemark : null as any;
        data["cScotOrderItemId"] = this.cScotOrderItemId !== undefined ? this.cScotOrderItemId : null as any;
        data["productClassification"] = this.productClassification !== undefined ? this.productClassification : null as any;
        data["orderClassification"] = this.orderClassification !== undefined ? this.orderClassification : null as any;
        data["oisExportOrderId"] = this.oisExportOrderId !== undefined ? this.oisExportOrderId : null as any;
        data["powerUnit"] = this.powerUnit !== undefined ? this.powerUnit : null as any;
        data["newUnitPrice"] = this.newUnitPrice !== undefined ? this.newUnitPrice : null as any;
        data["customerExpectedDeliveryDate"] = this.customerExpectedDeliveryDate ? this.customerExpectedDeliveryDate.toISOString() : null as any;
        data["wishedDate"] = this.wishedDate !== undefined ? this.wishedDate : null as any;
        data["gssQuotationNumber"] = this.gssQuotationNumber !== undefined ? this.gssQuotationNumber : null as any;
        data["mspOutputRemarks"] = this.mspOutputRemarks !== undefined ? this.mspOutputRemarks : null as any;
        data["oisExportOrder"] = this.oisExportOrder ? this.oisExportOrder.toJSON() : null as any;
        if (Array.isArray(this.productsVCs)) {
            data["productsVCs"] = [];
            for (let item of this.productsVCs)
                data["productsVCs"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.productVCConfirmations)) {
            data["productVCConfirmations"] = [];
            for (let item of this.productVCConfirmations)
                data["productVCConfirmations"].push(item ? item.toJSON() : null as any);
        }
        data["orderConfirMation"] = this.orderConfirMation !== undefined ? this.orderConfirMation : null as any;
        data["excelVcRemarkConfirmedLength"] = this.excelVcRemarkConfirmedLength !== undefined ? this.excelVcRemarkConfirmedLength : null as any;
        data["orderConfirMationComment"] = this.orderConfirMationComment !== undefined ? this.orderConfirMationComment : null as any;
        data["techConfirmationNumber"] = this.techConfirmationNumber !== undefined ? this.techConfirmationNumber : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["orderChangeProductBasicProcessEntity"] = this.orderChangeProductBasicProcessEntity ? this.orderChangeProductBasicProcessEntity.toJSON() : null as any;
        data["customerProductionNumber"] = this.customerProductionNumber !== undefined ? this.customerProductionNumber : null as any;
        return data;
    }
}

export class OISExportOrderProductsDto {
    id!: string;
    /** 电机 */
    basicMotorCode!: string | null;
    /** 数量 */
    number!: number | null;
    /** 面价 */
    transferListPrice!: string | null;
    /** TP系数 */
    tpDiscount!: number;
    /** 单价 */
    unitPrice!: number | null;
    /** 总价 */
    totalPrice!: number | null;
    /** 币种 */
    currency!: string | null;
    /** 描述 */
    describe!: string | null;
    /** 产品系列 */
    prodType!: string | null;
    /** 机座 */
    core!: string | null;
    /** 功率 */
    power!: string | null;
    /** 功率单位 */
    powerUnit!: string | null;
    /** 极数 */
    pole!: string | null;
    /** 电压 */
    voltage!: string | null;
    /** 频率 */
    frequency!: string | null;
    /** 安装类型 */
    installType!: string | null;
    /** 绝缘等级 */
    insulation!: string | null;
    /** 防护等级 */
    safty!: string | null;
    /** 机座2 */
    support!: string | null;
    /** 机座 */
    intSupport!: string | null;
    /** VC */
    variantCode!: string | null;
    /** 备注 */
    remark!: string | null;
    /** 行备注 */
    lineRemark!: string | null;
    cScotOrderItemId!: string | null;
    productClassification!: string | null;
    orderClassification!: string | null;
    oisExportOrderProductsId!: string | null;
    exportOrderProductsVCs!: OISExportOrderProductsVC[] | null;
    productVCConfirmations!: OISExportOrderProductVCConfirmation[] | null;
    /** 订单确认 */
    orderConfirMation!: string | null;
    /** VC是否增减 */
    vcIncreased!: string | null;
    /** 增加/减少的VC */
    vcAmountChange!: string | null;
    /** 价格是否变动 */
    priceChange!: string | null;
    /** 新单价 */
    newPrice!: number | null;
    /** header备注 */
    headerRemarkConfirmed!: string | null;
    /** 行备注 */
    lineRemarkConfirmed!: string | null;
    /** 客户期望交货期 */
    customerExpectedDeliveryDate!: moment.Moment | null;
    /** 客户期望交货期字符串 */
    readonly customerExpectedDeliveryDateString!: string | null;
    /** MSP输出备注 */
    mspOutputRemarks!: string | null;
    /** 新价格 */
    newUnitPrice!: number | null;
    /** 检查excel 导入产品长度 */
    excelVcRemarkConfirmedLength!: number | null;
    orderConfirMationComment!: string | null;
    /** 客户特定备注 */
    techConfirmationNumber!: string | null;
    gssQuotationNumber!: string | null;
    isLocked!: boolean | null;
    wishedDate!: string | null;
    newTotalPrice!: number | null;
    orderChangeProductBasicProcessEntity!: OrderChangeProductBasicProcessEntity;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.transferListPrice = _data["transferListPrice"] !== undefined ? _data["transferListPrice"] : null as any;
            this.tpDiscount = _data["tpDiscount"] !== undefined ? _data["tpDiscount"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.totalPrice = _data["totalPrice"] !== undefined ? _data["totalPrice"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
            this.describe = _data["describe"] !== undefined ? _data["describe"] : null as any;
            this.prodType = _data["prodType"] !== undefined ? _data["prodType"] : null as any;
            this.core = _data["core"] !== undefined ? _data["core"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.powerUnit = _data["powerUnit"] !== undefined ? _data["powerUnit"] : null as any;
            this.pole = _data["pole"] !== undefined ? _data["pole"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.installType = _data["installType"] !== undefined ? _data["installType"] : null as any;
            this.insulation = _data["insulation"] !== undefined ? _data["insulation"] : null as any;
            this.safty = _data["safty"] !== undefined ? _data["safty"] : null as any;
            this.support = _data["support"] !== undefined ? _data["support"] : null as any;
            this.intSupport = _data["intSupport"] !== undefined ? _data["intSupport"] : null as any;
            this.variantCode = _data["variantCode"] !== undefined ? _data["variantCode"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.lineRemark = _data["lineRemark"] !== undefined ? _data["lineRemark"] : null as any;
            this.cScotOrderItemId = _data["cScotOrderItemId"] !== undefined ? _data["cScotOrderItemId"] : null as any;
            this.productClassification = _data["productClassification"] !== undefined ? _data["productClassification"] : null as any;
            this.orderClassification = _data["orderClassification"] !== undefined ? _data["orderClassification"] : null as any;
            this.oisExportOrderProductsId = _data["oisExportOrderProductsId"] !== undefined ? _data["oisExportOrderProductsId"] : null as any;
            if (Array.isArray(_data["exportOrderProductsVCs"])) {
                this.exportOrderProductsVCs = [] as any;
                for (let item of _data["exportOrderProductsVCs"])
                    this.exportOrderProductsVCs!.push(OISExportOrderProductsVC.fromJS(item));
            }
            else {
                this.exportOrderProductsVCs = null as any;
            }
            if (Array.isArray(_data["productVCConfirmations"])) {
                this.productVCConfirmations = [] as any;
                for (let item of _data["productVCConfirmations"])
                    this.productVCConfirmations!.push(OISExportOrderProductVCConfirmation.fromJS(item));
            }
            else {
                this.productVCConfirmations = null as any;
            }
            this.orderConfirMation = _data["orderConfirMation"] !== undefined ? _data["orderConfirMation"] : null as any;
            this.vcIncreased = _data["vcIncreased"] !== undefined ? _data["vcIncreased"] : null as any;
            this.vcAmountChange = _data["vcAmountChange"] !== undefined ? _data["vcAmountChange"] : null as any;
            this.priceChange = _data["priceChange"] !== undefined ? _data["priceChange"] : null as any;
            this.newPrice = _data["newPrice"] !== undefined ? _data["newPrice"] : null as any;
            this.headerRemarkConfirmed = _data["headerRemarkConfirmed"] !== undefined ? _data["headerRemarkConfirmed"] : null as any;
            this.lineRemarkConfirmed = _data["lineRemarkConfirmed"] !== undefined ? _data["lineRemarkConfirmed"] : null as any;
            this.customerExpectedDeliveryDate = _data["customerExpectedDeliveryDate"] ? moment(_data["customerExpectedDeliveryDate"].toString()) : null as any;
            (this as any).customerExpectedDeliveryDateString = _data["customerExpectedDeliveryDateString"] !== undefined ? _data["customerExpectedDeliveryDateString"] : null as any;
            this.mspOutputRemarks = _data["mspOutputRemarks"] !== undefined ? _data["mspOutputRemarks"] : null as any;
            this.newUnitPrice = _data["newUnitPrice"] !== undefined ? _data["newUnitPrice"] : null as any;
            this.excelVcRemarkConfirmedLength = _data["excelVcRemarkConfirmedLength"] !== undefined ? _data["excelVcRemarkConfirmedLength"] : null as any;
            this.orderConfirMationComment = _data["orderConfirMationComment"] !== undefined ? _data["orderConfirMationComment"] : null as any;
            this.techConfirmationNumber = _data["techConfirmationNumber"] !== undefined ? _data["techConfirmationNumber"] : null as any;
            this.gssQuotationNumber = _data["gssQuotationNumber"] !== undefined ? _data["gssQuotationNumber"] : null as any;
            this.isLocked = _data["isLocked"] !== undefined ? _data["isLocked"] : null as any;
            this.wishedDate = _data["wishedDate"] !== undefined ? _data["wishedDate"] : null as any;
            this.newTotalPrice = _data["newTotalPrice"] !== undefined ? _data["newTotalPrice"] : null as any;
            this.orderChangeProductBasicProcessEntity = _data["orderChangeProductBasicProcessEntity"] ? OrderChangeProductBasicProcessEntity.fromJS(_data["orderChangeProductBasicProcessEntity"]) : null as any;
        }
    }

    static fromJS(data: any): OISExportOrderProductsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISExportOrderProductsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["transferListPrice"] = this.transferListPrice !== undefined ? this.transferListPrice : null as any;
        data["tpDiscount"] = this.tpDiscount !== undefined ? this.tpDiscount : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["totalPrice"] = this.totalPrice !== undefined ? this.totalPrice : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        data["describe"] = this.describe !== undefined ? this.describe : null as any;
        data["prodType"] = this.prodType !== undefined ? this.prodType : null as any;
        data["core"] = this.core !== undefined ? this.core : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["powerUnit"] = this.powerUnit !== undefined ? this.powerUnit : null as any;
        data["pole"] = this.pole !== undefined ? this.pole : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["installType"] = this.installType !== undefined ? this.installType : null as any;
        data["insulation"] = this.insulation !== undefined ? this.insulation : null as any;
        data["safty"] = this.safty !== undefined ? this.safty : null as any;
        data["support"] = this.support !== undefined ? this.support : null as any;
        data["intSupport"] = this.intSupport !== undefined ? this.intSupport : null as any;
        data["variantCode"] = this.variantCode !== undefined ? this.variantCode : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["lineRemark"] = this.lineRemark !== undefined ? this.lineRemark : null as any;
        data["cScotOrderItemId"] = this.cScotOrderItemId !== undefined ? this.cScotOrderItemId : null as any;
        data["productClassification"] = this.productClassification !== undefined ? this.productClassification : null as any;
        data["orderClassification"] = this.orderClassification !== undefined ? this.orderClassification : null as any;
        data["oisExportOrderProductsId"] = this.oisExportOrderProductsId !== undefined ? this.oisExportOrderProductsId : null as any;
        if (Array.isArray(this.exportOrderProductsVCs)) {
            data["exportOrderProductsVCs"] = [];
            for (let item of this.exportOrderProductsVCs)
                data["exportOrderProductsVCs"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.productVCConfirmations)) {
            data["productVCConfirmations"] = [];
            for (let item of this.productVCConfirmations)
                data["productVCConfirmations"].push(item ? item.toJSON() : null as any);
        }
        data["orderConfirMation"] = this.orderConfirMation !== undefined ? this.orderConfirMation : null as any;
        data["vcIncreased"] = this.vcIncreased !== undefined ? this.vcIncreased : null as any;
        data["vcAmountChange"] = this.vcAmountChange !== undefined ? this.vcAmountChange : null as any;
        data["priceChange"] = this.priceChange !== undefined ? this.priceChange : null as any;
        data["newPrice"] = this.newPrice !== undefined ? this.newPrice : null as any;
        data["headerRemarkConfirmed"] = this.headerRemarkConfirmed !== undefined ? this.headerRemarkConfirmed : null as any;
        data["lineRemarkConfirmed"] = this.lineRemarkConfirmed !== undefined ? this.lineRemarkConfirmed : null as any;
        data["customerExpectedDeliveryDate"] = this.customerExpectedDeliveryDate ? this.customerExpectedDeliveryDate.toISOString() : null as any;
        data["customerExpectedDeliveryDateString"] = this.customerExpectedDeliveryDateString !== undefined ? this.customerExpectedDeliveryDateString : null as any;
        data["mspOutputRemarks"] = this.mspOutputRemarks !== undefined ? this.mspOutputRemarks : null as any;
        data["newUnitPrice"] = this.newUnitPrice !== undefined ? this.newUnitPrice : null as any;
        data["excelVcRemarkConfirmedLength"] = this.excelVcRemarkConfirmedLength !== undefined ? this.excelVcRemarkConfirmedLength : null as any;
        data["orderConfirMationComment"] = this.orderConfirMationComment !== undefined ? this.orderConfirMationComment : null as any;
        data["techConfirmationNumber"] = this.techConfirmationNumber !== undefined ? this.techConfirmationNumber : null as any;
        data["gssQuotationNumber"] = this.gssQuotationNumber !== undefined ? this.gssQuotationNumber : null as any;
        data["isLocked"] = this.isLocked !== undefined ? this.isLocked : null as any;
        data["wishedDate"] = this.wishedDate !== undefined ? this.wishedDate : null as any;
        data["newTotalPrice"] = this.newTotalPrice !== undefined ? this.newTotalPrice : null as any;
        data["orderChangeProductBasicProcessEntity"] = this.orderChangeProductBasicProcessEntity ? this.orderChangeProductBasicProcessEntity.toJSON() : null as any;
        return data;
    }
}

export class OISExportOrderProductsDtoPagedResultDto {
    items!: OISExportOrderProductsDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OISExportOrderProductsDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): OISExportOrderProductsDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISExportOrderProductsDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class OISExportOrderProductsVC {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    oisExportOrderProductsId!: string;
    vcid!: string | null;
    meaning!: string | null;
    remark!: string | null;
    vcType!: number | null;
    vcOpenOrClose!: EnumOISExportOrderVcOpenOrClose;
    cScotOrderItemId!: string | null;
    category!: string | null;
    englishMeaning!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.oisExportOrderProductsId = _data["oisExportOrderProductsId"] !== undefined ? _data["oisExportOrderProductsId"] : null as any;
            this.vcid = _data["vcid"] !== undefined ? _data["vcid"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.vcOpenOrClose = _data["vcOpenOrClose"] !== undefined ? _data["vcOpenOrClose"] : null as any;
            this.cScotOrderItemId = _data["cScotOrderItemId"] !== undefined ? _data["cScotOrderItemId"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
        }
    }

    static fromJS(data: any): OISExportOrderProductsVC {
        data = typeof data === 'object' ? data : {};
        let result = new OISExportOrderProductsVC();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["oisExportOrderProductsId"] = this.oisExportOrderProductsId !== undefined ? this.oisExportOrderProductsId : null as any;
        data["vcid"] = this.vcid !== undefined ? this.vcid : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcOpenOrClose"] = this.vcOpenOrClose !== undefined ? this.vcOpenOrClose : null as any;
        data["cScotOrderItemId"] = this.cScotOrderItemId !== undefined ? this.cScotOrderItemId : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        return data;
    }
}

export class OISExportOrderReviewDto {
    id!: string;
    /** 审核人ID */
    approverUserId!: number | null;
    /** 审核人 */
    approverUserName!: string | null;
    /** 审核意见 */
    comments!: string | null;
    approvalStatus!: EnumOISExportOrderReviewStatus;
    /** 审核状态 */
    readonly approvalStatusName!: string | null;
    /** 创建时间 */
    creationTime!: moment.Moment | null;
    readonly creationTimeString!: string | null;
    creatorUserId!: number | null;
    /** 创建人 */
    creatorUserName!: string | null;
    /** 审核人 */
    lastModifierUserId!: number | null;
    /** 审核人 */
    lastModifierUserName!: string | null;
    /** 审核节点 */
    approvalNode!: string | null;
    lastModificationTime!: moment.Moment | null;
    readonly lastModificationTimeString!: string | null;
    approvalRole!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.approverUserId = _data["approverUserId"] !== undefined ? _data["approverUserId"] : null as any;
            this.approverUserName = _data["approverUserName"] !== undefined ? _data["approverUserName"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
            (this as any).approvalStatusName = _data["approvalStatusName"] !== undefined ? _data["approvalStatusName"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            (this as any).creationTimeString = _data["creationTimeString"] !== undefined ? _data["creationTimeString"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.creatorUserName = _data["creatorUserName"] !== undefined ? _data["creatorUserName"] : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.lastModifierUserName = _data["lastModifierUserName"] !== undefined ? _data["lastModifierUserName"] : null as any;
            this.approvalNode = _data["approvalNode"] !== undefined ? _data["approvalNode"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            (this as any).lastModificationTimeString = _data["lastModificationTimeString"] !== undefined ? _data["lastModificationTimeString"] : null as any;
            this.approvalRole = _data["approvalRole"] !== undefined ? _data["approvalRole"] : null as any;
        }
    }

    static fromJS(data: any): OISExportOrderReviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISExportOrderReviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["approverUserId"] = this.approverUserId !== undefined ? this.approverUserId : null as any;
        data["approverUserName"] = this.approverUserName !== undefined ? this.approverUserName : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        data["approvalStatusName"] = this.approvalStatusName !== undefined ? this.approvalStatusName : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creationTimeString"] = this.creationTimeString !== undefined ? this.creationTimeString : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["creatorUserName"] = this.creatorUserName !== undefined ? this.creatorUserName : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["lastModifierUserName"] = this.lastModifierUserName !== undefined ? this.lastModifierUserName : null as any;
        data["approvalNode"] = this.approvalNode !== undefined ? this.approvalNode : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModificationTimeString"] = this.lastModificationTimeString !== undefined ? this.lastModificationTimeString : null as any;
        data["approvalRole"] = this.approvalRole !== undefined ? this.approvalRole : null as any;
        return data;
    }
}

export class OISOrderFormAutomateCheckItemAddDto {
    /** 模块名称 */
    moduleName!: string | null;
    /** 项目名称 */
    itemName!: string | null;
    /** 项目描述 */
    itemContent!: string | null;
    /** 是否启用 */
    isEnable!: boolean;
    /** 错误提示 */
    errorMsg!: string | null;
    /** 级别（整单，产品行） */
    levels!: string | null;

    init(_data?: any) {
        if (_data) {
            this.moduleName = _data["moduleName"] !== undefined ? _data["moduleName"] : null as any;
            this.itemName = _data["itemName"] !== undefined ? _data["itemName"] : null as any;
            this.itemContent = _data["itemContent"] !== undefined ? _data["itemContent"] : null as any;
            this.isEnable = _data["isEnable"] !== undefined ? _data["isEnable"] : null as any;
            this.errorMsg = _data["errorMsg"] !== undefined ? _data["errorMsg"] : null as any;
            this.levels = _data["levels"] !== undefined ? _data["levels"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateCheckItemAddDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateCheckItemAddDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleName"] = this.moduleName !== undefined ? this.moduleName : null as any;
        data["itemName"] = this.itemName !== undefined ? this.itemName : null as any;
        data["itemContent"] = this.itemContent !== undefined ? this.itemContent : null as any;
        data["isEnable"] = this.isEnable !== undefined ? this.isEnable : null as any;
        data["errorMsg"] = this.errorMsg !== undefined ? this.errorMsg : null as any;
        data["levels"] = this.levels !== undefined ? this.levels : null as any;
        return data;
    }
}

export class OISOrderFormAutomateCheckItemEditDto {
    /** 模块名称 */
    moduleName!: string | null;
    /** 项目名称 */
    itemName!: string | null;
    /** 项目描述 */
    itemContent!: string | null;
    /** 是否启用 */
    isEnable!: boolean;
    /** 错误提示 */
    errorMsg!: string | null;
    /** 级别（整单，产品行） */
    levels!: string | null;
    id!: string;

    init(_data?: any) {
        if (_data) {
            this.moduleName = _data["moduleName"] !== undefined ? _data["moduleName"] : null as any;
            this.itemName = _data["itemName"] !== undefined ? _data["itemName"] : null as any;
            this.itemContent = _data["itemContent"] !== undefined ? _data["itemContent"] : null as any;
            this.isEnable = _data["isEnable"] !== undefined ? _data["isEnable"] : null as any;
            this.errorMsg = _data["errorMsg"] !== undefined ? _data["errorMsg"] : null as any;
            this.levels = _data["levels"] !== undefined ? _data["levels"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateCheckItemEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateCheckItemEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleName"] = this.moduleName !== undefined ? this.moduleName : null as any;
        data["itemName"] = this.itemName !== undefined ? this.itemName : null as any;
        data["itemContent"] = this.itemContent !== undefined ? this.itemContent : null as any;
        data["isEnable"] = this.isEnable !== undefined ? this.isEnable : null as any;
        data["errorMsg"] = this.errorMsg !== undefined ? this.errorMsg : null as any;
        data["levels"] = this.levels !== undefined ? this.levels : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

/** 自动审单检查项 */
export class OISOrderFormAutomateCheckItemPage {
    id!: string;
    /** 模块名称 */
    moduleName!: string | null;
    /** 项目名称 */
    itemName!: string | null;
    /** 项目描述 */
    itemContent!: string | null;
    /** 错误提醒 */
    errorMsg!: string | null;
    /** 级别（整单，产品行） */
    levels!: string | null;
    /** 是否启用 */
    isEnable!: boolean | null;
    readonly isEnableTxt!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.moduleName = _data["moduleName"] !== undefined ? _data["moduleName"] : null as any;
            this.itemName = _data["itemName"] !== undefined ? _data["itemName"] : null as any;
            this.itemContent = _data["itemContent"] !== undefined ? _data["itemContent"] : null as any;
            this.errorMsg = _data["errorMsg"] !== undefined ? _data["errorMsg"] : null as any;
            this.levels = _data["levels"] !== undefined ? _data["levels"] : null as any;
            this.isEnable = _data["isEnable"] !== undefined ? _data["isEnable"] : null as any;
            (this as any).isEnableTxt = _data["isEnableTxt"] !== undefined ? _data["isEnableTxt"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateCheckItemPage {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateCheckItemPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["moduleName"] = this.moduleName !== undefined ? this.moduleName : null as any;
        data["itemName"] = this.itemName !== undefined ? this.itemName : null as any;
        data["itemContent"] = this.itemContent !== undefined ? this.itemContent : null as any;
        data["errorMsg"] = this.errorMsg !== undefined ? this.errorMsg : null as any;
        data["levels"] = this.levels !== undefined ? this.levels : null as any;
        data["isEnable"] = this.isEnable !== undefined ? this.isEnable : null as any;
        data["isEnableTxt"] = this.isEnableTxt !== undefined ? this.isEnableTxt : null as any;
        return data;
    }
}

/** 自动审单检查项 */
export class OISOrderFormAutomateCheckItemPageInput {
    maxResultCount!: number;
    skipCount!: number;
    /** 模块名称 */
    moduleName!: string | null;
    /** 项目名称 */
    itemName!: string | null;
    /** 项目描述 */
    itemContent!: string | null;
    /** 错误提醒 */
    errorMsg!: string | null;
    /** 是否启用 */
    isEnable!: boolean | null;
    /** 级别（整单，产品行） */
    levels!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.moduleName = _data["moduleName"] !== undefined ? _data["moduleName"] : null as any;
            this.itemName = _data["itemName"] !== undefined ? _data["itemName"] : null as any;
            this.itemContent = _data["itemContent"] !== undefined ? _data["itemContent"] : null as any;
            this.errorMsg = _data["errorMsg"] !== undefined ? _data["errorMsg"] : null as any;
            this.isEnable = _data["isEnable"] !== undefined ? _data["isEnable"] : null as any;
            this.levels = _data["levels"] !== undefined ? _data["levels"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateCheckItemPageInput {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateCheckItemPageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["moduleName"] = this.moduleName !== undefined ? this.moduleName : null as any;
        data["itemName"] = this.itemName !== undefined ? this.itemName : null as any;
        data["itemContent"] = this.itemContent !== undefined ? this.itemContent : null as any;
        data["errorMsg"] = this.errorMsg !== undefined ? this.errorMsg : null as any;
        data["isEnable"] = this.isEnable !== undefined ? this.isEnable : null as any;
        data["levels"] = this.levels !== undefined ? this.levels : null as any;
        return data;
    }
}

export class OISOrderFormAutomateCheckItemPagePagedResultDto {
    items!: OISOrderFormAutomateCheckItemPage[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OISOrderFormAutomateCheckItemPage.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateCheckItemPagePagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateCheckItemPagePagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 自动审单检查结果列表 */
export class OISOrderFormAutomateCheckItemResultAddDto {
    /** 模块名称 */
    moduleName!: string | null;
    /** 项目名称 */
    itemName!: string | null;
    /** 项目描述 */
    itemContent!: string | null;
    /** 是否通过 */
    isPass!: boolean | null;
    /** 原因 */
    reason!: string | null;
    /** 合同号 */
    poNumber!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    /** 客户编名称 */
    customerName!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 其他参数 */
    otherRemark!: string | null;
    /** 订单id */
    orderFormId!: string | null;
    /** 任务id */
    taskId!: string | null;
    /** 级别（整单，产品行） */
    levels!: string | null;
    /** 产品序号 */
    serialNumber!: number | null;

    init(_data?: any) {
        if (_data) {
            this.moduleName = _data["moduleName"] !== undefined ? _data["moduleName"] : null as any;
            this.itemName = _data["itemName"] !== undefined ? _data["itemName"] : null as any;
            this.itemContent = _data["itemContent"] !== undefined ? _data["itemContent"] : null as any;
            this.isPass = _data["isPass"] !== undefined ? _data["isPass"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.otherRemark = _data["otherRemark"] !== undefined ? _data["otherRemark"] : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : null as any;
            this.levels = _data["levels"] !== undefined ? _data["levels"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateCheckItemResultAddDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateCheckItemResultAddDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleName"] = this.moduleName !== undefined ? this.moduleName : null as any;
        data["itemName"] = this.itemName !== undefined ? this.itemName : null as any;
        data["itemContent"] = this.itemContent !== undefined ? this.itemContent : null as any;
        data["isPass"] = this.isPass !== undefined ? this.isPass : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["otherRemark"] = this.otherRemark !== undefined ? this.otherRemark : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["taskId"] = this.taskId !== undefined ? this.taskId : null as any;
        data["levels"] = this.levels !== undefined ? this.levels : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        return data;
    }
}

/** 自动审单检查结果列表 */
export class OISOrderFormAutomateCheckItemResultPageDto {
    /** 模块名称 */
    moduleName!: string | null;
    /** 项目名称 */
    itemName!: string | null;
    /** 项目描述 */
    itemContent!: string | null;
    /** 是否通过 */
    isPass!: boolean | null;
    /** 原因 */
    reason!: string | null;
    /** 合同号 */
    poNumber!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    /** 客户编名称 */
    customerName!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 其他参数 */
    otherRemark!: string | null;
    /** 订单id */
    orderFormId!: string | null;
    /** 任务id */
    taskId!: string | null;
    /** 级别（整单，产品行） */
    levels!: string | null;
    /** 产品序号 */
    serialNumber!: number | null;
    id!: string;
    readonly isPassTxt!: string | null;
    /** 开始日期 */
    beginDate!: moment.Moment | null;
    /** 结束日期 */
    endDate!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.moduleName = _data["moduleName"] !== undefined ? _data["moduleName"] : null as any;
            this.itemName = _data["itemName"] !== undefined ? _data["itemName"] : null as any;
            this.itemContent = _data["itemContent"] !== undefined ? _data["itemContent"] : null as any;
            this.isPass = _data["isPass"] !== undefined ? _data["isPass"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.otherRemark = _data["otherRemark"] !== undefined ? _data["otherRemark"] : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : null as any;
            this.levels = _data["levels"] !== undefined ? _data["levels"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            (this as any).isPassTxt = _data["isPassTxt"] !== undefined ? _data["isPassTxt"] : null as any;
            this.beginDate = _data["beginDate"] ? moment(_data["beginDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateCheckItemResultPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateCheckItemResultPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleName"] = this.moduleName !== undefined ? this.moduleName : null as any;
        data["itemName"] = this.itemName !== undefined ? this.itemName : null as any;
        data["itemContent"] = this.itemContent !== undefined ? this.itemContent : null as any;
        data["isPass"] = this.isPass !== undefined ? this.isPass : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["otherRemark"] = this.otherRemark !== undefined ? this.otherRemark : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["taskId"] = this.taskId !== undefined ? this.taskId : null as any;
        data["levels"] = this.levels !== undefined ? this.levels : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["isPassTxt"] = this.isPassTxt !== undefined ? this.isPassTxt : null as any;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        return data;
    }
}

export class OISOrderFormAutomateCheckItemResultPageDtoPagedResultDto {
    items!: OISOrderFormAutomateCheckItemResultPageDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OISOrderFormAutomateCheckItemResultPageDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateCheckItemResultPageDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateCheckItemResultPageDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 自动审单检查结果列表 */
export class OISOrderFormAutomateCheckItemResultPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 模块名称 */
    moduleName!: string | null;
    /** 项目名称 */
    itemName!: string | null;
    /** 是否通过 */
    isPass!: boolean | null;
    /** 合同号 */
    poNumber!: string | null;
    /** 客户编名称 */
    customerName!: string | null;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 任务id */
    taskId!: string | null;
    /** 表单id */
    orderFormId!: string | null;
    /** 级别（整单，产品行） */
    levels!: string | null;
    /** 加载类型（整单/整行）（order/line） */
    dataType!: string | null;
    /** 开始日期 */
    beginDate!: moment.Moment | null;
    /** 结束日期 */
    endDate!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.moduleName = _data["moduleName"] !== undefined ? _data["moduleName"] : null as any;
            this.itemName = _data["itemName"] !== undefined ? _data["itemName"] : null as any;
            this.isPass = _data["isPass"] !== undefined ? _data["isPass"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.levels = _data["levels"] !== undefined ? _data["levels"] : null as any;
            this.dataType = _data["dataType"] !== undefined ? _data["dataType"] : null as any;
            this.beginDate = _data["beginDate"] ? moment(_data["beginDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateCheckItemResultPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateCheckItemResultPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["moduleName"] = this.moduleName !== undefined ? this.moduleName : null as any;
        data["itemName"] = this.itemName !== undefined ? this.itemName : null as any;
        data["isPass"] = this.isPass !== undefined ? this.isPass : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["taskId"] = this.taskId !== undefined ? this.taskId : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["levels"] = this.levels !== undefined ? this.levels : null as any;
        data["dataType"] = this.dataType !== undefined ? this.dataType : null as any;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        return data;
    }
}

/** 自动审单检查结果列表 */
export class OISOrderFormAutomateCheckItemResultSimplifyAddDto {
    /** 模块名称 */
    moduleName!: string | null;
    /** 项目名称 */
    itemName!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    /** 客户编名称 */
    customerName!: string | null;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 是否通过 */
    isPass!: boolean;
    /** 原因（检查项目的错误提醒） */
    reason!: string | null;
    /** 其他参数 */
    otherRemark!: string | null;
    /** 合同号 */
    poNumber!: string | null;
    /** 订单id */
    orderFormId!: string;
    /** 任务id */
    taskId!: string | null;
    /** 级别（整单，产品行） */
    levels!: string | null;
    /** 产品序号 */
    serialNumber!: number | null;

    init(_data?: any) {
        if (_data) {
            this.moduleName = _data["moduleName"] !== undefined ? _data["moduleName"] : null as any;
            this.itemName = _data["itemName"] !== undefined ? _data["itemName"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.isPass = _data["isPass"] !== undefined ? _data["isPass"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.otherRemark = _data["otherRemark"] !== undefined ? _data["otherRemark"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : null as any;
            this.levels = _data["levels"] !== undefined ? _data["levels"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateCheckItemResultSimplifyAddDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateCheckItemResultSimplifyAddDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleName"] = this.moduleName !== undefined ? this.moduleName : null as any;
        data["itemName"] = this.itemName !== undefined ? this.itemName : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["isPass"] = this.isPass !== undefined ? this.isPass : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["otherRemark"] = this.otherRemark !== undefined ? this.otherRemark : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["taskId"] = this.taskId !== undefined ? this.taskId : null as any;
        data["levels"] = this.levels !== undefined ? this.levels : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        return data;
    }
}

/** 自动审单检查结果列表 */
export class OISOrderFormAutomateCheckItemResultSimplifyPageDto {
    /** 模块名称 */
    moduleName!: string | null;
    /** 项目名称 */
    itemName!: string | null;
    /** 项目描述 */
    itemContent!: string | null;
    /** 是否通过 */
    isPass!: boolean | null;
    /** 原因 */
    reason!: string | null;
    /** 合同号 */
    poNumber!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    /** 客户编名称 */
    customerName!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 其他参数 */
    otherRemark!: string | null;
    /** 订单id */
    orderFormId!: string | null;
    /** 任务id */
    taskId!: string | null;
    /** 级别（整单，产品行） */
    levels!: string | null;
    /** 产品序号 */
    serialNumber!: number | null;
    id!: string;
    readonly isPassTxt!: string | null;
    automateStatus!: AutomateStatusEnum;
    automateStatusTxt!: string | null;
    creationTime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.moduleName = _data["moduleName"] !== undefined ? _data["moduleName"] : null as any;
            this.itemName = _data["itemName"] !== undefined ? _data["itemName"] : null as any;
            this.itemContent = _data["itemContent"] !== undefined ? _data["itemContent"] : null as any;
            this.isPass = _data["isPass"] !== undefined ? _data["isPass"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.otherRemark = _data["otherRemark"] !== undefined ? _data["otherRemark"] : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : null as any;
            this.levels = _data["levels"] !== undefined ? _data["levels"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            (this as any).isPassTxt = _data["isPassTxt"] !== undefined ? _data["isPassTxt"] : null as any;
            this.automateStatus = _data["automateStatus"] !== undefined ? _data["automateStatus"] : null as any;
            this.automateStatusTxt = _data["automateStatusTxt"] !== undefined ? _data["automateStatusTxt"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateCheckItemResultSimplifyPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateCheckItemResultSimplifyPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleName"] = this.moduleName !== undefined ? this.moduleName : null as any;
        data["itemName"] = this.itemName !== undefined ? this.itemName : null as any;
        data["itemContent"] = this.itemContent !== undefined ? this.itemContent : null as any;
        data["isPass"] = this.isPass !== undefined ? this.isPass : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["otherRemark"] = this.otherRemark !== undefined ? this.otherRemark : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["taskId"] = this.taskId !== undefined ? this.taskId : null as any;
        data["levels"] = this.levels !== undefined ? this.levels : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["isPassTxt"] = this.isPassTxt !== undefined ? this.isPassTxt : null as any;
        data["automateStatus"] = this.automateStatus !== undefined ? this.automateStatus : null as any;
        data["automateStatusTxt"] = this.automateStatusTxt !== undefined ? this.automateStatusTxt : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        return data;
    }
}

export class OISOrderFormAutomateCheckItemResultSimplifyPageDtoPagedResultDto {
    items!: OISOrderFormAutomateCheckItemResultSimplifyPageDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OISOrderFormAutomateCheckItemResultSimplifyPageDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateCheckItemResultSimplifyPageDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateCheckItemResultSimplifyPageDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 自动审单检查结果列表 */
export class OISOrderFormAutomateCheckItemResultSimplifyPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 模块名称 */
    moduleName!: string | null;
    /** 项目名称 */
    itemName!: string | null;
    /** 是否通过 */
    isPass!: boolean | null;
    /** 合同号 */
    poNumber!: string | null;
    /** 客户编名称 */
    customerName!: string | null;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 任务id */
    taskId!: string | null;
    /** 表单id */
    orderFormId!: string | null;
    /** 级别（整单，产品行） */
    levels!: string | null;
    /** 加载类型（整单/整行）（order/line） */
    dataType!: string | null;
    /** 开始日期 */
    beginDate!: moment.Moment | null;
    /** 结束日期 */
    endDate!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.moduleName = _data["moduleName"] !== undefined ? _data["moduleName"] : null as any;
            this.itemName = _data["itemName"] !== undefined ? _data["itemName"] : null as any;
            this.isPass = _data["isPass"] !== undefined ? _data["isPass"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.levels = _data["levels"] !== undefined ? _data["levels"] : null as any;
            this.dataType = _data["dataType"] !== undefined ? _data["dataType"] : null as any;
            this.beginDate = _data["beginDate"] ? moment(_data["beginDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateCheckItemResultSimplifyPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateCheckItemResultSimplifyPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["moduleName"] = this.moduleName !== undefined ? this.moduleName : null as any;
        data["itemName"] = this.itemName !== undefined ? this.itemName : null as any;
        data["isPass"] = this.isPass !== undefined ? this.isPass : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["taskId"] = this.taskId !== undefined ? this.taskId : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["levels"] = this.levels !== undefined ? this.levels : null as any;
        data["dataType"] = this.dataType !== undefined ? this.dataType : null as any;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        return data;
    }
}

export class OISOrderFormAutomateCheckItemSetEnable {
    id!: string | null;
    /** 是否启用 */
    isEnable!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.isEnable = _data["isEnable"] !== undefined ? _data["isEnable"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateCheckItemSetEnable {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateCheckItemSetEnable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["isEnable"] = this.isEnable !== undefined ? this.isEnable : null as any;
        return data;
    }
}

export class OISOrderFormAutomateGreenChannelProjectAddDto {
    /** 绿通号 */
    greenNumber!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 电机编码 */
    basicMotorCode!: string | null;
    /** 台数 */
    numberOfProduct!: number;

    init(_data?: any) {
        if (_data) {
            this.greenNumber = _data["greenNumber"] !== undefined ? _data["greenNumber"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.numberOfProduct = _data["numberOfProduct"] !== undefined ? _data["numberOfProduct"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateGreenChannelProjectAddDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateGreenChannelProjectAddDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["greenNumber"] = this.greenNumber !== undefined ? this.greenNumber : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["numberOfProduct"] = this.numberOfProduct !== undefined ? this.numberOfProduct : null as any;
        return data;
    }
}

export class OISOrderFormAutomateGreenChannelProjectEditDto {
    /** 绿通号 */
    greenNumber!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 电机编码 */
    basicMotorCode!: string | null;
    /** 台数 */
    numberOfProduct!: number;

    init(_data?: any) {
        if (_data) {
            this.greenNumber = _data["greenNumber"] !== undefined ? _data["greenNumber"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.numberOfProduct = _data["numberOfProduct"] !== undefined ? _data["numberOfProduct"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateGreenChannelProjectEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateGreenChannelProjectEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["greenNumber"] = this.greenNumber !== undefined ? this.greenNumber : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["numberOfProduct"] = this.numberOfProduct !== undefined ? this.numberOfProduct : null as any;
        return data;
    }
}

export class OISOrderFormAutomateGreenChannelProjectPageDto {
    /** 绿通号 */
    greenNumber!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 电机编码 */
    basicMotorCode!: string | null;
    /** 台数 */
    numberOfProduct!: number;
    id!: string;

    init(_data?: any) {
        if (_data) {
            this.greenNumber = _data["greenNumber"] !== undefined ? _data["greenNumber"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.numberOfProduct = _data["numberOfProduct"] !== undefined ? _data["numberOfProduct"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateGreenChannelProjectPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateGreenChannelProjectPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["greenNumber"] = this.greenNumber !== undefined ? this.greenNumber : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["numberOfProduct"] = this.numberOfProduct !== undefined ? this.numberOfProduct : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export class OISOrderFormAutomateGreenChannelProjectPageDtoPagedResultDto {
    items!: OISOrderFormAutomateGreenChannelProjectPageDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OISOrderFormAutomateGreenChannelProjectPageDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateGreenChannelProjectPageDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateGreenChannelProjectPageDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class OISOrderFormAutomateGreenChannelProjectPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 绿通号 */
    greenNumber!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 电机编码 */
    basicMotorCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.greenNumber = _data["greenNumber"] !== undefined ? _data["greenNumber"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateGreenChannelProjectPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateGreenChannelProjectPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["greenNumber"] = this.greenNumber !== undefined ? this.greenNumber : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        return data;
    }
}

export class OISOrderFormAutomateGreenChannelYearAddDto {
    /** 绿通号 */
    greenNumber!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 电机型号 */
    basicMotorModel!: string | null;

    init(_data?: any) {
        if (_data) {
            this.greenNumber = _data["greenNumber"] !== undefined ? _data["greenNumber"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateGreenChannelYearAddDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateGreenChannelYearAddDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["greenNumber"] = this.greenNumber !== undefined ? this.greenNumber : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        return data;
    }
}

export class OISOrderFormAutomateGreenChannelYearEditDto {
    /** 绿通号 */
    greenNumber!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 电机型号 */
    basicMotorModel!: string | null;
    id!: string;

    init(_data?: any) {
        if (_data) {
            this.greenNumber = _data["greenNumber"] !== undefined ? _data["greenNumber"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateGreenChannelYearEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateGreenChannelYearEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["greenNumber"] = this.greenNumber !== undefined ? this.greenNumber : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export class OISOrderFormAutomateGreenChannelYearPageDto {
    /** 绿通号 */
    greenNumber!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 电机型号 */
    basicMotorModel!: string | null;
    id!: string;

    init(_data?: any) {
        if (_data) {
            this.greenNumber = _data["greenNumber"] !== undefined ? _data["greenNumber"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateGreenChannelYearPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateGreenChannelYearPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["greenNumber"] = this.greenNumber !== undefined ? this.greenNumber : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export class OISOrderFormAutomateGreenChannelYearPageDtoPagedResultDto {
    items!: OISOrderFormAutomateGreenChannelYearPageDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OISOrderFormAutomateGreenChannelYearPageDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateGreenChannelYearPageDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateGreenChannelYearPageDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class OISOrderFormAutomateGreenChannelYearPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 绿通号 */
    greenNumber!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 电机型号 */
    basicMotorModel!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.greenNumber = _data["greenNumber"] !== undefined ? _data["greenNumber"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateGreenChannelYearPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateGreenChannelYearPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["greenNumber"] = this.greenNumber !== undefined ? this.greenNumber : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        return data;
    }
}

export class OISOrderFormAutomateOCRLogAddDto {
    /** 订单id */
    orderFormId!: string;
    /** 合同号 */
    poNumber!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    /** 客户编名称 */
    customerName!: string | null;
    /** 开始时间 */
    beginTime!: moment.Moment | null;
    /** 结束时间 */
    endTime!: moment.Moment | null;
    /** 状态 */
    taskStatus!: boolean | null;
    /** IP地址 */
    ip!: string | null;
    /** 文件名称 */
    fileName!: string | null;
    /** 文件Byte数据 */
    fileByte!: string | null;
    /** OCR服务，返回数据 */
    responsesData!: string | null;
    /** 备注 */
    remark!: string | null;
    /** 提交人姓名 */
    creatorUserName!: string | null;
    /** 提交人姓名 */
    creatorUserId!: number;
    /** 任务id */
    taskId!: string | null;
    /** 上级id */
    pid!: string | null;
    /** 提取后的水单信息 */
    bankInfo!: string | null;

    init(_data?: any) {
        if (_data) {
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.beginTime = _data["beginTime"] ? moment(_data["beginTime"].toString()) : null as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : null as any;
            this.taskStatus = _data["taskStatus"] !== undefined ? _data["taskStatus"] : null as any;
            this.ip = _data["ip"] !== undefined ? _data["ip"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.fileByte = _data["fileByte"] !== undefined ? _data["fileByte"] : null as any;
            this.responsesData = _data["responsesData"] !== undefined ? _data["responsesData"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.creatorUserName = _data["creatorUserName"] !== undefined ? _data["creatorUserName"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : null as any;
            this.pid = _data["pid"] !== undefined ? _data["pid"] : null as any;
            this.bankInfo = _data["bankInfo"] !== undefined ? _data["bankInfo"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateOCRLogAddDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateOCRLogAddDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["beginTime"] = this.beginTime ? this.beginTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        data["taskStatus"] = this.taskStatus !== undefined ? this.taskStatus : null as any;
        data["ip"] = this.ip !== undefined ? this.ip : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileByte"] = this.fileByte !== undefined ? this.fileByte : null as any;
        data["responsesData"] = this.responsesData !== undefined ? this.responsesData : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["creatorUserName"] = this.creatorUserName !== undefined ? this.creatorUserName : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["taskId"] = this.taskId !== undefined ? this.taskId : null as any;
        data["pid"] = this.pid !== undefined ? this.pid : null as any;
        data["bankInfo"] = this.bankInfo !== undefined ? this.bankInfo : null as any;
        return data;
    }
}

export class OISOrderFormAutomateOCRLogPageDto {
    /** 订单id */
    orderFormId!: string;
    /** 合同号 */
    poNumber!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    /** 客户编名称 */
    customerName!: string | null;
    /** 开始时间 */
    beginTime!: moment.Moment | null;
    /** 结束时间 */
    endTime!: moment.Moment | null;
    /** 状态 */
    taskStatus!: boolean | null;
    /** IP地址 */
    ip!: string | null;
    /** 文件名称 */
    fileName!: string | null;
    /** 文件Byte数据 */
    fileByte!: string | null;
    /** OCR服务，返回数据 */
    responsesData!: string | null;
    /** 备注 */
    remark!: string | null;
    /** 提交人姓名 */
    creatorUserName!: string | null;
    /** 提交人姓名 */
    creatorUserId!: number;
    /** 任务id */
    taskId!: string | null;
    /** 上级id */
    pid!: string | null;
    /** 提取后的水单信息 */
    bankInfo!: string | null;
    id!: string;
    /** 状态 描述 */
    readonly taskStatusTxt!: string | null;

    init(_data?: any) {
        if (_data) {
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.beginTime = _data["beginTime"] ? moment(_data["beginTime"].toString()) : null as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : null as any;
            this.taskStatus = _data["taskStatus"] !== undefined ? _data["taskStatus"] : null as any;
            this.ip = _data["ip"] !== undefined ? _data["ip"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.fileByte = _data["fileByte"] !== undefined ? _data["fileByte"] : null as any;
            this.responsesData = _data["responsesData"] !== undefined ? _data["responsesData"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.creatorUserName = _data["creatorUserName"] !== undefined ? _data["creatorUserName"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : null as any;
            this.pid = _data["pid"] !== undefined ? _data["pid"] : null as any;
            this.bankInfo = _data["bankInfo"] !== undefined ? _data["bankInfo"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            (this as any).taskStatusTxt = _data["taskStatusTxt"] !== undefined ? _data["taskStatusTxt"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateOCRLogPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateOCRLogPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["beginTime"] = this.beginTime ? this.beginTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        data["taskStatus"] = this.taskStatus !== undefined ? this.taskStatus : null as any;
        data["ip"] = this.ip !== undefined ? this.ip : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileByte"] = this.fileByte !== undefined ? this.fileByte : null as any;
        data["responsesData"] = this.responsesData !== undefined ? this.responsesData : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["creatorUserName"] = this.creatorUserName !== undefined ? this.creatorUserName : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["taskId"] = this.taskId !== undefined ? this.taskId : null as any;
        data["pid"] = this.pid !== undefined ? this.pid : null as any;
        data["bankInfo"] = this.bankInfo !== undefined ? this.bankInfo : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["taskStatusTxt"] = this.taskStatusTxt !== undefined ? this.taskStatusTxt : null as any;
        return data;
    }
}

export class OISOrderFormAutomateOCRLogPageDtoPagedResultDto {
    items!: OISOrderFormAutomateOCRLogPageDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OISOrderFormAutomateOCRLogPageDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateOCRLogPageDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateOCRLogPageDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class OISOrderFormAutomateOCRLogPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 合同号 */
    poNumber!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    /** 客户编名称 */
    customerName!: string | null;
    /** 状态 */
    taskStatus!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.taskStatus = _data["taskStatus"] !== undefined ? _data["taskStatus"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateOCRLogPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateOCRLogPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["taskStatus"] = this.taskStatus !== undefined ? this.taskStatus : null as any;
        return data;
    }
}

/** 任务执行记录 */
export class OISOrderFormAutomateTaskAddDto {
    /** 订单id */
    orderFormId!: string;
    /** 合同号 */
    poNumber!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    /** 开始时间 */
    beginTime!: moment.Moment | null;
    /** 结束时间 */
    endTime!: moment.Moment | null;
    /** 状态 */
    taskStatus!: number | null;
    /** 重试次数 */
    retryCount!: number | null;
    id!: string;
    lastModifierUserId!: number | null;
    lastModificationTime!: moment.Moment;

    init(_data?: any) {
        if (_data) {
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.beginTime = _data["beginTime"] ? moment(_data["beginTime"].toString()) : null as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : null as any;
            this.taskStatus = _data["taskStatus"] !== undefined ? _data["taskStatus"] : null as any;
            this.retryCount = _data["retryCount"] !== undefined ? _data["retryCount"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateTaskAddDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateTaskAddDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["beginTime"] = this.beginTime ? this.beginTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        data["taskStatus"] = this.taskStatus !== undefined ? this.taskStatus : null as any;
        data["retryCount"] = this.retryCount !== undefined ? this.retryCount : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        return data;
    }
}

/** 任务执行记录 */
export class OISOrderFormAutomateTaskEditDto {
    /** 订单id */
    orderFormId!: string;
    /** 合同号 */
    poNumber!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    /** 开始时间 */
    beginTime!: moment.Moment | null;
    /** 结束时间 */
    endTime!: moment.Moment | null;
    /** 状态 */
    taskStatus!: number | null;
    /** 重试次数 */
    retryCount!: number | null;
    id!: string;

    init(_data?: any) {
        if (_data) {
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.beginTime = _data["beginTime"] ? moment(_data["beginTime"].toString()) : null as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : null as any;
            this.taskStatus = _data["taskStatus"] !== undefined ? _data["taskStatus"] : null as any;
            this.retryCount = _data["retryCount"] !== undefined ? _data["retryCount"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateTaskEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateTaskEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["beginTime"] = this.beginTime ? this.beginTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        data["taskStatus"] = this.taskStatus !== undefined ? this.taskStatus : null as any;
        data["retryCount"] = this.retryCount !== undefined ? this.retryCount : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

/** 任务执行记录 */
export class OISOrderFormAutomateTaskPageDto {
    /** 合同号 */
    poNumber!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    /** 开始时间 */
    beginTime!: moment.Moment | null;
    /** 结束时间 */
    endTime!: moment.Moment | null;
    taskStatus!: EnumAutoApproveTaskStatus;
    /** 重试次数 */
    retryCount!: number | null;
    /** 状态 描述 */
    readonly taskStatusTxt!: string | null;
    creationTime!: moment.Moment;

    init(_data?: any) {
        if (_data) {
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.beginTime = _data["beginTime"] ? moment(_data["beginTime"].toString()) : null as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : null as any;
            this.taskStatus = _data["taskStatus"] !== undefined ? _data["taskStatus"] : null as any;
            this.retryCount = _data["retryCount"] !== undefined ? _data["retryCount"] : null as any;
            (this as any).taskStatusTxt = _data["taskStatusTxt"] !== undefined ? _data["taskStatusTxt"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateTaskPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateTaskPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["beginTime"] = this.beginTime ? this.beginTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        data["taskStatus"] = this.taskStatus !== undefined ? this.taskStatus : null as any;
        data["retryCount"] = this.retryCount !== undefined ? this.retryCount : null as any;
        data["taskStatusTxt"] = this.taskStatusTxt !== undefined ? this.taskStatusTxt : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        return data;
    }
}

export class OISOrderFormAutomateTaskPageDtoPagedResultDto {
    items!: OISOrderFormAutomateTaskPageDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OISOrderFormAutomateTaskPageDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateTaskPageDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateTaskPageDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 任务执行记录,列表查询条件 */
export class OISOrderFormAutomateTaskPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 合同号 */
    poNumber!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    /** 开始时间 */
    beginTime!: moment.Moment | null;
    /** 结束时间 */
    endTime!: moment.Moment | null;
    taskStatus!: EnumAutoApproveTaskStatus;
    /** 重试次数 */
    retryCount!: number | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.beginTime = _data["beginTime"] ? moment(_data["beginTime"].toString()) : null as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : null as any;
            this.taskStatus = _data["taskStatus"] !== undefined ? _data["taskStatus"] : null as any;
            this.retryCount = _data["retryCount"] !== undefined ? _data["retryCount"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateTaskPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateTaskPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["beginTime"] = this.beginTime ? this.beginTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        data["taskStatus"] = this.taskStatus !== undefined ? this.taskStatus : null as any;
        data["retryCount"] = this.retryCount !== undefined ? this.retryCount : null as any;
        return data;
    }
}

/** 任务执行记录 */
export class OISOrderFormAutomateTaskStatusAddDto {
    /** 订单id */
    orderFormId!: string | null;
    /** 合同号 */
    poNumber!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    taskStatus!: number | null;
    id!: string;

    init(_data?: any) {
        if (_data) {
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.taskStatus = _data["taskStatus"] !== undefined ? _data["taskStatus"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateTaskStatusAddDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateTaskStatusAddDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["taskStatus"] = this.taskStatus !== undefined ? this.taskStatus : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

/** 任务执行记录 */
export class OISOrderFormAutomateTaskStatusEditDto {
    /** 订单id */
    orderFormId!: string | null;
    /** 合同号 */
    poNumber!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 客户编码 */
    customerNo!: string | null;
    taskStatus!: number | null;
    id!: string;

    init(_data?: any) {
        if (_data) {
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.taskStatus = _data["taskStatus"] !== undefined ? _data["taskStatus"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): OISOrderFormAutomateTaskStatusEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OISOrderFormAutomateTaskStatusEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["taskStatus"] = this.taskStatus !== undefined ? this.taskStatus : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export class OrderAutomate {
    id!: number;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    orderId!: string;
    orderForm!: OrderForm;
    status!: AutomateStatusEnum;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : null as any;
            this.orderForm = _data["orderForm"] ? OrderForm.fromJS(_data["orderForm"]) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static fromJS(data: any): OrderAutomate {
        data = typeof data === 'object' ? data : {};
        let result = new OrderAutomate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["orderId"] = this.orderId !== undefined ? this.orderId : null as any;
        data["orderForm"] = this.orderForm ? this.orderForm.toJSON() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        return data;
    }
}

export class OrderAutomateLog {
    id!: number;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    orderId!: string;
    status!: AutomateStatusEnum;
    description!: string | null;
    orderForm!: OrderForm;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.orderForm = _data["orderForm"] ? OrderForm.fromJS(_data["orderForm"]) : null as any;
        }
    }

    static fromJS(data: any): OrderAutomateLog {
        data = typeof data === 'object' ? data : {};
        let result = new OrderAutomateLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["orderId"] = this.orderId !== undefined ? this.orderId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["orderForm"] = this.orderForm ? this.orderForm.toJSON() : null as any;
        return data;
    }
}

/** 1 = Mts */
export enum OrderBusinessType {
    Mts = 1,
}

/** 订单变更 */
export class OrderChangeDto {
    id!: string;
    /** 创建日期 */
    creationTime!: moment.Moment;
    readonly creationTimeString!: string | null;
    /** 关联选型 */
    modelId!: string | null;
    status!: OrderChangeStatus;
    /** 状态 */
    readonly statusString!: string | null;
    /** 订单产品变更 */
    orderProductChangeDtos!: OrderProductChangeDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            (this as any).creationTimeString = _data["creationTimeString"] !== undefined ? _data["creationTimeString"] : null as any;
            this.modelId = _data["modelId"] !== undefined ? _data["modelId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            (this as any).statusString = _data["statusString"] !== undefined ? _data["statusString"] : null as any;
            if (Array.isArray(_data["orderProductChangeDtos"])) {
                this.orderProductChangeDtos = [] as any;
                for (let item of _data["orderProductChangeDtos"])
                    this.orderProductChangeDtos!.push(OrderProductChangeDto.fromJS(item));
            }
            else {
                this.orderProductChangeDtos = null as any;
            }
        }
    }

    static fromJS(data: any): OrderChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creationTimeString"] = this.creationTimeString !== undefined ? this.creationTimeString : null as any;
        data["modelId"] = this.modelId !== undefined ? this.modelId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["statusString"] = this.statusString !== undefined ? this.statusString : null as any;
        if (Array.isArray(this.orderProductChangeDtos)) {
            data["orderProductChangeDtos"] = [];
            for (let item of this.orderProductChangeDtos)
                data["orderProductChangeDtos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class OrderChangeExecutionListDto {
    /** 主键 */
    id!: string;
    /** 工单Id */
    requestId!: string | null;
    /** oc号 */
    ocNumber!: string | null;
    /** iso号 */
    internalSalesOrder!: string | null;
    /** cso号 */
    customerSalesOrder!: string | null;
    /** 状态 */
    status!: string | null;
    /** 任务时间 */
    submissionTime!: moment.Moment | null;
    /** 完成时间 */
    completionTime!: moment.Moment | null;
    /** 执行人 */
    executorId!: number | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.requestId = _data["requestId"] !== undefined ? _data["requestId"] : null as any;
            this.ocNumber = _data["ocNumber"] !== undefined ? _data["ocNumber"] : null as any;
            this.internalSalesOrder = _data["internalSalesOrder"] !== undefined ? _data["internalSalesOrder"] : null as any;
            this.customerSalesOrder = _data["customerSalesOrder"] !== undefined ? _data["customerSalesOrder"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.submissionTime = _data["submissionTime"] ? moment(_data["submissionTime"].toString()) : null as any;
            this.completionTime = _data["completionTime"] ? moment(_data["completionTime"].toString()) : null as any;
            this.executorId = _data["executorId"] !== undefined ? _data["executorId"] : null as any;
        }
    }

    static fromJS(data: any): OrderChangeExecutionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeExecutionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["requestId"] = this.requestId !== undefined ? this.requestId : null as any;
        data["ocNumber"] = this.ocNumber !== undefined ? this.ocNumber : null as any;
        data["internalSalesOrder"] = this.internalSalesOrder !== undefined ? this.internalSalesOrder : null as any;
        data["customerSalesOrder"] = this.customerSalesOrder !== undefined ? this.customerSalesOrder : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["submissionTime"] = this.submissionTime ? this.submissionTime.toISOString() : null as any;
        data["completionTime"] = this.completionTime ? this.completionTime.toISOString() : null as any;
        data["executorId"] = this.executorId !== undefined ? this.executorId : null as any;
        return data;
    }
}

export class OrderChangeExecutionListQueryDto {
    maxResultCount!: number;
    skipCount!: number;
    /** oc号 */
    ocNumber!: string | null;
    /** iso号 */
    internalSalesOrder!: string | null;
    /** cso号 */
    customerSalesOrder!: string | null;
    /** 状态 */
    status!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.ocNumber = _data["ocNumber"] !== undefined ? _data["ocNumber"] : null as any;
            this.internalSalesOrder = _data["internalSalesOrder"] !== undefined ? _data["internalSalesOrder"] : null as any;
            this.customerSalesOrder = _data["customerSalesOrder"] !== undefined ? _data["customerSalesOrder"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static fromJS(data: any): OrderChangeExecutionListQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeExecutionListQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["ocNumber"] = this.ocNumber !== undefined ? this.ocNumber : null as any;
        data["internalSalesOrder"] = this.internalSalesOrder !== undefined ? this.internalSalesOrder : null as any;
        data["customerSalesOrder"] = this.customerSalesOrder !== undefined ? this.customerSalesOrder : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        return data;
    }
}

export class OrderChangeOrderForm {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    orderFormId!: string;
    projectName!: string | null;
    projectNo!: string | null;
    modelSelectionId!: string | null;
    modelSelectionName!: string | null;
    specialOfferApplicationNumber!: string | null;
    isManual!: boolean;
    totalNumber!: string | null;
    totalPrice!: number | null;
    customerOrderNumber!: string | null;
    orderCancelTime!: moment.Moment | null;
    orderTime!: moment.Moment | null;
    orderCompleteTime!: moment.Moment | null;
    expectedDeliveryDate!: string | null;
    customerExpectedDeliveryDate!: moment.Moment | null;
    poNumber!: string | null;
    orderStatus!: OrderStatus;
    orderType!: OrderType;
    orderSource!: string | null;
    cpCode!: string | null;
    cpCoName!: string | null;
    endCustomerCode!: string | null;
    endCustomerName!: string | null;
    shippingAddressCode!: string | null;
    shippingAddress!: string | null;
    responsibleSalesCode!: string | null;
    responsibleSalesName!: string | null;
    attachmentName!: string | null;
    omsOrderNumber!: string | null;
    dataPlatFormOrderTypeId!: string | null;
    industry!: Industry;
    industryId!: string | null;
    application!: Application;
    applicationId!: string | null;
    channel!: Channel;
    channelId!: string | null;
    salesAreaId!: string | null;
    salesArea!: SalesArea;
    smconfjson!: string | null;
    deliveryTerms!: string | null;
    isPoNumber!: boolean;
    forLibOrderFlg!: boolean | null;
    finalCustomer!: string | null;
    curTaxRate!: number | null;
    totalPriceWithoutTax!: number | null;
    totalTaxPrice!: number | null;
    finalCustomerCode!: string | null;
    specifyApproval!: boolean;
    specifyApprovalChecked!: boolean;
    locationCountry!: string | null;
    recordNumber!: string | null;
    approvalStatus!: ApprovalStatusEnum;
    salesPriceDecimal!: boolean;
    currencyId!: string | null;
    lectoTypesId!: string | null;
    isoOrderNumber!: string | null;
    csoOrderNumber!: string | null;
    orderChangeOrderFormVersions!: OrderChangeOrderFormVersions[] | null;
    orderChangeProcessEntityId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.projectNo = _data["projectNo"] !== undefined ? _data["projectNo"] : null as any;
            this.modelSelectionId = _data["modelSelectionId"] !== undefined ? _data["modelSelectionId"] : null as any;
            this.modelSelectionName = _data["modelSelectionName"] !== undefined ? _data["modelSelectionName"] : null as any;
            this.specialOfferApplicationNumber = _data["specialOfferApplicationNumber"] !== undefined ? _data["specialOfferApplicationNumber"] : null as any;
            this.isManual = _data["isManual"] !== undefined ? _data["isManual"] : null as any;
            this.totalNumber = _data["totalNumber"] !== undefined ? _data["totalNumber"] : null as any;
            this.totalPrice = _data["totalPrice"] !== undefined ? _data["totalPrice"] : null as any;
            this.customerOrderNumber = _data["customerOrderNumber"] !== undefined ? _data["customerOrderNumber"] : null as any;
            this.orderCancelTime = _data["orderCancelTime"] ? moment(_data["orderCancelTime"].toString()) : null as any;
            this.orderTime = _data["orderTime"] ? moment(_data["orderTime"].toString()) : null as any;
            this.orderCompleteTime = _data["orderCompleteTime"] ? moment(_data["orderCompleteTime"].toString()) : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.customerExpectedDeliveryDate = _data["customerExpectedDeliveryDate"] ? moment(_data["customerExpectedDeliveryDate"].toString()) : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.orderSource = _data["orderSource"] !== undefined ? _data["orderSource"] : null as any;
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.cpCoName = _data["cpCoName"] !== undefined ? _data["cpCoName"] : null as any;
            this.endCustomerCode = _data["endCustomerCode"] !== undefined ? _data["endCustomerCode"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.shippingAddressCode = _data["shippingAddressCode"] !== undefined ? _data["shippingAddressCode"] : null as any;
            this.shippingAddress = _data["shippingAddress"] !== undefined ? _data["shippingAddress"] : null as any;
            this.responsibleSalesCode = _data["responsibleSalesCode"] !== undefined ? _data["responsibleSalesCode"] : null as any;
            this.responsibleSalesName = _data["responsibleSalesName"] !== undefined ? _data["responsibleSalesName"] : null as any;
            this.attachmentName = _data["attachmentName"] !== undefined ? _data["attachmentName"] : null as any;
            this.omsOrderNumber = _data["omsOrderNumber"] !== undefined ? _data["omsOrderNumber"] : null as any;
            this.dataPlatFormOrderTypeId = _data["dataPlatFormOrderTypeId"] !== undefined ? _data["dataPlatFormOrderTypeId"] : null as any;
            this.industry = _data["industry"] ? Industry.fromJS(_data["industry"]) : null as any;
            this.industryId = _data["industryId"] !== undefined ? _data["industryId"] : null as any;
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : null as any;
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.channel = _data["channel"] ? Channel.fromJS(_data["channel"]) : null as any;
            this.channelId = _data["channelId"] !== undefined ? _data["channelId"] : null as any;
            this.salesAreaId = _data["salesAreaId"] !== undefined ? _data["salesAreaId"] : null as any;
            this.salesArea = _data["salesArea"] ? SalesArea.fromJS(_data["salesArea"]) : null as any;
            this.smconfjson = _data["smconfjson"] !== undefined ? _data["smconfjson"] : null as any;
            this.deliveryTerms = _data["deliveryTerms"] !== undefined ? _data["deliveryTerms"] : null as any;
            this.isPoNumber = _data["isPoNumber"] !== undefined ? _data["isPoNumber"] : null as any;
            this.forLibOrderFlg = _data["forLibOrderFlg"] !== undefined ? _data["forLibOrderFlg"] : null as any;
            this.finalCustomer = _data["finalCustomer"] !== undefined ? _data["finalCustomer"] : null as any;
            this.curTaxRate = _data["curTaxRate"] !== undefined ? _data["curTaxRate"] : null as any;
            this.totalPriceWithoutTax = _data["totalPriceWithoutTax"] !== undefined ? _data["totalPriceWithoutTax"] : null as any;
            this.totalTaxPrice = _data["totalTaxPrice"] !== undefined ? _data["totalTaxPrice"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.specifyApproval = _data["specifyApproval"] !== undefined ? _data["specifyApproval"] : null as any;
            this.specifyApprovalChecked = _data["specifyApprovalChecked"] !== undefined ? _data["specifyApprovalChecked"] : null as any;
            this.locationCountry = _data["locationCountry"] !== undefined ? _data["locationCountry"] : null as any;
            this.recordNumber = _data["recordNumber"] !== undefined ? _data["recordNumber"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
            this.salesPriceDecimal = _data["salesPriceDecimal"] !== undefined ? _data["salesPriceDecimal"] : null as any;
            this.currencyId = _data["currencyId"] !== undefined ? _data["currencyId"] : null as any;
            this.lectoTypesId = _data["lectoTypesId"] !== undefined ? _data["lectoTypesId"] : null as any;
            this.isoOrderNumber = _data["isoOrderNumber"] !== undefined ? _data["isoOrderNumber"] : null as any;
            this.csoOrderNumber = _data["csoOrderNumber"] !== undefined ? _data["csoOrderNumber"] : null as any;
            if (Array.isArray(_data["orderChangeOrderFormVersions"])) {
                this.orderChangeOrderFormVersions = [] as any;
                for (let item of _data["orderChangeOrderFormVersions"])
                    this.orderChangeOrderFormVersions!.push(OrderChangeOrderFormVersions.fromJS(item));
            }
            else {
                this.orderChangeOrderFormVersions = null as any;
            }
            this.orderChangeProcessEntityId = _data["orderChangeProcessEntityId"] !== undefined ? _data["orderChangeProcessEntityId"] : null as any;
        }
    }

    static fromJS(data: any): OrderChangeOrderForm {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeOrderForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["projectNo"] = this.projectNo !== undefined ? this.projectNo : null as any;
        data["modelSelectionId"] = this.modelSelectionId !== undefined ? this.modelSelectionId : null as any;
        data["modelSelectionName"] = this.modelSelectionName !== undefined ? this.modelSelectionName : null as any;
        data["specialOfferApplicationNumber"] = this.specialOfferApplicationNumber !== undefined ? this.specialOfferApplicationNumber : null as any;
        data["isManual"] = this.isManual !== undefined ? this.isManual : null as any;
        data["totalNumber"] = this.totalNumber !== undefined ? this.totalNumber : null as any;
        data["totalPrice"] = this.totalPrice !== undefined ? this.totalPrice : null as any;
        data["customerOrderNumber"] = this.customerOrderNumber !== undefined ? this.customerOrderNumber : null as any;
        data["orderCancelTime"] = this.orderCancelTime ? this.orderCancelTime.toISOString() : null as any;
        data["orderTime"] = this.orderTime ? this.orderTime.toISOString() : null as any;
        data["orderCompleteTime"] = this.orderCompleteTime ? this.orderCompleteTime.toISOString() : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["customerExpectedDeliveryDate"] = this.customerExpectedDeliveryDate ? this.customerExpectedDeliveryDate.toISOString() : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["orderSource"] = this.orderSource !== undefined ? this.orderSource : null as any;
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["cpCoName"] = this.cpCoName !== undefined ? this.cpCoName : null as any;
        data["endCustomerCode"] = this.endCustomerCode !== undefined ? this.endCustomerCode : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["shippingAddressCode"] = this.shippingAddressCode !== undefined ? this.shippingAddressCode : null as any;
        data["shippingAddress"] = this.shippingAddress !== undefined ? this.shippingAddress : null as any;
        data["responsibleSalesCode"] = this.responsibleSalesCode !== undefined ? this.responsibleSalesCode : null as any;
        data["responsibleSalesName"] = this.responsibleSalesName !== undefined ? this.responsibleSalesName : null as any;
        data["attachmentName"] = this.attachmentName !== undefined ? this.attachmentName : null as any;
        data["omsOrderNumber"] = this.omsOrderNumber !== undefined ? this.omsOrderNumber : null as any;
        data["dataPlatFormOrderTypeId"] = this.dataPlatFormOrderTypeId !== undefined ? this.dataPlatFormOrderTypeId : null as any;
        data["industry"] = this.industry ? this.industry.toJSON() : null as any;
        data["industryId"] = this.industryId !== undefined ? this.industryId : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["channel"] = this.channel ? this.channel.toJSON() : null as any;
        data["channelId"] = this.channelId !== undefined ? this.channelId : null as any;
        data["salesAreaId"] = this.salesAreaId !== undefined ? this.salesAreaId : null as any;
        data["salesArea"] = this.salesArea ? this.salesArea.toJSON() : null as any;
        data["smconfjson"] = this.smconfjson !== undefined ? this.smconfjson : null as any;
        data["deliveryTerms"] = this.deliveryTerms !== undefined ? this.deliveryTerms : null as any;
        data["isPoNumber"] = this.isPoNumber !== undefined ? this.isPoNumber : null as any;
        data["forLibOrderFlg"] = this.forLibOrderFlg !== undefined ? this.forLibOrderFlg : null as any;
        data["finalCustomer"] = this.finalCustomer !== undefined ? this.finalCustomer : null as any;
        data["curTaxRate"] = this.curTaxRate !== undefined ? this.curTaxRate : null as any;
        data["totalPriceWithoutTax"] = this.totalPriceWithoutTax !== undefined ? this.totalPriceWithoutTax : null as any;
        data["totalTaxPrice"] = this.totalTaxPrice !== undefined ? this.totalTaxPrice : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["specifyApproval"] = this.specifyApproval !== undefined ? this.specifyApproval : null as any;
        data["specifyApprovalChecked"] = this.specifyApprovalChecked !== undefined ? this.specifyApprovalChecked : null as any;
        data["locationCountry"] = this.locationCountry !== undefined ? this.locationCountry : null as any;
        data["recordNumber"] = this.recordNumber !== undefined ? this.recordNumber : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        data["salesPriceDecimal"] = this.salesPriceDecimal !== undefined ? this.salesPriceDecimal : null as any;
        data["currencyId"] = this.currencyId !== undefined ? this.currencyId : null as any;
        data["lectoTypesId"] = this.lectoTypesId !== undefined ? this.lectoTypesId : null as any;
        data["isoOrderNumber"] = this.isoOrderNumber !== undefined ? this.isoOrderNumber : null as any;
        data["csoOrderNumber"] = this.csoOrderNumber !== undefined ? this.csoOrderNumber : null as any;
        if (Array.isArray(this.orderChangeOrderFormVersions)) {
            data["orderChangeOrderFormVersions"] = [];
            for (let item of this.orderChangeOrderFormVersions)
                data["orderChangeOrderFormVersions"].push(item ? item.toJSON() : null as any);
        }
        data["orderChangeProcessEntityId"] = this.orderChangeProcessEntityId !== undefined ? this.orderChangeProcessEntityId : null as any;
        return data;
    }
}

/** 获取cso Iso */
export class OrderChangeOrderFormCsoIsoByTaskServiceRequestInDto {
    /** 流程Id */
    serviceRequestId!: string;
    /** 流程类型Id */
    serviceTypeId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.serviceRequestId = _data["serviceRequestId"] !== undefined ? _data["serviceRequestId"] : null as any;
            this.serviceTypeId = _data["serviceTypeId"] !== undefined ? _data["serviceTypeId"] : null as any;
        }
    }

    static fromJS(data: any): OrderChangeOrderFormCsoIsoByTaskServiceRequestInDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeOrderFormCsoIsoByTaskServiceRequestInDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceRequestId"] = this.serviceRequestId !== undefined ? this.serviceRequestId : null as any;
        data["serviceTypeId"] = this.serviceTypeId !== undefined ? this.serviceTypeId : null as any;
        return data;
    }
}

/** cso/iso出参 */
export class OrderChangeOrderFormCsoIsoByTaskServiceRequestOutDto {
    /** 流程Id */
    serviceRequestId!: string;
    /** ISO */
    internalSalesOrder!: string | null;
    /** CSO */
    customerSalesOrder!: string | null;
    /** 行级 BOM 锁定期日期（lockThresholdDate，流程2产品最小值） */
    bomLockDate!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.serviceRequestId = _data["serviceRequestId"] !== undefined ? _data["serviceRequestId"] : null as any;
            this.internalSalesOrder = _data["internalSalesOrder"] !== undefined ? _data["internalSalesOrder"] : null as any;
            this.customerSalesOrder = _data["customerSalesOrder"] !== undefined ? _data["customerSalesOrder"] : null as any;
            this.bomLockDate = _data["bomLockDate"] ? moment(_data["bomLockDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): OrderChangeOrderFormCsoIsoByTaskServiceRequestOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeOrderFormCsoIsoByTaskServiceRequestOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceRequestId"] = this.serviceRequestId !== undefined ? this.serviceRequestId : null as any;
        data["internalSalesOrder"] = this.internalSalesOrder !== undefined ? this.internalSalesOrder : null as any;
        data["customerSalesOrder"] = this.customerSalesOrder !== undefined ? this.customerSalesOrder : null as any;
        data["bomLockDate"] = this.bomLockDate ? this.bomLockDate.toISOString() : null as any;
        return data;
    }
}

export class OrderChangeOrderFormDto {
    id!: string;
    orderFormId!: string;
    /** 项目名称 */
    projectName!: string | null;
    /** 项目编号 */
    projectNo!: string | null;
    /** 选型Id */
    modelSelectionId!: string | null;
    /** 选型名称 */
    modelSelectionName!: string | null;
    /** 特价申请号 */
    specialOfferApplicationNumber!: string | null;
    /** 特价申请号来源true，则是手动的,false，就代表是自动生成的 */
    isManual!: boolean;
    /** 总台数 */
    totalNumber!: string | null;
    /** 总价 */
    totalPrice!: number | null;
    /** 客户订单号 */
    customerOrderNumber!: string | null;
    /** 取消时间 */
    orderCancelTime!: moment.Moment | null;
    /** 下单时间 */
    orderTime!: moment.Moment | null;
    /** 订单完成时间 */
    orderCompleteTime!: moment.Moment | null;
    /** 预计交货日期/天 */
    expectedDeliveryDate!: string | null;
    /** 客户期望交货日期 */
    customerExpectedDeliveryDate!: moment.Moment | null;
    /** PO号 */
    poNumber!: string | null;
    orderStatus!: OrderStatus;
    orderType!: OrderType;
    /** 订单来源 */
    orderSource!: string | null;
    /** CP编码 */
    cpCode!: string | null;
    /** CP名称 */
    cpCoName!: string | null;
    /** 最终客户编码 */
    endCustomerCode!: string | null;
    /** 最终客户名称 */
    endCustomerName!: string | null;
    /** 发货地址编码 */
    shippingAddressCode!: string | null;
    /** 发货地址 */
    shippingAddress!: string | null;
    /** 责任销售编码 */
    responsibleSalesCode!: string | null;
    /** 责任销售名称 */
    responsibleSalesName!: string | null;
    /** 附件合同名称 */
    attachmentName!: string | null;
    /** OMS订单号（暂时因为没有与OMS系统做接口，所以暂时由审批人员导入OMS系统成功之后填写） */
    omsOrderNumber!: string | null;
    dataPlatFormOrderType!: DataPlatFormOrderChangeTypeDto;
    dataPlatFormOrderTypeId!: string;
    industry!: Industry;
    application!: Application;
    channel!: Channel;
    salesArea!: SalesArea;
    /** 交货条款
此字段为20210324添加 */
    deliveryTerms!: string | null;
    /** 是否生成合同号 */
    isPoNumber!: boolean;
    /** 是否为备库订单 */
    forLibOrderFlg!: boolean | null;
    /** 最终客户名称 */
    finalCustomer!: string | null;
    /** 当前订单税率 */
    curTaxRate!: number | null;
    /** 不含税总金额 sum（ProductBasicMotors.PriceWithoutTax） */
    totalPriceWithoutTax!: number | null;
    /** 总税金 sum（ProductBasicMotors.UnitTaxPrice） */
    totalTaxPrice!: number | null;
    /** 最终客户代号 */
    finalCustomerCode!: string | null;
    /** 指定审批人 */
    specifyApproval!: boolean;
    /** 指定审批人是否已审批 */
    specifyApprovalChecked!: boolean;
    /** 最终用户所在地国家,关联风险国家表(CountryRisk) */
    locationCountry!: string | null;
    /** 备案号(仅风险国家填写) */
    recordNumber!: string | null;
    approvalStatus!: ApprovalStatusEnum;
    lectotypeId!: string;
    /** 产品售价保留小数 */
    salesPriceDecimal!: boolean;
    orderChangeOrderFormVersionsStatus!: EnumOrderChangeOrderFormVersionsStatus;
    readonly orderChangeOrderFormVersionsStatusName!: string | null;
    orderChangeVersionId!: string;
    /** 版本绑定的流程Id */
    taskServiceRequestId!: string | null;
    /** SCID */
    lectoTypesId!: string | null;
    /** 币种 */
    currencyId!: string | null;
    /** 币种 */
    currencyType!: string | null;
    /** pmu订单号 */
    pmuSalesOrder!: string | null;
    /** LSU订单号 */
    lsuSalesOrder!: string | null;
    /** 提出方, 创建时候填写 */
    commerceReduceSuggestion!: string | null;
    /** 提出方, 创建时候填写 */
    presentingParty!: string | null;
    /** 变更原因 ,创建时候填写 */
    changeReason!: string | null;
    /** 变更原因 - 其他 - 具体原因 */
    specificReason!: string | null;
    /** 呆滞物料总费用 */
    totalObsoleteInventoryCost!: number | null;
    /** 商务折扣 */
    businessDiscount!: number | null;
    /** 物料交期影响 */
    materialDeliveryImpact!: string | null;
    /** 选型问题类型
流程回传 */
    selectionIssueType!: string | null;
    /** 选型问题具体描述
流程回传 */
    selectionIssueDetail!: string | null;
    /** 责任方
流程回传 */
    responsibleParty!: string | null;
    /** 选型问题类型
流程回传 */
    scIssueType!: string | null;
    /** 选型问题类型-其他 */
    scIssueTypeReason!: string | null;
    /** 产品裸机 */
    orderChangeProductBasicMotor!: OrderChangeProductBasicMotorDto[] | null;
    orderChangeOrderFormVersions!: OrderChangeOrderFormVersionsDto[] | null;
    orderChangeProcessEntity!: OrderChangeProcessDto;
    orderChangeOrderMaxVersion!: OrderChangeOrderFormVersionsDto;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.projectNo = _data["projectNo"] !== undefined ? _data["projectNo"] : null as any;
            this.modelSelectionId = _data["modelSelectionId"] !== undefined ? _data["modelSelectionId"] : null as any;
            this.modelSelectionName = _data["modelSelectionName"] !== undefined ? _data["modelSelectionName"] : null as any;
            this.specialOfferApplicationNumber = _data["specialOfferApplicationNumber"] !== undefined ? _data["specialOfferApplicationNumber"] : null as any;
            this.isManual = _data["isManual"] !== undefined ? _data["isManual"] : null as any;
            this.totalNumber = _data["totalNumber"] !== undefined ? _data["totalNumber"] : null as any;
            this.totalPrice = _data["totalPrice"] !== undefined ? _data["totalPrice"] : null as any;
            this.customerOrderNumber = _data["customerOrderNumber"] !== undefined ? _data["customerOrderNumber"] : null as any;
            this.orderCancelTime = _data["orderCancelTime"] ? moment(_data["orderCancelTime"].toString()) : null as any;
            this.orderTime = _data["orderTime"] ? moment(_data["orderTime"].toString()) : null as any;
            this.orderCompleteTime = _data["orderCompleteTime"] ? moment(_data["orderCompleteTime"].toString()) : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.customerExpectedDeliveryDate = _data["customerExpectedDeliveryDate"] ? moment(_data["customerExpectedDeliveryDate"].toString()) : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.orderSource = _data["orderSource"] !== undefined ? _data["orderSource"] : null as any;
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.cpCoName = _data["cpCoName"] !== undefined ? _data["cpCoName"] : null as any;
            this.endCustomerCode = _data["endCustomerCode"] !== undefined ? _data["endCustomerCode"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.shippingAddressCode = _data["shippingAddressCode"] !== undefined ? _data["shippingAddressCode"] : null as any;
            this.shippingAddress = _data["shippingAddress"] !== undefined ? _data["shippingAddress"] : null as any;
            this.responsibleSalesCode = _data["responsibleSalesCode"] !== undefined ? _data["responsibleSalesCode"] : null as any;
            this.responsibleSalesName = _data["responsibleSalesName"] !== undefined ? _data["responsibleSalesName"] : null as any;
            this.attachmentName = _data["attachmentName"] !== undefined ? _data["attachmentName"] : null as any;
            this.omsOrderNumber = _data["omsOrderNumber"] !== undefined ? _data["omsOrderNumber"] : null as any;
            this.dataPlatFormOrderType = _data["dataPlatFormOrderType"] ? DataPlatFormOrderChangeTypeDto.fromJS(_data["dataPlatFormOrderType"]) : null as any;
            this.dataPlatFormOrderTypeId = _data["dataPlatFormOrderTypeId"] !== undefined ? _data["dataPlatFormOrderTypeId"] : null as any;
            this.industry = _data["industry"] ? Industry.fromJS(_data["industry"]) : null as any;
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : null as any;
            this.channel = _data["channel"] ? Channel.fromJS(_data["channel"]) : null as any;
            this.salesArea = _data["salesArea"] ? SalesArea.fromJS(_data["salesArea"]) : null as any;
            this.deliveryTerms = _data["deliveryTerms"] !== undefined ? _data["deliveryTerms"] : null as any;
            this.isPoNumber = _data["isPoNumber"] !== undefined ? _data["isPoNumber"] : null as any;
            this.forLibOrderFlg = _data["forLibOrderFlg"] !== undefined ? _data["forLibOrderFlg"] : null as any;
            this.finalCustomer = _data["finalCustomer"] !== undefined ? _data["finalCustomer"] : null as any;
            this.curTaxRate = _data["curTaxRate"] !== undefined ? _data["curTaxRate"] : null as any;
            this.totalPriceWithoutTax = _data["totalPriceWithoutTax"] !== undefined ? _data["totalPriceWithoutTax"] : null as any;
            this.totalTaxPrice = _data["totalTaxPrice"] !== undefined ? _data["totalTaxPrice"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.specifyApproval = _data["specifyApproval"] !== undefined ? _data["specifyApproval"] : null as any;
            this.specifyApprovalChecked = _data["specifyApprovalChecked"] !== undefined ? _data["specifyApprovalChecked"] : null as any;
            this.locationCountry = _data["locationCountry"] !== undefined ? _data["locationCountry"] : null as any;
            this.recordNumber = _data["recordNumber"] !== undefined ? _data["recordNumber"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
            this.lectotypeId = _data["lectotypeId"] !== undefined ? _data["lectotypeId"] : null as any;
            this.salesPriceDecimal = _data["salesPriceDecimal"] !== undefined ? _data["salesPriceDecimal"] : null as any;
            this.orderChangeOrderFormVersionsStatus = _data["orderChangeOrderFormVersionsStatus"] !== undefined ? _data["orderChangeOrderFormVersionsStatus"] : null as any;
            (this as any).orderChangeOrderFormVersionsStatusName = _data["orderChangeOrderFormVersionsStatusName"] !== undefined ? _data["orderChangeOrderFormVersionsStatusName"] : null as any;
            this.orderChangeVersionId = _data["orderChangeVersionId"] !== undefined ? _data["orderChangeVersionId"] : null as any;
            this.taskServiceRequestId = _data["taskServiceRequestId"] !== undefined ? _data["taskServiceRequestId"] : null as any;
            this.lectoTypesId = _data["lectoTypesId"] !== undefined ? _data["lectoTypesId"] : null as any;
            this.currencyId = _data["currencyId"] !== undefined ? _data["currencyId"] : null as any;
            this.currencyType = _data["currencyType"] !== undefined ? _data["currencyType"] : null as any;
            this.pmuSalesOrder = _data["pmuSalesOrder"] !== undefined ? _data["pmuSalesOrder"] : null as any;
            this.lsuSalesOrder = _data["lsuSalesOrder"] !== undefined ? _data["lsuSalesOrder"] : null as any;
            this.commerceReduceSuggestion = _data["commerceReduceSuggestion"] !== undefined ? _data["commerceReduceSuggestion"] : null as any;
            this.presentingParty = _data["presentingParty"] !== undefined ? _data["presentingParty"] : null as any;
            this.changeReason = _data["changeReason"] !== undefined ? _data["changeReason"] : null as any;
            this.specificReason = _data["specificReason"] !== undefined ? _data["specificReason"] : null as any;
            this.totalObsoleteInventoryCost = _data["totalObsoleteInventoryCost"] !== undefined ? _data["totalObsoleteInventoryCost"] : null as any;
            this.businessDiscount = _data["businessDiscount"] !== undefined ? _data["businessDiscount"] : null as any;
            this.materialDeliveryImpact = _data["materialDeliveryImpact"] !== undefined ? _data["materialDeliveryImpact"] : null as any;
            this.selectionIssueType = _data["selectionIssueType"] !== undefined ? _data["selectionIssueType"] : null as any;
            this.selectionIssueDetail = _data["selectionIssueDetail"] !== undefined ? _data["selectionIssueDetail"] : null as any;
            this.responsibleParty = _data["responsibleParty"] !== undefined ? _data["responsibleParty"] : null as any;
            this.scIssueType = _data["scIssueType"] !== undefined ? _data["scIssueType"] : null as any;
            this.scIssueTypeReason = _data["scIssueTypeReason"] !== undefined ? _data["scIssueTypeReason"] : null as any;
            if (Array.isArray(_data["orderChangeProductBasicMotor"])) {
                this.orderChangeProductBasicMotor = [] as any;
                for (let item of _data["orderChangeProductBasicMotor"])
                    this.orderChangeProductBasicMotor!.push(OrderChangeProductBasicMotorDto.fromJS(item));
            }
            else {
                this.orderChangeProductBasicMotor = null as any;
            }
            if (Array.isArray(_data["orderChangeOrderFormVersions"])) {
                this.orderChangeOrderFormVersions = [] as any;
                for (let item of _data["orderChangeOrderFormVersions"])
                    this.orderChangeOrderFormVersions!.push(OrderChangeOrderFormVersionsDto.fromJS(item));
            }
            else {
                this.orderChangeOrderFormVersions = null as any;
            }
            this.orderChangeProcessEntity = _data["orderChangeProcessEntity"] ? OrderChangeProcessDto.fromJS(_data["orderChangeProcessEntity"]) : null as any;
            this.orderChangeOrderMaxVersion = _data["orderChangeOrderMaxVersion"] ? OrderChangeOrderFormVersionsDto.fromJS(_data["orderChangeOrderMaxVersion"]) : null as any;
        }
    }

    static fromJS(data: any): OrderChangeOrderFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeOrderFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["projectNo"] = this.projectNo !== undefined ? this.projectNo : null as any;
        data["modelSelectionId"] = this.modelSelectionId !== undefined ? this.modelSelectionId : null as any;
        data["modelSelectionName"] = this.modelSelectionName !== undefined ? this.modelSelectionName : null as any;
        data["specialOfferApplicationNumber"] = this.specialOfferApplicationNumber !== undefined ? this.specialOfferApplicationNumber : null as any;
        data["isManual"] = this.isManual !== undefined ? this.isManual : null as any;
        data["totalNumber"] = this.totalNumber !== undefined ? this.totalNumber : null as any;
        data["totalPrice"] = this.totalPrice !== undefined ? this.totalPrice : null as any;
        data["customerOrderNumber"] = this.customerOrderNumber !== undefined ? this.customerOrderNumber : null as any;
        data["orderCancelTime"] = this.orderCancelTime ? this.orderCancelTime.toISOString() : null as any;
        data["orderTime"] = this.orderTime ? this.orderTime.toISOString() : null as any;
        data["orderCompleteTime"] = this.orderCompleteTime ? this.orderCompleteTime.toISOString() : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["customerExpectedDeliveryDate"] = this.customerExpectedDeliveryDate ? this.customerExpectedDeliveryDate.toISOString() : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["orderSource"] = this.orderSource !== undefined ? this.orderSource : null as any;
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["cpCoName"] = this.cpCoName !== undefined ? this.cpCoName : null as any;
        data["endCustomerCode"] = this.endCustomerCode !== undefined ? this.endCustomerCode : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["shippingAddressCode"] = this.shippingAddressCode !== undefined ? this.shippingAddressCode : null as any;
        data["shippingAddress"] = this.shippingAddress !== undefined ? this.shippingAddress : null as any;
        data["responsibleSalesCode"] = this.responsibleSalesCode !== undefined ? this.responsibleSalesCode : null as any;
        data["responsibleSalesName"] = this.responsibleSalesName !== undefined ? this.responsibleSalesName : null as any;
        data["attachmentName"] = this.attachmentName !== undefined ? this.attachmentName : null as any;
        data["omsOrderNumber"] = this.omsOrderNumber !== undefined ? this.omsOrderNumber : null as any;
        data["dataPlatFormOrderType"] = this.dataPlatFormOrderType ? this.dataPlatFormOrderType.toJSON() : null as any;
        data["dataPlatFormOrderTypeId"] = this.dataPlatFormOrderTypeId !== undefined ? this.dataPlatFormOrderTypeId : null as any;
        data["industry"] = this.industry ? this.industry.toJSON() : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["channel"] = this.channel ? this.channel.toJSON() : null as any;
        data["salesArea"] = this.salesArea ? this.salesArea.toJSON() : null as any;
        data["deliveryTerms"] = this.deliveryTerms !== undefined ? this.deliveryTerms : null as any;
        data["isPoNumber"] = this.isPoNumber !== undefined ? this.isPoNumber : null as any;
        data["forLibOrderFlg"] = this.forLibOrderFlg !== undefined ? this.forLibOrderFlg : null as any;
        data["finalCustomer"] = this.finalCustomer !== undefined ? this.finalCustomer : null as any;
        data["curTaxRate"] = this.curTaxRate !== undefined ? this.curTaxRate : null as any;
        data["totalPriceWithoutTax"] = this.totalPriceWithoutTax !== undefined ? this.totalPriceWithoutTax : null as any;
        data["totalTaxPrice"] = this.totalTaxPrice !== undefined ? this.totalTaxPrice : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["specifyApproval"] = this.specifyApproval !== undefined ? this.specifyApproval : null as any;
        data["specifyApprovalChecked"] = this.specifyApprovalChecked !== undefined ? this.specifyApprovalChecked : null as any;
        data["locationCountry"] = this.locationCountry !== undefined ? this.locationCountry : null as any;
        data["recordNumber"] = this.recordNumber !== undefined ? this.recordNumber : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        data["lectotypeId"] = this.lectotypeId !== undefined ? this.lectotypeId : null as any;
        data["salesPriceDecimal"] = this.salesPriceDecimal !== undefined ? this.salesPriceDecimal : null as any;
        data["orderChangeOrderFormVersionsStatus"] = this.orderChangeOrderFormVersionsStatus !== undefined ? this.orderChangeOrderFormVersionsStatus : null as any;
        data["orderChangeOrderFormVersionsStatusName"] = this.orderChangeOrderFormVersionsStatusName !== undefined ? this.orderChangeOrderFormVersionsStatusName : null as any;
        data["orderChangeVersionId"] = this.orderChangeVersionId !== undefined ? this.orderChangeVersionId : null as any;
        data["taskServiceRequestId"] = this.taskServiceRequestId !== undefined ? this.taskServiceRequestId : null as any;
        data["lectoTypesId"] = this.lectoTypesId !== undefined ? this.lectoTypesId : null as any;
        data["currencyId"] = this.currencyId !== undefined ? this.currencyId : null as any;
        data["currencyType"] = this.currencyType !== undefined ? this.currencyType : null as any;
        data["pmuSalesOrder"] = this.pmuSalesOrder !== undefined ? this.pmuSalesOrder : null as any;
        data["lsuSalesOrder"] = this.lsuSalesOrder !== undefined ? this.lsuSalesOrder : null as any;
        data["commerceReduceSuggestion"] = this.commerceReduceSuggestion !== undefined ? this.commerceReduceSuggestion : null as any;
        data["presentingParty"] = this.presentingParty !== undefined ? this.presentingParty : null as any;
        data["changeReason"] = this.changeReason !== undefined ? this.changeReason : null as any;
        data["specificReason"] = this.specificReason !== undefined ? this.specificReason : null as any;
        data["totalObsoleteInventoryCost"] = this.totalObsoleteInventoryCost !== undefined ? this.totalObsoleteInventoryCost : null as any;
        data["businessDiscount"] = this.businessDiscount !== undefined ? this.businessDiscount : null as any;
        data["materialDeliveryImpact"] = this.materialDeliveryImpact !== undefined ? this.materialDeliveryImpact : null as any;
        data["selectionIssueType"] = this.selectionIssueType !== undefined ? this.selectionIssueType : null as any;
        data["selectionIssueDetail"] = this.selectionIssueDetail !== undefined ? this.selectionIssueDetail : null as any;
        data["responsibleParty"] = this.responsibleParty !== undefined ? this.responsibleParty : null as any;
        data["scIssueType"] = this.scIssueType !== undefined ? this.scIssueType : null as any;
        data["scIssueTypeReason"] = this.scIssueTypeReason !== undefined ? this.scIssueTypeReason : null as any;
        if (Array.isArray(this.orderChangeProductBasicMotor)) {
            data["orderChangeProductBasicMotor"] = [];
            for (let item of this.orderChangeProductBasicMotor)
                data["orderChangeProductBasicMotor"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.orderChangeOrderFormVersions)) {
            data["orderChangeOrderFormVersions"] = [];
            for (let item of this.orderChangeOrderFormVersions)
                data["orderChangeOrderFormVersions"].push(item ? item.toJSON() : null as any);
        }
        data["orderChangeProcessEntity"] = this.orderChangeProcessEntity ? this.orderChangeProcessEntity.toJSON() : null as any;
        data["orderChangeOrderMaxVersion"] = this.orderChangeOrderMaxVersion ? this.orderChangeOrderMaxVersion.toJSON() : null as any;
        return data;
    }
}

export class OrderChangeOrderFormRevokeApproveDto {
    /** 流程Id */
    serviceRequestId!: string;
    /** 是否同意 */
    isApprove!: boolean;
    /** 审批原因 */
    revokeApproveRemark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.serviceRequestId = _data["serviceRequestId"] !== undefined ? _data["serviceRequestId"] : null as any;
            this.isApprove = _data["isApprove"] !== undefined ? _data["isApprove"] : null as any;
            this.revokeApproveRemark = _data["revokeApproveRemark"] !== undefined ? _data["revokeApproveRemark"] : null as any;
        }
    }

    static fromJS(data: any): OrderChangeOrderFormRevokeApproveDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeOrderFormRevokeApproveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceRequestId"] = this.serviceRequestId !== undefined ? this.serviceRequestId : null as any;
        data["isApprove"] = this.isApprove !== undefined ? this.isApprove : null as any;
        data["revokeApproveRemark"] = this.revokeApproveRemark !== undefined ? this.revokeApproveRemark : null as any;
        return data;
    }
}

export class OrderChangeOrderFormRevokeDto {
    /** 流程Id */
    serviceRequestId!: string;

    init(_data?: any) {
        if (_data) {
            this.serviceRequestId = _data["serviceRequestId"] !== undefined ? _data["serviceRequestId"] : null as any;
        }
    }

    static fromJS(data: any): OrderChangeOrderFormRevokeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeOrderFormRevokeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceRequestId"] = this.serviceRequestId !== undefined ? this.serviceRequestId : null as any;
        return data;
    }
}

export class OrderChangeOrderFormTaskLetDto {
    /** 子流程ID */
    taskLetServiceRequestId!: string;
    /** 主流程camunda实例ID */
    mainProcessInstanceId!: string | null;
    taskProcessInstanceId!: string | null;
    remark!: string | null;
    status!: EnumOrderChangeOrderFormVersionsStatus;
    serviceTypeId!: string | null;
    sequenceNumber!: string | null;

    init(_data?: any) {
        if (_data) {
            this.taskLetServiceRequestId = _data["taskLetServiceRequestId"] !== undefined ? _data["taskLetServiceRequestId"] : null as any;
            this.mainProcessInstanceId = _data["mainProcessInstanceId"] !== undefined ? _data["mainProcessInstanceId"] : null as any;
            this.taskProcessInstanceId = _data["taskProcessInstanceId"] !== undefined ? _data["taskProcessInstanceId"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.serviceTypeId = _data["serviceTypeId"] !== undefined ? _data["serviceTypeId"] : null as any;
            this.sequenceNumber = _data["sequenceNumber"] !== undefined ? _data["sequenceNumber"] : null as any;
        }
    }

    static fromJS(data: any): OrderChangeOrderFormTaskLetDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeOrderFormTaskLetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskLetServiceRequestId"] = this.taskLetServiceRequestId !== undefined ? this.taskLetServiceRequestId : null as any;
        data["mainProcessInstanceId"] = this.mainProcessInstanceId !== undefined ? this.mainProcessInstanceId : null as any;
        data["taskProcessInstanceId"] = this.taskProcessInstanceId !== undefined ? this.taskProcessInstanceId : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["serviceTypeId"] = this.serviceTypeId !== undefined ? this.serviceTypeId : null as any;
        data["sequenceNumber"] = this.sequenceNumber !== undefined ? this.sequenceNumber : null as any;
        return data;
    }
}

export class OrderChangeOrderFormVCDto {
    productCode!: string | null;
    vcCode!: string | null;
    changeType!: EnumChangeType;
    readonly changeTypeName!: string | null;
    serialNumber!: number | null;
    oldValue!: string | null;
    newValue!: string | null;
    oldRemark!: string | null;
    newRemark!: string | null;
    oldSalasPrice!: number | null;
    newSalasPrice!: number | null;
    oldUnitPrice!: number | null;
    newUnitPrice!: number | null;
    oldMeaning!: string | null;
    newMeaning!: string | null;
    orderChangeProductBasicMotorId!: string;
    orderChangeProductBasicMotor!: OrderChangeProductBasicMotor;

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"] !== undefined ? _data["productCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.changeType = _data["changeType"] !== undefined ? _data["changeType"] : null as any;
            (this as any).changeTypeName = _data["changeTypeName"] !== undefined ? _data["changeTypeName"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.oldValue = _data["oldValue"] !== undefined ? _data["oldValue"] : null as any;
            this.newValue = _data["newValue"] !== undefined ? _data["newValue"] : null as any;
            this.oldRemark = _data["oldRemark"] !== undefined ? _data["oldRemark"] : null as any;
            this.newRemark = _data["newRemark"] !== undefined ? _data["newRemark"] : null as any;
            this.oldSalasPrice = _data["oldSalasPrice"] !== undefined ? _data["oldSalasPrice"] : null as any;
            this.newSalasPrice = _data["newSalasPrice"] !== undefined ? _data["newSalasPrice"] : null as any;
            this.oldUnitPrice = _data["oldUnitPrice"] !== undefined ? _data["oldUnitPrice"] : null as any;
            this.newUnitPrice = _data["newUnitPrice"] !== undefined ? _data["newUnitPrice"] : null as any;
            this.oldMeaning = _data["oldMeaning"] !== undefined ? _data["oldMeaning"] : null as any;
            this.newMeaning = _data["newMeaning"] !== undefined ? _data["newMeaning"] : null as any;
            this.orderChangeProductBasicMotorId = _data["orderChangeProductBasicMotorId"] !== undefined ? _data["orderChangeProductBasicMotorId"] : null as any;
            this.orderChangeProductBasicMotor = _data["orderChangeProductBasicMotor"] ? OrderChangeProductBasicMotor.fromJS(_data["orderChangeProductBasicMotor"]) : null as any;
        }
    }

    static fromJS(data: any): OrderChangeOrderFormVCDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeOrderFormVCDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode !== undefined ? this.productCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["changeType"] = this.changeType !== undefined ? this.changeType : null as any;
        data["changeTypeName"] = this.changeTypeName !== undefined ? this.changeTypeName : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["oldValue"] = this.oldValue !== undefined ? this.oldValue : null as any;
        data["newValue"] = this.newValue !== undefined ? this.newValue : null as any;
        data["oldRemark"] = this.oldRemark !== undefined ? this.oldRemark : null as any;
        data["newRemark"] = this.newRemark !== undefined ? this.newRemark : null as any;
        data["oldSalasPrice"] = this.oldSalasPrice !== undefined ? this.oldSalasPrice : null as any;
        data["newSalasPrice"] = this.newSalasPrice !== undefined ? this.newSalasPrice : null as any;
        data["oldUnitPrice"] = this.oldUnitPrice !== undefined ? this.oldUnitPrice : null as any;
        data["newUnitPrice"] = this.newUnitPrice !== undefined ? this.newUnitPrice : null as any;
        data["oldMeaning"] = this.oldMeaning !== undefined ? this.oldMeaning : null as any;
        data["newMeaning"] = this.newMeaning !== undefined ? this.newMeaning : null as any;
        data["orderChangeProductBasicMotorId"] = this.orderChangeProductBasicMotorId !== undefined ? this.orderChangeProductBasicMotorId : null as any;
        data["orderChangeProductBasicMotor"] = this.orderChangeProductBasicMotor ? this.orderChangeProductBasicMotor.toJSON() : null as any;
        return data;
    }
}

export class OrderChangeOrderFormVersions {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    orderChangeOrderFormId!: string;
    sourceOrderFromID!: string;
    version!: number | null;
    status!: EnumOrderChangeOrderFormVersionsStatus;
    revokeApproveStatus!: EnumOrderChangeOrderFormVersionsRevokeStatus;
    revokeRemark!: string | null;
    revokeApproveRemark!: string | null;
    mspjson!: string | null;
    approvalRemark!: string | null;
    taskProcessInstanceId!: string | null;
    taskServiceRequestId!: string | null;
    serviceTypeId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.orderChangeOrderFormId = _data["orderChangeOrderFormId"] !== undefined ? _data["orderChangeOrderFormId"] : null as any;
            this.sourceOrderFromID = _data["sourceOrderFromID"] !== undefined ? _data["sourceOrderFromID"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.revokeApproveStatus = _data["revokeApproveStatus"] !== undefined ? _data["revokeApproveStatus"] : null as any;
            this.revokeRemark = _data["revokeRemark"] !== undefined ? _data["revokeRemark"] : null as any;
            this.revokeApproveRemark = _data["revokeApproveRemark"] !== undefined ? _data["revokeApproveRemark"] : null as any;
            this.mspjson = _data["mspjson"] !== undefined ? _data["mspjson"] : null as any;
            this.approvalRemark = _data["approvalRemark"] !== undefined ? _data["approvalRemark"] : null as any;
            this.taskProcessInstanceId = _data["taskProcessInstanceId"] !== undefined ? _data["taskProcessInstanceId"] : null as any;
            this.taskServiceRequestId = _data["taskServiceRequestId"] !== undefined ? _data["taskServiceRequestId"] : null as any;
            this.serviceTypeId = _data["serviceTypeId"] !== undefined ? _data["serviceTypeId"] : null as any;
        }
    }

    static fromJS(data: any): OrderChangeOrderFormVersions {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeOrderFormVersions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["orderChangeOrderFormId"] = this.orderChangeOrderFormId !== undefined ? this.orderChangeOrderFormId : null as any;
        data["sourceOrderFromID"] = this.sourceOrderFromID !== undefined ? this.sourceOrderFromID : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["revokeApproveStatus"] = this.revokeApproveStatus !== undefined ? this.revokeApproveStatus : null as any;
        data["revokeRemark"] = this.revokeRemark !== undefined ? this.revokeRemark : null as any;
        data["revokeApproveRemark"] = this.revokeApproveRemark !== undefined ? this.revokeApproveRemark : null as any;
        data["mspjson"] = this.mspjson !== undefined ? this.mspjson : null as any;
        data["approvalRemark"] = this.approvalRemark !== undefined ? this.approvalRemark : null as any;
        data["taskProcessInstanceId"] = this.taskProcessInstanceId !== undefined ? this.taskProcessInstanceId : null as any;
        data["taskServiceRequestId"] = this.taskServiceRequestId !== undefined ? this.taskServiceRequestId : null as any;
        data["serviceTypeId"] = this.serviceTypeId !== undefined ? this.serviceTypeId : null as any;
        return data;
    }
}

export class OrderChangeOrderFormVersionsDto {
    id!: string;
    /** 变更ID */
    orderChangeOrderFormId!: string;
    /** 源订单ID */
    sourceOrderFromID!: string;
    /** 版本号 */
    version!: number | null;
    status!: EnumOrderChangeOrderFormVersionsStatus;
    creationTime!: moment.Moment;
    /** 完成时间 */
    lastModificationTime!: moment.Moment | null;
    revokeApproveStatus!: EnumOrderChangeOrderFormVersionsRevokeStatus;
    readonly orderChangeOrderFormVersionsStatusName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.orderChangeOrderFormId = _data["orderChangeOrderFormId"] !== undefined ? _data["orderChangeOrderFormId"] : null as any;
            this.sourceOrderFromID = _data["sourceOrderFromID"] !== undefined ? _data["sourceOrderFromID"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.revokeApproveStatus = _data["revokeApproveStatus"] !== undefined ? _data["revokeApproveStatus"] : null as any;
            (this as any).orderChangeOrderFormVersionsStatusName = _data["orderChangeOrderFormVersionsStatusName"] !== undefined ? _data["orderChangeOrderFormVersionsStatusName"] : null as any;
        }
    }

    static fromJS(data: any): OrderChangeOrderFormVersionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeOrderFormVersionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["orderChangeOrderFormId"] = this.orderChangeOrderFormId !== undefined ? this.orderChangeOrderFormId : null as any;
        data["sourceOrderFromID"] = this.sourceOrderFromID !== undefined ? this.sourceOrderFromID : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["revokeApproveStatus"] = this.revokeApproveStatus !== undefined ? this.revokeApproveStatus : null as any;
        data["orderChangeOrderFormVersionsStatusName"] = this.orderChangeOrderFormVersionsStatusName !== undefined ? this.orderChangeOrderFormVersionsStatusName : null as any;
        return data;
    }
}

/** 内销,外销.订单变更公共类 */
export class OrderChangeProcessDto {
    id!: string;
    /** 版本ID */
    orderChangeOrderFormVersionsId!: string;
    /** 主订单ID */
    orderChangeFromId!: string;
    orderChangeType!: EnumOrderChangeType;
    /** 提出方, 创建时候填写 */
    presentingParty!: string | null;
    /** 变更原因 ,创建时候填写 */
    changeReason!: string | null;
    /** 变更原因,具体原因 */
    changeMaterialRemarks!: string | null;
    /** 责任方
流程回传 */
    responsibleParty!: string | null;
    /** 选型问题类型
流程回传 */
    selectionIssueType!: string | null;
    /** 选型问题具体描述
流程回传 */
    selectionIssueDetail!: string | null;
    /** 减免金额 */
    deductionAmount!: number | null;
    /** 减免原因 */
    abatementReason!: string | null;
    /** 减免提出方 */
    reductionRequester!: string | null;
    /** 减免具体原因 */
    abatementInitiator!: string | null;
    /** 提出方, 创建时候填写 */
    presentingPartyByBusiness!: string | null;
    /** 变更原因 ,创建时候填写 */
    changeReasonByBusiness!: string | null;
    /** 变更原因,具体原因 */
    changeMaterialRemarksByBusiness!: string | null;
    /** 责任方
流程回传 */
    responsiblePartyByBusiness!: string | null;
    /** 选型问题类型
流程回传 */
    selectionIssueTypeByBusiness!: string | null;
    /** 选型问题具体描述
流程回传 */
    selectionIssueDetailByBusiness!: string | null;
    /** 费用减免原因 */
    needDoFavorReason!: string | null;
    /** 费用减免具体原因 */
    needDoFavorReasonRemark!: string | null;
    orderChangeProductBasicProcesses!: OrderChangeProductBasicProcessDTO[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.orderChangeOrderFormVersionsId = _data["orderChangeOrderFormVersionsId"] !== undefined ? _data["orderChangeOrderFormVersionsId"] : null as any;
            this.orderChangeFromId = _data["orderChangeFromId"] !== undefined ? _data["orderChangeFromId"] : null as any;
            this.orderChangeType = _data["orderChangeType"] !== undefined ? _data["orderChangeType"] : null as any;
            this.presentingParty = _data["presentingParty"] !== undefined ? _data["presentingParty"] : null as any;
            this.changeReason = _data["changeReason"] !== undefined ? _data["changeReason"] : null as any;
            this.changeMaterialRemarks = _data["changeMaterialRemarks"] !== undefined ? _data["changeMaterialRemarks"] : null as any;
            this.responsibleParty = _data["responsibleParty"] !== undefined ? _data["responsibleParty"] : null as any;
            this.selectionIssueType = _data["selectionIssueType"] !== undefined ? _data["selectionIssueType"] : null as any;
            this.selectionIssueDetail = _data["selectionIssueDetail"] !== undefined ? _data["selectionIssueDetail"] : null as any;
            this.deductionAmount = _data["deductionAmount"] !== undefined ? _data["deductionAmount"] : null as any;
            this.abatementReason = _data["abatementReason"] !== undefined ? _data["abatementReason"] : null as any;
            this.reductionRequester = _data["reductionRequester"] !== undefined ? _data["reductionRequester"] : null as any;
            this.abatementInitiator = _data["abatementInitiator"] !== undefined ? _data["abatementInitiator"] : null as any;
            this.presentingPartyByBusiness = _data["presentingPartyByBusiness"] !== undefined ? _data["presentingPartyByBusiness"] : null as any;
            this.changeReasonByBusiness = _data["changeReasonByBusiness"] !== undefined ? _data["changeReasonByBusiness"] : null as any;
            this.changeMaterialRemarksByBusiness = _data["changeMaterialRemarksByBusiness"] !== undefined ? _data["changeMaterialRemarksByBusiness"] : null as any;
            this.responsiblePartyByBusiness = _data["responsiblePartyByBusiness"] !== undefined ? _data["responsiblePartyByBusiness"] : null as any;
            this.selectionIssueTypeByBusiness = _data["selectionIssueTypeByBusiness"] !== undefined ? _data["selectionIssueTypeByBusiness"] : null as any;
            this.selectionIssueDetailByBusiness = _data["selectionIssueDetailByBusiness"] !== undefined ? _data["selectionIssueDetailByBusiness"] : null as any;
            this.needDoFavorReason = _data["needDoFavorReason"] !== undefined ? _data["needDoFavorReason"] : null as any;
            this.needDoFavorReasonRemark = _data["needDoFavorReasonRemark"] !== undefined ? _data["needDoFavorReasonRemark"] : null as any;
            if (Array.isArray(_data["orderChangeProductBasicProcesses"])) {
                this.orderChangeProductBasicProcesses = [] as any;
                for (let item of _data["orderChangeProductBasicProcesses"])
                    this.orderChangeProductBasicProcesses!.push(OrderChangeProductBasicProcessDTO.fromJS(item));
            }
            else {
                this.orderChangeProductBasicProcesses = null as any;
            }
        }
    }

    static fromJS(data: any): OrderChangeProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["orderChangeOrderFormVersionsId"] = this.orderChangeOrderFormVersionsId !== undefined ? this.orderChangeOrderFormVersionsId : null as any;
        data["orderChangeFromId"] = this.orderChangeFromId !== undefined ? this.orderChangeFromId : null as any;
        data["orderChangeType"] = this.orderChangeType !== undefined ? this.orderChangeType : null as any;
        data["presentingParty"] = this.presentingParty !== undefined ? this.presentingParty : null as any;
        data["changeReason"] = this.changeReason !== undefined ? this.changeReason : null as any;
        data["changeMaterialRemarks"] = this.changeMaterialRemarks !== undefined ? this.changeMaterialRemarks : null as any;
        data["responsibleParty"] = this.responsibleParty !== undefined ? this.responsibleParty : null as any;
        data["selectionIssueType"] = this.selectionIssueType !== undefined ? this.selectionIssueType : null as any;
        data["selectionIssueDetail"] = this.selectionIssueDetail !== undefined ? this.selectionIssueDetail : null as any;
        data["deductionAmount"] = this.deductionAmount !== undefined ? this.deductionAmount : null as any;
        data["abatementReason"] = this.abatementReason !== undefined ? this.abatementReason : null as any;
        data["reductionRequester"] = this.reductionRequester !== undefined ? this.reductionRequester : null as any;
        data["abatementInitiator"] = this.abatementInitiator !== undefined ? this.abatementInitiator : null as any;
        data["presentingPartyByBusiness"] = this.presentingPartyByBusiness !== undefined ? this.presentingPartyByBusiness : null as any;
        data["changeReasonByBusiness"] = this.changeReasonByBusiness !== undefined ? this.changeReasonByBusiness : null as any;
        data["changeMaterialRemarksByBusiness"] = this.changeMaterialRemarksByBusiness !== undefined ? this.changeMaterialRemarksByBusiness : null as any;
        data["responsiblePartyByBusiness"] = this.responsiblePartyByBusiness !== undefined ? this.responsiblePartyByBusiness : null as any;
        data["selectionIssueTypeByBusiness"] = this.selectionIssueTypeByBusiness !== undefined ? this.selectionIssueTypeByBusiness : null as any;
        data["selectionIssueDetailByBusiness"] = this.selectionIssueDetailByBusiness !== undefined ? this.selectionIssueDetailByBusiness : null as any;
        data["needDoFavorReason"] = this.needDoFavorReason !== undefined ? this.needDoFavorReason : null as any;
        data["needDoFavorReasonRemark"] = this.needDoFavorReasonRemark !== undefined ? this.needDoFavorReasonRemark : null as any;
        if (Array.isArray(this.orderChangeProductBasicProcesses)) {
            data["orderChangeProductBasicProcesses"] = [];
            for (let item of this.orderChangeProductBasicProcesses)
                data["orderChangeProductBasicProcesses"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class OrderChangeProcessEntity {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    orderChangeOrderFormVersionsId!: string;
    orderChangeFromId!: string;
    orderChangeType!: EnumOrderChangeType;
    presentingParty!: string | null;
    changeReason!: string | null;
    changeMaterialRemarks!: string | null;
    responsibleParty!: string | null;
    selectionIssueType!: string | null;
    selectionIssueDetail!: string | null;
    deductionAmount!: number | null;
    abatementReason!: string | null;
    reductionRequester!: string | null;
    abatementInitiator!: string | null;
    presentingPartyByBusiness!: string | null;
    changeReasonByBusiness!: string | null;
    changeMaterialRemarksByBusiness!: string | null;
    responsiblePartyByBusiness!: string | null;
    selectionIssueTypeByBusiness!: string | null;
    selectionIssueDetailByBusiness!: string | null;
    needDoFavorReason!: string | null;
    needDoFavorReasonRemark!: string | null;
    orderChangeOrderForm!: OrderChangeOrderForm;
    orderChangeOrderFormVersions!: OrderChangeOrderFormVersions;
    orderChangeProductBasicProcesses!: OrderChangeProductBasicProcessEntity[] | null;
    oisExportOrder!: OISExportOrder;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.orderChangeOrderFormVersionsId = _data["orderChangeOrderFormVersionsId"] !== undefined ? _data["orderChangeOrderFormVersionsId"] : null as any;
            this.orderChangeFromId = _data["orderChangeFromId"] !== undefined ? _data["orderChangeFromId"] : null as any;
            this.orderChangeType = _data["orderChangeType"] !== undefined ? _data["orderChangeType"] : null as any;
            this.presentingParty = _data["presentingParty"] !== undefined ? _data["presentingParty"] : null as any;
            this.changeReason = _data["changeReason"] !== undefined ? _data["changeReason"] : null as any;
            this.changeMaterialRemarks = _data["changeMaterialRemarks"] !== undefined ? _data["changeMaterialRemarks"] : null as any;
            this.responsibleParty = _data["responsibleParty"] !== undefined ? _data["responsibleParty"] : null as any;
            this.selectionIssueType = _data["selectionIssueType"] !== undefined ? _data["selectionIssueType"] : null as any;
            this.selectionIssueDetail = _data["selectionIssueDetail"] !== undefined ? _data["selectionIssueDetail"] : null as any;
            this.deductionAmount = _data["deductionAmount"] !== undefined ? _data["deductionAmount"] : null as any;
            this.abatementReason = _data["abatementReason"] !== undefined ? _data["abatementReason"] : null as any;
            this.reductionRequester = _data["reductionRequester"] !== undefined ? _data["reductionRequester"] : null as any;
            this.abatementInitiator = _data["abatementInitiator"] !== undefined ? _data["abatementInitiator"] : null as any;
            this.presentingPartyByBusiness = _data["presentingPartyByBusiness"] !== undefined ? _data["presentingPartyByBusiness"] : null as any;
            this.changeReasonByBusiness = _data["changeReasonByBusiness"] !== undefined ? _data["changeReasonByBusiness"] : null as any;
            this.changeMaterialRemarksByBusiness = _data["changeMaterialRemarksByBusiness"] !== undefined ? _data["changeMaterialRemarksByBusiness"] : null as any;
            this.responsiblePartyByBusiness = _data["responsiblePartyByBusiness"] !== undefined ? _data["responsiblePartyByBusiness"] : null as any;
            this.selectionIssueTypeByBusiness = _data["selectionIssueTypeByBusiness"] !== undefined ? _data["selectionIssueTypeByBusiness"] : null as any;
            this.selectionIssueDetailByBusiness = _data["selectionIssueDetailByBusiness"] !== undefined ? _data["selectionIssueDetailByBusiness"] : null as any;
            this.needDoFavorReason = _data["needDoFavorReason"] !== undefined ? _data["needDoFavorReason"] : null as any;
            this.needDoFavorReasonRemark = _data["needDoFavorReasonRemark"] !== undefined ? _data["needDoFavorReasonRemark"] : null as any;
            this.orderChangeOrderForm = _data["orderChangeOrderForm"] ? OrderChangeOrderForm.fromJS(_data["orderChangeOrderForm"]) : null as any;
            this.orderChangeOrderFormVersions = _data["orderChangeOrderFormVersions"] ? OrderChangeOrderFormVersions.fromJS(_data["orderChangeOrderFormVersions"]) : null as any;
            if (Array.isArray(_data["orderChangeProductBasicProcesses"])) {
                this.orderChangeProductBasicProcesses = [] as any;
                for (let item of _data["orderChangeProductBasicProcesses"])
                    this.orderChangeProductBasicProcesses!.push(OrderChangeProductBasicProcessEntity.fromJS(item));
            }
            else {
                this.orderChangeProductBasicProcesses = null as any;
            }
            this.oisExportOrder = _data["oisExportOrder"] ? OISExportOrder.fromJS(_data["oisExportOrder"]) : null as any;
        }
    }

    static fromJS(data: any): OrderChangeProcessEntity {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeProcessEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["orderChangeOrderFormVersionsId"] = this.orderChangeOrderFormVersionsId !== undefined ? this.orderChangeOrderFormVersionsId : null as any;
        data["orderChangeFromId"] = this.orderChangeFromId !== undefined ? this.orderChangeFromId : null as any;
        data["orderChangeType"] = this.orderChangeType !== undefined ? this.orderChangeType : null as any;
        data["presentingParty"] = this.presentingParty !== undefined ? this.presentingParty : null as any;
        data["changeReason"] = this.changeReason !== undefined ? this.changeReason : null as any;
        data["changeMaterialRemarks"] = this.changeMaterialRemarks !== undefined ? this.changeMaterialRemarks : null as any;
        data["responsibleParty"] = this.responsibleParty !== undefined ? this.responsibleParty : null as any;
        data["selectionIssueType"] = this.selectionIssueType !== undefined ? this.selectionIssueType : null as any;
        data["selectionIssueDetail"] = this.selectionIssueDetail !== undefined ? this.selectionIssueDetail : null as any;
        data["deductionAmount"] = this.deductionAmount !== undefined ? this.deductionAmount : null as any;
        data["abatementReason"] = this.abatementReason !== undefined ? this.abatementReason : null as any;
        data["reductionRequester"] = this.reductionRequester !== undefined ? this.reductionRequester : null as any;
        data["abatementInitiator"] = this.abatementInitiator !== undefined ? this.abatementInitiator : null as any;
        data["presentingPartyByBusiness"] = this.presentingPartyByBusiness !== undefined ? this.presentingPartyByBusiness : null as any;
        data["changeReasonByBusiness"] = this.changeReasonByBusiness !== undefined ? this.changeReasonByBusiness : null as any;
        data["changeMaterialRemarksByBusiness"] = this.changeMaterialRemarksByBusiness !== undefined ? this.changeMaterialRemarksByBusiness : null as any;
        data["responsiblePartyByBusiness"] = this.responsiblePartyByBusiness !== undefined ? this.responsiblePartyByBusiness : null as any;
        data["selectionIssueTypeByBusiness"] = this.selectionIssueTypeByBusiness !== undefined ? this.selectionIssueTypeByBusiness : null as any;
        data["selectionIssueDetailByBusiness"] = this.selectionIssueDetailByBusiness !== undefined ? this.selectionIssueDetailByBusiness : null as any;
        data["needDoFavorReason"] = this.needDoFavorReason !== undefined ? this.needDoFavorReason : null as any;
        data["needDoFavorReasonRemark"] = this.needDoFavorReasonRemark !== undefined ? this.needDoFavorReasonRemark : null as any;
        data["orderChangeOrderForm"] = this.orderChangeOrderForm ? this.orderChangeOrderForm.toJSON() : null as any;
        data["orderChangeOrderFormVersions"] = this.orderChangeOrderFormVersions ? this.orderChangeOrderFormVersions.toJSON() : null as any;
        if (Array.isArray(this.orderChangeProductBasicProcesses)) {
            data["orderChangeProductBasicProcesses"] = [];
            for (let item of this.orderChangeProductBasicProcesses)
                data["orderChangeProductBasicProcesses"].push(item ? item.toJSON() : null as any);
        }
        data["oisExportOrder"] = this.oisExportOrder ? this.oisExportOrder.toJSON() : null as any;
        return data;
    }
}

export class OrderChangeProductBasicMotor {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    productMixCode!: string | null;
    customerMaterialNumber!: string | null;
    appraisalNumber!: string | null;
    orderType!: string | null;
    basicMotorModel!: string | null;
    basicMotorCode!: string | null;
    basicMotorType!: number;
    basicMotorSries!: string | null;
    numberOfProduct!: number;
    multipilerType!: number;
    multiplier!: number;
    multiplierExpiredDate!: moment.Moment | null;
    unitPriceType!: string | null;
    unitPriceExpiredTime!: moment.Moment | null;
    unitPrice!: number;
    salesPrice!: number;
    oemSalesPrice!: number;
    remark!: string | null;
    remarkTwo!: string | null;
    frameSize!: number;
    expectedDeliveryDate!: string | null;
    actualDeliveryDate!: string | null;
    customerExpectedDeliveryDate!: moment.Moment | null;
    customerActualDeliveryDate!: moment.Moment | null;
    gssQuotationNo!: string | null;
    gssTechnicalConfirmationNumber!: string | null;
    technicalSpecifications!: string | null;
    receivePrdTechJSON!: string | null;
    receivePrdElecsJSON!: string | null;
    checkResultOutput!: string | null;
    productClassification!: string | null;
    orderClassification!: string | null;
    orderChangeProductVC!: OrderChangeProductVC[] | null;
    shoppingCart!: ShoppingCart;
    priceWithTax!: number | null;
    priceWithoutTax!: number | null;
    unitTaxPrice!: number | null;
    discountUnitPrice!: number | null;
    noDiscountByPlatformUnitPrice!: number | null;
    noDiscountByListUnitPrice!: number | null;
    serialNumber!: number | null;
    scSerialNumber!: number | null;
    specialRebateFlag!: string | null;
    isNewPMSProduct!: boolean | null;
    precalItemNo!: number | null;
    operationalRemarks!: string | null;
    orderChangeOrderFormId!: string | null;
    shortLink!: string | null;
    pmuSoitemCategory!: string | null;
    totalUnitPrice!: number | null;
    pmsMultiplier!: number | null;
    originalMultiplier!: number | null;
    changeFee!: number | null;
    orderChangeProductBasicProcessEntity!: OrderChangeProductBasicProcessEntity;
    technologyQuotationProductId!: string | null;
    technicalSpecificationProductId!: string | null;
    jinCategoryCode!: string | null;
    jinVersion!: string | null;
    materialDescription!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.productMixCode = _data["productMixCode"] !== undefined ? _data["productMixCode"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorType = _data["basicMotorType"] !== undefined ? _data["basicMotorType"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.numberOfProduct = _data["numberOfProduct"] !== undefined ? _data["numberOfProduct"] : null as any;
            this.multipilerType = _data["multipilerType"] !== undefined ? _data["multipilerType"] : null as any;
            this.multiplier = _data["multiplier"] !== undefined ? _data["multiplier"] : null as any;
            this.multiplierExpiredDate = _data["multiplierExpiredDate"] ? moment(_data["multiplierExpiredDate"].toString()) : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.unitPriceExpiredTime = _data["unitPriceExpiredTime"] ? moment(_data["unitPriceExpiredTime"].toString()) : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.oemSalesPrice = _data["oemSalesPrice"] !== undefined ? _data["oemSalesPrice"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.remarkTwo = _data["remarkTwo"] !== undefined ? _data["remarkTwo"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.actualDeliveryDate = _data["actualDeliveryDate"] !== undefined ? _data["actualDeliveryDate"] : null as any;
            this.customerExpectedDeliveryDate = _data["customerExpectedDeliveryDate"] ? moment(_data["customerExpectedDeliveryDate"].toString()) : null as any;
            this.customerActualDeliveryDate = _data["customerActualDeliveryDate"] ? moment(_data["customerActualDeliveryDate"].toString()) : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.receivePrdTechJSON = _data["receivePrdTechJSON"] !== undefined ? _data["receivePrdTechJSON"] : null as any;
            this.receivePrdElecsJSON = _data["receivePrdElecsJSON"] !== undefined ? _data["receivePrdElecsJSON"] : null as any;
            this.checkResultOutput = _data["checkResultOutput"] !== undefined ? _data["checkResultOutput"] : null as any;
            this.productClassification = _data["productClassification"] !== undefined ? _data["productClassification"] : null as any;
            this.orderClassification = _data["orderClassification"] !== undefined ? _data["orderClassification"] : null as any;
            if (Array.isArray(_data["orderChangeProductVC"])) {
                this.orderChangeProductVC = [] as any;
                for (let item of _data["orderChangeProductVC"])
                    this.orderChangeProductVC!.push(OrderChangeProductVC.fromJS(item));
            }
            else {
                this.orderChangeProductVC = null as any;
            }
            this.shoppingCart = _data["shoppingCart"] ? ShoppingCart.fromJS(_data["shoppingCart"]) : null as any;
            this.priceWithTax = _data["priceWithTax"] !== undefined ? _data["priceWithTax"] : null as any;
            this.priceWithoutTax = _data["priceWithoutTax"] !== undefined ? _data["priceWithoutTax"] : null as any;
            this.unitTaxPrice = _data["unitTaxPrice"] !== undefined ? _data["unitTaxPrice"] : null as any;
            this.discountUnitPrice = _data["discountUnitPrice"] !== undefined ? _data["discountUnitPrice"] : null as any;
            this.noDiscountByPlatformUnitPrice = _data["noDiscountByPlatformUnitPrice"] !== undefined ? _data["noDiscountByPlatformUnitPrice"] : null as any;
            this.noDiscountByListUnitPrice = _data["noDiscountByListUnitPrice"] !== undefined ? _data["noDiscountByListUnitPrice"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.scSerialNumber = _data["scSerialNumber"] !== undefined ? _data["scSerialNumber"] : null as any;
            this.specialRebateFlag = _data["specialRebateFlag"] !== undefined ? _data["specialRebateFlag"] : null as any;
            this.isNewPMSProduct = _data["isNewPMSProduct"] !== undefined ? _data["isNewPMSProduct"] : null as any;
            this.precalItemNo = _data["precalItemNo"] !== undefined ? _data["precalItemNo"] : null as any;
            this.operationalRemarks = _data["operationalRemarks"] !== undefined ? _data["operationalRemarks"] : null as any;
            this.orderChangeOrderFormId = _data["orderChangeOrderFormId"] !== undefined ? _data["orderChangeOrderFormId"] : null as any;
            this.shortLink = _data["shortLink"] !== undefined ? _data["shortLink"] : null as any;
            this.pmuSoitemCategory = _data["pmuSoitemCategory"] !== undefined ? _data["pmuSoitemCategory"] : null as any;
            this.totalUnitPrice = _data["totalUnitPrice"] !== undefined ? _data["totalUnitPrice"] : null as any;
            this.pmsMultiplier = _data["pmsMultiplier"] !== undefined ? _data["pmsMultiplier"] : null as any;
            this.originalMultiplier = _data["originalMultiplier"] !== undefined ? _data["originalMultiplier"] : null as any;
            this.changeFee = _data["changeFee"] !== undefined ? _data["changeFee"] : null as any;
            this.orderChangeProductBasicProcessEntity = _data["orderChangeProductBasicProcessEntity"] ? OrderChangeProductBasicProcessEntity.fromJS(_data["orderChangeProductBasicProcessEntity"]) : null as any;
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
            this.technicalSpecificationProductId = _data["technicalSpecificationProductId"] !== undefined ? _data["technicalSpecificationProductId"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.materialDescription = _data["materialDescription"] !== undefined ? _data["materialDescription"] : null as any;
        }
    }

    static fromJS(data: any): OrderChangeProductBasicMotor {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeProductBasicMotor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["productMixCode"] = this.productMixCode !== undefined ? this.productMixCode : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorType"] = this.basicMotorType !== undefined ? this.basicMotorType : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["numberOfProduct"] = this.numberOfProduct !== undefined ? this.numberOfProduct : null as any;
        data["multipilerType"] = this.multipilerType !== undefined ? this.multipilerType : null as any;
        data["multiplier"] = this.multiplier !== undefined ? this.multiplier : null as any;
        data["multiplierExpiredDate"] = this.multiplierExpiredDate ? this.multiplierExpiredDate.toISOString() : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["unitPriceExpiredTime"] = this.unitPriceExpiredTime ? this.unitPriceExpiredTime.toISOString() : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["oemSalesPrice"] = this.oemSalesPrice !== undefined ? this.oemSalesPrice : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["remarkTwo"] = this.remarkTwo !== undefined ? this.remarkTwo : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["actualDeliveryDate"] = this.actualDeliveryDate !== undefined ? this.actualDeliveryDate : null as any;
        data["customerExpectedDeliveryDate"] = this.customerExpectedDeliveryDate ? this.customerExpectedDeliveryDate.toISOString() : null as any;
        data["customerActualDeliveryDate"] = this.customerActualDeliveryDate ? this.customerActualDeliveryDate.toISOString() : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["receivePrdTechJSON"] = this.receivePrdTechJSON !== undefined ? this.receivePrdTechJSON : null as any;
        data["receivePrdElecsJSON"] = this.receivePrdElecsJSON !== undefined ? this.receivePrdElecsJSON : null as any;
        data["checkResultOutput"] = this.checkResultOutput !== undefined ? this.checkResultOutput : null as any;
        data["productClassification"] = this.productClassification !== undefined ? this.productClassification : null as any;
        data["orderClassification"] = this.orderClassification !== undefined ? this.orderClassification : null as any;
        if (Array.isArray(this.orderChangeProductVC)) {
            data["orderChangeProductVC"] = [];
            for (let item of this.orderChangeProductVC)
                data["orderChangeProductVC"].push(item ? item.toJSON() : null as any);
        }
        data["shoppingCart"] = this.shoppingCart ? this.shoppingCart.toJSON() : null as any;
        data["priceWithTax"] = this.priceWithTax !== undefined ? this.priceWithTax : null as any;
        data["priceWithoutTax"] = this.priceWithoutTax !== undefined ? this.priceWithoutTax : null as any;
        data["unitTaxPrice"] = this.unitTaxPrice !== undefined ? this.unitTaxPrice : null as any;
        data["discountUnitPrice"] = this.discountUnitPrice !== undefined ? this.discountUnitPrice : null as any;
        data["noDiscountByPlatformUnitPrice"] = this.noDiscountByPlatformUnitPrice !== undefined ? this.noDiscountByPlatformUnitPrice : null as any;
        data["noDiscountByListUnitPrice"] = this.noDiscountByListUnitPrice !== undefined ? this.noDiscountByListUnitPrice : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["scSerialNumber"] = this.scSerialNumber !== undefined ? this.scSerialNumber : null as any;
        data["specialRebateFlag"] = this.specialRebateFlag !== undefined ? this.specialRebateFlag : null as any;
        data["isNewPMSProduct"] = this.isNewPMSProduct !== undefined ? this.isNewPMSProduct : null as any;
        data["precalItemNo"] = this.precalItemNo !== undefined ? this.precalItemNo : null as any;
        data["operationalRemarks"] = this.operationalRemarks !== undefined ? this.operationalRemarks : null as any;
        data["orderChangeOrderFormId"] = this.orderChangeOrderFormId !== undefined ? this.orderChangeOrderFormId : null as any;
        data["shortLink"] = this.shortLink !== undefined ? this.shortLink : null as any;
        data["pmuSoitemCategory"] = this.pmuSoitemCategory !== undefined ? this.pmuSoitemCategory : null as any;
        data["totalUnitPrice"] = this.totalUnitPrice !== undefined ? this.totalUnitPrice : null as any;
        data["pmsMultiplier"] = this.pmsMultiplier !== undefined ? this.pmsMultiplier : null as any;
        data["originalMultiplier"] = this.originalMultiplier !== undefined ? this.originalMultiplier : null as any;
        data["changeFee"] = this.changeFee !== undefined ? this.changeFee : null as any;
        data["orderChangeProductBasicProcessEntity"] = this.orderChangeProductBasicProcessEntity ? this.orderChangeProductBasicProcessEntity.toJSON() : null as any;
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        data["technicalSpecificationProductId"] = this.technicalSpecificationProductId !== undefined ? this.technicalSpecificationProductId : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["materialDescription"] = this.materialDescription !== undefined ? this.materialDescription : null as any;
        return data;
    }
}

export class OrderChangeProductBasicMotorAddDto {
    productId!: string;
    orderChangeProductId!: string;
    /** 面价 */
    unitPrice!: number | null;
    salesPrice!: number | null;
    multiplier!: number | null;
    unitPriceType!: string | null;
    /** GSS报价号 */
    gssQuotationNo!: string | null;
    /** GSS技术确认号（SFDC） */
    gssTechnicalConfirmationNumber!: string | null;
    /** 技术规范（技术规范号） */
    technicalSpecifications!: string | null;
    /** 是否允许编辑 */
    allowEditing!: boolean;
    /** 来源报价产品id */
    technologyQuotationProductId!: string | null;
    /** 来源协议产品id (协议是针对产品行的且对所有客户有效，因此在业务上不需要考虑客户变更的场景) */
    technicalSpecificationProductId!: string | null;
    /** 可打折面价 */
    discountUnitPrice!: number | null;
    /** 按台收不打折 */
    noDiscountByPlatformUnitPrice!: number | null;
    /** 按单收不打折 */
    noDiscountByListUnitPrice!: number | null;
    /** 境界代码 */
    jinMotorCode!: string | null;
    /** 境界版本号 */
    jinVersion!: string | null;
    /** 境界标识符号 */
    jinCategoryCode!: string | null;
    /** 内含vc备注 */
    insideVCOpenRemarks!: string | null;
    /** 基座号 */
    frameNo!: number | null;
    orderChangeProductBasicMotorVC!: OrderChangeProductBasicMotorVCAddDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"] !== undefined ? _data["productId"] : null as any;
            this.orderChangeProductId = _data["orderChangeProductId"] !== undefined ? _data["orderChangeProductId"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.multiplier = _data["multiplier"] !== undefined ? _data["multiplier"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.allowEditing = _data["allowEditing"] !== undefined ? _data["allowEditing"] : null as any;
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
            this.technicalSpecificationProductId = _data["technicalSpecificationProductId"] !== undefined ? _data["technicalSpecificationProductId"] : null as any;
            this.discountUnitPrice = _data["discountUnitPrice"] !== undefined ? _data["discountUnitPrice"] : null as any;
            this.noDiscountByPlatformUnitPrice = _data["noDiscountByPlatformUnitPrice"] !== undefined ? _data["noDiscountByPlatformUnitPrice"] : null as any;
            this.noDiscountByListUnitPrice = _data["noDiscountByListUnitPrice"] !== undefined ? _data["noDiscountByListUnitPrice"] : null as any;
            this.jinMotorCode = _data["jinMotorCode"] !== undefined ? _data["jinMotorCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.insideVCOpenRemarks = _data["insideVCOpenRemarks"] !== undefined ? _data["insideVCOpenRemarks"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            if (Array.isArray(_data["orderChangeProductBasicMotorVC"])) {
                this.orderChangeProductBasicMotorVC = [] as any;
                for (let item of _data["orderChangeProductBasicMotorVC"])
                    this.orderChangeProductBasicMotorVC!.push(OrderChangeProductBasicMotorVCAddDto.fromJS(item));
            }
            else {
                this.orderChangeProductBasicMotorVC = null as any;
            }
        }
    }

    static fromJS(data: any): OrderChangeProductBasicMotorAddDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeProductBasicMotorAddDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId !== undefined ? this.productId : null as any;
        data["orderChangeProductId"] = this.orderChangeProductId !== undefined ? this.orderChangeProductId : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["multiplier"] = this.multiplier !== undefined ? this.multiplier : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["allowEditing"] = this.allowEditing !== undefined ? this.allowEditing : null as any;
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        data["technicalSpecificationProductId"] = this.technicalSpecificationProductId !== undefined ? this.technicalSpecificationProductId : null as any;
        data["discountUnitPrice"] = this.discountUnitPrice !== undefined ? this.discountUnitPrice : null as any;
        data["noDiscountByPlatformUnitPrice"] = this.noDiscountByPlatformUnitPrice !== undefined ? this.noDiscountByPlatformUnitPrice : null as any;
        data["noDiscountByListUnitPrice"] = this.noDiscountByListUnitPrice !== undefined ? this.noDiscountByListUnitPrice : null as any;
        data["jinMotorCode"] = this.jinMotorCode !== undefined ? this.jinMotorCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["insideVCOpenRemarks"] = this.insideVCOpenRemarks !== undefined ? this.insideVCOpenRemarks : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        if (Array.isArray(this.orderChangeProductBasicMotorVC)) {
            data["orderChangeProductBasicMotorVC"] = [];
            for (let item of this.orderChangeProductBasicMotorVC)
                data["orderChangeProductBasicMotorVC"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class OrderChangeProductBasicMotorChange {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    orderChangeOrderFormVersionsId!: string;
    orderChangeProductBasicMotorId!: string;
    changeType!: EnumChangeType;
    oldValue!: string | null;
    newValue!: string | null;
    serialNumber!: number | null;
    newRemark!: string | null;
    oldRemark!: string | null;
    oldSalasPrice!: number | null;
    newSalasPrice!: number | null;
    oldUnitPrice!: number | null;
    newUnitPrice!: number | null;
    oldMeaning!: string | null;
    newMeaning!: string | null;
    orderChangeProductBasicMotor!: OrderChangeProductBasicMotor;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.orderChangeOrderFormVersionsId = _data["orderChangeOrderFormVersionsId"] !== undefined ? _data["orderChangeOrderFormVersionsId"] : null as any;
            this.orderChangeProductBasicMotorId = _data["orderChangeProductBasicMotorId"] !== undefined ? _data["orderChangeProductBasicMotorId"] : null as any;
            this.changeType = _data["changeType"] !== undefined ? _data["changeType"] : null as any;
            this.oldValue = _data["oldValue"] !== undefined ? _data["oldValue"] : null as any;
            this.newValue = _data["newValue"] !== undefined ? _data["newValue"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.newRemark = _data["newRemark"] !== undefined ? _data["newRemark"] : null as any;
            this.oldRemark = _data["oldRemark"] !== undefined ? _data["oldRemark"] : null as any;
            this.oldSalasPrice = _data["oldSalasPrice"] !== undefined ? _data["oldSalasPrice"] : null as any;
            this.newSalasPrice = _data["newSalasPrice"] !== undefined ? _data["newSalasPrice"] : null as any;
            this.oldUnitPrice = _data["oldUnitPrice"] !== undefined ? _data["oldUnitPrice"] : null as any;
            this.newUnitPrice = _data["newUnitPrice"] !== undefined ? _data["newUnitPrice"] : null as any;
            this.oldMeaning = _data["oldMeaning"] !== undefined ? _data["oldMeaning"] : null as any;
            this.newMeaning = _data["newMeaning"] !== undefined ? _data["newMeaning"] : null as any;
            this.orderChangeProductBasicMotor = _data["orderChangeProductBasicMotor"] ? OrderChangeProductBasicMotor.fromJS(_data["orderChangeProductBasicMotor"]) : null as any;
        }
    }

    static fromJS(data: any): OrderChangeProductBasicMotorChange {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeProductBasicMotorChange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["orderChangeOrderFormVersionsId"] = this.orderChangeOrderFormVersionsId !== undefined ? this.orderChangeOrderFormVersionsId : null as any;
        data["orderChangeProductBasicMotorId"] = this.orderChangeProductBasicMotorId !== undefined ? this.orderChangeProductBasicMotorId : null as any;
        data["changeType"] = this.changeType !== undefined ? this.changeType : null as any;
        data["oldValue"] = this.oldValue !== undefined ? this.oldValue : null as any;
        data["newValue"] = this.newValue !== undefined ? this.newValue : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["newRemark"] = this.newRemark !== undefined ? this.newRemark : null as any;
        data["oldRemark"] = this.oldRemark !== undefined ? this.oldRemark : null as any;
        data["oldSalasPrice"] = this.oldSalasPrice !== undefined ? this.oldSalasPrice : null as any;
        data["newSalasPrice"] = this.newSalasPrice !== undefined ? this.newSalasPrice : null as any;
        data["oldUnitPrice"] = this.oldUnitPrice !== undefined ? this.oldUnitPrice : null as any;
        data["newUnitPrice"] = this.newUnitPrice !== undefined ? this.newUnitPrice : null as any;
        data["oldMeaning"] = this.oldMeaning !== undefined ? this.oldMeaning : null as any;
        data["newMeaning"] = this.newMeaning !== undefined ? this.newMeaning : null as any;
        data["orderChangeProductBasicMotor"] = this.orderChangeProductBasicMotor ? this.orderChangeProductBasicMotor.toJSON() : null as any;
        return data;
    }
}

export class OrderChangeProductBasicMotorDto {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    /** 产品组合编码 */
    productMixCode!: string | null;
    /** 客户物料号 */
    customerMaterialNumber!: string | null;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** 订单形式 */
    orderType!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 主机类型 */
    basicMotorType!: number;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 产品组合的数量 */
    numberOfProduct!: number;
    /** 折扣类型，系数折扣 1,总价折扣 2 */
    multipilerType!: number;
    /** 系数 */
    multiplier!: number;
    /** 系数过期时间 */
    multiplierExpiredDate!: moment.Moment | null;
    /** 1, 来自面价（OIS需要重新取）， 2， GCS报价， 3， 客户自己填 */
    unitPriceType!: string | null;
    /** 对于 2 报价具有有效期 */
    unitPriceExpiredTime!: moment.Moment | null;
    /** 面价 */
    unitPrice!: number;
    /** 总面价 */
    totalUnitPrice!: number;
    /** 售价 */
    salesPrice!: number;
    /** 售价（OEM产品初始售价） */
    oemSalesPrice!: number;
    /** 备注(约定与主机生产、排期相关的信息存放此字段) */
    remark!: string | null;
    /** 备注二(约定与主机生产、排序无关，但是与创建订单或者主机下单规则有关的信息存放此字段) */
    remarkTwo!: string | null;
    /** 机座号 */
    frameSize!: number;
    /** 预计交货日期/天 */
    expectedDeliveryDate!: string | null;
    /** 实际交货日期/天 */
    actualDeliveryDate!: string | null;
    /** 客户期望交货日期 */
    customerExpectedDeliveryDate!: moment.Moment | null;
    /** 客户原期望交货期 */
    customerActualDeliveryDate!: moment.Moment | null;
    /** GSS报价号 */
    gssQuotationNo!: string | null;
    /** GSS技术确认号（SFDC） */
    gssTechnicalConfirmationNumber!: string | null;
    /** 技术规范（技术规范号） */
    technicalSpecifications!: string | null;
    /** 是否需要提醒 */
    isEarlyWarning!: boolean;
    /** 接收PrdTech的JSON */
    receivePrdTechJSON!: string | null;
    /** 接收PrdElecs的JSON */
    receivePrdElecsJSON!: string | null;
    /** SMCONF带过来的规则检查 */
    checkResultOutput!: string | null;
    /** 主机分类 */
    productClassification!: string | null;
    /** 订单分类 */
    orderClassification!: string | null;
    /** 产品VC */
    orderChangeProductVC!: OrderChangeProductVC[] | null;
    /** 产品境界内含VC */
    orderChangeProductJINVC!: OrderChangeProductVC[] | null;
    /** 1 含税总金额 售价(SalesPrice)*NumberOfProduct
售价(salesPrice)=(面价+VC.unitPrice)*系数(multiplier) */
    priceWithTax!: number | null;
    /** 2 不含税总金额 PriceWithTax/(1+OrderForm.TaxPrice)
PriceWithTax/1.13后四舍五入，保留2位小数，订单行先计算再合计进总价，界面显示只要在header里 */
    priceWithoutTax!: number | null;
    /** 3 税金 PriceWithTax - PriceWithoutTax */
    unitTaxPrice!: number | null;
    /** 可打折面价 */
    discountUnitPrice!: number | null;
    /** 按台收不打折 */
    noDiscountByPlatformUnitPrice!: number | null;
    /** 按单收不打折 */
    noDiscountByListUnitPrice!: number | null;
    /** 序号 */
    serialNumber!: number | null;
    /** SC序号 */
    scSerialNumber!: number | null;
    /** precal序号 */
    precalItemNo!: number | null;
    /** 特殊返点标识 */
    specialRebateFlag!: string | null;
    /**  PMS
是否为PMS派生选型后,新增的主机 */
    isNewPMSProduct!: boolean | null;
    orderChangeOrderFormId!: string | null;
    isLocked!: boolean | null;
    /** LSU 行号 */
    lsuItem!: string | null;
    /** Pmu 行号 */
    pmuSalesOrderItem!: string | null;
    pmuSoitemCategory!: string | null;
    /** PMS回传系数 */
    pmsMultiplier!: number | null;
    /** 总价折扣 原始系数(不四舍五入) */
    originalMultiplier!: number | null;
    /** 变更中额外费用 */
    changeFee!: number | null;
    shortLink!: string | null;
    /** 运营相关备注 */
    operationalRemarks!: string | null;
    /** 来源报价产品id */
    technologyQuotationProductId!: string | null;
    /** 来源协议产品id (协议是针对产品行的且对所有客户有效，因此在业务上不需要考虑客户变更的场景) */
    technicalSpecificationProductId!: string | null;
    jinBasicMotorCode!: string | null;
    /** 境界标识符 */
    jinCategoryCode!: string | null;
    /** 境界代码版本号 */
    jinVersion!: string | null;
    /** 变更后总价 */
    postSalesTotalPriceVisit!: number | null;
    /** 境界输出备注 */
    jinRemarkOutDto!: JinRemarkOutDto[] | null;
    orderChangeProductBasicProcessEntity!: OrderChangeProductBasicProcessEntity;
    /** 是否变更 */
    isChange!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.productMixCode = _data["productMixCode"] !== undefined ? _data["productMixCode"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorType = _data["basicMotorType"] !== undefined ? _data["basicMotorType"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.numberOfProduct = _data["numberOfProduct"] !== undefined ? _data["numberOfProduct"] : null as any;
            this.multipilerType = _data["multipilerType"] !== undefined ? _data["multipilerType"] : null as any;
            this.multiplier = _data["multiplier"] !== undefined ? _data["multiplier"] : null as any;
            this.multiplierExpiredDate = _data["multiplierExpiredDate"] ? moment(_data["multiplierExpiredDate"].toString()) : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.unitPriceExpiredTime = _data["unitPriceExpiredTime"] ? moment(_data["unitPriceExpiredTime"].toString()) : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.totalUnitPrice = _data["totalUnitPrice"] !== undefined ? _data["totalUnitPrice"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.oemSalesPrice = _data["oemSalesPrice"] !== undefined ? _data["oemSalesPrice"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.remarkTwo = _data["remarkTwo"] !== undefined ? _data["remarkTwo"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.actualDeliveryDate = _data["actualDeliveryDate"] !== undefined ? _data["actualDeliveryDate"] : null as any;
            this.customerExpectedDeliveryDate = _data["customerExpectedDeliveryDate"] ? moment(_data["customerExpectedDeliveryDate"].toString()) : null as any;
            this.customerActualDeliveryDate = _data["customerActualDeliveryDate"] ? moment(_data["customerActualDeliveryDate"].toString()) : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.isEarlyWarning = _data["isEarlyWarning"] !== undefined ? _data["isEarlyWarning"] : null as any;
            this.receivePrdTechJSON = _data["receivePrdTechJSON"] !== undefined ? _data["receivePrdTechJSON"] : null as any;
            this.receivePrdElecsJSON = _data["receivePrdElecsJSON"] !== undefined ? _data["receivePrdElecsJSON"] : null as any;
            this.checkResultOutput = _data["checkResultOutput"] !== undefined ? _data["checkResultOutput"] : null as any;
            this.productClassification = _data["productClassification"] !== undefined ? _data["productClassification"] : null as any;
            this.orderClassification = _data["orderClassification"] !== undefined ? _data["orderClassification"] : null as any;
            if (Array.isArray(_data["orderChangeProductVC"])) {
                this.orderChangeProductVC = [] as any;
                for (let item of _data["orderChangeProductVC"])
                    this.orderChangeProductVC!.push(OrderChangeProductVC.fromJS(item));
            }
            else {
                this.orderChangeProductVC = null as any;
            }
            if (Array.isArray(_data["orderChangeProductJINVC"])) {
                this.orderChangeProductJINVC = [] as any;
                for (let item of _data["orderChangeProductJINVC"])
                    this.orderChangeProductJINVC!.push(OrderChangeProductVC.fromJS(item));
            }
            else {
                this.orderChangeProductJINVC = null as any;
            }
            this.priceWithTax = _data["priceWithTax"] !== undefined ? _data["priceWithTax"] : null as any;
            this.priceWithoutTax = _data["priceWithoutTax"] !== undefined ? _data["priceWithoutTax"] : null as any;
            this.unitTaxPrice = _data["unitTaxPrice"] !== undefined ? _data["unitTaxPrice"] : null as any;
            this.discountUnitPrice = _data["discountUnitPrice"] !== undefined ? _data["discountUnitPrice"] : null as any;
            this.noDiscountByPlatformUnitPrice = _data["noDiscountByPlatformUnitPrice"] !== undefined ? _data["noDiscountByPlatformUnitPrice"] : null as any;
            this.noDiscountByListUnitPrice = _data["noDiscountByListUnitPrice"] !== undefined ? _data["noDiscountByListUnitPrice"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.scSerialNumber = _data["scSerialNumber"] !== undefined ? _data["scSerialNumber"] : null as any;
            this.precalItemNo = _data["precalItemNo"] !== undefined ? _data["precalItemNo"] : null as any;
            this.specialRebateFlag = _data["specialRebateFlag"] !== undefined ? _data["specialRebateFlag"] : null as any;
            this.isNewPMSProduct = _data["isNewPMSProduct"] !== undefined ? _data["isNewPMSProduct"] : null as any;
            this.orderChangeOrderFormId = _data["orderChangeOrderFormId"] !== undefined ? _data["orderChangeOrderFormId"] : null as any;
            this.isLocked = _data["isLocked"] !== undefined ? _data["isLocked"] : null as any;
            this.lsuItem = _data["lsuItem"] !== undefined ? _data["lsuItem"] : null as any;
            this.pmuSalesOrderItem = _data["pmuSalesOrderItem"] !== undefined ? _data["pmuSalesOrderItem"] : null as any;
            this.pmuSoitemCategory = _data["pmuSoitemCategory"] !== undefined ? _data["pmuSoitemCategory"] : null as any;
            this.pmsMultiplier = _data["pmsMultiplier"] !== undefined ? _data["pmsMultiplier"] : null as any;
            this.originalMultiplier = _data["originalMultiplier"] !== undefined ? _data["originalMultiplier"] : null as any;
            this.changeFee = _data["changeFee"] !== undefined ? _data["changeFee"] : null as any;
            this.shortLink = _data["shortLink"] !== undefined ? _data["shortLink"] : null as any;
            this.operationalRemarks = _data["operationalRemarks"] !== undefined ? _data["operationalRemarks"] : null as any;
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
            this.technicalSpecificationProductId = _data["technicalSpecificationProductId"] !== undefined ? _data["technicalSpecificationProductId"] : null as any;
            this.jinBasicMotorCode = _data["jinBasicMotorCode"] !== undefined ? _data["jinBasicMotorCode"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.postSalesTotalPriceVisit = _data["postSalesTotalPriceVisit"] !== undefined ? _data["postSalesTotalPriceVisit"] : null as any;
            if (Array.isArray(_data["jinRemarkOutDto"])) {
                this.jinRemarkOutDto = [] as any;
                for (let item of _data["jinRemarkOutDto"])
                    this.jinRemarkOutDto!.push(JinRemarkOutDto.fromJS(item));
            }
            else {
                this.jinRemarkOutDto = null as any;
            }
            this.orderChangeProductBasicProcessEntity = _data["orderChangeProductBasicProcessEntity"] ? OrderChangeProductBasicProcessEntity.fromJS(_data["orderChangeProductBasicProcessEntity"]) : null as any;
            this.isChange = _data["isChange"] !== undefined ? _data["isChange"] : null as any;
        }
    }

    static fromJS(data: any): OrderChangeProductBasicMotorDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeProductBasicMotorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["productMixCode"] = this.productMixCode !== undefined ? this.productMixCode : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorType"] = this.basicMotorType !== undefined ? this.basicMotorType : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["numberOfProduct"] = this.numberOfProduct !== undefined ? this.numberOfProduct : null as any;
        data["multipilerType"] = this.multipilerType !== undefined ? this.multipilerType : null as any;
        data["multiplier"] = this.multiplier !== undefined ? this.multiplier : null as any;
        data["multiplierExpiredDate"] = this.multiplierExpiredDate ? this.multiplierExpiredDate.toISOString() : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["unitPriceExpiredTime"] = this.unitPriceExpiredTime ? this.unitPriceExpiredTime.toISOString() : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["totalUnitPrice"] = this.totalUnitPrice !== undefined ? this.totalUnitPrice : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["oemSalesPrice"] = this.oemSalesPrice !== undefined ? this.oemSalesPrice : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["remarkTwo"] = this.remarkTwo !== undefined ? this.remarkTwo : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["actualDeliveryDate"] = this.actualDeliveryDate !== undefined ? this.actualDeliveryDate : null as any;
        data["customerExpectedDeliveryDate"] = this.customerExpectedDeliveryDate ? this.customerExpectedDeliveryDate.toISOString() : null as any;
        data["customerActualDeliveryDate"] = this.customerActualDeliveryDate ? this.customerActualDeliveryDate.toISOString() : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["isEarlyWarning"] = this.isEarlyWarning !== undefined ? this.isEarlyWarning : null as any;
        data["receivePrdTechJSON"] = this.receivePrdTechJSON !== undefined ? this.receivePrdTechJSON : null as any;
        data["receivePrdElecsJSON"] = this.receivePrdElecsJSON !== undefined ? this.receivePrdElecsJSON : null as any;
        data["checkResultOutput"] = this.checkResultOutput !== undefined ? this.checkResultOutput : null as any;
        data["productClassification"] = this.productClassification !== undefined ? this.productClassification : null as any;
        data["orderClassification"] = this.orderClassification !== undefined ? this.orderClassification : null as any;
        if (Array.isArray(this.orderChangeProductVC)) {
            data["orderChangeProductVC"] = [];
            for (let item of this.orderChangeProductVC)
                data["orderChangeProductVC"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.orderChangeProductJINVC)) {
            data["orderChangeProductJINVC"] = [];
            for (let item of this.orderChangeProductJINVC)
                data["orderChangeProductJINVC"].push(item ? item.toJSON() : null as any);
        }
        data["priceWithTax"] = this.priceWithTax !== undefined ? this.priceWithTax : null as any;
        data["priceWithoutTax"] = this.priceWithoutTax !== undefined ? this.priceWithoutTax : null as any;
        data["unitTaxPrice"] = this.unitTaxPrice !== undefined ? this.unitTaxPrice : null as any;
        data["discountUnitPrice"] = this.discountUnitPrice !== undefined ? this.discountUnitPrice : null as any;
        data["noDiscountByPlatformUnitPrice"] = this.noDiscountByPlatformUnitPrice !== undefined ? this.noDiscountByPlatformUnitPrice : null as any;
        data["noDiscountByListUnitPrice"] = this.noDiscountByListUnitPrice !== undefined ? this.noDiscountByListUnitPrice : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["scSerialNumber"] = this.scSerialNumber !== undefined ? this.scSerialNumber : null as any;
        data["precalItemNo"] = this.precalItemNo !== undefined ? this.precalItemNo : null as any;
        data["specialRebateFlag"] = this.specialRebateFlag !== undefined ? this.specialRebateFlag : null as any;
        data["isNewPMSProduct"] = this.isNewPMSProduct !== undefined ? this.isNewPMSProduct : null as any;
        data["orderChangeOrderFormId"] = this.orderChangeOrderFormId !== undefined ? this.orderChangeOrderFormId : null as any;
        data["isLocked"] = this.isLocked !== undefined ? this.isLocked : null as any;
        data["lsuItem"] = this.lsuItem !== undefined ? this.lsuItem : null as any;
        data["pmuSalesOrderItem"] = this.pmuSalesOrderItem !== undefined ? this.pmuSalesOrderItem : null as any;
        data["pmuSoitemCategory"] = this.pmuSoitemCategory !== undefined ? this.pmuSoitemCategory : null as any;
        data["pmsMultiplier"] = this.pmsMultiplier !== undefined ? this.pmsMultiplier : null as any;
        data["originalMultiplier"] = this.originalMultiplier !== undefined ? this.originalMultiplier : null as any;
        data["changeFee"] = this.changeFee !== undefined ? this.changeFee : null as any;
        data["shortLink"] = this.shortLink !== undefined ? this.shortLink : null as any;
        data["operationalRemarks"] = this.operationalRemarks !== undefined ? this.operationalRemarks : null as any;
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        data["technicalSpecificationProductId"] = this.technicalSpecificationProductId !== undefined ? this.technicalSpecificationProductId : null as any;
        data["jinBasicMotorCode"] = this.jinBasicMotorCode !== undefined ? this.jinBasicMotorCode : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["postSalesTotalPriceVisit"] = this.postSalesTotalPriceVisit !== undefined ? this.postSalesTotalPriceVisit : null as any;
        if (Array.isArray(this.jinRemarkOutDto)) {
            data["jinRemarkOutDto"] = [];
            for (let item of this.jinRemarkOutDto)
                data["jinRemarkOutDto"].push(item ? item.toJSON() : null as any);
        }
        data["orderChangeProductBasicProcessEntity"] = this.orderChangeProductBasicProcessEntity ? this.orderChangeProductBasicProcessEntity.toJSON() : null as any;
        data["isChange"] = this.isChange !== undefined ? this.isChange : null as any;
        return data;
    }
}

export class OrderChangeProductBasicMotorVCAddDto {
    /** 变量产品代码 */
    vcProductCode!: string | null;
    /** 变量编号 */
    vcCode!: string | null;
    /** 折扣类型 */
    discountType!: string | null;
    /** 1, 来自面价（OIS需要重新取）， 2， GCS报价， 3， 客户自己填 */
    unitPriceType!: string | null;
    /** 有效期 */
    unitPriceExpiredTime!: moment.Moment | null;
    /** 面价 */
    unitPrice!: number;
    /** 售价 */
    salesPrice!: number;
    /** 描述 */
    meaning!: string | null;
    /** 备注 */
    remark!: string | null;
    /** 接收VCFreeText的JSON */
    receiveVcFreeTextJSON!: string | null;
    vcType!: number | null;
    orderChangeProductBasicMotorId!: string | null;
    /** Vc显示类型 */
    vcShowType!: number;
    /** 来源报价产品VC id */
    technologyQuotationProductVCId!: string | null;
    /** 来源协议产品VC id */
    technicalSpecificationProductVCId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.vcProductCode = _data["vcProductCode"] !== undefined ? _data["vcProductCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.unitPriceExpiredTime = _data["unitPriceExpiredTime"] ? moment(_data["unitPriceExpiredTime"].toString()) : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.receiveVcFreeTextJSON = _data["receiveVcFreeTextJSON"] !== undefined ? _data["receiveVcFreeTextJSON"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.orderChangeProductBasicMotorId = _data["orderChangeProductBasicMotorId"] !== undefined ? _data["orderChangeProductBasicMotorId"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.technologyQuotationProductVCId = _data["technologyQuotationProductVCId"] !== undefined ? _data["technologyQuotationProductVCId"] : null as any;
            this.technicalSpecificationProductVCId = _data["technicalSpecificationProductVCId"] !== undefined ? _data["technicalSpecificationProductVCId"] : null as any;
        }
    }

    static fromJS(data: any): OrderChangeProductBasicMotorVCAddDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeProductBasicMotorVCAddDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcProductCode"] = this.vcProductCode !== undefined ? this.vcProductCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["discountType"] = this.discountType !== undefined ? this.discountType : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["unitPriceExpiredTime"] = this.unitPriceExpiredTime ? this.unitPriceExpiredTime.toISOString() : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["receiveVcFreeTextJSON"] = this.receiveVcFreeTextJSON !== undefined ? this.receiveVcFreeTextJSON : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["orderChangeProductBasicMotorId"] = this.orderChangeProductBasicMotorId !== undefined ? this.orderChangeProductBasicMotorId : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["technologyQuotationProductVCId"] = this.technologyQuotationProductVCId !== undefined ? this.technologyQuotationProductVCId : null as any;
        data["technicalSpecificationProductVCId"] = this.technicalSpecificationProductVCId !== undefined ? this.technicalSpecificationProductVCId : null as any;
        return data;
    }
}

/** 获取产品的所有版本变更信息 */
export class OrderChangeProductBasicMotorVersionAllDto {
    id!: string;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 境界标识符 */
    jinCategoryCode!: string | null;
    /** 境界版本 */
    jinVersion!: string | null;
    /** 产品组合的数量 */
    numberOfProduct!: number;
    /** 产品VC */
    orderChangeProductVC!: OrderChangeProductVC[] | null;
    /** 序号/行号 */
    serialNumber!: number | null;
    /** 版本号 */
    version!: number;
    /** 版本状态，enumOrderChangeOrderFormVersionsStatus */
    versionStatus!: string | null;
    /** 原订单id */
    sourceOrderFromID!: string;
    /** 合同号 */
    ponumber!: string | null;
    /** 变更服务申请的Id */
    serviceRequestId!: string | null;
    /** 变更服务申请的工单号 */
    sequenceNumber!: string | null;
    /** 变更状态 */
    serviceRequestStatus!: string | null;
    /** 变更时间,orderChangeOrderFormVersionsRepository==LastModificationTime */
    changeTime!: moment.Moment | null;
    /** 版本id */
    orderChangeOrderFormVersionsId!: string | null;
    /** 产品id */
    orderChangeProductBasicMotorId!: string | null;
    /** 变更前 */
    changeBefore!: string | null;
    /** 变更后 */
    changeAfter!: string | null;
    newOrderChangeSummaryOutDto!: NewOrderChangeSummaryOutDto;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.numberOfProduct = _data["numberOfProduct"] !== undefined ? _data["numberOfProduct"] : null as any;
            if (Array.isArray(_data["orderChangeProductVC"])) {
                this.orderChangeProductVC = [] as any;
                for (let item of _data["orderChangeProductVC"])
                    this.orderChangeProductVC!.push(OrderChangeProductVC.fromJS(item));
            }
            else {
                this.orderChangeProductVC = null as any;
            }
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.versionStatus = _data["versionStatus"] !== undefined ? _data["versionStatus"] : null as any;
            this.sourceOrderFromID = _data["sourceOrderFromID"] !== undefined ? _data["sourceOrderFromID"] : null as any;
            this.ponumber = _data["ponumber"] !== undefined ? _data["ponumber"] : null as any;
            this.serviceRequestId = _data["serviceRequestId"] !== undefined ? _data["serviceRequestId"] : null as any;
            this.sequenceNumber = _data["sequenceNumber"] !== undefined ? _data["sequenceNumber"] : null as any;
            this.serviceRequestStatus = _data["serviceRequestStatus"] !== undefined ? _data["serviceRequestStatus"] : null as any;
            this.changeTime = _data["changeTime"] ? moment(_data["changeTime"].toString()) : null as any;
            this.orderChangeOrderFormVersionsId = _data["orderChangeOrderFormVersionsId"] !== undefined ? _data["orderChangeOrderFormVersionsId"] : null as any;
            this.orderChangeProductBasicMotorId = _data["orderChangeProductBasicMotorId"] !== undefined ? _data["orderChangeProductBasicMotorId"] : null as any;
            this.changeBefore = _data["changeBefore"] !== undefined ? _data["changeBefore"] : null as any;
            this.changeAfter = _data["changeAfter"] !== undefined ? _data["changeAfter"] : null as any;
            this.newOrderChangeSummaryOutDto = _data["newOrderChangeSummaryOutDto"] ? NewOrderChangeSummaryOutDto.fromJS(_data["newOrderChangeSummaryOutDto"]) : null as any;
        }
    }

    static fromJS(data: any): OrderChangeProductBasicMotorVersionAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeProductBasicMotorVersionAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["numberOfProduct"] = this.numberOfProduct !== undefined ? this.numberOfProduct : null as any;
        if (Array.isArray(this.orderChangeProductVC)) {
            data["orderChangeProductVC"] = [];
            for (let item of this.orderChangeProductVC)
                data["orderChangeProductVC"].push(item ? item.toJSON() : null as any);
        }
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["versionStatus"] = this.versionStatus !== undefined ? this.versionStatus : null as any;
        data["sourceOrderFromID"] = this.sourceOrderFromID !== undefined ? this.sourceOrderFromID : null as any;
        data["ponumber"] = this.ponumber !== undefined ? this.ponumber : null as any;
        data["serviceRequestId"] = this.serviceRequestId !== undefined ? this.serviceRequestId : null as any;
        data["sequenceNumber"] = this.sequenceNumber !== undefined ? this.sequenceNumber : null as any;
        data["serviceRequestStatus"] = this.serviceRequestStatus !== undefined ? this.serviceRequestStatus : null as any;
        data["changeTime"] = this.changeTime ? this.changeTime.toISOString() : null as any;
        data["orderChangeOrderFormVersionsId"] = this.orderChangeOrderFormVersionsId !== undefined ? this.orderChangeOrderFormVersionsId : null as any;
        data["orderChangeProductBasicMotorId"] = this.orderChangeProductBasicMotorId !== undefined ? this.orderChangeProductBasicMotorId : null as any;
        data["changeBefore"] = this.changeBefore !== undefined ? this.changeBefore : null as any;
        data["changeAfter"] = this.changeAfter !== undefined ? this.changeAfter : null as any;
        data["newOrderChangeSummaryOutDto"] = this.newOrderChangeSummaryOutDto ? this.newOrderChangeSummaryOutDto.toJSON() : null as any;
        return data;
    }
}

export class OrderChangeProductBasicProcessDTO {
    id!: string;
    orderChangeProductBasicMotorId!: string | null;
    orderChangeProcessEntityId!: string;
    /** 产品行号 */
    serialNumber!: string | null;
    /** BOM是否变更 */
    isBomChanged!: boolean | null;
    /** BOM变更物料类型 */
    changeMaterialType!: string | null;
    /** BOM变更物料备注 */
    bomChangeMaterialRemarks!: string | null;
    /** 计划BOM更新时间 */
    plannedBomUpdateDuration!: number | null;
    /** 呆滞物料成本,默认0,流程中回传 */
    stagnantMaterialCosts!: number | null;
    /** 人工工时,默认0,流程中回传 */
    laborHours!: number | null;
    /** 物料交期影响 */
    materialDeliveryImpact!: string | null;
    /** 商务折扣 */
    commerceMultiplier!: number | null;
    /** 产品大类 */
    orderProductType!: string | null;
    /** ISO订单号 */
    isoOrderNumber!: string | null;
    /** CSO订单号 */
    csoOrderNumber!: string | null;
    /** 变更费用币种 */
    currencyType!: string | null;
    /** 变更前行总价 */
    preChangeTotalPrice!: number | null;
    /** 变更后行总价 */
    postChangeTotalPrice!: number | null;
    /** 客户确认行总价 */
    customerConfirmedTotalPrice!: number | null;
    /** 变更前系数 */
    preMultiplier!: number | null;
    /** 变更后系数 */
    postMultiplier!: number | null;
    /** 修改前的TP单价
TODO:初始化时候计算 */
    unitTransferPrice!: number | null;
    /** 修改前的TP单价
TODO:初始化时候计算 */
    transferPrice!: number | null;
    /** 修改前的TP单价
TODO:在发起流程时候计算 */
    unitTransferPriceModify!: number | null;
    /** 修改前的TP单价
TODO:在发起流程时候计算 */
    transferPriceModify!: number | null;
    /** 交期影响,默认0 */
    deliveryImpact!: number | null;
    /** 产线（字典表Value） */
    productionLine!: string | null;
    /** 产品组
根据 productType 筛选出产品组 */
    productGroup!: string | null;
    /** 订单类型 */
    orderType!: string | null;
    /** 实际BOM完成日期 */
    actualBomCompletionDate!: moment.Moment | null;
    /** 当前计划装配日期 */
    currentScheduledAssemblyDate!: moment.Moment | null;
    /** BOMDesignerID */
    bomDesignerID!: string | null;
    /** Bom状态 */
    bomStatus!: string | null;
    sapOrderType!: string | null;
    pmuSoitemCategory!: string | null;
    isDirectPass!: boolean | null;
    /** 最低可接受报价 */
    minimumAcceptableQuote!: number | null;
    /** 人工报价费用 */
    laborQuote!: number | null;
    fpDateByExport!: moment.Moment | null;
    /** 行当前是否修改状态
为系统自行计算，若行有修改则出现 */
    isStatusModifiableByExport!: boolean | null;
    /** 修改费用 */
    updatePriceByExport!: number | null;
    /** 修改备注 */
    updateRemarksByExport!: string | null;
    orderChangeProductBasicMotorDto!: OrderChangeProductBasicMotorDto;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.orderChangeProductBasicMotorId = _data["orderChangeProductBasicMotorId"] !== undefined ? _data["orderChangeProductBasicMotorId"] : null as any;
            this.orderChangeProcessEntityId = _data["orderChangeProcessEntityId"] !== undefined ? _data["orderChangeProcessEntityId"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.isBomChanged = _data["isBomChanged"] !== undefined ? _data["isBomChanged"] : null as any;
            this.changeMaterialType = _data["changeMaterialType"] !== undefined ? _data["changeMaterialType"] : null as any;
            this.bomChangeMaterialRemarks = _data["bomChangeMaterialRemarks"] !== undefined ? _data["bomChangeMaterialRemarks"] : null as any;
            this.plannedBomUpdateDuration = _data["plannedBomUpdateDuration"] !== undefined ? _data["plannedBomUpdateDuration"] : null as any;
            this.stagnantMaterialCosts = _data["stagnantMaterialCosts"] !== undefined ? _data["stagnantMaterialCosts"] : null as any;
            this.laborHours = _data["laborHours"] !== undefined ? _data["laborHours"] : null as any;
            this.materialDeliveryImpact = _data["materialDeliveryImpact"] !== undefined ? _data["materialDeliveryImpact"] : null as any;
            this.commerceMultiplier = _data["commerceMultiplier"] !== undefined ? _data["commerceMultiplier"] : null as any;
            this.orderProductType = _data["orderProductType"] !== undefined ? _data["orderProductType"] : null as any;
            this.isoOrderNumber = _data["isoOrderNumber"] !== undefined ? _data["isoOrderNumber"] : null as any;
            this.csoOrderNumber = _data["csoOrderNumber"] !== undefined ? _data["csoOrderNumber"] : null as any;
            this.currencyType = _data["currencyType"] !== undefined ? _data["currencyType"] : null as any;
            this.preChangeTotalPrice = _data["preChangeTotalPrice"] !== undefined ? _data["preChangeTotalPrice"] : null as any;
            this.postChangeTotalPrice = _data["postChangeTotalPrice"] !== undefined ? _data["postChangeTotalPrice"] : null as any;
            this.customerConfirmedTotalPrice = _data["customerConfirmedTotalPrice"] !== undefined ? _data["customerConfirmedTotalPrice"] : null as any;
            this.preMultiplier = _data["preMultiplier"] !== undefined ? _data["preMultiplier"] : null as any;
            this.postMultiplier = _data["postMultiplier"] !== undefined ? _data["postMultiplier"] : null as any;
            this.unitTransferPrice = _data["unitTransferPrice"] !== undefined ? _data["unitTransferPrice"] : null as any;
            this.transferPrice = _data["transferPrice"] !== undefined ? _data["transferPrice"] : null as any;
            this.unitTransferPriceModify = _data["unitTransferPriceModify"] !== undefined ? _data["unitTransferPriceModify"] : null as any;
            this.transferPriceModify = _data["transferPriceModify"] !== undefined ? _data["transferPriceModify"] : null as any;
            this.deliveryImpact = _data["deliveryImpact"] !== undefined ? _data["deliveryImpact"] : null as any;
            this.productionLine = _data["productionLine"] !== undefined ? _data["productionLine"] : null as any;
            this.productGroup = _data["productGroup"] !== undefined ? _data["productGroup"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.actualBomCompletionDate = _data["actualBomCompletionDate"] ? moment(_data["actualBomCompletionDate"].toString()) : null as any;
            this.currentScheduledAssemblyDate = _data["currentScheduledAssemblyDate"] ? moment(_data["currentScheduledAssemblyDate"].toString()) : null as any;
            this.bomDesignerID = _data["bomDesignerID"] !== undefined ? _data["bomDesignerID"] : null as any;
            this.bomStatus = _data["bomStatus"] !== undefined ? _data["bomStatus"] : null as any;
            this.sapOrderType = _data["sapOrderType"] !== undefined ? _data["sapOrderType"] : null as any;
            this.pmuSoitemCategory = _data["pmuSoitemCategory"] !== undefined ? _data["pmuSoitemCategory"] : null as any;
            this.isDirectPass = _data["isDirectPass"] !== undefined ? _data["isDirectPass"] : null as any;
            this.minimumAcceptableQuote = _data["minimumAcceptableQuote"] !== undefined ? _data["minimumAcceptableQuote"] : null as any;
            this.laborQuote = _data["laborQuote"] !== undefined ? _data["laborQuote"] : null as any;
            this.fpDateByExport = _data["fpDateByExport"] ? moment(_data["fpDateByExport"].toString()) : null as any;
            this.isStatusModifiableByExport = _data["isStatusModifiableByExport"] !== undefined ? _data["isStatusModifiableByExport"] : null as any;
            this.updatePriceByExport = _data["updatePriceByExport"] !== undefined ? _data["updatePriceByExport"] : null as any;
            this.updateRemarksByExport = _data["updateRemarksByExport"] !== undefined ? _data["updateRemarksByExport"] : null as any;
            this.orderChangeProductBasicMotorDto = _data["orderChangeProductBasicMotorDto"] ? OrderChangeProductBasicMotorDto.fromJS(_data["orderChangeProductBasicMotorDto"]) : null as any;
        }
    }

    static fromJS(data: any): OrderChangeProductBasicProcessDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeProductBasicProcessDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["orderChangeProductBasicMotorId"] = this.orderChangeProductBasicMotorId !== undefined ? this.orderChangeProductBasicMotorId : null as any;
        data["orderChangeProcessEntityId"] = this.orderChangeProcessEntityId !== undefined ? this.orderChangeProcessEntityId : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["isBomChanged"] = this.isBomChanged !== undefined ? this.isBomChanged : null as any;
        data["changeMaterialType"] = this.changeMaterialType !== undefined ? this.changeMaterialType : null as any;
        data["bomChangeMaterialRemarks"] = this.bomChangeMaterialRemarks !== undefined ? this.bomChangeMaterialRemarks : null as any;
        data["plannedBomUpdateDuration"] = this.plannedBomUpdateDuration !== undefined ? this.plannedBomUpdateDuration : null as any;
        data["stagnantMaterialCosts"] = this.stagnantMaterialCosts !== undefined ? this.stagnantMaterialCosts : null as any;
        data["laborHours"] = this.laborHours !== undefined ? this.laborHours : null as any;
        data["materialDeliveryImpact"] = this.materialDeliveryImpact !== undefined ? this.materialDeliveryImpact : null as any;
        data["commerceMultiplier"] = this.commerceMultiplier !== undefined ? this.commerceMultiplier : null as any;
        data["orderProductType"] = this.orderProductType !== undefined ? this.orderProductType : null as any;
        data["isoOrderNumber"] = this.isoOrderNumber !== undefined ? this.isoOrderNumber : null as any;
        data["csoOrderNumber"] = this.csoOrderNumber !== undefined ? this.csoOrderNumber : null as any;
        data["currencyType"] = this.currencyType !== undefined ? this.currencyType : null as any;
        data["preChangeTotalPrice"] = this.preChangeTotalPrice !== undefined ? this.preChangeTotalPrice : null as any;
        data["postChangeTotalPrice"] = this.postChangeTotalPrice !== undefined ? this.postChangeTotalPrice : null as any;
        data["customerConfirmedTotalPrice"] = this.customerConfirmedTotalPrice !== undefined ? this.customerConfirmedTotalPrice : null as any;
        data["preMultiplier"] = this.preMultiplier !== undefined ? this.preMultiplier : null as any;
        data["postMultiplier"] = this.postMultiplier !== undefined ? this.postMultiplier : null as any;
        data["unitTransferPrice"] = this.unitTransferPrice !== undefined ? this.unitTransferPrice : null as any;
        data["transferPrice"] = this.transferPrice !== undefined ? this.transferPrice : null as any;
        data["unitTransferPriceModify"] = this.unitTransferPriceModify !== undefined ? this.unitTransferPriceModify : null as any;
        data["transferPriceModify"] = this.transferPriceModify !== undefined ? this.transferPriceModify : null as any;
        data["deliveryImpact"] = this.deliveryImpact !== undefined ? this.deliveryImpact : null as any;
        data["productionLine"] = this.productionLine !== undefined ? this.productionLine : null as any;
        data["productGroup"] = this.productGroup !== undefined ? this.productGroup : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["actualBomCompletionDate"] = this.actualBomCompletionDate ? this.actualBomCompletionDate.toISOString() : null as any;
        data["currentScheduledAssemblyDate"] = this.currentScheduledAssemblyDate ? this.currentScheduledAssemblyDate.toISOString() : null as any;
        data["bomDesignerID"] = this.bomDesignerID !== undefined ? this.bomDesignerID : null as any;
        data["bomStatus"] = this.bomStatus !== undefined ? this.bomStatus : null as any;
        data["sapOrderType"] = this.sapOrderType !== undefined ? this.sapOrderType : null as any;
        data["pmuSoitemCategory"] = this.pmuSoitemCategory !== undefined ? this.pmuSoitemCategory : null as any;
        data["isDirectPass"] = this.isDirectPass !== undefined ? this.isDirectPass : null as any;
        data["minimumAcceptableQuote"] = this.minimumAcceptableQuote !== undefined ? this.minimumAcceptableQuote : null as any;
        data["laborQuote"] = this.laborQuote !== undefined ? this.laborQuote : null as any;
        data["fpDateByExport"] = this.fpDateByExport ? this.fpDateByExport.toISOString() : null as any;
        data["isStatusModifiableByExport"] = this.isStatusModifiableByExport !== undefined ? this.isStatusModifiableByExport : null as any;
        data["updatePriceByExport"] = this.updatePriceByExport !== undefined ? this.updatePriceByExport : null as any;
        data["updateRemarksByExport"] = this.updateRemarksByExport !== undefined ? this.updateRemarksByExport : null as any;
        data["orderChangeProductBasicMotorDto"] = this.orderChangeProductBasicMotorDto ? this.orderChangeProductBasicMotorDto.toJSON() : null as any;
        return data;
    }
}

export class OrderChangeProductBasicProcessEntity {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    orderChangeProductBasicMotorId!: string;
    orderChangeProcessEntityId!: string;
    serialNumber!: string | null;
    isBomChanged!: boolean | null;
    changeMaterialType!: string | null;
    bomChangeMaterialRemarks!: string | null;
    plannedBomUpdateDuration!: number | null;
    stagnantMaterialCosts!: number | null;
    laborHours!: number | null;
    materialDeliveryImpact!: string | null;
    commerceMultiplier!: number | null;
    commerceConfirmationMultiplier!: number | null;
    orderProductType!: string | null;
    preChangeTotalPrice!: number | null;
    postChangeTotalPrice!: number | null;
    preSalesPrice!: number | null;
    postSalesPrice!: number | null;
    customerConfirmedTotalPrice!: number | null;
    preMultiplier!: number | null;
    postMultiplier!: number | null;
    unitTransferPrice!: number | null;
    transferPrice!: number | null;
    unitTransferPriceModify!: number | null;
    transferPriceModify!: number | null;
    productionLine!: string | null;
    productGroup!: string | null;
    orderType!: string | null;
    actualBomCompletionDate!: moment.Moment | null;
    currentScheduledAssemblyDate!: moment.Moment | null;
    bomDesignerID!: string | null;
    bomStatus!: string | null;
    materialImpact!: boolean | null;
    sapOrderType!: string | null;
    pmuSoitemCategory!: string | null;
    isDirectPass!: boolean | null;
    minimumAcceptableQuote!: number | null;
    laborQuote!: number | null;
    isFeasible!: boolean | null;
    totalLaborCost!: number | null;
    internalSalesOrder!: string | null;
    customerSalesOrder!: string | null;
    csoItem!: string | null;
    isoItem!: string | null;
    stagnantInventoryCost!: number | null;
    additionalStagnantInventoryCost!: number | null;
    preAssemblyManualLaborHours!: number | null;
    calculateDeliveryImpact!: number | null;
    plannedConfirmationImpactOnDelivery!: number | null;
    changeFee!: number | null;
    currencyType!: string | null;
    changePrice!: number | null;
    exchangeRateAndTariff!: number | null;
    isManual!: boolean | null;
    factoryCompleteTime!: moment.Moment | null;
    mainTotalDelayImpact!: number | null;
    vcChangeDays!: number;
    hasChange!: boolean;
    customerConfirmationDay!: number | null;
    isExecutionAdvised!: boolean | null;
    fpDateByExport!: moment.Moment | null;
    isStatusModifiableByExport!: boolean | null;
    updatePriceByExport!: number | null;
    updateRemarksByExport!: string | null;
    totalDelayImpact!: number | null;
    oisExportOrderProducts!: OISExportOrderProducts;
    orderChangeProductBasicMotor!: OrderChangeProductBasicMotor;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.orderChangeProductBasicMotorId = _data["orderChangeProductBasicMotorId"] !== undefined ? _data["orderChangeProductBasicMotorId"] : null as any;
            this.orderChangeProcessEntityId = _data["orderChangeProcessEntityId"] !== undefined ? _data["orderChangeProcessEntityId"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.isBomChanged = _data["isBomChanged"] !== undefined ? _data["isBomChanged"] : null as any;
            this.changeMaterialType = _data["changeMaterialType"] !== undefined ? _data["changeMaterialType"] : null as any;
            this.bomChangeMaterialRemarks = _data["bomChangeMaterialRemarks"] !== undefined ? _data["bomChangeMaterialRemarks"] : null as any;
            this.plannedBomUpdateDuration = _data["plannedBomUpdateDuration"] !== undefined ? _data["plannedBomUpdateDuration"] : null as any;
            this.stagnantMaterialCosts = _data["stagnantMaterialCosts"] !== undefined ? _data["stagnantMaterialCosts"] : null as any;
            this.laborHours = _data["laborHours"] !== undefined ? _data["laborHours"] : null as any;
            this.materialDeliveryImpact = _data["materialDeliveryImpact"] !== undefined ? _data["materialDeliveryImpact"] : null as any;
            this.commerceMultiplier = _data["commerceMultiplier"] !== undefined ? _data["commerceMultiplier"] : null as any;
            this.commerceConfirmationMultiplier = _data["commerceConfirmationMultiplier"] !== undefined ? _data["commerceConfirmationMultiplier"] : null as any;
            this.orderProductType = _data["orderProductType"] !== undefined ? _data["orderProductType"] : null as any;
            this.preChangeTotalPrice = _data["preChangeTotalPrice"] !== undefined ? _data["preChangeTotalPrice"] : null as any;
            this.postChangeTotalPrice = _data["postChangeTotalPrice"] !== undefined ? _data["postChangeTotalPrice"] : null as any;
            this.preSalesPrice = _data["preSalesPrice"] !== undefined ? _data["preSalesPrice"] : null as any;
            this.postSalesPrice = _data["postSalesPrice"] !== undefined ? _data["postSalesPrice"] : null as any;
            this.customerConfirmedTotalPrice = _data["customerConfirmedTotalPrice"] !== undefined ? _data["customerConfirmedTotalPrice"] : null as any;
            this.preMultiplier = _data["preMultiplier"] !== undefined ? _data["preMultiplier"] : null as any;
            this.postMultiplier = _data["postMultiplier"] !== undefined ? _data["postMultiplier"] : null as any;
            this.unitTransferPrice = _data["unitTransferPrice"] !== undefined ? _data["unitTransferPrice"] : null as any;
            this.transferPrice = _data["transferPrice"] !== undefined ? _data["transferPrice"] : null as any;
            this.unitTransferPriceModify = _data["unitTransferPriceModify"] !== undefined ? _data["unitTransferPriceModify"] : null as any;
            this.transferPriceModify = _data["transferPriceModify"] !== undefined ? _data["transferPriceModify"] : null as any;
            this.productionLine = _data["productionLine"] !== undefined ? _data["productionLine"] : null as any;
            this.productGroup = _data["productGroup"] !== undefined ? _data["productGroup"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.actualBomCompletionDate = _data["actualBomCompletionDate"] ? moment(_data["actualBomCompletionDate"].toString()) : null as any;
            this.currentScheduledAssemblyDate = _data["currentScheduledAssemblyDate"] ? moment(_data["currentScheduledAssemblyDate"].toString()) : null as any;
            this.bomDesignerID = _data["bomDesignerID"] !== undefined ? _data["bomDesignerID"] : null as any;
            this.bomStatus = _data["bomStatus"] !== undefined ? _data["bomStatus"] : null as any;
            this.materialImpact = _data["materialImpact"] !== undefined ? _data["materialImpact"] : null as any;
            this.sapOrderType = _data["sapOrderType"] !== undefined ? _data["sapOrderType"] : null as any;
            this.pmuSoitemCategory = _data["pmuSoitemCategory"] !== undefined ? _data["pmuSoitemCategory"] : null as any;
            this.isDirectPass = _data["isDirectPass"] !== undefined ? _data["isDirectPass"] : null as any;
            this.minimumAcceptableQuote = _data["minimumAcceptableQuote"] !== undefined ? _data["minimumAcceptableQuote"] : null as any;
            this.laborQuote = _data["laborQuote"] !== undefined ? _data["laborQuote"] : null as any;
            this.isFeasible = _data["isFeasible"] !== undefined ? _data["isFeasible"] : null as any;
            this.totalLaborCost = _data["totalLaborCost"] !== undefined ? _data["totalLaborCost"] : null as any;
            this.internalSalesOrder = _data["internalSalesOrder"] !== undefined ? _data["internalSalesOrder"] : null as any;
            this.customerSalesOrder = _data["customerSalesOrder"] !== undefined ? _data["customerSalesOrder"] : null as any;
            this.csoItem = _data["csoItem"] !== undefined ? _data["csoItem"] : null as any;
            this.isoItem = _data["isoItem"] !== undefined ? _data["isoItem"] : null as any;
            this.stagnantInventoryCost = _data["stagnantInventoryCost"] !== undefined ? _data["stagnantInventoryCost"] : null as any;
            this.additionalStagnantInventoryCost = _data["additionalStagnantInventoryCost"] !== undefined ? _data["additionalStagnantInventoryCost"] : null as any;
            this.preAssemblyManualLaborHours = _data["preAssemblyManualLaborHours"] !== undefined ? _data["preAssemblyManualLaborHours"] : null as any;
            this.calculateDeliveryImpact = _data["calculateDeliveryImpact"] !== undefined ? _data["calculateDeliveryImpact"] : null as any;
            this.plannedConfirmationImpactOnDelivery = _data["plannedConfirmationImpactOnDelivery"] !== undefined ? _data["plannedConfirmationImpactOnDelivery"] : null as any;
            this.changeFee = _data["changeFee"] !== undefined ? _data["changeFee"] : null as any;
            this.currencyType = _data["currencyType"] !== undefined ? _data["currencyType"] : null as any;
            this.changePrice = _data["changePrice"] !== undefined ? _data["changePrice"] : null as any;
            this.exchangeRateAndTariff = _data["exchangeRateAndTariff"] !== undefined ? _data["exchangeRateAndTariff"] : null as any;
            this.isManual = _data["isManual"] !== undefined ? _data["isManual"] : null as any;
            this.factoryCompleteTime = _data["factoryCompleteTime"] ? moment(_data["factoryCompleteTime"].toString()) : null as any;
            this.mainTotalDelayImpact = _data["mainTotalDelayImpact"] !== undefined ? _data["mainTotalDelayImpact"] : null as any;
            this.vcChangeDays = _data["vcChangeDays"] !== undefined ? _data["vcChangeDays"] : null as any;
            this.hasChange = _data["hasChange"] !== undefined ? _data["hasChange"] : null as any;
            this.customerConfirmationDay = _data["customerConfirmationDay"] !== undefined ? _data["customerConfirmationDay"] : null as any;
            this.isExecutionAdvised = _data["isExecutionAdvised"] !== undefined ? _data["isExecutionAdvised"] : null as any;
            this.fpDateByExport = _data["fpDateByExport"] ? moment(_data["fpDateByExport"].toString()) : null as any;
            this.isStatusModifiableByExport = _data["isStatusModifiableByExport"] !== undefined ? _data["isStatusModifiableByExport"] : null as any;
            this.updatePriceByExport = _data["updatePriceByExport"] !== undefined ? _data["updatePriceByExport"] : null as any;
            this.updateRemarksByExport = _data["updateRemarksByExport"] !== undefined ? _data["updateRemarksByExport"] : null as any;
            this.totalDelayImpact = _data["totalDelayImpact"] !== undefined ? _data["totalDelayImpact"] : null as any;
            this.oisExportOrderProducts = _data["oisExportOrderProducts"] ? OISExportOrderProducts.fromJS(_data["oisExportOrderProducts"]) : null as any;
            this.orderChangeProductBasicMotor = _data["orderChangeProductBasicMotor"] ? OrderChangeProductBasicMotor.fromJS(_data["orderChangeProductBasicMotor"]) : null as any;
        }
    }

    static fromJS(data: any): OrderChangeProductBasicProcessEntity {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeProductBasicProcessEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["orderChangeProductBasicMotorId"] = this.orderChangeProductBasicMotorId !== undefined ? this.orderChangeProductBasicMotorId : null as any;
        data["orderChangeProcessEntityId"] = this.orderChangeProcessEntityId !== undefined ? this.orderChangeProcessEntityId : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["isBomChanged"] = this.isBomChanged !== undefined ? this.isBomChanged : null as any;
        data["changeMaterialType"] = this.changeMaterialType !== undefined ? this.changeMaterialType : null as any;
        data["bomChangeMaterialRemarks"] = this.bomChangeMaterialRemarks !== undefined ? this.bomChangeMaterialRemarks : null as any;
        data["plannedBomUpdateDuration"] = this.plannedBomUpdateDuration !== undefined ? this.plannedBomUpdateDuration : null as any;
        data["stagnantMaterialCosts"] = this.stagnantMaterialCosts !== undefined ? this.stagnantMaterialCosts : null as any;
        data["laborHours"] = this.laborHours !== undefined ? this.laborHours : null as any;
        data["materialDeliveryImpact"] = this.materialDeliveryImpact !== undefined ? this.materialDeliveryImpact : null as any;
        data["commerceMultiplier"] = this.commerceMultiplier !== undefined ? this.commerceMultiplier : null as any;
        data["commerceConfirmationMultiplier"] = this.commerceConfirmationMultiplier !== undefined ? this.commerceConfirmationMultiplier : null as any;
        data["orderProductType"] = this.orderProductType !== undefined ? this.orderProductType : null as any;
        data["preChangeTotalPrice"] = this.preChangeTotalPrice !== undefined ? this.preChangeTotalPrice : null as any;
        data["postChangeTotalPrice"] = this.postChangeTotalPrice !== undefined ? this.postChangeTotalPrice : null as any;
        data["preSalesPrice"] = this.preSalesPrice !== undefined ? this.preSalesPrice : null as any;
        data["postSalesPrice"] = this.postSalesPrice !== undefined ? this.postSalesPrice : null as any;
        data["customerConfirmedTotalPrice"] = this.customerConfirmedTotalPrice !== undefined ? this.customerConfirmedTotalPrice : null as any;
        data["preMultiplier"] = this.preMultiplier !== undefined ? this.preMultiplier : null as any;
        data["postMultiplier"] = this.postMultiplier !== undefined ? this.postMultiplier : null as any;
        data["unitTransferPrice"] = this.unitTransferPrice !== undefined ? this.unitTransferPrice : null as any;
        data["transferPrice"] = this.transferPrice !== undefined ? this.transferPrice : null as any;
        data["unitTransferPriceModify"] = this.unitTransferPriceModify !== undefined ? this.unitTransferPriceModify : null as any;
        data["transferPriceModify"] = this.transferPriceModify !== undefined ? this.transferPriceModify : null as any;
        data["productionLine"] = this.productionLine !== undefined ? this.productionLine : null as any;
        data["productGroup"] = this.productGroup !== undefined ? this.productGroup : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["actualBomCompletionDate"] = this.actualBomCompletionDate ? this.actualBomCompletionDate.toISOString() : null as any;
        data["currentScheduledAssemblyDate"] = this.currentScheduledAssemblyDate ? this.currentScheduledAssemblyDate.toISOString() : null as any;
        data["bomDesignerID"] = this.bomDesignerID !== undefined ? this.bomDesignerID : null as any;
        data["bomStatus"] = this.bomStatus !== undefined ? this.bomStatus : null as any;
        data["materialImpact"] = this.materialImpact !== undefined ? this.materialImpact : null as any;
        data["sapOrderType"] = this.sapOrderType !== undefined ? this.sapOrderType : null as any;
        data["pmuSoitemCategory"] = this.pmuSoitemCategory !== undefined ? this.pmuSoitemCategory : null as any;
        data["isDirectPass"] = this.isDirectPass !== undefined ? this.isDirectPass : null as any;
        data["minimumAcceptableQuote"] = this.minimumAcceptableQuote !== undefined ? this.minimumAcceptableQuote : null as any;
        data["laborQuote"] = this.laborQuote !== undefined ? this.laborQuote : null as any;
        data["isFeasible"] = this.isFeasible !== undefined ? this.isFeasible : null as any;
        data["totalLaborCost"] = this.totalLaborCost !== undefined ? this.totalLaborCost : null as any;
        data["internalSalesOrder"] = this.internalSalesOrder !== undefined ? this.internalSalesOrder : null as any;
        data["customerSalesOrder"] = this.customerSalesOrder !== undefined ? this.customerSalesOrder : null as any;
        data["csoItem"] = this.csoItem !== undefined ? this.csoItem : null as any;
        data["isoItem"] = this.isoItem !== undefined ? this.isoItem : null as any;
        data["stagnantInventoryCost"] = this.stagnantInventoryCost !== undefined ? this.stagnantInventoryCost : null as any;
        data["additionalStagnantInventoryCost"] = this.additionalStagnantInventoryCost !== undefined ? this.additionalStagnantInventoryCost : null as any;
        data["preAssemblyManualLaborHours"] = this.preAssemblyManualLaborHours !== undefined ? this.preAssemblyManualLaborHours : null as any;
        data["calculateDeliveryImpact"] = this.calculateDeliveryImpact !== undefined ? this.calculateDeliveryImpact : null as any;
        data["plannedConfirmationImpactOnDelivery"] = this.plannedConfirmationImpactOnDelivery !== undefined ? this.plannedConfirmationImpactOnDelivery : null as any;
        data["changeFee"] = this.changeFee !== undefined ? this.changeFee : null as any;
        data["currencyType"] = this.currencyType !== undefined ? this.currencyType : null as any;
        data["changePrice"] = this.changePrice !== undefined ? this.changePrice : null as any;
        data["exchangeRateAndTariff"] = this.exchangeRateAndTariff !== undefined ? this.exchangeRateAndTariff : null as any;
        data["isManual"] = this.isManual !== undefined ? this.isManual : null as any;
        data["factoryCompleteTime"] = this.factoryCompleteTime ? this.factoryCompleteTime.toISOString() : null as any;
        data["mainTotalDelayImpact"] = this.mainTotalDelayImpact !== undefined ? this.mainTotalDelayImpact : null as any;
        data["vcChangeDays"] = this.vcChangeDays !== undefined ? this.vcChangeDays : null as any;
        data["hasChange"] = this.hasChange !== undefined ? this.hasChange : null as any;
        data["customerConfirmationDay"] = this.customerConfirmationDay !== undefined ? this.customerConfirmationDay : null as any;
        data["isExecutionAdvised"] = this.isExecutionAdvised !== undefined ? this.isExecutionAdvised : null as any;
        data["fpDateByExport"] = this.fpDateByExport ? this.fpDateByExport.toISOString() : null as any;
        data["isStatusModifiableByExport"] = this.isStatusModifiableByExport !== undefined ? this.isStatusModifiableByExport : null as any;
        data["updatePriceByExport"] = this.updatePriceByExport !== undefined ? this.updatePriceByExport : null as any;
        data["updateRemarksByExport"] = this.updateRemarksByExport !== undefined ? this.updateRemarksByExport : null as any;
        data["totalDelayImpact"] = this.totalDelayImpact !== undefined ? this.totalDelayImpact : null as any;
        data["oisExportOrderProducts"] = this.oisExportOrderProducts ? this.oisExportOrderProducts.toJSON() : null as any;
        data["orderChangeProductBasicMotor"] = this.orderChangeProductBasicMotor ? this.orderChangeProductBasicMotor.toJSON() : null as any;
        return data;
    }
}

export class OrderChangeProductVC {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    vcProductCode!: string | null;
    vcCode!: string | null;
    discountType!: string | null;
    unitPriceType!: string | null;
    unitPriceExpiredTime!: moment.Moment | null;
    unitPrice!: number | null;
    salesPrice!: number | null;
    meaning!: string | null;
    remark!: string | null;
    receiveVcFreeTextJSON!: string | null;
    isNewProductVC!: boolean | null;
    vcType!: number | null;
    orderChangeProductBasicMotorId!: string | null;
    vcShowType!: number;
    technologyQuotationProductVCId!: string | null;
    technicalSpecificationProductVCId!: string | null;
    isNewMultiplier!: boolean | null;
    newMultiplier!: number | null;
    isInside!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.vcProductCode = _data["vcProductCode"] !== undefined ? _data["vcProductCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.unitPriceExpiredTime = _data["unitPriceExpiredTime"] ? moment(_data["unitPriceExpiredTime"].toString()) : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.receiveVcFreeTextJSON = _data["receiveVcFreeTextJSON"] !== undefined ? _data["receiveVcFreeTextJSON"] : null as any;
            this.isNewProductVC = _data["isNewProductVC"] !== undefined ? _data["isNewProductVC"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.orderChangeProductBasicMotorId = _data["orderChangeProductBasicMotorId"] !== undefined ? _data["orderChangeProductBasicMotorId"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.technologyQuotationProductVCId = _data["technologyQuotationProductVCId"] !== undefined ? _data["technologyQuotationProductVCId"] : null as any;
            this.technicalSpecificationProductVCId = _data["technicalSpecificationProductVCId"] !== undefined ? _data["technicalSpecificationProductVCId"] : null as any;
            this.isNewMultiplier = _data["isNewMultiplier"] !== undefined ? _data["isNewMultiplier"] : null as any;
            this.newMultiplier = _data["newMultiplier"] !== undefined ? _data["newMultiplier"] : null as any;
            this.isInside = _data["isInside"] !== undefined ? _data["isInside"] : null as any;
        }
    }

    static fromJS(data: any): OrderChangeProductVC {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeProductVC();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["vcProductCode"] = this.vcProductCode !== undefined ? this.vcProductCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["discountType"] = this.discountType !== undefined ? this.discountType : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["unitPriceExpiredTime"] = this.unitPriceExpiredTime ? this.unitPriceExpiredTime.toISOString() : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["receiveVcFreeTextJSON"] = this.receiveVcFreeTextJSON !== undefined ? this.receiveVcFreeTextJSON : null as any;
        data["isNewProductVC"] = this.isNewProductVC !== undefined ? this.isNewProductVC : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["orderChangeProductBasicMotorId"] = this.orderChangeProductBasicMotorId !== undefined ? this.orderChangeProductBasicMotorId : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["technologyQuotationProductVCId"] = this.technologyQuotationProductVCId !== undefined ? this.technologyQuotationProductVCId : null as any;
        data["technicalSpecificationProductVCId"] = this.technicalSpecificationProductVCId !== undefined ? this.technicalSpecificationProductVCId : null as any;
        data["isNewMultiplier"] = this.isNewMultiplier !== undefined ? this.isNewMultiplier : null as any;
        data["newMultiplier"] = this.newMultiplier !== undefined ? this.newMultiplier : null as any;
        data["isInside"] = this.isInside !== undefined ? this.isInside : null as any;
        return data;
    }
}

export class OrderChangeProductVCOut {
    orderChangeOrderFormId!: string | null;
    orderChangeProductBasicMotorId!: string | null;
    serialNumber!: number | null;
    basicMotorCode!: string | null;
    vcCode!: string | null;
    /** 开放内容 */
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.orderChangeOrderFormId = _data["orderChangeOrderFormId"] !== undefined ? _data["orderChangeOrderFormId"] : null as any;
            this.orderChangeProductBasicMotorId = _data["orderChangeProductBasicMotorId"] !== undefined ? _data["orderChangeProductBasicMotorId"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): OrderChangeProductVCOut {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeProductVCOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderChangeOrderFormId"] = this.orderChangeOrderFormId !== undefined ? this.orderChangeOrderFormId : null as any;
        data["orderChangeProductBasicMotorId"] = this.orderChangeProductBasicMotorId !== undefined ? this.orderChangeProductBasicMotorId : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

/** 0 = InProgress (进行中) 1 = Audit (待审核) 2 = Complete (完成) */
export enum OrderChangeStatus {
    InProgress = 0,
    Audit = 1,
    Complete = 2,
}

/** 订单变更汇总输出 */
export class OrderChangeSummaryOutDto {
    /** pmu订单号-ISO号 */
    internalSalesOrder!: string | null;
    /** LSU订单号-CSO号 */
    customerSalesOrder!: string | null;
    /** OMS单号 */
    omsOrderNumber!: string | null;
    /** 序列号-行号 */
    serialNumber!: number | null;
    /** 新增VC */
    addVCChange!: string[] | null;
    /** 删除VC */
    deleteVCChange!: string[] | null;
    /** 变更前售价 */
    oldSalesPrice!: string | null;
    /** 变更后售价 */
    newSalesPrice!: string | null;
    /** 变更前总面价 */
    oldTotalUnitPrice!: string | null;
    /** 变更后总面价 */
    newTotalUnitPrice!: string | null;
    /** 变更前系数 */
    oldMultiplier!: string | null;
    /** 变更后系数 */
    newMultiplier!: string | null;
    /** 短链接 */
    shortLink!: string | null;
    /** 变更前vc备注 */
    oldVCChangeRemark!: string[] | null;
    /** 变更后vc备注 */
    newVCChangeRemark!: string[] | null;
    /** 变更前协议号 */
    oldTechnicalSpecifications!: string | null;
    /** 变更后协议号 */
    newTechnicalSpecifications!: string | null;
    /** 变更前报价号 */
    oldGSSQuotationNo!: string | null;
    /** 变更后报价号 */
    newGSSQuotationNo!: string | null;
    /** 变更前技术确认号 */
    oldGSSTechnicalConfirmationNumber!: string | null;
    /** 变更后技术确认号 */
    newGSSTechnicalConfirmationNumber!: string | null;
    /** 变更前运营相关备注变更 */
    oldOperationalRemarks!: string | null;
    /** 变更后运营相关备注变更 */
    newOperationalRemarks!: string | null;
    /** 变更前客户物料号 */
    oldCustomerMaterialNumber!: string | null;
    /** 变更后客户物料号 */
    newCustomerMaterialNumber!: string | null;
    /** 变更前TP总价 */
    oldTransferPrice!: string | null;
    /** 变更后TP总价 */
    newTransferPrice!: string | null;
    /** 变更前TP单价 */
    oldUnitTransferPrice!: string | null;
    /** 变更后TP单价 */
    newUnitTransferPrice!: string | null;
    /** 变更前单价 */
    oldUnitPrice!: string | null;
    /** 变更后单价 */
    newUnitPrice!: string | null;
    /** 变更前期望交期 */
    oldCustomerExpectedDeliveryDate!: moment.Moment | null;
    /** 商务最终确认交期变化 */
    newCustomerExpectedDelivery!: number | null;
    /** bom更新时长 */
    plannedBomUpdateDuration!: number | null;
    /** 商务最终确认价格 */
    enterUnitPrice!: number | null;
    /** 产品组合的数量 */
    numberOfProduct!: number;

    init(_data?: any) {
        if (_data) {
            this.internalSalesOrder = _data["internalSalesOrder"] !== undefined ? _data["internalSalesOrder"] : null as any;
            this.customerSalesOrder = _data["customerSalesOrder"] !== undefined ? _data["customerSalesOrder"] : null as any;
            this.omsOrderNumber = _data["omsOrderNumber"] !== undefined ? _data["omsOrderNumber"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            if (Array.isArray(_data["addVCChange"])) {
                this.addVCChange = [] as any;
                for (let item of _data["addVCChange"])
                    this.addVCChange!.push(item);
            }
            else {
                this.addVCChange = null as any;
            }
            if (Array.isArray(_data["deleteVCChange"])) {
                this.deleteVCChange = [] as any;
                for (let item of _data["deleteVCChange"])
                    this.deleteVCChange!.push(item);
            }
            else {
                this.deleteVCChange = null as any;
            }
            this.oldSalesPrice = _data["oldSalesPrice"] !== undefined ? _data["oldSalesPrice"] : null as any;
            this.newSalesPrice = _data["newSalesPrice"] !== undefined ? _data["newSalesPrice"] : null as any;
            this.oldTotalUnitPrice = _data["oldTotalUnitPrice"] !== undefined ? _data["oldTotalUnitPrice"] : null as any;
            this.newTotalUnitPrice = _data["newTotalUnitPrice"] !== undefined ? _data["newTotalUnitPrice"] : null as any;
            this.oldMultiplier = _data["oldMultiplier"] !== undefined ? _data["oldMultiplier"] : null as any;
            this.newMultiplier = _data["newMultiplier"] !== undefined ? _data["newMultiplier"] : null as any;
            this.shortLink = _data["shortLink"] !== undefined ? _data["shortLink"] : null as any;
            if (Array.isArray(_data["oldVCChangeRemark"])) {
                this.oldVCChangeRemark = [] as any;
                for (let item of _data["oldVCChangeRemark"])
                    this.oldVCChangeRemark!.push(item);
            }
            else {
                this.oldVCChangeRemark = null as any;
            }
            if (Array.isArray(_data["newVCChangeRemark"])) {
                this.newVCChangeRemark = [] as any;
                for (let item of _data["newVCChangeRemark"])
                    this.newVCChangeRemark!.push(item);
            }
            else {
                this.newVCChangeRemark = null as any;
            }
            this.oldTechnicalSpecifications = _data["oldTechnicalSpecifications"] !== undefined ? _data["oldTechnicalSpecifications"] : null as any;
            this.newTechnicalSpecifications = _data["newTechnicalSpecifications"] !== undefined ? _data["newTechnicalSpecifications"] : null as any;
            this.oldGSSQuotationNo = _data["oldGSSQuotationNo"] !== undefined ? _data["oldGSSQuotationNo"] : null as any;
            this.newGSSQuotationNo = _data["newGSSQuotationNo"] !== undefined ? _data["newGSSQuotationNo"] : null as any;
            this.oldGSSTechnicalConfirmationNumber = _data["oldGSSTechnicalConfirmationNumber"] !== undefined ? _data["oldGSSTechnicalConfirmationNumber"] : null as any;
            this.newGSSTechnicalConfirmationNumber = _data["newGSSTechnicalConfirmationNumber"] !== undefined ? _data["newGSSTechnicalConfirmationNumber"] : null as any;
            this.oldOperationalRemarks = _data["oldOperationalRemarks"] !== undefined ? _data["oldOperationalRemarks"] : null as any;
            this.newOperationalRemarks = _data["newOperationalRemarks"] !== undefined ? _data["newOperationalRemarks"] : null as any;
            this.oldCustomerMaterialNumber = _data["oldCustomerMaterialNumber"] !== undefined ? _data["oldCustomerMaterialNumber"] : null as any;
            this.newCustomerMaterialNumber = _data["newCustomerMaterialNumber"] !== undefined ? _data["newCustomerMaterialNumber"] : null as any;
            this.oldTransferPrice = _data["oldTransferPrice"] !== undefined ? _data["oldTransferPrice"] : null as any;
            this.newTransferPrice = _data["newTransferPrice"] !== undefined ? _data["newTransferPrice"] : null as any;
            this.oldUnitTransferPrice = _data["oldUnitTransferPrice"] !== undefined ? _data["oldUnitTransferPrice"] : null as any;
            this.newUnitTransferPrice = _data["newUnitTransferPrice"] !== undefined ? _data["newUnitTransferPrice"] : null as any;
            this.oldUnitPrice = _data["oldUnitPrice"] !== undefined ? _data["oldUnitPrice"] : null as any;
            this.newUnitPrice = _data["newUnitPrice"] !== undefined ? _data["newUnitPrice"] : null as any;
            this.oldCustomerExpectedDeliveryDate = _data["oldCustomerExpectedDeliveryDate"] ? moment(_data["oldCustomerExpectedDeliveryDate"].toString()) : null as any;
            this.newCustomerExpectedDelivery = _data["newCustomerExpectedDelivery"] !== undefined ? _data["newCustomerExpectedDelivery"] : null as any;
            this.plannedBomUpdateDuration = _data["plannedBomUpdateDuration"] !== undefined ? _data["plannedBomUpdateDuration"] : null as any;
            this.enterUnitPrice = _data["enterUnitPrice"] !== undefined ? _data["enterUnitPrice"] : null as any;
            this.numberOfProduct = _data["numberOfProduct"] !== undefined ? _data["numberOfProduct"] : null as any;
        }
    }

    static fromJS(data: any): OrderChangeSummaryOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeSummaryOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalSalesOrder"] = this.internalSalesOrder !== undefined ? this.internalSalesOrder : null as any;
        data["customerSalesOrder"] = this.customerSalesOrder !== undefined ? this.customerSalesOrder : null as any;
        data["omsOrderNumber"] = this.omsOrderNumber !== undefined ? this.omsOrderNumber : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        if (Array.isArray(this.addVCChange)) {
            data["addVCChange"] = [];
            for (let item of this.addVCChange)
                data["addVCChange"].push(item);
        }
        if (Array.isArray(this.deleteVCChange)) {
            data["deleteVCChange"] = [];
            for (let item of this.deleteVCChange)
                data["deleteVCChange"].push(item);
        }
        data["oldSalesPrice"] = this.oldSalesPrice !== undefined ? this.oldSalesPrice : null as any;
        data["newSalesPrice"] = this.newSalesPrice !== undefined ? this.newSalesPrice : null as any;
        data["oldTotalUnitPrice"] = this.oldTotalUnitPrice !== undefined ? this.oldTotalUnitPrice : null as any;
        data["newTotalUnitPrice"] = this.newTotalUnitPrice !== undefined ? this.newTotalUnitPrice : null as any;
        data["oldMultiplier"] = this.oldMultiplier !== undefined ? this.oldMultiplier : null as any;
        data["newMultiplier"] = this.newMultiplier !== undefined ? this.newMultiplier : null as any;
        data["shortLink"] = this.shortLink !== undefined ? this.shortLink : null as any;
        if (Array.isArray(this.oldVCChangeRemark)) {
            data["oldVCChangeRemark"] = [];
            for (let item of this.oldVCChangeRemark)
                data["oldVCChangeRemark"].push(item);
        }
        if (Array.isArray(this.newVCChangeRemark)) {
            data["newVCChangeRemark"] = [];
            for (let item of this.newVCChangeRemark)
                data["newVCChangeRemark"].push(item);
        }
        data["oldTechnicalSpecifications"] = this.oldTechnicalSpecifications !== undefined ? this.oldTechnicalSpecifications : null as any;
        data["newTechnicalSpecifications"] = this.newTechnicalSpecifications !== undefined ? this.newTechnicalSpecifications : null as any;
        data["oldGSSQuotationNo"] = this.oldGSSQuotationNo !== undefined ? this.oldGSSQuotationNo : null as any;
        data["newGSSQuotationNo"] = this.newGSSQuotationNo !== undefined ? this.newGSSQuotationNo : null as any;
        data["oldGSSTechnicalConfirmationNumber"] = this.oldGSSTechnicalConfirmationNumber !== undefined ? this.oldGSSTechnicalConfirmationNumber : null as any;
        data["newGSSTechnicalConfirmationNumber"] = this.newGSSTechnicalConfirmationNumber !== undefined ? this.newGSSTechnicalConfirmationNumber : null as any;
        data["oldOperationalRemarks"] = this.oldOperationalRemarks !== undefined ? this.oldOperationalRemarks : null as any;
        data["newOperationalRemarks"] = this.newOperationalRemarks !== undefined ? this.newOperationalRemarks : null as any;
        data["oldCustomerMaterialNumber"] = this.oldCustomerMaterialNumber !== undefined ? this.oldCustomerMaterialNumber : null as any;
        data["newCustomerMaterialNumber"] = this.newCustomerMaterialNumber !== undefined ? this.newCustomerMaterialNumber : null as any;
        data["oldTransferPrice"] = this.oldTransferPrice !== undefined ? this.oldTransferPrice : null as any;
        data["newTransferPrice"] = this.newTransferPrice !== undefined ? this.newTransferPrice : null as any;
        data["oldUnitTransferPrice"] = this.oldUnitTransferPrice !== undefined ? this.oldUnitTransferPrice : null as any;
        data["newUnitTransferPrice"] = this.newUnitTransferPrice !== undefined ? this.newUnitTransferPrice : null as any;
        data["oldUnitPrice"] = this.oldUnitPrice !== undefined ? this.oldUnitPrice : null as any;
        data["newUnitPrice"] = this.newUnitPrice !== undefined ? this.newUnitPrice : null as any;
        data["oldCustomerExpectedDeliveryDate"] = this.oldCustomerExpectedDeliveryDate ? this.oldCustomerExpectedDeliveryDate.toISOString() : null as any;
        data["newCustomerExpectedDelivery"] = this.newCustomerExpectedDelivery !== undefined ? this.newCustomerExpectedDelivery : null as any;
        data["plannedBomUpdateDuration"] = this.plannedBomUpdateDuration !== undefined ? this.plannedBomUpdateDuration : null as any;
        data["enterUnitPrice"] = this.enterUnitPrice !== undefined ? this.enterUnitPrice : null as any;
        data["numberOfProduct"] = this.numberOfProduct !== undefined ? this.numberOfProduct : null as any;
        return data;
    }
}

export class OrderChangeTaskAuditLogsDto {
    taskId!: string | null;
    taskServiceRequestId!: string | null;
    taskName!: string | null;
    operatorEmail!: string | null;
    operatorName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : null as any;
            this.taskServiceRequestId = _data["taskServiceRequestId"] !== undefined ? _data["taskServiceRequestId"] : null as any;
            this.taskName = _data["taskName"] !== undefined ? _data["taskName"] : null as any;
            this.operatorEmail = _data["operatorEmail"] !== undefined ? _data["operatorEmail"] : null as any;
            this.operatorName = _data["operatorName"] !== undefined ? _data["operatorName"] : null as any;
        }
    }

    static fromJS(data: any): OrderChangeTaskAuditLogsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeTaskAuditLogsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId !== undefined ? this.taskId : null as any;
        data["taskServiceRequestId"] = this.taskServiceRequestId !== undefined ? this.taskServiceRequestId : null as any;
        data["taskName"] = this.taskName !== undefined ? this.taskName : null as any;
        data["operatorEmail"] = this.operatorEmail !== undefined ? this.operatorEmail : null as any;
        data["operatorName"] = this.operatorName !== undefined ? this.operatorName : null as any;
        return data;
    }
}

export class OrderForm {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    projectName!: string | null;
    projectNo!: string | null;
    modelSelectionId!: string | null;
    modelSelectionName!: string | null;
    specialOfferApplicationNumber!: string | null;
    isManual!: boolean;
    totalNumber!: string | null;
    totalPrice!: number | null;
    customerOrderNumber!: string | null;
    orderCancelTime!: moment.Moment | null;
    orderTime!: moment.Moment | null;
    orderCompleteTime!: moment.Moment | null;
    expectedDeliveryDate!: string | null;
    customerExpectedDeliveryDate!: moment.Moment | null;
    poNumber!: string | null;
    orderStatus!: OrderStatus;
    orderType!: OrderType;
    orderSource!: string | null;
    sourceType!: string | null;
    cpCode!: string | null;
    cpCoName!: string | null;
    endCustomerCode!: string | null;
    endCustomerName!: string | null;
    shippingAddressCode!: string | null;
    shippingAddress!: string | null;
    responsibleSalesCode!: string | null;
    responsibleSalesName!: string | null;
    attachmentName!: string | null;
    omsOrderNumber!: string | null;
    dataPlatFormOrderType!: DataPlatFormOrderType;
    dataPlatFormOrderTypeId!: string | null;
    industry!: Industry;
    industryId!: string | null;
    application!: Application;
    applicationId!: string | null;
    channel!: Channel;
    channelId!: string | null;
    salesArea!: SalesArea;
    salesAreaId!: string | null;
    smconfjson!: string | null;
    deliveryTerms!: string | null;
    isPoNumber!: boolean;
    productBasicMotors!: ProductBasicMotor[] | null;
    oisApprovals!: OISApproval[] | null;
    forLibOrderFlg!: boolean | null;
    forbidModityFinalCustomer!: boolean | null;
    finalCustomer!: string | null;
    curTaxRate!: number | null;
    totalPriceWithoutTax!: number | null;
    totalTaxPrice!: number | null;
    finalCustomerCode!: string | null;
    specifyApproval!: boolean;
    specifyApprovalChecked!: boolean;
    locationCountry!: string | null;
    recordNumber!: string | null;
    approvalStatus!: ApprovalStatusEnum;
    salesPriceDecimal!: boolean;
    currencyId!: string | null;
    exportManualOrder!: boolean;
    orderFormAutomate!: OrderAutomate;
    orderFormAutomateLogs!: OrderAutomateLog[] | null;
    openItem!: string | null;
    openItemRemark!: string | null;
    autoApproveTaskStatus!: string | null;
    attachmentBankReceipt!: string | null;
    doubleBookingId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.projectNo = _data["projectNo"] !== undefined ? _data["projectNo"] : null as any;
            this.modelSelectionId = _data["modelSelectionId"] !== undefined ? _data["modelSelectionId"] : null as any;
            this.modelSelectionName = _data["modelSelectionName"] !== undefined ? _data["modelSelectionName"] : null as any;
            this.specialOfferApplicationNumber = _data["specialOfferApplicationNumber"] !== undefined ? _data["specialOfferApplicationNumber"] : null as any;
            this.isManual = _data["isManual"] !== undefined ? _data["isManual"] : null as any;
            this.totalNumber = _data["totalNumber"] !== undefined ? _data["totalNumber"] : null as any;
            this.totalPrice = _data["totalPrice"] !== undefined ? _data["totalPrice"] : null as any;
            this.customerOrderNumber = _data["customerOrderNumber"] !== undefined ? _data["customerOrderNumber"] : null as any;
            this.orderCancelTime = _data["orderCancelTime"] ? moment(_data["orderCancelTime"].toString()) : null as any;
            this.orderTime = _data["orderTime"] ? moment(_data["orderTime"].toString()) : null as any;
            this.orderCompleteTime = _data["orderCompleteTime"] ? moment(_data["orderCompleteTime"].toString()) : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.customerExpectedDeliveryDate = _data["customerExpectedDeliveryDate"] ? moment(_data["customerExpectedDeliveryDate"].toString()) : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.orderSource = _data["orderSource"] !== undefined ? _data["orderSource"] : null as any;
            this.sourceType = _data["sourceType"] !== undefined ? _data["sourceType"] : null as any;
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.cpCoName = _data["cpCoName"] !== undefined ? _data["cpCoName"] : null as any;
            this.endCustomerCode = _data["endCustomerCode"] !== undefined ? _data["endCustomerCode"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.shippingAddressCode = _data["shippingAddressCode"] !== undefined ? _data["shippingAddressCode"] : null as any;
            this.shippingAddress = _data["shippingAddress"] !== undefined ? _data["shippingAddress"] : null as any;
            this.responsibleSalesCode = _data["responsibleSalesCode"] !== undefined ? _data["responsibleSalesCode"] : null as any;
            this.responsibleSalesName = _data["responsibleSalesName"] !== undefined ? _data["responsibleSalesName"] : null as any;
            this.attachmentName = _data["attachmentName"] !== undefined ? _data["attachmentName"] : null as any;
            this.omsOrderNumber = _data["omsOrderNumber"] !== undefined ? _data["omsOrderNumber"] : null as any;
            this.dataPlatFormOrderType = _data["dataPlatFormOrderType"] ? DataPlatFormOrderType.fromJS(_data["dataPlatFormOrderType"]) : null as any;
            this.dataPlatFormOrderTypeId = _data["dataPlatFormOrderTypeId"] !== undefined ? _data["dataPlatFormOrderTypeId"] : null as any;
            this.industry = _data["industry"] ? Industry.fromJS(_data["industry"]) : null as any;
            this.industryId = _data["industryId"] !== undefined ? _data["industryId"] : null as any;
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : null as any;
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.channel = _data["channel"] ? Channel.fromJS(_data["channel"]) : null as any;
            this.channelId = _data["channelId"] !== undefined ? _data["channelId"] : null as any;
            this.salesArea = _data["salesArea"] ? SalesArea.fromJS(_data["salesArea"]) : null as any;
            this.salesAreaId = _data["salesAreaId"] !== undefined ? _data["salesAreaId"] : null as any;
            this.smconfjson = _data["smconfjson"] !== undefined ? _data["smconfjson"] : null as any;
            this.deliveryTerms = _data["deliveryTerms"] !== undefined ? _data["deliveryTerms"] : null as any;
            this.isPoNumber = _data["isPoNumber"] !== undefined ? _data["isPoNumber"] : null as any;
            if (Array.isArray(_data["productBasicMotors"])) {
                this.productBasicMotors = [] as any;
                for (let item of _data["productBasicMotors"])
                    this.productBasicMotors!.push(ProductBasicMotor.fromJS(item));
            }
            else {
                this.productBasicMotors = null as any;
            }
            if (Array.isArray(_data["oisApprovals"])) {
                this.oisApprovals = [] as any;
                for (let item of _data["oisApprovals"])
                    this.oisApprovals!.push(OISApproval.fromJS(item));
            }
            else {
                this.oisApprovals = null as any;
            }
            this.forLibOrderFlg = _data["forLibOrderFlg"] !== undefined ? _data["forLibOrderFlg"] : null as any;
            this.forbidModityFinalCustomer = _data["forbidModityFinalCustomer"] !== undefined ? _data["forbidModityFinalCustomer"] : null as any;
            this.finalCustomer = _data["finalCustomer"] !== undefined ? _data["finalCustomer"] : null as any;
            this.curTaxRate = _data["curTaxRate"] !== undefined ? _data["curTaxRate"] : null as any;
            this.totalPriceWithoutTax = _data["totalPriceWithoutTax"] !== undefined ? _data["totalPriceWithoutTax"] : null as any;
            this.totalTaxPrice = _data["totalTaxPrice"] !== undefined ? _data["totalTaxPrice"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.specifyApproval = _data["specifyApproval"] !== undefined ? _data["specifyApproval"] : null as any;
            this.specifyApprovalChecked = _data["specifyApprovalChecked"] !== undefined ? _data["specifyApprovalChecked"] : null as any;
            this.locationCountry = _data["locationCountry"] !== undefined ? _data["locationCountry"] : null as any;
            this.recordNumber = _data["recordNumber"] !== undefined ? _data["recordNumber"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
            this.salesPriceDecimal = _data["salesPriceDecimal"] !== undefined ? _data["salesPriceDecimal"] : null as any;
            this.currencyId = _data["currencyId"] !== undefined ? _data["currencyId"] : null as any;
            this.exportManualOrder = _data["exportManualOrder"] !== undefined ? _data["exportManualOrder"] : null as any;
            this.orderFormAutomate = _data["orderFormAutomate"] ? OrderAutomate.fromJS(_data["orderFormAutomate"]) : null as any;
            if (Array.isArray(_data["orderFormAutomateLogs"])) {
                this.orderFormAutomateLogs = [] as any;
                for (let item of _data["orderFormAutomateLogs"])
                    this.orderFormAutomateLogs!.push(OrderAutomateLog.fromJS(item));
            }
            else {
                this.orderFormAutomateLogs = null as any;
            }
            this.openItem = _data["openItem"] !== undefined ? _data["openItem"] : null as any;
            this.openItemRemark = _data["openItemRemark"] !== undefined ? _data["openItemRemark"] : null as any;
            this.autoApproveTaskStatus = _data["autoApproveTaskStatus"] !== undefined ? _data["autoApproveTaskStatus"] : null as any;
            this.attachmentBankReceipt = _data["attachmentBankReceipt"] !== undefined ? _data["attachmentBankReceipt"] : null as any;
            this.doubleBookingId = _data["doubleBookingId"] !== undefined ? _data["doubleBookingId"] : null as any;
        }
    }

    static fromJS(data: any): OrderForm {
        data = typeof data === 'object' ? data : {};
        let result = new OrderForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["projectNo"] = this.projectNo !== undefined ? this.projectNo : null as any;
        data["modelSelectionId"] = this.modelSelectionId !== undefined ? this.modelSelectionId : null as any;
        data["modelSelectionName"] = this.modelSelectionName !== undefined ? this.modelSelectionName : null as any;
        data["specialOfferApplicationNumber"] = this.specialOfferApplicationNumber !== undefined ? this.specialOfferApplicationNumber : null as any;
        data["isManual"] = this.isManual !== undefined ? this.isManual : null as any;
        data["totalNumber"] = this.totalNumber !== undefined ? this.totalNumber : null as any;
        data["totalPrice"] = this.totalPrice !== undefined ? this.totalPrice : null as any;
        data["customerOrderNumber"] = this.customerOrderNumber !== undefined ? this.customerOrderNumber : null as any;
        data["orderCancelTime"] = this.orderCancelTime ? this.orderCancelTime.toISOString() : null as any;
        data["orderTime"] = this.orderTime ? this.orderTime.toISOString() : null as any;
        data["orderCompleteTime"] = this.orderCompleteTime ? this.orderCompleteTime.toISOString() : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["customerExpectedDeliveryDate"] = this.customerExpectedDeliveryDate ? this.customerExpectedDeliveryDate.toISOString() : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["orderSource"] = this.orderSource !== undefined ? this.orderSource : null as any;
        data["sourceType"] = this.sourceType !== undefined ? this.sourceType : null as any;
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["cpCoName"] = this.cpCoName !== undefined ? this.cpCoName : null as any;
        data["endCustomerCode"] = this.endCustomerCode !== undefined ? this.endCustomerCode : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["shippingAddressCode"] = this.shippingAddressCode !== undefined ? this.shippingAddressCode : null as any;
        data["shippingAddress"] = this.shippingAddress !== undefined ? this.shippingAddress : null as any;
        data["responsibleSalesCode"] = this.responsibleSalesCode !== undefined ? this.responsibleSalesCode : null as any;
        data["responsibleSalesName"] = this.responsibleSalesName !== undefined ? this.responsibleSalesName : null as any;
        data["attachmentName"] = this.attachmentName !== undefined ? this.attachmentName : null as any;
        data["omsOrderNumber"] = this.omsOrderNumber !== undefined ? this.omsOrderNumber : null as any;
        data["dataPlatFormOrderType"] = this.dataPlatFormOrderType ? this.dataPlatFormOrderType.toJSON() : null as any;
        data["dataPlatFormOrderTypeId"] = this.dataPlatFormOrderTypeId !== undefined ? this.dataPlatFormOrderTypeId : null as any;
        data["industry"] = this.industry ? this.industry.toJSON() : null as any;
        data["industryId"] = this.industryId !== undefined ? this.industryId : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["channel"] = this.channel ? this.channel.toJSON() : null as any;
        data["channelId"] = this.channelId !== undefined ? this.channelId : null as any;
        data["salesArea"] = this.salesArea ? this.salesArea.toJSON() : null as any;
        data["salesAreaId"] = this.salesAreaId !== undefined ? this.salesAreaId : null as any;
        data["smconfjson"] = this.smconfjson !== undefined ? this.smconfjson : null as any;
        data["deliveryTerms"] = this.deliveryTerms !== undefined ? this.deliveryTerms : null as any;
        data["isPoNumber"] = this.isPoNumber !== undefined ? this.isPoNumber : null as any;
        if (Array.isArray(this.productBasicMotors)) {
            data["productBasicMotors"] = [];
            for (let item of this.productBasicMotors)
                data["productBasicMotors"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.oisApprovals)) {
            data["oisApprovals"] = [];
            for (let item of this.oisApprovals)
                data["oisApprovals"].push(item ? item.toJSON() : null as any);
        }
        data["forLibOrderFlg"] = this.forLibOrderFlg !== undefined ? this.forLibOrderFlg : null as any;
        data["forbidModityFinalCustomer"] = this.forbidModityFinalCustomer !== undefined ? this.forbidModityFinalCustomer : null as any;
        data["finalCustomer"] = this.finalCustomer !== undefined ? this.finalCustomer : null as any;
        data["curTaxRate"] = this.curTaxRate !== undefined ? this.curTaxRate : null as any;
        data["totalPriceWithoutTax"] = this.totalPriceWithoutTax !== undefined ? this.totalPriceWithoutTax : null as any;
        data["totalTaxPrice"] = this.totalTaxPrice !== undefined ? this.totalTaxPrice : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["specifyApproval"] = this.specifyApproval !== undefined ? this.specifyApproval : null as any;
        data["specifyApprovalChecked"] = this.specifyApprovalChecked !== undefined ? this.specifyApprovalChecked : null as any;
        data["locationCountry"] = this.locationCountry !== undefined ? this.locationCountry : null as any;
        data["recordNumber"] = this.recordNumber !== undefined ? this.recordNumber : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        data["salesPriceDecimal"] = this.salesPriceDecimal !== undefined ? this.salesPriceDecimal : null as any;
        data["currencyId"] = this.currencyId !== undefined ? this.currencyId : null as any;
        data["exportManualOrder"] = this.exportManualOrder !== undefined ? this.exportManualOrder : null as any;
        data["orderFormAutomate"] = this.orderFormAutomate ? this.orderFormAutomate.toJSON() : null as any;
        if (Array.isArray(this.orderFormAutomateLogs)) {
            data["orderFormAutomateLogs"] = [];
            for (let item of this.orderFormAutomateLogs)
                data["orderFormAutomateLogs"].push(item ? item.toJSON() : null as any);
        }
        data["openItem"] = this.openItem !== undefined ? this.openItem : null as any;
        data["openItemRemark"] = this.openItemRemark !== undefined ? this.openItemRemark : null as any;
        data["autoApproveTaskStatus"] = this.autoApproveTaskStatus !== undefined ? this.autoApproveTaskStatus : null as any;
        data["attachmentBankReceipt"] = this.attachmentBankReceipt !== undefined ? this.attachmentBankReceipt : null as any;
        data["doubleBookingId"] = this.doubleBookingId !== undefined ? this.doubleBookingId : null as any;
        return data;
    }
}

/** 订单自动化操作记录 */
export class OrderFormAutomateLogDto {
    poNumber!: string | null;
    status!: AutomateStatusEnum;
    readonly statusName!: string | null;
    /** 描述 */
    description!: string | null;
    /** 操作人 */
    operator!: string | null;
    /** 操作时间 */
    operateTime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            (this as any).statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.operator = _data["operator"] !== undefined ? _data["operator"] : null as any;
            this.operateTime = _data["operateTime"] ? moment(_data["operateTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): OrderFormAutomateLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFormAutomateLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["operator"] = this.operator !== undefined ? this.operator : null as any;
        data["operateTime"] = this.operateTime ? this.operateTime.toISOString() : null as any;
        return data;
    }
}

export class OrderFormDto {
    id!: string;
    /** 特价申请号 */
    specialOfferApplicationNumber!: string | null;
    /** 系数 */
    coefficient!: string | null;
    /** 系数类型 */
    coefficientType!: string | null;
    /** 总价 */
    totalPrice!: string | null;
    /** 客户订单号 */
    customerOrderNumber!: string | null;
    /** 备注二 */
    remarkTwo!: string | null;
    /** 下单时间 */
    orderTime!: moment.Moment;
    /** 预计交货日期 */
    expectedDeliveryDate!: string | null;
    /** PO号 */
    poNumber!: string | null;
    orderStatus!: OrderStatus;
    orderType!: OrderType;
    /** CP编码 */
    cpCode!: string | null;
    /** CP名称 */
    cpCoName!: string | null;
    /** 最终客户编码 */
    endCustomerCode!: string | null;
    /** 最终客户名称 */
    endCustomerName!: string | null;
    /** 发货地址编码 */
    shippingAddressCode!: string | null;
    /** 发货地址 */
    shippingAddress!: string | null;
    /** 责任销售编码 */
    responsibleSalesCode!: string | null;
    /** 责任销售名称 */
    responsibleSalesName!: string | null;
    industry!: Industry;
    application!: Application;
    /** 产品裸机 */
    productBasicMotors!: ProductBasicMotor[] | null;
    /** 是否为备库订单 */
    forLibOrderFlg!: boolean | null;
    /** 最终客户名称 */
    finalCustomer!: string | null;
    /** 最终客户代号 */
    finalCustomerCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.specialOfferApplicationNumber = _data["specialOfferApplicationNumber"] !== undefined ? _data["specialOfferApplicationNumber"] : null as any;
            this.coefficient = _data["coefficient"] !== undefined ? _data["coefficient"] : null as any;
            this.coefficientType = _data["coefficientType"] !== undefined ? _data["coefficientType"] : null as any;
            this.totalPrice = _data["totalPrice"] !== undefined ? _data["totalPrice"] : null as any;
            this.customerOrderNumber = _data["customerOrderNumber"] !== undefined ? _data["customerOrderNumber"] : null as any;
            this.remarkTwo = _data["remarkTwo"] !== undefined ? _data["remarkTwo"] : null as any;
            this.orderTime = _data["orderTime"] ? moment(_data["orderTime"].toString()) : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.cpCoName = _data["cpCoName"] !== undefined ? _data["cpCoName"] : null as any;
            this.endCustomerCode = _data["endCustomerCode"] !== undefined ? _data["endCustomerCode"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.shippingAddressCode = _data["shippingAddressCode"] !== undefined ? _data["shippingAddressCode"] : null as any;
            this.shippingAddress = _data["shippingAddress"] !== undefined ? _data["shippingAddress"] : null as any;
            this.responsibleSalesCode = _data["responsibleSalesCode"] !== undefined ? _data["responsibleSalesCode"] : null as any;
            this.responsibleSalesName = _data["responsibleSalesName"] !== undefined ? _data["responsibleSalesName"] : null as any;
            this.industry = _data["industry"] ? Industry.fromJS(_data["industry"]) : null as any;
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : null as any;
            if (Array.isArray(_data["productBasicMotors"])) {
                this.productBasicMotors = [] as any;
                for (let item of _data["productBasicMotors"])
                    this.productBasicMotors!.push(ProductBasicMotor.fromJS(item));
            }
            else {
                this.productBasicMotors = null as any;
            }
            this.forLibOrderFlg = _data["forLibOrderFlg"] !== undefined ? _data["forLibOrderFlg"] : null as any;
            this.finalCustomer = _data["finalCustomer"] !== undefined ? _data["finalCustomer"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
        }
    }

    static fromJS(data: any): OrderFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["specialOfferApplicationNumber"] = this.specialOfferApplicationNumber !== undefined ? this.specialOfferApplicationNumber : null as any;
        data["coefficient"] = this.coefficient !== undefined ? this.coefficient : null as any;
        data["coefficientType"] = this.coefficientType !== undefined ? this.coefficientType : null as any;
        data["totalPrice"] = this.totalPrice !== undefined ? this.totalPrice : null as any;
        data["customerOrderNumber"] = this.customerOrderNumber !== undefined ? this.customerOrderNumber : null as any;
        data["remarkTwo"] = this.remarkTwo !== undefined ? this.remarkTwo : null as any;
        data["orderTime"] = this.orderTime ? this.orderTime.toISOString() : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["cpCoName"] = this.cpCoName !== undefined ? this.cpCoName : null as any;
        data["endCustomerCode"] = this.endCustomerCode !== undefined ? this.endCustomerCode : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["shippingAddressCode"] = this.shippingAddressCode !== undefined ? this.shippingAddressCode : null as any;
        data["shippingAddress"] = this.shippingAddress !== undefined ? this.shippingAddress : null as any;
        data["responsibleSalesCode"] = this.responsibleSalesCode !== undefined ? this.responsibleSalesCode : null as any;
        data["responsibleSalesName"] = this.responsibleSalesName !== undefined ? this.responsibleSalesName : null as any;
        data["industry"] = this.industry ? this.industry.toJSON() : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        if (Array.isArray(this.productBasicMotors)) {
            data["productBasicMotors"] = [];
            for (let item of this.productBasicMotors)
                data["productBasicMotors"].push(item ? item.toJSON() : null as any);
        }
        data["forLibOrderFlg"] = this.forLibOrderFlg !== undefined ? this.forLibOrderFlg : null as any;
        data["finalCustomer"] = this.finalCustomer !== undefined ? this.finalCustomer : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        return data;
    }
}

export class OrderFormDtoPagedResultDto {
    items!: OrderFormDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderFormDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): OrderFormDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFormDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class OrderFormFinalCustomer {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    userId!: number | null;
    userName!: string | null;
    userEmail!: string | null;
    customerNo!: string | null;
    customerName!: string | null;
    industryCode!: string | null;
    industryName!: string | null;
    finalCustomerName!: string | null;
    finalCustomerCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.userEmail = _data["userEmail"] !== undefined ? _data["userEmail"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.industryCode = _data["industryCode"] !== undefined ? _data["industryCode"] : null as any;
            this.industryName = _data["industryName"] !== undefined ? _data["industryName"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
        }
    }

    static fromJS(data: any): OrderFormFinalCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFormFinalCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["userEmail"] = this.userEmail !== undefined ? this.userEmail : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["industryCode"] = this.industryCode !== undefined ? this.industryCode : null as any;
        data["industryName"] = this.industryName !== undefined ? this.industryName : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        return data;
    }
}

export class OrderFormFinalCustomerDto {
    id!: string | null;
    /** CP编号 */
    customerNo!: string | null;
    /** CP名称 */
    customerName!: string | null;
    /** 用户Id */
    userId!: number | null;
    /** 用户名 */
    userName!: string | null;
    /** 用户邮箱 */
    userEmail!: string | null;
    /** 行业编码 */
    industryCode!: string | null;
    /** 行业名称 */
    industryName!: string | null;
    /** 最终客户名称 */
    finalCustomerName!: string;
    /** 最终客户代号 */
    finalCustomerCode!: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.userEmail = _data["userEmail"] !== undefined ? _data["userEmail"] : null as any;
            this.industryCode = _data["industryCode"] !== undefined ? _data["industryCode"] : null as any;
            this.industryName = _data["industryName"] !== undefined ? _data["industryName"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
        }
    }

    static fromJS(data: any): OrderFormFinalCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFormFinalCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["userEmail"] = this.userEmail !== undefined ? this.userEmail : null as any;
        data["industryCode"] = this.industryCode !== undefined ? this.industryCode : null as any;
        data["industryName"] = this.industryName !== undefined ? this.industryName : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        return data;
    }
}

export class OrderFormFinalCustomerDtoPagedResultDto {
    items!: OrderFormFinalCustomerDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderFormFinalCustomerDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): OrderFormFinalCustomerDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFormFinalCustomerDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class OrderFormFinalCustomerListBoxDto {
    /** 客户名称 */
    cusNo!: string | null;
    /** 客户名称 */
    cusAdrName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.cusNo = _data["cusNo"] !== undefined ? _data["cusNo"] : null as any;
            this.cusAdrName = _data["cusAdrName"] !== undefined ? _data["cusAdrName"] : null as any;
        }
    }

    static fromJS(data: any): OrderFormFinalCustomerListBoxDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFormFinalCustomerListBoxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cusNo"] = this.cusNo !== undefined ? this.cusNo : null as any;
        data["cusAdrName"] = this.cusAdrName !== undefined ? this.cusAdrName : null as any;
        return data;
    }
}

export class OrderHandlingRelationDto {
    id!: string;
    region!: string | null;
    readonly customerCode!: string | null;
    customerName!: string | null;
    /** 商务用户Id */
    orderHandlingId!: number | null;
    orderHandlingEmailName!: string | null;
    /** OHId */
    orderHandlingApproverId!: number | null;
    orderHandlingApproverEmailName!: string | null;
    isOHManager!: boolean | null;
    businessCustomerRelationBackUps!: BusinessCustomerRelationBackUpEntity[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.region = _data["region"] !== undefined ? _data["region"] : null as any;
            (this as any).customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.orderHandlingId = _data["orderHandlingId"] !== undefined ? _data["orderHandlingId"] : null as any;
            this.orderHandlingEmailName = _data["orderHandlingEmailName"] !== undefined ? _data["orderHandlingEmailName"] : null as any;
            this.orderHandlingApproverId = _data["orderHandlingApproverId"] !== undefined ? _data["orderHandlingApproverId"] : null as any;
            this.orderHandlingApproverEmailName = _data["orderHandlingApproverEmailName"] !== undefined ? _data["orderHandlingApproverEmailName"] : null as any;
            this.isOHManager = _data["isOHManager"] !== undefined ? _data["isOHManager"] : null as any;
            if (Array.isArray(_data["businessCustomerRelationBackUps"])) {
                this.businessCustomerRelationBackUps = [] as any;
                for (let item of _data["businessCustomerRelationBackUps"])
                    this.businessCustomerRelationBackUps!.push(BusinessCustomerRelationBackUpEntity.fromJS(item));
            }
            else {
                this.businessCustomerRelationBackUps = null as any;
            }
        }
    }

    static fromJS(data: any): OrderHandlingRelationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHandlingRelationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["region"] = this.region !== undefined ? this.region : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["orderHandlingId"] = this.orderHandlingId !== undefined ? this.orderHandlingId : null as any;
        data["orderHandlingEmailName"] = this.orderHandlingEmailName !== undefined ? this.orderHandlingEmailName : null as any;
        data["orderHandlingApproverId"] = this.orderHandlingApproverId !== undefined ? this.orderHandlingApproverId : null as any;
        data["orderHandlingApproverEmailName"] = this.orderHandlingApproverEmailName !== undefined ? this.orderHandlingApproverEmailName : null as any;
        data["isOHManager"] = this.isOHManager !== undefined ? this.isOHManager : null as any;
        if (Array.isArray(this.businessCustomerRelationBackUps)) {
            data["businessCustomerRelationBackUps"] = [];
            for (let item of this.businessCustomerRelationBackUps)
                data["businessCustomerRelationBackUps"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 订单信息DTO（用于费用车） */
export class OrderInfoForFeeCartDto {
    customerCode!: string | null;
    customerName!: string | null;
    csoNumber!: string | null;

    init(_data?: any) {
        if (_data) {
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.csoNumber = _data["csoNumber"] !== undefined ? _data["csoNumber"] : null as any;
        }
    }

    static fromJS(data: any): OrderInfoForFeeCartDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderInfoForFeeCartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["csoNumber"] = this.csoNumber !== undefined ? this.csoNumber : null as any;
        return data;
    }
}

export class OrderInformations {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    soldToParty!: string | null;
    customerName!: string | null;
    lsuOrderType!: string | null;
    lsuSalesOrg!: string | null;
    lsuSalesOrder!: string | null;
    lsuItem!: string | null;
    pmuOrderType!: string | null;
    pmuSalesOrg!: string | null;
    pmuSalesOrder!: string | null;
    pmuSalesOrderItem!: string | null;
    pmuSoitemCategory!: string | null;
    soItemCategoryText!: string | null;
    material!: string | null;
    materialDescriptionEn!: string | null;
    materialDescriptionCh!: string | null;
    lsuOrderQty!: number;
    lsuSalesEngineerName!: string | null;
    pmuStock!: number;
    purchaseOrderDate!: moment.Moment | null;
    lastGoodsReceiptDate!: moment.Moment | null;
    pmuDnQty!: number;
    lsuContractNumber!: string | null;
    lsuUnitPrice!: number;
    requestDeliveryDate!: moment.Moment | null;
    lsuBillingAmountWithoutTax!: number;
    unitPriceWithTax!: number;
    customerPo!: string | null;
    projectName!: string | null;
    customerProdNo!: string | null;
    materialGroup!: string | null;
    saleOrg!: SaleOrgStatus;
    productGroup!: string | null;
    salesOffice!: string | null;
    remark!: string | null;
    lsuSoCurr!: string | null;
    lsuItemValueWithTax!: number;
    lsuItemValue!: number;
    lsugiQtyTotal!: number;
    endCustomerName!: string | null;
    projectNameDes!: string | null;
    availableStock!: number;
    rejectionCodeForCSO!: string | null;
    rejectionDescriptionForCSO!: string | null;
    rejectionCodeForISO!: string | null;
    rejectionDescriptionForISO!: string | null;
    billingDate!: moment.Moment | null;
    billingQty!: number | null;
    lsuPOABDate!: moment.Moment | null;
    productType!: string | null;
    orderClassify!: string | null;
    sendingFlag!: string | null;
    omsOrderNumber!: string | null;
    omsOrderItem!: string | null;
    jinCategoryCode!: string | null;
    jinVersion!: string | null;
    orderBusinessType!: OrderBusinessType;
    productBasicMotorId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.soldToParty = _data["soldToParty"] !== undefined ? _data["soldToParty"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.lsuOrderType = _data["lsuOrderType"] !== undefined ? _data["lsuOrderType"] : null as any;
            this.lsuSalesOrg = _data["lsuSalesOrg"] !== undefined ? _data["lsuSalesOrg"] : null as any;
            this.lsuSalesOrder = _data["lsuSalesOrder"] !== undefined ? _data["lsuSalesOrder"] : null as any;
            this.lsuItem = _data["lsuItem"] !== undefined ? _data["lsuItem"] : null as any;
            this.pmuOrderType = _data["pmuOrderType"] !== undefined ? _data["pmuOrderType"] : null as any;
            this.pmuSalesOrg = _data["pmuSalesOrg"] !== undefined ? _data["pmuSalesOrg"] : null as any;
            this.pmuSalesOrder = _data["pmuSalesOrder"] !== undefined ? _data["pmuSalesOrder"] : null as any;
            this.pmuSalesOrderItem = _data["pmuSalesOrderItem"] !== undefined ? _data["pmuSalesOrderItem"] : null as any;
            this.pmuSoitemCategory = _data["pmuSoitemCategory"] !== undefined ? _data["pmuSoitemCategory"] : null as any;
            this.soItemCategoryText = _data["soItemCategoryText"] !== undefined ? _data["soItemCategoryText"] : null as any;
            this.material = _data["material"] !== undefined ? _data["material"] : null as any;
            this.materialDescriptionEn = _data["materialDescriptionEn"] !== undefined ? _data["materialDescriptionEn"] : null as any;
            this.materialDescriptionCh = _data["materialDescriptionCh"] !== undefined ? _data["materialDescriptionCh"] : null as any;
            this.lsuOrderQty = _data["lsuOrderQty"] !== undefined ? _data["lsuOrderQty"] : null as any;
            this.lsuSalesEngineerName = _data["lsuSalesEngineerName"] !== undefined ? _data["lsuSalesEngineerName"] : null as any;
            this.pmuStock = _data["pmuStock"] !== undefined ? _data["pmuStock"] : null as any;
            this.purchaseOrderDate = _data["purchaseOrderDate"] ? moment(_data["purchaseOrderDate"].toString()) : null as any;
            this.lastGoodsReceiptDate = _data["lastGoodsReceiptDate"] ? moment(_data["lastGoodsReceiptDate"].toString()) : null as any;
            this.pmuDnQty = _data["pmuDnQty"] !== undefined ? _data["pmuDnQty"] : null as any;
            this.lsuContractNumber = _data["lsuContractNumber"] !== undefined ? _data["lsuContractNumber"] : null as any;
            this.lsuUnitPrice = _data["lsuUnitPrice"] !== undefined ? _data["lsuUnitPrice"] : null as any;
            this.requestDeliveryDate = _data["requestDeliveryDate"] ? moment(_data["requestDeliveryDate"].toString()) : null as any;
            this.lsuBillingAmountWithoutTax = _data["lsuBillingAmountWithoutTax"] !== undefined ? _data["lsuBillingAmountWithoutTax"] : null as any;
            this.unitPriceWithTax = _data["unitPriceWithTax"] !== undefined ? _data["unitPriceWithTax"] : null as any;
            this.customerPo = _data["customerPo"] !== undefined ? _data["customerPo"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.customerProdNo = _data["customerProdNo"] !== undefined ? _data["customerProdNo"] : null as any;
            this.materialGroup = _data["materialGroup"] !== undefined ? _data["materialGroup"] : null as any;
            this.saleOrg = _data["saleOrg"] !== undefined ? _data["saleOrg"] : null as any;
            this.productGroup = _data["productGroup"] !== undefined ? _data["productGroup"] : null as any;
            this.salesOffice = _data["salesOffice"] !== undefined ? _data["salesOffice"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.lsuSoCurr = _data["lsuSoCurr"] !== undefined ? _data["lsuSoCurr"] : null as any;
            this.lsuItemValueWithTax = _data["lsuItemValueWithTax"] !== undefined ? _data["lsuItemValueWithTax"] : null as any;
            this.lsuItemValue = _data["lsuItemValue"] !== undefined ? _data["lsuItemValue"] : null as any;
            this.lsugiQtyTotal = _data["lsugiQtyTotal"] !== undefined ? _data["lsugiQtyTotal"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.projectNameDes = _data["projectNameDes"] !== undefined ? _data["projectNameDes"] : null as any;
            this.availableStock = _data["availableStock"] !== undefined ? _data["availableStock"] : null as any;
            this.rejectionCodeForCSO = _data["rejectionCodeForCSO"] !== undefined ? _data["rejectionCodeForCSO"] : null as any;
            this.rejectionDescriptionForCSO = _data["rejectionDescriptionForCSO"] !== undefined ? _data["rejectionDescriptionForCSO"] : null as any;
            this.rejectionCodeForISO = _data["rejectionCodeForISO"] !== undefined ? _data["rejectionCodeForISO"] : null as any;
            this.rejectionDescriptionForISO = _data["rejectionDescriptionForISO"] !== undefined ? _data["rejectionDescriptionForISO"] : null as any;
            this.billingDate = _data["billingDate"] ? moment(_data["billingDate"].toString()) : null as any;
            this.billingQty = _data["billingQty"] !== undefined ? _data["billingQty"] : null as any;
            this.lsuPOABDate = _data["lsuPOABDate"] ? moment(_data["lsuPOABDate"].toString()) : null as any;
            this.productType = _data["productType"] !== undefined ? _data["productType"] : null as any;
            this.orderClassify = _data["orderClassify"] !== undefined ? _data["orderClassify"] : null as any;
            this.sendingFlag = _data["sendingFlag"] !== undefined ? _data["sendingFlag"] : null as any;
            this.omsOrderNumber = _data["omsOrderNumber"] !== undefined ? _data["omsOrderNumber"] : null as any;
            this.omsOrderItem = _data["omsOrderItem"] !== undefined ? _data["omsOrderItem"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.orderBusinessType = _data["orderBusinessType"] !== undefined ? _data["orderBusinessType"] : null as any;
            this.productBasicMotorId = _data["productBasicMotorId"] !== undefined ? _data["productBasicMotorId"] : null as any;
        }
    }

    static fromJS(data: any): OrderInformations {
        data = typeof data === 'object' ? data : {};
        let result = new OrderInformations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["soldToParty"] = this.soldToParty !== undefined ? this.soldToParty : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["lsuOrderType"] = this.lsuOrderType !== undefined ? this.lsuOrderType : null as any;
        data["lsuSalesOrg"] = this.lsuSalesOrg !== undefined ? this.lsuSalesOrg : null as any;
        data["lsuSalesOrder"] = this.lsuSalesOrder !== undefined ? this.lsuSalesOrder : null as any;
        data["lsuItem"] = this.lsuItem !== undefined ? this.lsuItem : null as any;
        data["pmuOrderType"] = this.pmuOrderType !== undefined ? this.pmuOrderType : null as any;
        data["pmuSalesOrg"] = this.pmuSalesOrg !== undefined ? this.pmuSalesOrg : null as any;
        data["pmuSalesOrder"] = this.pmuSalesOrder !== undefined ? this.pmuSalesOrder : null as any;
        data["pmuSalesOrderItem"] = this.pmuSalesOrderItem !== undefined ? this.pmuSalesOrderItem : null as any;
        data["pmuSoitemCategory"] = this.pmuSoitemCategory !== undefined ? this.pmuSoitemCategory : null as any;
        data["soItemCategoryText"] = this.soItemCategoryText !== undefined ? this.soItemCategoryText : null as any;
        data["material"] = this.material !== undefined ? this.material : null as any;
        data["materialDescriptionEn"] = this.materialDescriptionEn !== undefined ? this.materialDescriptionEn : null as any;
        data["materialDescriptionCh"] = this.materialDescriptionCh !== undefined ? this.materialDescriptionCh : null as any;
        data["lsuOrderQty"] = this.lsuOrderQty !== undefined ? this.lsuOrderQty : null as any;
        data["lsuSalesEngineerName"] = this.lsuSalesEngineerName !== undefined ? this.lsuSalesEngineerName : null as any;
        data["pmuStock"] = this.pmuStock !== undefined ? this.pmuStock : null as any;
        data["purchaseOrderDate"] = this.purchaseOrderDate ? this.purchaseOrderDate.toISOString() : null as any;
        data["lastGoodsReceiptDate"] = this.lastGoodsReceiptDate ? this.lastGoodsReceiptDate.toISOString() : null as any;
        data["pmuDnQty"] = this.pmuDnQty !== undefined ? this.pmuDnQty : null as any;
        data["lsuContractNumber"] = this.lsuContractNumber !== undefined ? this.lsuContractNumber : null as any;
        data["lsuUnitPrice"] = this.lsuUnitPrice !== undefined ? this.lsuUnitPrice : null as any;
        data["requestDeliveryDate"] = this.requestDeliveryDate ? this.requestDeliveryDate.toISOString() : null as any;
        data["lsuBillingAmountWithoutTax"] = this.lsuBillingAmountWithoutTax !== undefined ? this.lsuBillingAmountWithoutTax : null as any;
        data["unitPriceWithTax"] = this.unitPriceWithTax !== undefined ? this.unitPriceWithTax : null as any;
        data["customerPo"] = this.customerPo !== undefined ? this.customerPo : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["customerProdNo"] = this.customerProdNo !== undefined ? this.customerProdNo : null as any;
        data["materialGroup"] = this.materialGroup !== undefined ? this.materialGroup : null as any;
        data["saleOrg"] = this.saleOrg !== undefined ? this.saleOrg : null as any;
        data["productGroup"] = this.productGroup !== undefined ? this.productGroup : null as any;
        data["salesOffice"] = this.salesOffice !== undefined ? this.salesOffice : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["lsuSoCurr"] = this.lsuSoCurr !== undefined ? this.lsuSoCurr : null as any;
        data["lsuItemValueWithTax"] = this.lsuItemValueWithTax !== undefined ? this.lsuItemValueWithTax : null as any;
        data["lsuItemValue"] = this.lsuItemValue !== undefined ? this.lsuItemValue : null as any;
        data["lsugiQtyTotal"] = this.lsugiQtyTotal !== undefined ? this.lsugiQtyTotal : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["projectNameDes"] = this.projectNameDes !== undefined ? this.projectNameDes : null as any;
        data["availableStock"] = this.availableStock !== undefined ? this.availableStock : null as any;
        data["rejectionCodeForCSO"] = this.rejectionCodeForCSO !== undefined ? this.rejectionCodeForCSO : null as any;
        data["rejectionDescriptionForCSO"] = this.rejectionDescriptionForCSO !== undefined ? this.rejectionDescriptionForCSO : null as any;
        data["rejectionCodeForISO"] = this.rejectionCodeForISO !== undefined ? this.rejectionCodeForISO : null as any;
        data["rejectionDescriptionForISO"] = this.rejectionDescriptionForISO !== undefined ? this.rejectionDescriptionForISO : null as any;
        data["billingDate"] = this.billingDate ? this.billingDate.toISOString() : null as any;
        data["billingQty"] = this.billingQty !== undefined ? this.billingQty : null as any;
        data["lsuPOABDate"] = this.lsuPOABDate ? this.lsuPOABDate.toISOString() : null as any;
        data["productType"] = this.productType !== undefined ? this.productType : null as any;
        data["orderClassify"] = this.orderClassify !== undefined ? this.orderClassify : null as any;
        data["sendingFlag"] = this.sendingFlag !== undefined ? this.sendingFlag : null as any;
        data["omsOrderNumber"] = this.omsOrderNumber !== undefined ? this.omsOrderNumber : null as any;
        data["omsOrderItem"] = this.omsOrderItem !== undefined ? this.omsOrderItem : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["orderBusinessType"] = this.orderBusinessType !== undefined ? this.orderBusinessType : null as any;
        data["productBasicMotorId"] = this.productBasicMotorId !== undefined ? this.productBasicMotorId : null as any;
        return data;
    }
}

export class OrderInformationsToIWorld {
    orderInformations!: OrderInformationsToIWorldOutDto[] | null;
    visualizations!: OrderVisualization[] | null;
    oisExportOrders!: OISExportOrder[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderInformations"])) {
                this.orderInformations = [] as any;
                for (let item of _data["orderInformations"])
                    this.orderInformations!.push(OrderInformationsToIWorldOutDto.fromJS(item));
            }
            else {
                this.orderInformations = null as any;
            }
            if (Array.isArray(_data["visualizations"])) {
                this.visualizations = [] as any;
                for (let item of _data["visualizations"])
                    this.visualizations!.push(OrderVisualization.fromJS(item));
            }
            else {
                this.visualizations = null as any;
            }
            if (Array.isArray(_data["oisExportOrders"])) {
                this.oisExportOrders = [] as any;
                for (let item of _data["oisExportOrders"])
                    this.oisExportOrders!.push(OISExportOrder.fromJS(item));
            }
            else {
                this.oisExportOrders = null as any;
            }
        }
    }

    static fromJS(data: any): OrderInformationsToIWorld {
        data = typeof data === 'object' ? data : {};
        let result = new OrderInformationsToIWorld();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderInformations)) {
            data["orderInformations"] = [];
            for (let item of this.orderInformations)
                data["orderInformations"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.visualizations)) {
            data["visualizations"] = [];
            for (let item of this.visualizations)
                data["visualizations"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.oisExportOrders)) {
            data["oisExportOrders"] = [];
            for (let item of this.oisExportOrders)
                data["oisExportOrders"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** iworld 出参 */
export class OrderInformationsToIWorldOutDto {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    /** 客户编号 */
    soldToParty!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** LSU订单类型 */
    lsuOrderType!: string | null;
    /** LSU销售区域 */
    lsuSalesOrg!: string | null;
    /** LSU订单号 (CSO) */
    lsuSalesOrder!: string | null;
    /** LSU项目号  (CSO Item) */
    lsuItem!: string | null;
    /** PMS订单类型 */
    pmuOrderType!: string | null;
    /** PMU销售区域 */
    pmuSalesOrg!: string | null;
    /** PMU订单号 (ISO) */
    pmuSalesOrder!: string | null;
    /** PMU项目号  (ISO Item) */
    pmuSalesOrderItem!: string | null;
    /** 内部订单项目行 */
    pmuSoitemCategory!: string | null;
    /** 项目类别描述 */
    soItemCategoryText!: string | null;
    /** 物料编码 */
    material!: string | null;
    /** 物料描述 */
    materialDescriptionEn!: string | null;
    /** 物料描述 */
    materialDescriptionCh!: string | null;
    /** LSU订单数量 */
    lsuOrderQty!: number;
    /** 销售雇员名字 */
    lsuSalesEngineerName!: string | null;
    /** 库存数量
由于DNS库存清单页面的逻辑+低压可视化的逻辑，这个字段用于保存实际可用库存
逻辑计算中使用计算后数据 */
    pmuStock!: number;
    /** 计划入库日
计划出库日
20220714 统一改成 计划发货日
逻辑计算中使用计算后数据 */
    purchaseOrderDate!: moment.Moment | null;
    /** 最后一次收货日期 */
    lastGoodsReceiptDate!: moment.Moment | null;
    /** 已发数量 */
    pmuDnQty!: number;
    /** 合同号 */
    lsuContractNumber!: string | null;
    /** 金额（不含税）
净价 */
    lsuUnitPrice!: number;
    /** 客户需求日期 */
    requestDeliveryDate!: moment.Moment | null;
    /** 开票金额 */
    lsuBillingAmountWithoutTax!: number;
    /** 金额（含税）- 最新字段 */
    unitPriceWithTax!: number;
    /** 客户采购订单号 */
    customerPo!: string | null;
    /** Precal号码 */
    projectName!: string | null;
    /** 客户物料代码 */
    customerProdNo!: string | null;
    /** 物料组 */
    materialGroup!: string | null;
    /** 产品组 */
    productGroup!: string | null;
    /** 区域 */
    salesOffice!: string | null;
    /** 备注 */
    remark!: string | null;
    /** 币种 */
    lsuSoCurr!: string | null;
    /** LSU订单行金额（含税） */
    lsuItemValueWithTax!: number;
    /** LSU订单行金额（不含税） */
    lsuItemValue!: number;
    /** LSU已出库数量（总数）
只用来显示，其他无用 */
    lsugiQtyTotal!: number;
    /** 二级客户名称 */
    endCustomerName!: string | null;
    /** 项目名称 */
    projectNameDes!: string | null;
    /** 可发货库存数
等测试之后，直接替换PmuStock，因为PmuStock的逻辑在SAP那边就有问题 */
    availableStock!: number;
    /** 订单取消代码 */
    rejectionCodeForCSO!: string | null;
    /** 订单取消备注 */
    rejectionDescriptionForCSO!: string | null;
    /** 订单取消代码 */
    rejectionCodeForISO!: string | null;
    /** 订单取消备注 */
    rejectionDescriptionForISO!: string | null;
    /** 开票日期 */
    billingDate!: moment.Moment | null;
    /** 开票数量 */
    billingQty!: number | null;
    /** Reconciliation date for agreed cunulative quantity */
    lsuPOABDate!: moment.Moment | null;
    /** 产品类型 */
    productType!: string | null;
    /** 订单类型 */
    orderClassify!: string | null;
    /** 下发类型
M = 手工执行  S = 后台JOB执行 */
    sendingFlag!: string | null;
    /** OMS订单号 */
    omsOrderNumber!: string | null;
    /** OMS订单行号 */
    omsOrderItem!: string | null;
    jinCategoryCode!: string | null;
    jinVersion!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.soldToParty = _data["soldToParty"] !== undefined ? _data["soldToParty"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.lsuOrderType = _data["lsuOrderType"] !== undefined ? _data["lsuOrderType"] : null as any;
            this.lsuSalesOrg = _data["lsuSalesOrg"] !== undefined ? _data["lsuSalesOrg"] : null as any;
            this.lsuSalesOrder = _data["lsuSalesOrder"] !== undefined ? _data["lsuSalesOrder"] : null as any;
            this.lsuItem = _data["lsuItem"] !== undefined ? _data["lsuItem"] : null as any;
            this.pmuOrderType = _data["pmuOrderType"] !== undefined ? _data["pmuOrderType"] : null as any;
            this.pmuSalesOrg = _data["pmuSalesOrg"] !== undefined ? _data["pmuSalesOrg"] : null as any;
            this.pmuSalesOrder = _data["pmuSalesOrder"] !== undefined ? _data["pmuSalesOrder"] : null as any;
            this.pmuSalesOrderItem = _data["pmuSalesOrderItem"] !== undefined ? _data["pmuSalesOrderItem"] : null as any;
            this.pmuSoitemCategory = _data["pmuSoitemCategory"] !== undefined ? _data["pmuSoitemCategory"] : null as any;
            this.soItemCategoryText = _data["soItemCategoryText"] !== undefined ? _data["soItemCategoryText"] : null as any;
            this.material = _data["material"] !== undefined ? _data["material"] : null as any;
            this.materialDescriptionEn = _data["materialDescriptionEn"] !== undefined ? _data["materialDescriptionEn"] : null as any;
            this.materialDescriptionCh = _data["materialDescriptionCh"] !== undefined ? _data["materialDescriptionCh"] : null as any;
            this.lsuOrderQty = _data["lsuOrderQty"] !== undefined ? _data["lsuOrderQty"] : null as any;
            this.lsuSalesEngineerName = _data["lsuSalesEngineerName"] !== undefined ? _data["lsuSalesEngineerName"] : null as any;
            this.pmuStock = _data["pmuStock"] !== undefined ? _data["pmuStock"] : null as any;
            this.purchaseOrderDate = _data["purchaseOrderDate"] ? moment(_data["purchaseOrderDate"].toString()) : null as any;
            this.lastGoodsReceiptDate = _data["lastGoodsReceiptDate"] ? moment(_data["lastGoodsReceiptDate"].toString()) : null as any;
            this.pmuDnQty = _data["pmuDnQty"] !== undefined ? _data["pmuDnQty"] : null as any;
            this.lsuContractNumber = _data["lsuContractNumber"] !== undefined ? _data["lsuContractNumber"] : null as any;
            this.lsuUnitPrice = _data["lsuUnitPrice"] !== undefined ? _data["lsuUnitPrice"] : null as any;
            this.requestDeliveryDate = _data["requestDeliveryDate"] ? moment(_data["requestDeliveryDate"].toString()) : null as any;
            this.lsuBillingAmountWithoutTax = _data["lsuBillingAmountWithoutTax"] !== undefined ? _data["lsuBillingAmountWithoutTax"] : null as any;
            this.unitPriceWithTax = _data["unitPriceWithTax"] !== undefined ? _data["unitPriceWithTax"] : null as any;
            this.customerPo = _data["customerPo"] !== undefined ? _data["customerPo"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.customerProdNo = _data["customerProdNo"] !== undefined ? _data["customerProdNo"] : null as any;
            this.materialGroup = _data["materialGroup"] !== undefined ? _data["materialGroup"] : null as any;
            this.productGroup = _data["productGroup"] !== undefined ? _data["productGroup"] : null as any;
            this.salesOffice = _data["salesOffice"] !== undefined ? _data["salesOffice"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.lsuSoCurr = _data["lsuSoCurr"] !== undefined ? _data["lsuSoCurr"] : null as any;
            this.lsuItemValueWithTax = _data["lsuItemValueWithTax"] !== undefined ? _data["lsuItemValueWithTax"] : null as any;
            this.lsuItemValue = _data["lsuItemValue"] !== undefined ? _data["lsuItemValue"] : null as any;
            this.lsugiQtyTotal = _data["lsugiQtyTotal"] !== undefined ? _data["lsugiQtyTotal"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.projectNameDes = _data["projectNameDes"] !== undefined ? _data["projectNameDes"] : null as any;
            this.availableStock = _data["availableStock"] !== undefined ? _data["availableStock"] : null as any;
            this.rejectionCodeForCSO = _data["rejectionCodeForCSO"] !== undefined ? _data["rejectionCodeForCSO"] : null as any;
            this.rejectionDescriptionForCSO = _data["rejectionDescriptionForCSO"] !== undefined ? _data["rejectionDescriptionForCSO"] : null as any;
            this.rejectionCodeForISO = _data["rejectionCodeForISO"] !== undefined ? _data["rejectionCodeForISO"] : null as any;
            this.rejectionDescriptionForISO = _data["rejectionDescriptionForISO"] !== undefined ? _data["rejectionDescriptionForISO"] : null as any;
            this.billingDate = _data["billingDate"] ? moment(_data["billingDate"].toString()) : null as any;
            this.billingQty = _data["billingQty"] !== undefined ? _data["billingQty"] : null as any;
            this.lsuPOABDate = _data["lsuPOABDate"] ? moment(_data["lsuPOABDate"].toString()) : null as any;
            this.productType = _data["productType"] !== undefined ? _data["productType"] : null as any;
            this.orderClassify = _data["orderClassify"] !== undefined ? _data["orderClassify"] : null as any;
            this.sendingFlag = _data["sendingFlag"] !== undefined ? _data["sendingFlag"] : null as any;
            this.omsOrderNumber = _data["omsOrderNumber"] !== undefined ? _data["omsOrderNumber"] : null as any;
            this.omsOrderItem = _data["omsOrderItem"] !== undefined ? _data["omsOrderItem"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
        }
    }

    static fromJS(data: any): OrderInformationsToIWorldOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderInformationsToIWorldOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["soldToParty"] = this.soldToParty !== undefined ? this.soldToParty : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["lsuOrderType"] = this.lsuOrderType !== undefined ? this.lsuOrderType : null as any;
        data["lsuSalesOrg"] = this.lsuSalesOrg !== undefined ? this.lsuSalesOrg : null as any;
        data["lsuSalesOrder"] = this.lsuSalesOrder !== undefined ? this.lsuSalesOrder : null as any;
        data["lsuItem"] = this.lsuItem !== undefined ? this.lsuItem : null as any;
        data["pmuOrderType"] = this.pmuOrderType !== undefined ? this.pmuOrderType : null as any;
        data["pmuSalesOrg"] = this.pmuSalesOrg !== undefined ? this.pmuSalesOrg : null as any;
        data["pmuSalesOrder"] = this.pmuSalesOrder !== undefined ? this.pmuSalesOrder : null as any;
        data["pmuSalesOrderItem"] = this.pmuSalesOrderItem !== undefined ? this.pmuSalesOrderItem : null as any;
        data["pmuSoitemCategory"] = this.pmuSoitemCategory !== undefined ? this.pmuSoitemCategory : null as any;
        data["soItemCategoryText"] = this.soItemCategoryText !== undefined ? this.soItemCategoryText : null as any;
        data["material"] = this.material !== undefined ? this.material : null as any;
        data["materialDescriptionEn"] = this.materialDescriptionEn !== undefined ? this.materialDescriptionEn : null as any;
        data["materialDescriptionCh"] = this.materialDescriptionCh !== undefined ? this.materialDescriptionCh : null as any;
        data["lsuOrderQty"] = this.lsuOrderQty !== undefined ? this.lsuOrderQty : null as any;
        data["lsuSalesEngineerName"] = this.lsuSalesEngineerName !== undefined ? this.lsuSalesEngineerName : null as any;
        data["pmuStock"] = this.pmuStock !== undefined ? this.pmuStock : null as any;
        data["purchaseOrderDate"] = this.purchaseOrderDate ? this.purchaseOrderDate.toISOString() : null as any;
        data["lastGoodsReceiptDate"] = this.lastGoodsReceiptDate ? this.lastGoodsReceiptDate.toISOString() : null as any;
        data["pmuDnQty"] = this.pmuDnQty !== undefined ? this.pmuDnQty : null as any;
        data["lsuContractNumber"] = this.lsuContractNumber !== undefined ? this.lsuContractNumber : null as any;
        data["lsuUnitPrice"] = this.lsuUnitPrice !== undefined ? this.lsuUnitPrice : null as any;
        data["requestDeliveryDate"] = this.requestDeliveryDate ? this.requestDeliveryDate.toISOString() : null as any;
        data["lsuBillingAmountWithoutTax"] = this.lsuBillingAmountWithoutTax !== undefined ? this.lsuBillingAmountWithoutTax : null as any;
        data["unitPriceWithTax"] = this.unitPriceWithTax !== undefined ? this.unitPriceWithTax : null as any;
        data["customerPo"] = this.customerPo !== undefined ? this.customerPo : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["customerProdNo"] = this.customerProdNo !== undefined ? this.customerProdNo : null as any;
        data["materialGroup"] = this.materialGroup !== undefined ? this.materialGroup : null as any;
        data["productGroup"] = this.productGroup !== undefined ? this.productGroup : null as any;
        data["salesOffice"] = this.salesOffice !== undefined ? this.salesOffice : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["lsuSoCurr"] = this.lsuSoCurr !== undefined ? this.lsuSoCurr : null as any;
        data["lsuItemValueWithTax"] = this.lsuItemValueWithTax !== undefined ? this.lsuItemValueWithTax : null as any;
        data["lsuItemValue"] = this.lsuItemValue !== undefined ? this.lsuItemValue : null as any;
        data["lsugiQtyTotal"] = this.lsugiQtyTotal !== undefined ? this.lsugiQtyTotal : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["projectNameDes"] = this.projectNameDes !== undefined ? this.projectNameDes : null as any;
        data["availableStock"] = this.availableStock !== undefined ? this.availableStock : null as any;
        data["rejectionCodeForCSO"] = this.rejectionCodeForCSO !== undefined ? this.rejectionCodeForCSO : null as any;
        data["rejectionDescriptionForCSO"] = this.rejectionDescriptionForCSO !== undefined ? this.rejectionDescriptionForCSO : null as any;
        data["rejectionCodeForISO"] = this.rejectionCodeForISO !== undefined ? this.rejectionCodeForISO : null as any;
        data["rejectionDescriptionForISO"] = this.rejectionDescriptionForISO !== undefined ? this.rejectionDescriptionForISO : null as any;
        data["billingDate"] = this.billingDate ? this.billingDate.toISOString() : null as any;
        data["billingQty"] = this.billingQty !== undefined ? this.billingQty : null as any;
        data["lsuPOABDate"] = this.lsuPOABDate ? this.lsuPOABDate.toISOString() : null as any;
        data["productType"] = this.productType !== undefined ? this.productType : null as any;
        data["orderClassify"] = this.orderClassify !== undefined ? this.orderClassify : null as any;
        data["sendingFlag"] = this.sendingFlag !== undefined ? this.sendingFlag : null as any;
        data["omsOrderNumber"] = this.omsOrderNumber !== undefined ? this.omsOrderNumber : null as any;
        data["omsOrderItem"] = this.omsOrderItem !== undefined ? this.omsOrderItem : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        return data;
    }
}

/** 订单产品变更 */
export class OrderProductChangeDto {
    id!: string;
    /** 变更内容 */
    changecontent!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.changecontent = _data["changecontent"] !== undefined ? _data["changecontent"] : null as any;
        }
    }

    static fromJS(data: any): OrderProductChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProductChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["changecontent"] = this.changecontent !== undefined ? this.changecontent : null as any;
        return data;
    }
}

export class OrderProductTypeEntity {
    id!: string;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    state!: boolean;
    productType!: string | null;
    productGroup!: string | null;
    engineeringManager!: string | null;
    isDefault!: boolean;
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.productType = _data["productType"] !== undefined ? _data["productType"] : null as any;
            this.productGroup = _data["productGroup"] !== undefined ? _data["productGroup"] : null as any;
            this.engineeringManager = _data["engineeringManager"] !== undefined ? _data["engineeringManager"] : null as any;
            this.isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): OrderProductTypeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProductTypeEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["productType"] = this.productType !== undefined ? this.productType : null as any;
        data["productGroup"] = this.productGroup !== undefined ? this.productGroup : null as any;
        data["engineeringManager"] = this.engineeringManager !== undefined ? this.engineeringManager : null as any;
        data["isDefault"] = this.isDefault !== undefined ? this.isDefault : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

/** 0 = NotStarted (待提交) 1 = Underway (处理中) 2 = adopt (已下单) 3 = Failed (已退回) 4 = Cancel (已取消) */
export enum OrderStatus {
    NotStarted = 0,
    Underway = 1,
    Adopt = 2,
    Failed = 3,
    Cancel = 4,
}

/** 1 = SmartConfigurator 2 = CTO 3 = OEM */
export enum OrderType {
    SmartConfigurator = 1,
    CTO = 2,
    OEM = 3,
}

export class OrderVisualization {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    orderId!: string;
    modelSelectionId!: string | null;
    omsOrderNumber!: string | null;
    customerOrderNumber!: string | null;
    lsuSalesEngineerCode!: string | null;
    lsuSalesEngineerName!: string | null;
    salesAreaCode!: string | null;
    salesAreaName!: string | null;
    basicMotorModel!: string | null;
    lsuCommercialName!: string | null;
    lsuCommercialId!: number | null;
    lsuCreateDate!: moment.Moment | null;
    orderSubmitDate!: moment.Moment | null;
    availableStockOriginal!: number;
    purchaseOrderDateOriginal!: moment.Moment | null;
    orderStatus!: number | null;
    stockStatus!: number | null;
    availableStockAuto!: number;
    firstStockDate!: moment.Moment | null;
    deliveryOvertimeDate!: moment.Moment | null;
    deliveryStatus!: number | null;
    purchaseOrderDateCurrent!: moment.Moment | null;
    purchaseOrderDateManual!: moment.Moment | null;
    orderInformations!: OrderInformations;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : null as any;
            this.modelSelectionId = _data["modelSelectionId"] !== undefined ? _data["modelSelectionId"] : null as any;
            this.omsOrderNumber = _data["omsOrderNumber"] !== undefined ? _data["omsOrderNumber"] : null as any;
            this.customerOrderNumber = _data["customerOrderNumber"] !== undefined ? _data["customerOrderNumber"] : null as any;
            this.lsuSalesEngineerCode = _data["lsuSalesEngineerCode"] !== undefined ? _data["lsuSalesEngineerCode"] : null as any;
            this.lsuSalesEngineerName = _data["lsuSalesEngineerName"] !== undefined ? _data["lsuSalesEngineerName"] : null as any;
            this.salesAreaCode = _data["salesAreaCode"] !== undefined ? _data["salesAreaCode"] : null as any;
            this.salesAreaName = _data["salesAreaName"] !== undefined ? _data["salesAreaName"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.lsuCommercialName = _data["lsuCommercialName"] !== undefined ? _data["lsuCommercialName"] : null as any;
            this.lsuCommercialId = _data["lsuCommercialId"] !== undefined ? _data["lsuCommercialId"] : null as any;
            this.lsuCreateDate = _data["lsuCreateDate"] ? moment(_data["lsuCreateDate"].toString()) : null as any;
            this.orderSubmitDate = _data["orderSubmitDate"] ? moment(_data["orderSubmitDate"].toString()) : null as any;
            this.availableStockOriginal = _data["availableStockOriginal"] !== undefined ? _data["availableStockOriginal"] : null as any;
            this.purchaseOrderDateOriginal = _data["purchaseOrderDateOriginal"] ? moment(_data["purchaseOrderDateOriginal"].toString()) : null as any;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : null as any;
            this.stockStatus = _data["stockStatus"] !== undefined ? _data["stockStatus"] : null as any;
            this.availableStockAuto = _data["availableStockAuto"] !== undefined ? _data["availableStockAuto"] : null as any;
            this.firstStockDate = _data["firstStockDate"] ? moment(_data["firstStockDate"].toString()) : null as any;
            this.deliveryOvertimeDate = _data["deliveryOvertimeDate"] ? moment(_data["deliveryOvertimeDate"].toString()) : null as any;
            this.deliveryStatus = _data["deliveryStatus"] !== undefined ? _data["deliveryStatus"] : null as any;
            this.purchaseOrderDateCurrent = _data["purchaseOrderDateCurrent"] ? moment(_data["purchaseOrderDateCurrent"].toString()) : null as any;
            this.purchaseOrderDateManual = _data["purchaseOrderDateManual"] ? moment(_data["purchaseOrderDateManual"].toString()) : null as any;
            this.orderInformations = _data["orderInformations"] ? OrderInformations.fromJS(_data["orderInformations"]) : null as any;
        }
    }

    static fromJS(data: any): OrderVisualization {
        data = typeof data === 'object' ? data : {};
        let result = new OrderVisualization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["orderId"] = this.orderId !== undefined ? this.orderId : null as any;
        data["modelSelectionId"] = this.modelSelectionId !== undefined ? this.modelSelectionId : null as any;
        data["omsOrderNumber"] = this.omsOrderNumber !== undefined ? this.omsOrderNumber : null as any;
        data["customerOrderNumber"] = this.customerOrderNumber !== undefined ? this.customerOrderNumber : null as any;
        data["lsuSalesEngineerCode"] = this.lsuSalesEngineerCode !== undefined ? this.lsuSalesEngineerCode : null as any;
        data["lsuSalesEngineerName"] = this.lsuSalesEngineerName !== undefined ? this.lsuSalesEngineerName : null as any;
        data["salesAreaCode"] = this.salesAreaCode !== undefined ? this.salesAreaCode : null as any;
        data["salesAreaName"] = this.salesAreaName !== undefined ? this.salesAreaName : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["lsuCommercialName"] = this.lsuCommercialName !== undefined ? this.lsuCommercialName : null as any;
        data["lsuCommercialId"] = this.lsuCommercialId !== undefined ? this.lsuCommercialId : null as any;
        data["lsuCreateDate"] = this.lsuCreateDate ? this.lsuCreateDate.toISOString() : null as any;
        data["orderSubmitDate"] = this.orderSubmitDate ? this.orderSubmitDate.toISOString() : null as any;
        data["availableStockOriginal"] = this.availableStockOriginal !== undefined ? this.availableStockOriginal : null as any;
        data["purchaseOrderDateOriginal"] = this.purchaseOrderDateOriginal ? this.purchaseOrderDateOriginal.toISOString() : null as any;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : null as any;
        data["stockStatus"] = this.stockStatus !== undefined ? this.stockStatus : null as any;
        data["availableStockAuto"] = this.availableStockAuto !== undefined ? this.availableStockAuto : null as any;
        data["firstStockDate"] = this.firstStockDate ? this.firstStockDate.toISOString() : null as any;
        data["deliveryOvertimeDate"] = this.deliveryOvertimeDate ? this.deliveryOvertimeDate.toISOString() : null as any;
        data["deliveryStatus"] = this.deliveryStatus !== undefined ? this.deliveryStatus : null as any;
        data["purchaseOrderDateCurrent"] = this.purchaseOrderDateCurrent ? this.purchaseOrderDateCurrent.toISOString() : null as any;
        data["purchaseOrderDateManual"] = this.purchaseOrderDateManual ? this.purchaseOrderDateManual.toISOString() : null as any;
        data["orderInformations"] = this.orderInformations ? this.orderInformations.toJSON() : null as any;
        return data;
    }
}

export class OriginFile {
    uid!: string | null;

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"] !== undefined ? _data["uid"] : null as any;
        }
    }

    static fromJS(data: any): OriginFile {
        data = typeof data === 'object' ? data : {};
        let result = new OriginFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid !== undefined ? this.uid : null as any;
        return data;
    }
}

/** 输出消息， */
export class OutPutMsg {
    /** 成功或失败 */
    isSussess!: boolean;
    /** 消息 */
    msg!: string | null;

    init(_data?: any) {
        if (_data) {
            this.isSussess = _data["isSussess"] !== undefined ? _data["isSussess"] : null as any;
            this.msg = _data["msg"] !== undefined ? _data["msg"] : null as any;
        }
    }

    static fromJS(data: any): OutPutMsg {
        data = typeof data === 'object' ? data : {};
        let result = new OutPutMsg();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSussess"] = this.isSussess !== undefined ? this.isSussess : null as any;
        data["msg"] = this.msg !== undefined ? this.msg : null as any;
        return data;
    }
}

export class OutputDto {
    /** 查询状态 */
    isSuccess!: boolean;
    /** 返回信息（查询成功返回空） */
    message!: string | null;
    /** Sap库存列表 */
    dataList!: any | null;

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.dataList = _data["dataList"] !== undefined ? _data["dataList"] : null as any;
        }
    }

    static fromJS(data: any): OutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["dataList"] = this.dataList !== undefined ? this.dataList : null as any;
        return data;
    }
}

/** 订单自动化操作记录 */
export class PageAutomateLogForOrderDto {
    /** 总数 */
    totalCount!: number;
    /** 操作记录 */
    data!: OrderFormAutomateLogDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OrderFormAutomateLogDto.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): PageAutomateLogForOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageAutomateLogForOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 订单自动化操作记录 */
export class PageAutomateLogsForOrderParam {
    maxResultCount!: number;
    skipCount!: number;
    /** 订单 Id */
    orderId!: string;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : null as any;
        }
    }

    static fromJS(data: any): PageAutomateLogsForOrderParam {
        data = typeof data === 'object' ? data : {};
        let result = new PageAutomateLogsForOrderParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["orderId"] = this.orderId !== undefined ? this.orderId : null as any;
        return data;
    }
}

export class PageAutomateLogsStatusForOrderParam {
    maxResultCount!: number;
    skipCount!: number;
    /** 开始时间 */
    startDate!: moment.Moment | null;
    /** 结束时间 */
    endDate!: moment.Moment | null;
    /** 合同号 */
    poNumber!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
        }
    }

    static fromJS(data: any): PageAutomateLogsStatusForOrderParam {
        data = typeof data === 'object' ? data : {};
        let result = new PageAutomateLogsStatusForOrderParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        return data;
    }
}

export class PageCTOProductBasicMotorAllDto {
    maxResultCount!: number;
    skipCount!: number;
    /** CP编码 */
    cpCode!: string | null;
    /** CP名称 */
    cpCoName!: string | null;
    /** 二级客户代码 */
    finalCustomerCode!: string | null;
    /** 二级客户名称 */
    finalCustomerName!: string | null;
    /** 客户物料号 */
    ctoCustomerMaterialNumber!: string | null;
    /** 系统组合号 */
    ctoProductMixCode!: string | null;
    /** 电机型号 */
    ctoBasicMotorModel!: string | null;
    /** 产品代码 */
    ctoBasicMotorCode!: string | null;
    /** 开始日期 */
    readonly startDateTime!: moment.Moment | null;
    /** 结束日期(结束日期包含在当日创建的数据，因此天数+1,判断时使用小于比较符) */
    readonly endDateTime!: moment.Moment | null;
    date!: moment.Moment[] | null;
    /** 状态 */
    status!: number | null;
    /** 确认状态(来源于SyncConfirmStatus) */
    confirmStatus!: number | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.cpCoName = _data["cpCoName"] !== undefined ? _data["cpCoName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.ctoCustomerMaterialNumber = _data["ctoCustomerMaterialNumber"] !== undefined ? _data["ctoCustomerMaterialNumber"] : null as any;
            this.ctoProductMixCode = _data["ctoProductMixCode"] !== undefined ? _data["ctoProductMixCode"] : null as any;
            this.ctoBasicMotorModel = _data["ctoBasicMotorModel"] !== undefined ? _data["ctoBasicMotorModel"] : null as any;
            this.ctoBasicMotorCode = _data["ctoBasicMotorCode"] !== undefined ? _data["ctoBasicMotorCode"] : null as any;
            (this as any).startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : null as any;
            (this as any).endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : null as any;
            if (Array.isArray(_data["date"])) {
                this.date = [] as any;
                for (let item of _data["date"])
                    this.date!.push(moment(item));
            }
            else {
                this.date = null as any;
            }
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.confirmStatus = _data["confirmStatus"] !== undefined ? _data["confirmStatus"] : null as any;
        }
    }

    static fromJS(data: any): PageCTOProductBasicMotorAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageCTOProductBasicMotorAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["cpCoName"] = this.cpCoName !== undefined ? this.cpCoName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["ctoCustomerMaterialNumber"] = this.ctoCustomerMaterialNumber !== undefined ? this.ctoCustomerMaterialNumber : null as any;
        data["ctoProductMixCode"] = this.ctoProductMixCode !== undefined ? this.ctoProductMixCode : null as any;
        data["ctoBasicMotorModel"] = this.ctoBasicMotorModel !== undefined ? this.ctoBasicMotorModel : null as any;
        data["ctoBasicMotorCode"] = this.ctoBasicMotorCode !== undefined ? this.ctoBasicMotorCode : null as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : null as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : null as any;
        if (Array.isArray(this.date)) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item.toISOString());
        }
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["confirmStatus"] = this.confirmStatus !== undefined ? this.confirmStatus : null as any;
        return data;
    }
}

/** 分页获取所有客户信息 */
export class PageCustomInfosByDeliveryTimeInputDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | null;
    /** 客户编号/名称 */
    keyword!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.sorting = _data["sorting"] !== undefined ? _data["sorting"] : null as any;
            this.keyword = _data["keyword"] !== undefined ? _data["keyword"] : null as any;
        }
    }

    static fromJS(data: any): PageCustomInfosByDeliveryTimeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageCustomInfosByDeliveryTimeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["sorting"] = this.sorting !== undefined ? this.sorting : null as any;
        data["keyword"] = this.keyword !== undefined ? this.keyword : null as any;
        return data;
    }
}

/** 提货单编辑输入对象 */
export class PageDeliveryNotesInputDto {
    /** 客户编号 */
    soldToParty!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** DNS编号 */
    number!: string | null;
    /** 邮编 */
    route!: string | null;
    /** 发货数量 */
    deliveryQty!: number;
    /** 计划拣配数量 */
    pickedQty!: number;
    /** 公司名称 */
    shipToPartyName!: string | null;
    /** 发货地址 */
    streetHouseNumber!: string | null;
    /** 城市 */
    city!: string | null;
    /** 联系人 */
    comments!: string | null;
    /** 电话 */
    telephone!: string | null;
    /** Iso DN */
    isoDn!: string | null;
    /** Cso DN */
    csoDn!: string | null;
    /** 提货单订单明细 */
    deliveryNotesItems!: PageDeliveryNotesOrderItemInputDto[] | null;
    /** 是否提交 */
    submit!: boolean;
    /** 运输类型 (10-自提、99-顺丰) */
    shippingType!: string | null;
    /** 拆单状态 */
    splitStatus!: boolean | null;
    /** 加急列表 */
    urgentList!: string[] | null;
    /** 是否勾选特殊附件 */
    hasSpecialAttachment!: boolean;
    /** 特殊附件文件名 */
    specialAttachmentName!: string | null;
    /** 是否勾选发运送货要求 */
    hasDeliveryRequirement!: boolean;
    /** 发运送货要求附件文件名 */
    deliveryRequirementAttachmentName!: string | null;
    /** 仅更新附件（报错状态可再次修改附件） */
    updateAttachmentsOnly!: boolean;
    /** 自提委托书司机姓名 */
    pickupDriverName!: string | null;
    /** 自提委托书司机电话 */
    pickupDriverPhone!: string | null;
    /** 自提委托书司机身份证号 */
    pickupDriverIdNo!: string | null;
    /** 自提委托书车牌号 */
    pickupPlateNo!: string | null;

    init(_data?: any) {
        if (_data) {
            this.soldToParty = _data["soldToParty"] !== undefined ? _data["soldToParty"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.route = _data["route"] !== undefined ? _data["route"] : null as any;
            this.deliveryQty = _data["deliveryQty"] !== undefined ? _data["deliveryQty"] : null as any;
            this.pickedQty = _data["pickedQty"] !== undefined ? _data["pickedQty"] : null as any;
            this.shipToPartyName = _data["shipToPartyName"] !== undefined ? _data["shipToPartyName"] : null as any;
            this.streetHouseNumber = _data["streetHouseNumber"] !== undefined ? _data["streetHouseNumber"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.telephone = _data["telephone"] !== undefined ? _data["telephone"] : null as any;
            this.isoDn = _data["isoDn"] !== undefined ? _data["isoDn"] : null as any;
            this.csoDn = _data["csoDn"] !== undefined ? _data["csoDn"] : null as any;
            if (Array.isArray(_data["deliveryNotesItems"])) {
                this.deliveryNotesItems = [] as any;
                for (let item of _data["deliveryNotesItems"])
                    this.deliveryNotesItems!.push(PageDeliveryNotesOrderItemInputDto.fromJS(item));
            }
            else {
                this.deliveryNotesItems = null as any;
            }
            this.submit = _data["submit"] !== undefined ? _data["submit"] : null as any;
            this.shippingType = _data["shippingType"] !== undefined ? _data["shippingType"] : null as any;
            this.splitStatus = _data["splitStatus"] !== undefined ? _data["splitStatus"] : null as any;
            if (Array.isArray(_data["urgentList"])) {
                this.urgentList = [] as any;
                for (let item of _data["urgentList"])
                    this.urgentList!.push(item);
            }
            else {
                this.urgentList = null as any;
            }
            this.hasSpecialAttachment = _data["hasSpecialAttachment"] !== undefined ? _data["hasSpecialAttachment"] : null as any;
            this.specialAttachmentName = _data["specialAttachmentName"] !== undefined ? _data["specialAttachmentName"] : null as any;
            this.hasDeliveryRequirement = _data["hasDeliveryRequirement"] !== undefined ? _data["hasDeliveryRequirement"] : null as any;
            this.deliveryRequirementAttachmentName = _data["deliveryRequirementAttachmentName"] !== undefined ? _data["deliveryRequirementAttachmentName"] : null as any;
            this.updateAttachmentsOnly = _data["updateAttachmentsOnly"] !== undefined ? _data["updateAttachmentsOnly"] : null as any;
            this.pickupDriverName = _data["pickupDriverName"] !== undefined ? _data["pickupDriverName"] : null as any;
            this.pickupDriverPhone = _data["pickupDriverPhone"] !== undefined ? _data["pickupDriverPhone"] : null as any;
            this.pickupDriverIdNo = _data["pickupDriverIdNo"] !== undefined ? _data["pickupDriverIdNo"] : null as any;
            this.pickupPlateNo = _data["pickupPlateNo"] !== undefined ? _data["pickupPlateNo"] : null as any;
        }
    }

    static fromJS(data: any): PageDeliveryNotesInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageDeliveryNotesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["soldToParty"] = this.soldToParty !== undefined ? this.soldToParty : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["route"] = this.route !== undefined ? this.route : null as any;
        data["deliveryQty"] = this.deliveryQty !== undefined ? this.deliveryQty : null as any;
        data["pickedQty"] = this.pickedQty !== undefined ? this.pickedQty : null as any;
        data["shipToPartyName"] = this.shipToPartyName !== undefined ? this.shipToPartyName : null as any;
        data["streetHouseNumber"] = this.streetHouseNumber !== undefined ? this.streetHouseNumber : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["telephone"] = this.telephone !== undefined ? this.telephone : null as any;
        data["isoDn"] = this.isoDn !== undefined ? this.isoDn : null as any;
        data["csoDn"] = this.csoDn !== undefined ? this.csoDn : null as any;
        if (Array.isArray(this.deliveryNotesItems)) {
            data["deliveryNotesItems"] = [];
            for (let item of this.deliveryNotesItems)
                data["deliveryNotesItems"].push(item ? item.toJSON() : null as any);
        }
        data["submit"] = this.submit !== undefined ? this.submit : null as any;
        data["shippingType"] = this.shippingType !== undefined ? this.shippingType : null as any;
        data["splitStatus"] = this.splitStatus !== undefined ? this.splitStatus : null as any;
        if (Array.isArray(this.urgentList)) {
            data["urgentList"] = [];
            for (let item of this.urgentList)
                data["urgentList"].push(item);
        }
        data["hasSpecialAttachment"] = this.hasSpecialAttachment !== undefined ? this.hasSpecialAttachment : null as any;
        data["specialAttachmentName"] = this.specialAttachmentName !== undefined ? this.specialAttachmentName : null as any;
        data["hasDeliveryRequirement"] = this.hasDeliveryRequirement !== undefined ? this.hasDeliveryRequirement : null as any;
        data["deliveryRequirementAttachmentName"] = this.deliveryRequirementAttachmentName !== undefined ? this.deliveryRequirementAttachmentName : null as any;
        data["updateAttachmentsOnly"] = this.updateAttachmentsOnly !== undefined ? this.updateAttachmentsOnly : null as any;
        data["pickupDriverName"] = this.pickupDriverName !== undefined ? this.pickupDriverName : null as any;
        data["pickupDriverPhone"] = this.pickupDriverPhone !== undefined ? this.pickupDriverPhone : null as any;
        data["pickupDriverIdNo"] = this.pickupDriverIdNo !== undefined ? this.pickupDriverIdNo : null as any;
        data["pickupPlateNo"] = this.pickupPlateNo !== undefined ? this.pickupPlateNo : null as any;
        return data;
    }
}

/** 提货单子项信息 */
export class PageDeliveryNotesOrderItemInputDto {
    /** 订单行号 */
    orderId!: string;
    /** 发货数量 */
    deliveryQty!: number;
    /** 状态 */
    status!: string | null;
    /** 运费 */
    freight!: number;
    /** 创建订单时的已发数量 */
    dnQty!: number;
    /** 创建订单时的订单数量 */
    orderQty!: number;
    /** 创建订单时的库存数量 */
    stockQty!: number;
    /** PMU订单号
统计判断运费 */
    pmuSalesOrder!: string | null;
    /** 金额（不含税）
净价 */
    lsuUnitPrice!: number;

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : null as any;
            this.deliveryQty = _data["deliveryQty"] !== undefined ? _data["deliveryQty"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.freight = _data["freight"] !== undefined ? _data["freight"] : null as any;
            this.dnQty = _data["dnQty"] !== undefined ? _data["dnQty"] : null as any;
            this.orderQty = _data["orderQty"] !== undefined ? _data["orderQty"] : null as any;
            this.stockQty = _data["stockQty"] !== undefined ? _data["stockQty"] : null as any;
            this.pmuSalesOrder = _data["pmuSalesOrder"] !== undefined ? _data["pmuSalesOrder"] : null as any;
            this.lsuUnitPrice = _data["lsuUnitPrice"] !== undefined ? _data["lsuUnitPrice"] : null as any;
        }
    }

    static fromJS(data: any): PageDeliveryNotesOrderItemInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageDeliveryNotesOrderItemInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId !== undefined ? this.orderId : null as any;
        data["deliveryQty"] = this.deliveryQty !== undefined ? this.deliveryQty : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["freight"] = this.freight !== undefined ? this.freight : null as any;
        data["dnQty"] = this.dnQty !== undefined ? this.dnQty : null as any;
        data["orderQty"] = this.orderQty !== undefined ? this.orderQty : null as any;
        data["stockQty"] = this.stockQty !== undefined ? this.stockQty : null as any;
        data["pmuSalesOrder"] = this.pmuSalesOrder !== undefined ? this.pmuSalesOrder : null as any;
        data["lsuUnitPrice"] = this.lsuUnitPrice !== undefined ? this.lsuUnitPrice : null as any;
        return data;
    }
}

/** 提货单子项信息 */
export class PageDeliveryNotesOrderItemOutputDto {
    /** 提货单子项编号 */
    id!: string;
    /** 订单行号 */
    orderId!: string;
    /** 订单行计划拣配数量 */
    deliveryQty!: number;
    /** Iso DN */
    isoDn!: string | null;
    /** Cso DN */
    csoDn!: string | null;
    /** Sap回写接口消息 */
    message!: string | null;
    /** Sap发货状态 */
    status!: string | null;
    /** 提货单状态 */
    readonly statusName!: string | null;
    orderInformations!: PageOutputDto;
    /** 运费 */
    freight!: number;
    /** 创建订单时的已发数量 */
    dnQty!: number;
    /** 创建订单时的订单数量 */
    orderQty!: number;
    /** 创建订单时的库存数量 */
    stockQty!: number;
    /** PMU订单号
统计判断运费 */
    readonly pmuSalesOrder!: string | null;
    /** 金额（不含税）
净价 */
    readonly lsuUnitPrice!: number;
    /** 是否加急 */
    isUrgent!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : null as any;
            this.deliveryQty = _data["deliveryQty"] !== undefined ? _data["deliveryQty"] : null as any;
            this.isoDn = _data["isoDn"] !== undefined ? _data["isoDn"] : null as any;
            this.csoDn = _data["csoDn"] !== undefined ? _data["csoDn"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            (this as any).statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            this.orderInformations = _data["orderInformations"] ? PageOutputDto.fromJS(_data["orderInformations"]) : null as any;
            this.freight = _data["freight"] !== undefined ? _data["freight"] : null as any;
            this.dnQty = _data["dnQty"] !== undefined ? _data["dnQty"] : null as any;
            this.orderQty = _data["orderQty"] !== undefined ? _data["orderQty"] : null as any;
            this.stockQty = _data["stockQty"] !== undefined ? _data["stockQty"] : null as any;
            (this as any).pmuSalesOrder = _data["pmuSalesOrder"] !== undefined ? _data["pmuSalesOrder"] : null as any;
            (this as any).lsuUnitPrice = _data["lsuUnitPrice"] !== undefined ? _data["lsuUnitPrice"] : null as any;
            this.isUrgent = _data["isUrgent"] !== undefined ? _data["isUrgent"] : null as any;
        }
    }

    static fromJS(data: any): PageDeliveryNotesOrderItemOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageDeliveryNotesOrderItemOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["orderId"] = this.orderId !== undefined ? this.orderId : null as any;
        data["deliveryQty"] = this.deliveryQty !== undefined ? this.deliveryQty : null as any;
        data["isoDn"] = this.isoDn !== undefined ? this.isoDn : null as any;
        data["csoDn"] = this.csoDn !== undefined ? this.csoDn : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        data["orderInformations"] = this.orderInformations ? this.orderInformations.toJSON() : null as any;
        data["freight"] = this.freight !== undefined ? this.freight : null as any;
        data["dnQty"] = this.dnQty !== undefined ? this.dnQty : null as any;
        data["orderQty"] = this.orderQty !== undefined ? this.orderQty : null as any;
        data["stockQty"] = this.stockQty !== undefined ? this.stockQty : null as any;
        data["pmuSalesOrder"] = this.pmuSalesOrder !== undefined ? this.pmuSalesOrder : null as any;
        data["lsuUnitPrice"] = this.lsuUnitPrice !== undefined ? this.lsuUnitPrice : null as any;
        data["isUrgent"] = this.isUrgent !== undefined ? this.isUrgent : null as any;
        return data;
    }
}

/** 提货单输出对象 */
export class PageDeliveryNotesOutputDto {
    /** 提货单编号 */
    id!: string;
    /** 提货单创建时间 */
    creationTime!: moment.Moment;
    /** 客户编号 */
    soldToParty!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** DNS编号 */
    number!: string | null;
    /** 发货类型 */
    route!: string | null;
    /** 发货数量 */
    deliveryQty!: number;
    /** 计划拣配数量 */
    pickedQty!: number;
    /** Ship to Part名称 */
    shipToPartyName!: string | null;
    /** 发货地址 */
    streetHouseNumber!: string | null;
    /** 城市 */
    city!: string | null;
    /** 联系人 */
    comments!: string | null;
    /** 电话 */
    telephone!: string | null;
    /** 提货单状态 */
    status!: number;
    /** 提货单状态 */
    readonly statusName!: string | null;
    /** 拆单状态 */
    splitStatus!: boolean;
    /** 禁止发货,若当前时间在客户限制发货时间内,则不允许发货 */
    deliveryDisable!: boolean;
    /** 禁止地址编辑 */
    addressDisable!: boolean;
    /** 运输类型 (10-自提、99-顺丰) */
    shippingType!: string | null;
    /** 提货单状态 */
    readonly shippingTypeName!: string | null;
    /** 提货单订单明细 */
    orderInformations!: PageOutputDto[] | null;
    /** 提货单订单明细 */
    deliveryNotesOrderItems!: PageDeliveryNotesOrderItemOutputDto[] | null;
    /** 运费规则：不含税item金额免运费下限 */
    freeFreightPrice!: number;
    /** 运费规则：运费比例 */
    freightRate!: number;
    /** 运费规则：运费比例 */
    minFreight!: number;
    /** 是否备库订单 */
    forLibOrderFlg!: boolean | null;
    /** 是否勾选特殊附件 */
    hasSpecialAttachment!: boolean;
    /** 特殊附件文件名 */
    specialAttachmentName!: string | null;
    /** 是否勾选发运送货要求 */
    hasDeliveryRequirement!: boolean;
    /** 发运送货要求附件文件名 */
    deliveryRequirementAttachmentName!: string | null;
    /** 物流已下载附件 */
    logisticsCompleted!: boolean;
    /** 仓库已下载附件 */
    warehouseCompleted!: boolean;
    /** 自提委托书司机姓名 */
    pickupDriverName!: string | null;
    /** 自提委托书司机电话 */
    pickupDriverPhone!: string | null;
    /** 自提委托书司机身份证号 */
    pickupDriverIdNo!: string | null;
    /** 自提委托书车牌号 */
    pickupPlateNo!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.soldToParty = _data["soldToParty"] !== undefined ? _data["soldToParty"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.route = _data["route"] !== undefined ? _data["route"] : null as any;
            this.deliveryQty = _data["deliveryQty"] !== undefined ? _data["deliveryQty"] : null as any;
            this.pickedQty = _data["pickedQty"] !== undefined ? _data["pickedQty"] : null as any;
            this.shipToPartyName = _data["shipToPartyName"] !== undefined ? _data["shipToPartyName"] : null as any;
            this.streetHouseNumber = _data["streetHouseNumber"] !== undefined ? _data["streetHouseNumber"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.telephone = _data["telephone"] !== undefined ? _data["telephone"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            (this as any).statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            this.splitStatus = _data["splitStatus"] !== undefined ? _data["splitStatus"] : null as any;
            this.deliveryDisable = _data["deliveryDisable"] !== undefined ? _data["deliveryDisable"] : null as any;
            this.addressDisable = _data["addressDisable"] !== undefined ? _data["addressDisable"] : null as any;
            this.shippingType = _data["shippingType"] !== undefined ? _data["shippingType"] : null as any;
            (this as any).shippingTypeName = _data["shippingTypeName"] !== undefined ? _data["shippingTypeName"] : null as any;
            if (Array.isArray(_data["orderInformations"])) {
                this.orderInformations = [] as any;
                for (let item of _data["orderInformations"])
                    this.orderInformations!.push(PageOutputDto.fromJS(item));
            }
            else {
                this.orderInformations = null as any;
            }
            if (Array.isArray(_data["deliveryNotesOrderItems"])) {
                this.deliveryNotesOrderItems = [] as any;
                for (let item of _data["deliveryNotesOrderItems"])
                    this.deliveryNotesOrderItems!.push(PageDeliveryNotesOrderItemOutputDto.fromJS(item));
            }
            else {
                this.deliveryNotesOrderItems = null as any;
            }
            this.freeFreightPrice = _data["freeFreightPrice"] !== undefined ? _data["freeFreightPrice"] : null as any;
            this.freightRate = _data["freightRate"] !== undefined ? _data["freightRate"] : null as any;
            this.minFreight = _data["minFreight"] !== undefined ? _data["minFreight"] : null as any;
            this.forLibOrderFlg = _data["forLibOrderFlg"] !== undefined ? _data["forLibOrderFlg"] : null as any;
            this.hasSpecialAttachment = _data["hasSpecialAttachment"] !== undefined ? _data["hasSpecialAttachment"] : null as any;
            this.specialAttachmentName = _data["specialAttachmentName"] !== undefined ? _data["specialAttachmentName"] : null as any;
            this.hasDeliveryRequirement = _data["hasDeliveryRequirement"] !== undefined ? _data["hasDeliveryRequirement"] : null as any;
            this.deliveryRequirementAttachmentName = _data["deliveryRequirementAttachmentName"] !== undefined ? _data["deliveryRequirementAttachmentName"] : null as any;
            this.logisticsCompleted = _data["logisticsCompleted"] !== undefined ? _data["logisticsCompleted"] : null as any;
            this.warehouseCompleted = _data["warehouseCompleted"] !== undefined ? _data["warehouseCompleted"] : null as any;
            this.pickupDriverName = _data["pickupDriverName"] !== undefined ? _data["pickupDriverName"] : null as any;
            this.pickupDriverPhone = _data["pickupDriverPhone"] !== undefined ? _data["pickupDriverPhone"] : null as any;
            this.pickupDriverIdNo = _data["pickupDriverIdNo"] !== undefined ? _data["pickupDriverIdNo"] : null as any;
            this.pickupPlateNo = _data["pickupPlateNo"] !== undefined ? _data["pickupPlateNo"] : null as any;
        }
    }

    static fromJS(data: any): PageDeliveryNotesOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageDeliveryNotesOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["soldToParty"] = this.soldToParty !== undefined ? this.soldToParty : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["route"] = this.route !== undefined ? this.route : null as any;
        data["deliveryQty"] = this.deliveryQty !== undefined ? this.deliveryQty : null as any;
        data["pickedQty"] = this.pickedQty !== undefined ? this.pickedQty : null as any;
        data["shipToPartyName"] = this.shipToPartyName !== undefined ? this.shipToPartyName : null as any;
        data["streetHouseNumber"] = this.streetHouseNumber !== undefined ? this.streetHouseNumber : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["telephone"] = this.telephone !== undefined ? this.telephone : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        data["splitStatus"] = this.splitStatus !== undefined ? this.splitStatus : null as any;
        data["deliveryDisable"] = this.deliveryDisable !== undefined ? this.deliveryDisable : null as any;
        data["addressDisable"] = this.addressDisable !== undefined ? this.addressDisable : null as any;
        data["shippingType"] = this.shippingType !== undefined ? this.shippingType : null as any;
        data["shippingTypeName"] = this.shippingTypeName !== undefined ? this.shippingTypeName : null as any;
        if (Array.isArray(this.orderInformations)) {
            data["orderInformations"] = [];
            for (let item of this.orderInformations)
                data["orderInformations"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.deliveryNotesOrderItems)) {
            data["deliveryNotesOrderItems"] = [];
            for (let item of this.deliveryNotesOrderItems)
                data["deliveryNotesOrderItems"].push(item ? item.toJSON() : null as any);
        }
        data["freeFreightPrice"] = this.freeFreightPrice !== undefined ? this.freeFreightPrice : null as any;
        data["freightRate"] = this.freightRate !== undefined ? this.freightRate : null as any;
        data["minFreight"] = this.minFreight !== undefined ? this.minFreight : null as any;
        data["forLibOrderFlg"] = this.forLibOrderFlg !== undefined ? this.forLibOrderFlg : null as any;
        data["hasSpecialAttachment"] = this.hasSpecialAttachment !== undefined ? this.hasSpecialAttachment : null as any;
        data["specialAttachmentName"] = this.specialAttachmentName !== undefined ? this.specialAttachmentName : null as any;
        data["hasDeliveryRequirement"] = this.hasDeliveryRequirement !== undefined ? this.hasDeliveryRequirement : null as any;
        data["deliveryRequirementAttachmentName"] = this.deliveryRequirementAttachmentName !== undefined ? this.deliveryRequirementAttachmentName : null as any;
        data["logisticsCompleted"] = this.logisticsCompleted !== undefined ? this.logisticsCompleted : null as any;
        data["warehouseCompleted"] = this.warehouseCompleted !== undefined ? this.warehouseCompleted : null as any;
        data["pickupDriverName"] = this.pickupDriverName !== undefined ? this.pickupDriverName : null as any;
        data["pickupDriverPhone"] = this.pickupDriverPhone !== undefined ? this.pickupDriverPhone : null as any;
        data["pickupDriverIdNo"] = this.pickupDriverIdNo !== undefined ? this.pickupDriverIdNo : null as any;
        data["pickupPlateNo"] = this.pickupPlateNo !== undefined ? this.pickupPlateNo : null as any;
        return data;
    }
}

/** 根据客户编号获取已维护发货时间记录 */
export class PageDeliveryTimeForSoldToPartyInputDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | null;
    /** 客户编号 */
    soldToParty!: string | null;
    /** 是否生效 */
    isActive!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.sorting = _data["sorting"] !== undefined ? _data["sorting"] : null as any;
            this.soldToParty = _data["soldToParty"] !== undefined ? _data["soldToParty"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
        }
    }

    static fromJS(data: any): PageDeliveryTimeForSoldToPartyInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageDeliveryTimeForSoldToPartyInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["sorting"] = this.sorting !== undefined ? this.sorting : null as any;
        data["soldToParty"] = this.soldToParty !== undefined ? this.soldToParty : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        return data;
    }
}

/** 外销订单审批分页查询对象 */
export class PageExportOrderApprovalAllSearchDto {
    maxResultCount!: number;
    skipCount!: number;
    /** OMS订单号 */
    cscot!: string | null;
    /** 审核状态 */
    approvalStatus!: number | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.cscot = _data["cscot"] !== undefined ? _data["cscot"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
        }
    }

    static fromJS(data: any): PageExportOrderApprovalAllSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageExportOrderApprovalAllSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["cscot"] = this.cscot !== undefined ? this.cscot : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        return data;
    }
}

export class PageExportOrderApprovalProcessNodeConfigurationSearchInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 提交人 */
    submitter!: number | null;
    /** 节点 */
    node!: string | null;
    /** 审核人 */
    reviewedBy!: number | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.submitter = _data["submitter"] !== undefined ? _data["submitter"] : null as any;
            this.node = _data["node"] !== undefined ? _data["node"] : null as any;
            this.reviewedBy = _data["reviewedBy"] !== undefined ? _data["reviewedBy"] : null as any;
        }
    }

    static fromJS(data: any): PageExportOrderApprovalProcessNodeConfigurationSearchInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageExportOrderApprovalProcessNodeConfigurationSearchInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["submitter"] = this.submitter !== undefined ? this.submitter : null as any;
        data["node"] = this.node !== undefined ? this.node : null as any;
        data["reviewedBy"] = this.reviewedBy !== undefined ? this.reviewedBy : null as any;
        return data;
    }
}

export class PageGradeBasicMotorSearchInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 主机分类 */
    productClassification!: string | null;
    /** 主机系列 */
    basicMotorSries!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.productClassification = _data["productClassification"] !== undefined ? _data["productClassification"] : null as any;
            if (Array.isArray(_data["basicMotorSries"])) {
                this.basicMotorSries = [] as any;
                for (let item of _data["basicMotorSries"])
                    this.basicMotorSries!.push(item);
            }
            else {
                this.basicMotorSries = null as any;
            }
        }
    }

    static fromJS(data: any): PageGradeBasicMotorSearchInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageGradeBasicMotorSearchInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["productClassification"] = this.productClassification !== undefined ? this.productClassification : null as any;
        if (Array.isArray(this.basicMotorSries)) {
            data["basicMotorSries"] = [];
            for (let item of this.basicMotorSries)
                data["basicMotorSries"].push(item);
        }
        return data;
    }
}

/** 特定产品代码 */
export class PageGradeBasicMotorSearchOutputDto {
    /** 主机分类编号 */
    id!: string;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 主机分类 */
    productClassification!: string | null;
    /** 主机系列 */
    basicMotorSries!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.productClassification = _data["productClassification"] !== undefined ? _data["productClassification"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
        }
    }

    static fromJS(data: any): PageGradeBasicMotorSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageGradeBasicMotorSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["productClassification"] = this.productClassification !== undefined ? this.productClassification : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        return data;
    }
}

export class PageGradeBasicMotorSearchOutputDtoPagedResultDto {
    items!: PageGradeBasicMotorSearchOutputDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageGradeBasicMotorSearchOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PageGradeBasicMotorSearchOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageGradeBasicMotorSearchOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class PageGradeCustomerSearchInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 客户编号 */
    customerNo!: string | null;
    /** 客户名称 */
    customerName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
        }
    }

    static fromJS(data: any): PageGradeCustomerSearchInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageGradeCustomerSearchInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        return data;
    }
}

/** 分类最终客户 */
export class PageGradeCustomerSearchOutputDto {
    /** 分类最终客户编号 */
    id!: string;
    /** 客户编号 */
    customerNo!: string | null;
    /** 客户名称 */
    customerName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
        }
    }

    static fromJS(data: any): PageGradeCustomerSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageGradeCustomerSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        return data;
    }
}

export class PageGradeCustomerSearchOutputDtoPagedResultDto {
    items!: PageGradeCustomerSearchOutputDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageGradeCustomerSearchOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PageGradeCustomerSearchOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageGradeCustomerSearchOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class PageGradeLevelVcSearchInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** Vc编号 */
    vcCode!: string | null;
    /** Vc系列 */
    basicVcSries!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            if (Array.isArray(_data["basicVcSries"])) {
                this.basicVcSries = [] as any;
                for (let item of _data["basicVcSries"])
                    this.basicVcSries!.push(item);
            }
            else {
                this.basicVcSries = null as any;
            }
        }
    }

    static fromJS(data: any): PageGradeLevelVcSearchInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageGradeLevelVcSearchInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        if (Array.isArray(this.basicVcSries)) {
            data["basicVcSries"] = [];
            for (let item of this.basicVcSries)
                data["basicVcSries"].push(item);
        }
        return data;
    }
}

/** 分类2级Vc */
export class PageGradeLevelVcSearchOutputDto {
    /** 分类2级Vc编号 */
    id!: string;
    /** Vc编号 */
    vcCode!: string | null;
    /** Vc系列 */
    basicVcSries!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.basicVcSries = _data["basicVcSries"] !== undefined ? _data["basicVcSries"] : null as any;
        }
    }

    static fromJS(data: any): PageGradeLevelVcSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageGradeLevelVcSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["basicVcSries"] = this.basicVcSries !== undefined ? this.basicVcSries : null as any;
        return data;
    }
}

export class PageGradeLevelVcSearchOutputDtoPagedResultDto {
    items!: PageGradeLevelVcSearchOutputDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageGradeLevelVcSearchOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PageGradeLevelVcSearchOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageGradeLevelVcSearchOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class PageGradeVcSearchInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** Vc编号 */
    vcCode!: string | null;
    /** 主机分类 */
    productClassification!: string | null;
    /** Vc系列 */
    basicVcSries!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.productClassification = _data["productClassification"] !== undefined ? _data["productClassification"] : null as any;
            if (Array.isArray(_data["basicVcSries"])) {
                this.basicVcSries = [] as any;
                for (let item of _data["basicVcSries"])
                    this.basicVcSries!.push(item);
            }
            else {
                this.basicVcSries = null as any;
            }
        }
    }

    static fromJS(data: any): PageGradeVcSearchInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageGradeVcSearchInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["productClassification"] = this.productClassification !== undefined ? this.productClassification : null as any;
        if (Array.isArray(this.basicVcSries)) {
            data["basicVcSries"] = [];
            for (let item of this.basicVcSries)
                data["basicVcSries"].push(item);
        }
        return data;
    }
}

/** 分类Vc */
export class PageGradeVcSearchOutputDto {
    /** 分类Vc编号 */
    id!: string;
    /** Vc编号 */
    vcCode!: string | null;
    /** 主机分类 */
    productClassification!: string | null;
    /** Vc系列 */
    basicVcSries!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.productClassification = _data["productClassification"] !== undefined ? _data["productClassification"] : null as any;
            this.basicVcSries = _data["basicVcSries"] !== undefined ? _data["basicVcSries"] : null as any;
        }
    }

    static fromJS(data: any): PageGradeVcSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageGradeVcSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["productClassification"] = this.productClassification !== undefined ? this.productClassification : null as any;
        data["basicVcSries"] = this.basicVcSries !== undefined ? this.basicVcSries : null as any;
        return data;
    }
}

export class PageGradeVcSearchOutputDtoPagedResultDto {
    items!: PageGradeVcSearchOutputDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageGradeVcSearchOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PageGradeVcSearchOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageGradeVcSearchOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 查询行业列表条件 */
export class PageIndustrySearchRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | null;
    /** 行业名称关键字 */
    keyword!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.sorting = _data["sorting"] !== undefined ? _data["sorting"] : null as any;
            this.keyword = _data["keyword"] !== undefined ? _data["keyword"] : null as any;
        }
    }

    static fromJS(data: any): PageIndustrySearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageIndustrySearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["sorting"] = this.sorting !== undefined ? this.sorting : null as any;
        data["keyword"] = this.keyword !== undefined ? this.keyword : null as any;
        return data;
    }
}

/** 行业查询返回列表 */
export class PageIndustrySearchResultDto {
    /** 主键 */
    id!: string;
    /** 行业名称 */
    industryName!: string | null;
    /** 行业代码 */
    industryCode!: string | null;
    /** 境界行业简称 */
    jinIndustryCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.industryName = _data["industryName"] !== undefined ? _data["industryName"] : null as any;
            this.industryCode = _data["industryCode"] !== undefined ? _data["industryCode"] : null as any;
            this.jinIndustryCode = _data["jinIndustryCode"] !== undefined ? _data["jinIndustryCode"] : null as any;
        }
    }

    static fromJS(data: any): PageIndustrySearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageIndustrySearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["industryName"] = this.industryName !== undefined ? this.industryName : null as any;
        data["industryCode"] = this.industryCode !== undefined ? this.industryCode : null as any;
        data["jinIndustryCode"] = this.jinIndustryCode !== undefined ? this.jinIndustryCode : null as any;
        return data;
    }
}

export class PageIndustrySearchResultDtoPagedResultDto {
    items!: PageIndustrySearchResultDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageIndustrySearchResultDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PageIndustrySearchResultDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageIndustrySearchResultDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class PageJobHistoriesOutputDto {
    /** 任务Id */
    jobId!: number;
    /** 任务名称 */
    jobName!: string | null;
    jobType!: JobEnum;
    /** 任务结果状态 */
    jobStatus!: boolean | null;
    /** 任务结果(一般为下载链接) */
    jobResult!: string | null;
    /** 操作人姓名 */
    operaterName!: string | null;
    /** 开始时间 */
    startTime!: moment.Moment;
    /** 结束时间 */
    endTime!: moment.Moment | null;
    /** 重试次数 */
    retryCount!: number;

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : null as any;
            this.jobName = _data["jobName"] !== undefined ? _data["jobName"] : null as any;
            this.jobType = _data["jobType"] !== undefined ? _data["jobType"] : null as any;
            this.jobStatus = _data["jobStatus"] !== undefined ? _data["jobStatus"] : null as any;
            this.jobResult = _data["jobResult"] !== undefined ? _data["jobResult"] : null as any;
            this.operaterName = _data["operaterName"] !== undefined ? _data["operaterName"] : null as any;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : null as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : null as any;
            this.retryCount = _data["retryCount"] !== undefined ? _data["retryCount"] : null as any;
        }
    }

    static fromJS(data: any): PageJobHistoriesOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageJobHistoriesOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId !== undefined ? this.jobId : null as any;
        data["jobName"] = this.jobName !== undefined ? this.jobName : null as any;
        data["jobType"] = this.jobType !== undefined ? this.jobType : null as any;
        data["jobStatus"] = this.jobStatus !== undefined ? this.jobStatus : null as any;
        data["jobResult"] = this.jobResult !== undefined ? this.jobResult : null as any;
        data["operaterName"] = this.operaterName !== undefined ? this.operaterName : null as any;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        data["retryCount"] = this.retryCount !== undefined ? this.retryCount : null as any;
        return data;
    }
}

export class PageMaintenancePlanDto {
    id!: string | null;
    customerName!: string | null;
    materialDescriptionCh!: string | null;
    pmuSalesOrder!: string | null;
    pmuSalesOrderItem!: string | null;
    purchaseOrderDateManual!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.materialDescriptionCh = _data["materialDescriptionCh"] !== undefined ? _data["materialDescriptionCh"] : null as any;
            this.pmuSalesOrder = _data["pmuSalesOrder"] !== undefined ? _data["pmuSalesOrder"] : null as any;
            this.pmuSalesOrderItem = _data["pmuSalesOrderItem"] !== undefined ? _data["pmuSalesOrderItem"] : null as any;
            this.purchaseOrderDateManual = _data["purchaseOrderDateManual"] ? moment(_data["purchaseOrderDateManual"].toString()) : null as any;
        }
    }

    static fromJS(data: any): PageMaintenancePlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageMaintenancePlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["materialDescriptionCh"] = this.materialDescriptionCh !== undefined ? this.materialDescriptionCh : null as any;
        data["pmuSalesOrder"] = this.pmuSalesOrder !== undefined ? this.pmuSalesOrder : null as any;
        data["pmuSalesOrderItem"] = this.pmuSalesOrderItem !== undefined ? this.pmuSalesOrderItem : null as any;
        data["purchaseOrderDateManual"] = this.purchaseOrderDateManual ? this.purchaseOrderDateManual.toISOString() : null as any;
        return data;
    }
}

/** 新增物料组输入对象 */
export class PageMaterialRulesAddressInputDto {
    /** 编号 */
    id!: string | null;
    /** 客户编号 */
    soldToParty!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 地址 */
    address!: string | null;
    /** 是否生效 */
    isActive!: boolean;
    /** 起始时间 */
    startDate!: moment.Moment;
    /** 终止时间 */
    endDate!: moment.Moment;
    /** 限制物料组编码,在此范围内的物料在下单时不可编辑地址 */
    materialRules!: PageMaterialRulesInputDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.soldToParty = _data["soldToParty"] !== undefined ? _data["soldToParty"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
            if (Array.isArray(_data["materialRules"])) {
                this.materialRules = [] as any;
                for (let item of _data["materialRules"])
                    this.materialRules!.push(PageMaterialRulesInputDto.fromJS(item));
            }
            else {
                this.materialRules = null as any;
            }
        }
    }

    static fromJS(data: any): PageMaterialRulesAddressInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageMaterialRulesAddressInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["soldToParty"] = this.soldToParty !== undefined ? this.soldToParty : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["address"] = this.address !== undefined ? this.address : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        if (Array.isArray(this.materialRules)) {
            data["materialRules"] = [];
            for (let item of this.materialRules)
                data["materialRules"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 物料组规则绑定地址输出对象 */
export class PageMaterialRulesAddressOutputDto {
    /** 编号 */
    id!: string;
    /** 客户编号 */
    soldToParty!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 地址 */
    address!: string | null;
    /** 是否生效 */
    isActive!: boolean;
    /** 限制物料组编码,在此范围内的物料在下单时不可编辑地址 */
    materialRules!: PageMaterialRulesOutputDto[] | null;
    /** 起始时间 */
    startDate!: moment.Moment;
    /** 起始时间String */
    readonly startDateString!: string | null;
    /** 终止时间 */
    endDate!: moment.Moment;
    /** 终止时间String */
    readonly endDateString!: string | null;
    /** 限制物料组编码字符串显示 */
    readonly materialRulesString!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.soldToParty = _data["soldToParty"] !== undefined ? _data["soldToParty"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            if (Array.isArray(_data["materialRules"])) {
                this.materialRules = [] as any;
                for (let item of _data["materialRules"])
                    this.materialRules!.push(PageMaterialRulesOutputDto.fromJS(item));
            }
            else {
                this.materialRules = null as any;
            }
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : null as any;
            (this as any).startDateString = _data["startDateString"] !== undefined ? _data["startDateString"] : null as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
            (this as any).endDateString = _data["endDateString"] !== undefined ? _data["endDateString"] : null as any;
            (this as any).materialRulesString = _data["materialRulesString"] !== undefined ? _data["materialRulesString"] : null as any;
        }
    }

    static fromJS(data: any): PageMaterialRulesAddressOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageMaterialRulesAddressOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["soldToParty"] = this.soldToParty !== undefined ? this.soldToParty : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["address"] = this.address !== undefined ? this.address : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        if (Array.isArray(this.materialRules)) {
            data["materialRules"] = [];
            for (let item of this.materialRules)
                data["materialRules"].push(item ? item.toJSON() : null as any);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["startDateString"] = this.startDateString !== undefined ? this.startDateString : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["endDateString"] = this.endDateString !== undefined ? this.endDateString : null as any;
        data["materialRulesString"] = this.materialRulesString !== undefined ? this.materialRulesString : null as any;
        return data;
    }
}

/** 物料组规则输入对象 */
export class PageMaterialRulesInputDto {
    /** 物料组编号 */
    materialCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.materialCode = _data["materialCode"] !== undefined ? _data["materialCode"] : null as any;
        }
    }

    static fromJS(data: any): PageMaterialRulesInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageMaterialRulesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialCode"] = this.materialCode !== undefined ? this.materialCode : null as any;
        return data;
    }
}

/** 物料组规则输出对象 */
export class PageMaterialRulesOutputDto {
    /** 物料组编号 */
    materialCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.materialCode = _data["materialCode"] !== undefined ? _data["materialCode"] : null as any;
        }
    }

    static fromJS(data: any): PageMaterialRulesOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageMaterialRulesOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialCode"] = this.materialCode !== undefined ? this.materialCode : null as any;
        return data;
    }
}

export class PageOEMProductBasicMotorAllDto {
    maxResultCount!: number;
    skipCount!: number;
    /** cp客户编号 */
    cpCodes!: string[] | null;
    /** oem客户编号 */
    oemCode!: string[] | null;
    /** 客户物料号 */
    oemCustomerMaterialNumber!: string | null;
    /** 系统组合号 */
    oemProductMixCode!: string | null;
    /** 电机型号 */
    oemBasicMotorModel!: string | null;
    /** 产品代码 */
    oemBasicMotorCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            if (Array.isArray(_data["cpCodes"])) {
                this.cpCodes = [] as any;
                for (let item of _data["cpCodes"])
                    this.cpCodes!.push(item);
            }
            else {
                this.cpCodes = null as any;
            }
            if (Array.isArray(_data["oemCode"])) {
                this.oemCode = [] as any;
                for (let item of _data["oemCode"])
                    this.oemCode!.push(item);
            }
            else {
                this.oemCode = null as any;
            }
            this.oemCustomerMaterialNumber = _data["oemCustomerMaterialNumber"] !== undefined ? _data["oemCustomerMaterialNumber"] : null as any;
            this.oemProductMixCode = _data["oemProductMixCode"] !== undefined ? _data["oemProductMixCode"] : null as any;
            this.oemBasicMotorModel = _data["oemBasicMotorModel"] !== undefined ? _data["oemBasicMotorModel"] : null as any;
            this.oemBasicMotorCode = _data["oemBasicMotorCode"] !== undefined ? _data["oemBasicMotorCode"] : null as any;
        }
    }

    static fromJS(data: any): PageOEMProductBasicMotorAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageOEMProductBasicMotorAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        if (Array.isArray(this.cpCodes)) {
            data["cpCodes"] = [];
            for (let item of this.cpCodes)
                data["cpCodes"].push(item);
        }
        if (Array.isArray(this.oemCode)) {
            data["oemCode"] = [];
            for (let item of this.oemCode)
                data["oemCode"].push(item);
        }
        data["oemCustomerMaterialNumber"] = this.oemCustomerMaterialNumber !== undefined ? this.oemCustomerMaterialNumber : null as any;
        data["oemProductMixCode"] = this.oemProductMixCode !== undefined ? this.oemProductMixCode : null as any;
        data["oemBasicMotorModel"] = this.oemBasicMotorModel !== undefined ? this.oemBasicMotorModel : null as any;
        data["oemBasicMotorCode"] = this.oemBasicMotorCode !== undefined ? this.oemBasicMotorCode : null as any;
        return data;
    }
}

/** Order Dashboard 查询对象 */
export class PageOrderDashboardDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 导出类型 */
    exportType!: number | null;
    /** 订单审批状态 */
    auditStatus!: AuditStatus[] | null;
    orderStatus!: OrderStatus;
    /** 下单开始时间 - 销售提交时间 */
    startDateTime!: moment.Moment | null;
    /** 下单结束时间 - 销售提交时间 */
    endDateTime!: moment.Moment | null;
    /** 销售区域 */
    salesAreaId!: string | null;
    /** 销售区域，多个 */
    salesAreaIdList!: string[] | null;
    /** 销售区域 */
    salesUserEmail!: string | null;
    /** 销售区域，多个 */
    salesUserEmailList!: string[] | null;
    /** 客户名称 */
    endCustomerName!: string | null;
    /** 是否只看有评审号 ProductBasicMotor.AppraisalNumber
以打勾的形式显示，筛选是否有评审号的方式，订单详情产品组合行信息中的评审号，只要一行有评审号就行 */
    appraisalNumberFlg!: boolean | null;
    /** 产品规格 主机型号
productBasicMotor.BasicMotorModel */
    basicMotorModel!: string | null;
    /** 商务名称-->OrderHandling
商务返回名下Cp订单记录 Role.OrderHandling
显示该OH操作的订单
OrderHandlingApprover */
    orderHandlingId!: number | null;
    /** 已审核订单 ==> 审批时间-开始时间
需修改,已退回 ==> 退单时间-开始时间 */
    oisApprovalStartDateTime!: moment.Moment | null;
    /** 已审核订单 ==> 审批时间-下单结束时间
需修改,已退回 ==> 退单时间-下单结束时间 */
    oisApprovalEndDateTime!: moment.Moment | null;
    /** 合同号 */
    poNumber!: string | null;
    /** 选型号 */
    modelSelectionId!: string | null;
    /** 特价申请号 */
    specialOfferApplicationNumber!: string | null;
    /** 总金额范围查询1 */
    totalAmountFront!: number;
    /** 总金额范围查询2 */
    totalAmountBefore!: number;
    /** 排序方式，默认正序 */
    sortStrOrder!: string[] | null;
    /** 直接客户 */
    finalCustomer!: string | null;
    /** 最终用户所在国家 */
    locationCountry!: string | null;
    /** 开口项 */
    openItems!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.exportType = _data["exportType"] !== undefined ? _data["exportType"] : null as any;
            if (Array.isArray(_data["auditStatus"])) {
                this.auditStatus = [] as any;
                for (let item of _data["auditStatus"])
                    this.auditStatus!.push(item);
            }
            else {
                this.auditStatus = null as any;
            }
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : null as any;
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : null as any;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : null as any;
            this.salesAreaId = _data["salesAreaId"] !== undefined ? _data["salesAreaId"] : null as any;
            if (Array.isArray(_data["salesAreaIdList"])) {
                this.salesAreaIdList = [] as any;
                for (let item of _data["salesAreaIdList"])
                    this.salesAreaIdList!.push(item);
            }
            else {
                this.salesAreaIdList = null as any;
            }
            this.salesUserEmail = _data["salesUserEmail"] !== undefined ? _data["salesUserEmail"] : null as any;
            if (Array.isArray(_data["salesUserEmailList"])) {
                this.salesUserEmailList = [] as any;
                for (let item of _data["salesUserEmailList"])
                    this.salesUserEmailList!.push(item);
            }
            else {
                this.salesUserEmailList = null as any;
            }
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.appraisalNumberFlg = _data["appraisalNumberFlg"] !== undefined ? _data["appraisalNumberFlg"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.orderHandlingId = _data["orderHandlingId"] !== undefined ? _data["orderHandlingId"] : null as any;
            this.oisApprovalStartDateTime = _data["oisApprovalStartDateTime"] ? moment(_data["oisApprovalStartDateTime"].toString()) : null as any;
            this.oisApprovalEndDateTime = _data["oisApprovalEndDateTime"] ? moment(_data["oisApprovalEndDateTime"].toString()) : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.modelSelectionId = _data["modelSelectionId"] !== undefined ? _data["modelSelectionId"] : null as any;
            this.specialOfferApplicationNumber = _data["specialOfferApplicationNumber"] !== undefined ? _data["specialOfferApplicationNumber"] : null as any;
            this.totalAmountFront = _data["totalAmountFront"] !== undefined ? _data["totalAmountFront"] : null as any;
            this.totalAmountBefore = _data["totalAmountBefore"] !== undefined ? _data["totalAmountBefore"] : null as any;
            if (Array.isArray(_data["sortStrOrder"])) {
                this.sortStrOrder = [] as any;
                for (let item of _data["sortStrOrder"])
                    this.sortStrOrder!.push(item);
            }
            else {
                this.sortStrOrder = null as any;
            }
            this.finalCustomer = _data["finalCustomer"] !== undefined ? _data["finalCustomer"] : null as any;
            this.locationCountry = _data["locationCountry"] !== undefined ? _data["locationCountry"] : null as any;
            if (Array.isArray(_data["openItems"])) {
                this.openItems = [] as any;
                for (let item of _data["openItems"])
                    this.openItems!.push(item);
            }
            else {
                this.openItems = null as any;
            }
        }
    }

    static fromJS(data: any): PageOrderDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageOrderDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["exportType"] = this.exportType !== undefined ? this.exportType : null as any;
        if (Array.isArray(this.auditStatus)) {
            data["auditStatus"] = [];
            for (let item of this.auditStatus)
                data["auditStatus"].push(item);
        }
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : null as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : null as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : null as any;
        data["salesAreaId"] = this.salesAreaId !== undefined ? this.salesAreaId : null as any;
        if (Array.isArray(this.salesAreaIdList)) {
            data["salesAreaIdList"] = [];
            for (let item of this.salesAreaIdList)
                data["salesAreaIdList"].push(item);
        }
        data["salesUserEmail"] = this.salesUserEmail !== undefined ? this.salesUserEmail : null as any;
        if (Array.isArray(this.salesUserEmailList)) {
            data["salesUserEmailList"] = [];
            for (let item of this.salesUserEmailList)
                data["salesUserEmailList"].push(item);
        }
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["appraisalNumberFlg"] = this.appraisalNumberFlg !== undefined ? this.appraisalNumberFlg : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["orderHandlingId"] = this.orderHandlingId !== undefined ? this.orderHandlingId : null as any;
        data["oisApprovalStartDateTime"] = this.oisApprovalStartDateTime ? this.oisApprovalStartDateTime.toISOString() : null as any;
        data["oisApprovalEndDateTime"] = this.oisApprovalEndDateTime ? this.oisApprovalEndDateTime.toISOString() : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["modelSelectionId"] = this.modelSelectionId !== undefined ? this.modelSelectionId : null as any;
        data["specialOfferApplicationNumber"] = this.specialOfferApplicationNumber !== undefined ? this.specialOfferApplicationNumber : null as any;
        data["totalAmountFront"] = this.totalAmountFront !== undefined ? this.totalAmountFront : null as any;
        data["totalAmountBefore"] = this.totalAmountBefore !== undefined ? this.totalAmountBefore : null as any;
        if (Array.isArray(this.sortStrOrder)) {
            data["sortStrOrder"] = [];
            for (let item of this.sortStrOrder)
                data["sortStrOrder"].push(item);
        }
        data["finalCustomer"] = this.finalCustomer !== undefined ? this.finalCustomer : null as any;
        data["locationCountry"] = this.locationCountry !== undefined ? this.locationCountry : null as any;
        if (Array.isArray(this.openItems)) {
            data["openItems"] = [];
            for (let item of this.openItems)
                data["openItems"].push(item);
        }
        return data;
    }
}

export class PageOrderFormAllDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 来源 SOI/MOI */
    sourceId!: string | null;
    /** PO号 */
    poNumber!: string | null;
    /** 特价申请号 */
    specialOfferApplicationNumber!: string | null;
    /** 最终客户 */
    endCustomerName!: string | null;
    /** 最终地址 */
    shippingAddress!: string | null;
    /** 订单状态 */
    orderStatus!: number | null;
    /** 开始时间 */
    startDateTime!: moment.Moment | null;
    /** 结束时间 */
    endDateTime!: moment.Moment | null;
    /** 完成开始时间 */
    completeStartDateTime!: moment.Moment | null;
    /** 完成结束时间 */
    completeEndDateTime!: moment.Moment | null;
    /** 排序方式 */
    sortOrder!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 销售 */
    salesName!: string | null;
    /** 行业 */
    industryName!: string | null;
    /** 直接客户 */
    finalCustomer!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.specialOfferApplicationNumber = _data["specialOfferApplicationNumber"] !== undefined ? _data["specialOfferApplicationNumber"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.shippingAddress = _data["shippingAddress"] !== undefined ? _data["shippingAddress"] : null as any;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : null as any;
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : null as any;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : null as any;
            this.completeStartDateTime = _data["completeStartDateTime"] ? moment(_data["completeStartDateTime"].toString()) : null as any;
            this.completeEndDateTime = _data["completeEndDateTime"] ? moment(_data["completeEndDateTime"].toString()) : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.salesName = _data["salesName"] !== undefined ? _data["salesName"] : null as any;
            this.industryName = _data["industryName"] !== undefined ? _data["industryName"] : null as any;
            this.finalCustomer = _data["finalCustomer"] !== undefined ? _data["finalCustomer"] : null as any;
        }
    }

    static fromJS(data: any): PageOrderFormAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageOrderFormAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["sourceId"] = this.sourceId !== undefined ? this.sourceId : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["specialOfferApplicationNumber"] = this.specialOfferApplicationNumber !== undefined ? this.specialOfferApplicationNumber : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["shippingAddress"] = this.shippingAddress !== undefined ? this.shippingAddress : null as any;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : null as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : null as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : null as any;
        data["completeStartDateTime"] = this.completeStartDateTime ? this.completeStartDateTime.toISOString() : null as any;
        data["completeEndDateTime"] = this.completeEndDateTime ? this.completeEndDateTime.toISOString() : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["salesName"] = this.salesName !== undefined ? this.salesName : null as any;
        data["industryName"] = this.industryName !== undefined ? this.industryName : null as any;
        data["finalCustomer"] = this.finalCustomer !== undefined ? this.finalCustomer : null as any;
        return data;
    }
}

export class PageOrderFormApprovalAllDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 导出类型 */
    exportType!: number | null;
    /** 合同号 */
    poNumber!: string | null;
    /** 客户名称 */
    endCustomerName!: string | null;
    /** 审核状态 */
    auditStatus!: number | null;
    /** 是否仅显示有评审号 */
    appraisalNumberFlg!: boolean | null;
    /** 销售区域名称 */
    salesAreaId!: string | null;
    /** 制单人 */
    creationName!: string | null;
    /** 开始时间 */
    startDateTime!: moment.Moment | null;
    /** 结束时间 */
    endDateTime!: moment.Moment | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 自动化状态 */
    automateStatus!: AutomateStatusEnum[] | null;
    /** 是否录入OMS系统 */
    isEnterOMS!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.exportType = _data["exportType"] !== undefined ? _data["exportType"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.auditStatus = _data["auditStatus"] !== undefined ? _data["auditStatus"] : null as any;
            this.appraisalNumberFlg = _data["appraisalNumberFlg"] !== undefined ? _data["appraisalNumberFlg"] : null as any;
            this.salesAreaId = _data["salesAreaId"] !== undefined ? _data["salesAreaId"] : null as any;
            this.creationName = _data["creationName"] !== undefined ? _data["creationName"] : null as any;
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : null as any;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            if (Array.isArray(_data["automateStatus"])) {
                this.automateStatus = [] as any;
                for (let item of _data["automateStatus"])
                    this.automateStatus!.push(item);
            }
            else {
                this.automateStatus = null as any;
            }
            this.isEnterOMS = _data["isEnterOMS"] !== undefined ? _data["isEnterOMS"] : null as any;
        }
    }

    static fromJS(data: any): PageOrderFormApprovalAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageOrderFormApprovalAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["exportType"] = this.exportType !== undefined ? this.exportType : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["auditStatus"] = this.auditStatus !== undefined ? this.auditStatus : null as any;
        data["appraisalNumberFlg"] = this.appraisalNumberFlg !== undefined ? this.appraisalNumberFlg : null as any;
        data["salesAreaId"] = this.salesAreaId !== undefined ? this.salesAreaId : null as any;
        data["creationName"] = this.creationName !== undefined ? this.creationName : null as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : null as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        if (Array.isArray(this.automateStatus)) {
            data["automateStatus"] = [];
            for (let item of this.automateStatus)
                data["automateStatus"].push(item);
        }
        data["isEnterOMS"] = this.isEnterOMS !== undefined ? this.isEnterOMS : null as any;
        return data;
    }
}

/** 订单输出对象 */
export class PageOrderOutputDto {
    /** 编号 */
    id!: string;
    /** 客户编号 */
    soldToParty!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 订单创建日期 */
    creationTime!: moment.Moment;
    /** 订单创建人 */
    creatorUser!: string | null;
    /** LSU订单号 (SAP订单号 ) */
    lsuSalesOrder!: string | null;
    /** LSU项目号  (SAP项目号 ) */
    lsuItem!: string | null;
    /** PMU订单号 (内部订单号 ) */
    pmuSalesOrder!: string | null;
    /** PMU项目号  (内部订单号行 ) */
    pmuSalesOrderItem!: string | null;
    /** 内部订单项目行 */
    pmuSoitemCategory!: string | null;
    /** 项目类别描述 */
    soItemCategoryText!: string | null;
    /** 物料编码 */
    material!: string | null;
    /** 物料描述 */
    materialDescriptionEn!: string | null;
    /** 物料描述 */
    materialDescriptionCh!: string | null;
    /** LSU订单数量 */
    lsuOrderQty!: number;
    /** 销售雇员名字 */
    lsuSalesEngineerName!: string | null;
    /** 库存数量 */
    pmuStock!: number;
    /** 最后一次收货日期 */
    lastGoodsReceiptDate!: moment.Moment | null;
    /** 最后一次收货日期 */
    readonly lastGoodsReceiptDateString!: string | null;
    /** 计划装配日期 */
    purchaseOrderDate!: moment.Moment | null;
    /** 计划装配日期 */
    readonly purchaseOrderDateString!: string | null;
    /** 已发数量 */
    pmuDnQty!: number;
    /** 合同号 */
    lsuContractNumber!: string | null;
    /** 金额（不含税）
净价 */
    lsuUnitPrice!: number;
    /** 金额（含税）- 最新字段 */
    unitPriceWithTax!: number;
    /** 客户需求日期 */
    requestDeliveryDate!: moment.Moment | null;
    /** 开票金额 */
    lsuBillingAmountWithoutTax!: number;
    /** 客户采购订单号 */
    customerPo!: string | null;
    /** 物料组 */
    materialGroup!: string | null;
    /** 库存状态
货已备齐, 货未备齐, 部分备齐 */
    stockStatus!: number | null;
    /** 对应提货单的子项数量 */
    lsuRowSpan!: number;
    /** 是否合并行 */
    lsuIsMerge!: boolean;
    lsuFreightAll!: number;
    /** 修改时间 */
    lastModificationTime!: moment.Moment | null;
    /** 修改时间 */
    readonly lastModificationTimeString!: string | null;
    /** 是否 可查询 OIS_ProductBasicMotor_Mts（合同号+行号） */
    isMts!: string | null;
    /** 订单业务类型 */
    orderBusinessType!: number | null;
    /** 境界类别代码 */
    jinCategoryCode!: string | null;
    /** 境界版本 */
    jinVersion!: string | null;
    /** 是否加急 */
    isUrgent!: boolean | null;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** 加急选择是否可用 */
    isUrgentEnable!: boolean;
    /** 4D订单强关联 */
    isOrderCorrelation_4D!: boolean;
    deliveryNotesOutputs!: PageDeliveryNotesOutputDto;
    deliveryNotesOrderItemOutputs!: PageDeliveryNotesOrderItemOutputDto;
    /** 对应提货单的子项数量 */
    rowSpan!: number;
    /** 是否合并行 */
    isMerge!: boolean;
    /** 是否有重试功能 */
    isRetry!: boolean;
    /** 提交人 */
    submitUser!: string | null;
    /** 产品组/Division */
    productGroup!: string | null;
    /** 产品组/Division */
    readonly productGroupName!: string | null;
    /** 第一次绿灯时间 */
    firstStockDate!: moment.Moment | null;
    /** DN历史状态 */
    dnLockHistoryFlag!: boolean;
    /** 客户物料代码 */
    customerProdNo!: string | null;
    /** 是否可查看境界对应的标准代码 */
    isShowJIN!: boolean;
    jINCodeStandardProductOutDto!: JINCodeStandardProductOutDto;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.soldToParty = _data["soldToParty"] !== undefined ? _data["soldToParty"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUser = _data["creatorUser"] !== undefined ? _data["creatorUser"] : null as any;
            this.lsuSalesOrder = _data["lsuSalesOrder"] !== undefined ? _data["lsuSalesOrder"] : null as any;
            this.lsuItem = _data["lsuItem"] !== undefined ? _data["lsuItem"] : null as any;
            this.pmuSalesOrder = _data["pmuSalesOrder"] !== undefined ? _data["pmuSalesOrder"] : null as any;
            this.pmuSalesOrderItem = _data["pmuSalesOrderItem"] !== undefined ? _data["pmuSalesOrderItem"] : null as any;
            this.pmuSoitemCategory = _data["pmuSoitemCategory"] !== undefined ? _data["pmuSoitemCategory"] : null as any;
            this.soItemCategoryText = _data["soItemCategoryText"] !== undefined ? _data["soItemCategoryText"] : null as any;
            this.material = _data["material"] !== undefined ? _data["material"] : null as any;
            this.materialDescriptionEn = _data["materialDescriptionEn"] !== undefined ? _data["materialDescriptionEn"] : null as any;
            this.materialDescriptionCh = _data["materialDescriptionCh"] !== undefined ? _data["materialDescriptionCh"] : null as any;
            this.lsuOrderQty = _data["lsuOrderQty"] !== undefined ? _data["lsuOrderQty"] : null as any;
            this.lsuSalesEngineerName = _data["lsuSalesEngineerName"] !== undefined ? _data["lsuSalesEngineerName"] : null as any;
            this.pmuStock = _data["pmuStock"] !== undefined ? _data["pmuStock"] : null as any;
            this.lastGoodsReceiptDate = _data["lastGoodsReceiptDate"] ? moment(_data["lastGoodsReceiptDate"].toString()) : null as any;
            (this as any).lastGoodsReceiptDateString = _data["lastGoodsReceiptDateString"] !== undefined ? _data["lastGoodsReceiptDateString"] : null as any;
            this.purchaseOrderDate = _data["purchaseOrderDate"] ? moment(_data["purchaseOrderDate"].toString()) : null as any;
            (this as any).purchaseOrderDateString = _data["purchaseOrderDateString"] !== undefined ? _data["purchaseOrderDateString"] : null as any;
            this.pmuDnQty = _data["pmuDnQty"] !== undefined ? _data["pmuDnQty"] : null as any;
            this.lsuContractNumber = _data["lsuContractNumber"] !== undefined ? _data["lsuContractNumber"] : null as any;
            this.lsuUnitPrice = _data["lsuUnitPrice"] !== undefined ? _data["lsuUnitPrice"] : null as any;
            this.unitPriceWithTax = _data["unitPriceWithTax"] !== undefined ? _data["unitPriceWithTax"] : null as any;
            this.requestDeliveryDate = _data["requestDeliveryDate"] ? moment(_data["requestDeliveryDate"].toString()) : null as any;
            this.lsuBillingAmountWithoutTax = _data["lsuBillingAmountWithoutTax"] !== undefined ? _data["lsuBillingAmountWithoutTax"] : null as any;
            this.customerPo = _data["customerPo"] !== undefined ? _data["customerPo"] : null as any;
            this.materialGroup = _data["materialGroup"] !== undefined ? _data["materialGroup"] : null as any;
            this.stockStatus = _data["stockStatus"] !== undefined ? _data["stockStatus"] : null as any;
            this.lsuRowSpan = _data["lsuRowSpan"] !== undefined ? _data["lsuRowSpan"] : null as any;
            this.lsuIsMerge = _data["lsuIsMerge"] !== undefined ? _data["lsuIsMerge"] : null as any;
            this.lsuFreightAll = _data["lsuFreightAll"] !== undefined ? _data["lsuFreightAll"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            (this as any).lastModificationTimeString = _data["lastModificationTimeString"] !== undefined ? _data["lastModificationTimeString"] : null as any;
            this.isMts = _data["isMts"] !== undefined ? _data["isMts"] : null as any;
            this.orderBusinessType = _data["orderBusinessType"] !== undefined ? _data["orderBusinessType"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.isUrgent = _data["isUrgent"] !== undefined ? _data["isUrgent"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.isUrgentEnable = _data["isUrgentEnable"] !== undefined ? _data["isUrgentEnable"] : null as any;
            this.isOrderCorrelation_4D = _data["isOrderCorrelation_4D"] !== undefined ? _data["isOrderCorrelation_4D"] : null as any;
            this.deliveryNotesOutputs = _data["deliveryNotesOutputs"] ? PageDeliveryNotesOutputDto.fromJS(_data["deliveryNotesOutputs"]) : null as any;
            this.deliveryNotesOrderItemOutputs = _data["deliveryNotesOrderItemOutputs"] ? PageDeliveryNotesOrderItemOutputDto.fromJS(_data["deliveryNotesOrderItemOutputs"]) : null as any;
            this.rowSpan = _data["rowSpan"] !== undefined ? _data["rowSpan"] : null as any;
            this.isMerge = _data["isMerge"] !== undefined ? _data["isMerge"] : null as any;
            this.isRetry = _data["isRetry"] !== undefined ? _data["isRetry"] : null as any;
            this.submitUser = _data["submitUser"] !== undefined ? _data["submitUser"] : null as any;
            this.productGroup = _data["productGroup"] !== undefined ? _data["productGroup"] : null as any;
            (this as any).productGroupName = _data["productGroupName"] !== undefined ? _data["productGroupName"] : null as any;
            this.firstStockDate = _data["firstStockDate"] ? moment(_data["firstStockDate"].toString()) : null as any;
            this.dnLockHistoryFlag = _data["dnLockHistoryFlag"] !== undefined ? _data["dnLockHistoryFlag"] : null as any;
            this.customerProdNo = _data["customerProdNo"] !== undefined ? _data["customerProdNo"] : null as any;
            this.isShowJIN = _data["isShowJIN"] !== undefined ? _data["isShowJIN"] : null as any;
            this.jINCodeStandardProductOutDto = _data["jINCodeStandardProductOutDto"] ? JINCodeStandardProductOutDto.fromJS(_data["jINCodeStandardProductOutDto"]) : null as any;
        }
    }

    static fromJS(data: any): PageOrderOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageOrderOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["soldToParty"] = this.soldToParty !== undefined ? this.soldToParty : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUser"] = this.creatorUser !== undefined ? this.creatorUser : null as any;
        data["lsuSalesOrder"] = this.lsuSalesOrder !== undefined ? this.lsuSalesOrder : null as any;
        data["lsuItem"] = this.lsuItem !== undefined ? this.lsuItem : null as any;
        data["pmuSalesOrder"] = this.pmuSalesOrder !== undefined ? this.pmuSalesOrder : null as any;
        data["pmuSalesOrderItem"] = this.pmuSalesOrderItem !== undefined ? this.pmuSalesOrderItem : null as any;
        data["pmuSoitemCategory"] = this.pmuSoitemCategory !== undefined ? this.pmuSoitemCategory : null as any;
        data["soItemCategoryText"] = this.soItemCategoryText !== undefined ? this.soItemCategoryText : null as any;
        data["material"] = this.material !== undefined ? this.material : null as any;
        data["materialDescriptionEn"] = this.materialDescriptionEn !== undefined ? this.materialDescriptionEn : null as any;
        data["materialDescriptionCh"] = this.materialDescriptionCh !== undefined ? this.materialDescriptionCh : null as any;
        data["lsuOrderQty"] = this.lsuOrderQty !== undefined ? this.lsuOrderQty : null as any;
        data["lsuSalesEngineerName"] = this.lsuSalesEngineerName !== undefined ? this.lsuSalesEngineerName : null as any;
        data["pmuStock"] = this.pmuStock !== undefined ? this.pmuStock : null as any;
        data["lastGoodsReceiptDate"] = this.lastGoodsReceiptDate ? this.lastGoodsReceiptDate.toISOString() : null as any;
        data["lastGoodsReceiptDateString"] = this.lastGoodsReceiptDateString !== undefined ? this.lastGoodsReceiptDateString : null as any;
        data["purchaseOrderDate"] = this.purchaseOrderDate ? this.purchaseOrderDate.toISOString() : null as any;
        data["purchaseOrderDateString"] = this.purchaseOrderDateString !== undefined ? this.purchaseOrderDateString : null as any;
        data["pmuDnQty"] = this.pmuDnQty !== undefined ? this.pmuDnQty : null as any;
        data["lsuContractNumber"] = this.lsuContractNumber !== undefined ? this.lsuContractNumber : null as any;
        data["lsuUnitPrice"] = this.lsuUnitPrice !== undefined ? this.lsuUnitPrice : null as any;
        data["unitPriceWithTax"] = this.unitPriceWithTax !== undefined ? this.unitPriceWithTax : null as any;
        data["requestDeliveryDate"] = this.requestDeliveryDate ? this.requestDeliveryDate.toISOString() : null as any;
        data["lsuBillingAmountWithoutTax"] = this.lsuBillingAmountWithoutTax !== undefined ? this.lsuBillingAmountWithoutTax : null as any;
        data["customerPo"] = this.customerPo !== undefined ? this.customerPo : null as any;
        data["materialGroup"] = this.materialGroup !== undefined ? this.materialGroup : null as any;
        data["stockStatus"] = this.stockStatus !== undefined ? this.stockStatus : null as any;
        data["lsuRowSpan"] = this.lsuRowSpan !== undefined ? this.lsuRowSpan : null as any;
        data["lsuIsMerge"] = this.lsuIsMerge !== undefined ? this.lsuIsMerge : null as any;
        data["lsuFreightAll"] = this.lsuFreightAll !== undefined ? this.lsuFreightAll : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModificationTimeString"] = this.lastModificationTimeString !== undefined ? this.lastModificationTimeString : null as any;
        data["isMts"] = this.isMts !== undefined ? this.isMts : null as any;
        data["orderBusinessType"] = this.orderBusinessType !== undefined ? this.orderBusinessType : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["isUrgent"] = this.isUrgent !== undefined ? this.isUrgent : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["isUrgentEnable"] = this.isUrgentEnable !== undefined ? this.isUrgentEnable : null as any;
        data["isOrderCorrelation_4D"] = this.isOrderCorrelation_4D !== undefined ? this.isOrderCorrelation_4D : null as any;
        data["deliveryNotesOutputs"] = this.deliveryNotesOutputs ? this.deliveryNotesOutputs.toJSON() : null as any;
        data["deliveryNotesOrderItemOutputs"] = this.deliveryNotesOrderItemOutputs ? this.deliveryNotesOrderItemOutputs.toJSON() : null as any;
        data["rowSpan"] = this.rowSpan !== undefined ? this.rowSpan : null as any;
        data["isMerge"] = this.isMerge !== undefined ? this.isMerge : null as any;
        data["isRetry"] = this.isRetry !== undefined ? this.isRetry : null as any;
        data["submitUser"] = this.submitUser !== undefined ? this.submitUser : null as any;
        data["productGroup"] = this.productGroup !== undefined ? this.productGroup : null as any;
        data["productGroupName"] = this.productGroupName !== undefined ? this.productGroupName : null as any;
        data["firstStockDate"] = this.firstStockDate ? this.firstStockDate.toISOString() : null as any;
        data["dnLockHistoryFlag"] = this.dnLockHistoryFlag !== undefined ? this.dnLockHistoryFlag : null as any;
        data["customerProdNo"] = this.customerProdNo !== undefined ? this.customerProdNo : null as any;
        data["isShowJIN"] = this.isShowJIN !== undefined ? this.isShowJIN : null as any;
        data["jINCodeStandardProductOutDto"] = this.jINCodeStandardProductOutDto ? this.jINCodeStandardProductOutDto.toJSON() : null as any;
        return data;
    }
}

export class PageOrderQuantityLimitSearchInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 第一层级 */
    level1!: string | null;
    /** 第二层级 */
    level2!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.level1 = _data["level1"] !== undefined ? _data["level1"] : null as any;
            this.level2 = _data["level2"] !== undefined ? _data["level2"] : null as any;
        }
    }

    static fromJS(data: any): PageOrderQuantityLimitSearchInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageOrderQuantityLimitSearchInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["level1"] = this.level1 !== undefined ? this.level1 : null as any;
        data["level2"] = this.level2 !== undefined ? this.level2 : null as any;
        return data;
    }
}

/** 销售区域 */
export class PageOrderQuantityLimitSearchOutputDto {
    id!: string;
    /** 第一层级 */
    level1!: string | null;
    /** 第二层级 */
    level2!: string | null;
    /** 最小基座号 */
    minFrameSize!: number;
    /** 最大基座号 */
    maxFrameSize!: number;
    /** 数量 */
    number!: number;
    /** 提醒信息 */
    message!: string | null;
    type!: QuantityLimitType;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.level1 = _data["level1"] !== undefined ? _data["level1"] : null as any;
            this.level2 = _data["level2"] !== undefined ? _data["level2"] : null as any;
            this.minFrameSize = _data["minFrameSize"] !== undefined ? _data["minFrameSize"] : null as any;
            this.maxFrameSize = _data["maxFrameSize"] !== undefined ? _data["maxFrameSize"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): PageOrderQuantityLimitSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageOrderQuantityLimitSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["level1"] = this.level1 !== undefined ? this.level1 : null as any;
        data["level2"] = this.level2 !== undefined ? this.level2 : null as any;
        data["minFrameSize"] = this.minFrameSize !== undefined ? this.minFrameSize : null as any;
        data["maxFrameSize"] = this.maxFrameSize !== undefined ? this.maxFrameSize : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }
}

export class PageOrderQuantityLimitSearchOutputDtoPagedResultDto {
    items!: PageOrderQuantityLimitSearchOutputDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageOrderQuantityLimitSearchOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PageOrderQuantityLimitSearchOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageOrderQuantityLimitSearchOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 低压可视化-订单信息列表展示 */
export class PageOrderVisualizationDto {
    /** 总数 */
    totalCount!: number;
    /** 库存分配锁定状态提醒 */
    deliveryLockTipFlg!: boolean;
    items!: PageOrderVisualizationOutputDto[] | null;
    mpItems!: PageMaintenancePlanDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            this.deliveryLockTipFlg = _data["deliveryLockTipFlg"] !== undefined ? _data["deliveryLockTipFlg"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageOrderVisualizationOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["mpItems"])) {
                this.mpItems = [] as any;
                for (let item of _data["mpItems"])
                    this.mpItems!.push(PageMaintenancePlanDto.fromJS(item));
            }
            else {
                this.mpItems = null as any;
            }
        }
    }

    static fromJS(data: any): PageOrderVisualizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageOrderVisualizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        data["deliveryLockTipFlg"] = this.deliveryLockTipFlg !== undefined ? this.deliveryLockTipFlg : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.mpItems)) {
            data["mpItems"] = [];
            for (let item of this.mpItems)
                data["mpItems"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 低压可视化-订单行信息列表展示--二级展示字段 */
export class PageOrderVisualizationItemOutputDto {
    /** 编号 OrderId */
    id!: string;
    /** LSU订单号 (SAP订单号 ) */
    lsuSalesOrder!: string | null;
    /** LSU项目号  (SAP项目号 ) */
    lsuItem!: string | null;
    /** PMU订单号 (内部订单号 ) */
    pmuSalesOrder!: string | null;
    /** PMU项目号  (内部订单号行 ) */
    pmuSalesOrderItem!: string | null;
    /** LSU订单数量(订单数量) */
    lsuOrderQty!: number;
    /** 物料编码(物料代码) */
    material!: string | null;
    /** 物料描述 */
    materialDescriptionCh!: string | null;
    /** 币种 */
    lsuSoCurr!: string | null;
    /** 含税总金额
LSU订单行金额（含税） */
    lsuItemValueWithTax!: number;
    /** 不含税总金额
LSU订单行金额（不含税） */
    lsuItemValue!: number;
    /** 含税单价 */
    unitPriceWithTax!: number;
    /** 不含税单价
净价 */
    lsuUnitPrice!: number;
    /** 客户需求日期 */
    requestDeliveryDate!: moment.Moment | null;
    readonly requestDeliveryDateString!: string | null;
    /** 库存数量 */
    pmuStock!: number;
    /** 已点发数量 */
    pmuDnQty!: number;
    /** 已出库数量 */
    lsugiQtyTotal!: number;
    /** 计划出库日期 */
    purchaseOrderDate!: moment.Moment | null;
    /** 计划出库日期 */
    readonly purchaseOrderDateString!: string | null;
    /** 备注 */
    remark!: string | null;
    /** 客户物料代码 */
    customerProdNo!: string | null;
    /** 第一次入库时间
第一次绿灯的日期
默认为null */
    firstStockDate!: moment.Moment | null;
    readonly firstStockDateString!: string | null;
    /** 产品组 */
    pg!: string | null;
    /** 二级客户名称 */
    endCustomerName!: string | null;
    /** Precal号码 */
    projectName!: string | null;
    /** 内部订单项目行 */
    pmuSoitemCategory!: string | null;
    /** 项目类别描述 */
    soItemCategoryText!: string | null;
    /** 销售雇员名字 */
    lsuSalesEngineerName!: string | null;
    /** 产品规格 主机型号 
MaterialDescriptionEn 取这个值第一个*之前的内容 */
    basicMotorModel!: string | null;
    /** 境界标识符 */
    jinCategoryCode!: string | null;
    /** 库存状态
货已备齐, 货未备齐, 部分备齐
（点黄灯显示数量，只有黄灯显示，悬停） */
    stockStatus!: number | null;
    /** 库存状态
货已备齐, 货未备齐, 部分备齐
（点黄灯显示数量，只有黄灯显示，悬停） */
    readonly stockStatusStr!: string | null;
    /** 是否可查看境界对应的标准代码 */
    isShowJIN!: boolean;
    jINCodeStandardProductOutDto!: JINCodeStandardProductOutDto;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** 是否 可查询 OIS_ProductBasicMotor_Mts（合同号+行号） */
    isMts!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.lsuSalesOrder = _data["lsuSalesOrder"] !== undefined ? _data["lsuSalesOrder"] : null as any;
            this.lsuItem = _data["lsuItem"] !== undefined ? _data["lsuItem"] : null as any;
            this.pmuSalesOrder = _data["pmuSalesOrder"] !== undefined ? _data["pmuSalesOrder"] : null as any;
            this.pmuSalesOrderItem = _data["pmuSalesOrderItem"] !== undefined ? _data["pmuSalesOrderItem"] : null as any;
            this.lsuOrderQty = _data["lsuOrderQty"] !== undefined ? _data["lsuOrderQty"] : null as any;
            this.material = _data["material"] !== undefined ? _data["material"] : null as any;
            this.materialDescriptionCh = _data["materialDescriptionCh"] !== undefined ? _data["materialDescriptionCh"] : null as any;
            this.lsuSoCurr = _data["lsuSoCurr"] !== undefined ? _data["lsuSoCurr"] : null as any;
            this.lsuItemValueWithTax = _data["lsuItemValueWithTax"] !== undefined ? _data["lsuItemValueWithTax"] : null as any;
            this.lsuItemValue = _data["lsuItemValue"] !== undefined ? _data["lsuItemValue"] : null as any;
            this.unitPriceWithTax = _data["unitPriceWithTax"] !== undefined ? _data["unitPriceWithTax"] : null as any;
            this.lsuUnitPrice = _data["lsuUnitPrice"] !== undefined ? _data["lsuUnitPrice"] : null as any;
            this.requestDeliveryDate = _data["requestDeliveryDate"] ? moment(_data["requestDeliveryDate"].toString()) : null as any;
            (this as any).requestDeliveryDateString = _data["requestDeliveryDateString"] !== undefined ? _data["requestDeliveryDateString"] : null as any;
            this.pmuStock = _data["pmuStock"] !== undefined ? _data["pmuStock"] : null as any;
            this.pmuDnQty = _data["pmuDnQty"] !== undefined ? _data["pmuDnQty"] : null as any;
            this.lsugiQtyTotal = _data["lsugiQtyTotal"] !== undefined ? _data["lsugiQtyTotal"] : null as any;
            this.purchaseOrderDate = _data["purchaseOrderDate"] ? moment(_data["purchaseOrderDate"].toString()) : null as any;
            (this as any).purchaseOrderDateString = _data["purchaseOrderDateString"] !== undefined ? _data["purchaseOrderDateString"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.customerProdNo = _data["customerProdNo"] !== undefined ? _data["customerProdNo"] : null as any;
            this.firstStockDate = _data["firstStockDate"] ? moment(_data["firstStockDate"].toString()) : null as any;
            (this as any).firstStockDateString = _data["firstStockDateString"] !== undefined ? _data["firstStockDateString"] : null as any;
            this.pg = _data["pg"] !== undefined ? _data["pg"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.pmuSoitemCategory = _data["pmuSoitemCategory"] !== undefined ? _data["pmuSoitemCategory"] : null as any;
            this.soItemCategoryText = _data["soItemCategoryText"] !== undefined ? _data["soItemCategoryText"] : null as any;
            this.lsuSalesEngineerName = _data["lsuSalesEngineerName"] !== undefined ? _data["lsuSalesEngineerName"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.stockStatus = _data["stockStatus"] !== undefined ? _data["stockStatus"] : null as any;
            (this as any).stockStatusStr = _data["stockStatusStr"] !== undefined ? _data["stockStatusStr"] : null as any;
            this.isShowJIN = _data["isShowJIN"] !== undefined ? _data["isShowJIN"] : null as any;
            this.jINCodeStandardProductOutDto = _data["jINCodeStandardProductOutDto"] ? JINCodeStandardProductOutDto.fromJS(_data["jINCodeStandardProductOutDto"]) : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.isMts = _data["isMts"] !== undefined ? _data["isMts"] : null as any;
        }
    }

    static fromJS(data: any): PageOrderVisualizationItemOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageOrderVisualizationItemOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["lsuSalesOrder"] = this.lsuSalesOrder !== undefined ? this.lsuSalesOrder : null as any;
        data["lsuItem"] = this.lsuItem !== undefined ? this.lsuItem : null as any;
        data["pmuSalesOrder"] = this.pmuSalesOrder !== undefined ? this.pmuSalesOrder : null as any;
        data["pmuSalesOrderItem"] = this.pmuSalesOrderItem !== undefined ? this.pmuSalesOrderItem : null as any;
        data["lsuOrderQty"] = this.lsuOrderQty !== undefined ? this.lsuOrderQty : null as any;
        data["material"] = this.material !== undefined ? this.material : null as any;
        data["materialDescriptionCh"] = this.materialDescriptionCh !== undefined ? this.materialDescriptionCh : null as any;
        data["lsuSoCurr"] = this.lsuSoCurr !== undefined ? this.lsuSoCurr : null as any;
        data["lsuItemValueWithTax"] = this.lsuItemValueWithTax !== undefined ? this.lsuItemValueWithTax : null as any;
        data["lsuItemValue"] = this.lsuItemValue !== undefined ? this.lsuItemValue : null as any;
        data["unitPriceWithTax"] = this.unitPriceWithTax !== undefined ? this.unitPriceWithTax : null as any;
        data["lsuUnitPrice"] = this.lsuUnitPrice !== undefined ? this.lsuUnitPrice : null as any;
        data["requestDeliveryDate"] = this.requestDeliveryDate ? this.requestDeliveryDate.toISOString() : null as any;
        data["requestDeliveryDateString"] = this.requestDeliveryDateString !== undefined ? this.requestDeliveryDateString : null as any;
        data["pmuStock"] = this.pmuStock !== undefined ? this.pmuStock : null as any;
        data["pmuDnQty"] = this.pmuDnQty !== undefined ? this.pmuDnQty : null as any;
        data["lsugiQtyTotal"] = this.lsugiQtyTotal !== undefined ? this.lsugiQtyTotal : null as any;
        data["purchaseOrderDate"] = this.purchaseOrderDate ? this.purchaseOrderDate.toISOString() : null as any;
        data["purchaseOrderDateString"] = this.purchaseOrderDateString !== undefined ? this.purchaseOrderDateString : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["customerProdNo"] = this.customerProdNo !== undefined ? this.customerProdNo : null as any;
        data["firstStockDate"] = this.firstStockDate ? this.firstStockDate.toISOString() : null as any;
        data["firstStockDateString"] = this.firstStockDateString !== undefined ? this.firstStockDateString : null as any;
        data["pg"] = this.pg !== undefined ? this.pg : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["pmuSoitemCategory"] = this.pmuSoitemCategory !== undefined ? this.pmuSoitemCategory : null as any;
        data["soItemCategoryText"] = this.soItemCategoryText !== undefined ? this.soItemCategoryText : null as any;
        data["lsuSalesEngineerName"] = this.lsuSalesEngineerName !== undefined ? this.lsuSalesEngineerName : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["stockStatus"] = this.stockStatus !== undefined ? this.stockStatus : null as any;
        data["stockStatusStr"] = this.stockStatusStr !== undefined ? this.stockStatusStr : null as any;
        data["isShowJIN"] = this.isShowJIN !== undefined ? this.isShowJIN : null as any;
        data["jINCodeStandardProductOutDto"] = this.jINCodeStandardProductOutDto ? this.jINCodeStandardProductOutDto.toJSON() : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["isMts"] = this.isMts !== undefined ? this.isMts : null as any;
        return data;
    }
}

/** 低压可视化-订单统计列表展示-一级显示字段项目 */
export class PageOrderVisualizationOutputDto {
    /** 编号 */
    id!: string;
    /** OMS号 */
    omsOrderNumber!: string | null;
    /** 销售区域编码20220718 */
    salesAreaCode!: string | null;
    /** 销售区域 */
    salesAreaName!: string | null;
    /** 客户编号 */
    soldToParty!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 客户采购订单号 */
    customerOrderNumber!: string | null;
    /** 合同号 */
    lsuContractNumber!: string | null;
    /** 销售名字 */
    lsuSalesEngineerName!: string | null;
    /** 商务名称 */
    lsuCommercialName!: string | null;
    /** 订单创建日期 */
    lsuCreateDate!: moment.Moment | null;
    readonly lsuCreateDateString!: string | null;
    /** 订单提交日期 */
    orderSubmitDate!: moment.Moment | null;
    readonly orderSubmitDateString!: string | null;
    /** 订单状态
所有行都已经入库才显示已入库
三期开发 */
    orderStatus!: number | null;
    /** 订单状态
所有行都已经入库才显示已入库
三期开发 */
    readonly orderStatusStr!: string | null;
    /** 库存时间
小于1个月
1-2个月
2-3个月
大于3个月
以行里面计算最短的为准
三期开发 */
    stockTimeStr!: string | null;
    /** 库存状态
货已备齐, 货未备齐
所有行都是绿灯才是绿灯 */
    stockStatus!: number | null;
    readonly stockStatusStr!: string | null;
    /** 二级客户名称 */
    endCustomerName!: string | null;
    /** 项目名称 */
    projectNameDes!: string | null;
    /** 二级显示字段 */
    items!: PageOrderVisualizationItemOutputDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.omsOrderNumber = _data["omsOrderNumber"] !== undefined ? _data["omsOrderNumber"] : null as any;
            this.salesAreaCode = _data["salesAreaCode"] !== undefined ? _data["salesAreaCode"] : null as any;
            this.salesAreaName = _data["salesAreaName"] !== undefined ? _data["salesAreaName"] : null as any;
            this.soldToParty = _data["soldToParty"] !== undefined ? _data["soldToParty"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.customerOrderNumber = _data["customerOrderNumber"] !== undefined ? _data["customerOrderNumber"] : null as any;
            this.lsuContractNumber = _data["lsuContractNumber"] !== undefined ? _data["lsuContractNumber"] : null as any;
            this.lsuSalesEngineerName = _data["lsuSalesEngineerName"] !== undefined ? _data["lsuSalesEngineerName"] : null as any;
            this.lsuCommercialName = _data["lsuCommercialName"] !== undefined ? _data["lsuCommercialName"] : null as any;
            this.lsuCreateDate = _data["lsuCreateDate"] ? moment(_data["lsuCreateDate"].toString()) : null as any;
            (this as any).lsuCreateDateString = _data["lsuCreateDateString"] !== undefined ? _data["lsuCreateDateString"] : null as any;
            this.orderSubmitDate = _data["orderSubmitDate"] ? moment(_data["orderSubmitDate"].toString()) : null as any;
            (this as any).orderSubmitDateString = _data["orderSubmitDateString"] !== undefined ? _data["orderSubmitDateString"] : null as any;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : null as any;
            (this as any).orderStatusStr = _data["orderStatusStr"] !== undefined ? _data["orderStatusStr"] : null as any;
            this.stockTimeStr = _data["stockTimeStr"] !== undefined ? _data["stockTimeStr"] : null as any;
            this.stockStatus = _data["stockStatus"] !== undefined ? _data["stockStatus"] : null as any;
            (this as any).stockStatusStr = _data["stockStatusStr"] !== undefined ? _data["stockStatusStr"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.projectNameDes = _data["projectNameDes"] !== undefined ? _data["projectNameDes"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageOrderVisualizationItemOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): PageOrderVisualizationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageOrderVisualizationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["omsOrderNumber"] = this.omsOrderNumber !== undefined ? this.omsOrderNumber : null as any;
        data["salesAreaCode"] = this.salesAreaCode !== undefined ? this.salesAreaCode : null as any;
        data["salesAreaName"] = this.salesAreaName !== undefined ? this.salesAreaName : null as any;
        data["soldToParty"] = this.soldToParty !== undefined ? this.soldToParty : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["customerOrderNumber"] = this.customerOrderNumber !== undefined ? this.customerOrderNumber : null as any;
        data["lsuContractNumber"] = this.lsuContractNumber !== undefined ? this.lsuContractNumber : null as any;
        data["lsuSalesEngineerName"] = this.lsuSalesEngineerName !== undefined ? this.lsuSalesEngineerName : null as any;
        data["lsuCommercialName"] = this.lsuCommercialName !== undefined ? this.lsuCommercialName : null as any;
        data["lsuCreateDate"] = this.lsuCreateDate ? this.lsuCreateDate.toISOString() : null as any;
        data["lsuCreateDateString"] = this.lsuCreateDateString !== undefined ? this.lsuCreateDateString : null as any;
        data["orderSubmitDate"] = this.orderSubmitDate ? this.orderSubmitDate.toISOString() : null as any;
        data["orderSubmitDateString"] = this.orderSubmitDateString !== undefined ? this.orderSubmitDateString : null as any;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : null as any;
        data["orderStatusStr"] = this.orderStatusStr !== undefined ? this.orderStatusStr : null as any;
        data["stockTimeStr"] = this.stockTimeStr !== undefined ? this.stockTimeStr : null as any;
        data["stockStatus"] = this.stockStatus !== undefined ? this.stockStatus : null as any;
        data["stockStatusStr"] = this.stockStatusStr !== undefined ? this.stockStatusStr : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["projectNameDes"] = this.projectNameDes !== undefined ? this.projectNameDes : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 订单列表展示 */
export class PageOutputDto {
    /** 编号 */
    id!: string;
    /** 客户编号 */
    soldToParty!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 订单创建日期 */
    creationTime!: moment.Moment;
    /** 订单创建人 */
    creatorUser!: string | null;
    /** LSU订单号 (SAP订单号 ) */
    lsuSalesOrder!: string | null;
    /** LSU项目号  (SAP项目号 ) */
    lsuItem!: string | null;
    /** PMU订单号 (内部订单号 ) */
    pmuSalesOrder!: string | null;
    /** PMU项目号  (内部订单号行 ) */
    pmuSalesOrderItem!: string | null;
    /** 内部订单项目行 */
    pmuSoitemCategory!: string | null;
    /** 项目类别描述 */
    soItemCategoryText!: string | null;
    /** 物料编码 */
    material!: string | null;
    /** 物料描述 */
    materialDescriptionEn!: string | null;
    /** 物料描述 */
    materialDescriptionCh!: string | null;
    /** LSU订单数量 */
    lsuOrderQty!: number;
    /** 销售雇员名字 */
    lsuSalesEngineerName!: string | null;
    /** 库存数量 */
    pmuStock!: number;
    /** 最后一次收货日期 */
    lastGoodsReceiptDate!: moment.Moment | null;
    /** 最后一次收货日期 */
    readonly lastGoodsReceiptDateString!: string | null;
    /** 计划装配日期 */
    purchaseOrderDate!: moment.Moment | null;
    /** 计划装配日期 */
    readonly purchaseOrderDateString!: string | null;
    /** 已发数量 */
    pmuDnQty!: number;
    /** 合同号 */
    lsuContractNumber!: string | null;
    /** 金额（不含税）
净价 */
    lsuUnitPrice!: number;
    /** 金额（含税）- 最新字段 */
    unitPriceWithTax!: number;
    /** 客户需求日期 */
    requestDeliveryDate!: moment.Moment | null;
    /** 开票金额 */
    lsuBillingAmountWithoutTax!: number;
    /** 客户采购订单号 */
    customerPo!: string | null;
    /** 客户物料代码 */
    customerProdNo!: string | null;
    /** 物料组 */
    materialGroup!: string | null;
    /** 库存状态
货已备齐, 货未备齐, 部分备齐 */
    stockStatus!: number | null;
    /** 对应提货单的子项数量 */
    lsuRowSpan!: number;
    /** 是否合并行 */
    lsuIsMerge!: boolean;
    lsuFreightAll!: number;
    /** 修改时间 */
    lastModificationTime!: moment.Moment | null;
    /** 修改时间 */
    readonly lastModificationTimeString!: string | null;
    /** 第一次绿灯时间 */
    firstStockDate!: moment.Moment | null;
    /** 是否 可查询 OIS_ProductBasicMotor_Mts（合同号+行号） */
    isMts!: string | null;
    /** 订单业务类型 */
    orderBusinessType!: number | null;
    /** 境界类别代码 */
    jinCategoryCode!: string | null;
    /** 境界版本 */
    jinVersion!: string | null;
    /** 是否可查看境界对应的标准代码 */
    isShowJIN!: boolean;
    jINCodeStandardProductOutDto!: JINCodeStandardProductOutDto;
    /** 是否加急 */
    isUrgent!: boolean;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** 加急选择是否可用 */
    isUrgentEnable!: boolean;
    /** 4D订单强关联 */
    isOrderCorrelation_4D!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.soldToParty = _data["soldToParty"] !== undefined ? _data["soldToParty"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUser = _data["creatorUser"] !== undefined ? _data["creatorUser"] : null as any;
            this.lsuSalesOrder = _data["lsuSalesOrder"] !== undefined ? _data["lsuSalesOrder"] : null as any;
            this.lsuItem = _data["lsuItem"] !== undefined ? _data["lsuItem"] : null as any;
            this.pmuSalesOrder = _data["pmuSalesOrder"] !== undefined ? _data["pmuSalesOrder"] : null as any;
            this.pmuSalesOrderItem = _data["pmuSalesOrderItem"] !== undefined ? _data["pmuSalesOrderItem"] : null as any;
            this.pmuSoitemCategory = _data["pmuSoitemCategory"] !== undefined ? _data["pmuSoitemCategory"] : null as any;
            this.soItemCategoryText = _data["soItemCategoryText"] !== undefined ? _data["soItemCategoryText"] : null as any;
            this.material = _data["material"] !== undefined ? _data["material"] : null as any;
            this.materialDescriptionEn = _data["materialDescriptionEn"] !== undefined ? _data["materialDescriptionEn"] : null as any;
            this.materialDescriptionCh = _data["materialDescriptionCh"] !== undefined ? _data["materialDescriptionCh"] : null as any;
            this.lsuOrderQty = _data["lsuOrderQty"] !== undefined ? _data["lsuOrderQty"] : null as any;
            this.lsuSalesEngineerName = _data["lsuSalesEngineerName"] !== undefined ? _data["lsuSalesEngineerName"] : null as any;
            this.pmuStock = _data["pmuStock"] !== undefined ? _data["pmuStock"] : null as any;
            this.lastGoodsReceiptDate = _data["lastGoodsReceiptDate"] ? moment(_data["lastGoodsReceiptDate"].toString()) : null as any;
            (this as any).lastGoodsReceiptDateString = _data["lastGoodsReceiptDateString"] !== undefined ? _data["lastGoodsReceiptDateString"] : null as any;
            this.purchaseOrderDate = _data["purchaseOrderDate"] ? moment(_data["purchaseOrderDate"].toString()) : null as any;
            (this as any).purchaseOrderDateString = _data["purchaseOrderDateString"] !== undefined ? _data["purchaseOrderDateString"] : null as any;
            this.pmuDnQty = _data["pmuDnQty"] !== undefined ? _data["pmuDnQty"] : null as any;
            this.lsuContractNumber = _data["lsuContractNumber"] !== undefined ? _data["lsuContractNumber"] : null as any;
            this.lsuUnitPrice = _data["lsuUnitPrice"] !== undefined ? _data["lsuUnitPrice"] : null as any;
            this.unitPriceWithTax = _data["unitPriceWithTax"] !== undefined ? _data["unitPriceWithTax"] : null as any;
            this.requestDeliveryDate = _data["requestDeliveryDate"] ? moment(_data["requestDeliveryDate"].toString()) : null as any;
            this.lsuBillingAmountWithoutTax = _data["lsuBillingAmountWithoutTax"] !== undefined ? _data["lsuBillingAmountWithoutTax"] : null as any;
            this.customerPo = _data["customerPo"] !== undefined ? _data["customerPo"] : null as any;
            this.customerProdNo = _data["customerProdNo"] !== undefined ? _data["customerProdNo"] : null as any;
            this.materialGroup = _data["materialGroup"] !== undefined ? _data["materialGroup"] : null as any;
            this.stockStatus = _data["stockStatus"] !== undefined ? _data["stockStatus"] : null as any;
            this.lsuRowSpan = _data["lsuRowSpan"] !== undefined ? _data["lsuRowSpan"] : null as any;
            this.lsuIsMerge = _data["lsuIsMerge"] !== undefined ? _data["lsuIsMerge"] : null as any;
            this.lsuFreightAll = _data["lsuFreightAll"] !== undefined ? _data["lsuFreightAll"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            (this as any).lastModificationTimeString = _data["lastModificationTimeString"] !== undefined ? _data["lastModificationTimeString"] : null as any;
            this.firstStockDate = _data["firstStockDate"] ? moment(_data["firstStockDate"].toString()) : null as any;
            this.isMts = _data["isMts"] !== undefined ? _data["isMts"] : null as any;
            this.orderBusinessType = _data["orderBusinessType"] !== undefined ? _data["orderBusinessType"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.isShowJIN = _data["isShowJIN"] !== undefined ? _data["isShowJIN"] : null as any;
            this.jINCodeStandardProductOutDto = _data["jINCodeStandardProductOutDto"] ? JINCodeStandardProductOutDto.fromJS(_data["jINCodeStandardProductOutDto"]) : null as any;
            this.isUrgent = _data["isUrgent"] !== undefined ? _data["isUrgent"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.isUrgentEnable = _data["isUrgentEnable"] !== undefined ? _data["isUrgentEnable"] : null as any;
            this.isOrderCorrelation_4D = _data["isOrderCorrelation_4D"] !== undefined ? _data["isOrderCorrelation_4D"] : null as any;
        }
    }

    static fromJS(data: any): PageOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["soldToParty"] = this.soldToParty !== undefined ? this.soldToParty : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUser"] = this.creatorUser !== undefined ? this.creatorUser : null as any;
        data["lsuSalesOrder"] = this.lsuSalesOrder !== undefined ? this.lsuSalesOrder : null as any;
        data["lsuItem"] = this.lsuItem !== undefined ? this.lsuItem : null as any;
        data["pmuSalesOrder"] = this.pmuSalesOrder !== undefined ? this.pmuSalesOrder : null as any;
        data["pmuSalesOrderItem"] = this.pmuSalesOrderItem !== undefined ? this.pmuSalesOrderItem : null as any;
        data["pmuSoitemCategory"] = this.pmuSoitemCategory !== undefined ? this.pmuSoitemCategory : null as any;
        data["soItemCategoryText"] = this.soItemCategoryText !== undefined ? this.soItemCategoryText : null as any;
        data["material"] = this.material !== undefined ? this.material : null as any;
        data["materialDescriptionEn"] = this.materialDescriptionEn !== undefined ? this.materialDescriptionEn : null as any;
        data["materialDescriptionCh"] = this.materialDescriptionCh !== undefined ? this.materialDescriptionCh : null as any;
        data["lsuOrderQty"] = this.lsuOrderQty !== undefined ? this.lsuOrderQty : null as any;
        data["lsuSalesEngineerName"] = this.lsuSalesEngineerName !== undefined ? this.lsuSalesEngineerName : null as any;
        data["pmuStock"] = this.pmuStock !== undefined ? this.pmuStock : null as any;
        data["lastGoodsReceiptDate"] = this.lastGoodsReceiptDate ? this.lastGoodsReceiptDate.toISOString() : null as any;
        data["lastGoodsReceiptDateString"] = this.lastGoodsReceiptDateString !== undefined ? this.lastGoodsReceiptDateString : null as any;
        data["purchaseOrderDate"] = this.purchaseOrderDate ? this.purchaseOrderDate.toISOString() : null as any;
        data["purchaseOrderDateString"] = this.purchaseOrderDateString !== undefined ? this.purchaseOrderDateString : null as any;
        data["pmuDnQty"] = this.pmuDnQty !== undefined ? this.pmuDnQty : null as any;
        data["lsuContractNumber"] = this.lsuContractNumber !== undefined ? this.lsuContractNumber : null as any;
        data["lsuUnitPrice"] = this.lsuUnitPrice !== undefined ? this.lsuUnitPrice : null as any;
        data["unitPriceWithTax"] = this.unitPriceWithTax !== undefined ? this.unitPriceWithTax : null as any;
        data["requestDeliveryDate"] = this.requestDeliveryDate ? this.requestDeliveryDate.toISOString() : null as any;
        data["lsuBillingAmountWithoutTax"] = this.lsuBillingAmountWithoutTax !== undefined ? this.lsuBillingAmountWithoutTax : null as any;
        data["customerPo"] = this.customerPo !== undefined ? this.customerPo : null as any;
        data["customerProdNo"] = this.customerProdNo !== undefined ? this.customerProdNo : null as any;
        data["materialGroup"] = this.materialGroup !== undefined ? this.materialGroup : null as any;
        data["stockStatus"] = this.stockStatus !== undefined ? this.stockStatus : null as any;
        data["lsuRowSpan"] = this.lsuRowSpan !== undefined ? this.lsuRowSpan : null as any;
        data["lsuIsMerge"] = this.lsuIsMerge !== undefined ? this.lsuIsMerge : null as any;
        data["lsuFreightAll"] = this.lsuFreightAll !== undefined ? this.lsuFreightAll : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModificationTimeString"] = this.lastModificationTimeString !== undefined ? this.lastModificationTimeString : null as any;
        data["firstStockDate"] = this.firstStockDate ? this.firstStockDate.toISOString() : null as any;
        data["isMts"] = this.isMts !== undefined ? this.isMts : null as any;
        data["orderBusinessType"] = this.orderBusinessType !== undefined ? this.orderBusinessType : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["isShowJIN"] = this.isShowJIN !== undefined ? this.isShowJIN : null as any;
        data["jINCodeStandardProductOutDto"] = this.jINCodeStandardProductOutDto ? this.jINCodeStandardProductOutDto.toJSON() : null as any;
        data["isUrgent"] = this.isUrgent !== undefined ? this.isUrgent : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["isUrgentEnable"] = this.isUrgentEnable !== undefined ? this.isUrgentEnable : null as any;
        data["isOrderCorrelation_4D"] = this.isOrderCorrelation_4D !== undefined ? this.isOrderCorrelation_4D : null as any;
        return data;
    }
}

export class PageReplenishInventoryRemindOutDto {
    /** 主键id */
    id!: string;
    /** 订单id */
    orderFormId!: string;
    /** 合同号 */
    contractNumber!: string | null;
    /** 订单类型编码 */
    dataPlatFormOrderTypeId!: string | null;
    /** 订单类型 */
    dataPlatFormOrderTypeName!: string | null;
    /** 选型号 */
    modelSelectionId!: string | null;
    /** 选型名称 */
    modelSelectionName!: string | null;
    /** 责任销售 */
    responsibleSalesName!: string | null;
    /** 责任销售编码 */
    responsibleSalesCode!: string | null;
    /** 客户名称 */
    endCustomerName!: string | null;
    /** 客户编码 */
    endCustomerCode!: string | null;
    /** 物料号 */
    materialNumber!: string | null;
    /** 电机编码 */
    basicMotorCode!: string | null;
    /** 电机型号 */
    basicMotorModel!: string | null;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** 数量 */
    materialQuantity!: number | null;
    /** 发送人 */
    fromUser!: string | null;
    /** 发送人姓名 */
    fromUserName!: string | null;
    /** 接收人 */
    toUser!: string | null;
    /** 接收人姓名 */
    toUserName!: string | null;
    /** 序号(行号) */
    serialNumber!: string | null;
    /** 创建时间 */
    creationTime!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.contractNumber = _data["contractNumber"] !== undefined ? _data["contractNumber"] : null as any;
            this.dataPlatFormOrderTypeId = _data["dataPlatFormOrderTypeId"] !== undefined ? _data["dataPlatFormOrderTypeId"] : null as any;
            this.dataPlatFormOrderTypeName = _data["dataPlatFormOrderTypeName"] !== undefined ? _data["dataPlatFormOrderTypeName"] : null as any;
            this.modelSelectionId = _data["modelSelectionId"] !== undefined ? _data["modelSelectionId"] : null as any;
            this.modelSelectionName = _data["modelSelectionName"] !== undefined ? _data["modelSelectionName"] : null as any;
            this.responsibleSalesName = _data["responsibleSalesName"] !== undefined ? _data["responsibleSalesName"] : null as any;
            this.responsibleSalesCode = _data["responsibleSalesCode"] !== undefined ? _data["responsibleSalesCode"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.endCustomerCode = _data["endCustomerCode"] !== undefined ? _data["endCustomerCode"] : null as any;
            this.materialNumber = _data["materialNumber"] !== undefined ? _data["materialNumber"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.materialQuantity = _data["materialQuantity"] !== undefined ? _data["materialQuantity"] : null as any;
            this.fromUser = _data["fromUser"] !== undefined ? _data["fromUser"] : null as any;
            this.fromUserName = _data["fromUserName"] !== undefined ? _data["fromUserName"] : null as any;
            this.toUser = _data["toUser"] !== undefined ? _data["toUser"] : null as any;
            this.toUserName = _data["toUserName"] !== undefined ? _data["toUserName"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.creationTime = _data["creationTime"] !== undefined ? _data["creationTime"] : null as any;
        }
    }

    static fromJS(data: any): PageReplenishInventoryRemindOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageReplenishInventoryRemindOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["contractNumber"] = this.contractNumber !== undefined ? this.contractNumber : null as any;
        data["dataPlatFormOrderTypeId"] = this.dataPlatFormOrderTypeId !== undefined ? this.dataPlatFormOrderTypeId : null as any;
        data["dataPlatFormOrderTypeName"] = this.dataPlatFormOrderTypeName !== undefined ? this.dataPlatFormOrderTypeName : null as any;
        data["modelSelectionId"] = this.modelSelectionId !== undefined ? this.modelSelectionId : null as any;
        data["modelSelectionName"] = this.modelSelectionName !== undefined ? this.modelSelectionName : null as any;
        data["responsibleSalesName"] = this.responsibleSalesName !== undefined ? this.responsibleSalesName : null as any;
        data["responsibleSalesCode"] = this.responsibleSalesCode !== undefined ? this.responsibleSalesCode : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["endCustomerCode"] = this.endCustomerCode !== undefined ? this.endCustomerCode : null as any;
        data["materialNumber"] = this.materialNumber !== undefined ? this.materialNumber : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["materialQuantity"] = this.materialQuantity !== undefined ? this.materialQuantity : null as any;
        data["fromUser"] = this.fromUser !== undefined ? this.fromUser : null as any;
        data["fromUserName"] = this.fromUserName !== undefined ? this.fromUserName : null as any;
        data["toUser"] = this.toUser !== undefined ? this.toUser : null as any;
        data["toUserName"] = this.toUserName !== undefined ? this.toUserName : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["creationTime"] = this.creationTime !== undefined ? this.creationTime : null as any;
        return data;
    }
}

export class PageReplenishInventoryRemindOutDtoPagedResultDto {
    items!: PageReplenishInventoryRemindOutDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageReplenishInventoryRemindOutDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PageReplenishInventoryRemindOutDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageReplenishInventoryRemindOutDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class PageResetToZeroLogDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 操作 */
    operation!: string | null;
    /** 操作人Id */
    operatorUserId!: number | null;
    /** 操作时间 */
    operationTime!: moment.Moment[] | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.operation = _data["operation"] !== undefined ? _data["operation"] : null as any;
            this.operatorUserId = _data["operatorUserId"] !== undefined ? _data["operatorUserId"] : null as any;
            if (Array.isArray(_data["operationTime"])) {
                this.operationTime = [] as any;
                for (let item of _data["operationTime"])
                    this.operationTime!.push(moment(item));
            }
            else {
                this.operationTime = null as any;
            }
        }
    }

    static fromJS(data: any): PageResetToZeroLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageResetToZeroLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["operation"] = this.operation !== undefined ? this.operation : null as any;
        data["operatorUserId"] = this.operatorUserId !== undefined ? this.operatorUserId : null as any;
        if (Array.isArray(this.operationTime)) {
            data["operationTime"] = [];
            for (let item of this.operationTime)
                data["operationTime"].push(item.toISOString());
        }
        return data;
    }
}

export class PageSalesAreaSearchInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 编码 */
    salesAreaCode!: string | null;
    /** 名称 */
    salesAreaName!: string | null;
    /** 是否启用 */
    enable!: boolean;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.salesAreaCode = _data["salesAreaCode"] !== undefined ? _data["salesAreaCode"] : null as any;
            this.salesAreaName = _data["salesAreaName"] !== undefined ? _data["salesAreaName"] : null as any;
            this.enable = _data["enable"] !== undefined ? _data["enable"] : null as any;
        }
    }

    static fromJS(data: any): PageSalesAreaSearchInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageSalesAreaSearchInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["salesAreaCode"] = this.salesAreaCode !== undefined ? this.salesAreaCode : null as any;
        data["salesAreaName"] = this.salesAreaName !== undefined ? this.salesAreaName : null as any;
        data["enable"] = this.enable !== undefined ? this.enable : null as any;
        return data;
    }
}

/** 销售区域 */
export class PageSalesAreaSearchOutputDto {
    /** 销售区域编号 */
    id!: string;
    /** 编码 */
    salesAreaCode!: string | null;
    /** 名称 */
    salesAreaName!: string | null;
    /** 是否启用 */
    enable!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.salesAreaCode = _data["salesAreaCode"] !== undefined ? _data["salesAreaCode"] : null as any;
            this.salesAreaName = _data["salesAreaName"] !== undefined ? _data["salesAreaName"] : null as any;
            this.enable = _data["enable"] !== undefined ? _data["enable"] : null as any;
        }
    }

    static fromJS(data: any): PageSalesAreaSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageSalesAreaSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["salesAreaCode"] = this.salesAreaCode !== undefined ? this.salesAreaCode : null as any;
        data["salesAreaName"] = this.salesAreaName !== undefined ? this.salesAreaName : null as any;
        data["enable"] = this.enable !== undefined ? this.enable : null as any;
        return data;
    }
}

export class PageSalesAreaSearchOutputDtoPagedResultDto {
    items!: PageSalesAreaSearchOutputDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageSalesAreaSearchOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PageSalesAreaSearchOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageSalesAreaSearchOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class PageSearchDNSplitOrderDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 客户id */
    customerNo!: string | null;
    /** 拆单日期范围 */
    date!: moment.Moment[] | null;
    /** 排序方式，默认正序 */
    sortOrder!: boolean;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            if (Array.isArray(_data["date"])) {
                this.date = [] as any;
                for (let item of _data["date"])
                    this.date!.push(moment(item));
            }
            else {
                this.date = null as any;
            }
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
        }
    }

    static fromJS(data: any): PageSearchDNSplitOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageSearchDNSplitOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        if (Array.isArray(this.date)) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item.toISOString());
        }
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        return data;
    }
}

/** 提货单历史记录查询 */
export class PageSearchDeliveryNotesDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 订单Id */
    orderIds!: string[] | null;
    /** 是否拆单 */
    isSplitOrder!: boolean | null;
    /** DNS编号 */
    number!: string | null;
    /** DN */
    deliveryNumber!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 提货单状态 */
    status!: number | null;
    /** LSU订单号 (SAP订单号 )/PMU订单号 (内部订单号 ) */
    salesOrder!: string | null;
    /** LSU项目号  (SAP项目号 )/PMU项目号  (内部订单号行 ) */
    salesOrderItem!: string | null;
    /** 合同号 */
    lsuContractNumber!: string | null;
    deliveryDate!: moment.Moment[] | null;
    /** 排序方式，默认正序 */
    sortOrder!: boolean;
    /** 产品组/Division */
    productGroup!: string | null;
    /** 运输类型
送货到门枚举值为空，所以前端定义为null，接口内部做处理 */
    shippingType!: ShippingType[] | null;
    /** 物料编码 */
    material!: string | null;
    /** 客户物料代码 */
    customerProdNo!: string | null;
    /** 当前用户角色 */
    roleNames!: string[] | null;
    /** 销售关联 */
    associationCustomers!: string[] | null;
    /** 是否加急 */
    isUrgent!: boolean | null;
    /** 仅返回已上传特殊附件或发运送货要求的提货单，并跳过信用额度等外部查询。 */
    hasAttachment!: boolean;
    /** 是否有附件。空表示不筛选；勾选特殊附件、发运送货要求或已上传对应文件都算有附件。 */
    hasAttachmentFilter!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds!.push(item);
            }
            else {
                this.orderIds = null as any;
            }
            this.isSplitOrder = _data["isSplitOrder"] !== undefined ? _data["isSplitOrder"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.deliveryNumber = _data["deliveryNumber"] !== undefined ? _data["deliveryNumber"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.salesOrder = _data["salesOrder"] !== undefined ? _data["salesOrder"] : null as any;
            this.salesOrderItem = _data["salesOrderItem"] !== undefined ? _data["salesOrderItem"] : null as any;
            this.lsuContractNumber = _data["lsuContractNumber"] !== undefined ? _data["lsuContractNumber"] : null as any;
            if (Array.isArray(_data["deliveryDate"])) {
                this.deliveryDate = [] as any;
                for (let item of _data["deliveryDate"])
                    this.deliveryDate!.push(moment(item));
            }
            else {
                this.deliveryDate = null as any;
            }
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.productGroup = _data["productGroup"] !== undefined ? _data["productGroup"] : null as any;
            if (Array.isArray(_data["shippingType"])) {
                this.shippingType = [] as any;
                for (let item of _data["shippingType"])
                    this.shippingType!.push(item);
            }
            else {
                this.shippingType = null as any;
            }
            this.material = _data["material"] !== undefined ? _data["material"] : null as any;
            this.customerProdNo = _data["customerProdNo"] !== undefined ? _data["customerProdNo"] : null as any;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            else {
                this.roleNames = null as any;
            }
            if (Array.isArray(_data["associationCustomers"])) {
                this.associationCustomers = [] as any;
                for (let item of _data["associationCustomers"])
                    this.associationCustomers!.push(item);
            }
            else {
                this.associationCustomers = null as any;
            }
            this.isUrgent = _data["isUrgent"] !== undefined ? _data["isUrgent"] : null as any;
            this.hasAttachment = _data["hasAttachment"] !== undefined ? _data["hasAttachment"] : null as any;
            this.hasAttachmentFilter = _data["hasAttachmentFilter"] !== undefined ? _data["hasAttachmentFilter"] : null as any;
        }
    }

    static fromJS(data: any): PageSearchDeliveryNotesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageSearchDeliveryNotesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        data["isSplitOrder"] = this.isSplitOrder !== undefined ? this.isSplitOrder : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["deliveryNumber"] = this.deliveryNumber !== undefined ? this.deliveryNumber : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["salesOrder"] = this.salesOrder !== undefined ? this.salesOrder : null as any;
        data["salesOrderItem"] = this.salesOrderItem !== undefined ? this.salesOrderItem : null as any;
        data["lsuContractNumber"] = this.lsuContractNumber !== undefined ? this.lsuContractNumber : null as any;
        if (Array.isArray(this.deliveryDate)) {
            data["deliveryDate"] = [];
            for (let item of this.deliveryDate)
                data["deliveryDate"].push(item.toISOString());
        }
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["productGroup"] = this.productGroup !== undefined ? this.productGroup : null as any;
        if (Array.isArray(this.shippingType)) {
            data["shippingType"] = [];
            for (let item of this.shippingType)
                data["shippingType"].push(item);
        }
        data["material"] = this.material !== undefined ? this.material : null as any;
        data["customerProdNo"] = this.customerProdNo !== undefined ? this.customerProdNo : null as any;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        if (Array.isArray(this.associationCustomers)) {
            data["associationCustomers"] = [];
            for (let item of this.associationCustomers)
                data["associationCustomers"].push(item);
        }
        data["isUrgent"] = this.isUrgent !== undefined ? this.isUrgent : null as any;
        data["hasAttachment"] = this.hasAttachment !== undefined ? this.hasAttachment : null as any;
        data["hasAttachmentFilter"] = this.hasAttachmentFilter !== undefined ? this.hasAttachmentFilter : null as any;
        return data;
    }
}

/** 后台任务记录查询参数 */
export class PageSearchJobHistoriesInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 搜索关键字 */
    keyword!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.keyword = _data["keyword"] !== undefined ? _data["keyword"] : null as any;
        }
    }

    static fromJS(data: any): PageSearchJobHistoriesInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageSearchJobHistoriesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["keyword"] = this.keyword !== undefined ? this.keyword : null as any;
        return data;
    }
}

/** 后台任务记录输出 */
export class PageSearchJobHistoriesOutputDto {
    /** 总数 */
    totalCount!: number;
    /** 数据集合 */
    items!: PageJobHistoriesOutputDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageJobHistoriesOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): PageSearchJobHistoriesOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageSearchJobHistoriesOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 页面查询Dto */
export class PageSearchOrderInformationDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 订单Id */
    orderIds!: string[] | null;
    /** 客户编号 */
    soldToParty!: string | null;
    /** LSU订单号/PMU订单号 */
    salesOrder!: string | null;
    /** LSU项目号/PMU项目号 */
    salesOrderItem!: string | null;
    /** 合同号 */
    lsuContractNumber!: string | null;
    /** 项目类别描述 */
    soItemCategoryText!: string | null;
    /** 物料编码 */
    material!: string | null;
    /** 客户物料代码 */
    customerProdNo!: string | null;
    /** 排序方式，默认正序 */
    sortStrOrder!: string[] | null;
    /** 只显示有库存数据 */
    stockQtyFlg!: boolean;
    /** 当前用户角色 */
    roleNames!: string[] | null;
    /** 销售名称 */
    lsuSalesEngineerName!: string | null;
    /** 订单分配 */
    orderCaregoryStatus!: number | null;
    /** 逾期未绿 */
    overdueGreenStatus!: number | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds!.push(item);
            }
            else {
                this.orderIds = null as any;
            }
            this.soldToParty = _data["soldToParty"] !== undefined ? _data["soldToParty"] : null as any;
            this.salesOrder = _data["salesOrder"] !== undefined ? _data["salesOrder"] : null as any;
            this.salesOrderItem = _data["salesOrderItem"] !== undefined ? _data["salesOrderItem"] : null as any;
            this.lsuContractNumber = _data["lsuContractNumber"] !== undefined ? _data["lsuContractNumber"] : null as any;
            this.soItemCategoryText = _data["soItemCategoryText"] !== undefined ? _data["soItemCategoryText"] : null as any;
            this.material = _data["material"] !== undefined ? _data["material"] : null as any;
            this.customerProdNo = _data["customerProdNo"] !== undefined ? _data["customerProdNo"] : null as any;
            if (Array.isArray(_data["sortStrOrder"])) {
                this.sortStrOrder = [] as any;
                for (let item of _data["sortStrOrder"])
                    this.sortStrOrder!.push(item);
            }
            else {
                this.sortStrOrder = null as any;
            }
            this.stockQtyFlg = _data["stockQtyFlg"] !== undefined ? _data["stockQtyFlg"] : null as any;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            else {
                this.roleNames = null as any;
            }
            this.lsuSalesEngineerName = _data["lsuSalesEngineerName"] !== undefined ? _data["lsuSalesEngineerName"] : null as any;
            this.orderCaregoryStatus = _data["orderCaregoryStatus"] !== undefined ? _data["orderCaregoryStatus"] : null as any;
            this.overdueGreenStatus = _data["overdueGreenStatus"] !== undefined ? _data["overdueGreenStatus"] : null as any;
        }
    }

    static fromJS(data: any): PageSearchOrderInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageSearchOrderInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        data["soldToParty"] = this.soldToParty !== undefined ? this.soldToParty : null as any;
        data["salesOrder"] = this.salesOrder !== undefined ? this.salesOrder : null as any;
        data["salesOrderItem"] = this.salesOrderItem !== undefined ? this.salesOrderItem : null as any;
        data["lsuContractNumber"] = this.lsuContractNumber !== undefined ? this.lsuContractNumber : null as any;
        data["soItemCategoryText"] = this.soItemCategoryText !== undefined ? this.soItemCategoryText : null as any;
        data["material"] = this.material !== undefined ? this.material : null as any;
        data["customerProdNo"] = this.customerProdNo !== undefined ? this.customerProdNo : null as any;
        if (Array.isArray(this.sortStrOrder)) {
            data["sortStrOrder"] = [];
            for (let item of this.sortStrOrder)
                data["sortStrOrder"].push(item);
        }
        data["stockQtyFlg"] = this.stockQtyFlg !== undefined ? this.stockQtyFlg : null as any;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["lsuSalesEngineerName"] = this.lsuSalesEngineerName !== undefined ? this.lsuSalesEngineerName : null as any;
        data["orderCaregoryStatus"] = this.orderCaregoryStatus !== undefined ? this.orderCaregoryStatus : null as any;
        data["overdueGreenStatus"] = this.overdueGreenStatus !== undefined ? this.overdueGreenStatus : null as any;
        return data;
    }
}

/** 低压可视化-页面查询Dto */
export class PageSearchOrderVisualizationDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 客户编号 页面不需要
商务、销售角色 */
    soldToParty!: string | null;
    /** 客户编号
商务、销售角色
模糊查询示例：上海昊磊（商务、销售角色） 鑫茂特（CP界面固定显示自己公司全称，不可以修改） */
    soldToPartyName!: string | null;
    /** 销售区域
salesAreaCode */
    salesAreaId!: string | null;
    /** 产品规格 主机型号
productBasicMotor.BasicMotorModel
MaterialDescriptionEn 取这个值第一个*之前的内容
低压可视化第二期开发 这个筛选使用手动输入  模糊搜索的方式 */
    basicMotorModel!: string | null;
    /** LSU订单号 */
    lsuSalesOrder!: string | null;
    /** PMU订单号 */
    pmuSalesOrder!: string | null;
    /** LSU/PMU 订单号 */
    deliveryNumber!: string | null;
    /** LSU项目号 页面不需要 */
    lsuItem!: string | null;
    /** PMU项目号 页面不需要 */
    pmuSalesOrderItem!: string | null;
    /** 合同号 */
    lsuContractNumber!: string | null;
    /** 开始时间 - 订单创建日期 LSUCreateDate
orderTime */
    createStartDateTime!: moment.Moment | null;
    /** 结束时间 - 订单创建日期 LSUCreateDate */
    createEndDateTime!: moment.Moment | null;
    /** 开始时间 - 客户需求日期
requestTime */
    requestStartDateTime!: moment.Moment | null;
    /** 结束时间 - 客户需求日期
requestTime */
    requestEndDateTime!: moment.Moment | null;
    /** 开始时间 - 计划出库日期
purchaseTime */
    purchaseStartDateTime!: moment.Moment | null;
    /** 结束时间 - 计划出库日期 */
    purchaseEndDateTime!: moment.Moment | null;
    /** 库存状态
货已备齐, 货未备齐, 部分备齐 */
    stockStatus!: number | null;
    /** 商务名称-->OrderHandling
AssociationCustomers
orderHandlingId */
    lsuCommercialId!: number | null;
    /** 销售名字
salesCode */
    lsuSalesEngineerCode!: string | null;
    /** 库存分配锁定状态
true 只显示在库存锁定期间的未完成订单
null,false 不做筛选 */
    deliveryLockFlg!: boolean | null;
    /** 排序方式，默认正序 */
    sortOrder!: boolean | null;
    materialDescriptionCh!: string | null;
    /** 是否只查询预占订单 */
    isMts!: boolean | null;
    /** 订单状态
所有行都已经入库才显示已入库
三期开发 */
    orderStatus!: number | null;
    /** 库存时间
小于1个月
1-2个月
2-3个月
大于3个月
以行里面计算最短的为准
三期开发 */
    stockTime!: number | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 二级客户名称
模糊筛选  三期开发 */
    endCustomerName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.soldToParty = _data["soldToParty"] !== undefined ? _data["soldToParty"] : null as any;
            this.soldToPartyName = _data["soldToPartyName"] !== undefined ? _data["soldToPartyName"] : null as any;
            this.salesAreaId = _data["salesAreaId"] !== undefined ? _data["salesAreaId"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.lsuSalesOrder = _data["lsuSalesOrder"] !== undefined ? _data["lsuSalesOrder"] : null as any;
            this.pmuSalesOrder = _data["pmuSalesOrder"] !== undefined ? _data["pmuSalesOrder"] : null as any;
            this.deliveryNumber = _data["deliveryNumber"] !== undefined ? _data["deliveryNumber"] : null as any;
            this.lsuItem = _data["lsuItem"] !== undefined ? _data["lsuItem"] : null as any;
            this.pmuSalesOrderItem = _data["pmuSalesOrderItem"] !== undefined ? _data["pmuSalesOrderItem"] : null as any;
            this.lsuContractNumber = _data["lsuContractNumber"] !== undefined ? _data["lsuContractNumber"] : null as any;
            this.createStartDateTime = _data["createStartDateTime"] ? moment(_data["createStartDateTime"].toString()) : null as any;
            this.createEndDateTime = _data["createEndDateTime"] ? moment(_data["createEndDateTime"].toString()) : null as any;
            this.requestStartDateTime = _data["requestStartDateTime"] ? moment(_data["requestStartDateTime"].toString()) : null as any;
            this.requestEndDateTime = _data["requestEndDateTime"] ? moment(_data["requestEndDateTime"].toString()) : null as any;
            this.purchaseStartDateTime = _data["purchaseStartDateTime"] ? moment(_data["purchaseStartDateTime"].toString()) : null as any;
            this.purchaseEndDateTime = _data["purchaseEndDateTime"] ? moment(_data["purchaseEndDateTime"].toString()) : null as any;
            this.stockStatus = _data["stockStatus"] !== undefined ? _data["stockStatus"] : null as any;
            this.lsuCommercialId = _data["lsuCommercialId"] !== undefined ? _data["lsuCommercialId"] : null as any;
            this.lsuSalesEngineerCode = _data["lsuSalesEngineerCode"] !== undefined ? _data["lsuSalesEngineerCode"] : null as any;
            this.deliveryLockFlg = _data["deliveryLockFlg"] !== undefined ? _data["deliveryLockFlg"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.materialDescriptionCh = _data["materialDescriptionCh"] !== undefined ? _data["materialDescriptionCh"] : null as any;
            this.isMts = _data["isMts"] !== undefined ? _data["isMts"] : null as any;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : null as any;
            this.stockTime = _data["stockTime"] !== undefined ? _data["stockTime"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
        }
    }

    static fromJS(data: any): PageSearchOrderVisualizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageSearchOrderVisualizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["soldToParty"] = this.soldToParty !== undefined ? this.soldToParty : null as any;
        data["soldToPartyName"] = this.soldToPartyName !== undefined ? this.soldToPartyName : null as any;
        data["salesAreaId"] = this.salesAreaId !== undefined ? this.salesAreaId : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["lsuSalesOrder"] = this.lsuSalesOrder !== undefined ? this.lsuSalesOrder : null as any;
        data["pmuSalesOrder"] = this.pmuSalesOrder !== undefined ? this.pmuSalesOrder : null as any;
        data["deliveryNumber"] = this.deliveryNumber !== undefined ? this.deliveryNumber : null as any;
        data["lsuItem"] = this.lsuItem !== undefined ? this.lsuItem : null as any;
        data["pmuSalesOrderItem"] = this.pmuSalesOrderItem !== undefined ? this.pmuSalesOrderItem : null as any;
        data["lsuContractNumber"] = this.lsuContractNumber !== undefined ? this.lsuContractNumber : null as any;
        data["createStartDateTime"] = this.createStartDateTime ? this.createStartDateTime.toISOString() : null as any;
        data["createEndDateTime"] = this.createEndDateTime ? this.createEndDateTime.toISOString() : null as any;
        data["requestStartDateTime"] = this.requestStartDateTime ? this.requestStartDateTime.toISOString() : null as any;
        data["requestEndDateTime"] = this.requestEndDateTime ? this.requestEndDateTime.toISOString() : null as any;
        data["purchaseStartDateTime"] = this.purchaseStartDateTime ? this.purchaseStartDateTime.toISOString() : null as any;
        data["purchaseEndDateTime"] = this.purchaseEndDateTime ? this.purchaseEndDateTime.toISOString() : null as any;
        data["stockStatus"] = this.stockStatus !== undefined ? this.stockStatus : null as any;
        data["lsuCommercialId"] = this.lsuCommercialId !== undefined ? this.lsuCommercialId : null as any;
        data["lsuSalesEngineerCode"] = this.lsuSalesEngineerCode !== undefined ? this.lsuSalesEngineerCode : null as any;
        data["deliveryLockFlg"] = this.deliveryLockFlg !== undefined ? this.deliveryLockFlg : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["materialDescriptionCh"] = this.materialDescriptionCh !== undefined ? this.materialDescriptionCh : null as any;
        data["isMts"] = this.isMts !== undefined ? this.isMts : null as any;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : null as any;
        data["stockTime"] = this.stockTime !== undefined ? this.stockTime : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        return data;
    }
}

export class PageSeriesApproverSearchInputDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 系列名称 */
    seriesName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
        }
    }

    static fromJS(data: any): PageSeriesApproverSearchInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageSeriesApproverSearchInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        return data;
    }
}

/** 订单系列审批人 */
export class PageSeriesApproverSearchOutputDto {
    id!: string;
    /** 编码 */
    seriesName!: string | null;
    /** 审批人 */
    userId!: number;
    /** 审批人名称 */
    userName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
        }
    }

    static fromJS(data: any): PageSeriesApproverSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageSeriesApproverSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        return data;
    }
}

export class PageSeriesApproverSearchOutputDtoPagedResultDto {
    items!: PageSeriesApproverSearchOutputDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageSeriesApproverSearchOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PageSeriesApproverSearchOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageSeriesApproverSearchOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 提货单历史记录查询返回Total对象 */
export class PageTotalDeliveryNotesDto {
    /** 总数 */
    totalCount!: number;
    /** 数据集合 */
    items!: PageOrderOutputDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageOrderOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): PageTotalDeliveryNotesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageTotalDeliveryNotesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 订单信息列表展示 */
export class PageTotalOrderInformationDto {
    /** 总数 */
    totalCount!: number;
    items!: PageOutputDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): PageTotalOrderInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageTotalOrderInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class PageTotalResetToZeroLogDto {
    /** 总数 */
    totalCount!: number;
    /** 数据集合 */
    items!: ResetToZeroLogOutDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ResetToZeroLogOutDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): PageTotalResetToZeroLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageTotalResetToZeroLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class PagedCustomerResultRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    keyword!: string | null;
    exportType!: number;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.keyword = _data["keyword"] !== undefined ? _data["keyword"] : null as any;
            this.exportType = _data["exportType"] !== undefined ? _data["exportType"] : null as any;
        }
    }

    static fromJS(data: any): PagedCustomerResultRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedCustomerResultRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["keyword"] = this.keyword !== undefined ? this.keyword : null as any;
        data["exportType"] = this.exportType !== undefined ? this.exportType : null as any;
        return data;
    }
}

/** 分页内销非销售订单 */
export class PagedDomesticNonSalesOrderRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 客户名称 */
    customerName!: string | null;
    /** 合同号 */
    contractNumber!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.contractNumber = _data["contractNumber"] !== undefined ? _data["contractNumber"] : null as any;
        }
    }

    static fromJS(data: any): PagedDomesticNonSalesOrderRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedDomesticNonSalesOrderRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["contractNumber"] = this.contractNumber !== undefined ? this.contractNumber : null as any;
        return data;
    }
}

/** 分页获取外销OpenVC */
export class PagedExportOrderOpenVcRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    /** VC编号 */
    vcCode!: string | null;
    /** OpenVc */
    open!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.open = _data["open"] !== undefined ? _data["open"] : null as any;
        }
    }

    static fromJS(data: any): PagedExportOrderOpenVcRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedExportOrderOpenVcRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["open"] = this.open !== undefined ? this.open : null as any;
        return data;
    }
}

export class PagedSaleAreaUserDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 搜索关键字 */
    keyword!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.keyword = _data["keyword"] !== undefined ? _data["keyword"] : null as any;
        }
    }

    static fromJS(data: any): PagedSaleAreaUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedSaleAreaUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["keyword"] = this.keyword !== undefined ? this.keyword : null as any;
        return data;
    }
}

/** 分页品类对象 */
export class PagedSpecialOfferNoRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 特价号 */
    specialOfferNumber!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.specialOfferNumber = _data["specialOfferNumber"] !== undefined ? _data["specialOfferNumber"] : null as any;
        }
    }

    static fromJS(data: any): PagedSpecialOfferNoRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedSpecialOfferNoRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["specialOfferNumber"] = this.specialOfferNumber !== undefined ? this.specialOfferNumber : null as any;
        return data;
    }
}

export class Prdelec {
    iRowNo!: string | null;
    cvVoltage!: number;
    fEffect!: number;
    cvConnection!: number;
    cvFrequency!: number;
    dOutput!: number;
    iSpeed!: number;
    fCurrent!: number;
    fCosfi!: number;
    fTorque!: number;
    fStartingCurrent!: number;
    iTETime!: number;
    cvTempRiseClass!: number;
    iAmbientTemp!: number;
    iAltitude!: number;
    cvTypeOfDuty!: number;
    cvDutyTime!: number;
    ie!: string | null;
    ieload100!: number;
    ieload75!: number;
    ieload50!: string | null;
    meps!: string | null;
    stamp!: boolean;
    cvElecTempClass!: number;
    calculationID!: string | null;
    fServiceFactor!: number;
    print!: string | null;

    init(_data?: any) {
        if (_data) {
            this.iRowNo = _data["iRowNo"] !== undefined ? _data["iRowNo"] : null as any;
            this.cvVoltage = _data["cvVoltage"] !== undefined ? _data["cvVoltage"] : null as any;
            this.fEffect = _data["fEffect"] !== undefined ? _data["fEffect"] : null as any;
            this.cvConnection = _data["cvConnection"] !== undefined ? _data["cvConnection"] : null as any;
            this.cvFrequency = _data["cvFrequency"] !== undefined ? _data["cvFrequency"] : null as any;
            this.dOutput = _data["dOutput"] !== undefined ? _data["dOutput"] : null as any;
            this.iSpeed = _data["iSpeed"] !== undefined ? _data["iSpeed"] : null as any;
            this.fCurrent = _data["fCurrent"] !== undefined ? _data["fCurrent"] : null as any;
            this.fCosfi = _data["fCosfi"] !== undefined ? _data["fCosfi"] : null as any;
            this.fTorque = _data["fTorque"] !== undefined ? _data["fTorque"] : null as any;
            this.fStartingCurrent = _data["fStartingCurrent"] !== undefined ? _data["fStartingCurrent"] : null as any;
            this.iTETime = _data["iTETime"] !== undefined ? _data["iTETime"] : null as any;
            this.cvTempRiseClass = _data["cvTempRiseClass"] !== undefined ? _data["cvTempRiseClass"] : null as any;
            this.iAmbientTemp = _data["iAmbientTemp"] !== undefined ? _data["iAmbientTemp"] : null as any;
            this.iAltitude = _data["iAltitude"] !== undefined ? _data["iAltitude"] : null as any;
            this.cvTypeOfDuty = _data["cvTypeOfDuty"] !== undefined ? _data["cvTypeOfDuty"] : null as any;
            this.cvDutyTime = _data["cvDutyTime"] !== undefined ? _data["cvDutyTime"] : null as any;
            this.ie = _data["ie"] !== undefined ? _data["ie"] : null as any;
            this.ieload100 = _data["ieload100"] !== undefined ? _data["ieload100"] : null as any;
            this.ieload75 = _data["ieload75"] !== undefined ? _data["ieload75"] : null as any;
            this.ieload50 = _data["ieload50"] !== undefined ? _data["ieload50"] : null as any;
            this.meps = _data["meps"] !== undefined ? _data["meps"] : null as any;
            this.stamp = _data["stamp"] !== undefined ? _data["stamp"] : null as any;
            this.cvElecTempClass = _data["cvElecTempClass"] !== undefined ? _data["cvElecTempClass"] : null as any;
            this.calculationID = _data["calculationID"] !== undefined ? _data["calculationID"] : null as any;
            this.fServiceFactor = _data["fServiceFactor"] !== undefined ? _data["fServiceFactor"] : null as any;
            this.print = _data["print"] !== undefined ? _data["print"] : null as any;
        }
    }

    static fromJS(data: any): Prdelec {
        data = typeof data === 'object' ? data : {};
        let result = new Prdelec();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iRowNo"] = this.iRowNo !== undefined ? this.iRowNo : null as any;
        data["cvVoltage"] = this.cvVoltage !== undefined ? this.cvVoltage : null as any;
        data["fEffect"] = this.fEffect !== undefined ? this.fEffect : null as any;
        data["cvConnection"] = this.cvConnection !== undefined ? this.cvConnection : null as any;
        data["cvFrequency"] = this.cvFrequency !== undefined ? this.cvFrequency : null as any;
        data["dOutput"] = this.dOutput !== undefined ? this.dOutput : null as any;
        data["iSpeed"] = this.iSpeed !== undefined ? this.iSpeed : null as any;
        data["fCurrent"] = this.fCurrent !== undefined ? this.fCurrent : null as any;
        data["fCosfi"] = this.fCosfi !== undefined ? this.fCosfi : null as any;
        data["fTorque"] = this.fTorque !== undefined ? this.fTorque : null as any;
        data["fStartingCurrent"] = this.fStartingCurrent !== undefined ? this.fStartingCurrent : null as any;
        data["iTETime"] = this.iTETime !== undefined ? this.iTETime : null as any;
        data["cvTempRiseClass"] = this.cvTempRiseClass !== undefined ? this.cvTempRiseClass : null as any;
        data["iAmbientTemp"] = this.iAmbientTemp !== undefined ? this.iAmbientTemp : null as any;
        data["iAltitude"] = this.iAltitude !== undefined ? this.iAltitude : null as any;
        data["cvTypeOfDuty"] = this.cvTypeOfDuty !== undefined ? this.cvTypeOfDuty : null as any;
        data["cvDutyTime"] = this.cvDutyTime !== undefined ? this.cvDutyTime : null as any;
        data["ie"] = this.ie !== undefined ? this.ie : null as any;
        data["ieload100"] = this.ieload100 !== undefined ? this.ieload100 : null as any;
        data["ieload75"] = this.ieload75 !== undefined ? this.ieload75 : null as any;
        data["ieload50"] = this.ieload50 !== undefined ? this.ieload50 : null as any;
        data["meps"] = this.meps !== undefined ? this.meps : null as any;
        data["stamp"] = this.stamp !== undefined ? this.stamp : null as any;
        data["cvElecTempClass"] = this.cvElecTempClass !== undefined ? this.cvElecTempClass : null as any;
        data["calculationID"] = this.calculationID !== undefined ? this.calculationID : null as any;
        data["fServiceFactor"] = this.fServiceFactor !== undefined ? this.fServiceFactor : null as any;
        data["print"] = this.print !== undefined ? this.print : null as any;
        return data;
    }
}

export class Prdtech {
    szTypeDesignation!: string | null;
    cvIntProtection!: number;
    cvCoolMethod!: number;
    cvMounting!: number;
    cvInsulationClass!: number;
    cvTempRiseClass!: number;
    iAmbientTemp!: number;
    iAltitude!: number;
    cvLoadType!: number;
    cvStartingOfMotor!: number;
    cvTypeOfDuty!: number;
    cvDutyTime!: number;
    szSoundPreslLev_Db_A!: string | null;
    cvEXProtection!: number;
    cvEXGrouping!: number;
    cvTechTempClass!: number;
    szCertificateNo!: string | null;
    bIsNema!: boolean;
    cvTerminalBoxLocation!: number;
    cvDirectionOfRotation!: number;
    szBearing_d_end!: string | null;
    szBearingNon_d_end!: string | null;
    cvLubrication!: number;
    cvStandard!: number;
    fServiceFactor!: number;
    szApplication!: string | null;
    cvPolesHigh!: number;
    cvPolesLow!: number;
    cvFrameSize!: number;
    bTwoSpeedMotor!: boolean;
    ie50hz!: string | null;
    ie50hzload100!: number;
    ie50hzload75!: number;
    ie50hzload50!: number;
    ie60hz!: string | null;
    ie60hzload100!: number;
    ie60hzload75!: number;
    ie60hzload50!: number;
    cvPrdType!: number;
    meps!: string | null;

    init(_data?: any) {
        if (_data) {
            this.szTypeDesignation = _data["szTypeDesignation"] !== undefined ? _data["szTypeDesignation"] : null as any;
            this.cvIntProtection = _data["cvIntProtection"] !== undefined ? _data["cvIntProtection"] : null as any;
            this.cvCoolMethod = _data["cvCoolMethod"] !== undefined ? _data["cvCoolMethod"] : null as any;
            this.cvMounting = _data["cvMounting"] !== undefined ? _data["cvMounting"] : null as any;
            this.cvInsulationClass = _data["cvInsulationClass"] !== undefined ? _data["cvInsulationClass"] : null as any;
            this.cvTempRiseClass = _data["cvTempRiseClass"] !== undefined ? _data["cvTempRiseClass"] : null as any;
            this.iAmbientTemp = _data["iAmbientTemp"] !== undefined ? _data["iAmbientTemp"] : null as any;
            this.iAltitude = _data["iAltitude"] !== undefined ? _data["iAltitude"] : null as any;
            this.cvLoadType = _data["cvLoadType"] !== undefined ? _data["cvLoadType"] : null as any;
            this.cvStartingOfMotor = _data["cvStartingOfMotor"] !== undefined ? _data["cvStartingOfMotor"] : null as any;
            this.cvTypeOfDuty = _data["cvTypeOfDuty"] !== undefined ? _data["cvTypeOfDuty"] : null as any;
            this.cvDutyTime = _data["cvDutyTime"] !== undefined ? _data["cvDutyTime"] : null as any;
            this.szSoundPreslLev_Db_A = _data["szSoundPreslLev_Db_A"] !== undefined ? _data["szSoundPreslLev_Db_A"] : null as any;
            this.cvEXProtection = _data["cvEXProtection"] !== undefined ? _data["cvEXProtection"] : null as any;
            this.cvEXGrouping = _data["cvEXGrouping"] !== undefined ? _data["cvEXGrouping"] : null as any;
            this.cvTechTempClass = _data["cvTechTempClass"] !== undefined ? _data["cvTechTempClass"] : null as any;
            this.szCertificateNo = _data["szCertificateNo"] !== undefined ? _data["szCertificateNo"] : null as any;
            this.bIsNema = _data["bIsNema"] !== undefined ? _data["bIsNema"] : null as any;
            this.cvTerminalBoxLocation = _data["cvTerminalBoxLocation"] !== undefined ? _data["cvTerminalBoxLocation"] : null as any;
            this.cvDirectionOfRotation = _data["cvDirectionOfRotation"] !== undefined ? _data["cvDirectionOfRotation"] : null as any;
            this.szBearing_d_end = _data["szBearing_d_end"] !== undefined ? _data["szBearing_d_end"] : null as any;
            this.szBearingNon_d_end = _data["szBearingNon_d_end"] !== undefined ? _data["szBearingNon_d_end"] : null as any;
            this.cvLubrication = _data["cvLubrication"] !== undefined ? _data["cvLubrication"] : null as any;
            this.cvStandard = _data["cvStandard"] !== undefined ? _data["cvStandard"] : null as any;
            this.fServiceFactor = _data["fServiceFactor"] !== undefined ? _data["fServiceFactor"] : null as any;
            this.szApplication = _data["szApplication"] !== undefined ? _data["szApplication"] : null as any;
            this.cvPolesHigh = _data["cvPolesHigh"] !== undefined ? _data["cvPolesHigh"] : null as any;
            this.cvPolesLow = _data["cvPolesLow"] !== undefined ? _data["cvPolesLow"] : null as any;
            this.cvFrameSize = _data["cvFrameSize"] !== undefined ? _data["cvFrameSize"] : null as any;
            this.bTwoSpeedMotor = _data["bTwoSpeedMotor"] !== undefined ? _data["bTwoSpeedMotor"] : null as any;
            this.ie50hz = _data["ie50hz"] !== undefined ? _data["ie50hz"] : null as any;
            this.ie50hzload100 = _data["ie50hzload100"] !== undefined ? _data["ie50hzload100"] : null as any;
            this.ie50hzload75 = _data["ie50hzload75"] !== undefined ? _data["ie50hzload75"] : null as any;
            this.ie50hzload50 = _data["ie50hzload50"] !== undefined ? _data["ie50hzload50"] : null as any;
            this.ie60hz = _data["ie60hz"] !== undefined ? _data["ie60hz"] : null as any;
            this.ie60hzload100 = _data["ie60hzload100"] !== undefined ? _data["ie60hzload100"] : null as any;
            this.ie60hzload75 = _data["ie60hzload75"] !== undefined ? _data["ie60hzload75"] : null as any;
            this.ie60hzload50 = _data["ie60hzload50"] !== undefined ? _data["ie60hzload50"] : null as any;
            this.cvPrdType = _data["cvPrdType"] !== undefined ? _data["cvPrdType"] : null as any;
            this.meps = _data["meps"] !== undefined ? _data["meps"] : null as any;
        }
    }

    static fromJS(data: any): Prdtech {
        data = typeof data === 'object' ? data : {};
        let result = new Prdtech();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["szTypeDesignation"] = this.szTypeDesignation !== undefined ? this.szTypeDesignation : null as any;
        data["cvIntProtection"] = this.cvIntProtection !== undefined ? this.cvIntProtection : null as any;
        data["cvCoolMethod"] = this.cvCoolMethod !== undefined ? this.cvCoolMethod : null as any;
        data["cvMounting"] = this.cvMounting !== undefined ? this.cvMounting : null as any;
        data["cvInsulationClass"] = this.cvInsulationClass !== undefined ? this.cvInsulationClass : null as any;
        data["cvTempRiseClass"] = this.cvTempRiseClass !== undefined ? this.cvTempRiseClass : null as any;
        data["iAmbientTemp"] = this.iAmbientTemp !== undefined ? this.iAmbientTemp : null as any;
        data["iAltitude"] = this.iAltitude !== undefined ? this.iAltitude : null as any;
        data["cvLoadType"] = this.cvLoadType !== undefined ? this.cvLoadType : null as any;
        data["cvStartingOfMotor"] = this.cvStartingOfMotor !== undefined ? this.cvStartingOfMotor : null as any;
        data["cvTypeOfDuty"] = this.cvTypeOfDuty !== undefined ? this.cvTypeOfDuty : null as any;
        data["cvDutyTime"] = this.cvDutyTime !== undefined ? this.cvDutyTime : null as any;
        data["szSoundPreslLev_Db_A"] = this.szSoundPreslLev_Db_A !== undefined ? this.szSoundPreslLev_Db_A : null as any;
        data["cvEXProtection"] = this.cvEXProtection !== undefined ? this.cvEXProtection : null as any;
        data["cvEXGrouping"] = this.cvEXGrouping !== undefined ? this.cvEXGrouping : null as any;
        data["cvTechTempClass"] = this.cvTechTempClass !== undefined ? this.cvTechTempClass : null as any;
        data["szCertificateNo"] = this.szCertificateNo !== undefined ? this.szCertificateNo : null as any;
        data["bIsNema"] = this.bIsNema !== undefined ? this.bIsNema : null as any;
        data["cvTerminalBoxLocation"] = this.cvTerminalBoxLocation !== undefined ? this.cvTerminalBoxLocation : null as any;
        data["cvDirectionOfRotation"] = this.cvDirectionOfRotation !== undefined ? this.cvDirectionOfRotation : null as any;
        data["szBearing_d_end"] = this.szBearing_d_end !== undefined ? this.szBearing_d_end : null as any;
        data["szBearingNon_d_end"] = this.szBearingNon_d_end !== undefined ? this.szBearingNon_d_end : null as any;
        data["cvLubrication"] = this.cvLubrication !== undefined ? this.cvLubrication : null as any;
        data["cvStandard"] = this.cvStandard !== undefined ? this.cvStandard : null as any;
        data["fServiceFactor"] = this.fServiceFactor !== undefined ? this.fServiceFactor : null as any;
        data["szApplication"] = this.szApplication !== undefined ? this.szApplication : null as any;
        data["cvPolesHigh"] = this.cvPolesHigh !== undefined ? this.cvPolesHigh : null as any;
        data["cvPolesLow"] = this.cvPolesLow !== undefined ? this.cvPolesLow : null as any;
        data["cvFrameSize"] = this.cvFrameSize !== undefined ? this.cvFrameSize : null as any;
        data["bTwoSpeedMotor"] = this.bTwoSpeedMotor !== undefined ? this.bTwoSpeedMotor : null as any;
        data["ie50hz"] = this.ie50hz !== undefined ? this.ie50hz : null as any;
        data["ie50hzload100"] = this.ie50hzload100 !== undefined ? this.ie50hzload100 : null as any;
        data["ie50hzload75"] = this.ie50hzload75 !== undefined ? this.ie50hzload75 : null as any;
        data["ie50hzload50"] = this.ie50hzload50 !== undefined ? this.ie50hzload50 : null as any;
        data["ie60hz"] = this.ie60hz !== undefined ? this.ie60hz : null as any;
        data["ie60hzload100"] = this.ie60hzload100 !== undefined ? this.ie60hzload100 : null as any;
        data["ie60hzload75"] = this.ie60hzload75 !== undefined ? this.ie60hzload75 : null as any;
        data["ie60hzload50"] = this.ie60hzload50 !== undefined ? this.ie60hzload50 : null as any;
        data["cvPrdType"] = this.cvPrdType !== undefined ? this.cvPrdType : null as any;
        data["meps"] = this.meps !== undefined ? this.meps : null as any;
        return data;
    }
}

export class Prodelec {
    vc!: string[] | null;
    /** 需要修改elec 的第几行 */
    elecRow!: number;
    /** vc 002 在第一行要改哪些值 */
    elec!: Elec[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vc"])) {
                this.vc = [] as any;
                for (let item of _data["vc"])
                    this.vc!.push(item);
            }
            else {
                this.vc = null as any;
            }
            this.elecRow = _data["elecRow"] !== undefined ? _data["elecRow"] : null as any;
            if (Array.isArray(_data["elec"])) {
                this.elec = [] as any;
                for (let item of _data["elec"])
                    this.elec!.push(Elec.fromJS(item));
            }
            else {
                this.elec = null as any;
            }
        }
    }

    static fromJS(data: any): Prodelec {
        data = typeof data === 'object' ? data : {};
        let result = new Prodelec();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vc)) {
            data["vc"] = [];
            for (let item of this.vc)
                data["vc"].push(item);
        }
        data["elecRow"] = this.elecRow !== undefined ? this.elecRow : null as any;
        if (Array.isArray(this.elec)) {
            data["elec"] = [];
            for (let item of this.elec)
                data["elec"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class Prodtech {
    /** vc */
    vc!: string[] | null;
    /** input box type */
    inType!: string | null;
    /** integer string list read-only imagelist combobox float */
    paraType!: string | null;
    /** 问题点，tech data 不应该有voltage，需要使用实际设备调用Motorizer api 测试。 */
    key!: string | null;
    mask!: string | null;
    /** default value */
    val!: string | null;
    desc!: string | null;
    help!: string | null;
    domain!: Domain;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vc"])) {
                this.vc = [] as any;
                for (let item of _data["vc"])
                    this.vc!.push(item);
            }
            else {
                this.vc = null as any;
            }
            this.inType = _data["inType"] !== undefined ? _data["inType"] : null as any;
            this.paraType = _data["paraType"] !== undefined ? _data["paraType"] : null as any;
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.mask = _data["mask"] !== undefined ? _data["mask"] : null as any;
            this.val = _data["val"] !== undefined ? _data["val"] : null as any;
            this.desc = _data["desc"] !== undefined ? _data["desc"] : null as any;
            this.help = _data["help"] !== undefined ? _data["help"] : null as any;
            this.domain = _data["domain"] ? Domain.fromJS(_data["domain"]) : null as any;
        }
    }

    static fromJS(data: any): Prodtech {
        data = typeof data === 'object' ? data : {};
        let result = new Prodtech();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vc)) {
            data["vc"] = [];
            for (let item of this.vc)
                data["vc"].push(item);
        }
        data["inType"] = this.inType !== undefined ? this.inType : null as any;
        data["paraType"] = this.paraType !== undefined ? this.paraType : null as any;
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["mask"] = this.mask !== undefined ? this.mask : null as any;
        data["val"] = this.val !== undefined ? this.val : null as any;
        data["desc"] = this.desc !== undefined ? this.desc : null as any;
        data["help"] = this.help !== undefined ? this.help : null as any;
        data["domain"] = this.domain ? this.domain.toJSON() : null as any;
        return data;
    }
}

export class ProductBasicMotor {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    productMixCode!: string | null;
    customerMaterialNumber!: string | null;
    appraisalNumber!: string | null;
    orderType!: string | null;
    basicMotorModel!: string | null;
    basicMotorCode!: string | null;
    basicMotorType!: number;
    basicMotorSries!: string | null;
    numberOfProduct!: number;
    multipilerType!: number;
    multiplier!: number;
    multiplierExpiredDate!: moment.Moment | null;
    unitPriceType!: string | null;
    unitPriceExpiredTime!: moment.Moment | null;
    unitPrice!: number;
    salesPrice!: number;
    oemSalesPrice!: number;
    remark!: string | null;
    remarkTwo!: string | null;
    frameSize!: number;
    expectedDeliveryDate!: string | null;
    actualDeliveryDate!: string | null;
    originalActualDeliveryDate!: string | null;
    customerExpectedDeliveryDate!: moment.Moment | null;
    customerActualDeliveryDate!: moment.Moment | null;
    gssQuotationNo!: string | null;
    gssTechnicalConfirmationNumber!: string | null;
    technicalSpecifications!: string | null;
    receivePrdTechJSON!: string | null;
    receivePrdElecsJSON!: string | null;
    checkResultOutput!: string | null;
    productClassification!: string | null;
    orderClassification!: string | null;
    productVCs!: ProductVC[] | null;
    productBasicMotorMtss!: ProductBasicMotorMts[] | null;
    orderForm!: OrderForm;
    orderFormId!: string | null;
    shoppingCart!: ShoppingCart;
    priceWithTax!: number | null;
    priceWithoutTax!: number | null;
    unitTaxPrice!: number | null;
    discountUnitPrice!: number | null;
    noDiscountByPlatformUnitPrice!: number | null;
    noDiscountByListUnitPrice!: number | null;
    serialNumber!: number | null;
    scSerialNumber!: number | null;
    precalItemNo!: number | null;
    specialRebateFlag!: string | null;
    isNewPMSProduct!: boolean | null;
    operationalRemarks!: string | null;
    pmsMultiplier!: number | null;
    originalMultiplier!: number | null;
    specialOfferNumber!: string | null;
    agreementChanges!: boolean;
    technologyQuotationProductId!: string | null;
    technicalSpecificationProductId!: string | null;
    jinCategoryCode!: string | null;
    jinVersion!: string | null;
    materialDescription!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.productMixCode = _data["productMixCode"] !== undefined ? _data["productMixCode"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.orderType = _data["orderType"] !== undefined ? _data["orderType"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorType = _data["basicMotorType"] !== undefined ? _data["basicMotorType"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.numberOfProduct = _data["numberOfProduct"] !== undefined ? _data["numberOfProduct"] : null as any;
            this.multipilerType = _data["multipilerType"] !== undefined ? _data["multipilerType"] : null as any;
            this.multiplier = _data["multiplier"] !== undefined ? _data["multiplier"] : null as any;
            this.multiplierExpiredDate = _data["multiplierExpiredDate"] ? moment(_data["multiplierExpiredDate"].toString()) : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.unitPriceExpiredTime = _data["unitPriceExpiredTime"] ? moment(_data["unitPriceExpiredTime"].toString()) : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.oemSalesPrice = _data["oemSalesPrice"] !== undefined ? _data["oemSalesPrice"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.remarkTwo = _data["remarkTwo"] !== undefined ? _data["remarkTwo"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.actualDeliveryDate = _data["actualDeliveryDate"] !== undefined ? _data["actualDeliveryDate"] : null as any;
            this.originalActualDeliveryDate = _data["originalActualDeliveryDate"] !== undefined ? _data["originalActualDeliveryDate"] : null as any;
            this.customerExpectedDeliveryDate = _data["customerExpectedDeliveryDate"] ? moment(_data["customerExpectedDeliveryDate"].toString()) : null as any;
            this.customerActualDeliveryDate = _data["customerActualDeliveryDate"] ? moment(_data["customerActualDeliveryDate"].toString()) : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.receivePrdTechJSON = _data["receivePrdTechJSON"] !== undefined ? _data["receivePrdTechJSON"] : null as any;
            this.receivePrdElecsJSON = _data["receivePrdElecsJSON"] !== undefined ? _data["receivePrdElecsJSON"] : null as any;
            this.checkResultOutput = _data["checkResultOutput"] !== undefined ? _data["checkResultOutput"] : null as any;
            this.productClassification = _data["productClassification"] !== undefined ? _data["productClassification"] : null as any;
            this.orderClassification = _data["orderClassification"] !== undefined ? _data["orderClassification"] : null as any;
            if (Array.isArray(_data["productVCs"])) {
                this.productVCs = [] as any;
                for (let item of _data["productVCs"])
                    this.productVCs!.push(ProductVC.fromJS(item));
            }
            else {
                this.productVCs = null as any;
            }
            if (Array.isArray(_data["productBasicMotorMtss"])) {
                this.productBasicMotorMtss = [] as any;
                for (let item of _data["productBasicMotorMtss"])
                    this.productBasicMotorMtss!.push(ProductBasicMotorMts.fromJS(item));
            }
            else {
                this.productBasicMotorMtss = null as any;
            }
            this.orderForm = _data["orderForm"] ? OrderForm.fromJS(_data["orderForm"]) : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.shoppingCart = _data["shoppingCart"] ? ShoppingCart.fromJS(_data["shoppingCart"]) : null as any;
            this.priceWithTax = _data["priceWithTax"] !== undefined ? _data["priceWithTax"] : null as any;
            this.priceWithoutTax = _data["priceWithoutTax"] !== undefined ? _data["priceWithoutTax"] : null as any;
            this.unitTaxPrice = _data["unitTaxPrice"] !== undefined ? _data["unitTaxPrice"] : null as any;
            this.discountUnitPrice = _data["discountUnitPrice"] !== undefined ? _data["discountUnitPrice"] : null as any;
            this.noDiscountByPlatformUnitPrice = _data["noDiscountByPlatformUnitPrice"] !== undefined ? _data["noDiscountByPlatformUnitPrice"] : null as any;
            this.noDiscountByListUnitPrice = _data["noDiscountByListUnitPrice"] !== undefined ? _data["noDiscountByListUnitPrice"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.scSerialNumber = _data["scSerialNumber"] !== undefined ? _data["scSerialNumber"] : null as any;
            this.precalItemNo = _data["precalItemNo"] !== undefined ? _data["precalItemNo"] : null as any;
            this.specialRebateFlag = _data["specialRebateFlag"] !== undefined ? _data["specialRebateFlag"] : null as any;
            this.isNewPMSProduct = _data["isNewPMSProduct"] !== undefined ? _data["isNewPMSProduct"] : null as any;
            this.operationalRemarks = _data["operationalRemarks"] !== undefined ? _data["operationalRemarks"] : null as any;
            this.pmsMultiplier = _data["pmsMultiplier"] !== undefined ? _data["pmsMultiplier"] : null as any;
            this.originalMultiplier = _data["originalMultiplier"] !== undefined ? _data["originalMultiplier"] : null as any;
            this.specialOfferNumber = _data["specialOfferNumber"] !== undefined ? _data["specialOfferNumber"] : null as any;
            this.agreementChanges = _data["agreementChanges"] !== undefined ? _data["agreementChanges"] : null as any;
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
            this.technicalSpecificationProductId = _data["technicalSpecificationProductId"] !== undefined ? _data["technicalSpecificationProductId"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.materialDescription = _data["materialDescription"] !== undefined ? _data["materialDescription"] : null as any;
        }
    }

    static fromJS(data: any): ProductBasicMotor {
        data = typeof data === 'object' ? data : {};
        let result = new ProductBasicMotor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["productMixCode"] = this.productMixCode !== undefined ? this.productMixCode : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["orderType"] = this.orderType !== undefined ? this.orderType : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorType"] = this.basicMotorType !== undefined ? this.basicMotorType : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["numberOfProduct"] = this.numberOfProduct !== undefined ? this.numberOfProduct : null as any;
        data["multipilerType"] = this.multipilerType !== undefined ? this.multipilerType : null as any;
        data["multiplier"] = this.multiplier !== undefined ? this.multiplier : null as any;
        data["multiplierExpiredDate"] = this.multiplierExpiredDate ? this.multiplierExpiredDate.toISOString() : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["unitPriceExpiredTime"] = this.unitPriceExpiredTime ? this.unitPriceExpiredTime.toISOString() : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["oemSalesPrice"] = this.oemSalesPrice !== undefined ? this.oemSalesPrice : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["remarkTwo"] = this.remarkTwo !== undefined ? this.remarkTwo : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["actualDeliveryDate"] = this.actualDeliveryDate !== undefined ? this.actualDeliveryDate : null as any;
        data["originalActualDeliveryDate"] = this.originalActualDeliveryDate !== undefined ? this.originalActualDeliveryDate : null as any;
        data["customerExpectedDeliveryDate"] = this.customerExpectedDeliveryDate ? this.customerExpectedDeliveryDate.toISOString() : null as any;
        data["customerActualDeliveryDate"] = this.customerActualDeliveryDate ? this.customerActualDeliveryDate.toISOString() : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["receivePrdTechJSON"] = this.receivePrdTechJSON !== undefined ? this.receivePrdTechJSON : null as any;
        data["receivePrdElecsJSON"] = this.receivePrdElecsJSON !== undefined ? this.receivePrdElecsJSON : null as any;
        data["checkResultOutput"] = this.checkResultOutput !== undefined ? this.checkResultOutput : null as any;
        data["productClassification"] = this.productClassification !== undefined ? this.productClassification : null as any;
        data["orderClassification"] = this.orderClassification !== undefined ? this.orderClassification : null as any;
        if (Array.isArray(this.productVCs)) {
            data["productVCs"] = [];
            for (let item of this.productVCs)
                data["productVCs"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.productBasicMotorMtss)) {
            data["productBasicMotorMtss"] = [];
            for (let item of this.productBasicMotorMtss)
                data["productBasicMotorMtss"].push(item ? item.toJSON() : null as any);
        }
        data["orderForm"] = this.orderForm ? this.orderForm.toJSON() : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["shoppingCart"] = this.shoppingCart ? this.shoppingCart.toJSON() : null as any;
        data["priceWithTax"] = this.priceWithTax !== undefined ? this.priceWithTax : null as any;
        data["priceWithoutTax"] = this.priceWithoutTax !== undefined ? this.priceWithoutTax : null as any;
        data["unitTaxPrice"] = this.unitTaxPrice !== undefined ? this.unitTaxPrice : null as any;
        data["discountUnitPrice"] = this.discountUnitPrice !== undefined ? this.discountUnitPrice : null as any;
        data["noDiscountByPlatformUnitPrice"] = this.noDiscountByPlatformUnitPrice !== undefined ? this.noDiscountByPlatformUnitPrice : null as any;
        data["noDiscountByListUnitPrice"] = this.noDiscountByListUnitPrice !== undefined ? this.noDiscountByListUnitPrice : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["scSerialNumber"] = this.scSerialNumber !== undefined ? this.scSerialNumber : null as any;
        data["precalItemNo"] = this.precalItemNo !== undefined ? this.precalItemNo : null as any;
        data["specialRebateFlag"] = this.specialRebateFlag !== undefined ? this.specialRebateFlag : null as any;
        data["isNewPMSProduct"] = this.isNewPMSProduct !== undefined ? this.isNewPMSProduct : null as any;
        data["operationalRemarks"] = this.operationalRemarks !== undefined ? this.operationalRemarks : null as any;
        data["pmsMultiplier"] = this.pmsMultiplier !== undefined ? this.pmsMultiplier : null as any;
        data["originalMultiplier"] = this.originalMultiplier !== undefined ? this.originalMultiplier : null as any;
        data["specialOfferNumber"] = this.specialOfferNumber !== undefined ? this.specialOfferNumber : null as any;
        data["agreementChanges"] = this.agreementChanges !== undefined ? this.agreementChanges : null as any;
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        data["technicalSpecificationProductId"] = this.technicalSpecificationProductId !== undefined ? this.technicalSpecificationProductId : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["materialDescription"] = this.materialDescription !== undefined ? this.materialDescription : null as any;
        return data;
    }
}

/** 0 = Active (已发布) 1 = Inactive (待发布) 2 = Expired (已失效) */
export enum ProductBasicMotorCodeStatus {
    Active = 0,
    Inactive = 1,
    Expired = 2,
}

export class ProductBasicMotorMts {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    productBasicMotor!: ProductBasicMotor;
    productBasicMotorId!: string;
    poNumber!: string | null;
    basicMotorCode!: string | null;
    autoDeliveryTime!: moment.Moment | null;
    shipToPartyName!: string | null;
    telephone!: string | null;
    streetHouseNumber!: string | null;
    thipToPartyName!: string | null;
    shippingType!: string | null;
    availableStock!: number | null;
    orderSource!: string | null;
    createUserId!: number | null;
    forLibOrderFlg!: boolean;
    isAutomaticShipping!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.productBasicMotor = _data["productBasicMotor"] ? ProductBasicMotor.fromJS(_data["productBasicMotor"]) : null as any;
            this.productBasicMotorId = _data["productBasicMotorId"] !== undefined ? _data["productBasicMotorId"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.autoDeliveryTime = _data["autoDeliveryTime"] ? moment(_data["autoDeliveryTime"].toString()) : null as any;
            this.shipToPartyName = _data["shipToPartyName"] !== undefined ? _data["shipToPartyName"] : null as any;
            this.telephone = _data["telephone"] !== undefined ? _data["telephone"] : null as any;
            this.streetHouseNumber = _data["streetHouseNumber"] !== undefined ? _data["streetHouseNumber"] : null as any;
            this.thipToPartyName = _data["thipToPartyName"] !== undefined ? _data["thipToPartyName"] : null as any;
            this.shippingType = _data["shippingType"] !== undefined ? _data["shippingType"] : null as any;
            this.availableStock = _data["availableStock"] !== undefined ? _data["availableStock"] : null as any;
            this.orderSource = _data["orderSource"] !== undefined ? _data["orderSource"] : null as any;
            this.createUserId = _data["createUserId"] !== undefined ? _data["createUserId"] : null as any;
            this.forLibOrderFlg = _data["forLibOrderFlg"] !== undefined ? _data["forLibOrderFlg"] : null as any;
            this.isAutomaticShipping = _data["isAutomaticShipping"] !== undefined ? _data["isAutomaticShipping"] : null as any;
        }
    }

    static fromJS(data: any): ProductBasicMotorMts {
        data = typeof data === 'object' ? data : {};
        let result = new ProductBasicMotorMts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["productBasicMotor"] = this.productBasicMotor ? this.productBasicMotor.toJSON() : null as any;
        data["productBasicMotorId"] = this.productBasicMotorId !== undefined ? this.productBasicMotorId : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["autoDeliveryTime"] = this.autoDeliveryTime ? this.autoDeliveryTime.toISOString() : null as any;
        data["shipToPartyName"] = this.shipToPartyName !== undefined ? this.shipToPartyName : null as any;
        data["telephone"] = this.telephone !== undefined ? this.telephone : null as any;
        data["streetHouseNumber"] = this.streetHouseNumber !== undefined ? this.streetHouseNumber : null as any;
        data["thipToPartyName"] = this.thipToPartyName !== undefined ? this.thipToPartyName : null as any;
        data["shippingType"] = this.shippingType !== undefined ? this.shippingType : null as any;
        data["availableStock"] = this.availableStock !== undefined ? this.availableStock : null as any;
        data["orderSource"] = this.orderSource !== undefined ? this.orderSource : null as any;
        data["createUserId"] = this.createUserId !== undefined ? this.createUserId : null as any;
        data["forLibOrderFlg"] = this.forLibOrderFlg !== undefined ? this.forLibOrderFlg : null as any;
        data["isAutomaticShipping"] = this.isAutomaticShipping !== undefined ? this.isAutomaticShipping : null as any;
        return data;
    }
}

/** ois 下单 */
export class ProductBasicMotorMtsInDto {
    /** 主键Id */
    id!: string | null;
    /** 主机Id */
    productBasicMotorId!: string | null;
    /** 合同号 */
    poNumber!: string | null;
    /** 行号 */
    serialNumber!: string | null;
    /** 物料号 */
    basicMotorCode!: string | null;
    /** 自动发货时间 */
    autoDeliveryTime!: moment.Moment | null;
    /** 是否为备库订单 */
    forLibOrderFlg!: boolean;
    /** 订单来源 */
    orderSource!: string | null;
    /** 客户名称 */
    shipToPartyName!: string | null;
    /** 联系电话 */
    telephone!: string | null;
    /** 收货地址 */
    streetHouseNumber!: string | null;
    /** 收货地址編碼 */
    streetHouseNumberCode!: string | null;
    /** 收货人 */
    thipToPartyName!: string | null;
    /** 运输类型 */
    shippingType!: string | null;
    /** 可用库存 */
    availableStock!: number | null;
    /** 创建人 */
    createUserId!: number | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.productBasicMotorId = _data["productBasicMotorId"] !== undefined ? _data["productBasicMotorId"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.autoDeliveryTime = _data["autoDeliveryTime"] ? moment(_data["autoDeliveryTime"].toString()) : null as any;
            this.forLibOrderFlg = _data["forLibOrderFlg"] !== undefined ? _data["forLibOrderFlg"] : null as any;
            this.orderSource = _data["orderSource"] !== undefined ? _data["orderSource"] : null as any;
            this.shipToPartyName = _data["shipToPartyName"] !== undefined ? _data["shipToPartyName"] : null as any;
            this.telephone = _data["telephone"] !== undefined ? _data["telephone"] : null as any;
            this.streetHouseNumber = _data["streetHouseNumber"] !== undefined ? _data["streetHouseNumber"] : null as any;
            this.streetHouseNumberCode = _data["streetHouseNumberCode"] !== undefined ? _data["streetHouseNumberCode"] : null as any;
            this.thipToPartyName = _data["thipToPartyName"] !== undefined ? _data["thipToPartyName"] : null as any;
            this.shippingType = _data["shippingType"] !== undefined ? _data["shippingType"] : null as any;
            this.availableStock = _data["availableStock"] !== undefined ? _data["availableStock"] : null as any;
            this.createUserId = _data["createUserId"] !== undefined ? _data["createUserId"] : null as any;
        }
    }

    static fromJS(data: any): ProductBasicMotorMtsInDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductBasicMotorMtsInDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["productBasicMotorId"] = this.productBasicMotorId !== undefined ? this.productBasicMotorId : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["autoDeliveryTime"] = this.autoDeliveryTime ? this.autoDeliveryTime.toISOString() : null as any;
        data["forLibOrderFlg"] = this.forLibOrderFlg !== undefined ? this.forLibOrderFlg : null as any;
        data["orderSource"] = this.orderSource !== undefined ? this.orderSource : null as any;
        data["shipToPartyName"] = this.shipToPartyName !== undefined ? this.shipToPartyName : null as any;
        data["telephone"] = this.telephone !== undefined ? this.telephone : null as any;
        data["streetHouseNumber"] = this.streetHouseNumber !== undefined ? this.streetHouseNumber : null as any;
        data["streetHouseNumberCode"] = this.streetHouseNumberCode !== undefined ? this.streetHouseNumberCode : null as any;
        data["thipToPartyName"] = this.thipToPartyName !== undefined ? this.thipToPartyName : null as any;
        data["shippingType"] = this.shippingType !== undefined ? this.shippingType : null as any;
        data["availableStock"] = this.availableStock !== undefined ? this.availableStock : null as any;
        data["createUserId"] = this.createUserId !== undefined ? this.createUserId : null as any;
        return data;
    }
}

/** 0 = Standard (-) 1 = Confirmed (已确认) 2 = Create (新增) 3 = Remove (移除) */
export enum ProductSyncConfirmStatus {
    Standard = 0,
    Confirmed = 1,
    Create = 2,
    Remove = 3,
}

export class ProductVC {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    vcProductCode!: string | null;
    vcCode!: string | null;
    vcShowType!: number;
    discountType!: string | null;
    unitPriceType!: string | null;
    unitPriceExpiredTime!: moment.Moment | null;
    unitPrice!: number;
    salesPrice!: number;
    meaning!: string | null;
    remark!: string | null;
    receiveVcFreeTextJSON!: string | null;
    productBasicMotor!: ProductBasicMotor;
    isNewProductVC!: boolean | null;
    vcType!: number;
    technologyQuotationProductVCId!: string | null;
    technicalSpecificationProductVCId!: string | null;
    productBasicMotorId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.vcProductCode = _data["vcProductCode"] !== undefined ? _data["vcProductCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.unitPriceExpiredTime = _data["unitPriceExpiredTime"] ? moment(_data["unitPriceExpiredTime"].toString()) : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.receiveVcFreeTextJSON = _data["receiveVcFreeTextJSON"] !== undefined ? _data["receiveVcFreeTextJSON"] : null as any;
            this.productBasicMotor = _data["productBasicMotor"] ? ProductBasicMotor.fromJS(_data["productBasicMotor"]) : null as any;
            this.isNewProductVC = _data["isNewProductVC"] !== undefined ? _data["isNewProductVC"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.technologyQuotationProductVCId = _data["technologyQuotationProductVCId"] !== undefined ? _data["technologyQuotationProductVCId"] : null as any;
            this.technicalSpecificationProductVCId = _data["technicalSpecificationProductVCId"] !== undefined ? _data["technicalSpecificationProductVCId"] : null as any;
            this.productBasicMotorId = _data["productBasicMotorId"] !== undefined ? _data["productBasicMotorId"] : null as any;
        }
    }

    static fromJS(data: any): ProductVC {
        data = typeof data === 'object' ? data : {};
        let result = new ProductVC();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["vcProductCode"] = this.vcProductCode !== undefined ? this.vcProductCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["discountType"] = this.discountType !== undefined ? this.discountType : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["unitPriceExpiredTime"] = this.unitPriceExpiredTime ? this.unitPriceExpiredTime.toISOString() : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["receiveVcFreeTextJSON"] = this.receiveVcFreeTextJSON !== undefined ? this.receiveVcFreeTextJSON : null as any;
        data["productBasicMotor"] = this.productBasicMotor ? this.productBasicMotor.toJSON() : null as any;
        data["isNewProductVC"] = this.isNewProductVC !== undefined ? this.isNewProductVC : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["technologyQuotationProductVCId"] = this.technologyQuotationProductVCId !== undefined ? this.technologyQuotationProductVCId : null as any;
        data["technicalSpecificationProductVCId"] = this.technicalSpecificationProductVCId !== undefined ? this.technicalSpecificationProductVCId : null as any;
        data["productBasicMotorId"] = this.productBasicMotorId !== undefined ? this.productBasicMotorId : null as any;
        return data;
    }
}

/** 0 = Superposition (叠加) 1 = Value (取值) */
export enum PurchaseCycleMode {
    Superposition = 0,
    Value = 1,
}

/** 0 = Appoint (指定基座号) 1 = Range (指定基座号范围) */
export enum QuantityLimitType {
    Appoint = 0,
    Range = 1,
}

export class QueryBOMProductDto {
    /** 节点上下文（当前任务节点的 formKey；空 = 不做默认值带出） */
    formKey!: string | null;
    /** 变更版本ID */
    ocfId!: string;
    /** 行号 */
    serialNumbers!: string[] | null;
    /** 请求TaskId */
    taskServiceRequestId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.formKey = _data["formKey"] !== undefined ? _data["formKey"] : null as any;
            this.ocfId = _data["ocfId"] !== undefined ? _data["ocfId"] : null as any;
            if (Array.isArray(_data["serialNumbers"])) {
                this.serialNumbers = [] as any;
                for (let item of _data["serialNumbers"])
                    this.serialNumbers!.push(item);
            }
            else {
                this.serialNumbers = null as any;
            }
            this.taskServiceRequestId = _data["taskServiceRequestId"] !== undefined ? _data["taskServiceRequestId"] : null as any;
        }
    }

    static fromJS(data: any): QueryBOMProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryBOMProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formKey"] = this.formKey !== undefined ? this.formKey : null as any;
        data["ocfId"] = this.ocfId !== undefined ? this.ocfId : null as any;
        if (Array.isArray(this.serialNumbers)) {
            data["serialNumbers"] = [];
            for (let item of this.serialNumbers)
                data["serialNumbers"].push(item);
        }
        data["taskServiceRequestId"] = this.taskServiceRequestId !== undefined ? this.taskServiceRequestId : null as any;
        return data;
    }
}

export class QueryBOMProductForAllDto {
    /** 变更版本ID */
    orderChangeFormVersionId!: string;
    /** 查询的行 */
    queryBOMProductForAllItems!: QueryBOMProductForAllItem[] | null;

    init(_data?: any) {
        if (_data) {
            this.orderChangeFormVersionId = _data["orderChangeFormVersionId"] !== undefined ? _data["orderChangeFormVersionId"] : null as any;
            if (Array.isArray(_data["queryBOMProductForAllItems"])) {
                this.queryBOMProductForAllItems = [] as any;
                for (let item of _data["queryBOMProductForAllItems"])
                    this.queryBOMProductForAllItems!.push(QueryBOMProductForAllItem.fromJS(item));
            }
            else {
                this.queryBOMProductForAllItems = null as any;
            }
        }
    }

    static fromJS(data: any): QueryBOMProductForAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryBOMProductForAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderChangeFormVersionId"] = this.orderChangeFormVersionId !== undefined ? this.orderChangeFormVersionId : null as any;
        if (Array.isArray(this.queryBOMProductForAllItems)) {
            data["queryBOMProductForAllItems"] = [];
            for (let item of this.queryBOMProductForAllItems)
                data["queryBOMProductForAllItems"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class QueryBOMProductForAllItem {
    /** 待计算行序号 */
    inputSerialNumber!: number;
    /** 商务折扣系数 */
    inputMultiplier!: number;
    /** 行报价 */
    inputPrice!: number;
    /** 汇率*关税 */
    exchangeRateAndTariff!: number | null;

    init(_data?: any) {
        if (_data) {
            this.inputSerialNumber = _data["inputSerialNumber"] !== undefined ? _data["inputSerialNumber"] : null as any;
            this.inputMultiplier = _data["inputMultiplier"] !== undefined ? _data["inputMultiplier"] : null as any;
            this.inputPrice = _data["inputPrice"] !== undefined ? _data["inputPrice"] : null as any;
            this.exchangeRateAndTariff = _data["exchangeRateAndTariff"] !== undefined ? _data["exchangeRateAndTariff"] : null as any;
        }
    }

    static fromJS(data: any): QueryBOMProductForAllItem {
        data = typeof data === 'object' ? data : {};
        let result = new QueryBOMProductForAllItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputSerialNumber"] = this.inputSerialNumber !== undefined ? this.inputSerialNumber : null as any;
        data["inputMultiplier"] = this.inputMultiplier !== undefined ? this.inputMultiplier : null as any;
        data["inputPrice"] = this.inputPrice !== undefined ? this.inputPrice : null as any;
        data["exchangeRateAndTariff"] = this.exchangeRateAndTariff !== undefined ? this.exchangeRateAndTariff : null as any;
        return data;
    }
}

export class QueryZppMotMpsLifeDto {
    itSos!: ZppMotStrucSoitem[] | null;
    ivWerks!: string | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["itSos"])) {
                this.itSos = [] as any;
                for (let item of _data["itSos"])
                    this.itSos!.push(ZppMotStrucSoitem.fromJS(item));
            }
            else {
                this.itSos = null as any;
            }
            this.ivWerks = _data["ivWerks"] !== undefined ? _data["ivWerks"] : null as any;
        }
    }

    static fromJS(data: any): QueryZppMotMpsLifeDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryZppMotMpsLifeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.itSos)) {
            data["itSos"] = [];
            for (let item of this.itSos)
                data["itSos"].push(item ? item.toJSON() : null as any);
        }
        data["ivWerks"] = this.ivWerks !== undefined ? this.ivWerks : null as any;
        return data;
    }
}

export class ReplenishInventoryRemind {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    orderFormId!: string;
    contractNumber!: string | null;
    dataPlatFormOrderTypeId!: string | null;
    dataPlatFormOrderTypeName!: string | null;
    modelSelectionId!: string | null;
    modelSelectionName!: string | null;
    responsibleSalesName!: string | null;
    responsibleSalesCode!: string | null;
    endCustomerName!: string | null;
    endCustomerCode!: string | null;
    materialNumber!: string | null;
    basicMotorCode!: string | null;
    basicMotorModel!: string | null;
    appraisalNumber!: string | null;
    materialQuantity!: number | null;
    fromUser!: string | null;
    fromUserName!: string | null;
    toUser!: string | null;
    toUserName!: string | null;
    serialNumber!: string | null;
    isSendEmail!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.contractNumber = _data["contractNumber"] !== undefined ? _data["contractNumber"] : null as any;
            this.dataPlatFormOrderTypeId = _data["dataPlatFormOrderTypeId"] !== undefined ? _data["dataPlatFormOrderTypeId"] : null as any;
            this.dataPlatFormOrderTypeName = _data["dataPlatFormOrderTypeName"] !== undefined ? _data["dataPlatFormOrderTypeName"] : null as any;
            this.modelSelectionId = _data["modelSelectionId"] !== undefined ? _data["modelSelectionId"] : null as any;
            this.modelSelectionName = _data["modelSelectionName"] !== undefined ? _data["modelSelectionName"] : null as any;
            this.responsibleSalesName = _data["responsibleSalesName"] !== undefined ? _data["responsibleSalesName"] : null as any;
            this.responsibleSalesCode = _data["responsibleSalesCode"] !== undefined ? _data["responsibleSalesCode"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.endCustomerCode = _data["endCustomerCode"] !== undefined ? _data["endCustomerCode"] : null as any;
            this.materialNumber = _data["materialNumber"] !== undefined ? _data["materialNumber"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.materialQuantity = _data["materialQuantity"] !== undefined ? _data["materialQuantity"] : null as any;
            this.fromUser = _data["fromUser"] !== undefined ? _data["fromUser"] : null as any;
            this.fromUserName = _data["fromUserName"] !== undefined ? _data["fromUserName"] : null as any;
            this.toUser = _data["toUser"] !== undefined ? _data["toUser"] : null as any;
            this.toUserName = _data["toUserName"] !== undefined ? _data["toUserName"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.isSendEmail = _data["isSendEmail"] !== undefined ? _data["isSendEmail"] : null as any;
        }
    }

    static fromJS(data: any): ReplenishInventoryRemind {
        data = typeof data === 'object' ? data : {};
        let result = new ReplenishInventoryRemind();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["contractNumber"] = this.contractNumber !== undefined ? this.contractNumber : null as any;
        data["dataPlatFormOrderTypeId"] = this.dataPlatFormOrderTypeId !== undefined ? this.dataPlatFormOrderTypeId : null as any;
        data["dataPlatFormOrderTypeName"] = this.dataPlatFormOrderTypeName !== undefined ? this.dataPlatFormOrderTypeName : null as any;
        data["modelSelectionId"] = this.modelSelectionId !== undefined ? this.modelSelectionId : null as any;
        data["modelSelectionName"] = this.modelSelectionName !== undefined ? this.modelSelectionName : null as any;
        data["responsibleSalesName"] = this.responsibleSalesName !== undefined ? this.responsibleSalesName : null as any;
        data["responsibleSalesCode"] = this.responsibleSalesCode !== undefined ? this.responsibleSalesCode : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["endCustomerCode"] = this.endCustomerCode !== undefined ? this.endCustomerCode : null as any;
        data["materialNumber"] = this.materialNumber !== undefined ? this.materialNumber : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["materialQuantity"] = this.materialQuantity !== undefined ? this.materialQuantity : null as any;
        data["fromUser"] = this.fromUser !== undefined ? this.fromUser : null as any;
        data["fromUserName"] = this.fromUserName !== undefined ? this.fromUserName : null as any;
        data["toUser"] = this.toUser !== undefined ? this.toUser : null as any;
        data["toUserName"] = this.toUserName !== undefined ? this.toUserName : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["isSendEmail"] = this.isSendEmail !== undefined ? this.isSendEmail : null as any;
        return data;
    }
}

/** 按查询条件导出类 */
export class ReplenishInventoryRemindExportInDto {
    /** 客户名称 */
    endCustomerName!: string | null;
    /** 电机编码 */
    basicMotorCode!: string | null;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** 开始时间 */
    beginTime!: moment.Moment | null;
    /** 结束时间 */
    endTime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.beginTime = _data["beginTime"] ? moment(_data["beginTime"].toString()) : null as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ReplenishInventoryRemindExportInDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReplenishInventoryRemindExportInDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["beginTime"] = this.beginTime ? this.beginTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        return data;
    }
}

/** 补充库存提醒 */
export class ReplenishInventoryRemindInDto {
    /** 订单id */
    orderFormId!: string;
    /** 合同号 */
    contractNumber!: string | null;
    /** 订单类型 */
    dataPlatFormOrderTypeName!: string | null;
    /** 订单类型编码 */
    dataPlatFormOrderTypeId!: string | null;
    /** 选型号 */
    modelSelectionId!: string | null;
    /** 选型名称 */
    modelSelectionName!: string | null;
    /** 责任销售 */
    responsibleSalesName!: string | null;
    /** 责任销售Code */
    responsibleSalesCode!: string | null;
    /** 客户名称 */
    endCustomerName!: string | null;
    /** 客户编码 */
    endCustomerCode!: string | null;
    /** 物料号 */
    materialNumber!: string | null;
    /** 电机编码 */
    basicMotorCode!: string | null;
    /** 电机型号 */
    basicMotorModel!: string | null;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** 数量 */
    materialQuantity!: number | null;
    /** 序号(行号) */
    serialNumber!: string | null;

    init(_data?: any) {
        if (_data) {
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.contractNumber = _data["contractNumber"] !== undefined ? _data["contractNumber"] : null as any;
            this.dataPlatFormOrderTypeName = _data["dataPlatFormOrderTypeName"] !== undefined ? _data["dataPlatFormOrderTypeName"] : null as any;
            this.dataPlatFormOrderTypeId = _data["dataPlatFormOrderTypeId"] !== undefined ? _data["dataPlatFormOrderTypeId"] : null as any;
            this.modelSelectionId = _data["modelSelectionId"] !== undefined ? _data["modelSelectionId"] : null as any;
            this.modelSelectionName = _data["modelSelectionName"] !== undefined ? _data["modelSelectionName"] : null as any;
            this.responsibleSalesName = _data["responsibleSalesName"] !== undefined ? _data["responsibleSalesName"] : null as any;
            this.responsibleSalesCode = _data["responsibleSalesCode"] !== undefined ? _data["responsibleSalesCode"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.endCustomerCode = _data["endCustomerCode"] !== undefined ? _data["endCustomerCode"] : null as any;
            this.materialNumber = _data["materialNumber"] !== undefined ? _data["materialNumber"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.materialQuantity = _data["materialQuantity"] !== undefined ? _data["materialQuantity"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
        }
    }

    static fromJS(data: any): ReplenishInventoryRemindInDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReplenishInventoryRemindInDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["contractNumber"] = this.contractNumber !== undefined ? this.contractNumber : null as any;
        data["dataPlatFormOrderTypeName"] = this.dataPlatFormOrderTypeName !== undefined ? this.dataPlatFormOrderTypeName : null as any;
        data["dataPlatFormOrderTypeId"] = this.dataPlatFormOrderTypeId !== undefined ? this.dataPlatFormOrderTypeId : null as any;
        data["modelSelectionId"] = this.modelSelectionId !== undefined ? this.modelSelectionId : null as any;
        data["modelSelectionName"] = this.modelSelectionName !== undefined ? this.modelSelectionName : null as any;
        data["responsibleSalesName"] = this.responsibleSalesName !== undefined ? this.responsibleSalesName : null as any;
        data["responsibleSalesCode"] = this.responsibleSalesCode !== undefined ? this.responsibleSalesCode : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["endCustomerCode"] = this.endCustomerCode !== undefined ? this.endCustomerCode : null as any;
        data["materialNumber"] = this.materialNumber !== undefined ? this.materialNumber : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["materialQuantity"] = this.materialQuantity !== undefined ? this.materialQuantity : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        return data;
    }
}

/** 补充库存提醒，列表查询输入 */
export class ReplenishInventoryRemindSearchInDto {
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | null;
    /** 客户名称 */
    endCustomerName!: string | null;
    /** 电机编码 */
    basicMotorCode!: string | null;
    /** 评审号 */
    appraisalNumber!: string | null;
    /** 开始日期 */
    beginTime!: moment.Moment | null;
    /** 结束日期 */
    endTime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.filter = _data["filter"] !== undefined ? _data["filter"] : null as any;
            this.endCustomerName = _data["endCustomerName"] !== undefined ? _data["endCustomerName"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.beginTime = _data["beginTime"] ? moment(_data["beginTime"].toString()) : null as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ReplenishInventoryRemindSearchInDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReplenishInventoryRemindSearchInDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["filter"] = this.filter !== undefined ? this.filter : null as any;
        data["endCustomerName"] = this.endCustomerName !== undefined ? this.endCustomerName : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["beginTime"] = this.beginTime ? this.beginTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        return data;
    }
}

export class Required {
    /** 对应请求参数中的freetext key */
    key!: string | null;
    /** 理论上只会有string，尚不确定 */
    type!: string | null;
    /** 需要用如下正则表达式来检查用户的输入 */
    mask!: string | null;
    /** 给用户显示输入框时显示给用户的key */
    desc!: string | null;
    /** 提供给用户的输入框的占位符 */
    help!: string | null;

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.mask = _data["mask"] !== undefined ? _data["mask"] : null as any;
            this.desc = _data["desc"] !== undefined ? _data["desc"] : null as any;
            this.help = _data["help"] !== undefined ? _data["help"] : null as any;
        }
    }

    static fromJS(data: any): Required {
        data = typeof data === 'object' ? data : {};
        let result = new Required();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["mask"] = this.mask !== undefined ? this.mask : null as any;
        data["desc"] = this.desc !== undefined ? this.desc : null as any;
        data["help"] = this.help !== undefined ? this.help : null as any;
        return data;
    }
}

export class ResetSearchDto {
    /** 角色Id */
    roleId!: number | null;
    /** 角色名称 */
    roleName!: string | null;
    /** 用户Id */
    userId!: number | null;
    /** 是否启用 */
    isEnable!: boolean | null;
    skipCount!: number;
    maxResultCount!: number;

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : null as any;
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.isEnable = _data["isEnable"] !== undefined ? _data["isEnable"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
        }
    }

    static fromJS(data: any): ResetSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId !== undefined ? this.roleId : null as any;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["isEnable"] = this.isEnable !== undefined ? this.isEnable : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        return data;
    }
}

/** 一键清理 */
export class ResetToZeroInDto {
    id!: string | null;
    /** 角色id */
    roleId!: number | null;
    /** 角色名称 */
    roleName!: string | null;
    /** 用户Id */
    userId!: number | null;
    /** 是否启用一键清零 */
    isEnable!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : null as any;
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.isEnable = _data["isEnable"] !== undefined ? _data["isEnable"] : null as any;
        }
    }

    static fromJS(data: any): ResetToZeroInDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetToZeroInDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["roleId"] = this.roleId !== undefined ? this.roleId : null as any;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["isEnable"] = this.isEnable !== undefined ? this.isEnable : null as any;
        return data;
    }
}

/** 一键清理 */
export class ResetToZeroListOutDto {
    /** 主键 */
    id!: string | null;
    /** 角色id */
    roleId!: number;
    /** 角色名称 */
    roleName!: string | null;
    /** 用户Id */
    userId!: number;
    /** 是否启用一键清零 */
    isEnable!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : null as any;
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.isEnable = _data["isEnable"] !== undefined ? _data["isEnable"] : null as any;
        }
    }

    static fromJS(data: any): ResetToZeroListOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetToZeroListOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["roleId"] = this.roleId !== undefined ? this.roleId : null as any;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["isEnable"] = this.isEnable !== undefined ? this.isEnable : null as any;
        return data;
    }
}

export class ResetToZeroListOutDtoPagedResultDto {
    items!: ResetToZeroListOutDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ResetToZeroListOutDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): ResetToZeroListOutDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetToZeroListOutDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 一键清零日志 */
export class ResetToZeroLogOutDto {
    /** 主键 */
    id!: string | null;
    /** 操作 */
    operation!: string | null;
    /** 操作人Id */
    operatorUserId!: number | null;
    /** 操作人 */
    operatorUserName!: string | null;
    /** 操作时间 */
    operationTime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.operation = _data["operation"] !== undefined ? _data["operation"] : null as any;
            this.operatorUserId = _data["operatorUserId"] !== undefined ? _data["operatorUserId"] : null as any;
            this.operatorUserName = _data["operatorUserName"] !== undefined ? _data["operatorUserName"] : null as any;
            this.operationTime = _data["operationTime"] ? moment(_data["operationTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ResetToZeroLogOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetToZeroLogOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["operation"] = this.operation !== undefined ? this.operation : null as any;
        data["operatorUserId"] = this.operatorUserId !== undefined ? this.operatorUserId : null as any;
        data["operatorUserName"] = this.operatorUserName !== undefined ? this.operatorUserName : null as any;
        data["operationTime"] = this.operationTime ? this.operationTime.toISOString() : null as any;
        return data;
    }
}

/** 一键清理 */
export class ResetToZeroOutDto {
    /** 主键 */
    id!: string | null;
    /** 角色id */
    roleId!: number;
    /** 角色名称 */
    roleName!: string | null;
    /** 用户Id */
    userId!: number;
    /** 是否启用一键清零 */
    isEnable!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : null as any;
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.isEnable = _data["isEnable"] !== undefined ? _data["isEnable"] : null as any;
        }
    }

    static fromJS(data: any): ResetToZeroOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetToZeroOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["roleId"] = this.roleId !== undefined ? this.roleId : null as any;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["isEnable"] = this.isEnable !== undefined ? this.isEnable : null as any;
        return data;
    }
}

export class Resolvable {
    /** 因为111的要求 */
    resolution!: string | null;
    /** 所以要把424替换成426 */
    solution!: Solution[] | null;

    init(_data?: any) {
        if (_data) {
            this.resolution = _data["resolution"] !== undefined ? _data["resolution"] : null as any;
            if (Array.isArray(_data["solution"])) {
                this.solution = [] as any;
                for (let item of _data["solution"])
                    this.solution!.push(Solution.fromJS(item));
            }
            else {
                this.solution = null as any;
            }
        }
    }

    static fromJS(data: any): Resolvable {
        data = typeof data === 'object' ? data : {};
        let result = new Resolvable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resolution"] = this.resolution !== undefined ? this.resolution : null as any;
        if (Array.isArray(this.solution)) {
            data["solution"] = [];
            for (let item of this.solution)
                data["solution"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class ReturnOrderStateTimeDataDto {
    /** 订单ID */
    orderFormId!: string;
    /** 合同号 */
    poNumber!: string | null;

    init(_data?: any) {
        if (_data) {
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
        }
    }

    static fromJS(data: any): ReturnOrderStateTimeDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnOrderStateTimeDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        return data;
    }
}

export class RevokeOrderChangeDto {
    orderFormId!: string;
    orderChangeOrderFormId!: string;
    /** 撤销原因 */
    revokeRemark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.orderChangeOrderFormId = _data["orderChangeOrderFormId"] !== undefined ? _data["orderChangeOrderFormId"] : null as any;
            this.revokeRemark = _data["revokeRemark"] !== undefined ? _data["revokeRemark"] : null as any;
        }
    }

    static fromJS(data: any): RevokeOrderChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RevokeOrderChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["orderChangeOrderFormId"] = this.orderChangeOrderFormId !== undefined ? this.orderChangeOrderFormId : null as any;
        data["revokeRemark"] = this.revokeRemark !== undefined ? this.revokeRemark : null as any;
        return data;
    }
}

/** 撤销入参 */
export class RevokeVCConfirmationDto {
    /** vcID */
    id!: string;
    /** 订单Id */
    orderId!: string;
    /** 行vc编号 */
    vcId!: string;
    /** 行号 */
    cScotOrderItemId!: string | null;
    /** 是否创建订单 */
    isCreate!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : null as any;
            this.vcId = _data["vcId"] !== undefined ? _data["vcId"] : null as any;
            this.cScotOrderItemId = _data["cScotOrderItemId"] !== undefined ? _data["cScotOrderItemId"] : null as any;
            this.isCreate = _data["isCreate"] !== undefined ? _data["isCreate"] : null as any;
        }
    }

    static fromJS(data: any): RevokeVCConfirmationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RevokeVCConfirmationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["orderId"] = this.orderId !== undefined ? this.orderId : null as any;
        data["vcId"] = this.vcId !== undefined ? this.vcId : null as any;
        data["cScotOrderItemId"] = this.cScotOrderItemId !== undefined ? this.cScotOrderItemId : null as any;
        data["isCreate"] = this.isCreate !== undefined ? this.isCreate : null as any;
        return data;
    }
}

export class SaleAreaUserDto {
    /** Id */
    id!: number | null;
    /** 销售区域编码 */
    salesAreaCode!: string;
    /** 销售区域名称 */
    salesAreaName!: string | null;
    /** 关联用户Id（销售） */
    userId!: number;
    /** 关联用户名称（销售） */
    userName!: string | null;
    /** 关联用户邮箱（销售） */
    userEmail!: string | null;
    /** 是否启用 */
    enable!: boolean;
    /** 最后更新时间 */
    lastModifyTime!: moment.Moment;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.salesAreaCode = _data["salesAreaCode"] !== undefined ? _data["salesAreaCode"] : null as any;
            this.salesAreaName = _data["salesAreaName"] !== undefined ? _data["salesAreaName"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.userEmail = _data["userEmail"] !== undefined ? _data["userEmail"] : null as any;
            this.enable = _data["enable"] !== undefined ? _data["enable"] : null as any;
            this.lastModifyTime = _data["lastModifyTime"] ? moment(_data["lastModifyTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): SaleAreaUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaleAreaUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["salesAreaCode"] = this.salesAreaCode !== undefined ? this.salesAreaCode : null as any;
        data["salesAreaName"] = this.salesAreaName !== undefined ? this.salesAreaName : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["userEmail"] = this.userEmail !== undefined ? this.userEmail : null as any;
        data["enable"] = this.enable !== undefined ? this.enable : null as any;
        data["lastModifyTime"] = this.lastModifyTime ? this.lastModifyTime.toISOString() : null as any;
        return data;
    }
}

export class SaleAreaUserDtoPagedResultDto {
    items!: SaleAreaUserDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SaleAreaUserDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): SaleAreaUserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaleAreaUserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 2100 = CNMOT (CNMOT) 2903 = EMS_SU (CNEMS-SU) */
export enum SaleOrgStatus {
    CNMOT = 2100,
    EMS_SU = 2903,
}

export class SalesArea {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    salesAreaCode!: string | null;
    salesAreaName!: string | null;
    enable!: boolean;
    orderForms!: OrderForm[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.salesAreaCode = _data["salesAreaCode"] !== undefined ? _data["salesAreaCode"] : null as any;
            this.salesAreaName = _data["salesAreaName"] !== undefined ? _data["salesAreaName"] : null as any;
            this.enable = _data["enable"] !== undefined ? _data["enable"] : true;
            if (Array.isArray(_data["orderForms"])) {
                this.orderForms = [] as any;
                for (let item of _data["orderForms"])
                    this.orderForms!.push(OrderForm.fromJS(item));
            }
            else {
                this.orderForms = null as any;
            }
        }
    }

    static fromJS(data: any): SalesArea {
        data = typeof data === 'object' ? data : {};
        let result = new SalesArea();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["salesAreaCode"] = this.salesAreaCode !== undefined ? this.salesAreaCode : null as any;
        data["salesAreaName"] = this.salesAreaName !== undefined ? this.salesAreaName : null as any;
        data["enable"] = this.enable !== undefined ? this.enable : null as any;
        if (Array.isArray(this.orderForms)) {
            data["orderForms"] = [];
            for (let item of this.orderForms)
                data["orderForms"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 订单信息上传接口参数 */
export class SapBacklogInputDto {
    /** 客户编号 */
    kunnr!: string | null;
    /** 客户名称 */
    kunnR_NAME1!: string | null;
    /** 订单创建日期 */
    erdat!: string | null;
    /** 订单类型 */
    auart!: string | null;
    /** 销售区域 */
    vkorg!: string | null;
    /** 订单号 */
    vbeln!: string | null;
    /** 订单行项目 */
    posnr!: string | null;
    /** 订单行项目类别 */
    pstyv!: string | null;
    /** 项目类别描述 */
    pstyV_VTEXT!: string | null;
    /** 物料编码 */
    matnr!: string | null;
    /** 物料描述 */
    arktx!: string | null;
    /** 订单数量 */
    kwmeng!: number;
    /** 销售雇员名字 */
    namev!: string | null;
    /** 库存数量 */
    commitqty!: number;
    /** 最后一次收货日期 */
    grdat!: string | null;
    /** 已发数量 */
    qtY_DELIVERIED!: number;
    /** 合同号 */
    bstkD_EH!: string | null;
    /** 金额（含税） */
    netpr!: number;
    /** 客户需求日期 */
    zreqdd!: string | null;
    /** Precal号码 */
    vbbK_Z007!: string | null;
    /** 客户采购订单号 */
    bstnk!: string | null;
    /** 客户物料代码 */
    kdmat!: string | null;
    /** 物料组 */
    matkl!: string | null;
    /** 计划入库日 */
    bstdK_E!: string | null;
    /** 金额（含税）新 */
    pricE_WITH_TAX!: number;
    saleOrg!: SaleOrgStatus;
    /** 可发货库存数 */
    stocK_A!: number;
    /** 下发类型
M = 手工执行  S = 后台JOB执行 */
    sendingflag!: string | null;

    init(_data?: any) {
        if (_data) {
            this.kunnr = _data["kunnr"] !== undefined ? _data["kunnr"] : null as any;
            this.kunnR_NAME1 = _data["kunnR_NAME1"] !== undefined ? _data["kunnR_NAME1"] : null as any;
            this.erdat = _data["erdat"] !== undefined ? _data["erdat"] : null as any;
            this.auart = _data["auart"] !== undefined ? _data["auart"] : null as any;
            this.vkorg = _data["vkorg"] !== undefined ? _data["vkorg"] : null as any;
            this.vbeln = _data["vbeln"] !== undefined ? _data["vbeln"] : null as any;
            this.posnr = _data["posnr"] !== undefined ? _data["posnr"] : null as any;
            this.pstyv = _data["pstyv"] !== undefined ? _data["pstyv"] : null as any;
            this.pstyV_VTEXT = _data["pstyV_VTEXT"] !== undefined ? _data["pstyV_VTEXT"] : null as any;
            this.matnr = _data["matnr"] !== undefined ? _data["matnr"] : null as any;
            this.arktx = _data["arktx"] !== undefined ? _data["arktx"] : null as any;
            this.kwmeng = _data["kwmeng"] !== undefined ? _data["kwmeng"] : null as any;
            this.namev = _data["namev"] !== undefined ? _data["namev"] : null as any;
            this.commitqty = _data["commitqty"] !== undefined ? _data["commitqty"] : null as any;
            this.grdat = _data["grdat"] !== undefined ? _data["grdat"] : null as any;
            this.qtY_DELIVERIED = _data["qtY_DELIVERIED"] !== undefined ? _data["qtY_DELIVERIED"] : null as any;
            this.bstkD_EH = _data["bstkD_EH"] !== undefined ? _data["bstkD_EH"] : null as any;
            this.netpr = _data["netpr"] !== undefined ? _data["netpr"] : null as any;
            this.zreqdd = _data["zreqdd"] !== undefined ? _data["zreqdd"] : null as any;
            this.vbbK_Z007 = _data["vbbK_Z007"] !== undefined ? _data["vbbK_Z007"] : null as any;
            this.bstnk = _data["bstnk"] !== undefined ? _data["bstnk"] : null as any;
            this.kdmat = _data["kdmat"] !== undefined ? _data["kdmat"] : null as any;
            this.matkl = _data["matkl"] !== undefined ? _data["matkl"] : null as any;
            this.bstdK_E = _data["bstdK_E"] !== undefined ? _data["bstdK_E"] : null as any;
            this.pricE_WITH_TAX = _data["pricE_WITH_TAX"] !== undefined ? _data["pricE_WITH_TAX"] : null as any;
            this.saleOrg = _data["saleOrg"] !== undefined ? _data["saleOrg"] : null as any;
            this.stocK_A = _data["stocK_A"] !== undefined ? _data["stocK_A"] : null as any;
            this.sendingflag = _data["sendingflag"] !== undefined ? _data["sendingflag"] : null as any;
        }
    }

    static fromJS(data: any): SapBacklogInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapBacklogInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunnr"] = this.kunnr !== undefined ? this.kunnr : null as any;
        data["kunnR_NAME1"] = this.kunnR_NAME1 !== undefined ? this.kunnR_NAME1 : null as any;
        data["erdat"] = this.erdat !== undefined ? this.erdat : null as any;
        data["auart"] = this.auart !== undefined ? this.auart : null as any;
        data["vkorg"] = this.vkorg !== undefined ? this.vkorg : null as any;
        data["vbeln"] = this.vbeln !== undefined ? this.vbeln : null as any;
        data["posnr"] = this.posnr !== undefined ? this.posnr : null as any;
        data["pstyv"] = this.pstyv !== undefined ? this.pstyv : null as any;
        data["pstyV_VTEXT"] = this.pstyV_VTEXT !== undefined ? this.pstyV_VTEXT : null as any;
        data["matnr"] = this.matnr !== undefined ? this.matnr : null as any;
        data["arktx"] = this.arktx !== undefined ? this.arktx : null as any;
        data["kwmeng"] = this.kwmeng !== undefined ? this.kwmeng : null as any;
        data["namev"] = this.namev !== undefined ? this.namev : null as any;
        data["commitqty"] = this.commitqty !== undefined ? this.commitqty : null as any;
        data["grdat"] = this.grdat !== undefined ? this.grdat : null as any;
        data["qtY_DELIVERIED"] = this.qtY_DELIVERIED !== undefined ? this.qtY_DELIVERIED : null as any;
        data["bstkD_EH"] = this.bstkD_EH !== undefined ? this.bstkD_EH : null as any;
        data["netpr"] = this.netpr !== undefined ? this.netpr : null as any;
        data["zreqdd"] = this.zreqdd !== undefined ? this.zreqdd : null as any;
        data["vbbK_Z007"] = this.vbbK_Z007 !== undefined ? this.vbbK_Z007 : null as any;
        data["bstnk"] = this.bstnk !== undefined ? this.bstnk : null as any;
        data["kdmat"] = this.kdmat !== undefined ? this.kdmat : null as any;
        data["matkl"] = this.matkl !== undefined ? this.matkl : null as any;
        data["bstdK_E"] = this.bstdK_E !== undefined ? this.bstdK_E : null as any;
        data["pricE_WITH_TAX"] = this.pricE_WITH_TAX !== undefined ? this.pricE_WITH_TAX : null as any;
        data["saleOrg"] = this.saleOrg !== undefined ? this.saleOrg : null as any;
        data["stocK_A"] = this.stocK_A !== undefined ? this.stocK_A : null as any;
        data["sendingflag"] = this.sendingflag !== undefined ? this.sendingflag : null as any;
        return data;
    }
}

/** SAP回调DNS输入参数 */
export class SapCreateDnsItemInputDto {
    /** LSU订单号 */
    vbeln!: string | null;
    /** LSU项目号 */
    posnr!: string | null;
    /** PMU订单号 */
    vbelN_CSO!: string | null;
    /** PMU项目号 */
    posnR_CSO!: string | null;
    /** Route */
    route!: string | null;
    /** 发货数量 */
    lfimg!: number;
    /** 计划拣配数量 */
    pikmg!: number;
    /** Ship to Part名称 */
    namE_A!: string | null;
    /** 发货地址 */
    street!: string | null;
    /** 城市 */
    city!: string | null;
    /** 联系人 */
    remark!: string | null;
    /** 电话 */
    teL_NUMBER!: string | null;
    /** Iso DN */
    vbelN_DN!: string | null;
    /** Cso DN */
    vbelN_DN_CSO!: string | null;
    /** 消息 */
    text!: string | null;
    /** DNS编号 */
    dnS_NUMBER!: string | null;
    /** 运输方式 加急9002/不加急9001 */
    traty!: string | null;

    init(_data?: any) {
        if (_data) {
            this.vbeln = _data["vbeln"] !== undefined ? _data["vbeln"] : null as any;
            this.posnr = _data["posnr"] !== undefined ? _data["posnr"] : null as any;
            this.vbelN_CSO = _data["vbelN_CSO"] !== undefined ? _data["vbelN_CSO"] : null as any;
            this.posnR_CSO = _data["posnR_CSO"] !== undefined ? _data["posnR_CSO"] : null as any;
            this.route = _data["route"] !== undefined ? _data["route"] : null as any;
            this.lfimg = _data["lfimg"] !== undefined ? _data["lfimg"] : null as any;
            this.pikmg = _data["pikmg"] !== undefined ? _data["pikmg"] : null as any;
            this.namE_A = _data["namE_A"] !== undefined ? _data["namE_A"] : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.teL_NUMBER = _data["teL_NUMBER"] !== undefined ? _data["teL_NUMBER"] : null as any;
            this.vbelN_DN = _data["vbelN_DN"] !== undefined ? _data["vbelN_DN"] : null as any;
            this.vbelN_DN_CSO = _data["vbelN_DN_CSO"] !== undefined ? _data["vbelN_DN_CSO"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.dnS_NUMBER = _data["dnS_NUMBER"] !== undefined ? _data["dnS_NUMBER"] : null as any;
            this.traty = _data["traty"] !== undefined ? _data["traty"] : null as any;
        }
    }

    static fromJS(data: any): SapCreateDnsItemInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapCreateDnsItemInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vbeln"] = this.vbeln !== undefined ? this.vbeln : null as any;
        data["posnr"] = this.posnr !== undefined ? this.posnr : null as any;
        data["vbelN_CSO"] = this.vbelN_CSO !== undefined ? this.vbelN_CSO : null as any;
        data["posnR_CSO"] = this.posnR_CSO !== undefined ? this.posnR_CSO : null as any;
        data["route"] = this.route !== undefined ? this.route : null as any;
        data["lfimg"] = this.lfimg !== undefined ? this.lfimg : null as any;
        data["pikmg"] = this.pikmg !== undefined ? this.pikmg : null as any;
        data["namE_A"] = this.namE_A !== undefined ? this.namE_A : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["teL_NUMBER"] = this.teL_NUMBER !== undefined ? this.teL_NUMBER : null as any;
        data["vbelN_DN"] = this.vbelN_DN !== undefined ? this.vbelN_DN : null as any;
        data["vbelN_DN_CSO"] = this.vbelN_DN_CSO !== undefined ? this.vbelN_DN_CSO : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["dnS_NUMBER"] = this.dnS_NUMBER !== undefined ? this.dnS_NUMBER : null as any;
        data["traty"] = this.traty !== undefined ? this.traty : null as any;
        return data;
    }
}

/** Sap库存请求参数 */
export class SapMtsStkInputDto {
    /** 物料编码 */
    materialNumberList!: string[] | null;
    /** 工厂编号 */
    werks!: string | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["materialNumberList"])) {
                this.materialNumberList = [] as any;
                for (let item of _data["materialNumberList"])
                    this.materialNumberList!.push(item);
            }
            else {
                this.materialNumberList = null as any;
            }
            this.werks = _data["werks"] !== undefined ? _data["werks"] : null as any;
        }
    }

    static fromJS(data: any): SapMtsStkInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapMtsStkInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.materialNumberList)) {
            data["materialNumberList"] = [];
            for (let item of this.materialNumberList)
                data["materialNumberList"].push(item);
        }
        data["werks"] = this.werks !== undefined ? this.werks : null as any;
        return data;
    }
}

/** Sap库存参数 */
export class SapMtsStkOutputDto {
    /** 工厂编号 */
    plant!: string | null;
    /** 物料编号 */
    materialNumber!: string | null;
    /** 预占库存 */
    bookedStock!: number;
    /** 可用库存 */
    availableStock!: number;

    init(_data?: any) {
        if (_data) {
            this.plant = _data["plant"] !== undefined ? _data["plant"] : null as any;
            this.materialNumber = _data["materialNumber"] !== undefined ? _data["materialNumber"] : null as any;
            this.bookedStock = _data["bookedStock"] !== undefined ? _data["bookedStock"] : null as any;
            this.availableStock = _data["availableStock"] !== undefined ? _data["availableStock"] : null as any;
        }
    }

    static fromJS(data: any): SapMtsStkOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapMtsStkOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plant"] = this.plant !== undefined ? this.plant : null as any;
        data["materialNumber"] = this.materialNumber !== undefined ? this.materialNumber : null as any;
        data["bookedStock"] = this.bookedStock !== undefined ? this.bookedStock : null as any;
        data["availableStock"] = this.availableStock !== undefined ? this.availableStock : null as any;
        return data;
    }
}

/** Sap输出参数 */
export class SapMtsStkOutputDtoListSapOutputDto {
    /** 查询状态 */
    isSuccess!: boolean;
    /** 返回信息（查询成功返回空） */
    message!: string | null;
    /** Sap库存列表 */
    dataList!: SapMtsStkOutputDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            if (Array.isArray(_data["dataList"])) {
                this.dataList = [] as any;
                for (let item of _data["dataList"])
                    this.dataList!.push(SapMtsStkOutputDto.fromJS(item));
            }
            else {
                this.dataList = null as any;
            }
        }
    }

    static fromJS(data: any): SapMtsStkOutputDtoListSapOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapMtsStkOutputDtoListSapOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        if (Array.isArray(this.dataList)) {
            data["dataList"] = [];
            for (let item of this.dataList)
                data["dataList"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** Sap库存预占参数 */
export class SapOisOrdInputDto {
    /** OIS订单编号 */
    oisOrderNo!: string | null;
    /** OIS订单行号 */
    oisOrderItem!: string | null;
    /** 物料编号 */
    materialNumber!: string | null;
    /** 数量 */
    itemQuantity!: number;
    /** 交货日期 */
    deliveryDate!: moment.Moment;
    /** 删除标志 */
    deletionFlag!: boolean;

    init(_data?: any) {
        if (_data) {
            this.oisOrderNo = _data["oisOrderNo"] !== undefined ? _data["oisOrderNo"] : null as any;
            this.oisOrderItem = _data["oisOrderItem"] !== undefined ? _data["oisOrderItem"] : null as any;
            this.materialNumber = _data["materialNumber"] !== undefined ? _data["materialNumber"] : null as any;
            this.itemQuantity = _data["itemQuantity"] !== undefined ? _data["itemQuantity"] : null as any;
            this.deliveryDate = _data["deliveryDate"] ? moment(_data["deliveryDate"].toString()) : null as any;
            this.deletionFlag = _data["deletionFlag"] !== undefined ? _data["deletionFlag"] : null as any;
        }
    }

    static fromJS(data: any): SapOisOrdInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapOisOrdInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oisOrderNo"] = this.oisOrderNo !== undefined ? this.oisOrderNo : null as any;
        data["oisOrderItem"] = this.oisOrderItem !== undefined ? this.oisOrderItem : null as any;
        data["materialNumber"] = this.materialNumber !== undefined ? this.materialNumber : null as any;
        data["itemQuantity"] = this.itemQuantity !== undefined ? this.itemQuantity : null as any;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : null as any;
        data["deletionFlag"] = this.deletionFlag !== undefined ? this.deletionFlag : null as any;
        return data;
    }
}

/** Sap库存预占输出参数 */
export class SapOisOrdOutputDto {
    /** 查询状态 */
    isSuccess!: boolean;
    /** 返回信息 */
    message!: string | null;
    /** OIS订单编号 */
    oisOrderNo!: string | null;
    /** OIS订单行号 */
    oisOrderItem!: string | null;

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.oisOrderNo = _data["oisOrderNo"] !== undefined ? _data["oisOrderNo"] : null as any;
            this.oisOrderItem = _data["oisOrderItem"] !== undefined ? _data["oisOrderItem"] : null as any;
        }
    }

    static fromJS(data: any): SapOisOrdOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapOisOrdOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["oisOrderNo"] = this.oisOrderNo !== undefined ? this.oisOrderNo : null as any;
        data["oisOrderItem"] = this.oisOrderItem !== undefined ? this.oisOrderItem : null as any;
        return data;
    }
}

/** Sap输出参数 */
export class SapOisOrdOutputDtoListSapOutputDto {
    /** 查询状态 */
    isSuccess!: boolean;
    /** 返回信息（查询成功返回空） */
    message!: string | null;
    /** Sap库存列表 */
    dataList!: SapOisOrdOutputDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            if (Array.isArray(_data["dataList"])) {
                this.dataList = [] as any;
                for (let item of _data["dataList"])
                    this.dataList!.push(SapOisOrdOutputDto.fromJS(item));
            }
            else {
                this.dataList = null as any;
            }
        }
    }

    static fromJS(data: any): SapOisOrdOutputDtoListSapOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapOisOrdOutputDtoListSapOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        if (Array.isArray(this.dataList)) {
            data["dataList"] = [];
            for (let item of this.dataList)
                data["dataList"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 订单信息上传接口返回参数 */
export class SapOutputDto {
    /** 消息 */
    code!: number;
    /** 成功失败标识 */
    message!: string | null;

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): SapOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }
}

/** 订单信息上传接口参数 */
export class SapTrackingInputDto {
    /** 客户编号 */
    kunnr!: string | null;
    /** 客户名称 */
    namE1!: string | null;
    /** 订单创建日期 */
    erdat!: string | null;
    /** LSU订单类型 */
    auart!: string | null;
    /** LSU销售区域 */
    vkorg!: string | null;
    /** LSU订单号 */
    vbeln!: string | null;
    /** LSU订单行 */
    posnr!: string | null;
    /** PMS订单类型 */
    auarT_PMU!: string | null;
    /** PMU销售区域 */
    vkorG_PMU!: string | null;
    /** 内部订单号 */
    pmuso!: string | null;
    /** 内部订单行 */
    pmusi!: string | null;
    /** 内部订单项目行 */
    pmusoctg!: string | null;
    /** 项目类别描述 */
    pmuvtext!: string | null;
    /** 物料编码 */
    matnr!: string | null;
    /** 物料描述 */
    arktX_EN!: string | null;
    /** 物料描述 */
    arktX_ZH!: string | null;
    /** LSU订单数量 */
    kwmeng!: number;
    /** 销售雇员名字 */
    namZ1!: string | null;
    /** 库存数量 */
    pmustock!: number;
    /** 最后一次收货日期 */
    gidaT_PMU!: string | null;
    /** 已发数量 */
    pmuqty!: number;
    /** 实际交付数量（以销售单位为单位） */
    pmudq!: number;
    /** 合同号 */
    bstkD_E!: string | null;
    /** 金额（含税） */
    netpR_LSU!: number;
    /** 客户需求日期 */
    reqdd!: string | null;
    /** 开票金额 */
    blamT_LSU!: number;
    /** 客户采购订单号 */
    cuspo!: string | null;
    /** 物料组 */
    matkl!: string | null;
    /** 计划入库日 */
    bstdK_E!: string | null;
    /** 金额（含税）新 */
    pricE_LSU!: number;
    saleOrg!: SaleOrgStatus;
    /** 产品组 */
    pg!: string | null;
    /** 区域 */
    bezeI_VKBUR!: string | null;
    /** 备注 */
    remark!: string | null;
    /** 客户物料代码 */
    kdmat!: string | null;
    /** 币种 */
    waerk!: string | null;
    /** LSU订单行金额（含税） */
    kzwI1!: number;
    /** LSU订单行金额（不含税） */
    netwR_LSU!: number;
    /** LSU已出库数量（总数） */
    tlfimg!: number;
    /** 二级客户名称 */
    namE1_ZX!: string | null;
    /** 项目名称 */
    bname!: string | null;
    /** 可发货库存数 */
    stocK_A!: number;
    /** 订单取消代码 */
    abgru!: string | null;
    /** 订单取消备注 */
    lsubezei!: string | null;
    /** 订单取消代码 */
    pmuabgru!: string | null;
    /** 订单取消备注 */
    pmubezei!: string | null;
    /** 开票数量 */
    brfmng!: number;
    /** 开票日期 */
    berdat!: string | null;
    /** 下发类型
M = 手工执行  S = 后台JOB执行 */
    sendingflag!: string | null;

    init(_data?: any) {
        if (_data) {
            this.kunnr = _data["kunnr"] !== undefined ? _data["kunnr"] : null as any;
            this.namE1 = _data["namE1"] !== undefined ? _data["namE1"] : null as any;
            this.erdat = _data["erdat"] !== undefined ? _data["erdat"] : null as any;
            this.auart = _data["auart"] !== undefined ? _data["auart"] : null as any;
            this.vkorg = _data["vkorg"] !== undefined ? _data["vkorg"] : null as any;
            this.vbeln = _data["vbeln"] !== undefined ? _data["vbeln"] : null as any;
            this.posnr = _data["posnr"] !== undefined ? _data["posnr"] : null as any;
            this.auarT_PMU = _data["auarT_PMU"] !== undefined ? _data["auarT_PMU"] : null as any;
            this.vkorG_PMU = _data["vkorG_PMU"] !== undefined ? _data["vkorG_PMU"] : null as any;
            this.pmuso = _data["pmuso"] !== undefined ? _data["pmuso"] : null as any;
            this.pmusi = _data["pmusi"] !== undefined ? _data["pmusi"] : null as any;
            this.pmusoctg = _data["pmusoctg"] !== undefined ? _data["pmusoctg"] : null as any;
            this.pmuvtext = _data["pmuvtext"] !== undefined ? _data["pmuvtext"] : null as any;
            this.matnr = _data["matnr"] !== undefined ? _data["matnr"] : null as any;
            this.arktX_EN = _data["arktX_EN"] !== undefined ? _data["arktX_EN"] : null as any;
            this.arktX_ZH = _data["arktX_ZH"] !== undefined ? _data["arktX_ZH"] : null as any;
            this.kwmeng = _data["kwmeng"] !== undefined ? _data["kwmeng"] : null as any;
            this.namZ1 = _data["namZ1"] !== undefined ? _data["namZ1"] : null as any;
            this.pmustock = _data["pmustock"] !== undefined ? _data["pmustock"] : null as any;
            this.gidaT_PMU = _data["gidaT_PMU"] !== undefined ? _data["gidaT_PMU"] : null as any;
            this.pmuqty = _data["pmuqty"] !== undefined ? _data["pmuqty"] : null as any;
            this.pmudq = _data["pmudq"] !== undefined ? _data["pmudq"] : null as any;
            this.bstkD_E = _data["bstkD_E"] !== undefined ? _data["bstkD_E"] : null as any;
            this.netpR_LSU = _data["netpR_LSU"] !== undefined ? _data["netpR_LSU"] : null as any;
            this.reqdd = _data["reqdd"] !== undefined ? _data["reqdd"] : null as any;
            this.blamT_LSU = _data["blamT_LSU"] !== undefined ? _data["blamT_LSU"] : null as any;
            this.cuspo = _data["cuspo"] !== undefined ? _data["cuspo"] : null as any;
            this.matkl = _data["matkl"] !== undefined ? _data["matkl"] : null as any;
            this.bstdK_E = _data["bstdK_E"] !== undefined ? _data["bstdK_E"] : null as any;
            this.pricE_LSU = _data["pricE_LSU"] !== undefined ? _data["pricE_LSU"] : null as any;
            this.saleOrg = _data["saleOrg"] !== undefined ? _data["saleOrg"] : null as any;
            this.pg = _data["pg"] !== undefined ? _data["pg"] : null as any;
            this.bezeI_VKBUR = _data["bezeI_VKBUR"] !== undefined ? _data["bezeI_VKBUR"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.kdmat = _data["kdmat"] !== undefined ? _data["kdmat"] : null as any;
            this.waerk = _data["waerk"] !== undefined ? _data["waerk"] : null as any;
            this.kzwI1 = _data["kzwI1"] !== undefined ? _data["kzwI1"] : null as any;
            this.netwR_LSU = _data["netwR_LSU"] !== undefined ? _data["netwR_LSU"] : null as any;
            this.tlfimg = _data["tlfimg"] !== undefined ? _data["tlfimg"] : null as any;
            this.namE1_ZX = _data["namE1_ZX"] !== undefined ? _data["namE1_ZX"] : null as any;
            this.bname = _data["bname"] !== undefined ? _data["bname"] : null as any;
            this.stocK_A = _data["stocK_A"] !== undefined ? _data["stocK_A"] : null as any;
            this.abgru = _data["abgru"] !== undefined ? _data["abgru"] : null as any;
            this.lsubezei = _data["lsubezei"] !== undefined ? _data["lsubezei"] : null as any;
            this.pmuabgru = _data["pmuabgru"] !== undefined ? _data["pmuabgru"] : null as any;
            this.pmubezei = _data["pmubezei"] !== undefined ? _data["pmubezei"] : null as any;
            this.brfmng = _data["brfmng"] !== undefined ? _data["brfmng"] : null as any;
            this.berdat = _data["berdat"] !== undefined ? _data["berdat"] : null as any;
            this.sendingflag = _data["sendingflag"] !== undefined ? _data["sendingflag"] : null as any;
        }
    }

    static fromJS(data: any): SapTrackingInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapTrackingInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunnr"] = this.kunnr !== undefined ? this.kunnr : null as any;
        data["namE1"] = this.namE1 !== undefined ? this.namE1 : null as any;
        data["erdat"] = this.erdat !== undefined ? this.erdat : null as any;
        data["auart"] = this.auart !== undefined ? this.auart : null as any;
        data["vkorg"] = this.vkorg !== undefined ? this.vkorg : null as any;
        data["vbeln"] = this.vbeln !== undefined ? this.vbeln : null as any;
        data["posnr"] = this.posnr !== undefined ? this.posnr : null as any;
        data["auarT_PMU"] = this.auarT_PMU !== undefined ? this.auarT_PMU : null as any;
        data["vkorG_PMU"] = this.vkorG_PMU !== undefined ? this.vkorG_PMU : null as any;
        data["pmuso"] = this.pmuso !== undefined ? this.pmuso : null as any;
        data["pmusi"] = this.pmusi !== undefined ? this.pmusi : null as any;
        data["pmusoctg"] = this.pmusoctg !== undefined ? this.pmusoctg : null as any;
        data["pmuvtext"] = this.pmuvtext !== undefined ? this.pmuvtext : null as any;
        data["matnr"] = this.matnr !== undefined ? this.matnr : null as any;
        data["arktX_EN"] = this.arktX_EN !== undefined ? this.arktX_EN : null as any;
        data["arktX_ZH"] = this.arktX_ZH !== undefined ? this.arktX_ZH : null as any;
        data["kwmeng"] = this.kwmeng !== undefined ? this.kwmeng : null as any;
        data["namZ1"] = this.namZ1 !== undefined ? this.namZ1 : null as any;
        data["pmustock"] = this.pmustock !== undefined ? this.pmustock : null as any;
        data["gidaT_PMU"] = this.gidaT_PMU !== undefined ? this.gidaT_PMU : null as any;
        data["pmuqty"] = this.pmuqty !== undefined ? this.pmuqty : null as any;
        data["pmudq"] = this.pmudq !== undefined ? this.pmudq : null as any;
        data["bstkD_E"] = this.bstkD_E !== undefined ? this.bstkD_E : null as any;
        data["netpR_LSU"] = this.netpR_LSU !== undefined ? this.netpR_LSU : null as any;
        data["reqdd"] = this.reqdd !== undefined ? this.reqdd : null as any;
        data["blamT_LSU"] = this.blamT_LSU !== undefined ? this.blamT_LSU : null as any;
        data["cuspo"] = this.cuspo !== undefined ? this.cuspo : null as any;
        data["matkl"] = this.matkl !== undefined ? this.matkl : null as any;
        data["bstdK_E"] = this.bstdK_E !== undefined ? this.bstdK_E : null as any;
        data["pricE_LSU"] = this.pricE_LSU !== undefined ? this.pricE_LSU : null as any;
        data["saleOrg"] = this.saleOrg !== undefined ? this.saleOrg : null as any;
        data["pg"] = this.pg !== undefined ? this.pg : null as any;
        data["bezeI_VKBUR"] = this.bezeI_VKBUR !== undefined ? this.bezeI_VKBUR : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["kdmat"] = this.kdmat !== undefined ? this.kdmat : null as any;
        data["waerk"] = this.waerk !== undefined ? this.waerk : null as any;
        data["kzwI1"] = this.kzwI1 !== undefined ? this.kzwI1 : null as any;
        data["netwR_LSU"] = this.netwR_LSU !== undefined ? this.netwR_LSU : null as any;
        data["tlfimg"] = this.tlfimg !== undefined ? this.tlfimg : null as any;
        data["namE1_ZX"] = this.namE1_ZX !== undefined ? this.namE1_ZX : null as any;
        data["bname"] = this.bname !== undefined ? this.bname : null as any;
        data["stocK_A"] = this.stocK_A !== undefined ? this.stocK_A : null as any;
        data["abgru"] = this.abgru !== undefined ? this.abgru : null as any;
        data["lsubezei"] = this.lsubezei !== undefined ? this.lsubezei : null as any;
        data["pmuabgru"] = this.pmuabgru !== undefined ? this.pmuabgru : null as any;
        data["pmubezei"] = this.pmubezei !== undefined ? this.pmubezei : null as any;
        data["brfmng"] = this.brfmng !== undefined ? this.brfmng : null as any;
        data["berdat"] = this.berdat !== undefined ? this.berdat : null as any;
        data["sendingflag"] = this.sendingflag !== undefined ? this.sendingflag : null as any;
        return data;
    }
}

export class SaveTaxRateDto {
    /** 税率 */
    rate!: number;

    init(_data?: any) {
        if (_data) {
            this.rate = _data["rate"] !== undefined ? _data["rate"] : null as any;
        }
    }

    static fromJS(data: any): SaveTaxRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTaxRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate !== undefined ? this.rate : null as any;
        return data;
    }
}

export class SelectOrInput {
    requiredByCode!: string | null;
    selection!: string[] | null;
    helper!: string | null;
    showType!: VCShowType;

    init(_data?: any) {
        if (_data) {
            this.requiredByCode = _data["requiredByCode"] !== undefined ? _data["requiredByCode"] : null as any;
            if (Array.isArray(_data["selection"])) {
                this.selection = [] as any;
                for (let item of _data["selection"])
                    this.selection!.push(item);
            }
            else {
                this.selection = null as any;
            }
            this.helper = _data["helper"] !== undefined ? _data["helper"] : null as any;
            this.showType = _data["showType"] !== undefined ? _data["showType"] : null as any;
        }
    }

    static fromJS(data: any): SelectOrInput {
        data = typeof data === 'object' ? data : {};
        let result = new SelectOrInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requiredByCode"] = this.requiredByCode !== undefined ? this.requiredByCode : null as any;
        if (Array.isArray(this.selection)) {
            data["selection"] = [];
            for (let item of this.selection)
                data["selection"].push(item);
        }
        data["helper"] = this.helper !== undefined ? this.helper : null as any;
        data["showType"] = this.showType !== undefined ? this.showType : null as any;
        return data;
    }
}

export class ServiceRequestListOutput {
    id!: string;
    sequenceNumber!: string | null;
    serviceTypeId!: string | null;
    processDefinitionId!: string | null;
    processInstanceId!: string | null;
    initiator!: string | null;
    customerCode!: string | null;
    customerName!: string | null;
    serviceName!: string | null;
    submissionTime!: moment.Moment | null;
    status!: ServiceRequestStatusEnum;
    completeTime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.sequenceNumber = _data["sequenceNumber"] !== undefined ? _data["sequenceNumber"] : null as any;
            this.serviceTypeId = _data["serviceTypeId"] !== undefined ? _data["serviceTypeId"] : null as any;
            this.processDefinitionId = _data["processDefinitionId"] !== undefined ? _data["processDefinitionId"] : null as any;
            this.processInstanceId = _data["processInstanceId"] !== undefined ? _data["processInstanceId"] : null as any;
            this.initiator = _data["initiator"] !== undefined ? _data["initiator"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.serviceName = _data["serviceName"] !== undefined ? _data["serviceName"] : null as any;
            this.submissionTime = _data["submissionTime"] ? moment(_data["submissionTime"].toString()) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.completeTime = _data["completeTime"] ? moment(_data["completeTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ServiceRequestListOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["sequenceNumber"] = this.sequenceNumber !== undefined ? this.sequenceNumber : null as any;
        data["serviceTypeId"] = this.serviceTypeId !== undefined ? this.serviceTypeId : null as any;
        data["processDefinitionId"] = this.processDefinitionId !== undefined ? this.processDefinitionId : null as any;
        data["processInstanceId"] = this.processInstanceId !== undefined ? this.processInstanceId : null as any;
        data["initiator"] = this.initiator !== undefined ? this.initiator : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["serviceName"] = this.serviceName !== undefined ? this.serviceName : null as any;
        data["submissionTime"] = this.submissionTime ? this.submissionTime.toISOString() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["completeTime"] = this.completeTime ? this.completeTime.toISOString() : null as any;
        return data;
    }
}

/** 0 = _0 1 = _1 2 = _2 4 = _4 */
export enum ServiceRequestStatusEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
}

/** 6 = 送至仓库 10 = 到厂自提 (Z19999) 11 = 送货到站 (Z10000) 99 = 顺丰速运 (Z19999) */
export enum ShippingType {
    送至仓库 = 6,
    到厂自提 = 10,
    送货到站 = 11,
    顺丰速运 = 99,
}

export class ShoppingCart {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    ctoProductBasicMotor!: CTOProductBasicMotor;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.ctoProductBasicMotor = _data["ctoProductBasicMotor"] ? CTOProductBasicMotor.fromJS(_data["ctoProductBasicMotor"]) : null as any;
        }
    }

    static fromJS(data: any): ShoppingCart {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["ctoProductBasicMotor"] = this.ctoProductBasicMotor ? this.ctoProductBasicMotor.toJSON() : null as any;
        return data;
    }
}

/** 0 = Free 1 = Occupied 2 = Released */
export enum SnOccupyStatus {
    Free = 0,
    Occupied = 1,
    Released = 2,
}

export class Solution {
    from!: string | null;
    to!: string | null;

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] !== undefined ? _data["from"] : null as any;
            this.to = _data["to"] !== undefined ? _data["to"] : null as any;
        }
    }

    static fromJS(data: any): Solution {
        data = typeof data === 'object' ? data : {};
        let result = new Solution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from !== undefined ? this.from : null as any;
        data["to"] = this.to !== undefined ? this.to : null as any;
        return data;
    }
}

export class SpecialOfferNoDto {
    id!: string;
    /** 特价号 */
    specialOfferNumber!: string | null;
    /** 有效期 */
    validityPeriod!: moment.Moment | null;
    /** 有效期 */
    validityPeriodString!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.specialOfferNumber = _data["specialOfferNumber"] !== undefined ? _data["specialOfferNumber"] : null as any;
            this.validityPeriod = _data["validityPeriod"] ? moment(_data["validityPeriod"].toString()) : null as any;
            this.validityPeriodString = _data["validityPeriodString"] !== undefined ? _data["validityPeriodString"] : null as any;
        }
    }

    static fromJS(data: any): SpecialOfferNoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialOfferNoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["specialOfferNumber"] = this.specialOfferNumber !== undefined ? this.specialOfferNumber : null as any;
        data["validityPeriod"] = this.validityPeriod ? this.validityPeriod.toISOString() : null as any;
        data["validityPeriodString"] = this.validityPeriodString !== undefined ? this.validityPeriodString : null as any;
        return data;
    }
}

export class SpecialOfferNoDtoPagedResultDto {
    items!: SpecialOfferNoDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SpecialOfferNoDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): SpecialOfferNoDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialOfferNoDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 提交费用购物车结果DTO */
export class SubmitFeeCartResultDto {
    /** 是否成功 */
    success!: boolean;
    /** 购物车ID */
    cartId!: string;
    /** 消息 */
    message!: string | null;
    /** 订单号（订单中心回写后才有；提交当下为空） */
    orderNo!: string | null;
    cartType!: FeeCartType;

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : null as any;
            this.cartId = _data["cartId"] !== undefined ? _data["cartId"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.orderNo = _data["orderNo"] !== undefined ? _data["orderNo"] : null as any;
            this.cartType = _data["cartType"] !== undefined ? _data["cartType"] : null as any;
        }
    }

    static fromJS(data: any): SubmitFeeCartResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitFeeCartResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : null as any;
        data["cartId"] = this.cartId !== undefined ? this.cartId : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["orderNo"] = this.orderNo !== undefined ? this.orderNo : null as any;
        data["cartType"] = this.cartType !== undefined ? this.cartType : null as any;
        return data;
    }
}

export class SysMessageLogDto {
    id!: string;
    creatorUserId!: number | null;
    creationTime!: moment.Moment;
    /** 消息名称 */
    messageName!: string | null;
    /** 消息类型 */
    messageType!: string | null;
    /** 服务名 */
    servicesName!: string | null;
    /** 方法名称 */
    funName!: string | null;
    /** 表名字 */
    tablesName!: string | null;
    /** 业务id */
    businessId!: string | null;
    /** 请求参数 */
    requestJson!: string | null;
    /** 错误消息 */
    errorMessage!: string | null;
    /** 文件base64 */
    fileData!: string | null;
    /** 文件名称 */
    fileName!: string | null;
    /** 文件类型 */
    fileType!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.messageName = _data["messageName"] !== undefined ? _data["messageName"] : null as any;
            this.messageType = _data["messageType"] !== undefined ? _data["messageType"] : null as any;
            this.servicesName = _data["servicesName"] !== undefined ? _data["servicesName"] : null as any;
            this.funName = _data["funName"] !== undefined ? _data["funName"] : null as any;
            this.tablesName = _data["tablesName"] !== undefined ? _data["tablesName"] : null as any;
            this.businessId = _data["businessId"] !== undefined ? _data["businessId"] : null as any;
            this.requestJson = _data["requestJson"] !== undefined ? _data["requestJson"] : null as any;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : null as any;
            this.fileData = _data["fileData"] !== undefined ? _data["fileData"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.fileType = _data["fileType"] !== undefined ? _data["fileType"] : null as any;
        }
    }

    static fromJS(data: any): SysMessageLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new SysMessageLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["messageName"] = this.messageName !== undefined ? this.messageName : null as any;
        data["messageType"] = this.messageType !== undefined ? this.messageType : null as any;
        data["servicesName"] = this.servicesName !== undefined ? this.servicesName : null as any;
        data["funName"] = this.funName !== undefined ? this.funName : null as any;
        data["tablesName"] = this.tablesName !== undefined ? this.tablesName : null as any;
        data["businessId"] = this.businessId !== undefined ? this.businessId : null as any;
        data["requestJson"] = this.requestJson !== undefined ? this.requestJson : null as any;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null as any;
        data["fileData"] = this.fileData !== undefined ? this.fileData : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileType"] = this.fileType !== undefined ? this.fileType : null as any;
        return data;
    }
}

export class TaskServiceChangeOrderFormDto {
    taskServiceRequestId!: string | null;
    remark!: string | null;
    formVersionsStatus!: EnumOrderChangeOrderFormVersionsStatus;

    init(_data?: any) {
        if (_data) {
            this.taskServiceRequestId = _data["taskServiceRequestId"] !== undefined ? _data["taskServiceRequestId"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.formVersionsStatus = _data["formVersionsStatus"] !== undefined ? _data["formVersionsStatus"] : null as any;
        }
    }

    static fromJS(data: any): TaskServiceChangeOrderFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskServiceChangeOrderFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskServiceRequestId"] = this.taskServiceRequestId !== undefined ? this.taskServiceRequestId : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["formVersionsStatus"] = this.formVersionsStatus !== undefined ? this.formVersionsStatus : null as any;
        return data;
    }
}

export class TaxRate {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    rate!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.rate = _data["rate"] !== undefined ? _data["rate"] : null as any;
        }
    }

    static fromJS(data: any): TaxRate {
        data = typeof data === 'object' ? data : {};
        let result = new TaxRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["rate"] = this.rate !== undefined ? this.rate : null as any;
        return data;
    }
}

export class UpateUrgentConfigurationDto {
    id!: string;
    /** 仅商务加急 */
    onlyBusinessExpress!: boolean;
    /** 4D订单强关联 */
    orderCorrelation_4D!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.onlyBusinessExpress = _data["onlyBusinessExpress"] !== undefined ? _data["onlyBusinessExpress"] : null as any;
            this.orderCorrelation_4D = _data["orderCorrelation_4D"] !== undefined ? _data["orderCorrelation_4D"] : null as any;
        }
    }

    static fromJS(data: any): UpateUrgentConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpateUrgentConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["onlyBusinessExpress"] = this.onlyBusinessExpress !== undefined ? this.onlyBusinessExpress : null as any;
        data["orderCorrelation_4D"] = this.orderCorrelation_4D !== undefined ? this.orderCorrelation_4D : null as any;
        return data;
    }
}

export class UpdateJINInsideVcRemarkInputDto {
    /** 关联订单Id */
    orderId!: string;
    /** 关联产品Id */
    productBasicMotorId!: string;
    /** vccode */
    vcCode!: string | null;
    /** 境界代码 */
    jinMototCode!: string | null;
    /** 境界版本 */
    jinVersion!: string | null;
    /** 序号 */
    serialNumber!: number;
    insideVcRelType!: InsideVcRelType;
    vcRemark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : null as any;
            this.productBasicMotorId = _data["productBasicMotorId"] !== undefined ? _data["productBasicMotorId"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.jinMototCode = _data["jinMototCode"] !== undefined ? _data["jinMototCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.insideVcRelType = _data["insideVcRelType"] !== undefined ? _data["insideVcRelType"] : null as any;
            this.vcRemark = _data["vcRemark"] !== undefined ? _data["vcRemark"] : null as any;
        }
    }

    static fromJS(data: any): UpdateJINInsideVcRemarkInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJINInsideVcRemarkInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId !== undefined ? this.orderId : null as any;
        data["productBasicMotorId"] = this.productBasicMotorId !== undefined ? this.productBasicMotorId : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["jinMototCode"] = this.jinMototCode !== undefined ? this.jinMototCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["insideVcRelType"] = this.insideVcRelType !== undefined ? this.insideVcRelType : null as any;
        data["vcRemark"] = this.vcRemark !== undefined ? this.vcRemark : null as any;
        return data;
    }
}

export class UpdateProductBasicMotorConfirmStatusInputDto {
    ids!: string[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            else {
                this.ids = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateProductBasicMotorConfirmStatusInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductBasicMotorConfirmStatusInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export class UpdateSpecialOfferNoDto {
    /** 特价号 */
    specialOfferNumber!: string | null;
    /** 有效期 */
    validityPeriod!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.specialOfferNumber = _data["specialOfferNumber"] !== undefined ? _data["specialOfferNumber"] : null as any;
            this.validityPeriod = _data["validityPeriod"] ? moment(_data["validityPeriod"].toString()) : null as any;
        }
    }

    static fromJS(data: any): UpdateSpecialOfferNoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSpecialOfferNoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specialOfferNumber"] = this.specialOfferNumber !== undefined ? this.specialOfferNumber : null as any;
        data["validityPeriod"] = this.validityPeriod ? this.validityPeriod.toISOString() : null as any;
        return data;
    }
}

export class UrgentConfiguration {
    id!: string;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    onlyBusinessExpress!: boolean;
    orderCorrelation_4D!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.onlyBusinessExpress = _data["onlyBusinessExpress"] !== undefined ? _data["onlyBusinessExpress"] : null as any;
            this.orderCorrelation_4D = _data["orderCorrelation_4D"] !== undefined ? _data["orderCorrelation_4D"] : null as any;
        }
    }

    static fromJS(data: any): UrgentConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new UrgentConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["onlyBusinessExpress"] = this.onlyBusinessExpress !== undefined ? this.onlyBusinessExpress : null as any;
        data["orderCorrelation_4D"] = this.orderCorrelation_4D !== undefined ? this.orderCorrelation_4D : null as any;
        return data;
    }
}

/** 0 = Label (Label) 1 = Input (输入) 2 = Select (选择) 3 = SelectAndInput (选择+输入) -1 = UnKnow */
export enum VCShowType {
    Label = 0,
    Input = 1,
    Select = 2,
    SelectAndInput = 3,
    UnKnow = -1,
}

export class VaildCustomCodeSalesPriceDto {
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 机座号 */
    frameSize!: number;
    /** 验证消息 */
    message!: string | null;

    init(_data?: any) {
        if (_data) {
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): VaildCustomCodeSalesPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new VaildCustomCodeSalesPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }
}

export class VariableValue {
    value!: any | null;
    type!: string | null;

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): VariableValue {
        data = typeof data === 'object' ? data : {};
        let result = new VariableValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }
}

/** 1 = Close (CloseVc) 2 = Open (OpenVc) -1 = UnKnow */
export enum VcOpenOrClose {
    Close = 1,
    Open = 2,
    UnKnow = -1,
}

/** 0 = Standard (标准) 1 = Custom (自定义) 2 = Industry (行业VC) 4 = Import (进口电机配置VC) 5 = ExportOrder (特殊Vc) -1 = None (编号缺失) */
export enum VcType {
    Standard = 0,
    Custom = 1,
    Industry = 2,
    Import = 4,
    ExportOrder = 5,
    None = -1,
}

export class Vcfreetext {
    key!: string | null;
    value!: string | null;

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static fromJS(data: any): Vcfreetext {
        data = typeof data === 'object' ? data : {};
        let result = new Vcfreetext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }
}

export class WriteAutomateLogForOrderParam {
    /** 主键 */
    orderId!: string;
    status!: AutomateStatusEnum;
    /** 描述 */
    description!: string | null;
    /** 邮件名称 */
    emailAddress!: string | null;
    /** OMS 单号 */
    omsNumber!: string | null;
    /** 备注 */
    omsRemark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.omsNumber = _data["omsNumber"] !== undefined ? _data["omsNumber"] : null as any;
            this.omsRemark = _data["omsRemark"] !== undefined ? _data["omsRemark"] : null as any;
        }
    }

    static fromJS(data: any): WriteAutomateLogForOrderParam {
        data = typeof data === 'object' ? data : {};
        let result = new WriteAutomateLogForOrderParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId !== undefined ? this.orderId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["omsNumber"] = this.omsNumber !== undefined ? this.omsNumber : null as any;
        data["omsRemark"] = this.omsRemark !== undefined ? this.omsRemark : null as any;
        return data;
    }
}

export class WriteBackBusinessDataDto {
    /** 审批ID */
    approvalId!: string;
    auditStatus!: AuditStatus;
    /** 附件合同名称 */
    attachmentName!: string | null;
    /** OMS订单号（暂时因为没有与OMS系统做接口，所以暂时由审批人员导入OMS系统成功之后填写） */
    omsOrderNumber!: string | null;
    remarks!: string | null;

    init(_data?: any) {
        if (_data) {
            this.approvalId = _data["approvalId"] !== undefined ? _data["approvalId"] : null as any;
            this.auditStatus = _data["auditStatus"] !== undefined ? _data["auditStatus"] : null as any;
            this.attachmentName = _data["attachmentName"] !== undefined ? _data["attachmentName"] : null as any;
            this.omsOrderNumber = _data["omsOrderNumber"] !== undefined ? _data["omsOrderNumber"] : null as any;
            this.remarks = _data["remarks"] !== undefined ? _data["remarks"] : null as any;
        }
    }

    static fromJS(data: any): WriteBackBusinessDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteBackBusinessDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalId"] = this.approvalId !== undefined ? this.approvalId : null as any;
        data["auditStatus"] = this.auditStatus !== undefined ? this.auditStatus : null as any;
        data["attachmentName"] = this.attachmentName !== undefined ? this.attachmentName : null as any;
        data["omsOrderNumber"] = this.omsOrderNumber !== undefined ? this.omsOrderNumber : null as any;
        data["remarks"] = this.remarks !== undefined ? this.remarks : null as any;
        return data;
    }
}

/** 回写费用购物车审批结果DTO */
export class WriteBackFeeCartResultDto {
    /** 购物车ID */
    cartId!: string;
    resultStatus!: FeeCartResultStatus;
    /** 结果消息 */
    resultMessage!: string | null;
    /** 订单FormId（可选） */
    orderFormId!: string | null;
    /** 订单号（可选） */
    orderNo!: string | null;

    init(_data?: any) {
        if (_data) {
            this.cartId = _data["cartId"] !== undefined ? _data["cartId"] : null as any;
            this.resultStatus = _data["resultStatus"] !== undefined ? _data["resultStatus"] : null as any;
            this.resultMessage = _data["resultMessage"] !== undefined ? _data["resultMessage"] : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.orderNo = _data["orderNo"] !== undefined ? _data["orderNo"] : null as any;
        }
    }

    static fromJS(data: any): WriteBackFeeCartResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteBackFeeCartResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cartId"] = this.cartId !== undefined ? this.cartId : null as any;
        data["resultStatus"] = this.resultStatus !== undefined ? this.resultStatus : null as any;
        data["resultMessage"] = this.resultMessage !== undefined ? this.resultMessage : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["orderNo"] = this.orderNo !== undefined ? this.orderNo : null as any;
        return data;
    }
}

/** 回写订单信息DTO */
export class WriteBackOrderInfoDto {
    /** 购物车ID */
    cartId!: string;
    /** 订单FormId */
    orderFormId!: string;
    /** 订单号 */
    orderNo!: string | null;

    init(_data?: any) {
        if (_data) {
            this.cartId = _data["cartId"] !== undefined ? _data["cartId"] : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.orderNo = _data["orderNo"] !== undefined ? _data["orderNo"] : null as any;
        }
    }

    static fromJS(data: any): WriteBackOrderInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteBackOrderInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cartId"] = this.cartId !== undefined ? this.cartId : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["orderNo"] = this.orderNo !== undefined ? this.orderNo : null as any;
        return data;
    }
}

export class ZppMotStrucSoitem {
    mspOrd!: string | null;
    mspItem!: string | null;

    init(_data?: any) {
        if (_data) {
            this.mspOrd = _data["mspOrd"] !== undefined ? _data["mspOrd"] : null as any;
            this.mspItem = _data["mspItem"] !== undefined ? _data["mspItem"] : null as any;
        }
    }

    static fromJS(data: any): ZppMotStrucSoitem {
        data = typeof data === 'object' ? data : {};
        let result = new ZppMotStrucSoitem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mspOrd"] = this.mspOrd !== undefined ? this.mspOrd : null as any;
        data["mspItem"] = this.mspItem !== undefined ? this.mspItem : null as any;
        return data;
    }
}

/** 1 = Pending (待审批) 2 = Approved (已审批) 3 = Rejected (已拒绝) */
export enum EnumOrderChangeOrderFormVersionsRevokeStatus {
    Pending = 1,
    Approved = 2,
    Rejected = 3,
}

/** 1 = Pending (已下单) 2 = Processing (草稿) 3 = SCPending (选型中) 4 = SCDone (选型完成) 5 = Approved (已批准) 6 = Rejected (已退回) 7 = PendingConfirmation (待确认) 8 = RejectNewOrderChange (退回重新变更) 9 = WorkflowError (工作流异常) 10 = Revoked (已撤销) */
export enum EnumOrderChangeOrderFormVersionsStatus {
    Pending = 1,
    Processing = 2,
    SCPending = 3,
    SCDone = 4,
    Approved = 5,
    Rejected = 6,
    PendingConfirmation = 7,
    RejectNewOrderChange = 8,
    WorkflowError = 9,
    Revoked = 10,
}

/** 1 = NumberWiresCheck (头数检查) 2 = OctCheck (oct规则检查) 3 = CustomCheck (自定义规则检查（61条）) 4 = MotorizerCheck (Motorizer检查) 5 = OCTOpenVCChek (OCT OpenVC 检查) 6 = BuiltInRule (一些内置规则，比如裸机不能配VC) 7 = MotorAndVcValidityCheck (客户化代码检查) */
export enum RuleSource {
    NumberWiresCheck = 1,
    OctCheck = 2,
    CustomCheck = 3,
    MotorizerCheck = 4,
    OCTOpenVCChek = 5,
    BuiltInRule = 6,
    MotorAndVcValidityCheck = 7,
}

export class AddAuthorizedUserCustomerRequestDto {
    /** 用户Id */
    userId!: number;
    /** 用户类型 */
    userType!: number;
    /** 二级客户代码 */
    finalCustomerCodes!: AuthorizedCustomerInfoRequestDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.userType = _data["userType"] !== undefined ? _data["userType"] : null as any;
            if (Array.isArray(_data["finalCustomerCodes"])) {
                this.finalCustomerCodes = [] as any;
                for (let item of _data["finalCustomerCodes"])
                    this.finalCustomerCodes!.push(AuthorizedCustomerInfoRequestDto.fromJS(item));
            }
            else {
                this.finalCustomerCodes = null as any;
            }
        }
    }

    static fromJS(data: any): AddAuthorizedUserCustomerRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddAuthorizedUserCustomerRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userType"] = this.userType !== undefined ? this.userType : null as any;
        if (Array.isArray(this.finalCustomerCodes)) {
            data["finalCustomerCodes"] = [];
            for (let item of this.finalCustomerCodes)
                data["finalCustomerCodes"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 新增境界维护人请求参数 */
export class AddAuthorizedUserJINSenarioRequestDto {
    userItem!: AuthorizedUserJINSenarioRequestDto[] | null;
    /** 场景类型 */
    senarioType!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userItem"])) {
                this.userItem = [] as any;
                for (let item of _data["userItem"])
                    this.userItem!.push(AuthorizedUserJINSenarioRequestDto.fromJS(item));
            }
            else {
                this.userItem = null as any;
            }
            this.senarioType = _data["senarioType"] !== undefined ? _data["senarioType"] : null as any;
        }
    }

    static fromJS(data: any): AddAuthorizedUserJINSenarioRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddAuthorizedUserJINSenarioRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userItem)) {
            data["userItem"] = [];
            for (let item of this.userItem)
                data["userItem"].push(item ? item.toJSON() : null as any);
        }
        data["senarioType"] = this.senarioType !== undefined ? this.senarioType : null as any;
        return data;
    }
}

export class AddCustomProductInPutDto {
    id!: string;
    lectoTypeId!: string;
    productNumber!: number;
    basicMotorCode!: string | null;
    basicMotorModel!: string | null;
    isHaveVc!: IsHaveVc;
    isNeedHeightOutput!: IsYes;
    clienter!: string;
    voltageCode!: string | null;
    frequency!: string | null;
    basicMotorMounting!: string | null;
    power!: string | null;
    poleNo!: string | null;
    eneEff!: string | null;
    encoder!: string | null;
    brake!: string | null;
    frameNo!: string | null;
    basicMotorType!: BasicMotorType;
    basicMotorSries!: string | null;
    wiringMode!: string | null;
    voltage!: string | null;
    source!: ProdcutAndVcSource;
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    productionCycle!: number;
    testCycle!: number;
    capacityCycle!: number;
    inToOutCycle!: number;
    grCycle!: number;
    serialNo!: number | null;
    makeOrBuy!: string | null;
    customMotorParameters!: LectoTypeProductParameterDto[] | null;
    lectoTypeCustomProductPrice!: LectoTypeCustomProductPriceDto;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.productNumber = _data["productNumber"] !== undefined ? _data["productNumber"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.isHaveVc = _data["isHaveVc"] !== undefined ? _data["isHaveVc"] : null as any;
            this.isNeedHeightOutput = _data["isNeedHeightOutput"] !== undefined ? _data["isNeedHeightOutput"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.voltageCode = _data["voltageCode"] !== undefined ? _data["voltageCode"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.encoder = _data["encoder"] !== undefined ? _data["encoder"] : null as any;
            this.brake = _data["brake"] !== undefined ? _data["brake"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.basicMotorType = _data["basicMotorType"] !== undefined ? _data["basicMotorType"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.capacityCycle = _data["capacityCycle"] !== undefined ? _data["capacityCycle"] : null as any;
            this.inToOutCycle = _data["inToOutCycle"] !== undefined ? _data["inToOutCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            if (Array.isArray(_data["customMotorParameters"])) {
                this.customMotorParameters = [] as any;
                for (let item of _data["customMotorParameters"])
                    this.customMotorParameters!.push(LectoTypeProductParameterDto.fromJS(item));
            }
            else {
                this.customMotorParameters = null as any;
            }
            this.lectoTypeCustomProductPrice = _data["lectoTypeCustomProductPrice"] ? LectoTypeCustomProductPriceDto.fromJS(_data["lectoTypeCustomProductPrice"]) : null as any;
        }
    }

    static fromJS(data: any): AddCustomProductInPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomProductInPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["productNumber"] = this.productNumber !== undefined ? this.productNumber : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["isHaveVc"] = this.isHaveVc !== undefined ? this.isHaveVc : null as any;
        data["isNeedHeightOutput"] = this.isNeedHeightOutput !== undefined ? this.isNeedHeightOutput : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["voltageCode"] = this.voltageCode !== undefined ? this.voltageCode : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["encoder"] = this.encoder !== undefined ? this.encoder : null as any;
        data["brake"] = this.brake !== undefined ? this.brake : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["basicMotorType"] = this.basicMotorType !== undefined ? this.basicMotorType : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["capacityCycle"] = this.capacityCycle !== undefined ? this.capacityCycle : null as any;
        data["inToOutCycle"] = this.inToOutCycle !== undefined ? this.inToOutCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        if (Array.isArray(this.customMotorParameters)) {
            data["customMotorParameters"] = [];
            for (let item of this.customMotorParameters)
                data["customMotorParameters"].push(item ? item.toJSON() : null as any);
        }
        data["lectoTypeCustomProductPrice"] = this.lectoTypeCustomProductPrice ? this.lectoTypeCustomProductPrice.toJSON() : null as any;
        return data;
    }
}

export class AddCustomVcInputDto {
    vcID!: string | null;
    category!: string | null;
    meaning!: string | null;
    numberWires!: number;
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    purchaseCycle!: number;
    grCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    productionCycle!: number;
    testCycle!: number;
    shipSurveyCycle!: number;
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): AddCustomVcInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomVcInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

export class AddCustomerRequestDto {
    /** 客户名称 */
    finalCustomerName!: string | null;
    /** 二级客户代码 */
    finalCustomerCode!: string | null;
    /** 一级客户 */
    clienter!: string | null;
    /** 一级客户名称（冗余字段） */
    clientName!: string | null;
    userInfos!: AddCustomerUserInfoRequestDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            if (Array.isArray(_data["userInfos"])) {
                this.userInfos = [] as any;
                for (let item of _data["userInfos"])
                    this.userInfos!.push(AddCustomerUserInfoRequestDto.fromJS(item));
            }
            else {
                this.userInfos = null as any;
            }
        }
    }

    static fromJS(data: any): AddCustomerRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        if (Array.isArray(this.userInfos)) {
            data["userInfos"] = [];
            for (let item of this.userInfos)
                data["userInfos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class AddCustomerUserInfoRequestDto {
    /** 用户Id */
    userId!: number;
    /** 用户类型 */
    userType!: number;

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.userType = _data["userType"] !== undefined ? _data["userType"] : null as any;
        }
    }

    static fromJS(data: any): AddCustomerUserInfoRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerUserInfoRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userType"] = this.userType !== undefined ? this.userType : null as any;
        return data;
    }
}

export class AddImportProductInputDto {
    lectoTypeId!: string;
    basicMotorCode!: string | null;
    basicMotorModel!: string | null;
    basicMotorMounting!: string | null;
    basicMotorType!: BasicMotorType;
    power!: string | null;
    frequency!: string | null;
    poleNo!: string | null;
    voltage!: string | null;
    productNumber!: number;
    unitPrice!: number | null;
    unitPriceResult!: string | null;
    source!: ProdcutAndVcSource;
    vcCodes!: string | null;
    vcCodeRemark!: string | null;
    defaultMultiplier!: number;
    discountUnitPrice!: number | null;
    noDiscountByPlatformUnitPrice!: number | null;
    noDiscountByListUnitPrice!: number | null;
    gssQuotationNo!: string | null;
    gssTechnicalConfirmationNumber!: string | null;
    remarkTwo!: string | null;
    vcs!: AddImportProductVcInputDto[] | null;
    serialNo!: number | null;
    cycle!: number;

    init(_data?: any) {
        if (_data) {
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.basicMotorType = _data["basicMotorType"] !== undefined ? _data["basicMotorType"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.productNumber = _data["productNumber"] !== undefined ? _data["productNumber"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.vcCodes = _data["vcCodes"] !== undefined ? _data["vcCodes"] : null as any;
            this.vcCodeRemark = _data["vcCodeRemark"] !== undefined ? _data["vcCodeRemark"] : null as any;
            this.defaultMultiplier = _data["defaultMultiplier"] !== undefined ? _data["defaultMultiplier"] : null as any;
            this.discountUnitPrice = _data["discountUnitPrice"] !== undefined ? _data["discountUnitPrice"] : null as any;
            this.noDiscountByPlatformUnitPrice = _data["noDiscountByPlatformUnitPrice"] !== undefined ? _data["noDiscountByPlatformUnitPrice"] : null as any;
            this.noDiscountByListUnitPrice = _data["noDiscountByListUnitPrice"] !== undefined ? _data["noDiscountByListUnitPrice"] : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.remarkTwo = _data["remarkTwo"] !== undefined ? _data["remarkTwo"] : null as any;
            if (Array.isArray(_data["vcs"])) {
                this.vcs = [] as any;
                for (let item of _data["vcs"])
                    this.vcs!.push(AddImportProductVcInputDto.fromJS(item));
            }
            else {
                this.vcs = null as any;
            }
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : null as any;
            this.cycle = _data["cycle"] !== undefined ? _data["cycle"] : null as any;
        }
    }

    static fromJS(data: any): AddImportProductInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddImportProductInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["basicMotorType"] = this.basicMotorType !== undefined ? this.basicMotorType : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["productNumber"] = this.productNumber !== undefined ? this.productNumber : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["vcCodes"] = this.vcCodes !== undefined ? this.vcCodes : null as any;
        data["vcCodeRemark"] = this.vcCodeRemark !== undefined ? this.vcCodeRemark : null as any;
        data["defaultMultiplier"] = this.defaultMultiplier !== undefined ? this.defaultMultiplier : null as any;
        data["discountUnitPrice"] = this.discountUnitPrice !== undefined ? this.discountUnitPrice : null as any;
        data["noDiscountByPlatformUnitPrice"] = this.noDiscountByPlatformUnitPrice !== undefined ? this.noDiscountByPlatformUnitPrice : null as any;
        data["noDiscountByListUnitPrice"] = this.noDiscountByListUnitPrice !== undefined ? this.noDiscountByListUnitPrice : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["remarkTwo"] = this.remarkTwo !== undefined ? this.remarkTwo : null as any;
        if (Array.isArray(this.vcs)) {
            data["vcs"] = [];
            for (let item of this.vcs)
                data["vcs"].push(item ? item.toJSON() : null as any);
        }
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : null as any;
        data["cycle"] = this.cycle !== undefined ? this.cycle : null as any;
        return data;
    }
}

export class AddImportProductVcInputDto {
    vcID!: string | null;
    meaning!: string | null;
    numberWires!: number;
    unitPrice!: number;
    unitPriceResult!: string | null;
    source!: ProdcutAndVcSource;
    vcType!: VcType;
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): AddImportProductVcInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddImportProductVcInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

export class AddIndustryVCInPutDto {
    id!: string | null;
    vcID!: string | null;
    meaning!: string | null;
    englishMeaning!: string | null;
    vcTypeDescription!: string | null;
    numberWires!: number;
    owner!: string | null;
    validStartTime!: moment.Moment;
    validEndTime!: moment.Moment;
    categoryId!: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.owner = _data["owner"] !== undefined ? _data["owner"] : null as any;
            this.validStartTime = _data["validStartTime"] ? moment(_data["validStartTime"].toString()) : null as any;
            this.validEndTime = _data["validEndTime"] ? moment(_data["validEndTime"].toString()) : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
        }
    }

    static fromJS(data: any): AddIndustryVCInPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddIndustryVCInPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["owner"] = this.owner !== undefined ? this.owner : null as any;
        data["validStartTime"] = this.validStartTime ? this.validStartTime.toISOString() : null as any;
        data["validEndTime"] = this.validEndTime ? this.validEndTime.toISOString() : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        return data;
    }
}

export class AddIndustryVCPriceInPutDto {
    id!: string | null;
    industryVCId!: string;
    basicMotorSries!: string | null;
    frameNo!: number;
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    productionCycle!: number;
    testCycle!: number;
    shipSurveyCycle!: number;
    grCycle!: number;
    scmCycle!: number | null;
    scmCalculationMode!: string | null;
    scmRemark!: string | null;
    extraOverlayTime!: boolean | null;
    isOverlayLogic!: boolean | null;
    unitPrice!: number;
    unitPriceFormula!: string | null;
    unitPriceType!: UnitPriceType;
    cost!: number | null;
    costFormula!: string | null;
    costType!: CostType;
    costTypeDetail!: string | null;
    quotationPrinciple!: string | null;
    quotationPrincipleDetails!: string | null;
    engineeringCycleUpdateTime!: moment.Moment | null;
    shipSurveyCycleUpdateTime!: moment.Moment | null;
    productionCycleUpdateTime!: moment.Moment | null;
    purchaseCycleUpdateTime!: moment.Moment | null;
    testCycleUpdateTime!: moment.Moment | null;
    grCycleUpdateTime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.industryVCId = _data["industryVCId"] !== undefined ? _data["industryVCId"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.scmCycle = _data["scmCycle"] !== undefined ? _data["scmCycle"] : null as any;
            this.scmCalculationMode = _data["scmCalculationMode"] !== undefined ? _data["scmCalculationMode"] : null as any;
            this.scmRemark = _data["scmRemark"] !== undefined ? _data["scmRemark"] : null as any;
            this.extraOverlayTime = _data["extraOverlayTime"] !== undefined ? _data["extraOverlayTime"] : null as any;
            this.isOverlayLogic = _data["isOverlayLogic"] !== undefined ? _data["isOverlayLogic"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.engineeringCycleUpdateTime = _data["engineeringCycleUpdateTime"] ? moment(_data["engineeringCycleUpdateTime"].toString()) : null as any;
            this.shipSurveyCycleUpdateTime = _data["shipSurveyCycleUpdateTime"] ? moment(_data["shipSurveyCycleUpdateTime"].toString()) : null as any;
            this.productionCycleUpdateTime = _data["productionCycleUpdateTime"] ? moment(_data["productionCycleUpdateTime"].toString()) : null as any;
            this.purchaseCycleUpdateTime = _data["purchaseCycleUpdateTime"] ? moment(_data["purchaseCycleUpdateTime"].toString()) : null as any;
            this.testCycleUpdateTime = _data["testCycleUpdateTime"] ? moment(_data["testCycleUpdateTime"].toString()) : null as any;
            this.grCycleUpdateTime = _data["grCycleUpdateTime"] ? moment(_data["grCycleUpdateTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): AddIndustryVCPriceInPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddIndustryVCPriceInPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["industryVCId"] = this.industryVCId !== undefined ? this.industryVCId : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["scmCycle"] = this.scmCycle !== undefined ? this.scmCycle : null as any;
        data["scmCalculationMode"] = this.scmCalculationMode !== undefined ? this.scmCalculationMode : null as any;
        data["scmRemark"] = this.scmRemark !== undefined ? this.scmRemark : null as any;
        data["extraOverlayTime"] = this.extraOverlayTime !== undefined ? this.extraOverlayTime : null as any;
        data["isOverlayLogic"] = this.isOverlayLogic !== undefined ? this.isOverlayLogic : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["engineeringCycleUpdateTime"] = this.engineeringCycleUpdateTime ? this.engineeringCycleUpdateTime.toISOString() : null as any;
        data["shipSurveyCycleUpdateTime"] = this.shipSurveyCycleUpdateTime ? this.shipSurveyCycleUpdateTime.toISOString() : null as any;
        data["productionCycleUpdateTime"] = this.productionCycleUpdateTime ? this.productionCycleUpdateTime.toISOString() : null as any;
        data["purchaseCycleUpdateTime"] = this.purchaseCycleUpdateTime ? this.purchaseCycleUpdateTime.toISOString() : null as any;
        data["testCycleUpdateTime"] = this.testCycleUpdateTime ? this.testCycleUpdateTime.toISOString() : null as any;
        data["grCycleUpdateTime"] = this.grCycleUpdateTime ? this.grCycleUpdateTime.toISOString() : null as any;
        return data;
    }
}

export class AddLectoTypeProductDto {
    lectoTypeId!: string;
    basicMotorInfoId!: string;
    basicMotorType!: BasicMotorType;
    basicMotorCode!: string | null;
    basicMotorModel!: string | null;
    basicMotorMounting!: string | null;
    frameNo!: number;
    basicMotorSries!: string | null;
    isHaveVc!: IsHaveVc;
    power!: string | null;
    frequency!: string | null;
    poleNo!: string | null;
    voltage!: string | null;
    cycle!: number;
    encoder!: string | null;
    source!: ProdcutAndVcSource;
    serialNo!: number | null;

    init(_data?: any) {
        if (_data) {
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.basicMotorInfoId = _data["basicMotorInfoId"] !== undefined ? _data["basicMotorInfoId"] : null as any;
            this.basicMotorType = _data["basicMotorType"] !== undefined ? _data["basicMotorType"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.isHaveVc = _data["isHaveVc"] !== undefined ? _data["isHaveVc"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.cycle = _data["cycle"] !== undefined ? _data["cycle"] : null as any;
            this.encoder = _data["encoder"] !== undefined ? _data["encoder"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : null as any;
        }
    }

    static fromJS(data: any): AddLectoTypeProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddLectoTypeProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["basicMotorInfoId"] = this.basicMotorInfoId !== undefined ? this.basicMotorInfoId : null as any;
        data["basicMotorType"] = this.basicMotorType !== undefined ? this.basicMotorType : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["isHaveVc"] = this.isHaveVc !== undefined ? this.isHaveVc : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["cycle"] = this.cycle !== undefined ? this.cycle : null as any;
        data["encoder"] = this.encoder !== undefined ? this.encoder : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : null as any;
        return data;
    }
}

export class AddLectoTypeProductVc {
    /** 自定义VC交期信息 */
    customVcPriceId!: string;
    /** 选型产品编号 */
    lectoTypeProductIds!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.customVcPriceId = _data["customVcPriceId"] !== undefined ? _data["customVcPriceId"] : null as any;
            if (Array.isArray(_data["lectoTypeProductIds"])) {
                this.lectoTypeProductIds = [] as any;
                for (let item of _data["lectoTypeProductIds"])
                    this.lectoTypeProductIds!.push(item);
            }
            else {
                this.lectoTypeProductIds = null as any;
            }
        }
    }

    static fromJS(data: any): AddLectoTypeProductVc {
        data = typeof data === 'object' ? data : {};
        let result = new AddLectoTypeProductVc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customVcPriceId"] = this.customVcPriceId !== undefined ? this.customVcPriceId : null as any;
        if (Array.isArray(this.lectoTypeProductIds)) {
            data["lectoTypeProductIds"] = [];
            for (let item of this.lectoTypeProductIds)
                data["lectoTypeProductIds"].push(item);
        }
        return data;
    }
}

export class AddLectoTypeProductVcInputDto {
    lectoTypeProductIds!: string[] | null;
    vcInfoId!: string;
    vcProductCode!: string | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lectoTypeProductIds"])) {
                this.lectoTypeProductIds = [] as any;
                for (let item of _data["lectoTypeProductIds"])
                    this.lectoTypeProductIds!.push(item);
            }
            else {
                this.lectoTypeProductIds = null as any;
            }
            this.vcInfoId = _data["vcInfoId"] !== undefined ? _data["vcInfoId"] : null as any;
            this.vcProductCode = _data["vcProductCode"] !== undefined ? _data["vcProductCode"] : null as any;
        }
    }

    static fromJS(data: any): AddLectoTypeProductVcInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddLectoTypeProductVcInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lectoTypeProductIds)) {
            data["lectoTypeProductIds"] = [];
            for (let item of this.lectoTypeProductIds)
                data["lectoTypeProductIds"].push(item);
        }
        data["vcInfoId"] = this.vcInfoId !== undefined ? this.vcInfoId : null as any;
        data["vcProductCode"] = this.vcProductCode !== undefined ? this.vcProductCode : null as any;
        return data;
    }
}

export class AddProductCombinationInputDto {
    number!: string | null;
    lectoTypeId!: string;
    clientid!: string | null;

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.clientid = _data["clientid"] !== undefined ? _data["clientid"] : null as any;
        }
    }

    static fromJS(data: any): AddProductCombinationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductCombinationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["clientid"] = this.clientid !== undefined ? this.clientid : null as any;
        return data;
    }
}

export class AddVcInfoDto {
    id!: string;
    vcID!: string;
    meaning!: string | null;
    englishMeaning!: string | null;
    numberWires!: number;
    vcTypeDescription!: string | null;
    categoryId!: string;
    category!: string | null;
    vcLongCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.vcLongCode = _data["vcLongCode"] !== undefined ? _data["vcLongCode"] : null as any;
        }
    }

    static fromJS(data: any): AddVcInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddVcInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["vcLongCode"] = this.vcLongCode !== undefined ? this.vcLongCode : null as any;
        return data;
    }
}

export class AllKindVCCompleteInfoOutputDto {
    /** VC ID */
    vcID!: string | null;
    /** 品类 */
    categoryId!: string;
    /** 品类 */
    category!: string | null;
    /** VC含义 */
    meaning!: string | null;
    /** 英文含义 */
    englishMeaning!: string | null;
    /** VC备注 */
    vcTypeDescription!: string | null;
    vcType!: VcType;
    readonly vcTypeName!: string | null;
    /** VC头数 */
    numberWires!: number;
    showType!: VCShowType;
    /** 所属人 */
    owner!: string | null;
    vcPriceOrRuleInfos!: VcPriceOrRuleInfo[] | null;

    init(_data?: any) {
        if (_data) {
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            (this as any).vcTypeName = _data["vcTypeName"] !== undefined ? _data["vcTypeName"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.showType = _data["showType"] !== undefined ? _data["showType"] : null as any;
            this.owner = _data["owner"] !== undefined ? _data["owner"] : null as any;
            if (Array.isArray(_data["vcPriceOrRuleInfos"])) {
                this.vcPriceOrRuleInfos = [] as any;
                for (let item of _data["vcPriceOrRuleInfos"])
                    this.vcPriceOrRuleInfos!.push(VcPriceOrRuleInfo.fromJS(item));
            }
            else {
                this.vcPriceOrRuleInfos = null as any;
            }
        }
    }

    static fromJS(data: any): AllKindVCCompleteInfoOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllKindVCCompleteInfoOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcTypeName"] = this.vcTypeName !== undefined ? this.vcTypeName : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["showType"] = this.showType !== undefined ? this.showType : null as any;
        data["owner"] = this.owner !== undefined ? this.owner : null as any;
        if (Array.isArray(this.vcPriceOrRuleInfos)) {
            data["vcPriceOrRuleInfos"] = [];
            for (let item of this.vcPriceOrRuleInfos)
                data["vcPriceOrRuleInfos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class ApplyPreCalInput {
    id!: string;
    creatorUserId!: number | null;
    userFriendlyID!: string | null;
    name!: string | null;
    clientID!: string | null;
    clientName!: string | null;
    finalCustomerCode!: string | null;
    finalCustomerName!: string | null;
    shippingAddressCode!: string | null;
    shippingAddress!: string | null;
    sourceId!: string | null;
    expectedDeliveryDate!: number;
    status!: LectoTypeStatus;
    sourceType!: SourceType;
    responsibleSalesCode!: string | null;
    responsibleSalesName!: string | null;
    responsibleSalesEamil!: string | null;
    specialOfferApplicationNumber!: string | null;
    precalIDSoucre!: string | null;
    redirectPreCalUrl!: string | null;
    dq!: GetTechnologyQuotationDto;
    te!: GetTechnologyQuotationDto;
    products!: SMProduct[] | null;
    records!: SMRecord[] | null;
    readonly standardProducts!: SMProduct[] | null;
    isHelp!: boolean;
    helpCompleted!: boolean;
    pmsProjectCode!: string | null;
    pmsProjectType!: number | null;
    isOrderDirectly!: boolean;
    orderChange!: boolean;
    orderFormId!: string | null;
    orderFormChangeId!: string;
    onComplateHook!: string | null;
    jinLectoType!: boolean;
    jinLectoTypeId!: string | null;
    listPriceSeriesId!: string | null;
    listPriceJINSeriesId!: string | null;
    lectoTypeHelpInfo!: GetLectoTypeHelpInfoDto;
    lectoTypeHelpInfoId!: string | null;
    email!: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.userFriendlyID = _data["userFriendlyID"] !== undefined ? _data["userFriendlyID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.clientID = _data["clientID"] !== undefined ? _data["clientID"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.shippingAddressCode = _data["shippingAddressCode"] !== undefined ? _data["shippingAddressCode"] : null as any;
            this.shippingAddress = _data["shippingAddress"] !== undefined ? _data["shippingAddress"] : null as any;
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.sourceType = _data["sourceType"] !== undefined ? _data["sourceType"] : null as any;
            this.responsibleSalesCode = _data["responsibleSalesCode"] !== undefined ? _data["responsibleSalesCode"] : null as any;
            this.responsibleSalesName = _data["responsibleSalesName"] !== undefined ? _data["responsibleSalesName"] : null as any;
            this.responsibleSalesEamil = _data["responsibleSalesEamil"] !== undefined ? _data["responsibleSalesEamil"] : null as any;
            this.specialOfferApplicationNumber = _data["specialOfferApplicationNumber"] !== undefined ? _data["specialOfferApplicationNumber"] : null as any;
            this.precalIDSoucre = _data["precalIDSoucre"] !== undefined ? _data["precalIDSoucre"] : null as any;
            this.redirectPreCalUrl = _data["redirectPreCalUrl"] !== undefined ? _data["redirectPreCalUrl"] : null as any;
            this.dq = _data["dq"] ? GetTechnologyQuotationDto.fromJS(_data["dq"]) : null as any;
            this.te = _data["te"] ? GetTechnologyQuotationDto.fromJS(_data["te"]) : null as any;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(SMProduct.fromJS(item));
            }
            else {
                this.products = null as any;
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(SMRecord.fromJS(item));
            }
            else {
                this.records = null as any;
            }
            if (Array.isArray(_data["standardProducts"])) {
                (this as any).standardProducts = [] as any;
                for (let item of _data["standardProducts"])
                    (this as any).standardProducts!.push(SMProduct.fromJS(item));
            }
            else {
                (this as any).standardProducts = null as any;
            }
            this.isHelp = _data["isHelp"] !== undefined ? _data["isHelp"] : null as any;
            this.helpCompleted = _data["helpCompleted"] !== undefined ? _data["helpCompleted"] : null as any;
            this.pmsProjectCode = _data["pmsProjectCode"] !== undefined ? _data["pmsProjectCode"] : null as any;
            this.pmsProjectType = _data["pmsProjectType"] !== undefined ? _data["pmsProjectType"] : null as any;
            this.isOrderDirectly = _data["isOrderDirectly"] !== undefined ? _data["isOrderDirectly"] : null as any;
            this.orderChange = _data["orderChange"] !== undefined ? _data["orderChange"] : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.orderFormChangeId = _data["orderFormChangeId"] !== undefined ? _data["orderFormChangeId"] : null as any;
            this.onComplateHook = _data["onComplateHook"] !== undefined ? _data["onComplateHook"] : null as any;
            this.jinLectoType = _data["jinLectoType"] !== undefined ? _data["jinLectoType"] : null as any;
            this.jinLectoTypeId = _data["jinLectoTypeId"] !== undefined ? _data["jinLectoTypeId"] : null as any;
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.listPriceJINSeriesId = _data["listPriceJINSeriesId"] !== undefined ? _data["listPriceJINSeriesId"] : null as any;
            this.lectoTypeHelpInfo = _data["lectoTypeHelpInfo"] ? GetLectoTypeHelpInfoDto.fromJS(_data["lectoTypeHelpInfo"]) : null as any;
            this.lectoTypeHelpInfoId = _data["lectoTypeHelpInfoId"] !== undefined ? _data["lectoTypeHelpInfoId"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): ApplyPreCalInput {
        data = typeof data === 'object' ? data : {};
        let result = new ApplyPreCalInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["userFriendlyID"] = this.userFriendlyID !== undefined ? this.userFriendlyID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["clientID"] = this.clientID !== undefined ? this.clientID : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["shippingAddressCode"] = this.shippingAddressCode !== undefined ? this.shippingAddressCode : null as any;
        data["shippingAddress"] = this.shippingAddress !== undefined ? this.shippingAddress : null as any;
        data["sourceId"] = this.sourceId !== undefined ? this.sourceId : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["sourceType"] = this.sourceType !== undefined ? this.sourceType : null as any;
        data["responsibleSalesCode"] = this.responsibleSalesCode !== undefined ? this.responsibleSalesCode : null as any;
        data["responsibleSalesName"] = this.responsibleSalesName !== undefined ? this.responsibleSalesName : null as any;
        data["responsibleSalesEamil"] = this.responsibleSalesEamil !== undefined ? this.responsibleSalesEamil : null as any;
        data["specialOfferApplicationNumber"] = this.specialOfferApplicationNumber !== undefined ? this.specialOfferApplicationNumber : null as any;
        data["precalIDSoucre"] = this.precalIDSoucre !== undefined ? this.precalIDSoucre : null as any;
        data["redirectPreCalUrl"] = this.redirectPreCalUrl !== undefined ? this.redirectPreCalUrl : null as any;
        data["dq"] = this.dq ? this.dq.toJSON() : null as any;
        data["te"] = this.te ? this.te.toJSON() : null as any;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.standardProducts)) {
            data["standardProducts"] = [];
            for (let item of this.standardProducts)
                data["standardProducts"].push(item ? item.toJSON() : null as any);
        }
        data["isHelp"] = this.isHelp !== undefined ? this.isHelp : null as any;
        data["helpCompleted"] = this.helpCompleted !== undefined ? this.helpCompleted : null as any;
        data["pmsProjectCode"] = this.pmsProjectCode !== undefined ? this.pmsProjectCode : null as any;
        data["pmsProjectType"] = this.pmsProjectType !== undefined ? this.pmsProjectType : null as any;
        data["isOrderDirectly"] = this.isOrderDirectly !== undefined ? this.isOrderDirectly : null as any;
        data["orderChange"] = this.orderChange !== undefined ? this.orderChange : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["orderFormChangeId"] = this.orderFormChangeId !== undefined ? this.orderFormChangeId : null as any;
        data["onComplateHook"] = this.onComplateHook !== undefined ? this.onComplateHook : null as any;
        data["jinLectoType"] = this.jinLectoType !== undefined ? this.jinLectoType : null as any;
        data["jinLectoTypeId"] = this.jinLectoTypeId !== undefined ? this.jinLectoTypeId : null as any;
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["listPriceJINSeriesId"] = this.listPriceJINSeriesId !== undefined ? this.listPriceJINSeriesId : null as any;
        data["lectoTypeHelpInfo"] = this.lectoTypeHelpInfo ? this.lectoTypeHelpInfo.toJSON() : null as any;
        data["lectoTypeHelpInfoId"] = this.lectoTypeHelpInfoId !== undefined ? this.lectoTypeHelpInfoId : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export class ApprovalIndustryVCInPutDto {
    info!: string | null;
    isApproval!: TQApprovalStatus;
    industryVCId!: string;

    init(_data?: any) {
        if (_data) {
            this.info = _data["info"] !== undefined ? _data["info"] : null as any;
            this.isApproval = _data["isApproval"] !== undefined ? _data["isApproval"] : null as any;
            this.industryVCId = _data["industryVCId"] !== undefined ? _data["industryVCId"] : null as any;
        }
    }

    static fromJS(data: any): ApprovalIndustryVCInPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalIndustryVCInPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["info"] = this.info !== undefined ? this.info : null as any;
        data["isApproval"] = this.isApproval !== undefined ? this.isApproval : null as any;
        data["industryVCId"] = this.industryVCId !== undefined ? this.industryVCId : null as any;
        return data;
    }
}

export class Assembly {
    readonly definedTypes!: TypeInfo[] | null;
    readonly exportedTypes!: Type[] | null;
    readonly codeBase!: string | null;
    entryPoint!: MethodInfo;
    readonly fullName!: string | null;
    readonly imageRuntimeVersion!: string | null;
    readonly isDynamic!: boolean;
    readonly location!: string | null;
    readonly reflectionOnly!: boolean;
    readonly isCollectible!: boolean;
    readonly isFullyTrusted!: boolean;
    readonly customAttributes!: CustomAttributeData[] | null;
    readonly escapedCodeBase!: string | null;
    manifestModule!: Module;
    readonly modules!: Module[] | null;
    readonly globalAssemblyCache!: boolean;
    readonly hostContext!: number;
    securityRuleSet!: SecurityRuleSet;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["definedTypes"])) {
                (this as any).definedTypes = [] as any;
                for (let item of _data["definedTypes"])
                    (this as any).definedTypes!.push(TypeInfo.fromJS(item));
            }
            else {
                (this as any).definedTypes = null as any;
            }
            if (Array.isArray(_data["exportedTypes"])) {
                (this as any).exportedTypes = [] as any;
                for (let item of _data["exportedTypes"])
                    (this as any).exportedTypes!.push(Type.fromJS(item));
            }
            else {
                (this as any).exportedTypes = null as any;
            }
            (this as any).codeBase = _data["codeBase"] !== undefined ? _data["codeBase"] : null as any;
            this.entryPoint = _data["entryPoint"] ? MethodInfo.fromJS(_data["entryPoint"]) : null as any;
            (this as any).fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            (this as any).imageRuntimeVersion = _data["imageRuntimeVersion"] !== undefined ? _data["imageRuntimeVersion"] : null as any;
            (this as any).isDynamic = _data["isDynamic"] !== undefined ? _data["isDynamic"] : null as any;
            (this as any).location = _data["location"] !== undefined ? _data["location"] : null as any;
            (this as any).reflectionOnly = _data["reflectionOnly"] !== undefined ? _data["reflectionOnly"] : null as any;
            (this as any).isCollectible = _data["isCollectible"] !== undefined ? _data["isCollectible"] : null as any;
            (this as any).isFullyTrusted = _data["isFullyTrusted"] !== undefined ? _data["isFullyTrusted"] : null as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            else {
                (this as any).customAttributes = null as any;
            }
            (this as any).escapedCodeBase = _data["escapedCodeBase"] !== undefined ? _data["escapedCodeBase"] : null as any;
            this.manifestModule = _data["manifestModule"] ? Module.fromJS(_data["manifestModule"]) : null as any;
            if (Array.isArray(_data["modules"])) {
                (this as any).modules = [] as any;
                for (let item of _data["modules"])
                    (this as any).modules!.push(Module.fromJS(item));
            }
            else {
                (this as any).modules = null as any;
            }
            (this as any).globalAssemblyCache = _data["globalAssemblyCache"] !== undefined ? _data["globalAssemblyCache"] : null as any;
            (this as any).hostContext = _data["hostContext"] !== undefined ? _data["hostContext"] : null as any;
            this.securityRuleSet = _data["securityRuleSet"] !== undefined ? _data["securityRuleSet"] : null as any;
        }
    }

    static fromJS(data: any): Assembly {
        data = typeof data === 'object' ? data : {};
        let result = new Assembly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definedTypes)) {
            data["definedTypes"] = [];
            for (let item of this.definedTypes)
                data["definedTypes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.exportedTypes)) {
            data["exportedTypes"] = [];
            for (let item of this.exportedTypes)
                data["exportedTypes"].push(item ? item.toJSON() : null as any);
        }
        data["codeBase"] = this.codeBase !== undefined ? this.codeBase : null as any;
        data["entryPoint"] = this.entryPoint ? this.entryPoint.toJSON() : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["imageRuntimeVersion"] = this.imageRuntimeVersion !== undefined ? this.imageRuntimeVersion : null as any;
        data["isDynamic"] = this.isDynamic !== undefined ? this.isDynamic : null as any;
        data["location"] = this.location !== undefined ? this.location : null as any;
        data["reflectionOnly"] = this.reflectionOnly !== undefined ? this.reflectionOnly : null as any;
        data["isCollectible"] = this.isCollectible !== undefined ? this.isCollectible : null as any;
        data["isFullyTrusted"] = this.isFullyTrusted !== undefined ? this.isFullyTrusted : null as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : null as any);
        }
        data["escapedCodeBase"] = this.escapedCodeBase !== undefined ? this.escapedCodeBase : null as any;
        data["manifestModule"] = this.manifestModule ? this.manifestModule.toJSON() : null as any;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item ? item.toJSON() : null as any);
        }
        data["globalAssemblyCache"] = this.globalAssemblyCache !== undefined ? this.globalAssemblyCache : null as any;
        data["hostContext"] = this.hostContext !== undefined ? this.hostContext : null as any;
        data["securityRuleSet"] = this.securityRuleSet !== undefined ? this.securityRuleSet : null as any;
        return data;
    }
}

export class AttachmentFileInfo {
    showName!: string | null;
    fieldId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.showName = _data["showName"] !== undefined ? _data["showName"] : null as any;
            this.fieldId = _data["fieldId"] !== undefined ? _data["fieldId"] : null as any;
        }
    }

    static fromJS(data: any): AttachmentFileInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentFileInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showName"] = this.showName !== undefined ? this.showName : null as any;
        data["fieldId"] = this.fieldId !== undefined ? this.fieldId : null as any;
        return data;
    }
}

export class AuthorizedCustomerInfoRequestDto {
    /** 客户名称 */
    finalCustomerName!: string | null;
    /** 二级客户代码 */
    finalCustomerCode!: string | null;
    /** 一级客户 */
    clienter!: string | null;
    /** 一级客户名称（冗余字段） */
    clientName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
        }
    }

    static fromJS(data: any): AuthorizedCustomerInfoRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizedCustomerInfoRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        return data;
    }
}

export class AuthorizedCustomerUserInfoOutPutDto {
    id!: string;
    userName!: string | null;
    /** 用户Id */
    userId!: number;
    /** 用户类型 */
    userType!: number;
    /** 是否默认 (1:默认) */
    isDefault!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.userType = _data["userType"] !== undefined ? _data["userType"] : null as any;
            this.isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : null as any;
        }
    }

    static fromJS(data: any): AuthorizedCustomerUserInfoOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizedCustomerUserInfoOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userType"] = this.userType !== undefined ? this.userType : null as any;
        data["isDefault"] = this.isDefault !== undefined ? this.isDefault : null as any;
        return data;
    }
}

export class AuthorizedUserCustomerInfoOutPutDto {
    id!: string;
    /** 二级客户名称 */
    finalCustomerName!: string | null;
    /** 二级客户代码 */
    finalCustomerCode!: string | null;
    /** 一级客户 */
    clienter!: string | null;
    /** 一级客户名称（冗余字段） */
    clientName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
        }
    }

    static fromJS(data: any): AuthorizedUserCustomerInfoOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizedUserCustomerInfoOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        return data;
    }
}

export class AuthorizedUserJINSenarioDto {
    /** 主键 */
    id!: string;
    /** 用户名称 */
    userName!: string | null;
    /** 用户Id */
    userId!: number;
    /** 用户类型 */
    userType!: number;
    /** 境界类型 */
    senarioType!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.userType = _data["userType"] !== undefined ? _data["userType"] : null as any;
            this.senarioType = _data["senarioType"] !== undefined ? _data["senarioType"] : null as any;
        }
    }

    static fromJS(data: any): AuthorizedUserJINSenarioDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizedUserJINSenarioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userType"] = this.userType !== undefined ? this.userType : null as any;
        data["senarioType"] = this.senarioType !== undefined ? this.senarioType : null as any;
        return data;
    }
}

export class AuthorizedUserJINSenarioRequestDto {
    /** 用户Id */
    userId!: number;
    /** 用户类型 */
    userType!: number;

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.userType = _data["userType"] !== undefined ? _data["userType"] : null as any;
        }
    }

    static fromJS(data: any): AuthorizedUserJINSenarioRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizedUserJINSenarioRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userType"] = this.userType !== undefined ? this.userType : null as any;
        return data;
    }
}

export class BasicMotorApplicableVcInputDto {
    /** 产品代码 */
    basicMotorCode!: string | null;
    /** 行业VC所属人 */
    industryVCOwners!: string[] | null;
    /** Vc编号 */
    vcs!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            if (Array.isArray(_data["industryVCOwners"])) {
                this.industryVCOwners = [] as any;
                for (let item of _data["industryVCOwners"])
                    this.industryVCOwners!.push(item);
            }
            else {
                this.industryVCOwners = null as any;
            }
            if (Array.isArray(_data["vcs"])) {
                this.vcs = [] as any;
                for (let item of _data["vcs"])
                    this.vcs!.push(item);
            }
            else {
                this.vcs = null as any;
            }
        }
    }

    static fromJS(data: any): BasicMotorApplicableVcInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicMotorApplicableVcInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        if (Array.isArray(this.industryVCOwners)) {
            data["industryVCOwners"] = [];
            for (let item of this.industryVCOwners)
                data["industryVCOwners"].push(item);
        }
        if (Array.isArray(this.vcs)) {
            data["vcs"] = [];
            for (let item of this.vcs)
                data["vcs"].push(item);
        }
        return data;
    }
}

export class BasicMotorApplicableVcOutputDto {
    /** 产品代码 */
    basicMotorCode!: string | null;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 机座号 */
    frameNo!: number;
    /** Vc编号 */
    vcs!: PageCheckVcRulesOutputDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            if (Array.isArray(_data["vcs"])) {
                this.vcs = [] as any;
                for (let item of _data["vcs"])
                    this.vcs!.push(PageCheckVcRulesOutputDto.fromJS(item));
            }
            else {
                this.vcs = null as any;
            }
        }
    }

    static fromJS(data: any): BasicMotorApplicableVcOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicMotorApplicableVcOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        if (Array.isArray(this.vcs)) {
            data["vcs"] = [];
            for (let item of this.vcs)
                data["vcs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 0 = Active (已发布) 1 = Inactive (待发布) 2 = Expired (已失效) 3 = OnlyShow (仅展示) */
export enum BasicMotorCodeStatus {
    Active = 0,
    Inactive = 1,
    Expired = 2,
    OnlyShow = 3,
}

/** 0 = Default 1 = Custom 2 = CustomerCode 3 = JIN */
export enum BasicMotorCodeType {
    Default = 0,
    Custom = 1,
    CustomerCode = 2,
    JIN = 3,
}

export class BasicMotorCompatibleInfo {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    matrix!: string | null;
    standardCodes!: string | null;
    preModifiedCodes!: string | null;
    basicMotorInfo!: BasicMotorInfo;
    basicMotorInfoId!: string;
    version!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.matrix = _data["matrix"] !== undefined ? _data["matrix"] : null as any;
            this.standardCodes = _data["standardCodes"] !== undefined ? _data["standardCodes"] : null as any;
            this.preModifiedCodes = _data["preModifiedCodes"] !== undefined ? _data["preModifiedCodes"] : null as any;
            this.basicMotorInfo = _data["basicMotorInfo"] ? BasicMotorInfo.fromJS(_data["basicMotorInfo"]) : null as any;
            this.basicMotorInfoId = _data["basicMotorInfoId"] !== undefined ? _data["basicMotorInfoId"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
        }
    }

    static fromJS(data: any): BasicMotorCompatibleInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BasicMotorCompatibleInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["matrix"] = this.matrix !== undefined ? this.matrix : null as any;
        data["standardCodes"] = this.standardCodes !== undefined ? this.standardCodes : null as any;
        data["preModifiedCodes"] = this.preModifiedCodes !== undefined ? this.preModifiedCodes : null as any;
        data["basicMotorInfo"] = this.basicMotorInfo ? this.basicMotorInfo.toJSON() : null as any;
        data["basicMotorInfoId"] = this.basicMotorInfoId !== undefined ? this.basicMotorInfoId : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        return data;
    }
}

export class BasicMotorCompatibleInfoDTO {
    matrix!: string[] | null;
    standard_codes!: string | null;
    pre_modified_codes!: string | null;
    motorcode!: string | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["matrix"])) {
                this.matrix = [] as any;
                for (let item of _data["matrix"])
                    this.matrix!.push(item);
            }
            else {
                this.matrix = null as any;
            }
            this.standard_codes = _data["standard_codes"] !== undefined ? _data["standard_codes"] : null as any;
            this.pre_modified_codes = _data["pre_modified_codes"] !== undefined ? _data["pre_modified_codes"] : null as any;
            this.motorcode = _data["motorcode"] !== undefined ? _data["motorcode"] : null as any;
        }
    }

    static fromJS(data: any): BasicMotorCompatibleInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BasicMotorCompatibleInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.matrix)) {
            data["matrix"] = [];
            for (let item of this.matrix)
                data["matrix"].push(item);
        }
        data["standard_codes"] = this.standard_codes !== undefined ? this.standard_codes : null as any;
        data["pre_modified_codes"] = this.pre_modified_codes !== undefined ? this.pre_modified_codes : null as any;
        data["motorcode"] = this.motorcode !== undefined ? this.motorcode : null as any;
        return data;
    }
}

export class BasicMotorCustomer {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    basicMotorInfoId!: string;
    customerCode!: string | null;
    customerName!: string | null;
    subCustomerCode!: string | null;
    subCustomerName!: string | null;
    basicMotorInfo!: BasicMotorInfo;
    seriesName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.basicMotorInfoId = _data["basicMotorInfoId"] !== undefined ? _data["basicMotorInfoId"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.subCustomerCode = _data["subCustomerCode"] !== undefined ? _data["subCustomerCode"] : null as any;
            this.subCustomerName = _data["subCustomerName"] !== undefined ? _data["subCustomerName"] : null as any;
            this.basicMotorInfo = _data["basicMotorInfo"] ? BasicMotorInfo.fromJS(_data["basicMotorInfo"]) : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
        }
    }

    static fromJS(data: any): BasicMotorCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new BasicMotorCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["basicMotorInfoId"] = this.basicMotorInfoId !== undefined ? this.basicMotorInfoId : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["subCustomerCode"] = this.subCustomerCode !== undefined ? this.subCustomerCode : null as any;
        data["subCustomerName"] = this.subCustomerName !== undefined ? this.subCustomerName : null as any;
        data["basicMotorInfo"] = this.basicMotorInfo ? this.basicMotorInfo.toJSON() : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        return data;
    }
}

export class BasicMotorCustomerOutPutDto {
    customerCode!: string | null;
    customerName!: string | null;
    subCustomerCode!: string | null;
    subCustomerName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.subCustomerCode = _data["subCustomerCode"] !== undefined ? _data["subCustomerCode"] : null as any;
            this.subCustomerName = _data["subCustomerName"] !== undefined ? _data["subCustomerName"] : null as any;
        }
    }

    static fromJS(data: any): BasicMotorCustomerOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicMotorCustomerOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["subCustomerCode"] = this.subCustomerCode !== undefined ? this.subCustomerCode : null as any;
        data["subCustomerName"] = this.subCustomerName !== undefined ? this.subCustomerName : null as any;
        return data;
    }
}

export class BasicMotorInfo {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    basicMotorCode!: string | null;
    basicMotorModel!: string | null;
    isHaveVc!: IsHaveVc;
    isNeedHeightOutput!: IsYes;
    clienter!: string | null;
    voltageCode!: string | null;
    basicMotorMounting!: string | null;
    frameNo!: number;
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    productionCycle!: number;
    testCycle!: number;
    capacityCycle!: number;
    grCycle!: number;
    inToOutCycle!: number;
    makeOrBuy!: string | null;
    product!: string | null;
    typeDesignation!: string | null;
    basicMotorSriesId!: number | null;
    basicMotorCompatibleInfoId!: string | null;
    cpCode!: string | null;
    capacityCycleUpdateTime!: moment.Moment | null;
    engineeringCycleUpdateTime!: moment.Moment | null;
    productionCycleUpdateTime!: moment.Moment | null;
    purchaseCycleUpdateTime!: moment.Moment | null;
    testCycleUpdateTime!: moment.Moment | null;
    grCycleUpdateTime!: moment.Moment | null;
    inToOutCycleUpdateTime!: moment.Moment | null;
    cpBasicMotorCode!: string | null;
    basicMotorSries!: BasicMotorSries;
    basicMotorParameters!: BasicMotorParameter[] | null;
    basicMotorCustomers!: BasicMotorCustomer[] | null;
    basicMotorCompatibleInfo!: BasicMotorCompatibleInfo;
    basicMotorCodeType!: BasicMotorCodeType;
    status!: BasicMotorCodeStatus;
    confirmStatus!: SyncConfirmStatus;
    isStandardCode!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.isHaveVc = _data["isHaveVc"] !== undefined ? _data["isHaveVc"] : null as any;
            this.isNeedHeightOutput = _data["isNeedHeightOutput"] !== undefined ? _data["isNeedHeightOutput"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.voltageCode = _data["voltageCode"] !== undefined ? _data["voltageCode"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.capacityCycle = _data["capacityCycle"] !== undefined ? _data["capacityCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.inToOutCycle = _data["inToOutCycle"] !== undefined ? _data["inToOutCycle"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.product = _data["product"] !== undefined ? _data["product"] : null as any;
            this.typeDesignation = _data["typeDesignation"] !== undefined ? _data["typeDesignation"] : null as any;
            this.basicMotorSriesId = _data["basicMotorSriesId"] !== undefined ? _data["basicMotorSriesId"] : null as any;
            this.basicMotorCompatibleInfoId = _data["basicMotorCompatibleInfoId"] !== undefined ? _data["basicMotorCompatibleInfoId"] : null as any;
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.capacityCycleUpdateTime = _data["capacityCycleUpdateTime"] ? moment(_data["capacityCycleUpdateTime"].toString()) : null as any;
            this.engineeringCycleUpdateTime = _data["engineeringCycleUpdateTime"] ? moment(_data["engineeringCycleUpdateTime"].toString()) : null as any;
            this.productionCycleUpdateTime = _data["productionCycleUpdateTime"] ? moment(_data["productionCycleUpdateTime"].toString()) : null as any;
            this.purchaseCycleUpdateTime = _data["purchaseCycleUpdateTime"] ? moment(_data["purchaseCycleUpdateTime"].toString()) : null as any;
            this.testCycleUpdateTime = _data["testCycleUpdateTime"] ? moment(_data["testCycleUpdateTime"].toString()) : null as any;
            this.grCycleUpdateTime = _data["grCycleUpdateTime"] ? moment(_data["grCycleUpdateTime"].toString()) : null as any;
            this.inToOutCycleUpdateTime = _data["inToOutCycleUpdateTime"] ? moment(_data["inToOutCycleUpdateTime"].toString()) : null as any;
            this.cpBasicMotorCode = _data["cpBasicMotorCode"] !== undefined ? _data["cpBasicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] ? BasicMotorSries.fromJS(_data["basicMotorSries"]) : null as any;
            if (Array.isArray(_data["basicMotorParameters"])) {
                this.basicMotorParameters = [] as any;
                for (let item of _data["basicMotorParameters"])
                    this.basicMotorParameters!.push(BasicMotorParameter.fromJS(item));
            }
            else {
                this.basicMotorParameters = null as any;
            }
            if (Array.isArray(_data["basicMotorCustomers"])) {
                this.basicMotorCustomers = [] as any;
                for (let item of _data["basicMotorCustomers"])
                    this.basicMotorCustomers!.push(BasicMotorCustomer.fromJS(item));
            }
            else {
                this.basicMotorCustomers = null as any;
            }
            this.basicMotorCompatibleInfo = _data["basicMotorCompatibleInfo"] ? BasicMotorCompatibleInfo.fromJS(_data["basicMotorCompatibleInfo"]) : null as any;
            this.basicMotorCodeType = _data["basicMotorCodeType"] !== undefined ? _data["basicMotorCodeType"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.confirmStatus = _data["confirmStatus"] !== undefined ? _data["confirmStatus"] : null as any;
            this.isStandardCode = _data["isStandardCode"] !== undefined ? _data["isStandardCode"] : null as any;
        }
    }

    static fromJS(data: any): BasicMotorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BasicMotorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["isHaveVc"] = this.isHaveVc !== undefined ? this.isHaveVc : null as any;
        data["isNeedHeightOutput"] = this.isNeedHeightOutput !== undefined ? this.isNeedHeightOutput : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["voltageCode"] = this.voltageCode !== undefined ? this.voltageCode : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["capacityCycle"] = this.capacityCycle !== undefined ? this.capacityCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["inToOutCycle"] = this.inToOutCycle !== undefined ? this.inToOutCycle : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["product"] = this.product !== undefined ? this.product : null as any;
        data["typeDesignation"] = this.typeDesignation !== undefined ? this.typeDesignation : null as any;
        data["basicMotorSriesId"] = this.basicMotorSriesId !== undefined ? this.basicMotorSriesId : null as any;
        data["basicMotorCompatibleInfoId"] = this.basicMotorCompatibleInfoId !== undefined ? this.basicMotorCompatibleInfoId : null as any;
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["capacityCycleUpdateTime"] = this.capacityCycleUpdateTime ? this.capacityCycleUpdateTime.toISOString() : null as any;
        data["engineeringCycleUpdateTime"] = this.engineeringCycleUpdateTime ? this.engineeringCycleUpdateTime.toISOString() : null as any;
        data["productionCycleUpdateTime"] = this.productionCycleUpdateTime ? this.productionCycleUpdateTime.toISOString() : null as any;
        data["purchaseCycleUpdateTime"] = this.purchaseCycleUpdateTime ? this.purchaseCycleUpdateTime.toISOString() : null as any;
        data["testCycleUpdateTime"] = this.testCycleUpdateTime ? this.testCycleUpdateTime.toISOString() : null as any;
        data["grCycleUpdateTime"] = this.grCycleUpdateTime ? this.grCycleUpdateTime.toISOString() : null as any;
        data["inToOutCycleUpdateTime"] = this.inToOutCycleUpdateTime ? this.inToOutCycleUpdateTime.toISOString() : null as any;
        data["cpBasicMotorCode"] = this.cpBasicMotorCode !== undefined ? this.cpBasicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries ? this.basicMotorSries.toJSON() : null as any;
        if (Array.isArray(this.basicMotorParameters)) {
            data["basicMotorParameters"] = [];
            for (let item of this.basicMotorParameters)
                data["basicMotorParameters"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.basicMotorCustomers)) {
            data["basicMotorCustomers"] = [];
            for (let item of this.basicMotorCustomers)
                data["basicMotorCustomers"].push(item ? item.toJSON() : null as any);
        }
        data["basicMotorCompatibleInfo"] = this.basicMotorCompatibleInfo ? this.basicMotorCompatibleInfo.toJSON() : null as any;
        data["basicMotorCodeType"] = this.basicMotorCodeType !== undefined ? this.basicMotorCodeType : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["confirmStatus"] = this.confirmStatus !== undefined ? this.confirmStatus : null as any;
        data["isStandardCode"] = this.isStandardCode !== undefined ? this.isStandardCode : null as any;
        return data;
    }
}

export class BasicMotorInfoCustomersOutPutDto {
    /** 编号 */
    id!: string;
    /** 主机代码 */
    basicMotorCode!: string | null;
    cpBasicMotorCode!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    basicMotorCodeType!: BasicMotorCodeType;
    isHaveVc!: IsHaveVc;
    /** 境界标识码 */
    jinCategoryCode!: string | null;
    customers!: BasicMotorCustomerOutPutDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.cpBasicMotorCode = _data["cpBasicMotorCode"] !== undefined ? _data["cpBasicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCodeType = _data["basicMotorCodeType"] !== undefined ? _data["basicMotorCodeType"] : null as any;
            this.isHaveVc = _data["isHaveVc"] !== undefined ? _data["isHaveVc"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(BasicMotorCustomerOutPutDto.fromJS(item));
            }
            else {
                this.customers = null as any;
            }
        }
    }

    static fromJS(data: any): BasicMotorInfoCustomersOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicMotorInfoCustomersOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["cpBasicMotorCode"] = this.cpBasicMotorCode !== undefined ? this.cpBasicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCodeType"] = this.basicMotorCodeType !== undefined ? this.basicMotorCodeType : null as any;
        data["isHaveVc"] = this.isHaveVc !== undefined ? this.isHaveVc : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class BasicMotorInfoDto {
    /** 主机代码 */
    basicMotorCode!: string | null;
    /** 机座号 */
    frameNo!: number;
    /** 电机系列 */
    basicMotorSries!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;

    init(_data?: any) {
        if (_data) {
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
        }
    }

    static fromJS(data: any): BasicMotorInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicMotorInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        return data;
    }
}

/** 0 = Params 1 = Code 2 = ItemNo */
export enum BasicMotorInfoSeachType {
    Params = 0,
    Code = 1,
    ItemNo = 2,
}

export class BasicMotorParameter {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    wiringMode!: string | null;
    frequency!: string | null;
    power!: string | null;
    poleNo!: string | null;
    eneEff!: string | null;
    encoder!: string | null;
    brake!: string | null;
    voltage!: string | null;
    basicMotorInfoId!: string;
    basicMotorInfo!: BasicMotorInfo;
    insulation!: string | null;
    safty!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.encoder = _data["encoder"] !== undefined ? _data["encoder"] : null as any;
            this.brake = _data["brake"] !== undefined ? _data["brake"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.basicMotorInfoId = _data["basicMotorInfoId"] !== undefined ? _data["basicMotorInfoId"] : null as any;
            this.basicMotorInfo = _data["basicMotorInfo"] ? BasicMotorInfo.fromJS(_data["basicMotorInfo"]) : null as any;
            this.insulation = _data["insulation"] !== undefined ? _data["insulation"] : null as any;
            this.safty = _data["safty"] !== undefined ? _data["safty"] : null as any;
        }
    }

    static fromJS(data: any): BasicMotorParameter {
        data = typeof data === 'object' ? data : {};
        let result = new BasicMotorParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["encoder"] = this.encoder !== undefined ? this.encoder : null as any;
        data["brake"] = this.brake !== undefined ? this.brake : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["basicMotorInfoId"] = this.basicMotorInfoId !== undefined ? this.basicMotorInfoId : null as any;
        data["basicMotorInfo"] = this.basicMotorInfo ? this.basicMotorInfo.toJSON() : null as any;
        data["insulation"] = this.insulation !== undefined ? this.insulation : null as any;
        data["safty"] = this.safty !== undefined ? this.safty : null as any;
        return data;
    }
}

export class BasicMotorParameterOutputDto {
    id!: string;
    wiringMode!: string | null;
    frequency!: string | null;
    power!: string | null;
    poleNo!: string | null;
    eneEff!: string | null;
    encoder!: string | null;
    brake!: string | null;
    voltage!: string | null;
    insulation!: string | null;
    safty!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.encoder = _data["encoder"] !== undefined ? _data["encoder"] : null as any;
            this.brake = _data["brake"] !== undefined ? _data["brake"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.insulation = _data["insulation"] !== undefined ? _data["insulation"] : null as any;
            this.safty = _data["safty"] !== undefined ? _data["safty"] : null as any;
        }
    }

    static fromJS(data: any): BasicMotorParameterOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicMotorParameterOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["encoder"] = this.encoder !== undefined ? this.encoder : null as any;
        data["brake"] = this.brake !== undefined ? this.brake : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["insulation"] = this.insulation !== undefined ? this.insulation : null as any;
        data["safty"] = this.safty !== undefined ? this.safty : null as any;
        return data;
    }
}

/** 主机查询可适用VC */
export class BasicMotorQueryApplicableVcInputDto {
    /** 产品代码 */
    basicMotorCodes!: string[] | null;
    /** 产品系列 */
    basicMotorSries!: string[] | null;
    /** 产品基座号 */
    frameNos!: number[] | null;
    /** Vc编号 */
    vcs!: string[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["basicMotorCodes"])) {
                this.basicMotorCodes = [] as any;
                for (let item of _data["basicMotorCodes"])
                    this.basicMotorCodes!.push(item);
            }
            else {
                this.basicMotorCodes = null as any;
            }
            if (Array.isArray(_data["basicMotorSries"])) {
                this.basicMotorSries = [] as any;
                for (let item of _data["basicMotorSries"])
                    this.basicMotorSries!.push(item);
            }
            else {
                this.basicMotorSries = null as any;
            }
            if (Array.isArray(_data["frameNos"])) {
                this.frameNos = [] as any;
                for (let item of _data["frameNos"])
                    this.frameNos!.push(item);
            }
            else {
                this.frameNos = null as any;
            }
            if (Array.isArray(_data["vcs"])) {
                this.vcs = [] as any;
                for (let item of _data["vcs"])
                    this.vcs!.push(item);
            }
            else {
                this.vcs = null as any;
            }
        }
    }

    static fromJS(data: any): BasicMotorQueryApplicableVcInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicMotorQueryApplicableVcInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.basicMotorCodes)) {
            data["basicMotorCodes"] = [];
            for (let item of this.basicMotorCodes)
                data["basicMotorCodes"].push(item);
        }
        if (Array.isArray(this.basicMotorSries)) {
            data["basicMotorSries"] = [];
            for (let item of this.basicMotorSries)
                data["basicMotorSries"].push(item);
        }
        if (Array.isArray(this.frameNos)) {
            data["frameNos"] = [];
            for (let item of this.frameNos)
                data["frameNos"].push(item);
        }
        if (Array.isArray(this.vcs)) {
            data["vcs"] = [];
            for (let item of this.vcs)
                data["vcs"].push(item);
        }
        return data;
    }
}

export class BasicMotorSries {
    id!: number;
    name!: string | null;
    level!: number;
    parentId!: number;
    hide!: boolean;
    isSynced!: boolean;
    sourceId!: string | null;
    sortOrder!: number;
    status!: number;
    lastModificationTime!: moment.Moment | null;
    isJINSeries!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.level = _data["level"] !== undefined ? _data["level"] : null as any;
            this.parentId = _data["parentId"] !== undefined ? _data["parentId"] : null as any;
            this.hide = _data["hide"] !== undefined ? _data["hide"] : null as any;
            this.isSynced = _data["isSynced"] !== undefined ? _data["isSynced"] : null as any;
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.isJINSeries = _data["isJINSeries"] !== undefined ? _data["isJINSeries"] : null as any;
        }
    }

    static fromJS(data: any): BasicMotorSries {
        data = typeof data === 'object' ? data : {};
        let result = new BasicMotorSries();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["level"] = this.level !== undefined ? this.level : null as any;
        data["parentId"] = this.parentId !== undefined ? this.parentId : null as any;
        data["hide"] = this.hide !== undefined ? this.hide : null as any;
        data["isSynced"] = this.isSynced !== undefined ? this.isSynced : null as any;
        data["sourceId"] = this.sourceId !== undefined ? this.sourceId : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["isJINSeries"] = this.isJINSeries !== undefined ? this.isJINSeries : null as any;
        return data;
    }
}

export class BasicMotorSriesInfoDto {
    id!: number;
    /** 主机名称 */
    name!: string | null;
    /** 层级 */
    level!: number;
    /** 父节点编号 */
    parentId!: number;
    /** 同级排序 */
    sortOrder!: number;
    /** 状态 */
    status!: number;
    /** 是否隐藏 */
    hide!: boolean;
    /** 是否来自同步 */
    isSynced!: boolean;
    /** 来源Id */
    sourceId!: string | null;
    /** 是否境界类型 */
    isJINSeries!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.level = _data["level"] !== undefined ? _data["level"] : null as any;
            this.parentId = _data["parentId"] !== undefined ? _data["parentId"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.hide = _data["hide"] !== undefined ? _data["hide"] : null as any;
            this.isSynced = _data["isSynced"] !== undefined ? _data["isSynced"] : null as any;
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : null as any;
            this.isJINSeries = _data["isJINSeries"] !== undefined ? _data["isJINSeries"] : null as any;
        }
    }

    static fromJS(data: any): BasicMotorSriesInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicMotorSriesInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["level"] = this.level !== undefined ? this.level : null as any;
        data["parentId"] = this.parentId !== undefined ? this.parentId : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["hide"] = this.hide !== undefined ? this.hide : null as any;
        data["isSynced"] = this.isSynced !== undefined ? this.isSynced : null as any;
        data["sourceId"] = this.sourceId !== undefined ? this.sourceId : null as any;
        data["isJINSeries"] = this.isJINSeries !== undefined ? this.isJINSeries : null as any;
        return data;
    }
}

export class BasicMotorSriesTreeDto {
    /** 编号 */
    id!: number;
    /** 主机名称 */
    name!: string | null;
    /** 层级 */
    level!: number;
    /** 父节点编号 */
    parentId!: number;
    /** 同级排序 */
    sortOrder!: number;
    /** 状态 */
    status!: number;
    /** 是否隐藏 */
    hide!: boolean;
    /** 是否来自同步 */
    isSynced!: boolean;
    /** 来源Id */
    sourceId!: string | null;
    /** 子节点列表信息 */
    subs!: BasicMotorSriesTreeDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.level = _data["level"] !== undefined ? _data["level"] : null as any;
            this.parentId = _data["parentId"] !== undefined ? _data["parentId"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.hide = _data["hide"] !== undefined ? _data["hide"] : null as any;
            this.isSynced = _data["isSynced"] !== undefined ? _data["isSynced"] : null as any;
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : null as any;
            if (Array.isArray(_data["subs"])) {
                this.subs = [] as any;
                for (let item of _data["subs"])
                    this.subs!.push(BasicMotorSriesTreeDto.fromJS(item));
            }
            else {
                this.subs = null as any;
            }
        }
    }

    static fromJS(data: any): BasicMotorSriesTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicMotorSriesTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["level"] = this.level !== undefined ? this.level : null as any;
        data["parentId"] = this.parentId !== undefined ? this.parentId : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["hide"] = this.hide !== undefined ? this.hide : null as any;
        data["isSynced"] = this.isSynced !== undefined ? this.isSynced : null as any;
        data["sourceId"] = this.sourceId !== undefined ? this.sourceId : null as any;
        if (Array.isArray(this.subs)) {
            data["subs"] = [];
            for (let item of this.subs)
                data["subs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 0 = Standard 1 = Custom 3 = Import */
export enum BasicMotorType {
    Standard = 0,
    Custom = 1,
    Import = 3,
}

/** 基础主机交期输出对象 */
export class BasicProductCycleOutput {
    id!: string;
    /** 创建日期 */
    creationTime!: moment.Moment;
    /** 创建人 */
    creatorUserId!: number | null;
    /** 产品组合编码 */
    productMixCode!: string;
    /** 主机代码 */
    basicMotorCode!: string | null;
    basicMotorSries!: string | null;
    basicMotorType!: BasicMotorType;
    /** 机座号 */
    frameNo!: number;
    /** 主机周期 */
    cycle!: number;
    /** 整机交期 */
    expectedDeliveryDate!: number;
    /** 工程周期（自然天） */
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    /** 采购周期（自然天） */
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    /** 生产周期（自然天） */
    productionCycle!: number;
    /** 测试周期（自然天） */
    testCycle!: number;
    /** 产能周期（自然天） */
    capacityCycle!: number;
    /** GR */
    grCycle!: number;
    /** 入库到出库时间 */
    inToOutCycle!: number;
    /** 主机包含的Vc交期 */
    vcs!: BasicProductCycleVcOutput[] | null;
    /** GCS帮助ID */
    gcsHelpProductId!: string | null;
    makeOrBuy!: string | null;
    /** 境界版本 */
    jinVersion!: string | null;
    /** 境界标识符 */
    jinCategoryCode!: string | null;
    /** 客户编码 */
    clienter!: string | null;
    basicMotorCodeType!: BasicMotorCodeType;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.productMixCode = _data["productMixCode"] !== undefined ? _data["productMixCode"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.basicMotorType = _data["basicMotorType"] !== undefined ? _data["basicMotorType"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.cycle = _data["cycle"] !== undefined ? _data["cycle"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.capacityCycle = _data["capacityCycle"] !== undefined ? _data["capacityCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.inToOutCycle = _data["inToOutCycle"] !== undefined ? _data["inToOutCycle"] : null as any;
            if (Array.isArray(_data["vcs"])) {
                this.vcs = [] as any;
                for (let item of _data["vcs"])
                    this.vcs!.push(BasicProductCycleVcOutput.fromJS(item));
            }
            else {
                this.vcs = null as any;
            }
            this.gcsHelpProductId = _data["gcsHelpProductId"] !== undefined ? _data["gcsHelpProductId"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.basicMotorCodeType = _data["basicMotorCodeType"] !== undefined ? _data["basicMotorCodeType"] : null as any;
        }
    }

    static fromJS(data: any): BasicProductCycleOutput {
        data = typeof data === 'object' ? data : {};
        let result = new BasicProductCycleOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["productMixCode"] = this.productMixCode !== undefined ? this.productMixCode : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["basicMotorType"] = this.basicMotorType !== undefined ? this.basicMotorType : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["cycle"] = this.cycle !== undefined ? this.cycle : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["capacityCycle"] = this.capacityCycle !== undefined ? this.capacityCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["inToOutCycle"] = this.inToOutCycle !== undefined ? this.inToOutCycle : null as any;
        if (Array.isArray(this.vcs)) {
            data["vcs"] = [];
            for (let item of this.vcs)
                data["vcs"].push(item ? item.toJSON() : null as any);
        }
        data["gcsHelpProductId"] = this.gcsHelpProductId !== undefined ? this.gcsHelpProductId : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["basicMotorCodeType"] = this.basicMotorCodeType !== undefined ? this.basicMotorCodeType : null as any;
        return data;
    }
}

/** 基础主机Vc交期输出对象 */
export class BasicProductCycleVcOutput {
    id!: string;
    /** 创建日期 */
    creationTime!: moment.Moment;
    /** 创建人 */
    creatorUserId!: number | null;
    /** Vc编号 */
    vcId!: string | null;
    vcType!: VcType;
    /** 工程周期（自然天） */
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    /** 采购周期（自然天） */
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    /** 生产周期（自然天） */
    productionCycle!: number;
    /** 测试周期（自然天） */
    testCycle!: number;
    /** 船检周期（自然天） */
    shipSurveyCycle!: number;
    /** GR */
    grCycle!: number;
    /** SCM周期（自然天，来自VC主数据子表，按VcID+FrameNo+产品系列匹配） */
    scmCycle!: number | null;
    /** 是否内含vc */
    isInside!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.vcId = _data["vcId"] !== undefined ? _data["vcId"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.scmCycle = _data["scmCycle"] !== undefined ? _data["scmCycle"] : null as any;
            this.isInside = _data["isInside"] !== undefined ? _data["isInside"] : null as any;
        }
    }

    static fromJS(data: any): BasicProductCycleVcOutput {
        data = typeof data === 'object' ? data : {};
        let result = new BasicProductCycleVcOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["vcId"] = this.vcId !== undefined ? this.vcId : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["scmCycle"] = this.scmCycle !== undefined ? this.scmCycle : null as any;
        data["isInside"] = this.isInside !== undefined ? this.isInside : null as any;
        return data;
    }
}

export class BatchAddCustomerInfoRequestDto {
    /** 客户名称 */
    finalCustomerName!: string | null;
    /** 二级客户代码 */
    finalCustomerCode!: string | null;
    /** 一级客户 */
    clienter!: string | null;
    /** 一级客户名称（冗余字段） */
    clientName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
        }
    }

    static fromJS(data: any): BatchAddCustomerInfoRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchAddCustomerInfoRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        return data;
    }
}

export class BatchAddCustomerRequestDto {
    customerInfos!: BatchAddCustomerInfoRequestDto[] | null;
    userInfos!: AddCustomerUserInfoRequestDto[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customerInfos"])) {
                this.customerInfos = [] as any;
                for (let item of _data["customerInfos"])
                    this.customerInfos!.push(BatchAddCustomerInfoRequestDto.fromJS(item));
            }
            else {
                this.customerInfos = null as any;
            }
            if (Array.isArray(_data["userInfos"])) {
                this.userInfos = [] as any;
                for (let item of _data["userInfos"])
                    this.userInfos!.push(AddCustomerUserInfoRequestDto.fromJS(item));
            }
            else {
                this.userInfos = null as any;
            }
        }
    }

    static fromJS(data: any): BatchAddCustomerRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchAddCustomerRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customerInfos)) {
            data["customerInfos"] = [];
            for (let item of this.customerInfos)
                data["customerInfos"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.userInfos)) {
            data["userInfos"] = [];
            for (let item of this.userInfos)
                data["userInfos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class BatchDeleteInputDto {
    ids!: string[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            else {
                this.ids = null as any;
            }
        }
    }

    static fromJS(data: any): BatchDeleteInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchDeleteInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export class BooleanStringListValueTuple {

    init(_data?: any) {
    }

    static fromJS(data: any): BooleanStringListValueTuple {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanStringListValueTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export class CPQuotedNeedHelpInPut {
    id!: string;
    remark!: string | null;
    products!: CPQuotedNeedHelpProductInPut[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(CPQuotedNeedHelpProductInPut.fromJS(item));
            }
            else {
                this.products = null as any;
            }
        }
    }

    static fromJS(data: any): CPQuotedNeedHelpInPut {
        data = typeof data === 'object' ? data : {};
        let result = new CPQuotedNeedHelpInPut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class CPQuotedNeedHelpProductInPut {
    id!: string;
    expectMultiplier!: number | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.expectMultiplier = _data["expectMultiplier"] !== undefined ? _data["expectMultiplier"] : null as any;
        }
    }

    static fromJS(data: any): CPQuotedNeedHelpProductInPut {
        data = typeof data === 'object' ? data : {};
        let result = new CPQuotedNeedHelpProductInPut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["expectMultiplier"] = this.expectMultiplier !== undefined ? this.expectMultiplier : null as any;
        return data;
    }
}

export class CallBackInput {
    precalID!: string | null;
    state!: number;
    readonly isApproved!: boolean;
    validityTill!: number;
    dateTime!: moment.Moment;

    init(_data?: any) {
        if (_data) {
            this.precalID = _data["precalID"] !== undefined ? _data["precalID"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            (this as any).isApproved = _data["isApproved"] !== undefined ? _data["isApproved"] : null as any;
            this.validityTill = _data["validityTill"] !== undefined ? _data["validityTill"] : null as any;
            this.dateTime = _data["dateTime"] ? moment(_data["dateTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): CallBackInput {
        data = typeof data === 'object' ? data : {};
        let result = new CallBackInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["precalID"] = this.precalID !== undefined ? this.precalID : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["isApproved"] = this.isApproved !== undefined ? this.isApproved : null as any;
        data["validityTill"] = this.validityTill !== undefined ? this.validityTill : null as any;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : null as any;
        return data;
    }
}

/** 1 = Standard 2 = VarArgs 3 = Any 32 = HasThis 64 = ExplicitThis */
export enum CallingConventions {
    Standard = 1,
    VarArgs = 2,
    Any = 3,
    HasThis = 32,
    ExplicitThis = 64,
}

export class Category {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    code!: number;
    meaning!: string | null;
    remark!: string | null;
    specific!: boolean;
    categoryCodes!: CategoryCode[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.specific = _data["specific"] !== undefined ? _data["specific"] : null as any;
            if (Array.isArray(_data["categoryCodes"])) {
                this.categoryCodes = [] as any;
                for (let item of _data["categoryCodes"])
                    this.categoryCodes!.push(CategoryCode.fromJS(item));
            }
            else {
                this.categoryCodes = null as any;
            }
        }
    }

    static fromJS(data: any): Category {
        data = typeof data === 'object' ? data : {};
        let result = new Category();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["specific"] = this.specific !== undefined ? this.specific : null as any;
        if (Array.isArray(this.categoryCodes)) {
            data["categoryCodes"] = [];
            for (let item of this.categoryCodes)
                data["categoryCodes"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class CategoryCode {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    code!: string | null;
    enable!: boolean;
    lockTime!: moment.Moment | null;
    categoryId!: string;
    category!: Category;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.enable = _data["enable"] !== undefined ? _data["enable"] : null as any;
            this.lockTime = _data["lockTime"] ? moment(_data["lockTime"].toString()) : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.category = _data["category"] ? Category.fromJS(_data["category"]) : null as any;
        }
    }

    static fromJS(data: any): CategoryCode {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["enable"] = this.enable !== undefined ? this.enable : null as any;
        data["lockTime"] = this.lockTime ? this.lockTime.toISOString() : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["category"] = this.category ? this.category.toJSON() : null as any;
        return data;
    }
}

export class CategoryCodeDto {
    id!: string;
    /** 编码 */
    code!: string | null;
    /** 启用 */
    enable!: boolean;
    /** 锁定时间 */
    lockTime!: moment.Moment | null;
    /** 修改人编号 */
    lastModifierUserId!: number | null;
    /** 修改人 */
    modifierUser!: string | null;
    /** 修改时间 */
    lastModificationTime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.enable = _data["enable"] !== undefined ? _data["enable"] : null as any;
            this.lockTime = _data["lockTime"] ? moment(_data["lockTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.modifierUser = _data["modifierUser"] !== undefined ? _data["modifierUser"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): CategoryCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["enable"] = this.enable !== undefined ? this.enable : null as any;
        data["lockTime"] = this.lockTime ? this.lockTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["modifierUser"] = this.modifierUser !== undefined ? this.modifierUser : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        return data;
    }
}

export class CategoryCodeDtoPagedResultDto {
    items!: CategoryCodeDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CategoryCodeDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): CategoryCodeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryCodeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class CategoryDto {
    id!: string;
    /** 代码 */
    code!: number;
    /** 含义 */
    meaning!: string | null;
    /** 是否为特殊品类 */
    specific!: boolean;
    /** 说明 */
    remark!: string | null;
    /** 使用次数 */
    usageCount!: number;
    /** 品类包含的编号集合 */
    categoryCodeDtos!: CategoryCodeDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.specific = _data["specific"] !== undefined ? _data["specific"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.usageCount = _data["usageCount"] !== undefined ? _data["usageCount"] : null as any;
            if (Array.isArray(_data["categoryCodeDtos"])) {
                this.categoryCodeDtos = [] as any;
                for (let item of _data["categoryCodeDtos"])
                    this.categoryCodeDtos!.push(CategoryCodeDto.fromJS(item));
            }
            else {
                this.categoryCodeDtos = null as any;
            }
        }
    }

    static fromJS(data: any): CategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["specific"] = this.specific !== undefined ? this.specific : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["usageCount"] = this.usageCount !== undefined ? this.usageCount : null as any;
        if (Array.isArray(this.categoryCodeDtos)) {
            data["categoryCodeDtos"] = [];
            for (let item of this.categoryCodeDtos)
                data["categoryCodeDtos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class CategoryDtoPagedResultDto {
    items!: CategoryDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CategoryDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): CategoryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class CcsCreateLectoTypeInputDto {
    name!: string | null;
    clientCode!: string | null;
    clientName!: string | null;
    shippingAddressCode!: string | null;
    shippingAddress!: string | null;
    saleEmail!: string | null;
    createrEmail!: string | null;
    helpUserEmail!: string | null;
    finalCustomerCode!: string | null;
    finalCustomerName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.clientCode = _data["clientCode"] !== undefined ? _data["clientCode"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.shippingAddressCode = _data["shippingAddressCode"] !== undefined ? _data["shippingAddressCode"] : null as any;
            this.shippingAddress = _data["shippingAddress"] !== undefined ? _data["shippingAddress"] : null as any;
            this.saleEmail = _data["saleEmail"] !== undefined ? _data["saleEmail"] : null as any;
            this.createrEmail = _data["createrEmail"] !== undefined ? _data["createrEmail"] : null as any;
            this.helpUserEmail = _data["helpUserEmail"] !== undefined ? _data["helpUserEmail"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
        }
    }

    static fromJS(data: any): CcsCreateLectoTypeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CcsCreateLectoTypeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["clientCode"] = this.clientCode !== undefined ? this.clientCode : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["shippingAddressCode"] = this.shippingAddressCode !== undefined ? this.shippingAddressCode : null as any;
        data["shippingAddress"] = this.shippingAddress !== undefined ? this.shippingAddress : null as any;
        data["saleEmail"] = this.saleEmail !== undefined ? this.saleEmail : null as any;
        data["createrEmail"] = this.createrEmail !== undefined ? this.createrEmail : null as any;
        data["helpUserEmail"] = this.helpUserEmail !== undefined ? this.helpUserEmail : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        return data;
    }
}

export class ChangeJINCodeInputDto {
    /** 选型产品 */
    lectoTypeProductId!: string;
    /** 境界代码 */
    jinMotorCode!: string | null;
    /** 境界版本号 */
    jinVersion!: string | null;
    /** 境界标识符 */
    jinCategoryCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.lectoTypeProductId = _data["lectoTypeProductId"] !== undefined ? _data["lectoTypeProductId"] : null as any;
            this.jinMotorCode = _data["jinMotorCode"] !== undefined ? _data["jinMotorCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
        }
    }

    static fromJS(data: any): ChangeJINCodeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeJINCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lectoTypeProductId"] = this.lectoTypeProductId !== undefined ? this.lectoTypeProductId : null as any;
        data["jinMotorCode"] = this.jinMotorCode !== undefined ? this.jinMotorCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        return data;
    }
}

/** 检查技术规范号产品对象 */
export class ChangeTeVcReamrkProductDto {
    id!: string;
    /** 产品代码 */
    basicMotorCode!: string | null;
    /** 境界标识符 */
    jinCategoryCode!: string | null;
    /** 境界版本 */
    jinVersion!: string | null;
    /** 技术规范号 */
    technicalSpecifications!: string | null;
    /** 是否增减了VC或改动了VC的备注信息导致技术协议发生了变动 */
    agreementChanges!: boolean;
    changeTeVcReamrkProductVCs!: ChangeTeVcReamrkProductVCDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.agreementChanges = _data["agreementChanges"] !== undefined ? _data["agreementChanges"] : null as any;
            if (Array.isArray(_data["changeTeVcReamrkProductVCs"])) {
                this.changeTeVcReamrkProductVCs = [] as any;
                for (let item of _data["changeTeVcReamrkProductVCs"])
                    this.changeTeVcReamrkProductVCs!.push(ChangeTeVcReamrkProductVCDto.fromJS(item));
            }
            else {
                this.changeTeVcReamrkProductVCs = null as any;
            }
        }
    }

    static fromJS(data: any): ChangeTeVcReamrkProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeTeVcReamrkProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["agreementChanges"] = this.agreementChanges !== undefined ? this.agreementChanges : null as any;
        if (Array.isArray(this.changeTeVcReamrkProductVCs)) {
            data["changeTeVcReamrkProductVCs"] = [];
            for (let item of this.changeTeVcReamrkProductVCs)
                data["changeTeVcReamrkProductVCs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 检查技术规范号产品VC对象 */
export class ChangeTeVcReamrkProductVCDto {
    /** VC编号 */
    vcCode!: string | null;
    /** 是否内含vc */
    isInside!: boolean | null;
    /** 备注 */
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.isInside = _data["isInside"] !== undefined ? _data["isInside"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): ChangeTeVcReamrkProductVCDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeTeVcReamrkProductVCDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["isInside"] = this.isInside !== undefined ? this.isInside : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

/** 检查自定义VC最新面价 */
export class CheckCustomVcListUnitPriceInputDto {
    /** 产品代码集合 */
    basicMotorCodes!: string[] | null;
    /** VC编号集合 */
    vcCodes!: string[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["basicMotorCodes"])) {
                this.basicMotorCodes = [] as any;
                for (let item of _data["basicMotorCodes"])
                    this.basicMotorCodes!.push(item);
            }
            else {
                this.basicMotorCodes = null as any;
            }
            if (Array.isArray(_data["vcCodes"])) {
                this.vcCodes = [] as any;
                for (let item of _data["vcCodes"])
                    this.vcCodes!.push(item);
            }
            else {
                this.vcCodes = null as any;
            }
        }
    }

    static fromJS(data: any): CheckCustomVcListUnitPriceInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckCustomVcListUnitPriceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.basicMotorCodes)) {
            data["basicMotorCodes"] = [];
            for (let item of this.basicMotorCodes)
                data["basicMotorCodes"].push(item);
        }
        if (Array.isArray(this.vcCodes)) {
            data["vcCodes"] = [];
            for (let item of this.vcCodes)
                data["vcCodes"].push(item);
        }
        return data;
    }
}

/** 自定义VC价格匹配返回 */
export class CheckCustomVcListUnitPriceOutputDto {
    /** VC ID */
    vcID!: string | null;
    /** 含义 */
    meaning!: string | null;
    /** 英文含义 */
    englishMeaning!: string | null;
    /** 产品代码 */
    basicMotorCode!: string | null;
    /** 产品型号 */
    basicMotorModel!: string | null;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 机座号 */
    frameNo!: number;
    /** 单价 */
    unitPrice!: number;
    /** 面价公式 */
    unitPriceFormula!: string | null;
    unitPriceType!: UnitPriceType;
    /** 打折类型 */
    readonly unitPriceTypeString!: string | null;
    /** 成本 */
    cost!: number | null;
    /** 成本公式 */
    costFormula!: string | null;
    costType!: CostType;
    /** 成本类型 */
    readonly costTypeString!: string | null;
    /** 成本类型详情 */
    costTypeDetail!: string | null;
    /** 报价原则 */
    quotationPrinciple!: string | null;
    /** 报价原则详情 */
    quotationPrincipleDetails!: string | null;

    init(_data?: any) {
        if (_data) {
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            (this as any).unitPriceTypeString = _data["unitPriceTypeString"] !== undefined ? _data["unitPriceTypeString"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            (this as any).costTypeString = _data["costTypeString"] !== undefined ? _data["costTypeString"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
        }
    }

    static fromJS(data: any): CheckCustomVcListUnitPriceOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckCustomVcListUnitPriceOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["unitPriceTypeString"] = this.unitPriceTypeString !== undefined ? this.unitPriceTypeString : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeString"] = this.costTypeString !== undefined ? this.costTypeString : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        return data;
    }
}

/** 检查行业VC最新面价 */
export class CheckIndustryVcListUnitPriceInputDto {
    /** 产品代码集合 */
    basicMotorCodes!: string[] | null;
    /** VC编号集合 */
    vcCodes!: string[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["basicMotorCodes"])) {
                this.basicMotorCodes = [] as any;
                for (let item of _data["basicMotorCodes"])
                    this.basicMotorCodes!.push(item);
            }
            else {
                this.basicMotorCodes = null as any;
            }
            if (Array.isArray(_data["vcCodes"])) {
                this.vcCodes = [] as any;
                for (let item of _data["vcCodes"])
                    this.vcCodes!.push(item);
            }
            else {
                this.vcCodes = null as any;
            }
        }
    }

    static fromJS(data: any): CheckIndustryVcListUnitPriceInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckIndustryVcListUnitPriceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.basicMotorCodes)) {
            data["basicMotorCodes"] = [];
            for (let item of this.basicMotorCodes)
                data["basicMotorCodes"].push(item);
        }
        if (Array.isArray(this.vcCodes)) {
            data["vcCodes"] = [];
            for (let item of this.vcCodes)
                data["vcCodes"].push(item);
        }
        return data;
    }
}

/** 检查行业VC最新面价返回 */
export class CheckIndustryVcListUnitPriceOutputDto {
    /** VC ID */
    vcID!: string | null;
    /** 含义 */
    meaning!: string | null;
    /** 英文含义 */
    englishMeaning!: string | null;
    /** 产品代码 */
    basicMotorCode!: string | null;
    /** 产品型号 */
    basicMotorModel!: string | null;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 机座号 */
    frameNo!: number;
    /** 单价 */
    unitPrice!: number;
    /** 面价公式 */
    unitPriceFormula!: string | null;
    unitPriceType!: UnitPriceType;
    /** 打折类型 */
    readonly unitPriceTypeString!: string | null;
    /** 成本 */
    cost!: number | null;
    /** 成本公式 */
    costFormula!: string | null;
    costType!: CostType;
    /** 成本类型 */
    readonly costTypeString!: string | null;
    /** 成本类型详情 */
    costTypeDetail!: string | null;
    /** 报价原则 */
    quotationPrinciple!: string | null;
    /** 报价原则详情 */
    quotationPrincipleDetails!: string | null;

    init(_data?: any) {
        if (_data) {
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            (this as any).unitPriceTypeString = _data["unitPriceTypeString"] !== undefined ? _data["unitPriceTypeString"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            (this as any).costTypeString = _data["costTypeString"] !== undefined ? _data["costTypeString"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
        }
    }

    static fromJS(data: any): CheckIndustryVcListUnitPriceOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckIndustryVcListUnitPriceOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["unitPriceTypeString"] = this.unitPriceTypeString !== undefined ? this.unitPriceTypeString : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeString"] = this.costTypeString !== undefined ? this.costTypeString : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        return data;
    }
}

export class CheckMessage {
    vcConstraintType!: VCConstraintTypeEnum;
    mainVC!: string | null;
    msg!: string | null;
    relVcIds!: string[] | null;
    sourceType!: CheckRuleSoureEnum;

    init(_data?: any) {
        if (_data) {
            this.vcConstraintType = _data["vcConstraintType"] !== undefined ? _data["vcConstraintType"] : null as any;
            this.mainVC = _data["mainVC"] !== undefined ? _data["mainVC"] : null as any;
            this.msg = _data["msg"] !== undefined ? _data["msg"] : null as any;
            if (Array.isArray(_data["relVcIds"])) {
                this.relVcIds = [] as any;
                for (let item of _data["relVcIds"])
                    this.relVcIds!.push(item);
            }
            else {
                this.relVcIds = null as any;
            }
            this.sourceType = _data["sourceType"] !== undefined ? _data["sourceType"] : null as any;
        }
    }

    static fromJS(data: any): CheckMessage {
        data = typeof data === 'object' ? data : {};
        let result = new CheckMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcConstraintType"] = this.vcConstraintType !== undefined ? this.vcConstraintType : null as any;
        data["mainVC"] = this.mainVC !== undefined ? this.mainVC : null as any;
        data["msg"] = this.msg !== undefined ? this.msg : null as any;
        if (Array.isArray(this.relVcIds)) {
            data["relVcIds"] = [];
            for (let item of this.relVcIds)
                data["relVcIds"].push(item);
        }
        data["sourceType"] = this.sourceType !== undefined ? this.sourceType : null as any;
        return data;
    }
}

export class CheckResultOutput {
    productId!: string;
    ruleSource!: RuleSource;
    ruleNo!: RuleNo;
    readonly result!: number;
    unavaliable!: string[] | null;
    redundant!: string[] | null;
    incompatible!: Incompatible[] | null;
    required!: string[] | null;
    resolvable!: Resolvable[] | null;
    freetext!: Freetext[] | null;
    prodtech!: Prodtech[] | null;
    prodElec!: Prodelec[] | null;
    selectOrInput!: SelectOrInput[] | null;
    warn!: string[] | null;
    error!: string[] | null;
    vcConstraintInfo!: CheckMessage[] | null;

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"] !== undefined ? _data["productId"] : null as any;
            this.ruleSource = _data["ruleSource"] !== undefined ? _data["ruleSource"] : null as any;
            this.ruleNo = _data["ruleNo"] !== undefined ? _data["ruleNo"] : null as any;
            (this as any).result = _data["result"] !== undefined ? _data["result"] : null as any;
            if (Array.isArray(_data["unavaliable"])) {
                this.unavaliable = [] as any;
                for (let item of _data["unavaliable"])
                    this.unavaliable!.push(item);
            }
            else {
                this.unavaliable = null as any;
            }
            if (Array.isArray(_data["redundant"])) {
                this.redundant = [] as any;
                for (let item of _data["redundant"])
                    this.redundant!.push(item);
            }
            else {
                this.redundant = null as any;
            }
            if (Array.isArray(_data["incompatible"])) {
                this.incompatible = [] as any;
                for (let item of _data["incompatible"])
                    this.incompatible!.push(Incompatible.fromJS(item));
            }
            else {
                this.incompatible = null as any;
            }
            if (Array.isArray(_data["required"])) {
                this.required = [] as any;
                for (let item of _data["required"])
                    this.required!.push(item);
            }
            else {
                this.required = null as any;
            }
            if (Array.isArray(_data["resolvable"])) {
                this.resolvable = [] as any;
                for (let item of _data["resolvable"])
                    this.resolvable!.push(Resolvable.fromJS(item));
            }
            else {
                this.resolvable = null as any;
            }
            if (Array.isArray(_data["freetext"])) {
                this.freetext = [] as any;
                for (let item of _data["freetext"])
                    this.freetext!.push(Freetext.fromJS(item));
            }
            else {
                this.freetext = null as any;
            }
            if (Array.isArray(_data["prodtech"])) {
                this.prodtech = [] as any;
                for (let item of _data["prodtech"])
                    this.prodtech!.push(Prodtech.fromJS(item));
            }
            else {
                this.prodtech = null as any;
            }
            if (Array.isArray(_data["prodElec"])) {
                this.prodElec = [] as any;
                for (let item of _data["prodElec"])
                    this.prodElec!.push(Prodelec.fromJS(item));
            }
            else {
                this.prodElec = null as any;
            }
            if (Array.isArray(_data["selectOrInput"])) {
                this.selectOrInput = [] as any;
                for (let item of _data["selectOrInput"])
                    this.selectOrInput!.push(SelectOrInput.fromJS(item));
            }
            else {
                this.selectOrInput = null as any;
            }
            if (Array.isArray(_data["warn"])) {
                this.warn = [] as any;
                for (let item of _data["warn"])
                    this.warn!.push(item);
            }
            else {
                this.warn = null as any;
            }
            if (Array.isArray(_data["error"])) {
                this.error = [] as any;
                for (let item of _data["error"])
                    this.error!.push(item);
            }
            else {
                this.error = null as any;
            }
            if (Array.isArray(_data["vcConstraintInfo"])) {
                this.vcConstraintInfo = [] as any;
                for (let item of _data["vcConstraintInfo"])
                    this.vcConstraintInfo!.push(CheckMessage.fromJS(item));
            }
            else {
                this.vcConstraintInfo = null as any;
            }
        }
    }

    static fromJS(data: any): CheckResultOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId !== undefined ? this.productId : null as any;
        data["ruleSource"] = this.ruleSource !== undefined ? this.ruleSource : null as any;
        data["ruleNo"] = this.ruleNo !== undefined ? this.ruleNo : null as any;
        data["result"] = this.result !== undefined ? this.result : null as any;
        if (Array.isArray(this.unavaliable)) {
            data["unavaliable"] = [];
            for (let item of this.unavaliable)
                data["unavaliable"].push(item);
        }
        if (Array.isArray(this.redundant)) {
            data["redundant"] = [];
            for (let item of this.redundant)
                data["redundant"].push(item);
        }
        if (Array.isArray(this.incompatible)) {
            data["incompatible"] = [];
            for (let item of this.incompatible)
                data["incompatible"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.required)) {
            data["required"] = [];
            for (let item of this.required)
                data["required"].push(item);
        }
        if (Array.isArray(this.resolvable)) {
            data["resolvable"] = [];
            for (let item of this.resolvable)
                data["resolvable"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.freetext)) {
            data["freetext"] = [];
            for (let item of this.freetext)
                data["freetext"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.prodtech)) {
            data["prodtech"] = [];
            for (let item of this.prodtech)
                data["prodtech"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.prodElec)) {
            data["prodElec"] = [];
            for (let item of this.prodElec)
                data["prodElec"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectOrInput)) {
            data["selectOrInput"] = [];
            for (let item of this.selectOrInput)
                data["selectOrInput"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.warn)) {
            data["warn"] = [];
            for (let item of this.warn)
                data["warn"].push(item);
        }
        if (Array.isArray(this.error)) {
            data["error"] = [];
            for (let item of this.error)
                data["error"].push(item);
        }
        if (Array.isArray(this.vcConstraintInfo)) {
            data["vcConstraintInfo"] = [];
            for (let item of this.vcConstraintInfo)
                data["vcConstraintInfo"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class CheckRuleDto {
    id!: string;
    vcID!: string | null;
    vcShowType!: VCShowType;
    attributeName!: string | null;
    attributeSelect!: string | null;
    frameNo!: number;
    basicMotorSries!: string | null;
    mainVC!: string | null;
    scmCycle!: number | null;
    scmCalculationMode!: string | null;
    scmRemark!: string | null;
    extraOverlayTime!: boolean | null;
    isOverlayLogic!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.attributeName = _data["attributeName"] !== undefined ? _data["attributeName"] : null as any;
            this.attributeSelect = _data["attributeSelect"] !== undefined ? _data["attributeSelect"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.mainVC = _data["mainVC"] !== undefined ? _data["mainVC"] : null as any;
            this.scmCycle = _data["scmCycle"] !== undefined ? _data["scmCycle"] : null as any;
            this.scmCalculationMode = _data["scmCalculationMode"] !== undefined ? _data["scmCalculationMode"] : null as any;
            this.scmRemark = _data["scmRemark"] !== undefined ? _data["scmRemark"] : null as any;
            this.extraOverlayTime = _data["extraOverlayTime"] !== undefined ? _data["extraOverlayTime"] : null as any;
            this.isOverlayLogic = _data["isOverlayLogic"] !== undefined ? _data["isOverlayLogic"] : null as any;
        }
    }

    static fromJS(data: any): CheckRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["attributeName"] = this.attributeName !== undefined ? this.attributeName : null as any;
        data["attributeSelect"] = this.attributeSelect !== undefined ? this.attributeSelect : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["mainVC"] = this.mainVC !== undefined ? this.mainVC : null as any;
        data["scmCycle"] = this.scmCycle !== undefined ? this.scmCycle : null as any;
        data["scmCalculationMode"] = this.scmCalculationMode !== undefined ? this.scmCalculationMode : null as any;
        data["scmRemark"] = this.scmRemark !== undefined ? this.scmRemark : null as any;
        data["extraOverlayTime"] = this.extraOverlayTime !== undefined ? this.extraOverlayTime : null as any;
        data["isOverlayLogic"] = this.isOverlayLogic !== undefined ? this.isOverlayLogic : null as any;
        return data;
    }
}

/** 0 = None 1 = MotorNotSupportVCSelection (MotorNotSupportVCSelection) 2 = NumberWiresCheckRules (NumberWiresCheckRules) 3 = SingleVCNotificationRules (SingleVCNotificationRules) 4 = VCGroupRules (VCGroupRules) 5 = DoubleVCCheckRules (DoubleVCCheckRules) 6 = MotorizerRules (MotorizerRules) 7 = OCTOpenVCRules (OCTOpenVCRules) 8 = CustomRule (CustomRule) 9 = MotorCustomerRule (MotorCustomerRule) 10 = MotorAndVcValidityCheck (MotorAndVcValidityCheck) */
export enum CheckRuleSoureEnum {
    None = 0,
    MotorNotSupportVCSelection = 1,
    NumberWiresCheckRules = 2,
    SingleVCNotificationRules = 3,
    VCGroupRules = 4,
    DoubleVCCheckRules = 5,
    MotorizerRules = 6,
    OCTOpenVCRules = 7,
    CustomRule = 8,
    MotorCustomerRule = 9,
    MotorAndVcValidityCheck = 10,
}

export class CheckVcRuleDto {
    /** VC ID */
    vcID!: string | null;
    vcShowType!: VCShowType;
    /** 属性名 */
    attributeName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.attributeName = _data["attributeName"] !== undefined ? _data["attributeName"] : null as any;
        }
    }

    static fromJS(data: any): CheckVcRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckVcRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["attributeName"] = this.attributeName !== undefined ? this.attributeName : null as any;
        return data;
    }
}

export class Claim {
    readonly issuer!: string | null;
    readonly originalIssuer!: string | null;
    readonly properties!: { [key: string]: string; } | null;
    subject!: ClaimsIdentity;
    readonly type!: string | null;
    readonly value!: string | null;
    readonly valueType!: string | null;

    init(_data?: any) {
        if (_data) {
            (this as any).issuer = _data["issuer"] !== undefined ? _data["issuer"] : null as any;
            (this as any).originalIssuer = _data["originalIssuer"] !== undefined ? _data["originalIssuer"] : null as any;
            if (_data["properties"]) {
                (this as any).properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        ((this as any).properties as any)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : null as any;
                }
            }
            else {
                (this as any).properties = null as any;
            }
            this.subject = _data["subject"] ? ClaimsIdentity.fromJS(_data["subject"]) : null as any;
            (this as any).type = _data["type"] !== undefined ? _data["type"] : null as any;
            (this as any).value = _data["value"] !== undefined ? _data["value"] : null as any;
            (this as any).valueType = _data["valueType"] !== undefined ? _data["valueType"] : null as any;
        }
    }

    static fromJS(data: any): Claim {
        data = typeof data === 'object' ? data : {};
        let result = new Claim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuer"] = this.issuer !== undefined ? this.issuer : null as any;
        data["originalIssuer"] = this.originalIssuer !== undefined ? this.originalIssuer : null as any;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (data["properties"] as any)[key] = this.properties[key] !== undefined ? this.properties[key] : null as any;
            }
        }
        data["subject"] = this.subject ? this.subject.toJSON() : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["valueType"] = this.valueType !== undefined ? this.valueType : null as any;
        return data;
    }
}

export class ClaimsIdentity {
    readonly authenticationType!: string | null;
    readonly isAuthenticated!: boolean;
    actor!: ClaimsIdentity;
    bootstrapContext!: any | null;
    readonly claims!: Claim[] | null;
    label!: string | null;
    readonly name!: string | null;
    readonly nameClaimType!: string | null;
    readonly roleClaimType!: string | null;

    init(_data?: any) {
        if (_data) {
            (this as any).authenticationType = _data["authenticationType"] !== undefined ? _data["authenticationType"] : null as any;
            (this as any).isAuthenticated = _data["isAuthenticated"] !== undefined ? _data["isAuthenticated"] : null as any;
            this.actor = _data["actor"] ? ClaimsIdentity.fromJS(_data["actor"]) : null as any;
            this.bootstrapContext = _data["bootstrapContext"] !== undefined ? _data["bootstrapContext"] : null as any;
            if (Array.isArray(_data["claims"])) {
                (this as any).claims = [] as any;
                for (let item of _data["claims"])
                    (this as any).claims!.push(Claim.fromJS(item));
            }
            else {
                (this as any).claims = null as any;
            }
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            (this as any).name = _data["name"] !== undefined ? _data["name"] : null as any;
            (this as any).nameClaimType = _data["nameClaimType"] !== undefined ? _data["nameClaimType"] : null as any;
            (this as any).roleClaimType = _data["roleClaimType"] !== undefined ? _data["roleClaimType"] : null as any;
        }
    }

    static fromJS(data: any): ClaimsIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authenticationType"] = this.authenticationType !== undefined ? this.authenticationType : null as any;
        data["isAuthenticated"] = this.isAuthenticated !== undefined ? this.isAuthenticated : null as any;
        data["actor"] = this.actor ? this.actor.toJSON() : null as any;
        data["bootstrapContext"] = this.bootstrapContext !== undefined ? this.bootstrapContext : null as any;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item ? item.toJSON() : null as any);
        }
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["nameClaimType"] = this.nameClaimType !== undefined ? this.nameClaimType : null as any;
        data["roleClaimType"] = this.roleClaimType !== undefined ? this.roleClaimType : null as any;
        return data;
    }
}

export class ClienterAndFinalCustomerDto {
    /** 一级客户代码 */
    clienter!: string | null;
    /** 二级客户代码 */
    finalCustomerCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
        }
    }

    static fromJS(data: any): ClienterAndFinalCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClienterAndFinalCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        return data;
    }
}

export class ConstructorInfo {
    readonly name!: string | null;
    declaringType!: Type;
    reflectedType!: Type;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | null;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    attributes!: MethodAttributes;
    methodImplementationFlags!: MethodImplAttributes;
    callingConvention!: CallingConventions;
    readonly isAbstract!: boolean;
    readonly isConstructor!: boolean;
    readonly isFinal!: boolean;
    readonly isHideBySig!: boolean;
    readonly isSpecialName!: boolean;
    readonly isStatic!: boolean;
    readonly isVirtual!: boolean;
    readonly isAssembly!: boolean;
    readonly isFamily!: boolean;
    readonly isFamilyAndAssembly!: boolean;
    readonly isFamilyOrAssembly!: boolean;
    readonly isPrivate!: boolean;
    readonly isPublic!: boolean;
    readonly isConstructedGenericMethod!: boolean;
    readonly isGenericMethod!: boolean;
    readonly isGenericMethodDefinition!: boolean;
    readonly containsGenericParameters!: boolean;
    methodHandle!: RuntimeMethodHandle;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    memberType!: MemberTypes;

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : null as any;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : null as any;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : null as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            else {
                (this as any).customAttributes = null as any;
            }
            (this as any).isCollectible = _data["isCollectible"] !== undefined ? _data["isCollectible"] : null as any;
            (this as any).metadataToken = _data["metadataToken"] !== undefined ? _data["metadataToken"] : null as any;
            this.attributes = _data["attributes"] !== undefined ? _data["attributes"] : null as any;
            this.methodImplementationFlags = _data["methodImplementationFlags"] !== undefined ? _data["methodImplementationFlags"] : null as any;
            this.callingConvention = _data["callingConvention"] !== undefined ? _data["callingConvention"] : null as any;
            (this as any).isAbstract = _data["isAbstract"] !== undefined ? _data["isAbstract"] : null as any;
            (this as any).isConstructor = _data["isConstructor"] !== undefined ? _data["isConstructor"] : null as any;
            (this as any).isFinal = _data["isFinal"] !== undefined ? _data["isFinal"] : null as any;
            (this as any).isHideBySig = _data["isHideBySig"] !== undefined ? _data["isHideBySig"] : null as any;
            (this as any).isSpecialName = _data["isSpecialName"] !== undefined ? _data["isSpecialName"] : null as any;
            (this as any).isStatic = _data["isStatic"] !== undefined ? _data["isStatic"] : null as any;
            (this as any).isVirtual = _data["isVirtual"] !== undefined ? _data["isVirtual"] : null as any;
            (this as any).isAssembly = _data["isAssembly"] !== undefined ? _data["isAssembly"] : null as any;
            (this as any).isFamily = _data["isFamily"] !== undefined ? _data["isFamily"] : null as any;
            (this as any).isFamilyAndAssembly = _data["isFamilyAndAssembly"] !== undefined ? _data["isFamilyAndAssembly"] : null as any;
            (this as any).isFamilyOrAssembly = _data["isFamilyOrAssembly"] !== undefined ? _data["isFamilyOrAssembly"] : null as any;
            (this as any).isPrivate = _data["isPrivate"] !== undefined ? _data["isPrivate"] : null as any;
            (this as any).isPublic = _data["isPublic"] !== undefined ? _data["isPublic"] : null as any;
            (this as any).isConstructedGenericMethod = _data["isConstructedGenericMethod"] !== undefined ? _data["isConstructedGenericMethod"] : null as any;
            (this as any).isGenericMethod = _data["isGenericMethod"] !== undefined ? _data["isGenericMethod"] : null as any;
            (this as any).isGenericMethodDefinition = _data["isGenericMethodDefinition"] !== undefined ? _data["isGenericMethodDefinition"] : null as any;
            (this as any).containsGenericParameters = _data["containsGenericParameters"] !== undefined ? _data["containsGenericParameters"] : null as any;
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : null as any;
            (this as any).isSecurityCritical = _data["isSecurityCritical"] !== undefined ? _data["isSecurityCritical"] : null as any;
            (this as any).isSecuritySafeCritical = _data["isSecuritySafeCritical"] !== undefined ? _data["isSecuritySafeCritical"] : null as any;
            (this as any).isSecurityTransparent = _data["isSecurityTransparent"] !== undefined ? _data["isSecurityTransparent"] : null as any;
            this.memberType = _data["memberType"] !== undefined ? _data["memberType"] : null as any;
        }
    }

    static fromJS(data: any): ConstructorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : null as any;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : null as any;
        data["module"] = this.module ? this.module.toJSON() : null as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : null as any);
        }
        data["isCollectible"] = this.isCollectible !== undefined ? this.isCollectible : null as any;
        data["metadataToken"] = this.metadataToken !== undefined ? this.metadataToken : null as any;
        data["attributes"] = this.attributes !== undefined ? this.attributes : null as any;
        data["methodImplementationFlags"] = this.methodImplementationFlags !== undefined ? this.methodImplementationFlags : null as any;
        data["callingConvention"] = this.callingConvention !== undefined ? this.callingConvention : null as any;
        data["isAbstract"] = this.isAbstract !== undefined ? this.isAbstract : null as any;
        data["isConstructor"] = this.isConstructor !== undefined ? this.isConstructor : null as any;
        data["isFinal"] = this.isFinal !== undefined ? this.isFinal : null as any;
        data["isHideBySig"] = this.isHideBySig !== undefined ? this.isHideBySig : null as any;
        data["isSpecialName"] = this.isSpecialName !== undefined ? this.isSpecialName : null as any;
        data["isStatic"] = this.isStatic !== undefined ? this.isStatic : null as any;
        data["isVirtual"] = this.isVirtual !== undefined ? this.isVirtual : null as any;
        data["isAssembly"] = this.isAssembly !== undefined ? this.isAssembly : null as any;
        data["isFamily"] = this.isFamily !== undefined ? this.isFamily : null as any;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly !== undefined ? this.isFamilyAndAssembly : null as any;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly !== undefined ? this.isFamilyOrAssembly : null as any;
        data["isPrivate"] = this.isPrivate !== undefined ? this.isPrivate : null as any;
        data["isPublic"] = this.isPublic !== undefined ? this.isPublic : null as any;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod !== undefined ? this.isConstructedGenericMethod : null as any;
        data["isGenericMethod"] = this.isGenericMethod !== undefined ? this.isGenericMethod : null as any;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition !== undefined ? this.isGenericMethodDefinition : null as any;
        data["containsGenericParameters"] = this.containsGenericParameters !== undefined ? this.containsGenericParameters : null as any;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : null as any;
        data["isSecurityCritical"] = this.isSecurityCritical !== undefined ? this.isSecurityCritical : null as any;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical !== undefined ? this.isSecuritySafeCritical : null as any;
        data["isSecurityTransparent"] = this.isSecurityTransparent !== undefined ? this.isSecurityTransparent : null as any;
        data["memberType"] = this.memberType !== undefined ? this.memberType : null as any;
        return data;
    }
}

export class ContractReviewCostInput {
    appId!: string | null;
    contractreviewCode!: string | null;
    customerID!: string | null;
    mdmCode!: string | null;
    cost!: number;
    modelCost!: number;
    unit!: number;
    status!: string | null;
    validDate!: string | null;
    descriptionCH!: string | null;
    descriptionEN!: string | null;

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"] !== undefined ? _data["appId"] : null as any;
            this.contractreviewCode = _data["contractreviewCode"] !== undefined ? _data["contractreviewCode"] : null as any;
            this.customerID = _data["customerID"] !== undefined ? _data["customerID"] : null as any;
            this.mdmCode = _data["mdmCode"] !== undefined ? _data["mdmCode"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.modelCost = _data["modelCost"] !== undefined ? _data["modelCost"] : null as any;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.validDate = _data["validDate"] !== undefined ? _data["validDate"] : null as any;
            this.descriptionCH = _data["descriptionCH"] !== undefined ? _data["descriptionCH"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
        }
    }

    static fromJS(data: any): ContractReviewCostInput {
        data = typeof data === 'object' ? data : {};
        let result = new ContractReviewCostInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId !== undefined ? this.appId : null as any;
        data["contractreviewCode"] = this.contractreviewCode !== undefined ? this.contractreviewCode : null as any;
        data["customerID"] = this.customerID !== undefined ? this.customerID : null as any;
        data["mdmCode"] = this.mdmCode !== undefined ? this.mdmCode : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["modelCost"] = this.modelCost !== undefined ? this.modelCost : null as any;
        data["unit"] = this.unit !== undefined ? this.unit : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["validDate"] = this.validDate !== undefined ? this.validDate : null as any;
        data["descriptionCH"] = this.descriptionCH !== undefined ? this.descriptionCH : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        return data;
    }
}

export class CopyHisModelInputDto {
    id!: string;
    name!: string | null;
    isSplit!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.isSplit = _data["isSplit"] !== undefined ? _data["isSplit"] : null as any;
        }
    }

    static fromJS(data: any): CopyHisModelInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CopyHisModelInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["isSplit"] = this.isSplit !== undefined ? this.isSplit : null as any;
        return data;
    }
}

export class CopyProductVcsInputDto {
    lectoTypeProductIdGo!: string;
    lectoTypeProductIdEnds!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.lectoTypeProductIdGo = _data["lectoTypeProductIdGo"] !== undefined ? _data["lectoTypeProductIdGo"] : null as any;
            if (Array.isArray(_data["lectoTypeProductIdEnds"])) {
                this.lectoTypeProductIdEnds = [] as any;
                for (let item of _data["lectoTypeProductIdEnds"])
                    this.lectoTypeProductIdEnds!.push(item);
            }
            else {
                this.lectoTypeProductIdEnds = null as any;
            }
        }
    }

    static fromJS(data: any): CopyProductVcsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CopyProductVcsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lectoTypeProductIdGo"] = this.lectoTypeProductIdGo !== undefined ? this.lectoTypeProductIdGo : null as any;
        if (Array.isArray(this.lectoTypeProductIdEnds)) {
            data["lectoTypeProductIdEnds"] = [];
            for (let item of this.lectoTypeProductIdEnds)
                data["lectoTypeProductIdEnds"].push(item);
        }
        return data;
    }
}

export class CreateCategoryDto {
    /** 代码 */
    code!: number;
    /** 含义 */
    meaning!: string | null;
    /** 描述 */
    remark!: string | null;
    /** 是否为特殊品类 */
    specific!: boolean;

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.specific = _data["specific"] !== undefined ? _data["specific"] : null as any;
        }
    }

    static fromJS(data: any): CreateCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["specific"] = this.specific !== undefined ? this.specific : null as any;
        return data;
    }
}

export class CreateCustomVcApprovalDto {
    /** 自定义VC编号 */
    customVcId!: string;
    /** 审批信息 */
    info!: string | null;
    isApproval!: TQApprovalStatus;

    init(_data?: any) {
        if (_data) {
            this.customVcId = _data["customVcId"] !== undefined ? _data["customVcId"] : null as any;
            this.info = _data["info"] !== undefined ? _data["info"] : null as any;
            this.isApproval = _data["isApproval"] !== undefined ? _data["isApproval"] : null as any;
        }
    }

    static fromJS(data: any): CreateCustomVcApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomVcApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customVcId"] = this.customVcId !== undefined ? this.customVcId : null as any;
        data["info"] = this.info !== undefined ? this.info : null as any;
        data["isApproval"] = this.isApproval !== undefined ? this.isApproval : null as any;
        return data;
    }
}

export class CreateCustomVcDto {
    /** VC ID */
    vcID!: string | null;
    /** 品类 */
    categoryId!: string;
    /** VC含义 */
    meaning!: string | null;
    /** 英文含义 */
    englishMeaning!: string | null;
    /** VC备注 */
    vcTypeDescription!: string | null;
    /** VC头数 */
    numberWires!: number;

    init(_data?: any) {
        if (_data) {
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
        }
    }

    static fromJS(data: any): CreateCustomVcDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomVcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        return data;
    }
}

export class CreateCustomVcPriceDto {
    /** 主机代码 */
    basicMotorCode!: string | null;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 机座号 */
    frameNo!: number;
    /** 工程周期（自然日） */
    engineeringCycle!: number | null;
    engineeringCalculationMode!: EngineeringCalculationMode;
    /** 采购周期（工作日） */
    purchaseCycle!: number | null;
    purchaseCycleMode!: PurchaseCycleMode;
    /** 生产周期（自然日） */
    productionCycle!: number | null;
    /** GR增量 */
    grCycle!: number | null;
    /** SCM周期 */
    scmCycle!: number | null;
    /** SCM计算方式 */
    scmCalculationMode!: string | null;
    /** SCM备注 */
    scmRemark!: string | null;
    /** 额外叠加时间 */
    extraOverlayTime!: boolean | null;
    /** 是否叠加逻辑 */
    isOverlayLogic!: boolean | null;
    /** 测试周期（自然日） */
    testCycle!: number | null;
    /** 船检周期（自然日） */
    shipSurveyCycle!: number | null;
    /** 单价 */
    unitPrice!: number | null;
    /** 面价公式 */
    unitPriceFormula!: string | null;
    unitPriceType!: UnitPriceType;
    /** 成本 */
    cost!: number | null;
    /** 成本公式 */
    costFormula!: string | null;
    costType!: CostType;
    /** 成本类型详情 */
    costTypeDetail!: string | null;
    /** 报价原则 */
    quotationPrinciple!: string | null;
    /** 报价原则详情 */
    quotationPrincipleDetails!: string | null;
    /** 自定义VC编号 */
    customVcId!: string;

    init(_data?: any) {
        if (_data) {
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.scmCycle = _data["scmCycle"] !== undefined ? _data["scmCycle"] : null as any;
            this.scmCalculationMode = _data["scmCalculationMode"] !== undefined ? _data["scmCalculationMode"] : null as any;
            this.scmRemark = _data["scmRemark"] !== undefined ? _data["scmRemark"] : null as any;
            this.extraOverlayTime = _data["extraOverlayTime"] !== undefined ? _data["extraOverlayTime"] : null as any;
            this.isOverlayLogic = _data["isOverlayLogic"] !== undefined ? _data["isOverlayLogic"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.customVcId = _data["customVcId"] !== undefined ? _data["customVcId"] : null as any;
        }
    }

    static fromJS(data: any): CreateCustomVcPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomVcPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["scmCycle"] = this.scmCycle !== undefined ? this.scmCycle : null as any;
        data["scmCalculationMode"] = this.scmCalculationMode !== undefined ? this.scmCalculationMode : null as any;
        data["scmRemark"] = this.scmRemark !== undefined ? this.scmRemark : null as any;
        data["extraOverlayTime"] = this.extraOverlayTime !== undefined ? this.extraOverlayTime : null as any;
        data["isOverlayLogic"] = this.isOverlayLogic !== undefined ? this.isOverlayLogic : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["customVcId"] = this.customVcId !== undefined ? this.customVcId : null as any;
        return data;
    }
}

/** 生成国产报价 */
export class CreateDqDto {
    id!: string | null;
    /** 选型id */
    lectoTypeId!: string;
    /** 国产报价号 */
    domesticQuotationNumber!: string | null;
    /** 生产周期 */
    cycle!: number;
    /** 最终客户id */
    clienter!: string | null;
    /** 最终客户名称 */
    clientName!: string | null;
    /** 二级客户Id */
    finalCustomerCode!: string | null;
    /** 二级客户名称 */
    finalCustomerName!: string | null;
    /** 技术协议附件列表 */
    dqAttachs!: string | null;
    /** 国产报价备注 */
    dqRemark!: string | null;
    /** 报价过期时间 */
    quotationExpiredTime!: moment.Moment | null;
    dqStatus!: TechnologyQuotationStatus;
    technologyQuotationProducts!: CreateDqProductDto[] | null;
    /** 是否提交 */
    isSubmit!: boolean;
    /** 一次性项目号 */
    projectName!: string | null;
    /** PMS项目类型 */
    pmsProjectType!: number | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.domesticQuotationNumber = _data["domesticQuotationNumber"] !== undefined ? _data["domesticQuotationNumber"] : null as any;
            this.cycle = _data["cycle"] !== undefined ? _data["cycle"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.dqAttachs = _data["dqAttachs"] !== undefined ? _data["dqAttachs"] : null as any;
            this.dqRemark = _data["dqRemark"] !== undefined ? _data["dqRemark"] : null as any;
            this.quotationExpiredTime = _data["quotationExpiredTime"] ? moment(_data["quotationExpiredTime"].toString()) : null as any;
            this.dqStatus = _data["dqStatus"] !== undefined ? _data["dqStatus"] : null as any;
            if (Array.isArray(_data["technologyQuotationProducts"])) {
                this.technologyQuotationProducts = [] as any;
                for (let item of _data["technologyQuotationProducts"])
                    this.technologyQuotationProducts!.push(CreateDqProductDto.fromJS(item));
            }
            else {
                this.technologyQuotationProducts = null as any;
            }
            this.isSubmit = _data["isSubmit"] !== undefined ? _data["isSubmit"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.pmsProjectType = _data["pmsProjectType"] !== undefined ? _data["pmsProjectType"] : null as any;
        }
    }

    static fromJS(data: any): CreateDqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["domesticQuotationNumber"] = this.domesticQuotationNumber !== undefined ? this.domesticQuotationNumber : null as any;
        data["cycle"] = this.cycle !== undefined ? this.cycle : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["dqAttachs"] = this.dqAttachs !== undefined ? this.dqAttachs : null as any;
        data["dqRemark"] = this.dqRemark !== undefined ? this.dqRemark : null as any;
        data["quotationExpiredTime"] = this.quotationExpiredTime ? this.quotationExpiredTime.toISOString() : null as any;
        data["dqStatus"] = this.dqStatus !== undefined ? this.dqStatus : null as any;
        if (Array.isArray(this.technologyQuotationProducts)) {
            data["technologyQuotationProducts"] = [];
            for (let item of this.technologyQuotationProducts)
                data["technologyQuotationProducts"].push(item ? item.toJSON() : null as any);
        }
        data["isSubmit"] = this.isSubmit !== undefined ? this.isSubmit : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["pmsProjectType"] = this.pmsProjectType !== undefined ? this.pmsProjectType : null as any;
        return data;
    }
}

export class CreateDqProductDto {
    id!: string | null;
    /** 选型产品id */
    lectoTypeProductId!: string;
    /** 主机代码 */
    basicMotorCode!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 安装方式 */
    basicMotorMounting!: string | null;
    /** 功率 */
    power!: string | null;
    /** 极数 */
    poleNo!: string | null;
    /** 频率 */
    frequency!: string | null;
    /** 电压 */
    voltage!: string | null;
    /** 机座号 */
    frameNo!: number;
    basicMotorType!: BasicMotorType;
    basicMotorSries!: string | null;
    jinCategoryCode!: string | null;
    /** 境界版本 */
    jinVersion!: string | null;
    /** 面价选型产品来源id */
    listPriceBasicMotorPriceId!: string | null;
    /** 折扣系数 */
    listPriceMultiplier!: number;
    /** 周期 */
    cycle!: number;
    /** 数量 */
    productNumber!: number;
    /** 技术规范号 */
    technicalSpecifications!: string | null;
    quotationType!: QuotationType;
    /** 单价 */
    unitPrice!: number | null;
    /** 单价结果 */
    unitPriceResult!: string | null;
    /** 面价公式 */
    unitPriceFormula!: string | null;
    /** 成本 */
    cost!: number | null;
    /** 成本公式 */
    costFormula!: string | null;
    costType!: CostType;
    /** 成本类型详情 */
    costTypeDetail!: string | null;
    /** 报价原则 */
    quotationPrinciple!: string | null;
    /** 报价原则详情 */
    quotationPrincipleDetails!: string | null;
    /** 国产报价备注 */
    dqRemark!: string | null;
    /** 工程周期（自然天） */
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    /** 采购周期（自然天） */
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    /** 生产周期（自然天） */
    productionCycle!: number;
    /** 测试周期（自然天） */
    testCycle!: number;
    /** 产能周期（自然天） */
    capacityCycle!: number;
    /** GR增量 */
    grCycle!: number;
    /** 入库到出库时间 */
    inToOutCycle!: number;
    isHaveVc!: IsHaveVc;
    isNeedHeightOutput!: IsYes;
    /** 能效 */
    eneEff!: string | null;
    /** 编码器 */
    encoder!: string | null;
    /** 制动器 */
    brake!: string | null;
    clienter!: string | null;
    basicMotorSriesId!: number | null;
    voltageCode!: string | null;
    makeOrBuy!: string | null;
    /** 来源协议产品id (协议是针对产品行的且对所有客户有效，因此在业务上不需要考虑客户变更的场景) */
    technicalSpecificationProductId!: string | null;
    technologyQuotationProductVCs!: CreateDqProductVCDto[] | null;
    dqProductParametersStr!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.lectoTypeProductId = _data["lectoTypeProductId"] !== undefined ? _data["lectoTypeProductId"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.basicMotorType = _data["basicMotorType"] !== undefined ? _data["basicMotorType"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.listPriceBasicMotorPriceId = _data["listPriceBasicMotorPriceId"] !== undefined ? _data["listPriceBasicMotorPriceId"] : null as any;
            this.listPriceMultiplier = _data["listPriceMultiplier"] !== undefined ? _data["listPriceMultiplier"] : null as any;
            this.cycle = _data["cycle"] !== undefined ? _data["cycle"] : null as any;
            this.productNumber = _data["productNumber"] !== undefined ? _data["productNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.quotationType = _data["quotationType"] !== undefined ? _data["quotationType"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.dqRemark = _data["dqRemark"] !== undefined ? _data["dqRemark"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.capacityCycle = _data["capacityCycle"] !== undefined ? _data["capacityCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.inToOutCycle = _data["inToOutCycle"] !== undefined ? _data["inToOutCycle"] : null as any;
            this.isHaveVc = _data["isHaveVc"] !== undefined ? _data["isHaveVc"] : null as any;
            this.isNeedHeightOutput = _data["isNeedHeightOutput"] !== undefined ? _data["isNeedHeightOutput"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.encoder = _data["encoder"] !== undefined ? _data["encoder"] : null as any;
            this.brake = _data["brake"] !== undefined ? _data["brake"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.basicMotorSriesId = _data["basicMotorSriesId"] !== undefined ? _data["basicMotorSriesId"] : null as any;
            this.voltageCode = _data["voltageCode"] !== undefined ? _data["voltageCode"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.technicalSpecificationProductId = _data["technicalSpecificationProductId"] !== undefined ? _data["technicalSpecificationProductId"] : null as any;
            if (Array.isArray(_data["technologyQuotationProductVCs"])) {
                this.technologyQuotationProductVCs = [] as any;
                for (let item of _data["technologyQuotationProductVCs"])
                    this.technologyQuotationProductVCs!.push(CreateDqProductVCDto.fromJS(item));
            }
            else {
                this.technologyQuotationProductVCs = null as any;
            }
            this.dqProductParametersStr = _data["dqProductParametersStr"] !== undefined ? _data["dqProductParametersStr"] : null as any;
        }
    }

    static fromJS(data: any): CreateDqProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDqProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["lectoTypeProductId"] = this.lectoTypeProductId !== undefined ? this.lectoTypeProductId : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["basicMotorType"] = this.basicMotorType !== undefined ? this.basicMotorType : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["listPriceBasicMotorPriceId"] = this.listPriceBasicMotorPriceId !== undefined ? this.listPriceBasicMotorPriceId : null as any;
        data["listPriceMultiplier"] = this.listPriceMultiplier !== undefined ? this.listPriceMultiplier : null as any;
        data["cycle"] = this.cycle !== undefined ? this.cycle : null as any;
        data["productNumber"] = this.productNumber !== undefined ? this.productNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["quotationType"] = this.quotationType !== undefined ? this.quotationType : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["dqRemark"] = this.dqRemark !== undefined ? this.dqRemark : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["capacityCycle"] = this.capacityCycle !== undefined ? this.capacityCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["inToOutCycle"] = this.inToOutCycle !== undefined ? this.inToOutCycle : null as any;
        data["isHaveVc"] = this.isHaveVc !== undefined ? this.isHaveVc : null as any;
        data["isNeedHeightOutput"] = this.isNeedHeightOutput !== undefined ? this.isNeedHeightOutput : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["encoder"] = this.encoder !== undefined ? this.encoder : null as any;
        data["brake"] = this.brake !== undefined ? this.brake : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["basicMotorSriesId"] = this.basicMotorSriesId !== undefined ? this.basicMotorSriesId : null as any;
        data["voltageCode"] = this.voltageCode !== undefined ? this.voltageCode : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["technicalSpecificationProductId"] = this.technicalSpecificationProductId !== undefined ? this.technicalSpecificationProductId : null as any;
        if (Array.isArray(this.technologyQuotationProductVCs)) {
            data["technologyQuotationProductVCs"] = [];
            for (let item of this.technologyQuotationProductVCs)
                data["technologyQuotationProductVCs"].push(item ? item.toJSON() : null as any);
        }
        data["dqProductParametersStr"] = this.dqProductParametersStr !== undefined ? this.dqProductParametersStr : null as any;
        return data;
    }
}

export class CreateDqProductVCDto {
    id!: string | null;
    /** 选型产品VC id */
    lectoTypeProductVCId!: string;
    /** VC ID */
    vcID!: string | null;
    /** 品类 */
    category!: string | null;
    /** VC含义 */
    meaning!: string | null;
    /** VC开放式内容 */
    remark!: string | null;
    /** 单价 */
    unitPrice!: number | null;
    /** 单价结果 */
    unitPriceResult!: string | null;
    discountType!: UnitPriceType;
    /** 面价公式 */
    unitPriceFormula!: string | null;
    /** 成本 */
    cost!: number | null;
    /** 成本公式 */
    costFormula!: string | null;
    costType!: CostType;
    /** 成本类型详情 */
    costTypeDetail!: string | null;
    /** 报价原则 */
    quotationPrinciple!: string | null;
    /** 报价原则详情 */
    quotationPrincipleDetails!: string | null;
    /** 工程周期（自然天） */
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    /** 采购周期（自然天） */
    purchaseCycle!: number;
    /** 生产周期（自然天） */
    productionCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    /** 测试周期（自然天） */
    testCycle!: number;
    /** 船检周期（自然天） */
    shipSurveyCycle!: number;
    vcType!: VcType;
    /** Gr */
    grCycle!: number;
    vcShowType!: VCShowType;
    /** 来源协议产品VC id */
    technicalSpecificationProductVCId!: string | null;
    /** 备注 */
    vcTypeDescription!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.lectoTypeProductVCId = _data["lectoTypeProductVCId"] !== undefined ? _data["lectoTypeProductVCId"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.technicalSpecificationProductVCId = _data["technicalSpecificationProductVCId"] !== undefined ? _data["technicalSpecificationProductVCId"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
        }
    }

    static fromJS(data: any): CreateDqProductVCDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDqProductVCDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["lectoTypeProductVCId"] = this.lectoTypeProductVCId !== undefined ? this.lectoTypeProductVCId : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["discountType"] = this.discountType !== undefined ? this.discountType : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["technicalSpecificationProductVCId"] = this.technicalSpecificationProductVCId !== undefined ? this.technicalSpecificationProductVCId : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        return data;
    }
}

export class CreateLectoTypeInputDto {
    name!: string;
    clienter!: string;
    clientName!: string | null;
    shippingAddressCode!: string | null;
    shippingAddress!: string | null;
    saleId!: number | null;
    saleName!: string | null;
    lectoPeople!: number | null;
    finalCustomerCode!: string | null;
    finalCustomerName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.shippingAddressCode = _data["shippingAddressCode"] !== undefined ? _data["shippingAddressCode"] : null as any;
            this.shippingAddress = _data["shippingAddress"] !== undefined ? _data["shippingAddress"] : null as any;
            this.saleId = _data["saleId"] !== undefined ? _data["saleId"] : null as any;
            this.saleName = _data["saleName"] !== undefined ? _data["saleName"] : null as any;
            this.lectoPeople = _data["lectoPeople"] !== undefined ? _data["lectoPeople"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
        }
    }

    static fromJS(data: any): CreateLectoTypeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLectoTypeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["shippingAddressCode"] = this.shippingAddressCode !== undefined ? this.shippingAddressCode : null as any;
        data["shippingAddress"] = this.shippingAddress !== undefined ? this.shippingAddress : null as any;
        data["saleId"] = this.saleId !== undefined ? this.saleId : null as any;
        data["saleName"] = this.saleName !== undefined ? this.saleName : null as any;
        data["lectoPeople"] = this.lectoPeople !== undefined ? this.lectoPeople : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        return data;
    }
}

export class CreateOrEditDoubleVCCheckRulesDto {
    id!: string | null;
    productType!: string;
    seatNoMax!: number;
    seatNoMin!: number;
    vCId1!: string;
    vCId2!: string;
    rule!: string | null;
    compulsoryType!: number;
    promptContent!: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.productType = _data["productType"] !== undefined ? _data["productType"] : null as any;
            this.seatNoMax = _data["seatNoMax"] !== undefined ? _data["seatNoMax"] : null as any;
            this.seatNoMin = _data["seatNoMin"] !== undefined ? _data["seatNoMin"] : null as any;
            this.vCId1 = _data["vCId1"] !== undefined ? _data["vCId1"] : null as any;
            this.vCId2 = _data["vCId2"] !== undefined ? _data["vCId2"] : null as any;
            this.rule = _data["rule"] !== undefined ? _data["rule"] : null as any;
            this.compulsoryType = _data["compulsoryType"] !== undefined ? _data["compulsoryType"] : null as any;
            this.promptContent = _data["promptContent"] !== undefined ? _data["promptContent"] : null as any;
        }
    }

    static fromJS(data: any): CreateOrEditDoubleVCCheckRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditDoubleVCCheckRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["productType"] = this.productType !== undefined ? this.productType : null as any;
        data["seatNoMax"] = this.seatNoMax !== undefined ? this.seatNoMax : null as any;
        data["seatNoMin"] = this.seatNoMin !== undefined ? this.seatNoMin : null as any;
        data["vCId1"] = this.vCId1 !== undefined ? this.vCId1 : null as any;
        data["vCId2"] = this.vCId2 !== undefined ? this.vCId2 : null as any;
        data["rule"] = this.rule !== undefined ? this.rule : null as any;
        data["compulsoryType"] = this.compulsoryType !== undefined ? this.compulsoryType : null as any;
        data["promptContent"] = this.promptContent !== undefined ? this.promptContent : null as any;
        return data;
    }
}

export class CreateOrEditNumberWiresCheckRulesDto {
    id!: string | null;
    productType!: string;
    seatNoMax!: number;
    seatNoMin!: number;
    maxNumberWires!: number;
    compulsoryType!: number;
    promptContent!: string;
    remarks!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.productType = _data["productType"] !== undefined ? _data["productType"] : null as any;
            this.seatNoMax = _data["seatNoMax"] !== undefined ? _data["seatNoMax"] : null as any;
            this.seatNoMin = _data["seatNoMin"] !== undefined ? _data["seatNoMin"] : null as any;
            this.maxNumberWires = _data["maxNumberWires"] !== undefined ? _data["maxNumberWires"] : null as any;
            this.compulsoryType = _data["compulsoryType"] !== undefined ? _data["compulsoryType"] : null as any;
            this.promptContent = _data["promptContent"] !== undefined ? _data["promptContent"] : null as any;
            this.remarks = _data["remarks"] !== undefined ? _data["remarks"] : null as any;
        }
    }

    static fromJS(data: any): CreateOrEditNumberWiresCheckRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditNumberWiresCheckRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["productType"] = this.productType !== undefined ? this.productType : null as any;
        data["seatNoMax"] = this.seatNoMax !== undefined ? this.seatNoMax : null as any;
        data["seatNoMin"] = this.seatNoMin !== undefined ? this.seatNoMin : null as any;
        data["maxNumberWires"] = this.maxNumberWires !== undefined ? this.maxNumberWires : null as any;
        data["compulsoryType"] = this.compulsoryType !== undefined ? this.compulsoryType : null as any;
        data["promptContent"] = this.promptContent !== undefined ? this.promptContent : null as any;
        data["remarks"] = this.remarks !== undefined ? this.remarks : null as any;
        return data;
    }
}

export class CreateOrEditSingleVCNotificationRulesDto {
    id!: string | null;
    productType!: string;
    seatNoMax!: number;
    seatNoMin!: number;
    sort!: number;
    promptContent!: string;
    vCId!: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.productType = _data["productType"] !== undefined ? _data["productType"] : null as any;
            this.seatNoMax = _data["seatNoMax"] !== undefined ? _data["seatNoMax"] : null as any;
            this.seatNoMin = _data["seatNoMin"] !== undefined ? _data["seatNoMin"] : null as any;
            this.sort = _data["sort"] !== undefined ? _data["sort"] : null as any;
            this.promptContent = _data["promptContent"] !== undefined ? _data["promptContent"] : null as any;
            this.vCId = _data["vCId"] !== undefined ? _data["vCId"] : null as any;
        }
    }

    static fromJS(data: any): CreateOrEditSingleVCNotificationRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSingleVCNotificationRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["productType"] = this.productType !== undefined ? this.productType : null as any;
        data["seatNoMax"] = this.seatNoMax !== undefined ? this.seatNoMax : null as any;
        data["seatNoMin"] = this.seatNoMin !== undefined ? this.seatNoMin : null as any;
        data["sort"] = this.sort !== undefined ? this.sort : null as any;
        data["promptContent"] = this.promptContent !== undefined ? this.promptContent : null as any;
        data["vCId"] = this.vCId !== undefined ? this.vCId : null as any;
        return data;
    }
}

export class CreateOrEditVCGroupRulesDto {
    id!: string | null;
    productType!: string;
    seatNoMax!: number;
    seatNoMin!: number;
    compulsoryType!: number;
    poleNos!: string[];
    vCIds!: string[];
    promptContent!: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.productType = _data["productType"] !== undefined ? _data["productType"] : null as any;
            this.seatNoMax = _data["seatNoMax"] !== undefined ? _data["seatNoMax"] : null as any;
            this.seatNoMin = _data["seatNoMin"] !== undefined ? _data["seatNoMin"] : null as any;
            this.compulsoryType = _data["compulsoryType"] !== undefined ? _data["compulsoryType"] : null as any;
            if (Array.isArray(_data["poleNos"])) {
                this.poleNos = [] as any;
                for (let item of _data["poleNos"])
                    this.poleNos!.push(item);
            }
            else {
                this.poleNos = null as any;
            }
            if (Array.isArray(_data["vCIds"])) {
                this.vCIds = [] as any;
                for (let item of _data["vCIds"])
                    this.vCIds!.push(item);
            }
            else {
                this.vCIds = null as any;
            }
            this.promptContent = _data["promptContent"] !== undefined ? _data["promptContent"] : null as any;
        }
    }

    static fromJS(data: any): CreateOrEditVCGroupRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditVCGroupRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["productType"] = this.productType !== undefined ? this.productType : null as any;
        data["seatNoMax"] = this.seatNoMax !== undefined ? this.seatNoMax : null as any;
        data["seatNoMin"] = this.seatNoMin !== undefined ? this.seatNoMin : null as any;
        data["compulsoryType"] = this.compulsoryType !== undefined ? this.compulsoryType : null as any;
        if (Array.isArray(this.poleNos)) {
            data["poleNos"] = [];
            for (let item of this.poleNos)
                data["poleNos"].push(item);
        }
        if (Array.isArray(this.vCIds)) {
            data["vCIds"] = [];
            for (let item of this.vCIds)
                data["vCIds"].push(item);
        }
        data["promptContent"] = this.promptContent !== undefined ? this.promptContent : null as any;
        return data;
    }
}

export class CreateOrUpdateBasicMotorInfoInputDto {
    id!: string;
    basicMotorCode!: string;
    basicMotorSriesId!: number | null;
    voltage!: string | null;
    wiringMode!: string | null;
    frequency!: string | null;
    power!: string | null;
    eneEff!: string | null;
    frameNo!: number;
    poleNo!: string | null;
    basicMotorMounting!: string | null;
    isHaveVc!: IsHaveVc;
    encoder!: string | null;
    insulation!: string | null;
    safty!: string | null;
    brake!: string | null;
    basicMotorModel!: string | null;
    isNeedHeightOutput!: IsYes;
    cpCode!: string | null;
    cpName!: string | null;
    customerRemark!: string | null;
    customerMaterialNumber!: string | null;
    technicalSpecifications!: string | null;
    salesPrice!: number | null;
    rowKey!: string | null;
    voltageCode!: string | null;
    cpBasicMotorCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSriesId = _data["basicMotorSriesId"] !== undefined ? _data["basicMotorSriesId"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.isHaveVc = _data["isHaveVc"] !== undefined ? _data["isHaveVc"] : null as any;
            this.encoder = _data["encoder"] !== undefined ? _data["encoder"] : null as any;
            this.insulation = _data["insulation"] !== undefined ? _data["insulation"] : null as any;
            this.safty = _data["safty"] !== undefined ? _data["safty"] : null as any;
            this.brake = _data["brake"] !== undefined ? _data["brake"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.isNeedHeightOutput = _data["isNeedHeightOutput"] !== undefined ? _data["isNeedHeightOutput"] : null as any;
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.cpName = _data["cpName"] !== undefined ? _data["cpName"] : null as any;
            this.customerRemark = _data["customerRemark"] !== undefined ? _data["customerRemark"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.rowKey = _data["rowKey"] !== undefined ? _data["rowKey"] : null as any;
            this.voltageCode = _data["voltageCode"] !== undefined ? _data["voltageCode"] : null as any;
            this.cpBasicMotorCode = _data["cpBasicMotorCode"] !== undefined ? _data["cpBasicMotorCode"] : null as any;
        }
    }

    static fromJS(data: any): CreateOrUpdateBasicMotorInfoInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateBasicMotorInfoInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSriesId"] = this.basicMotorSriesId !== undefined ? this.basicMotorSriesId : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["isHaveVc"] = this.isHaveVc !== undefined ? this.isHaveVc : null as any;
        data["encoder"] = this.encoder !== undefined ? this.encoder : null as any;
        data["insulation"] = this.insulation !== undefined ? this.insulation : null as any;
        data["safty"] = this.safty !== undefined ? this.safty : null as any;
        data["brake"] = this.brake !== undefined ? this.brake : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["isNeedHeightOutput"] = this.isNeedHeightOutput !== undefined ? this.isNeedHeightOutput : null as any;
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["cpName"] = this.cpName !== undefined ? this.cpName : null as any;
        data["customerRemark"] = this.customerRemark !== undefined ? this.customerRemark : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["rowKey"] = this.rowKey !== undefined ? this.rowKey : null as any;
        data["voltageCode"] = this.voltageCode !== undefined ? this.voltageCode : null as any;
        data["cpBasicMotorCode"] = this.cpBasicMotorCode !== undefined ? this.cpBasicMotorCode : null as any;
        return data;
    }
}

export class CreateOrUpdateCustomMotorInfoInputDto {
    id!: string;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 产品类型 */
    basicMotorSriesId!: number;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 机座号 */
    frameNo!: number;
    /** 安装方式 */
    basicMotorMounting!: string | null;
    /** 极数 */
    poleNo!: string | null;
    isHaveVc!: IsHaveVc;
    /** 电压代码 */
    voltageCode!: string | null;
    isNeedHeightOutput!: IsYes;
    /** 能效 */
    eneEff!: string | null;
    /** 自制OR外购 */
    makeOrBuy!: string | null;
    /** 工程周期（自然天） */
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    /** 采购周期（自然天） */
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    /** 生产周期（自然天） */
    productionCycle!: number;
    /** 测试周期（自然天） */
    testCycle!: number;
    /** 产能周期（自然天） */
    capacityCycle!: number;
    /** GR增量 */
    grCycle!: number;
    /** 入库到出库时间 */
    inToOutCycle!: number;
    /** 自定义电机参数 */
    customMotorParameters!: CustomMotorInfoParamDto[] | null;
    /** 单价 */
    unitPrice!: number | null;
    /** 面价公式 */
    unitPriceFormula!: string | null;
    /** 打折类型 */
    unitPriceType!: number | null;
    /** 成本 */
    cost!: number | null;
    /** 成本公式 */
    costFormula!: string | null;
    costType!: CostType;
    /** 成本类型详情 */
    costTypeDetail!: string | null;
    /** 报价原则 */
    quotationPrinciple!: string | null;
    /** 报价原则详情 */
    quotationPrincipleDetails!: string | null;
    /** 备注 */
    dqRemark!: string | null;
    basicMotorSries!: string | null;
    isSubmit!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSriesId = _data["basicMotorSriesId"] !== undefined ? _data["basicMotorSriesId"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.isHaveVc = _data["isHaveVc"] !== undefined ? _data["isHaveVc"] : null as any;
            this.voltageCode = _data["voltageCode"] !== undefined ? _data["voltageCode"] : null as any;
            this.isNeedHeightOutput = _data["isNeedHeightOutput"] !== undefined ? _data["isNeedHeightOutput"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.capacityCycle = _data["capacityCycle"] !== undefined ? _data["capacityCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.inToOutCycle = _data["inToOutCycle"] !== undefined ? _data["inToOutCycle"] : null as any;
            if (Array.isArray(_data["customMotorParameters"])) {
                this.customMotorParameters = [] as any;
                for (let item of _data["customMotorParameters"])
                    this.customMotorParameters!.push(CustomMotorInfoParamDto.fromJS(item));
            }
            else {
                this.customMotorParameters = null as any;
            }
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.dqRemark = _data["dqRemark"] !== undefined ? _data["dqRemark"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.isSubmit = _data["isSubmit"] !== undefined ? _data["isSubmit"] : null as any;
        }
    }

    static fromJS(data: any): CreateOrUpdateCustomMotorInfoInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCustomMotorInfoInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSriesId"] = this.basicMotorSriesId !== undefined ? this.basicMotorSriesId : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["isHaveVc"] = this.isHaveVc !== undefined ? this.isHaveVc : null as any;
        data["voltageCode"] = this.voltageCode !== undefined ? this.voltageCode : null as any;
        data["isNeedHeightOutput"] = this.isNeedHeightOutput !== undefined ? this.isNeedHeightOutput : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["capacityCycle"] = this.capacityCycle !== undefined ? this.capacityCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["inToOutCycle"] = this.inToOutCycle !== undefined ? this.inToOutCycle : null as any;
        if (Array.isArray(this.customMotorParameters)) {
            data["customMotorParameters"] = [];
            for (let item of this.customMotorParameters)
                data["customMotorParameters"].push(item ? item.toJSON() : null as any);
        }
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["dqRemark"] = this.dqRemark !== undefined ? this.dqRemark : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["isSubmit"] = this.isSubmit !== undefined ? this.isSubmit : null as any;
        return data;
    }
}

export class CreateOrUpdateSuperimposedChangeValueReportsDto {
    /** id */
    id!: string;
    /** VC ID */
    vcID!: string | null;
    /** 机座号 */
    frameNo!: number | null;
    /** 产品类型 */
    basicMotorSries!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
        }
    }

    static fromJS(data: any): CreateOrUpdateSuperimposedChangeValueReportsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSuperimposedChangeValueReportsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        return data;
    }
}

/** 创建或更新Vc长短代码映射Dto */
export class CreateOrUpdateVcLongShortCodeMappingDto {
    /** Id（更新时必填） */
    id!: string | null;
    /** Vc短代码 */
    shortVcCode!: string | null;
    /** Vc短代码品类（后端自动填充，前端可不传） */
    shortVcCategory!: string | null;
    /** Vc长代码 */
    longVcCode!: string | null;
    /** Vc长代码品类（后端自动填充，前端可不传） */
    longVcCategory!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.shortVcCode = _data["shortVcCode"] !== undefined ? _data["shortVcCode"] : null as any;
            this.shortVcCategory = _data["shortVcCategory"] !== undefined ? _data["shortVcCategory"] : null as any;
            this.longVcCode = _data["longVcCode"] !== undefined ? _data["longVcCode"] : null as any;
            this.longVcCategory = _data["longVcCategory"] !== undefined ? _data["longVcCategory"] : null as any;
        }
    }

    static fromJS(data: any): CreateOrUpdateVcLongShortCodeMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateVcLongShortCodeMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["shortVcCode"] = this.shortVcCode !== undefined ? this.shortVcCode : null as any;
        data["shortVcCategory"] = this.shortVcCategory !== undefined ? this.shortVcCategory : null as any;
        data["longVcCode"] = this.longVcCode !== undefined ? this.longVcCode : null as any;
        data["longVcCategory"] = this.longVcCategory !== undefined ? this.longVcCategory : null as any;
        return data;
    }
}

export class CreateSpeciaVcDto {
    /** VcCode */
    code!: string | null;
    /** 品类 */
    categoryId!: string;
    /** 品类 */
    category!: string | null;
    /** VC含义 */
    meaning!: string | null;
    /** VC英文含义 */
    englishMeaning!: string | null;
    /** VC备注 */
    description!: string | null;
    /** VC头数 */
    numberWires!: number;
    showType!: VCShowType;
    /** 属性名 */
    attributeName!: string | null;
    /** 属性选择 */
    attributeSelect!: string | null;

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.showType = _data["showType"] !== undefined ? _data["showType"] : null as any;
            this.attributeName = _data["attributeName"] !== undefined ? _data["attributeName"] : null as any;
            this.attributeSelect = _data["attributeSelect"] !== undefined ? _data["attributeSelect"] : null as any;
        }
    }

    static fromJS(data: any): CreateSpeciaVcDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSpeciaVcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["showType"] = this.showType !== undefined ? this.showType : null as any;
        data["attributeName"] = this.attributeName !== undefined ? this.attributeName : null as any;
        data["attributeSelect"] = this.attributeSelect !== undefined ? this.attributeSelect : null as any;
        return data;
    }
}

/** 生成技术协议 */
export class CreateTeDto {
    id!: string | null;
    /** 选型id */
    lectoTypeId!: string;
    /** 项目名称 */
    projectName!: string | null;
    /** 行业 */
    industry!: string | null;
    /** 最终客户id */
    clienter!: string | null;
    /** 最终客户名称 */
    clientName!: string | null;
    /** 二级客户Id */
    finalCustomerCode!: string | null;
    /** 二级客户名称 */
    finalCustomerName!: string | null;
    /** 技术规范号 */
    technicalSpecifications!: string | null;
    /** 技术确认号 */
    technicalConfirmation!: string | null;
    /** 技术协议附件列表 */
    teAttachs!: string | null;
    /** 技术协议备注 */
    teRemark!: string | null;
    teStatus!: TechnologyQuotationStatus;
    /** PMS项目类型 */
    pmsProjectType!: number | null;
    technicalSpecificationProducts!: CreateTeProductDto[] | null;
    /** 是否提交 */
    isSubmit!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.industry = _data["industry"] !== undefined ? _data["industry"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.technicalConfirmation = _data["technicalConfirmation"] !== undefined ? _data["technicalConfirmation"] : null as any;
            this.teAttachs = _data["teAttachs"] !== undefined ? _data["teAttachs"] : null as any;
            this.teRemark = _data["teRemark"] !== undefined ? _data["teRemark"] : null as any;
            this.teStatus = _data["teStatus"] !== undefined ? _data["teStatus"] : null as any;
            this.pmsProjectType = _data["pmsProjectType"] !== undefined ? _data["pmsProjectType"] : null as any;
            if (Array.isArray(_data["technicalSpecificationProducts"])) {
                this.technicalSpecificationProducts = [] as any;
                for (let item of _data["technicalSpecificationProducts"])
                    this.technicalSpecificationProducts!.push(CreateTeProductDto.fromJS(item));
            }
            else {
                this.technicalSpecificationProducts = null as any;
            }
            this.isSubmit = _data["isSubmit"] !== undefined ? _data["isSubmit"] : null as any;
        }
    }

    static fromJS(data: any): CreateTeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["industry"] = this.industry !== undefined ? this.industry : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["technicalConfirmation"] = this.technicalConfirmation !== undefined ? this.technicalConfirmation : null as any;
        data["teAttachs"] = this.teAttachs !== undefined ? this.teAttachs : null as any;
        data["teRemark"] = this.teRemark !== undefined ? this.teRemark : null as any;
        data["teStatus"] = this.teStatus !== undefined ? this.teStatus : null as any;
        data["pmsProjectType"] = this.pmsProjectType !== undefined ? this.pmsProjectType : null as any;
        if (Array.isArray(this.technicalSpecificationProducts)) {
            data["technicalSpecificationProducts"] = [];
            for (let item of this.technicalSpecificationProducts)
                data["technicalSpecificationProducts"].push(item ? item.toJSON() : null as any);
        }
        data["isSubmit"] = this.isSubmit !== undefined ? this.isSubmit : null as any;
        return data;
    }
}

export class CreateTeProductDto {
    id!: string | null;
    /** 选型产品id */
    lectoTypeProductId!: string;
    /** 单价结果 */
    unitPriceResult!: string | null;
    /** 铭牌上电机型号 */
    motorModelOnTheNameplate!: string | null;
    /** 系统型号 */
    systemMOdel!: string | null;
    /** 功率/极数 */
    powerPoleNo!: string | null;
    /** 额定电压/频率 */
    voltageFrequency!: string | null;
    /** 安装型式 */
    technologyAgreementBasicMotorMounting!: string | null;
    /** 防护等级 */
    ip!: string | null;
    /** 冷却方式 */
    ic!: string | null;
    /** 绝缘/温升等级 */
    insulationTemperatureRiseClass!: string | null;
    /** 旋转方向 */
    directionOfRotation!: string | null;
    /** 环境温度 */
    ambientTemperature!: string | null;
    /** 应用 */
    application!: string | null;
    /** 工作制 */
    workingSystem!: string | null;
    /** 其他 */
    other!: string | null;
    /** 结构图 */
    structurecharT!: string | null;
    /** 技术数据表 */
    technicalDataTable!: string | null;
    /** 数量 */
    productNumber!: number;
    /** 备注 */
    teRemark!: string | null;
    /** 主机代码 */
    basicMotorCode!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 安装方式 */
    basicMotorMounting!: string | null;
    /** 功率 */
    power!: string | null;
    /** 频率 */
    frequency!: string | null;
    /** 电压 */
    voltage!: string | null;
    /** 机座号 */
    frameNo!: number;
    /** 周期 */
    cycle!: number;
    basicMotorType!: BasicMotorType;
    basicMotorSries!: string | null;
    jinCategoryCode!: string | null;
    /** 境界版本 */
    jinVersion!: string | null;
    /** 面价选型产品来源id */
    listPriceBasicMotorPriceId!: string | null;
    /** 增加折扣系数 */
    listPriceMultiplier!: number;
    /** 来源报价产品id */
    technologyQuotationProductId!: string | null;
    technologyQuotationProductVCs!: CreateTeProductVCDto[] | null;
    teProductParametersStr!: string | null;
    /** GR增量 */
    grCycle!: number;
    /** 入库到出库时间 */
    inToOutCycle!: number;
    isHaveVc!: IsHaveVc;
    isNeedHeightOutput!: IsYes;
    voltageCode!: string | null;
    makeOrBuy!: string | null;
    /** 极数 */
    poleNo!: string | null;
    /** 制动器 */
    brake!: string | null;
    /** 单价 */
    unitPrice!: number | null;
    /** 面价公式 */
    unitPriceFormula!: string | null;
    /** 成本 */
    cost!: number | null;
    /** 成本公式 */
    costFormula!: string | null;
    costType!: CostType;
    /** 成本类型详情 */
    costTypeDetail!: string | null;
    /** 报价原则 */
    quotationPrinciple!: string | null;
    /** 报价原则详情 */
    quotationPrincipleDetails!: string | null;
    /** 国产报价备注 */
    dqRemark!: string | null;
    /** 工程周期（自然天） */
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    /** 采购周期（自然天） */
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    /** 生产周期（自然天） */
    productionCycle!: number;
    /** 测试周期（自然天） */
    testCycle!: number;
    /** 产能周期（自然天） */
    capacityCycle!: number;
    basicMotorSriesId!: number | null;
    eneEff!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.lectoTypeProductId = _data["lectoTypeProductId"] !== undefined ? _data["lectoTypeProductId"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.motorModelOnTheNameplate = _data["motorModelOnTheNameplate"] !== undefined ? _data["motorModelOnTheNameplate"] : null as any;
            this.systemMOdel = _data["systemMOdel"] !== undefined ? _data["systemMOdel"] : null as any;
            this.powerPoleNo = _data["powerPoleNo"] !== undefined ? _data["powerPoleNo"] : null as any;
            this.voltageFrequency = _data["voltageFrequency"] !== undefined ? _data["voltageFrequency"] : null as any;
            this.technologyAgreementBasicMotorMounting = _data["technologyAgreementBasicMotorMounting"] !== undefined ? _data["technologyAgreementBasicMotorMounting"] : null as any;
            this.ip = _data["ip"] !== undefined ? _data["ip"] : null as any;
            this.ic = _data["ic"] !== undefined ? _data["ic"] : null as any;
            this.insulationTemperatureRiseClass = _data["insulationTemperatureRiseClass"] !== undefined ? _data["insulationTemperatureRiseClass"] : null as any;
            this.directionOfRotation = _data["directionOfRotation"] !== undefined ? _data["directionOfRotation"] : null as any;
            this.ambientTemperature = _data["ambientTemperature"] !== undefined ? _data["ambientTemperature"] : null as any;
            this.application = _data["application"] !== undefined ? _data["application"] : null as any;
            this.workingSystem = _data["workingSystem"] !== undefined ? _data["workingSystem"] : null as any;
            this.other = _data["other"] !== undefined ? _data["other"] : null as any;
            this.structurecharT = _data["structurecharT"] !== undefined ? _data["structurecharT"] : null as any;
            this.technicalDataTable = _data["technicalDataTable"] !== undefined ? _data["technicalDataTable"] : null as any;
            this.productNumber = _data["productNumber"] !== undefined ? _data["productNumber"] : null as any;
            this.teRemark = _data["teRemark"] !== undefined ? _data["teRemark"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.cycle = _data["cycle"] !== undefined ? _data["cycle"] : null as any;
            this.basicMotorType = _data["basicMotorType"] !== undefined ? _data["basicMotorType"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.listPriceBasicMotorPriceId = _data["listPriceBasicMotorPriceId"] !== undefined ? _data["listPriceBasicMotorPriceId"] : null as any;
            this.listPriceMultiplier = _data["listPriceMultiplier"] !== undefined ? _data["listPriceMultiplier"] : null as any;
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
            if (Array.isArray(_data["technologyQuotationProductVCs"])) {
                this.technologyQuotationProductVCs = [] as any;
                for (let item of _data["technologyQuotationProductVCs"])
                    this.technologyQuotationProductVCs!.push(CreateTeProductVCDto.fromJS(item));
            }
            else {
                this.technologyQuotationProductVCs = null as any;
            }
            this.teProductParametersStr = _data["teProductParametersStr"] !== undefined ? _data["teProductParametersStr"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.inToOutCycle = _data["inToOutCycle"] !== undefined ? _data["inToOutCycle"] : null as any;
            this.isHaveVc = _data["isHaveVc"] !== undefined ? _data["isHaveVc"] : null as any;
            this.isNeedHeightOutput = _data["isNeedHeightOutput"] !== undefined ? _data["isNeedHeightOutput"] : null as any;
            this.voltageCode = _data["voltageCode"] !== undefined ? _data["voltageCode"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.brake = _data["brake"] !== undefined ? _data["brake"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.dqRemark = _data["dqRemark"] !== undefined ? _data["dqRemark"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.capacityCycle = _data["capacityCycle"] !== undefined ? _data["capacityCycle"] : null as any;
            this.basicMotorSriesId = _data["basicMotorSriesId"] !== undefined ? _data["basicMotorSriesId"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
        }
    }

    static fromJS(data: any): CreateTeProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["lectoTypeProductId"] = this.lectoTypeProductId !== undefined ? this.lectoTypeProductId : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["motorModelOnTheNameplate"] = this.motorModelOnTheNameplate !== undefined ? this.motorModelOnTheNameplate : null as any;
        data["systemMOdel"] = this.systemMOdel !== undefined ? this.systemMOdel : null as any;
        data["powerPoleNo"] = this.powerPoleNo !== undefined ? this.powerPoleNo : null as any;
        data["voltageFrequency"] = this.voltageFrequency !== undefined ? this.voltageFrequency : null as any;
        data["technologyAgreementBasicMotorMounting"] = this.technologyAgreementBasicMotorMounting !== undefined ? this.technologyAgreementBasicMotorMounting : null as any;
        data["ip"] = this.ip !== undefined ? this.ip : null as any;
        data["ic"] = this.ic !== undefined ? this.ic : null as any;
        data["insulationTemperatureRiseClass"] = this.insulationTemperatureRiseClass !== undefined ? this.insulationTemperatureRiseClass : null as any;
        data["directionOfRotation"] = this.directionOfRotation !== undefined ? this.directionOfRotation : null as any;
        data["ambientTemperature"] = this.ambientTemperature !== undefined ? this.ambientTemperature : null as any;
        data["application"] = this.application !== undefined ? this.application : null as any;
        data["workingSystem"] = this.workingSystem !== undefined ? this.workingSystem : null as any;
        data["other"] = this.other !== undefined ? this.other : null as any;
        data["structurecharT"] = this.structurecharT !== undefined ? this.structurecharT : null as any;
        data["technicalDataTable"] = this.technicalDataTable !== undefined ? this.technicalDataTable : null as any;
        data["productNumber"] = this.productNumber !== undefined ? this.productNumber : null as any;
        data["teRemark"] = this.teRemark !== undefined ? this.teRemark : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["cycle"] = this.cycle !== undefined ? this.cycle : null as any;
        data["basicMotorType"] = this.basicMotorType !== undefined ? this.basicMotorType : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["listPriceBasicMotorPriceId"] = this.listPriceBasicMotorPriceId !== undefined ? this.listPriceBasicMotorPriceId : null as any;
        data["listPriceMultiplier"] = this.listPriceMultiplier !== undefined ? this.listPriceMultiplier : null as any;
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        if (Array.isArray(this.technologyQuotationProductVCs)) {
            data["technologyQuotationProductVCs"] = [];
            for (let item of this.technologyQuotationProductVCs)
                data["technologyQuotationProductVCs"].push(item ? item.toJSON() : null as any);
        }
        data["teProductParametersStr"] = this.teProductParametersStr !== undefined ? this.teProductParametersStr : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["inToOutCycle"] = this.inToOutCycle !== undefined ? this.inToOutCycle : null as any;
        data["isHaveVc"] = this.isHaveVc !== undefined ? this.isHaveVc : null as any;
        data["isNeedHeightOutput"] = this.isNeedHeightOutput !== undefined ? this.isNeedHeightOutput : null as any;
        data["voltageCode"] = this.voltageCode !== undefined ? this.voltageCode : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["brake"] = this.brake !== undefined ? this.brake : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["dqRemark"] = this.dqRemark !== undefined ? this.dqRemark : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["capacityCycle"] = this.capacityCycle !== undefined ? this.capacityCycle : null as any;
        data["basicMotorSriesId"] = this.basicMotorSriesId !== undefined ? this.basicMotorSriesId : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        return data;
    }
}

export class CreateTeProductVCDto {
    id!: string | null;
    /** 选型产品VC id */
    lectoTypeProductVCId!: string;
    /** VC ID */
    vcID!: string;
    /** 品类 */
    category!: string | null;
    /** VC含义 */
    meaning!: string;
    /** VC开放式内容 */
    remark!: string | null;
    /** VC头数 */
    numberWires!: number;
    /** 单价结果 */
    unitPriceResult!: string | null;
    vcType!: VcType;
    /** 工程周期（自然周） */
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    /** 采购周期（自然周） */
    purchaseCycle!: number;
    /** 生产周期（自然周） */
    productionCycle!: number;
    /** 测试周期（自然周） */
    testCycle!: number;
    /** 船检周期（自然周） */
    shipSurveyCycle!: number;
    vcShowType!: VCShowType;
    /** 来源报价产品VC id */
    technologyQuotationProductVCId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.lectoTypeProductVCId = _data["lectoTypeProductVCId"] !== undefined ? _data["lectoTypeProductVCId"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.technologyQuotationProductVCId = _data["technologyQuotationProductVCId"] !== undefined ? _data["technologyQuotationProductVCId"] : null as any;
        }
    }

    static fromJS(data: any): CreateTeProductVCDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeProductVCDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["lectoTypeProductVCId"] = this.lectoTypeProductVCId !== undefined ? this.lectoTypeProductVCId : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["technologyQuotationProductVCId"] = this.technologyQuotationProductVCId !== undefined ? this.technologyQuotationProductVCId : null as any;
        return data;
    }
}

export class CreateTechinalCatalogueDto {
    /** 名称 */
    name!: string | null;
    /** 描述 */
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): CreateTechinalCatalogueDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTechinalCatalogueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

export class CreateTechnicalAgreementDto {
    /** 标题 */
    title!: string | null;
    /** 附件链接 */
    fileUrl!: string | null;
    /** 技术协议目录编号 */
    techinalCatalogueId!: string;

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.fileUrl = _data["fileUrl"] !== undefined ? _data["fileUrl"] : null as any;
            this.techinalCatalogueId = _data["techinalCatalogueId"] !== undefined ? _data["techinalCatalogueId"] : null as any;
        }
    }

    static fromJS(data: any): CreateTechnicalAgreementDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTechnicalAgreementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["fileUrl"] = this.fileUrl !== undefined ? this.fileUrl : null as any;
        data["techinalCatalogueId"] = this.techinalCatalogueId !== undefined ? this.techinalCatalogueId : null as any;
        return data;
    }
}

export class CreateTechnologyQuotationApprovalInputDto {
    info!: string | null;
    isApproval!: TQApprovalStatus;
    technologyQuotationId!: string;

    init(_data?: any) {
        if (_data) {
            this.info = _data["info"] !== undefined ? _data["info"] : null as any;
            this.isApproval = _data["isApproval"] !== undefined ? _data["isApproval"] : null as any;
            this.technologyQuotationId = _data["technologyQuotationId"] !== undefined ? _data["technologyQuotationId"] : null as any;
        }
    }

    static fromJS(data: any): CreateTechnologyQuotationApprovalInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTechnologyQuotationApprovalInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["info"] = this.info !== undefined ? this.info : null as any;
        data["isApproval"] = this.isApproval !== undefined ? this.isApproval : null as any;
        data["technologyQuotationId"] = this.technologyQuotationId !== undefined ? this.technologyQuotationId : null as any;
        return data;
    }
}

export class CustomAttributeData {
    attributeType!: Type;
    constructor_!: ConstructorInfo;
    readonly constructorArguments!: CustomAttributeTypedArgument[] | null;
    readonly namedArguments!: CustomAttributeNamedArgument[] | null;

    init(_data?: any) {
        if (_data) {
            this.attributeType = _data["attributeType"] ? Type.fromJS(_data["attributeType"]) : null as any;
            this.constructor_ = _data["constructor"] ? ConstructorInfo.fromJS(_data["constructor"]) : null as any;
            if (Array.isArray(_data["constructorArguments"])) {
                (this as any).constructorArguments = [] as any;
                for (let item of _data["constructorArguments"])
                    (this as any).constructorArguments!.push(CustomAttributeTypedArgument.fromJS(item));
            }
            else {
                (this as any).constructorArguments = null as any;
            }
            if (Array.isArray(_data["namedArguments"])) {
                (this as any).namedArguments = [] as any;
                for (let item of _data["namedArguments"])
                    (this as any).namedArguments!.push(CustomAttributeNamedArgument.fromJS(item));
            }
            else {
                (this as any).namedArguments = null as any;
            }
        }
    }

    static fromJS(data: any): CustomAttributeData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeType"] = this.attributeType ? this.attributeType.toJSON() : null as any;
        data["constructor"] = this.constructor_ ? this.constructor_.toJSON() : null as any;
        if (Array.isArray(this.constructorArguments)) {
            data["constructorArguments"] = [];
            for (let item of this.constructorArguments)
                data["constructorArguments"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.namedArguments)) {
            data["namedArguments"] = [];
            for (let item of this.namedArguments)
                data["namedArguments"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class CustomAttributeNamedArgument {
    memberInfo!: MemberInfo;
    typedValue!: CustomAttributeTypedArgument;
    readonly memberName!: string | null;
    readonly isField!: boolean;

    init(_data?: any) {
        if (_data) {
            this.memberInfo = _data["memberInfo"] ? MemberInfo.fromJS(_data["memberInfo"]) : null as any;
            this.typedValue = _data["typedValue"] ? CustomAttributeTypedArgument.fromJS(_data["typedValue"]) : null as any;
            (this as any).memberName = _data["memberName"] !== undefined ? _data["memberName"] : null as any;
            (this as any).isField = _data["isField"] !== undefined ? _data["isField"] : null as any;
        }
    }

    static fromJS(data: any): CustomAttributeNamedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeNamedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberInfo"] = this.memberInfo ? this.memberInfo.toJSON() : null as any;
        data["typedValue"] = this.typedValue ? this.typedValue.toJSON() : null as any;
        data["memberName"] = this.memberName !== undefined ? this.memberName : null as any;
        data["isField"] = this.isField !== undefined ? this.isField : null as any;
        return data;
    }
}

export class CustomAttributeTypedArgument {
    argumentType!: Type;
    value!: any | null;

    init(_data?: any) {
        if (_data) {
            this.argumentType = _data["argumentType"] ? Type.fromJS(_data["argumentType"]) : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static fromJS(data: any): CustomAttributeTypedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeTypedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["argumentType"] = this.argumentType ? this.argumentType.toJSON() : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }
}

export class CustomCodeMotorInfo {
    basicMotorCode!: string | null;
    productMixCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.productMixCode = _data["productMixCode"] !== undefined ? _data["productMixCode"] : null as any;
        }
    }

    static fromJS(data: any): CustomCodeMotorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CustomCodeMotorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["productMixCode"] = this.productMixCode !== undefined ? this.productMixCode : null as any;
        return data;
    }
}

export class CustomCodeProductCycleInput {
    /** 产品代码 */
    customCodeMotorInfos!: CustomCodeMotorInfo[] | null;
    /** 客户化代码 */
    endCustomerCode!: string | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customCodeMotorInfos"])) {
                this.customCodeMotorInfos = [] as any;
                for (let item of _data["customCodeMotorInfos"])
                    this.customCodeMotorInfos!.push(CustomCodeMotorInfo.fromJS(item));
            }
            else {
                this.customCodeMotorInfos = null as any;
            }
            this.endCustomerCode = _data["endCustomerCode"] !== undefined ? _data["endCustomerCode"] : null as any;
        }
    }

    static fromJS(data: any): CustomCodeProductCycleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomCodeProductCycleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customCodeMotorInfos)) {
            data["customCodeMotorInfos"] = [];
            for (let item of this.customCodeMotorInfos)
                data["customCodeMotorInfos"].push(item ? item.toJSON() : null as any);
        }
        data["endCustomerCode"] = this.endCustomerCode !== undefined ? this.endCustomerCode : null as any;
        return data;
    }
}

export class CustomCodeProductCycleOutput {
    basicProductCycleOutputs!: BasicProductCycleOutput[] | null;
    lectoTypeProductDateOutputs!: LectoTypeProductDateOutput[] | null;
    productMixCodes!: { [key: string]: string; } | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["basicProductCycleOutputs"])) {
                this.basicProductCycleOutputs = [] as any;
                for (let item of _data["basicProductCycleOutputs"])
                    this.basicProductCycleOutputs!.push(BasicProductCycleOutput.fromJS(item));
            }
            else {
                this.basicProductCycleOutputs = null as any;
            }
            if (Array.isArray(_data["lectoTypeProductDateOutputs"])) {
                this.lectoTypeProductDateOutputs = [] as any;
                for (let item of _data["lectoTypeProductDateOutputs"])
                    this.lectoTypeProductDateOutputs!.push(LectoTypeProductDateOutput.fromJS(item));
            }
            else {
                this.lectoTypeProductDateOutputs = null as any;
            }
            if (_data["productMixCodes"]) {
                this.productMixCodes = {} as any;
                for (let key in _data["productMixCodes"]) {
                    if (_data["productMixCodes"].hasOwnProperty(key))
                        (this.productMixCodes as any)![key] = _data["productMixCodes"][key] !== undefined ? _data["productMixCodes"][key] : null as any;
                }
            }
            else {
                this.productMixCodes = null as any;
            }
        }
    }

    static fromJS(data: any): CustomCodeProductCycleOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomCodeProductCycleOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.basicProductCycleOutputs)) {
            data["basicProductCycleOutputs"] = [];
            for (let item of this.basicProductCycleOutputs)
                data["basicProductCycleOutputs"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.lectoTypeProductDateOutputs)) {
            data["lectoTypeProductDateOutputs"] = [];
            for (let item of this.lectoTypeProductDateOutputs)
                data["lectoTypeProductDateOutputs"].push(item ? item.toJSON() : null as any);
        }
        if (this.productMixCodes) {
            data["productMixCodes"] = {};
            for (let key in this.productMixCodes) {
                if (this.productMixCodes.hasOwnProperty(key))
                    (data["productMixCodes"] as any)[key] = this.productMixCodes[key] !== undefined ? this.productMixCodes[key] : null as any;
            }
        }
        return data;
    }
}

export class CustomMotorEditApprovalDto {
    id!: string;
    satus!: CustomMotorInfoSatus;
    /** 审批意见 */
    info!: string | null;
    /** 审批同意还是拒绝 */
    isApproval!: boolean;
    isApprovalName!: string | null;
    creationTime!: moment.Moment;
    /** 创建人 */
    creatorUserName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.satus = _data["satus"] !== undefined ? _data["satus"] : null as any;
            this.info = _data["info"] !== undefined ? _data["info"] : null as any;
            this.isApproval = _data["isApproval"] !== undefined ? _data["isApproval"] : null as any;
            this.isApprovalName = _data["isApprovalName"] !== undefined ? _data["isApprovalName"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserName = _data["creatorUserName"] !== undefined ? _data["creatorUserName"] : null as any;
        }
    }

    static fromJS(data: any): CustomMotorEditApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomMotorEditApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["satus"] = this.satus !== undefined ? this.satus : null as any;
        data["info"] = this.info !== undefined ? this.info : null as any;
        data["isApproval"] = this.isApproval !== undefined ? this.isApproval : null as any;
        data["isApprovalName"] = this.isApprovalName !== undefined ? this.isApprovalName : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserName"] = this.creatorUserName !== undefined ? this.creatorUserName : null as any;
        return data;
    }
}

export class CustomMotorInfoParamDto {
    id!: string;
    /** 接线方式 */
    wiringMode!: string | null;
    /** 自定义电机Id */
    customMotorInfoId!: string;
    /** 频率 */
    frequency!: string | null;
    /** 功率 */
    power!: string | null;
    /** 电压 */
    voltage!: string | null;
    eneEff!: string | null;
    poleNo!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
            this.customMotorInfoId = _data["customMotorInfoId"] !== undefined ? _data["customMotorInfoId"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
        }
    }

    static fromJS(data: any): CustomMotorInfoParamDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomMotorInfoParamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        data["customMotorInfoId"] = this.customMotorInfoId !== undefined ? this.customMotorInfoId : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        return data;
    }
}

/** 0 = WaitToExamine (待审核) 1 = Rejected (已驳回) 2 = Completed (已完成) 3 = Disable (已禁用) 4 = Draft (草稿) */
export enum CustomMotorInfoSatus {
    WaitToExamine = 0,
    Rejected = 1,
    Completed = 2,
    Disable = 3,
    Draft = 4,
}

/** 产品自定义规则检查对象 */
export class CustomRuleCheckProductDto {
    id!: string;
    /** 产品系列 */
    basicMotorSries!: string | null;
    basicMotorCode!: string | null;
    basicMotorType!: BasicMotorType;
    /** 技术确认号 (SFDC的号) */
    technicalConfirmation!: string | null;
    vc!: CustomRuleCheckProductVcDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorType = _data["basicMotorType"] !== undefined ? _data["basicMotorType"] : null as any;
            this.technicalConfirmation = _data["technicalConfirmation"] !== undefined ? _data["technicalConfirmation"] : null as any;
            if (Array.isArray(_data["vc"])) {
                this.vc = [] as any;
                for (let item of _data["vc"])
                    this.vc!.push(CustomRuleCheckProductVcDto.fromJS(item));
            }
            else {
                this.vc = null as any;
            }
        }
    }

    static fromJS(data: any): CustomRuleCheckProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomRuleCheckProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorType"] = this.basicMotorType !== undefined ? this.basicMotorType : null as any;
        data["technicalConfirmation"] = this.technicalConfirmation !== undefined ? this.technicalConfirmation : null as any;
        if (Array.isArray(this.vc)) {
            data["vc"] = [];
            for (let item of this.vc)
                data["vc"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 产品Vc自定义规则检查对象 */
export class CustomRuleCheckProductVcDto {
    id!: string;
    /** VC 短码， 包括999小代码 */
    vcCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
        }
    }

    static fromJS(data: any): CustomRuleCheckProductVcDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomRuleCheckProductVcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        return data;
    }
}

export class CustomVcApprovalDto {
    id!: string;
    /** 创建人编号 */
    creatorUserId!: number | null;
    /** 创建人 */
    creatorUser!: string | null;
    /** 创建日期 */
    creationTime!: moment.Moment;
    /** 审批信息 */
    info!: string | null;
    isApproval!: TQApprovalStatus;
    /** 是否审批 */
    readonly isApprovalName!: string | null;
    customVcId!: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.creatorUser = _data["creatorUser"] !== undefined ? _data["creatorUser"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.info = _data["info"] !== undefined ? _data["info"] : null as any;
            this.isApproval = _data["isApproval"] !== undefined ? _data["isApproval"] : null as any;
            (this as any).isApprovalName = _data["isApprovalName"] !== undefined ? _data["isApprovalName"] : null as any;
            this.customVcId = _data["customVcId"] !== undefined ? _data["customVcId"] : null as any;
        }
    }

    static fromJS(data: any): CustomVcApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomVcApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["creatorUser"] = this.creatorUser !== undefined ? this.creatorUser : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["info"] = this.info !== undefined ? this.info : null as any;
        data["isApproval"] = this.isApproval !== undefined ? this.isApproval : null as any;
        data["isApprovalName"] = this.isApprovalName !== undefined ? this.isApprovalName : null as any;
        data["customVcId"] = this.customVcId !== undefined ? this.customVcId : null as any;
        return data;
    }
}

export class CustomVcDtoPagedResultDto {
    items!: CustomVcDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustomVcDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): CustomVcDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomVcDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class CustomVcPriceDtoPagedResultDto {
    items!: CustomVcPriceDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustomVcPriceDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): CustomVcPriceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomVcPriceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 1 = EngineeringCycleIsConfirm (工程已确认) 2 = EngineeringCycleIsNotConfirm (工程未确认) 3 = PurchaseCycleIsConfirm (采购已确认) 4 = PurchaseCycleIsNotConfirm (采购未确认) 5 = ProductionCycleNull (生产已确认) 6 = ProductionCycleIsNotConfirm (生产未确认) 7 = TestCycleIsConfirm (测试已确认) 8 = TestCycleIsNotConfirm (测试未确认) 9 = ShipSurveCycleIsConfirm (船检已确认) 10 = ShipSurveCycleIsNotConfirm (船检未确认) 11 = GrCycleIsConfirm (VCGR已确认) 12 = GrCycleIsNotConfirm (VCGR未确认) */
export enum CycleIsConfirm {
    EngineeringCycleIsConfirm = 1,
    EngineeringCycleIsNotConfirm = 2,
    PurchaseCycleIsConfirm = 3,
    PurchaseCycleIsNotConfirm = 4,
    ProductionCycleNull = 5,
    ProductionCycleIsNotConfirm = 6,
    TestCycleIsConfirm = 7,
    TestCycleIsNotConfirm = 8,
    ShipSurveCycleIsConfirm = 9,
    ShipSurveCycleIsNotConfirm = 10,
    GrCycleIsConfirm = 11,
    GrCycleIsNotConfirm = 12,
}

/** 1 = EngineeringCycleIsNull (工程为空) 2 = EngineeringCycleIsNotNull (工程不为空) 3 = PurchaseCycleIsNull (采购为空) 4 = PurchaseCycleIsNotNull (采购不为空) 5 = ProductionCycleIsNull (生产为空) 6 = ProductionCycleIsNotNull (生产不为空) 7 = TestCycleIsNull (测试为空) 8 = TestCycleIsNotNull (测试不为空) 9 = ShipSurveCycleIsNull (船检为空) 10 = ShipSurveCycleIsNotNull (船检不为空) 11 = GrCycleIsNull (VCGR为空) 12 = GrCycleIsNotNull (VCGR不为空) */
export enum CycleIsNull {
    EngineeringCycleIsNull = 1,
    EngineeringCycleIsNotNull = 2,
    PurchaseCycleIsNull = 3,
    PurchaseCycleIsNotNull = 4,
    ProductionCycleIsNull = 5,
    ProductionCycleIsNotNull = 6,
    TestCycleIsNull = 7,
    TestCycleIsNotNull = 8,
    ShipSurveCycleIsNull = 9,
    ShipSurveCycleIsNotNull = 10,
    GrCycleIsNull = 11,
    GrCycleIsNotNull = 12,
}

export class DomesticQuotationDetailsApproval {
    info!: string | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    isApproval!: TQApprovalStatus;

    init(_data?: any) {
        if (_data) {
            this.info = _data["info"] !== undefined ? _data["info"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.isApproval = _data["isApproval"] !== undefined ? _data["isApproval"] : null as any;
        }
    }

    static fromJS(data: any): DomesticQuotationDetailsApproval {
        data = typeof data === 'object' ? data : {};
        let result = new DomesticQuotationDetailsApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["info"] = this.info !== undefined ? this.info : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["isApproval"] = this.isApproval !== undefined ? this.isApproval : null as any;
        return data;
    }
}

export class DomesticQuotationDetailsProduct {
    id!: string;
    basicMotorCode!: string | null;
    basicMotorModel!: string | null;
    basicMotorType!: BasicMotorType;
    basicMotorSries!: string | null;
    basicMotorMounting!: string | null;
    frameNo!: number;
    unitPrice!: number | null;
    unitPriceResult!: string | null;
    unitPriceFormula!: string | null;
    cost!: number | null;
    costFormula!: string | null;
    costType!: CostType;
    costTypeDetail!: string | null;
    cycle!: number;
    expectedDeliveryDate!: number;
    quotationPrinciple!: string | null;
    quotationPrincipleDetails!: string | null;
    productNumber!: number;
    power!: string | null;
    dqRemark!: string | null;
    technicalSpecifications!: string | null;
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    productionCycle!: number;
    testCycle!: number;
    capacityCycle!: number;
    grCycle!: number;
    inToOutCycle!: number;
    makeOrBuy!: string | null;
    technicalSpecificationProductId!: string | null;
    technologyQuotationProductId!: string | null;
    jinCategoryCode!: string | null;
    jinVersion!: string | null;
    jinBasicMotorCode!: string | null;
    jinBasicMotorModel!: string | null;
    jinBasicMotorMounting!: string | null;
    jinBasicMotorSries!: string | null;
    jinFrameSize!: number;
    jinPower!: string | null;
    listPriceMultiplier!: number;
    technologyQuotationProductVCs!: DomesticQuotationDetailsProductVC[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorType = _data["basicMotorType"] !== undefined ? _data["basicMotorType"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.cycle = _data["cycle"] !== undefined ? _data["cycle"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.productNumber = _data["productNumber"] !== undefined ? _data["productNumber"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.dqRemark = _data["dqRemark"] !== undefined ? _data["dqRemark"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.capacityCycle = _data["capacityCycle"] !== undefined ? _data["capacityCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.inToOutCycle = _data["inToOutCycle"] !== undefined ? _data["inToOutCycle"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.technicalSpecificationProductId = _data["technicalSpecificationProductId"] !== undefined ? _data["technicalSpecificationProductId"] : null as any;
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.jinBasicMotorCode = _data["jinBasicMotorCode"] !== undefined ? _data["jinBasicMotorCode"] : null as any;
            this.jinBasicMotorModel = _data["jinBasicMotorModel"] !== undefined ? _data["jinBasicMotorModel"] : null as any;
            this.jinBasicMotorMounting = _data["jinBasicMotorMounting"] !== undefined ? _data["jinBasicMotorMounting"] : null as any;
            this.jinBasicMotorSries = _data["jinBasicMotorSries"] !== undefined ? _data["jinBasicMotorSries"] : null as any;
            this.jinFrameSize = _data["jinFrameSize"] !== undefined ? _data["jinFrameSize"] : null as any;
            this.jinPower = _data["jinPower"] !== undefined ? _data["jinPower"] : null as any;
            this.listPriceMultiplier = _data["listPriceMultiplier"] !== undefined ? _data["listPriceMultiplier"] : null as any;
            if (Array.isArray(_data["technologyQuotationProductVCs"])) {
                this.technologyQuotationProductVCs = [] as any;
                for (let item of _data["technologyQuotationProductVCs"])
                    this.technologyQuotationProductVCs!.push(DomesticQuotationDetailsProductVC.fromJS(item));
            }
            else {
                this.technologyQuotationProductVCs = null as any;
            }
        }
    }

    static fromJS(data: any): DomesticQuotationDetailsProduct {
        data = typeof data === 'object' ? data : {};
        let result = new DomesticQuotationDetailsProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorType"] = this.basicMotorType !== undefined ? this.basicMotorType : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["cycle"] = this.cycle !== undefined ? this.cycle : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["productNumber"] = this.productNumber !== undefined ? this.productNumber : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["dqRemark"] = this.dqRemark !== undefined ? this.dqRemark : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["capacityCycle"] = this.capacityCycle !== undefined ? this.capacityCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["inToOutCycle"] = this.inToOutCycle !== undefined ? this.inToOutCycle : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["technicalSpecificationProductId"] = this.technicalSpecificationProductId !== undefined ? this.technicalSpecificationProductId : null as any;
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["jinBasicMotorCode"] = this.jinBasicMotorCode !== undefined ? this.jinBasicMotorCode : null as any;
        data["jinBasicMotorModel"] = this.jinBasicMotorModel !== undefined ? this.jinBasicMotorModel : null as any;
        data["jinBasicMotorMounting"] = this.jinBasicMotorMounting !== undefined ? this.jinBasicMotorMounting : null as any;
        data["jinBasicMotorSries"] = this.jinBasicMotorSries !== undefined ? this.jinBasicMotorSries : null as any;
        data["jinFrameSize"] = this.jinFrameSize !== undefined ? this.jinFrameSize : null as any;
        data["jinPower"] = this.jinPower !== undefined ? this.jinPower : null as any;
        data["listPriceMultiplier"] = this.listPriceMultiplier !== undefined ? this.listPriceMultiplier : null as any;
        if (Array.isArray(this.technologyQuotationProductVCs)) {
            data["technologyQuotationProductVCs"] = [];
            for (let item of this.technologyQuotationProductVCs)
                data["technologyQuotationProductVCs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class DomesticQuotationDetailsProductVC {
    id!: string;
    vcID!: string | null;
    meaning!: string | null;
    category!: string | null;
    remark!: string | null;
    vcType!: VcType;
    isInside!: boolean;
    unitPrice!: number | null;
    unitPriceResult!: string | null;
    unitPriceFormula!: string | null;
    unitPriceType!: UnitPriceType;
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    productionCycle!: number;
    testCycle!: number;
    shipSurveyCycle!: number;
    cost!: number | null;
    costFormula!: string | null;
    costType!: CostType;
    costTypeDetail!: string | null;
    quotationPrinciple!: string | null;
    quotationPrincipleDetails!: string | null;
    grCycle!: number;
    inToOutCycle!: number;
    makeOrBuy!: string | null;
    vcShowType!: VCShowType;
    technicalSpecificationProductVCId!: string | null;
    technologyQuotationProductVCId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.isInside = _data["isInside"] !== undefined ? _data["isInside"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.inToOutCycle = _data["inToOutCycle"] !== undefined ? _data["inToOutCycle"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.technicalSpecificationProductVCId = _data["technicalSpecificationProductVCId"] !== undefined ? _data["technicalSpecificationProductVCId"] : null as any;
            this.technologyQuotationProductVCId = _data["technologyQuotationProductVCId"] !== undefined ? _data["technologyQuotationProductVCId"] : null as any;
        }
    }

    static fromJS(data: any): DomesticQuotationDetailsProductVC {
        data = typeof data === 'object' ? data : {};
        let result = new DomesticQuotationDetailsProductVC();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["isInside"] = this.isInside !== undefined ? this.isInside : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["inToOutCycle"] = this.inToOutCycle !== undefined ? this.inToOutCycle : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["technicalSpecificationProductVCId"] = this.technicalSpecificationProductVCId !== undefined ? this.technicalSpecificationProductVCId : null as any;
        data["technologyQuotationProductVCId"] = this.technologyQuotationProductVCId !== undefined ? this.technologyQuotationProductVCId : null as any;
        return data;
    }
}

/** 0 = 未知 1 = 或同用 2 = 冲突 3 = 同用 */
export enum DoubleVCCheckRule {
    未知 = 0,
    或同用 = 1,
    冲突 = 2,
    同用 = 3,
}

export class DoubleVCCheckRulesDto {
    id!: string;
    productType!: string | null;
    seatNoMax!: number;
    seatNoMin!: number;
    vCId1!: string | null;
    vCId2!: string | null;
    ruleEnum!: DoubleVCCheckRule;
    ruleNo!: RuleNo;
    rule!: string | null;
    compulsoryType!: number;
    promptContent!: string | null;
    creationTime!: moment.Moment;
    lastModificationTime!: moment.Moment | null;
    isDeleted!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.productType = _data["productType"] !== undefined ? _data["productType"] : null as any;
            this.seatNoMax = _data["seatNoMax"] !== undefined ? _data["seatNoMax"] : null as any;
            this.seatNoMin = _data["seatNoMin"] !== undefined ? _data["seatNoMin"] : null as any;
            this.vCId1 = _data["vCId1"] !== undefined ? _data["vCId1"] : null as any;
            this.vCId2 = _data["vCId2"] !== undefined ? _data["vCId2"] : null as any;
            this.ruleEnum = _data["ruleEnum"] !== undefined ? _data["ruleEnum"] : null as any;
            this.ruleNo = _data["ruleNo"] !== undefined ? _data["ruleNo"] : null as any;
            this.rule = _data["rule"] !== undefined ? _data["rule"] : null as any;
            this.compulsoryType = _data["compulsoryType"] !== undefined ? _data["compulsoryType"] : null as any;
            this.promptContent = _data["promptContent"] !== undefined ? _data["promptContent"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
        }
    }

    static fromJS(data: any): DoubleVCCheckRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoubleVCCheckRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["productType"] = this.productType !== undefined ? this.productType : null as any;
        data["seatNoMax"] = this.seatNoMax !== undefined ? this.seatNoMax : null as any;
        data["seatNoMin"] = this.seatNoMin !== undefined ? this.seatNoMin : null as any;
        data["vCId1"] = this.vCId1 !== undefined ? this.vCId1 : null as any;
        data["vCId2"] = this.vCId2 !== undefined ? this.vCId2 : null as any;
        data["ruleEnum"] = this.ruleEnum !== undefined ? this.ruleEnum : null as any;
        data["ruleNo"] = this.ruleNo !== undefined ? this.ruleNo : null as any;
        data["rule"] = this.rule !== undefined ? this.rule : null as any;
        data["compulsoryType"] = this.compulsoryType !== undefined ? this.compulsoryType : null as any;
        data["promptContent"] = this.promptContent !== undefined ? this.promptContent : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        return data;
    }
}

export class DoubleVCCheckRulesDtoPagedResultDto {
    items!: DoubleVCCheckRulesDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DoubleVCCheckRulesDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): DoubleVCCheckRulesDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoubleVCCheckRulesDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 0 = None 512 = SpecialName 1024 = ReservedMask */
export enum EventAttributes {
    None = 0,
    SpecialName = 512,
    ReservedMask = 1024,
}

export class EventInfo {
    readonly name!: string | null;
    declaringType!: Type;
    reflectedType!: Type;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | null;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    memberType!: MemberTypes;
    attributes!: EventAttributes;
    readonly isSpecialName!: boolean;
    addMethod!: MethodInfo;
    removeMethod!: MethodInfo;
    raiseMethod!: MethodInfo;
    readonly isMulticast!: boolean;
    eventHandlerType!: Type;

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : null as any;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : null as any;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : null as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            else {
                (this as any).customAttributes = null as any;
            }
            (this as any).isCollectible = _data["isCollectible"] !== undefined ? _data["isCollectible"] : null as any;
            (this as any).metadataToken = _data["metadataToken"] !== undefined ? _data["metadataToken"] : null as any;
            this.memberType = _data["memberType"] !== undefined ? _data["memberType"] : null as any;
            this.attributes = _data["attributes"] !== undefined ? _data["attributes"] : null as any;
            (this as any).isSpecialName = _data["isSpecialName"] !== undefined ? _data["isSpecialName"] : null as any;
            this.addMethod = _data["addMethod"] ? MethodInfo.fromJS(_data["addMethod"]) : null as any;
            this.removeMethod = _data["removeMethod"] ? MethodInfo.fromJS(_data["removeMethod"]) : null as any;
            this.raiseMethod = _data["raiseMethod"] ? MethodInfo.fromJS(_data["raiseMethod"]) : null as any;
            (this as any).isMulticast = _data["isMulticast"] !== undefined ? _data["isMulticast"] : null as any;
            this.eventHandlerType = _data["eventHandlerType"] ? Type.fromJS(_data["eventHandlerType"]) : null as any;
        }
    }

    static fromJS(data: any): EventInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EventInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : null as any;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : null as any;
        data["module"] = this.module ? this.module.toJSON() : null as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : null as any);
        }
        data["isCollectible"] = this.isCollectible !== undefined ? this.isCollectible : null as any;
        data["metadataToken"] = this.metadataToken !== undefined ? this.metadataToken : null as any;
        data["memberType"] = this.memberType !== undefined ? this.memberType : null as any;
        data["attributes"] = this.attributes !== undefined ? this.attributes : null as any;
        data["isSpecialName"] = this.isSpecialName !== undefined ? this.isSpecialName : null as any;
        data["addMethod"] = this.addMethod ? this.addMethod.toJSON() : null as any;
        data["removeMethod"] = this.removeMethod ? this.removeMethod.toJSON() : null as any;
        data["raiseMethod"] = this.raiseMethod ? this.raiseMethod.toJSON() : null as any;
        data["isMulticast"] = this.isMulticast !== undefined ? this.isMulticast : null as any;
        data["eventHandlerType"] = this.eventHandlerType ? this.eventHandlerType.toJSON() : null as any;
        return data;
    }
}

export class ExcelCellAddress {
    readonly row!: number;
    readonly column!: number;
    readonly address!: string | null;
    readonly isRef!: boolean;

    init(_data?: any) {
        if (_data) {
            (this as any).row = _data["row"] !== undefined ? _data["row"] : null as any;
            (this as any).column = _data["column"] !== undefined ? _data["column"] : null as any;
            (this as any).address = _data["address"] !== undefined ? _data["address"] : null as any;
            (this as any).isRef = _data["isRef"] !== undefined ? _data["isRef"] : null as any;
        }
    }

    static fromJS(data: any): ExcelCellAddress {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelCellAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["row"] = this.row !== undefined ? this.row : null as any;
        data["column"] = this.column !== undefined ? this.column : null as any;
        data["address"] = this.address !== undefined ? this.address : null as any;
        data["isRef"] = this.isRef !== undefined ? this.isRef : null as any;
        return data;
    }
}

/** Class extends exception to hold casting exception circumstances */
export class ExcelException {
    targetSite!: MethodBase;
    readonly message!: string | null;
    readonly data!: { [key: string]: any; } | null;
    innerException!: Exception;
    helpLink!: string | null;
    source!: string | null;
    hResult!: number;
    readonly stackTrace!: string | null;
    args!: ExcelExceptionArgs;

    init(_data?: any) {
        if (_data) {
            this.targetSite = _data["targetSite"] ? MethodBase.fromJS(_data["targetSite"]) : null as any;
            (this as any).message = _data["message"] !== undefined ? _data["message"] : null as any;
            if (_data["data"]) {
                (this as any).data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        ((this as any).data as any)![key] = _data["data"][key] !== undefined ? _data["data"][key] : null as any;
                }
            }
            else {
                (this as any).data = null as any;
            }
            this.innerException = _data["innerException"] ? Exception.fromJS(_data["innerException"]) : null as any;
            this.helpLink = _data["helpLink"] !== undefined ? _data["helpLink"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.hResult = _data["hResult"] !== undefined ? _data["hResult"] : null as any;
            (this as any).stackTrace = _data["stackTrace"] !== undefined ? _data["stackTrace"] : null as any;
            this.args = _data["args"] ? ExcelExceptionArgs.fromJS(_data["args"]) : null as any;
        }
    }

    static fromJS(data: any): ExcelException {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetSite"] = this.targetSite ? this.targetSite.toJSON() : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (data["data"] as any)[key] = this.data[key] !== undefined ? this.data[key] : null as any;
            }
        }
        data["innerException"] = this.innerException ? this.innerException.toJSON() : null as any;
        data["helpLink"] = this.helpLink !== undefined ? this.helpLink : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["hResult"] = this.hResult !== undefined ? this.hResult : null as any;
        data["stackTrace"] = this.stackTrace !== undefined ? this.stackTrace : null as any;
        data["args"] = this.args ? this.args.toJSON() : null as any;
        return data;
    }
}

/** Class contains exception circumstances */
export class ExcelExceptionArgs {
    /** Property that was tried to set */
    propertyName!: string | null;
    /** Column that was mapped to this property */
    columnName!: string | null;
    expectedType!: Type;
    /** Cell value returned by EPPlus */
    cellValue!: any | null;
    cellAddress!: ExcelCellAddress;

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"] !== undefined ? _data["propertyName"] : null as any;
            this.columnName = _data["columnName"] !== undefined ? _data["columnName"] : null as any;
            this.expectedType = _data["expectedType"] ? Type.fromJS(_data["expectedType"]) : null as any;
            this.cellValue = _data["cellValue"] !== undefined ? _data["cellValue"] : null as any;
            this.cellAddress = _data["cellAddress"] ? ExcelCellAddress.fromJS(_data["cellAddress"]) : null as any;
        }
    }

    static fromJS(data: any): ExcelExceptionArgs {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelExceptionArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName !== undefined ? this.propertyName : null as any;
        data["columnName"] = this.columnName !== undefined ? this.columnName : null as any;
        data["expectedType"] = this.expectedType ? this.expectedType.toJSON() : null as any;
        data["cellValue"] = this.cellValue !== undefined ? this.cellValue : null as any;
        data["cellAddress"] = this.cellAddress ? this.cellAddress.toJSON() : null as any;
        return data;
    }
}

export class Exception {
    targetSite!: MethodBase;
    readonly message!: string | null;
    readonly data!: { [key: string]: any; } | null;
    innerException!: Exception;
    helpLink!: string | null;
    source!: string | null;
    hResult!: number;
    readonly stackTrace!: string | null;

    init(_data?: any) {
        if (_data) {
            this.targetSite = _data["targetSite"] ? MethodBase.fromJS(_data["targetSite"]) : null as any;
            (this as any).message = _data["message"] !== undefined ? _data["message"] : null as any;
            if (_data["data"]) {
                (this as any).data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        ((this as any).data as any)![key] = _data["data"][key] !== undefined ? _data["data"][key] : null as any;
                }
            }
            else {
                (this as any).data = null as any;
            }
            this.innerException = _data["innerException"] ? Exception.fromJS(_data["innerException"]) : null as any;
            this.helpLink = _data["helpLink"] !== undefined ? _data["helpLink"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.hResult = _data["hResult"] !== undefined ? _data["hResult"] : null as any;
            (this as any).stackTrace = _data["stackTrace"] !== undefined ? _data["stackTrace"] : null as any;
        }
    }

    static fromJS(data: any): Exception {
        data = typeof data === 'object' ? data : {};
        let result = new Exception();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetSite"] = this.targetSite ? this.targetSite.toJSON() : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (data["data"] as any)[key] = this.data[key] !== undefined ? this.data[key] : null as any;
            }
        }
        data["innerException"] = this.innerException ? this.innerException.toJSON() : null as any;
        data["helpLink"] = this.helpLink !== undefined ? this.helpLink : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["hResult"] = this.hResult !== undefined ? this.hResult : null as any;
        data["stackTrace"] = this.stackTrace !== undefined ? this.stackTrace : null as any;
        return data;
    }
}

export class FacePriceMatchingInPutDto {
    products!: FacePriceMatchingProductInPutDto[] | null;
    vcs!: FacePriceMatchingProductInPutDto[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(FacePriceMatchingProductInPutDto.fromJS(item));
            }
            else {
                this.products = null as any;
            }
            if (Array.isArray(_data["vcs"])) {
                this.vcs = [] as any;
                for (let item of _data["vcs"])
                    this.vcs!.push(FacePriceMatchingProductInPutDto.fromJS(item));
            }
            else {
                this.vcs = null as any;
            }
        }
    }

    static fromJS(data: any): FacePriceMatchingInPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new FacePriceMatchingInPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.vcs)) {
            data["vcs"] = [];
            for (let item of this.vcs)
                data["vcs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class FacePriceMatchingProductInPutDto {
    id!: string;
    unitPrice!: number | null;
    unitPriceResult!: string | null;
    vcProductCode!: string | null;
    unitPriceType!: UnitPriceType;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.vcProductCode = _data["vcProductCode"] !== undefined ? _data["vcProductCode"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
        }
    }

    static fromJS(data: any): FacePriceMatchingProductInPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new FacePriceMatchingProductInPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["vcProductCode"] = this.vcProductCode !== undefined ? this.vcProductCode : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        return data;
    }
}

/** 0 = PrivateScope 1 = Private 2 = FamANDAssem 3 = Assembly 4 = Family 5 = FamORAssem 6 = Public 7 = FieldAccessMask 16 = Static 32 = InitOnly 64 = Literal 128 = NotSerialized 256 = HasFieldRVA 512 = SpecialName 1024 = RTSpecialName 4096 = HasFieldMarshal 8192 = PinvokeImpl 32768 = HasDefault 38144 = ReservedMask */
export enum FieldAttributes {
    PrivateScope = 0,
    Private = 1,
    FamANDAssem = 2,
    Assembly = 3,
    Family = 4,
    FamORAssem = 5,
    Public = 6,
    FieldAccessMask = 7,
    Static = 16,
    InitOnly = 32,
    Literal = 64,
    NotSerialized = 128,
    HasFieldRVA = 256,
    SpecialName = 512,
    RTSpecialName = 1024,
    HasFieldMarshal = 4096,
    PinvokeImpl = 8192,
    HasDefault = 32768,
    ReservedMask = 38144,
}

export class FieldInfo {
    readonly name!: string | null;
    declaringType!: Type;
    reflectedType!: Type;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | null;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    memberType!: MemberTypes;
    attributes!: FieldAttributes;
    fieldType!: Type;
    readonly isInitOnly!: boolean;
    readonly isLiteral!: boolean;
    readonly isNotSerialized!: boolean;
    readonly isPinvokeImpl!: boolean;
    readonly isSpecialName!: boolean;
    readonly isStatic!: boolean;
    readonly isAssembly!: boolean;
    readonly isFamily!: boolean;
    readonly isFamilyAndAssembly!: boolean;
    readonly isFamilyOrAssembly!: boolean;
    readonly isPrivate!: boolean;
    readonly isPublic!: boolean;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    fieldHandle!: RuntimeFieldHandle;

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : null as any;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : null as any;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : null as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            else {
                (this as any).customAttributes = null as any;
            }
            (this as any).isCollectible = _data["isCollectible"] !== undefined ? _data["isCollectible"] : null as any;
            (this as any).metadataToken = _data["metadataToken"] !== undefined ? _data["metadataToken"] : null as any;
            this.memberType = _data["memberType"] !== undefined ? _data["memberType"] : null as any;
            this.attributes = _data["attributes"] !== undefined ? _data["attributes"] : null as any;
            this.fieldType = _data["fieldType"] ? Type.fromJS(_data["fieldType"]) : null as any;
            (this as any).isInitOnly = _data["isInitOnly"] !== undefined ? _data["isInitOnly"] : null as any;
            (this as any).isLiteral = _data["isLiteral"] !== undefined ? _data["isLiteral"] : null as any;
            (this as any).isNotSerialized = _data["isNotSerialized"] !== undefined ? _data["isNotSerialized"] : null as any;
            (this as any).isPinvokeImpl = _data["isPinvokeImpl"] !== undefined ? _data["isPinvokeImpl"] : null as any;
            (this as any).isSpecialName = _data["isSpecialName"] !== undefined ? _data["isSpecialName"] : null as any;
            (this as any).isStatic = _data["isStatic"] !== undefined ? _data["isStatic"] : null as any;
            (this as any).isAssembly = _data["isAssembly"] !== undefined ? _data["isAssembly"] : null as any;
            (this as any).isFamily = _data["isFamily"] !== undefined ? _data["isFamily"] : null as any;
            (this as any).isFamilyAndAssembly = _data["isFamilyAndAssembly"] !== undefined ? _data["isFamilyAndAssembly"] : null as any;
            (this as any).isFamilyOrAssembly = _data["isFamilyOrAssembly"] !== undefined ? _data["isFamilyOrAssembly"] : null as any;
            (this as any).isPrivate = _data["isPrivate"] !== undefined ? _data["isPrivate"] : null as any;
            (this as any).isPublic = _data["isPublic"] !== undefined ? _data["isPublic"] : null as any;
            (this as any).isSecurityCritical = _data["isSecurityCritical"] !== undefined ? _data["isSecurityCritical"] : null as any;
            (this as any).isSecuritySafeCritical = _data["isSecuritySafeCritical"] !== undefined ? _data["isSecuritySafeCritical"] : null as any;
            (this as any).isSecurityTransparent = _data["isSecurityTransparent"] !== undefined ? _data["isSecurityTransparent"] : null as any;
            this.fieldHandle = _data["fieldHandle"] ? RuntimeFieldHandle.fromJS(_data["fieldHandle"]) : null as any;
        }
    }

    static fromJS(data: any): FieldInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FieldInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : null as any;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : null as any;
        data["module"] = this.module ? this.module.toJSON() : null as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : null as any);
        }
        data["isCollectible"] = this.isCollectible !== undefined ? this.isCollectible : null as any;
        data["metadataToken"] = this.metadataToken !== undefined ? this.metadataToken : null as any;
        data["memberType"] = this.memberType !== undefined ? this.memberType : null as any;
        data["attributes"] = this.attributes !== undefined ? this.attributes : null as any;
        data["fieldType"] = this.fieldType ? this.fieldType.toJSON() : null as any;
        data["isInitOnly"] = this.isInitOnly !== undefined ? this.isInitOnly : null as any;
        data["isLiteral"] = this.isLiteral !== undefined ? this.isLiteral : null as any;
        data["isNotSerialized"] = this.isNotSerialized !== undefined ? this.isNotSerialized : null as any;
        data["isPinvokeImpl"] = this.isPinvokeImpl !== undefined ? this.isPinvokeImpl : null as any;
        data["isSpecialName"] = this.isSpecialName !== undefined ? this.isSpecialName : null as any;
        data["isStatic"] = this.isStatic !== undefined ? this.isStatic : null as any;
        data["isAssembly"] = this.isAssembly !== undefined ? this.isAssembly : null as any;
        data["isFamily"] = this.isFamily !== undefined ? this.isFamily : null as any;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly !== undefined ? this.isFamilyAndAssembly : null as any;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly !== undefined ? this.isFamilyOrAssembly : null as any;
        data["isPrivate"] = this.isPrivate !== undefined ? this.isPrivate : null as any;
        data["isPublic"] = this.isPublic !== undefined ? this.isPublic : null as any;
        data["isSecurityCritical"] = this.isSecurityCritical !== undefined ? this.isSecurityCritical : null as any;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical !== undefined ? this.isSecuritySafeCritical : null as any;
        data["isSecurityTransparent"] = this.isSecurityTransparent !== undefined ? this.isSecurityTransparent : null as any;
        data["fieldHandle"] = this.fieldHandle ? this.fieldHandle.toJSON() : null as any;
        return data;
    }
}

export class GenerateReviewNoDto {
    isBookOrder!: boolean;
    prefix!: string | null;
    orderTime!: string | null;
    serialNo!: string | null;
    readonly signal!: string | null;
    deliveryWeek!: string | null;

    init(_data?: any) {
        if (_data) {
            this.isBookOrder = _data["isBookOrder"] !== undefined ? _data["isBookOrder"] : null as any;
            this.prefix = _data["prefix"] !== undefined ? _data["prefix"] : null as any;
            this.orderTime = _data["orderTime"] !== undefined ? _data["orderTime"] : null as any;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : null as any;
            (this as any).signal = _data["signal"] !== undefined ? _data["signal"] : null as any;
            this.deliveryWeek = _data["deliveryWeek"] !== undefined ? _data["deliveryWeek"] : null as any;
        }
    }

    static fromJS(data: any): GenerateReviewNoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateReviewNoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isBookOrder"] = this.isBookOrder !== undefined ? this.isBookOrder : null as any;
        data["prefix"] = this.prefix !== undefined ? this.prefix : null as any;
        data["orderTime"] = this.orderTime !== undefined ? this.orderTime : null as any;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : null as any;
        data["signal"] = this.signal !== undefined ? this.signal : null as any;
        data["deliveryWeek"] = this.deliveryWeek !== undefined ? this.deliveryWeek : null as any;
        return data;
    }
}

/** 0 = None 1 = Covariant 2 = Contravariant 3 = VarianceMask 4 = ReferenceTypeConstraint 8 = NotNullableValueTypeConstraint 16 = DefaultConstructorConstraint 28 = SpecialConstraintMask */
export enum GenericParameterAttributes {
    None = 0,
    Covariant = 1,
    Contravariant = 2,
    VarianceMask = 3,
    ReferenceTypeConstraint = 4,
    NotNullableValueTypeConstraint = 8,
    DefaultConstructorConstraint = 16,
    SpecialConstraintMask = 28,
}

export class GetAllBasicDataOutPutDto {
    name!: string | null;
    value!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
            else {
                this.value = null as any;
            }
        }
    }

    static fromJS(data: any): GetAllBasicDataOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllBasicDataOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }
}

export class GetAllDoubleVCCheckRulesInput {
    maxResultCount!: number;
    skipCount!: number;
    ids!: string[] | null;
    productType!: string | null;
    seatNoMax!: number | null;
    seatNoMin!: number | null;
    vCId1!: string | null;
    vCId2!: string | null;
    rule!: string | null;
    compulsoryType!: number | null;
    promptContent!: string | null;
    creationStartTime!: moment.Moment | null;
    creationEndTime!: moment.Moment | null;
    lastModificationStartTime!: moment.Moment | null;
    lastModificationEndTime!: moment.Moment | null;
    isDeleted!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            else {
                this.ids = null as any;
            }
            this.productType = _data["productType"] !== undefined ? _data["productType"] : null as any;
            this.seatNoMax = _data["seatNoMax"] !== undefined ? _data["seatNoMax"] : null as any;
            this.seatNoMin = _data["seatNoMin"] !== undefined ? _data["seatNoMin"] : null as any;
            this.vCId1 = _data["vCId1"] !== undefined ? _data["vCId1"] : null as any;
            this.vCId2 = _data["vCId2"] !== undefined ? _data["vCId2"] : null as any;
            this.rule = _data["rule"] !== undefined ? _data["rule"] : null as any;
            this.compulsoryType = _data["compulsoryType"] !== undefined ? _data["compulsoryType"] : null as any;
            this.promptContent = _data["promptContent"] !== undefined ? _data["promptContent"] : null as any;
            this.creationStartTime = _data["creationStartTime"] ? moment(_data["creationStartTime"].toString()) : null as any;
            this.creationEndTime = _data["creationEndTime"] ? moment(_data["creationEndTime"].toString()) : null as any;
            this.lastModificationStartTime = _data["lastModificationStartTime"] ? moment(_data["lastModificationStartTime"].toString()) : null as any;
            this.lastModificationEndTime = _data["lastModificationEndTime"] ? moment(_data["lastModificationEndTime"].toString()) : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
        }
    }

    static fromJS(data: any): GetAllDoubleVCCheckRulesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllDoubleVCCheckRulesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["productType"] = this.productType !== undefined ? this.productType : null as any;
        data["seatNoMax"] = this.seatNoMax !== undefined ? this.seatNoMax : null as any;
        data["seatNoMin"] = this.seatNoMin !== undefined ? this.seatNoMin : null as any;
        data["vCId1"] = this.vCId1 !== undefined ? this.vCId1 : null as any;
        data["vCId2"] = this.vCId2 !== undefined ? this.vCId2 : null as any;
        data["rule"] = this.rule !== undefined ? this.rule : null as any;
        data["compulsoryType"] = this.compulsoryType !== undefined ? this.compulsoryType : null as any;
        data["promptContent"] = this.promptContent !== undefined ? this.promptContent : null as any;
        data["creationStartTime"] = this.creationStartTime ? this.creationStartTime.toISOString() : null as any;
        data["creationEndTime"] = this.creationEndTime ? this.creationEndTime.toISOString() : null as any;
        data["lastModificationStartTime"] = this.lastModificationStartTime ? this.lastModificationStartTime.toISOString() : null as any;
        data["lastModificationEndTime"] = this.lastModificationEndTime ? this.lastModificationEndTime.toISOString() : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        return data;
    }
}

export class GetAllNumberWiresCheckRulesInput {
    maxResultCount!: number;
    skipCount!: number;
    ids!: string[] | null;
    productType!: string | null;
    seatNoMax!: number | null;
    seatNoMin!: number | null;
    maxNumberWires!: number | null;
    compulsoryType!: number | null;
    content!: string | null;
    creationStartTime!: moment.Moment | null;
    creationEndTime!: moment.Moment | null;
    lastModificationStartTime!: moment.Moment | null;
    lastModificationEndTime!: moment.Moment | null;
    isDeleted!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            else {
                this.ids = null as any;
            }
            this.productType = _data["productType"] !== undefined ? _data["productType"] : null as any;
            this.seatNoMax = _data["seatNoMax"] !== undefined ? _data["seatNoMax"] : null as any;
            this.seatNoMin = _data["seatNoMin"] !== undefined ? _data["seatNoMin"] : null as any;
            this.maxNumberWires = _data["maxNumberWires"] !== undefined ? _data["maxNumberWires"] : null as any;
            this.compulsoryType = _data["compulsoryType"] !== undefined ? _data["compulsoryType"] : null as any;
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
            this.creationStartTime = _data["creationStartTime"] ? moment(_data["creationStartTime"].toString()) : null as any;
            this.creationEndTime = _data["creationEndTime"] ? moment(_data["creationEndTime"].toString()) : null as any;
            this.lastModificationStartTime = _data["lastModificationStartTime"] ? moment(_data["lastModificationStartTime"].toString()) : null as any;
            this.lastModificationEndTime = _data["lastModificationEndTime"] ? moment(_data["lastModificationEndTime"].toString()) : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
        }
    }

    static fromJS(data: any): GetAllNumberWiresCheckRulesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllNumberWiresCheckRulesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["productType"] = this.productType !== undefined ? this.productType : null as any;
        data["seatNoMax"] = this.seatNoMax !== undefined ? this.seatNoMax : null as any;
        data["seatNoMin"] = this.seatNoMin !== undefined ? this.seatNoMin : null as any;
        data["maxNumberWires"] = this.maxNumberWires !== undefined ? this.maxNumberWires : null as any;
        data["compulsoryType"] = this.compulsoryType !== undefined ? this.compulsoryType : null as any;
        data["content"] = this.content !== undefined ? this.content : null as any;
        data["creationStartTime"] = this.creationStartTime ? this.creationStartTime.toISOString() : null as any;
        data["creationEndTime"] = this.creationEndTime ? this.creationEndTime.toISOString() : null as any;
        data["lastModificationStartTime"] = this.lastModificationStartTime ? this.lastModificationStartTime.toISOString() : null as any;
        data["lastModificationEndTime"] = this.lastModificationEndTime ? this.lastModificationEndTime.toISOString() : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        return data;
    }
}

export class GetAllSingleVCNotificationRulesInput {
    maxResultCount!: number;
    skipCount!: number;
    ids!: string[] | null;
    productType!: string | null;
    seatNoMax!: number | null;
    seatNoMin!: number | null;
    promptContent!: string | null;
    vCId!: string | null;
    creationStartTime!: moment.Moment | null;
    creationEndTime!: moment.Moment | null;
    lastModificationStartTime!: moment.Moment | null;
    lastModificationEndTime!: moment.Moment | null;
    isDeleted!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            else {
                this.ids = null as any;
            }
            this.productType = _data["productType"] !== undefined ? _data["productType"] : null as any;
            this.seatNoMax = _data["seatNoMax"] !== undefined ? _data["seatNoMax"] : null as any;
            this.seatNoMin = _data["seatNoMin"] !== undefined ? _data["seatNoMin"] : null as any;
            this.promptContent = _data["promptContent"] !== undefined ? _data["promptContent"] : null as any;
            this.vCId = _data["vCId"] !== undefined ? _data["vCId"] : null as any;
            this.creationStartTime = _data["creationStartTime"] ? moment(_data["creationStartTime"].toString()) : null as any;
            this.creationEndTime = _data["creationEndTime"] ? moment(_data["creationEndTime"].toString()) : null as any;
            this.lastModificationStartTime = _data["lastModificationStartTime"] ? moment(_data["lastModificationStartTime"].toString()) : null as any;
            this.lastModificationEndTime = _data["lastModificationEndTime"] ? moment(_data["lastModificationEndTime"].toString()) : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
        }
    }

    static fromJS(data: any): GetAllSingleVCNotificationRulesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSingleVCNotificationRulesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["productType"] = this.productType !== undefined ? this.productType : null as any;
        data["seatNoMax"] = this.seatNoMax !== undefined ? this.seatNoMax : null as any;
        data["seatNoMin"] = this.seatNoMin !== undefined ? this.seatNoMin : null as any;
        data["promptContent"] = this.promptContent !== undefined ? this.promptContent : null as any;
        data["vCId"] = this.vCId !== undefined ? this.vCId : null as any;
        data["creationStartTime"] = this.creationStartTime ? this.creationStartTime.toISOString() : null as any;
        data["creationEndTime"] = this.creationEndTime ? this.creationEndTime.toISOString() : null as any;
        data["lastModificationStartTime"] = this.lastModificationStartTime ? this.lastModificationStartTime.toISOString() : null as any;
        data["lastModificationEndTime"] = this.lastModificationEndTime ? this.lastModificationEndTime.toISOString() : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        return data;
    }
}

export class GetAllThreeBasicMotorSriesOutPutDto {
    id!: number;
    name!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): GetAllThreeBasicMotorSriesOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllThreeBasicMotorSriesOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export class GetAllVCGroupRulesInput {
    maxResultCount!: number;
    skipCount!: number;
    ids!: string[] | null;
    productType!: string | null;
    seatNoMax!: number | null;
    seatNoMin!: number | null;
    compulsoryType!: number | null;
    promptContent!: string | null;
    vCIds!: string[] | null;
    poleNos!: string[] | null;
    creationStartTime!: moment.Moment | null;
    creationEndTime!: moment.Moment | null;
    lastModificationStartTime!: moment.Moment | null;
    lastModificationEndTime!: moment.Moment | null;
    isDeleted!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            else {
                this.ids = null as any;
            }
            this.productType = _data["productType"] !== undefined ? _data["productType"] : null as any;
            this.seatNoMax = _data["seatNoMax"] !== undefined ? _data["seatNoMax"] : null as any;
            this.seatNoMin = _data["seatNoMin"] !== undefined ? _data["seatNoMin"] : null as any;
            this.compulsoryType = _data["compulsoryType"] !== undefined ? _data["compulsoryType"] : null as any;
            this.promptContent = _data["promptContent"] !== undefined ? _data["promptContent"] : null as any;
            if (Array.isArray(_data["vCIds"])) {
                this.vCIds = [] as any;
                for (let item of _data["vCIds"])
                    this.vCIds!.push(item);
            }
            else {
                this.vCIds = null as any;
            }
            if (Array.isArray(_data["poleNos"])) {
                this.poleNos = [] as any;
                for (let item of _data["poleNos"])
                    this.poleNos!.push(item);
            }
            else {
                this.poleNos = null as any;
            }
            this.creationStartTime = _data["creationStartTime"] ? moment(_data["creationStartTime"].toString()) : null as any;
            this.creationEndTime = _data["creationEndTime"] ? moment(_data["creationEndTime"].toString()) : null as any;
            this.lastModificationStartTime = _data["lastModificationStartTime"] ? moment(_data["lastModificationStartTime"].toString()) : null as any;
            this.lastModificationEndTime = _data["lastModificationEndTime"] ? moment(_data["lastModificationEndTime"].toString()) : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
        }
    }

    static fromJS(data: any): GetAllVCGroupRulesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllVCGroupRulesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["productType"] = this.productType !== undefined ? this.productType : null as any;
        data["seatNoMax"] = this.seatNoMax !== undefined ? this.seatNoMax : null as any;
        data["seatNoMin"] = this.seatNoMin !== undefined ? this.seatNoMin : null as any;
        data["compulsoryType"] = this.compulsoryType !== undefined ? this.compulsoryType : null as any;
        data["promptContent"] = this.promptContent !== undefined ? this.promptContent : null as any;
        if (Array.isArray(this.vCIds)) {
            data["vCIds"] = [];
            for (let item of this.vCIds)
                data["vCIds"].push(item);
        }
        if (Array.isArray(this.poleNos)) {
            data["poleNos"] = [];
            for (let item of this.poleNos)
                data["poleNos"].push(item);
        }
        data["creationStartTime"] = this.creationStartTime ? this.creationStartTime.toISOString() : null as any;
        data["creationEndTime"] = this.creationEndTime ? this.creationEndTime.toISOString() : null as any;
        data["lastModificationStartTime"] = this.lastModificationStartTime ? this.lastModificationStartTime.toISOString() : null as any;
        data["lastModificationEndTime"] = this.lastModificationEndTime ? this.lastModificationEndTime.toISOString() : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        return data;
    }
}

/** 获取GCS授权用户信息 */
export class GetAuthorizedUserCustomerOutputDto {
    /** 用户名称 */
    userName!: string | null;
    /** 用户Id */
    userId!: number;
    /** 用户类型 */
    userType!: number;
    customerInfos!: AuthorizedUserCustomerInfoOutPutDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.userType = _data["userType"] !== undefined ? _data["userType"] : null as any;
            if (Array.isArray(_data["customerInfos"])) {
                this.customerInfos = [] as any;
                for (let item of _data["customerInfos"])
                    this.customerInfos!.push(AuthorizedUserCustomerInfoOutPutDto.fromJS(item));
            }
            else {
                this.customerInfos = null as any;
            }
        }
    }

    static fromJS(data: any): GetAuthorizedUserCustomerOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuthorizedUserCustomerOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userType"] = this.userType !== undefined ? this.userType : null as any;
        if (Array.isArray(this.customerInfos)) {
            data["customerInfos"] = [];
            for (let item of this.customerInfos)
                data["customerInfos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetAuthorizedUserCustomerOutputDtoPagedResultDto {
    items!: GetAuthorizedUserCustomerOutputDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAuthorizedUserCustomerOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): GetAuthorizedUserCustomerOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuthorizedUserCustomerOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class GetCheckRuleDetailDto {
    id!: string;
    vcID!: string;
    meaning!: string | null;
    englishMeaning!: string | null;
    numberWires!: number;
    vcTypeDescription!: string | null;
    categoryId!: string;
    category!: string | null;
    vcShowType!: VCShowType;
    attributeName!: string | null;
    attributeSelect!: string | null;
    frameNo!: number;
    basicMotorSries!: string | null;
    mainVC!: string | null;
    scmCycle!: number | null;
    scmCalculationMode!: string | null;
    scmRemark!: string | null;
    extraOverlayTime!: boolean | null;
    isOverlayLogic!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.attributeName = _data["attributeName"] !== undefined ? _data["attributeName"] : null as any;
            this.attributeSelect = _data["attributeSelect"] !== undefined ? _data["attributeSelect"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.mainVC = _data["mainVC"] !== undefined ? _data["mainVC"] : null as any;
            this.scmCycle = _data["scmCycle"] !== undefined ? _data["scmCycle"] : null as any;
            this.scmCalculationMode = _data["scmCalculationMode"] !== undefined ? _data["scmCalculationMode"] : null as any;
            this.scmRemark = _data["scmRemark"] !== undefined ? _data["scmRemark"] : null as any;
            this.extraOverlayTime = _data["extraOverlayTime"] !== undefined ? _data["extraOverlayTime"] : null as any;
            this.isOverlayLogic = _data["isOverlayLogic"] !== undefined ? _data["isOverlayLogic"] : null as any;
        }
    }

    static fromJS(data: any): GetCheckRuleDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCheckRuleDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["attributeName"] = this.attributeName !== undefined ? this.attributeName : null as any;
        data["attributeSelect"] = this.attributeSelect !== undefined ? this.attributeSelect : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["mainVC"] = this.mainVC !== undefined ? this.mainVC : null as any;
        data["scmCycle"] = this.scmCycle !== undefined ? this.scmCycle : null as any;
        data["scmCalculationMode"] = this.scmCalculationMode !== undefined ? this.scmCalculationMode : null as any;
        data["scmRemark"] = this.scmRemark !== undefined ? this.scmRemark : null as any;
        data["extraOverlayTime"] = this.extraOverlayTime !== undefined ? this.extraOverlayTime : null as any;
        data["isOverlayLogic"] = this.isOverlayLogic !== undefined ? this.isOverlayLogic : null as any;
        return data;
    }
}

export class GetCodesVersionAndVcsInputDto {
    code!: string | null;
    version!: string | null;

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
        }
    }

    static fromJS(data: any): GetCodesVersionAndVcsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCodesVersionAndVcsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        return data;
    }
}

export class GetCustomMotorInfoDetailDto {
    id!: string;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 产品类型 */
    basicMotorSriesId!: number;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 机座号 */
    frameNo!: number;
    /** 安装方式 */
    basicMotorMounting!: string | null;
    /** 极数 */
    poleNo!: string | null;
    isHaveVc!: IsHaveVc;
    /** 电压代码 */
    voltageCode!: string | null;
    isNeedHeightOutput!: IsYes;
    /** 能效 */
    eneEff!: string | null;
    /** 自制OR外购 */
    makeOrBuy!: string | null;
    /** 工程周期（自然天） */
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    /** 采购周期（自然天） */
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    /** 生产周期（自然天） */
    productionCycle!: number;
    /** 测试周期（自然天） */
    testCycle!: number;
    /** 产能周期（自然天） */
    capacityCycle!: number;
    /** GR增量 */
    grCycle!: number;
    /** 入库到出库时间 */
    inToOutCycle!: number;
    /** 自定义电机参数 */
    customMotorParameters!: CustomMotorInfoParamDto[] | null;
    basicMotorSries!: string | null;
    /** 单价 */
    unitPrice!: number | null;
    /** 面价公式 */
    unitPriceFormula!: string | null;
    /** 打折类型 */
    unitPriceType!: number | null;
    /** 成本 */
    cost!: number | null;
    /** 成本公式 */
    costFormula!: string | null;
    costType!: CostType;
    /** 成本类型详情 */
    costTypeDetail!: string | null;
    /** 报价原则 */
    quotationPrinciple!: string | null;
    /** 报价原则详情 */
    quotationPrincipleDetails!: string | null;
    /** 产能周期更新/确认时间 */
    capacityCycleUpdateTime!: moment.Moment | null;
    /** 工程周期更新/确认时间 */
    engineeringCycleUpdateTime!: moment.Moment | null;
    /** 生产周期更新/确认时间 */
    productionCycleUpdateTime!: moment.Moment | null;
    /** 采购周期更新/确认时间 */
    purchaseCycleUpdateTime!: moment.Moment | null;
    /** 测试周期更新/确认时间 */
    testCycleUpdateTime!: moment.Moment | null;
    /** GR增量更新时间/确认时间 */
    grCycleUpdateTime!: moment.Moment | null;
    /** 入库到出库更新时间/确认时间 */
    inToOutCycleUpdateTime!: moment.Moment | null;
    status!: CustomMotorInfoSatus;
    /** 备注 */
    dqRemark!: string | null;
    customMotorEditApprovals!: CustomMotorEditApprovalDto[] | null;
    newCustomMotorInfo!: GetCustomMotorInfoDetailDto;
    relBasicMotorCodeType!: BasicMotorCodeType;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSriesId = _data["basicMotorSriesId"] !== undefined ? _data["basicMotorSriesId"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.isHaveVc = _data["isHaveVc"] !== undefined ? _data["isHaveVc"] : null as any;
            this.voltageCode = _data["voltageCode"] !== undefined ? _data["voltageCode"] : null as any;
            this.isNeedHeightOutput = _data["isNeedHeightOutput"] !== undefined ? _data["isNeedHeightOutput"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.capacityCycle = _data["capacityCycle"] !== undefined ? _data["capacityCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.inToOutCycle = _data["inToOutCycle"] !== undefined ? _data["inToOutCycle"] : null as any;
            if (Array.isArray(_data["customMotorParameters"])) {
                this.customMotorParameters = [] as any;
                for (let item of _data["customMotorParameters"])
                    this.customMotorParameters!.push(CustomMotorInfoParamDto.fromJS(item));
            }
            else {
                this.customMotorParameters = null as any;
            }
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.capacityCycleUpdateTime = _data["capacityCycleUpdateTime"] ? moment(_data["capacityCycleUpdateTime"].toString()) : null as any;
            this.engineeringCycleUpdateTime = _data["engineeringCycleUpdateTime"] ? moment(_data["engineeringCycleUpdateTime"].toString()) : null as any;
            this.productionCycleUpdateTime = _data["productionCycleUpdateTime"] ? moment(_data["productionCycleUpdateTime"].toString()) : null as any;
            this.purchaseCycleUpdateTime = _data["purchaseCycleUpdateTime"] ? moment(_data["purchaseCycleUpdateTime"].toString()) : null as any;
            this.testCycleUpdateTime = _data["testCycleUpdateTime"] ? moment(_data["testCycleUpdateTime"].toString()) : null as any;
            this.grCycleUpdateTime = _data["grCycleUpdateTime"] ? moment(_data["grCycleUpdateTime"].toString()) : null as any;
            this.inToOutCycleUpdateTime = _data["inToOutCycleUpdateTime"] ? moment(_data["inToOutCycleUpdateTime"].toString()) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.dqRemark = _data["dqRemark"] !== undefined ? _data["dqRemark"] : null as any;
            if (Array.isArray(_data["customMotorEditApprovals"])) {
                this.customMotorEditApprovals = [] as any;
                for (let item of _data["customMotorEditApprovals"])
                    this.customMotorEditApprovals!.push(CustomMotorEditApprovalDto.fromJS(item));
            }
            else {
                this.customMotorEditApprovals = null as any;
            }
            this.newCustomMotorInfo = _data["newCustomMotorInfo"] ? GetCustomMotorInfoDetailDto.fromJS(_data["newCustomMotorInfo"]) : null as any;
            this.relBasicMotorCodeType = _data["relBasicMotorCodeType"] !== undefined ? _data["relBasicMotorCodeType"] : null as any;
        }
    }

    static fromJS(data: any): GetCustomMotorInfoDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomMotorInfoDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSriesId"] = this.basicMotorSriesId !== undefined ? this.basicMotorSriesId : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["isHaveVc"] = this.isHaveVc !== undefined ? this.isHaveVc : null as any;
        data["voltageCode"] = this.voltageCode !== undefined ? this.voltageCode : null as any;
        data["isNeedHeightOutput"] = this.isNeedHeightOutput !== undefined ? this.isNeedHeightOutput : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["capacityCycle"] = this.capacityCycle !== undefined ? this.capacityCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["inToOutCycle"] = this.inToOutCycle !== undefined ? this.inToOutCycle : null as any;
        if (Array.isArray(this.customMotorParameters)) {
            data["customMotorParameters"] = [];
            for (let item of this.customMotorParameters)
                data["customMotorParameters"].push(item ? item.toJSON() : null as any);
        }
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["capacityCycleUpdateTime"] = this.capacityCycleUpdateTime ? this.capacityCycleUpdateTime.toISOString() : null as any;
        data["engineeringCycleUpdateTime"] = this.engineeringCycleUpdateTime ? this.engineeringCycleUpdateTime.toISOString() : null as any;
        data["productionCycleUpdateTime"] = this.productionCycleUpdateTime ? this.productionCycleUpdateTime.toISOString() : null as any;
        data["purchaseCycleUpdateTime"] = this.purchaseCycleUpdateTime ? this.purchaseCycleUpdateTime.toISOString() : null as any;
        data["testCycleUpdateTime"] = this.testCycleUpdateTime ? this.testCycleUpdateTime.toISOString() : null as any;
        data["grCycleUpdateTime"] = this.grCycleUpdateTime ? this.grCycleUpdateTime.toISOString() : null as any;
        data["inToOutCycleUpdateTime"] = this.inToOutCycleUpdateTime ? this.inToOutCycleUpdateTime.toISOString() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["dqRemark"] = this.dqRemark !== undefined ? this.dqRemark : null as any;
        if (Array.isArray(this.customMotorEditApprovals)) {
            data["customMotorEditApprovals"] = [];
            for (let item of this.customMotorEditApprovals)
                data["customMotorEditApprovals"].push(item ? item.toJSON() : null as any);
        }
        data["newCustomMotorInfo"] = this.newCustomMotorInfo ? this.newCustomMotorInfo.toJSON() : null as any;
        data["relBasicMotorCodeType"] = this.relBasicMotorCodeType !== undefined ? this.relBasicMotorCodeType : null as any;
        return data;
    }
}

export class GetCustomerComboxSelectDto {
    /** 功率 */
    power!: SelectDto[] | null;
    /** 极数 */
    poleNo!: SelectDto[] | null;
    /** 能效 */
    eneEff!: SelectDto[] | null;
    /** 电压 */
    voltage!: SelectDto[] | null;
    /** 频率 */
    frequency!: SelectDto[] | null;
    /** 安装方式 */
    basicMotorMounting!: SelectDto[] | null;
    frameNo!: SelectDto[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["power"])) {
                this.power = [] as any;
                for (let item of _data["power"])
                    this.power!.push(SelectDto.fromJS(item));
            }
            else {
                this.power = null as any;
            }
            if (Array.isArray(_data["poleNo"])) {
                this.poleNo = [] as any;
                for (let item of _data["poleNo"])
                    this.poleNo!.push(SelectDto.fromJS(item));
            }
            else {
                this.poleNo = null as any;
            }
            if (Array.isArray(_data["eneEff"])) {
                this.eneEff = [] as any;
                for (let item of _data["eneEff"])
                    this.eneEff!.push(SelectDto.fromJS(item));
            }
            else {
                this.eneEff = null as any;
            }
            if (Array.isArray(_data["voltage"])) {
                this.voltage = [] as any;
                for (let item of _data["voltage"])
                    this.voltage!.push(SelectDto.fromJS(item));
            }
            else {
                this.voltage = null as any;
            }
            if (Array.isArray(_data["frequency"])) {
                this.frequency = [] as any;
                for (let item of _data["frequency"])
                    this.frequency!.push(SelectDto.fromJS(item));
            }
            else {
                this.frequency = null as any;
            }
            if (Array.isArray(_data["basicMotorMounting"])) {
                this.basicMotorMounting = [] as any;
                for (let item of _data["basicMotorMounting"])
                    this.basicMotorMounting!.push(SelectDto.fromJS(item));
            }
            else {
                this.basicMotorMounting = null as any;
            }
            if (Array.isArray(_data["frameNo"])) {
                this.frameNo = [] as any;
                for (let item of _data["frameNo"])
                    this.frameNo!.push(SelectDto.fromJS(item));
            }
            else {
                this.frameNo = null as any;
            }
        }
    }

    static fromJS(data: any): GetCustomerComboxSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerComboxSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.power)) {
            data["power"] = [];
            for (let item of this.power)
                data["power"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.poleNo)) {
            data["poleNo"] = [];
            for (let item of this.poleNo)
                data["poleNo"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.eneEff)) {
            data["eneEff"] = [];
            for (let item of this.eneEff)
                data["eneEff"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.voltage)) {
            data["voltage"] = [];
            for (let item of this.voltage)
                data["voltage"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.frequency)) {
            data["frequency"] = [];
            for (let item of this.frequency)
                data["frequency"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.basicMotorMounting)) {
            data["basicMotorMounting"] = [];
            for (let item of this.basicMotorMounting)
                data["basicMotorMounting"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.frameNo)) {
            data["frameNo"] = [];
            for (let item of this.frameNo)
                data["frameNo"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetCycleDetailDto {
    id!: string;
    product!: string | null;
    /** 工程周期（自然天） */
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    /** 采购周期（自然天） */
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    /** 生产周期（自然天） */
    productionCycle!: number;
    /** 产能周期（自然天） */
    capacityCycle!: number;
    /** GR增量 */
    grCycle!: number;
    /** 测试周期（自然天） */
    testCycle!: number;
    /** 入库到出库时间 */
    inToOutCycle!: number;
    /** 自制OR外购 */
    makeOrBuy!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.product = _data["product"] !== undefined ? _data["product"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.capacityCycle = _data["capacityCycle"] !== undefined ? _data["capacityCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.inToOutCycle = _data["inToOutCycle"] !== undefined ? _data["inToOutCycle"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
        }
    }

    static fromJS(data: any): GetCycleDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCycleDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["product"] = this.product !== undefined ? this.product : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["capacityCycle"] = this.capacityCycle !== undefined ? this.capacityCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["inToOutCycle"] = this.inToOutCycle !== undefined ? this.inToOutCycle : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        return data;
    }
}

export class GetDomesticQuotationDetailsOutPutDto {
    id!: string;
    userFriendlyID!: string | null;
    cycle!: number;
    clienter!: string | null;
    clientName!: string | null;
    finalCustomerCode!: string | null;
    finalCustomerName!: string | null;
    domesticQuotationNumber!: string | null;
    dqAttachs!: string | null;
    dqRemark!: string | null;
    projectName!: string | null;
    isOnceProject!: boolean;
    pmsProjectType!: number | null;
    isSourceLP!: boolean;
    sourceType!: SourceType;
    dqStatus!: TechnologyQuotationStatus;
    quotationExpiredTime!: moment.Moment | null;
    technologyQuotationProducts!: DomesticQuotationDetailsProduct[] | null;
    quotationApprovals!: DomesticQuotationDetailsApproval[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.userFriendlyID = _data["userFriendlyID"] !== undefined ? _data["userFriendlyID"] : null as any;
            this.cycle = _data["cycle"] !== undefined ? _data["cycle"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.domesticQuotationNumber = _data["domesticQuotationNumber"] !== undefined ? _data["domesticQuotationNumber"] : null as any;
            this.dqAttachs = _data["dqAttachs"] !== undefined ? _data["dqAttachs"] : null as any;
            this.dqRemark = _data["dqRemark"] !== undefined ? _data["dqRemark"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.isOnceProject = _data["isOnceProject"] !== undefined ? _data["isOnceProject"] : null as any;
            this.pmsProjectType = _data["pmsProjectType"] !== undefined ? _data["pmsProjectType"] : null as any;
            this.isSourceLP = _data["isSourceLP"] !== undefined ? _data["isSourceLP"] : null as any;
            this.sourceType = _data["sourceType"] !== undefined ? _data["sourceType"] : null as any;
            this.dqStatus = _data["dqStatus"] !== undefined ? _data["dqStatus"] : null as any;
            this.quotationExpiredTime = _data["quotationExpiredTime"] ? moment(_data["quotationExpiredTime"].toString()) : null as any;
            if (Array.isArray(_data["technologyQuotationProducts"])) {
                this.technologyQuotationProducts = [] as any;
                for (let item of _data["technologyQuotationProducts"])
                    this.technologyQuotationProducts!.push(DomesticQuotationDetailsProduct.fromJS(item));
            }
            else {
                this.technologyQuotationProducts = null as any;
            }
            if (Array.isArray(_data["quotationApprovals"])) {
                this.quotationApprovals = [] as any;
                for (let item of _data["quotationApprovals"])
                    this.quotationApprovals!.push(DomesticQuotationDetailsApproval.fromJS(item));
            }
            else {
                this.quotationApprovals = null as any;
            }
        }
    }

    static fromJS(data: any): GetDomesticQuotationDetailsOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDomesticQuotationDetailsOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["userFriendlyID"] = this.userFriendlyID !== undefined ? this.userFriendlyID : null as any;
        data["cycle"] = this.cycle !== undefined ? this.cycle : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["domesticQuotationNumber"] = this.domesticQuotationNumber !== undefined ? this.domesticQuotationNumber : null as any;
        data["dqAttachs"] = this.dqAttachs !== undefined ? this.dqAttachs : null as any;
        data["dqRemark"] = this.dqRemark !== undefined ? this.dqRemark : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["isOnceProject"] = this.isOnceProject !== undefined ? this.isOnceProject : null as any;
        data["pmsProjectType"] = this.pmsProjectType !== undefined ? this.pmsProjectType : null as any;
        data["isSourceLP"] = this.isSourceLP !== undefined ? this.isSourceLP : null as any;
        data["sourceType"] = this.sourceType !== undefined ? this.sourceType : null as any;
        data["dqStatus"] = this.dqStatus !== undefined ? this.dqStatus : null as any;
        data["quotationExpiredTime"] = this.quotationExpiredTime ? this.quotationExpiredTime.toISOString() : null as any;
        if (Array.isArray(this.technologyQuotationProducts)) {
            data["technologyQuotationProducts"] = [];
            for (let item of this.technologyQuotationProducts)
                data["technologyQuotationProducts"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.quotationApprovals)) {
            data["quotationApprovals"] = [];
            for (let item of this.quotationApprovals)
                data["quotationApprovals"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetDoubleVCCheckRulesForEditOutput {
    doubleVCCheckRules!: CreateOrEditDoubleVCCheckRulesDto;

    init(_data?: any) {
        if (_data) {
            this.doubleVCCheckRules = _data["doubleVCCheckRules"] ? CreateOrEditDoubleVCCheckRulesDto.fromJS(_data["doubleVCCheckRules"]) : null as any;
        }
    }

    static fromJS(data: any): GetDoubleVCCheckRulesForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDoubleVCCheckRulesForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doubleVCCheckRules"] = this.doubleVCCheckRules ? this.doubleVCCheckRules.toJSON() : null as any;
        return data;
    }
}

export class GetDraftsInPutDto {
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | null;
    userFriendlyID!: string | null;
    name!: string | null;
    clientId!: string | null;
    appraisalNumber!: string | null;
    date!: moment.Moment[] | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.filter = _data["filter"] !== undefined ? _data["filter"] : null as any;
            this.userFriendlyID = _data["userFriendlyID"] !== undefined ? _data["userFriendlyID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            if (Array.isArray(_data["date"])) {
                this.date = [] as any;
                for (let item of _data["date"])
                    this.date!.push(moment(item));
            }
            else {
                this.date = null as any;
            }
        }
    }

    static fromJS(data: any): GetDraftsInPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDraftsInPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["filter"] = this.filter !== undefined ? this.filter : null as any;
        data["userFriendlyID"] = this.userFriendlyID !== undefined ? this.userFriendlyID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        if (Array.isArray(this.date)) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item.toISOString());
        }
        return data;
    }
}

export class GetDraftsOutPutDto {
    id!: string;
    userFriendlyID!: string | null;
    name!: string | null;
    clientName!: string | null;
    finalCustomerName!: string | null;
    shippingAddressCode!: string | null;
    shippingAddress!: string | null;
    saleId!: number | null;
    saleName!: string | null;
    createId!: number | null;
    createName!: string | null;
    lastModificationTime!: moment.Moment | null;
    type!: LectoTypeStatus;
    sourceType!: SourceType;
    pmsProjectCode!: string | null;
    version!: number | null;
    pmsCount!: number;
    isHasOneCode!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.userFriendlyID = _data["userFriendlyID"] !== undefined ? _data["userFriendlyID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.shippingAddressCode = _data["shippingAddressCode"] !== undefined ? _data["shippingAddressCode"] : null as any;
            this.shippingAddress = _data["shippingAddress"] !== undefined ? _data["shippingAddress"] : null as any;
            this.saleId = _data["saleId"] !== undefined ? _data["saleId"] : null as any;
            this.saleName = _data["saleName"] !== undefined ? _data["saleName"] : null as any;
            this.createId = _data["createId"] !== undefined ? _data["createId"] : null as any;
            this.createName = _data["createName"] !== undefined ? _data["createName"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.sourceType = _data["sourceType"] !== undefined ? _data["sourceType"] : null as any;
            this.pmsProjectCode = _data["pmsProjectCode"] !== undefined ? _data["pmsProjectCode"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.pmsCount = _data["pmsCount"] !== undefined ? _data["pmsCount"] : null as any;
            this.isHasOneCode = _data["isHasOneCode"] !== undefined ? _data["isHasOneCode"] : null as any;
        }
    }

    static fromJS(data: any): GetDraftsOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDraftsOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["userFriendlyID"] = this.userFriendlyID !== undefined ? this.userFriendlyID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["shippingAddressCode"] = this.shippingAddressCode !== undefined ? this.shippingAddressCode : null as any;
        data["shippingAddress"] = this.shippingAddress !== undefined ? this.shippingAddress : null as any;
        data["saleId"] = this.saleId !== undefined ? this.saleId : null as any;
        data["saleName"] = this.saleName !== undefined ? this.saleName : null as any;
        data["createId"] = this.createId !== undefined ? this.createId : null as any;
        data["createName"] = this.createName !== undefined ? this.createName : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["sourceType"] = this.sourceType !== undefined ? this.sourceType : null as any;
        data["pmsProjectCode"] = this.pmsProjectCode !== undefined ? this.pmsProjectCode : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["pmsCount"] = this.pmsCount !== undefined ? this.pmsCount : null as any;
        data["isHasOneCode"] = this.isHasOneCode !== undefined ? this.isHasOneCode : null as any;
        return data;
    }
}

export class GetDraftsOutPutDtoPagedResultDto {
    items!: GetDraftsOutPutDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetDraftsOutPutDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): GetDraftsOutPutDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDraftsOutPutDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class GetGCSByCustomerAndLectoTypeIdDto {
    /** 客户信息 */
    customerInfos!: ClienterAndFinalCustomerDto[] | null;
    /** 选型Id */
    lectoTypeId!: string | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customerInfos"])) {
                this.customerInfos = [] as any;
                for (let item of _data["customerInfos"])
                    this.customerInfos!.push(ClienterAndFinalCustomerDto.fromJS(item));
            }
            else {
                this.customerInfos = null as any;
            }
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
        }
    }

    static fromJS(data: any): GetGCSByCustomerAndLectoTypeIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGCSByCustomerAndLectoTypeIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customerInfos)) {
            data["customerInfos"] = [];
            for (let item of this.customerInfos)
                data["customerInfos"].push(item ? item.toJSON() : null as any);
        }
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        return data;
    }
}

export class GetGCSByCustomerInputDto {
    /** 一级客户名称 */
    clienters!: string[] | null;
    /** 二级客户 */
    finalCustomerCodes!: string[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clienters"])) {
                this.clienters = [] as any;
                for (let item of _data["clienters"])
                    this.clienters!.push(item);
            }
            else {
                this.clienters = null as any;
            }
            if (Array.isArray(_data["finalCustomerCodes"])) {
                this.finalCustomerCodes = [] as any;
                for (let item of _data["finalCustomerCodes"])
                    this.finalCustomerCodes!.push(item);
            }
            else {
                this.finalCustomerCodes = null as any;
            }
        }
    }

    static fromJS(data: any): GetGCSByCustomerInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGCSByCustomerInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clienters)) {
            data["clienters"] = [];
            for (let item of this.clienters)
                data["clienters"].push(item);
        }
        if (Array.isArray(this.finalCustomerCodes)) {
            data["finalCustomerCodes"] = [];
            for (let item of this.finalCustomerCodes)
                data["finalCustomerCodes"].push(item);
        }
        return data;
    }
}

export class GetGCSByCustomerOutputDto {
    /** 二级客户名称 */
    finalCustomerName!: string | null;
    /** 二级客户代码 */
    finalCustomerCode!: string | null;
    /** 一级客户 */
    clienter!: string | null;
    /** 一级客户名称（冗余字段） */
    clientName!: string | null;
    userInfos!: AuthorizedCustomerUserInfoOutPutDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            if (Array.isArray(_data["userInfos"])) {
                this.userInfos = [] as any;
                for (let item of _data["userInfos"])
                    this.userInfos!.push(AuthorizedCustomerUserInfoOutPutDto.fromJS(item));
            }
            else {
                this.userInfos = null as any;
            }
        }
    }

    static fromJS(data: any): GetGCSByCustomerOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGCSByCustomerOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        if (Array.isArray(this.userInfos)) {
            data["userInfos"] = [];
            for (let item of this.userInfos)
                data["userInfos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetHelpCompleteRecordOutPutDto {
    helpCompleteRecords!: HelpCompleteRecord[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["helpCompleteRecords"])) {
                this.helpCompleteRecords = [] as any;
                for (let item of _data["helpCompleteRecords"])
                    this.helpCompleteRecords!.push(HelpCompleteRecord.fromJS(item));
            }
            else {
                this.helpCompleteRecords = null as any;
            }
        }
    }

    static fromJS(data: any): GetHelpCompleteRecordOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetHelpCompleteRecordOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.helpCompleteRecords)) {
            data["helpCompleteRecords"] = [];
            for (let item of this.helpCompleteRecords)
                data["helpCompleteRecords"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetHelpLectoTypeOutPutDto {
    id!: string;
    userFriendlyID!: string | null;
    name!: string | null;
    creationTime!: moment.Moment;
    lastModificationTime!: moment.Moment | null;
    status!: LectoTypeStatus;
    creatorUserId!: number | null;
    gcsUserId!: number | null;
    lectoTypeHelpInfoId!: string | null;
    clienter!: string | null;
    finalCustomerCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.userFriendlyID = _data["userFriendlyID"] !== undefined ? _data["userFriendlyID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.gcsUserId = _data["gcsUserId"] !== undefined ? _data["gcsUserId"] : null as any;
            this.lectoTypeHelpInfoId = _data["lectoTypeHelpInfoId"] !== undefined ? _data["lectoTypeHelpInfoId"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
        }
    }

    static fromJS(data: any): GetHelpLectoTypeOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetHelpLectoTypeOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["userFriendlyID"] = this.userFriendlyID !== undefined ? this.userFriendlyID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["gcsUserId"] = this.gcsUserId !== undefined ? this.gcsUserId : null as any;
        data["lectoTypeHelpInfoId"] = this.lectoTypeHelpInfoId !== undefined ? this.lectoTypeHelpInfoId : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        return data;
    }
}

export class GetHelpLectoTypeOutPutDtoPagedResultDto {
    items!: GetHelpLectoTypeOutPutDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetHelpLectoTypeOutPutDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): GetHelpLectoTypeOutPutDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetHelpLectoTypeOutPutDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class GetHistoryLectoTypeInPutDto {
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | null;
    userFriendlyID!: string | null;
    name!: string | null;
    creatorUserId!: number | null;
    status!: LectoTypeStatus;
    date!: moment.Moment[] | null;
    clientId!: string | null;
    createId!: string | null;
    state!: number;
    isDeleted!: number;
    technicalSpecifications!: string | null;
    technicalConfirmation!: string | null;
    domesticQuotationNumber!: string | null;
    readonly startDate!: moment.Moment | null;
    readonly endDate!: moment.Moment | null;
    appraisalNumber!: string | null;
    pmsProjectCode!: string | null;
    version!: number | null;
    pmsCount!: number;
    helpTags!: number[] | null;
    gcsUserId!: number | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.filter = _data["filter"] !== undefined ? _data["filter"] : null as any;
            this.userFriendlyID = _data["userFriendlyID"] !== undefined ? _data["userFriendlyID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["date"])) {
                this.date = [] as any;
                for (let item of _data["date"])
                    this.date!.push(moment(item));
            }
            else {
                this.date = null as any;
            }
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.createId = _data["createId"] !== undefined ? _data["createId"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.technicalConfirmation = _data["technicalConfirmation"] !== undefined ? _data["technicalConfirmation"] : null as any;
            this.domesticQuotationNumber = _data["domesticQuotationNumber"] !== undefined ? _data["domesticQuotationNumber"] : null as any;
            (this as any).startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : null as any;
            (this as any).endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.pmsProjectCode = _data["pmsProjectCode"] !== undefined ? _data["pmsProjectCode"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.pmsCount = _data["pmsCount"] !== undefined ? _data["pmsCount"] : null as any;
            if (Array.isArray(_data["helpTags"])) {
                this.helpTags = [] as any;
                for (let item of _data["helpTags"])
                    this.helpTags!.push(item);
            }
            else {
                this.helpTags = null as any;
            }
            this.gcsUserId = _data["gcsUserId"] !== undefined ? _data["gcsUserId"] : null as any;
        }
    }

    static fromJS(data: any): GetHistoryLectoTypeInPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetHistoryLectoTypeInPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["filter"] = this.filter !== undefined ? this.filter : null as any;
        data["userFriendlyID"] = this.userFriendlyID !== undefined ? this.userFriendlyID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.date)) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item.toISOString());
        }
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["createId"] = this.createId !== undefined ? this.createId : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["technicalConfirmation"] = this.technicalConfirmation !== undefined ? this.technicalConfirmation : null as any;
        data["domesticQuotationNumber"] = this.domesticQuotationNumber !== undefined ? this.domesticQuotationNumber : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["pmsProjectCode"] = this.pmsProjectCode !== undefined ? this.pmsProjectCode : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["pmsCount"] = this.pmsCount !== undefined ? this.pmsCount : null as any;
        if (Array.isArray(this.helpTags)) {
            data["helpTags"] = [];
            for (let item of this.helpTags)
                data["helpTags"].push(item);
        }
        data["gcsUserId"] = this.gcsUserId !== undefined ? this.gcsUserId : null as any;
        return data;
    }
}

export class GetHistoryLectoTypeOutPutDto {
    id!: string;
    userFriendlyID!: string | null;
    name!: string | null;
    creationTime!: moment.Moment;
    clientName!: string | null;
    finalCustomerName!: string | null;
    lastModificationTime!: moment.Moment | null;
    lectoTypeStatus!: LectoTypeStatus;
    creatorUserId!: number | null;
    isDeleted!: boolean;
    creatorName!: string | null;
    sourceType!: SourceType;
    pmsProjectCode!: string | null;
    version!: number | null;
    pmsCount!: number;
    isHasOneCode!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.userFriendlyID = _data["userFriendlyID"] !== undefined ? _data["userFriendlyID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lectoTypeStatus = _data["lectoTypeStatus"] !== undefined ? _data["lectoTypeStatus"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.creatorName = _data["creatorName"] !== undefined ? _data["creatorName"] : null as any;
            this.sourceType = _data["sourceType"] !== undefined ? _data["sourceType"] : null as any;
            this.pmsProjectCode = _data["pmsProjectCode"] !== undefined ? _data["pmsProjectCode"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.pmsCount = _data["pmsCount"] !== undefined ? _data["pmsCount"] : null as any;
            this.isHasOneCode = _data["isHasOneCode"] !== undefined ? _data["isHasOneCode"] : null as any;
        }
    }

    static fromJS(data: any): GetHistoryLectoTypeOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetHistoryLectoTypeOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["userFriendlyID"] = this.userFriendlyID !== undefined ? this.userFriendlyID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lectoTypeStatus"] = this.lectoTypeStatus !== undefined ? this.lectoTypeStatus : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["creatorName"] = this.creatorName !== undefined ? this.creatorName : null as any;
        data["sourceType"] = this.sourceType !== undefined ? this.sourceType : null as any;
        data["pmsProjectCode"] = this.pmsProjectCode !== undefined ? this.pmsProjectCode : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["pmsCount"] = this.pmsCount !== undefined ? this.pmsCount : null as any;
        data["isHasOneCode"] = this.isHasOneCode !== undefined ? this.isHasOneCode : null as any;
        return data;
    }
}

export class GetHistoryLectoTypeOutPutDtoPagedResultDto {
    items!: GetHistoryLectoTypeOutPutDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetHistoryLectoTypeOutPutDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): GetHistoryLectoTypeOutPutDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetHistoryLectoTypeOutPutDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class GetIndustryVCApprovalOutPutDto {
    info!: string | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    creatorUserName!: string | null;
    isApproval!: TQApprovalStatus;
    readonly isApprovalName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.info = _data["info"] !== undefined ? _data["info"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.creatorUserName = _data["creatorUserName"] !== undefined ? _data["creatorUserName"] : null as any;
            this.isApproval = _data["isApproval"] !== undefined ? _data["isApproval"] : null as any;
            (this as any).isApprovalName = _data["isApprovalName"] !== undefined ? _data["isApprovalName"] : null as any;
        }
    }

    static fromJS(data: any): GetIndustryVCApprovalOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIndustryVCApprovalOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["info"] = this.info !== undefined ? this.info : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["creatorUserName"] = this.creatorUserName !== undefined ? this.creatorUserName : null as any;
        data["isApproval"] = this.isApproval !== undefined ? this.isApproval : null as any;
        data["isApprovalName"] = this.isApprovalName !== undefined ? this.isApprovalName : null as any;
        return data;
    }
}

export class GetIndustryVCDetailsOutPutDto {
    id!: string;
    vcID!: string | null;
    meaning!: string | null;
    englishMeaning!: string | null;
    vcTypeDescription!: string | null;
    numberWires!: number;
    owner!: string | null;
    attachs!: string | null;
    status!: IndustryVCStatus;
    creatorUserId!: number | null;
    validStartTime!: moment.Moment;
    validEndTime!: moment.Moment;
    categoryId!: string;
    category!: string | null;
    upgrade!: boolean;
    industryVCPrices!: GetIndustryVCPriceDetailsOutPutDto[] | null;
    industryVCApprovals!: GetIndustryVCApprovalOutPutDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.owner = _data["owner"] !== undefined ? _data["owner"] : null as any;
            this.attachs = _data["attachs"] !== undefined ? _data["attachs"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.validStartTime = _data["validStartTime"] ? moment(_data["validStartTime"].toString()) : null as any;
            this.validEndTime = _data["validEndTime"] ? moment(_data["validEndTime"].toString()) : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.upgrade = _data["upgrade"] !== undefined ? _data["upgrade"] : null as any;
            if (Array.isArray(_data["industryVCPrices"])) {
                this.industryVCPrices = [] as any;
                for (let item of _data["industryVCPrices"])
                    this.industryVCPrices!.push(GetIndustryVCPriceDetailsOutPutDto.fromJS(item));
            }
            else {
                this.industryVCPrices = null as any;
            }
            if (Array.isArray(_data["industryVCApprovals"])) {
                this.industryVCApprovals = [] as any;
                for (let item of _data["industryVCApprovals"])
                    this.industryVCApprovals!.push(GetIndustryVCApprovalOutPutDto.fromJS(item));
            }
            else {
                this.industryVCApprovals = null as any;
            }
        }
    }

    static fromJS(data: any): GetIndustryVCDetailsOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIndustryVCDetailsOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["owner"] = this.owner !== undefined ? this.owner : null as any;
        data["attachs"] = this.attachs !== undefined ? this.attachs : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["validStartTime"] = this.validStartTime ? this.validStartTime.toISOString() : null as any;
        data["validEndTime"] = this.validEndTime ? this.validEndTime.toISOString() : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["upgrade"] = this.upgrade !== undefined ? this.upgrade : null as any;
        if (Array.isArray(this.industryVCPrices)) {
            data["industryVCPrices"] = [];
            for (let item of this.industryVCPrices)
                data["industryVCPrices"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.industryVCApprovals)) {
            data["industryVCApprovals"] = [];
            for (let item of this.industryVCApprovals)
                data["industryVCApprovals"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetIndustryVCPriceDetailsOutPutDto {
    id!: string;
    basicMotorSries!: string | null;
    frameNo!: number;
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    readonly engineeringCalculationModeName!: string | null;
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    readonly purchaseCycleModeName!: string | null;
    productionCycle!: number;
    testCycle!: number;
    grCycle!: number;
    scmCycle!: number;
    scmCalculationMode!: string | null;
    scmRemark!: string | null;
    extraOverlayTime!: boolean;
    isOverlayLogic!: boolean;
    shipSurveyCycle!: number;
    engineeringCycleUpdateTime!: moment.Moment | null;
    shipSurveyCycleUpdateTime!: moment.Moment | null;
    productionCycleUpdateTime!: moment.Moment | null;
    purchaseCycleUpdateTime!: moment.Moment | null;
    testCycleUpdateTime!: moment.Moment | null;
    grCycleUpdateTime!: moment.Moment | null;
    unitPrice!: number;
    unitPriceFormula!: string | null;
    unitPriceType!: UnitPriceType;
    readonly unitPriceTypeName!: string | null;
    cost!: number | null;
    costFormula!: string | null;
    costType!: CostType;
    costTypeDetail!: string | null;
    quotationPrinciple!: string | null;
    quotationPrincipleDetails!: string | null;
    placeOrderCount!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            (this as any).engineeringCalculationModeName = _data["engineeringCalculationModeName"] !== undefined ? _data["engineeringCalculationModeName"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            (this as any).purchaseCycleModeName = _data["purchaseCycleModeName"] !== undefined ? _data["purchaseCycleModeName"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.scmCycle = _data["scmCycle"] !== undefined ? _data["scmCycle"] : null as any;
            this.scmCalculationMode = _data["scmCalculationMode"] !== undefined ? _data["scmCalculationMode"] : null as any;
            this.scmRemark = _data["scmRemark"] !== undefined ? _data["scmRemark"] : null as any;
            this.extraOverlayTime = _data["extraOverlayTime"] !== undefined ? _data["extraOverlayTime"] : null as any;
            this.isOverlayLogic = _data["isOverlayLogic"] !== undefined ? _data["isOverlayLogic"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.engineeringCycleUpdateTime = _data["engineeringCycleUpdateTime"] ? moment(_data["engineeringCycleUpdateTime"].toString()) : null as any;
            this.shipSurveyCycleUpdateTime = _data["shipSurveyCycleUpdateTime"] ? moment(_data["shipSurveyCycleUpdateTime"].toString()) : null as any;
            this.productionCycleUpdateTime = _data["productionCycleUpdateTime"] ? moment(_data["productionCycleUpdateTime"].toString()) : null as any;
            this.purchaseCycleUpdateTime = _data["purchaseCycleUpdateTime"] ? moment(_data["purchaseCycleUpdateTime"].toString()) : null as any;
            this.testCycleUpdateTime = _data["testCycleUpdateTime"] ? moment(_data["testCycleUpdateTime"].toString()) : null as any;
            this.grCycleUpdateTime = _data["grCycleUpdateTime"] ? moment(_data["grCycleUpdateTime"].toString()) : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            (this as any).unitPriceTypeName = _data["unitPriceTypeName"] !== undefined ? _data["unitPriceTypeName"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.placeOrderCount = _data["placeOrderCount"] !== undefined ? _data["placeOrderCount"] : null as any;
        }
    }

    static fromJS(data: any): GetIndustryVCPriceDetailsOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIndustryVCPriceDetailsOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["engineeringCalculationModeName"] = this.engineeringCalculationModeName !== undefined ? this.engineeringCalculationModeName : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["purchaseCycleModeName"] = this.purchaseCycleModeName !== undefined ? this.purchaseCycleModeName : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["scmCycle"] = this.scmCycle !== undefined ? this.scmCycle : null as any;
        data["scmCalculationMode"] = this.scmCalculationMode !== undefined ? this.scmCalculationMode : null as any;
        data["scmRemark"] = this.scmRemark !== undefined ? this.scmRemark : null as any;
        data["extraOverlayTime"] = this.extraOverlayTime !== undefined ? this.extraOverlayTime : null as any;
        data["isOverlayLogic"] = this.isOverlayLogic !== undefined ? this.isOverlayLogic : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["engineeringCycleUpdateTime"] = this.engineeringCycleUpdateTime ? this.engineeringCycleUpdateTime.toISOString() : null as any;
        data["shipSurveyCycleUpdateTime"] = this.shipSurveyCycleUpdateTime ? this.shipSurveyCycleUpdateTime.toISOString() : null as any;
        data["productionCycleUpdateTime"] = this.productionCycleUpdateTime ? this.productionCycleUpdateTime.toISOString() : null as any;
        data["purchaseCycleUpdateTime"] = this.purchaseCycleUpdateTime ? this.purchaseCycleUpdateTime.toISOString() : null as any;
        data["testCycleUpdateTime"] = this.testCycleUpdateTime ? this.testCycleUpdateTime.toISOString() : null as any;
        data["grCycleUpdateTime"] = this.grCycleUpdateTime ? this.grCycleUpdateTime.toISOString() : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["unitPriceTypeName"] = this.unitPriceTypeName !== undefined ? this.unitPriceTypeName : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["placeOrderCount"] = this.placeOrderCount !== undefined ? this.placeOrderCount : null as any;
        return data;
    }
}

export class GetInventoryOutPutDto {
    id!: string;
    creatorUserId!: number | null;
    userFriendlyID!: string | null;
    name!: string | null;
    clientID!: string | null;
    clientName!: string | null;
    finalCustomerCode!: string | null;
    finalCustomerName!: string | null;
    shippingAddressCode!: string | null;
    shippingAddress!: string | null;
    sourceId!: string | null;
    expectedDeliveryDate!: number;
    status!: LectoTypeStatus;
    sourceType!: SourceType;
    responsibleSalesCode!: string | null;
    responsibleSalesName!: string | null;
    responsibleSalesEamil!: string | null;
    specialOfferApplicationNumber!: string | null;
    precalIDSoucre!: string | null;
    redirectPreCalUrl!: string | null;
    dq!: GetTechnologyQuotationDto;
    te!: GetTechnologyQuotationDto;
    products!: SMProduct[] | null;
    records!: SMRecord[] | null;
    readonly standardProducts!: SMProduct[] | null;
    isHelp!: boolean;
    helpCompleted!: boolean;
    pmsProjectCode!: string | null;
    pmsProjectType!: number | null;
    isOrderDirectly!: boolean;
    orderChange!: boolean;
    orderFormId!: string | null;
    orderFormChangeId!: string;
    onComplateHook!: string | null;
    jinLectoType!: boolean;
    jinLectoTypeId!: string | null;
    listPriceSeriesId!: string | null;
    listPriceJINSeriesId!: string | null;
    lectoTypeHelpInfo!: GetLectoTypeHelpInfoDto;
    lectoTypeHelpInfoId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.userFriendlyID = _data["userFriendlyID"] !== undefined ? _data["userFriendlyID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.clientID = _data["clientID"] !== undefined ? _data["clientID"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.shippingAddressCode = _data["shippingAddressCode"] !== undefined ? _data["shippingAddressCode"] : null as any;
            this.shippingAddress = _data["shippingAddress"] !== undefined ? _data["shippingAddress"] : null as any;
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.sourceType = _data["sourceType"] !== undefined ? _data["sourceType"] : null as any;
            this.responsibleSalesCode = _data["responsibleSalesCode"] !== undefined ? _data["responsibleSalesCode"] : null as any;
            this.responsibleSalesName = _data["responsibleSalesName"] !== undefined ? _data["responsibleSalesName"] : null as any;
            this.responsibleSalesEamil = _data["responsibleSalesEamil"] !== undefined ? _data["responsibleSalesEamil"] : null as any;
            this.specialOfferApplicationNumber = _data["specialOfferApplicationNumber"] !== undefined ? _data["specialOfferApplicationNumber"] : null as any;
            this.precalIDSoucre = _data["precalIDSoucre"] !== undefined ? _data["precalIDSoucre"] : null as any;
            this.redirectPreCalUrl = _data["redirectPreCalUrl"] !== undefined ? _data["redirectPreCalUrl"] : null as any;
            this.dq = _data["dq"] ? GetTechnologyQuotationDto.fromJS(_data["dq"]) : null as any;
            this.te = _data["te"] ? GetTechnologyQuotationDto.fromJS(_data["te"]) : null as any;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(SMProduct.fromJS(item));
            }
            else {
                this.products = null as any;
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(SMRecord.fromJS(item));
            }
            else {
                this.records = null as any;
            }
            if (Array.isArray(_data["standardProducts"])) {
                (this as any).standardProducts = [] as any;
                for (let item of _data["standardProducts"])
                    (this as any).standardProducts!.push(SMProduct.fromJS(item));
            }
            else {
                (this as any).standardProducts = null as any;
            }
            this.isHelp = _data["isHelp"] !== undefined ? _data["isHelp"] : null as any;
            this.helpCompleted = _data["helpCompleted"] !== undefined ? _data["helpCompleted"] : null as any;
            this.pmsProjectCode = _data["pmsProjectCode"] !== undefined ? _data["pmsProjectCode"] : null as any;
            this.pmsProjectType = _data["pmsProjectType"] !== undefined ? _data["pmsProjectType"] : null as any;
            this.isOrderDirectly = _data["isOrderDirectly"] !== undefined ? _data["isOrderDirectly"] : null as any;
            this.orderChange = _data["orderChange"] !== undefined ? _data["orderChange"] : null as any;
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.orderFormChangeId = _data["orderFormChangeId"] !== undefined ? _data["orderFormChangeId"] : null as any;
            this.onComplateHook = _data["onComplateHook"] !== undefined ? _data["onComplateHook"] : null as any;
            this.jinLectoType = _data["jinLectoType"] !== undefined ? _data["jinLectoType"] : null as any;
            this.jinLectoTypeId = _data["jinLectoTypeId"] !== undefined ? _data["jinLectoTypeId"] : null as any;
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.listPriceJINSeriesId = _data["listPriceJINSeriesId"] !== undefined ? _data["listPriceJINSeriesId"] : null as any;
            this.lectoTypeHelpInfo = _data["lectoTypeHelpInfo"] ? GetLectoTypeHelpInfoDto.fromJS(_data["lectoTypeHelpInfo"]) : null as any;
            this.lectoTypeHelpInfoId = _data["lectoTypeHelpInfoId"] !== undefined ? _data["lectoTypeHelpInfoId"] : null as any;
        }
    }

    static fromJS(data: any): GetInventoryOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInventoryOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["userFriendlyID"] = this.userFriendlyID !== undefined ? this.userFriendlyID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["clientID"] = this.clientID !== undefined ? this.clientID : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["shippingAddressCode"] = this.shippingAddressCode !== undefined ? this.shippingAddressCode : null as any;
        data["shippingAddress"] = this.shippingAddress !== undefined ? this.shippingAddress : null as any;
        data["sourceId"] = this.sourceId !== undefined ? this.sourceId : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["sourceType"] = this.sourceType !== undefined ? this.sourceType : null as any;
        data["responsibleSalesCode"] = this.responsibleSalesCode !== undefined ? this.responsibleSalesCode : null as any;
        data["responsibleSalesName"] = this.responsibleSalesName !== undefined ? this.responsibleSalesName : null as any;
        data["responsibleSalesEamil"] = this.responsibleSalesEamil !== undefined ? this.responsibleSalesEamil : null as any;
        data["specialOfferApplicationNumber"] = this.specialOfferApplicationNumber !== undefined ? this.specialOfferApplicationNumber : null as any;
        data["precalIDSoucre"] = this.precalIDSoucre !== undefined ? this.precalIDSoucre : null as any;
        data["redirectPreCalUrl"] = this.redirectPreCalUrl !== undefined ? this.redirectPreCalUrl : null as any;
        data["dq"] = this.dq ? this.dq.toJSON() : null as any;
        data["te"] = this.te ? this.te.toJSON() : null as any;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.standardProducts)) {
            data["standardProducts"] = [];
            for (let item of this.standardProducts)
                data["standardProducts"].push(item ? item.toJSON() : null as any);
        }
        data["isHelp"] = this.isHelp !== undefined ? this.isHelp : null as any;
        data["helpCompleted"] = this.helpCompleted !== undefined ? this.helpCompleted : null as any;
        data["pmsProjectCode"] = this.pmsProjectCode !== undefined ? this.pmsProjectCode : null as any;
        data["pmsProjectType"] = this.pmsProjectType !== undefined ? this.pmsProjectType : null as any;
        data["isOrderDirectly"] = this.isOrderDirectly !== undefined ? this.isOrderDirectly : null as any;
        data["orderChange"] = this.orderChange !== undefined ? this.orderChange : null as any;
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["orderFormChangeId"] = this.orderFormChangeId !== undefined ? this.orderFormChangeId : null as any;
        data["onComplateHook"] = this.onComplateHook !== undefined ? this.onComplateHook : null as any;
        data["jinLectoType"] = this.jinLectoType !== undefined ? this.jinLectoType : null as any;
        data["jinLectoTypeId"] = this.jinLectoTypeId !== undefined ? this.jinLectoTypeId : null as any;
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["listPriceJINSeriesId"] = this.listPriceJINSeriesId !== undefined ? this.listPriceJINSeriesId : null as any;
        data["lectoTypeHelpInfo"] = this.lectoTypeHelpInfo ? this.lectoTypeHelpInfo.toJSON() : null as any;
        data["lectoTypeHelpInfoId"] = this.lectoTypeHelpInfoId !== undefined ? this.lectoTypeHelpInfoId : null as any;
        return data;
    }
}

export class GetInventoryOutPutDtoBooleanStringListValueTuple {

    init(_data?: any) {
    }

    static fromJS(data: any): GetInventoryOutPutDtoBooleanStringListValueTuple {
        data = typeof data === 'object' ? data : {};
        let result = new GetInventoryOutPutDtoBooleanStringListValueTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export class GetJINCodeLectoTypePageInputDto {
    /** 客户编码 */
    clienter!: string | null;
    /** 客户名称 */
    clientName!: string | null;
    /** 二级客户编码 */
    finalCustomerCode!: string | null;
    /** 二级客户名称 */
    finalCustomerName!: string | null;
    /** 境界系列ID */
    listPriceSeriesId!: string;
    /** 境界面价系列ID */
    listPriceJINSeriesId!: string;

    init(_data?: any) {
        if (_data) {
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.listPriceJINSeriesId = _data["listPriceJINSeriesId"] !== undefined ? _data["listPriceJINSeriesId"] : null as any;
        }
    }

    static fromJS(data: any): GetJINCodeLectoTypePageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJINCodeLectoTypePageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["listPriceJINSeriesId"] = this.listPriceJINSeriesId !== undefined ? this.listPriceJINSeriesId : null as any;
        return data;
    }
}

export class GetLectoTypeDetailsDto {
    id!: string;
    name!: string | null;
    userFriendlyID!: string | null;
    clientID!: string | null;
    clientName!: string | null;
    finalCustomerName!: string | null;
    finalCustomerCode!: string | null;
    createName!: string | null;
    gcsHandleName!: string | null;
    gcsCreateName!: string | null;
    salesName!: string | null;
    preCalNumber!: string | null;
    expectedDeliveryDate!: string | null;
    gcsHelpName!: string | null;
    status!: LectoTypeStatus;
    products!: LectoTypeDetailsProductDto[] | null;
    records!: SMRecord[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.userFriendlyID = _data["userFriendlyID"] !== undefined ? _data["userFriendlyID"] : null as any;
            this.clientID = _data["clientID"] !== undefined ? _data["clientID"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.createName = _data["createName"] !== undefined ? _data["createName"] : null as any;
            this.gcsHandleName = _data["gcsHandleName"] !== undefined ? _data["gcsHandleName"] : null as any;
            this.gcsCreateName = _data["gcsCreateName"] !== undefined ? _data["gcsCreateName"] : null as any;
            this.salesName = _data["salesName"] !== undefined ? _data["salesName"] : null as any;
            this.preCalNumber = _data["preCalNumber"] !== undefined ? _data["preCalNumber"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.gcsHelpName = _data["gcsHelpName"] !== undefined ? _data["gcsHelpName"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(LectoTypeDetailsProductDto.fromJS(item));
            }
            else {
                this.products = null as any;
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(SMRecord.fromJS(item));
            }
            else {
                this.records = null as any;
            }
        }
    }

    static fromJS(data: any): GetLectoTypeDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLectoTypeDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["userFriendlyID"] = this.userFriendlyID !== undefined ? this.userFriendlyID : null as any;
        data["clientID"] = this.clientID !== undefined ? this.clientID : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["createName"] = this.createName !== undefined ? this.createName : null as any;
        data["gcsHandleName"] = this.gcsHandleName !== undefined ? this.gcsHandleName : null as any;
        data["gcsCreateName"] = this.gcsCreateName !== undefined ? this.gcsCreateName : null as any;
        data["salesName"] = this.salesName !== undefined ? this.salesName : null as any;
        data["preCalNumber"] = this.preCalNumber !== undefined ? this.preCalNumber : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["gcsHelpName"] = this.gcsHelpName !== undefined ? this.gcsHelpName : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetLectoTypeHelpInfoDto {
    id!: string | null;
    remark!: string | null;
    attachmentFiles!: AttachmentFileInfo[] | null;
    completeRemark!: string | null;
    completeAttachmentFiles!: AttachmentFileInfo[] | null;
    backWriteStatus!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            if (Array.isArray(_data["attachmentFiles"])) {
                this.attachmentFiles = [] as any;
                for (let item of _data["attachmentFiles"])
                    this.attachmentFiles!.push(AttachmentFileInfo.fromJS(item));
            }
            else {
                this.attachmentFiles = null as any;
            }
            this.completeRemark = _data["completeRemark"] !== undefined ? _data["completeRemark"] : null as any;
            if (Array.isArray(_data["completeAttachmentFiles"])) {
                this.completeAttachmentFiles = [] as any;
                for (let item of _data["completeAttachmentFiles"])
                    this.completeAttachmentFiles!.push(AttachmentFileInfo.fromJS(item));
            }
            else {
                this.completeAttachmentFiles = null as any;
            }
            this.backWriteStatus = _data["backWriteStatus"] !== undefined ? _data["backWriteStatus"] : null as any;
        }
    }

    static fromJS(data: any): GetLectoTypeHelpInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLectoTypeHelpInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        if (Array.isArray(this.attachmentFiles)) {
            data["attachmentFiles"] = [];
            for (let item of this.attachmentFiles)
                data["attachmentFiles"].push(item ? item.toJSON() : null as any);
        }
        data["completeRemark"] = this.completeRemark !== undefined ? this.completeRemark : null as any;
        if (Array.isArray(this.completeAttachmentFiles)) {
            data["completeAttachmentFiles"] = [];
            for (let item of this.completeAttachmentFiles)
                data["completeAttachmentFiles"].push(item ? item.toJSON() : null as any);
        }
        data["backWriteStatus"] = this.backWriteStatus !== undefined ? this.backWriteStatus : null as any;
        return data;
    }
}

export class GetMassQuotationNumberInput {
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | null;
    quotationNumber!: string | null;
    customerName!: string | null;
    subCustomerName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.filter = _data["filter"] !== undefined ? _data["filter"] : null as any;
            this.quotationNumber = _data["quotationNumber"] !== undefined ? _data["quotationNumber"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.subCustomerName = _data["subCustomerName"] !== undefined ? _data["subCustomerName"] : null as any;
        }
    }

    static fromJS(data: any): GetMassQuotationNumberInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMassQuotationNumberInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["filter"] = this.filter !== undefined ? this.filter : null as any;
        data["quotationNumber"] = this.quotationNumber !== undefined ? this.quotationNumber : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["subCustomerName"] = this.subCustomerName !== undefined ? this.subCustomerName : null as any;
        return data;
    }
}

export class GetNumberWiresCheckRulesForEditOutput {
    numberWiresCheckRules!: CreateOrEditNumberWiresCheckRulesDto;

    init(_data?: any) {
        if (_data) {
            this.numberWiresCheckRules = _data["numberWiresCheckRules"] ? CreateOrEditNumberWiresCheckRulesDto.fromJS(_data["numberWiresCheckRules"]) : null as any;
        }
    }

    static fromJS(data: any): GetNumberWiresCheckRulesForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNumberWiresCheckRulesForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberWiresCheckRules"] = this.numberWiresCheckRules ? this.numberWiresCheckRules.toJSON() : null as any;
        return data;
    }
}

export class GetPageAuthorizedCustomerInputDto {
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | null;
    finalCustomerName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.filter = _data["filter"] !== undefined ? _data["filter"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
        }
    }

    static fromJS(data: any): GetPageAuthorizedCustomerInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageAuthorizedCustomerInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["filter"] = this.filter !== undefined ? this.filter : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        return data;
    }
}

export class GetPageAuthorizedCustomerOutputDto {
    id!: string;
    /** 二级客户名称 */
    finalCustomerName!: string | null;
    /** 二级客户代码 */
    finalCustomerCode!: string | null;
    /** 一级客户 */
    clienter!: string | null;
    /** 一级客户名称（冗余字段） */
    clientName!: string | null;
    userInfos!: GetPageAuthorizedCustomerUserInfoOutPutDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            if (Array.isArray(_data["userInfos"])) {
                this.userInfos = [] as any;
                for (let item of _data["userInfos"])
                    this.userInfos!.push(GetPageAuthorizedCustomerUserInfoOutPutDto.fromJS(item));
            }
            else {
                this.userInfos = null as any;
            }
        }
    }

    static fromJS(data: any): GetPageAuthorizedCustomerOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageAuthorizedCustomerOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        if (Array.isArray(this.userInfos)) {
            data["userInfos"] = [];
            for (let item of this.userInfos)
                data["userInfos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetPageAuthorizedCustomerOutputDtoPagedResultDto {
    items!: GetPageAuthorizedCustomerOutputDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPageAuthorizedCustomerOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): GetPageAuthorizedCustomerOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageAuthorizedCustomerOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class GetPageAuthorizedCustomerUserInfoOutPutDto {
    id!: string;
    userName!: string | null;
    /** 用户Id */
    userId!: number;
    /** 用户类型 */
    userType!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.userType = _data["userType"] !== undefined ? _data["userType"] : null as any;
        }
    }

    static fromJS(data: any): GetPageAuthorizedCustomerUserInfoOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageAuthorizedCustomerUserInfoOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userType"] = this.userType !== undefined ? this.userType : null as any;
        return data;
    }
}

export class GetPageDomesticQuotationInPutDto {
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | null;
    domesticQuotationNumber!: string | null;
    clientids!: string[] | null;
    userFriendlyID!: string | null;
    clientName!: string | null;
    finalCustomerName!: string | null;
    creatorUserId!: number | null;
    creationTime!: moment.Moment[] | null;
    status!: TechnologyQuotationStatus;
    readonly creationStartDate!: moment.Moment | null;
    readonly creationEndDate!: moment.Moment | null;
    dqType!: number | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.filter = _data["filter"] !== undefined ? _data["filter"] : null as any;
            this.domesticQuotationNumber = _data["domesticQuotationNumber"] !== undefined ? _data["domesticQuotationNumber"] : null as any;
            if (Array.isArray(_data["clientids"])) {
                this.clientids = [] as any;
                for (let item of _data["clientids"])
                    this.clientids!.push(item);
            }
            else {
                this.clientids = null as any;
            }
            this.userFriendlyID = _data["userFriendlyID"] !== undefined ? _data["userFriendlyID"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            if (Array.isArray(_data["creationTime"])) {
                this.creationTime = [] as any;
                for (let item of _data["creationTime"])
                    this.creationTime!.push(moment(item));
            }
            else {
                this.creationTime = null as any;
            }
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            (this as any).creationStartDate = _data["creationStartDate"] ? moment(_data["creationStartDate"].toString()) : null as any;
            (this as any).creationEndDate = _data["creationEndDate"] ? moment(_data["creationEndDate"].toString()) : null as any;
            this.dqType = _data["dqType"] !== undefined ? _data["dqType"] : null as any;
        }
    }

    static fromJS(data: any): GetPageDomesticQuotationInPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageDomesticQuotationInPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["filter"] = this.filter !== undefined ? this.filter : null as any;
        data["domesticQuotationNumber"] = this.domesticQuotationNumber !== undefined ? this.domesticQuotationNumber : null as any;
        if (Array.isArray(this.clientids)) {
            data["clientids"] = [];
            for (let item of this.clientids)
                data["clientids"].push(item);
        }
        data["userFriendlyID"] = this.userFriendlyID !== undefined ? this.userFriendlyID : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        if (Array.isArray(this.creationTime)) {
            data["creationTime"] = [];
            for (let item of this.creationTime)
                data["creationTime"].push(item.toISOString());
        }
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["creationStartDate"] = this.creationStartDate ? this.creationStartDate.toISOString() : null as any;
        data["creationEndDate"] = this.creationEndDate ? this.creationEndDate.toISOString() : null as any;
        data["dqType"] = this.dqType !== undefined ? this.dqType : null as any;
        return data;
    }
}

export class GetPageDomesticQuotationOutPutDto {
    id!: string;
    cycle!: number;
    clientName!: string | null;
    finalCustomerName!: string | null;
    domesticQuotationNumber!: string | null;
    status!: TechnologyQuotationStatus;
    quotationExpiredTime!: moment.Moment | null;
    creatorUserId!: number | null;
    creationTime!: moment.Moment;
    jinCategoryCode!: string | null;
    projectName!: string | null;
    isOnceProject!: boolean;
    isSourceLP!: boolean;
    sourceType!: SourceType;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.cycle = _data["cycle"] !== undefined ? _data["cycle"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.domesticQuotationNumber = _data["domesticQuotationNumber"] !== undefined ? _data["domesticQuotationNumber"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.quotationExpiredTime = _data["quotationExpiredTime"] ? moment(_data["quotationExpiredTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.isOnceProject = _data["isOnceProject"] !== undefined ? _data["isOnceProject"] : null as any;
            this.isSourceLP = _data["isSourceLP"] !== undefined ? _data["isSourceLP"] : null as any;
            this.sourceType = _data["sourceType"] !== undefined ? _data["sourceType"] : null as any;
        }
    }

    static fromJS(data: any): GetPageDomesticQuotationOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageDomesticQuotationOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["cycle"] = this.cycle !== undefined ? this.cycle : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["domesticQuotationNumber"] = this.domesticQuotationNumber !== undefined ? this.domesticQuotationNumber : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["quotationExpiredTime"] = this.quotationExpiredTime ? this.quotationExpiredTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["isOnceProject"] = this.isOnceProject !== undefined ? this.isOnceProject : null as any;
        data["isSourceLP"] = this.isSourceLP !== undefined ? this.isSourceLP : null as any;
        data["sourceType"] = this.sourceType !== undefined ? this.sourceType : null as any;
        return data;
    }
}

export class GetPageDomesticQuotationOutPutDtoPagedResultDto {
    items!: GetPageDomesticQuotationOutPutDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPageDomesticQuotationOutPutDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): GetPageDomesticQuotationOutPutDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageDomesticQuotationOutPutDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class GetPageIndustryVCByParamInPutDto {
    basicMotorSries!: string | null;
    frameNo!: number;
    lectoTypeId!: string;
    jinCategoryCode!: string | null;
    basicMotorCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
        }
    }

    static fromJS(data: any): GetPageIndustryVCByParamInPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageIndustryVCByParamInPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        return data;
    }
}

export class GetPageIndustryVCByParamOutPutDto {
    id!: string;
    vcID!: string | null;
    meaning!: string | null;
    unitPrice!: number;
    isAdd!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.isAdd = _data["isAdd"] !== undefined ? _data["isAdd"] : null as any;
        }
    }

    static fromJS(data: any): GetPageIndustryVCByParamOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageIndustryVCByParamOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["isAdd"] = this.isAdd !== undefined ? this.isAdd : null as any;
        return data;
    }
}

export class GetPageIndustryVCInPutDto {
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | null;
    vcID!: string | null;
    meaning!: string | null;
    englishMeaning!: string | null;
    vcTypeDescription!: string | null;
    owner!: number;
    validStartTime!: moment.Moment | null;
    validEndTime!: moment.Moment | null;
    status!: number;
    categoryId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.filter = _data["filter"] !== undefined ? _data["filter"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.owner = _data["owner"] !== undefined ? _data["owner"] : null as any;
            this.validStartTime = _data["validStartTime"] ? moment(_data["validStartTime"].toString()) : null as any;
            this.validEndTime = _data["validEndTime"] ? moment(_data["validEndTime"].toString()) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
        }
    }

    static fromJS(data: any): GetPageIndustryVCInPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageIndustryVCInPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["filter"] = this.filter !== undefined ? this.filter : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["owner"] = this.owner !== undefined ? this.owner : null as any;
        data["validStartTime"] = this.validStartTime ? this.validStartTime.toISOString() : null as any;
        data["validEndTime"] = this.validEndTime ? this.validEndTime.toISOString() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        return data;
    }
}

export class GetPageIndustryVCOutPutDto {
    id!: string;
    vcID!: string | null;
    meaning!: string | null;
    englishMeaning!: string | null;
    vcTypeDescription!: string | null;
    numberWires!: number;
    owner!: string | null;
    ownerName!: string | null;
    creatorUserId!: number | null;
    status!: IndustryVCStatus;
    validStartTime!: moment.Moment;
    validEndTime!: moment.Moment;
    categoryId!: string;
    category!: string | null;
    placeOrderCount!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.owner = _data["owner"] !== undefined ? _data["owner"] : null as any;
            this.ownerName = _data["ownerName"] !== undefined ? _data["ownerName"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.validStartTime = _data["validStartTime"] ? moment(_data["validStartTime"].toString()) : null as any;
            this.validEndTime = _data["validEndTime"] ? moment(_data["validEndTime"].toString()) : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.placeOrderCount = _data["placeOrderCount"] !== undefined ? _data["placeOrderCount"] : null as any;
        }
    }

    static fromJS(data: any): GetPageIndustryVCOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageIndustryVCOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["owner"] = this.owner !== undefined ? this.owner : null as any;
        data["ownerName"] = this.ownerName !== undefined ? this.ownerName : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["validStartTime"] = this.validStartTime ? this.validStartTime.toISOString() : null as any;
        data["validEndTime"] = this.validEndTime ? this.validEndTime.toISOString() : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["placeOrderCount"] = this.placeOrderCount !== undefined ? this.placeOrderCount : null as any;
        return data;
    }
}

export class GetPageIndustryVCOutPutDtoPagedResultDto {
    items!: GetPageIndustryVCOutPutDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPageIndustryVCOutPutDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): GetPageIndustryVCOutPutDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageIndustryVCOutPutDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class GetPageMainPlanReportDto {
    /** VC ID */
    vcID!: string | null;
    /** 产品 */
    product!: string | null;
    /** 产品类型 */
    basicMotorSries!: string | null;
    /** 能效 */
    eneEff!: string | null;
    /** 机座号 */
    frameNo!: number;
    /** 采购周期（自然天） */
    purchaseCycle!: number | null;
    /** 标准PDT */
    motorPurchaseCycle!: number | null;
    /** VC PDT */
    vcPDT!: number | null;
    grCycleStr!: string | null;
    grCycle!: number | null;
    /** SCM周期 */
    scmCycle!: number | null;
    makeOrBuy!: string | null;
    basicMotorSriesId!: number | null;
    changeType!: string | null;
    basicMotorCode!: string | null;
    /** 长代码对应的VCID */
    standVcID!: string | null;
    /** 含义 */
    meaning!: string | null;
    /** 主VC */
    mainVC!: string | null;
    /** 主VC含义 */
    mainVCMeaning!: string | null;

    init(_data?: any) {
        if (_data) {
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.product = _data["product"] !== undefined ? _data["product"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.motorPurchaseCycle = _data["motorPurchaseCycle"] !== undefined ? _data["motorPurchaseCycle"] : null as any;
            this.vcPDT = _data["vcPDT"] !== undefined ? _data["vcPDT"] : null as any;
            this.grCycleStr = _data["grCycleStr"] !== undefined ? _data["grCycleStr"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.scmCycle = _data["scmCycle"] !== undefined ? _data["scmCycle"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.basicMotorSriesId = _data["basicMotorSriesId"] !== undefined ? _data["basicMotorSriesId"] : null as any;
            this.changeType = _data["changeType"] !== undefined ? _data["changeType"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.standVcID = _data["standVcID"] !== undefined ? _data["standVcID"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.mainVC = _data["mainVC"] !== undefined ? _data["mainVC"] : null as any;
            this.mainVCMeaning = _data["mainVCMeaning"] !== undefined ? _data["mainVCMeaning"] : null as any;
        }
    }

    static fromJS(data: any): GetPageMainPlanReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageMainPlanReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["product"] = this.product !== undefined ? this.product : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["motorPurchaseCycle"] = this.motorPurchaseCycle !== undefined ? this.motorPurchaseCycle : null as any;
        data["vcPDT"] = this.vcPDT !== undefined ? this.vcPDT : null as any;
        data["grCycleStr"] = this.grCycleStr !== undefined ? this.grCycleStr : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["scmCycle"] = this.scmCycle !== undefined ? this.scmCycle : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["basicMotorSriesId"] = this.basicMotorSriesId !== undefined ? this.basicMotorSriesId : null as any;
        data["changeType"] = this.changeType !== undefined ? this.changeType : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["standVcID"] = this.standVcID !== undefined ? this.standVcID : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["mainVC"] = this.mainVC !== undefined ? this.mainVC : null as any;
        data["mainVCMeaning"] = this.mainVCMeaning !== undefined ? this.mainVCMeaning : null as any;
        return data;
    }
}

export class GetPageMainPlanReportDtoPagedResultDto {
    items!: GetPageMainPlanReportDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPageMainPlanReportDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): GetPageMainPlanReportDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageMainPlanReportDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class GetPageMainPlanReportInputDto {
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | null;
    /** VCID */
    vcID!: string | null;
    /** 产品类型 */
    basicMotorSries!: string | null;
    /** 基座号 */
    frameNo!: number | null;
    mainVC!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.filter = _data["filter"] !== undefined ? _data["filter"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.mainVC = _data["mainVC"] !== undefined ? _data["mainVC"] : null as any;
        }
    }

    static fromJS(data: any): GetPageMainPlanReportInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageMainPlanReportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["filter"] = this.filter !== undefined ? this.filter : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["mainVC"] = this.mainVC !== undefined ? this.mainVC : null as any;
        return data;
    }
}

export class GetPageSuperimposedChangeValueDto {
    key!: string | null;
    /** VC ID */
    vcID!: string | null;
    /** 含义 */
    meaning!: string | null;
    /** 主VC */
    mainVC!: string | null;
    /** 主VC含义 */
    mainVCMeaning!: string | null;
    /** 机座号 */
    frameNo!: number;
    /** 产品类型 */
    basicMotorSries!: string | null;
    pdt!: number | null;
    mainVCPDT!: number | null;
    /** VC采购时间 */
    purchaseCycle!: number | null;
    /** VC额外增加时间 */
    vcExtraTime!: number | null;
    /** 1.抓取的 2.report表里的 */
    type!: number;
    longVcCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.mainVC = _data["mainVC"] !== undefined ? _data["mainVC"] : null as any;
            this.mainVCMeaning = _data["mainVCMeaning"] !== undefined ? _data["mainVCMeaning"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.pdt = _data["pdt"] !== undefined ? _data["pdt"] : null as any;
            this.mainVCPDT = _data["mainVCPDT"] !== undefined ? _data["mainVCPDT"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.vcExtraTime = _data["vcExtraTime"] !== undefined ? _data["vcExtraTime"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.longVcCode = _data["longVcCode"] !== undefined ? _data["longVcCode"] : null as any;
        }
    }

    static fromJS(data: any): GetPageSuperimposedChangeValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageSuperimposedChangeValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["mainVC"] = this.mainVC !== undefined ? this.mainVC : null as any;
        data["mainVCMeaning"] = this.mainVCMeaning !== undefined ? this.mainVCMeaning : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["pdt"] = this.pdt !== undefined ? this.pdt : null as any;
        data["mainVCPDT"] = this.mainVCPDT !== undefined ? this.mainVCPDT : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["vcExtraTime"] = this.vcExtraTime !== undefined ? this.vcExtraTime : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["longVcCode"] = this.longVcCode !== undefined ? this.longVcCode : null as any;
        return data;
    }
}

export class GetPageSuperimposedChangeValueDtoPagedResultDto {
    items!: GetPageSuperimposedChangeValueDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPageSuperimposedChangeValueDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): GetPageSuperimposedChangeValueDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageSuperimposedChangeValueDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class GetPageSuperimposedChangeValueInput {
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | null;
    vcID!: string | null;
    frameNo!: number | null;
    mainVC!: string | null;
    basicMotorSriesNames!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.filter = _data["filter"] !== undefined ? _data["filter"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.mainVC = _data["mainVC"] !== undefined ? _data["mainVC"] : null as any;
            if (Array.isArray(_data["basicMotorSriesNames"])) {
                this.basicMotorSriesNames = [] as any;
                for (let item of _data["basicMotorSriesNames"])
                    this.basicMotorSriesNames!.push(item);
            }
            else {
                this.basicMotorSriesNames = null as any;
            }
        }
    }

    static fromJS(data: any): GetPageSuperimposedChangeValueInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageSuperimposedChangeValueInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["filter"] = this.filter !== undefined ? this.filter : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["mainVC"] = this.mainVC !== undefined ? this.mainVC : null as any;
        if (Array.isArray(this.basicMotorSriesNames)) {
            data["basicMotorSriesNames"] = [];
            for (let item of this.basicMotorSriesNames)
                data["basicMotorSriesNames"].push(item);
        }
        return data;
    }
}

export class GetPageTechnologyAgreementInPutDto {
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | null;
    technicalSpecifications!: string | null;
    technicalConfirmation!: string | null;
    userFriendlyID!: string | null;
    clientids!: string[] | null;
    clientName!: string | null;
    finalCustomerName!: string | null;
    industry!: string | null;
    projectName!: string | null;
    creatorUserId!: number | null;
    lastTeCreatorUserId!: number | null;
    lastTeCreationTime!: moment.Moment[] | null;
    readonly lastTeCreationStartDate!: moment.Moment | null;
    readonly lastTeCreationEndDate!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.filter = _data["filter"] !== undefined ? _data["filter"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.technicalConfirmation = _data["technicalConfirmation"] !== undefined ? _data["technicalConfirmation"] : null as any;
            this.userFriendlyID = _data["userFriendlyID"] !== undefined ? _data["userFriendlyID"] : null as any;
            if (Array.isArray(_data["clientids"])) {
                this.clientids = [] as any;
                for (let item of _data["clientids"])
                    this.clientids!.push(item);
            }
            else {
                this.clientids = null as any;
            }
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.industry = _data["industry"] !== undefined ? _data["industry"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastTeCreatorUserId = _data["lastTeCreatorUserId"] !== undefined ? _data["lastTeCreatorUserId"] : null as any;
            if (Array.isArray(_data["lastTeCreationTime"])) {
                this.lastTeCreationTime = [] as any;
                for (let item of _data["lastTeCreationTime"])
                    this.lastTeCreationTime!.push(moment(item));
            }
            else {
                this.lastTeCreationTime = null as any;
            }
            (this as any).lastTeCreationStartDate = _data["lastTeCreationStartDate"] ? moment(_data["lastTeCreationStartDate"].toString()) : null as any;
            (this as any).lastTeCreationEndDate = _data["lastTeCreationEndDate"] ? moment(_data["lastTeCreationEndDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): GetPageTechnologyAgreementInPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageTechnologyAgreementInPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["filter"] = this.filter !== undefined ? this.filter : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["technicalConfirmation"] = this.technicalConfirmation !== undefined ? this.technicalConfirmation : null as any;
        data["userFriendlyID"] = this.userFriendlyID !== undefined ? this.userFriendlyID : null as any;
        if (Array.isArray(this.clientids)) {
            data["clientids"] = [];
            for (let item of this.clientids)
                data["clientids"].push(item);
        }
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["industry"] = this.industry !== undefined ? this.industry : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastTeCreatorUserId"] = this.lastTeCreatorUserId !== undefined ? this.lastTeCreatorUserId : null as any;
        if (Array.isArray(this.lastTeCreationTime)) {
            data["lastTeCreationTime"] = [];
            for (let item of this.lastTeCreationTime)
                data["lastTeCreationTime"].push(item.toISOString());
        }
        data["lastTeCreationStartDate"] = this.lastTeCreationStartDate ? this.lastTeCreationStartDate.toISOString() : null as any;
        data["lastTeCreationEndDate"] = this.lastTeCreationEndDate ? this.lastTeCreationEndDate.toISOString() : null as any;
        return data;
    }
}

export class GetPageTechnologyAgreementOutPutDto {
    id!: string;
    status!: TechnologyQuotationStatus;
    technicalSpecifications!: string | null;
    technicalConfirmation!: string | null;
    clientName!: string | null;
    finalCustomerName!: string | null;
    projectName!: string | null;
    industry!: string | null;
    creatorUserId!: number | null;
    lastTeCreatorUserId!: number | null;
    lastTeCreationTime!: moment.Moment | null;
    jinCategoryCode!: string | null;
    isOneTimeProject!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.technicalConfirmation = _data["technicalConfirmation"] !== undefined ? _data["technicalConfirmation"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.industry = _data["industry"] !== undefined ? _data["industry"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastTeCreatorUserId = _data["lastTeCreatorUserId"] !== undefined ? _data["lastTeCreatorUserId"] : null as any;
            this.lastTeCreationTime = _data["lastTeCreationTime"] ? moment(_data["lastTeCreationTime"].toString()) : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.isOneTimeProject = _data["isOneTimeProject"] !== undefined ? _data["isOneTimeProject"] : null as any;
        }
    }

    static fromJS(data: any): GetPageTechnologyAgreementOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageTechnologyAgreementOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["technicalConfirmation"] = this.technicalConfirmation !== undefined ? this.technicalConfirmation : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["industry"] = this.industry !== undefined ? this.industry : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastTeCreatorUserId"] = this.lastTeCreatorUserId !== undefined ? this.lastTeCreatorUserId : null as any;
        data["lastTeCreationTime"] = this.lastTeCreationTime ? this.lastTeCreationTime.toISOString() : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["isOneTimeProject"] = this.isOneTimeProject !== undefined ? this.isOneTimeProject : null as any;
        return data;
    }
}

export class GetPageTechnologyAgreementOutPutDtoPagedResultDto {
    items!: GetPageTechnologyAgreementOutPutDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPageTechnologyAgreementOutPutDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): GetPageTechnologyAgreementOutPutDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageTechnologyAgreementOutPutDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class GetPageVCCycleOutputDto {
    id!: string;
    vcID!: string | null;
    vcLongCode!: string | null;
    vcType!: VcType;
    readonly vcTypeName!: string | null;
    category!: string | null;
    meaning!: string | null;
    vcTypeDescription!: string | null;
    vcShowType!: VCShowType;
    readonly vcShowTypeName!: string | null;
    attributeName!: string | null;
    attributeSelect!: string | null;
    frameNo!: number;
    basicMotorSries!: string | null;
    engineeringCycle!: number | null;
    engineeringCalculationMode!: EngineeringCalculationMode;
    readonly engineeringCalculationModeName!: string | null;
    purchaseCycle!: number | null;
    purchaseCycleMode!: PurchaseCycleMode;
    readonly purchaseCycleModeName!: string | null;
    grCycle!: number | null;
    standardGrCycle!: number | null;
    scmCycle!: number | null;
    scmCalculationMode!: string | null;
    scmRemark!: string | null;
    extraOverlayTime!: boolean | null;
    isOverlayLogic!: boolean | null;
    productionCycle!: number | null;
    testCycle!: number | null;
    shipSurveyCycle!: number | null;
    engineeringCycleUpdateTime!: moment.Moment | null;
    shipSurveyCycleUpdateTime!: moment.Moment | null;
    productionCycleUpdateTime!: moment.Moment | null;
    purchaseCycleUpdateTime!: moment.Moment | null;
    testCycleUpdateTime!: moment.Moment | null;
    grCycleUpdateTime!: moment.Moment | null;
    engineeringComment!: string | null;
    purchaseComment!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.vcLongCode = _data["vcLongCode"] !== undefined ? _data["vcLongCode"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            (this as any).vcTypeName = _data["vcTypeName"] !== undefined ? _data["vcTypeName"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            (this as any).vcShowTypeName = _data["vcShowTypeName"] !== undefined ? _data["vcShowTypeName"] : null as any;
            this.attributeName = _data["attributeName"] !== undefined ? _data["attributeName"] : null as any;
            this.attributeSelect = _data["attributeSelect"] !== undefined ? _data["attributeSelect"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            (this as any).engineeringCalculationModeName = _data["engineeringCalculationModeName"] !== undefined ? _data["engineeringCalculationModeName"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            (this as any).purchaseCycleModeName = _data["purchaseCycleModeName"] !== undefined ? _data["purchaseCycleModeName"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.standardGrCycle = _data["standardGrCycle"] !== undefined ? _data["standardGrCycle"] : null as any;
            this.scmCycle = _data["scmCycle"] !== undefined ? _data["scmCycle"] : null as any;
            this.scmCalculationMode = _data["scmCalculationMode"] !== undefined ? _data["scmCalculationMode"] : null as any;
            this.scmRemark = _data["scmRemark"] !== undefined ? _data["scmRemark"] : null as any;
            this.extraOverlayTime = _data["extraOverlayTime"] !== undefined ? _data["extraOverlayTime"] : null as any;
            this.isOverlayLogic = _data["isOverlayLogic"] !== undefined ? _data["isOverlayLogic"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.engineeringCycleUpdateTime = _data["engineeringCycleUpdateTime"] ? moment(_data["engineeringCycleUpdateTime"].toString()) : null as any;
            this.shipSurveyCycleUpdateTime = _data["shipSurveyCycleUpdateTime"] ? moment(_data["shipSurveyCycleUpdateTime"].toString()) : null as any;
            this.productionCycleUpdateTime = _data["productionCycleUpdateTime"] ? moment(_data["productionCycleUpdateTime"].toString()) : null as any;
            this.purchaseCycleUpdateTime = _data["purchaseCycleUpdateTime"] ? moment(_data["purchaseCycleUpdateTime"].toString()) : null as any;
            this.testCycleUpdateTime = _data["testCycleUpdateTime"] ? moment(_data["testCycleUpdateTime"].toString()) : null as any;
            this.grCycleUpdateTime = _data["grCycleUpdateTime"] ? moment(_data["grCycleUpdateTime"].toString()) : null as any;
            this.engineeringComment = _data["engineeringComment"] !== undefined ? _data["engineeringComment"] : null as any;
            this.purchaseComment = _data["purchaseComment"] !== undefined ? _data["purchaseComment"] : null as any;
        }
    }

    static fromJS(data: any): GetPageVCCycleOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageVCCycleOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["vcLongCode"] = this.vcLongCode !== undefined ? this.vcLongCode : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcTypeName"] = this.vcTypeName !== undefined ? this.vcTypeName : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["vcShowTypeName"] = this.vcShowTypeName !== undefined ? this.vcShowTypeName : null as any;
        data["attributeName"] = this.attributeName !== undefined ? this.attributeName : null as any;
        data["attributeSelect"] = this.attributeSelect !== undefined ? this.attributeSelect : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["engineeringCalculationModeName"] = this.engineeringCalculationModeName !== undefined ? this.engineeringCalculationModeName : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["purchaseCycleModeName"] = this.purchaseCycleModeName !== undefined ? this.purchaseCycleModeName : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["standardGrCycle"] = this.standardGrCycle !== undefined ? this.standardGrCycle : null as any;
        data["scmCycle"] = this.scmCycle !== undefined ? this.scmCycle : null as any;
        data["scmCalculationMode"] = this.scmCalculationMode !== undefined ? this.scmCalculationMode : null as any;
        data["scmRemark"] = this.scmRemark !== undefined ? this.scmRemark : null as any;
        data["extraOverlayTime"] = this.extraOverlayTime !== undefined ? this.extraOverlayTime : null as any;
        data["isOverlayLogic"] = this.isOverlayLogic !== undefined ? this.isOverlayLogic : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["engineeringCycleUpdateTime"] = this.engineeringCycleUpdateTime ? this.engineeringCycleUpdateTime.toISOString() : null as any;
        data["shipSurveyCycleUpdateTime"] = this.shipSurveyCycleUpdateTime ? this.shipSurveyCycleUpdateTime.toISOString() : null as any;
        data["productionCycleUpdateTime"] = this.productionCycleUpdateTime ? this.productionCycleUpdateTime.toISOString() : null as any;
        data["purchaseCycleUpdateTime"] = this.purchaseCycleUpdateTime ? this.purchaseCycleUpdateTime.toISOString() : null as any;
        data["testCycleUpdateTime"] = this.testCycleUpdateTime ? this.testCycleUpdateTime.toISOString() : null as any;
        data["grCycleUpdateTime"] = this.grCycleUpdateTime ? this.grCycleUpdateTime.toISOString() : null as any;
        data["engineeringComment"] = this.engineeringComment !== undefined ? this.engineeringComment : null as any;
        data["purchaseComment"] = this.purchaseComment !== undefined ? this.purchaseComment : null as any;
        return data;
    }
}

export class GetPageVCCycleOutputDtoPagedResultDto {
    items!: GetPageVCCycleOutputDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPageVCCycleOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): GetPageVCCycleOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageVCCycleOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class GetParamsATreeOutPutDto {
    id!: number;
    pId!: number;
    value!: number;
    title!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pId = _data["pId"] !== undefined ? _data["pId"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
        }
    }

    static fromJS(data: any): GetParamsATreeOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetParamsATreeOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pId"] = this.pId !== undefined ? this.pId : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        return data;
    }
}

export class GetSameBasicCodeJINCodesOutputDto {
    id!: string;
    basicMotorCode!: string | null;
    cpBasicMotorCode!: string | null;
    basicMotorModel!: string | null;
    eneEff!: string | null;
    voltage!: string | null;
    wiringMode!: string | null;
    isHaveVc!: IsHaveVc;
    readonly isHaveVcName!: string | null;
    isNeedHeightOutput!: IsYes;
    readonly isNeedHeightOutputName!: string | null;
    frequency!: string | null;
    power!: string | null;
    basicMotorMounting!: string | null;
    poleNo!: string | null;
    frameNo!: number;
    encoder!: string | null;
    basicMotorSries!: string | null;
    unitPrice!: number;
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    productionCycle!: number;
    testCycle!: number;
    capacityCycle!: number;
    basicMotorParameters!: BasicMotorParameterOutputDto[] | null;
    grCycle!: number;
    makeOrBuy!: string | null;
    voltageCode!: string | null;
    brake!: string | null;
    rowKey!: string | null;
    cpCode!: string | null;
    cpName!: string | null;
    customerRemark!: string | null;
    customerMaterialNumber!: string | null;
    technicalSpecifications!: string | null;
    inToOutCycle!: number;
    jinBasicMotorCode!: string | null;
    jinBasicMotorModel!: string | null;
    jinBasicMotorMounting!: string | null;
    jinBasicMotorSries!: string | null;
    jinFrameSize!: number;
    jinPower!: string | null;
    jinCodeVC!: SMVC[] | null;
    status!: number;
    confirmStatus!: number;
    insulation!: string | null;
    safty!: string | null;
    basicMotorTypeName!: string | null;
    /** 境界标识符 */
    jinCategoryCode!: string | null;
    /** 境界版本 */
    jinVersion!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.cpBasicMotorCode = _data["cpBasicMotorCode"] !== undefined ? _data["cpBasicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
            this.isHaveVc = _data["isHaveVc"] !== undefined ? _data["isHaveVc"] : null as any;
            (this as any).isHaveVcName = _data["isHaveVcName"] !== undefined ? _data["isHaveVcName"] : null as any;
            this.isNeedHeightOutput = _data["isNeedHeightOutput"] !== undefined ? _data["isNeedHeightOutput"] : null as any;
            (this as any).isNeedHeightOutputName = _data["isNeedHeightOutputName"] !== undefined ? _data["isNeedHeightOutputName"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.encoder = _data["encoder"] !== undefined ? _data["encoder"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.capacityCycle = _data["capacityCycle"] !== undefined ? _data["capacityCycle"] : null as any;
            if (Array.isArray(_data["basicMotorParameters"])) {
                this.basicMotorParameters = [] as any;
                for (let item of _data["basicMotorParameters"])
                    this.basicMotorParameters!.push(BasicMotorParameterOutputDto.fromJS(item));
            }
            else {
                this.basicMotorParameters = null as any;
            }
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.voltageCode = _data["voltageCode"] !== undefined ? _data["voltageCode"] : null as any;
            this.brake = _data["brake"] !== undefined ? _data["brake"] : null as any;
            this.rowKey = _data["rowKey"] !== undefined ? _data["rowKey"] : null as any;
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.cpName = _data["cpName"] !== undefined ? _data["cpName"] : null as any;
            this.customerRemark = _data["customerRemark"] !== undefined ? _data["customerRemark"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.inToOutCycle = _data["inToOutCycle"] !== undefined ? _data["inToOutCycle"] : null as any;
            this.jinBasicMotorCode = _data["jinBasicMotorCode"] !== undefined ? _data["jinBasicMotorCode"] : null as any;
            this.jinBasicMotorModel = _data["jinBasicMotorModel"] !== undefined ? _data["jinBasicMotorModel"] : null as any;
            this.jinBasicMotorMounting = _data["jinBasicMotorMounting"] !== undefined ? _data["jinBasicMotorMounting"] : null as any;
            this.jinBasicMotorSries = _data["jinBasicMotorSries"] !== undefined ? _data["jinBasicMotorSries"] : null as any;
            this.jinFrameSize = _data["jinFrameSize"] !== undefined ? _data["jinFrameSize"] : null as any;
            this.jinPower = _data["jinPower"] !== undefined ? _data["jinPower"] : null as any;
            if (Array.isArray(_data["jinCodeVC"])) {
                this.jinCodeVC = [] as any;
                for (let item of _data["jinCodeVC"])
                    this.jinCodeVC!.push(SMVC.fromJS(item));
            }
            else {
                this.jinCodeVC = null as any;
            }
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.confirmStatus = _data["confirmStatus"] !== undefined ? _data["confirmStatus"] : null as any;
            this.insulation = _data["insulation"] !== undefined ? _data["insulation"] : null as any;
            this.safty = _data["safty"] !== undefined ? _data["safty"] : null as any;
            this.basicMotorTypeName = _data["basicMotorTypeName"] !== undefined ? _data["basicMotorTypeName"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
        }
    }

    static fromJS(data: any): GetSameBasicCodeJINCodesOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSameBasicCodeJINCodesOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["cpBasicMotorCode"] = this.cpBasicMotorCode !== undefined ? this.cpBasicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        data["isHaveVc"] = this.isHaveVc !== undefined ? this.isHaveVc : null as any;
        data["isHaveVcName"] = this.isHaveVcName !== undefined ? this.isHaveVcName : null as any;
        data["isNeedHeightOutput"] = this.isNeedHeightOutput !== undefined ? this.isNeedHeightOutput : null as any;
        data["isNeedHeightOutputName"] = this.isNeedHeightOutputName !== undefined ? this.isNeedHeightOutputName : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["encoder"] = this.encoder !== undefined ? this.encoder : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["capacityCycle"] = this.capacityCycle !== undefined ? this.capacityCycle : null as any;
        if (Array.isArray(this.basicMotorParameters)) {
            data["basicMotorParameters"] = [];
            for (let item of this.basicMotorParameters)
                data["basicMotorParameters"].push(item ? item.toJSON() : null as any);
        }
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["voltageCode"] = this.voltageCode !== undefined ? this.voltageCode : null as any;
        data["brake"] = this.brake !== undefined ? this.brake : null as any;
        data["rowKey"] = this.rowKey !== undefined ? this.rowKey : null as any;
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["cpName"] = this.cpName !== undefined ? this.cpName : null as any;
        data["customerRemark"] = this.customerRemark !== undefined ? this.customerRemark : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["inToOutCycle"] = this.inToOutCycle !== undefined ? this.inToOutCycle : null as any;
        data["jinBasicMotorCode"] = this.jinBasicMotorCode !== undefined ? this.jinBasicMotorCode : null as any;
        data["jinBasicMotorModel"] = this.jinBasicMotorModel !== undefined ? this.jinBasicMotorModel : null as any;
        data["jinBasicMotorMounting"] = this.jinBasicMotorMounting !== undefined ? this.jinBasicMotorMounting : null as any;
        data["jinBasicMotorSries"] = this.jinBasicMotorSries !== undefined ? this.jinBasicMotorSries : null as any;
        data["jinFrameSize"] = this.jinFrameSize !== undefined ? this.jinFrameSize : null as any;
        data["jinPower"] = this.jinPower !== undefined ? this.jinPower : null as any;
        if (Array.isArray(this.jinCodeVC)) {
            data["jinCodeVC"] = [];
            for (let item of this.jinCodeVC)
                data["jinCodeVC"].push(item ? item.toJSON() : null as any);
        }
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["confirmStatus"] = this.confirmStatus !== undefined ? this.confirmStatus : null as any;
        data["insulation"] = this.insulation !== undefined ? this.insulation : null as any;
        data["safty"] = this.safty !== undefined ? this.safty : null as any;
        data["basicMotorTypeName"] = this.basicMotorTypeName !== undefined ? this.basicMotorTypeName : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        return data;
    }
}

export class GetSingleVCNotificationRulesForEditOutput {
    singleVCNotificationRules!: CreateOrEditSingleVCNotificationRulesDto;

    init(_data?: any) {
        if (_data) {
            this.singleVCNotificationRules = _data["singleVCNotificationRules"] ? CreateOrEditSingleVCNotificationRulesDto.fromJS(_data["singleVCNotificationRules"]) : null as any;
        }
    }

    static fromJS(data: any): GetSingleVCNotificationRulesForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSingleVCNotificationRulesForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["singleVCNotificationRules"] = this.singleVCNotificationRules ? this.singleVCNotificationRules.toJSON() : null as any;
        return data;
    }
}

export class GetTechnologyAgreementDetailsOutPutDto {
    id!: string;
    version!: string | null;
    industry!: string | null;
    projectName!: string | null;
    technicalSpecifications!: string | null;
    technicalConfirmation!: string | null;
    teAttachs!: string | null;
    teRemark!: string | null;
    pmsProjectType!: number | null;
    teStatus!: TechnologyQuotationStatus;
    technologyQuotationProducts!: TechnologyAgreementDetailsProduct[] | null;
    technologyApprovals!: TechnologyAgreementDetailstApproval[] | null;
    quotationApprovals!: TechnologyAgreementDetailstApproval[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.industry = _data["industry"] !== undefined ? _data["industry"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.technicalConfirmation = _data["technicalConfirmation"] !== undefined ? _data["technicalConfirmation"] : null as any;
            this.teAttachs = _data["teAttachs"] !== undefined ? _data["teAttachs"] : null as any;
            this.teRemark = _data["teRemark"] !== undefined ? _data["teRemark"] : null as any;
            this.pmsProjectType = _data["pmsProjectType"] !== undefined ? _data["pmsProjectType"] : null as any;
            this.teStatus = _data["teStatus"] !== undefined ? _data["teStatus"] : null as any;
            if (Array.isArray(_data["technologyQuotationProducts"])) {
                this.technologyQuotationProducts = [] as any;
                for (let item of _data["technologyQuotationProducts"])
                    this.technologyQuotationProducts!.push(TechnologyAgreementDetailsProduct.fromJS(item));
            }
            else {
                this.technologyQuotationProducts = null as any;
            }
            if (Array.isArray(_data["technologyApprovals"])) {
                this.technologyApprovals = [] as any;
                for (let item of _data["technologyApprovals"])
                    this.technologyApprovals!.push(TechnologyAgreementDetailstApproval.fromJS(item));
            }
            else {
                this.technologyApprovals = null as any;
            }
            if (Array.isArray(_data["quotationApprovals"])) {
                this.quotationApprovals = [] as any;
                for (let item of _data["quotationApprovals"])
                    this.quotationApprovals!.push(TechnologyAgreementDetailstApproval.fromJS(item));
            }
            else {
                this.quotationApprovals = null as any;
            }
        }
    }

    static fromJS(data: any): GetTechnologyAgreementDetailsOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTechnologyAgreementDetailsOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["industry"] = this.industry !== undefined ? this.industry : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["technicalConfirmation"] = this.technicalConfirmation !== undefined ? this.technicalConfirmation : null as any;
        data["teAttachs"] = this.teAttachs !== undefined ? this.teAttachs : null as any;
        data["teRemark"] = this.teRemark !== undefined ? this.teRemark : null as any;
        data["pmsProjectType"] = this.pmsProjectType !== undefined ? this.pmsProjectType : null as any;
        data["teStatus"] = this.teStatus !== undefined ? this.teStatus : null as any;
        if (Array.isArray(this.technologyQuotationProducts)) {
            data["technologyQuotationProducts"] = [];
            for (let item of this.technologyQuotationProducts)
                data["technologyQuotationProducts"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.technologyApprovals)) {
            data["technologyApprovals"] = [];
            for (let item of this.technologyApprovals)
                data["technologyApprovals"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.quotationApprovals)) {
            data["quotationApprovals"] = [];
            for (let item of this.quotationApprovals)
                data["quotationApprovals"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetTechnologyQuotationDto {
    id!: string;
    creationTime!: moment.Moment;
    projectName!: string | null;
    industry!: string | null;
    cycle!: number;
    clienter!: string | null;
    clientName!: string | null;
    technicalSpecifications!: string | null;
    technicalConfirmation!: string | null;
    teAttachs!: string | null;
    teRemark!: string | null;
    dqRemark!: string | null;
    teStatus!: TechnologyQuotationStatus;
    domesticQuotationNumber!: string | null;
    dqAttachs!: string | null;
    dqStatus!: TechnologyQuotationStatus;
    quotationExpiredTime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.industry = _data["industry"] !== undefined ? _data["industry"] : null as any;
            this.cycle = _data["cycle"] !== undefined ? _data["cycle"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.technicalConfirmation = _data["technicalConfirmation"] !== undefined ? _data["technicalConfirmation"] : null as any;
            this.teAttachs = _data["teAttachs"] !== undefined ? _data["teAttachs"] : null as any;
            this.teRemark = _data["teRemark"] !== undefined ? _data["teRemark"] : null as any;
            this.dqRemark = _data["dqRemark"] !== undefined ? _data["dqRemark"] : null as any;
            this.teStatus = _data["teStatus"] !== undefined ? _data["teStatus"] : null as any;
            this.domesticQuotationNumber = _data["domesticQuotationNumber"] !== undefined ? _data["domesticQuotationNumber"] : null as any;
            this.dqAttachs = _data["dqAttachs"] !== undefined ? _data["dqAttachs"] : null as any;
            this.dqStatus = _data["dqStatus"] !== undefined ? _data["dqStatus"] : null as any;
            this.quotationExpiredTime = _data["quotationExpiredTime"] ? moment(_data["quotationExpiredTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): GetTechnologyQuotationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTechnologyQuotationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["industry"] = this.industry !== undefined ? this.industry : null as any;
        data["cycle"] = this.cycle !== undefined ? this.cycle : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["technicalConfirmation"] = this.technicalConfirmation !== undefined ? this.technicalConfirmation : null as any;
        data["teAttachs"] = this.teAttachs !== undefined ? this.teAttachs : null as any;
        data["teRemark"] = this.teRemark !== undefined ? this.teRemark : null as any;
        data["dqRemark"] = this.dqRemark !== undefined ? this.dqRemark : null as any;
        data["teStatus"] = this.teStatus !== undefined ? this.teStatus : null as any;
        data["domesticQuotationNumber"] = this.domesticQuotationNumber !== undefined ? this.domesticQuotationNumber : null as any;
        data["dqAttachs"] = this.dqAttachs !== undefined ? this.dqAttachs : null as any;
        data["dqStatus"] = this.dqStatus !== undefined ? this.dqStatus : null as any;
        data["quotationExpiredTime"] = this.quotationExpiredTime ? this.quotationExpiredTime.toISOString() : null as any;
        return data;
    }
}

export class GetTechnologyQuotationProductDto {
    id!: string;
    motorModelOnTheNameplate!: string | null;
    systemMOdel!: string | null;
    powerPoleNo!: string | null;
    voltageFrequency!: string | null;
    technologyAgreementBasicMotorMounting!: string | null;
    ip!: string | null;
    ic!: string | null;
    insulationTemperatureRiseClass!: string | null;
    directionOfRotation!: string | null;
    ambientTemperature!: string | null;
    application!: string | null;
    workingSystem!: string | null;
    other!: string | null;
    structurecharT!: string | null;
    technicalDataTable!: string | null;
    basicMotorCode!: string | null;
    basicMotorModel!: string | null;
    basicMotorMounting!: string | null;
    frameNo!: number;
    basicMotorType!: BasicMotorType;
    basicMotorSries!: string | null;
    unitPrice!: number | null;
    unitPriceResult!: string | null;
    unitPriceFormula!: string | null;
    cost!: number | null;
    costFormula!: string | null;
    costType!: CostType;
    costTypeDetail!: string | null;
    quotationPrinciple!: string | null;
    quotationPrincipleDetails!: string | null;
    teRemark!: string | null;
    dqRemark!: string | null;
    cycle!: number;
    jinCategoryCode!: string | null;
    jinVersion!: string | null;
    listPriceMultiplier!: number;
    lineNumber!: string | null;
    technologyQuotationId!: string;
    technologyQuotation!: GetTechnologyQuotationDto;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.motorModelOnTheNameplate = _data["motorModelOnTheNameplate"] !== undefined ? _data["motorModelOnTheNameplate"] : null as any;
            this.systemMOdel = _data["systemMOdel"] !== undefined ? _data["systemMOdel"] : null as any;
            this.powerPoleNo = _data["powerPoleNo"] !== undefined ? _data["powerPoleNo"] : null as any;
            this.voltageFrequency = _data["voltageFrequency"] !== undefined ? _data["voltageFrequency"] : null as any;
            this.technologyAgreementBasicMotorMounting = _data["technologyAgreementBasicMotorMounting"] !== undefined ? _data["technologyAgreementBasicMotorMounting"] : null as any;
            this.ip = _data["ip"] !== undefined ? _data["ip"] : null as any;
            this.ic = _data["ic"] !== undefined ? _data["ic"] : null as any;
            this.insulationTemperatureRiseClass = _data["insulationTemperatureRiseClass"] !== undefined ? _data["insulationTemperatureRiseClass"] : null as any;
            this.directionOfRotation = _data["directionOfRotation"] !== undefined ? _data["directionOfRotation"] : null as any;
            this.ambientTemperature = _data["ambientTemperature"] !== undefined ? _data["ambientTemperature"] : null as any;
            this.application = _data["application"] !== undefined ? _data["application"] : null as any;
            this.workingSystem = _data["workingSystem"] !== undefined ? _data["workingSystem"] : null as any;
            this.other = _data["other"] !== undefined ? _data["other"] : null as any;
            this.structurecharT = _data["structurecharT"] !== undefined ? _data["structurecharT"] : null as any;
            this.technicalDataTable = _data["technicalDataTable"] !== undefined ? _data["technicalDataTable"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.basicMotorType = _data["basicMotorType"] !== undefined ? _data["basicMotorType"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.teRemark = _data["teRemark"] !== undefined ? _data["teRemark"] : null as any;
            this.dqRemark = _data["dqRemark"] !== undefined ? _data["dqRemark"] : null as any;
            this.cycle = _data["cycle"] !== undefined ? _data["cycle"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.listPriceMultiplier = _data["listPriceMultiplier"] !== undefined ? _data["listPriceMultiplier"] : null as any;
            this.lineNumber = _data["lineNumber"] !== undefined ? _data["lineNumber"] : null as any;
            this.technologyQuotationId = _data["technologyQuotationId"] !== undefined ? _data["technologyQuotationId"] : null as any;
            this.technologyQuotation = _data["technologyQuotation"] ? GetTechnologyQuotationDto.fromJS(_data["technologyQuotation"]) : null as any;
        }
    }

    static fromJS(data: any): GetTechnologyQuotationProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTechnologyQuotationProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["motorModelOnTheNameplate"] = this.motorModelOnTheNameplate !== undefined ? this.motorModelOnTheNameplate : null as any;
        data["systemMOdel"] = this.systemMOdel !== undefined ? this.systemMOdel : null as any;
        data["powerPoleNo"] = this.powerPoleNo !== undefined ? this.powerPoleNo : null as any;
        data["voltageFrequency"] = this.voltageFrequency !== undefined ? this.voltageFrequency : null as any;
        data["technologyAgreementBasicMotorMounting"] = this.technologyAgreementBasicMotorMounting !== undefined ? this.technologyAgreementBasicMotorMounting : null as any;
        data["ip"] = this.ip !== undefined ? this.ip : null as any;
        data["ic"] = this.ic !== undefined ? this.ic : null as any;
        data["insulationTemperatureRiseClass"] = this.insulationTemperatureRiseClass !== undefined ? this.insulationTemperatureRiseClass : null as any;
        data["directionOfRotation"] = this.directionOfRotation !== undefined ? this.directionOfRotation : null as any;
        data["ambientTemperature"] = this.ambientTemperature !== undefined ? this.ambientTemperature : null as any;
        data["application"] = this.application !== undefined ? this.application : null as any;
        data["workingSystem"] = this.workingSystem !== undefined ? this.workingSystem : null as any;
        data["other"] = this.other !== undefined ? this.other : null as any;
        data["structurecharT"] = this.structurecharT !== undefined ? this.structurecharT : null as any;
        data["technicalDataTable"] = this.technicalDataTable !== undefined ? this.technicalDataTable : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["basicMotorType"] = this.basicMotorType !== undefined ? this.basicMotorType : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["teRemark"] = this.teRemark !== undefined ? this.teRemark : null as any;
        data["dqRemark"] = this.dqRemark !== undefined ? this.dqRemark : null as any;
        data["cycle"] = this.cycle !== undefined ? this.cycle : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["listPriceMultiplier"] = this.listPriceMultiplier !== undefined ? this.listPriceMultiplier : null as any;
        data["lineNumber"] = this.lineNumber !== undefined ? this.lineNumber : null as any;
        data["technologyQuotationId"] = this.technologyQuotationId !== undefined ? this.technologyQuotationId : null as any;
        data["technologyQuotation"] = this.technologyQuotation ? this.technologyQuotation.toJSON() : null as any;
        return data;
    }
}

export class GetTechnologyQuotationProductVCDto {
    id!: string;
    vcID!: string | null;
    category!: string | null;
    meaning!: string | null;
    vcTypeDescription!: string | null;
    numberWires!: number;
    remark!: string | null;
    vcType!: VcType;
    unitPrice!: number | null;
    unitPriceResult!: string | null;
    unitPriceFormula!: string | null;
    unitPriceType!: UnitPriceType;
    cost!: number | null;
    costFormula!: string | null;
    costType!: CostType;
    costTypeDetail!: string | null;
    quotationPrinciple!: string | null;
    quotationPrincipleDetails!: string | null;
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    purchaseCycle!: number;
    productionCycle!: number;
    testCycle!: number;
    shipSurveyCycle!: number;
    grCycle!: number;
    dqProduct!: GetTechnologyQuotationProductDto;
    teProduct!: GetTechnologyQuotationProductDto;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.dqProduct = _data["dqProduct"] ? GetTechnologyQuotationProductDto.fromJS(_data["dqProduct"]) : null as any;
            this.teProduct = _data["teProduct"] ? GetTechnologyQuotationProductDto.fromJS(_data["teProduct"]) : null as any;
        }
    }

    static fromJS(data: any): GetTechnologyQuotationProductVCDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTechnologyQuotationProductVCDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["dqProduct"] = this.dqProduct ? this.dqProduct.toJSON() : null as any;
        data["teProduct"] = this.teProduct ? this.teProduct.toJSON() : null as any;
        return data;
    }
}

export class GetVCCycleDetailDto {
    id!: string;
    vcID!: string | null;
    category!: string | null;
    vcType!: VcType;
    readonly vcTypeName!: string | null;
    engineeringCycle!: number | null;
    engineeringCalculationMode!: EngineeringCalculationMode;
    engineeringComment!: string | null;
    purchaseCycle!: number | null;
    grCycle!: number | null;
    standardGrCycle!: number | null;
    scmCycle!: number | null;
    scmCalculationMode!: string | null;
    scmRemark!: string | null;
    extraOverlayTime!: boolean | null;
    isOverlayLogic!: boolean | null;
    purchaseComment!: string | null;
    purchaseCycleMode!: PurchaseCycleMode;
    productionCycle!: number;
    productionComment!: string | null;
    testCycle!: number;
    shipSurveyCycle!: number;
    testComment!: string | null;
    shipSurveyComment!: string | null;
    meaning!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            (this as any).vcTypeName = _data["vcTypeName"] !== undefined ? _data["vcTypeName"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.engineeringComment = _data["engineeringComment"] !== undefined ? _data["engineeringComment"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.standardGrCycle = _data["standardGrCycle"] !== undefined ? _data["standardGrCycle"] : null as any;
            this.scmCycle = _data["scmCycle"] !== undefined ? _data["scmCycle"] : null as any;
            this.scmCalculationMode = _data["scmCalculationMode"] !== undefined ? _data["scmCalculationMode"] : null as any;
            this.scmRemark = _data["scmRemark"] !== undefined ? _data["scmRemark"] : null as any;
            this.extraOverlayTime = _data["extraOverlayTime"] !== undefined ? _data["extraOverlayTime"] : null as any;
            this.isOverlayLogic = _data["isOverlayLogic"] !== undefined ? _data["isOverlayLogic"] : null as any;
            this.purchaseComment = _data["purchaseComment"] !== undefined ? _data["purchaseComment"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.productionComment = _data["productionComment"] !== undefined ? _data["productionComment"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.testComment = _data["testComment"] !== undefined ? _data["testComment"] : null as any;
            this.shipSurveyComment = _data["shipSurveyComment"] !== undefined ? _data["shipSurveyComment"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
        }
    }

    static fromJS(data: any): GetVCCycleDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetVCCycleDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcTypeName"] = this.vcTypeName !== undefined ? this.vcTypeName : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["engineeringComment"] = this.engineeringComment !== undefined ? this.engineeringComment : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["standardGrCycle"] = this.standardGrCycle !== undefined ? this.standardGrCycle : null as any;
        data["scmCycle"] = this.scmCycle !== undefined ? this.scmCycle : null as any;
        data["scmCalculationMode"] = this.scmCalculationMode !== undefined ? this.scmCalculationMode : null as any;
        data["scmRemark"] = this.scmRemark !== undefined ? this.scmRemark : null as any;
        data["extraOverlayTime"] = this.extraOverlayTime !== undefined ? this.extraOverlayTime : null as any;
        data["isOverlayLogic"] = this.isOverlayLogic !== undefined ? this.isOverlayLogic : null as any;
        data["purchaseComment"] = this.purchaseComment !== undefined ? this.purchaseComment : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["productionComment"] = this.productionComment !== undefined ? this.productionComment : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["testComment"] = this.testComment !== undefined ? this.testComment : null as any;
        data["shipSurveyComment"] = this.shipSurveyComment !== undefined ? this.shipSurveyComment : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        return data;
    }
}

export class GetVCIDSelectDto {
    value!: string | null;
    label!: string | null;
    categoryId!: string;
    meaning!: string | null;
    vcID!: string | null;
    basicMotorSries!: string[] | null;
    frameNo!: { [key: string]: number[]; } | null;

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            if (Array.isArray(_data["basicMotorSries"])) {
                this.basicMotorSries = [] as any;
                for (let item of _data["basicMotorSries"])
                    this.basicMotorSries!.push(item);
            }
            else {
                this.basicMotorSries = null as any;
            }
            if (_data["frameNo"]) {
                this.frameNo = {} as any;
                for (let key in _data["frameNo"]) {
                    if (_data["frameNo"].hasOwnProperty(key))
                        (this.frameNo as any)![key] = _data["frameNo"][key] !== undefined ? _data["frameNo"][key] : null as any;
                }
            }
            else {
                this.frameNo = null as any;
            }
        }
    }

    static fromJS(data: any): GetVCIDSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetVCIDSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        if (Array.isArray(this.basicMotorSries)) {
            data["basicMotorSries"] = [];
            for (let item of this.basicMotorSries)
                data["basicMotorSries"].push(item);
        }
        if (this.frameNo) {
            data["frameNo"] = {};
            for (let key in this.frameNo) {
                if (this.frameNo.hasOwnProperty(key))
                    (data["frameNo"] as any)[key] = this.frameNo[key] !== undefined ? this.frameNo[key] : null as any;
            }
        }
        return data;
    }
}

export class GetVCInfoDetailDto {
    id!: string;
    /** VC ID */
    vcID!: string | null;
    /** 品类 */
    categoryId!: string;
    /** 品类 */
    category!: string | null;
    /** VC含义 */
    meaning!: string | null;
    /** 英文含义 */
    englishMeaning!: string | null;
    /** VC备注 */
    vcTypeDescription!: string | null;
    /** VC头数 */
    numberWires!: number;
    /** 999长代码 */
    vcLongCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.vcLongCode = _data["vcLongCode"] !== undefined ? _data["vcLongCode"] : null as any;
        }
    }

    static fromJS(data: any): GetVCInfoDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetVCInfoDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["vcLongCode"] = this.vcLongCode !== undefined ? this.vcLongCode : null as any;
        return data;
    }
}

export class GreenChannelReviewNoDto {
    id!: string | null;
    /** 客户编号 */
    customerNo!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 产品ID */
    productId!: string;
    /** 产品编号 */
    productNo!: string | null;
    /** VcID */
    vcId!: string | null;
    /** 绿通号 */
    reviewNo!: string | null;
    /** Vc编号 */
    vcCode!: string | null;
    /** 生效时间 */
    beginTime!: moment.Moment | null;
    /** 失效时间 */
    endTime!: moment.Moment | null;
    /** 排序时间 */
    sortTime!: moment.Moment | null;
    isEnable!: boolean;
    /** 天数规则 */
    daysRule!: string | null;
    /** 交期周数规则 */
    deliveryWeekRule!: string | null;
    beginStringRule!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : null as any;
            this.productNo = _data["productNo"] !== undefined ? _data["productNo"] : null as any;
            this.vcId = _data["vcId"] !== undefined ? _data["vcId"] : null as any;
            this.reviewNo = _data["reviewNo"] !== undefined ? _data["reviewNo"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.beginTime = _data["beginTime"] ? moment(_data["beginTime"].toString()) : null as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : null as any;
            this.sortTime = _data["sortTime"] ? moment(_data["sortTime"].toString()) : null as any;
            this.isEnable = _data["isEnable"] !== undefined ? _data["isEnable"] : null as any;
            this.daysRule = _data["daysRule"] !== undefined ? _data["daysRule"] : null as any;
            this.deliveryWeekRule = _data["deliveryWeekRule"] !== undefined ? _data["deliveryWeekRule"] : null as any;
            this.beginStringRule = _data["beginStringRule"] !== undefined ? _data["beginStringRule"] : null as any;
        }
    }

    static fromJS(data: any): GreenChannelReviewNoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GreenChannelReviewNoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["productId"] = this.productId !== undefined ? this.productId : null as any;
        data["productNo"] = this.productNo !== undefined ? this.productNo : null as any;
        data["vcId"] = this.vcId !== undefined ? this.vcId : null as any;
        data["reviewNo"] = this.reviewNo !== undefined ? this.reviewNo : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["beginTime"] = this.beginTime ? this.beginTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        data["sortTime"] = this.sortTime ? this.sortTime.toISOString() : null as any;
        data["isEnable"] = this.isEnable !== undefined ? this.isEnable : null as any;
        data["daysRule"] = this.daysRule !== undefined ? this.daysRule : null as any;
        data["deliveryWeekRule"] = this.deliveryWeekRule !== undefined ? this.deliveryWeekRule : null as any;
        data["beginStringRule"] = this.beginStringRule !== undefined ? this.beginStringRule : null as any;
        return data;
    }
}

export class GreenChannelReviewNoListInDto {
    /** 客户名称 */
    customerName!: string | null;
    /** 产品编码 */
    productNo!: string | null;
    /** vc编码 */
    vcCode!: string | null;
    /** 绿通号 */
    reviewNo!: string | null;
    /** 有效期开始时间 */
    beginTime!: moment.Moment | null;
    /** 有效期结束时间 */
    endTime!: moment.Moment | null;
    /** 是否启用 */
    isEnable!: boolean | null;
    skipCount!: number;
    maxResultCount!: number;

    init(_data?: any) {
        if (_data) {
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.productNo = _data["productNo"] !== undefined ? _data["productNo"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.reviewNo = _data["reviewNo"] !== undefined ? _data["reviewNo"] : null as any;
            this.beginTime = _data["beginTime"] ? moment(_data["beginTime"].toString()) : null as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : null as any;
            this.isEnable = _data["isEnable"] !== undefined ? _data["isEnable"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
        }
    }

    static fromJS(data: any): GreenChannelReviewNoListInDto {
        data = typeof data === 'object' ? data : {};
        let result = new GreenChannelReviewNoListInDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["productNo"] = this.productNo !== undefined ? this.productNo : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["reviewNo"] = this.reviewNo !== undefined ? this.reviewNo : null as any;
        data["beginTime"] = this.beginTime ? this.beginTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        data["isEnable"] = this.isEnable !== undefined ? this.isEnable : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        return data;
    }
}

export class GreenChannelReviewNoListOutDto {
    id!: string | null;
    /** 客户编号 */
    customerNo!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 产品ID */
    productId!: string;
    /** 产品编号 */
    productNo!: string | null;
    /** VcID */
    vcId!: string | null;
    /** 绿通号 */
    reviewNo!: string | null;
    /** Vc编号 */
    vcCode!: string | null;
    /** 生效时间 */
    beginTime!: moment.Moment | null;
    /** 失效时间 */
    endTime!: moment.Moment | null;
    /** 排序时间 */
    sortTime!: moment.Moment | null;
    isEnable!: boolean;
    /** 天数规则 */
    daysRule!: string | null;
    /** 交期周数规则 */
    deliveryWeekRule!: string | null;
    beginStringRule!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.customerNo = _data["customerNo"] !== undefined ? _data["customerNo"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : null as any;
            this.productNo = _data["productNo"] !== undefined ? _data["productNo"] : null as any;
            this.vcId = _data["vcId"] !== undefined ? _data["vcId"] : null as any;
            this.reviewNo = _data["reviewNo"] !== undefined ? _data["reviewNo"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.beginTime = _data["beginTime"] ? moment(_data["beginTime"].toString()) : null as any;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : null as any;
            this.sortTime = _data["sortTime"] ? moment(_data["sortTime"].toString()) : null as any;
            this.isEnable = _data["isEnable"] !== undefined ? _data["isEnable"] : null as any;
            this.daysRule = _data["daysRule"] !== undefined ? _data["daysRule"] : null as any;
            this.deliveryWeekRule = _data["deliveryWeekRule"] !== undefined ? _data["deliveryWeekRule"] : null as any;
            this.beginStringRule = _data["beginStringRule"] !== undefined ? _data["beginStringRule"] : null as any;
        }
    }

    static fromJS(data: any): GreenChannelReviewNoListOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GreenChannelReviewNoListOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["customerNo"] = this.customerNo !== undefined ? this.customerNo : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["productId"] = this.productId !== undefined ? this.productId : null as any;
        data["productNo"] = this.productNo !== undefined ? this.productNo : null as any;
        data["vcId"] = this.vcId !== undefined ? this.vcId : null as any;
        data["reviewNo"] = this.reviewNo !== undefined ? this.reviewNo : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["beginTime"] = this.beginTime ? this.beginTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        data["sortTime"] = this.sortTime ? this.sortTime.toISOString() : null as any;
        data["isEnable"] = this.isEnable !== undefined ? this.isEnable : null as any;
        data["daysRule"] = this.daysRule !== undefined ? this.daysRule : null as any;
        data["deliveryWeekRule"] = this.deliveryWeekRule !== undefined ? this.deliveryWeekRule : null as any;
        data["beginStringRule"] = this.beginStringRule !== undefined ? this.beginStringRule : null as any;
        return data;
    }
}

export class GreenChannelReviewNoListOutDtoPagedResultDto {
    items!: GreenChannelReviewNoListOutDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GreenChannelReviewNoListOutDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): GreenChannelReviewNoListOutDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GreenChannelReviewNoListOutDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 绿通启用状态修改DTO */
export class GreenChannelSetEnableDto {
    /** 主键 */
    id!: string[] | null;
    /** 是否启用 */
    isEnable!: boolean;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["id"])) {
                this.id = [] as any;
                for (let item of _data["id"])
                    this.id!.push(item);
            }
            else {
                this.id = null as any;
            }
            this.isEnable = _data["isEnable"] !== undefined ? _data["isEnable"] : null as any;
        }
    }

    static fromJS(data: any): GreenChannelSetEnableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GreenChannelSetEnableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.id)) {
            data["id"] = [];
            for (let item of this.id)
                data["id"].push(item);
        }
        data["isEnable"] = this.isEnable !== undefined ? this.isEnable : null as any;
        return data;
    }
}

export class HelpCompleteRecord {
    /** 完成协助时间 */
    creationTime!: moment.Moment;
    /** 请求协助关联Id */
    lectoTypeHelpInfoId!: string | null;
    /** 请求协助时间 */
    applyCreationTime!: moment.Moment | null;
    /** 请求协助时备注 */
    remark!: string | null;
    /** 请求协助上传附件 */
    attachmentFiles!: AttachmentFileInfo[] | null;
    /** 完成协助时备注 */
    completeRemark!: string | null;
    /** 完成协助上传附件 */
    completeAttachmentFiles!: AttachmentFileInfo[] | null;
    /** 请求协助完成人 */
    gcsUserName!: string | null;
    /** 请求协助文件名 根据用户权限给不一样 */
    lectoTypeInfoFileName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.lectoTypeHelpInfoId = _data["lectoTypeHelpInfoId"] !== undefined ? _data["lectoTypeHelpInfoId"] : null as any;
            this.applyCreationTime = _data["applyCreationTime"] ? moment(_data["applyCreationTime"].toString()) : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            if (Array.isArray(_data["attachmentFiles"])) {
                this.attachmentFiles = [] as any;
                for (let item of _data["attachmentFiles"])
                    this.attachmentFiles!.push(AttachmentFileInfo.fromJS(item));
            }
            else {
                this.attachmentFiles = null as any;
            }
            this.completeRemark = _data["completeRemark"] !== undefined ? _data["completeRemark"] : null as any;
            if (Array.isArray(_data["completeAttachmentFiles"])) {
                this.completeAttachmentFiles = [] as any;
                for (let item of _data["completeAttachmentFiles"])
                    this.completeAttachmentFiles!.push(AttachmentFileInfo.fromJS(item));
            }
            else {
                this.completeAttachmentFiles = null as any;
            }
            this.gcsUserName = _data["gcsUserName"] !== undefined ? _data["gcsUserName"] : null as any;
            this.lectoTypeInfoFileName = _data["lectoTypeInfoFileName"] !== undefined ? _data["lectoTypeInfoFileName"] : null as any;
        }
    }

    static fromJS(data: any): HelpCompleteRecord {
        data = typeof data === 'object' ? data : {};
        let result = new HelpCompleteRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["lectoTypeHelpInfoId"] = this.lectoTypeHelpInfoId !== undefined ? this.lectoTypeHelpInfoId : null as any;
        data["applyCreationTime"] = this.applyCreationTime ? this.applyCreationTime.toISOString() : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        if (Array.isArray(this.attachmentFiles)) {
            data["attachmentFiles"] = [];
            for (let item of this.attachmentFiles)
                data["attachmentFiles"].push(item ? item.toJSON() : null as any);
        }
        data["completeRemark"] = this.completeRemark !== undefined ? this.completeRemark : null as any;
        if (Array.isArray(this.completeAttachmentFiles)) {
            data["completeAttachmentFiles"] = [];
            for (let item of this.completeAttachmentFiles)
                data["completeAttachmentFiles"].push(item ? item.toJSON() : null as any);
        }
        data["gcsUserName"] = this.gcsUserName !== undefined ? this.gcsUserName : null as any;
        data["lectoTypeInfoFileName"] = this.lectoTypeInfoFileName !== undefined ? this.lectoTypeInfoFileName : null as any;
        return data;
    }
}

export class HelpLectoType {
    id!: string;
    remark!: string | null;
    changeSelectedIds!: string[] | null;
    helpTag!: number | null;
    gcsUserId!: number | null;
    fileInfos!: AttachmentFileInfo[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            if (Array.isArray(_data["changeSelectedIds"])) {
                this.changeSelectedIds = [] as any;
                for (let item of _data["changeSelectedIds"])
                    this.changeSelectedIds!.push(item);
            }
            else {
                this.changeSelectedIds = null as any;
            }
            this.helpTag = _data["helpTag"] !== undefined ? _data["helpTag"] : null as any;
            this.gcsUserId = _data["gcsUserId"] !== undefined ? _data["gcsUserId"] : null as any;
            if (Array.isArray(_data["fileInfos"])) {
                this.fileInfos = [] as any;
                for (let item of _data["fileInfos"])
                    this.fileInfos!.push(AttachmentFileInfo.fromJS(item));
            }
            else {
                this.fileInfos = null as any;
            }
        }
    }

    static fromJS(data: any): HelpLectoType {
        data = typeof data === 'object' ? data : {};
        let result = new HelpLectoType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        if (Array.isArray(this.changeSelectedIds)) {
            data["changeSelectedIds"] = [];
            for (let item of this.changeSelectedIds)
                data["changeSelectedIds"].push(item);
        }
        data["helpTag"] = this.helpTag !== undefined ? this.helpTag : null as any;
        data["gcsUserId"] = this.gcsUserId !== undefined ? this.gcsUserId : null as any;
        if (Array.isArray(this.fileInfos)) {
            data["fileInfos"] = [];
            for (let item of this.fileInfos)
                data["fileInfos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class ICustomAttributeProvider {

    init(_data?: any) {
    }

    static fromJS(data: any): ICustomAttributeProvider {
        data = typeof data === 'object' ? data : {};
        let result = new ICustomAttributeProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export class ImportOutput {
    readonly success!: boolean;
    importCount!: number;
    readonly exceptions!: ExcelException[] | null;

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"] !== undefined ? _data["success"] : null as any;
            this.importCount = _data["importCount"] !== undefined ? _data["importCount"] : null as any;
            if (Array.isArray(_data["exceptions"])) {
                (this as any).exceptions = [] as any;
                for (let item of _data["exceptions"])
                    (this as any).exceptions!.push(ExcelException.fromJS(item));
            }
            else {
                (this as any).exceptions = null as any;
            }
        }
    }

    static fromJS(data: any): ImportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ImportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : null as any;
        data["importCount"] = this.importCount !== undefined ? this.importCount : null as any;
        if (Array.isArray(this.exceptions)) {
            data["exceptions"] = [];
            for (let item of this.exceptions)
                data["exceptions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class IntPtr {

    init(_data?: any) {
    }

    static fromJS(data: any): IntPtr {
        data = typeof data === 'object' ? data : {};
        let result = new IntPtr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** 0 = CanCarry 1 = MustCarry (Y) 2 = NoCarry (N) -1 = unlimited (未知) */
export enum IsHaveVc {
    CanCarry = 0,
    MustCarry = 1,
    NoCarry = 2,
    Unlimited = -1,
}

/** 0 = No (N) 1 = Yes (Y) -2 = Null -1 = Undfiend (未知) */
export enum IsYes {
    No = 0,
    Yes = 1,
    Null = -2,
    Undfiend = -1,
}

export class JINCodeDto {
    id!: string;
    /** 境界代码 */
    jinMotorCode!: string;
    /** 标准电机代码 */
    basicMotorCode!: string;
    hasVCs!: boolean;
    canCarryVCs!: boolean;
    version!: string;
    subCustomerCode!: string | null;
    customerCode!: string | null;
    listPriceMultiplier!: number;
    /** 物料描述 */
    materialDescription!: string | null;
    /** 境界标识符 */
    jinIndicator!: string | null;
    /** 境界电机交期 */
    jinMotorCycle!: number;
    /** 境界电机整机交期 */
    jinMotorExpectedDeliveryDate!: number;
    /** 电机安装方式 */
    mountingName!: string | null;
    /** 铭牌 */
    jinTypeDesignation!: string | null;
    /** 电机型号 */
    jinMotorModel!: string | null;
    /** 电机单价 - JIN Code */
    jinUnitPrice!: number;
    basicMotorInfo!: PageBasicMotorInfoOutputDto;
    /** VC信息 */
    vCs!: PageCheckVcRulesOutputDto[] | null;
    /** 电机参数 */
    basicMotorParameters!: BasicMotorParameterOutputDto[] | null;
    /** 境界代码电机参数 */
    jinBasicMotorParameters!: BasicMotorParameterOutputDto[] | null;
    /** 对应国产报价产品Id */
    technologyQuotationProductId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.jinMotorCode = _data["jinMotorCode"] !== undefined ? _data["jinMotorCode"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.hasVCs = _data["hasVCs"] !== undefined ? _data["hasVCs"] : null as any;
            this.canCarryVCs = _data["canCarryVCs"] !== undefined ? _data["canCarryVCs"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.subCustomerCode = _data["subCustomerCode"] !== undefined ? _data["subCustomerCode"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.listPriceMultiplier = _data["listPriceMultiplier"] !== undefined ? _data["listPriceMultiplier"] : null as any;
            this.materialDescription = _data["materialDescription"] !== undefined ? _data["materialDescription"] : null as any;
            this.jinIndicator = _data["jinIndicator"] !== undefined ? _data["jinIndicator"] : null as any;
            this.jinMotorCycle = _data["jinMotorCycle"] !== undefined ? _data["jinMotorCycle"] : null as any;
            this.jinMotorExpectedDeliveryDate = _data["jinMotorExpectedDeliveryDate"] !== undefined ? _data["jinMotorExpectedDeliveryDate"] : null as any;
            this.mountingName = _data["mountingName"] !== undefined ? _data["mountingName"] : null as any;
            this.jinTypeDesignation = _data["jinTypeDesignation"] !== undefined ? _data["jinTypeDesignation"] : null as any;
            this.jinMotorModel = _data["jinMotorModel"] !== undefined ? _data["jinMotorModel"] : null as any;
            this.jinUnitPrice = _data["jinUnitPrice"] !== undefined ? _data["jinUnitPrice"] : null as any;
            this.basicMotorInfo = _data["basicMotorInfo"] ? PageBasicMotorInfoOutputDto.fromJS(_data["basicMotorInfo"]) : null as any;
            if (Array.isArray(_data["vCs"])) {
                this.vCs = [] as any;
                for (let item of _data["vCs"])
                    this.vCs!.push(PageCheckVcRulesOutputDto.fromJS(item));
            }
            else {
                this.vCs = null as any;
            }
            if (Array.isArray(_data["basicMotorParameters"])) {
                this.basicMotorParameters = [] as any;
                for (let item of _data["basicMotorParameters"])
                    this.basicMotorParameters!.push(BasicMotorParameterOutputDto.fromJS(item));
            }
            else {
                this.basicMotorParameters = null as any;
            }
            if (Array.isArray(_data["jinBasicMotorParameters"])) {
                this.jinBasicMotorParameters = [] as any;
                for (let item of _data["jinBasicMotorParameters"])
                    this.jinBasicMotorParameters!.push(BasicMotorParameterOutputDto.fromJS(item));
            }
            else {
                this.jinBasicMotorParameters = null as any;
            }
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
        }
    }

    static fromJS(data: any): JINCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new JINCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["jinMotorCode"] = this.jinMotorCode !== undefined ? this.jinMotorCode : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["hasVCs"] = this.hasVCs !== undefined ? this.hasVCs : null as any;
        data["canCarryVCs"] = this.canCarryVCs !== undefined ? this.canCarryVCs : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["subCustomerCode"] = this.subCustomerCode !== undefined ? this.subCustomerCode : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["listPriceMultiplier"] = this.listPriceMultiplier !== undefined ? this.listPriceMultiplier : null as any;
        data["materialDescription"] = this.materialDescription !== undefined ? this.materialDescription : null as any;
        data["jinIndicator"] = this.jinIndicator !== undefined ? this.jinIndicator : null as any;
        data["jinMotorCycle"] = this.jinMotorCycle !== undefined ? this.jinMotorCycle : null as any;
        data["jinMotorExpectedDeliveryDate"] = this.jinMotorExpectedDeliveryDate !== undefined ? this.jinMotorExpectedDeliveryDate : null as any;
        data["mountingName"] = this.mountingName !== undefined ? this.mountingName : null as any;
        data["jinTypeDesignation"] = this.jinTypeDesignation !== undefined ? this.jinTypeDesignation : null as any;
        data["jinMotorModel"] = this.jinMotorModel !== undefined ? this.jinMotorModel : null as any;
        data["jinUnitPrice"] = this.jinUnitPrice !== undefined ? this.jinUnitPrice : null as any;
        data["basicMotorInfo"] = this.basicMotorInfo ? this.basicMotorInfo.toJSON() : null as any;
        if (Array.isArray(this.vCs)) {
            data["vCs"] = [];
            for (let item of this.vCs)
                data["vCs"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.basicMotorParameters)) {
            data["basicMotorParameters"] = [];
            for (let item of this.basicMotorParameters)
                data["basicMotorParameters"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.jinBasicMotorParameters)) {
            data["jinBasicMotorParameters"] = [];
            for (let item of this.jinBasicMotorParameters)
                data["jinBasicMotorParameters"].push(item ? item.toJSON() : null as any);
        }
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        return data;
    }
}

export class JINCodeForCycleDto {
    /** 境界Id */
    id!: string;
    /** 境界代码 */
    jinMotorCode!: string | null;
    /** 标准电机代码 */
    basicMotorCode!: string | null;
    hasVCs!: boolean;
    canCarryVCs!: boolean;
    version!: string;
    subCustomerCode!: string | null;
    customerCode!: string | null;
    listPriceMultiplier!: number;
    /** 物料描述 */
    materialDescription!: string | null;
    /** 境界标识符 */
    jinIndicator!: string | null;
    /** 境界电机交期 */
    jinMotorCycle!: number;
    /** 境界整机机交期 */
    jinMotorExpectedDeliveryDate!: number;
    /** 电机安装方式 */
    mountingName!: string | null;
    /** 铭牌 */
    jinTypeDesignation!: string | null;
    /** 电机型号 */
    jinMotorModel!: string | null;
    basicMotorInfo!: PageBasicMotorInfoOutputDto;
    /** VC信息 */
    vCs!: PageCheckVcRulesOutputDto[] | null;
    /** 电机参数 */
    basicMotorParameters!: BasicMotorParameterOutputDto[] | null;
    /** 境界代码电机参数 */
    jinBasicMotorParameters!: BasicMotorParameterOutputDto[] | null;
    jinMapBasicProductCycle!: BasicProductCycleOutput;
    /** 境界VC交期相关数据 */
    jinvcCycles!: BasicProductCycleVcOutput[] | null;
    /** 对应国产报价产品Id */
    technologyQuotationProductId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.jinMotorCode = _data["jinMotorCode"] !== undefined ? _data["jinMotorCode"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.hasVCs = _data["hasVCs"] !== undefined ? _data["hasVCs"] : null as any;
            this.canCarryVCs = _data["canCarryVCs"] !== undefined ? _data["canCarryVCs"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.subCustomerCode = _data["subCustomerCode"] !== undefined ? _data["subCustomerCode"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.listPriceMultiplier = _data["listPriceMultiplier"] !== undefined ? _data["listPriceMultiplier"] : null as any;
            this.materialDescription = _data["materialDescription"] !== undefined ? _data["materialDescription"] : null as any;
            this.jinIndicator = _data["jinIndicator"] !== undefined ? _data["jinIndicator"] : null as any;
            this.jinMotorCycle = _data["jinMotorCycle"] !== undefined ? _data["jinMotorCycle"] : null as any;
            this.jinMotorExpectedDeliveryDate = _data["jinMotorExpectedDeliveryDate"] !== undefined ? _data["jinMotorExpectedDeliveryDate"] : null as any;
            this.mountingName = _data["mountingName"] !== undefined ? _data["mountingName"] : null as any;
            this.jinTypeDesignation = _data["jinTypeDesignation"] !== undefined ? _data["jinTypeDesignation"] : null as any;
            this.jinMotorModel = _data["jinMotorModel"] !== undefined ? _data["jinMotorModel"] : null as any;
            this.basicMotorInfo = _data["basicMotorInfo"] ? PageBasicMotorInfoOutputDto.fromJS(_data["basicMotorInfo"]) : null as any;
            if (Array.isArray(_data["vCs"])) {
                this.vCs = [] as any;
                for (let item of _data["vCs"])
                    this.vCs!.push(PageCheckVcRulesOutputDto.fromJS(item));
            }
            else {
                this.vCs = null as any;
            }
            if (Array.isArray(_data["basicMotorParameters"])) {
                this.basicMotorParameters = [] as any;
                for (let item of _data["basicMotorParameters"])
                    this.basicMotorParameters!.push(BasicMotorParameterOutputDto.fromJS(item));
            }
            else {
                this.basicMotorParameters = null as any;
            }
            if (Array.isArray(_data["jinBasicMotorParameters"])) {
                this.jinBasicMotorParameters = [] as any;
                for (let item of _data["jinBasicMotorParameters"])
                    this.jinBasicMotorParameters!.push(BasicMotorParameterOutputDto.fromJS(item));
            }
            else {
                this.jinBasicMotorParameters = null as any;
            }
            this.jinMapBasicProductCycle = _data["jinMapBasicProductCycle"] ? BasicProductCycleOutput.fromJS(_data["jinMapBasicProductCycle"]) : null as any;
            if (Array.isArray(_data["jinvcCycles"])) {
                this.jinvcCycles = [] as any;
                for (let item of _data["jinvcCycles"])
                    this.jinvcCycles!.push(BasicProductCycleVcOutput.fromJS(item));
            }
            else {
                this.jinvcCycles = null as any;
            }
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
        }
    }

    static fromJS(data: any): JINCodeForCycleDto {
        data = typeof data === 'object' ? data : {};
        let result = new JINCodeForCycleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["jinMotorCode"] = this.jinMotorCode !== undefined ? this.jinMotorCode : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["hasVCs"] = this.hasVCs !== undefined ? this.hasVCs : null as any;
        data["canCarryVCs"] = this.canCarryVCs !== undefined ? this.canCarryVCs : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["subCustomerCode"] = this.subCustomerCode !== undefined ? this.subCustomerCode : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["listPriceMultiplier"] = this.listPriceMultiplier !== undefined ? this.listPriceMultiplier : null as any;
        data["materialDescription"] = this.materialDescription !== undefined ? this.materialDescription : null as any;
        data["jinIndicator"] = this.jinIndicator !== undefined ? this.jinIndicator : null as any;
        data["jinMotorCycle"] = this.jinMotorCycle !== undefined ? this.jinMotorCycle : null as any;
        data["jinMotorExpectedDeliveryDate"] = this.jinMotorExpectedDeliveryDate !== undefined ? this.jinMotorExpectedDeliveryDate : null as any;
        data["mountingName"] = this.mountingName !== undefined ? this.mountingName : null as any;
        data["jinTypeDesignation"] = this.jinTypeDesignation !== undefined ? this.jinTypeDesignation : null as any;
        data["jinMotorModel"] = this.jinMotorModel !== undefined ? this.jinMotorModel : null as any;
        data["basicMotorInfo"] = this.basicMotorInfo ? this.basicMotorInfo.toJSON() : null as any;
        if (Array.isArray(this.vCs)) {
            data["vCs"] = [];
            for (let item of this.vCs)
                data["vCs"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.basicMotorParameters)) {
            data["basicMotorParameters"] = [];
            for (let item of this.basicMotorParameters)
                data["basicMotorParameters"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.jinBasicMotorParameters)) {
            data["jinBasicMotorParameters"] = [];
            for (let item of this.jinBasicMotorParameters)
                data["jinBasicMotorParameters"].push(item ? item.toJSON() : null as any);
        }
        data["jinMapBasicProductCycle"] = this.jinMapBasicProductCycle ? this.jinMapBasicProductCycle.toJSON() : null as any;
        if (Array.isArray(this.jinvcCycles)) {
            data["jinvcCycles"] = [];
            for (let item of this.jinvcCycles)
                data["jinvcCycles"].push(item ? item.toJSON() : null as any);
        }
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        return data;
    }
}

export class JINCodeLectoTypePageOutPutDto {
    /** 选型名称 */
    name!: string | null;
    /** 选型Id */
    lectoTypeId!: string;
    /** 选型状态 */
    status!: string | null;
    /** 选型号 */
    userFriendlyID!: string | null;

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.userFriendlyID = _data["userFriendlyID"] !== undefined ? _data["userFriendlyID"] : null as any;
        }
    }

    static fromJS(data: any): JINCodeLectoTypePageOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new JINCodeLectoTypePageOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["userFriendlyID"] = this.userFriendlyID !== undefined ? this.userFriendlyID : null as any;
        return data;
    }
}

export class JINCodeLectoTypeProcessingCodesOutputDto {
    /** 主键Id */
    listPriceBasicMotorPriceId!: string | null;
    /** 选型Id */
    lectoTypeId!: string;
    /** B代码 */
    basicMotorCode!: string | null;
    /** 序号 */
    serialNo!: number;

    init(_data?: any) {
        if (_data) {
            this.listPriceBasicMotorPriceId = _data["listPriceBasicMotorPriceId"] !== undefined ? _data["listPriceBasicMotorPriceId"] : null as any;
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : null as any;
        }
    }

    static fromJS(data: any): JINCodeLectoTypeProcessingCodesOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new JINCodeLectoTypeProcessingCodesOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceBasicMotorPriceId"] = this.listPriceBasicMotorPriceId !== undefined ? this.listPriceBasicMotorPriceId : null as any;
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : null as any;
        return data;
    }
}

export class JINLectoType {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    lectoTypeId!: string;
    listPriceSeriesId!: string | null;
    listPriceJINSeriesId!: string | null;
    seriesName!: string | null;
    attachmentFiles!: string | null;
    status!: number | null;
    jinCategoryCode!: string | null;
    seriesVersion!: string | null;
    helpType!: JINLectoTypeHelpType;
    lectoType!: LectoType;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.listPriceJINSeriesId = _data["listPriceJINSeriesId"] !== undefined ? _data["listPriceJINSeriesId"] : null as any;
            this.seriesName = _data["seriesName"] !== undefined ? _data["seriesName"] : null as any;
            this.attachmentFiles = _data["attachmentFiles"] !== undefined ? _data["attachmentFiles"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.seriesVersion = _data["seriesVersion"] !== undefined ? _data["seriesVersion"] : null as any;
            this.helpType = _data["helpType"] !== undefined ? _data["helpType"] : null as any;
            this.lectoType = _data["lectoType"] ? LectoType.fromJS(_data["lectoType"]) : null as any;
        }
    }

    static fromJS(data: any): JINLectoType {
        data = typeof data === 'object' ? data : {};
        let result = new JINLectoType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["listPriceJINSeriesId"] = this.listPriceJINSeriesId !== undefined ? this.listPriceJINSeriesId : null as any;
        data["seriesName"] = this.seriesName !== undefined ? this.seriesName : null as any;
        data["attachmentFiles"] = this.attachmentFiles !== undefined ? this.attachmentFiles : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["seriesVersion"] = this.seriesVersion !== undefined ? this.seriesVersion : null as any;
        data["helpType"] = this.helpType !== undefined ? this.helpType : null as any;
        data["lectoType"] = this.lectoType ? this.lectoType.toJSON() : null as any;
        return data;
    }
}

export class JINLectoTypeCompletedDto {
    /** 选型Id */
    lectoTypeId!: string;
    /** 备注 */
    remark!: string | null;
    /** 附件名称 */
    fileInfos!: AttachmentFileInfo[] | null;

    init(_data?: any) {
        if (_data) {
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            if (Array.isArray(_data["fileInfos"])) {
                this.fileInfos = [] as any;
                for (let item of _data["fileInfos"])
                    this.fileInfos!.push(AttachmentFileInfo.fromJS(item));
            }
            else {
                this.fileInfos = null as any;
            }
        }
    }

    static fromJS(data: any): JINLectoTypeCompletedDto {
        data = typeof data === 'object' ? data : {};
        let result = new JINLectoTypeCompletedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        if (Array.isArray(this.fileInfos)) {
            data["fileInfos"] = [];
            for (let item of this.fileInfos)
                data["fileInfos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 0 = ExcludeVC (外含VC) 1 = IncludeVC (面价选型内含VC) 2 = ProjectExcludeVC (项目外挂VC) 3 = ProjectIncludeVC (项目内含VC) */
export enum JINLectoTypeHelpType {
    ExcludeVC = 0,
    IncludeVC = 1,
    ProjectExcludeVC = 2,
    ProjectIncludeVC = 3,
}

/** 境界选型参数 */
export class JINLectoTypeInputDto {
    /** 客户编码 */
    clienter!: string | null;
    /** 客户名称 */
    clientName!: string | null;
    /** 二级客户编码 */
    finalCustomerCode!: string | null;
    /** 二级客户名称 */
    finalCustomerName!: string | null;
    /** 境界面价系列ID */
    listPriceJINSeriesId!: string;
    /** 境界面价系列名称 */
    listPriceJINSeriesName!: string | null;
    /** 境界标识符 */
    jinCategoryCode!: string | null;
    /** 面价系列Id */
    listPriceSeriesId!: string;
    /** 境界版本号 */
    seriesVersion!: string | null;
    /** 境界选型产品 */
    products!: JINLectoTypeProductInput[] | null;

    init(_data?: any) {
        if (_data) {
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.listPriceJINSeriesId = _data["listPriceJINSeriesId"] !== undefined ? _data["listPriceJINSeriesId"] : null as any;
            this.listPriceJINSeriesName = _data["listPriceJINSeriesName"] !== undefined ? _data["listPriceJINSeriesName"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            this.seriesVersion = _data["seriesVersion"] !== undefined ? _data["seriesVersion"] : null as any;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(JINLectoTypeProductInput.fromJS(item));
            }
            else {
                this.products = null as any;
            }
        }
    }

    static fromJS(data: any): JINLectoTypeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new JINLectoTypeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["listPriceJINSeriesId"] = this.listPriceJINSeriesId !== undefined ? this.listPriceJINSeriesId : null as any;
        data["listPriceJINSeriesName"] = this.listPriceJINSeriesName !== undefined ? this.listPriceJINSeriesName : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        data["seriesVersion"] = this.seriesVersion !== undefined ? this.seriesVersion : null as any;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 境界选型输出 */
export class JINLectoTypeOutDto {
    /** 选型Id */
    lectoTypeId!: string;
    /** 境界选型Id */
    jinLectoTypeId!: string;
    /** 选型号 */
    userFriendlyID!: string | null;
    /** 选型名 */
    name!: string | null;

    init(_data?: any) {
        if (_data) {
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.jinLectoTypeId = _data["jinLectoTypeId"] !== undefined ? _data["jinLectoTypeId"] : null as any;
            this.userFriendlyID = _data["userFriendlyID"] !== undefined ? _data["userFriendlyID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): JINLectoTypeOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new JINLectoTypeOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["jinLectoTypeId"] = this.jinLectoTypeId !== undefined ? this.jinLectoTypeId : null as any;
        data["userFriendlyID"] = this.userFriendlyID !== undefined ? this.userFriendlyID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export class JINLectoTypeProductInput {
    /** 标准代码 */
    basicMotorCode!: string | null;
    /** 系列 */
    basicMotorSries!: string | null;
    /** 主机类型 */
    basicMotorModel!: string | null;
    /** 安装方式 */
    basicMotorMounting!: string | null;
    /** 极数 */
    poleNo!: string | null;
    /** 电压 */
    voltage!: string | null;
    /** 机座号 */
    frameNo!: number;
    /** 功率 */
    power!: string | null;
    /** 编码器 */
    encoder!: string | null;
    /** 频率 */
    frequency!: string | null;
    /** 境界标识符 */
    jinCategoryCode!: string | null;
    /** 境界代码 */
    jinMotorCode!: string | null;
    /** 版本号 */
    jinVersion!: string | null;
    /** 境界面价价格Id */
    listPriceBasicMotorPriceId!: string;
    vcs!: JINLectoTypeProductVCInput[] | null;
    /** 国产报价产品行Id */
    technologyQuotationProductId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.encoder = _data["encoder"] !== undefined ? _data["encoder"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinMotorCode = _data["jinMotorCode"] !== undefined ? _data["jinMotorCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.listPriceBasicMotorPriceId = _data["listPriceBasicMotorPriceId"] !== undefined ? _data["listPriceBasicMotorPriceId"] : null as any;
            if (Array.isArray(_data["vcs"])) {
                this.vcs = [] as any;
                for (let item of _data["vcs"])
                    this.vcs!.push(JINLectoTypeProductVCInput.fromJS(item));
            }
            else {
                this.vcs = null as any;
            }
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
        }
    }

    static fromJS(data: any): JINLectoTypeProductInput {
        data = typeof data === 'object' ? data : {};
        let result = new JINLectoTypeProductInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["encoder"] = this.encoder !== undefined ? this.encoder : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinMotorCode"] = this.jinMotorCode !== undefined ? this.jinMotorCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["listPriceBasicMotorPriceId"] = this.listPriceBasicMotorPriceId !== undefined ? this.listPriceBasicMotorPriceId : null as any;
        if (Array.isArray(this.vcs)) {
            data["vcs"] = [];
            for (let item of this.vcs)
                data["vcs"].push(item ? item.toJSON() : null as any);
        }
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        return data;
    }
}

export class JINLectoTypeProductVCInput {
    vcID!: string | null;
    vcType!: VcType;
    /** 品类 */
    category!: string | null;
    /** VC含义 */
    meaning!: string | null;
    /** VC头数 */
    numberWires!: number;
    /** VC开放式内容 */
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): JINLectoTypeProductVCInput {
        data = typeof data === 'object' ? data : {};
        let result = new JINLectoTypeProductVCInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

export class JINMapBasicMotorCodeDto {
    /** 境界代码 */
    jinMotorCode!: string | null;
    /** 标准电机代码 */
    basicMotorCode!: string | null;
    hasVCs!: boolean;
    canCarryVCs!: boolean;
    version!: string | null;
    /** 境界标识符 */
    jinIndicator!: string | null;
    basicMotorInfo!: PageBasicMotorInfoOutputDto;

    init(_data?: any) {
        if (_data) {
            this.jinMotorCode = _data["jinMotorCode"] !== undefined ? _data["jinMotorCode"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.hasVCs = _data["hasVCs"] !== undefined ? _data["hasVCs"] : null as any;
            this.canCarryVCs = _data["canCarryVCs"] !== undefined ? _data["canCarryVCs"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.jinIndicator = _data["jinIndicator"] !== undefined ? _data["jinIndicator"] : null as any;
            this.basicMotorInfo = _data["basicMotorInfo"] ? PageBasicMotorInfoOutputDto.fromJS(_data["basicMotorInfo"]) : null as any;
        }
    }

    static fromJS(data: any): JINMapBasicMotorCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new JINMapBasicMotorCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jinMotorCode"] = this.jinMotorCode !== undefined ? this.jinMotorCode : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["hasVCs"] = this.hasVCs !== undefined ? this.hasVCs : null as any;
        data["canCarryVCs"] = this.canCarryVCs !== undefined ? this.canCarryVCs : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["jinIndicator"] = this.jinIndicator !== undefined ? this.jinIndicator : null as any;
        data["basicMotorInfo"] = this.basicMotorInfo ? this.basicMotorInfo.toJSON() : null as any;
        return data;
    }
}

export class JINSenarioShowDto {
    /** 境界名称 */
    senarioName!: string | null;
    /** 境界类型 */
    senarioType!: number;
    /** 维护人列表 */
    userJINSenarioList!: AuthorizedUserJINSenarioDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.senarioName = _data["senarioName"] !== undefined ? _data["senarioName"] : null as any;
            this.senarioType = _data["senarioType"] !== undefined ? _data["senarioType"] : null as any;
            if (Array.isArray(_data["userJINSenarioList"])) {
                this.userJINSenarioList = [] as any;
                for (let item of _data["userJINSenarioList"])
                    this.userJINSenarioList!.push(AuthorizedUserJINSenarioDto.fromJS(item));
            }
            else {
                this.userJINSenarioList = null as any;
            }
        }
    }

    static fromJS(data: any): JINSenarioShowDto {
        data = typeof data === 'object' ? data : {};
        let result = new JINSenarioShowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["senarioName"] = this.senarioName !== undefined ? this.senarioName : null as any;
        data["senarioType"] = this.senarioType !== undefined ? this.senarioType : null as any;
        if (Array.isArray(this.userJINSenarioList)) {
            data["userJINSenarioList"] = [];
            for (let item of this.userJINSenarioList)
                data["userJINSenarioList"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class Job {
    id!: number;
    stateId!: number;
    stateName!: string | null;
    invocationData!: string | null;
    arguments!: string | null;
    createdAt!: moment.Moment;
    expireAt!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.stateId = _data["stateId"] !== undefined ? _data["stateId"] : null as any;
            this.stateName = _data["stateName"] !== undefined ? _data["stateName"] : null as any;
            this.invocationData = _data["invocationData"] !== undefined ? _data["invocationData"] : null as any;
            this.arguments = _data["arguments"] !== undefined ? _data["arguments"] : null as any;
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : null as any;
            this.expireAt = _data["expireAt"] ? moment(_data["expireAt"].toString()) : null as any;
        }
    }

    static fromJS(data: any): Job {
        data = typeof data === 'object' ? data : {};
        let result = new Job();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["stateId"] = this.stateId !== undefined ? this.stateId : null as any;
        data["stateName"] = this.stateName !== undefined ? this.stateName : null as any;
        data["invocationData"] = this.invocationData !== undefined ? this.invocationData : null as any;
        data["arguments"] = this.arguments !== undefined ? this.arguments : null as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : null as any;
        data["expireAt"] = this.expireAt ? this.expireAt.toISOString() : null as any;
        return data;
    }
}

export class JobPagedResultDto {
    items!: Job[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Job.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): JobPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 0 = Sequential 2 = Explicit 3 = Auto */
export enum LayoutKind {
    Sequential = 0,
    Explicit = 2,
    Auto = 3,
}

export class LectoType {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    name!: string | null;
    userFriendlyID!: string | null;
    clienter!: string | null;
    clientName!: string | null;
    finalCustomerCode!: string | null;
    finalCustomerName!: string | null;
    shippingAddressCode!: string | null;
    shippingAddress!: string | null;
    saleId!: number | null;
    gcsHandleId!: number | null;
    saleName!: string | null;
    onComplateHook!: string | null;
    accessKey!: string | null;
    sourceType!: SourceType;
    status!: LectoTypeStatus;
    precalID!: string | null;
    precalIDSoucre!: string | null;
    redirectPreCalUrl!: string | null;
    gcsCreateId!: number | null;
    isBeLongGCS!: boolean;
    pmsProjectCode!: string | null;
    pmsProjectType!: number | null;
    version!: number | null;
    sourceLectoTypeID!: string | null;
    pmSourceLectoTypeID!: string | null;
    lectoTypeHelpInfoId!: string | null;
    technologyQuotationId!: string | null;
    technicalSpecificationId!: string | null;
    products!: LectoTypeProduct[] | null;
    technologyQuotation!: TechnologyQuotation;
    technicalSpecification!: TechnologyQuotation;
    records!: LectoTypeRecord[] | null;
    helpInfos!: LectoTypeHelpInfo[] | null;
    jinLectoType!: JINLectoType;
    completeHelpRecords!: LectoTypeCompleteHelpRecord[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.userFriendlyID = _data["userFriendlyID"] !== undefined ? _data["userFriendlyID"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.shippingAddressCode = _data["shippingAddressCode"] !== undefined ? _data["shippingAddressCode"] : null as any;
            this.shippingAddress = _data["shippingAddress"] !== undefined ? _data["shippingAddress"] : null as any;
            this.saleId = _data["saleId"] !== undefined ? _data["saleId"] : null as any;
            this.gcsHandleId = _data["gcsHandleId"] !== undefined ? _data["gcsHandleId"] : null as any;
            this.saleName = _data["saleName"] !== undefined ? _data["saleName"] : null as any;
            this.onComplateHook = _data["onComplateHook"] !== undefined ? _data["onComplateHook"] : null as any;
            this.accessKey = _data["accessKey"] !== undefined ? _data["accessKey"] : null as any;
            this.sourceType = _data["sourceType"] !== undefined ? _data["sourceType"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.precalID = _data["precalID"] !== undefined ? _data["precalID"] : null as any;
            this.precalIDSoucre = _data["precalIDSoucre"] !== undefined ? _data["precalIDSoucre"] : null as any;
            this.redirectPreCalUrl = _data["redirectPreCalUrl"] !== undefined ? _data["redirectPreCalUrl"] : null as any;
            this.gcsCreateId = _data["gcsCreateId"] !== undefined ? _data["gcsCreateId"] : null as any;
            this.isBeLongGCS = _data["isBeLongGCS"] !== undefined ? _data["isBeLongGCS"] : null as any;
            this.pmsProjectCode = _data["pmsProjectCode"] !== undefined ? _data["pmsProjectCode"] : null as any;
            this.pmsProjectType = _data["pmsProjectType"] !== undefined ? _data["pmsProjectType"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.sourceLectoTypeID = _data["sourceLectoTypeID"] !== undefined ? _data["sourceLectoTypeID"] : null as any;
            this.pmSourceLectoTypeID = _data["pmSourceLectoTypeID"] !== undefined ? _data["pmSourceLectoTypeID"] : null as any;
            this.lectoTypeHelpInfoId = _data["lectoTypeHelpInfoId"] !== undefined ? _data["lectoTypeHelpInfoId"] : null as any;
            this.technologyQuotationId = _data["technologyQuotationId"] !== undefined ? _data["technologyQuotationId"] : null as any;
            this.technicalSpecificationId = _data["technicalSpecificationId"] !== undefined ? _data["technicalSpecificationId"] : null as any;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(LectoTypeProduct.fromJS(item));
            }
            else {
                this.products = null as any;
            }
            this.technologyQuotation = _data["technologyQuotation"] ? TechnologyQuotation.fromJS(_data["technologyQuotation"]) : null as any;
            this.technicalSpecification = _data["technicalSpecification"] ? TechnologyQuotation.fromJS(_data["technicalSpecification"]) : null as any;
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(LectoTypeRecord.fromJS(item));
            }
            else {
                this.records = null as any;
            }
            if (Array.isArray(_data["helpInfos"])) {
                this.helpInfos = [] as any;
                for (let item of _data["helpInfos"])
                    this.helpInfos!.push(LectoTypeHelpInfo.fromJS(item));
            }
            else {
                this.helpInfos = null as any;
            }
            this.jinLectoType = _data["jinLectoType"] ? JINLectoType.fromJS(_data["jinLectoType"]) : null as any;
            if (Array.isArray(_data["completeHelpRecords"])) {
                this.completeHelpRecords = [] as any;
                for (let item of _data["completeHelpRecords"])
                    this.completeHelpRecords!.push(LectoTypeCompleteHelpRecord.fromJS(item));
            }
            else {
                this.completeHelpRecords = null as any;
            }
        }
    }

    static fromJS(data: any): LectoType {
        data = typeof data === 'object' ? data : {};
        let result = new LectoType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["userFriendlyID"] = this.userFriendlyID !== undefined ? this.userFriendlyID : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["shippingAddressCode"] = this.shippingAddressCode !== undefined ? this.shippingAddressCode : null as any;
        data["shippingAddress"] = this.shippingAddress !== undefined ? this.shippingAddress : null as any;
        data["saleId"] = this.saleId !== undefined ? this.saleId : null as any;
        data["gcsHandleId"] = this.gcsHandleId !== undefined ? this.gcsHandleId : null as any;
        data["saleName"] = this.saleName !== undefined ? this.saleName : null as any;
        data["onComplateHook"] = this.onComplateHook !== undefined ? this.onComplateHook : null as any;
        data["accessKey"] = this.accessKey !== undefined ? this.accessKey : null as any;
        data["sourceType"] = this.sourceType !== undefined ? this.sourceType : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["precalID"] = this.precalID !== undefined ? this.precalID : null as any;
        data["precalIDSoucre"] = this.precalIDSoucre !== undefined ? this.precalIDSoucre : null as any;
        data["redirectPreCalUrl"] = this.redirectPreCalUrl !== undefined ? this.redirectPreCalUrl : null as any;
        data["gcsCreateId"] = this.gcsCreateId !== undefined ? this.gcsCreateId : null as any;
        data["isBeLongGCS"] = this.isBeLongGCS !== undefined ? this.isBeLongGCS : null as any;
        data["pmsProjectCode"] = this.pmsProjectCode !== undefined ? this.pmsProjectCode : null as any;
        data["pmsProjectType"] = this.pmsProjectType !== undefined ? this.pmsProjectType : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["sourceLectoTypeID"] = this.sourceLectoTypeID !== undefined ? this.sourceLectoTypeID : null as any;
        data["pmSourceLectoTypeID"] = this.pmSourceLectoTypeID !== undefined ? this.pmSourceLectoTypeID : null as any;
        data["lectoTypeHelpInfoId"] = this.lectoTypeHelpInfoId !== undefined ? this.lectoTypeHelpInfoId : null as any;
        data["technologyQuotationId"] = this.technologyQuotationId !== undefined ? this.technologyQuotationId : null as any;
        data["technicalSpecificationId"] = this.technicalSpecificationId !== undefined ? this.technicalSpecificationId : null as any;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : null as any);
        }
        data["technologyQuotation"] = this.technologyQuotation ? this.technologyQuotation.toJSON() : null as any;
        data["technicalSpecification"] = this.technicalSpecification ? this.technicalSpecification.toJSON() : null as any;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.helpInfos)) {
            data["helpInfos"] = [];
            for (let item of this.helpInfos)
                data["helpInfos"].push(item ? item.toJSON() : null as any);
        }
        data["jinLectoType"] = this.jinLectoType ? this.jinLectoType.toJSON() : null as any;
        if (Array.isArray(this.completeHelpRecords)) {
            data["completeHelpRecords"] = [];
            for (let item of this.completeHelpRecords)
                data["completeHelpRecords"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class LectoTypeCompleteHelpRecord {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    completeRemark!: string | null;
    completeAttachmentFiles!: string | null;
    gcsUserId!: number;
    lectoTypeInfoFileName!: string | null;
    lectoTypeCompleteInfoFileName!: string | null;
    technologyQuotationId!: string | null;
    technicalSpecificationId!: string | null;
    lectoTypeHelpInfoId!: string | null;
    lectoTypeId!: string;
    lectoType!: LectoType;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.completeRemark = _data["completeRemark"] !== undefined ? _data["completeRemark"] : null as any;
            this.completeAttachmentFiles = _data["completeAttachmentFiles"] !== undefined ? _data["completeAttachmentFiles"] : null as any;
            this.gcsUserId = _data["gcsUserId"] !== undefined ? _data["gcsUserId"] : null as any;
            this.lectoTypeInfoFileName = _data["lectoTypeInfoFileName"] !== undefined ? _data["lectoTypeInfoFileName"] : null as any;
            this.lectoTypeCompleteInfoFileName = _data["lectoTypeCompleteInfoFileName"] !== undefined ? _data["lectoTypeCompleteInfoFileName"] : null as any;
            this.technologyQuotationId = _data["technologyQuotationId"] !== undefined ? _data["technologyQuotationId"] : null as any;
            this.technicalSpecificationId = _data["technicalSpecificationId"] !== undefined ? _data["technicalSpecificationId"] : null as any;
            this.lectoTypeHelpInfoId = _data["lectoTypeHelpInfoId"] !== undefined ? _data["lectoTypeHelpInfoId"] : null as any;
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.lectoType = _data["lectoType"] ? LectoType.fromJS(_data["lectoType"]) : null as any;
        }
    }

    static fromJS(data: any): LectoTypeCompleteHelpRecord {
        data = typeof data === 'object' ? data : {};
        let result = new LectoTypeCompleteHelpRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["completeRemark"] = this.completeRemark !== undefined ? this.completeRemark : null as any;
        data["completeAttachmentFiles"] = this.completeAttachmentFiles !== undefined ? this.completeAttachmentFiles : null as any;
        data["gcsUserId"] = this.gcsUserId !== undefined ? this.gcsUserId : null as any;
        data["lectoTypeInfoFileName"] = this.lectoTypeInfoFileName !== undefined ? this.lectoTypeInfoFileName : null as any;
        data["lectoTypeCompleteInfoFileName"] = this.lectoTypeCompleteInfoFileName !== undefined ? this.lectoTypeCompleteInfoFileName : null as any;
        data["technologyQuotationId"] = this.technologyQuotationId !== undefined ? this.technologyQuotationId : null as any;
        data["technicalSpecificationId"] = this.technicalSpecificationId !== undefined ? this.technicalSpecificationId : null as any;
        data["lectoTypeHelpInfoId"] = this.lectoTypeHelpInfoId !== undefined ? this.lectoTypeHelpInfoId : null as any;
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["lectoType"] = this.lectoType ? this.lectoType.toJSON() : null as any;
        return data;
    }
}

export class LectoTypeCustomProductPriceDto {
    id!: string;
    unitPrice!: number | null;
    unitPriceFormula!: string | null;
    unitPriceType!: number | null;
    cost!: number | null;
    costFormula!: string | null;
    costType!: CostType;
    costTypeDetail!: string | null;
    quotationPrinciple!: string | null;
    quotationPrincipleDetails!: string | null;
    dqRemark!: string | null;
    lectoTypeProductId!: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.dqRemark = _data["dqRemark"] !== undefined ? _data["dqRemark"] : null as any;
            this.lectoTypeProductId = _data["lectoTypeProductId"] !== undefined ? _data["lectoTypeProductId"] : null as any;
        }
    }

    static fromJS(data: any): LectoTypeCustomProductPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LectoTypeCustomProductPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["dqRemark"] = this.dqRemark !== undefined ? this.dqRemark : null as any;
        data["lectoTypeProductId"] = this.lectoTypeProductId !== undefined ? this.lectoTypeProductId : null as any;
        return data;
    }
}

/** 选型预计交货天数出对象 */
export class LectoTypeDateOutput {
    /** 预计交货最大天数 */
    expectedDeliveryDate!: number;
    /** 主机预计交货天数 */
    products!: LectoTypeProductDateOutput[] | null;

    init(_data?: any) {
        if (_data) {
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(LectoTypeProductDateOutput.fromJS(item));
            }
            else {
                this.products = null as any;
            }
        }
    }

    static fromJS(data: any): LectoTypeDateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LectoTypeDateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class LectoTypeDetailsProductDto {
    id!: string;
    basicMotorModel!: string | null;
    basicMotorCode!: string | null;
    basicMotorMounting!: string | null;
    frameNo!: number;
    basicMotorType!: BasicMotorType;
    basicMotorSries!: string | null;
    power!: string | null;
    poleNo!: string | null;
    unitPrice!: string | null;
    numberOfProduct!: string | null;
    expectedDeliveryDate!: string | null;
    cycle!: number;
    defaultMultiplier!: string | null;
    expectMultiplier!: string | null;
    technicalSpecifications!: string | null;
    domesticQuotationNumber!: string | null;
    technicalConfirmation!: string | null;
    appraisalNumber!: string | null;
    serialNo!: number;
    salesPrice!: number | null;
    technologyQuotationProductId!: string | null;
    technicalSpecificationProductId!: string | null;
    jinCategoryCode!: string | null;
    jinVersion!: string | null;
    jinBasicMotorCode!: string | null;
    jinBasicMotorModel!: string | null;
    jinBasicMotorMounting!: string | null;
    jinBasicMotorSries!: string | null;
    jinFrameSize!: number;
    jinPower!: string | null;
    jinUnitPrice!: number;
    listPriceMultiplier!: number;
    vcs!: LectoTypeDetailsProductVcDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.basicMotorType = _data["basicMotorType"] !== undefined ? _data["basicMotorType"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.numberOfProduct = _data["numberOfProduct"] !== undefined ? _data["numberOfProduct"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.cycle = _data["cycle"] !== undefined ? _data["cycle"] : null as any;
            this.defaultMultiplier = _data["defaultMultiplier"] !== undefined ? _data["defaultMultiplier"] : null as any;
            this.expectMultiplier = _data["expectMultiplier"] !== undefined ? _data["expectMultiplier"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.domesticQuotationNumber = _data["domesticQuotationNumber"] !== undefined ? _data["domesticQuotationNumber"] : null as any;
            this.technicalConfirmation = _data["technicalConfirmation"] !== undefined ? _data["technicalConfirmation"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
            this.technicalSpecificationProductId = _data["technicalSpecificationProductId"] !== undefined ? _data["technicalSpecificationProductId"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.jinBasicMotorCode = _data["jinBasicMotorCode"] !== undefined ? _data["jinBasicMotorCode"] : null as any;
            this.jinBasicMotorModel = _data["jinBasicMotorModel"] !== undefined ? _data["jinBasicMotorModel"] : null as any;
            this.jinBasicMotorMounting = _data["jinBasicMotorMounting"] !== undefined ? _data["jinBasicMotorMounting"] : null as any;
            this.jinBasicMotorSries = _data["jinBasicMotorSries"] !== undefined ? _data["jinBasicMotorSries"] : null as any;
            this.jinFrameSize = _data["jinFrameSize"] !== undefined ? _data["jinFrameSize"] : null as any;
            this.jinPower = _data["jinPower"] !== undefined ? _data["jinPower"] : null as any;
            this.jinUnitPrice = _data["jinUnitPrice"] !== undefined ? _data["jinUnitPrice"] : null as any;
            this.listPriceMultiplier = _data["listPriceMultiplier"] !== undefined ? _data["listPriceMultiplier"] : null as any;
            if (Array.isArray(_data["vcs"])) {
                this.vcs = [] as any;
                for (let item of _data["vcs"])
                    this.vcs!.push(LectoTypeDetailsProductVcDto.fromJS(item));
            }
            else {
                this.vcs = null as any;
            }
        }
    }

    static fromJS(data: any): LectoTypeDetailsProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new LectoTypeDetailsProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["basicMotorType"] = this.basicMotorType !== undefined ? this.basicMotorType : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["numberOfProduct"] = this.numberOfProduct !== undefined ? this.numberOfProduct : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["cycle"] = this.cycle !== undefined ? this.cycle : null as any;
        data["defaultMultiplier"] = this.defaultMultiplier !== undefined ? this.defaultMultiplier : null as any;
        data["expectMultiplier"] = this.expectMultiplier !== undefined ? this.expectMultiplier : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["domesticQuotationNumber"] = this.domesticQuotationNumber !== undefined ? this.domesticQuotationNumber : null as any;
        data["technicalConfirmation"] = this.technicalConfirmation !== undefined ? this.technicalConfirmation : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        data["technicalSpecificationProductId"] = this.technicalSpecificationProductId !== undefined ? this.technicalSpecificationProductId : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["jinBasicMotorCode"] = this.jinBasicMotorCode !== undefined ? this.jinBasicMotorCode : null as any;
        data["jinBasicMotorModel"] = this.jinBasicMotorModel !== undefined ? this.jinBasicMotorModel : null as any;
        data["jinBasicMotorMounting"] = this.jinBasicMotorMounting !== undefined ? this.jinBasicMotorMounting : null as any;
        data["jinBasicMotorSries"] = this.jinBasicMotorSries !== undefined ? this.jinBasicMotorSries : null as any;
        data["jinFrameSize"] = this.jinFrameSize !== undefined ? this.jinFrameSize : null as any;
        data["jinPower"] = this.jinPower !== undefined ? this.jinPower : null as any;
        data["jinUnitPrice"] = this.jinUnitPrice !== undefined ? this.jinUnitPrice : null as any;
        data["listPriceMultiplier"] = this.listPriceMultiplier !== undefined ? this.listPriceMultiplier : null as any;
        if (Array.isArray(this.vcs)) {
            data["vcs"] = [];
            for (let item of this.vcs)
                data["vcs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class LectoTypeDetailsProductVcDto {
    id!: string;
    vcCode!: string | null;
    category!: string | null;
    meaning!: string | null;
    remark!: string | null;
    unitPrice!: string | null;
    standardUnitPrice!: string | null;
    vcType!: VcType;
    isInside!: boolean;
    technologyQuotationProductVCId!: string | null;
    technicalSpecificationProductVCId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.standardUnitPrice = _data["standardUnitPrice"] !== undefined ? _data["standardUnitPrice"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.isInside = _data["isInside"] !== undefined ? _data["isInside"] : null as any;
            this.technologyQuotationProductVCId = _data["technologyQuotationProductVCId"] !== undefined ? _data["technologyQuotationProductVCId"] : null as any;
            this.technicalSpecificationProductVCId = _data["technicalSpecificationProductVCId"] !== undefined ? _data["technicalSpecificationProductVCId"] : null as any;
        }
    }

    static fromJS(data: any): LectoTypeDetailsProductVcDto {
        data = typeof data === 'object' ? data : {};
        let result = new LectoTypeDetailsProductVcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["standardUnitPrice"] = this.standardUnitPrice !== undefined ? this.standardUnitPrice : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["isInside"] = this.isInside !== undefined ? this.isInside : null as any;
        data["technologyQuotationProductVCId"] = this.technologyQuotationProductVCId !== undefined ? this.technologyQuotationProductVCId : null as any;
        data["technicalSpecificationProductVCId"] = this.technicalSpecificationProductVCId !== undefined ? this.technicalSpecificationProductVCId : null as any;
        return data;
    }
}

export class LectoTypeGetInventoryOutPutDtoValueTuple {

    init(_data?: any) {
    }

    static fromJS(data: any): LectoTypeGetInventoryOutPutDtoValueTuple {
        data = typeof data === 'object' ? data : {};
        let result = new LectoTypeGetInventoryOutPutDtoValueTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export class LectoTypeHelpInfo {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    attachmentFiles!: string | null;
    gcsUserId!: number;
    remark!: string | null;
    completeRemark!: string | null;
    completeAttachmentFiles!: string | null;
    helpType!: JINLectoTypeHelpType;
    backWriteStatus!: boolean;
    lectoTypeId!: string;
    lectoType!: LectoType;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.attachmentFiles = _data["attachmentFiles"] !== undefined ? _data["attachmentFiles"] : null as any;
            this.gcsUserId = _data["gcsUserId"] !== undefined ? _data["gcsUserId"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.completeRemark = _data["completeRemark"] !== undefined ? _data["completeRemark"] : null as any;
            this.completeAttachmentFiles = _data["completeAttachmentFiles"] !== undefined ? _data["completeAttachmentFiles"] : null as any;
            this.helpType = _data["helpType"] !== undefined ? _data["helpType"] : null as any;
            this.backWriteStatus = _data["backWriteStatus"] !== undefined ? _data["backWriteStatus"] : null as any;
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.lectoType = _data["lectoType"] ? LectoType.fromJS(_data["lectoType"]) : null as any;
        }
    }

    static fromJS(data: any): LectoTypeHelpInfo {
        data = typeof data === 'object' ? data : {};
        let result = new LectoTypeHelpInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["attachmentFiles"] = this.attachmentFiles !== undefined ? this.attachmentFiles : null as any;
        data["gcsUserId"] = this.gcsUserId !== undefined ? this.gcsUserId : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["completeRemark"] = this.completeRemark !== undefined ? this.completeRemark : null as any;
        data["completeAttachmentFiles"] = this.completeAttachmentFiles !== undefined ? this.completeAttachmentFiles : null as any;
        data["helpType"] = this.helpType !== undefined ? this.helpType : null as any;
        data["backWriteStatus"] = this.backWriteStatus !== undefined ? this.backWriteStatus : null as any;
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["lectoType"] = this.lectoType ? this.lectoType.toJSON() : null as any;
        return data;
    }
}

export class LectoTypeProduct {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    productNumber!: number;
    basicMotorCode!: string | null;
    basicMotorModel!: string | null;
    basicMotorMounting!: string | null;
    frameNo!: number;
    isHaveVc!: IsHaveVc;
    power!: string | null;
    basicMotorType!: BasicMotorType;
    basicMotorSries!: string | null;
    unitPrice!: number | null;
    unitPriceResult!: string | null;
    cycle!: number;
    technicalConfirmation!: string | null;
    appraisalNumber!: string | null;
    source!: ProdcutAndVcSource;
    remark!: string | null;
    remarkTwo!: string | null;
    frequency!: string | null;
    poleNo!: string | null;
    voltage!: string | null;
    voltageCode!: string | null;
    eneEff!: string | null;
    encoder!: string | null;
    defaultMultiplier!: number;
    multipilerType!: MultipilerType;
    expectMultiplier!: number | null;
    precalID!: string | null;
    precalMultiplierExpiredDateTime!: moment.Moment | null;
    internalText!: string | null;
    discountUnitPrice!: number | null;
    noDiscountByPlatformUnitPrice!: number | null;
    noDiscountByListUnitPrice!: number | null;
    gssQuotationNo!: string | null;
    gssTechnicalConfirmationNumber!: string | null;
    salesPrice!: number | null;
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    productionCycle!: number;
    testCycle!: number;
    capacityCycle!: number;
    grCycle!: number;
    inToOutCycle!: number;
    makeOrBuy!: string | null;
    serialNo!: number;
    submit!: boolean;
    precalItemNo!: number | null;
    isNewPMSProduct!: boolean | null;
    pmsMultiplier!: number | null;
    technicalSpecification!: string | null;
    changeSelected!: boolean;
    mspSourceType!: MSPSourceTypeEnum;
    mspSourceID!: string | null;
    listPriceBasicMotorPriceId!: string | null;
    listPriceJINCode!: string | null;
    insideVCOpenRemarks!: string | null;
    lectoTypeId!: string;
    technologyQuotationProductId!: string | null;
    technicalSpecificationProductId!: string | null;
    isNeedHeightOutput!: IsYes;
    lectoType!: LectoType;
    vcs!: LectoTypeProductVC[] | null;
    technologyQuotationProduct!: TechnologyQuotationProduct;
    technicalSpecificationProduct!: TechnologyQuotationProduct;
    gcsHelpProductId!: string | null;
    jinCategoryCode!: string | null;
    jinVersion!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.productNumber = _data["productNumber"] !== undefined ? _data["productNumber"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.isHaveVc = _data["isHaveVc"] !== undefined ? _data["isHaveVc"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.basicMotorType = _data["basicMotorType"] !== undefined ? _data["basicMotorType"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.cycle = _data["cycle"] !== undefined ? _data["cycle"] : null as any;
            this.technicalConfirmation = _data["technicalConfirmation"] !== undefined ? _data["technicalConfirmation"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.remarkTwo = _data["remarkTwo"] !== undefined ? _data["remarkTwo"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.voltageCode = _data["voltageCode"] !== undefined ? _data["voltageCode"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.encoder = _data["encoder"] !== undefined ? _data["encoder"] : null as any;
            this.defaultMultiplier = _data["defaultMultiplier"] !== undefined ? _data["defaultMultiplier"] : null as any;
            this.multipilerType = _data["multipilerType"] !== undefined ? _data["multipilerType"] : null as any;
            this.expectMultiplier = _data["expectMultiplier"] !== undefined ? _data["expectMultiplier"] : null as any;
            this.precalID = _data["precalID"] !== undefined ? _data["precalID"] : null as any;
            this.precalMultiplierExpiredDateTime = _data["precalMultiplierExpiredDateTime"] ? moment(_data["precalMultiplierExpiredDateTime"].toString()) : null as any;
            this.internalText = _data["internalText"] !== undefined ? _data["internalText"] : null as any;
            this.discountUnitPrice = _data["discountUnitPrice"] !== undefined ? _data["discountUnitPrice"] : null as any;
            this.noDiscountByPlatformUnitPrice = _data["noDiscountByPlatformUnitPrice"] !== undefined ? _data["noDiscountByPlatformUnitPrice"] : null as any;
            this.noDiscountByListUnitPrice = _data["noDiscountByListUnitPrice"] !== undefined ? _data["noDiscountByListUnitPrice"] : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.capacityCycle = _data["capacityCycle"] !== undefined ? _data["capacityCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.inToOutCycle = _data["inToOutCycle"] !== undefined ? _data["inToOutCycle"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : null as any;
            this.submit = _data["submit"] !== undefined ? _data["submit"] : null as any;
            this.precalItemNo = _data["precalItemNo"] !== undefined ? _data["precalItemNo"] : null as any;
            this.isNewPMSProduct = _data["isNewPMSProduct"] !== undefined ? _data["isNewPMSProduct"] : null as any;
            this.pmsMultiplier = _data["pmsMultiplier"] !== undefined ? _data["pmsMultiplier"] : null as any;
            this.technicalSpecification = _data["technicalSpecification"] !== undefined ? _data["technicalSpecification"] : null as any;
            this.changeSelected = _data["changeSelected"] !== undefined ? _data["changeSelected"] : null as any;
            this.mspSourceType = _data["mspSourceType"] !== undefined ? _data["mspSourceType"] : null as any;
            this.mspSourceID = _data["mspSourceID"] !== undefined ? _data["mspSourceID"] : null as any;
            this.listPriceBasicMotorPriceId = _data["listPriceBasicMotorPriceId"] !== undefined ? _data["listPriceBasicMotorPriceId"] : null as any;
            this.listPriceJINCode = _data["listPriceJINCode"] !== undefined ? _data["listPriceJINCode"] : null as any;
            this.insideVCOpenRemarks = _data["insideVCOpenRemarks"] !== undefined ? _data["insideVCOpenRemarks"] : null as any;
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
            this.technicalSpecificationProductId = _data["technicalSpecificationProductId"] !== undefined ? _data["technicalSpecificationProductId"] : null as any;
            this.isNeedHeightOutput = _data["isNeedHeightOutput"] !== undefined ? _data["isNeedHeightOutput"] : null as any;
            this.lectoType = _data["lectoType"] ? LectoType.fromJS(_data["lectoType"]) : null as any;
            if (Array.isArray(_data["vcs"])) {
                this.vcs = [] as any;
                for (let item of _data["vcs"])
                    this.vcs!.push(LectoTypeProductVC.fromJS(item));
            }
            else {
                this.vcs = null as any;
            }
            this.technologyQuotationProduct = _data["technologyQuotationProduct"] ? TechnologyQuotationProduct.fromJS(_data["technologyQuotationProduct"]) : null as any;
            this.technicalSpecificationProduct = _data["technicalSpecificationProduct"] ? TechnologyQuotationProduct.fromJS(_data["technicalSpecificationProduct"]) : null as any;
            this.gcsHelpProductId = _data["gcsHelpProductId"] !== undefined ? _data["gcsHelpProductId"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
        }
    }

    static fromJS(data: any): LectoTypeProduct {
        data = typeof data === 'object' ? data : {};
        let result = new LectoTypeProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["productNumber"] = this.productNumber !== undefined ? this.productNumber : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["isHaveVc"] = this.isHaveVc !== undefined ? this.isHaveVc : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["basicMotorType"] = this.basicMotorType !== undefined ? this.basicMotorType : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["cycle"] = this.cycle !== undefined ? this.cycle : null as any;
        data["technicalConfirmation"] = this.technicalConfirmation !== undefined ? this.technicalConfirmation : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["remarkTwo"] = this.remarkTwo !== undefined ? this.remarkTwo : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["voltageCode"] = this.voltageCode !== undefined ? this.voltageCode : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["encoder"] = this.encoder !== undefined ? this.encoder : null as any;
        data["defaultMultiplier"] = this.defaultMultiplier !== undefined ? this.defaultMultiplier : null as any;
        data["multipilerType"] = this.multipilerType !== undefined ? this.multipilerType : null as any;
        data["expectMultiplier"] = this.expectMultiplier !== undefined ? this.expectMultiplier : null as any;
        data["precalID"] = this.precalID !== undefined ? this.precalID : null as any;
        data["precalMultiplierExpiredDateTime"] = this.precalMultiplierExpiredDateTime ? this.precalMultiplierExpiredDateTime.toISOString() : null as any;
        data["internalText"] = this.internalText !== undefined ? this.internalText : null as any;
        data["discountUnitPrice"] = this.discountUnitPrice !== undefined ? this.discountUnitPrice : null as any;
        data["noDiscountByPlatformUnitPrice"] = this.noDiscountByPlatformUnitPrice !== undefined ? this.noDiscountByPlatformUnitPrice : null as any;
        data["noDiscountByListUnitPrice"] = this.noDiscountByListUnitPrice !== undefined ? this.noDiscountByListUnitPrice : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["capacityCycle"] = this.capacityCycle !== undefined ? this.capacityCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["inToOutCycle"] = this.inToOutCycle !== undefined ? this.inToOutCycle : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : null as any;
        data["submit"] = this.submit !== undefined ? this.submit : null as any;
        data["precalItemNo"] = this.precalItemNo !== undefined ? this.precalItemNo : null as any;
        data["isNewPMSProduct"] = this.isNewPMSProduct !== undefined ? this.isNewPMSProduct : null as any;
        data["pmsMultiplier"] = this.pmsMultiplier !== undefined ? this.pmsMultiplier : null as any;
        data["technicalSpecification"] = this.technicalSpecification !== undefined ? this.technicalSpecification : null as any;
        data["changeSelected"] = this.changeSelected !== undefined ? this.changeSelected : null as any;
        data["mspSourceType"] = this.mspSourceType !== undefined ? this.mspSourceType : null as any;
        data["mspSourceID"] = this.mspSourceID !== undefined ? this.mspSourceID : null as any;
        data["listPriceBasicMotorPriceId"] = this.listPriceBasicMotorPriceId !== undefined ? this.listPriceBasicMotorPriceId : null as any;
        data["listPriceJINCode"] = this.listPriceJINCode !== undefined ? this.listPriceJINCode : null as any;
        data["insideVCOpenRemarks"] = this.insideVCOpenRemarks !== undefined ? this.insideVCOpenRemarks : null as any;
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        data["technicalSpecificationProductId"] = this.technicalSpecificationProductId !== undefined ? this.technicalSpecificationProductId : null as any;
        data["isNeedHeightOutput"] = this.isNeedHeightOutput !== undefined ? this.isNeedHeightOutput : null as any;
        data["lectoType"] = this.lectoType ? this.lectoType.toJSON() : null as any;
        if (Array.isArray(this.vcs)) {
            data["vcs"] = [];
            for (let item of this.vcs)
                data["vcs"].push(item ? item.toJSON() : null as any);
        }
        data["technologyQuotationProduct"] = this.technologyQuotationProduct ? this.technologyQuotationProduct.toJSON() : null as any;
        data["technicalSpecificationProduct"] = this.technicalSpecificationProduct ? this.technicalSpecificationProduct.toJSON() : null as any;
        data["gcsHelpProductId"] = this.gcsHelpProductId !== undefined ? this.gcsHelpProductId : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        return data;
    }
}

export class LectoTypeProductDateOutput {
    /** 产品组合编码 */
    productMixCode!: string;
    /** 预计交货最大天数 */
    expectedDeliveryDate!: number;

    init(_data?: any) {
        if (_data) {
            this.productMixCode = _data["productMixCode"] !== undefined ? _data["productMixCode"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
        }
    }

    static fromJS(data: any): LectoTypeProductDateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LectoTypeProductDateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productMixCode"] = this.productMixCode !== undefined ? this.productMixCode : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        return data;
    }
}

export class LectoTypeProductParameterDto {
    id!: string;
    wiringMode!: string | null;
    lectoTypeProductId!: string;
    frequency!: string | null;
    power!: string | null;
    voltage!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
            this.lectoTypeProductId = _data["lectoTypeProductId"] !== undefined ? _data["lectoTypeProductId"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
        }
    }

    static fromJS(data: any): LectoTypeProductParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new LectoTypeProductParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        data["lectoTypeProductId"] = this.lectoTypeProductId !== undefined ? this.lectoTypeProductId : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        return data;
    }
}

export class LectoTypeProductVC {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    vcID!: string | null;
    category!: string | null;
    meaning!: string | null;
    numberWires!: number;
    cost!: number | null;
    costFormula!: string | null;
    costType!: CostType;
    costTypeDetail!: string | null;
    quotationPrinciple!: string | null;
    quotationPrincipleDetails!: string | null;
    unitPrice!: number | null;
    unitPriceFormula!: string | null;
    unitPriceType!: UnitPriceType;
    unitPriceResult!: string | null;
    unitPriceExpiredTime!: moment.Moment | null;
    vcType!: VcType;
    vcProductCode!: string | null;
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    productionCycle!: number;
    testCycle!: number;
    shipSurveyCycle!: number;
    grCycle!: number;
    makeOrBuy!: string | null;
    source!: ProdcutAndVcSource;
    remark!: string | null;
    isNewPMSProductVC!: boolean | null;
    vcShowType!: VCShowType;
    serialNo!: number | null;
    vcTypeDescription!: string | null;
    lectoTypeProductId!: string;
    technologyQuotationProductVCId!: string | null;
    technicalSpecificationProductVCId!: string | null;
    lectoTypeProduct!: LectoTypeProduct;
    technologyQuotationProductVC!: TechnologyQuotationProductVC;
    technicalSpecificationProductVC!: TechnologyQuotationProductVC;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.unitPriceExpiredTime = _data["unitPriceExpiredTime"] ? moment(_data["unitPriceExpiredTime"].toString()) : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.vcProductCode = _data["vcProductCode"] !== undefined ? _data["vcProductCode"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.isNewPMSProductVC = _data["isNewPMSProductVC"] !== undefined ? _data["isNewPMSProductVC"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.lectoTypeProductId = _data["lectoTypeProductId"] !== undefined ? _data["lectoTypeProductId"] : null as any;
            this.technologyQuotationProductVCId = _data["technologyQuotationProductVCId"] !== undefined ? _data["technologyQuotationProductVCId"] : null as any;
            this.technicalSpecificationProductVCId = _data["technicalSpecificationProductVCId"] !== undefined ? _data["technicalSpecificationProductVCId"] : null as any;
            this.lectoTypeProduct = _data["lectoTypeProduct"] ? LectoTypeProduct.fromJS(_data["lectoTypeProduct"]) : null as any;
            this.technologyQuotationProductVC = _data["technologyQuotationProductVC"] ? TechnologyQuotationProductVC.fromJS(_data["technologyQuotationProductVC"]) : null as any;
            this.technicalSpecificationProductVC = _data["technicalSpecificationProductVC"] ? TechnologyQuotationProductVC.fromJS(_data["technicalSpecificationProductVC"]) : null as any;
        }
    }

    static fromJS(data: any): LectoTypeProductVC {
        data = typeof data === 'object' ? data : {};
        let result = new LectoTypeProductVC();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["unitPriceExpiredTime"] = this.unitPriceExpiredTime ? this.unitPriceExpiredTime.toISOString() : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcProductCode"] = this.vcProductCode !== undefined ? this.vcProductCode : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["isNewPMSProductVC"] = this.isNewPMSProductVC !== undefined ? this.isNewPMSProductVC : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["lectoTypeProductId"] = this.lectoTypeProductId !== undefined ? this.lectoTypeProductId : null as any;
        data["technologyQuotationProductVCId"] = this.technologyQuotationProductVCId !== undefined ? this.technologyQuotationProductVCId : null as any;
        data["technicalSpecificationProductVCId"] = this.technicalSpecificationProductVCId !== undefined ? this.technicalSpecificationProductVCId : null as any;
        data["lectoTypeProduct"] = this.lectoTypeProduct ? this.lectoTypeProduct.toJSON() : null as any;
        data["technologyQuotationProductVC"] = this.technologyQuotationProductVC ? this.technologyQuotationProductVC.toJSON() : null as any;
        data["technicalSpecificationProductVC"] = this.technicalSpecificationProductVC ? this.technicalSpecificationProductVC.toJSON() : null as any;
        return data;
    }
}

export class LectoTypeProductVCsRecords {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    vcID!: string | null;
    category!: string | null;
    meaning!: string | null;
    numberWires!: number;
    cost!: number | null;
    costFormula!: string | null;
    costType!: CostType;
    costTypeDetail!: string | null;
    quotationPrinciple!: string | null;
    quotationPrincipleDetails!: string | null;
    unitPrice!: number | null;
    unitPriceFormula!: string | null;
    unitPriceType!: UnitPriceType;
    unitPriceResult!: string | null;
    unitPriceExpiredTime!: moment.Moment | null;
    vcType!: VcType;
    vcProductCode!: string | null;
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    productionCycle!: number;
    testCycle!: number;
    shipSurveyCycle!: number;
    grCycle!: number;
    makeOrBuy!: string | null;
    source!: ProdcutAndVcSource;
    remark!: string | null;
    isNewPMSProductVC!: boolean | null;
    vcShowType!: VCShowType;
    serialNo!: number | null;
    technologyQuotationProductVCId!: string | null;
    technicalSpecificationProductVCId!: string | null;
    technicalSpecificationProductVC!: TechnologyQuotationProductVC;
    lectoTypeProductId!: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.unitPriceExpiredTime = _data["unitPriceExpiredTime"] ? moment(_data["unitPriceExpiredTime"].toString()) : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.vcProductCode = _data["vcProductCode"] !== undefined ? _data["vcProductCode"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.isNewPMSProductVC = _data["isNewPMSProductVC"] !== undefined ? _data["isNewPMSProductVC"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : null as any;
            this.technologyQuotationProductVCId = _data["technologyQuotationProductVCId"] !== undefined ? _data["technologyQuotationProductVCId"] : null as any;
            this.technicalSpecificationProductVCId = _data["technicalSpecificationProductVCId"] !== undefined ? _data["technicalSpecificationProductVCId"] : null as any;
            this.technicalSpecificationProductVC = _data["technicalSpecificationProductVC"] ? TechnologyQuotationProductVC.fromJS(_data["technicalSpecificationProductVC"]) : null as any;
            this.lectoTypeProductId = _data["lectoTypeProductId"] !== undefined ? _data["lectoTypeProductId"] : null as any;
        }
    }

    static fromJS(data: any): LectoTypeProductVCsRecords {
        data = typeof data === 'object' ? data : {};
        let result = new LectoTypeProductVCsRecords();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["unitPriceExpiredTime"] = this.unitPriceExpiredTime ? this.unitPriceExpiredTime.toISOString() : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcProductCode"] = this.vcProductCode !== undefined ? this.vcProductCode : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["isNewPMSProductVC"] = this.isNewPMSProductVC !== undefined ? this.isNewPMSProductVC : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : null as any;
        data["technologyQuotationProductVCId"] = this.technologyQuotationProductVCId !== undefined ? this.technologyQuotationProductVCId : null as any;
        data["technicalSpecificationProductVCId"] = this.technicalSpecificationProductVCId !== undefined ? this.technicalSpecificationProductVCId : null as any;
        data["technicalSpecificationProductVC"] = this.technicalSpecificationProductVC ? this.technicalSpecificationProductVC.toJSON() : null as any;
        data["lectoTypeProductId"] = this.lectoTypeProductId !== undefined ? this.lectoTypeProductId : null as any;
        return data;
    }
}

export class LectoTypeProductVc163209NoGcsHelpDto {
    /** 产品行号（SerialNo） */
    serialNo!: number;
    /** 命中的VC ID集合（163/209） */
    hitVcIds!: string[] | null;
    /** 提示信息 */
    message!: string | null;

    init(_data?: any) {
        if (_data) {
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : null as any;
            if (Array.isArray(_data["hitVcIds"])) {
                this.hitVcIds = [] as any;
                for (let item of _data["hitVcIds"])
                    this.hitVcIds!.push(item);
            }
            else {
                this.hitVcIds = null as any;
            }
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): LectoTypeProductVc163209NoGcsHelpDto {
        data = typeof data === 'object' ? data : {};
        let result = new LectoTypeProductVc163209NoGcsHelpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : null as any;
        if (Array.isArray(this.hitVcIds)) {
            data["hitVcIds"] = [];
            for (let item of this.hitVcIds)
                data["hitVcIds"].push(item);
        }
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }
}

export class LectoTypeProductsRecords {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    productNumber!: number;
    basicMotorCode!: string | null;
    basicMotorModel!: string | null;
    basicMotorMounting!: string | null;
    frameNo!: number;
    isHaveVc!: IsHaveVc;
    power!: string | null;
    basicMotorType!: BasicMotorType;
    basicMotorSries!: string | null;
    unitPrice!: number | null;
    unitPriceResult!: string | null;
    cycle!: number;
    technicalConfirmation!: string | null;
    appraisalNumber!: string | null;
    source!: ProdcutAndVcSource;
    remark!: string | null;
    remarkTwo!: string | null;
    frequency!: string | null;
    poleNo!: string | null;
    voltage!: string | null;
    encoder!: string | null;
    defaultMultiplier!: number;
    multipilerType!: MultipilerType;
    expectMultiplier!: number | null;
    precalID!: string | null;
    precalMultiplierExpiredDateTime!: moment.Moment | null;
    internalText!: string | null;
    discountUnitPrice!: number | null;
    noDiscountByPlatformUnitPrice!: number | null;
    noDiscountByListUnitPrice!: number | null;
    gssQuotationNo!: string | null;
    gssTechnicalConfirmationNumber!: string | null;
    salesPrice!: number | null;
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    productionCycle!: number;
    testCycle!: number;
    capacityCycle!: number;
    grCycle!: number;
    makeOrBuy!: string | null;
    serialNo!: number;
    submit!: boolean;
    precalItemNo!: number | null;
    isNewPMSProduct!: boolean | null;
    pmsMultiplier!: number | null;
    technicalSpecification!: string | null;
    changeSelected!: boolean;
    mspSourceType!: MSPSourceTypeEnum;
    mspSourceID!: string | null;
    lectoTypeId!: string;
    technologyQuotationProductId!: string | null;
    technicalSpecificationProductId!: string | null;
    technicalSpecificationProduct!: TechnologyQuotationProduct;
    gcsHelpProductId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.productNumber = _data["productNumber"] !== undefined ? _data["productNumber"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.isHaveVc = _data["isHaveVc"] !== undefined ? _data["isHaveVc"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.basicMotorType = _data["basicMotorType"] !== undefined ? _data["basicMotorType"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.cycle = _data["cycle"] !== undefined ? _data["cycle"] : null as any;
            this.technicalConfirmation = _data["technicalConfirmation"] !== undefined ? _data["technicalConfirmation"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.remarkTwo = _data["remarkTwo"] !== undefined ? _data["remarkTwo"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.encoder = _data["encoder"] !== undefined ? _data["encoder"] : null as any;
            this.defaultMultiplier = _data["defaultMultiplier"] !== undefined ? _data["defaultMultiplier"] : null as any;
            this.multipilerType = _data["multipilerType"] !== undefined ? _data["multipilerType"] : null as any;
            this.expectMultiplier = _data["expectMultiplier"] !== undefined ? _data["expectMultiplier"] : null as any;
            this.precalID = _data["precalID"] !== undefined ? _data["precalID"] : null as any;
            this.precalMultiplierExpiredDateTime = _data["precalMultiplierExpiredDateTime"] ? moment(_data["precalMultiplierExpiredDateTime"].toString()) : null as any;
            this.internalText = _data["internalText"] !== undefined ? _data["internalText"] : null as any;
            this.discountUnitPrice = _data["discountUnitPrice"] !== undefined ? _data["discountUnitPrice"] : null as any;
            this.noDiscountByPlatformUnitPrice = _data["noDiscountByPlatformUnitPrice"] !== undefined ? _data["noDiscountByPlatformUnitPrice"] : null as any;
            this.noDiscountByListUnitPrice = _data["noDiscountByListUnitPrice"] !== undefined ? _data["noDiscountByListUnitPrice"] : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.capacityCycle = _data["capacityCycle"] !== undefined ? _data["capacityCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : null as any;
            this.submit = _data["submit"] !== undefined ? _data["submit"] : null as any;
            this.precalItemNo = _data["precalItemNo"] !== undefined ? _data["precalItemNo"] : null as any;
            this.isNewPMSProduct = _data["isNewPMSProduct"] !== undefined ? _data["isNewPMSProduct"] : null as any;
            this.pmsMultiplier = _data["pmsMultiplier"] !== undefined ? _data["pmsMultiplier"] : null as any;
            this.technicalSpecification = _data["technicalSpecification"] !== undefined ? _data["technicalSpecification"] : null as any;
            this.changeSelected = _data["changeSelected"] !== undefined ? _data["changeSelected"] : null as any;
            this.mspSourceType = _data["mspSourceType"] !== undefined ? _data["mspSourceType"] : null as any;
            this.mspSourceID = _data["mspSourceID"] !== undefined ? _data["mspSourceID"] : null as any;
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
            this.technicalSpecificationProductId = _data["technicalSpecificationProductId"] !== undefined ? _data["technicalSpecificationProductId"] : null as any;
            this.technicalSpecificationProduct = _data["technicalSpecificationProduct"] ? TechnologyQuotationProduct.fromJS(_data["technicalSpecificationProduct"]) : null as any;
            this.gcsHelpProductId = _data["gcsHelpProductId"] !== undefined ? _data["gcsHelpProductId"] : null as any;
        }
    }

    static fromJS(data: any): LectoTypeProductsRecords {
        data = typeof data === 'object' ? data : {};
        let result = new LectoTypeProductsRecords();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["productNumber"] = this.productNumber !== undefined ? this.productNumber : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["isHaveVc"] = this.isHaveVc !== undefined ? this.isHaveVc : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["basicMotorType"] = this.basicMotorType !== undefined ? this.basicMotorType : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["cycle"] = this.cycle !== undefined ? this.cycle : null as any;
        data["technicalConfirmation"] = this.technicalConfirmation !== undefined ? this.technicalConfirmation : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["remarkTwo"] = this.remarkTwo !== undefined ? this.remarkTwo : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["encoder"] = this.encoder !== undefined ? this.encoder : null as any;
        data["defaultMultiplier"] = this.defaultMultiplier !== undefined ? this.defaultMultiplier : null as any;
        data["multipilerType"] = this.multipilerType !== undefined ? this.multipilerType : null as any;
        data["expectMultiplier"] = this.expectMultiplier !== undefined ? this.expectMultiplier : null as any;
        data["precalID"] = this.precalID !== undefined ? this.precalID : null as any;
        data["precalMultiplierExpiredDateTime"] = this.precalMultiplierExpiredDateTime ? this.precalMultiplierExpiredDateTime.toISOString() : null as any;
        data["internalText"] = this.internalText !== undefined ? this.internalText : null as any;
        data["discountUnitPrice"] = this.discountUnitPrice !== undefined ? this.discountUnitPrice : null as any;
        data["noDiscountByPlatformUnitPrice"] = this.noDiscountByPlatformUnitPrice !== undefined ? this.noDiscountByPlatformUnitPrice : null as any;
        data["noDiscountByListUnitPrice"] = this.noDiscountByListUnitPrice !== undefined ? this.noDiscountByListUnitPrice : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["capacityCycle"] = this.capacityCycle !== undefined ? this.capacityCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : null as any;
        data["submit"] = this.submit !== undefined ? this.submit : null as any;
        data["precalItemNo"] = this.precalItemNo !== undefined ? this.precalItemNo : null as any;
        data["isNewPMSProduct"] = this.isNewPMSProduct !== undefined ? this.isNewPMSProduct : null as any;
        data["pmsMultiplier"] = this.pmsMultiplier !== undefined ? this.pmsMultiplier : null as any;
        data["technicalSpecification"] = this.technicalSpecification !== undefined ? this.technicalSpecification : null as any;
        data["changeSelected"] = this.changeSelected !== undefined ? this.changeSelected : null as any;
        data["mspSourceType"] = this.mspSourceType !== undefined ? this.mspSourceType : null as any;
        data["mspSourceID"] = this.mspSourceID !== undefined ? this.mspSourceID : null as any;
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        data["technicalSpecificationProductId"] = this.technicalSpecificationProductId !== undefined ? this.technicalSpecificationProductId : null as any;
        data["technicalSpecificationProduct"] = this.technicalSpecificationProduct ? this.technicalSpecificationProduct.toJSON() : null as any;
        data["gcsHelpProductId"] = this.gcsHelpProductId !== undefined ? this.gcsHelpProductId : null as any;
        return data;
    }
}

export class LectoTypeRecord {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    propStatus!: LectoTypeStatus;
    currentStatus!: LectoTypeStatus;
    remark!: string | null;
    lectoTypeId!: string;
    lectoType!: LectoType;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.propStatus = _data["propStatus"] !== undefined ? _data["propStatus"] : null as any;
            this.currentStatus = _data["currentStatus"] !== undefined ? _data["currentStatus"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.lectoType = _data["lectoType"] ? LectoType.fromJS(_data["lectoType"]) : null as any;
        }
    }

    static fromJS(data: any): LectoTypeRecord {
        data = typeof data === 'object' ? data : {};
        let result = new LectoTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["propStatus"] = this.propStatus !== undefined ? this.propStatus : null as any;
        data["currentStatus"] = this.currentStatus !== undefined ? this.currentStatus : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["lectoType"] = this.lectoType ? this.lectoType.toJSON() : null as any;
        return data;
    }
}

/** 选型后台任务参数(数据可序列化,会持久化至数据库中) */
export class LectoTypeRecordJobArgs {
    /** 任务名称 */
    jobName!: string | null;
    /** 请求协助记录编号-通过记录编号确定唯一的Job任务 */
    recordId!: string;

    init(_data?: any) {
        if (_data) {
            this.jobName = _data["jobName"] !== undefined ? _data["jobName"] : null as any;
            this.recordId = _data["recordId"] !== undefined ? _data["recordId"] : null as any;
        }
    }

    static fromJS(data: any): LectoTypeRecordJobArgs {
        data = typeof data === 'object' ? data : {};
        let result = new LectoTypeRecordJobArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobName"] = this.jobName !== undefined ? this.jobName : null as any;
        data["recordId"] = this.recordId !== undefined ? this.recordId : null as any;
        return data;
    }
}

/** 0 = Conducting (进行中) 1 = NeedGCSHelp (待GCS帮助) 2 = GCSHelping (GCS帮助中) 4 = Quoted (已报价) 5 = Completed (已完成) 6 = NeedSaleHelp (等待销售帮助) 7 = SaleHelping (销售帮助中) 8 = 折扣审批中 (折扣审批中) 9 = 折扣审批通过 (折扣审批通过) 10 = 折扣审批拒绝 (折扣审批拒绝) 11 = 等待销售帮助申请折扣 (等待销售帮助申请折扣) 12 = 销售帮助申请折扣中 (销售帮助申请折扣中) 13 = 销售帮助申请折扣审批中 (销售帮助申请折扣审批中) 14 = 销售帮助申请折扣审批通过 (销售帮助申请折扣审批通过) 15 = 销售帮助申请折扣审批拒绝 (销售帮助申请折扣审批拒绝) 16 = 锁定 (锁定) -1 = Undfiend (未知) */
export enum LectoTypeStatus {
    Conducting = 0,
    NeedGCSHelp = 1,
    GCSHelping = 2,
    Quoted = 4,
    Completed = 5,
    NeedSaleHelp = 6,
    SaleHelping = 7,
    折扣审批中 = 8,
    折扣审批通过 = 9,
    折扣审批拒绝 = 10,
    等待销售帮助申请折扣 = 11,
    销售帮助申请折扣中 = 12,
    销售帮助申请折扣审批中 = 13,
    销售帮助申请折扣审批通过 = 14,
    销售帮助申请折扣审批拒绝 = 15,
    锁定 = 16,
    Undfiend = -1,
}

/** 选型VC技术协议备注信息 */
export class LectoTypeTeVCRemarkDto {
    /** VC编号 */
    vcID!: string | null;
    /** VC备注 */
    remark!: string | null;
    /** 产品编号 */
    productId!: string;
    /** 技术规范号 */
    technicalSpecifications!: string | null;

    init(_data?: any) {
        if (_data) {
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
        }
    }

    static fromJS(data: any): LectoTypeTeVCRemarkDto {
        data = typeof data === 'object' ? data : {};
        let result = new LectoTypeTeVCRemarkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["productId"] = this.productId !== undefined ? this.productId : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        return data;
    }
}

export class LectoTypeVersionsByList {
    id!: string;
    userFriendlyID!: string | null;
    name!: string | null;
    pmsProjectCode!: string | null;
    version!: number | null;
    creationTime!: moment.Moment | null;
    lectoTypeStatus!: LectoTypeStatus;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.userFriendlyID = _data["userFriendlyID"] !== undefined ? _data["userFriendlyID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.pmsProjectCode = _data["pmsProjectCode"] !== undefined ? _data["pmsProjectCode"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.lectoTypeStatus = _data["lectoTypeStatus"] !== undefined ? _data["lectoTypeStatus"] : null as any;
        }
    }

    static fromJS(data: any): LectoTypeVersionsByList {
        data = typeof data === 'object' ? data : {};
        let result = new LectoTypeVersionsByList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["userFriendlyID"] = this.userFriendlyID !== undefined ? this.userFriendlyID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["pmsProjectCode"] = this.pmsProjectCode !== undefined ? this.pmsProjectCode : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["lectoTypeStatus"] = this.lectoTypeStatus !== undefined ? this.lectoTypeStatus : null as any;
        return data;
    }
}

export class MSPSourceProduct {
    id!: string;
    basicMotorCode!: string | null;
    basicMotorModel!: string | null;
    basicMotorSries!: string | null;
    mspSourceProductVCs!: MSPSourceProductVC[] | null;
    serialNo!: number;
    mspSourceTypeBusiness!: MSPSourceTypeBusiness;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            if (Array.isArray(_data["mspSourceProductVCs"])) {
                this.mspSourceProductVCs = [] as any;
                for (let item of _data["mspSourceProductVCs"])
                    this.mspSourceProductVCs!.push(MSPSourceProductVC.fromJS(item));
            }
            else {
                this.mspSourceProductVCs = null as any;
            }
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : null as any;
            this.mspSourceTypeBusiness = _data["mspSourceTypeBusiness"] !== undefined ? _data["mspSourceTypeBusiness"] : null as any;
        }
    }

    static fromJS(data: any): MSPSourceProduct {
        data = typeof data === 'object' ? data : {};
        let result = new MSPSourceProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        if (Array.isArray(this.mspSourceProductVCs)) {
            data["mspSourceProductVCs"] = [];
            for (let item of this.mspSourceProductVCs)
                data["mspSourceProductVCs"].push(item ? item.toJSON() : null as any);
        }
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : null as any;
        data["mspSourceTypeBusiness"] = this.mspSourceTypeBusiness !== undefined ? this.mspSourceTypeBusiness : null as any;
        return data;
    }
}

export class MSPSourceProductVC {
    id!: string;
    vcCode!: string | null;
    category!: string | null;
    meaning!: string | null;
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): MSPSourceProductVC {
        data = typeof data === 'object' ? data : {};
        let result = new MSPSourceProductVC();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

/** 1 = FloodDragonProduct 2 = VC163209 */
export enum MSPSourceTypeBusiness {
    FloodDragonProduct = 1,
    VC163209 = 2,
}

/** 0 = Selection 1 = CopySelection 2 = QuoteTechnology 3 = QuoteQuotations 4 = QuoteHistorySelection */
export enum MSPSourceTypeEnum {
    Selection = 0,
    CopySelection = 1,
    QuoteTechnology = 2,
    QuoteQuotations = 3,
    QuoteHistorySelection = 4,
}

export class MacthQuotationNumberFromLectoTypeInput {
    lectoTypeId!: string;
    /** 产品编码 */
    basicMotorCodeList!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            if (Array.isArray(_data["basicMotorCodeList"])) {
                this.basicMotorCodeList = [] as any;
                for (let item of _data["basicMotorCodeList"])
                    this.basicMotorCodeList!.push(item);
            }
            else {
                this.basicMotorCodeList = null as any;
            }
        }
    }

    static fromJS(data: any): MacthQuotationNumberFromLectoTypeInput {
        data = typeof data === 'object' ? data : {};
        let result = new MacthQuotationNumberFromLectoTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        if (Array.isArray(this.basicMotorCodeList)) {
            data["basicMotorCodeList"] = [];
            for (let item of this.basicMotorCodeList)
                data["basicMotorCodeList"].push(item);
        }
        return data;
    }
}

export class MassQuotationNumber {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    quotationNumber!: string | null;
    customerCode!: string | null;
    subCustomerCode!: string | null;
    customerName!: string | null;
    subCustomerName!: string | null;
    effectiveTime!: moment.Moment;
    basicMotorCode!: string | null;
    jinVersion!: string | null;
    jinCategoryCode!: string | null;
    basicMotorModel!: string | null;
    expirationTime!: moment.Moment;
    lineNumber!: string | null;
    modelSelectionId!: string | null;
    productId!: string;
    exectMultiplier!: number;
    approverMultiplier!: number;
    specialType!: SpecialTypeEnum;
    massQuotationNumberBaseInfoId!: string;
    massQuotationNumberBaseInfo!: MassQuotationNumberBaseInfo;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.quotationNumber = _data["quotationNumber"] !== undefined ? _data["quotationNumber"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.subCustomerCode = _data["subCustomerCode"] !== undefined ? _data["subCustomerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.subCustomerName = _data["subCustomerName"] !== undefined ? _data["subCustomerName"] : null as any;
            this.effectiveTime = _data["effectiveTime"] ? moment(_data["effectiveTime"].toString()) : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.expirationTime = _data["expirationTime"] ? moment(_data["expirationTime"].toString()) : null as any;
            this.lineNumber = _data["lineNumber"] !== undefined ? _data["lineNumber"] : null as any;
            this.modelSelectionId = _data["modelSelectionId"] !== undefined ? _data["modelSelectionId"] : null as any;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : null as any;
            this.exectMultiplier = _data["exectMultiplier"] !== undefined ? _data["exectMultiplier"] : null as any;
            this.approverMultiplier = _data["approverMultiplier"] !== undefined ? _data["approverMultiplier"] : null as any;
            this.specialType = _data["specialType"] !== undefined ? _data["specialType"] : null as any;
            this.massQuotationNumberBaseInfoId = _data["massQuotationNumberBaseInfoId"] !== undefined ? _data["massQuotationNumberBaseInfoId"] : null as any;
            this.massQuotationNumberBaseInfo = _data["massQuotationNumberBaseInfo"] ? MassQuotationNumberBaseInfo.fromJS(_data["massQuotationNumberBaseInfo"]) : null as any;
        }
    }

    static fromJS(data: any): MassQuotationNumber {
        data = typeof data === 'object' ? data : {};
        let result = new MassQuotationNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["quotationNumber"] = this.quotationNumber !== undefined ? this.quotationNumber : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["subCustomerCode"] = this.subCustomerCode !== undefined ? this.subCustomerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["subCustomerName"] = this.subCustomerName !== undefined ? this.subCustomerName : null as any;
        data["effectiveTime"] = this.effectiveTime ? this.effectiveTime.toISOString() : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["expirationTime"] = this.expirationTime ? this.expirationTime.toISOString() : null as any;
        data["lineNumber"] = this.lineNumber !== undefined ? this.lineNumber : null as any;
        data["modelSelectionId"] = this.modelSelectionId !== undefined ? this.modelSelectionId : null as any;
        data["productId"] = this.productId !== undefined ? this.productId : null as any;
        data["exectMultiplier"] = this.exectMultiplier !== undefined ? this.exectMultiplier : null as any;
        data["approverMultiplier"] = this.approverMultiplier !== undefined ? this.approverMultiplier : null as any;
        data["specialType"] = this.specialType !== undefined ? this.specialType : null as any;
        data["massQuotationNumberBaseInfoId"] = this.massQuotationNumberBaseInfoId !== undefined ? this.massQuotationNumberBaseInfoId : null as any;
        data["massQuotationNumberBaseInfo"] = this.massQuotationNumberBaseInfo ? this.massQuotationNumberBaseInfo.toJSON() : null as any;
        return data;
    }
}

export class MassQuotationNumberBaseInfo {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    quotationNumber!: string | null;
    customerCode!: string | null;
    subCustomerCode!: string | null;
    customerName!: string | null;
    subCustomerName!: string | null;
    effectiveTime!: moment.Moment;
    expirationTime!: moment.Moment;
    remark!: string | null;
    modelSelectionId!: string | null;
    specialType!: SpecialTypeEnum;
    massQuotationNumbers!: MassQuotationNumber[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.quotationNumber = _data["quotationNumber"] !== undefined ? _data["quotationNumber"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.subCustomerCode = _data["subCustomerCode"] !== undefined ? _data["subCustomerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.subCustomerName = _data["subCustomerName"] !== undefined ? _data["subCustomerName"] : null as any;
            this.effectiveTime = _data["effectiveTime"] ? moment(_data["effectiveTime"].toString()) : null as any;
            this.expirationTime = _data["expirationTime"] ? moment(_data["expirationTime"].toString()) : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.modelSelectionId = _data["modelSelectionId"] !== undefined ? _data["modelSelectionId"] : null as any;
            this.specialType = _data["specialType"] !== undefined ? _data["specialType"] : null as any;
            if (Array.isArray(_data["massQuotationNumbers"])) {
                this.massQuotationNumbers = [] as any;
                for (let item of _data["massQuotationNumbers"])
                    this.massQuotationNumbers!.push(MassQuotationNumber.fromJS(item));
            }
            else {
                this.massQuotationNumbers = null as any;
            }
        }
    }

    static fromJS(data: any): MassQuotationNumberBaseInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MassQuotationNumberBaseInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["quotationNumber"] = this.quotationNumber !== undefined ? this.quotationNumber : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["subCustomerCode"] = this.subCustomerCode !== undefined ? this.subCustomerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["subCustomerName"] = this.subCustomerName !== undefined ? this.subCustomerName : null as any;
        data["effectiveTime"] = this.effectiveTime ? this.effectiveTime.toISOString() : null as any;
        data["expirationTime"] = this.expirationTime ? this.expirationTime.toISOString() : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["modelSelectionId"] = this.modelSelectionId !== undefined ? this.modelSelectionId : null as any;
        data["specialType"] = this.specialType !== undefined ? this.specialType : null as any;
        if (Array.isArray(this.massQuotationNumbers)) {
            data["massQuotationNumbers"] = [];
            for (let item of this.massQuotationNumbers)
                data["massQuotationNumbers"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class MassQuotationNumberBaseInfoOutput {
    id!: string;
    /** 特价号 */
    quotationNumber!: string | null;
    /** 客户代码 */
    customerCode!: string | null;
    /** 二级客户代码 */
    subCustomerCode!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 二级客户名称 */
    subCustomerName!: string | null;
    /** 生效时间 */
    effectiveTime!: moment.Moment | null;
    /** 失效时间 */
    expirationTime!: moment.Moment | null;
    /** 行号 */
    lineNumber!: string | null;
    modelSelectionId!: string | null;
    /** 特价号Id */
    massQuotationNumberBaseInfoId!: string | null;
    /** 创建时间 */
    createTime!: moment.Moment | null;
    /** 备注 */
    remark!: string | null;
    /** 参数数据 */
    massQuotationNumbers!: MassQuotationNumberOutput[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.quotationNumber = _data["quotationNumber"] !== undefined ? _data["quotationNumber"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.subCustomerCode = _data["subCustomerCode"] !== undefined ? _data["subCustomerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.subCustomerName = _data["subCustomerName"] !== undefined ? _data["subCustomerName"] : null as any;
            this.effectiveTime = _data["effectiveTime"] ? moment(_data["effectiveTime"].toString()) : null as any;
            this.expirationTime = _data["expirationTime"] ? moment(_data["expirationTime"].toString()) : null as any;
            this.lineNumber = _data["lineNumber"] !== undefined ? _data["lineNumber"] : null as any;
            this.modelSelectionId = _data["modelSelectionId"] !== undefined ? _data["modelSelectionId"] : null as any;
            this.massQuotationNumberBaseInfoId = _data["massQuotationNumberBaseInfoId"] !== undefined ? _data["massQuotationNumberBaseInfoId"] : null as any;
            this.createTime = _data["createTime"] ? moment(_data["createTime"].toString()) : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            if (Array.isArray(_data["massQuotationNumbers"])) {
                this.massQuotationNumbers = [] as any;
                for (let item of _data["massQuotationNumbers"])
                    this.massQuotationNumbers!.push(MassQuotationNumberOutput.fromJS(item));
            }
            else {
                this.massQuotationNumbers = null as any;
            }
        }
    }

    static fromJS(data: any): MassQuotationNumberBaseInfoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new MassQuotationNumberBaseInfoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["quotationNumber"] = this.quotationNumber !== undefined ? this.quotationNumber : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["subCustomerCode"] = this.subCustomerCode !== undefined ? this.subCustomerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["subCustomerName"] = this.subCustomerName !== undefined ? this.subCustomerName : null as any;
        data["effectiveTime"] = this.effectiveTime ? this.effectiveTime.toISOString() : null as any;
        data["expirationTime"] = this.expirationTime ? this.expirationTime.toISOString() : null as any;
        data["lineNumber"] = this.lineNumber !== undefined ? this.lineNumber : null as any;
        data["modelSelectionId"] = this.modelSelectionId !== undefined ? this.modelSelectionId : null as any;
        data["massQuotationNumberBaseInfoId"] = this.massQuotationNumberBaseInfoId !== undefined ? this.massQuotationNumberBaseInfoId : null as any;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        if (Array.isArray(this.massQuotationNumbers)) {
            data["massQuotationNumbers"] = [];
            for (let item of this.massQuotationNumbers)
                data["massQuotationNumbers"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class MassQuotationNumberBaseInfoOutputPagedResultDto {
    items!: MassQuotationNumberBaseInfoOutput[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MassQuotationNumberBaseInfoOutput.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): MassQuotationNumberBaseInfoOutputPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MassQuotationNumberBaseInfoOutputPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class MassQuotationNumberOutput {
    /** 特价号 */
    quotationNumber!: string | null;
    /** 客户代码 */
    customerCode!: string | null;
    /** 二级客户代码 */
    subCustomerCode!: string | null;
    /** 客户名称 */
    customerName!: string | null;
    /** 二级客户名称 */
    subCustomerName!: string | null;
    /** 生效时间 */
    effectiveTime!: moment.Moment;
    /** 主机代码 */
    basicMotorCode!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 产品系列 */
    basicMotorSeries!: string | null;
    /** 失效时间 */
    expirationTime!: moment.Moment;
    /** 行号 */
    lineNumber!: string | null;
    modelSelectionId!: string | null;
    /** 期望系数 */
    exectMultiplier!: number;
    /** 审批系数 */
    approverMultiplier!: number;
    /** 特价号Id */
    massQuotationNumberBaseInfoId!: string;
    massQuotationNumberBaseInfo!: MassQuotationNumberBaseInfo;

    init(_data?: any) {
        if (_data) {
            this.quotationNumber = _data["quotationNumber"] !== undefined ? _data["quotationNumber"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.subCustomerCode = _data["subCustomerCode"] !== undefined ? _data["subCustomerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.subCustomerName = _data["subCustomerName"] !== undefined ? _data["subCustomerName"] : null as any;
            this.effectiveTime = _data["effectiveTime"] ? moment(_data["effectiveTime"].toString()) : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorSeries = _data["basicMotorSeries"] !== undefined ? _data["basicMotorSeries"] : null as any;
            this.expirationTime = _data["expirationTime"] ? moment(_data["expirationTime"].toString()) : null as any;
            this.lineNumber = _data["lineNumber"] !== undefined ? _data["lineNumber"] : null as any;
            this.modelSelectionId = _data["modelSelectionId"] !== undefined ? _data["modelSelectionId"] : null as any;
            this.exectMultiplier = _data["exectMultiplier"] !== undefined ? _data["exectMultiplier"] : null as any;
            this.approverMultiplier = _data["approverMultiplier"] !== undefined ? _data["approverMultiplier"] : null as any;
            this.massQuotationNumberBaseInfoId = _data["massQuotationNumberBaseInfoId"] !== undefined ? _data["massQuotationNumberBaseInfoId"] : null as any;
            this.massQuotationNumberBaseInfo = _data["massQuotationNumberBaseInfo"] ? MassQuotationNumberBaseInfo.fromJS(_data["massQuotationNumberBaseInfo"]) : null as any;
        }
    }

    static fromJS(data: any): MassQuotationNumberOutput {
        data = typeof data === 'object' ? data : {};
        let result = new MassQuotationNumberOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quotationNumber"] = this.quotationNumber !== undefined ? this.quotationNumber : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["subCustomerCode"] = this.subCustomerCode !== undefined ? this.subCustomerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["subCustomerName"] = this.subCustomerName !== undefined ? this.subCustomerName : null as any;
        data["effectiveTime"] = this.effectiveTime ? this.effectiveTime.toISOString() : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorSeries"] = this.basicMotorSeries !== undefined ? this.basicMotorSeries : null as any;
        data["expirationTime"] = this.expirationTime ? this.expirationTime.toISOString() : null as any;
        data["lineNumber"] = this.lineNumber !== undefined ? this.lineNumber : null as any;
        data["modelSelectionId"] = this.modelSelectionId !== undefined ? this.modelSelectionId : null as any;
        data["exectMultiplier"] = this.exectMultiplier !== undefined ? this.exectMultiplier : null as any;
        data["approverMultiplier"] = this.approverMultiplier !== undefined ? this.approverMultiplier : null as any;
        data["massQuotationNumberBaseInfoId"] = this.massQuotationNumberBaseInfoId !== undefined ? this.massQuotationNumberBaseInfoId : null as any;
        data["massQuotationNumberBaseInfo"] = this.massQuotationNumberBaseInfo ? this.massQuotationNumberBaseInfo.toJSON() : null as any;
        return data;
    }
}

export class MemberInfo {
    memberType!: MemberTypes;
    readonly name!: string | null;
    declaringType!: Type;
    reflectedType!: Type;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | null;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"] !== undefined ? _data["memberType"] : null as any;
            (this as any).name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : null as any;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : null as any;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : null as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            else {
                (this as any).customAttributes = null as any;
            }
            (this as any).isCollectible = _data["isCollectible"] !== undefined ? _data["isCollectible"] : null as any;
            (this as any).metadataToken = _data["metadataToken"] !== undefined ? _data["metadataToken"] : null as any;
        }
    }

    static fromJS(data: any): MemberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType !== undefined ? this.memberType : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : null as any;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : null as any;
        data["module"] = this.module ? this.module.toJSON() : null as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : null as any);
        }
        data["isCollectible"] = this.isCollectible !== undefined ? this.isCollectible : null as any;
        data["metadataToken"] = this.metadataToken !== undefined ? this.metadataToken : null as any;
        return data;
    }
}

/** 1 = Constructor 2 = Event 4 = Field 8 = Method 16 = Property 32 = TypeInfo 64 = Custom 128 = NestedType 191 = All */
export enum MemberTypes {
    Constructor = 1,
    Event = 2,
    Field = 4,
    Method = 8,
    Property = 16,
    TypeInfo = 32,
    Custom = 64,
    NestedType = 128,
    All = 191,
}

/** 0 = ReuseSlot 1 = Private 2 = FamANDAssem 3 = Assembly 4 = Family 5 = FamORAssem 6 = Public 7 = MemberAccessMask 8 = UnmanagedExport 16 = Static 32 = Final 64 = Virtual 128 = HideBySig 256 = VtableLayoutMask 512 = CheckAccessOnOverride 1024 = Abstract 2048 = SpecialName 4096 = RTSpecialName 8192 = PinvokeImpl 16384 = HasSecurity 32768 = RequireSecObject 53248 = ReservedMask */
export enum MethodAttributes {
    ReuseSlot = 0,
    Private = 1,
    FamANDAssem = 2,
    Assembly = 3,
    Family = 4,
    FamORAssem = 5,
    Public = 6,
    MemberAccessMask = 7,
    UnmanagedExport = 8,
    Static = 16,
    Final = 32,
    Virtual = 64,
    HideBySig = 128,
    VtableLayoutMask = 256,
    CheckAccessOnOverride = 512,
    Abstract = 1024,
    SpecialName = 2048,
    RTSpecialName = 4096,
    PinvokeImpl = 8192,
    HasSecurity = 16384,
    RequireSecObject = 32768,
    ReservedMask = 53248,
}

export class MethodBase {
    memberType!: MemberTypes;
    readonly name!: string | null;
    declaringType!: Type;
    reflectedType!: Type;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | null;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    attributes!: MethodAttributes;
    methodImplementationFlags!: MethodImplAttributes;
    callingConvention!: CallingConventions;
    readonly isAbstract!: boolean;
    readonly isConstructor!: boolean;
    readonly isFinal!: boolean;
    readonly isHideBySig!: boolean;
    readonly isSpecialName!: boolean;
    readonly isStatic!: boolean;
    readonly isVirtual!: boolean;
    readonly isAssembly!: boolean;
    readonly isFamily!: boolean;
    readonly isFamilyAndAssembly!: boolean;
    readonly isFamilyOrAssembly!: boolean;
    readonly isPrivate!: boolean;
    readonly isPublic!: boolean;
    readonly isConstructedGenericMethod!: boolean;
    readonly isGenericMethod!: boolean;
    readonly isGenericMethodDefinition!: boolean;
    readonly containsGenericParameters!: boolean;
    methodHandle!: RuntimeMethodHandle;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"] !== undefined ? _data["memberType"] : null as any;
            (this as any).name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : null as any;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : null as any;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : null as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            else {
                (this as any).customAttributes = null as any;
            }
            (this as any).isCollectible = _data["isCollectible"] !== undefined ? _data["isCollectible"] : null as any;
            (this as any).metadataToken = _data["metadataToken"] !== undefined ? _data["metadataToken"] : null as any;
            this.attributes = _data["attributes"] !== undefined ? _data["attributes"] : null as any;
            this.methodImplementationFlags = _data["methodImplementationFlags"] !== undefined ? _data["methodImplementationFlags"] : null as any;
            this.callingConvention = _data["callingConvention"] !== undefined ? _data["callingConvention"] : null as any;
            (this as any).isAbstract = _data["isAbstract"] !== undefined ? _data["isAbstract"] : null as any;
            (this as any).isConstructor = _data["isConstructor"] !== undefined ? _data["isConstructor"] : null as any;
            (this as any).isFinal = _data["isFinal"] !== undefined ? _data["isFinal"] : null as any;
            (this as any).isHideBySig = _data["isHideBySig"] !== undefined ? _data["isHideBySig"] : null as any;
            (this as any).isSpecialName = _data["isSpecialName"] !== undefined ? _data["isSpecialName"] : null as any;
            (this as any).isStatic = _data["isStatic"] !== undefined ? _data["isStatic"] : null as any;
            (this as any).isVirtual = _data["isVirtual"] !== undefined ? _data["isVirtual"] : null as any;
            (this as any).isAssembly = _data["isAssembly"] !== undefined ? _data["isAssembly"] : null as any;
            (this as any).isFamily = _data["isFamily"] !== undefined ? _data["isFamily"] : null as any;
            (this as any).isFamilyAndAssembly = _data["isFamilyAndAssembly"] !== undefined ? _data["isFamilyAndAssembly"] : null as any;
            (this as any).isFamilyOrAssembly = _data["isFamilyOrAssembly"] !== undefined ? _data["isFamilyOrAssembly"] : null as any;
            (this as any).isPrivate = _data["isPrivate"] !== undefined ? _data["isPrivate"] : null as any;
            (this as any).isPublic = _data["isPublic"] !== undefined ? _data["isPublic"] : null as any;
            (this as any).isConstructedGenericMethod = _data["isConstructedGenericMethod"] !== undefined ? _data["isConstructedGenericMethod"] : null as any;
            (this as any).isGenericMethod = _data["isGenericMethod"] !== undefined ? _data["isGenericMethod"] : null as any;
            (this as any).isGenericMethodDefinition = _data["isGenericMethodDefinition"] !== undefined ? _data["isGenericMethodDefinition"] : null as any;
            (this as any).containsGenericParameters = _data["containsGenericParameters"] !== undefined ? _data["containsGenericParameters"] : null as any;
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : null as any;
            (this as any).isSecurityCritical = _data["isSecurityCritical"] !== undefined ? _data["isSecurityCritical"] : null as any;
            (this as any).isSecuritySafeCritical = _data["isSecuritySafeCritical"] !== undefined ? _data["isSecuritySafeCritical"] : null as any;
            (this as any).isSecurityTransparent = _data["isSecurityTransparent"] !== undefined ? _data["isSecurityTransparent"] : null as any;
        }
    }

    static fromJS(data: any): MethodBase {
        data = typeof data === 'object' ? data : {};
        let result = new MethodBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType !== undefined ? this.memberType : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : null as any;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : null as any;
        data["module"] = this.module ? this.module.toJSON() : null as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : null as any);
        }
        data["isCollectible"] = this.isCollectible !== undefined ? this.isCollectible : null as any;
        data["metadataToken"] = this.metadataToken !== undefined ? this.metadataToken : null as any;
        data["attributes"] = this.attributes !== undefined ? this.attributes : null as any;
        data["methodImplementationFlags"] = this.methodImplementationFlags !== undefined ? this.methodImplementationFlags : null as any;
        data["callingConvention"] = this.callingConvention !== undefined ? this.callingConvention : null as any;
        data["isAbstract"] = this.isAbstract !== undefined ? this.isAbstract : null as any;
        data["isConstructor"] = this.isConstructor !== undefined ? this.isConstructor : null as any;
        data["isFinal"] = this.isFinal !== undefined ? this.isFinal : null as any;
        data["isHideBySig"] = this.isHideBySig !== undefined ? this.isHideBySig : null as any;
        data["isSpecialName"] = this.isSpecialName !== undefined ? this.isSpecialName : null as any;
        data["isStatic"] = this.isStatic !== undefined ? this.isStatic : null as any;
        data["isVirtual"] = this.isVirtual !== undefined ? this.isVirtual : null as any;
        data["isAssembly"] = this.isAssembly !== undefined ? this.isAssembly : null as any;
        data["isFamily"] = this.isFamily !== undefined ? this.isFamily : null as any;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly !== undefined ? this.isFamilyAndAssembly : null as any;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly !== undefined ? this.isFamilyOrAssembly : null as any;
        data["isPrivate"] = this.isPrivate !== undefined ? this.isPrivate : null as any;
        data["isPublic"] = this.isPublic !== undefined ? this.isPublic : null as any;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod !== undefined ? this.isConstructedGenericMethod : null as any;
        data["isGenericMethod"] = this.isGenericMethod !== undefined ? this.isGenericMethod : null as any;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition !== undefined ? this.isGenericMethodDefinition : null as any;
        data["containsGenericParameters"] = this.containsGenericParameters !== undefined ? this.containsGenericParameters : null as any;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : null as any;
        data["isSecurityCritical"] = this.isSecurityCritical !== undefined ? this.isSecurityCritical : null as any;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical !== undefined ? this.isSecuritySafeCritical : null as any;
        data["isSecurityTransparent"] = this.isSecurityTransparent !== undefined ? this.isSecurityTransparent : null as any;
        return data;
    }
}

/** 0 = Managed 1 = Native 2 = OPTIL 3 = Runtime 4 = Unmanaged 8 = NoInlining 16 = ForwardRef 32 = Synchronized 64 = NoOptimization 128 = PreserveSig 256 = AggressiveInlining 512 = AggressiveOptimization 4096 = InternalCall 65535 = MaxMethodImplVal */
export enum MethodImplAttributes {
    Managed = 0,
    Native = 1,
    OPTIL = 2,
    Runtime = 3,
    Unmanaged = 4,
    NoInlining = 8,
    ForwardRef = 16,
    Synchronized = 32,
    NoOptimization = 64,
    PreserveSig = 128,
    AggressiveInlining = 256,
    AggressiveOptimization = 512,
    InternalCall = 4096,
    MaxMethodImplVal = 65535,
}

export class MethodInfo {
    readonly name!: string | null;
    declaringType!: Type;
    reflectedType!: Type;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | null;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    attributes!: MethodAttributes;
    methodImplementationFlags!: MethodImplAttributes;
    callingConvention!: CallingConventions;
    readonly isAbstract!: boolean;
    readonly isConstructor!: boolean;
    readonly isFinal!: boolean;
    readonly isHideBySig!: boolean;
    readonly isSpecialName!: boolean;
    readonly isStatic!: boolean;
    readonly isVirtual!: boolean;
    readonly isAssembly!: boolean;
    readonly isFamily!: boolean;
    readonly isFamilyAndAssembly!: boolean;
    readonly isFamilyOrAssembly!: boolean;
    readonly isPrivate!: boolean;
    readonly isPublic!: boolean;
    readonly isConstructedGenericMethod!: boolean;
    readonly isGenericMethod!: boolean;
    readonly isGenericMethodDefinition!: boolean;
    readonly containsGenericParameters!: boolean;
    methodHandle!: RuntimeMethodHandle;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    memberType!: MemberTypes;
    returnParameter!: ParameterInfo;
    returnType!: Type;
    returnTypeCustomAttributes!: ICustomAttributeProvider;

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : null as any;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : null as any;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : null as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            else {
                (this as any).customAttributes = null as any;
            }
            (this as any).isCollectible = _data["isCollectible"] !== undefined ? _data["isCollectible"] : null as any;
            (this as any).metadataToken = _data["metadataToken"] !== undefined ? _data["metadataToken"] : null as any;
            this.attributes = _data["attributes"] !== undefined ? _data["attributes"] : null as any;
            this.methodImplementationFlags = _data["methodImplementationFlags"] !== undefined ? _data["methodImplementationFlags"] : null as any;
            this.callingConvention = _data["callingConvention"] !== undefined ? _data["callingConvention"] : null as any;
            (this as any).isAbstract = _data["isAbstract"] !== undefined ? _data["isAbstract"] : null as any;
            (this as any).isConstructor = _data["isConstructor"] !== undefined ? _data["isConstructor"] : null as any;
            (this as any).isFinal = _data["isFinal"] !== undefined ? _data["isFinal"] : null as any;
            (this as any).isHideBySig = _data["isHideBySig"] !== undefined ? _data["isHideBySig"] : null as any;
            (this as any).isSpecialName = _data["isSpecialName"] !== undefined ? _data["isSpecialName"] : null as any;
            (this as any).isStatic = _data["isStatic"] !== undefined ? _data["isStatic"] : null as any;
            (this as any).isVirtual = _data["isVirtual"] !== undefined ? _data["isVirtual"] : null as any;
            (this as any).isAssembly = _data["isAssembly"] !== undefined ? _data["isAssembly"] : null as any;
            (this as any).isFamily = _data["isFamily"] !== undefined ? _data["isFamily"] : null as any;
            (this as any).isFamilyAndAssembly = _data["isFamilyAndAssembly"] !== undefined ? _data["isFamilyAndAssembly"] : null as any;
            (this as any).isFamilyOrAssembly = _data["isFamilyOrAssembly"] !== undefined ? _data["isFamilyOrAssembly"] : null as any;
            (this as any).isPrivate = _data["isPrivate"] !== undefined ? _data["isPrivate"] : null as any;
            (this as any).isPublic = _data["isPublic"] !== undefined ? _data["isPublic"] : null as any;
            (this as any).isConstructedGenericMethod = _data["isConstructedGenericMethod"] !== undefined ? _data["isConstructedGenericMethod"] : null as any;
            (this as any).isGenericMethod = _data["isGenericMethod"] !== undefined ? _data["isGenericMethod"] : null as any;
            (this as any).isGenericMethodDefinition = _data["isGenericMethodDefinition"] !== undefined ? _data["isGenericMethodDefinition"] : null as any;
            (this as any).containsGenericParameters = _data["containsGenericParameters"] !== undefined ? _data["containsGenericParameters"] : null as any;
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : null as any;
            (this as any).isSecurityCritical = _data["isSecurityCritical"] !== undefined ? _data["isSecurityCritical"] : null as any;
            (this as any).isSecuritySafeCritical = _data["isSecuritySafeCritical"] !== undefined ? _data["isSecuritySafeCritical"] : null as any;
            (this as any).isSecurityTransparent = _data["isSecurityTransparent"] !== undefined ? _data["isSecurityTransparent"] : null as any;
            this.memberType = _data["memberType"] !== undefined ? _data["memberType"] : null as any;
            this.returnParameter = _data["returnParameter"] ? ParameterInfo.fromJS(_data["returnParameter"]) : null as any;
            this.returnType = _data["returnType"] ? Type.fromJS(_data["returnType"]) : null as any;
            this.returnTypeCustomAttributes = _data["returnTypeCustomAttributes"] ? ICustomAttributeProvider.fromJS(_data["returnTypeCustomAttributes"]) : null as any;
        }
    }

    static fromJS(data: any): MethodInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MethodInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : null as any;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : null as any;
        data["module"] = this.module ? this.module.toJSON() : null as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : null as any);
        }
        data["isCollectible"] = this.isCollectible !== undefined ? this.isCollectible : null as any;
        data["metadataToken"] = this.metadataToken !== undefined ? this.metadataToken : null as any;
        data["attributes"] = this.attributes !== undefined ? this.attributes : null as any;
        data["methodImplementationFlags"] = this.methodImplementationFlags !== undefined ? this.methodImplementationFlags : null as any;
        data["callingConvention"] = this.callingConvention !== undefined ? this.callingConvention : null as any;
        data["isAbstract"] = this.isAbstract !== undefined ? this.isAbstract : null as any;
        data["isConstructor"] = this.isConstructor !== undefined ? this.isConstructor : null as any;
        data["isFinal"] = this.isFinal !== undefined ? this.isFinal : null as any;
        data["isHideBySig"] = this.isHideBySig !== undefined ? this.isHideBySig : null as any;
        data["isSpecialName"] = this.isSpecialName !== undefined ? this.isSpecialName : null as any;
        data["isStatic"] = this.isStatic !== undefined ? this.isStatic : null as any;
        data["isVirtual"] = this.isVirtual !== undefined ? this.isVirtual : null as any;
        data["isAssembly"] = this.isAssembly !== undefined ? this.isAssembly : null as any;
        data["isFamily"] = this.isFamily !== undefined ? this.isFamily : null as any;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly !== undefined ? this.isFamilyAndAssembly : null as any;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly !== undefined ? this.isFamilyOrAssembly : null as any;
        data["isPrivate"] = this.isPrivate !== undefined ? this.isPrivate : null as any;
        data["isPublic"] = this.isPublic !== undefined ? this.isPublic : null as any;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod !== undefined ? this.isConstructedGenericMethod : null as any;
        data["isGenericMethod"] = this.isGenericMethod !== undefined ? this.isGenericMethod : null as any;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition !== undefined ? this.isGenericMethodDefinition : null as any;
        data["containsGenericParameters"] = this.containsGenericParameters !== undefined ? this.containsGenericParameters : null as any;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : null as any;
        data["isSecurityCritical"] = this.isSecurityCritical !== undefined ? this.isSecurityCritical : null as any;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical !== undefined ? this.isSecuritySafeCritical : null as any;
        data["isSecurityTransparent"] = this.isSecurityTransparent !== undefined ? this.isSecurityTransparent : null as any;
        data["memberType"] = this.memberType !== undefined ? this.memberType : null as any;
        data["returnParameter"] = this.returnParameter ? this.returnParameter.toJSON() : null as any;
        data["returnType"] = this.returnType ? this.returnType.toJSON() : null as any;
        data["returnTypeCustomAttributes"] = this.returnTypeCustomAttributes ? this.returnTypeCustomAttributes.toJSON() : null as any;
        return data;
    }
}

export class ModelQuoteResult {
    /** 派生选型直接下单 */
    isOrderDirectly!: boolean;
    message!: string | null;

    init(_data?: any) {
        if (_data) {
            this.isOrderDirectly = _data["isOrderDirectly"] !== undefined ? _data["isOrderDirectly"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): ModelQuoteResult {
        data = typeof data === 'object' ? data : {};
        let result = new ModelQuoteResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOrderDirectly"] = this.isOrderDirectly !== undefined ? this.isOrderDirectly : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }
}

export class Module {
    assembly!: Assembly;
    readonly fullyQualifiedName!: string | null;
    readonly name!: string | null;
    readonly mdStreamVersion!: number;
    readonly moduleVersionId!: string;
    readonly scopeName!: string | null;
    moduleHandle!: ModuleHandle;
    readonly customAttributes!: CustomAttributeData[] | null;
    readonly metadataToken!: number;

    init(_data?: any) {
        if (_data) {
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : null as any;
            (this as any).fullyQualifiedName = _data["fullyQualifiedName"] !== undefined ? _data["fullyQualifiedName"] : null as any;
            (this as any).name = _data["name"] !== undefined ? _data["name"] : null as any;
            (this as any).mdStreamVersion = _data["mdStreamVersion"] !== undefined ? _data["mdStreamVersion"] : null as any;
            (this as any).moduleVersionId = _data["moduleVersionId"] !== undefined ? _data["moduleVersionId"] : null as any;
            (this as any).scopeName = _data["scopeName"] !== undefined ? _data["scopeName"] : null as any;
            this.moduleHandle = _data["moduleHandle"] ? ModuleHandle.fromJS(_data["moduleHandle"]) : null as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            else {
                (this as any).customAttributes = null as any;
            }
            (this as any).metadataToken = _data["metadataToken"] !== undefined ? _data["metadataToken"] : null as any;
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assembly"] = this.assembly ? this.assembly.toJSON() : null as any;
        data["fullyQualifiedName"] = this.fullyQualifiedName !== undefined ? this.fullyQualifiedName : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["mdStreamVersion"] = this.mdStreamVersion !== undefined ? this.mdStreamVersion : null as any;
        data["moduleVersionId"] = this.moduleVersionId !== undefined ? this.moduleVersionId : null as any;
        data["scopeName"] = this.scopeName !== undefined ? this.scopeName : null as any;
        data["moduleHandle"] = this.moduleHandle ? this.moduleHandle.toJSON() : null as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : null as any);
        }
        data["metadataToken"] = this.metadataToken !== undefined ? this.metadataToken : null as any;
        return data;
    }
}

export class ModuleHandle {
    readonly mdStreamVersion!: number;

    init(_data?: any) {
        if (_data) {
            (this as any).mdStreamVersion = _data["mdStreamVersion"] !== undefined ? _data["mdStreamVersion"] : null as any;
        }
    }

    static fromJS(data: any): ModuleHandle {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mdStreamVersion"] = this.mdStreamVersion !== undefined ? this.mdStreamVersion : null as any;
        return data;
    }
}

export class MotorCycleEditDto {
    id!: string;
    product!: string | null;
    /** 工程周期（自然天） */
    engineeringCycle!: number | null;
    engineeringCalculationMode!: EngineeringCalculationMode;
    /** 采购周期（自然天） */
    purchaseCycle!: number | null;
    purchaseCycleMode!: PurchaseCycleMode;
    /** 生产周期（自然天） */
    productionCycle!: number | null;
    /** 产能周期（自然天） */
    capacityCycle!: number | null;
    /** GR增量 */
    grCycle!: number | null;
    /** 测试周期（自然天） */
    testCycle!: number | null;
    /** 入库到出库时间 */
    inToOutCycle!: number | null;
    /** 自制OR外购 */
    makeOrBuy!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.product = _data["product"] !== undefined ? _data["product"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.capacityCycle = _data["capacityCycle"] !== undefined ? _data["capacityCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.inToOutCycle = _data["inToOutCycle"] !== undefined ? _data["inToOutCycle"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
        }
    }

    static fromJS(data: any): MotorCycleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorCycleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["product"] = this.product !== undefined ? this.product : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["capacityCycle"] = this.capacityCycle !== undefined ? this.capacityCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["inToOutCycle"] = this.inToOutCycle !== undefined ? this.inToOutCycle : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        return data;
    }
}

/** Motorizer检查更新 */
export class MotorizerRuleJobArgs {
    /** 任务名称 */
    jobName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.jobName = _data["jobName"] !== undefined ? _data["jobName"] : null as any;
        }
    }

    static fromJS(data: any): MotorizerRuleJobArgs {
        data = typeof data === 'object' ? data : {};
        let result = new MotorizerRuleJobArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobName"] = this.jobName !== undefined ? this.jobName : null as any;
        return data;
    }
}

/** 1 = 系数折扣 2 = 总价折扣 */
export enum MultipilerType {
    系数折扣 = 1,
    总价折扣 = 2,
}

export class NewGetInventoryOutPutDto {
    id!: string;
    creatorUserId!: number | null;
    userFriendlyID!: string | null;
    name!: string | null;
    clientID!: string | null;
    clientName!: string | null;
    shippingAddressCode!: string | null;
    shippingAddress!: string | null;
    sourceId!: string | null;
    expectedDeliveryDate!: number;
    status!: LectoTypeStatus;
    sourceType!: SourceType;
    responsibleSalesCode!: string | null;
    responsibleSalesName!: string | null;
    responsibleSalesEamil!: string | null;
    specialOfferApplicationNumber!: string | null;
    precalIDSoucre!: string | null;
    redirectPreCalUrl!: string | null;
    tq!: GetTechnologyQuotationDto;
    products!: SMProduct[] | null;
    records!: SMRecord[] | null;
    readonly standardProducts!: SMProduct[] | null;
    isHelp!: boolean;
    helpCompleted!: boolean;
    pmsProjectCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.userFriendlyID = _data["userFriendlyID"] !== undefined ? _data["userFriendlyID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.clientID = _data["clientID"] !== undefined ? _data["clientID"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.shippingAddressCode = _data["shippingAddressCode"] !== undefined ? _data["shippingAddressCode"] : null as any;
            this.shippingAddress = _data["shippingAddress"] !== undefined ? _data["shippingAddress"] : null as any;
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.sourceType = _data["sourceType"] !== undefined ? _data["sourceType"] : null as any;
            this.responsibleSalesCode = _data["responsibleSalesCode"] !== undefined ? _data["responsibleSalesCode"] : null as any;
            this.responsibleSalesName = _data["responsibleSalesName"] !== undefined ? _data["responsibleSalesName"] : null as any;
            this.responsibleSalesEamil = _data["responsibleSalesEamil"] !== undefined ? _data["responsibleSalesEamil"] : null as any;
            this.specialOfferApplicationNumber = _data["specialOfferApplicationNumber"] !== undefined ? _data["specialOfferApplicationNumber"] : null as any;
            this.precalIDSoucre = _data["precalIDSoucre"] !== undefined ? _data["precalIDSoucre"] : null as any;
            this.redirectPreCalUrl = _data["redirectPreCalUrl"] !== undefined ? _data["redirectPreCalUrl"] : null as any;
            this.tq = _data["tq"] ? GetTechnologyQuotationDto.fromJS(_data["tq"]) : null as any;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(SMProduct.fromJS(item));
            }
            else {
                this.products = null as any;
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(SMRecord.fromJS(item));
            }
            else {
                this.records = null as any;
            }
            if (Array.isArray(_data["standardProducts"])) {
                (this as any).standardProducts = [] as any;
                for (let item of _data["standardProducts"])
                    (this as any).standardProducts!.push(SMProduct.fromJS(item));
            }
            else {
                (this as any).standardProducts = null as any;
            }
            this.isHelp = _data["isHelp"] !== undefined ? _data["isHelp"] : null as any;
            this.helpCompleted = _data["helpCompleted"] !== undefined ? _data["helpCompleted"] : null as any;
            this.pmsProjectCode = _data["pmsProjectCode"] !== undefined ? _data["pmsProjectCode"] : null as any;
        }
    }

    static fromJS(data: any): NewGetInventoryOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewGetInventoryOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["userFriendlyID"] = this.userFriendlyID !== undefined ? this.userFriendlyID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["clientID"] = this.clientID !== undefined ? this.clientID : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["shippingAddressCode"] = this.shippingAddressCode !== undefined ? this.shippingAddressCode : null as any;
        data["shippingAddress"] = this.shippingAddress !== undefined ? this.shippingAddress : null as any;
        data["sourceId"] = this.sourceId !== undefined ? this.sourceId : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["sourceType"] = this.sourceType !== undefined ? this.sourceType : null as any;
        data["responsibleSalesCode"] = this.responsibleSalesCode !== undefined ? this.responsibleSalesCode : null as any;
        data["responsibleSalesName"] = this.responsibleSalesName !== undefined ? this.responsibleSalesName : null as any;
        data["responsibleSalesEamil"] = this.responsibleSalesEamil !== undefined ? this.responsibleSalesEamil : null as any;
        data["specialOfferApplicationNumber"] = this.specialOfferApplicationNumber !== undefined ? this.specialOfferApplicationNumber : null as any;
        data["precalIDSoucre"] = this.precalIDSoucre !== undefined ? this.precalIDSoucre : null as any;
        data["redirectPreCalUrl"] = this.redirectPreCalUrl !== undefined ? this.redirectPreCalUrl : null as any;
        data["tq"] = this.tq ? this.tq.toJSON() : null as any;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.standardProducts)) {
            data["standardProducts"] = [];
            for (let item of this.standardProducts)
                data["standardProducts"].push(item ? item.toJSON() : null as any);
        }
        data["isHelp"] = this.isHelp !== undefined ? this.isHelp : null as any;
        data["helpCompleted"] = this.helpCompleted !== undefined ? this.helpCompleted : null as any;
        data["pmsProjectCode"] = this.pmsProjectCode !== undefined ? this.pmsProjectCode : null as any;
        return data;
    }
}

export class NumberWiresCheckRulesDto {
    id!: string;
    productType!: string | null;
    seatNoMax!: number;
    seatNoMin!: number;
    maxNumberWires!: number;
    compulsoryType!: number;
    promptContent!: string | null;
    remarks!: string | null;
    creationTime!: moment.Moment;
    lastModificationTime!: moment.Moment | null;
    isDeleted!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.productType = _data["productType"] !== undefined ? _data["productType"] : null as any;
            this.seatNoMax = _data["seatNoMax"] !== undefined ? _data["seatNoMax"] : null as any;
            this.seatNoMin = _data["seatNoMin"] !== undefined ? _data["seatNoMin"] : null as any;
            this.maxNumberWires = _data["maxNumberWires"] !== undefined ? _data["maxNumberWires"] : null as any;
            this.compulsoryType = _data["compulsoryType"] !== undefined ? _data["compulsoryType"] : null as any;
            this.promptContent = _data["promptContent"] !== undefined ? _data["promptContent"] : null as any;
            this.remarks = _data["remarks"] !== undefined ? _data["remarks"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
        }
    }

    static fromJS(data: any): NumberWiresCheckRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new NumberWiresCheckRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["productType"] = this.productType !== undefined ? this.productType : null as any;
        data["seatNoMax"] = this.seatNoMax !== undefined ? this.seatNoMax : null as any;
        data["seatNoMin"] = this.seatNoMin !== undefined ? this.seatNoMin : null as any;
        data["maxNumberWires"] = this.maxNumberWires !== undefined ? this.maxNumberWires : null as any;
        data["compulsoryType"] = this.compulsoryType !== undefined ? this.compulsoryType : null as any;
        data["promptContent"] = this.promptContent !== undefined ? this.promptContent : null as any;
        data["remarks"] = this.remarks !== undefined ? this.remarks : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        return data;
    }
}

export class NumberWiresCheckRulesDtoPagedResultDto {
    items!: NumberWiresCheckRulesDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NumberWiresCheckRulesDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): NumberWiresCheckRulesDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NumberWiresCheckRulesDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class OCTOpenVCRuleDto {
    vcID!: string | null;
    basicMotorSries!: string | null;
    frameNo!: number;
    vcShowType!: VCShowType;
    attributeSelect!: string | null;
    attributeName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.attributeSelect = _data["attributeSelect"] !== undefined ? _data["attributeSelect"] : null as any;
            this.attributeName = _data["attributeName"] !== undefined ? _data["attributeName"] : null as any;
        }
    }

    static fromJS(data: any): OCTOpenVCRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new OCTOpenVCRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["attributeSelect"] = this.attributeSelect !== undefined ? this.attributeSelect : null as any;
        data["attributeName"] = this.attributeName !== undefined ? this.attributeName : null as any;
        return data;
    }
}

/** OpenVc简略检查 */
export class OpenVcCheckBriefProductDto {
    id!: string;
    /** 产品系列 */
    basicMotorSries!: string | null;
    basicMotorCode!: string | null;
    /** 机座号 */
    frameSize!: number;
    /** 境界标识符 */
    jinCategoryCode!: string | null;
    /** 境界版本 */
    jinVersion!: string | null;
    jinBasicMotorCode!: string | null;
    /** 境界产品系列 */
    jinBasicMotorSries!: string | null;
    /** 标记是否已经重新补充完境界代码 */
    isSupply!: boolean | null;
    /** 错误信息 */
    error!: string[] | null;
    /** 提示信息 */
    warn!: string[] | null;
    /** Vc配置 */
    vcs!: OpenVcCheckBriefVcDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.jinBasicMotorCode = _data["jinBasicMotorCode"] !== undefined ? _data["jinBasicMotorCode"] : null as any;
            this.jinBasicMotorSries = _data["jinBasicMotorSries"] !== undefined ? _data["jinBasicMotorSries"] : null as any;
            this.isSupply = _data["isSupply"] !== undefined ? _data["isSupply"] : null as any;
            if (Array.isArray(_data["error"])) {
                this.error = [] as any;
                for (let item of _data["error"])
                    this.error!.push(item);
            }
            else {
                this.error = null as any;
            }
            if (Array.isArray(_data["warn"])) {
                this.warn = [] as any;
                for (let item of _data["warn"])
                    this.warn!.push(item);
            }
            else {
                this.warn = null as any;
            }
            if (Array.isArray(_data["vcs"])) {
                this.vcs = [] as any;
                for (let item of _data["vcs"])
                    this.vcs!.push(OpenVcCheckBriefVcDto.fromJS(item));
            }
            else {
                this.vcs = null as any;
            }
        }
    }

    static fromJS(data: any): OpenVcCheckBriefProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpenVcCheckBriefProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["jinBasicMotorCode"] = this.jinBasicMotorCode !== undefined ? this.jinBasicMotorCode : null as any;
        data["jinBasicMotorSries"] = this.jinBasicMotorSries !== undefined ? this.jinBasicMotorSries : null as any;
        data["isSupply"] = this.isSupply !== undefined ? this.isSupply : null as any;
        if (Array.isArray(this.error)) {
            data["error"] = [];
            for (let item of this.error)
                data["error"].push(item);
        }
        if (Array.isArray(this.warn)) {
            data["warn"] = [];
            for (let item of this.warn)
                data["warn"].push(item);
        }
        if (Array.isArray(this.vcs)) {
            data["vcs"] = [];
            for (let item of this.vcs)
                data["vcs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class OpenVcCheckBriefProductDtoListBooleanStringListValueTuple {

    init(_data?: any) {
    }

    static fromJS(data: any): OpenVcCheckBriefProductDtoListBooleanStringListValueTuple {
        data = typeof data === 'object' ? data : {};
        let result = new OpenVcCheckBriefProductDtoListBooleanStringListValueTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** OpenVc简略检查 */
export class OpenVcCheckBriefVcDto {
    id!: string;
    /** VC 短码， 包括999小代码 */
    vcCode!: string | null;
    vcShowType!: VCShowType;
    /** VC开放式内容(OpenVC 备注) */
    remark!: string | null;
    selectOrInput!: SelectOrInput;
    /** 是否内置 */
    isInside!: boolean | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.selectOrInput = _data["selectOrInput"] ? SelectOrInput.fromJS(_data["selectOrInput"]) : null as any;
            this.isInside = _data["isInside"] !== undefined ? _data["isInside"] : null as any;
        }
    }

    static fromJS(data: any): OpenVcCheckBriefVcDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpenVcCheckBriefVcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["selectOrInput"] = this.selectOrInput ? this.selectOrInput.toJSON() : null as any;
        data["isInside"] = this.isInside !== undefined ? this.isInside : null as any;
        return data;
    }
}

/** 订单变更选型 */
export class OrderChangLectoTypeDto {
    /** 订单编号 */
    orderFormId!: string;
    /** 订单变更编号，Order Change在审批流时会发起多个变更申请，在审批中的订单允许发起二次变更，但是在选型中同一时间只允许存在一个变更 */
    orderFormChangeId!: string;
    /** 选型号 */
    userFriendlyID!: string | null;
    /** 订单合同号 */
    poNumber!: string | null;
    products!: OrderChangLectoTypeProductDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.orderFormId = _data["orderFormId"] !== undefined ? _data["orderFormId"] : null as any;
            this.orderFormChangeId = _data["orderFormChangeId"] !== undefined ? _data["orderFormChangeId"] : null as any;
            this.userFriendlyID = _data["userFriendlyID"] !== undefined ? _data["userFriendlyID"] : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(OrderChangLectoTypeProductDto.fromJS(item));
            }
            else {
                this.products = null as any;
            }
        }
    }

    static fromJS(data: any): OrderChangLectoTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangLectoTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderFormId"] = this.orderFormId !== undefined ? this.orderFormId : null as any;
        data["orderFormChangeId"] = this.orderFormChangeId !== undefined ? this.orderFormChangeId : null as any;
        data["userFriendlyID"] = this.userFriendlyID !== undefined ? this.userFriendlyID : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 订单变更选型产品 */
export class OrderChangLectoTypeProductDto {
    /** 单价 */
    unitPrice!: number | null;
    /** 可打折面价 */
    discountUnitPrice!: number | null;
    /** 按台收不打折 */
    noDiscountByPlatformUnitPrice!: number | null;
    /** 按单收不打折 */
    noDiscountByListUnitPrice!: number | null;
    /** 原选型对应的选型产品编号 */
    lectoTypeProductId!: string;
    /** 订单对应的产品编号 */
    orderProductId!: string;
    /** 是否允许编辑 */
    allowEditing!: boolean;
    /** 序号 */
    serialNo!: number;
    /** 技术协议号 */
    technicalSpecification!: string | null;
    /** GSS技术确认号 */
    gssTechnicalConfirmationNumber!: string | null;
    /** 来源报价产品id */
    technologyQuotationProductId!: string | null;
    /** 来源协议产品id (协议是针对产品行的且对所有客户有效，因此在业务上不需要考虑客户变更的场景) */
    technicalSpecificationProductId!: string | null;
    /** 产品数量 */
    numberOfProduct!: number;
    vcs!: OrderChangLectoTypeProductVcDto[] | null;
    /** 内含vc备注 */
    insideVCOpenRemarks!: string | null;

    init(_data?: any) {
        if (_data) {
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.discountUnitPrice = _data["discountUnitPrice"] !== undefined ? _data["discountUnitPrice"] : null as any;
            this.noDiscountByPlatformUnitPrice = _data["noDiscountByPlatformUnitPrice"] !== undefined ? _data["noDiscountByPlatformUnitPrice"] : null as any;
            this.noDiscountByListUnitPrice = _data["noDiscountByListUnitPrice"] !== undefined ? _data["noDiscountByListUnitPrice"] : null as any;
            this.lectoTypeProductId = _data["lectoTypeProductId"] !== undefined ? _data["lectoTypeProductId"] : null as any;
            this.orderProductId = _data["orderProductId"] !== undefined ? _data["orderProductId"] : null as any;
            this.allowEditing = _data["allowEditing"] !== undefined ? _data["allowEditing"] : null as any;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : null as any;
            this.technicalSpecification = _data["technicalSpecification"] !== undefined ? _data["technicalSpecification"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
            this.technicalSpecificationProductId = _data["technicalSpecificationProductId"] !== undefined ? _data["technicalSpecificationProductId"] : null as any;
            this.numberOfProduct = _data["numberOfProduct"] !== undefined ? _data["numberOfProduct"] : null as any;
            if (Array.isArray(_data["vcs"])) {
                this.vcs = [] as any;
                for (let item of _data["vcs"])
                    this.vcs!.push(OrderChangLectoTypeProductVcDto.fromJS(item));
            }
            else {
                this.vcs = null as any;
            }
            this.insideVCOpenRemarks = _data["insideVCOpenRemarks"] !== undefined ? _data["insideVCOpenRemarks"] : null as any;
        }
    }

    static fromJS(data: any): OrderChangLectoTypeProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangLectoTypeProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["discountUnitPrice"] = this.discountUnitPrice !== undefined ? this.discountUnitPrice : null as any;
        data["noDiscountByPlatformUnitPrice"] = this.noDiscountByPlatformUnitPrice !== undefined ? this.noDiscountByPlatformUnitPrice : null as any;
        data["noDiscountByListUnitPrice"] = this.noDiscountByListUnitPrice !== undefined ? this.noDiscountByListUnitPrice : null as any;
        data["lectoTypeProductId"] = this.lectoTypeProductId !== undefined ? this.lectoTypeProductId : null as any;
        data["orderProductId"] = this.orderProductId !== undefined ? this.orderProductId : null as any;
        data["allowEditing"] = this.allowEditing !== undefined ? this.allowEditing : null as any;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : null as any;
        data["technicalSpecification"] = this.technicalSpecification !== undefined ? this.technicalSpecification : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        data["technicalSpecificationProductId"] = this.technicalSpecificationProductId !== undefined ? this.technicalSpecificationProductId : null as any;
        data["numberOfProduct"] = this.numberOfProduct !== undefined ? this.numberOfProduct : null as any;
        if (Array.isArray(this.vcs)) {
            data["vcs"] = [];
            for (let item of this.vcs)
                data["vcs"].push(item ? item.toJSON() : null as any);
        }
        data["insideVCOpenRemarks"] = this.insideVCOpenRemarks !== undefined ? this.insideVCOpenRemarks : null as any;
        return data;
    }
}

/** 订单变更选型产品VC */
export class OrderChangLectoTypeProductVcDto {
    /** VC编号 */
    vcCode!: string | null;
    vcShowType!: VCShowType;
    /** VC备注/开放式内容 */
    remark!: string | null;
    /** 来源报价产品VC id */
    technologyQuotationProductVCId!: string | null;
    /** 来源协议产品VC id */
    technicalSpecificationProductVCId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.technologyQuotationProductVCId = _data["technologyQuotationProductVCId"] !== undefined ? _data["technologyQuotationProductVCId"] : null as any;
            this.technicalSpecificationProductVCId = _data["technicalSpecificationProductVCId"] !== undefined ? _data["technicalSpecificationProductVCId"] : null as any;
        }
    }

    static fromJS(data: any): OrderChangLectoTypeProductVcDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangLectoTypeProductVcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["technologyQuotationProductVCId"] = this.technologyQuotationProductVCId !== undefined ? this.technologyQuotationProductVCId : null as any;
        data["technicalSpecificationProductVCId"] = this.technicalSpecificationProductVCId !== undefined ? this.technicalSpecificationProductVCId : null as any;
        return data;
    }
}

/** 选型变更返回信息 */
export class OrderChangeLectoTypeOutputDto {
    id!: string;
    /** 选型号 */
    userFriendlyID!: string | null;
    /** 选型名 */
    name!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.userFriendlyID = _data["userFriendlyID"] !== undefined ? _data["userFriendlyID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): OrderChangeLectoTypeOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangeLectoTypeOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["userFriendlyID"] = this.userFriendlyID !== undefined ? this.userFriendlyID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export class PageAllKindVCInfoOutDto {
    /** VC ID */
    vcID!: string | null;
    /** 品类 */
    categoryId!: string;
    /** 品类 */
    category!: string | null;
    /** VC含义 */
    meaning!: string | null;
    /** 英文含义 */
    englishMeaning!: string | null;
    /** VC备注 */
    vcTypeDescription!: string | null;
    vcType!: VcType;
    readonly vcTypeName!: string | null;
    /** VC头数 */
    numberWires!: number;

    init(_data?: any) {
        if (_data) {
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            (this as any).vcTypeName = _data["vcTypeName"] !== undefined ? _data["vcTypeName"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
        }
    }

    static fromJS(data: any): PageAllKindVCInfoOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageAllKindVCInfoOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcTypeName"] = this.vcTypeName !== undefined ? this.vcTypeName : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        return data;
    }
}

export class PageAllKindVCInfoOutDtoPagedResultDto {
    items!: PageAllKindVCInfoOutDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageAllKindVCInfoOutDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PageAllKindVCInfoOutDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageAllKindVCInfoOutDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class PageBasicMotorInfoOutputDto {
    id!: string;
    basicMotorCode!: string | null;
    cpBasicMotorCode!: string | null;
    basicMotorModel!: string | null;
    eneEff!: string | null;
    voltage!: string | null;
    wiringMode!: string | null;
    isHaveVc!: IsHaveVc;
    readonly isHaveVcName!: string | null;
    isNeedHeightOutput!: IsYes;
    readonly isNeedHeightOutputName!: string | null;
    frequency!: string | null;
    power!: string | null;
    basicMotorMounting!: string | null;
    poleNo!: string | null;
    frameNo!: number;
    encoder!: string | null;
    basicMotorSries!: string | null;
    unitPrice!: number;
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    productionCycle!: number;
    testCycle!: number;
    capacityCycle!: number;
    basicMotorParameters!: BasicMotorParameterOutputDto[] | null;
    grCycle!: number;
    makeOrBuy!: string | null;
    voltageCode!: string | null;
    brake!: string | null;
    rowKey!: string | null;
    cpCode!: string | null;
    cpName!: string | null;
    customerRemark!: string | null;
    customerMaterialNumber!: string | null;
    technicalSpecifications!: string | null;
    inToOutCycle!: number;
    jinBasicMotorCode!: string | null;
    jinBasicMotorModel!: string | null;
    jinBasicMotorMounting!: string | null;
    jinBasicMotorSries!: string | null;
    jinFrameSize!: number;
    jinPower!: string | null;
    jinCodeVC!: SMVC[] | null;
    status!: number;
    confirmStatus!: number;
    insulation!: string | null;
    safty!: string | null;
    basicMotorTypeName!: string | null;
    jinCategoryCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.cpBasicMotorCode = _data["cpBasicMotorCode"] !== undefined ? _data["cpBasicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
            this.isHaveVc = _data["isHaveVc"] !== undefined ? _data["isHaveVc"] : null as any;
            (this as any).isHaveVcName = _data["isHaveVcName"] !== undefined ? _data["isHaveVcName"] : null as any;
            this.isNeedHeightOutput = _data["isNeedHeightOutput"] !== undefined ? _data["isNeedHeightOutput"] : null as any;
            (this as any).isNeedHeightOutputName = _data["isNeedHeightOutputName"] !== undefined ? _data["isNeedHeightOutputName"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.encoder = _data["encoder"] !== undefined ? _data["encoder"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.capacityCycle = _data["capacityCycle"] !== undefined ? _data["capacityCycle"] : null as any;
            if (Array.isArray(_data["basicMotorParameters"])) {
                this.basicMotorParameters = [] as any;
                for (let item of _data["basicMotorParameters"])
                    this.basicMotorParameters!.push(BasicMotorParameterOutputDto.fromJS(item));
            }
            else {
                this.basicMotorParameters = null as any;
            }
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.voltageCode = _data["voltageCode"] !== undefined ? _data["voltageCode"] : null as any;
            this.brake = _data["brake"] !== undefined ? _data["brake"] : null as any;
            this.rowKey = _data["rowKey"] !== undefined ? _data["rowKey"] : null as any;
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.cpName = _data["cpName"] !== undefined ? _data["cpName"] : null as any;
            this.customerRemark = _data["customerRemark"] !== undefined ? _data["customerRemark"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.inToOutCycle = _data["inToOutCycle"] !== undefined ? _data["inToOutCycle"] : null as any;
            this.jinBasicMotorCode = _data["jinBasicMotorCode"] !== undefined ? _data["jinBasicMotorCode"] : null as any;
            this.jinBasicMotorModel = _data["jinBasicMotorModel"] !== undefined ? _data["jinBasicMotorModel"] : null as any;
            this.jinBasicMotorMounting = _data["jinBasicMotorMounting"] !== undefined ? _data["jinBasicMotorMounting"] : null as any;
            this.jinBasicMotorSries = _data["jinBasicMotorSries"] !== undefined ? _data["jinBasicMotorSries"] : null as any;
            this.jinFrameSize = _data["jinFrameSize"] !== undefined ? _data["jinFrameSize"] : null as any;
            this.jinPower = _data["jinPower"] !== undefined ? _data["jinPower"] : null as any;
            if (Array.isArray(_data["jinCodeVC"])) {
                this.jinCodeVC = [] as any;
                for (let item of _data["jinCodeVC"])
                    this.jinCodeVC!.push(SMVC.fromJS(item));
            }
            else {
                this.jinCodeVC = null as any;
            }
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.confirmStatus = _data["confirmStatus"] !== undefined ? _data["confirmStatus"] : null as any;
            this.insulation = _data["insulation"] !== undefined ? _data["insulation"] : null as any;
            this.safty = _data["safty"] !== undefined ? _data["safty"] : null as any;
            this.basicMotorTypeName = _data["basicMotorTypeName"] !== undefined ? _data["basicMotorTypeName"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
        }
    }

    static fromJS(data: any): PageBasicMotorInfoOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageBasicMotorInfoOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["cpBasicMotorCode"] = this.cpBasicMotorCode !== undefined ? this.cpBasicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        data["isHaveVc"] = this.isHaveVc !== undefined ? this.isHaveVc : null as any;
        data["isHaveVcName"] = this.isHaveVcName !== undefined ? this.isHaveVcName : null as any;
        data["isNeedHeightOutput"] = this.isNeedHeightOutput !== undefined ? this.isNeedHeightOutput : null as any;
        data["isNeedHeightOutputName"] = this.isNeedHeightOutputName !== undefined ? this.isNeedHeightOutputName : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["encoder"] = this.encoder !== undefined ? this.encoder : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["capacityCycle"] = this.capacityCycle !== undefined ? this.capacityCycle : null as any;
        if (Array.isArray(this.basicMotorParameters)) {
            data["basicMotorParameters"] = [];
            for (let item of this.basicMotorParameters)
                data["basicMotorParameters"].push(item ? item.toJSON() : null as any);
        }
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["voltageCode"] = this.voltageCode !== undefined ? this.voltageCode : null as any;
        data["brake"] = this.brake !== undefined ? this.brake : null as any;
        data["rowKey"] = this.rowKey !== undefined ? this.rowKey : null as any;
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["cpName"] = this.cpName !== undefined ? this.cpName : null as any;
        data["customerRemark"] = this.customerRemark !== undefined ? this.customerRemark : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["inToOutCycle"] = this.inToOutCycle !== undefined ? this.inToOutCycle : null as any;
        data["jinBasicMotorCode"] = this.jinBasicMotorCode !== undefined ? this.jinBasicMotorCode : null as any;
        data["jinBasicMotorModel"] = this.jinBasicMotorModel !== undefined ? this.jinBasicMotorModel : null as any;
        data["jinBasicMotorMounting"] = this.jinBasicMotorMounting !== undefined ? this.jinBasicMotorMounting : null as any;
        data["jinBasicMotorSries"] = this.jinBasicMotorSries !== undefined ? this.jinBasicMotorSries : null as any;
        data["jinFrameSize"] = this.jinFrameSize !== undefined ? this.jinFrameSize : null as any;
        data["jinPower"] = this.jinPower !== undefined ? this.jinPower : null as any;
        if (Array.isArray(this.jinCodeVC)) {
            data["jinCodeVC"] = [];
            for (let item of this.jinCodeVC)
                data["jinCodeVC"].push(item ? item.toJSON() : null as any);
        }
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["confirmStatus"] = this.confirmStatus !== undefined ? this.confirmStatus : null as any;
        data["insulation"] = this.insulation !== undefined ? this.insulation : null as any;
        data["safty"] = this.safty !== undefined ? this.safty : null as any;
        data["basicMotorTypeName"] = this.basicMotorTypeName !== undefined ? this.basicMotorTypeName : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        return data;
    }
}

export class PageBasicMotorInfoOutputDtoPagedResultDto {
    items!: PageBasicMotorInfoOutputDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageBasicMotorInfoOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PageBasicMotorInfoOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageBasicMotorInfoOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class PageBasicMotorInfosInputDto {
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | null;
    voltage!: string;
    frequency!: string;
    power!: string;
    basicMotorMounting!: string;
    poleNo!: string;
    eneEffs!: string[] | null;
    encoders!: string[] | null;
    brakes!: string[] | null;
    basicMotorSriesIds!: number[] | null;
    frameNos!: number[] | null;
    frameNo!: number | null;
    isHaveVc!: IsHaveVc;
    clienter!: string | null;
    finalCustomerCode!: string | null;
    basicMotorInfoSeachType!: BasicMotorInfoSeachType;
    code!: string | null;
    hasInactive!: boolean;
    isCycleQuery!: boolean;
    cpCode!: string | null;
    basicMotorCodeType!: number | null;
    status!: number | null;
    confirmStatus!: number | null;
    insulation!: string | null;
    safty!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.filter = _data["filter"] !== undefined ? _data["filter"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            if (Array.isArray(_data["eneEffs"])) {
                this.eneEffs = [] as any;
                for (let item of _data["eneEffs"])
                    this.eneEffs!.push(item);
            }
            else {
                this.eneEffs = null as any;
            }
            if (Array.isArray(_data["encoders"])) {
                this.encoders = [] as any;
                for (let item of _data["encoders"])
                    this.encoders!.push(item);
            }
            else {
                this.encoders = null as any;
            }
            if (Array.isArray(_data["brakes"])) {
                this.brakes = [] as any;
                for (let item of _data["brakes"])
                    this.brakes!.push(item);
            }
            else {
                this.brakes = null as any;
            }
            if (Array.isArray(_data["basicMotorSriesIds"])) {
                this.basicMotorSriesIds = [] as any;
                for (let item of _data["basicMotorSriesIds"])
                    this.basicMotorSriesIds!.push(item);
            }
            else {
                this.basicMotorSriesIds = null as any;
            }
            if (Array.isArray(_data["frameNos"])) {
                this.frameNos = [] as any;
                for (let item of _data["frameNos"])
                    this.frameNos!.push(item);
            }
            else {
                this.frameNos = null as any;
            }
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.isHaveVc = _data["isHaveVc"] !== undefined ? _data["isHaveVc"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.basicMotorInfoSeachType = _data["basicMotorInfoSeachType"] !== undefined ? _data["basicMotorInfoSeachType"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.hasInactive = _data["hasInactive"] !== undefined ? _data["hasInactive"] : null as any;
            this.isCycleQuery = _data["isCycleQuery"] !== undefined ? _data["isCycleQuery"] : null as any;
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
            this.basicMotorCodeType = _data["basicMotorCodeType"] !== undefined ? _data["basicMotorCodeType"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.confirmStatus = _data["confirmStatus"] !== undefined ? _data["confirmStatus"] : null as any;
            this.insulation = _data["insulation"] !== undefined ? _data["insulation"] : null as any;
            this.safty = _data["safty"] !== undefined ? _data["safty"] : null as any;
        }
    }

    static fromJS(data: any): PageBasicMotorInfosInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageBasicMotorInfosInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["filter"] = this.filter !== undefined ? this.filter : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        if (Array.isArray(this.eneEffs)) {
            data["eneEffs"] = [];
            for (let item of this.eneEffs)
                data["eneEffs"].push(item);
        }
        if (Array.isArray(this.encoders)) {
            data["encoders"] = [];
            for (let item of this.encoders)
                data["encoders"].push(item);
        }
        if (Array.isArray(this.brakes)) {
            data["brakes"] = [];
            for (let item of this.brakes)
                data["brakes"].push(item);
        }
        if (Array.isArray(this.basicMotorSriesIds)) {
            data["basicMotorSriesIds"] = [];
            for (let item of this.basicMotorSriesIds)
                data["basicMotorSriesIds"].push(item);
        }
        if (Array.isArray(this.frameNos)) {
            data["frameNos"] = [];
            for (let item of this.frameNos)
                data["frameNos"].push(item);
        }
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["isHaveVc"] = this.isHaveVc !== undefined ? this.isHaveVc : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["basicMotorInfoSeachType"] = this.basicMotorInfoSeachType !== undefined ? this.basicMotorInfoSeachType : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["hasInactive"] = this.hasInactive !== undefined ? this.hasInactive : null as any;
        data["isCycleQuery"] = this.isCycleQuery !== undefined ? this.isCycleQuery : null as any;
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        data["basicMotorCodeType"] = this.basicMotorCodeType !== undefined ? this.basicMotorCodeType : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["confirmStatus"] = this.confirmStatus !== undefined ? this.confirmStatus : null as any;
        data["insulation"] = this.insulation !== undefined ? this.insulation : null as any;
        data["safty"] = this.safty !== undefined ? this.safty : null as any;
        return data;
    }
}

export class PageBasicMotorSriesDetailsOutputDto {
    /** 编号 */
    id!: number;
    /** 主机名称 */
    name!: string | null;
    /** 层级 */
    level!: number;
    /** 父节点编号 */
    parentId!: number;
    /** 是否境界类型 */
    isJINSeries!: boolean;
    /** 系列内包含的主机 */
    basicMotorInfos!: PageBasicMotorInfoOutputDto[] | null;
    /** 系列内包含的VC */
    basicCheckVcRules!: PageCheckVcRulesOutputDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.level = _data["level"] !== undefined ? _data["level"] : null as any;
            this.parentId = _data["parentId"] !== undefined ? _data["parentId"] : null as any;
            this.isJINSeries = _data["isJINSeries"] !== undefined ? _data["isJINSeries"] : null as any;
            if (Array.isArray(_data["basicMotorInfos"])) {
                this.basicMotorInfos = [] as any;
                for (let item of _data["basicMotorInfos"])
                    this.basicMotorInfos!.push(PageBasicMotorInfoOutputDto.fromJS(item));
            }
            else {
                this.basicMotorInfos = null as any;
            }
            if (Array.isArray(_data["basicCheckVcRules"])) {
                this.basicCheckVcRules = [] as any;
                for (let item of _data["basicCheckVcRules"])
                    this.basicCheckVcRules!.push(PageCheckVcRulesOutputDto.fromJS(item));
            }
            else {
                this.basicCheckVcRules = null as any;
            }
        }
    }

    static fromJS(data: any): PageBasicMotorSriesDetailsOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageBasicMotorSriesDetailsOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["level"] = this.level !== undefined ? this.level : null as any;
        data["parentId"] = this.parentId !== undefined ? this.parentId : null as any;
        data["isJINSeries"] = this.isJINSeries !== undefined ? this.isJINSeries : null as any;
        if (Array.isArray(this.basicMotorInfos)) {
            data["basicMotorInfos"] = [];
            for (let item of this.basicMotorInfos)
                data["basicMotorInfos"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.basicCheckVcRules)) {
            data["basicCheckVcRules"] = [];
            for (let item of this.basicCheckVcRules)
                data["basicCheckVcRules"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 主机系列页面输出对象 */
export class PageBasicMotorSriesOutputDto {
    /** 编号 */
    id!: number;
    /** 主机名称 */
    name!: string | null;
    /** 层级 */
    level!: number;
    /** 父节点编号 */
    parentId!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.level = _data["level"] !== undefined ? _data["level"] : null as any;
            this.parentId = _data["parentId"] !== undefined ? _data["parentId"] : null as any;
        }
    }

    static fromJS(data: any): PageBasicMotorSriesOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageBasicMotorSriesOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["level"] = this.level !== undefined ? this.level : null as any;
        data["parentId"] = this.parentId !== undefined ? this.parentId : null as any;
        return data;
    }
}

/** 主机系列查询输入对象 */
export class PageBasicMotorSriesSearchDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 主机系列名称 */
    sriesName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.sriesName = _data["sriesName"] !== undefined ? _data["sriesName"] : null as any;
        }
    }

    static fromJS(data: any): PageBasicMotorSriesSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageBasicMotorSriesSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["sriesName"] = this.sriesName !== undefined ? this.sriesName : null as any;
        return data;
    }
}

export class PageCheckRuleInputDto {
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | null;
    vcId!: string | null;
    basicMotorSriesNames!: string[] | null;
    categoryId!: string | null;
    frameNo!: number | null;
    meaning!: string | null;
    confirmStatus!: number | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.filter = _data["filter"] !== undefined ? _data["filter"] : null as any;
            this.vcId = _data["vcId"] !== undefined ? _data["vcId"] : null as any;
            if (Array.isArray(_data["basicMotorSriesNames"])) {
                this.basicMotorSriesNames = [] as any;
                for (let item of _data["basicMotorSriesNames"])
                    this.basicMotorSriesNames!.push(item);
            }
            else {
                this.basicMotorSriesNames = null as any;
            }
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.confirmStatus = _data["confirmStatus"] !== undefined ? _data["confirmStatus"] : null as any;
        }
    }

    static fromJS(data: any): PageCheckRuleInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageCheckRuleInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["filter"] = this.filter !== undefined ? this.filter : null as any;
        data["vcId"] = this.vcId !== undefined ? this.vcId : null as any;
        if (Array.isArray(this.basicMotorSriesNames)) {
            data["basicMotorSriesNames"] = [];
            for (let item of this.basicMotorSriesNames)
                data["basicMotorSriesNames"].push(item);
        }
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["confirmStatus"] = this.confirmStatus !== undefined ? this.confirmStatus : null as any;
        return data;
    }
}

export class PageCheckVcRulesOutputDto {
    id!: string;
    vcID!: string | null;
    category!: string | null;
    meaning!: string | null;
    englishMeaning!: string | null;
    vcTypeDescription!: string | null;
    vcType!: VcType;
    vcShowType!: VCShowType;
    readonly vcShowTypeName!: string | null;
    vcOpenOrClose!: VcOpenOrClose;
    attributeName!: string | null;
    attributeSelect!: string | null;
    frameNo!: number;
    basicMotorSries!: string | null;
    unitPrice!: number;
    discountType!: UnitPriceType;
    vcProductCode!: string | null;
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    readonly engineeringCalculationModeName!: string | null;
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    readonly purchaseCycleModeName!: string | null;
    productionCycle!: number;
    testCycle!: number;
    shipSurveyCycle!: number;
    grCycle!: number;
    scmCycle!: number | null;
    scmCalculationMode!: string | null;
    scmRemark!: string | null;
    extraOverlayTime!: boolean | null;
    isOverlayLogic!: boolean | null;
    makeOrBuy!: string | null;
    basicMotorCode!: string | null;
    vcLongCode!: string | null;
    mainVC!: string | null;
    confirmStatus!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            (this as any).vcShowTypeName = _data["vcShowTypeName"] !== undefined ? _data["vcShowTypeName"] : null as any;
            this.vcOpenOrClose = _data["vcOpenOrClose"] !== undefined ? _data["vcOpenOrClose"] : null as any;
            this.attributeName = _data["attributeName"] !== undefined ? _data["attributeName"] : null as any;
            this.attributeSelect = _data["attributeSelect"] !== undefined ? _data["attributeSelect"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : null as any;
            this.vcProductCode = _data["vcProductCode"] !== undefined ? _data["vcProductCode"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            (this as any).engineeringCalculationModeName = _data["engineeringCalculationModeName"] !== undefined ? _data["engineeringCalculationModeName"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            (this as any).purchaseCycleModeName = _data["purchaseCycleModeName"] !== undefined ? _data["purchaseCycleModeName"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.scmCycle = _data["scmCycle"] !== undefined ? _data["scmCycle"] : null as any;
            this.scmCalculationMode = _data["scmCalculationMode"] !== undefined ? _data["scmCalculationMode"] : null as any;
            this.scmRemark = _data["scmRemark"] !== undefined ? _data["scmRemark"] : null as any;
            this.extraOverlayTime = _data["extraOverlayTime"] !== undefined ? _data["extraOverlayTime"] : null as any;
            this.isOverlayLogic = _data["isOverlayLogic"] !== undefined ? _data["isOverlayLogic"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.vcLongCode = _data["vcLongCode"] !== undefined ? _data["vcLongCode"] : null as any;
            this.mainVC = _data["mainVC"] !== undefined ? _data["mainVC"] : null as any;
            this.confirmStatus = _data["confirmStatus"] !== undefined ? _data["confirmStatus"] : null as any;
        }
    }

    static fromJS(data: any): PageCheckVcRulesOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageCheckVcRulesOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["vcShowTypeName"] = this.vcShowTypeName !== undefined ? this.vcShowTypeName : null as any;
        data["vcOpenOrClose"] = this.vcOpenOrClose !== undefined ? this.vcOpenOrClose : null as any;
        data["attributeName"] = this.attributeName !== undefined ? this.attributeName : null as any;
        data["attributeSelect"] = this.attributeSelect !== undefined ? this.attributeSelect : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["discountType"] = this.discountType !== undefined ? this.discountType : null as any;
        data["vcProductCode"] = this.vcProductCode !== undefined ? this.vcProductCode : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["engineeringCalculationModeName"] = this.engineeringCalculationModeName !== undefined ? this.engineeringCalculationModeName : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["purchaseCycleModeName"] = this.purchaseCycleModeName !== undefined ? this.purchaseCycleModeName : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["scmCycle"] = this.scmCycle !== undefined ? this.scmCycle : null as any;
        data["scmCalculationMode"] = this.scmCalculationMode !== undefined ? this.scmCalculationMode : null as any;
        data["scmRemark"] = this.scmRemark !== undefined ? this.scmRemark : null as any;
        data["extraOverlayTime"] = this.extraOverlayTime !== undefined ? this.extraOverlayTime : null as any;
        data["isOverlayLogic"] = this.isOverlayLogic !== undefined ? this.isOverlayLogic : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["vcLongCode"] = this.vcLongCode !== undefined ? this.vcLongCode : null as any;
        data["mainVC"] = this.mainVC !== undefined ? this.mainVC : null as any;
        data["confirmStatus"] = this.confirmStatus !== undefined ? this.confirmStatus : null as any;
        return data;
    }
}

export class PageCheckVcRulesOutputDtoPagedResultDto {
    items!: PageCheckVcRulesOutputDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageCheckVcRulesOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PageCheckVcRulesOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageCheckVcRulesOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class PageCustomMotorInfoOutputDto {
    id!: string;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 产品 */
    product!: string | null;
    basicMotorSriesId!: number;
    /** 产品类型 */
    basicMotorSries!: string | null;
    /** 电压参数组合信息 */
    paramterInfo!: string | null;
    /** 能效 */
    eneEff!: string | null;
    /** 机座号 */
    frameNo!: number;
    /** 极数 */
    poleNo!: string | null;
    /** 安装方式 */
    basicMotorMounting!: string | null;
    /** 电压代码 */
    voltageCode!: string | null;
    isHaveVc!: IsHaveVc;
    /** 是否带VC */
    readonly isHaveVcName!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 工程周期（自然天） */
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    /** 工程计算方式名称 */
    readonly engineeringCalculationModeName!: string | null;
    /** 采购周期（自然天） */
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    /** 采购计算方式名称 */
    readonly purchaseCycleModeName!: string | null;
    /** 生产周期（自然天） */
    productionCycle!: number;
    /** 产能周期（自然天） */
    capacityCycle!: number;
    /** GR增量 */
    grCycle!: number;
    /** 测试周期（自然天） */
    testCycle!: number;
    /** 入库到出库时间 */
    inToOutCycle!: number;
    /** 创建人 */
    creatorUserId!: number;
    /** 创建时间 */
    creationTime!: moment.Moment;
    status!: CustomMotorInfoSatus;
    /** 状态名称 */
    readonly statusName!: string | null;
    /** 产能周期更新/确认时间 */
    capacityCycleUpdateTime!: moment.Moment | null;
    /** 工程周期更新/确认时间 */
    engineeringCycleUpdateTime!: moment.Moment | null;
    /** 生产周期更新/确认时间 */
    productionCycleUpdateTime!: moment.Moment | null;
    /** 采购周期更新/确认时间 */
    purchaseCycleUpdateTime!: moment.Moment | null;
    /** 测试周期更新/确认时间 */
    testCycleUpdateTime!: moment.Moment | null;
    /** GR增量更新时间/确认时间 */
    grCycleUpdateTime!: moment.Moment | null;
    /** 入库到出库更新时间/确认时间 */
    inToOutCycleUpdateTime!: moment.Moment | null;
    /** 创建人 */
    creatorUser!: string | null;
    customMotorParameters!: CustomMotorInfoParamDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.product = _data["product"] !== undefined ? _data["product"] : null as any;
            this.basicMotorSriesId = _data["basicMotorSriesId"] !== undefined ? _data["basicMotorSriesId"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.paramterInfo = _data["paramterInfo"] !== undefined ? _data["paramterInfo"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.voltageCode = _data["voltageCode"] !== undefined ? _data["voltageCode"] : null as any;
            this.isHaveVc = _data["isHaveVc"] !== undefined ? _data["isHaveVc"] : null as any;
            (this as any).isHaveVcName = _data["isHaveVcName"] !== undefined ? _data["isHaveVcName"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            (this as any).engineeringCalculationModeName = _data["engineeringCalculationModeName"] !== undefined ? _data["engineeringCalculationModeName"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            (this as any).purchaseCycleModeName = _data["purchaseCycleModeName"] !== undefined ? _data["purchaseCycleModeName"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.capacityCycle = _data["capacityCycle"] !== undefined ? _data["capacityCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.inToOutCycle = _data["inToOutCycle"] !== undefined ? _data["inToOutCycle"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            (this as any).statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            this.capacityCycleUpdateTime = _data["capacityCycleUpdateTime"] ? moment(_data["capacityCycleUpdateTime"].toString()) : null as any;
            this.engineeringCycleUpdateTime = _data["engineeringCycleUpdateTime"] ? moment(_data["engineeringCycleUpdateTime"].toString()) : null as any;
            this.productionCycleUpdateTime = _data["productionCycleUpdateTime"] ? moment(_data["productionCycleUpdateTime"].toString()) : null as any;
            this.purchaseCycleUpdateTime = _data["purchaseCycleUpdateTime"] ? moment(_data["purchaseCycleUpdateTime"].toString()) : null as any;
            this.testCycleUpdateTime = _data["testCycleUpdateTime"] ? moment(_data["testCycleUpdateTime"].toString()) : null as any;
            this.grCycleUpdateTime = _data["grCycleUpdateTime"] ? moment(_data["grCycleUpdateTime"].toString()) : null as any;
            this.inToOutCycleUpdateTime = _data["inToOutCycleUpdateTime"] ? moment(_data["inToOutCycleUpdateTime"].toString()) : null as any;
            this.creatorUser = _data["creatorUser"] !== undefined ? _data["creatorUser"] : null as any;
            if (Array.isArray(_data["customMotorParameters"])) {
                this.customMotorParameters = [] as any;
                for (let item of _data["customMotorParameters"])
                    this.customMotorParameters!.push(CustomMotorInfoParamDto.fromJS(item));
            }
            else {
                this.customMotorParameters = null as any;
            }
        }
    }

    static fromJS(data: any): PageCustomMotorInfoOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageCustomMotorInfoOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["product"] = this.product !== undefined ? this.product : null as any;
        data["basicMotorSriesId"] = this.basicMotorSriesId !== undefined ? this.basicMotorSriesId : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["paramterInfo"] = this.paramterInfo !== undefined ? this.paramterInfo : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["voltageCode"] = this.voltageCode !== undefined ? this.voltageCode : null as any;
        data["isHaveVc"] = this.isHaveVc !== undefined ? this.isHaveVc : null as any;
        data["isHaveVcName"] = this.isHaveVcName !== undefined ? this.isHaveVcName : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["engineeringCalculationModeName"] = this.engineeringCalculationModeName !== undefined ? this.engineeringCalculationModeName : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["purchaseCycleModeName"] = this.purchaseCycleModeName !== undefined ? this.purchaseCycleModeName : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["capacityCycle"] = this.capacityCycle !== undefined ? this.capacityCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["inToOutCycle"] = this.inToOutCycle !== undefined ? this.inToOutCycle : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        data["capacityCycleUpdateTime"] = this.capacityCycleUpdateTime ? this.capacityCycleUpdateTime.toISOString() : null as any;
        data["engineeringCycleUpdateTime"] = this.engineeringCycleUpdateTime ? this.engineeringCycleUpdateTime.toISOString() : null as any;
        data["productionCycleUpdateTime"] = this.productionCycleUpdateTime ? this.productionCycleUpdateTime.toISOString() : null as any;
        data["purchaseCycleUpdateTime"] = this.purchaseCycleUpdateTime ? this.purchaseCycleUpdateTime.toISOString() : null as any;
        data["testCycleUpdateTime"] = this.testCycleUpdateTime ? this.testCycleUpdateTime.toISOString() : null as any;
        data["grCycleUpdateTime"] = this.grCycleUpdateTime ? this.grCycleUpdateTime.toISOString() : null as any;
        data["inToOutCycleUpdateTime"] = this.inToOutCycleUpdateTime ? this.inToOutCycleUpdateTime.toISOString() : null as any;
        data["creatorUser"] = this.creatorUser !== undefined ? this.creatorUser : null as any;
        if (Array.isArray(this.customMotorParameters)) {
            data["customMotorParameters"] = [];
            for (let item of this.customMotorParameters)
                data["customMotorParameters"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class PageCustomMotorInfoOutputDtoPagedResultDto {
    items!: PageCustomMotorInfoOutputDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageCustomMotorInfoOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PageCustomMotorInfoOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageCustomMotorInfoOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 批量获取境界代码列表 */
export class PageListJINCodeDto {
    code!: string | null;
    version!: string | null;

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
        }
    }

    static fromJS(data: any): PageListJINCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageListJINCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        return data;
    }
}

export class PageMotorcycleOutputDto {
    id!: string;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 客户化代码主机编码 */
    cpBasicMotorCode!: string | null;
    /** 产品 */
    product!: string | null;
    basicMotorSriesId!: number | null;
    /** 产品类型 */
    basicMotorSries!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 自制OR外购 */
    makeOrBuy!: string | null;
    /** 电机类型 标准、自定义、客户化代码 */
    motorType!: string | null;
    /** 电压参数组合信息 */
    paramterInfo!: string | null;
    /** 能效 */
    eneEff!: string | null;
    /** 机座号 */
    frameNo!: number;
    /** 极数 */
    poleNo!: string | null;
    /** 安装方式 */
    basicMotorMounting!: string | null;
    /** 电压代码 */
    voltageCode!: string | null;
    isHaveVc!: IsHaveVc;
    /** 是否带VC */
    readonly isHaveVcName!: string | null;
    /** 所属客户名称 */
    cpName!: string | null;
    /** 客户化代码备注 */
    customerRemark!: string | null;
    isNeedHeightOutput!: IsYes;
    readonly isNeedHeightOutputName!: string | null;
    engineeringCalculationMode!: EngineeringCalculationMode;
    /** 工程计算方式名称 */
    readonly engineeringCalculationModeName!: string | null;
    purchaseCycleMode!: PurchaseCycleMode;
    /** 采购计算方式名称 */
    readonly purchaseCycleModeName!: string | null;
    /** 工程周期（自然天） */
    engineeringCycle!: number;
    /** 工程周期（周） */
    engineeringCycleWK!: number;
    /** 采购周期（自然天） */
    purchaseCycle!: number;
    /** 采购周期（周） */
    purchaseCycleWK!: number;
    /** GR增量 */
    grCycle!: number;
    /** GR增量周 */
    grCycleWK!: number;
    /** 生产周期（自然天） */
    productionCycle!: number;
    /** 生产周期（周） */
    productionCycleWK!: number;
    /** 测试周期（自然天） */
    testCycle!: number;
    testCycleWK!: number;
    /** 产能周期（自然天） */
    capacityCycle!: number;
    /** 产能周期（周） */
    capacityCycleWK!: number;
    /** 入库到出库时间 */
    inToOutCycle!: number;
    /** 入库到出库时间 */
    inToOutCycleWK!: number;
    /** 交期ND */
    cycleTotal!: number;
    cycleTotalWK!: number;
    /** 产能周期更新/确认时间 */
    capacityCycleUpdateTime!: moment.Moment | null;
    /** 工程周期更新/确认时间 */
    engineeringCycleUpdateTime!: moment.Moment | null;
    /** 生产周期更新/确认时间 */
    productionCycleUpdateTime!: moment.Moment | null;
    /** 采购周期更新/确认时间 */
    purchaseCycleUpdateTime!: moment.Moment | null;
    /** 测试周期更新/确认时间 */
    testCycleUpdateTime!: moment.Moment | null;
    /** GR增量更新时间/确认时间 */
    grCycleUpdateTime!: moment.Moment | null;
    /** 入库到出库更新时间/确认时间 */
    inToOutCycleUpdateTime!: moment.Moment | null;
    customMotorParameters!: CustomMotorInfoParamDto[] | null;
    cpCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.cpBasicMotorCode = _data["cpBasicMotorCode"] !== undefined ? _data["cpBasicMotorCode"] : null as any;
            this.product = _data["product"] !== undefined ? _data["product"] : null as any;
            this.basicMotorSriesId = _data["basicMotorSriesId"] !== undefined ? _data["basicMotorSriesId"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.motorType = _data["motorType"] !== undefined ? _data["motorType"] : null as any;
            this.paramterInfo = _data["paramterInfo"] !== undefined ? _data["paramterInfo"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.voltageCode = _data["voltageCode"] !== undefined ? _data["voltageCode"] : null as any;
            this.isHaveVc = _data["isHaveVc"] !== undefined ? _data["isHaveVc"] : null as any;
            (this as any).isHaveVcName = _data["isHaveVcName"] !== undefined ? _data["isHaveVcName"] : null as any;
            this.cpName = _data["cpName"] !== undefined ? _data["cpName"] : null as any;
            this.customerRemark = _data["customerRemark"] !== undefined ? _data["customerRemark"] : null as any;
            this.isNeedHeightOutput = _data["isNeedHeightOutput"] !== undefined ? _data["isNeedHeightOutput"] : null as any;
            (this as any).isNeedHeightOutputName = _data["isNeedHeightOutputName"] !== undefined ? _data["isNeedHeightOutputName"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            (this as any).engineeringCalculationModeName = _data["engineeringCalculationModeName"] !== undefined ? _data["engineeringCalculationModeName"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            (this as any).purchaseCycleModeName = _data["purchaseCycleModeName"] !== undefined ? _data["purchaseCycleModeName"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCycleWK = _data["engineeringCycleWK"] !== undefined ? _data["engineeringCycleWK"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleWK = _data["purchaseCycleWK"] !== undefined ? _data["purchaseCycleWK"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.grCycleWK = _data["grCycleWK"] !== undefined ? _data["grCycleWK"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.productionCycleWK = _data["productionCycleWK"] !== undefined ? _data["productionCycleWK"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.testCycleWK = _data["testCycleWK"] !== undefined ? _data["testCycleWK"] : null as any;
            this.capacityCycle = _data["capacityCycle"] !== undefined ? _data["capacityCycle"] : null as any;
            this.capacityCycleWK = _data["capacityCycleWK"] !== undefined ? _data["capacityCycleWK"] : null as any;
            this.inToOutCycle = _data["inToOutCycle"] !== undefined ? _data["inToOutCycle"] : null as any;
            this.inToOutCycleWK = _data["inToOutCycleWK"] !== undefined ? _data["inToOutCycleWK"] : null as any;
            this.cycleTotal = _data["cycleTotal"] !== undefined ? _data["cycleTotal"] : null as any;
            this.cycleTotalWK = _data["cycleTotalWK"] !== undefined ? _data["cycleTotalWK"] : null as any;
            this.capacityCycleUpdateTime = _data["capacityCycleUpdateTime"] ? moment(_data["capacityCycleUpdateTime"].toString()) : null as any;
            this.engineeringCycleUpdateTime = _data["engineeringCycleUpdateTime"] ? moment(_data["engineeringCycleUpdateTime"].toString()) : null as any;
            this.productionCycleUpdateTime = _data["productionCycleUpdateTime"] ? moment(_data["productionCycleUpdateTime"].toString()) : null as any;
            this.purchaseCycleUpdateTime = _data["purchaseCycleUpdateTime"] ? moment(_data["purchaseCycleUpdateTime"].toString()) : null as any;
            this.testCycleUpdateTime = _data["testCycleUpdateTime"] ? moment(_data["testCycleUpdateTime"].toString()) : null as any;
            this.grCycleUpdateTime = _data["grCycleUpdateTime"] ? moment(_data["grCycleUpdateTime"].toString()) : null as any;
            this.inToOutCycleUpdateTime = _data["inToOutCycleUpdateTime"] ? moment(_data["inToOutCycleUpdateTime"].toString()) : null as any;
            if (Array.isArray(_data["customMotorParameters"])) {
                this.customMotorParameters = [] as any;
                for (let item of _data["customMotorParameters"])
                    this.customMotorParameters!.push(CustomMotorInfoParamDto.fromJS(item));
            }
            else {
                this.customMotorParameters = null as any;
            }
            this.cpCode = _data["cpCode"] !== undefined ? _data["cpCode"] : null as any;
        }
    }

    static fromJS(data: any): PageMotorcycleOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageMotorcycleOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["cpBasicMotorCode"] = this.cpBasicMotorCode !== undefined ? this.cpBasicMotorCode : null as any;
        data["product"] = this.product !== undefined ? this.product : null as any;
        data["basicMotorSriesId"] = this.basicMotorSriesId !== undefined ? this.basicMotorSriesId : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["motorType"] = this.motorType !== undefined ? this.motorType : null as any;
        data["paramterInfo"] = this.paramterInfo !== undefined ? this.paramterInfo : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["voltageCode"] = this.voltageCode !== undefined ? this.voltageCode : null as any;
        data["isHaveVc"] = this.isHaveVc !== undefined ? this.isHaveVc : null as any;
        data["isHaveVcName"] = this.isHaveVcName !== undefined ? this.isHaveVcName : null as any;
        data["cpName"] = this.cpName !== undefined ? this.cpName : null as any;
        data["customerRemark"] = this.customerRemark !== undefined ? this.customerRemark : null as any;
        data["isNeedHeightOutput"] = this.isNeedHeightOutput !== undefined ? this.isNeedHeightOutput : null as any;
        data["isNeedHeightOutputName"] = this.isNeedHeightOutputName !== undefined ? this.isNeedHeightOutputName : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["engineeringCalculationModeName"] = this.engineeringCalculationModeName !== undefined ? this.engineeringCalculationModeName : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["purchaseCycleModeName"] = this.purchaseCycleModeName !== undefined ? this.purchaseCycleModeName : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCycleWK"] = this.engineeringCycleWK !== undefined ? this.engineeringCycleWK : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleWK"] = this.purchaseCycleWK !== undefined ? this.purchaseCycleWK : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["grCycleWK"] = this.grCycleWK !== undefined ? this.grCycleWK : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["productionCycleWK"] = this.productionCycleWK !== undefined ? this.productionCycleWK : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["testCycleWK"] = this.testCycleWK !== undefined ? this.testCycleWK : null as any;
        data["capacityCycle"] = this.capacityCycle !== undefined ? this.capacityCycle : null as any;
        data["capacityCycleWK"] = this.capacityCycleWK !== undefined ? this.capacityCycleWK : null as any;
        data["inToOutCycle"] = this.inToOutCycle !== undefined ? this.inToOutCycle : null as any;
        data["inToOutCycleWK"] = this.inToOutCycleWK !== undefined ? this.inToOutCycleWK : null as any;
        data["cycleTotal"] = this.cycleTotal !== undefined ? this.cycleTotal : null as any;
        data["cycleTotalWK"] = this.cycleTotalWK !== undefined ? this.cycleTotalWK : null as any;
        data["capacityCycleUpdateTime"] = this.capacityCycleUpdateTime ? this.capacityCycleUpdateTime.toISOString() : null as any;
        data["engineeringCycleUpdateTime"] = this.engineeringCycleUpdateTime ? this.engineeringCycleUpdateTime.toISOString() : null as any;
        data["productionCycleUpdateTime"] = this.productionCycleUpdateTime ? this.productionCycleUpdateTime.toISOString() : null as any;
        data["purchaseCycleUpdateTime"] = this.purchaseCycleUpdateTime ? this.purchaseCycleUpdateTime.toISOString() : null as any;
        data["testCycleUpdateTime"] = this.testCycleUpdateTime ? this.testCycleUpdateTime.toISOString() : null as any;
        data["grCycleUpdateTime"] = this.grCycleUpdateTime ? this.grCycleUpdateTime.toISOString() : null as any;
        data["inToOutCycleUpdateTime"] = this.inToOutCycleUpdateTime ? this.inToOutCycleUpdateTime.toISOString() : null as any;
        if (Array.isArray(this.customMotorParameters)) {
            data["customMotorParameters"] = [];
            for (let item of this.customMotorParameters)
                data["customMotorParameters"].push(item ? item.toJSON() : null as any);
        }
        data["cpCode"] = this.cpCode !== undefined ? this.cpCode : null as any;
        return data;
    }
}

export class PageMotorcycleOutputDtoPagedResultDto {
    items!: PageMotorcycleOutputDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageMotorcycleOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PageMotorcycleOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageMotorcycleOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class PageSearchCustomMotorInfoInputDto {
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | null;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 机座号 */
    frameNos!: number[] | null;
    /** 功率 */
    power!: string | null;
    /** 极数 */
    poleNo!: string | null;
    /** 主机系列id */
    basicMotorSriesIds!: number[] | null;
    /** 能效 */
    eneEff!: string | null;
    isHaveVc!: IsHaveVc;
    /** 电压 */
    voltage!: string | null;
    /** 频率 */
    frequency!: string | null;
    /** 安装方式 */
    basicMotorMounting!: string | null;
    /** 交期是否确认 */
    isConfirm!: boolean | null;
    status!: CustomMotorInfoSatus;
    /** 创建人 */
    creatorUserId!: number | null;
    creationTime!: moment.Moment[] | null;
    readonly creationStartTime!: moment.Moment | null;
    readonly creationEndTime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.filter = _data["filter"] !== undefined ? _data["filter"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            if (Array.isArray(_data["frameNos"])) {
                this.frameNos = [] as any;
                for (let item of _data["frameNos"])
                    this.frameNos!.push(item);
            }
            else {
                this.frameNos = null as any;
            }
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            if (Array.isArray(_data["basicMotorSriesIds"])) {
                this.basicMotorSriesIds = [] as any;
                for (let item of _data["basicMotorSriesIds"])
                    this.basicMotorSriesIds!.push(item);
            }
            else {
                this.basicMotorSriesIds = null as any;
            }
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.isHaveVc = _data["isHaveVc"] !== undefined ? _data["isHaveVc"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.isConfirm = _data["isConfirm"] !== undefined ? _data["isConfirm"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            if (Array.isArray(_data["creationTime"])) {
                this.creationTime = [] as any;
                for (let item of _data["creationTime"])
                    this.creationTime!.push(moment(item));
            }
            else {
                this.creationTime = null as any;
            }
            (this as any).creationStartTime = _data["creationStartTime"] ? moment(_data["creationStartTime"].toString()) : null as any;
            (this as any).creationEndTime = _data["creationEndTime"] ? moment(_data["creationEndTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): PageSearchCustomMotorInfoInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageSearchCustomMotorInfoInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["filter"] = this.filter !== undefined ? this.filter : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        if (Array.isArray(this.frameNos)) {
            data["frameNos"] = [];
            for (let item of this.frameNos)
                data["frameNos"].push(item);
        }
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        if (Array.isArray(this.basicMotorSriesIds)) {
            data["basicMotorSriesIds"] = [];
            for (let item of this.basicMotorSriesIds)
                data["basicMotorSriesIds"].push(item);
        }
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["isHaveVc"] = this.isHaveVc !== undefined ? this.isHaveVc : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["isConfirm"] = this.isConfirm !== undefined ? this.isConfirm : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        if (Array.isArray(this.creationTime)) {
            data["creationTime"] = [];
            for (let item of this.creationTime)
                data["creationTime"].push(item.toISOString());
        }
        data["creationStartTime"] = this.creationStartTime ? this.creationStartTime.toISOString() : null as any;
        data["creationEndTime"] = this.creationEndTime ? this.creationEndTime.toISOString() : null as any;
        return data;
    }
}

export class PageSearchMotorCycleInputDto {
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | null;
    /** 主机编码 */
    basicMotorCode!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 机座号 */
    frameNos!: number[] | null;
    /** 功率 */
    power!: string | null;
    /** 极数 */
    poleNo!: string | null;
    /** 主机系列id */
    basicMotorSriesIds!: number[] | null;
    /** 能效 */
    eneEff!: string | null;
    isHaveVc!: IsHaveVc;
    /** 电压 */
    voltage!: string | null;
    /** 频率 */
    frequency!: string | null;
    /** 安装方式 */
    basicMotorMounting!: string | null;
    /** 交期是否确认 */
    isConfirm!: boolean | null;
    /** 自制OR外购 */
    makeOrBuy!: string | null;
    motorType!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.filter = _data["filter"] !== undefined ? _data["filter"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            if (Array.isArray(_data["frameNos"])) {
                this.frameNos = [] as any;
                for (let item of _data["frameNos"])
                    this.frameNos!.push(item);
            }
            else {
                this.frameNos = null as any;
            }
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            if (Array.isArray(_data["basicMotorSriesIds"])) {
                this.basicMotorSriesIds = [] as any;
                for (let item of _data["basicMotorSriesIds"])
                    this.basicMotorSriesIds!.push(item);
            }
            else {
                this.basicMotorSriesIds = null as any;
            }
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.isHaveVc = _data["isHaveVc"] !== undefined ? _data["isHaveVc"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.isConfirm = _data["isConfirm"] !== undefined ? _data["isConfirm"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.motorType = _data["motorType"] !== undefined ? _data["motorType"] : null as any;
        }
    }

    static fromJS(data: any): PageSearchMotorCycleInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageSearchMotorCycleInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["filter"] = this.filter !== undefined ? this.filter : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        if (Array.isArray(this.frameNos)) {
            data["frameNos"] = [];
            for (let item of this.frameNos)
                data["frameNos"].push(item);
        }
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        if (Array.isArray(this.basicMotorSriesIds)) {
            data["basicMotorSriesIds"] = [];
            for (let item of this.basicMotorSriesIds)
                data["basicMotorSriesIds"].push(item);
        }
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["isHaveVc"] = this.isHaveVc !== undefined ? this.isHaveVc : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["isConfirm"] = this.isConfirm !== undefined ? this.isConfirm : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["motorType"] = this.motorType !== undefined ? this.motorType : null as any;
        return data;
    }
}

/** 主机系列页面分页输入对象 */
export class PageTotalBasicMotorSriesDto {
    /** 总数 */
    totalCount!: number;
    /** 数据集合 */
    items!: PageBasicMotorSriesOutputDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageBasicMotorSriesOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): PageTotalBasicMotorSriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageTotalBasicMotorSriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class PageVCCycleOutputDtoInputDto {
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | null;
    vcId!: string | null;
    vcType!: VcType;
    categoryId!: string | null;
    meaning!: string | null;
    frameNo!: number | null;
    basicMotorSriesNames!: string[] | null;
    cycleNull!: CycleIsNull[] | null;
    cycleConfirm!: CycleIsConfirm[] | null;
    creationTime!: moment.Moment[] | null;
    readonly creationStartTime!: moment.Moment | null;
    readonly creationEndTime!: moment.Moment | null;
    vcLongCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.filter = _data["filter"] !== undefined ? _data["filter"] : null as any;
            this.vcId = _data["vcId"] !== undefined ? _data["vcId"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            if (Array.isArray(_data["basicMotorSriesNames"])) {
                this.basicMotorSriesNames = [] as any;
                for (let item of _data["basicMotorSriesNames"])
                    this.basicMotorSriesNames!.push(item);
            }
            else {
                this.basicMotorSriesNames = null as any;
            }
            if (Array.isArray(_data["cycleNull"])) {
                this.cycleNull = [] as any;
                for (let item of _data["cycleNull"])
                    this.cycleNull!.push(item);
            }
            else {
                this.cycleNull = null as any;
            }
            if (Array.isArray(_data["cycleConfirm"])) {
                this.cycleConfirm = [] as any;
                for (let item of _data["cycleConfirm"])
                    this.cycleConfirm!.push(item);
            }
            else {
                this.cycleConfirm = null as any;
            }
            if (Array.isArray(_data["creationTime"])) {
                this.creationTime = [] as any;
                for (let item of _data["creationTime"])
                    this.creationTime!.push(moment(item));
            }
            else {
                this.creationTime = null as any;
            }
            (this as any).creationStartTime = _data["creationStartTime"] ? moment(_data["creationStartTime"].toString()) : null as any;
            (this as any).creationEndTime = _data["creationEndTime"] ? moment(_data["creationEndTime"].toString()) : null as any;
            this.vcLongCode = _data["vcLongCode"] !== undefined ? _data["vcLongCode"] : null as any;
        }
    }

    static fromJS(data: any): PageVCCycleOutputDtoInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageVCCycleOutputDtoInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["filter"] = this.filter !== undefined ? this.filter : null as any;
        data["vcId"] = this.vcId !== undefined ? this.vcId : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        if (Array.isArray(this.basicMotorSriesNames)) {
            data["basicMotorSriesNames"] = [];
            for (let item of this.basicMotorSriesNames)
                data["basicMotorSriesNames"].push(item);
        }
        if (Array.isArray(this.cycleNull)) {
            data["cycleNull"] = [];
            for (let item of this.cycleNull)
                data["cycleNull"].push(item);
        }
        if (Array.isArray(this.cycleConfirm)) {
            data["cycleConfirm"] = [];
            for (let item of this.cycleConfirm)
                data["cycleConfirm"].push(item);
        }
        if (Array.isArray(this.creationTime)) {
            data["creationTime"] = [];
            for (let item of this.creationTime)
                data["creationTime"].push(item.toISOString());
        }
        data["creationStartTime"] = this.creationStartTime ? this.creationStartTime.toISOString() : null as any;
        data["creationEndTime"] = this.creationEndTime ? this.creationEndTime.toISOString() : null as any;
        data["vcLongCode"] = this.vcLongCode !== undefined ? this.vcLongCode : null as any;
        return data;
    }
}

export class PageVcInfoOutputDto {
    id!: string;
    vcID!: string | null;
    categoryId!: string;
    category!: string | null;
    meaning!: string | null;
    englishMeaning!: string | null;
    vcTypeDescription!: string | null;
    numberWires!: number;
    vcType!: VcType;
    readonly vcTypeName!: string | null;
    vcCode!: string | null;
    vcLongCode!: string | null;
    clienter!: string;
    validStartTime!: moment.Moment;
    validEndTime!: moment.Moment;
    checkVCRules!: PageCheckVcRulesOutputDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            (this as any).vcTypeName = _data["vcTypeName"] !== undefined ? _data["vcTypeName"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.vcLongCode = _data["vcLongCode"] !== undefined ? _data["vcLongCode"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.validStartTime = _data["validStartTime"] ? moment(_data["validStartTime"].toString()) : null as any;
            this.validEndTime = _data["validEndTime"] ? moment(_data["validEndTime"].toString()) : null as any;
            if (Array.isArray(_data["checkVCRules"])) {
                this.checkVCRules = [] as any;
                for (let item of _data["checkVCRules"])
                    this.checkVCRules!.push(PageCheckVcRulesOutputDto.fromJS(item));
            }
            else {
                this.checkVCRules = null as any;
            }
        }
    }

    static fromJS(data: any): PageVcInfoOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageVcInfoOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcTypeName"] = this.vcTypeName !== undefined ? this.vcTypeName : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["vcLongCode"] = this.vcLongCode !== undefined ? this.vcLongCode : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["validStartTime"] = this.validStartTime ? this.validStartTime.toISOString() : null as any;
        data["validEndTime"] = this.validEndTime ? this.validEndTime.toISOString() : null as any;
        if (Array.isArray(this.checkVCRules)) {
            data["checkVCRules"] = [];
            for (let item of this.checkVCRules)
                data["checkVCRules"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class PageVcInfoOutputDtoPagedResultDto {
    items!: PageVcInfoOutputDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageVcInfoOutputDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): PageVcInfoOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageVcInfoOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class PageVsInfoInputDto {
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | null;
    vcId!: string | null;
    vcID!: string | null;
    categoryId!: string | null;
    meaning!: string | null;
    englishMeaning!: string | null;
    vcCodes!: string[] | null;
    basicMotorSriesNames!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.filter = _data["filter"] !== undefined ? _data["filter"] : null as any;
            this.vcId = _data["vcId"] !== undefined ? _data["vcId"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            if (Array.isArray(_data["vcCodes"])) {
                this.vcCodes = [] as any;
                for (let item of _data["vcCodes"])
                    this.vcCodes!.push(item);
            }
            else {
                this.vcCodes = null as any;
            }
            if (Array.isArray(_data["basicMotorSriesNames"])) {
                this.basicMotorSriesNames = [] as any;
                for (let item of _data["basicMotorSriesNames"])
                    this.basicMotorSriesNames!.push(item);
            }
            else {
                this.basicMotorSriesNames = null as any;
            }
        }
    }

    static fromJS(data: any): PageVsInfoInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageVsInfoInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["filter"] = this.filter !== undefined ? this.filter : null as any;
        data["vcId"] = this.vcId !== undefined ? this.vcId : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        if (Array.isArray(this.vcCodes)) {
            data["vcCodes"] = [];
            for (let item of this.vcCodes)
                data["vcCodes"].push(item);
        }
        if (Array.isArray(this.basicMotorSriesNames)) {
            data["basicMotorSriesNames"] = [];
            for (let item of this.basicMotorSriesNames)
                data["basicMotorSriesNames"].push(item);
        }
        return data;
    }
}

export class PagedCategoryCodeRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    categoryId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
        }
    }

    static fromJS(data: any): PagedCategoryCodeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedCategoryCodeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        return data;
    }
}

/** 分页品类对象 */
export class PagedCategoryRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 含义 */
    meaning!: string | null;
    /** 描述 */
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): PagedCategoryRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedCategoryRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

export class PagedCustomVcCycleRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 自定义VC编号 */
    customVcId!: string;
    /** 机座号 */
    frameNos!: number[] | null;
    /** 产品系列 */
    basicMotorSries!: string[] | null;
    /** 主机代码 */
    basicMotorCode!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.customVcId = _data["customVcId"] !== undefined ? _data["customVcId"] : null as any;
            if (Array.isArray(_data["frameNos"])) {
                this.frameNos = [] as any;
                for (let item of _data["frameNos"])
                    this.frameNos!.push(item);
            }
            else {
                this.frameNos = null as any;
            }
            if (Array.isArray(_data["basicMotorSries"])) {
                this.basicMotorSries = [] as any;
                for (let item of _data["basicMotorSries"])
                    this.basicMotorSries!.push(item);
            }
            else {
                this.basicMotorSries = null as any;
            }
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
        }
    }

    static fromJS(data: any): PagedCustomVcCycleRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedCustomVcCycleRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["customVcId"] = this.customVcId !== undefined ? this.customVcId : null as any;
        if (Array.isArray(this.frameNos)) {
            data["frameNos"] = [];
            for (let item of this.frameNos)
                data["frameNos"].push(item);
        }
        if (Array.isArray(this.basicMotorSries)) {
            data["basicMotorSries"] = [];
            for (let item of this.basicMotorSries)
                data["basicMotorSries"].push(item);
        }
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        return data;
    }
}

export class PagedCustomVcRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    /** VC ID */
    vcID!: string | null;
    /** VC ID */
    notFoundVcID!: string | null;
    /** 品类 */
    categoryId!: string | null;
    /** VC含义 */
    meaning!: string | null;
    /** 英文含义 */
    englishMeaning!: string | null;
    /** VC备注 */
    vcTypeDescription!: string | null;
    /** VC头数 */
    numberWires!: number;
    status!: IndustryVCStatus;
    /** 创建人 */
    creatorUserId!: number | null;
    /** 机座号 */
    frameNos!: number[] | null;
    /** 产品系列 */
    basicMotorSries!: string[] | null;
    /** 主机代码 */
    basicMotorCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.notFoundVcID = _data["notFoundVcID"] !== undefined ? _data["notFoundVcID"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            if (Array.isArray(_data["frameNos"])) {
                this.frameNos = [] as any;
                for (let item of _data["frameNos"])
                    this.frameNos!.push(item);
            }
            else {
                this.frameNos = null as any;
            }
            if (Array.isArray(_data["basicMotorSries"])) {
                this.basicMotorSries = [] as any;
                for (let item of _data["basicMotorSries"])
                    this.basicMotorSries!.push(item);
            }
            else {
                this.basicMotorSries = null as any;
            }
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
        }
    }

    static fromJS(data: any): PagedCustomVcRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedCustomVcRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["notFoundVcID"] = this.notFoundVcID !== undefined ? this.notFoundVcID : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        if (Array.isArray(this.frameNos)) {
            data["frameNos"] = [];
            for (let item of this.frameNos)
                data["frameNos"].push(item);
        }
        if (Array.isArray(this.basicMotorSries)) {
            data["basicMotorSries"] = [];
            for (let item of this.basicMotorSries)
                data["basicMotorSries"].push(item);
        }
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        return data;
    }
}

/** 定时任务记录分页查询 */
export class PagedJobRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 任务信息 */
    invocationData!: string | null;
    /** 任务参数 */
    arguments!: string | null;
    /** 开始时间 */
    startDatetime!: moment.Moment | null;
    /** 结束时间 */
    endDatetime!: moment.Moment | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.invocationData = _data["invocationData"] !== undefined ? _data["invocationData"] : null as any;
            this.arguments = _data["arguments"] !== undefined ? _data["arguments"] : null as any;
            this.startDatetime = _data["startDatetime"] ? moment(_data["startDatetime"].toString()) : null as any;
            this.endDatetime = _data["endDatetime"] ? moment(_data["endDatetime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): PagedJobRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedJobRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["invocationData"] = this.invocationData !== undefined ? this.invocationData : null as any;
        data["arguments"] = this.arguments !== undefined ? this.arguments : null as any;
        data["startDatetime"] = this.startDatetime ? this.startDatetime.toISOString() : null as any;
        data["endDatetime"] = this.endDatetime ? this.endDatetime.toISOString() : null as any;
        return data;
    }
}

export class PagedSpeciaVcRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    /** VcCode */
    code!: string | null;
    /** 品类 */
    categoryId!: string | null;
    /** VC含义 */
    meaning!: string | null;
    /** VC备注 */
    description!: string | null;
    showType!: VCShowType;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.showType = _data["showType"] !== undefined ? _data["showType"] : null as any;
        }
    }

    static fromJS(data: any): PagedSpeciaVcRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedSpeciaVcRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["showType"] = this.showType !== undefined ? this.showType : null as any;
        return data;
    }
}

export class PagedSynchronizeSapBaseRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    /** VC ID */
    vcID!: string | null;
    /** 品类 */
    category!: string | null;
    /** VC含义 */
    meaning!: string | null;
    /** 英文含义 */
    englishMeaning!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
        }
    }

    static fromJS(data: any): PagedSynchronizeSapBaseRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedSynchronizeSapBaseRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        return data;
    }
}

export class PagedSynchronizeSapCycleRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    /** VC ID */
    vcID!: string | null;
    /** 机座号 */
    frameNo!: number;
    /** 产品系列 */
    basicMotorSries!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
        }
    }

    static fromJS(data: any): PagedSynchronizeSapCycleRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedSynchronizeSapCycleRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        return data;
    }
}

/** 分页品类对象 */
export class PagedTechinalCatalogueRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    /** 名称 */
    name!: string | null;
    /** 描述 */
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): PagedTechinalCatalogueRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedTechinalCatalogueRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

/** 分页技术协议书对象 */
export class PagedTechnicalAgreementRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    techinalCatalogueId!: string | null;
    /** 标题 */
    title!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.techinalCatalogueId = _data["techinalCatalogueId"] !== undefined ? _data["techinalCatalogueId"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
        }
    }

    static fromJS(data: any): PagedTechnicalAgreementRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedTechnicalAgreementRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["techinalCatalogueId"] = this.techinalCatalogueId !== undefined ? this.techinalCatalogueId : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        return data;
    }
}

/** 分页对象 */
export class PagedVcLongShortCodeMappingRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    /** Vc短代码 */
    shortVcCode!: string | null;
    /** Vc短代码品类 */
    shortVcCategory!: string | null;
    /** Vc长代码 */
    longVcCode!: string | null;
    /** Vc长代码品类 */
    longVcCategory!: string | null;

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"] !== undefined ? _data["maxResultCount"] : null as any;
            this.skipCount = _data["skipCount"] !== undefined ? _data["skipCount"] : null as any;
            this.shortVcCode = _data["shortVcCode"] !== undefined ? _data["shortVcCode"] : null as any;
            this.shortVcCategory = _data["shortVcCategory"] !== undefined ? _data["shortVcCategory"] : null as any;
            this.longVcCode = _data["longVcCode"] !== undefined ? _data["longVcCode"] : null as any;
            this.longVcCategory = _data["longVcCategory"] !== undefined ? _data["longVcCategory"] : null as any;
        }
    }

    static fromJS(data: any): PagedVcLongShortCodeMappingRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedVcLongShortCodeMappingRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount !== undefined ? this.maxResultCount : null as any;
        data["skipCount"] = this.skipCount !== undefined ? this.skipCount : null as any;
        data["shortVcCode"] = this.shortVcCode !== undefined ? this.shortVcCode : null as any;
        data["shortVcCategory"] = this.shortVcCategory !== undefined ? this.shortVcCategory : null as any;
        data["longVcCode"] = this.longVcCode !== undefined ? this.longVcCode : null as any;
        data["longVcCategory"] = this.longVcCategory !== undefined ? this.longVcCategory : null as any;
        return data;
    }
}

/** 0 = None 1 = In 2 = Out 4 = Lcid 8 = Retval 16 = Optional 4096 = HasDefault 8192 = HasFieldMarshal 16384 = Reserved3 32768 = Reserved4 61440 = ReservedMask */
export enum ParameterAttributes {
    None = 0,
    In = 1,
    Out = 2,
    Lcid = 4,
    Retval = 8,
    Optional = 16,
    HasDefault = 4096,
    HasFieldMarshal = 8192,
    Reserved3 = 16384,
    Reserved4 = 32768,
    ReservedMask = 61440,
}

export class ParameterInfo {
    attributes!: ParameterAttributes;
    member!: MemberInfo;
    readonly name!: string | null;
    parameterType!: Type;
    readonly position!: number;
    readonly isIn!: boolean;
    readonly isLcid!: boolean;
    readonly isOptional!: boolean;
    readonly isOut!: boolean;
    readonly isRetval!: boolean;
    readonly defaultValue!: any | null;
    readonly rawDefaultValue!: any | null;
    readonly hasDefaultValue!: boolean;
    readonly customAttributes!: CustomAttributeData[] | null;
    readonly metadataToken!: number;

    init(_data?: any) {
        if (_data) {
            this.attributes = _data["attributes"] !== undefined ? _data["attributes"] : null as any;
            this.member = _data["member"] ? MemberInfo.fromJS(_data["member"]) : null as any;
            (this as any).name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.parameterType = _data["parameterType"] ? Type.fromJS(_data["parameterType"]) : null as any;
            (this as any).position = _data["position"] !== undefined ? _data["position"] : null as any;
            (this as any).isIn = _data["isIn"] !== undefined ? _data["isIn"] : null as any;
            (this as any).isLcid = _data["isLcid"] !== undefined ? _data["isLcid"] : null as any;
            (this as any).isOptional = _data["isOptional"] !== undefined ? _data["isOptional"] : null as any;
            (this as any).isOut = _data["isOut"] !== undefined ? _data["isOut"] : null as any;
            (this as any).isRetval = _data["isRetval"] !== undefined ? _data["isRetval"] : null as any;
            (this as any).defaultValue = _data["defaultValue"] !== undefined ? _data["defaultValue"] : null as any;
            (this as any).rawDefaultValue = _data["rawDefaultValue"] !== undefined ? _data["rawDefaultValue"] : null as any;
            (this as any).hasDefaultValue = _data["hasDefaultValue"] !== undefined ? _data["hasDefaultValue"] : null as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            else {
                (this as any).customAttributes = null as any;
            }
            (this as any).metadataToken = _data["metadataToken"] !== undefined ? _data["metadataToken"] : null as any;
        }
    }

    static fromJS(data: any): ParameterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes !== undefined ? this.attributes : null as any;
        data["member"] = this.member ? this.member.toJSON() : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["parameterType"] = this.parameterType ? this.parameterType.toJSON() : null as any;
        data["position"] = this.position !== undefined ? this.position : null as any;
        data["isIn"] = this.isIn !== undefined ? this.isIn : null as any;
        data["isLcid"] = this.isLcid !== undefined ? this.isLcid : null as any;
        data["isOptional"] = this.isOptional !== undefined ? this.isOptional : null as any;
        data["isOut"] = this.isOut !== undefined ? this.isOut : null as any;
        data["isRetval"] = this.isRetval !== undefined ? this.isRetval : null as any;
        data["defaultValue"] = this.defaultValue !== undefined ? this.defaultValue : null as any;
        data["rawDefaultValue"] = this.rawDefaultValue !== undefined ? this.rawDefaultValue : null as any;
        data["hasDefaultValue"] = this.hasDefaultValue !== undefined ? this.hasDefaultValue : null as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : null as any);
        }
        data["metadataToken"] = this.metadataToken !== undefined ? this.metadataToken : null as any;
        return data;
    }
}

export class PostInput {
    appId!: string | null;
    email!: string | null;
    url!: string | null;
    industryManager!: string | null;
    businessCategory!: string | null;
    company!: string | null;
    priority!: string | null;
    customerNumber!: string | null;
    productGroup!: string | null;
    endUsersName!: string | null;
    majorProducts!: string | null;
    deliveryTerm!: string | null;
    omsQuotatoinNumber!: string | null;
    deliArea!: string | null;
    gssQuotatoinNumber!: string | null;
    meansofTransport!: string | null;
    projectName!: string | null;
    readonly spCurrency!: number | null;
    riskReviewNumber!: string | null;
    tpCurrency!: number;
    paymentTerm!: string | null;
    projectManager!: string | null;
    validityType!: string | null;
    preliminarydeliverytime!: moment.Moment | null;
    hubManager!: string | null;
    fciTemplate!: string | null;
    customerContact!: string | null;
    sts!: string | null;
    authorizationDepartmentMgr!: string | null;
    list!: PostInputList[] | null;

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"] !== undefined ? _data["appId"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.industryManager = _data["industryManager"] !== undefined ? _data["industryManager"] : null as any;
            this.businessCategory = _data["businessCategory"] !== undefined ? _data["businessCategory"] : null as any;
            this.company = _data["company"] !== undefined ? _data["company"] : null as any;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : null as any;
            this.customerNumber = _data["customerNumber"] !== undefined ? _data["customerNumber"] : null as any;
            this.productGroup = _data["productGroup"] !== undefined ? _data["productGroup"] : null as any;
            this.endUsersName = _data["endUsersName"] !== undefined ? _data["endUsersName"] : null as any;
            this.majorProducts = _data["majorProducts"] !== undefined ? _data["majorProducts"] : null as any;
            this.deliveryTerm = _data["deliveryTerm"] !== undefined ? _data["deliveryTerm"] : null as any;
            this.omsQuotatoinNumber = _data["omsQuotatoinNumber"] !== undefined ? _data["omsQuotatoinNumber"] : null as any;
            this.deliArea = _data["deliArea"] !== undefined ? _data["deliArea"] : null as any;
            this.gssQuotatoinNumber = _data["gssQuotatoinNumber"] !== undefined ? _data["gssQuotatoinNumber"] : null as any;
            this.meansofTransport = _data["meansofTransport"] !== undefined ? _data["meansofTransport"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            (this as any).spCurrency = _data["spCurrency"] !== undefined ? _data["spCurrency"] : null as any;
            this.riskReviewNumber = _data["riskReviewNumber"] !== undefined ? _data["riskReviewNumber"] : null as any;
            this.tpCurrency = _data["tpCurrency"] !== undefined ? _data["tpCurrency"] : null as any;
            this.paymentTerm = _data["paymentTerm"] !== undefined ? _data["paymentTerm"] : null as any;
            this.projectManager = _data["projectManager"] !== undefined ? _data["projectManager"] : null as any;
            this.validityType = _data["validityType"] !== undefined ? _data["validityType"] : null as any;
            this.preliminarydeliverytime = _data["preliminarydeliverytime"] ? moment(_data["preliminarydeliverytime"].toString()) : null as any;
            this.hubManager = _data["hubManager"] !== undefined ? _data["hubManager"] : null as any;
            this.fciTemplate = _data["fciTemplate"] !== undefined ? _data["fciTemplate"] : null as any;
            this.customerContact = _data["customerContact"] !== undefined ? _data["customerContact"] : null as any;
            this.sts = _data["sts"] !== undefined ? _data["sts"] : null as any;
            this.authorizationDepartmentMgr = _data["authorizationDepartmentMgr"] !== undefined ? _data["authorizationDepartmentMgr"] : null as any;
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"])
                    this.list!.push(PostInputList.fromJS(item));
            }
            else {
                this.list = null as any;
            }
        }
    }

    static fromJS(data: any): PostInput {
        data = typeof data === 'object' ? data : {};
        let result = new PostInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId !== undefined ? this.appId : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["industryManager"] = this.industryManager !== undefined ? this.industryManager : null as any;
        data["businessCategory"] = this.businessCategory !== undefined ? this.businessCategory : null as any;
        data["company"] = this.company !== undefined ? this.company : null as any;
        data["priority"] = this.priority !== undefined ? this.priority : null as any;
        data["customerNumber"] = this.customerNumber !== undefined ? this.customerNumber : null as any;
        data["productGroup"] = this.productGroup !== undefined ? this.productGroup : null as any;
        data["endUsersName"] = this.endUsersName !== undefined ? this.endUsersName : null as any;
        data["majorProducts"] = this.majorProducts !== undefined ? this.majorProducts : null as any;
        data["deliveryTerm"] = this.deliveryTerm !== undefined ? this.deliveryTerm : null as any;
        data["omsQuotatoinNumber"] = this.omsQuotatoinNumber !== undefined ? this.omsQuotatoinNumber : null as any;
        data["deliArea"] = this.deliArea !== undefined ? this.deliArea : null as any;
        data["gssQuotatoinNumber"] = this.gssQuotatoinNumber !== undefined ? this.gssQuotatoinNumber : null as any;
        data["meansofTransport"] = this.meansofTransport !== undefined ? this.meansofTransport : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["spCurrency"] = this.spCurrency !== undefined ? this.spCurrency : null as any;
        data["riskReviewNumber"] = this.riskReviewNumber !== undefined ? this.riskReviewNumber : null as any;
        data["tpCurrency"] = this.tpCurrency !== undefined ? this.tpCurrency : null as any;
        data["paymentTerm"] = this.paymentTerm !== undefined ? this.paymentTerm : null as any;
        data["projectManager"] = this.projectManager !== undefined ? this.projectManager : null as any;
        data["validityType"] = this.validityType !== undefined ? this.validityType : null as any;
        data["preliminarydeliverytime"] = this.preliminarydeliverytime ? this.preliminarydeliverytime.toISOString() : null as any;
        data["hubManager"] = this.hubManager !== undefined ? this.hubManager : null as any;
        data["fciTemplate"] = this.fciTemplate !== undefined ? this.fciTemplate : null as any;
        data["customerContact"] = this.customerContact !== undefined ? this.customerContact : null as any;
        data["sts"] = this.sts !== undefined ? this.sts : null as any;
        data["authorizationDepartmentMgr"] = this.authorizationDepartmentMgr !== undefined ? this.authorizationDepartmentMgr : null as any;
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class PostInputList {
    productNumber!: string | null;
    multiplier!: number;
    qty!: number;
    motorListprice!: number | null;
    internalText!: string | null;
    voltage!: string | null;
    frequency!: string | null;
    mountingtype!: string | null;
    classofprotection!: string | null;
    output!: string | null;
    insulationclass!: string | null;
    tempriseclass!: string | null;
    vcListprice!: number | null;
    readonly unitsalesprice!: number | null;
    unittransferprice!: number;
    variantprodno!: string | null;
    productName!: string | null;
    facePriceTotal!: number;
    vC999!: number | null;

    init(_data?: any) {
        if (_data) {
            this.productNumber = _data["productNumber"] !== undefined ? _data["productNumber"] : null as any;
            this.multiplier = _data["multiplier"] !== undefined ? _data["multiplier"] : null as any;
            this.qty = _data["qty"] !== undefined ? _data["qty"] : null as any;
            this.motorListprice = _data["motorListprice"] !== undefined ? _data["motorListprice"] : null as any;
            this.internalText = _data["internalText"] !== undefined ? _data["internalText"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.mountingtype = _data["mountingtype"] !== undefined ? _data["mountingtype"] : null as any;
            this.classofprotection = _data["classofprotection"] !== undefined ? _data["classofprotection"] : null as any;
            this.output = _data["output"] !== undefined ? _data["output"] : null as any;
            this.insulationclass = _data["insulationclass"] !== undefined ? _data["insulationclass"] : null as any;
            this.tempriseclass = _data["tempriseclass"] !== undefined ? _data["tempriseclass"] : null as any;
            this.vcListprice = _data["vcListprice"] !== undefined ? _data["vcListprice"] : null as any;
            (this as any).unitsalesprice = _data["unitsalesprice"] !== undefined ? _data["unitsalesprice"] : null as any;
            this.unittransferprice = _data["unittransferprice"] !== undefined ? _data["unittransferprice"] : null as any;
            this.variantprodno = _data["variantprodno"] !== undefined ? _data["variantprodno"] : null as any;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : null as any;
            this.facePriceTotal = _data["facePriceTotal"] !== undefined ? _data["facePriceTotal"] : null as any;
            this.vC999 = _data["vC999"] !== undefined ? _data["vC999"] : null as any;
        }
    }

    static fromJS(data: any): PostInputList {
        data = typeof data === 'object' ? data : {};
        let result = new PostInputList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productNumber"] = this.productNumber !== undefined ? this.productNumber : null as any;
        data["multiplier"] = this.multiplier !== undefined ? this.multiplier : null as any;
        data["qty"] = this.qty !== undefined ? this.qty : null as any;
        data["motorListprice"] = this.motorListprice !== undefined ? this.motorListprice : null as any;
        data["internalText"] = this.internalText !== undefined ? this.internalText : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["mountingtype"] = this.mountingtype !== undefined ? this.mountingtype : null as any;
        data["classofprotection"] = this.classofprotection !== undefined ? this.classofprotection : null as any;
        data["output"] = this.output !== undefined ? this.output : null as any;
        data["insulationclass"] = this.insulationclass !== undefined ? this.insulationclass : null as any;
        data["tempriseclass"] = this.tempriseclass !== undefined ? this.tempriseclass : null as any;
        data["vcListprice"] = this.vcListprice !== undefined ? this.vcListprice : null as any;
        data["unitsalesprice"] = this.unitsalesprice !== undefined ? this.unitsalesprice : null as any;
        data["unittransferprice"] = this.unittransferprice !== undefined ? this.unittransferprice : null as any;
        data["variantprodno"] = this.variantprodno !== undefined ? this.variantprodno : null as any;
        data["productName"] = this.productName !== undefined ? this.productName : null as any;
        data["facePriceTotal"] = this.facePriceTotal !== undefined ? this.facePriceTotal : null as any;
        data["vC999"] = this.vC999 !== undefined ? this.vC999 : null as any;
        return data;
    }
}

export class PostOutput {
    code!: number;
    serialNo!: string | null;
    url!: string | null;
    message!: string | null;

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): PostOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PostOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }
}

/** 0 = Standard 1 = Custom 2 = TE 3 = DQ 4 = history 5 = Import 6 = CustomerCode */
export enum ProdcutAndVcSource {
    Standard = 0,
    Custom = 1,
    TE = 2,
    DQ = 3,
    History = 4,
    Import = 5,
    CustomerCode = 6,
}

export class ProducttFromLPInput {
    listPriceBasicMotorPriceId!: string;
    /** 面价 */
    unitPrice!: number | null;
    /** 标准代码 */
    basicMotorCode!: string | null;
    /** 境界系列 */
    basicMotorSries!: string | null;
    /** 主机类型 */
    basicMotorModel!: string | null;
    /** 安装方式 */
    basicMotorMounting!: string | null;
    /** 极数 */
    poleNo!: string | null;
    /** 电压 */
    voltage!: string | null;
    /** 机座号 */
    frameNo!: number;
    /** 功率 */
    power!: string | null;
    /** 编码器 */
    encoder!: string | null;
    /** 频率 */
    frequency!: string | null;
    /** 境界标识符 */
    jinCategoryCode!: string | null;
    /** 境界代码 */
    jinMotorCode!: string | null;
    /** 版本号 */
    jinVersion!: string | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceBasicMotorPriceId = _data["listPriceBasicMotorPriceId"] !== undefined ? _data["listPriceBasicMotorPriceId"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.encoder = _data["encoder"] !== undefined ? _data["encoder"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinMotorCode = _data["jinMotorCode"] !== undefined ? _data["jinMotorCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
        }
    }

    static fromJS(data: any): ProducttFromLPInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProducttFromLPInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceBasicMotorPriceId"] = this.listPriceBasicMotorPriceId !== undefined ? this.listPriceBasicMotorPriceId : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["encoder"] = this.encoder !== undefined ? this.encoder : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinMotorCode"] = this.jinMotorCode !== undefined ? this.jinMotorCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        return data;
    }
}

/** 0 = None 512 = SpecialName 1024 = RTSpecialName 4096 = HasDefault 8192 = Reserved2 16384 = Reserved3 32768 = Reserved4 62464 = ReservedMask */
export enum PropertyAttributes {
    None = 0,
    SpecialName = 512,
    RTSpecialName = 1024,
    HasDefault = 4096,
    Reserved2 = 8192,
    Reserved3 = 16384,
    Reserved4 = 32768,
    ReservedMask = 62464,
}

export class PropertyInfo {
    readonly name!: string | null;
    declaringType!: Type;
    reflectedType!: Type;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | null;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    memberType!: MemberTypes;
    propertyType!: Type;
    attributes!: PropertyAttributes;
    readonly isSpecialName!: boolean;
    readonly canRead!: boolean;
    readonly canWrite!: boolean;
    getMethod!: MethodInfo;
    setMethod!: MethodInfo;

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : null as any;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : null as any;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : null as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            else {
                (this as any).customAttributes = null as any;
            }
            (this as any).isCollectible = _data["isCollectible"] !== undefined ? _data["isCollectible"] : null as any;
            (this as any).metadataToken = _data["metadataToken"] !== undefined ? _data["metadataToken"] : null as any;
            this.memberType = _data["memberType"] !== undefined ? _data["memberType"] : null as any;
            this.propertyType = _data["propertyType"] ? Type.fromJS(_data["propertyType"]) : null as any;
            this.attributes = _data["attributes"] !== undefined ? _data["attributes"] : null as any;
            (this as any).isSpecialName = _data["isSpecialName"] !== undefined ? _data["isSpecialName"] : null as any;
            (this as any).canRead = _data["canRead"] !== undefined ? _data["canRead"] : null as any;
            (this as any).canWrite = _data["canWrite"] !== undefined ? _data["canWrite"] : null as any;
            this.getMethod = _data["getMethod"] ? MethodInfo.fromJS(_data["getMethod"]) : null as any;
            this.setMethod = _data["setMethod"] ? MethodInfo.fromJS(_data["setMethod"]) : null as any;
        }
    }

    static fromJS(data: any): PropertyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : null as any;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : null as any;
        data["module"] = this.module ? this.module.toJSON() : null as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : null as any);
        }
        data["isCollectible"] = this.isCollectible !== undefined ? this.isCollectible : null as any;
        data["metadataToken"] = this.metadataToken !== undefined ? this.metadataToken : null as any;
        data["memberType"] = this.memberType !== undefined ? this.memberType : null as any;
        data["propertyType"] = this.propertyType ? this.propertyType.toJSON() : null as any;
        data["attributes"] = this.attributes !== undefined ? this.attributes : null as any;
        data["isSpecialName"] = this.isSpecialName !== undefined ? this.isSpecialName : null as any;
        data["canRead"] = this.canRead !== undefined ? this.canRead : null as any;
        data["canWrite"] = this.canWrite !== undefined ? this.canWrite : null as any;
        data["getMethod"] = this.getMethod ? this.getMethod.toJSON() : null as any;
        data["setMethod"] = this.setMethod ? this.setMethod.toJSON() : null as any;
        return data;
    }
}

export class QuotationApproval {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    info!: string | null;
    isApproval!: TQApprovalStatus;
    technologyQuotationId!: string;
    technologyQuotation!: TechnologyQuotation;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.info = _data["info"] !== undefined ? _data["info"] : null as any;
            this.isApproval = _data["isApproval"] !== undefined ? _data["isApproval"] : null as any;
            this.technologyQuotationId = _data["technologyQuotationId"] !== undefined ? _data["technologyQuotationId"] : null as any;
            this.technologyQuotation = _data["technologyQuotation"] ? TechnologyQuotation.fromJS(_data["technologyQuotation"]) : null as any;
        }
    }

    static fromJS(data: any): QuotationApproval {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["info"] = this.info !== undefined ? this.info : null as any;
        data["isApproval"] = this.isApproval !== undefined ? this.isApproval : null as any;
        data["technologyQuotationId"] = this.technologyQuotationId !== undefined ? this.technologyQuotationId : null as any;
        data["technologyQuotation"] = this.technologyQuotation ? this.technologyQuotation.toJSON() : null as any;
        return data;
    }
}

export class QuotationOnBudgeExportInPutDto {
    id!: string;
    multipliers!: QuotationOnBudgeMultiplier[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["multipliers"])) {
                this.multipliers = [] as any;
                for (let item of _data["multipliers"])
                    this.multipliers!.push(QuotationOnBudgeMultiplier.fromJS(item));
            }
            else {
                this.multipliers = null as any;
            }
        }
    }

    static fromJS(data: any): QuotationOnBudgeExportInPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationOnBudgeExportInPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.multipliers)) {
            data["multipliers"] = [];
            for (let item of this.multipliers)
                data["multipliers"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class QuotationOnBudgeMultiplier {
    id!: string;
    multipilerType!: MultipilerType;
    expectMultiplier!: number;
    productPrice!: number;
    price!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.multipilerType = _data["multipilerType"] !== undefined ? _data["multipilerType"] : null as any;
            this.expectMultiplier = _data["expectMultiplier"] !== undefined ? _data["expectMultiplier"] : null as any;
            this.productPrice = _data["productPrice"] !== undefined ? _data["productPrice"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
        }
    }

    static fromJS(data: any): QuotationOnBudgeMultiplier {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationOnBudgeMultiplier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["multipilerType"] = this.multipilerType !== undefined ? this.multipilerType : null as any;
        data["expectMultiplier"] = this.expectMultiplier !== undefined ? this.expectMultiplier : null as any;
        data["productPrice"] = this.productPrice !== undefined ? this.productPrice : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        return data;
    }
}

export class QuotationPrincipleRow {
    id!: number;
    code!: string | null;
    quotationPrincipleDetails!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
        }
    }

    static fromJS(data: any): QuotationPrincipleRow {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationPrincipleRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        return data;
    }
}

/** 0 = BasicMotorListPriceMissing 1 = VcListPriceMissing 2 = BothListPriceMissing */
export enum QuotationType {
    BasicMotorListPriceMissing = 0,
    VcListPriceMissing = 1,
    BothListPriceMissing = 2,
}

export class RepetitiveOutputDto {
    /** 是否存在VC */
    existVc!: boolean;
    /** 是否存在产品代码配置 */
    existProduct!: boolean;
    /** 是否存在同系列同交期配置 */
    exiesSriesFrameNo!: boolean;
    /** 是否存在审批通过的同系列同交期配置 */
    exiesApprovedSriesFrameNo!: boolean;
    customVcPriceDto!: CustomVcPriceDto;

    init(_data?: any) {
        if (_data) {
            this.existVc = _data["existVc"] !== undefined ? _data["existVc"] : null as any;
            this.existProduct = _data["existProduct"] !== undefined ? _data["existProduct"] : null as any;
            this.exiesSriesFrameNo = _data["exiesSriesFrameNo"] !== undefined ? _data["exiesSriesFrameNo"] : null as any;
            this.exiesApprovedSriesFrameNo = _data["exiesApprovedSriesFrameNo"] !== undefined ? _data["exiesApprovedSriesFrameNo"] : null as any;
            this.customVcPriceDto = _data["customVcPriceDto"] ? CustomVcPriceDto.fromJS(_data["customVcPriceDto"]) : null as any;
        }
    }

    static fromJS(data: any): RepetitiveOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new RepetitiveOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["existVc"] = this.existVc !== undefined ? this.existVc : null as any;
        data["existProduct"] = this.existProduct !== undefined ? this.existProduct : null as any;
        data["exiesSriesFrameNo"] = this.exiesSriesFrameNo !== undefined ? this.exiesSriesFrameNo : null as any;
        data["exiesApprovedSriesFrameNo"] = this.exiesApprovedSriesFrameNo !== undefined ? this.exiesApprovedSriesFrameNo : null as any;
        data["customVcPriceDto"] = this.customVcPriceDto ? this.customVcPriceDto.toJSON() : null as any;
        return data;
    }
}

/** 检查产品下VC的价格来源情况 */
export class RepetitivePriceProductDto {
    id!: string;
    /** 主机代码 */
    basicMotorCode!: string | null;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 机座号 */
    frameNo!: number;
    /** 产品下配置的VC情况 */
    repetitivePriceVcs!: RepetitivePriceVcDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            if (Array.isArray(_data["repetitivePriceVcs"])) {
                this.repetitivePriceVcs = [] as any;
                for (let item of _data["repetitivePriceVcs"])
                    this.repetitivePriceVcs!.push(RepetitivePriceVcDto.fromJS(item));
            }
            else {
                this.repetitivePriceVcs = null as any;
            }
        }
    }

    static fromJS(data: any): RepetitivePriceProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new RepetitivePriceProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        if (Array.isArray(this.repetitivePriceVcs)) {
            data["repetitivePriceVcs"] = [];
            for (let item of this.repetitivePriceVcs)
                data["repetitivePriceVcs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class RepetitivePriceVcDto {
    id!: string;
    /** 自定义VC编号 */
    vcID!: string | null;
    /** 是否存在VC */
    existVc!: boolean;
    /** 是否存在产品代码配置 */
    existProduct!: boolean;
    /** 是否存在同系列同交期配置 */
    exiesSriesFrameNo!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.existVc = _data["existVc"] !== undefined ? _data["existVc"] : null as any;
            this.existProduct = _data["existProduct"] !== undefined ? _data["existProduct"] : null as any;
            this.exiesSriesFrameNo = _data["exiesSriesFrameNo"] !== undefined ? _data["exiesSriesFrameNo"] : null as any;
        }
    }

    static fromJS(data: any): RepetitivePriceVcDto {
        data = typeof data === 'object' ? data : {};
        let result = new RepetitivePriceVcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["existVc"] = this.existVc !== undefined ? this.existVc : null as any;
        data["existProduct"] = this.existProduct !== undefined ? this.existProduct : null as any;
        data["exiesSriesFrameNo"] = this.exiesSriesFrameNo !== undefined ? this.exiesSriesFrameNo : null as any;
        return data;
    }
}

export class RepetitiveSriesFrameNoSearchDto {
    /** 自定义VC编号 */
    vcID!: string | null;
    /** 自定义VC编号 */
    customVcId!: string | null;
    /** 自定义VC面价及交期编号 */
    customVcPriceId!: string | null;
    /** 主机代码 */
    basicMotorCode!: string | null;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 机座号 */
    frameNo!: number | null;

    init(_data?: any) {
        if (_data) {
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.customVcId = _data["customVcId"] !== undefined ? _data["customVcId"] : null as any;
            this.customVcPriceId = _data["customVcPriceId"] !== undefined ? _data["customVcPriceId"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
        }
    }

    static fromJS(data: any): RepetitiveSriesFrameNoSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new RepetitiveSriesFrameNoSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["customVcId"] = this.customVcId !== undefined ? this.customVcId : null as any;
        data["customVcPriceId"] = this.customVcPriceId !== undefined ? this.customVcPriceId : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        return data;
    }
}

export class ReturnMessage {
    success!: boolean;
    message!: string | null;
    errorCode!: number;
    content!: any | null;

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.errorCode = _data["errorCode"] !== undefined ? _data["errorCode"] : null as any;
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
        }
    }

    static fromJS(data: any): ReturnMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["errorCode"] = this.errorCode !== undefined ? this.errorCode : null as any;
        data["content"] = this.content !== undefined ? this.content : null as any;
        return data;
    }
}

export class RuntimeFieldHandle {
    value!: IntPtr;

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : null as any;
        }
    }

    static fromJS(data: any): RuntimeFieldHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeFieldHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : null as any;
        return data;
    }
}

export class RuntimeMethodHandle {
    value!: IntPtr;

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : null as any;
        }
    }

    static fromJS(data: any): RuntimeMethodHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeMethodHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : null as any;
        return data;
    }
}

export class RuntimeTypeHandle {
    value!: IntPtr;

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : null as any;
        }
    }

    static fromJS(data: any): RuntimeTypeHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeTypeHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : null as any;
        return data;
    }
}

export class SMProduct {
    quotationNumber!: string | null;
    exectMultiplier!: number | null;
    approverMultiplier!: number | null;
    massQuotationNumberId!: string | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    id!: string;
    basicMotorType!: BasicMotorType;
    isCustomerCode!: boolean;
    customerMaterialNumber!: string | null;
    numberOfProduct!: number;
    jinCategoryCode!: string | null;
    basicMotorModel!: string | null;
    jinBasicMotorModel!: string | null;
    basicMotorMounting!: string | null;
    jinBasicMotorMounting!: string | null;
    basicMotorSries!: string | null;
    jinBasicMotorSries!: string | null;
    power!: string | null;
    jinPower!: string | null;
    basicMotorCode!: string | null;
    jinBasicMotorCode!: string | null;
    isSupply!: boolean;
    frameSize!: number;
    jinFrameSize!: number;
    materialDescription!: string | null;
    unitPriceResult!: string | null;
    unitPriceType!: string | null;
    unitPriceExpiredTime!: moment.Moment | null;
    unitPrice!: number;
    jinWiringMode!: string | null;
    jinEneEff!: string | null;
    jinUnitPrice!: number;
    salesPrice!: number | null;
    cost!: number | null;
    costType!: CostType;
    quotationPrinciple!: string | null;
    quotationPrincipleDetails!: string | null;
    multipilerType!: MultipilerType;
    defaultMultiplier!: number;
    jinMultipilerType!: MultipilerType;
    jinVersion!: string | null;
    listPriceMultiplier!: number;
    expectMultiplier!: number | null;
    precalMultiplierExpiredDateTime!: moment.Moment | null;
    precalID!: string | null;
    internalText!: string | null;
    price!: number;
    productPrice!: number;
    remark!: string | null;
    remarkTwo!: string | null;
    vc!: SMVC[] | null;
    isCustomMotor!: boolean;
    readonly standardVcs!: SMVC[] | null;
    insideVCOpenRemarks!: string | null;
    prdTech!: Prdtech;
    prdElecs!: Prdelec[] | null;
    technicalConfirmation!: string | null;
    technicalSpecification!: string | null;
    source!: ProdcutAndVcSource;
    encoder!: string | null;
    eneEff!: string | null;
    frequency!: string | null;
    isHaveVc!: IsHaveVc;
    isNeedHeightOutput!: IsYes;
    poleNo!: string | null;
    wiringMode!: string | null;
    voltage!: string | null;
    expectedDeliveryDate!: number;
    cycle!: number;
    addVcs!: string | null;
    delVcs!: string | null;
    dqProduct!: GetTechnologyQuotationProductDto;
    teProduct!: GetTechnologyQuotationProductDto;
    checkResultOutput!: CheckResultOutput;
    discountUnitPrice!: number | null;
    noDiscountByPlatformUnitPrice!: number | null;
    noDiscountByListUnitPrice!: number | null;
    gssQuotationNo!: string | null;
    gssTechnicalConfirmationNumber!: string | null;
    appraisalNumber!: string | null;
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    productionCycle!: number;
    testCycle!: number;
    capacityCycle!: number;
    grCycle!: number;
    inToOutCycle!: number;
    serialNo!: number;
    submit!: boolean;
    precalItemNo!: number | null;
    sourceLectoTypeID!: string | null;
    isNewPMSProduct!: boolean | null;
    totalListPriceExcludenoDiscountVC!: number | null;
    allowEditing!: boolean;
    orderProductId!: string | null;
    pmsMultiplier!: number | null;
    originalMultiplier!: number | null;
    agreementChanges!: boolean;
    technologyQuotationProductId!: string | null;
    technicalSpecificationProductId!: string | null;
    changeSelected!: boolean;
    mspSourceType!: MSPSourceTypeEnum;
    mspSourceID!: string | null;
    mspSourceProduct!: MSPSourceProduct[] | null;
    gcsHelpProductId!: string | null;
    gcsSourceProduct!: MSPSourceProduct[] | null;
    voltageCode!: string | null;
    makeOrBuy!: string | null;
    listPriceBasicMotorPriceId!: string | null;
    listPriceJINCode!: string | null;
    customMotorParameters!: LectoTypeProductParameterDto[] | null;
    lectoTypeCustomProductPrice!: LectoTypeCustomProductPriceDto;
    isChangeVC163209!: boolean;

    init(_data?: any) {
        if (_data) {
            this.quotationNumber = _data["quotationNumber"] !== undefined ? _data["quotationNumber"] : null as any;
            this.exectMultiplier = _data["exectMultiplier"] !== undefined ? _data["exectMultiplier"] : null as any;
            this.approverMultiplier = _data["approverMultiplier"] !== undefined ? _data["approverMultiplier"] : null as any;
            this.massQuotationNumberId = _data["massQuotationNumberId"] !== undefined ? _data["massQuotationNumberId"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorType = _data["basicMotorType"] !== undefined ? _data["basicMotorType"] : null as any;
            this.isCustomerCode = _data["isCustomerCode"] !== undefined ? _data["isCustomerCode"] : null as any;
            this.customerMaterialNumber = _data["customerMaterialNumber"] !== undefined ? _data["customerMaterialNumber"] : null as any;
            this.numberOfProduct = _data["numberOfProduct"] !== undefined ? _data["numberOfProduct"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.jinBasicMotorModel = _data["jinBasicMotorModel"] !== undefined ? _data["jinBasicMotorModel"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.jinBasicMotorMounting = _data["jinBasicMotorMounting"] !== undefined ? _data["jinBasicMotorMounting"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.jinBasicMotorSries = _data["jinBasicMotorSries"] !== undefined ? _data["jinBasicMotorSries"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.jinPower = _data["jinPower"] !== undefined ? _data["jinPower"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.jinBasicMotorCode = _data["jinBasicMotorCode"] !== undefined ? _data["jinBasicMotorCode"] : null as any;
            this.isSupply = _data["isSupply"] !== undefined ? _data["isSupply"] : null as any;
            this.frameSize = _data["frameSize"] !== undefined ? _data["frameSize"] : null as any;
            this.jinFrameSize = _data["jinFrameSize"] !== undefined ? _data["jinFrameSize"] : null as any;
            this.materialDescription = _data["materialDescription"] !== undefined ? _data["materialDescription"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.unitPriceExpiredTime = _data["unitPriceExpiredTime"] ? moment(_data["unitPriceExpiredTime"].toString()) : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.jinWiringMode = _data["jinWiringMode"] !== undefined ? _data["jinWiringMode"] : null as any;
            this.jinEneEff = _data["jinEneEff"] !== undefined ? _data["jinEneEff"] : null as any;
            this.jinUnitPrice = _data["jinUnitPrice"] !== undefined ? _data["jinUnitPrice"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.multipilerType = _data["multipilerType"] !== undefined ? _data["multipilerType"] : null as any;
            this.defaultMultiplier = _data["defaultMultiplier"] !== undefined ? _data["defaultMultiplier"] : null as any;
            this.jinMultipilerType = _data["jinMultipilerType"] !== undefined ? _data["jinMultipilerType"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.listPriceMultiplier = _data["listPriceMultiplier"] !== undefined ? _data["listPriceMultiplier"] : null as any;
            this.expectMultiplier = _data["expectMultiplier"] !== undefined ? _data["expectMultiplier"] : null as any;
            this.precalMultiplierExpiredDateTime = _data["precalMultiplierExpiredDateTime"] ? moment(_data["precalMultiplierExpiredDateTime"].toString()) : null as any;
            this.precalID = _data["precalID"] !== undefined ? _data["precalID"] : null as any;
            this.internalText = _data["internalText"] !== undefined ? _data["internalText"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            this.productPrice = _data["productPrice"] !== undefined ? _data["productPrice"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.remarkTwo = _data["remarkTwo"] !== undefined ? _data["remarkTwo"] : null as any;
            if (Array.isArray(_data["vc"])) {
                this.vc = [] as any;
                for (let item of _data["vc"])
                    this.vc!.push(SMVC.fromJS(item));
            }
            else {
                this.vc = null as any;
            }
            this.isCustomMotor = _data["isCustomMotor"] !== undefined ? _data["isCustomMotor"] : null as any;
            if (Array.isArray(_data["standardVcs"])) {
                (this as any).standardVcs = [] as any;
                for (let item of _data["standardVcs"])
                    (this as any).standardVcs!.push(SMVC.fromJS(item));
            }
            else {
                (this as any).standardVcs = null as any;
            }
            this.insideVCOpenRemarks = _data["insideVCOpenRemarks"] !== undefined ? _data["insideVCOpenRemarks"] : null as any;
            this.prdTech = _data["prdTech"] ? Prdtech.fromJS(_data["prdTech"]) : null as any;
            if (Array.isArray(_data["prdElecs"])) {
                this.prdElecs = [] as any;
                for (let item of _data["prdElecs"])
                    this.prdElecs!.push(Prdelec.fromJS(item));
            }
            else {
                this.prdElecs = null as any;
            }
            this.technicalConfirmation = _data["technicalConfirmation"] !== undefined ? _data["technicalConfirmation"] : null as any;
            this.technicalSpecification = _data["technicalSpecification"] !== undefined ? _data["technicalSpecification"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.encoder = _data["encoder"] !== undefined ? _data["encoder"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.isHaveVc = _data["isHaveVc"] !== undefined ? _data["isHaveVc"] : null as any;
            this.isNeedHeightOutput = _data["isNeedHeightOutput"] !== undefined ? _data["isNeedHeightOutput"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] !== undefined ? _data["expectedDeliveryDate"] : null as any;
            this.cycle = _data["cycle"] !== undefined ? _data["cycle"] : null as any;
            this.addVcs = _data["addVcs"] !== undefined ? _data["addVcs"] : null as any;
            this.delVcs = _data["delVcs"] !== undefined ? _data["delVcs"] : null as any;
            this.dqProduct = _data["dqProduct"] ? GetTechnologyQuotationProductDto.fromJS(_data["dqProduct"]) : null as any;
            this.teProduct = _data["teProduct"] ? GetTechnologyQuotationProductDto.fromJS(_data["teProduct"]) : null as any;
            this.checkResultOutput = _data["checkResultOutput"] ? CheckResultOutput.fromJS(_data["checkResultOutput"]) : null as any;
            this.discountUnitPrice = _data["discountUnitPrice"] !== undefined ? _data["discountUnitPrice"] : null as any;
            this.noDiscountByPlatformUnitPrice = _data["noDiscountByPlatformUnitPrice"] !== undefined ? _data["noDiscountByPlatformUnitPrice"] : null as any;
            this.noDiscountByListUnitPrice = _data["noDiscountByListUnitPrice"] !== undefined ? _data["noDiscountByListUnitPrice"] : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.appraisalNumber = _data["appraisalNumber"] !== undefined ? _data["appraisalNumber"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.capacityCycle = _data["capacityCycle"] !== undefined ? _data["capacityCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.inToOutCycle = _data["inToOutCycle"] !== undefined ? _data["inToOutCycle"] : null as any;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : null as any;
            this.submit = _data["submit"] !== undefined ? _data["submit"] : null as any;
            this.precalItemNo = _data["precalItemNo"] !== undefined ? _data["precalItemNo"] : null as any;
            this.sourceLectoTypeID = _data["sourceLectoTypeID"] !== undefined ? _data["sourceLectoTypeID"] : null as any;
            this.isNewPMSProduct = _data["isNewPMSProduct"] !== undefined ? _data["isNewPMSProduct"] : null as any;
            this.totalListPriceExcludenoDiscountVC = _data["totalListPriceExcludenoDiscountVC"] !== undefined ? _data["totalListPriceExcludenoDiscountVC"] : null as any;
            this.allowEditing = _data["allowEditing"] !== undefined ? _data["allowEditing"] : null as any;
            this.orderProductId = _data["orderProductId"] !== undefined ? _data["orderProductId"] : null as any;
            this.pmsMultiplier = _data["pmsMultiplier"] !== undefined ? _data["pmsMultiplier"] : null as any;
            this.originalMultiplier = _data["originalMultiplier"] !== undefined ? _data["originalMultiplier"] : null as any;
            this.agreementChanges = _data["agreementChanges"] !== undefined ? _data["agreementChanges"] : null as any;
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
            this.technicalSpecificationProductId = _data["technicalSpecificationProductId"] !== undefined ? _data["technicalSpecificationProductId"] : null as any;
            this.changeSelected = _data["changeSelected"] !== undefined ? _data["changeSelected"] : null as any;
            this.mspSourceType = _data["mspSourceType"] !== undefined ? _data["mspSourceType"] : null as any;
            this.mspSourceID = _data["mspSourceID"] !== undefined ? _data["mspSourceID"] : null as any;
            if (Array.isArray(_data["mspSourceProduct"])) {
                this.mspSourceProduct = [] as any;
                for (let item of _data["mspSourceProduct"])
                    this.mspSourceProduct!.push(MSPSourceProduct.fromJS(item));
            }
            else {
                this.mspSourceProduct = null as any;
            }
            this.gcsHelpProductId = _data["gcsHelpProductId"] !== undefined ? _data["gcsHelpProductId"] : null as any;
            if (Array.isArray(_data["gcsSourceProduct"])) {
                this.gcsSourceProduct = [] as any;
                for (let item of _data["gcsSourceProduct"])
                    this.gcsSourceProduct!.push(MSPSourceProduct.fromJS(item));
            }
            else {
                this.gcsSourceProduct = null as any;
            }
            this.voltageCode = _data["voltageCode"] !== undefined ? _data["voltageCode"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.listPriceBasicMotorPriceId = _data["listPriceBasicMotorPriceId"] !== undefined ? _data["listPriceBasicMotorPriceId"] : null as any;
            this.listPriceJINCode = _data["listPriceJINCode"] !== undefined ? _data["listPriceJINCode"] : null as any;
            if (Array.isArray(_data["customMotorParameters"])) {
                this.customMotorParameters = [] as any;
                for (let item of _data["customMotorParameters"])
                    this.customMotorParameters!.push(LectoTypeProductParameterDto.fromJS(item));
            }
            else {
                this.customMotorParameters = null as any;
            }
            this.lectoTypeCustomProductPrice = _data["lectoTypeCustomProductPrice"] ? LectoTypeCustomProductPriceDto.fromJS(_data["lectoTypeCustomProductPrice"]) : null as any;
            this.isChangeVC163209 = _data["isChangeVC163209"] !== undefined ? _data["isChangeVC163209"] : null as any;
        }
    }

    static fromJS(data: any): SMProduct {
        data = typeof data === 'object' ? data : {};
        let result = new SMProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quotationNumber"] = this.quotationNumber !== undefined ? this.quotationNumber : null as any;
        data["exectMultiplier"] = this.exectMultiplier !== undefined ? this.exectMultiplier : null as any;
        data["approverMultiplier"] = this.approverMultiplier !== undefined ? this.approverMultiplier : null as any;
        data["massQuotationNumberId"] = this.massQuotationNumberId !== undefined ? this.massQuotationNumberId : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorType"] = this.basicMotorType !== undefined ? this.basicMotorType : null as any;
        data["isCustomerCode"] = this.isCustomerCode !== undefined ? this.isCustomerCode : null as any;
        data["customerMaterialNumber"] = this.customerMaterialNumber !== undefined ? this.customerMaterialNumber : null as any;
        data["numberOfProduct"] = this.numberOfProduct !== undefined ? this.numberOfProduct : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["jinBasicMotorModel"] = this.jinBasicMotorModel !== undefined ? this.jinBasicMotorModel : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["jinBasicMotorMounting"] = this.jinBasicMotorMounting !== undefined ? this.jinBasicMotorMounting : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["jinBasicMotorSries"] = this.jinBasicMotorSries !== undefined ? this.jinBasicMotorSries : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["jinPower"] = this.jinPower !== undefined ? this.jinPower : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["jinBasicMotorCode"] = this.jinBasicMotorCode !== undefined ? this.jinBasicMotorCode : null as any;
        data["isSupply"] = this.isSupply !== undefined ? this.isSupply : null as any;
        data["frameSize"] = this.frameSize !== undefined ? this.frameSize : null as any;
        data["jinFrameSize"] = this.jinFrameSize !== undefined ? this.jinFrameSize : null as any;
        data["materialDescription"] = this.materialDescription !== undefined ? this.materialDescription : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["unitPriceExpiredTime"] = this.unitPriceExpiredTime ? this.unitPriceExpiredTime.toISOString() : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["jinWiringMode"] = this.jinWiringMode !== undefined ? this.jinWiringMode : null as any;
        data["jinEneEff"] = this.jinEneEff !== undefined ? this.jinEneEff : null as any;
        data["jinUnitPrice"] = this.jinUnitPrice !== undefined ? this.jinUnitPrice : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["multipilerType"] = this.multipilerType !== undefined ? this.multipilerType : null as any;
        data["defaultMultiplier"] = this.defaultMultiplier !== undefined ? this.defaultMultiplier : null as any;
        data["jinMultipilerType"] = this.jinMultipilerType !== undefined ? this.jinMultipilerType : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["listPriceMultiplier"] = this.listPriceMultiplier !== undefined ? this.listPriceMultiplier : null as any;
        data["expectMultiplier"] = this.expectMultiplier !== undefined ? this.expectMultiplier : null as any;
        data["precalMultiplierExpiredDateTime"] = this.precalMultiplierExpiredDateTime ? this.precalMultiplierExpiredDateTime.toISOString() : null as any;
        data["precalID"] = this.precalID !== undefined ? this.precalID : null as any;
        data["internalText"] = this.internalText !== undefined ? this.internalText : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["productPrice"] = this.productPrice !== undefined ? this.productPrice : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["remarkTwo"] = this.remarkTwo !== undefined ? this.remarkTwo : null as any;
        if (Array.isArray(this.vc)) {
            data["vc"] = [];
            for (let item of this.vc)
                data["vc"].push(item ? item.toJSON() : null as any);
        }
        data["isCustomMotor"] = this.isCustomMotor !== undefined ? this.isCustomMotor : null as any;
        if (Array.isArray(this.standardVcs)) {
            data["standardVcs"] = [];
            for (let item of this.standardVcs)
                data["standardVcs"].push(item ? item.toJSON() : null as any);
        }
        data["insideVCOpenRemarks"] = this.insideVCOpenRemarks !== undefined ? this.insideVCOpenRemarks : null as any;
        data["prdTech"] = this.prdTech ? this.prdTech.toJSON() : null as any;
        if (Array.isArray(this.prdElecs)) {
            data["prdElecs"] = [];
            for (let item of this.prdElecs)
                data["prdElecs"].push(item ? item.toJSON() : null as any);
        }
        data["technicalConfirmation"] = this.technicalConfirmation !== undefined ? this.technicalConfirmation : null as any;
        data["technicalSpecification"] = this.technicalSpecification !== undefined ? this.technicalSpecification : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["encoder"] = this.encoder !== undefined ? this.encoder : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["isHaveVc"] = this.isHaveVc !== undefined ? this.isHaveVc : null as any;
        data["isNeedHeightOutput"] = this.isNeedHeightOutput !== undefined ? this.isNeedHeightOutput : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate !== undefined ? this.expectedDeliveryDate : null as any;
        data["cycle"] = this.cycle !== undefined ? this.cycle : null as any;
        data["addVcs"] = this.addVcs !== undefined ? this.addVcs : null as any;
        data["delVcs"] = this.delVcs !== undefined ? this.delVcs : null as any;
        data["dqProduct"] = this.dqProduct ? this.dqProduct.toJSON() : null as any;
        data["teProduct"] = this.teProduct ? this.teProduct.toJSON() : null as any;
        data["checkResultOutput"] = this.checkResultOutput ? this.checkResultOutput.toJSON() : null as any;
        data["discountUnitPrice"] = this.discountUnitPrice !== undefined ? this.discountUnitPrice : null as any;
        data["noDiscountByPlatformUnitPrice"] = this.noDiscountByPlatformUnitPrice !== undefined ? this.noDiscountByPlatformUnitPrice : null as any;
        data["noDiscountByListUnitPrice"] = this.noDiscountByListUnitPrice !== undefined ? this.noDiscountByListUnitPrice : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["appraisalNumber"] = this.appraisalNumber !== undefined ? this.appraisalNumber : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["capacityCycle"] = this.capacityCycle !== undefined ? this.capacityCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["inToOutCycle"] = this.inToOutCycle !== undefined ? this.inToOutCycle : null as any;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : null as any;
        data["submit"] = this.submit !== undefined ? this.submit : null as any;
        data["precalItemNo"] = this.precalItemNo !== undefined ? this.precalItemNo : null as any;
        data["sourceLectoTypeID"] = this.sourceLectoTypeID !== undefined ? this.sourceLectoTypeID : null as any;
        data["isNewPMSProduct"] = this.isNewPMSProduct !== undefined ? this.isNewPMSProduct : null as any;
        data["totalListPriceExcludenoDiscountVC"] = this.totalListPriceExcludenoDiscountVC !== undefined ? this.totalListPriceExcludenoDiscountVC : null as any;
        data["allowEditing"] = this.allowEditing !== undefined ? this.allowEditing : null as any;
        data["orderProductId"] = this.orderProductId !== undefined ? this.orderProductId : null as any;
        data["pmsMultiplier"] = this.pmsMultiplier !== undefined ? this.pmsMultiplier : null as any;
        data["originalMultiplier"] = this.originalMultiplier !== undefined ? this.originalMultiplier : null as any;
        data["agreementChanges"] = this.agreementChanges !== undefined ? this.agreementChanges : null as any;
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        data["technicalSpecificationProductId"] = this.technicalSpecificationProductId !== undefined ? this.technicalSpecificationProductId : null as any;
        data["changeSelected"] = this.changeSelected !== undefined ? this.changeSelected : null as any;
        data["mspSourceType"] = this.mspSourceType !== undefined ? this.mspSourceType : null as any;
        data["mspSourceID"] = this.mspSourceID !== undefined ? this.mspSourceID : null as any;
        if (Array.isArray(this.mspSourceProduct)) {
            data["mspSourceProduct"] = [];
            for (let item of this.mspSourceProduct)
                data["mspSourceProduct"].push(item ? item.toJSON() : null as any);
        }
        data["gcsHelpProductId"] = this.gcsHelpProductId !== undefined ? this.gcsHelpProductId : null as any;
        if (Array.isArray(this.gcsSourceProduct)) {
            data["gcsSourceProduct"] = [];
            for (let item of this.gcsSourceProduct)
                data["gcsSourceProduct"].push(item ? item.toJSON() : null as any);
        }
        data["voltageCode"] = this.voltageCode !== undefined ? this.voltageCode : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["listPriceBasicMotorPriceId"] = this.listPriceBasicMotorPriceId !== undefined ? this.listPriceBasicMotorPriceId : null as any;
        data["listPriceJINCode"] = this.listPriceJINCode !== undefined ? this.listPriceJINCode : null as any;
        if (Array.isArray(this.customMotorParameters)) {
            data["customMotorParameters"] = [];
            for (let item of this.customMotorParameters)
                data["customMotorParameters"].push(item ? item.toJSON() : null as any);
        }
        data["lectoTypeCustomProductPrice"] = this.lectoTypeCustomProductPrice ? this.lectoTypeCustomProductPrice.toJSON() : null as any;
        data["isChangeVC163209"] = this.isChangeVC163209 !== undefined ? this.isChangeVC163209 : null as any;
        return data;
    }
}

export class SMRecord {
    propStatus!: LectoTypeStatus;
    currentStatus!: LectoTypeStatus;
    remark!: string | null;
    name!: string | null;
    id!: number | null;
    creationTime!: moment.Moment;

    init(_data?: any) {
        if (_data) {
            this.propStatus = _data["propStatus"] !== undefined ? _data["propStatus"] : null as any;
            this.currentStatus = _data["currentStatus"] !== undefined ? _data["currentStatus"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): SMRecord {
        data = typeof data === 'object' ? data : {};
        let result = new SMRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propStatus"] = this.propStatus !== undefined ? this.propStatus : null as any;
        data["currentStatus"] = this.currentStatus !== undefined ? this.currentStatus : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        return data;
    }
}

export class SMVC {
    id!: string;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    category!: string | null;
    meaning!: string | null;
    remark!: string | null;
    vcTypeDescription!: string | null;
    numberWires!: number;
    vcProductCode!: string | null;
    vcCode!: string | null;
    unitPriceResult!: string | null;
    unitPriceType!: string | null;
    unitPrice!: number | null;
    isMulListPriceMultiplier!: boolean | null;
    standardUnitPrice!: number | null;
    unitPriceFormula!: string | null;
    unitPriceExpiredTime!: moment.Moment | null;
    discountType!: UnitPriceType;
    cost!: number;
    costFormula!: string | null;
    costType!: CostType;
    costTypeDetail!: string | null;
    quotationPrinciple!: string | null;
    quotationPrincipleDetails!: string | null;
    vcType!: VcType;
    vcShowType!: VCShowType;
    vcFreeText!: Vcfreetext[] | null;
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    productionCycle!: number;
    testCycle!: number;
    shipSurveyCycle!: number;
    grCycle!: number;
    source!: ProdcutAndVcSource;
    dqProductVc!: GetTechnologyQuotationProductVCDto;
    teProductVc!: GetTechnologyQuotationProductVCDto;
    isInside!: boolean;
    isNewProductVC!: boolean | null;
    technologyQuotationProductVCId!: string | null;
    technicalSpecificationProductVCId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.vcProductCode = _data["vcProductCode"] !== undefined ? _data["vcProductCode"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.isMulListPriceMultiplier = _data["isMulListPriceMultiplier"] !== undefined ? _data["isMulListPriceMultiplier"] : null as any;
            this.standardUnitPrice = _data["standardUnitPrice"] !== undefined ? _data["standardUnitPrice"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.unitPriceExpiredTime = _data["unitPriceExpiredTime"] ? moment(_data["unitPriceExpiredTime"].toString()) : null as any;
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            if (Array.isArray(_data["vcFreeText"])) {
                this.vcFreeText = [] as any;
                for (let item of _data["vcFreeText"])
                    this.vcFreeText!.push(Vcfreetext.fromJS(item));
            }
            else {
                this.vcFreeText = null as any;
            }
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.dqProductVc = _data["dqProductVc"] ? GetTechnologyQuotationProductVCDto.fromJS(_data["dqProductVc"]) : null as any;
            this.teProductVc = _data["teProductVc"] ? GetTechnologyQuotationProductVCDto.fromJS(_data["teProductVc"]) : null as any;
            this.isInside = _data["isInside"] !== undefined ? _data["isInside"] : null as any;
            this.isNewProductVC = _data["isNewProductVC"] !== undefined ? _data["isNewProductVC"] : null as any;
            this.technologyQuotationProductVCId = _data["technologyQuotationProductVCId"] !== undefined ? _data["technologyQuotationProductVCId"] : null as any;
            this.technicalSpecificationProductVCId = _data["technicalSpecificationProductVCId"] !== undefined ? _data["technicalSpecificationProductVCId"] : null as any;
        }
    }

    static fromJS(data: any): SMVC {
        data = typeof data === 'object' ? data : {};
        let result = new SMVC();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["vcProductCode"] = this.vcProductCode !== undefined ? this.vcProductCode : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["isMulListPriceMultiplier"] = this.isMulListPriceMultiplier !== undefined ? this.isMulListPriceMultiplier : null as any;
        data["standardUnitPrice"] = this.standardUnitPrice !== undefined ? this.standardUnitPrice : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["unitPriceExpiredTime"] = this.unitPriceExpiredTime ? this.unitPriceExpiredTime.toISOString() : null as any;
        data["discountType"] = this.discountType !== undefined ? this.discountType : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        if (Array.isArray(this.vcFreeText)) {
            data["vcFreeText"] = [];
            for (let item of this.vcFreeText)
                data["vcFreeText"].push(item ? item.toJSON() : null as any);
        }
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["dqProductVc"] = this.dqProductVc ? this.dqProductVc.toJSON() : null as any;
        data["teProductVc"] = this.teProductVc ? this.teProductVc.toJSON() : null as any;
        data["isInside"] = this.isInside !== undefined ? this.isInside : null as any;
        data["isNewProductVC"] = this.isNewProductVC !== undefined ? this.isNewProductVC : null as any;
        data["technologyQuotationProductVCId"] = this.technologyQuotationProductVCId !== undefined ? this.technologyQuotationProductVCId : null as any;
        data["technicalSpecificationProductVCId"] = this.technicalSpecificationProductVCId !== undefined ? this.technicalSpecificationProductVCId : null as any;
        return data;
    }
}

export class SaleHelpDisCountCompletedInPut {
    id!: string;
    remark!: string | null;
    lists!: SaleHelpDisCountCompletedProductsInPut[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            if (Array.isArray(_data["lists"])) {
                this.lists = [] as any;
                for (let item of _data["lists"])
                    this.lists!.push(SaleHelpDisCountCompletedProductsInPut.fromJS(item));
            }
            else {
                this.lists = null as any;
            }
        }
    }

    static fromJS(data: any): SaleHelpDisCountCompletedInPut {
        data = typeof data === 'object' ? data : {};
        let result = new SaleHelpDisCountCompletedInPut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        if (Array.isArray(this.lists)) {
            data["lists"] = [];
            for (let item of this.lists)
                data["lists"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class SaleHelpDisCountCompletedProductsInPut {
    id!: string;
    expectMultiplier!: number | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.expectMultiplier = _data["expectMultiplier"] !== undefined ? _data["expectMultiplier"] : null as any;
        }
    }

    static fromJS(data: any): SaleHelpDisCountCompletedProductsInPut {
        data = typeof data === 'object' ? data : {};
        let result = new SaleHelpDisCountCompletedProductsInPut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["expectMultiplier"] = this.expectMultiplier !== undefined ? this.expectMultiplier : null as any;
        return data;
    }
}

/** 0 = None 1 = Level1 2 = Level2 */
export enum SecurityRuleSet {
    None = 0,
    Level1 = 1,
    Level2 = 2,
}

export class SelectDto {
    value!: string | null;
    label!: string | null;

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
        }
    }

    static fromJS(data: any): SelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        return data;
    }
}

export class SetPReCalNumberInPutDto {
    id!: string;
    precalID!: string | null;
    precalIDSoucre!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.precalID = _data["precalID"] !== undefined ? _data["precalID"] : null as any;
            this.precalIDSoucre = _data["precalIDSoucre"] !== undefined ? _data["precalIDSoucre"] : null as any;
        }
    }

    static fromJS(data: any): SetPReCalNumberInPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetPReCalNumberInPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["precalID"] = this.precalID !== undefined ? this.precalID : null as any;
        data["precalIDSoucre"] = this.precalIDSoucre !== undefined ? this.precalIDSoucre : null as any;
        return data;
    }
}

export class SingleVCNotificationRulesDto {
    id!: string;
    productType!: string | null;
    seatNoMax!: number;
    seatNoMin!: number;
    sort!: number;
    promptContent!: string | null;
    vCId!: string | null;
    creationTime!: moment.Moment;
    lastModificationTime!: moment.Moment | null;
    isDeleted!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.productType = _data["productType"] !== undefined ? _data["productType"] : null as any;
            this.seatNoMax = _data["seatNoMax"] !== undefined ? _data["seatNoMax"] : null as any;
            this.seatNoMin = _data["seatNoMin"] !== undefined ? _data["seatNoMin"] : null as any;
            this.sort = _data["sort"] !== undefined ? _data["sort"] : null as any;
            this.promptContent = _data["promptContent"] !== undefined ? _data["promptContent"] : null as any;
            this.vCId = _data["vCId"] !== undefined ? _data["vCId"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
        }
    }

    static fromJS(data: any): SingleVCNotificationRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SingleVCNotificationRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["productType"] = this.productType !== undefined ? this.productType : null as any;
        data["seatNoMax"] = this.seatNoMax !== undefined ? this.seatNoMax : null as any;
        data["seatNoMin"] = this.seatNoMin !== undefined ? this.seatNoMin : null as any;
        data["sort"] = this.sort !== undefined ? this.sort : null as any;
        data["promptContent"] = this.promptContent !== undefined ? this.promptContent : null as any;
        data["vCId"] = this.vCId !== undefined ? this.vCId : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        return data;
    }
}

export class SingleVCNotificationRulesDtoPagedResultDto {
    items!: SingleVCNotificationRulesDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SingleVCNotificationRulesDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): SingleVCNotificationRulesDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SingleVCNotificationRulesDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 0 = User (User) 1 = Pms (Pms) 2 = Ccs (Ccs) 3 = LP (LP) */
export enum SourceType {
    User = 0,
    Pms = 1,
    Ccs = 2,
    LP = 3,
}

export class SpeciaVcDto {
    id!: string;
    /** 创建人编号 */
    creatorUserId!: number | null;
    /** 创建人 */
    creatorUser!: string | null;
    /** 创建日期 */
    creationTime!: moment.Moment;
    /** VcCode */
    code!: string | null;
    /** 品类 */
    categoryId!: string;
    /** 品类 */
    category!: string | null;
    /** VC含义 */
    meaning!: string | null;
    /** VC英文含义 */
    englishMeaning!: string | null;
    /** VC备注 */
    description!: string | null;
    /** VC头数 */
    numberWires!: number;
    showType!: VCShowType;
    /** 显示类型 */
    readonly showTypeString!: string | null;
    vcOpenOrClose!: VcOpenOrClose;
    /** 属性名 */
    attributeName!: string | null;
    /** 属性选择 */
    attributeSelect!: string | null;
    /** 下单次数 */
    placeOrderCount!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.creatorUser = _data["creatorUser"] !== undefined ? _data["creatorUser"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.showType = _data["showType"] !== undefined ? _data["showType"] : null as any;
            (this as any).showTypeString = _data["showTypeString"] !== undefined ? _data["showTypeString"] : null as any;
            this.vcOpenOrClose = _data["vcOpenOrClose"] !== undefined ? _data["vcOpenOrClose"] : null as any;
            this.attributeName = _data["attributeName"] !== undefined ? _data["attributeName"] : null as any;
            this.attributeSelect = _data["attributeSelect"] !== undefined ? _data["attributeSelect"] : null as any;
            this.placeOrderCount = _data["placeOrderCount"] !== undefined ? _data["placeOrderCount"] : null as any;
        }
    }

    static fromJS(data: any): SpeciaVcDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpeciaVcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["creatorUser"] = this.creatorUser !== undefined ? this.creatorUser : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["showType"] = this.showType !== undefined ? this.showType : null as any;
        data["showTypeString"] = this.showTypeString !== undefined ? this.showTypeString : null as any;
        data["vcOpenOrClose"] = this.vcOpenOrClose !== undefined ? this.vcOpenOrClose : null as any;
        data["attributeName"] = this.attributeName !== undefined ? this.attributeName : null as any;
        data["attributeSelect"] = this.attributeSelect !== undefined ? this.attributeSelect : null as any;
        data["placeOrderCount"] = this.placeOrderCount !== undefined ? this.placeOrderCount : null as any;
        return data;
    }
}

export class SpeciaVcDtoPagedResultDto {
    items!: SpeciaVcDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SpeciaVcDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): SpeciaVcDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpeciaVcDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 1 = Year (年度特价) 2 = Project (项目特价) */
export enum SpecialTypeEnum {
    Year = 1,
    Project = 2,
}

export class SpecialVCodeInput {
    appId!: string | null;
    variantCode!: string | null;
    variantCodeCost!: string | null;
    descriptionEN!: string | null;
    descriptionCH!: string | null;

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"] !== undefined ? _data["appId"] : null as any;
            this.variantCode = _data["variantCode"] !== undefined ? _data["variantCode"] : null as any;
            this.variantCodeCost = _data["variantCodeCost"] !== undefined ? _data["variantCodeCost"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.descriptionCH = _data["descriptionCH"] !== undefined ? _data["descriptionCH"] : null as any;
        }
    }

    static fromJS(data: any): SpecialVCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialVCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId !== undefined ? this.appId : null as any;
        data["variantCode"] = this.variantCode !== undefined ? this.variantCode : null as any;
        data["variantCodeCost"] = this.variantCodeCost !== undefined ? this.variantCodeCost : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["descriptionCH"] = this.descriptionCH !== undefined ? this.descriptionCH : null as any;
        return data;
    }
}

export class State {
    id!: number;
    jobId!: number;
    name!: string | null;
    reason!: string | null;
    createdAt!: moment.Moment;
    data!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
        }
    }

    static fromJS(data: any): State {
        data = typeof data === 'object' ? data : {};
        let result = new State();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["jobId"] = this.jobId !== undefined ? this.jobId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        return data;
    }
}

export class StructLayoutAttribute {
    readonly typeId!: any | null;
    value!: LayoutKind;

    init(_data?: any) {
        if (_data) {
            (this as any).typeId = _data["typeId"] !== undefined ? _data["typeId"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static fromJS(data: any): StructLayoutAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new StructLayoutAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId !== undefined ? this.typeId : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }
}

/** 0 = Standard (-) 1 = Confirmed (已确认) 2 = Create (新增) 3 = Remove (移除) */
export enum SyncConfirmStatus {
    Standard = 0,
    Confirmed = 1,
    Create = 2,
    Remove = 3,
}

export class SynchronizeSapBaseDto {
    id!: string;
    /** 创建时间 */
    creationTime!: moment.Moment;
    readonly creationTimeString!: string | null;
    /** 修改时间 */
    lastModificationTime!: moment.Moment | null;
    readonly lastModificationTimeString!: string | null;
    /** VC ID */
    vcID!: string | null;
    /** 品类 */
    category!: string | null;
    /** VC含义 */
    meaning!: string | null;
    /** 英文含义 */
    englishMeaning!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            (this as any).creationTimeString = _data["creationTimeString"] !== undefined ? _data["creationTimeString"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            (this as any).lastModificationTimeString = _data["lastModificationTimeString"] !== undefined ? _data["lastModificationTimeString"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
        }
    }

    static fromJS(data: any): SynchronizeSapBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SynchronizeSapBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creationTimeString"] = this.creationTimeString !== undefined ? this.creationTimeString : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModificationTimeString"] = this.lastModificationTimeString !== undefined ? this.lastModificationTimeString : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        return data;
    }
}

export class SynchronizeSapBaseDtoPagedResultDto {
    items!: SynchronizeSapBaseDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SynchronizeSapBaseDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): SynchronizeSapBaseDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SynchronizeSapBaseDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class SynchronizeSapCycleDto {
    id!: string;
    /** 创建时间 */
    creationTime!: moment.Moment;
    readonly creationTimeString!: string | null;
    /** 修改时间 */
    lastModificationTime!: moment.Moment | null;
    readonly lastModificationTimeString!: string | null;
    /** VC ID */
    vcID!: string | null;
    /** 机座号 */
    frameNo!: number;
    /** 产品系列 */
    basicMotorSries!: string | null;
    /** 工程周期（自然天） */
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    /** 工程计算方式 */
    readonly engineeringCalculationModeName!: string | null;
    /** 采购周期（自然天） */
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    /** 采购计算方式 */
    readonly purchaseCycleModeName!: string | null;
    /** 生产周期（自然天） */
    productionCycle!: number;
    /** 测试周期（自然天） */
    testCycle!: number;
    /** 船检周期（自然天） */
    shipSurveyCycle!: number;
    /** 产能周期（自然天） */
    capacityCycle!: number;
    /** GR增量 */
    grCycle!: number;
    /** 自制OR外购 */
    makeOrBuy!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            (this as any).creationTimeString = _data["creationTimeString"] !== undefined ? _data["creationTimeString"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            (this as any).lastModificationTimeString = _data["lastModificationTimeString"] !== undefined ? _data["lastModificationTimeString"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            (this as any).engineeringCalculationModeName = _data["engineeringCalculationModeName"] !== undefined ? _data["engineeringCalculationModeName"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            (this as any).purchaseCycleModeName = _data["purchaseCycleModeName"] !== undefined ? _data["purchaseCycleModeName"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.capacityCycle = _data["capacityCycle"] !== undefined ? _data["capacityCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
        }
    }

    static fromJS(data: any): SynchronizeSapCycleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SynchronizeSapCycleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creationTimeString"] = this.creationTimeString !== undefined ? this.creationTimeString : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModificationTimeString"] = this.lastModificationTimeString !== undefined ? this.lastModificationTimeString : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["engineeringCalculationModeName"] = this.engineeringCalculationModeName !== undefined ? this.engineeringCalculationModeName : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["purchaseCycleModeName"] = this.purchaseCycleModeName !== undefined ? this.purchaseCycleModeName : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["capacityCycle"] = this.capacityCycle !== undefined ? this.capacityCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        return data;
    }
}

export class SynchronizeSapCycleDtoPagedResultDto {
    items!: SynchronizeSapCycleDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SynchronizeSapCycleDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): SynchronizeSapCycleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SynchronizeSapCycleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** 0 = Standard (标准VC) 1 = Custom (自定义VC) 2 = Industry (行业VC) 4 = SpeciaVc (特殊VC) 5 = StandardProduct (标准电机) */
export enum SynchronizeSapRecordDataType {
    Standard = 0,
    Custom = 1,
    Industry = 2,
    SpeciaVc = 4,
    StandardProduct = 5,
}

/** 同步SAP记录 */
export class SynchronizeSapRecordDto {
    id!: string;
    /** 创建时间 */
    creationTime!: moment.Moment;
    readonly creationTimeString!: string | null;
    /** 标识 */
    vcId!: string | null;
    /** 请求 */
    request!: string | null;
    /** 响应 */
    response!: string | null;
    /** 是否同步 */
    synchronize!: boolean;
    readonly synchronizeString!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            (this as any).creationTimeString = _data["creationTimeString"] !== undefined ? _data["creationTimeString"] : null as any;
            this.vcId = _data["vcId"] !== undefined ? _data["vcId"] : null as any;
            this.request = _data["request"] !== undefined ? _data["request"] : null as any;
            this.response = _data["response"] !== undefined ? _data["response"] : null as any;
            this.synchronize = _data["synchronize"] !== undefined ? _data["synchronize"] : null as any;
            (this as any).synchronizeString = _data["synchronizeString"] !== undefined ? _data["synchronizeString"] : null as any;
        }
    }

    static fromJS(data: any): SynchronizeSapRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new SynchronizeSapRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creationTimeString"] = this.creationTimeString !== undefined ? this.creationTimeString : null as any;
        data["vcId"] = this.vcId !== undefined ? this.vcId : null as any;
        data["request"] = this.request !== undefined ? this.request : null as any;
        data["response"] = this.response !== undefined ? this.response : null as any;
        data["synchronize"] = this.synchronize !== undefined ? this.synchronize : null as any;
        data["synchronizeString"] = this.synchronizeString !== undefined ? this.synchronizeString : null as any;
        return data;
    }
}

export class SystemAllowPriceOutput {
    /** 是否允许申请特价 */
    allow!: boolean;
    getInventoryOutPutDto!: GetInventoryOutPutDto;

    init(_data?: any) {
        if (_data) {
            this.allow = _data["allow"] !== undefined ? _data["allow"] : null as any;
            this.getInventoryOutPutDto = _data["getInventoryOutPutDto"] ? GetInventoryOutPutDto.fromJS(_data["getInventoryOutPutDto"]) : null as any;
        }
    }

    static fromJS(data: any): SystemAllowPriceOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SystemAllowPriceOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allow"] = this.allow !== undefined ? this.allow : null as any;
        data["getInventoryOutPutDto"] = this.getInventoryOutPutDto ? this.getInventoryOutPutDto.toJSON() : null as any;
        return data;
    }
}

/** 第三方系统回写Precal特价输入对象 */
export class SystemCallbackPrecalInput {
    /** 选型编号 */
    lectoTypeId!: string;
    /** Pre-Cal单号 */
    precalId!: string | null;
    /** 申请折扣的主机集合 */
    products!: SystemCallbackPrecalProductInput[] | null;

    init(_data?: any) {
        if (_data) {
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.precalId = _data["precalId"] !== undefined ? _data["precalId"] : null as any;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(SystemCallbackPrecalProductInput.fromJS(item));
            }
            else {
                this.products = null as any;
            }
        }
    }

    static fromJS(data: any): SystemCallbackPrecalInput {
        data = typeof data === 'object' ? data : {};
        let result = new SystemCallbackPrecalInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["precalId"] = this.precalId !== undefined ? this.precalId : null as any;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 回写折扣输入对象 */
export class SystemCallbackPrecalProductInput {
    /** 选型中包含主机的编号 */
    productId!: string;
    /** 折扣 */
    expectMultiplier!: number;
    /** 报价有效期 */
    validityTill!: number;
    /** 审批时间 */
    checkedDate!: moment.Moment;
    /** Pre-Cal行号 */
    precalItemNo!: number | null;
    industryMDMCode!: string | null;
    industrySAPCode!: string | null;
    /** 审批系数 */
    approvedMultiplier!: number;
    /** 折扣类型，默认系数折扣 */
    discountType!: number | null;
    /** 一口价售价 */
    salePrice!: number | null;

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"] !== undefined ? _data["productId"] : null as any;
            this.expectMultiplier = _data["expectMultiplier"] !== undefined ? _data["expectMultiplier"] : null as any;
            this.validityTill = _data["validityTill"] !== undefined ? _data["validityTill"] : null as any;
            this.checkedDate = _data["checkedDate"] ? moment(_data["checkedDate"].toString()) : null as any;
            this.precalItemNo = _data["precalItemNo"] !== undefined ? _data["precalItemNo"] : null as any;
            this.industryMDMCode = _data["industryMDMCode"] !== undefined ? _data["industryMDMCode"] : null as any;
            this.industrySAPCode = _data["industrySAPCode"] !== undefined ? _data["industrySAPCode"] : null as any;
            this.approvedMultiplier = _data["approvedMultiplier"] !== undefined ? _data["approvedMultiplier"] : null as any;
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : null as any;
            this.salePrice = _data["salePrice"] !== undefined ? _data["salePrice"] : null as any;
        }
    }

    static fromJS(data: any): SystemCallbackPrecalProductInput {
        data = typeof data === 'object' ? data : {};
        let result = new SystemCallbackPrecalProductInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId !== undefined ? this.productId : null as any;
        data["expectMultiplier"] = this.expectMultiplier !== undefined ? this.expectMultiplier : null as any;
        data["validityTill"] = this.validityTill !== undefined ? this.validityTill : null as any;
        data["checkedDate"] = this.checkedDate ? this.checkedDate.toISOString() : null as any;
        data["precalItemNo"] = this.precalItemNo !== undefined ? this.precalItemNo : null as any;
        data["industryMDMCode"] = this.industryMDMCode !== undefined ? this.industryMDMCode : null as any;
        data["industrySAPCode"] = this.industrySAPCode !== undefined ? this.industrySAPCode : null as any;
        data["approvedMultiplier"] = this.approvedMultiplier !== undefined ? this.approvedMultiplier : null as any;
        data["discountType"] = this.discountType !== undefined ? this.discountType : null as any;
        data["salePrice"] = this.salePrice !== undefined ? this.salePrice : null as any;
        return data;
    }
}

/** 选型变更客户 */
export class SystemChangeClienterDto {
    /** 选型编号 */
    lectoTypeId!: string;
    /** 客户编号 */
    clienter!: string | null;
    /** 客户名称 */
    clientName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
        }
    }

    static fromJS(data: any): SystemChangeClienterDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemChangeClienterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        return data;
    }
}

/** 选型变更创建人 */
export class SystemChangeCreatorDto {
    /** 选型编号 */
    lectoTypeId!: string;
    /** 客户 */
    clienter!: string | null;
    /** 客户名称 */
    clientName!: string | null;
    /** 销售邮箱 */
    salesEmail!: string | null;
    /** CP客户邮箱 */
    cpEmail!: string | null;

    init(_data?: any) {
        if (_data) {
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.salesEmail = _data["salesEmail"] !== undefined ? _data["salesEmail"] : null as any;
            this.cpEmail = _data["cpEmail"] !== undefined ? _data["cpEmail"] : null as any;
        }
    }

    static fromJS(data: any): SystemChangeCreatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemChangeCreatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["salesEmail"] = this.salesEmail !== undefined ? this.salesEmail : null as any;
        data["cpEmail"] = this.cpEmail !== undefined ? this.cpEmail : null as any;
        return data;
    }
}

export class SystemCopyLectoTypeInputDto {
    name!: string;
    clientCode!: string;
    type!: LectoTypeStatus;
    onComplateHook!: string | null;
    originID!: string;

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.clientCode = _data["clientCode"] !== undefined ? _data["clientCode"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.onComplateHook = _data["onComplateHook"] !== undefined ? _data["onComplateHook"] : null as any;
            this.originID = _data["originID"] !== undefined ? _data["originID"] : null as any;
        }
    }

    static fromJS(data: any): SystemCopyLectoTypeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemCopyLectoTypeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["clientCode"] = this.clientCode !== undefined ? this.clientCode : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["onComplateHook"] = this.onComplateHook !== undefined ? this.onComplateHook : null as any;
        data["originID"] = this.originID !== undefined ? this.originID : null as any;
        return data;
    }
}

export class SystemCreateLectoTypeInputDto {
    name!: string;
    clientCode!: string;
    type!: LectoTypeStatus;
    createrEmail!: string | null;
    onComplateHook!: string | null;
    pmsProjectCode!: string | null;
    sourceType!: SourceType;
    pmsProjectType!: number | null;
    finalCustomerCode!: string | null;
    finalCustomerName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.clientCode = _data["clientCode"] !== undefined ? _data["clientCode"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.createrEmail = _data["createrEmail"] !== undefined ? _data["createrEmail"] : null as any;
            this.onComplateHook = _data["onComplateHook"] !== undefined ? _data["onComplateHook"] : null as any;
            this.pmsProjectCode = _data["pmsProjectCode"] !== undefined ? _data["pmsProjectCode"] : null as any;
            this.sourceType = _data["sourceType"] !== undefined ? _data["sourceType"] : null as any;
            this.pmsProjectType = _data["pmsProjectType"] !== undefined ? _data["pmsProjectType"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
        }
    }

    static fromJS(data: any): SystemCreateLectoTypeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemCreateLectoTypeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["clientCode"] = this.clientCode !== undefined ? this.clientCode : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["createrEmail"] = this.createrEmail !== undefined ? this.createrEmail : null as any;
        data["onComplateHook"] = this.onComplateHook !== undefined ? this.onComplateHook : null as any;
        data["pmsProjectCode"] = this.pmsProjectCode !== undefined ? this.pmsProjectCode : null as any;
        data["sourceType"] = this.sourceType !== undefined ? this.sourceType : null as any;
        data["pmsProjectType"] = this.pmsProjectType !== undefined ? this.pmsProjectType : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        return data;
    }
}

export class SystemCreateLectoTypeResponseDto {
    id!: string;
    userFriendlyName!: string | null;
    link!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.userFriendlyName = _data["userFriendlyName"] !== undefined ? _data["userFriendlyName"] : null as any;
            this.link = _data["link"] !== undefined ? _data["link"] : null as any;
        }
    }

    static fromJS(data: any): SystemCreateLectoTypeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemCreateLectoTypeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["userFriendlyName"] = this.userFriendlyName !== undefined ? this.userFriendlyName : null as any;
        data["link"] = this.link !== undefined ? this.link : null as any;
        return data;
    }
}

/** 第三方系统替换选型责任销售输入对象 */
export class SystemReplaceSalesInput {
    /** 选型编号 */
    lectoTypeId!: string;
    /** 替换责任销售邮箱 */
    salesEmail!: string | null;

    init(_data?: any) {
        if (_data) {
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.salesEmail = _data["salesEmail"] !== undefined ? _data["salesEmail"] : null as any;
        }
    }

    static fromJS(data: any): SystemReplaceSalesInput {
        data = typeof data === 'object' ? data : {};
        let result = new SystemReplaceSalesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["salesEmail"] = this.salesEmail !== undefined ? this.salesEmail : null as any;
        return data;
    }
}

/** 第三方系统更新选型 */
export class SystemSetStatusInput {
    /** 选型编号 */
    lectoTypeId!: string;
    status!: LectoTypeStatus;

    init(_data?: any) {
        if (_data) {
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static fromJS(data: any): SystemSetStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new SystemSetStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        return data;
    }
}

/** 0 = NoApproval (驳回) 1 = Approval (审批) 2 = Withdraw (撤回) */
export enum TQApprovalStatus {
    NoApproval = 0,
    Approval = 1,
    Withdraw = 2,
}

export class TechinalCatalogueDto {
    id!: string;
    /** 名称 */
    name!: string | null;
    /** 描述 */
    remark!: string | null;
    /** 数量 */
    count!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
        }
    }

    static fromJS(data: any): TechinalCatalogueDto {
        data = typeof data === 'object' ? data : {};
        let result = new TechinalCatalogueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        return data;
    }
}

export class TechinalCatalogueDtoPagedResultDto {
    items!: TechinalCatalogueDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TechinalCatalogueDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): TechinalCatalogueDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TechinalCatalogueDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class TechnicalAgreementDto {
    id!: string;
    /** 标题 */
    title!: string | null;
    /** 附件链接 */
    fileUrl!: string | null;
    /** 发布时间 */
    creationTime!: moment.Moment;
    /** 技术协议目录名称 */
    techinalCatalogueName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.fileUrl = _data["fileUrl"] !== undefined ? _data["fileUrl"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.techinalCatalogueName = _data["techinalCatalogueName"] !== undefined ? _data["techinalCatalogueName"] : null as any;
        }
    }

    static fromJS(data: any): TechnicalAgreementDto {
        data = typeof data === 'object' ? data : {};
        let result = new TechnicalAgreementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["fileUrl"] = this.fileUrl !== undefined ? this.fileUrl : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["techinalCatalogueName"] = this.techinalCatalogueName !== undefined ? this.techinalCatalogueName : null as any;
        return data;
    }
}

export class TechnicalAgreementDtoPagedResultDto {
    items!: TechnicalAgreementDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TechnicalAgreementDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): TechnicalAgreementDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TechnicalAgreementDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class TechnologyAgreementDetailsProduct {
    id!: string;
    motorModelOnTheNameplate!: string | null;
    systemMOdel!: string | null;
    powerPoleNo!: string | null;
    voltageFrequency!: string | null;
    technologyAgreementBasicMotorMounting!: string | null;
    ip!: string | null;
    ic!: string | null;
    insulationTemperatureRiseClass!: string | null;
    directionOfRotation!: string | null;
    ambientTemperature!: string | null;
    application!: string | null;
    workingSystem!: string | null;
    other!: string | null;
    structurecharT!: string | null;
    technicalDataTable!: string | null;
    teRemark!: string | null;
    basicMotorCode!: string | null;
    basicMotorModel!: string | null;
    basicMotorMounting!: string | null;
    power!: string | null;
    frameNo!: number;
    basicMotorSries!: string | null;
    technologyQuotationProductVCs!: TechnologyAgreementDetailsProductVC[] | null;
    jinCategoryCode!: string | null;
    jinVersion!: string | null;
    jinBasicMotorCode!: string | null;
    jinBasicMotorModel!: string | null;
    jinBasicMotorMounting!: string | null;
    jinBasicMotorSries!: string | null;
    jinFrameSize!: number;
    jinPower!: string | null;
    jinEneEff!: string | null;
    jinWiringMode!: string | null;
    jinPoleNo!: string | null;
    jinVoltage!: string | null;
    jinFrequency!: string | null;
    standardProductParam!: TechnologyAgreementDetailsStandardProduct;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.motorModelOnTheNameplate = _data["motorModelOnTheNameplate"] !== undefined ? _data["motorModelOnTheNameplate"] : null as any;
            this.systemMOdel = _data["systemMOdel"] !== undefined ? _data["systemMOdel"] : null as any;
            this.powerPoleNo = _data["powerPoleNo"] !== undefined ? _data["powerPoleNo"] : null as any;
            this.voltageFrequency = _data["voltageFrequency"] !== undefined ? _data["voltageFrequency"] : null as any;
            this.technologyAgreementBasicMotorMounting = _data["technologyAgreementBasicMotorMounting"] !== undefined ? _data["technologyAgreementBasicMotorMounting"] : null as any;
            this.ip = _data["ip"] !== undefined ? _data["ip"] : null as any;
            this.ic = _data["ic"] !== undefined ? _data["ic"] : null as any;
            this.insulationTemperatureRiseClass = _data["insulationTemperatureRiseClass"] !== undefined ? _data["insulationTemperatureRiseClass"] : null as any;
            this.directionOfRotation = _data["directionOfRotation"] !== undefined ? _data["directionOfRotation"] : null as any;
            this.ambientTemperature = _data["ambientTemperature"] !== undefined ? _data["ambientTemperature"] : null as any;
            this.application = _data["application"] !== undefined ? _data["application"] : null as any;
            this.workingSystem = _data["workingSystem"] !== undefined ? _data["workingSystem"] : null as any;
            this.other = _data["other"] !== undefined ? _data["other"] : null as any;
            this.structurecharT = _data["structurecharT"] !== undefined ? _data["structurecharT"] : null as any;
            this.technicalDataTable = _data["technicalDataTable"] !== undefined ? _data["technicalDataTable"] : null as any;
            this.teRemark = _data["teRemark"] !== undefined ? _data["teRemark"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            if (Array.isArray(_data["technologyQuotationProductVCs"])) {
                this.technologyQuotationProductVCs = [] as any;
                for (let item of _data["technologyQuotationProductVCs"])
                    this.technologyQuotationProductVCs!.push(TechnologyAgreementDetailsProductVC.fromJS(item));
            }
            else {
                this.technologyQuotationProductVCs = null as any;
            }
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.jinBasicMotorCode = _data["jinBasicMotorCode"] !== undefined ? _data["jinBasicMotorCode"] : null as any;
            this.jinBasicMotorModel = _data["jinBasicMotorModel"] !== undefined ? _data["jinBasicMotorModel"] : null as any;
            this.jinBasicMotorMounting = _data["jinBasicMotorMounting"] !== undefined ? _data["jinBasicMotorMounting"] : null as any;
            this.jinBasicMotorSries = _data["jinBasicMotorSries"] !== undefined ? _data["jinBasicMotorSries"] : null as any;
            this.jinFrameSize = _data["jinFrameSize"] !== undefined ? _data["jinFrameSize"] : null as any;
            this.jinPower = _data["jinPower"] !== undefined ? _data["jinPower"] : null as any;
            this.jinEneEff = _data["jinEneEff"] !== undefined ? _data["jinEneEff"] : null as any;
            this.jinWiringMode = _data["jinWiringMode"] !== undefined ? _data["jinWiringMode"] : null as any;
            this.jinPoleNo = _data["jinPoleNo"] !== undefined ? _data["jinPoleNo"] : null as any;
            this.jinVoltage = _data["jinVoltage"] !== undefined ? _data["jinVoltage"] : null as any;
            this.jinFrequency = _data["jinFrequency"] !== undefined ? _data["jinFrequency"] : null as any;
            this.standardProductParam = _data["standardProductParam"] ? TechnologyAgreementDetailsStandardProduct.fromJS(_data["standardProductParam"]) : null as any;
        }
    }

    static fromJS(data: any): TechnologyAgreementDetailsProduct {
        data = typeof data === 'object' ? data : {};
        let result = new TechnologyAgreementDetailsProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["motorModelOnTheNameplate"] = this.motorModelOnTheNameplate !== undefined ? this.motorModelOnTheNameplate : null as any;
        data["systemMOdel"] = this.systemMOdel !== undefined ? this.systemMOdel : null as any;
        data["powerPoleNo"] = this.powerPoleNo !== undefined ? this.powerPoleNo : null as any;
        data["voltageFrequency"] = this.voltageFrequency !== undefined ? this.voltageFrequency : null as any;
        data["technologyAgreementBasicMotorMounting"] = this.technologyAgreementBasicMotorMounting !== undefined ? this.technologyAgreementBasicMotorMounting : null as any;
        data["ip"] = this.ip !== undefined ? this.ip : null as any;
        data["ic"] = this.ic !== undefined ? this.ic : null as any;
        data["insulationTemperatureRiseClass"] = this.insulationTemperatureRiseClass !== undefined ? this.insulationTemperatureRiseClass : null as any;
        data["directionOfRotation"] = this.directionOfRotation !== undefined ? this.directionOfRotation : null as any;
        data["ambientTemperature"] = this.ambientTemperature !== undefined ? this.ambientTemperature : null as any;
        data["application"] = this.application !== undefined ? this.application : null as any;
        data["workingSystem"] = this.workingSystem !== undefined ? this.workingSystem : null as any;
        data["other"] = this.other !== undefined ? this.other : null as any;
        data["structurecharT"] = this.structurecharT !== undefined ? this.structurecharT : null as any;
        data["technicalDataTable"] = this.technicalDataTable !== undefined ? this.technicalDataTable : null as any;
        data["teRemark"] = this.teRemark !== undefined ? this.teRemark : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        if (Array.isArray(this.technologyQuotationProductVCs)) {
            data["technologyQuotationProductVCs"] = [];
            for (let item of this.technologyQuotationProductVCs)
                data["technologyQuotationProductVCs"].push(item ? item.toJSON() : null as any);
        }
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["jinBasicMotorCode"] = this.jinBasicMotorCode !== undefined ? this.jinBasicMotorCode : null as any;
        data["jinBasicMotorModel"] = this.jinBasicMotorModel !== undefined ? this.jinBasicMotorModel : null as any;
        data["jinBasicMotorMounting"] = this.jinBasicMotorMounting !== undefined ? this.jinBasicMotorMounting : null as any;
        data["jinBasicMotorSries"] = this.jinBasicMotorSries !== undefined ? this.jinBasicMotorSries : null as any;
        data["jinFrameSize"] = this.jinFrameSize !== undefined ? this.jinFrameSize : null as any;
        data["jinPower"] = this.jinPower !== undefined ? this.jinPower : null as any;
        data["jinEneEff"] = this.jinEneEff !== undefined ? this.jinEneEff : null as any;
        data["jinWiringMode"] = this.jinWiringMode !== undefined ? this.jinWiringMode : null as any;
        data["jinPoleNo"] = this.jinPoleNo !== undefined ? this.jinPoleNo : null as any;
        data["jinVoltage"] = this.jinVoltage !== undefined ? this.jinVoltage : null as any;
        data["jinFrequency"] = this.jinFrequency !== undefined ? this.jinFrequency : null as any;
        data["standardProductParam"] = this.standardProductParam ? this.standardProductParam.toJSON() : null as any;
        return data;
    }
}

export class TechnologyAgreementDetailsProductVC {
    id!: string;
    vcID!: string | null;
    isInside!: boolean;
    meaning!: string | null;
    remark!: string | null;
    category!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.isInside = _data["isInside"] !== undefined ? _data["isInside"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
        }
    }

    static fromJS(data: any): TechnologyAgreementDetailsProductVC {
        data = typeof data === 'object' ? data : {};
        let result = new TechnologyAgreementDetailsProductVC();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["isInside"] = this.isInside !== undefined ? this.isInside : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        return data;
    }
}

export class TechnologyAgreementDetailsStandardProduct {
    basicMotorCode!: string | null;
    basicMotorModel!: string | null;
    eneEff!: string | null;
    poleNo!: string | null;
    voltage!: string | null;
    frequency!: string | null;
    wiringMode!: string | null;
    basicMotorMounting!: string | null;
    power!: string | null;

    init(_data?: any) {
        if (_data) {
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.wiringMode = _data["wiringMode"] !== undefined ? _data["wiringMode"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
        }
    }

    static fromJS(data: any): TechnologyAgreementDetailsStandardProduct {
        data = typeof data === 'object' ? data : {};
        let result = new TechnologyAgreementDetailsStandardProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["wiringMode"] = this.wiringMode !== undefined ? this.wiringMode : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        return data;
    }
}

export class TechnologyAgreementDetailstApproval {
    info!: string | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    isApproval!: TQApprovalStatus;

    init(_data?: any) {
        if (_data) {
            this.info = _data["info"] !== undefined ? _data["info"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.isApproval = _data["isApproval"] !== undefined ? _data["isApproval"] : null as any;
        }
    }

    static fromJS(data: any): TechnologyAgreementDetailstApproval {
        data = typeof data === 'object' ? data : {};
        let result = new TechnologyAgreementDetailstApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["info"] = this.info !== undefined ? this.info : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["isApproval"] = this.isApproval !== undefined ? this.isApproval : null as any;
        return data;
    }
}

export class TechnologyApproval {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    info!: string | null;
    isApproval!: TQApprovalStatus;
    technologyQuotationId!: string;
    technologyQuotation!: TechnologyQuotation;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.info = _data["info"] !== undefined ? _data["info"] : null as any;
            this.isApproval = _data["isApproval"] !== undefined ? _data["isApproval"] : null as any;
            this.technologyQuotationId = _data["technologyQuotationId"] !== undefined ? _data["technologyQuotationId"] : null as any;
            this.technologyQuotation = _data["technologyQuotation"] ? TechnologyQuotation.fromJS(_data["technologyQuotation"]) : null as any;
        }
    }

    static fromJS(data: any): TechnologyApproval {
        data = typeof data === 'object' ? data : {};
        let result = new TechnologyApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["info"] = this.info !== undefined ? this.info : null as any;
        data["isApproval"] = this.isApproval !== undefined ? this.isApproval : null as any;
        data["technologyQuotationId"] = this.technologyQuotationId !== undefined ? this.technologyQuotationId : null as any;
        data["technologyQuotation"] = this.technologyQuotation ? this.technologyQuotation.toJSON() : null as any;
        return data;
    }
}

export class TechnologyQuotation {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    projectName!: string | null;
    industry!: string | null;
    cycle!: number;
    clienter!: string | null;
    clientName!: string | null;
    finalCustomerCode!: string | null;
    finalCustomerName!: string | null;
    technicalSpecifications!: string | null;
    technicalConfirmation!: string | null;
    teAttachs!: string | null;
    teRemark!: string | null;
    dqRemark!: string | null;
    teStatus!: TechnologyQuotationStatus;
    lastTeCreatorUserId!: number | null;
    lastTeCreationTime!: moment.Moment | null;
    domesticQuotationNumber!: string | null;
    dqAttachs!: string | null;
    dqStatus!: TechnologyQuotationStatus;
    lastDqCreatorUserId!: number | null;
    lastDqCreationTime!: moment.Moment | null;
    quotationExpiredTime!: moment.Moment | null;
    pmsProjectType!: number | null;
    sourceType!: SourceType;
    technologyQuotationProducts!: TechnologyQuotationProduct[] | null;
    technologyApprovals!: TechnologyApproval[] | null;
    quotationApprovals!: QuotationApproval[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.industry = _data["industry"] !== undefined ? _data["industry"] : null as any;
            this.cycle = _data["cycle"] !== undefined ? _data["cycle"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.technicalConfirmation = _data["technicalConfirmation"] !== undefined ? _data["technicalConfirmation"] : null as any;
            this.teAttachs = _data["teAttachs"] !== undefined ? _data["teAttachs"] : null as any;
            this.teRemark = _data["teRemark"] !== undefined ? _data["teRemark"] : null as any;
            this.dqRemark = _data["dqRemark"] !== undefined ? _data["dqRemark"] : null as any;
            this.teStatus = _data["teStatus"] !== undefined ? _data["teStatus"] : null as any;
            this.lastTeCreatorUserId = _data["lastTeCreatorUserId"] !== undefined ? _data["lastTeCreatorUserId"] : null as any;
            this.lastTeCreationTime = _data["lastTeCreationTime"] ? moment(_data["lastTeCreationTime"].toString()) : null as any;
            this.domesticQuotationNumber = _data["domesticQuotationNumber"] !== undefined ? _data["domesticQuotationNumber"] : null as any;
            this.dqAttachs = _data["dqAttachs"] !== undefined ? _data["dqAttachs"] : null as any;
            this.dqStatus = _data["dqStatus"] !== undefined ? _data["dqStatus"] : null as any;
            this.lastDqCreatorUserId = _data["lastDqCreatorUserId"] !== undefined ? _data["lastDqCreatorUserId"] : null as any;
            this.lastDqCreationTime = _data["lastDqCreationTime"] ? moment(_data["lastDqCreationTime"].toString()) : null as any;
            this.quotationExpiredTime = _data["quotationExpiredTime"] ? moment(_data["quotationExpiredTime"].toString()) : null as any;
            this.pmsProjectType = _data["pmsProjectType"] !== undefined ? _data["pmsProjectType"] : null as any;
            this.sourceType = _data["sourceType"] !== undefined ? _data["sourceType"] : null as any;
            if (Array.isArray(_data["technologyQuotationProducts"])) {
                this.technologyQuotationProducts = [] as any;
                for (let item of _data["technologyQuotationProducts"])
                    this.technologyQuotationProducts!.push(TechnologyQuotationProduct.fromJS(item));
            }
            else {
                this.technologyQuotationProducts = null as any;
            }
            if (Array.isArray(_data["technologyApprovals"])) {
                this.technologyApprovals = [] as any;
                for (let item of _data["technologyApprovals"])
                    this.technologyApprovals!.push(TechnologyApproval.fromJS(item));
            }
            else {
                this.technologyApprovals = null as any;
            }
            if (Array.isArray(_data["quotationApprovals"])) {
                this.quotationApprovals = [] as any;
                for (let item of _data["quotationApprovals"])
                    this.quotationApprovals!.push(QuotationApproval.fromJS(item));
            }
            else {
                this.quotationApprovals = null as any;
            }
        }
    }

    static fromJS(data: any): TechnologyQuotation {
        data = typeof data === 'object' ? data : {};
        let result = new TechnologyQuotation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["industry"] = this.industry !== undefined ? this.industry : null as any;
        data["cycle"] = this.cycle !== undefined ? this.cycle : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["technicalConfirmation"] = this.technicalConfirmation !== undefined ? this.technicalConfirmation : null as any;
        data["teAttachs"] = this.teAttachs !== undefined ? this.teAttachs : null as any;
        data["teRemark"] = this.teRemark !== undefined ? this.teRemark : null as any;
        data["dqRemark"] = this.dqRemark !== undefined ? this.dqRemark : null as any;
        data["teStatus"] = this.teStatus !== undefined ? this.teStatus : null as any;
        data["lastTeCreatorUserId"] = this.lastTeCreatorUserId !== undefined ? this.lastTeCreatorUserId : null as any;
        data["lastTeCreationTime"] = this.lastTeCreationTime ? this.lastTeCreationTime.toISOString() : null as any;
        data["domesticQuotationNumber"] = this.domesticQuotationNumber !== undefined ? this.domesticQuotationNumber : null as any;
        data["dqAttachs"] = this.dqAttachs !== undefined ? this.dqAttachs : null as any;
        data["dqStatus"] = this.dqStatus !== undefined ? this.dqStatus : null as any;
        data["lastDqCreatorUserId"] = this.lastDqCreatorUserId !== undefined ? this.lastDqCreatorUserId : null as any;
        data["lastDqCreationTime"] = this.lastDqCreationTime ? this.lastDqCreationTime.toISOString() : null as any;
        data["quotationExpiredTime"] = this.quotationExpiredTime ? this.quotationExpiredTime.toISOString() : null as any;
        data["pmsProjectType"] = this.pmsProjectType !== undefined ? this.pmsProjectType : null as any;
        data["sourceType"] = this.sourceType !== undefined ? this.sourceType : null as any;
        if (Array.isArray(this.technologyQuotationProducts)) {
            data["technologyQuotationProducts"] = [];
            for (let item of this.technologyQuotationProducts)
                data["technologyQuotationProducts"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.technologyApprovals)) {
            data["technologyApprovals"] = [];
            for (let item of this.technologyApprovals)
                data["technologyApprovals"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.quotationApprovals)) {
            data["quotationApprovals"] = [];
            for (let item of this.quotationApprovals)
                data["quotationApprovals"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class TechnologyQuotationProduct {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    motorModelOnTheNameplate!: string | null;
    systemMOdel!: string | null;
    powerPoleNo!: string | null;
    voltageFrequency!: string | null;
    technologyAgreementBasicMotorMounting!: string | null;
    ip!: string | null;
    ic!: string | null;
    insulationTemperatureRiseClass!: string | null;
    directionOfRotation!: string | null;
    ambientTemperature!: string | null;
    application!: string | null;
    workingSystem!: string | null;
    other!: string | null;
    structurecharT!: string | null;
    technicalDataTable!: string | null;
    basicMotorCode!: string | null;
    basicMotorModel!: string | null;
    basicMotorMounting!: string | null;
    power!: string | null;
    poleNo!: string | null;
    frequency!: string | null;
    voltage!: string | null;
    frameNo!: number;
    basicMotorType!: BasicMotorType;
    basicMotorSries!: string | null;
    cycle!: number;
    unitPrice!: number | null;
    unitPriceResult!: string | null;
    unitPriceFormula!: string | null;
    cost!: number | null;
    costFormula!: string | null;
    costType!: CostType;
    costTypeDetail!: string | null;
    quotationPrinciple!: string | null;
    quotationPrincipleDetails!: string | null;
    productNumber!: number;
    teRemark!: string | null;
    dqRemark!: string | null;
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    productionCycle!: number;
    testCycle!: number;
    capacityCycle!: number;
    grCycle!: number;
    inToOutCycle!: number;
    makeOrBuy!: string | null;
    technicalSpecificationProductId!: string | null;
    technologyQuotationProductId!: string | null;
    isHaveVc!: IsHaveVc;
    isNeedHeightOutput!: IsYes;
    eneEff!: string | null;
    encoder!: string | null;
    brake!: string | null;
    clienter!: string | null;
    voltageCode!: string | null;
    listPriceBasicMotorPriceId!: string | null;
    technologyQuotationId!: string;
    technologyQuotation!: TechnologyQuotation;
    technologyQuotationProductVCs!: TechnologyQuotationProductVC[] | null;
    jinCategoryCode!: string | null;
    jinVersion!: string | null;
    listPriceMultiplier!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.motorModelOnTheNameplate = _data["motorModelOnTheNameplate"] !== undefined ? _data["motorModelOnTheNameplate"] : null as any;
            this.systemMOdel = _data["systemMOdel"] !== undefined ? _data["systemMOdel"] : null as any;
            this.powerPoleNo = _data["powerPoleNo"] !== undefined ? _data["powerPoleNo"] : null as any;
            this.voltageFrequency = _data["voltageFrequency"] !== undefined ? _data["voltageFrequency"] : null as any;
            this.technologyAgreementBasicMotorMounting = _data["technologyAgreementBasicMotorMounting"] !== undefined ? _data["technologyAgreementBasicMotorMounting"] : null as any;
            this.ip = _data["ip"] !== undefined ? _data["ip"] : null as any;
            this.ic = _data["ic"] !== undefined ? _data["ic"] : null as any;
            this.insulationTemperatureRiseClass = _data["insulationTemperatureRiseClass"] !== undefined ? _data["insulationTemperatureRiseClass"] : null as any;
            this.directionOfRotation = _data["directionOfRotation"] !== undefined ? _data["directionOfRotation"] : null as any;
            this.ambientTemperature = _data["ambientTemperature"] !== undefined ? _data["ambientTemperature"] : null as any;
            this.application = _data["application"] !== undefined ? _data["application"] : null as any;
            this.workingSystem = _data["workingSystem"] !== undefined ? _data["workingSystem"] : null as any;
            this.other = _data["other"] !== undefined ? _data["other"] : null as any;
            this.structurecharT = _data["structurecharT"] !== undefined ? _data["structurecharT"] : null as any;
            this.technicalDataTable = _data["technicalDataTable"] !== undefined ? _data["technicalDataTable"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.basicMotorType = _data["basicMotorType"] !== undefined ? _data["basicMotorType"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.cycle = _data["cycle"] !== undefined ? _data["cycle"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.productNumber = _data["productNumber"] !== undefined ? _data["productNumber"] : null as any;
            this.teRemark = _data["teRemark"] !== undefined ? _data["teRemark"] : null as any;
            this.dqRemark = _data["dqRemark"] !== undefined ? _data["dqRemark"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.capacityCycle = _data["capacityCycle"] !== undefined ? _data["capacityCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.inToOutCycle = _data["inToOutCycle"] !== undefined ? _data["inToOutCycle"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.technicalSpecificationProductId = _data["technicalSpecificationProductId"] !== undefined ? _data["technicalSpecificationProductId"] : null as any;
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
            this.isHaveVc = _data["isHaveVc"] !== undefined ? _data["isHaveVc"] : null as any;
            this.isNeedHeightOutput = _data["isNeedHeightOutput"] !== undefined ? _data["isNeedHeightOutput"] : null as any;
            this.eneEff = _data["eneEff"] !== undefined ? _data["eneEff"] : null as any;
            this.encoder = _data["encoder"] !== undefined ? _data["encoder"] : null as any;
            this.brake = _data["brake"] !== undefined ? _data["brake"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.voltageCode = _data["voltageCode"] !== undefined ? _data["voltageCode"] : null as any;
            this.listPriceBasicMotorPriceId = _data["listPriceBasicMotorPriceId"] !== undefined ? _data["listPriceBasicMotorPriceId"] : null as any;
            this.technologyQuotationId = _data["technologyQuotationId"] !== undefined ? _data["technologyQuotationId"] : null as any;
            this.technologyQuotation = _data["technologyQuotation"] ? TechnologyQuotation.fromJS(_data["technologyQuotation"]) : null as any;
            if (Array.isArray(_data["technologyQuotationProductVCs"])) {
                this.technologyQuotationProductVCs = [] as any;
                for (let item of _data["technologyQuotationProductVCs"])
                    this.technologyQuotationProductVCs!.push(TechnologyQuotationProductVC.fromJS(item));
            }
            else {
                this.technologyQuotationProductVCs = null as any;
            }
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
            this.listPriceMultiplier = _data["listPriceMultiplier"] !== undefined ? _data["listPriceMultiplier"] : null as any;
        }
    }

    static fromJS(data: any): TechnologyQuotationProduct {
        data = typeof data === 'object' ? data : {};
        let result = new TechnologyQuotationProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["motorModelOnTheNameplate"] = this.motorModelOnTheNameplate !== undefined ? this.motorModelOnTheNameplate : null as any;
        data["systemMOdel"] = this.systemMOdel !== undefined ? this.systemMOdel : null as any;
        data["powerPoleNo"] = this.powerPoleNo !== undefined ? this.powerPoleNo : null as any;
        data["voltageFrequency"] = this.voltageFrequency !== undefined ? this.voltageFrequency : null as any;
        data["technologyAgreementBasicMotorMounting"] = this.technologyAgreementBasicMotorMounting !== undefined ? this.technologyAgreementBasicMotorMounting : null as any;
        data["ip"] = this.ip !== undefined ? this.ip : null as any;
        data["ic"] = this.ic !== undefined ? this.ic : null as any;
        data["insulationTemperatureRiseClass"] = this.insulationTemperatureRiseClass !== undefined ? this.insulationTemperatureRiseClass : null as any;
        data["directionOfRotation"] = this.directionOfRotation !== undefined ? this.directionOfRotation : null as any;
        data["ambientTemperature"] = this.ambientTemperature !== undefined ? this.ambientTemperature : null as any;
        data["application"] = this.application !== undefined ? this.application : null as any;
        data["workingSystem"] = this.workingSystem !== undefined ? this.workingSystem : null as any;
        data["other"] = this.other !== undefined ? this.other : null as any;
        data["structurecharT"] = this.structurecharT !== undefined ? this.structurecharT : null as any;
        data["technicalDataTable"] = this.technicalDataTable !== undefined ? this.technicalDataTable : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["basicMotorType"] = this.basicMotorType !== undefined ? this.basicMotorType : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["cycle"] = this.cycle !== undefined ? this.cycle : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["productNumber"] = this.productNumber !== undefined ? this.productNumber : null as any;
        data["teRemark"] = this.teRemark !== undefined ? this.teRemark : null as any;
        data["dqRemark"] = this.dqRemark !== undefined ? this.dqRemark : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["capacityCycle"] = this.capacityCycle !== undefined ? this.capacityCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["inToOutCycle"] = this.inToOutCycle !== undefined ? this.inToOutCycle : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["technicalSpecificationProductId"] = this.technicalSpecificationProductId !== undefined ? this.technicalSpecificationProductId : null as any;
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        data["isHaveVc"] = this.isHaveVc !== undefined ? this.isHaveVc : null as any;
        data["isNeedHeightOutput"] = this.isNeedHeightOutput !== undefined ? this.isNeedHeightOutput : null as any;
        data["eneEff"] = this.eneEff !== undefined ? this.eneEff : null as any;
        data["encoder"] = this.encoder !== undefined ? this.encoder : null as any;
        data["brake"] = this.brake !== undefined ? this.brake : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["voltageCode"] = this.voltageCode !== undefined ? this.voltageCode : null as any;
        data["listPriceBasicMotorPriceId"] = this.listPriceBasicMotorPriceId !== undefined ? this.listPriceBasicMotorPriceId : null as any;
        data["technologyQuotationId"] = this.technologyQuotationId !== undefined ? this.technologyQuotationId : null as any;
        data["technologyQuotation"] = this.technologyQuotation ? this.technologyQuotation.toJSON() : null as any;
        if (Array.isArray(this.technologyQuotationProductVCs)) {
            data["technologyQuotationProductVCs"] = [];
            for (let item of this.technologyQuotationProductVCs)
                data["technologyQuotationProductVCs"].push(item ? item.toJSON() : null as any);
        }
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        data["listPriceMultiplier"] = this.listPriceMultiplier !== undefined ? this.listPriceMultiplier : null as any;
        return data;
    }
}

export class TechnologyQuotationProductVC {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    vcID!: string | null;
    category!: string | null;
    meaning!: string | null;
    vcTypeDescription!: string | null;
    numberWires!: number;
    remark!: string | null;
    vcType!: VcType;
    unitPrice!: number | null;
    unitPriceResult!: string | null;
    unitPriceFormula!: string | null;
    unitPriceType!: UnitPriceType;
    cost!: number | null;
    costFormula!: string | null;
    costType!: CostType;
    costTypeDetail!: string | null;
    quotationPrinciple!: string | null;
    quotationPrincipleDetails!: string | null;
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    productionCycle!: number;
    testCycle!: number;
    shipSurveyCycle!: number;
    grCycle!: number;
    makeOrBuy!: string | null;
    vcShowType!: VCShowType;
    technicalSpecificationProductVCId!: string | null;
    technologyQuotationProductVCId!: string | null;
    technologyQuotationProductId!: string;
    technologyQuotationProduct!: TechnologyQuotationProduct;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.technicalSpecificationProductVCId = _data["technicalSpecificationProductVCId"] !== undefined ? _data["technicalSpecificationProductVCId"] : null as any;
            this.technologyQuotationProductVCId = _data["technologyQuotationProductVCId"] !== undefined ? _data["technologyQuotationProductVCId"] : null as any;
            this.technologyQuotationProductId = _data["technologyQuotationProductId"] !== undefined ? _data["technologyQuotationProductId"] : null as any;
            this.technologyQuotationProduct = _data["technologyQuotationProduct"] ? TechnologyQuotationProduct.fromJS(_data["technologyQuotationProduct"]) : null as any;
        }
    }

    static fromJS(data: any): TechnologyQuotationProductVC {
        data = typeof data === 'object' ? data : {};
        let result = new TechnologyQuotationProductVC();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["technicalSpecificationProductVCId"] = this.technicalSpecificationProductVCId !== undefined ? this.technicalSpecificationProductVCId : null as any;
        data["technologyQuotationProductVCId"] = this.technologyQuotationProductVCId !== undefined ? this.technologyQuotationProductVCId : null as any;
        data["technologyQuotationProductId"] = this.technologyQuotationProductId !== undefined ? this.technologyQuotationProductId : null as any;
        data["technologyQuotationProduct"] = this.technologyQuotationProduct ? this.technologyQuotationProduct.toJSON() : null as any;
        return data;
    }
}

/** 0 = WaitToExamine 1 = Rejected 2 = ExamineSuccess 3 = Completed 4 = Disable -2 = Draft -1 = UnKnow */
export enum TechnologyQuotationStatus {
    WaitToExamine = 0,
    Rejected = 1,
    ExamineSuccess = 2,
    Completed = 3,
    Disable = 4,
    Draft = -2,
    UnKnow = -1,
}

/** 转行业VC */
export class TransferToIndustryVcDto {
    /** 所属人 */
    owner!: string | null;
    /** 开始有效期 */
    validStartTime!: moment.Moment;
    /** 结束有效期 */
    validEndTime!: moment.Moment;

    init(_data?: any) {
        if (_data) {
            this.owner = _data["owner"] !== undefined ? _data["owner"] : null as any;
            this.validStartTime = _data["validStartTime"] ? moment(_data["validStartTime"].toString()) : null as any;
            this.validEndTime = _data["validEndTime"] ? moment(_data["validEndTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): TransferToIndustryVcDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferToIndustryVcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["owner"] = this.owner !== undefined ? this.owner : null as any;
        data["validStartTime"] = this.validStartTime ? this.validStartTime.toISOString() : null as any;
        data["validEndTime"] = this.validEndTime ? this.validEndTime.toISOString() : null as any;
        return data;
    }
}

export class Type {
    readonly name!: string | null;
    readonly customAttributes!: CustomAttributeData[] | null;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    readonly isInterface!: boolean;
    memberType!: MemberTypes;
    readonly namespace!: string | null;
    readonly assemblyQualifiedName!: string | null;
    readonly fullName!: string | null;
    assembly!: Assembly;
    module!: Module;
    readonly isNested!: boolean;
    declaringType!: Type;
    declaringMethod!: MethodBase;
    reflectedType!: Type;
    underlyingSystemType!: Type;
    readonly isTypeDefinition!: boolean;
    readonly isArray!: boolean;
    readonly isByRef!: boolean;
    readonly isPointer!: boolean;
    readonly isConstructedGenericType!: boolean;
    readonly isGenericParameter!: boolean;
    readonly isGenericTypeParameter!: boolean;
    readonly isGenericMethodParameter!: boolean;
    readonly isGenericType!: boolean;
    readonly isGenericTypeDefinition!: boolean;
    readonly isSZArray!: boolean;
    readonly isVariableBoundArray!: boolean;
    readonly isByRefLike!: boolean;
    readonly isFunctionPointer!: boolean;
    readonly isUnmanagedFunctionPointer!: boolean;
    readonly hasElementType!: boolean;
    readonly genericTypeArguments!: Type[] | null;
    readonly genericParameterPosition!: number;
    genericParameterAttributes!: GenericParameterAttributes;
    attributes!: TypeAttributes;
    readonly isAbstract!: boolean;
    readonly isImport!: boolean;
    readonly isSealed!: boolean;
    readonly isSpecialName!: boolean;
    readonly isClass!: boolean;
    readonly isNestedAssembly!: boolean;
    readonly isNestedFamANDAssem!: boolean;
    readonly isNestedFamily!: boolean;
    readonly isNestedFamORAssem!: boolean;
    readonly isNestedPrivate!: boolean;
    readonly isNestedPublic!: boolean;
    readonly isNotPublic!: boolean;
    readonly isPublic!: boolean;
    readonly isAutoLayout!: boolean;
    readonly isExplicitLayout!: boolean;
    readonly isLayoutSequential!: boolean;
    readonly isAnsiClass!: boolean;
    readonly isAutoClass!: boolean;
    readonly isUnicodeClass!: boolean;
    readonly isCOMObject!: boolean;
    readonly isContextful!: boolean;
    readonly isEnum!: boolean;
    readonly isMarshalByRef!: boolean;
    readonly isPrimitive!: boolean;
    readonly isValueType!: boolean;
    readonly isSignatureType!: boolean;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    structLayoutAttribute!: StructLayoutAttribute;
    typeInitializer!: ConstructorInfo;
    typeHandle!: RuntimeTypeHandle;
    readonly guid!: string;
    baseType!: Type;
    readonly isSerializable!: boolean;
    readonly containsGenericParameters!: boolean;
    readonly isVisible!: boolean;

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            else {
                (this as any).customAttributes = null as any;
            }
            (this as any).isCollectible = _data["isCollectible"] !== undefined ? _data["isCollectible"] : null as any;
            (this as any).metadataToken = _data["metadataToken"] !== undefined ? _data["metadataToken"] : null as any;
            (this as any).isInterface = _data["isInterface"] !== undefined ? _data["isInterface"] : null as any;
            this.memberType = _data["memberType"] !== undefined ? _data["memberType"] : null as any;
            (this as any).namespace = _data["namespace"] !== undefined ? _data["namespace"] : null as any;
            (this as any).assemblyQualifiedName = _data["assemblyQualifiedName"] !== undefined ? _data["assemblyQualifiedName"] : null as any;
            (this as any).fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : null as any;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : null as any;
            (this as any).isNested = _data["isNested"] !== undefined ? _data["isNested"] : null as any;
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : null as any;
            this.declaringMethod = _data["declaringMethod"] ? MethodBase.fromJS(_data["declaringMethod"]) : null as any;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : null as any;
            this.underlyingSystemType = _data["underlyingSystemType"] ? Type.fromJS(_data["underlyingSystemType"]) : null as any;
            (this as any).isTypeDefinition = _data["isTypeDefinition"] !== undefined ? _data["isTypeDefinition"] : null as any;
            (this as any).isArray = _data["isArray"] !== undefined ? _data["isArray"] : null as any;
            (this as any).isByRef = _data["isByRef"] !== undefined ? _data["isByRef"] : null as any;
            (this as any).isPointer = _data["isPointer"] !== undefined ? _data["isPointer"] : null as any;
            (this as any).isConstructedGenericType = _data["isConstructedGenericType"] !== undefined ? _data["isConstructedGenericType"] : null as any;
            (this as any).isGenericParameter = _data["isGenericParameter"] !== undefined ? _data["isGenericParameter"] : null as any;
            (this as any).isGenericTypeParameter = _data["isGenericTypeParameter"] !== undefined ? _data["isGenericTypeParameter"] : null as any;
            (this as any).isGenericMethodParameter = _data["isGenericMethodParameter"] !== undefined ? _data["isGenericMethodParameter"] : null as any;
            (this as any).isGenericType = _data["isGenericType"] !== undefined ? _data["isGenericType"] : null as any;
            (this as any).isGenericTypeDefinition = _data["isGenericTypeDefinition"] !== undefined ? _data["isGenericTypeDefinition"] : null as any;
            (this as any).isSZArray = _data["isSZArray"] !== undefined ? _data["isSZArray"] : null as any;
            (this as any).isVariableBoundArray = _data["isVariableBoundArray"] !== undefined ? _data["isVariableBoundArray"] : null as any;
            (this as any).isByRefLike = _data["isByRefLike"] !== undefined ? _data["isByRefLike"] : null as any;
            (this as any).isFunctionPointer = _data["isFunctionPointer"] !== undefined ? _data["isFunctionPointer"] : null as any;
            (this as any).isUnmanagedFunctionPointer = _data["isUnmanagedFunctionPointer"] !== undefined ? _data["isUnmanagedFunctionPointer"] : null as any;
            (this as any).hasElementType = _data["hasElementType"] !== undefined ? _data["hasElementType"] : null as any;
            if (Array.isArray(_data["genericTypeArguments"])) {
                (this as any).genericTypeArguments = [] as any;
                for (let item of _data["genericTypeArguments"])
                    (this as any).genericTypeArguments!.push(Type.fromJS(item));
            }
            else {
                (this as any).genericTypeArguments = null as any;
            }
            (this as any).genericParameterPosition = _data["genericParameterPosition"] !== undefined ? _data["genericParameterPosition"] : null as any;
            this.genericParameterAttributes = _data["genericParameterAttributes"] !== undefined ? _data["genericParameterAttributes"] : null as any;
            this.attributes = _data["attributes"] !== undefined ? _data["attributes"] : null as any;
            (this as any).isAbstract = _data["isAbstract"] !== undefined ? _data["isAbstract"] : null as any;
            (this as any).isImport = _data["isImport"] !== undefined ? _data["isImport"] : null as any;
            (this as any).isSealed = _data["isSealed"] !== undefined ? _data["isSealed"] : null as any;
            (this as any).isSpecialName = _data["isSpecialName"] !== undefined ? _data["isSpecialName"] : null as any;
            (this as any).isClass = _data["isClass"] !== undefined ? _data["isClass"] : null as any;
            (this as any).isNestedAssembly = _data["isNestedAssembly"] !== undefined ? _data["isNestedAssembly"] : null as any;
            (this as any).isNestedFamANDAssem = _data["isNestedFamANDAssem"] !== undefined ? _data["isNestedFamANDAssem"] : null as any;
            (this as any).isNestedFamily = _data["isNestedFamily"] !== undefined ? _data["isNestedFamily"] : null as any;
            (this as any).isNestedFamORAssem = _data["isNestedFamORAssem"] !== undefined ? _data["isNestedFamORAssem"] : null as any;
            (this as any).isNestedPrivate = _data["isNestedPrivate"] !== undefined ? _data["isNestedPrivate"] : null as any;
            (this as any).isNestedPublic = _data["isNestedPublic"] !== undefined ? _data["isNestedPublic"] : null as any;
            (this as any).isNotPublic = _data["isNotPublic"] !== undefined ? _data["isNotPublic"] : null as any;
            (this as any).isPublic = _data["isPublic"] !== undefined ? _data["isPublic"] : null as any;
            (this as any).isAutoLayout = _data["isAutoLayout"] !== undefined ? _data["isAutoLayout"] : null as any;
            (this as any).isExplicitLayout = _data["isExplicitLayout"] !== undefined ? _data["isExplicitLayout"] : null as any;
            (this as any).isLayoutSequential = _data["isLayoutSequential"] !== undefined ? _data["isLayoutSequential"] : null as any;
            (this as any).isAnsiClass = _data["isAnsiClass"] !== undefined ? _data["isAnsiClass"] : null as any;
            (this as any).isAutoClass = _data["isAutoClass"] !== undefined ? _data["isAutoClass"] : null as any;
            (this as any).isUnicodeClass = _data["isUnicodeClass"] !== undefined ? _data["isUnicodeClass"] : null as any;
            (this as any).isCOMObject = _data["isCOMObject"] !== undefined ? _data["isCOMObject"] : null as any;
            (this as any).isContextful = _data["isContextful"] !== undefined ? _data["isContextful"] : null as any;
            (this as any).isEnum = _data["isEnum"] !== undefined ? _data["isEnum"] : null as any;
            (this as any).isMarshalByRef = _data["isMarshalByRef"] !== undefined ? _data["isMarshalByRef"] : null as any;
            (this as any).isPrimitive = _data["isPrimitive"] !== undefined ? _data["isPrimitive"] : null as any;
            (this as any).isValueType = _data["isValueType"] !== undefined ? _data["isValueType"] : null as any;
            (this as any).isSignatureType = _data["isSignatureType"] !== undefined ? _data["isSignatureType"] : null as any;
            (this as any).isSecurityCritical = _data["isSecurityCritical"] !== undefined ? _data["isSecurityCritical"] : null as any;
            (this as any).isSecuritySafeCritical = _data["isSecuritySafeCritical"] !== undefined ? _data["isSecuritySafeCritical"] : null as any;
            (this as any).isSecurityTransparent = _data["isSecurityTransparent"] !== undefined ? _data["isSecurityTransparent"] : null as any;
            this.structLayoutAttribute = _data["structLayoutAttribute"] ? StructLayoutAttribute.fromJS(_data["structLayoutAttribute"]) : null as any;
            this.typeInitializer = _data["typeInitializer"] ? ConstructorInfo.fromJS(_data["typeInitializer"]) : null as any;
            this.typeHandle = _data["typeHandle"] ? RuntimeTypeHandle.fromJS(_data["typeHandle"]) : null as any;
            (this as any).guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.baseType = _data["baseType"] ? Type.fromJS(_data["baseType"]) : null as any;
            (this as any).isSerializable = _data["isSerializable"] !== undefined ? _data["isSerializable"] : null as any;
            (this as any).containsGenericParameters = _data["containsGenericParameters"] !== undefined ? _data["containsGenericParameters"] : null as any;
            (this as any).isVisible = _data["isVisible"] !== undefined ? _data["isVisible"] : null as any;
        }
    }

    static fromJS(data: any): Type {
        data = typeof data === 'object' ? data : {};
        let result = new Type();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : null as any);
        }
        data["isCollectible"] = this.isCollectible !== undefined ? this.isCollectible : null as any;
        data["metadataToken"] = this.metadataToken !== undefined ? this.metadataToken : null as any;
        data["isInterface"] = this.isInterface !== undefined ? this.isInterface : null as any;
        data["memberType"] = this.memberType !== undefined ? this.memberType : null as any;
        data["namespace"] = this.namespace !== undefined ? this.namespace : null as any;
        data["assemblyQualifiedName"] = this.assemblyQualifiedName !== undefined ? this.assemblyQualifiedName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : null as any;
        data["module"] = this.module ? this.module.toJSON() : null as any;
        data["isNested"] = this.isNested !== undefined ? this.isNested : null as any;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : null as any;
        data["declaringMethod"] = this.declaringMethod ? this.declaringMethod.toJSON() : null as any;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : null as any;
        data["underlyingSystemType"] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : null as any;
        data["isTypeDefinition"] = this.isTypeDefinition !== undefined ? this.isTypeDefinition : null as any;
        data["isArray"] = this.isArray !== undefined ? this.isArray : null as any;
        data["isByRef"] = this.isByRef !== undefined ? this.isByRef : null as any;
        data["isPointer"] = this.isPointer !== undefined ? this.isPointer : null as any;
        data["isConstructedGenericType"] = this.isConstructedGenericType !== undefined ? this.isConstructedGenericType : null as any;
        data["isGenericParameter"] = this.isGenericParameter !== undefined ? this.isGenericParameter : null as any;
        data["isGenericTypeParameter"] = this.isGenericTypeParameter !== undefined ? this.isGenericTypeParameter : null as any;
        data["isGenericMethodParameter"] = this.isGenericMethodParameter !== undefined ? this.isGenericMethodParameter : null as any;
        data["isGenericType"] = this.isGenericType !== undefined ? this.isGenericType : null as any;
        data["isGenericTypeDefinition"] = this.isGenericTypeDefinition !== undefined ? this.isGenericTypeDefinition : null as any;
        data["isSZArray"] = this.isSZArray !== undefined ? this.isSZArray : null as any;
        data["isVariableBoundArray"] = this.isVariableBoundArray !== undefined ? this.isVariableBoundArray : null as any;
        data["isByRefLike"] = this.isByRefLike !== undefined ? this.isByRefLike : null as any;
        data["isFunctionPointer"] = this.isFunctionPointer !== undefined ? this.isFunctionPointer : null as any;
        data["isUnmanagedFunctionPointer"] = this.isUnmanagedFunctionPointer !== undefined ? this.isUnmanagedFunctionPointer : null as any;
        data["hasElementType"] = this.hasElementType !== undefined ? this.hasElementType : null as any;
        if (Array.isArray(this.genericTypeArguments)) {
            data["genericTypeArguments"] = [];
            for (let item of this.genericTypeArguments)
                data["genericTypeArguments"].push(item ? item.toJSON() : null as any);
        }
        data["genericParameterPosition"] = this.genericParameterPosition !== undefined ? this.genericParameterPosition : null as any;
        data["genericParameterAttributes"] = this.genericParameterAttributes !== undefined ? this.genericParameterAttributes : null as any;
        data["attributes"] = this.attributes !== undefined ? this.attributes : null as any;
        data["isAbstract"] = this.isAbstract !== undefined ? this.isAbstract : null as any;
        data["isImport"] = this.isImport !== undefined ? this.isImport : null as any;
        data["isSealed"] = this.isSealed !== undefined ? this.isSealed : null as any;
        data["isSpecialName"] = this.isSpecialName !== undefined ? this.isSpecialName : null as any;
        data["isClass"] = this.isClass !== undefined ? this.isClass : null as any;
        data["isNestedAssembly"] = this.isNestedAssembly !== undefined ? this.isNestedAssembly : null as any;
        data["isNestedFamANDAssem"] = this.isNestedFamANDAssem !== undefined ? this.isNestedFamANDAssem : null as any;
        data["isNestedFamily"] = this.isNestedFamily !== undefined ? this.isNestedFamily : null as any;
        data["isNestedFamORAssem"] = this.isNestedFamORAssem !== undefined ? this.isNestedFamORAssem : null as any;
        data["isNestedPrivate"] = this.isNestedPrivate !== undefined ? this.isNestedPrivate : null as any;
        data["isNestedPublic"] = this.isNestedPublic !== undefined ? this.isNestedPublic : null as any;
        data["isNotPublic"] = this.isNotPublic !== undefined ? this.isNotPublic : null as any;
        data["isPublic"] = this.isPublic !== undefined ? this.isPublic : null as any;
        data["isAutoLayout"] = this.isAutoLayout !== undefined ? this.isAutoLayout : null as any;
        data["isExplicitLayout"] = this.isExplicitLayout !== undefined ? this.isExplicitLayout : null as any;
        data["isLayoutSequential"] = this.isLayoutSequential !== undefined ? this.isLayoutSequential : null as any;
        data["isAnsiClass"] = this.isAnsiClass !== undefined ? this.isAnsiClass : null as any;
        data["isAutoClass"] = this.isAutoClass !== undefined ? this.isAutoClass : null as any;
        data["isUnicodeClass"] = this.isUnicodeClass !== undefined ? this.isUnicodeClass : null as any;
        data["isCOMObject"] = this.isCOMObject !== undefined ? this.isCOMObject : null as any;
        data["isContextful"] = this.isContextful !== undefined ? this.isContextful : null as any;
        data["isEnum"] = this.isEnum !== undefined ? this.isEnum : null as any;
        data["isMarshalByRef"] = this.isMarshalByRef !== undefined ? this.isMarshalByRef : null as any;
        data["isPrimitive"] = this.isPrimitive !== undefined ? this.isPrimitive : null as any;
        data["isValueType"] = this.isValueType !== undefined ? this.isValueType : null as any;
        data["isSignatureType"] = this.isSignatureType !== undefined ? this.isSignatureType : null as any;
        data["isSecurityCritical"] = this.isSecurityCritical !== undefined ? this.isSecurityCritical : null as any;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical !== undefined ? this.isSecuritySafeCritical : null as any;
        data["isSecurityTransparent"] = this.isSecurityTransparent !== undefined ? this.isSecurityTransparent : null as any;
        data["structLayoutAttribute"] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : null as any;
        data["typeInitializer"] = this.typeInitializer ? this.typeInitializer.toJSON() : null as any;
        data["typeHandle"] = this.typeHandle ? this.typeHandle.toJSON() : null as any;
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : null as any;
        data["isSerializable"] = this.isSerializable !== undefined ? this.isSerializable : null as any;
        data["containsGenericParameters"] = this.containsGenericParameters !== undefined ? this.containsGenericParameters : null as any;
        data["isVisible"] = this.isVisible !== undefined ? this.isVisible : null as any;
        return data;
    }
}

/** 0 = Class 1 = Public 2 = NestedPublic 3 = NestedPrivate 4 = NestedFamily 5 = NestedAssembly 6 = NestedFamANDAssem 7 = NestedFamORAssem 8 = SequentialLayout 16 = ExplicitLayout 24 = LayoutMask 32 = ClassSemanticsMask 128 = Abstract 256 = Sealed 1024 = SpecialName 2048 = RTSpecialName 4096 = Import 8192 = Serializable 16384 = WindowsRuntime 65536 = UnicodeClass 131072 = AutoClass 196608 = CustomFormatClass 262144 = HasSecurity 264192 = ReservedMask 1048576 = BeforeFieldInit 12582912 = CustomFormatMask */
export enum TypeAttributes {
    Class = 0,
    Public = 1,
    NestedPublic = 2,
    NestedPrivate = 3,
    NestedFamily = 4,
    NestedAssembly = 5,
    NestedFamANDAssem = 6,
    NestedFamORAssem = 7,
    SequentialLayout = 8,
    ExplicitLayout = 16,
    LayoutMask = 24,
    ClassSemanticsMask = 32,
    Abstract = 128,
    Sealed = 256,
    SpecialName = 1024,
    RTSpecialName = 2048,
    Import = 4096,
    Serializable = 8192,
    WindowsRuntime = 16384,
    UnicodeClass = 65536,
    AutoClass = 131072,
    CustomFormatClass = 196608,
    HasSecurity = 262144,
    ReservedMask = 264192,
    BeforeFieldInit = 1048576,
    CustomFormatMask = 12582912,
}

export class TypeInfo {
    readonly name!: string | null;
    readonly customAttributes!: CustomAttributeData[] | null;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    readonly isInterface!: boolean;
    memberType!: MemberTypes;
    readonly namespace!: string | null;
    readonly assemblyQualifiedName!: string | null;
    readonly fullName!: string | null;
    assembly!: Assembly;
    module!: Module;
    readonly isNested!: boolean;
    declaringType!: Type;
    declaringMethod!: MethodBase;
    reflectedType!: Type;
    underlyingSystemType!: Type;
    readonly isTypeDefinition!: boolean;
    readonly isArray!: boolean;
    readonly isByRef!: boolean;
    readonly isPointer!: boolean;
    readonly isConstructedGenericType!: boolean;
    readonly isGenericParameter!: boolean;
    readonly isGenericTypeParameter!: boolean;
    readonly isGenericMethodParameter!: boolean;
    readonly isGenericType!: boolean;
    readonly isGenericTypeDefinition!: boolean;
    readonly isSZArray!: boolean;
    readonly isVariableBoundArray!: boolean;
    readonly isByRefLike!: boolean;
    readonly isFunctionPointer!: boolean;
    readonly isUnmanagedFunctionPointer!: boolean;
    readonly hasElementType!: boolean;
    readonly genericTypeArguments!: Type[] | null;
    readonly genericParameterPosition!: number;
    genericParameterAttributes!: GenericParameterAttributes;
    attributes!: TypeAttributes;
    readonly isAbstract!: boolean;
    readonly isImport!: boolean;
    readonly isSealed!: boolean;
    readonly isSpecialName!: boolean;
    readonly isClass!: boolean;
    readonly isNestedAssembly!: boolean;
    readonly isNestedFamANDAssem!: boolean;
    readonly isNestedFamily!: boolean;
    readonly isNestedFamORAssem!: boolean;
    readonly isNestedPrivate!: boolean;
    readonly isNestedPublic!: boolean;
    readonly isNotPublic!: boolean;
    readonly isPublic!: boolean;
    readonly isAutoLayout!: boolean;
    readonly isExplicitLayout!: boolean;
    readonly isLayoutSequential!: boolean;
    readonly isAnsiClass!: boolean;
    readonly isAutoClass!: boolean;
    readonly isUnicodeClass!: boolean;
    readonly isCOMObject!: boolean;
    readonly isContextful!: boolean;
    readonly isEnum!: boolean;
    readonly isMarshalByRef!: boolean;
    readonly isPrimitive!: boolean;
    readonly isValueType!: boolean;
    readonly isSignatureType!: boolean;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    structLayoutAttribute!: StructLayoutAttribute;
    typeInitializer!: ConstructorInfo;
    typeHandle!: RuntimeTypeHandle;
    readonly guid!: string;
    baseType!: Type;
    readonly isSerializable!: boolean;
    readonly containsGenericParameters!: boolean;
    readonly isVisible!: boolean;
    readonly genericTypeParameters!: Type[] | null;
    readonly declaredConstructors!: ConstructorInfo[] | null;
    readonly declaredEvents!: EventInfo[] | null;
    readonly declaredFields!: FieldInfo[] | null;
    readonly declaredMembers!: MemberInfo[] | null;
    readonly declaredMethods!: MethodInfo[] | null;
    readonly declaredNestedTypes!: TypeInfo[] | null;
    readonly declaredProperties!: PropertyInfo[] | null;
    readonly implementedInterfaces!: Type[] | null;

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            else {
                (this as any).customAttributes = null as any;
            }
            (this as any).isCollectible = _data["isCollectible"] !== undefined ? _data["isCollectible"] : null as any;
            (this as any).metadataToken = _data["metadataToken"] !== undefined ? _data["metadataToken"] : null as any;
            (this as any).isInterface = _data["isInterface"] !== undefined ? _data["isInterface"] : null as any;
            this.memberType = _data["memberType"] !== undefined ? _data["memberType"] : null as any;
            (this as any).namespace = _data["namespace"] !== undefined ? _data["namespace"] : null as any;
            (this as any).assemblyQualifiedName = _data["assemblyQualifiedName"] !== undefined ? _data["assemblyQualifiedName"] : null as any;
            (this as any).fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : null as any;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : null as any;
            (this as any).isNested = _data["isNested"] !== undefined ? _data["isNested"] : null as any;
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : null as any;
            this.declaringMethod = _data["declaringMethod"] ? MethodBase.fromJS(_data["declaringMethod"]) : null as any;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : null as any;
            this.underlyingSystemType = _data["underlyingSystemType"] ? Type.fromJS(_data["underlyingSystemType"]) : null as any;
            (this as any).isTypeDefinition = _data["isTypeDefinition"] !== undefined ? _data["isTypeDefinition"] : null as any;
            (this as any).isArray = _data["isArray"] !== undefined ? _data["isArray"] : null as any;
            (this as any).isByRef = _data["isByRef"] !== undefined ? _data["isByRef"] : null as any;
            (this as any).isPointer = _data["isPointer"] !== undefined ? _data["isPointer"] : null as any;
            (this as any).isConstructedGenericType = _data["isConstructedGenericType"] !== undefined ? _data["isConstructedGenericType"] : null as any;
            (this as any).isGenericParameter = _data["isGenericParameter"] !== undefined ? _data["isGenericParameter"] : null as any;
            (this as any).isGenericTypeParameter = _data["isGenericTypeParameter"] !== undefined ? _data["isGenericTypeParameter"] : null as any;
            (this as any).isGenericMethodParameter = _data["isGenericMethodParameter"] !== undefined ? _data["isGenericMethodParameter"] : null as any;
            (this as any).isGenericType = _data["isGenericType"] !== undefined ? _data["isGenericType"] : null as any;
            (this as any).isGenericTypeDefinition = _data["isGenericTypeDefinition"] !== undefined ? _data["isGenericTypeDefinition"] : null as any;
            (this as any).isSZArray = _data["isSZArray"] !== undefined ? _data["isSZArray"] : null as any;
            (this as any).isVariableBoundArray = _data["isVariableBoundArray"] !== undefined ? _data["isVariableBoundArray"] : null as any;
            (this as any).isByRefLike = _data["isByRefLike"] !== undefined ? _data["isByRefLike"] : null as any;
            (this as any).isFunctionPointer = _data["isFunctionPointer"] !== undefined ? _data["isFunctionPointer"] : null as any;
            (this as any).isUnmanagedFunctionPointer = _data["isUnmanagedFunctionPointer"] !== undefined ? _data["isUnmanagedFunctionPointer"] : null as any;
            (this as any).hasElementType = _data["hasElementType"] !== undefined ? _data["hasElementType"] : null as any;
            if (Array.isArray(_data["genericTypeArguments"])) {
                (this as any).genericTypeArguments = [] as any;
                for (let item of _data["genericTypeArguments"])
                    (this as any).genericTypeArguments!.push(Type.fromJS(item));
            }
            else {
                (this as any).genericTypeArguments = null as any;
            }
            (this as any).genericParameterPosition = _data["genericParameterPosition"] !== undefined ? _data["genericParameterPosition"] : null as any;
            this.genericParameterAttributes = _data["genericParameterAttributes"] !== undefined ? _data["genericParameterAttributes"] : null as any;
            this.attributes = _data["attributes"] !== undefined ? _data["attributes"] : null as any;
            (this as any).isAbstract = _data["isAbstract"] !== undefined ? _data["isAbstract"] : null as any;
            (this as any).isImport = _data["isImport"] !== undefined ? _data["isImport"] : null as any;
            (this as any).isSealed = _data["isSealed"] !== undefined ? _data["isSealed"] : null as any;
            (this as any).isSpecialName = _data["isSpecialName"] !== undefined ? _data["isSpecialName"] : null as any;
            (this as any).isClass = _data["isClass"] !== undefined ? _data["isClass"] : null as any;
            (this as any).isNestedAssembly = _data["isNestedAssembly"] !== undefined ? _data["isNestedAssembly"] : null as any;
            (this as any).isNestedFamANDAssem = _data["isNestedFamANDAssem"] !== undefined ? _data["isNestedFamANDAssem"] : null as any;
            (this as any).isNestedFamily = _data["isNestedFamily"] !== undefined ? _data["isNestedFamily"] : null as any;
            (this as any).isNestedFamORAssem = _data["isNestedFamORAssem"] !== undefined ? _data["isNestedFamORAssem"] : null as any;
            (this as any).isNestedPrivate = _data["isNestedPrivate"] !== undefined ? _data["isNestedPrivate"] : null as any;
            (this as any).isNestedPublic = _data["isNestedPublic"] !== undefined ? _data["isNestedPublic"] : null as any;
            (this as any).isNotPublic = _data["isNotPublic"] !== undefined ? _data["isNotPublic"] : null as any;
            (this as any).isPublic = _data["isPublic"] !== undefined ? _data["isPublic"] : null as any;
            (this as any).isAutoLayout = _data["isAutoLayout"] !== undefined ? _data["isAutoLayout"] : null as any;
            (this as any).isExplicitLayout = _data["isExplicitLayout"] !== undefined ? _data["isExplicitLayout"] : null as any;
            (this as any).isLayoutSequential = _data["isLayoutSequential"] !== undefined ? _data["isLayoutSequential"] : null as any;
            (this as any).isAnsiClass = _data["isAnsiClass"] !== undefined ? _data["isAnsiClass"] : null as any;
            (this as any).isAutoClass = _data["isAutoClass"] !== undefined ? _data["isAutoClass"] : null as any;
            (this as any).isUnicodeClass = _data["isUnicodeClass"] !== undefined ? _data["isUnicodeClass"] : null as any;
            (this as any).isCOMObject = _data["isCOMObject"] !== undefined ? _data["isCOMObject"] : null as any;
            (this as any).isContextful = _data["isContextful"] !== undefined ? _data["isContextful"] : null as any;
            (this as any).isEnum = _data["isEnum"] !== undefined ? _data["isEnum"] : null as any;
            (this as any).isMarshalByRef = _data["isMarshalByRef"] !== undefined ? _data["isMarshalByRef"] : null as any;
            (this as any).isPrimitive = _data["isPrimitive"] !== undefined ? _data["isPrimitive"] : null as any;
            (this as any).isValueType = _data["isValueType"] !== undefined ? _data["isValueType"] : null as any;
            (this as any).isSignatureType = _data["isSignatureType"] !== undefined ? _data["isSignatureType"] : null as any;
            (this as any).isSecurityCritical = _data["isSecurityCritical"] !== undefined ? _data["isSecurityCritical"] : null as any;
            (this as any).isSecuritySafeCritical = _data["isSecuritySafeCritical"] !== undefined ? _data["isSecuritySafeCritical"] : null as any;
            (this as any).isSecurityTransparent = _data["isSecurityTransparent"] !== undefined ? _data["isSecurityTransparent"] : null as any;
            this.structLayoutAttribute = _data["structLayoutAttribute"] ? StructLayoutAttribute.fromJS(_data["structLayoutAttribute"]) : null as any;
            this.typeInitializer = _data["typeInitializer"] ? ConstructorInfo.fromJS(_data["typeInitializer"]) : null as any;
            this.typeHandle = _data["typeHandle"] ? RuntimeTypeHandle.fromJS(_data["typeHandle"]) : null as any;
            (this as any).guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.baseType = _data["baseType"] ? Type.fromJS(_data["baseType"]) : null as any;
            (this as any).isSerializable = _data["isSerializable"] !== undefined ? _data["isSerializable"] : null as any;
            (this as any).containsGenericParameters = _data["containsGenericParameters"] !== undefined ? _data["containsGenericParameters"] : null as any;
            (this as any).isVisible = _data["isVisible"] !== undefined ? _data["isVisible"] : null as any;
            if (Array.isArray(_data["genericTypeParameters"])) {
                (this as any).genericTypeParameters = [] as any;
                for (let item of _data["genericTypeParameters"])
                    (this as any).genericTypeParameters!.push(Type.fromJS(item));
            }
            else {
                (this as any).genericTypeParameters = null as any;
            }
            if (Array.isArray(_data["declaredConstructors"])) {
                (this as any).declaredConstructors = [] as any;
                for (let item of _data["declaredConstructors"])
                    (this as any).declaredConstructors!.push(ConstructorInfo.fromJS(item));
            }
            else {
                (this as any).declaredConstructors = null as any;
            }
            if (Array.isArray(_data["declaredEvents"])) {
                (this as any).declaredEvents = [] as any;
                for (let item of _data["declaredEvents"])
                    (this as any).declaredEvents!.push(EventInfo.fromJS(item));
            }
            else {
                (this as any).declaredEvents = null as any;
            }
            if (Array.isArray(_data["declaredFields"])) {
                (this as any).declaredFields = [] as any;
                for (let item of _data["declaredFields"])
                    (this as any).declaredFields!.push(FieldInfo.fromJS(item));
            }
            else {
                (this as any).declaredFields = null as any;
            }
            if (Array.isArray(_data["declaredMembers"])) {
                (this as any).declaredMembers = [] as any;
                for (let item of _data["declaredMembers"])
                    (this as any).declaredMembers!.push(MemberInfo.fromJS(item));
            }
            else {
                (this as any).declaredMembers = null as any;
            }
            if (Array.isArray(_data["declaredMethods"])) {
                (this as any).declaredMethods = [] as any;
                for (let item of _data["declaredMethods"])
                    (this as any).declaredMethods!.push(MethodInfo.fromJS(item));
            }
            else {
                (this as any).declaredMethods = null as any;
            }
            if (Array.isArray(_data["declaredNestedTypes"])) {
                (this as any).declaredNestedTypes = [] as any;
                for (let item of _data["declaredNestedTypes"])
                    (this as any).declaredNestedTypes!.push(TypeInfo.fromJS(item));
            }
            else {
                (this as any).declaredNestedTypes = null as any;
            }
            if (Array.isArray(_data["declaredProperties"])) {
                (this as any).declaredProperties = [] as any;
                for (let item of _data["declaredProperties"])
                    (this as any).declaredProperties!.push(PropertyInfo.fromJS(item));
            }
            else {
                (this as any).declaredProperties = null as any;
            }
            if (Array.isArray(_data["implementedInterfaces"])) {
                (this as any).implementedInterfaces = [] as any;
                for (let item of _data["implementedInterfaces"])
                    (this as any).implementedInterfaces!.push(Type.fromJS(item));
            }
            else {
                (this as any).implementedInterfaces = null as any;
            }
        }
    }

    static fromJS(data: any): TypeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TypeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : null as any);
        }
        data["isCollectible"] = this.isCollectible !== undefined ? this.isCollectible : null as any;
        data["metadataToken"] = this.metadataToken !== undefined ? this.metadataToken : null as any;
        data["isInterface"] = this.isInterface !== undefined ? this.isInterface : null as any;
        data["memberType"] = this.memberType !== undefined ? this.memberType : null as any;
        data["namespace"] = this.namespace !== undefined ? this.namespace : null as any;
        data["assemblyQualifiedName"] = this.assemblyQualifiedName !== undefined ? this.assemblyQualifiedName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : null as any;
        data["module"] = this.module ? this.module.toJSON() : null as any;
        data["isNested"] = this.isNested !== undefined ? this.isNested : null as any;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : null as any;
        data["declaringMethod"] = this.declaringMethod ? this.declaringMethod.toJSON() : null as any;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : null as any;
        data["underlyingSystemType"] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : null as any;
        data["isTypeDefinition"] = this.isTypeDefinition !== undefined ? this.isTypeDefinition : null as any;
        data["isArray"] = this.isArray !== undefined ? this.isArray : null as any;
        data["isByRef"] = this.isByRef !== undefined ? this.isByRef : null as any;
        data["isPointer"] = this.isPointer !== undefined ? this.isPointer : null as any;
        data["isConstructedGenericType"] = this.isConstructedGenericType !== undefined ? this.isConstructedGenericType : null as any;
        data["isGenericParameter"] = this.isGenericParameter !== undefined ? this.isGenericParameter : null as any;
        data["isGenericTypeParameter"] = this.isGenericTypeParameter !== undefined ? this.isGenericTypeParameter : null as any;
        data["isGenericMethodParameter"] = this.isGenericMethodParameter !== undefined ? this.isGenericMethodParameter : null as any;
        data["isGenericType"] = this.isGenericType !== undefined ? this.isGenericType : null as any;
        data["isGenericTypeDefinition"] = this.isGenericTypeDefinition !== undefined ? this.isGenericTypeDefinition : null as any;
        data["isSZArray"] = this.isSZArray !== undefined ? this.isSZArray : null as any;
        data["isVariableBoundArray"] = this.isVariableBoundArray !== undefined ? this.isVariableBoundArray : null as any;
        data["isByRefLike"] = this.isByRefLike !== undefined ? this.isByRefLike : null as any;
        data["isFunctionPointer"] = this.isFunctionPointer !== undefined ? this.isFunctionPointer : null as any;
        data["isUnmanagedFunctionPointer"] = this.isUnmanagedFunctionPointer !== undefined ? this.isUnmanagedFunctionPointer : null as any;
        data["hasElementType"] = this.hasElementType !== undefined ? this.hasElementType : null as any;
        if (Array.isArray(this.genericTypeArguments)) {
            data["genericTypeArguments"] = [];
            for (let item of this.genericTypeArguments)
                data["genericTypeArguments"].push(item ? item.toJSON() : null as any);
        }
        data["genericParameterPosition"] = this.genericParameterPosition !== undefined ? this.genericParameterPosition : null as any;
        data["genericParameterAttributes"] = this.genericParameterAttributes !== undefined ? this.genericParameterAttributes : null as any;
        data["attributes"] = this.attributes !== undefined ? this.attributes : null as any;
        data["isAbstract"] = this.isAbstract !== undefined ? this.isAbstract : null as any;
        data["isImport"] = this.isImport !== undefined ? this.isImport : null as any;
        data["isSealed"] = this.isSealed !== undefined ? this.isSealed : null as any;
        data["isSpecialName"] = this.isSpecialName !== undefined ? this.isSpecialName : null as any;
        data["isClass"] = this.isClass !== undefined ? this.isClass : null as any;
        data["isNestedAssembly"] = this.isNestedAssembly !== undefined ? this.isNestedAssembly : null as any;
        data["isNestedFamANDAssem"] = this.isNestedFamANDAssem !== undefined ? this.isNestedFamANDAssem : null as any;
        data["isNestedFamily"] = this.isNestedFamily !== undefined ? this.isNestedFamily : null as any;
        data["isNestedFamORAssem"] = this.isNestedFamORAssem !== undefined ? this.isNestedFamORAssem : null as any;
        data["isNestedPrivate"] = this.isNestedPrivate !== undefined ? this.isNestedPrivate : null as any;
        data["isNestedPublic"] = this.isNestedPublic !== undefined ? this.isNestedPublic : null as any;
        data["isNotPublic"] = this.isNotPublic !== undefined ? this.isNotPublic : null as any;
        data["isPublic"] = this.isPublic !== undefined ? this.isPublic : null as any;
        data["isAutoLayout"] = this.isAutoLayout !== undefined ? this.isAutoLayout : null as any;
        data["isExplicitLayout"] = this.isExplicitLayout !== undefined ? this.isExplicitLayout : null as any;
        data["isLayoutSequential"] = this.isLayoutSequential !== undefined ? this.isLayoutSequential : null as any;
        data["isAnsiClass"] = this.isAnsiClass !== undefined ? this.isAnsiClass : null as any;
        data["isAutoClass"] = this.isAutoClass !== undefined ? this.isAutoClass : null as any;
        data["isUnicodeClass"] = this.isUnicodeClass !== undefined ? this.isUnicodeClass : null as any;
        data["isCOMObject"] = this.isCOMObject !== undefined ? this.isCOMObject : null as any;
        data["isContextful"] = this.isContextful !== undefined ? this.isContextful : null as any;
        data["isEnum"] = this.isEnum !== undefined ? this.isEnum : null as any;
        data["isMarshalByRef"] = this.isMarshalByRef !== undefined ? this.isMarshalByRef : null as any;
        data["isPrimitive"] = this.isPrimitive !== undefined ? this.isPrimitive : null as any;
        data["isValueType"] = this.isValueType !== undefined ? this.isValueType : null as any;
        data["isSignatureType"] = this.isSignatureType !== undefined ? this.isSignatureType : null as any;
        data["isSecurityCritical"] = this.isSecurityCritical !== undefined ? this.isSecurityCritical : null as any;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical !== undefined ? this.isSecuritySafeCritical : null as any;
        data["isSecurityTransparent"] = this.isSecurityTransparent !== undefined ? this.isSecurityTransparent : null as any;
        data["structLayoutAttribute"] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : null as any;
        data["typeInitializer"] = this.typeInitializer ? this.typeInitializer.toJSON() : null as any;
        data["typeHandle"] = this.typeHandle ? this.typeHandle.toJSON() : null as any;
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : null as any;
        data["isSerializable"] = this.isSerializable !== undefined ? this.isSerializable : null as any;
        data["containsGenericParameters"] = this.containsGenericParameters !== undefined ? this.containsGenericParameters : null as any;
        data["isVisible"] = this.isVisible !== undefined ? this.isVisible : null as any;
        if (Array.isArray(this.genericTypeParameters)) {
            data["genericTypeParameters"] = [];
            for (let item of this.genericTypeParameters)
                data["genericTypeParameters"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.declaredConstructors)) {
            data["declaredConstructors"] = [];
            for (let item of this.declaredConstructors)
                data["declaredConstructors"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.declaredEvents)) {
            data["declaredEvents"] = [];
            for (let item of this.declaredEvents)
                data["declaredEvents"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.declaredFields)) {
            data["declaredFields"] = [];
            for (let item of this.declaredFields)
                data["declaredFields"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.declaredMembers)) {
            data["declaredMembers"] = [];
            for (let item of this.declaredMembers)
                data["declaredMembers"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.declaredMethods)) {
            data["declaredMethods"] = [];
            for (let item of this.declaredMethods)
                data["declaredMethods"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.declaredNestedTypes)) {
            data["declaredNestedTypes"] = [];
            for (let item of this.declaredNestedTypes)
                data["declaredNestedTypes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.declaredProperties)) {
            data["declaredProperties"] = [];
            for (let item of this.declaredProperties)
                data["declaredProperties"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.implementedInterfaces)) {
            data["implementedInterfaces"] = [];
            for (let item of this.implementedInterfaces)
                data["implementedInterfaces"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class UpdateBasicMotorConfirmStatusInputDto {
    basicMotorInfoIds!: string[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["basicMotorInfoIds"])) {
                this.basicMotorInfoIds = [] as any;
                for (let item of _data["basicMotorInfoIds"])
                    this.basicMotorInfoIds!.push(item);
            }
            else {
                this.basicMotorInfoIds = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateBasicMotorConfirmStatusInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBasicMotorConfirmStatusInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.basicMotorInfoIds)) {
            data["basicMotorInfoIds"] = [];
            for (let item of this.basicMotorInfoIds)
                data["basicMotorInfoIds"].push(item);
        }
        return data;
    }
}

export class UpdateCategoryDto {
    /** 含义 */
    meaning!: string | null;
    /** 描述 */
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): UpdateCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

export class UpdateCustomProductUnitPriceInputDto {
    id!: string;
    unitPrice!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
        }
    }

    static fromJS(data: any): UpdateCustomProductUnitPriceInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomProductUnitPriceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        return data;
    }
}

export class UpdateCustomVcDto {
    /** VC ID */
    vcID!: string | null;
    /** 品类 */
    categoryId!: string;
    /** VC含义 */
    meaning!: string | null;
    /** 英文含义 */
    englishMeaning!: string | null;
    /** VC备注 */
    vcTypeDescription!: string | null;
    /** VC头数 */
    numberWires!: number;

    init(_data?: any) {
        if (_data) {
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
        }
    }

    static fromJS(data: any): UpdateCustomVcDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomVcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        return data;
    }
}

export class UpdateCustomVcPriceDto {
    /** 主机代码 */
    basicMotorCode!: string | null;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 主机型号 */
    basicMotorModel!: string | null;
    /** 机座号 */
    frameNo!: number;
    /** 工程周期（自然日） */
    engineeringCycle!: number | null;
    engineeringCalculationMode!: EngineeringCalculationMode;
    /** 采购周期（工作日） */
    purchaseCycle!: number | null;
    purchaseCycleMode!: PurchaseCycleMode;
    /** 生产周期（自然日） */
    productionCycle!: number | null;
    /** 测试周期（自然日） */
    testCycle!: number | null;
    /** 船检周期（自然日） */
    shipSurveyCycle!: number | null;
    /** GR增量 */
    grCycle!: number | null;
    /** SCM周期 */
    scmCycle!: number | null;
    /** SCM计算方式 */
    scmCalculationMode!: string | null;
    /** SCM备注 */
    scmRemark!: string | null;
    /** 额外叠加时间 */
    extraOverlayTime!: boolean | null;
    /** 是否叠加逻辑 */
    isOverlayLogic!: boolean | null;
    /** 单价 */
    unitPrice!: number | null;
    /** 面价公式 */
    unitPriceFormula!: string | null;
    unitPriceType!: UnitPriceType;
    /** 成本 */
    cost!: number | null;
    /** 成本公式 */
    costFormula!: string | null;
    costType!: CostType;
    /** 成本类型详情 */
    costTypeDetail!: string | null;
    /** 报价原则 */
    quotationPrinciple!: string | null;
    /** 报价原则详情 */
    quotationPrincipleDetails!: string | null;

    init(_data?: any) {
        if (_data) {
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.scmCycle = _data["scmCycle"] !== undefined ? _data["scmCycle"] : null as any;
            this.scmCalculationMode = _data["scmCalculationMode"] !== undefined ? _data["scmCalculationMode"] : null as any;
            this.scmRemark = _data["scmRemark"] !== undefined ? _data["scmRemark"] : null as any;
            this.extraOverlayTime = _data["extraOverlayTime"] !== undefined ? _data["extraOverlayTime"] : null as any;
            this.isOverlayLogic = _data["isOverlayLogic"] !== undefined ? _data["isOverlayLogic"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
        }
    }

    static fromJS(data: any): UpdateCustomVcPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomVcPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["scmCycle"] = this.scmCycle !== undefined ? this.scmCycle : null as any;
        data["scmCalculationMode"] = this.scmCalculationMode !== undefined ? this.scmCalculationMode : null as any;
        data["scmRemark"] = this.scmRemark !== undefined ? this.scmRemark : null as any;
        data["extraOverlayTime"] = this.extraOverlayTime !== undefined ? this.extraOverlayTime : null as any;
        data["isOverlayLogic"] = this.isOverlayLogic !== undefined ? this.isOverlayLogic : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        return data;
    }
}

export class UpdateCustomVcUnitPriceInputDto {
    id!: string;
    unitPrice!: number;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
        }
    }

    static fromJS(data: any): UpdateCustomVcUnitPriceInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomVcUnitPriceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        return data;
    }
}

/** 更新国产报价 */
export class UpdateDqDto {
    /** 国产报价编号 */
    id!: string;
    /** 国产报价号 */
    domesticQuotationNumber!: string | null;
    /** 生产周期 */
    cycle!: number;
    /** 技术协议附件列表 */
    dqAttachs!: string | null;
    /** 国产报价备注 */
    dqRemark!: string | null;
    /** 报价过期时间 */
    quotationExpiredTime!: moment.Moment | null;
    dqStatus!: TechnologyQuotationStatus;
    technologyQuotationProducts!: UpdateDqProductDto[] | null;
    /** 是否提交 */
    isSubmit!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.domesticQuotationNumber = _data["domesticQuotationNumber"] !== undefined ? _data["domesticQuotationNumber"] : null as any;
            this.cycle = _data["cycle"] !== undefined ? _data["cycle"] : null as any;
            this.dqAttachs = _data["dqAttachs"] !== undefined ? _data["dqAttachs"] : null as any;
            this.dqRemark = _data["dqRemark"] !== undefined ? _data["dqRemark"] : null as any;
            this.quotationExpiredTime = _data["quotationExpiredTime"] ? moment(_data["quotationExpiredTime"].toString()) : null as any;
            this.dqStatus = _data["dqStatus"] !== undefined ? _data["dqStatus"] : null as any;
            if (Array.isArray(_data["technologyQuotationProducts"])) {
                this.technologyQuotationProducts = [] as any;
                for (let item of _data["technologyQuotationProducts"])
                    this.technologyQuotationProducts!.push(UpdateDqProductDto.fromJS(item));
            }
            else {
                this.technologyQuotationProducts = null as any;
            }
            this.isSubmit = _data["isSubmit"] !== undefined ? _data["isSubmit"] : null as any;
        }
    }

    static fromJS(data: any): UpdateDqDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["domesticQuotationNumber"] = this.domesticQuotationNumber !== undefined ? this.domesticQuotationNumber : null as any;
        data["cycle"] = this.cycle !== undefined ? this.cycle : null as any;
        data["dqAttachs"] = this.dqAttachs !== undefined ? this.dqAttachs : null as any;
        data["dqRemark"] = this.dqRemark !== undefined ? this.dqRemark : null as any;
        data["quotationExpiredTime"] = this.quotationExpiredTime ? this.quotationExpiredTime.toISOString() : null as any;
        data["dqStatus"] = this.dqStatus !== undefined ? this.dqStatus : null as any;
        if (Array.isArray(this.technologyQuotationProducts)) {
            data["technologyQuotationProducts"] = [];
            for (let item of this.technologyQuotationProducts)
                data["technologyQuotationProducts"].push(item ? item.toJSON() : null as any);
        }
        data["isSubmit"] = this.isSubmit !== undefined ? this.isSubmit : null as any;
        return data;
    }
}

/** 更新国产报价主机 */
export class UpdateDqProductDto {
    /** 国产报价主机编号 */
    id!: string;
    /** 单价 */
    unitPrice!: number | null;
    /** 单价结果 */
    unitPriceResult!: string | null;
    /** 面价公式 */
    unitPriceFormula!: string | null;
    /** 成本 */
    cost!: number | null;
    /** 成本公式 */
    costFormula!: string | null;
    costType!: CostType;
    /** 成本类型详情 */
    costTypeDetail!: string | null;
    /** 报价原则 */
    quotationPrinciple!: string | null;
    /** 报价原则详情 */
    quotationPrincipleDetails!: string | null;
    /** 国产报价备注 */
    dqRemark!: string | null;
    technologyQuotationProductVCs!: UpdateDqProductVCDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.dqRemark = _data["dqRemark"] !== undefined ? _data["dqRemark"] : null as any;
            if (Array.isArray(_data["technologyQuotationProductVCs"])) {
                this.technologyQuotationProductVCs = [] as any;
                for (let item of _data["technologyQuotationProductVCs"])
                    this.technologyQuotationProductVCs!.push(UpdateDqProductVCDto.fromJS(item));
            }
            else {
                this.technologyQuotationProductVCs = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateDqProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDqProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["dqRemark"] = this.dqRemark !== undefined ? this.dqRemark : null as any;
        if (Array.isArray(this.technologyQuotationProductVCs)) {
            data["technologyQuotationProductVCs"] = [];
            for (let item of this.technologyQuotationProductVCs)
                data["technologyQuotationProductVCs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** 更新国产报价主机VC */
export class UpdateDqProductVCDto {
    id!: string;
    /** 单价 */
    unitPrice!: number | null;
    /** 单价结果 */
    unitPriceResult!: string | null;
    discountType!: UnitPriceType;
    /** 面价公式 */
    unitPriceFormula!: string | null;
    /** 成本 */
    cost!: number | null;
    /** 成本公式 */
    costFormula!: string | null;
    costType!: CostType;
    /** 成本类型详情 */
    costTypeDetail!: string | null;
    /** 报价原则 */
    quotationPrinciple!: string | null;
    /** 报价原则详情 */
    quotationPrincipleDetails!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.discountType = _data["discountType"] !== undefined ? _data["discountType"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
        }
    }

    static fromJS(data: any): UpdateDqProductVCDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDqProductVCDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["discountType"] = this.discountType !== undefined ? this.discountType : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        return data;
    }
}

export class UpdateGCSInputDto {
    /** 主键Id */
    helpInfoId!: string;
    /** GCS人员 */
    gcsUserId!: number;

    init(_data?: any) {
        if (_data) {
            this.helpInfoId = _data["helpInfoId"] !== undefined ? _data["helpInfoId"] : null as any;
            this.gcsUserId = _data["gcsUserId"] !== undefined ? _data["gcsUserId"] : null as any;
        }
    }

    static fromJS(data: any): UpdateGCSInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGCSInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["helpInfoId"] = this.helpInfoId !== undefined ? this.helpInfoId : null as any;
        data["gcsUserId"] = this.gcsUserId !== undefined ? this.gcsUserId : null as any;
        return data;
    }
}

export class UpdateImportProductInputDto {
    id!: string;
    basicMotorCode!: string | null;
    basicMotorModel!: string | null;
    basicMotorMounting!: string | null;
    power!: string | null;
    frequency!: string | null;
    voltage!: string | null;
    poleNo!: string | null;
    productNumber!: number;
    unitPrice!: number | null;
    unitPriceResult!: string | null;
    source!: ProdcutAndVcSource;
    vcCodes!: string | null;
    vcCodeRemark!: string | null;
    defaultMultiplier!: number;
    discountUnitPrice!: number | null;
    noDiscountByPlatformUnitPrice!: number | null;
    noDiscountByListUnitPrice!: number | null;
    gssQuotationNo!: string | null;
    gssTechnicalConfirmationNumber!: string | null;
    remarkTwo!: string | null;
    cycle!: number;
    vcs!: AddImportProductVcInputDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.productNumber = _data["productNumber"] !== undefined ? _data["productNumber"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceResult = _data["unitPriceResult"] !== undefined ? _data["unitPriceResult"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.vcCodes = _data["vcCodes"] !== undefined ? _data["vcCodes"] : null as any;
            this.vcCodeRemark = _data["vcCodeRemark"] !== undefined ? _data["vcCodeRemark"] : null as any;
            this.defaultMultiplier = _data["defaultMultiplier"] !== undefined ? _data["defaultMultiplier"] : null as any;
            this.discountUnitPrice = _data["discountUnitPrice"] !== undefined ? _data["discountUnitPrice"] : null as any;
            this.noDiscountByPlatformUnitPrice = _data["noDiscountByPlatformUnitPrice"] !== undefined ? _data["noDiscountByPlatformUnitPrice"] : null as any;
            this.noDiscountByListUnitPrice = _data["noDiscountByListUnitPrice"] !== undefined ? _data["noDiscountByListUnitPrice"] : null as any;
            this.gssQuotationNo = _data["gssQuotationNo"] !== undefined ? _data["gssQuotationNo"] : null as any;
            this.gssTechnicalConfirmationNumber = _data["gssTechnicalConfirmationNumber"] !== undefined ? _data["gssTechnicalConfirmationNumber"] : null as any;
            this.remarkTwo = _data["remarkTwo"] !== undefined ? _data["remarkTwo"] : null as any;
            this.cycle = _data["cycle"] !== undefined ? _data["cycle"] : null as any;
            if (Array.isArray(_data["vcs"])) {
                this.vcs = [] as any;
                for (let item of _data["vcs"])
                    this.vcs!.push(AddImportProductVcInputDto.fromJS(item));
            }
            else {
                this.vcs = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateImportProductInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateImportProductInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["productNumber"] = this.productNumber !== undefined ? this.productNumber : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceResult"] = this.unitPriceResult !== undefined ? this.unitPriceResult : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["vcCodes"] = this.vcCodes !== undefined ? this.vcCodes : null as any;
        data["vcCodeRemark"] = this.vcCodeRemark !== undefined ? this.vcCodeRemark : null as any;
        data["defaultMultiplier"] = this.defaultMultiplier !== undefined ? this.defaultMultiplier : null as any;
        data["discountUnitPrice"] = this.discountUnitPrice !== undefined ? this.discountUnitPrice : null as any;
        data["noDiscountByPlatformUnitPrice"] = this.noDiscountByPlatformUnitPrice !== undefined ? this.noDiscountByPlatformUnitPrice : null as any;
        data["noDiscountByListUnitPrice"] = this.noDiscountByListUnitPrice !== undefined ? this.noDiscountByListUnitPrice : null as any;
        data["gssQuotationNo"] = this.gssQuotationNo !== undefined ? this.gssQuotationNo : null as any;
        data["gssTechnicalConfirmationNumber"] = this.gssTechnicalConfirmationNumber !== undefined ? this.gssTechnicalConfirmationNumber : null as any;
        data["remarkTwo"] = this.remarkTwo !== undefined ? this.remarkTwo : null as any;
        data["cycle"] = this.cycle !== undefined ? this.cycle : null as any;
        if (Array.isArray(this.vcs)) {
            data["vcs"] = [];
            for (let item of this.vcs)
                data["vcs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class UpdateLectoTypeFinalCustomerInfoDto {
    /** 选型ID */
    lectoTypeId!: string;
    /** 二级客户代码 */
    finalCustomerCode!: string | null;
    /** 二级客户名称 */
    finalCustomerName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.finalCustomerCode = _data["finalCustomerCode"] !== undefined ? _data["finalCustomerCode"] : null as any;
            this.finalCustomerName = _data["finalCustomerName"] !== undefined ? _data["finalCustomerName"] : null as any;
        }
    }

    static fromJS(data: any): UpdateLectoTypeFinalCustomerInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLectoTypeFinalCustomerInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["finalCustomerCode"] = this.finalCustomerCode !== undefined ? this.finalCustomerCode : null as any;
        data["finalCustomerName"] = this.finalCustomerName !== undefined ? this.finalCustomerName : null as any;
        return data;
    }
}

export class UpdateLectoTypeInfoFromLPInputDto {
    /** 选型Id */
    lectoTypeId!: string | null;
    listPriceJINSeriesId!: string | null;
    /** 选型号 */
    userFriendlyID!: string | null;
    /** 境界标识符 */
    jinCategoryCode!: string | null;
    /** 面价系列Id */
    listPriceSeriesId!: string | null;
    /** 面价选型信息 */
    products!: UpdateLectoTypeProductFromLPInputDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.listPriceJINSeriesId = _data["listPriceJINSeriesId"] !== undefined ? _data["listPriceJINSeriesId"] : null as any;
            this.userFriendlyID = _data["userFriendlyID"] !== undefined ? _data["userFriendlyID"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(UpdateLectoTypeProductFromLPInputDto.fromJS(item));
            }
            else {
                this.products = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateLectoTypeInfoFromLPInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLectoTypeInfoFromLPInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["listPriceJINSeriesId"] = this.listPriceJINSeriesId !== undefined ? this.listPriceJINSeriesId : null as any;
        data["userFriendlyID"] = this.userFriendlyID !== undefined ? this.userFriendlyID : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class UpdateLectoTypeProductFromLPInputDto {
    /** 选型产品Id */
    lectoTypeProductId!: string | null;
    /** 面价 */
    unitPrice!: number | null;
    /** 标准代码 */
    basicMotorCode!: string | null;
    /** 境界系列 */
    basicMotorSries!: string | null;
    /** 主机类型 */
    basicMotorModel!: string | null;
    /** 安装方式 */
    basicMotorMounting!: string | null;
    /** 极数 */
    poleNo!: string | null;
    /** 电压 */
    voltage!: string | null;
    /** 机座号 */
    frameNo!: number;
    /** 功率 */
    power!: string | null;
    /** 编码器 */
    encoder!: string | null;
    /** 频率 */
    frequency!: string | null;
    /** 境界标识符 */
    jinCategoryCode!: string | null;
    /** 境界代码 */
    jinMotorCode!: string | null;
    /** 版本号 */
    jinVersion!: string | null;

    init(_data?: any) {
        if (_data) {
            this.lectoTypeProductId = _data["lectoTypeProductId"] !== undefined ? _data["lectoTypeProductId"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.basicMotorModel = _data["basicMotorModel"] !== undefined ? _data["basicMotorModel"] : null as any;
            this.basicMotorMounting = _data["basicMotorMounting"] !== undefined ? _data["basicMotorMounting"] : null as any;
            this.poleNo = _data["poleNo"] !== undefined ? _data["poleNo"] : null as any;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.power = _data["power"] !== undefined ? _data["power"] : null as any;
            this.encoder = _data["encoder"] !== undefined ? _data["encoder"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.jinMotorCode = _data["jinMotorCode"] !== undefined ? _data["jinMotorCode"] : null as any;
            this.jinVersion = _data["jinVersion"] !== undefined ? _data["jinVersion"] : null as any;
        }
    }

    static fromJS(data: any): UpdateLectoTypeProductFromLPInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLectoTypeProductFromLPInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lectoTypeProductId"] = this.lectoTypeProductId !== undefined ? this.lectoTypeProductId : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["basicMotorModel"] = this.basicMotorModel !== undefined ? this.basicMotorModel : null as any;
        data["basicMotorMounting"] = this.basicMotorMounting !== undefined ? this.basicMotorMounting : null as any;
        data["poleNo"] = this.poleNo !== undefined ? this.poleNo : null as any;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["power"] = this.power !== undefined ? this.power : null as any;
        data["encoder"] = this.encoder !== undefined ? this.encoder : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["jinMotorCode"] = this.jinMotorCode !== undefined ? this.jinMotorCode : null as any;
        data["jinVersion"] = this.jinVersion !== undefined ? this.jinVersion : null as any;
        return data;
    }
}

export class UpdatePMSProjectCodeDTO {
    lectoTypeId!: string | null;
    pmsProjectCode!: string | null;

    init(_data?: any) {
        if (_data) {
            this.lectoTypeId = _data["lectoTypeId"] !== undefined ? _data["lectoTypeId"] : null as any;
            this.pmsProjectCode = _data["pmsProjectCode"] !== undefined ? _data["pmsProjectCode"] : null as any;
        }
    }

    static fromJS(data: any): UpdatePMSProjectCodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePMSProjectCodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lectoTypeId"] = this.lectoTypeId !== undefined ? this.lectoTypeId : null as any;
        data["pmsProjectCode"] = this.pmsProjectCode !== undefined ? this.pmsProjectCode : null as any;
        return data;
    }
}

/** 更新下单次数 */
export class UpdatePlaceOrderCountDto {
    /** VC编号 */
    vcID!: string | null;
    /** 主机代码 */
    basicMotorCode!: string | null;
    /** 主机系列 */
    basicMotorSries!: string | null;
    /** 机座号 */
    frameNo!: number;
    /** 下单次数 */
    orderCount!: number;

    init(_data?: any) {
        if (_data) {
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.orderCount = _data["orderCount"] !== undefined ? _data["orderCount"] : null as any;
        }
    }

    static fromJS(data: any): UpdatePlaceOrderCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlaceOrderCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["orderCount"] = this.orderCount !== undefined ? this.orderCount : null as any;
        return data;
    }
}

export class UpdateProductFromLPInputDto {
    /** 境界面价系列ID */
    listPriceJINSeriesId!: string;
    /** 境界标识符 */
    jinCategoryCode!: string | null;
    /** 面价系列Id */
    listPriceSeriesId!: string;
    products!: ProducttFromLPInput[] | null;

    init(_data?: any) {
        if (_data) {
            this.listPriceJINSeriesId = _data["listPriceJINSeriesId"] !== undefined ? _data["listPriceJINSeriesId"] : null as any;
            this.jinCategoryCode = _data["jinCategoryCode"] !== undefined ? _data["jinCategoryCode"] : null as any;
            this.listPriceSeriesId = _data["listPriceSeriesId"] !== undefined ? _data["listPriceSeriesId"] : null as any;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProducttFromLPInput.fromJS(item));
            }
            else {
                this.products = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateProductFromLPInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductFromLPInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPriceJINSeriesId"] = this.listPriceJINSeriesId !== undefined ? this.listPriceJINSeriesId : null as any;
        data["jinCategoryCode"] = this.jinCategoryCode !== undefined ? this.jinCategoryCode : null as any;
        data["listPriceSeriesId"] = this.listPriceSeriesId !== undefined ? this.listPriceSeriesId : null as any;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class UpdateProductMultiplierDto {
    lectoTypeProducId!: string;
    expectMultiplier!: number;
    defaultMultiplier!: number;
    unitPrice!: number | null;
    salesPrice!: number | null;
    multipilerType!: MultipilerType;

    init(_data?: any) {
        if (_data) {
            this.lectoTypeProducId = _data["lectoTypeProducId"] !== undefined ? _data["lectoTypeProducId"] : null as any;
            this.expectMultiplier = _data["expectMultiplier"] !== undefined ? _data["expectMultiplier"] : null as any;
            this.defaultMultiplier = _data["defaultMultiplier"] !== undefined ? _data["defaultMultiplier"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : null as any;
            this.multipilerType = _data["multipilerType"] !== undefined ? _data["multipilerType"] : null as any;
        }
    }

    static fromJS(data: any): UpdateProductMultiplierDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductMultiplierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lectoTypeProducId"] = this.lectoTypeProducId !== undefined ? this.lectoTypeProducId : null as any;
        data["expectMultiplier"] = this.expectMultiplier !== undefined ? this.expectMultiplier : null as any;
        data["defaultMultiplier"] = this.defaultMultiplier !== undefined ? this.defaultMultiplier : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : null as any;
        data["multipilerType"] = this.multipilerType !== undefined ? this.multipilerType : null as any;
        return data;
    }
}

export class UpdateSpeciaVcDto {
    /** VcCode */
    code!: string | null;
    /** 品类 */
    categoryId!: string;
    /** 品类 */
    category!: string | null;
    /** VC含义 */
    meaning!: string | null;
    /** VC英文含义 */
    englishMeaning!: string | null;
    /** VC备注 */
    description!: string | null;
    /** VC头数 */
    numberWires!: number;
    showType!: VCShowType;
    /** 属性名 */
    attributeName!: string | null;
    /** 属性选择 */
    attributeSelect!: string | null;

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.showType = _data["showType"] !== undefined ? _data["showType"] : null as any;
            this.attributeName = _data["attributeName"] !== undefined ? _data["attributeName"] : null as any;
            this.attributeSelect = _data["attributeSelect"] !== undefined ? _data["attributeSelect"] : null as any;
        }
    }

    static fromJS(data: any): UpdateSpeciaVcDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSpeciaVcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["showType"] = this.showType !== undefined ? this.showType : null as any;
        data["attributeName"] = this.attributeName !== undefined ? this.attributeName : null as any;
        data["attributeSelect"] = this.attributeSelect !== undefined ? this.attributeSelect : null as any;
        return data;
    }
}

/** 更新技术协议 */
export class UpdateTeDto {
    id!: string | null;
    /** 项目名称 */
    projectName!: string | null;
    /** 行业 */
    industry!: string | null;
    /** 技术规范号 */
    technicalSpecifications!: string | null;
    /** 技术确认号 */
    technicalConfirmation!: string | null;
    /** 技术协议附件列表 */
    teAttachs!: string | null;
    /** 技术协议备注 */
    teRemark!: string | null;
    teStatus!: TechnologyQuotationStatus;
    technologyQuotationProducts!: UpdateTeProductDto[] | null;
    /** 是否提交 */
    isSubmit!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.industry = _data["industry"] !== undefined ? _data["industry"] : null as any;
            this.technicalSpecifications = _data["technicalSpecifications"] !== undefined ? _data["technicalSpecifications"] : null as any;
            this.technicalConfirmation = _data["technicalConfirmation"] !== undefined ? _data["technicalConfirmation"] : null as any;
            this.teAttachs = _data["teAttachs"] !== undefined ? _data["teAttachs"] : null as any;
            this.teRemark = _data["teRemark"] !== undefined ? _data["teRemark"] : null as any;
            this.teStatus = _data["teStatus"] !== undefined ? _data["teStatus"] : null as any;
            if (Array.isArray(_data["technologyQuotationProducts"])) {
                this.technologyQuotationProducts = [] as any;
                for (let item of _data["technologyQuotationProducts"])
                    this.technologyQuotationProducts!.push(UpdateTeProductDto.fromJS(item));
            }
            else {
                this.technologyQuotationProducts = null as any;
            }
            this.isSubmit = _data["isSubmit"] !== undefined ? _data["isSubmit"] : null as any;
        }
    }

    static fromJS(data: any): UpdateTeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["industry"] = this.industry !== undefined ? this.industry : null as any;
        data["technicalSpecifications"] = this.technicalSpecifications !== undefined ? this.technicalSpecifications : null as any;
        data["technicalConfirmation"] = this.technicalConfirmation !== undefined ? this.technicalConfirmation : null as any;
        data["teAttachs"] = this.teAttachs !== undefined ? this.teAttachs : null as any;
        data["teRemark"] = this.teRemark !== undefined ? this.teRemark : null as any;
        data["teStatus"] = this.teStatus !== undefined ? this.teStatus : null as any;
        if (Array.isArray(this.technologyQuotationProducts)) {
            data["technologyQuotationProducts"] = [];
            for (let item of this.technologyQuotationProducts)
                data["technologyQuotationProducts"].push(item ? item.toJSON() : null as any);
        }
        data["isSubmit"] = this.isSubmit !== undefined ? this.isSubmit : null as any;
        return data;
    }
}

export class UpdateTeProductDto {
    id!: string | null;
    /** 铭牌上电机型号 */
    motorModelOnTheNameplate!: string | null;
    /** 系统型号 */
    systemMOdel!: string | null;
    /** 功率/极数 */
    powerPoleNo!: string | null;
    /** 额定电压/频率 */
    voltageFrequency!: string | null;
    /** 安装型式 */
    technologyAgreementBasicMotorMounting!: string | null;
    /** 防护等级 */
    ip!: string | null;
    /** 冷却方式 */
    ic!: string | null;
    /** 绝缘/温升等级 */
    insulationTemperatureRiseClass!: string | null;
    /** 旋转方向 */
    directionOfRotation!: string | null;
    /** 环境温度 */
    ambientTemperature!: string | null;
    /** 应用 */
    application!: string | null;
    /** 工作制 */
    workingSystem!: string | null;
    /** 其他 */
    other!: string | null;
    /** 结构图 */
    structurecharT!: string | null;
    /** 技术数据表 */
    technicalDataTable!: string | null;
    /** 备注 */
    teRemark!: string | null;
    technologyQuotationProductVCs!: UpdateTeProductVCDto[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.motorModelOnTheNameplate = _data["motorModelOnTheNameplate"] !== undefined ? _data["motorModelOnTheNameplate"] : null as any;
            this.systemMOdel = _data["systemMOdel"] !== undefined ? _data["systemMOdel"] : null as any;
            this.powerPoleNo = _data["powerPoleNo"] !== undefined ? _data["powerPoleNo"] : null as any;
            this.voltageFrequency = _data["voltageFrequency"] !== undefined ? _data["voltageFrequency"] : null as any;
            this.technologyAgreementBasicMotorMounting = _data["technologyAgreementBasicMotorMounting"] !== undefined ? _data["technologyAgreementBasicMotorMounting"] : null as any;
            this.ip = _data["ip"] !== undefined ? _data["ip"] : null as any;
            this.ic = _data["ic"] !== undefined ? _data["ic"] : null as any;
            this.insulationTemperatureRiseClass = _data["insulationTemperatureRiseClass"] !== undefined ? _data["insulationTemperatureRiseClass"] : null as any;
            this.directionOfRotation = _data["directionOfRotation"] !== undefined ? _data["directionOfRotation"] : null as any;
            this.ambientTemperature = _data["ambientTemperature"] !== undefined ? _data["ambientTemperature"] : null as any;
            this.application = _data["application"] !== undefined ? _data["application"] : null as any;
            this.workingSystem = _data["workingSystem"] !== undefined ? _data["workingSystem"] : null as any;
            this.other = _data["other"] !== undefined ? _data["other"] : null as any;
            this.structurecharT = _data["structurecharT"] !== undefined ? _data["structurecharT"] : null as any;
            this.technicalDataTable = _data["technicalDataTable"] !== undefined ? _data["technicalDataTable"] : null as any;
            this.teRemark = _data["teRemark"] !== undefined ? _data["teRemark"] : null as any;
            if (Array.isArray(_data["technologyQuotationProductVCs"])) {
                this.technologyQuotationProductVCs = [] as any;
                for (let item of _data["technologyQuotationProductVCs"])
                    this.technologyQuotationProductVCs!.push(UpdateTeProductVCDto.fromJS(item));
            }
            else {
                this.technologyQuotationProductVCs = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateTeProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["motorModelOnTheNameplate"] = this.motorModelOnTheNameplate !== undefined ? this.motorModelOnTheNameplate : null as any;
        data["systemMOdel"] = this.systemMOdel !== undefined ? this.systemMOdel : null as any;
        data["powerPoleNo"] = this.powerPoleNo !== undefined ? this.powerPoleNo : null as any;
        data["voltageFrequency"] = this.voltageFrequency !== undefined ? this.voltageFrequency : null as any;
        data["technologyAgreementBasicMotorMounting"] = this.technologyAgreementBasicMotorMounting !== undefined ? this.technologyAgreementBasicMotorMounting : null as any;
        data["ip"] = this.ip !== undefined ? this.ip : null as any;
        data["ic"] = this.ic !== undefined ? this.ic : null as any;
        data["insulationTemperatureRiseClass"] = this.insulationTemperatureRiseClass !== undefined ? this.insulationTemperatureRiseClass : null as any;
        data["directionOfRotation"] = this.directionOfRotation !== undefined ? this.directionOfRotation : null as any;
        data["ambientTemperature"] = this.ambientTemperature !== undefined ? this.ambientTemperature : null as any;
        data["application"] = this.application !== undefined ? this.application : null as any;
        data["workingSystem"] = this.workingSystem !== undefined ? this.workingSystem : null as any;
        data["other"] = this.other !== undefined ? this.other : null as any;
        data["structurecharT"] = this.structurecharT !== undefined ? this.structurecharT : null as any;
        data["technicalDataTable"] = this.technicalDataTable !== undefined ? this.technicalDataTable : null as any;
        data["teRemark"] = this.teRemark !== undefined ? this.teRemark : null as any;
        if (Array.isArray(this.technologyQuotationProductVCs)) {
            data["technologyQuotationProductVCs"] = [];
            for (let item of this.technologyQuotationProductVCs)
                data["technologyQuotationProductVCs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class UpdateTeProductVCDto {
    id!: string | null;
    /** VC ID */
    vcID!: string | null;
    /** VC含义 */
    meaning!: string;
    /** VC开放式内容 */
    remark!: string | null;
    /** VC头数 */
    numberWires!: number;
    /** 工程周期（自然周） */
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    /** 采购周期（自然周） */
    purchaseCycle!: number;
    /** 生产周期（自然周） */
    productionCycle!: number;
    /** 测试周期（自然周） */
    testCycle!: number;
    /** 船检周期（自然周） */
    shipSurveyCycle!: number;
    vcType!: VcType;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
        }
    }

    static fromJS(data: any): UpdateTeProductVCDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeProductVCDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        return data;
    }
}

export class UpdateTechinalCatalogueDto {
    /** 名称 */
    name!: string | null;
    /** 描述 */
    remark!: string | null;

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
        }
    }

    static fromJS(data: any): UpdateTechinalCatalogueDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTechinalCatalogueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        return data;
    }
}

export class UpdateTechnicalAgreementDto {
    /** 标题 */
    title!: string | null;
    /** 附件链接 */
    fileUrl!: string | null;

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.fileUrl = _data["fileUrl"] !== undefined ? _data["fileUrl"] : null as any;
        }
    }

    static fromJS(data: any): UpdateTechnicalAgreementDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTechnicalAgreementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["fileUrl"] = this.fileUrl !== undefined ? this.fileUrl : null as any;
        return data;
    }
}

export class UpdateVCCheckRuleConfirmStatusInputDto {
    vcCheckRuleIds!: string[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vcCheckRuleIds"])) {
                this.vcCheckRuleIds = [] as any;
                for (let item of _data["vcCheckRuleIds"])
                    this.vcCheckRuleIds!.push(item);
            }
            else {
                this.vcCheckRuleIds = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateVCCheckRuleConfirmStatusInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVCCheckRuleConfirmStatusInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vcCheckRuleIds)) {
            data["vcCheckRuleIds"] = [];
            for (let item of this.vcCheckRuleIds)
                data["vcCheckRuleIds"].push(item);
        }
        return data;
    }
}

/** 0 = None (未知) 1 = Any (需要配置VC) 2 = And (指定VC必须全包含) 3 = Or (指定VC必中至少配置一个) */
export enum VCConstraintTypeEnum {
    None = 0,
    Any = 1,
    And = 2,
    Or = 3,
}

export class VCCycleEditDto {
    id!: string;
    vcType!: VcType;
    engineeringCycle!: number | null;
    engineeringCalculationMode!: EngineeringCalculationMode;
    engineeringComment!: string | null;
    purchaseCycle!: number | null;
    grCycle!: number | null;
    scmCycle!: number | null;
    scmCalculationMode!: string | null;
    scmRemark!: string | null;
    extraOverlayTime!: boolean | null;
    isOverlayLogic!: boolean | null;
    purchaseComment!: string | null;
    purchaseCycleMode!: PurchaseCycleMode;
    productionCycle!: number | null;
    productionComment!: string | null;
    testCycle!: number | null;
    shipSurveyCycle!: number | null;
    testComment!: string | null;
    shipSurveyComment!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.engineeringComment = _data["engineeringComment"] !== undefined ? _data["engineeringComment"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.scmCycle = _data["scmCycle"] !== undefined ? _data["scmCycle"] : null as any;
            this.scmCalculationMode = _data["scmCalculationMode"] !== undefined ? _data["scmCalculationMode"] : null as any;
            this.scmRemark = _data["scmRemark"] !== undefined ? _data["scmRemark"] : null as any;
            this.extraOverlayTime = _data["extraOverlayTime"] !== undefined ? _data["extraOverlayTime"] : null as any;
            this.isOverlayLogic = _data["isOverlayLogic"] !== undefined ? _data["isOverlayLogic"] : null as any;
            this.purchaseComment = _data["purchaseComment"] !== undefined ? _data["purchaseComment"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.productionComment = _data["productionComment"] !== undefined ? _data["productionComment"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.testComment = _data["testComment"] !== undefined ? _data["testComment"] : null as any;
            this.shipSurveyComment = _data["shipSurveyComment"] !== undefined ? _data["shipSurveyComment"] : null as any;
        }
    }

    static fromJS(data: any): VCCycleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new VCCycleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["engineeringComment"] = this.engineeringComment !== undefined ? this.engineeringComment : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["scmCycle"] = this.scmCycle !== undefined ? this.scmCycle : null as any;
        data["scmCalculationMode"] = this.scmCalculationMode !== undefined ? this.scmCalculationMode : null as any;
        data["scmRemark"] = this.scmRemark !== undefined ? this.scmRemark : null as any;
        data["extraOverlayTime"] = this.extraOverlayTime !== undefined ? this.extraOverlayTime : null as any;
        data["isOverlayLogic"] = this.isOverlayLogic !== undefined ? this.isOverlayLogic : null as any;
        data["purchaseComment"] = this.purchaseComment !== undefined ? this.purchaseComment : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["productionComment"] = this.productionComment !== undefined ? this.productionComment : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["testComment"] = this.testComment !== undefined ? this.testComment : null as any;
        data["shipSurveyComment"] = this.shipSurveyComment !== undefined ? this.shipSurveyComment : null as any;
        return data;
    }
}

export class VCGroupRulesDto {
    id!: string;
    productType!: string | null;
    seatNoMax!: number;
    seatNoMin!: number;
    compulsoryType!: number;
    vCIds!: string[] | null;
    promptContent!: string | null;
    creationTime!: moment.Moment;
    lastModificationTime!: moment.Moment | null;
    isDeleted!: boolean;
    poleNos!: string[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.productType = _data["productType"] !== undefined ? _data["productType"] : null as any;
            this.seatNoMax = _data["seatNoMax"] !== undefined ? _data["seatNoMax"] : null as any;
            this.seatNoMin = _data["seatNoMin"] !== undefined ? _data["seatNoMin"] : null as any;
            this.compulsoryType = _data["compulsoryType"] !== undefined ? _data["compulsoryType"] : null as any;
            if (Array.isArray(_data["vCIds"])) {
                this.vCIds = [] as any;
                for (let item of _data["vCIds"])
                    this.vCIds!.push(item);
            }
            else {
                this.vCIds = null as any;
            }
            this.promptContent = _data["promptContent"] !== undefined ? _data["promptContent"] : null as any;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            if (Array.isArray(_data["poleNos"])) {
                this.poleNos = [] as any;
                for (let item of _data["poleNos"])
                    this.poleNos!.push(item);
            }
            else {
                this.poleNos = null as any;
            }
        }
    }

    static fromJS(data: any): VCGroupRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new VCGroupRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["productType"] = this.productType !== undefined ? this.productType : null as any;
        data["seatNoMax"] = this.seatNoMax !== undefined ? this.seatNoMax : null as any;
        data["seatNoMin"] = this.seatNoMin !== undefined ? this.seatNoMin : null as any;
        data["compulsoryType"] = this.compulsoryType !== undefined ? this.compulsoryType : null as any;
        if (Array.isArray(this.vCIds)) {
            data["vCIds"] = [];
            for (let item of this.vCIds)
                data["vCIds"].push(item);
        }
        data["promptContent"] = this.promptContent !== undefined ? this.promptContent : null as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        if (Array.isArray(this.poleNos)) {
            data["poleNos"] = [];
            for (let item of this.poleNos)
                data["poleNos"].push(item);
        }
        return data;
    }
}

export class VCGroupRulesDtoPagedResultDto {
    items!: VCGroupRulesDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VCGroupRulesDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): VCGroupRulesDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VCGroupRulesDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class VcInfo {
    id!: string;
    readonly domainEvents!: IEventData[] | null;
    creationTime!: moment.Moment;
    creatorUserId!: number | null;
    lastModificationTime!: moment.Moment | null;
    lastModifierUserId!: number | null;
    isDeleted!: boolean;
    deleterUserId!: number | null;
    deletionTime!: moment.Moment | null;
    vcID!: string | null;
    categoryId!: string;
    category!: string | null;
    meaning!: string | null;
    englishMeaning!: string | null;
    vcTypeDescription!: string | null;
    numberWires!: number;
    vcType!: VcType;
    vcCode!: string | null;
    clienter!: string;
    validStartTime!: moment.Moment;
    validEndTime!: moment.Moment;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["domainEvents"])) {
                (this as any).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (this as any).domainEvents!.push(IEventData.fromJS(item));
            }
            else {
                (this as any).domainEvents = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : null as any;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : null as any;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : null as any;
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.meaning = _data["meaning"] !== undefined ? _data["meaning"] : null as any;
            this.englishMeaning = _data["englishMeaning"] !== undefined ? _data["englishMeaning"] : null as any;
            this.vcTypeDescription = _data["vcTypeDescription"] !== undefined ? _data["vcTypeDescription"] : null as any;
            this.numberWires = _data["numberWires"] !== undefined ? _data["numberWires"] : null as any;
            this.vcType = _data["vcType"] !== undefined ? _data["vcType"] : null as any;
            this.vcCode = _data["vcCode"] !== undefined ? _data["vcCode"] : null as any;
            this.clienter = _data["clienter"] !== undefined ? _data["clienter"] : null as any;
            this.validStartTime = _data["validStartTime"] ? moment(_data["validStartTime"].toString()) : null as any;
            this.validEndTime = _data["validEndTime"] ? moment(_data["validEndTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): VcInfo {
        data = typeof data === 'object' ? data : {};
        let result = new VcInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : null as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : null as any;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : null as any;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["meaning"] = this.meaning !== undefined ? this.meaning : null as any;
        data["englishMeaning"] = this.englishMeaning !== undefined ? this.englishMeaning : null as any;
        data["vcTypeDescription"] = this.vcTypeDescription !== undefined ? this.vcTypeDescription : null as any;
        data["numberWires"] = this.numberWires !== undefined ? this.numberWires : null as any;
        data["vcType"] = this.vcType !== undefined ? this.vcType : null as any;
        data["vcCode"] = this.vcCode !== undefined ? this.vcCode : null as any;
        data["clienter"] = this.clienter !== undefined ? this.clienter : null as any;
        data["validStartTime"] = this.validStartTime ? this.validStartTime.toISOString() : null as any;
        data["validEndTime"] = this.validEndTime ? this.validEndTime.toISOString() : null as any;
        return data;
    }
}

export class VcInfoPagedResultDto {
    items!: VcInfo[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VcInfo.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): VcInfoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VcInfoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export class VcLongShortCodeMappingDto {
    id!: string;
    /** Vc短代码 */
    shortVcCode!: string | null;
    /** Vc短代码品类 */
    shortVcCategory!: string | null;
    /** Vc长代码 */
    longVcCode!: string | null;
    /** Vc长代码品类 */
    longVcCategory!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.shortVcCode = _data["shortVcCode"] !== undefined ? _data["shortVcCode"] : null as any;
            this.shortVcCategory = _data["shortVcCategory"] !== undefined ? _data["shortVcCategory"] : null as any;
            this.longVcCode = _data["longVcCode"] !== undefined ? _data["longVcCode"] : null as any;
            this.longVcCategory = _data["longVcCategory"] !== undefined ? _data["longVcCategory"] : null as any;
        }
    }

    static fromJS(data: any): VcLongShortCodeMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new VcLongShortCodeMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["shortVcCode"] = this.shortVcCode !== undefined ? this.shortVcCode : null as any;
        data["shortVcCategory"] = this.shortVcCategory !== undefined ? this.shortVcCategory : null as any;
        data["longVcCode"] = this.longVcCode !== undefined ? this.longVcCode : null as any;
        data["longVcCategory"] = this.longVcCategory !== undefined ? this.longVcCategory : null as any;
        return data;
    }
}

export class VcLongShortCodeMappingDtoPagedResultDto {
    items!: VcLongShortCodeMappingDto[] | null;
    totalCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VcLongShortCodeMappingDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): VcLongShortCodeMappingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VcLongShortCodeMappingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

/** VC选项Dto（用于下拉选择） */
export class VcOptionDto {
    /** VC编号 */
    vcId!: string | null;
    /** 品类名称 */
    categoryName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.vcId = _data["vcId"] !== undefined ? _data["vcId"] : null as any;
            this.categoryName = _data["categoryName"] !== undefined ? _data["categoryName"] : null as any;
        }
    }

    static fromJS(data: any): VcOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new VcOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcId"] = this.vcId !== undefined ? this.vcId : null as any;
        data["categoryName"] = this.categoryName !== undefined ? this.categoryName : null as any;
        return data;
    }
}

export class VcPriceOrRuleInfo {
    /** 编号 */
    id!: string;
    vcID!: string | null;
    /** 产品系列 */
    basicMotorSries!: string | null;
    frameNo!: number;
    engineeringCycle!: number;
    engineeringCalculationMode!: EngineeringCalculationMode;
    purchaseCycle!: number;
    purchaseCycleMode!: PurchaseCycleMode;
    productionCycle!: number;
    testCycle!: number;
    grCycle!: number;
    shipSurveyCycle!: number;
    unitPrice!: number;
    unitPriceFormula!: string | null;
    unitPriceType!: UnitPriceType;
    cost!: number | null;
    costFormula!: string | null;
    costType!: CostType;
    costTypeDetail!: string | null;
    quotationPrinciple!: string | null;
    quotationPrincipleDetails!: string | null;
    /** 自制OR外购 */
    makeOrBuy!: string | null;
    /** 主机代码 */
    basicMotorCode!: string | null;
    vcShowType!: VCShowType;
    /** 属性名 */
    attributeName!: string | null;
    /** 属性选择 */
    attributeSelect!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.vcID = _data["vcID"] !== undefined ? _data["vcID"] : null as any;
            this.basicMotorSries = _data["basicMotorSries"] !== undefined ? _data["basicMotorSries"] : null as any;
            this.frameNo = _data["frameNo"] !== undefined ? _data["frameNo"] : null as any;
            this.engineeringCycle = _data["engineeringCycle"] !== undefined ? _data["engineeringCycle"] : null as any;
            this.engineeringCalculationMode = _data["engineeringCalculationMode"] !== undefined ? _data["engineeringCalculationMode"] : null as any;
            this.purchaseCycle = _data["purchaseCycle"] !== undefined ? _data["purchaseCycle"] : null as any;
            this.purchaseCycleMode = _data["purchaseCycleMode"] !== undefined ? _data["purchaseCycleMode"] : null as any;
            this.productionCycle = _data["productionCycle"] !== undefined ? _data["productionCycle"] : null as any;
            this.testCycle = _data["testCycle"] !== undefined ? _data["testCycle"] : null as any;
            this.grCycle = _data["grCycle"] !== undefined ? _data["grCycle"] : null as any;
            this.shipSurveyCycle = _data["shipSurveyCycle"] !== undefined ? _data["shipSurveyCycle"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.unitPriceFormula = _data["unitPriceFormula"] !== undefined ? _data["unitPriceFormula"] : null as any;
            this.unitPriceType = _data["unitPriceType"] !== undefined ? _data["unitPriceType"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.costFormula = _data["costFormula"] !== undefined ? _data["costFormula"] : null as any;
            this.costType = _data["costType"] !== undefined ? _data["costType"] : null as any;
            this.costTypeDetail = _data["costTypeDetail"] !== undefined ? _data["costTypeDetail"] : null as any;
            this.quotationPrinciple = _data["quotationPrinciple"] !== undefined ? _data["quotationPrinciple"] : null as any;
            this.quotationPrincipleDetails = _data["quotationPrincipleDetails"] !== undefined ? _data["quotationPrincipleDetails"] : null as any;
            this.makeOrBuy = _data["makeOrBuy"] !== undefined ? _data["makeOrBuy"] : null as any;
            this.basicMotorCode = _data["basicMotorCode"] !== undefined ? _data["basicMotorCode"] : null as any;
            this.vcShowType = _data["vcShowType"] !== undefined ? _data["vcShowType"] : null as any;
            this.attributeName = _data["attributeName"] !== undefined ? _data["attributeName"] : null as any;
            this.attributeSelect = _data["attributeSelect"] !== undefined ? _data["attributeSelect"] : null as any;
        }
    }

    static fromJS(data: any): VcPriceOrRuleInfo {
        data = typeof data === 'object' ? data : {};
        let result = new VcPriceOrRuleInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["vcID"] = this.vcID !== undefined ? this.vcID : null as any;
        data["basicMotorSries"] = this.basicMotorSries !== undefined ? this.basicMotorSries : null as any;
        data["frameNo"] = this.frameNo !== undefined ? this.frameNo : null as any;
        data["engineeringCycle"] = this.engineeringCycle !== undefined ? this.engineeringCycle : null as any;
        data["engineeringCalculationMode"] = this.engineeringCalculationMode !== undefined ? this.engineeringCalculationMode : null as any;
        data["purchaseCycle"] = this.purchaseCycle !== undefined ? this.purchaseCycle : null as any;
        data["purchaseCycleMode"] = this.purchaseCycleMode !== undefined ? this.purchaseCycleMode : null as any;
        data["productionCycle"] = this.productionCycle !== undefined ? this.productionCycle : null as any;
        data["testCycle"] = this.testCycle !== undefined ? this.testCycle : null as any;
        data["grCycle"] = this.grCycle !== undefined ? this.grCycle : null as any;
        data["shipSurveyCycle"] = this.shipSurveyCycle !== undefined ? this.shipSurveyCycle : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["unitPriceFormula"] = this.unitPriceFormula !== undefined ? this.unitPriceFormula : null as any;
        data["unitPriceType"] = this.unitPriceType !== undefined ? this.unitPriceType : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["costFormula"] = this.costFormula !== undefined ? this.costFormula : null as any;
        data["costType"] = this.costType !== undefined ? this.costType : null as any;
        data["costTypeDetail"] = this.costTypeDetail !== undefined ? this.costTypeDetail : null as any;
        data["quotationPrinciple"] = this.quotationPrinciple !== undefined ? this.quotationPrinciple : null as any;
        data["quotationPrincipleDetails"] = this.quotationPrincipleDetails !== undefined ? this.quotationPrincipleDetails : null as any;
        data["makeOrBuy"] = this.makeOrBuy !== undefined ? this.makeOrBuy : null as any;
        data["basicMotorCode"] = this.basicMotorCode !== undefined ? this.basicMotorCode : null as any;
        data["vcShowType"] = this.vcShowType !== undefined ? this.vcShowType : null as any;
        data["attributeName"] = this.attributeName !== undefined ? this.attributeName : null as any;
        data["attributeSelect"] = this.attributeSelect !== undefined ? this.attributeSelect : null as any;
        return data;
    }
}

/** 0 = passed (没有错误) 1 = 头数不匹配 (00000000001(1)) 2 = vc对于裸机不可选 (00000000010(2)) 4 = vc不兼容 (00000000100(4)) 8 = 配置了某vc的情况下还需要配置另外的VC (00000001000(8)) 16 = 需要将某个vc替换成另外的vc (00000010000(16)) 32 = 需要额外的freetext (00000100000(32)) 64 = 需要提供技术参数 (00001000000(64)) 128 = 需要提供电气特性 (00010000000(128)) 256 = 需要显示警告信息 (00100000000(256)) 512 = 需要显示错误信息 (01000000000(512)) 1024 = 选型必须由gcs帮助进行 (10000000000(1024)) 2048 = needRemark (需要备注信息) -1 = 未知错误 (other) */
export enum RuleNo {
    Passed = 0,
    头数不匹配 = 1,
    Vc对于裸机不可选 = 2,
    Vc不兼容 = 4,
    配置了某vc的情况下还需要配置另外的VC = 8,
    需要将某个vc替换成另外的vc = 16,
    需要额外的freetext = 32,
    需要提供技术参数 = 64,
    需要提供电气特性 = 128,
    需要显示警告信息 = 256,
    需要显示错误信息 = 512,
    选型必须由gcs帮助进行 = 1024,
    NeedRemark = 2048,
    未知错误 = -1,
}

export class ActivityInstanceDto {
    id!: string | null;
    parentActivityInstanceId!: string | null;
    activityId!: string | null;
    activityName!: string | null;
    name!: string | null;
    activityType!: string | null;
    processInstanceId!: string | null;
    processDefinitionId!: string | null;
    childActivityInstances!: ActivityInstanceDto[] | null;
    childTransitionInstances!: TransitionInstanceDto[] | null;
    executionIds!: string[] | null;
    incidentIds!: string[] | null;
    incidents!: ActivityInstanceIncidentDto[] | null;

    [key: string]: any;

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.parentActivityInstanceId = _data["parentActivityInstanceId"] !== undefined ? _data["parentActivityInstanceId"] : null as any;
            this.activityId = _data["activityId"] !== undefined ? _data["activityId"] : null as any;
            this.activityName = _data["activityName"] !== undefined ? _data["activityName"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : null as any;
            this.processInstanceId = _data["processInstanceId"] !== undefined ? _data["processInstanceId"] : null as any;
            this.processDefinitionId = _data["processDefinitionId"] !== undefined ? _data["processDefinitionId"] : null as any;
            if (Array.isArray(_data["childActivityInstances"])) {
                this.childActivityInstances = [] as any;
                for (let item of _data["childActivityInstances"])
                    this.childActivityInstances!.push(ActivityInstanceDto.fromJS(item));
            }
            else {
                this.childActivityInstances = null as any;
            }
            if (Array.isArray(_data["childTransitionInstances"])) {
                this.childTransitionInstances = [] as any;
                for (let item of _data["childTransitionInstances"])
                    this.childTransitionInstances!.push(TransitionInstanceDto.fromJS(item));
            }
            else {
                this.childTransitionInstances = null as any;
            }
            if (Array.isArray(_data["executionIds"])) {
                this.executionIds = [] as any;
                for (let item of _data["executionIds"])
                    this.executionIds!.push(item);
            }
            else {
                this.executionIds = null as any;
            }
            if (Array.isArray(_data["incidentIds"])) {
                this.incidentIds = [] as any;
                for (let item of _data["incidentIds"])
                    this.incidentIds!.push(item);
            }
            else {
                this.incidentIds = null as any;
            }
            if (Array.isArray(_data["incidents"])) {
                this.incidents = [] as any;
                for (let item of _data["incidents"])
                    this.incidents!.push(ActivityInstanceIncidentDto.fromJS(item));
            }
            else {
                this.incidents = null as any;
            }
        }
    }

    static fromJS(data: any): ActivityInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["parentActivityInstanceId"] = this.parentActivityInstanceId !== undefined ? this.parentActivityInstanceId : null as any;
        data["activityId"] = this.activityId !== undefined ? this.activityId : null as any;
        data["activityName"] = this.activityName !== undefined ? this.activityName : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["activityType"] = this.activityType !== undefined ? this.activityType : null as any;
        data["processInstanceId"] = this.processInstanceId !== undefined ? this.processInstanceId : null as any;
        data["processDefinitionId"] = this.processDefinitionId !== undefined ? this.processDefinitionId : null as any;
        if (Array.isArray(this.childActivityInstances)) {
            data["childActivityInstances"] = [];
            for (let item of this.childActivityInstances)
                data["childActivityInstances"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.childTransitionInstances)) {
            data["childTransitionInstances"] = [];
            for (let item of this.childTransitionInstances)
                data["childTransitionInstances"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.executionIds)) {
            data["executionIds"] = [];
            for (let item of this.executionIds)
                data["executionIds"].push(item);
        }
        if (Array.isArray(this.incidentIds)) {
            data["incidentIds"] = [];
            for (let item of this.incidentIds)
                data["incidentIds"].push(item);
        }
        if (Array.isArray(this.incidents)) {
            data["incidents"] = [];
            for (let item of this.incidents)
                data["incidents"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class ActivityInstanceIncidentDto {
    id!: string | null;
    activityId!: string | null;

    [key: string]: any;

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.activityId = _data["activityId"] !== undefined ? _data["activityId"] : null as any;
        }
    }

    static fromJS(data: any): ActivityInstanceIncidentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityInstanceIncidentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["activityId"] = this.activityId !== undefined ? this.activityId : null as any;
        return data;
    }
}

export class ActivityInstanceWithBPMN {
    activityInstance!: ActivityInstanceDto;
    bpmn!: ProcessDefinitionDiagramDto;

    init(_data?: any) {
        if (_data) {
            this.activityInstance = _data["activityInstance"] ? ActivityInstanceDto.fromJS(_data["activityInstance"]) : null as any;
            this.bpmn = _data["bpmn"] ? ProcessDefinitionDiagramDto.fromJS(_data["bpmn"]) : null as any;
        }
    }

    static fromJS(data: any): ActivityInstanceWithBPMN {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityInstanceWithBPMN();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityInstance"] = this.activityInstance ? this.activityInstance.toJSON() : null as any;
        data["bpmn"] = this.bpmn ? this.bpmn.toJSON() : null as any;
        return data;
    }
}

export class AssigneeInfo {
    uid!: string | null;
    email!: string | null;
    name!: string | null;

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"] !== undefined ? _data["uid"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): AssigneeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AssigneeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid !== undefined ? this.uid : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export class AttachmentSimpleDto {
    id!: string;
    fileName!: string | null;
    fileFullName!: string | null;
    mimeType!: string | null;
    fileSize!: number;
    uploadTime!: moment.Moment;
    sasUri!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.fileFullName = _data["fileFullName"] !== undefined ? _data["fileFullName"] : null as any;
            this.mimeType = _data["mimeType"] !== undefined ? _data["mimeType"] : null as any;
            this.fileSize = _data["fileSize"] !== undefined ? _data["fileSize"] : null as any;
            this.uploadTime = _data["uploadTime"] ? moment(_data["uploadTime"].toString()) : null as any;
            this.sasUri = _data["sasUri"] !== undefined ? _data["sasUri"] : null as any;
        }
    }

    static fromJS(data: any): AttachmentSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileFullName"] = this.fileFullName !== undefined ? this.fileFullName : null as any;
        data["mimeType"] = this.mimeType !== undefined ? this.mimeType : null as any;
        data["fileSize"] = this.fileSize !== undefined ? this.fileSize : null as any;
        data["uploadTime"] = this.uploadTime ? this.uploadTime.toISOString() : null as any;
        data["sasUri"] = this.sasUri !== undefined ? this.sasUri : null as any;
        return data;
    }
}

export enum ButtonView {
    _2 = 2,
}

export class CommentReadReceiptDto {
    id!: string;
    commentId!: string;
    userId!: string | null;
    receiptResult!: ReceiptResultType;
    readTime!: moment.Moment;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.commentId = _data["commentId"] !== undefined ? _data["commentId"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.receiptResult = _data["receiptResult"] !== undefined ? _data["receiptResult"] : null as any;
            this.readTime = _data["readTime"] ? moment(_data["readTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): CommentReadReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentReadReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["commentId"] = this.commentId !== undefined ? this.commentId : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["receiptResult"] = this.receiptResult !== undefined ? this.receiptResult : null as any;
        data["readTime"] = this.readTime ? this.readTime.toISOString() : null as any;
        return data;
    }
}

export enum CommentType {
    _0 = 0,
    _1 = 1,
}

export class Conclusion {
    link!: string | null;
    formData!: string | null;

    init(_data?: any) {
        if (_data) {
            this.link = _data["link"] !== undefined ? _data["link"] : null as any;
            this.formData = _data["formData"] !== undefined ? _data["formData"] : null as any;
        }
    }

    static fromJS(data: any): Conclusion {
        data = typeof data === 'object' ? data : {};
        let result = new Conclusion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link !== undefined ? this.link : null as any;
        data["formData"] = this.formData !== undefined ? this.formData : null as any;
        return data;
    }
}

export class CreateAttachmentDto {
    fileName!: string;
    mimeType!: string;
    fileSize!: number;

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.mimeType = _data["mimeType"] !== undefined ? _data["mimeType"] : null as any;
            this.fileSize = _data["fileSize"] !== undefined ? _data["fileSize"] : null as any;
        }
    }

    static fromJS(data: any): CreateAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["mimeType"] = this.mimeType !== undefined ? this.mimeType : null as any;
        data["fileSize"] = this.fileSize !== undefined ? this.fileSize : null as any;
        return data;
    }
}

export class CreateCommentDto {
    serviceRequestId!: string;
    content!: string | null;
    externalVisible!: boolean;
    formData!: string | null;
    formSchema!: string | null;
    commentType!: CommentType;
    isReadReceiptRequired!: boolean;

    init(_data?: any) {
        if (_data) {
            this.serviceRequestId = _data["serviceRequestId"] !== undefined ? _data["serviceRequestId"] : null as any;
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
            this.externalVisible = _data["externalVisible"] !== undefined ? _data["externalVisible"] : null as any;
            this.formData = _data["formData"] !== undefined ? _data["formData"] : null as any;
            this.formSchema = _data["formSchema"] !== undefined ? _data["formSchema"] : null as any;
            this.commentType = _data["commentType"] !== undefined ? _data["commentType"] : null as any;
            this.isReadReceiptRequired = _data["isReadReceiptRequired"] !== undefined ? _data["isReadReceiptRequired"] : null as any;
        }
    }

    static fromJS(data: any): CreateCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceRequestId"] = this.serviceRequestId !== undefined ? this.serviceRequestId : null as any;
        data["content"] = this.content !== undefined ? this.content : null as any;
        data["externalVisible"] = this.externalVisible !== undefined ? this.externalVisible : null as any;
        data["formData"] = this.formData !== undefined ? this.formData : null as any;
        data["formSchema"] = this.formSchema !== undefined ? this.formSchema : null as any;
        data["commentType"] = this.commentType !== undefined ? this.commentType : null as any;
        data["isReadReceiptRequired"] = this.isReadReceiptRequired !== undefined ? this.isReadReceiptRequired : null as any;
        return data;
    }
}

export class CreateResponsibilityInput {
    key!: string;
    email!: string;
    serviceTypeId!: string;

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.serviceTypeId = _data["serviceTypeId"] !== undefined ? _data["serviceTypeId"] : null as any;
        }
    }

    static fromJS(data: any): CreateResponsibilityInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateResponsibilityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["serviceTypeId"] = this.serviceTypeId !== undefined ? this.serviceTypeId : null as any;
        return data;
    }
}

export class CreateResponsibilityOutput {
    id!: string;
    key!: string;
    uid!: string;
    email!: string;
    serviceTypeId!: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.uid = _data["uid"] !== undefined ? _data["uid"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.serviceTypeId = _data["serviceTypeId"] !== undefined ? _data["serviceTypeId"] : null as any;
        }
    }

    static fromJS(data: any): CreateResponsibilityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateResponsibilityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["uid"] = this.uid !== undefined ? this.uid : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["serviceTypeId"] = this.serviceTypeId !== undefined ? this.serviceTypeId : null as any;
        return data;
    }
}

export class CreateServiceRequestInput {
    id!: string | null;
    serviceTypeId!: string;
    customerCode!: string | null;
    customerName!: string | null;
    serviceName!: string | null;
    submitForm!: FormSchemaInfo;
    attachments!: string[] | null;
    initiatorIdentifierId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.serviceTypeId = _data["serviceTypeId"] !== undefined ? _data["serviceTypeId"] : null as any;
            this.customerCode = _data["customerCode"] !== undefined ? _data["customerCode"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.serviceName = _data["serviceName"] !== undefined ? _data["serviceName"] : null as any;
            this.submitForm = _data["submitForm"] ? FormSchemaInfo.fromJS(_data["submitForm"]) : null as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(item);
            }
            else {
                this.attachments = null as any;
            }
            this.initiatorIdentifierId = _data["initiatorIdentifierId"] !== undefined ? _data["initiatorIdentifierId"] : null as any;
        }
    }

    static fromJS(data: any): CreateServiceRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["serviceTypeId"] = this.serviceTypeId !== undefined ? this.serviceTypeId : null as any;
        data["customerCode"] = this.customerCode !== undefined ? this.customerCode : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["serviceName"] = this.serviceName !== undefined ? this.serviceName : null as any;
        data["submitForm"] = this.submitForm ? this.submitForm.toJSON() : null as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item);
        }
        data["initiatorIdentifierId"] = this.initiatorIdentifierId !== undefined ? this.initiatorIdentifierId : null as any;
        return data;
    }
}

export class CreateServiceRequestOutput {
    id!: string;
    sequenceNumber!: string | null;
    status!: ServiceRequestStatusEnum;
    serviceTypeId!: string | null;
    processDefinitionId!: string | null;
    processInstanceId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.sequenceNumber = _data["sequenceNumber"] !== undefined ? _data["sequenceNumber"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.serviceTypeId = _data["serviceTypeId"] !== undefined ? _data["serviceTypeId"] : null as any;
            this.processDefinitionId = _data["processDefinitionId"] !== undefined ? _data["processDefinitionId"] : null as any;
            this.processInstanceId = _data["processInstanceId"] !== undefined ? _data["processInstanceId"] : null as any;
        }
    }

    static fromJS(data: any): CreateServiceRequestOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceRequestOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["sequenceNumber"] = this.sequenceNumber !== undefined ? this.sequenceNumber : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["serviceTypeId"] = this.serviceTypeId !== undefined ? this.serviceTypeId : null as any;
        data["processDefinitionId"] = this.processDefinitionId !== undefined ? this.processDefinitionId : null as any;
        data["processInstanceId"] = this.processInstanceId !== undefined ? this.processInstanceId : null as any;
        return data;
    }
}

export class CreatedAttachmentResultDto {
    id!: string;
    fileName!: string | null;
    fileFullName!: string | null;
    mimeType!: string | null;
    fileSize!: number;
    sasUri!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.fileFullName = _data["fileFullName"] !== undefined ? _data["fileFullName"] : null as any;
            this.mimeType = _data["mimeType"] !== undefined ? _data["mimeType"] : null as any;
            this.fileSize = _data["fileSize"] !== undefined ? _data["fileSize"] : null as any;
            this.sasUri = _data["sasUri"] !== undefined ? _data["sasUri"] : null as any;
        }
    }

    static fromJS(data: any): CreatedAttachmentResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatedAttachmentResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileFullName"] = this.fileFullName !== undefined ? this.fileFullName : null as any;
        data["mimeType"] = this.mimeType !== undefined ? this.mimeType : null as any;
        data["fileSize"] = this.fileSize !== undefined ? this.fileSize : null as any;
        data["sasUri"] = this.sasUri !== undefined ? this.sasUri : null as any;
        return data;
    }
}

export class EVariablesDto {
    id!: string | null;
    link!: string | null;
    cronExpression!: string | null;
    autoCommentEmail!: string | null;
    isNewData!: boolean;
    buttonView!: ButtonView;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.link = _data["link"] !== undefined ? _data["link"] : null as any;
            this.cronExpression = _data["cronExpression"] !== undefined ? _data["cronExpression"] : null as any;
            this.autoCommentEmail = _data["autoCommentEmail"] !== undefined ? _data["autoCommentEmail"] : null as any;
            this.isNewData = _data["isNewData"] !== undefined ? _data["isNewData"] : null as any;
            this.buttonView = _data["buttonView"] !== undefined ? _data["buttonView"] : null as any;
        }
    }

    static fromJS(data: any): EVariablesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EVariablesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["link"] = this.link !== undefined ? this.link : null as any;
        data["cronExpression"] = this.cronExpression !== undefined ? this.cronExpression : null as any;
        data["autoCommentEmail"] = this.autoCommentEmail !== undefined ? this.autoCommentEmail : null as any;
        data["isNewData"] = this.isNewData !== undefined ? this.isNewData : null as any;
        data["buttonView"] = this.buttonView !== undefined ? this.buttonView : null as any;
        return data;
    }
}

export class ExternalTaskInterfaceData {
    taskInterfaceId!: string;
    formSchemaId!: string | null;
    formData!: string | null;

    init(_data?: any) {
        if (_data) {
            this.taskInterfaceId = _data["taskInterfaceId"] !== undefined ? _data["taskInterfaceId"] : null as any;
            this.formSchemaId = _data["formSchemaId"] !== undefined ? _data["formSchemaId"] : null as any;
            this.formData = _data["formData"] !== undefined ? _data["formData"] : null as any;
        }
    }

    static fromJS(data: any): ExternalTaskInterfaceData {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalTaskInterfaceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskInterfaceId"] = this.taskInterfaceId !== undefined ? this.taskInterfaceId : null as any;
        data["formSchemaId"] = this.formSchemaId !== undefined ? this.formSchemaId : null as any;
        data["formData"] = this.formData !== undefined ? this.formData : null as any;
        return data;
    }
}

export class ExternalTaskInterfaceDetail {
    taskInterfaceId!: string;
    taskId!: string | null;
    interfaceType!: TaskInterfaceType;
    formSchema!: FormSchemaOutput;
    formData!: string | null;
    actionItems!: TaskInterfaceActionItem;
    variables!: EVariablesDto;

    init(_data?: any) {
        if (_data) {
            this.taskInterfaceId = _data["taskInterfaceId"] !== undefined ? _data["taskInterfaceId"] : null as any;
            this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : null as any;
            this.interfaceType = _data["interfaceType"] !== undefined ? _data["interfaceType"] : null as any;
            this.formSchema = _data["formSchema"] ? FormSchemaOutput.fromJS(_data["formSchema"]) : null as any;
            this.formData = _data["formData"] !== undefined ? _data["formData"] : null as any;
            this.actionItems = _data["actionItems"] !== undefined ? _data["actionItems"] : null as any;
            this.variables = _data["variables"] ? EVariablesDto.fromJS(_data["variables"]) : null as any;
        }
    }

    static fromJS(data: any): ExternalTaskInterfaceDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalTaskInterfaceDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskInterfaceId"] = this.taskInterfaceId !== undefined ? this.taskInterfaceId : null as any;
        data["taskId"] = this.taskId !== undefined ? this.taskId : null as any;
        data["interfaceType"] = this.interfaceType !== undefined ? this.interfaceType : null as any;
        data["formSchema"] = this.formSchema ? this.formSchema.toJSON() : null as any;
        data["formData"] = this.formData !== undefined ? this.formData : null as any;
        data["actionItems"] = this.actionItems !== undefined ? this.actionItems : null as any;
        data["variables"] = this.variables ? this.variables.toJSON() : null as any;
        return data;
    }
}

export class ExternalTaskInterfaceInput {
    taskInterfaceId!: string | null;
    taskId!: string | null;
    name!: string | null;
    formSchemaId!: string | null;
    formData!: string | null;
    variables!: string | null;

    init(_data?: any) {
        if (_data) {
            this.taskInterfaceId = _data["taskInterfaceId"] !== undefined ? _data["taskInterfaceId"] : null as any;
            this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.formSchemaId = _data["formSchemaId"] !== undefined ? _data["formSchemaId"] : null as any;
            this.formData = _data["formData"] !== undefined ? _data["formData"] : null as any;
            this.variables = _data["variables"] !== undefined ? _data["variables"] : null as any;
        }
    }

    static fromJS(data: any): ExternalTaskInterfaceInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalTaskInterfaceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskInterfaceId"] = this.taskInterfaceId !== undefined ? this.taskInterfaceId : null as any;
        data["taskId"] = this.taskId !== undefined ? this.taskId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["formSchemaId"] = this.formSchemaId !== undefined ? this.formSchemaId : null as any;
        data["formData"] = this.formData !== undefined ? this.formData : null as any;
        data["variables"] = this.variables !== undefined ? this.variables : null as any;
        return data;
    }
}

export class ExternalTaskInterfaceOutput {
    taskInterfaceId!: string | null;
    formData!: string | null;
    variables!: EVariablesDto;
    state!: TaskInterfaceOutput;
    msg!: string | null;

    init(_data?: any) {
        if (_data) {
            this.taskInterfaceId = _data["taskInterfaceId"] !== undefined ? _data["taskInterfaceId"] : null as any;
            this.formData = _data["formData"] !== undefined ? _data["formData"] : null as any;
            this.variables = _data["variables"] ? EVariablesDto.fromJS(_data["variables"]) : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.msg = _data["msg"] !== undefined ? _data["msg"] : null as any;
        }
    }

    static fromJS(data: any): ExternalTaskInterfaceOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalTaskInterfaceOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskInterfaceId"] = this.taskInterfaceId !== undefined ? this.taskInterfaceId : null as any;
        data["formData"] = this.formData !== undefined ? this.formData : null as any;
        data["variables"] = this.variables ? this.variables.toJSON() : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["msg"] = this.msg !== undefined ? this.msg : null as any;
        return data;
    }
}

export class FormDataSnapshotOutputDto {
    propertyName!: string | null;
    title!: string | null;
    dataType!: string | null;
    value!: string | null;

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"] !== undefined ? _data["propertyName"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.dataType = _data["dataType"] !== undefined ? _data["dataType"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static fromJS(data: any): FormDataSnapshotOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormDataSnapshotOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName !== undefined ? this.propertyName : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["dataType"] = this.dataType !== undefined ? this.dataType : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }
}

export class FormSchemaInfo {
    formSchemaId!: string | null;
    formData!: string | null;

    init(_data?: any) {
        if (_data) {
            this.formSchemaId = _data["formSchemaId"] !== undefined ? _data["formSchemaId"] : null as any;
            this.formData = _data["formData"] !== undefined ? _data["formData"] : null as any;
        }
    }

    static fromJS(data: any): FormSchemaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FormSchemaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formSchemaId"] = this.formSchemaId !== undefined ? this.formSchemaId : null as any;
        data["formData"] = this.formData !== undefined ? this.formData : null as any;
        return data;
    }
}

export class FormSchemaOutput {
    id!: string;
    formKey!: string | null;
    serviceTypeId!: string | null;
    serviceTypeName!: string | null;
    processDefinitionId!: string | null;
    taskDefinitionKey!: string | null;
    schema!: string | null;
    defaultValues!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.formKey = _data["formKey"] !== undefined ? _data["formKey"] : null as any;
            this.serviceTypeId = _data["serviceTypeId"] !== undefined ? _data["serviceTypeId"] : null as any;
            this.serviceTypeName = _data["serviceTypeName"] !== undefined ? _data["serviceTypeName"] : null as any;
            this.processDefinitionId = _data["processDefinitionId"] !== undefined ? _data["processDefinitionId"] : null as any;
            this.taskDefinitionKey = _data["taskDefinitionKey"] !== undefined ? _data["taskDefinitionKey"] : null as any;
            this.schema = _data["schema"] !== undefined ? _data["schema"] : null as any;
            this.defaultValues = _data["defaultValues"] !== undefined ? _data["defaultValues"] : null as any;
        }
    }

    static fromJS(data: any): FormSchemaOutput {
        data = typeof data === 'object' ? data : {};
        let result = new FormSchemaOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["formKey"] = this.formKey !== undefined ? this.formKey : null as any;
        data["serviceTypeId"] = this.serviceTypeId !== undefined ? this.serviceTypeId : null as any;
        data["serviceTypeName"] = this.serviceTypeName !== undefined ? this.serviceTypeName : null as any;
        data["processDefinitionId"] = this.processDefinitionId !== undefined ? this.processDefinitionId : null as any;
        data["taskDefinitionKey"] = this.taskDefinitionKey !== undefined ? this.taskDefinitionKey : null as any;
        data["schema"] = this.schema !== undefined ? this.schema : null as any;
        data["defaultValues"] = this.defaultValues !== undefined ? this.defaultValues : null as any;
        return data;
    }
}

export enum FunctionPermission {
    _0 = 0,
    _1 = 1,
}

export class GetAttachmentSasUriOutput {
    attachments!: AttachmentSimpleDto[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentSimpleDto.fromJS(item));
            }
            else {
                this.attachments = null as any;
            }
        }
    }

    static fromJS(data: any): GetAttachmentSasUriOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttachmentSasUriOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class GetCandidateUserDto {
    userId!: string | null;
    userName!: string | null;
    userEmail!: string | null;

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.userEmail = _data["userEmail"] !== undefined ? _data["userEmail"] : null as any;
        }
    }

    static fromJS(data: any): GetCandidateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCandidateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["userEmail"] = this.userEmail !== undefined ? this.userEmail : null as any;
        return data;
    }
}

export class GetCommentsDto {
    id!: string;
    serviceRequestId!: string;
    content!: string | null;
    creator!: string | null;
    creatorName!: string | null;
    creatorEmail!: string | null;
    abbUser!: boolean;
    visible!: boolean;
    externalVisible!: boolean;
    isReadReceiptRequired!: boolean;
    commentReadReceipts!: CommentReadReceiptDto[] | null;
    creationTime!: moment.Moment;
    commentType!: CommentType;
    formData!: string | null;
    formSchema!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.serviceRequestId = _data["serviceRequestId"] !== undefined ? _data["serviceRequestId"] : null as any;
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
            this.creator = _data["creator"] !== undefined ? _data["creator"] : null as any;
            this.creatorName = _data["creatorName"] !== undefined ? _data["creatorName"] : null as any;
            this.creatorEmail = _data["creatorEmail"] !== undefined ? _data["creatorEmail"] : null as any;
            this.abbUser = _data["abbUser"] !== undefined ? _data["abbUser"] : null as any;
            this.visible = _data["visible"] !== undefined ? _data["visible"] : null as any;
            this.externalVisible = _data["externalVisible"] !== undefined ? _data["externalVisible"] : null as any;
            this.isReadReceiptRequired = _data["isReadReceiptRequired"] !== undefined ? _data["isReadReceiptRequired"] : null as any;
            if (Array.isArray(_data["commentReadReceipts"])) {
                this.commentReadReceipts = [] as any;
                for (let item of _data["commentReadReceipts"])
                    this.commentReadReceipts!.push(CommentReadReceiptDto.fromJS(item));
            }
            else {
                this.commentReadReceipts = null as any;
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : null as any;
            this.commentType = _data["commentType"] !== undefined ? _data["commentType"] : null as any;
            this.formData = _data["formData"] !== undefined ? _data["formData"] : null as any;
            this.formSchema = _data["formSchema"] !== undefined ? _data["formSchema"] : null as any;
        }
    }

    static fromJS(data: any): GetCommentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["serviceRequestId"] = this.serviceRequestId !== undefined ? this.serviceRequestId : null as any;
        data["content"] = this.content !== undefined ? this.content : null as any;
        data["creator"] = this.creator !== undefined ? this.creator : null as any;
        data["creatorName"] = this.creatorName !== undefined ? this.creatorName : null as any;
        data["creatorEmail"] = this.creatorEmail !== undefined ? this.creatorEmail : null as any;
        data["abbUser"] = this.abbUser !== undefined ? this.abbUser : null as any;
        data["visible"] = this.visible !== undefined ? this.visible : null as any;
        data["externalVisible"] = this.externalVisible !== undefined ? this.externalVisible : null as any;
        data["isReadReceiptRequired"] = this.isReadReceiptRequired !== undefined ? this.isReadReceiptRequired : null as any;
        if (Array.isArray(this.commentReadReceipts)) {
            data["commentReadReceipts"] = [];
            for (let item of this.commentReadReceipts)
                data["commentReadReceipts"].push(item ? item.toJSON() : null as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : null as any;
        data["commentType"] = this.commentType !== undefined ? this.commentType : null as any;
        data["formData"] = this.formData !== undefined ? this.formData : null as any;
        data["formSchema"] = this.formSchema !== undefined ? this.formSchema : null as any;
        return data;
    }
}

export class GetProcessHistoryOutput {
    serviceRequestId!: string;
    /** 流程实例Id */
    processInstanceId!: string | null;
    /** 节点实例Id */
    taskId!: string | null;
    /** 节点名称 */
    taskName!: string | null;
    /** 触发操作的人 */
    currentOperator!: string | null;
    /** 操作人名称 */
    currentOperatorName!: string | null;
    operation!: ProcessActionEnum;
    /** 操作描述 */
    description!: string | null;
    /** 操作发生的时间 */
    occurTime!: moment.Moment;
    taskForm!: TaskForm;
    /** 任务接口详细信息列表 */
    externalTaskInterfaceDetailList!: ExternalTaskInterfaceDetail[] | null;
    operationDisplayName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.serviceRequestId = _data["serviceRequestId"] !== undefined ? _data["serviceRequestId"] : null as any;
            this.processInstanceId = _data["processInstanceId"] !== undefined ? _data["processInstanceId"] : null as any;
            this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : null as any;
            this.taskName = _data["taskName"] !== undefined ? _data["taskName"] : null as any;
            this.currentOperator = _data["currentOperator"] !== undefined ? _data["currentOperator"] : null as any;
            this.currentOperatorName = _data["currentOperatorName"] !== undefined ? _data["currentOperatorName"] : null as any;
            this.operation = _data["operation"] !== undefined ? _data["operation"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.occurTime = _data["occurTime"] ? moment(_data["occurTime"].toString()) : null as any;
            this.taskForm = _data["taskForm"] ? TaskForm.fromJS(_data["taskForm"]) : null as any;
            if (Array.isArray(_data["externalTaskInterfaceDetailList"])) {
                this.externalTaskInterfaceDetailList = [] as any;
                for (let item of _data["externalTaskInterfaceDetailList"])
                    this.externalTaskInterfaceDetailList!.push(ExternalTaskInterfaceDetail.fromJS(item));
            }
            else {
                this.externalTaskInterfaceDetailList = null as any;
            }
            this.operationDisplayName = _data["operationDisplayName"] !== undefined ? _data["operationDisplayName"] : null as any;
        }
    }

    static fromJS(data: any): GetProcessHistoryOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProcessHistoryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceRequestId"] = this.serviceRequestId !== undefined ? this.serviceRequestId : null as any;
        data["processInstanceId"] = this.processInstanceId !== undefined ? this.processInstanceId : null as any;
        data["taskId"] = this.taskId !== undefined ? this.taskId : null as any;
        data["taskName"] = this.taskName !== undefined ? this.taskName : null as any;
        data["currentOperator"] = this.currentOperator !== undefined ? this.currentOperator : null as any;
        data["currentOperatorName"] = this.currentOperatorName !== undefined ? this.currentOperatorName : null as any;
        data["operation"] = this.operation !== undefined ? this.operation : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["occurTime"] = this.occurTime ? this.occurTime.toISOString() : null as any;
        data["taskForm"] = this.taskForm ? this.taskForm.toJSON() : null as any;
        if (Array.isArray(this.externalTaskInterfaceDetailList)) {
            data["externalTaskInterfaceDetailList"] = [];
            for (let item of this.externalTaskInterfaceDetailList)
                data["externalTaskInterfaceDetailList"].push(item ? item.toJSON() : null as any);
        }
        data["operationDisplayName"] = this.operationDisplayName !== undefined ? this.operationDisplayName : null as any;
        return data;
    }
}

export class GetProcessHistoryOutput2 {
    sequenceNumber!: string | null;
    serviceRequestId!: string;
    /** 流程实例Id */
    processInstanceId!: string | null;
    /** 节点实例Id */
    taskId!: string | null;
    /** 节点名称 */
    taskName!: string | null;
    /** 触发操作的人 */
    currentOperator!: string | null;
    /** 操作人名称 */
    currentOperatorName!: string | null;
    operation!: ProcessActionEnum;
    /** 操作描述 */
    description!: string | null;
    /** 操作发生的时间 */
    occurTime!: moment.Moment;
    taskForm!: TaskForm;
    /** 任务接口详细信息列表 */
    externalTaskInterfaceDetailList!: ExternalTaskInterfaceDetail[] | null;
    operationDisplayName!: string | null;

    init(_data?: any) {
        if (_data) {
            this.sequenceNumber = _data["sequenceNumber"] !== undefined ? _data["sequenceNumber"] : null as any;
            this.serviceRequestId = _data["serviceRequestId"] !== undefined ? _data["serviceRequestId"] : null as any;
            this.processInstanceId = _data["processInstanceId"] !== undefined ? _data["processInstanceId"] : null as any;
            this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : null as any;
            this.taskName = _data["taskName"] !== undefined ? _data["taskName"] : null as any;
            this.currentOperator = _data["currentOperator"] !== undefined ? _data["currentOperator"] : null as any;
            this.currentOperatorName = _data["currentOperatorName"] !== undefined ? _data["currentOperatorName"] : null as any;
            this.operation = _data["operation"] !== undefined ? _data["operation"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.occurTime = _data["occurTime"] ? moment(_data["occurTime"].toString()) : null as any;
            this.taskForm = _data["taskForm"] ? TaskForm.fromJS(_data["taskForm"]) : null as any;
            if (Array.isArray(_data["externalTaskInterfaceDetailList"])) {
                this.externalTaskInterfaceDetailList = [] as any;
                for (let item of _data["externalTaskInterfaceDetailList"])
                    this.externalTaskInterfaceDetailList!.push(ExternalTaskInterfaceDetail.fromJS(item));
            }
            else {
                this.externalTaskInterfaceDetailList = null as any;
            }
            this.operationDisplayName = _data["operationDisplayName"] !== undefined ? _data["operationDisplayName"] : null as any;
        }
    }

    static fromJS(data: any): GetProcessHistoryOutput2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetProcessHistoryOutput2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequenceNumber"] = this.sequenceNumber !== undefined ? this.sequenceNumber : null as any;
        data["serviceRequestId"] = this.serviceRequestId !== undefined ? this.serviceRequestId : null as any;
        data["processInstanceId"] = this.processInstanceId !== undefined ? this.processInstanceId : null as any;
        data["taskId"] = this.taskId !== undefined ? this.taskId : null as any;
        data["taskName"] = this.taskName !== undefined ? this.taskName : null as any;
        data["currentOperator"] = this.currentOperator !== undefined ? this.currentOperator : null as any;
        data["currentOperatorName"] = this.currentOperatorName !== undefined ? this.currentOperatorName : null as any;
        data["operation"] = this.operation !== undefined ? this.operation : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["occurTime"] = this.occurTime ? this.occurTime.toISOString() : null as any;
        data["taskForm"] = this.taskForm ? this.taskForm.toJSON() : null as any;
        if (Array.isArray(this.externalTaskInterfaceDetailList)) {
            data["externalTaskInterfaceDetailList"] = [];
            for (let item of this.externalTaskInterfaceDetailList)
                data["externalTaskInterfaceDetailList"].push(item ? item.toJSON() : null as any);
        }
        data["operationDisplayName"] = this.operationDisplayName !== undefined ? this.operationDisplayName : null as any;
        return data;
    }
}

export class GetProcessHistoryOutput2PagedResultDto {
    totalCount!: number;
    items!: GetProcessHistoryOutput2[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetProcessHistoryOutput2.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): GetProcessHistoryOutput2PagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProcessHistoryOutput2PagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class PostServiceTypeDefinitionDto {
    serviceTypeId!: string;
    serviceTypeName!: string;
    processDefinitionId!: string;
    description!: string | null;

    init(_data?: any) {
        if (_data) {
            this.serviceTypeId = _data["serviceTypeId"] !== undefined ? _data["serviceTypeId"] : null as any;
            this.serviceTypeName = _data["serviceTypeName"] !== undefined ? _data["serviceTypeName"] : null as any;
            this.processDefinitionId = _data["processDefinitionId"] !== undefined ? _data["processDefinitionId"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): PostServiceTypeDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostServiceTypeDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceTypeId"] = this.serviceTypeId !== undefined ? this.serviceTypeId : null as any;
        data["serviceTypeName"] = this.serviceTypeName !== undefined ? this.serviceTypeName : null as any;
        data["processDefinitionId"] = this.processDefinitionId !== undefined ? this.processDefinitionId : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }
}

export enum ProcessActionEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _8 = 8,
    _9 = 9,
    __1 = -1,
}

export class ProcessDefinitionDiagramDto {
    id!: string | null;
    bpmn20Xml!: string | null;

    [key: string]: any;

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.bpmn20Xml = _data["bpmn20Xml"] !== undefined ? _data["bpmn20Xml"] : null as any;
        }
    }

    static fromJS(data: any): ProcessDefinitionDiagramDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessDefinitionDiagramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["bpmn20Xml"] = this.bpmn20Xml !== undefined ? this.bpmn20Xml : null as any;
        return data;
    }
}

export enum ProcessTaskStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    __1 = -1,
}

export class Prop {
    name!: string | null;
    title!: string | null;

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
        }
    }

    static fromJS(data: any): Prop {
        data = typeof data === 'object' ? data : {};
        let result = new Prop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        return data;
    }
}

export class ReassignNewAssignee {
    uid!: string;
    email!: string | null;

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"] !== undefined ? _data["uid"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): ReassignNewAssignee {
        data = typeof data === 'object' ? data : {};
        let result = new ReassignNewAssignee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid !== undefined ? this.uid : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export enum ReceiptResultType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class ReturnResult {
    isSuccess!: boolean;
    data!: any | null;

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
        }
    }

    static fromJS(data: any): ReturnResult {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        return data;
    }
}

export class SaveWorkOrderTaskInput {
    id!: string | null;
    taskNewStatus!: TaskNewStatusInfo;
    submitForm!: FormSchemaInfo;
    attachments!: string[] | null;
    externalTaskInterfaceDataList!: ExternalTaskInterfaceData[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.taskNewStatus = _data["taskNewStatus"] ? TaskNewStatusInfo.fromJS(_data["taskNewStatus"]) : null as any;
            this.submitForm = _data["submitForm"] ? FormSchemaInfo.fromJS(_data["submitForm"]) : null as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(item);
            }
            else {
                this.attachments = null as any;
            }
            if (Array.isArray(_data["externalTaskInterfaceDataList"])) {
                this.externalTaskInterfaceDataList = [] as any;
                for (let item of _data["externalTaskInterfaceDataList"])
                    this.externalTaskInterfaceDataList!.push(ExternalTaskInterfaceData.fromJS(item));
            }
            else {
                this.externalTaskInterfaceDataList = null as any;
            }
        }
    }

    static fromJS(data: any): SaveWorkOrderTaskInput {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWorkOrderTaskInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["taskNewStatus"] = this.taskNewStatus ? this.taskNewStatus.toJSON() : null as any;
        data["submitForm"] = this.submitForm ? this.submitForm.toJSON() : null as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item);
        }
        if (Array.isArray(this.externalTaskInterfaceDataList)) {
            data["externalTaskInterfaceDataList"] = [];
            for (let item of this.externalTaskInterfaceDataList)
                data["externalTaskInterfaceDataList"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class SaveWorkOrderTaskOutput {
    id!: string;
    sequenceNumber!: string | null;
    serviceTypeId!: string | null;
    processDefinitionId!: string | null;
    processInstanceId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.sequenceNumber = _data["sequenceNumber"] !== undefined ? _data["sequenceNumber"] : null as any;
            this.serviceTypeId = _data["serviceTypeId"] !== undefined ? _data["serviceTypeId"] : null as any;
            this.processDefinitionId = _data["processDefinitionId"] !== undefined ? _data["processDefinitionId"] : null as any;
            this.processInstanceId = _data["processInstanceId"] !== undefined ? _data["processInstanceId"] : null as any;
        }
    }

    static fromJS(data: any): SaveWorkOrderTaskOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWorkOrderTaskOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["sequenceNumber"] = this.sequenceNumber !== undefined ? this.sequenceNumber : null as any;
        data["serviceTypeId"] = this.serviceTypeId !== undefined ? this.serviceTypeId : null as any;
        data["processDefinitionId"] = this.processDefinitionId !== undefined ? this.processDefinitionId : null as any;
        data["processInstanceId"] = this.processInstanceId !== undefined ? this.processInstanceId : null as any;
        return data;
    }
}

export class ServiceRequestDetailOutput {
    id!: string;
    sequenceNumber!: string | null;
    serviceTypeId!: string | null;
    serviceTypeName!: string | null;
    processDefinitionId!: string | null;
    processInstanceId!: string | null;
    initiatorInfo!: UserInfoDto;
    submissionTime!: moment.Moment | null;
    startProcessingTime!: moment.Moment | null;
    status!: ServiceRequestStatusEnum;
    completeTime!: moment.Moment | null;
    startForm!: StartFormOfServiceRequest;
    taskInfo!: TaskInfo;
    nextTaskInfo!: TaskInfo;
    processResult!: any[] | null;
    processResultSchema!: any[] | null;
    conclusionList!: Conclusion[] | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.sequenceNumber = _data["sequenceNumber"] !== undefined ? _data["sequenceNumber"] : null as any;
            this.serviceTypeId = _data["serviceTypeId"] !== undefined ? _data["serviceTypeId"] : null as any;
            this.serviceTypeName = _data["serviceTypeName"] !== undefined ? _data["serviceTypeName"] : null as any;
            this.processDefinitionId = _data["processDefinitionId"] !== undefined ? _data["processDefinitionId"] : null as any;
            this.processInstanceId = _data["processInstanceId"] !== undefined ? _data["processInstanceId"] : null as any;
            this.initiatorInfo = _data["initiatorInfo"] ? UserInfoDto.fromJS(_data["initiatorInfo"]) : null as any;
            this.submissionTime = _data["submissionTime"] ? moment(_data["submissionTime"].toString()) : null as any;
            this.startProcessingTime = _data["startProcessingTime"] ? moment(_data["startProcessingTime"].toString()) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.completeTime = _data["completeTime"] ? moment(_data["completeTime"].toString()) : null as any;
            this.startForm = _data["startForm"] ? StartFormOfServiceRequest.fromJS(_data["startForm"]) : null as any;
            this.taskInfo = _data["taskInfo"] ? TaskInfo.fromJS(_data["taskInfo"]) : null as any;
            this.nextTaskInfo = _data["nextTaskInfo"] ? TaskInfo.fromJS(_data["nextTaskInfo"]) : null as any;
            if (Array.isArray(_data["processResult"])) {
                this.processResult = [] as any;
                for (let item of _data["processResult"])
                    this.processResult!.push(item);
            }
            else {
                this.processResult = null as any;
            }
            if (Array.isArray(_data["processResultSchema"])) {
                this.processResultSchema = [] as any;
                for (let item of _data["processResultSchema"])
                    this.processResultSchema!.push(item);
            }
            else {
                this.processResultSchema = null as any;
            }
            if (Array.isArray(_data["conclusionList"])) {
                this.conclusionList = [] as any;
                for (let item of _data["conclusionList"])
                    this.conclusionList!.push(Conclusion.fromJS(item));
            }
            else {
                this.conclusionList = null as any;
            }
        }
    }

    static fromJS(data: any): ServiceRequestDetailOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestDetailOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["sequenceNumber"] = this.sequenceNumber !== undefined ? this.sequenceNumber : null as any;
        data["serviceTypeId"] = this.serviceTypeId !== undefined ? this.serviceTypeId : null as any;
        data["serviceTypeName"] = this.serviceTypeName !== undefined ? this.serviceTypeName : null as any;
        data["processDefinitionId"] = this.processDefinitionId !== undefined ? this.processDefinitionId : null as any;
        data["processInstanceId"] = this.processInstanceId !== undefined ? this.processInstanceId : null as any;
        data["initiatorInfo"] = this.initiatorInfo ? this.initiatorInfo.toJSON() : null as any;
        data["submissionTime"] = this.submissionTime ? this.submissionTime.toISOString() : null as any;
        data["startProcessingTime"] = this.startProcessingTime ? this.startProcessingTime.toISOString() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["completeTime"] = this.completeTime ? this.completeTime.toISOString() : null as any;
        data["startForm"] = this.startForm ? this.startForm.toJSON() : null as any;
        data["taskInfo"] = this.taskInfo ? this.taskInfo.toJSON() : null as any;
        data["nextTaskInfo"] = this.nextTaskInfo ? this.nextTaskInfo.toJSON() : null as any;
        if (Array.isArray(this.processResult)) {
            data["processResult"] = [];
            for (let item of this.processResult)
                data["processResult"].push(item);
        }
        if (Array.isArray(this.processResultSchema)) {
            data["processResultSchema"] = [];
            for (let item of this.processResultSchema)
                data["processResultSchema"].push(item);
        }
        if (Array.isArray(this.conclusionList)) {
            data["conclusionList"] = [];
            for (let item of this.conclusionList)
                data["conclusionList"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class ServiceRequestListItemOutput {
    id!: string;
    sequenceNumber!: string | null;
    serviceTypeId!: string | null;
    serviceTypeName!: string | null;
    processDefinitionId!: string | null;
    processInstanceId!: string | null;
    initiator!: string | null;
    customerId!: string | null;
    submissionTime!: moment.Moment | null;
    status!: ServiceRequestStatusEnum;
    completeTime!: moment.Moment | null;
    taskInfo!: TaskInfo;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.sequenceNumber = _data["sequenceNumber"] !== undefined ? _data["sequenceNumber"] : null as any;
            this.serviceTypeId = _data["serviceTypeId"] !== undefined ? _data["serviceTypeId"] : null as any;
            this.serviceTypeName = _data["serviceTypeName"] !== undefined ? _data["serviceTypeName"] : null as any;
            this.processDefinitionId = _data["processDefinitionId"] !== undefined ? _data["processDefinitionId"] : null as any;
            this.processInstanceId = _data["processInstanceId"] !== undefined ? _data["processInstanceId"] : null as any;
            this.initiator = _data["initiator"] !== undefined ? _data["initiator"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.submissionTime = _data["submissionTime"] ? moment(_data["submissionTime"].toString()) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.completeTime = _data["completeTime"] ? moment(_data["completeTime"].toString()) : null as any;
            this.taskInfo = _data["taskInfo"] ? TaskInfo.fromJS(_data["taskInfo"]) : null as any;
        }
    }

    static fromJS(data: any): ServiceRequestListItemOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestListItemOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["sequenceNumber"] = this.sequenceNumber !== undefined ? this.sequenceNumber : null as any;
        data["serviceTypeId"] = this.serviceTypeId !== undefined ? this.serviceTypeId : null as any;
        data["serviceTypeName"] = this.serviceTypeName !== undefined ? this.serviceTypeName : null as any;
        data["processDefinitionId"] = this.processDefinitionId !== undefined ? this.processDefinitionId : null as any;
        data["processInstanceId"] = this.processInstanceId !== undefined ? this.processInstanceId : null as any;
        data["initiator"] = this.initiator !== undefined ? this.initiator : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["submissionTime"] = this.submissionTime ? this.submissionTime.toISOString() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["completeTime"] = this.completeTime ? this.completeTime.toISOString() : null as any;
        data["taskInfo"] = this.taskInfo ? this.taskInfo.toJSON() : null as any;
        return data;
    }
}

export class ServiceRequestListPageOutput {
    totalCount!: number;
    serviceRequests!: ServiceRequestListItemOutput[] | null;

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["serviceRequests"])) {
                this.serviceRequests = [] as any;
                for (let item of _data["serviceRequests"])
                    this.serviceRequests!.push(ServiceRequestListItemOutput.fromJS(item));
            }
            else {
                this.serviceRequests = null as any;
            }
        }
    }

    static fromJS(data: any): ServiceRequestListPageOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestListPageOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.serviceRequests)) {
            data["serviceRequests"] = [];
            for (let item of this.serviceRequests)
                data["serviceRequests"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class ServiceTypeDefinitionsOutput {
    serviceTypeId!: string | null;
    serviceTypeName!: string | null;
    description!: string | null;

    init(_data?: any) {
        if (_data) {
            this.serviceTypeId = _data["serviceTypeId"] !== undefined ? _data["serviceTypeId"] : null as any;
            this.serviceTypeName = _data["serviceTypeName"] !== undefined ? _data["serviceTypeName"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): ServiceTypeDefinitionsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeDefinitionsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceTypeId"] = this.serviceTypeId !== undefined ? this.serviceTypeId : null as any;
        data["serviceTypeName"] = this.serviceTypeName !== undefined ? this.serviceTypeName : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }
}

export class StartFormOfServiceRequest {
    formSchema!: StartFormSchema;
    formData!: string | null;

    init(_data?: any) {
        if (_data) {
            this.formSchema = _data["formSchema"] ? StartFormSchema.fromJS(_data["formSchema"]) : null as any;
            this.formData = _data["formData"] !== undefined ? _data["formData"] : null as any;
        }
    }

    static fromJS(data: any): StartFormOfServiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StartFormOfServiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formSchema"] = this.formSchema ? this.formSchema.toJSON() : null as any;
        data["formData"] = this.formData !== undefined ? this.formData : null as any;
        return data;
    }
}

export class StartFormSchema {
    id!: string;
    formKey!: string | null;
    schema!: string | null;
    defaultValues!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.formKey = _data["formKey"] !== undefined ? _data["formKey"] : null as any;
            this.schema = _data["schema"] !== undefined ? _data["schema"] : null as any;
            this.defaultValues = _data["defaultValues"] !== undefined ? _data["defaultValues"] : null as any;
        }
    }

    static fromJS(data: any): StartFormSchema {
        data = typeof data === 'object' ? data : {};
        let result = new StartFormSchema();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["formKey"] = this.formKey !== undefined ? this.formKey : null as any;
        data["schema"] = this.schema !== undefined ? this.schema : null as any;
        data["defaultValues"] = this.defaultValues !== undefined ? this.defaultValues : null as any;
        return data;
    }
}

export class TaskForm {
    formSchema!: TaskFormSchema;
    formData!: string | null;

    init(_data?: any) {
        if (_data) {
            this.formSchema = _data["formSchema"] ? TaskFormSchema.fromJS(_data["formSchema"]) : null as any;
            this.formData = _data["formData"] !== undefined ? _data["formData"] : null as any;
        }
    }

    static fromJS(data: any): TaskForm {
        data = typeof data === 'object' ? data : {};
        let result = new TaskForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formSchema"] = this.formSchema ? this.formSchema.toJSON() : null as any;
        data["formData"] = this.formData !== undefined ? this.formData : null as any;
        return data;
    }
}

export class TaskFormDataRecordOutput {
    id!: string;
    formSchemaId!: string;
    taskId!: string | null;
    formData!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.formSchemaId = _data["formSchemaId"] !== undefined ? _data["formSchemaId"] : null as any;
            this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : null as any;
            this.formData = _data["formData"] !== undefined ? _data["formData"] : null as any;
        }
    }

    static fromJS(data: any): TaskFormDataRecordOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TaskFormDataRecordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["formSchemaId"] = this.formSchemaId !== undefined ? this.formSchemaId : null as any;
        data["taskId"] = this.taskId !== undefined ? this.taskId : null as any;
        data["formData"] = this.formData !== undefined ? this.formData : null as any;
        return data;
    }
}

export class TaskFormSchema {
    id!: string;
    formKey!: string | null;
    schema!: string | null;
    defaultValues!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.formKey = _data["formKey"] !== undefined ? _data["formKey"] : null as any;
            this.schema = _data["schema"] !== undefined ? _data["schema"] : null as any;
            this.defaultValues = _data["defaultValues"] !== undefined ? _data["defaultValues"] : null as any;
        }
    }

    static fromJS(data: any): TaskFormSchema {
        data = typeof data === 'object' ? data : {};
        let result = new TaskFormSchema();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["formKey"] = this.formKey !== undefined ? this.formKey : null as any;
        data["schema"] = this.schema !== undefined ? this.schema : null as any;
        data["defaultValues"] = this.defaultValues !== undefined ? this.defaultValues : null as any;
        return data;
    }
}

export class TaskInfo {
    id!: string | null;
    name!: string | null;
    status!: ProcessTaskStatus;
    assignee!: string | null;
    assigneeName!: string | null;
    isWindowTask!: boolean;
    taskTypeFlag!: TaskTypeFlag;
    isConfidential!: boolean;
    priority!: number;
    owner!: string | null;
    created!: moment.Moment | null;
    due!: moment.Moment | null;
    followUp!: moment.Moment | null;
    startedAt!: moment.Moment | null;
    wordOrderCreateAt!: moment.Moment | null;
    sequenceNumber!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.assignee = _data["assignee"] !== undefined ? _data["assignee"] : null as any;
            this.assigneeName = _data["assigneeName"] !== undefined ? _data["assigneeName"] : null as any;
            this.isWindowTask = _data["isWindowTask"] !== undefined ? _data["isWindowTask"] : null as any;
            this.taskTypeFlag = _data["taskTypeFlag"] !== undefined ? _data["taskTypeFlag"] : null as any;
            this.isConfidential = _data["isConfidential"] !== undefined ? _data["isConfidential"] : null as any;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : null as any;
            this.owner = _data["owner"] !== undefined ? _data["owner"] : null as any;
            this.created = _data["created"] ? moment(_data["created"].toString()) : null as any;
            this.due = _data["due"] ? moment(_data["due"].toString()) : null as any;
            this.followUp = _data["followUp"] ? moment(_data["followUp"].toString()) : null as any;
            this.startedAt = _data["startedAt"] ? moment(_data["startedAt"].toString()) : null as any;
            this.wordOrderCreateAt = _data["wordOrderCreateAt"] ? moment(_data["wordOrderCreateAt"].toString()) : null as any;
            this.sequenceNumber = _data["sequenceNumber"] !== undefined ? _data["sequenceNumber"] : null as any;
        }
    }

    static fromJS(data: any): TaskInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TaskInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["assignee"] = this.assignee !== undefined ? this.assignee : null as any;
        data["assigneeName"] = this.assigneeName !== undefined ? this.assigneeName : null as any;
        data["isWindowTask"] = this.isWindowTask !== undefined ? this.isWindowTask : null as any;
        data["taskTypeFlag"] = this.taskTypeFlag !== undefined ? this.taskTypeFlag : null as any;
        data["isConfidential"] = this.isConfidential !== undefined ? this.isConfidential : null as any;
        data["priority"] = this.priority !== undefined ? this.priority : null as any;
        data["owner"] = this.owner !== undefined ? this.owner : null as any;
        data["created"] = this.created ? this.created.toISOString() : null as any;
        data["due"] = this.due ? this.due.toISOString() : null as any;
        data["followUp"] = this.followUp ? this.followUp.toISOString() : null as any;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : null as any;
        data["wordOrderCreateAt"] = this.wordOrderCreateAt ? this.wordOrderCreateAt.toISOString() : null as any;
        data["sequenceNumber"] = this.sequenceNumber !== undefined ? this.sequenceNumber : null as any;
        return data;
    }
}

export enum TaskInterfaceActionItem {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum TaskInterfaceOutput {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum TaskInterfaceType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class TaskNewStatusInfo {
    startedAt!: moment.Moment | null;
    status!: ProcessTaskStatus;
    taskId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.startedAt = _data["startedAt"] ? moment(_data["startedAt"].toString()) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : null as any;
        }
    }

    static fromJS(data: any): TaskNewStatusInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TaskNewStatusInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["taskId"] = this.taskId !== undefined ? this.taskId : null as any;
        return data;
    }
}

export enum TaskTypeFlag {
    _0 = 0,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
}

export class TodoAndConcernCountOutput {
    todoCount!: number;
    concernCount!: number;

    init(_data?: any) {
        if (_data) {
            this.todoCount = _data["todoCount"] !== undefined ? _data["todoCount"] : null as any;
            this.concernCount = _data["concernCount"] !== undefined ? _data["concernCount"] : null as any;
        }
    }

    static fromJS(data: any): TodoAndConcernCountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TodoAndConcernCountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["todoCount"] = this.todoCount !== undefined ? this.todoCount : null as any;
        data["concernCount"] = this.concernCount !== undefined ? this.concernCount : null as any;
        return data;
    }
}

export class TransitionInstanceDto {
    id!: string | null;
    parentActivityInstanceId!: string | null;
    activityId!: string | null;
    activityName!: string | null;
    activityType!: string | null;
    processInstanceId!: string | null;
    processDefinitionId!: string | null;
    executionId!: string | null;
    incidentIds!: string[] | null;
    incidents!: ActivityInstanceIncidentDto[] | null;

    [key: string]: any;

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.parentActivityInstanceId = _data["parentActivityInstanceId"] !== undefined ? _data["parentActivityInstanceId"] : null as any;
            this.activityId = _data["activityId"] !== undefined ? _data["activityId"] : null as any;
            this.activityName = _data["activityName"] !== undefined ? _data["activityName"] : null as any;
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : null as any;
            this.processInstanceId = _data["processInstanceId"] !== undefined ? _data["processInstanceId"] : null as any;
            this.processDefinitionId = _data["processDefinitionId"] !== undefined ? _data["processDefinitionId"] : null as any;
            this.executionId = _data["executionId"] !== undefined ? _data["executionId"] : null as any;
            if (Array.isArray(_data["incidentIds"])) {
                this.incidentIds = [] as any;
                for (let item of _data["incidentIds"])
                    this.incidentIds!.push(item);
            }
            else {
                this.incidentIds = null as any;
            }
            if (Array.isArray(_data["incidents"])) {
                this.incidents = [] as any;
                for (let item of _data["incidents"])
                    this.incidents!.push(ActivityInstanceIncidentDto.fromJS(item));
            }
            else {
                this.incidents = null as any;
            }
        }
    }

    static fromJS(data: any): TransitionInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransitionInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["parentActivityInstanceId"] = this.parentActivityInstanceId !== undefined ? this.parentActivityInstanceId : null as any;
        data["activityId"] = this.activityId !== undefined ? this.activityId : null as any;
        data["activityName"] = this.activityName !== undefined ? this.activityName : null as any;
        data["activityType"] = this.activityType !== undefined ? this.activityType : null as any;
        data["processInstanceId"] = this.processInstanceId !== undefined ? this.processInstanceId : null as any;
        data["processDefinitionId"] = this.processDefinitionId !== undefined ? this.processDefinitionId : null as any;
        data["executionId"] = this.executionId !== undefined ? this.executionId : null as any;
        if (Array.isArray(this.incidentIds)) {
            data["incidentIds"] = [];
            for (let item of this.incidentIds)
                data["incidentIds"].push(item);
        }
        if (Array.isArray(this.incidents)) {
            data["incidents"] = [];
            for (let item of this.incidents)
                data["incidents"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export class UserInfoDto {
    userName!: string | null;
    userId!: string | null;
    orgName!: string | null;
    orgType!: string | null;
    orgId!: string | null;
    department!: string | null;
    email!: string | null;
    abbUser!: boolean;
    functionPermission!: FunctionPermission;

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.orgName = _data["orgName"] !== undefined ? _data["orgName"] : null as any;
            this.orgType = _data["orgType"] !== undefined ? _data["orgType"] : null as any;
            this.orgId = _data["orgId"] !== undefined ? _data["orgId"] : null as any;
            this.department = _data["department"] !== undefined ? _data["department"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.abbUser = _data["abbUser"] !== undefined ? _data["abbUser"] : null as any;
            this.functionPermission = _data["functionPermission"] !== undefined ? _data["functionPermission"] : null as any;
        }
    }

    static fromJS(data: any): UserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["orgName"] = this.orgName !== undefined ? this.orgName : null as any;
        data["orgType"] = this.orgType !== undefined ? this.orgType : null as any;
        data["orgId"] = this.orgId !== undefined ? this.orgId : null as any;
        data["department"] = this.department !== undefined ? this.department : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["abbUser"] = this.abbUser !== undefined ? this.abbUser : null as any;
        data["functionPermission"] = this.functionPermission !== undefined ? this.functionPermission : null as any;
        return data;
    }
}

export class WorkOrderReassignInput {
    serviceRequestId!: string;
    requestSequenceNumber!: string | null;
    newAssignee!: ReassignNewAssignee;
    taskId!: string | null;

    init(_data?: any) {
        if (_data) {
            this.serviceRequestId = _data["serviceRequestId"] !== undefined ? _data["serviceRequestId"] : null as any;
            this.requestSequenceNumber = _data["requestSequenceNumber"] !== undefined ? _data["requestSequenceNumber"] : null as any;
            this.newAssignee = _data["newAssignee"] ? ReassignNewAssignee.fromJS(_data["newAssignee"]) : null as any;
            this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : null as any;
        }
    }

    static fromJS(data: any): WorkOrderReassignInput {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderReassignInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceRequestId"] = this.serviceRequestId !== undefined ? this.serviceRequestId : null as any;
        data["requestSequenceNumber"] = this.requestSequenceNumber !== undefined ? this.requestSequenceNumber : null as any;
        data["newAssignee"] = this.newAssignee ? this.newAssignee.toJSON() : null as any;
        data["taskId"] = this.taskId !== undefined ? this.taskId : null as any;
        return data;
    }
}

export class WorkOrderReassignOutput {
    serviceRequestId!: string;
    requestSequenceNumber!: string | null;
    taskId!: string | null;
    newAssignee!: ReassignNewAssignee;

    init(_data?: any) {
        if (_data) {
            this.serviceRequestId = _data["serviceRequestId"] !== undefined ? _data["serviceRequestId"] : null as any;
            this.requestSequenceNumber = _data["requestSequenceNumber"] !== undefined ? _data["requestSequenceNumber"] : null as any;
            this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : null as any;
            this.newAssignee = _data["newAssignee"] ? ReassignNewAssignee.fromJS(_data["newAssignee"]) : null as any;
        }
    }

    static fromJS(data: any): WorkOrderReassignOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderReassignOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceRequestId"] = this.serviceRequestId !== undefined ? this.serviceRequestId : null as any;
        data["requestSequenceNumber"] = this.requestSequenceNumber !== undefined ? this.requestSequenceNumber : null as any;
        data["taskId"] = this.taskId !== undefined ? this.taskId : null as any;
        data["newAssignee"] = this.newAssignee ? this.newAssignee.toJSON() : null as any;
        return data;
    }
}

export class WorkOrderTaskDetailOutput {
    myRoles!: string[] | null;
    taskInfo!: TaskInfo;
    taskForm!: TaskForm;
    assigneeInfo!: AssigneeInfo;
    attachments!: AttachmentSimpleDto[] | null;
    serviceType!: PostServiceTypeDefinitionDto;
    externalTaskInterfaceDetailList!: ExternalTaskInterfaceDetail[] | null;
    processResult!: any[] | null;
    processResultSchema!: any[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["myRoles"])) {
                this.myRoles = [] as any;
                for (let item of _data["myRoles"])
                    this.myRoles!.push(item);
            }
            else {
                this.myRoles = null as any;
            }
            this.taskInfo = _data["taskInfo"] ? TaskInfo.fromJS(_data["taskInfo"]) : null as any;
            this.taskForm = _data["taskForm"] ? TaskForm.fromJS(_data["taskForm"]) : null as any;
            this.assigneeInfo = _data["assigneeInfo"] ? AssigneeInfo.fromJS(_data["assigneeInfo"]) : null as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentSimpleDto.fromJS(item));
            }
            else {
                this.attachments = null as any;
            }
            this.serviceType = _data["serviceType"] ? PostServiceTypeDefinitionDto.fromJS(_data["serviceType"]) : null as any;
            if (Array.isArray(_data["externalTaskInterfaceDetailList"])) {
                this.externalTaskInterfaceDetailList = [] as any;
                for (let item of _data["externalTaskInterfaceDetailList"])
                    this.externalTaskInterfaceDetailList!.push(ExternalTaskInterfaceDetail.fromJS(item));
            }
            else {
                this.externalTaskInterfaceDetailList = null as any;
            }
            if (Array.isArray(_data["processResult"])) {
                this.processResult = [] as any;
                for (let item of _data["processResult"])
                    this.processResult!.push(item);
            }
            else {
                this.processResult = null as any;
            }
            if (Array.isArray(_data["processResultSchema"])) {
                this.processResultSchema = [] as any;
                for (let item of _data["processResultSchema"])
                    this.processResultSchema!.push(item);
            }
            else {
                this.processResultSchema = null as any;
            }
        }
    }

    static fromJS(data: any): WorkOrderTaskDetailOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderTaskDetailOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.myRoles)) {
            data["myRoles"] = [];
            for (let item of this.myRoles)
                data["myRoles"].push(item);
        }
        data["taskInfo"] = this.taskInfo ? this.taskInfo.toJSON() : null as any;
        data["taskForm"] = this.taskForm ? this.taskForm.toJSON() : null as any;
        data["assigneeInfo"] = this.assigneeInfo ? this.assigneeInfo.toJSON() : null as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : null as any);
        }
        data["serviceType"] = this.serviceType ? this.serviceType.toJSON() : null as any;
        if (Array.isArray(this.externalTaskInterfaceDetailList)) {
            data["externalTaskInterfaceDetailList"] = [];
            for (let item of this.externalTaskInterfaceDetailList)
                data["externalTaskInterfaceDetailList"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.processResult)) {
            data["processResult"] = [];
            for (let item of this.processResult)
                data["processResult"].push(item);
        }
        if (Array.isArray(this.processResultSchema)) {
            data["processResultSchema"] = [];
            for (let item of this.processResultSchema)
                data["processResultSchema"].push(item);
        }
        return data;
    }
}

export class WorkOrderToDoItemOutput {
    id!: string;
    sequenceNumber!: string | null;
    serviceTypeId!: string | null;
    serviceTypeName!: string | null;
    processInstanceId!: string | null;
    initiator!: string | null;
    initiatorName!: string | null;
    initiatorEmail!: string | null;
    customerId!: string | null;
    customerName!: string | null;
    serviceName!: string | null;
    submissionTime!: moment.Moment | null;
    status!: ServiceRequestStatusEnum;
    statusDisplayName!: string | null;
    taskInfo!: TaskInfo;
    startedAt!: moment.Moment | null;
    formDataSnapshots!: FormDataSnapshotOutputDto[] | null;
    readonly formDataSnapshotJson!: any | null;
    customerSalesOrder!: string | null;
    internalSalesOrder!: string | null;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.sequenceNumber = _data["sequenceNumber"] !== undefined ? _data["sequenceNumber"] : null as any;
            this.serviceTypeId = _data["serviceTypeId"] !== undefined ? _data["serviceTypeId"] : null as any;
            this.serviceTypeName = _data["serviceTypeName"] !== undefined ? _data["serviceTypeName"] : null as any;
            this.processInstanceId = _data["processInstanceId"] !== undefined ? _data["processInstanceId"] : null as any;
            this.initiator = _data["initiator"] !== undefined ? _data["initiator"] : null as any;
            this.initiatorName = _data["initiatorName"] !== undefined ? _data["initiatorName"] : null as any;
            this.initiatorEmail = _data["initiatorEmail"] !== undefined ? _data["initiatorEmail"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.serviceName = _data["serviceName"] !== undefined ? _data["serviceName"] : null as any;
            this.submissionTime = _data["submissionTime"] ? moment(_data["submissionTime"].toString()) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.statusDisplayName = _data["statusDisplayName"] !== undefined ? _data["statusDisplayName"] : null as any;
            this.taskInfo = _data["taskInfo"] ? TaskInfo.fromJS(_data["taskInfo"]) : null as any;
            this.startedAt = _data["startedAt"] ? moment(_data["startedAt"].toString()) : null as any;
            if (Array.isArray(_data["formDataSnapshots"])) {
                this.formDataSnapshots = [] as any;
                for (let item of _data["formDataSnapshots"])
                    this.formDataSnapshots!.push(FormDataSnapshotOutputDto.fromJS(item));
            }
            else {
                this.formDataSnapshots = null as any;
            }
            (this as any).formDataSnapshotJson = _data["formDataSnapshotJson"] !== undefined ? _data["formDataSnapshotJson"] : null as any;
            this.customerSalesOrder = _data["customerSalesOrder"] !== undefined ? _data["customerSalesOrder"] : null as any;
            this.internalSalesOrder = _data["internalSalesOrder"] !== undefined ? _data["internalSalesOrder"] : null as any;
        }
    }

    static fromJS(data: any): WorkOrderToDoItemOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderToDoItemOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["sequenceNumber"] = this.sequenceNumber !== undefined ? this.sequenceNumber : null as any;
        data["serviceTypeId"] = this.serviceTypeId !== undefined ? this.serviceTypeId : null as any;
        data["serviceTypeName"] = this.serviceTypeName !== undefined ? this.serviceTypeName : null as any;
        data["processInstanceId"] = this.processInstanceId !== undefined ? this.processInstanceId : null as any;
        data["initiator"] = this.initiator !== undefined ? this.initiator : null as any;
        data["initiatorName"] = this.initiatorName !== undefined ? this.initiatorName : null as any;
        data["initiatorEmail"] = this.initiatorEmail !== undefined ? this.initiatorEmail : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["serviceName"] = this.serviceName !== undefined ? this.serviceName : null as any;
        data["submissionTime"] = this.submissionTime ? this.submissionTime.toISOString() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["statusDisplayName"] = this.statusDisplayName !== undefined ? this.statusDisplayName : null as any;
        data["taskInfo"] = this.taskInfo ? this.taskInfo.toJSON() : null as any;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : null as any;
        if (Array.isArray(this.formDataSnapshots)) {
            data["formDataSnapshots"] = [];
            for (let item of this.formDataSnapshots)
                data["formDataSnapshots"].push(item ? item.toJSON() : null as any);
        }
        data["formDataSnapshotJson"] = this.formDataSnapshotJson !== undefined ? this.formDataSnapshotJson : null as any;
        data["customerSalesOrder"] = this.customerSalesOrder !== undefined ? this.customerSalesOrder : null as any;
        data["internalSalesOrder"] = this.internalSalesOrder !== undefined ? this.internalSalesOrder : null as any;
        return data;
    }
}

export class WorkOrders {
    readonly formPropertyNames!: Prop[] | null;
    orders!: WorkOrderToDoItemOutput[] | null;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formPropertyNames"])) {
                (this as any).formPropertyNames = [] as any;
                for (let item of _data["formPropertyNames"])
                    (this as any).formPropertyNames!.push(Prop.fromJS(item));
            }
            else {
                (this as any).formPropertyNames = null as any;
            }
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(WorkOrderToDoItemOutput.fromJS(item));
            }
            else {
                this.orders = null as any;
            }
        }
    }

    static fromJS(data: any): WorkOrders {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrders();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formPropertyNames)) {
            data["formPropertyNames"] = [];
            for (let item of this.formPropertyNames)
                data["formPropertyNames"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}